/* eslint-disable */
import { DateOnly } from 'src/utils/dates';
import { DateTime } from 'src/utils/dates';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: DateOnly;
  DateTime: DateTime;
  JSONObject: any;
  BigInt: any;
  IdOrName: any;
};

export type Query = {
  __typename?: 'Query';
  costConfidences: Array<CostConfidenceDetail>;
  aiEntityProposal: AiEntityProposal;
  aiEntityProposals: AiEntityProposalsPage;
  aiFieldProposal: AiFieldProposal;
  aiFieldProposals: AiFieldProposalsPage;
  aiProposal: AiProposal;
  approval: Approval;
  approvals?: Maybe<ApprovalPage>;
  /** Returns assets matching the filter. If filter is empty, returns []. */
  assets: Array<Asset>;
  bidContract: BidContract;
  bidContractItems: Array<BidContractPotentialItem>;
  bidContractsPage: BidContractsPage;
  /** @deprecated Use the paginated bidContractLineItemsPaged query. */
  bidContractLineItems: Array<BidContractLineItem>;
  bidContractLineItemsPage: BidContractLineItemsPageResult;
  bidContractRevision: BidContractRevision;
  bidItem: BidItem;
  bidItems: Array<BidItem>;
  bidItemsPage: BidItemsPage;
  potentialBidItems: Array<BidItem>;
  bidItemEstimate: BidItemEstimate;
  bidItemEstimates: BidItemEstimatesPageResult;
  bidPackage: BidPackage;
  potentialBidItemsPage: BidItemsPage;
  overlappingBidPackages: OverlappingBidPackagesResult;
  bidScopeSourceDetail: Array<BidScopeSourceDetail>;
  /**
   * Returns the global options available as bid plan dimensions for the given product offerings,
   * grouped by global option type and filtered to plan-based bid dimensions.
   */
  potentialBidPlanDimensions: Array<PotentialBidPlanDimensionResult>;
  costCodeBidCoverage: Array<CostCodeBidCoverageResult>;
  bidPackageGroup: BidPackageGroup;
  bidPackageGroups: BidPackageGroupsPageResult;
  bidPackageGroupProductOfferingsInfo: BidPackageGroupProductOfferingsResult;
  bidPackageVersion: BidPackageVersion;
  bidPackageVersionScopeLines: Array<BidPackageScopeLine>;
  bill: Bill;
  bills: Array<Bill>;
  billsPage: BillsPage;
  billMetrics?: Maybe<BillMetricsResult>;
  billGmailMessages: Array<BillGmailMessage>;
  billOcr?: Maybe<BillOcr>;
  builder: Builder;
  businessFunction: BusinessFunction;
  businessFunctions: Array<BusinessFunction>;
  projectRolesForBusinessFunctionType: Array<ProjectRoleDetail>;
  changeEvent: ChangeEvent;
  changeEvents: Array<ChangeEvent>;
  changeEventLineItems: Array<ChangeEventLineItem>;
  changeEventBudgetPhases: Array<ChangeEventBudgetPhaseDetail>;
  changeEventReasons: Array<ChangeEventReason>;
  changeRequest: ChangeRequest;
  changeRequests: ChangeRequestsPageResult;
  availableDependencyChangeRequests: Array<ChangeRequest>;
  changeRequestAsset: ChangeRequestAsset;
  changeRequestAssets: ChangeRequestAssetsPageResult;
  changeRequestGroup: ChangeRequestGroup;
  changeRequestGroups: Array<ChangeRequestGroup>;
  checkoutConfig: CheckoutConfig;
  checkoutConfigs: CheckoutConfigsPage;
  checkoutPricingTrace: CheckoutPricingTrace;
  insideMapsSlotAudit: InsideMapsSlotAuditResult;
  insideMapsSlotDiff: InsideMapsSlotDiffResult;
  cohorts: Array<Cohort>;
  cohort: Cohort;
  canCollaborate: CanCollaborate;
  comment: Comment;
  commentStream?: Maybe<CommentStream>;
  /** @deprecated Use the paginated userRelevantCommentStreamsPaged query */
  userRelevantCommentStreams: Array<CommentStream>;
  userRelevantCommentStreamsPaged: UserRelevantCommentStreamsResult;
  commentable: Commentable;
  commitment: Commitment;
  commitments: Array<Commitment>;
  commitmentsPage: CommitmentsPage;
  commitmentStatuses: Array<CommitmentStatusDetail>;
  commitmentTypes: Array<CommitmentTypeDetail>;
  commitmentChangeOrder: CommitmentChangeOrder;
  community: Community;
  communities: CommunitiesPageResult;
  costCodes: Array<CostCode>;
  costDivisions: Array<CostDivision>;
  costTypes: Array<CostTypeDetail>;
  customers: Array<Customer>;
  customerOwnerEntities: Array<CustomerOwnerEntity>;
  designPackage: DesignPackage;
  designPackages: DesignPackagesPageResult;
  designPackageFinishSchedule: DesignPackageFinishSchedulePageResult;
  /**
   * Determines what the target combinations for each product card will be based on the placeholder and a product card
   * that we're currently adding/editing. This is useful for the FE to know which combinations will be stolen or dropped
   * from sibling product cards without making excessive requests to the BE.
   *
   * Example: Stolen Combination
   * - Given the following product cards:
   *   - `tli:1` - `targetCombinations: [[Essential]]`
   *   - `tli:2` - `targetCombinations: [[Deluxe], [Premium]]`
   * - When we edit the first product card to have combinations `[[Essential], [Deluxe]]`
   * - Then the second product card will lose the `[Deluxe]` combination
   *   - `tli:1` - `targetCombinations: [[Essential], [Deluxe]]`
   *   - `tli:2` - `targetCombinations: [[Premium]]`
   */
  placeholderCombinations: Array<PlaceholderCombinationsResult>;
  developments: Array<Development>;
  development: Development;
  developmentLotSummaryCharts?: Maybe<DevelopmentLotSummaryChartsResult>;
  developmentCommitment: DevelopmentCommitment;
  developmentCommitments: Array<DevelopmentCommitment>;
  developmentCommitmentsPage: DevelopmentCommitmentsPage;
  /** @deprecated Replaced by developmentCommitmentPotentialLineItems */
  protoDevelopmentCommitmentSummary: DevelopmentCommitmentSummary;
  /**
   * When creating or updating a dev commitment, provides a list of project items, grouped by cost code+type, for the user to include.
   *
   * If creating a dev commitment, then stage+projectIds are required.
   *
   * If updating a dev commitment, then just developmentCommitmentId is required.
   */
  developmentCommitmentPotentialLineItems: Array<DevelopmentCommitmentPotentialLineItem>;
  /** Ability to only include/exclude system-controlled document types */
  documentTypes: Array<DocumentTypeDetail>;
  /** @deprecated replaced by documentsPage */
  documents: Array<Document>;
  documentsPage: DocumentsPageResult;
  document: Document;
  documentCategories: Array<DocumentCategoryDetail>;
  userProjectDocuments: Array<Document>;
  drops: Array<Drop>;
  entity: Entity;
  enumDetails: AllEnumDetails;
  identifyProjectAccrualAdjustments: Array<IdentifyProjectAccrualAdjustmentsResult>;
  projectEstimate: Estimate;
  projectEstimates: Array<Estimate>;
  expenses: Array<Expense>;
  expensesPage: ExpensesPage;
  expense: Expense;
  featureFlag: FeatureFlag;
  featureFlags: Array<FeatureFlag>;
  availableFeatureFlagTypes: Array<FeatureFlagTypeDetail>;
  userFeatureFlags: Array<FeatureFlag>;
  featureTypes: Array<FeatureType>;
  followable: Followable;
  globalOptions: Array<GlobalOption>;
  globalOption: GlobalOption;
  globalOptionGroups: Array<GlobalOptionGroup>;
  globalOptionTags: Array<GlobalOptionTag>;
  globalOptionTypes: Array<GlobalOptionType>;
  globalPhases: Array<GlobalPhase>;
  globalPhase: GlobalPhase;
  globalPlanConstraintItems: Array<GlobalPlanConstraintItem>;
  globalPlanMilestone: GlobalPlanMilestone;
  globalPlanMilestones: GlobalPlanMilestonesPageResult;
  globalPlanMilestoneGroups: Array<GlobalPlanMilestoneGroup>;
  globalPlanStage: GlobalPlanStage;
  globalPlanStages: Array<GlobalPlanStage>;
  globalPlanTag: GlobalPlanTag;
  globalPlanTags: Array<GlobalPlanTag>;
  globalPlanTask: GlobalPlanTask;
  globalPlanTasks: GlobalPlanTasksPageResult;
  globalSearch: Array<GlobalSearchResult>;
  globalSubPhases: Array<GlobalSubPhase>;
  globalTasks: Array<GlobalTask>;
  homeowners: HomeownersPage;
  homeownerContract: HomeownerContract;
  homeownerContracts: Array<HomeownerContract>;
  homeownerContractChangeOrder: HomeownerContractChangeOrder;
  homeownerContractChangeOrders: Array<HomeownerContractChangeOrder>;
  homeownerNotes: Array<HomeownerNote>;
  homeownerNote: HomeownerNote;
  currentInternalUser?: Maybe<InternalUser>;
  internalUsers: Array<InternalUser>;
  invoice: Invoice;
  invoices: Array<Invoice>;
  invoicesPage: InvoicesPage;
  invoiceScheduleTemplate: InvoiceScheduleTemplate;
  invoiceScheduleTemplates: Array<InvoiceScheduleTemplate>;
  items: Array<Item>;
  itemStatuses: Array<ItemStatusDetail>;
  itemPlanTaskMappingPage: ItemPlanTaskMappingPage;
  itemTemplates: Array<ItemTemplate>;
  itemTemplate: ItemTemplate;
  itemTemplateItem: ItemTemplateItem;
  itemTemplateItemVersion: ItemTemplateItemVersion;
  itemTemplateItemVersions: Array<ItemTemplateItemVersion>;
  itemTemplateItemVersionsPage: ItemTemplateItemVersionsPage;
  itemTemplateItemVersionGroupTotals: Array<ItemTemplateItemVersionGroupTotal>;
  jobLog: JobLog;
  /** @deprecated Use jobLogsPage instead */
  jobLogs: Array<JobLog>;
  jobLogsPage: JobLogsPageResult;
  jobLogImages: Array<JobLogImage>;
  jobLogNote: JobLogNote;
  lienWaiver: LienWaiver;
  lienWaivers: Array<LienWaiver>;
  lienWaiversPage: LienWaiversPage;
  locations: Array<Location>;
  location: Location;
  lot: Lot;
  lotRatings: Array<LotRating>;
  market: Market;
  markets: Array<Market>;
  materialAttributeDimensions: Array<MaterialAttributeDimension>;
  materialBrands: Array<MaterialBrand>;
  materialTypes: Array<MaterialTypeDetail>;
  materialListings: MaterialListingsPage;
  materialVariant: MaterialVariant;
  materialVariantCostSources: MaterialVariantCostSourcesPage;
  materialVariants: MaterialVariantsPage;
  /** @deprecated Use materialVariantsForPlaceholder instead. */
  materialVariantsForPlaceholderTli: Array<MaterialVariant>;
  materialVariantsForPlaceholder: Array<MaterialVariant>;
  /**
   * Preview the MaterialVariant.displayName that would result from the given listing, model number, and MAVs.
   * Used by the merge-materials UI before the merge job runs.
   */
  previewMaterialVariantDisplayName: Scalars['String'];
  materialVariantMerge: MaterialVariantMerge;
  /**
   * Merge history for material variants. Two main uses:
   *
   * 1. Stale-id resolution: filter `mergedFromId` to learn where a merged-away id went, then read `winner`.
   * 2. Winner-side history: filter `winnerId` for everything folded into a survivor.
   */
  materialVariantMerges: MaterialVariantMergesPage;
  materialVariantTags: Array<MaterialVariantTag>;
  mermaid: MermaidResult;
  mobileSyncUpdates: MobileSyncUpdatesPageResult;
  pandaDoc: PandaDoc;
  pandaDocs: Array<PandaDoc>;
  paymentTerms: Array<PaymentTerm>;
  paymentTermDueFromDetails: Array<PaymentTermDueFromDetail>;
  planMilestone: PlanMilestone;
  planMilestones: PlanMilestonesResult;
  planPackage: PlanPackage;
  planPackages: PlanPackagesPageResult;
  draftPlanSchedule: DraftScheduleResult;
  /** Query for planTask & planMilestone historical date snapshots. Default `asOfDate` is `PlanSchedule.currentBaselineDate` */
  planScheduleSnapshots: PlanScheduleSnapshotsResult;
  planSchedule: PlanSchedule;
  planTask: PlanTask;
  planTasks: PlanTasksResult;
  preconContractTypes: Array<PreconContractType>;
  productOffering: ProductOffering;
  productOfferings: ProductOfferingsPageResult;
  potentialOptions: Array<ReadyPlanOption>;
  /** Computes the cost and price details for a product offering, including the selected and unselected options. */
  computeProductOfferingCostsAndPrices: ComputeProductOfferingCostsAndPricesResponse;
  /** Calculates the default options for a product offering based on the current configuration. */
  calculateDefaultOfferingOptions: Array<ReadyPlanOption>;
  /**  Calculates the scope difference (added and removed TLIVs) between two product offering configurations.  */
  calculateScopeChange: CalculateScopeChangeResult;
  productOfferingConfig: ProductOfferingConfig;
  productOfferingConfigs: ProductOfferingConfigsPage;
  computeProductOfferingConfigCosts: ComputeProductOfferingConfigCostsResult;
  productTypes: Array<ProductType>;
  computeProgramData: NewProgramData;
  /**
   * note: `id` is deprecated, use `filter` instead
   * @deprecated Use the paginated projectsPage query
   */
  projects: Array<Project>;
  projectsPage: ProjectsPageResult;
  project: Project;
  projectFeatures: Array<ProjectFeatureDetail>;
  homeownerProject: Project;
  homeownerProjects: Array<Project>;
  myTeamMemberProjects: Array<Project>;
  projectRoleDetails: Array<ProjectRoleDetail>;
  projectsToUpdateByTemplates: ProjectsToUpdateByTemplatesResult;
  projectOptionCutoffs: Array<OptionWithCutoffDate>;
  /** note: this is a top level resolver due to the expense of calling it */
  projectCompletedTaskBudgetReview: Array<ProjectCompletedTaskBudgetReview>;
  projectDirectMarginGraph: ProjectDirectMarginGraph;
  projectChangeEventGraphs: ProjectChangeEventGraphsResult;
  /** Returns the project's in-scope bid packages with their preferred signed BCR and aggregated cost, used by the Release To Trades flow. */
  relevantProjectBidPackages: Array<RelevantProjectBidPackage>;
  projectCostCodes: ProjectCostCodesPageResult;
  projectItem: ProjectItem;
  projectItems: Array<ProjectItem>;
  projectItemsPage: ProjectItemsPage;
  projectLotDetail: ProjectLotDetail;
  projectLotDetails: Array<ProjectLotDetail>;
  /**
   * Loads the ProjectReadyPlanConfig with the aggregate version plugin installed
   * for either a prpc ID or a project ID.
   */
  projectReadyPlanConfig: ProjectReadyPlanConfig;
  projectReadyPlanConfigs: Array<ProjectReadyPlanConfig>;
  projectStage: ProjectStage;
  projectStatusChangeReasons: Array<ProjectStatusChangeReason>;
  punchlistItemTodos: Array<PunchlistItemTodo>;
  readyPlan: ReadyPlan;
  readyPlans: Array<ReadyPlan>;
  readyPlanStatuses: Array<ReadyPlanStatusDetail>;
  computeReadyPlanCost: ComputeReadyPlanCostResult;
  /** @deprecated Use readyPlanLike2 instead */
  readyPlanLike: Array<ReadyPlanLike>;
  /**  Replacement for readyPlanLike which has the initially desired error when ID doesn't exist and returns a singular entity.  */
  readyPlanLike2: ReadyPlanLike;
  /**  AI-generated versionNotes for the current version of the ready plan  */
  generateReadyPlanVersionNotes: GenerateReadyPlanVersionNotesResult;
  readyPlanAggregateVersions: Array<ReadyPlanAggregateVersion>;
  readyPlanAggregateVersionsPage: ReadyPlanAggregateVersionsPageResult;
  readyPlanAggregateVersion: ReadyPlanAggregateVersion;
  readyPlanConfigLike: ReadyPlanConfigLike;
  readyPlanOption: ReadyPlanOption;
  readyPlanOptions: Array<ReadyPlanOption>;
  referencable: Referencable;
  region: Region;
  regions: Array<Region>;
  requiredTaskDocument: RequiredTaskDocument;
  roomTypes: Array<RoomType>;
  testQuery: Scalars['Int'];
  schedules: Array<Schedule>;
  schedule: Schedule;
  scheduleFlags: Array<ScheduleFlag>;
  scheduleFlagReasons: Array<ScheduleFlagReason>;
  schedulePhases: Array<SchedulePhase>;
  schedulePhase: SchedulePhase;
  latestActivePhase?: Maybe<SchedulePhase>;
  scheduleSubPhases: Array<ScheduleSubPhase>;
  scheduleSubPhase: ScheduleSubPhase;
  scheduleTask: ScheduleTask;
  scheduleTasks: Array<ScheduleTask>;
  milestoneTasksForTemplates: Array<ScheduleTask>;
  scheduleTemplates: Array<ScheduleTemplate>;
  scheduleTemplate: ScheduleTemplate;
  scopeChangeReasons: Array<ScopeChangeReason>;
  siteSpecificInfos: Array<SiteSpecificInfo>;
  stages: Array<StageDetail>;
  structure: Structure;
  structures: StructuresPageResult;
  subdivision: Subdivision;
  submarkets: Array<Submarket>;
  takeoffLineItem: TakeoffLineItem;
  takeoffLineItemsPage: TakeoffLineItemsPage;
  testGroupDependenciesLineItems: Array<TakeoffLineItem>;
  task: Task;
  tasks: Array<Task>;
  /**  By default returns a max of 100 tasks. We purposefully don't support paging due to cross-db/TS filtering.  */
  tasks2: TaskPage;
  tasksPage: TaskPage;
  taskStatuses: Array<TaskStatusDetail>;
  toDoStatuses: Array<ToDoStatusDetail>;
  toDoTypes?: Maybe<Array<ToDoTypeDetail>>;
  toDos: Array<ToDo>;
  trackedJob: TrackedJob;
  trackedJobs: Array<TrackedJob>;
  tradeCategories: Array<TradeCategory>;
  tradeCategory: TradeCategory;
  tradeCategoryLeadTimes: Array<TradeCategoryLeadTimeLike>;
  tradePartners: Array<TradePartner>;
  tradePartnersPage: TradePartnersPage;
  tradePartner: TradePartner;
  tradePartnerContactsWithRoles: Array<MarketContactWithRoles>;
  tradePartnerContacts: Array<TradePartnerContact>;
  tradePartnerMailingLists: Array<TradePartnerMailingList>;
  tradePartnerMarketRoles: Array<TradePartnerMarketRoleDetail>;
  tradePartnerRequirement: TradePartnerRequirement;
  tradePartnerRequirements: Array<TradePartnerRequirement>;
  tradePartnerRequirementTypes: Array<TradePartnerRequirementTypeDetail>;
  tradePartnerRequirementStatuses: Array<TradePartnerRequirementStatusDetail>;
  unit: Unit;
  unitsOfMeasure: Array<UnitOfMeasure>;
  currentUser?: Maybe<User>;
  communicationChannels: Array<CommunicationChannelDetail>;
  userCommunicationPreferences?: Maybe<UserCommunicationPreference>;
  userEvents: Array<UserEvent>;
  userEventParentTypes: Array<UserEventParentType>;
  userGroup?: Maybe<UserGroup>;
  userGroups: Array<UserGroup>;
  warrantyTicket: WarrantyTicket;
  warrantyTickets: Array<WarrantyTicket>;
  warrantyTicketsPage: WarrantyTicketsPage;
  warrantyTicketItemTypesDetail: Array<WarrantyTicketItemTypeDetail>;
  warrantyTicketItemStatusesDetail: Array<WarrantyTicketItemStatusDetail>;
  warrantyTicketTypesDetail: Array<WarrantyTicketTypeDetail>;
  warrantyTicketStatusesDetail: Array<WarrantyTicketStatusDetail>;
  workAuthorization: WorkAuthorization;
  workAuthorizations: Array<WorkAuthorization>;
};


export type QueryAiEntityProposalArgs = {
  id: Scalars['ID'];
};


export type QueryAiEntityProposalsArgs = {
  filter?: InputMaybe<AiEntityProposalFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAiFieldProposalArgs = {
  id: Scalars['ID'];
};


export type QueryAiFieldProposalsArgs = {
  filter?: InputMaybe<AiFieldProposalFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAiProposalArgs = {
  id: Scalars['ID'];
};


export type QueryApprovalArgs = {
  id: Scalars['ID'];
};


export type QueryApprovalsArgs = {
  filter: ApprovalFilter;
};


export type QueryAssetsArgs = {
  filter: AssetsFilter;
};


export type QueryBidContractArgs = {
  id: Scalars['ID'];
};


export type QueryBidContractItemsArgs = {
  filter?: InputMaybe<BidContractItemsFilter>;
  developmentId?: InputMaybe<Scalars['ID']>;
  developmentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryBidContractsPageArgs = {
  filter?: InputMaybe<BidContractsFilter>;
  page?: InputMaybe<PageFilter>;
  order?: InputMaybe<BidContractOrder>;
};


export type QueryBidContractLineItemsArgs = {
  filter?: InputMaybe<BidContractLineItemFilter>;
};


export type QueryBidContractLineItemsPageArgs = {
  filter?: InputMaybe<BidContractLineItemFilter>;
  page?: InputMaybe<PageFilter>;
};


export type QueryBidContractRevisionArgs = {
  id: Scalars['ID'];
};


export type QueryBidItemArgs = {
  id: Scalars['ID'];
};


export type QueryBidItemsArgs = {
  filter?: InputMaybe<BidItemFilter>;
  order?: InputMaybe<BidItemOrder>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryBidItemsPageArgs = {
  filter?: InputMaybe<BidItemFilter>;
  order?: InputMaybe<BidItemOrder>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryPotentialBidItemsArgs = {
  filter?: InputMaybe<PotentialBidItemFilter>;
};


export type QueryBidItemEstimateArgs = {
  id: Scalars['ID'];
};


export type QueryBidItemEstimatesArgs = {
  filter?: InputMaybe<BidItemEstimateFilter>;
  page?: InputMaybe<PageFilter>;
};


export type QueryBidPackageArgs = {
  id: Scalars['ID'];
};


export type QueryPotentialBidItemsPageArgs = {
  filter: PotentialBidItemsPageFilter;
  order?: InputMaybe<BidItemOrder>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryOverlappingBidPackagesArgs = {
  costCodes: Array<Scalars['ID']>;
  costType: CostType;
  projects: Array<Scalars['ID']>;
  scopeSource: BidScopeSource;
};


export type QueryPotentialBidPlanDimensionsArgs = {
  productOfferingIds: Array<Scalars['ID']>;
};


export type QueryCostCodeBidCoverageArgs = {
  filter: CostCodeBidCoverageFilter;
};


export type QueryBidPackageGroupArgs = {
  id: Scalars['ID'];
};


export type QueryBidPackageGroupsArgs = {
  filter?: InputMaybe<BidPackageGroupsFilter>;
  orderBy?: InputMaybe<BidPackageGroupOrderBy>;
  page?: InputMaybe<PageFilter>;
};


export type QueryBidPackageGroupProductOfferingsInfoArgs = {
  id: Scalars['ID'];
};


export type QueryBidPackageVersionArgs = {
  id: Scalars['ID'];
};


export type QueryBidPackageVersionScopeLinesArgs = {
  id: Scalars['ID'];
  filter: BpvScopeLinesFilter;
};


export type QueryBillArgs = {
  id: Scalars['ID'];
};


export type QueryBillsArgs = {
  filter?: InputMaybe<BillFilter>;
  order?: InputMaybe<BillOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryBillsPageArgs = {
  filter?: InputMaybe<BillFilter>;
  order?: InputMaybe<BillOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryBillMetricsArgs = {
  filter?: InputMaybe<BillFilter>;
};


export type QueryBillGmailMessagesArgs = {
  filter: BillGmailMessageFilter;
  page?: InputMaybe<PageFilter>;
  orderBy?: InputMaybe<BillGmailMessageOrderBy>;
};


export type QueryBillOcrArgs = {
  id: Scalars['ID'];
};


export type QueryBuilderArgs = {
  id: Scalars['ID'];
};


export type QueryBusinessFunctionArgs = {
  id: Scalars['ID'];
};


export type QueryProjectRolesForBusinessFunctionTypeArgs = {
  businessFunctionType: BusinessFunctionType;
};


export type QueryChangeEventArgs = {
  id: Scalars['ID'];
};


export type QueryChangeEventsArgs = {
  filter?: InputMaybe<ChangeEventFilter>;
};


export type QueryChangeEventLineItemsArgs = {
  filter?: InputMaybe<ChangeEventLineItemFilter>;
};


export type QueryChangeEventReasonsArgs = {
  filter?: InputMaybe<ChangeEventReasonFilter>;
};


export type QueryChangeRequestArgs = {
  id: Scalars['ID'];
};


export type QueryChangeRequestsArgs = {
  filter?: InputMaybe<ChangeRequestsFilter>;
  orderBy?: InputMaybe<ChangeRequestOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryAvailableDependencyChangeRequestsArgs = {
  id: Scalars['ID'];
  kind: ChangeRequestDependency;
};


export type QueryChangeRequestAssetArgs = {
  id: Scalars['ID'];
};


export type QueryChangeRequestAssetsArgs = {
  filter?: InputMaybe<ChangeRequestAssetFilter>;
  orderBy?: InputMaybe<ChangeRequestAssetOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryChangeRequestGroupArgs = {
  id: Scalars['ID'];
};


export type QueryCheckoutConfigArgs = {
  id: Scalars['ID'];
};


export type QueryCheckoutConfigsArgs = {
  filter?: InputMaybe<CheckoutConfigsFilter>;
  order?: InputMaybe<CheckoutConfigsOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryCheckoutPricingTraceArgs = {
  input: CheckoutPricingTraceInput;
};


export type QueryInsideMapsSlotAuditArgs = {
  input: InsideMapsSlotAuditInput;
};


export type QueryInsideMapsSlotDiffArgs = {
  input: InsideMapsSlotDiffInput;
};


export type QueryCohortsArgs = {
  filter?: InputMaybe<CohortFilter>;
};


export type QueryCohortArgs = {
  id: Scalars['ID'];
};


export type QueryCanCollaborateArgs = {
  id: Scalars['ID'];
};


export type QueryCommentArgs = {
  id: Scalars['ID'];
};


export type QueryCommentStreamArgs = {
  id: Scalars['ID'];
};


export type QueryUserRelevantCommentStreamsArgs = {
  filter: UserRelevantCommentStreamsFilter;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryUserRelevantCommentStreamsPagedArgs = {
  filter: UserRelevantCommentStreamsFilter;
  page?: InputMaybe<PageFilter>;
};


export type QueryCommentableArgs = {
  id: Scalars['ID'];
};


export type QueryCommitmentArgs = {
  id: Scalars['ID'];
};


export type QueryCommitmentsArgs = {
  filter?: InputMaybe<CommitmentsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CommitmentOrder>;
};


export type QueryCommitmentsPageArgs = {
  filter?: InputMaybe<CommitmentsFilter>;
  page?: InputMaybe<PageFilter>;
  orderBy?: InputMaybe<CommitmentOrder>;
};


export type QueryCommitmentChangeOrderArgs = {
  id: Scalars['ID'];
};


export type QueryCommunityArgs = {
  id: Scalars['ID'];
};


export type QueryCommunitiesArgs = {
  filter?: InputMaybe<ProjectFilter>;
  orderBy?: InputMaybe<ProjectOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryCostCodesArgs = {
  filter?: InputMaybe<CostCodeFilter>;
};


export type QueryCostDivisionsArgs = {
  filter?: InputMaybe<CostDivisionFilter>;
};


export type QueryCustomerOwnerEntitiesArgs = {
  filter: CustomerOwnerEntityFilter;
};


export type QueryDesignPackageArgs = {
  id: Scalars['ID'];
  versionId?: InputMaybe<Scalars['ID']>;
};


export type QueryDesignPackagesArgs = {
  filter?: InputMaybe<DesignPackageFilter>;
  orderBy?: InputMaybe<DesignPackageOrderBy>;
  page?: InputMaybe<PageFilter>;
};


export type QueryDesignPackageFinishScheduleArgs = {
  filter: DesignPackageFinishScheduleFilter;
  page?: InputMaybe<PageFilter>;
};


export type QueryPlaceholderCombinationsArgs = {
  input: PlaceholderCombinationsInput;
};


export type QueryDevelopmentsArgs = {
  filter?: InputMaybe<DevelopmentFilter>;
};


export type QueryDevelopmentArgs = {
  id: Scalars['ID'];
};


export type QueryDevelopmentLotSummaryChartsArgs = {
  id: Scalars['ID'];
  projectIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryDevelopmentCommitmentArgs = {
  id: Scalars['ID'];
};


export type QueryDevelopmentCommitmentsArgs = {
  filter: DevelopmentCommitmentFilter;
};


export type QueryDevelopmentCommitmentsPageArgs = {
  filter: DevelopmentCommitmentFilter;
  page?: InputMaybe<PageFilter>;
};


export type QueryProtoDevelopmentCommitmentSummaryArgs = {
  projectIds: Array<Scalars['ID']>;
  tradeCategoryIds: Array<Scalars['ID']>;
  stage?: InputMaybe<Stage>;
  type?: InputMaybe<DevelopmentCommitmentType>;
  costTypes?: InputMaybe<Array<CostType>>;
};


export type QueryDevelopmentCommitmentPotentialLineItemsArgs = {
  developmentCommitmentId?: InputMaybe<Scalars['ID']>;
  projectIds?: InputMaybe<Array<Scalars['ID']>>;
  stage?: InputMaybe<Stage>;
};


export type QueryDocumentTypesArgs = {
  systemControlled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DocumentsOrder>;
};


export type QueryDocumentsPageArgs = {
  filter: DocumentsFilter;
  page: PageFilter;
  order?: InputMaybe<DocumentsOrder>;
};


export type QueryDocumentArgs = {
  id: Scalars['ID'];
  versionId?: InputMaybe<Scalars['ID']>;
};


export type QueryUserProjectDocumentsArgs = {
  project: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryDropsArgs = {
  filter?: InputMaybe<DropsFilter>;
};


export type QueryEntityArgs = {
  id: Scalars['ID'];
};


export type QueryIdentifyProjectAccrualAdjustmentsArgs = {
  input: IdentifyProjectAccrualAdjustmentsInput;
};


export type QueryProjectEstimateArgs = {
  id: Scalars['ID'];
};


export type QueryProjectEstimatesArgs = {
  filter: EstimateFilter;
};


export type QueryExpensesArgs = {
  filter?: InputMaybe<ExpenseFilter>;
};


export type QueryExpensesPageArgs = {
  filter?: InputMaybe<ExpenseFilter>;
  page?: InputMaybe<PageFilter>;
};


export type QueryExpenseArgs = {
  id: Scalars['ID'];
};


export type QueryFeatureFlagArgs = {
  type: FeatureFlagType;
};


export type QueryFeatureFlagsArgs = {
  filter: FeatureFlagFilter;
};


export type QueryAvailableFeatureFlagTypesArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFeatureTypesArgs = {
  filter?: InputMaybe<FeatureTypesFilter>;
};


export type QueryFollowableArgs = {
  id: Scalars['ID'];
};


export type QueryGlobalOptionsArgs = {
  filter?: InputMaybe<GlobalOptionsFilter>;
};


export type QueryGlobalOptionArgs = {
  id: Scalars['ID'];
};


export type QueryGlobalOptionGroupsArgs = {
  filter?: InputMaybe<GlobalOptionGroupFilter>;
};


export type QueryGlobalOptionTagsArgs = {
  filter?: InputMaybe<GlobalOptionTagsFilter>;
};


export type QueryGlobalOptionTypesArgs = {
  filter?: InputMaybe<GlobalOptionTypesFilter>;
};


export type QueryGlobalPhasesArgs = {
  filter?: InputMaybe<GlobalPhaseFilter>;
};


export type QueryGlobalPhaseArgs = {
  id: Scalars['ID'];
};


export type QueryGlobalPlanMilestoneArgs = {
  id: Scalars['ID'];
};


export type QueryGlobalPlanMilestonesArgs = {
  filter?: InputMaybe<GlobalPlanMilestoneFilter>;
  page?: InputMaybe<PageFilter>;
  orderBy?: InputMaybe<GlobalPlanMilestoneOrder>;
};


export type QueryGlobalPlanStageArgs = {
  id: Scalars['ID'];
};


export type QueryGlobalPlanTagArgs = {
  id: Scalars['ID'];
};


export type QueryGlobalPlanTaskArgs = {
  id: Scalars['ID'];
};


export type QueryGlobalPlanTasksArgs = {
  filter?: InputMaybe<GlobalPlanTaskFilter>;
  page?: InputMaybe<PageFilter>;
};


export type QueryGlobalSearchArgs = {
  query: Scalars['String'];
};


export type QueryGlobalSubPhasesArgs = {
  filter?: InputMaybe<GlobalSubPhasesFilter>;
};


export type QueryGlobalTasksArgs = {
  filter?: InputMaybe<GlobalTasksFilter>;
};


export type QueryHomeownersArgs = {
  filter?: InputMaybe<HomeownersFilter>;
  order?: InputMaybe<HomeownersOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryHomeownerContractArgs = {
  id: Scalars['ID'];
};


export type QueryHomeownerContractsArgs = {
  filter: HomeownerContractFilter;
};


export type QueryHomeownerContractChangeOrderArgs = {
  id: Scalars['ID'];
};


export type QueryHomeownerContractChangeOrdersArgs = {
  filter: HomeownerContractChangeOrderFilter;
};


export type QueryHomeownerNotesArgs = {
  filter?: InputMaybe<HomeownerNoteFilter>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryHomeownerNoteArgs = {
  id: Scalars['ID'];
};


export type QueryInternalUsersArgs = {
  filter?: InputMaybe<InternalUserFilter>;
};


export type QueryInvoiceArgs = {
  id: Scalars['ID'];
};


export type QueryInvoicesArgs = {
  filter?: InputMaybe<InvoiceFilter>;
  order?: InputMaybe<InvoiceOrder>;
};


export type QueryInvoicesPageArgs = {
  filter?: InputMaybe<InvoiceFilter>;
  order?: InputMaybe<InvoiceOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryInvoiceScheduleTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryItemsArgs = {
  filter?: InputMaybe<ItemFilter>;
};


export type QueryItemPlanTaskMappingPageArgs = {
  page?: InputMaybe<PageFilter>;
};


export type QueryItemTemplatesArgs = {
  filter?: InputMaybe<ItemTemplateFilter>;
  order?: InputMaybe<ItemTemplateOrder>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryItemTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryItemTemplateItemArgs = {
  id: Scalars['ID'];
};


export type QueryItemTemplateItemVersionArgs = {
  id: Scalars['ID'];
};


export type QueryItemTemplateItemVersionsArgs = {
  filter?: InputMaybe<ItemTemplateItemVersionFilter>;
};


export type QueryItemTemplateItemVersionsPageArgs = {
  filter?: InputMaybe<ItemTemplateItemVersionFilter>;
  subFilter?: InputMaybe<ItemTemplateItemVersionFilter>;
  order?: InputMaybe<Array<ItemTemplateItemVersionOrder>>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryItemTemplateItemVersionGroupTotalsArgs = {
  input: GroupTotalsInput;
};


export type QueryJobLogArgs = {
  id: Scalars['ID'];
};


export type QueryJobLogsArgs = {
  filter: JobLogFilter;
};


export type QueryJobLogsPageArgs = {
  filter: JobLogFilter;
  orderBy?: InputMaybe<JobLogOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryJobLogImagesArgs = {
  filter: JobLogImageFilter;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<JobLogImageOrder>;
};


export type QueryJobLogNoteArgs = {
  id: Scalars['ID'];
};


export type QueryLienWaiverArgs = {
  id: Scalars['ID'];
};


export type QueryLienWaiversArgs = {
  filter: LienWaiverFilter;
};


export type QueryLienWaiversPageArgs = {
  filter?: InputMaybe<LienWaiverFilter>;
  order?: InputMaybe<LienWaiverOrder>;
  page: PageFilter;
};


export type QueryLocationsArgs = {
  filter?: InputMaybe<LocationsFilter>;
  orderBy?: InputMaybe<LocationOrderBy>;
  effectiveLocations?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLocationArgs = {
  id: Scalars['ID'];
};


export type QueryLotArgs = {
  id: Scalars['ID'];
};


export type QueryMarketArgs = {
  id: Scalars['ID'];
};


export type QueryMaterialAttributeDimensionsArgs = {
  filter?: InputMaybe<MaterialAttributeDimensionFilter>;
};


export type QueryMaterialBrandsArgs = {
  filter: MaterialBrandFilter;
};


export type QueryMaterialListingsArgs = {
  filter: MaterialListingsFilter;
  orderBy?: InputMaybe<MaterialListingOrderBy>;
  page?: InputMaybe<PageFilter>;
};


export type QueryMaterialVariantArgs = {
  id: Scalars['ID'];
};


export type QueryMaterialVariantCostSourcesArgs = {
  materialVariantId: Scalars['ID'];
  orderBy?: InputMaybe<MaterialCostSourceOrderBy>;
  page?: InputMaybe<PageFilter>;
};


export type QueryMaterialVariantsArgs = {
  filter: MaterialVariantsFilter;
  orderBy?: InputMaybe<MaterialVariantOrderBy>;
  page?: InputMaybe<PageFilter>;
};


export type QueryMaterialVariantsForPlaceholderTliArgs = {
  filter: MaterialVariantsForPlaceholderTliFilter;
  orderBy?: InputMaybe<MaterialVariantOrderBy>;
};


export type QueryMaterialVariantsForPlaceholderArgs = {
  filter: MaterialVariantsForPlaceholderFilter;
  orderBy?: InputMaybe<MaterialVariantOrderBy>;
};


export type QueryPreviewMaterialVariantDisplayNameArgs = {
  input: PreviewMaterialVariantDisplayNameInput;
};


export type QueryMaterialVariantMergeArgs = {
  id: Scalars['ID'];
};


export type QueryMaterialVariantMergesArgs = {
  filter?: InputMaybe<MaterialVariantMergeFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryMermaidArgs = {
  input: MermaidInput;
};


export type QueryMobileSyncUpdatesArgs = {
  input: MobileSyncUpdatesInput;
  page?: InputMaybe<PageFilter>;
};


export type QueryPandaDocArgs = {
  id: Scalars['ID'];
};


export type QueryPandaDocsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<PandaDocFilter>;
};


export type QueryPaymentTermsArgs = {
  filter?: InputMaybe<PaymentTermFilter>;
};


export type QueryPlanMilestoneArgs = {
  id: Scalars['ID'];
};


export type QueryPlanMilestonesArgs = {
  filter?: InputMaybe<PlanMilestoneFilter>;
  orderBy?: InputMaybe<PlanMilestoneOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryPlanPackageArgs = {
  id: Scalars['ID'];
  versionId?: InputMaybe<Scalars['ID']>;
};


export type QueryPlanPackagesArgs = {
  filter?: InputMaybe<PlanPackageFilter>;
  orderBy?: InputMaybe<PlanPackageOrderBy>;
  page?: InputMaybe<PageFilter>;
};


export type QueryDraftPlanScheduleArgs = {
  input: DraftScheduleInput;
};


export type QueryPlanScheduleSnapshotsArgs = {
  input: PlanScheduleSnapshotsInput;
};


export type QueryPlanScheduleArgs = {
  idOrScheduleParentId: Scalars['ID'];
};


export type QueryPlanTaskArgs = {
  id: Scalars['ID'];
};


export type QueryPlanTasksArgs = {
  filter?: InputMaybe<PlanTasksFilter>;
  order?: InputMaybe<PlanTasksOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryProductOfferingArgs = {
  id: Scalars['ID'];
  versionId?: InputMaybe<Scalars['ID']>;
};


export type QueryProductOfferingsArgs = {
  filter?: InputMaybe<ProductOfferingsFilter>;
  orderBy?: InputMaybe<ProductOfferingOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryPotentialOptionsArgs = {
  input: PotentialOptionsInput;
};


export type QueryComputeProductOfferingCostsAndPricesArgs = {
  input: ComputeProductOfferingCostsAndPricesInput;
};


export type QueryCalculateDefaultOfferingOptionsArgs = {
  input: CalculateDefaultOfferingOptionsInput;
};


export type QueryCalculateScopeChangeArgs = {
  input: CalculateScopeChangeInput;
};


export type QueryProductOfferingConfigArgs = {
  id: Scalars['ID'];
};


export type QueryProductOfferingConfigsArgs = {
  filter?: InputMaybe<ProductOfferingConfigsFilter>;
  order?: InputMaybe<ProductOfferingConfigOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryComputeProductOfferingConfigCostsArgs = {
  input: ProductOfferingConfigCostsInput;
};


export type QueryComputeProgramDataArgs = {
  input: ComputeProgramDataInput;
};


export type QueryProjectsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<ProjectFilter>;
};


export type QueryProjectsPageArgs = {
  filter?: InputMaybe<ProjectFilter>;
  orderBy?: InputMaybe<ProjectOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryProjectArgs = {
  id: Scalars['ID'];
};


export type QueryHomeownerProjectArgs = {
  by: SearchBy;
  id: Scalars['ID'];
};


export type QueryProjectsToUpdateByTemplatesArgs = {
  input: ProjectsToUpdateByTemplatesInput;
};


export type QueryProjectOptionCutoffsArgs = {
  projectId: Scalars['ID'];
};


export type QueryProjectCompletedTaskBudgetReviewArgs = {
  projectId: Scalars['ID'];
};


export type QueryProjectDirectMarginGraphArgs = {
  projectId: Scalars['ID'];
  filter?: InputMaybe<ProjectDirectMarginGraphFilter>;
};


export type QueryProjectChangeEventGraphsArgs = {
  projectId: Scalars['ID'];
  filter?: InputMaybe<ProjectChangeEventGraphsFilter>;
};


export type QueryRelevantProjectBidPackagesArgs = {
  projectId: Scalars['ID'];
};


export type QueryProjectCostCodesArgs = {
  filter?: InputMaybe<ProjectCostCodeFilter>;
  page?: InputMaybe<PageFilter>;
};


export type QueryProjectItemArgs = {
  id: Scalars['ID'];
};


export type QueryProjectItemsArgs = {
  filter: ProjectItemFilter;
};


export type QueryProjectItemsPageArgs = {
  filter: ProjectItemFilter;
  page?: InputMaybe<PageFilter>;
};


export type QueryProjectLotDetailArgs = {
  id: Scalars['ID'];
};


export type QueryProjectLotDetailsArgs = {
  filter: ProjectLotDetailFilter;
};


export type QueryProjectReadyPlanConfigArgs = {
  id?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
};


export type QueryProjectReadyPlanConfigsArgs = {
  filter?: InputMaybe<ProjectReadyPlanConfigFilter>;
};


export type QueryProjectStageArgs = {
  id: Scalars['ID'];
};


export type QueryProjectStatusChangeReasonsArgs = {
  filter?: InputMaybe<ProjectStatusChangeReasonsFilter>;
};


export type QueryPunchlistItemTodosArgs = {
  filter?: InputMaybe<PunchlistItemFilter>;
};


export type QueryReadyPlanArgs = {
  id: Scalars['ID'];
  versionId?: InputMaybe<Scalars['ID']>;
};


export type QueryReadyPlansArgs = {
  filter?: InputMaybe<ReadyPlanFilter>;
};


export type QueryComputeReadyPlanCostArgs = {
  input: ComputeReadyPlanCostInput;
};


export type QueryReadyPlanLikeArgs = {
  filter?: InputMaybe<ReadyPlanFilter>;
};


export type QueryReadyPlanLike2Args = {
  id: Scalars['ID'];
  versionId?: InputMaybe<Scalars['ID']>;
};


export type QueryGenerateReadyPlanVersionNotesArgs = {
  readyPlanId: Scalars['ID'];
};


export type QueryReadyPlanAggregateVersionsArgs = {
  filter: ReadyPlanAggregateVersionsFilter;
};


export type QueryReadyPlanAggregateVersionsPageArgs = {
  filter: ReadyPlanAggregateVersionsFilter;
  page: PageFilter;
};


export type QueryReadyPlanAggregateVersionArgs = {
  id: Scalars['ID'];
};


export type QueryReadyPlanConfigLikeArgs = {
  id: Scalars['ID'];
};


export type QueryReadyPlanOptionArgs = {
  id: Scalars['ID'];
  versionId?: InputMaybe<Scalars['ID']>;
};


export type QueryReadyPlanOptionsArgs = {
  filter?: InputMaybe<ReadyPlanOptionsFilter>;
};


export type QueryReferencableArgs = {
  id: Scalars['ID'];
};


export type QueryRegionArgs = {
  id: Scalars['ID'];
};


export type QueryRequiredTaskDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryTestQueryArgs = {
  error?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySchedulesArgs = {
  filter: SchedulesFilter;
};


export type QueryScheduleArgs = {
  id: Scalars['ID'];
};


export type QueryScheduleFlagsArgs = {
  filter?: InputMaybe<ScheduleFlagFilter>;
};


export type QueryScheduleFlagReasonsArgs = {
  filter: ScheduleFlagReasonsFilter;
};


export type QuerySchedulePhasesArgs = {
  filter?: InputMaybe<SchedulePhasesFilter>;
};


export type QuerySchedulePhaseArgs = {
  id: Scalars['ID'];
};


export type QueryLatestActivePhaseArgs = {
  parent: Scalars['ID'];
  stage: Stage;
};


export type QueryScheduleSubPhasesArgs = {
  filter?: InputMaybe<ScheduleSubPhasesFilter>;
};


export type QueryScheduleSubPhaseArgs = {
  id: Scalars['ID'];
};


export type QueryScheduleTaskArgs = {
  id: Scalars['ID'];
};


export type QueryScheduleTasksArgs = {
  filter?: InputMaybe<ScheduleTaskFilter>;
  order?: InputMaybe<ScheduleTaskOrder>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryMilestoneTasksForTemplatesArgs = {
  input: MilestoneTasksForTemplatesInput;
};


export type QueryScheduleTemplatesArgs = {
  filter?: InputMaybe<ScheduleTemplatesFilter>;
};


export type QueryScheduleTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryStructureArgs = {
  id: Scalars['ID'];
};


export type QueryStructuresArgs = {
  filter?: InputMaybe<ProjectFilter>;
  orderBy?: InputMaybe<ProjectOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QuerySubdivisionArgs = {
  id: Scalars['ID'];
};


export type QueryTakeoffLineItemArgs = {
  id: Scalars['ID'];
  versionId?: InputMaybe<Scalars['ID']>;
};


export type QueryTakeoffLineItemsPageArgs = {
  filter?: InputMaybe<TakeoffLineItemFilter>;
  subFilter?: InputMaybe<TakeoffLineItemFilter>;
  order?: InputMaybe<Array<TakeoffLineItemOrder>>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  versionId?: InputMaybe<Scalars['ID']>;
};


export type QueryTestGroupDependenciesLineItemsArgs = {
  input: TestGroupDependenciesLineItemsInput;
};


export type QueryTaskArgs = {
  id: Scalars['ID'];
};


export type QueryTasksArgs = {
  filter?: InputMaybe<TaskFilter>;
  order?: InputMaybe<TaskOrder>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryTasks2Args = {
  filter?: InputMaybe<TaskFilter>;
  order?: InputMaybe<TaskOrder>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryTasksPageArgs = {
  filter?: InputMaybe<TaskFilter>;
  orderBy?: InputMaybe<TaskOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryToDosArgs = {
  filter: ToDoFilter;
  first?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryTrackedJobArgs = {
  id: Scalars['ID'];
};


export type QueryTrackedJobsArgs = {
  filter?: InputMaybe<TrackedJobFilter>;
};


export type QueryTradeCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryTradeCategoryLeadTimesArgs = {
  filter: TradeCategoryLeadTimeFilter;
};


export type QueryTradePartnersArgs = {
  filter?: InputMaybe<TradePartnerFilter>;
};


export type QueryTradePartnersPageArgs = {
  filter: TradePartnerFilter;
  page: PageFilter;
};


export type QueryTradePartnerArgs = {
  id: Scalars['ID'];
};


export type QueryTradePartnerContactsWithRolesArgs = {
  tradePartnerId: Scalars['ID'];
  scopeId: Scalars['ID'];
  marketRoles: Array<TradePartnerMarketRole>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTradePartnerContactsArgs = {
  filter: TradePartnerContactsFilter;
};


export type QueryTradePartnerRequirementArgs = {
  id: Scalars['ID'];
};


export type QueryTradePartnerRequirementsArgs = {
  filter?: InputMaybe<TradePartnerRequirementFilter>;
};


export type QueryUnitArgs = {
  id: Scalars['ID'];
};


export type QueryUserCommunicationPreferencesArgs = {
  user: Scalars['ID'];
};


export type QueryUserEventsArgs = {
  filter: UserEventFilter;
  order?: InputMaybe<UserEventOrder>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryUserGroupArgs = {
  id: Scalars['ID'];
};


export type QueryUserGroupsArgs = {
  filter?: InputMaybe<UserGroupFilter>;
};


export type QueryWarrantyTicketArgs = {
  id: Scalars['ID'];
};


export type QueryWarrantyTicketsArgs = {
  filter?: InputMaybe<WarrantyTicketFilter>;
};


export type QueryWarrantyTicketsPageArgs = {
  filter?: InputMaybe<WarrantyTicketFilter>;
  page?: InputMaybe<PageFilter>;
};


export type QueryWorkAuthorizationArgs = {
  id: Scalars['ID'];
};


export type QueryWorkAuthorizationsArgs = {
  filter?: InputMaybe<WorkAuthorizationFilter>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  saveHomeownerContractLineItems: Array<HomeownerContractLineItem>;
  resolveAiFieldProposals: ResolveAiFieldProposalsResult;
  saveApproval: SaveApprovalResult;
  saveApprovals: SaveApprovalsResult;
  saveApprover: SaveApproverResult;
  saveApprovers: SaveApproversResult;
  /**  Creates an asset upload url with the following  key structure `assets/${UUID}`.  */
  createAssetUploadUrl: CreateAssetUploadUrlResult;
  createAsset: CreateAssetResult;
  /**
   * Creates presigned URLs for multipart upload of large files.
   * Returns URLs for each part that the client should upload to.
   * Use the returned s3Key and uploadId in AssetInput when creating/attaching the asset.
   */
  createAssetMultipartUploadUrl: CreateAssetMultipartUploadUrlResult;
  /**
   * Aborts an in-progress multipart upload and cleans up uploaded parts.
   * Call this if the client cancels the upload or encounters errors.
   */
  abortAssetMultipartUpload: AbortAssetMultipartUploadResult;
  saveAttachment: SaveAttachmentResult;
  deleteAttachment: DeleteAttachmentResult;
  deleteAuditEvents: DeleteAuditEventsResult;
  saveBidContract: SaveBidContractResult;
  /**
   * Copies the bid contract's entered costs (PBBCLIs on its latest revision) from one product
   * offering onto the matching lines of the given sibling offerings.
   */
  copyPlanBasedBidCosts: CopyPlanBasedBidCostsResult;
  saveBidContractLineItem: SaveBidContractLineItemResult;
  saveBidContractLineItems: SaveBidContractLineItemsResult;
  deleteBidContractLineItems: DeleteBidContractLineItemResult;
  saveBidContractRevision: SaveBidContractRevisionResult;
  deleteBidContractRevision: EmptyResult;
  internallySignBidContractRevision: BidContractRevision;
  saveBidContractTradeLineItems: SaveBidContractTradeLineItemsResult;
  saveBidItem: SaveBidItemResult;
  saveBidItemEstimate: SaveBidItemEstimateResult;
  saveBidPackage: SaveBidPackageResult;
  saveBidPackages: SaveBidPackagesResult;
  acceptBidPackageIncomingUpdates: BidPackage;
  /**
   * PBBv2 only, advances a POF's RPAV on the BidPackageVersion to its published (active)
   * version and marks that POF's updates as accepted.
   */
  reviewBidPackageIncomingUpdates: BidPackage;
  deleteBidPackage: EmptyResult;
  /**
   * Creates a new BidPackageVersion on an already-awarded BidPackage, along with new draft BCRs, so costs
   * can be revised without re-running the full bidding workflow.
   */
  reviseBidPackageCosts: ReviseBidPackageCostsResult;
  /**
   * Enqueues a job that creates a new draft BCR on the bid package's latest version, migrating costs
   * from the given source BCR. Trade lines are matched by product offering and (globalOption + location)
   * equivalence, recovering costs that were dropped on the new bid package version when an option
   * group was recreated.
   */
  migrateBidPackageCosts: MigrateBidPackageCostsResult;
  saveBidPackageAwards: SaveBidPackageAwardsResult;
  saveBidPackageRequest: SaveBidPackageRequestResult;
  saveBill: SaveBillResult;
  saveBills: SaveBillsResult;
  deleteBill: EmptyResult;
  syncBillToIntacct: EmptyResult;
  handleBillEmailNotification: EmptyResult;
  handleBillParserResult: EmptyResult;
  runBillParser: RunBillParserResult;
  deletePreConBudgetLineItem: DeletePreConBudgetLineItemResult;
  savePreConBudgetLineItem: SavePreConBudgetLineItemResult;
  approvePreConBudget: ApprovePreConBudgetLineItemResult;
  saveBuilder: SaveBuilderResult;
  saveBusinessFunction: SaveBusinessFunctionResult;
  deleteChangeEvent: EmptyResult;
  saveChangeEvent: SaveChangeEventResult;
  saveChangeEvents: SaveChangeEventsResult;
  createChangeEventLineItemsFromCommitted: SaveChangeEventResult;
  createChangeEventFromBidContractRevision: SaveChangeEventResult;
  saveChangeEventLineItems: SaveChangeEventLineItemsResult;
  deleteChangeEventLineItems: EmptyResult;
  saveChangeEventReason: SaveChangeEventReasonResult;
  saveChangeRequest: SaveChangeRequestResult;
  saveChangeRequests: SaveChangeRequestsResult;
  saveChangeRequestAssets: SaveChangeRequestAssetsResult;
  saveChangeRequestGroup: SaveChangeRequestGroupResult;
  saveChangeRequestGroups: SaveChangeRequestGroupsResult;
  deleteChangeRequestGroup: EmptyResult;
  saveCheckoutConfig: SaveCheckoutConfigResult;
  /**
   * Provides an escape hatch for moving an already reserved checkout config back to draft status.
   * This includes clearing the reserved prices and cutoff dates
   *
   * If `preserveExpiresAt` is true, the expiresAt date will not be cleared.
   */
  unreserveCheckoutConfig: SaveCheckoutConfigResult;
  syncCheckoutConfigToVersion: SaveCheckoutConfigResult;
  runCheckoutPricingReport: RunCheckoutPricingReportResult;
  createCredentialsForExistingClient: EmptyResult;
  updateClientEmail: EmptyResult;
  saveCohorts: SaveCohortsResult;
  deleteCohort: EmptyResult;
  saveComment: SaveCommentResult;
  deleteComment: DeleteCommentResult;
  markCommentStreamAsRead?: Maybe<CommentStream>;
  saveCommitment: SaveCommitmentResult;
  saveCommitments: SaveCommitmentsResult;
  deleteCommitmentLineItems: EmptyResult;
  deleteCommitment: EmptyResult;
  /**  Marks commitments (or change orders) created from bid contracts for release (signed) to trade partners.  */
  releaseBidCommitments: Array<CommitmentLike>;
  /**  Creates/updates commitments based on Bid Contracts.  */
  saveBidToCommitments: SaveCommitmentsResult;
  moveCommitmentsToNewTradePartner: Scalars['String'];
  assignWorkToBidContract: Array<ChangeEvent>;
  /**  Creates draft Commitments for the given BCRs scoped to a single project.  */
  assignBidPackageWorkToBidContract: Array<Commitment>;
  unassignWorkFromBidContract: EmptyResult;
  createCommitmentFromBill: CreateCommitmentFromBillResult;
  saveCommitmentChangeOrder: SaveCommitmentChangeOrderResult;
  deleteCommitmentChangeOrder: EmptyResult;
  saveCommunity: SaveCommunityResult;
  saveCostCodes: SaveCostCodesResult;
  deleteCostCode: EmptyResult;
  saveCostDivisions: SaveCostDivisionsResult;
  deleteCostDivision: EmptyResult;
  saveCustomer: SaveCustomerResult;
  saveCustomerItemConfig: SaveCustomerItemConfigResult;
  saveCustomerOwnerEntity: SaveCustomerOwnerEntityResult;
  sendTestDailyLotSummaryDigest?: Maybe<EmptyResult>;
  deleteDataCacheEntry: EmptyResult;
  clearDataCache: EmptyResult;
  saveDesignPackage: SaveDesignPackageResult;
  createDesignPackagePlaceholderTli: CreateDesignPackagePlaceholderTliResult;
  acceptDesignPackageUpdates: SaveDesignPackageUpdatesResult;
  copyDesignPackage: SaveDesignPackageResult;
  copyDesignPackageCards: CopyDesignPackageCardsResult;
  savePersonalizationOptionGroup: SavePersonalizationOptionGroupResult;
  /**  Copies selections from one option to another (e.g., make SchemeA exactly match SchemeB).  */
  copyDesignPackageSelections: CopyDesignPackageSelectionsResult;
  /**  Auto-assigns package option materials to the POF RPOs that are linked to the DP Package Personalization RPOGs.  */
  autoAssignPackageOptionMaterials: EmptyResult;
  /**  TODO: Delete after we run this. Backfills contiguous, 1-based checkoutOrder onto DP RPOs from their POF counterparts.  */
  backfillDesignPackageOptionCheckoutOrder: Array<ReadyPlanOptionGroup>;
  saveDevelopments: SaveDevelopmentsResult;
  deleteDevelopments: EmptyResult;
  /**  A temporary mutation to bulk write primary bid costs into templates.  */
  pushBidCostsIntoTemplates: EmptyResult;
  saveDevelopmentCommitment: SaveDevelopmentCommitmentResult;
  deleteDevelopmentCommitment: EmptyResult;
  deleteDevelopmentCommitmentProjectsAndCommitments: DeleteDevelopmentCommitmentProjectsAndCommitmentsResult;
  saveDevelopmentOptions: SaveDevelopmentOptionsResult;
  saveDevelopmentTeamMember: EmptyResult;
  /** @deprecated Use `createAssetUploadUrl` to upload a document Asset, then use `saveDocuments` to create the Document and Asset. */
  createDocumentPendingUpload: CreateDocumentPendingUploadResult;
  /** @deprecated Use `createAssetUploadUrl` to upload a document Asset, then use `saveDocuments` to create the Document and Asset. */
  markDocumentAsUploaded: MarkDocumentAsUploadedResult;
  toggleDocumentAsFavorited: ToggleDocumentAsFavoritedResult;
  saveDocuments: SaveDocumentsResult;
  deleteDocuments: DeleteDocumentsResult;
  saveDrop: SaveDropResult;
  deleteDrop: EmptyResult;
  erpRevenueInitialBalance: EmptyResult;
  saveEstimate: SaveEstimateResult;
  saveExpenses: SaveExpensesResult;
  deleteExpenses: EmptyResult;
  convertExpenseToBill: ConvertExpenseToBillResult;
  saveExpenseAllocations: SaveExpenseAllocationsResult;
  saveFeatureFlag: SaveFeatureFlagResult;
  saveFeatureFlagTarget: SaveFeatureFlagTargetResult;
  saveFeatureType: SaveFeatureTypeResult;
  deleteFeatureType: EmptyResult;
  followSequenceSheet: FollowSequenceSheetResult;
  saveFollowers: SaveFollowersResult;
  saveGlobalOptions: SaveGlobalOptionsResult;
  migrateGlobalOption?: Maybe<EmptyResult>;
  migrateGlobalOptions?: Maybe<EmptyResult>;
  saveGlobalOptionGroup: SaveGlobalOptionGroupResult;
  saveGlobalOptionTags: SaveGlobalOptionTagsResult;
  saveGlobalOptionTypes: SaveGlobalOptionTypesResult;
  /**  Used to create and update GlobalPhases  */
  saveGlobalPhases: SaveGlobalPhasesResult;
  saveGlobalPlanConstraintItem: SaveGlobalPlanConstraintItemResult;
  saveGlobalPlanConstraintItems: SaveGlobalPlanConstraintItemsResult;
  deleteGlobalPlanConstraintItem: EmptyResult;
  saveGlobalPlanMilestone: SaveGlobalPlanMilestoneResult;
  saveGlobalPlanMilestones: SaveGlobalPlanMilestonesResult;
  saveGlobalPlanMilestoneGroup: SaveGlobalPlanMilestoneGroupResult;
  saveGlobalPlanStage: SaveGlobalPlanStageResult;
  saveGlobalPlanStageVariants: SaveGlobalPlanStageVariantsResult;
  saveGlobalPlanTag: SaveGlobalPlanTagResult;
  bulkSaveGlobalPlanTags: BulkSaveGlobalPlanTagsResult;
  saveGlobalPlanTask: SaveGlobalPlanTaskResult;
  saveGlobalPlanTasks: SaveGlobalPlanTasksResult;
  saveGlobalRequiredTaskDocument: SaveGlobalRequiredTaskDocumentResult;
  /**  Used to create and update globalSubPhases  */
  saveGlobalSubPhases: SaveGlobalSubPhasesResult;
  /**  Replaces one GlobalSubPhase with another on ALL Projects  */
  replaceGlobalSubPhase?: Maybe<ReplaceGlobalSubPhaseResult>;
  saveGlobalTasks: SaveGlobalTasksResult;
  saveHomeboundHoliday: SaveHomeboundHolidayResult;
  saveHomeowner: SaveHomeownerResult;
  /** Public mutation for signing up new homeowners */
  signUpHomeowner: EmptyResult;
  saveHomeownerContract: SaveHomeownerContractResult;
  saveHomeownerContractChangeOrder: SaveHomeownerContractChangeOrderResult;
  deleteHomeownerContract?: Maybe<EmptyResult>;
  deleteHomeownerContractChangeOrder?: Maybe<EmptyResult>;
  reverseEngineerInsuranceAndContingency?: Maybe<EmptyResult>;
  saveHomeownerNote: SaveHomeownerNoteResult;
  deleteHomeownerNote?: Maybe<EmptyResult>;
  saveInternalUser: SaveInternalUserResult;
  reassignTeamMembers?: Maybe<EmptyResult>;
  saveInvoice: SaveInvoiceResult;
  saveInvoices: SaveInvoicesResult;
  deleteInvoice: EmptyResult;
  syncInvoiceToIntacct: EmptyResult;
  saveInvoiceDocument: SaveInvoiceDocumentResult;
  deleteInvoiceSchedule: DeleteInvoiceScheduleResult;
  saveInvoiceScheduleTemplate: SaveInvoiceScheduleTemplateResult;
  saveItems: Array<Item>;
  deleteItem: EmptyResult;
  saveItemPlanTaskMapping: SaveItemPlanTaskMappingResult;
  deleteItemPlanTaskMapping: EmptyResult;
  saveItemSlot: SaveItemSlotResult;
  saveItemTemplate: SaveItemTemplateResult;
  saveItemTemplates: SaveItemTemplatesResult;
  applyItemTemplate: ApplyItemTemplateResult;
  applyItemTemplateToChangeEvent: ApplyItemTemplateToChangeEventResult;
  cloneItemTemplate: CloneItemTemplateResult;
  copyItemTemplateItems: CopyItemTemplateItemsResult;
  createNewItemTemplateVersions: CreateNewItemTemplateVersionsResult;
  activateItemTemplateVersions: ActivateItemTemplateVersionsResult;
  recalcItemTemplateHashes: EmptyResult;
  archiveItemTemplateVersions: EmptyResult;
  deleteItemTemplates: EmptyResult;
  saveItemTemplateItemVersions: SaveItemTemplateItemVersionsResult;
  dedupeReadyPlanItemTemplateItemVersions: DedupeReadyPlanItemTemplateItemVersionsResult;
  /**
   * !!! Never use these mutations in client side code or via automation. !!!
   * !!!         They are only intended to be called *manually*.          !!!
   */
  addJob: AddJobResult;
  addJobs: AddJobsResult;
  saveJobLog: SaveJobLogResult;
  duplicateJobLogs: DuplicateJobLogsResult;
  saveJobLogImage: SaveJobLogImageResult;
  deleteJobLogImage: DeleteJobLogImageResult;
  saveJobLogNote: SaveJobLogNoteResult;
  deleteJobLogNote: DeleteJobLogNoteResult;
  saveLienWaiver: SaveLienWaiverResult;
  saveLocations: SaveLocationsResult;
  deleteLocation: EmptyResult;
  /** Only returns locations that match the path received in the input */
  createLocationsFromPaths: SaveLocationsResult;
  saveLot: SaveLotResult;
  saveLotRating: SaveLotRatingResult;
  saveMarket: SaveMarketResult;
  saveMaterialAssemblyComponent: SaveMaterialAssemblyComponentResult;
  saveMaterialAttributeValue: SaveMaterialAttributeValueResult;
  backfillMavsNumericValues: BackfillResponse;
  saveMaterialBrand: SaveMaterialBrandResult;
  saveMaterialLeadTimeConfig: SaveMaterialLeadTimeConfigResult;
  mergeMaterialListings: MergeMaterialListingsResult;
  migrateMaterialListingItem: MigrateMaterialListingItemResult;
  saveMaterialListing: MaterialListing;
  saveMaterialVariant: SaveMaterialVariantResult;
  uploadMaterialVariants: UploadMaterialVariantsResult;
  mergeMaterialVariants: MergeMaterialVariantsResult;
  saveMaterialVariantTag: SaveMaterialVariantTagResult;
  saveOptionPricingConfigs: SaveOptionPricingConfigsResult;
  deleteOptionPricingConfig: EmptyResult;
  savePandaDoc: SavePandaDocResult;
  deletePandaDoc: DeletePandaDocResult;
  uploadPandaDoc: UploadPandaDocResult;
  handlePandaDocWebhook: EmptyResult;
  createPandaDocSession: PandaDocSession;
  savePaymentTerm: SavePaymentTermResult;
  savePlanPackage: SavePlanPackageResult;
  copyPlanPackage: SavePlanPackageResult;
  /**  TODO: Delete after we run this  */
  backfillPlanPackageOptionGroupLocations: Array<ReadyPlanOptionGroup>;
  createPlanPackageAiProposal: PlanPackageAiProposal;
  /**  Request slots for the given plan packages  */
  createPlanPackageIncomingSlots: Array<PlanPackageIncomingSlot>;
  /**  Delete ppis entirely  */
  deletePlanPackageIncomingSlots: EmptyResult;
  /**  Mark ppis as rejected  */
  rejectPlanPackageIncomingSlots: EmptyResult;
  savePlanSchedule: SavePlanScheduleResult;
  saveDraftSchedule: DraftScheduleResult;
  resetPlanScheduleDates: SavePlanScheduleResult;
  deletePlanSchedule: EmptyResult;
  /**
   * Pins Vertical Complete TDF to each Structure's TCT and re-scales non-user-set construction PMTs
   * using the community VC ratio. Non-Structure ids are skipped.
   */
  forceScalePlanMilestoneTargets: ForceScalePlanMilestoneTargetsResult;
  savePlanTask: SavePlanTaskResult;
  /**
   * Bulk endpoint for power users to make a limited set of changes to tasks across schedules.
   * Always prefer `saveDraftSchedule.draftTaskChanges` when operating on a single schedule.
   */
  bulkSavePlanTasks: BulkSavePlanTasksResult;
  savePlanTaskChecklistItem: SavePlanTaskChecklistItemResult;
  deletePlanTaskChecklistItem: EmptyResult;
  savePreconContractType: SavePreconContractTypeResult;
  saveProductOffering: SaveProductOfferingResult;
  acceptProductOfferingUpdates: ProductOffering;
  promoteToCheckout: EmptyResult;
  saveProductOfferingConfig: SaveProductOfferingConfigResult;
  saveProductType: SaveProductTypeResult;
  toggleProjectFeature: SaveProjectResult;
  deleteProject: EmptyResult;
  saveProject: SaveProjectResult;
  recalcProjectDates: EmptyResult;
  /**
   * Call the google maps api to populate projects with geocoding info based on build address.
   * We are currently calling this manually as a part of hack day. In the future we will also do this as a part of project creation
   */
  geocodeProjects: EmptyResult;
  resyncProjectFinancials: EmptyResult;
  cloneProjectCostAllocations: CloneProjectCostAllocationsResult;
  exportProjectBills: ExportProjectBillsResult;
  /** @deprecated Field no longer supported */
  createProjectFromReadyPlanConfig: SaveProjectResult;
  createProjectFromReadyPlan: SaveProjectResult;
  applyInvoiceScheduleToProject: ApplyInvoiceScheduleResult;
  saveProjectAllocationRule: SaveProjectAllocationRuleResult;
  saveProjectCollaborator: EmptyResult;
  sendInviteEmail: SendInviteEmailResult;
  deleteProjectCollaborator: EmptyResult;
  saveProjectContact: SaveProjectContactResult;
  saveProjectInvoiceSetting: SaveProjectInvoiceSettingResult;
  saveProjectItems: SaveProjectItemsResult;
  duplicateProjectItems: DuplicateProjectItemsResult;
  deleteProjectItem: EmptyResult;
  deleteProjectItems: EmptyResult;
  saveProjectLotDetails: SaveProjectLotDetailsResult;
  saveProjectReadyPlanConfigs: SaveProjectReadyPlanConfigsResult;
  applyProjectReadyPlanConfigs: ApplyProjectReadyPlanConfigsResult;
  /**  Used to update the price of ProjectReadyPlanConfigOptions.  */
  saveProjectReadyPlanConfigOptions: SaveProjectReadyPlanConfigOptionsResult;
  syncSalesforcePrpc: EmptyResult;
  saveProjectSiteCondition: SaveProjectSiteConditionResult;
  sendProjectSiteConditionsNotification: EmptyResult;
  saveProjectSiteSpecificInfo: SaveProjectSiteSpecificInfoResult;
  /**  Admin.  */
  saveProjectStage: EmptyResult;
  /**
   *  Schedule.
   * @deprecated Use `saveProjectStage`.
   */
  completeStage: EmptyResult;
  saveProjectStatusChangeReasons: SaveProjectStatusChangeReasonsResult;
  updateProjectRole: UpdateProjectRoleResult;
  bulkUpdateProjectRole: Array<BulkUpdateProjectRoleResult>;
  sendProjectUpdate?: Maybe<EmptyResult>;
  savePunchlistItemTodos: SavePunchlistItemTodosResult;
  /**
   * Sends an email to the trade partner associated with punchlist items.
   *
   * If additional emails or contacts are provided, then a single TradePartner must be associated with all items.
   * A project must be associated with all items, but multiple projects are allowed.
   */
  sendTradePartnerPunchlistEmail: SendTradePartnerPunchlistEmailResults;
  /** Export a CSV of punchlist items and send it via email. */
  sendPunchlistExportEmail: SendPunchlistExportEmailResults;
  registerPushNotificationToken: RegisterPushNotificationTokenResult;
  unregisterPushNotificationToken: EmptyResult;
  /**
   * Publishes a "Trigger Database Reset" event that routes through EventBridge to the
   * GraphQLServiceQaDatabaseReset state machine, which force-redeploys the calling task's
   * `<env>-db` and `<env>` ECS services (pulling the latest sanitized-from-prod image).
   */
  triggerQaDatabaseReset: TriggerQaDatabaseResetResult;
  saveReadyPlan: SaveReadyPlanResult;
  saveReadyPlans: SaveReadyPlansResult;
  deleteReadyPlans: EmptyResult;
  /**
   * Scopes GOGs to RPs via the GOG.readyPlan relation. Ensures global options are moved/copied accordingly.
   * Currently only supports scoping Interior/Exterior Scheme and Package Personalization GOGs to DPs.
   *
   * Example 1: Scoping Interior Scheme
   * Given an Interior Scheme GOG (gog:1) and the following DPs that use the GOG: rp:1, rp:2, rp:3,
   * When we scope the GOG to the DPs,
   * Then 3 new GOGs should be created:
   * - gog:2, readyPlan: rp:1
   * - gog:3, readyPlan: rp:2
   * - gog:4, readyPlan: rp:3
   * And the original GOG should be deleted
   */
  scopeGlobalOptionGroupsToReadyPlans: ScopeGlobalOptionGroupsToReadyPlansResult;
  saveReadyPlanAggregateVersion: SaveReadyPlanAggregateVersionResult;
  /**  Deletes a ReadyPlanAggregateVersion, and all related changes.  */
  deleteReadyPlanAggregateVersion: DeleteReadyPlanAggregateVersionResult;
  saveReadyPlanDesignNote: SaveReadyPlanDesignNoteResult;
  saveReadyPlanLocations: SaveReadyPlanLocationBulkResult;
  createDesignPackageAlternateLocation: CreateDesignPackageAlternateLocationResult;
  saveDesignPackageLocationPlanMappings: SaveDesignPackageLocationPlanMappingsResult;
  deleteDesignPackageAlternateLocation: SaveDesignPackageLocationPlanMappingsResult;
  saveReadyPlanOptions: SaveReadyPlanOptionsResult;
  mergeReadyPlanOptions: MergeReadyPlanOptionsResult;
  saveReadyPlanOptionGroup: SaveReadyPlanOptionGroupResult;
  saveReadyPlanOptionGroups: SaveReadyPlanOptionGroupsResult;
  saveReadyPlanOptionProgramDataModifications: SaveReadyPlanOptionProgramDataModificationsResult;
  deleteReadyPlanOptionProgramDataModifications: Array<DeleteReadyPlanOptionProgramDataModificationsResult>;
  saveReadyPlanRequiredOptions: SaveReadyPlanRequiredOptionsResult;
  saveReferences: SaveReferencesResult;
  deleteReferences: EmptyResult;
  saveRegion: SaveRegionResult;
  saveRequiredTaskDocument: SaveRequiredTaskDocumentResult;
  deleteRequireTaskDocument: DeleteRequiredTaskDocumentResult;
  saveRoomType: SaveRoomTypeResult;
  testMutation: TestMutationResult;
  syncSalesforceEntity: EmptyResult;
  saveSchedule: SaveScheduleResult;
  /** @deprecated This mutation is no longer supported, please use the `resetScheduleBaselines` job via `addJobForSchedules` mutation instead. */
  resetScheduleBaselines: ResetScheduleBaselinesResult;
  scheduleSoftDeleteSubPhasesWithEmptyTasks?: Maybe<EmptyResult>;
  addJobForSchedules: EmptyResult;
  saveScheduleFlag: SaveScheduleFlagResult;
  deleteScheduleFlag: DeleteScheduleFlagResult;
  saveScheduleFlagReasons: SaveScheduleFlagReasonsResult;
  /**  Used to Create and Update SchedulePhases  */
  saveSchedulePhases: SaveSchedulePhasesResult;
  deleteSchedulePhases: DeleteSchedulePhasesResult;
  recalculateSchedulePhaseStatus: EmptyResult;
  saveScheduleSettings: SaveScheduleSettingsResult;
  /** Create or update one or more ScheduleSubPhases */
  saveScheduleSubPhases: SaveScheduleSubPhasesResult;
  /** Delete a ScheduleSubPhase and all associated ScheduleTasks */
  deleteScheduleSubPhases: DeleteScheduleSubPhasesResult;
  /** Move a list of ScheduleSubPhases to different GlobalPhase -> SchedulePhase parent */
  moveScheduleSubPhases: MoveScheduleSubPhasesResult;
  /** Recalculate the task status rollup on ScheduleSubPhases via a job */
  recalculateScheduleSubPhaseStatus: EmptyResult;
  saveScheduleTasks: SaveScheduleTasksResult;
  saveScheduleTaskChecklistItem: SaveScheduleTaskChecklistItemResult;
  deleteScheduleTaskChecklistItem: EmptyResult;
  applyTemplateChecklistItems?: Maybe<EmptyResult>;
  saveScheduleTemplates: SaveScheduleTemplatesResult;
  duplicateScheduleTemplate: DuplicateScheduleTemplateResult;
  applyScheduleTemplates: ApplyScheduleTemplatesResult;
  saveScheduleTemplateItemMappings: SaveScheduleTemplateItemMappingsResult;
  saveScopeChangeReason: SaveScopeChangeReasonResult;
  setupData: EmptyResult;
  saveSiteSpecificInfo: SaveSiteSpecificInfoResult;
  saveStructure: SaveStructureResult;
  saveSubdivision: SaveSubdivisionResult;
  saveSubmarket: SaveSubmarketResult;
  saveTakeoffLineItems: SaveTakeoffLineItemResult;
  copyTakeoffLineItems: CopyTakeoffLineItemsResult;
  /** @deprecated Use `saveScheduleTasks` with `delete: true` instead */
  deleteTask: EmptyResult;
  saveTaskWorkDay: SaveTaskWorkDayResult;
  saveToDos: SaveToDosResult;
  deleteToDo: EmptyResult;
  saveToDoChecklistItem: SaveToDoChecklistItemResult;
  saveTradeCategory: SaveTradeCategoryResult;
  saveTradeCategoryLeadTimes: SaveTradeCategoryLeadTimesResult;
  /** @deprecated Use `saveTradePartners`. */
  saveTradePartner: SaveTradePartnerResult;
  saveTradePartners: SaveTradePartnersResult;
  deleteTradePartner: EmptyResult;
  saveTradePartnerAgreement: SaveTradePartnerAgreementResult;
  deleteTradePartnerAgreement: DeleteTradePartnerAgreementResult;
  saveTradePartnerAvailabilityRequest: SaveTradePartnerAvailabilityRequestResult;
  saveTradePartnerAvailabilityRequests: SaveTradePartnerAvailabilityRequestsResult;
  /**  keeping this input separate for permissioning with the trade portal.  */
  updateTradePartnerAvailabilityRequestStatus: EmptyResult;
  approveTradePartnerAvailabilityRequest: EmptyResult;
  saveTradePartnerContact: SaveTradePartnerContactResult;
  deleteTradePartnerContact: DeleteTradePartnerContactResult;
  saveTradePartnerMarketContact: SaveTradePartnerMarketContactResult;
  deleteTradePartnerMarketContact: DeleteTradePartnerMarketContactResult;
  saveTradePartnerRequirement: SaveTradePartnerRequirementResult;
  saveTradePartnerReview: SaveTradePartnerReviewResult;
  saveUnit: SaveUnitResult;
  saveUnitsOfMeasure: SaveUnitsOfMeasureResult;
  deleteUnitOfMeasure: EmptyResult;
  saveUser: SaveUserResult;
  activateUser: ActivateUserResult;
  deactivateUser: DeactivateUserResult;
  activateUsers: ActivateUsersResult;
  deactivateUsers: DeactivateUsersResult;
  saveUserCommunicationPreference: SaveUserCommunicationPreferenceResult;
  saveUserGroup: SaveUserGroupResult;
  removeUserGroup: EmptyResult;
  deleteWarrantyTicket: EmptyResult;
  saveWarrantyTicket: SaveWarrantyTicketResult;
  saveWarrantyTicketItem: SaveWarrantyTicketItemResult;
  deleteWarrantyTicketItem: EmptyResult;
  saveWarrantyTicketItems: SaveWarrantyTicketItemsResult;
  saveWorkAuthorization: SaveWorkAuthorizationResult;
  deleteWorkAuthorization: EmptyResult;
};


export type MutationSaveHomeownerContractLineItemsArgs = {
  input: SaveHomeownerContractLineItemsInput;
};


export type MutationResolveAiFieldProposalsArgs = {
  input: Array<ResolveAiFieldProposalInput>;
};


export type MutationSaveApprovalArgs = {
  input: SaveApprovalInput;
};


export type MutationSaveApprovalsArgs = {
  input: Array<SaveApprovalInput>;
};


export type MutationSaveApproverArgs = {
  input: SaveApproverInput;
};


export type MutationSaveApproversArgs = {
  inputs: Array<SaveApproverInput>;
};


export type MutationCreateAssetUploadUrlArgs = {
  input: CreateAssetUploadUrlInput;
};


export type MutationCreateAssetArgs = {
  input: AssetInput;
};


export type MutationCreateAssetMultipartUploadUrlArgs = {
  input: CreateAssetMultipartUploadUrlInput;
};


export type MutationAbortAssetMultipartUploadArgs = {
  input: AbortAssetMultipartUploadInput;
};


export type MutationSaveAttachmentArgs = {
  input: SaveAttachmentInput;
};


export type MutationDeleteAttachmentArgs = {
  input: DeleteAttachmentInput;
};


export type MutationDeleteAuditEventsArgs = {
  input: DeleteAuditEventsInput;
};


export type MutationSaveBidContractArgs = {
  input: SaveBidContractInput;
};


export type MutationCopyPlanBasedBidCostsArgs = {
  input: CopyPlanBasedBidCostsInput;
};


export type MutationSaveBidContractLineItemArgs = {
  input: SaveBidContractLineItemInput;
};


export type MutationSaveBidContractLineItemsArgs = {
  bidContractRevisionId: Scalars['ID'];
  lineItems: Array<SaveBidContractLineItemInput>;
};


export type MutationDeleteBidContractLineItemsArgs = {
  bidContractRevisionId: Scalars['ID'];
  lineItemIds: Array<Scalars['ID']>;
};


export type MutationSaveBidContractRevisionArgs = {
  input: SaveBidContractRevisionInput;
};


export type MutationDeleteBidContractRevisionArgs = {
  input: DeleteBidContractRevisionInput;
};


export type MutationInternallySignBidContractRevisionArgs = {
  input: InternallySignBidContractRevisionInput;
};


export type MutationSaveBidContractTradeLineItemsArgs = {
  input: SaveBidContractTradeLineItemsInput;
};


export type MutationSaveBidItemArgs = {
  input: SaveBidItemInput;
};


export type MutationSaveBidItemEstimateArgs = {
  input: SaveBidItemEstimateInput;
};


export type MutationSaveBidPackageArgs = {
  input: SaveBidPackageInput;
};


export type MutationSaveBidPackagesArgs = {
  input: Array<SaveBidPackageInput>;
};


export type MutationAcceptBidPackageIncomingUpdatesArgs = {
  input: AcceptBidPackageIncomingUpdatesInput;
};


export type MutationReviewBidPackageIncomingUpdatesArgs = {
  input: ReviewBidPackageIncomingUpdatesInput;
};


export type MutationDeleteBidPackageArgs = {
  input: DeleteEntityInput;
};


export type MutationReviseBidPackageCostsArgs = {
  input: ReviseBidPackageCostsInput;
};


export type MutationMigrateBidPackageCostsArgs = {
  input: MigrateBidPackageCostsInput;
};


export type MutationSaveBidPackageAwardsArgs = {
  input: SaveBidPackageAwardsInput;
};


export type MutationSaveBidPackageRequestArgs = {
  input: SaveBidPackageRequestInput;
};


export type MutationSaveBillArgs = {
  input: SaveBillInput;
};


export type MutationSaveBillsArgs = {
  input: SaveBillsInput;
};


export type MutationDeleteBillArgs = {
  input: DeleteBillInput;
};


export type MutationSyncBillToIntacctArgs = {
  input: SyncBillToIntacctInput;
};


export type MutationHandleBillEmailNotificationArgs = {
  input: HandleBillEmailNotificationInput;
};


export type MutationHandleBillParserResultArgs = {
  input: HandleBillParserResultInput;
};


export type MutationRunBillParserArgs = {
  input: RunBillParserInput;
};


export type MutationDeletePreConBudgetLineItemArgs = {
  input: DeletePreConBudgetLineItemInput;
};


export type MutationSavePreConBudgetLineItemArgs = {
  input: SavePreConBudgetLineItemInput;
};


export type MutationApprovePreConBudgetArgs = {
  input: ApprovePreConBudgetLineItemInput;
};


export type MutationSaveBuilderArgs = {
  input: SaveBuilderInput;
};


export type MutationSaveBusinessFunctionArgs = {
  input: SaveBusinessFunctionInput;
};


export type MutationDeleteChangeEventArgs = {
  input: DeleteChangeEventInput;
};


export type MutationSaveChangeEventArgs = {
  input: SaveChangeEventInput;
};


export type MutationSaveChangeEventsArgs = {
  input: Array<SaveChangeEventsInput>;
};


export type MutationCreateChangeEventLineItemsFromCommittedArgs = {
  changeEventId: Scalars['ID'];
  includeDraftCommitments?: InputMaybe<Scalars['Boolean']>;
  includeZeroCommitted?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateChangeEventFromBidContractRevisionArgs = {
  input: CreateChangeEventFromBidContractRevisionInput;
};


export type MutationSaveChangeEventLineItemsArgs = {
  input: SaveChangeEventLineItemsInput;
};


export type MutationDeleteChangeEventLineItemsArgs = {
  input: DeleteEntitiesInput;
};


export type MutationSaveChangeEventReasonArgs = {
  input: SaveChangeEventReasonInput;
};


export type MutationSaveChangeRequestArgs = {
  input: SaveChangeRequestInput;
};


export type MutationSaveChangeRequestsArgs = {
  input: SaveChangeRequestsInput;
};


export type MutationSaveChangeRequestAssetsArgs = {
  input: SaveChangeRequestAssetsInput;
};


export type MutationSaveChangeRequestGroupArgs = {
  input: SaveChangeRequestGroupInput;
};


export type MutationSaveChangeRequestGroupsArgs = {
  input: Array<SaveChangeRequestGroupInput>;
};


export type MutationDeleteChangeRequestGroupArgs = {
  input: DeleteEntityInput;
};


export type MutationSaveCheckoutConfigArgs = {
  input: SaveCheckoutConfigInput;
};


export type MutationUnreserveCheckoutConfigArgs = {
  input: UnreserveCheckoutConfigInput;
};


export type MutationSyncCheckoutConfigToVersionArgs = {
  input: SyncCheckoutConfigToVersionInput;
};


export type MutationRunCheckoutPricingReportArgs = {
  input: RunCheckoutPricingReportInput;
};


export type MutationCreateCredentialsForExistingClientArgs = {
  input: CreateCredentialsForExistingClientInput;
};


export type MutationUpdateClientEmailArgs = {
  input: UpdateClientEmailInput;
};


export type MutationSaveCohortsArgs = {
  input: SaveCohortsInput;
};


export type MutationDeleteCohortArgs = {
  input: DeleteCohortInput;
};


export type MutationSaveCommentArgs = {
  input: SaveCommentInput;
};


export type MutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


export type MutationMarkCommentStreamAsReadArgs = {
  input: MarkCommentStreamAsReadInput;
};


export type MutationSaveCommitmentArgs = {
  input: SaveCommitmentInput;
};


export type MutationSaveCommitmentsArgs = {
  input: Array<SaveCommitmentInput>;
};


export type MutationDeleteCommitmentLineItemsArgs = {
  input: DeleteCommitmentLineItemsInput;
};


export type MutationDeleteCommitmentArgs = {
  input: DeleteCommitmentInput;
};


export type MutationReleaseBidCommitmentsArgs = {
  commitmentLikeIds: Array<Scalars['ID']>;
};


export type MutationSaveBidToCommitmentsArgs = {
  inputs: Array<SaveBidToCommitmentsInput>;
};


export type MutationMoveCommitmentsToNewTradePartnerArgs = {
  input: MoveCommitmentsToNewTradePartnerInput;
};


export type MutationAssignWorkToBidContractArgs = {
  input: Array<AssignWorkToBidContractInput>;
};


export type MutationAssignBidPackageWorkToBidContractArgs = {
  input: AssignBidPackageWorkToBidContractInput;
};


export type MutationUnassignWorkFromBidContractArgs = {
  input: UnassignWorkFromBidContractInput;
};


export type MutationCreateCommitmentFromBillArgs = {
  input: CreateCommitmentFromBillInput;
};


export type MutationSaveCommitmentChangeOrderArgs = {
  input: SaveCommitmentChangeOrderInput;
};


export type MutationDeleteCommitmentChangeOrderArgs = {
  input: DeleteCommitmentChangeOrderInput;
};


export type MutationSaveCommunityArgs = {
  input: SaveCommunityInput;
};


export type MutationSaveCostCodesArgs = {
  input: SaveCostCodesInput;
};


export type MutationDeleteCostCodeArgs = {
  input: DeleteCostCodeInput;
};


export type MutationSaveCostDivisionsArgs = {
  input: SaveCostDivisionsInput;
};


export type MutationDeleteCostDivisionArgs = {
  input: DeleteCostDivisionInput;
};


export type MutationSaveCustomerArgs = {
  input: SaveCustomerInput;
};


export type MutationSaveCustomerItemConfigArgs = {
  input: SaveCustomerItemConfigInput;
};


export type MutationSaveCustomerOwnerEntityArgs = {
  input: SaveCustomerOwnerEntityInput;
};


export type MutationSendTestDailyLotSummaryDigestArgs = {
  input: SendTestDailyLotSummaryDigestInput;
};


export type MutationDeleteDataCacheEntryArgs = {
  input: DeleteDataCacheEntryInput;
};


export type MutationClearDataCacheArgs = {
  input: ClearDataCacheInput;
};


export type MutationSaveDesignPackageArgs = {
  input: SaveDesignPackageInput;
};


export type MutationCreateDesignPackagePlaceholderTliArgs = {
  input: CreateDesignPackagePlaceholderTliInput;
};


export type MutationAcceptDesignPackageUpdatesArgs = {
  input: AcceptDesignPackageUpdatesInput;
};


export type MutationCopyDesignPackageArgs = {
  input: CopyDesignPackageInput;
};


export type MutationCopyDesignPackageCardsArgs = {
  input: CopyDesignPackageCardsInput;
};


export type MutationSavePersonalizationOptionGroupArgs = {
  input: SavePersonalizationOptionGroupInput;
};


export type MutationCopyDesignPackageSelectionsArgs = {
  input: CopyDesignPackageSelectionsInput;
};


export type MutationAutoAssignPackageOptionMaterialsArgs = {
  input: AutoAssignPackageOptionMaterialsInput;
};


export type MutationBackfillDesignPackageOptionCheckoutOrderArgs = {
  input: BackfillDesignPackageOptionCheckoutOrderInput;
};


export type MutationSaveDevelopmentsArgs = {
  input: SaveDevelopmentsInput;
};


export type MutationDeleteDevelopmentsArgs = {
  input: DeleteEntitiesInput;
};


export type MutationPushBidCostsIntoTemplatesArgs = {
  developmentId?: InputMaybe<Scalars['ID']>;
};


export type MutationSaveDevelopmentCommitmentArgs = {
  input: SaveDevelopmentCommitmentInput;
};


export type MutationDeleteDevelopmentCommitmentArgs = {
  input: DeleteDevelopmentCommitmentInput;
};


export type MutationDeleteDevelopmentCommitmentProjectsAndCommitmentsArgs = {
  input: DeleteDevelopmentCommitmentProjectsAndCommitmentsInput;
};


export type MutationSaveDevelopmentOptionsArgs = {
  input: SaveDevelopmentOptionsInput;
};


export type MutationSaveDevelopmentTeamMemberArgs = {
  input: SaveDevelopmentTeamMemberInput;
};


export type MutationCreateDocumentPendingUploadArgs = {
  input: CreateDocumentPendingUploadInput;
};


export type MutationMarkDocumentAsUploadedArgs = {
  input: MarkDocumentAsUploadedInput;
};


export type MutationToggleDocumentAsFavoritedArgs = {
  input: ToggleDocumentAsFavoritedInput;
};


export type MutationSaveDocumentsArgs = {
  input: SaveDocumentsInput;
};


export type MutationDeleteDocumentsArgs = {
  input: DeleteEntitiesInput;
};


export type MutationSaveDropArgs = {
  input: SaveDropInput;
};


export type MutationDeleteDropArgs = {
  input: DeleteDropInput;
};


export type MutationErpRevenueInitialBalanceArgs = {
  input: ErpRevenueInitialBalanceInput;
};


export type MutationSaveEstimateArgs = {
  input: SaveEstimateInput;
};


export type MutationSaveExpensesArgs = {
  input: SaveExpensesInput;
};


export type MutationDeleteExpensesArgs = {
  input: DeleteEntitiesInput;
};


export type MutationConvertExpenseToBillArgs = {
  input: ConvertExpenseToBillInput;
};


export type MutationSaveExpenseAllocationsArgs = {
  input: SaveExpenseAllocationsInput;
};


export type MutationSaveFeatureFlagArgs = {
  input: SaveFeatureFlagInput;
};


export type MutationSaveFeatureFlagTargetArgs = {
  input: SaveFeatureFlagTargetInput;
};


export type MutationSaveFeatureTypeArgs = {
  input: SaveFeatureTypeInput;
};


export type MutationDeleteFeatureTypeArgs = {
  input: DeleteFeatureTypeInput;
};


export type MutationFollowSequenceSheetArgs = {
  input: FollowSequenceSheetInput;
};


export type MutationSaveFollowersArgs = {
  input: SaveFollowersInput;
};


export type MutationSaveGlobalOptionsArgs = {
  input: SaveGlobalOptionsInput;
};


export type MutationMigrateGlobalOptionArgs = {
  input: MigrateGlobalOptionInput;
};


export type MutationMigrateGlobalOptionsArgs = {
  input: MigrateGlobalOptionsInput;
};


export type MutationSaveGlobalOptionGroupArgs = {
  input: SaveGlobalOptionGroupInput;
};


export type MutationSaveGlobalOptionTagsArgs = {
  input: SaveGlobalOptionTagsInput;
};


export type MutationSaveGlobalOptionTypesArgs = {
  input: SaveGlobalOptionTypesInput;
};


export type MutationSaveGlobalPhasesArgs = {
  input: SaveGlobalPhasesInput;
};


export type MutationSaveGlobalPlanConstraintItemArgs = {
  input: SaveGlobalPlanConstraintItemInput;
};


export type MutationSaveGlobalPlanConstraintItemsArgs = {
  input: Array<SaveGlobalPlanConstraintItemInput>;
};


export type MutationDeleteGlobalPlanConstraintItemArgs = {
  input: DeleteGlobalPlanConstraintItemInput;
};


export type MutationSaveGlobalPlanMilestoneArgs = {
  input: SaveGlobalPlanMilestoneInput;
};


export type MutationSaveGlobalPlanMilestonesArgs = {
  input: SaveGlobalPlanMilestonesInput;
};


export type MutationSaveGlobalPlanMilestoneGroupArgs = {
  input: SaveGlobalMilestoneGroupInput;
};


export type MutationSaveGlobalPlanStageArgs = {
  input: SaveGlobalPlanStageInput;
};


export type MutationSaveGlobalPlanStageVariantsArgs = {
  input: SaveGlobalPlanStageVariantsInput;
};


export type MutationSaveGlobalPlanTagArgs = {
  input: SaveGlobalPlanTagInput;
};


export type MutationBulkSaveGlobalPlanTagsArgs = {
  input: Array<SaveGlobalPlanTagInput>;
};


export type MutationSaveGlobalPlanTaskArgs = {
  input: SaveGlobalPlanTaskInput;
};


export type MutationSaveGlobalPlanTasksArgs = {
  input: Array<SaveGlobalPlanTaskInput>;
};


export type MutationSaveGlobalRequiredTaskDocumentArgs = {
  input: SaveGlobalRequiredTaskDocumentInput;
};


export type MutationSaveGlobalSubPhasesArgs = {
  input: SaveGlobalSubPhasesInput;
};


export type MutationReplaceGlobalSubPhaseArgs = {
  input: ReplaceGlobalSubPhaseInput;
};


export type MutationSaveGlobalTasksArgs = {
  input: SaveGlobalTasksInput;
};


export type MutationSaveHomeboundHolidayArgs = {
  input: SaveHomeboundHolidayInput;
};


export type MutationSaveHomeownerArgs = {
  input: SaveHomeownerInput;
};


export type MutationSignUpHomeownerArgs = {
  input: SignUpHomeownerInput;
};


export type MutationSaveHomeownerContractArgs = {
  input: SaveHomeownerContractInput;
};


export type MutationSaveHomeownerContractChangeOrderArgs = {
  input: SaveHomeownerContractChangeOrderInput;
};


export type MutationDeleteHomeownerContractArgs = {
  input: DeleteEntityInput;
};


export type MutationDeleteHomeownerContractChangeOrderArgs = {
  input: DeleteHomeownerContractChangeOrderInput;
};


export type MutationReverseEngineerInsuranceAndContingencyArgs = {
  homeownerContractId: Scalars['ID'];
  newMarkupInBasisPoints: Scalars['Int'];
  insuranceItemId: Scalars['ID'];
  insurancePriceInCents: Scalars['Int'];
  contingencyItemId: Scalars['ID'];
};


export type MutationSaveHomeownerNoteArgs = {
  input: SaveHomeownerNoteInput;
};


export type MutationDeleteHomeownerNoteArgs = {
  input: DeleteEntityInput;
};


export type MutationSaveInternalUserArgs = {
  input: SaveInternalUserInput;
};


export type MutationReassignTeamMembersArgs = {
  input: ReassignTeamMembersInput;
};


export type MutationSaveInvoiceArgs = {
  input: SaveInvoiceInput;
};


export type MutationSaveInvoicesArgs = {
  input: SaveInvoicesInput;
};


export type MutationDeleteInvoiceArgs = {
  input: DeleteInvoiceInput;
};


export type MutationSyncInvoiceToIntacctArgs = {
  input: SyncInvoiceToIntacctInput;
};


export type MutationSaveInvoiceDocumentArgs = {
  input: SaveInvoiceDocumentInput;
};


export type MutationDeleteInvoiceScheduleArgs = {
  input: DeleteInvoiceScheduleInput;
};


export type MutationSaveInvoiceScheduleTemplateArgs = {
  input: SaveInvoiceScheduleTemplateInput;
};


export type MutationSaveItemsArgs = {
  input: SaveItemsInput;
};


export type MutationDeleteItemArgs = {
  input: DeleteItemInput;
};


export type MutationSaveItemPlanTaskMappingArgs = {
  input: SaveItemPlanTaskMappingInput;
};


export type MutationDeleteItemPlanTaskMappingArgs = {
  input: DeleteItemPlanTaskMappingInput;
};


export type MutationSaveItemSlotArgs = {
  input: SaveItemSlotInput;
};


export type MutationSaveItemTemplateArgs = {
  input: SaveItemTemplateInput;
};


export type MutationSaveItemTemplatesArgs = {
  input: SaveItemTemplatesInput;
};


export type MutationApplyItemTemplateArgs = {
  input: ApplyItemTemplateInput;
};


export type MutationApplyItemTemplateToChangeEventArgs = {
  input: ApplyItemTemplateToChangeEventInput;
};


export type MutationCloneItemTemplateArgs = {
  input: CloneItemTemplateInput;
};


export type MutationCopyItemTemplateItemsArgs = {
  input: CopyItemTemplateItemsInput;
};


export type MutationCreateNewItemTemplateVersionsArgs = {
  input: CreateNewItemTemplateVersionsInput;
};


export type MutationActivateItemTemplateVersionsArgs = {
  input: ActivateItemTemplateVersionsInput;
};


export type MutationRecalcItemTemplateHashesArgs = {
  input?: InputMaybe<ItemTemplateFilter>;
};


export type MutationArchiveItemTemplateVersionsArgs = {
  input: ArchiveItemTemplateVersionsInput;
};


export type MutationDeleteItemTemplatesArgs = {
  input: DeleteEntitiesInput;
};


export type MutationSaveItemTemplateItemVersionsArgs = {
  input: SaveItemTemplateItemVersionsInput;
  groupTotalsInput?: InputMaybe<GroupTotalsInput>;
};


export type MutationDedupeReadyPlanItemTemplateItemVersionsArgs = {
  input: DedupeReadyPlanItemTemplateItemVersionsInput;
};


export type MutationAddJobArgs = {
  input: AddJobInput;
};


export type MutationAddJobsArgs = {
  input: AddJobsInput;
};


export type MutationSaveJobLogArgs = {
  input: SaveJobLogInput;
};


export type MutationDuplicateJobLogsArgs = {
  input: DuplicateJobLogsInput;
};


export type MutationSaveJobLogImageArgs = {
  input: SaveJobLogImageInput;
};


export type MutationDeleteJobLogImageArgs = {
  input: DeleteJobLogImageInput;
};


export type MutationSaveJobLogNoteArgs = {
  input: SaveJobLogNoteInput;
};


export type MutationDeleteJobLogNoteArgs = {
  input: DeleteJobLogNoteInput;
};


export type MutationSaveLienWaiverArgs = {
  input: SaveLienWaiverInput;
};


export type MutationSaveLocationsArgs = {
  input: SaveLocationsInput;
};


export type MutationDeleteLocationArgs = {
  input: DeleteLocationInput;
};


export type MutationCreateLocationsFromPathsArgs = {
  input: CreateLocationsFromPathsInput;
};


export type MutationSaveLotArgs = {
  input: SaveLotInput;
};


export type MutationSaveLotRatingArgs = {
  input: SaveLotRatingInput;
};


export type MutationSaveMarketArgs = {
  input: SaveMarketInput;
};


export type MutationSaveMaterialAssemblyComponentArgs = {
  input: SaveMaterialAssemblyComponentInput;
};


export type MutationSaveMaterialAttributeValueArgs = {
  input: SaveMaterialAttributeValueInput;
};


export type MutationSaveMaterialBrandArgs = {
  input: SaveMaterialBrandInput;
};


export type MutationSaveMaterialLeadTimeConfigArgs = {
  input: SaveMaterialLeadTimeConfigInput;
};


export type MutationMergeMaterialListingsArgs = {
  input: MergeMaterialListingsInput;
};


export type MutationMigrateMaterialListingItemArgs = {
  input: MigrateMaterialListingItemInput;
};


export type MutationSaveMaterialListingArgs = {
  input: SaveMaterialListingInput;
};


export type MutationSaveMaterialVariantArgs = {
  input: SaveMaterialVariantInput;
};


export type MutationUploadMaterialVariantsArgs = {
  input: UploadMaterialVariantsInput;
};


export type MutationMergeMaterialVariantsArgs = {
  input: MergeMaterialVariantsInput;
};


export type MutationSaveMaterialVariantTagArgs = {
  input: SaveMaterialVariantTagInput;
};


export type MutationSaveOptionPricingConfigsArgs = {
  input: SaveOptionPricingConfigsInput;
};


export type MutationDeleteOptionPricingConfigArgs = {
  input: DeleteOptionPricingConfigInput;
};


export type MutationSavePandaDocArgs = {
  input: SavePandaDocInput;
};


export type MutationDeletePandaDocArgs = {
  input: DeletePandaDocInput;
};


export type MutationUploadPandaDocArgs = {
  input: UploadPandaDocInput;
};


export type MutationHandlePandaDocWebhookArgs = {
  input: HandlePandaDocWebhookInput;
};


export type MutationCreatePandaDocSessionArgs = {
  input: CreatePandaDocSessionInput;
};


export type MutationSavePaymentTermArgs = {
  input: SavePaymentTermInput;
};


export type MutationSavePlanPackageArgs = {
  input: SavePlanPackageInput;
};


export type MutationCopyPlanPackageArgs = {
  input: CopyPlanPackageInput;
};


export type MutationBackfillPlanPackageOptionGroupLocationsArgs = {
  input: BackfillPlanPackageOptionGroupLocationsInput;
};


export type MutationCreatePlanPackageAiProposalArgs = {
  input: CreatePlanPackageAiProposalInput;
};


export type MutationCreatePlanPackageIncomingSlotsArgs = {
  input: CreatePlanPackageIncomingSlotsInput;
};


export type MutationDeletePlanPackageIncomingSlotsArgs = {
  input: PlanPackageIncomingSlotIdsInput;
};


export type MutationRejectPlanPackageIncomingSlotsArgs = {
  input: PlanPackageIncomingSlotIdsInput;
};


export type MutationSavePlanScheduleArgs = {
  input: SavePlanScheduleInput;
};


export type MutationSaveDraftScheduleArgs = {
  input: DraftScheduleInput;
};


export type MutationResetPlanScheduleDatesArgs = {
  input: ResetPlanScheduleDatesInput;
};


export type MutationDeletePlanScheduleArgs = {
  input: DeleteEntityInput;
};


export type MutationForceScalePlanMilestoneTargetsArgs = {
  input: ForceScalePlanMilestoneTargetsInput;
};


export type MutationSavePlanTaskArgs = {
  input: SavePlanTaskInput;
};


export type MutationBulkSavePlanTasksArgs = {
  input: Array<BulkSavePlanTaskInput>;
};


export type MutationSavePlanTaskChecklistItemArgs = {
  input: SavePlanTaskChecklistItemInput;
};


export type MutationDeletePlanTaskChecklistItemArgs = {
  input: DeletePlanTaskChecklistItemInput;
};


export type MutationSavePreconContractTypeArgs = {
  input: SavePreconContractTypeInput;
};


export type MutationSaveProductOfferingArgs = {
  input: SaveProductOfferingInput;
};


export type MutationAcceptProductOfferingUpdatesArgs = {
  input: AcceptProductOfferingUpdatesInput;
};


export type MutationPromoteToCheckoutArgs = {
  input: PromoteToCheckoutInput;
};


export type MutationSaveProductOfferingConfigArgs = {
  input: SaveProductOfferingConfigInput;
};


export type MutationSaveProductTypeArgs = {
  input: SaveProductTypeInput;
};


export type MutationToggleProjectFeatureArgs = {
  input: ToggleProjectFeatureInput;
};


export type MutationDeleteProjectArgs = {
  input: DeleteProjectInput;
};


export type MutationSaveProjectArgs = {
  input: ProjectInput;
};


export type MutationRecalcProjectDatesArgs = {
  input: RecalcProjectDatesInput;
};


export type MutationGeocodeProjectsArgs = {
  input: GeocodeProjectsInput;
};


export type MutationResyncProjectFinancialsArgs = {
  input?: InputMaybe<ResyncProjectFinancialsInput>;
};


export type MutationCloneProjectCostAllocationsArgs = {
  input: CloneProjectCostAllocationsInput;
};


export type MutationExportProjectBillsArgs = {
  input: ExportProjectBillsInput;
};


export type MutationCreateProjectFromReadyPlanConfigArgs = {
  input: CreateProjectFromReadyPlanConfigInput;
};


export type MutationCreateProjectFromReadyPlanArgs = {
  input: CreateProjectFromReadyPlanInput;
};


export type MutationApplyInvoiceScheduleToProjectArgs = {
  input: ApplyInvoiceScheduleInput;
};


export type MutationSaveProjectAllocationRuleArgs = {
  input: SaveProjectAllocationRuleInput;
};


export type MutationSaveProjectCollaboratorArgs = {
  input: SaveProjectCollaboratorInput;
};


export type MutationSendInviteEmailArgs = {
  input: SendInviteEmailInput;
};


export type MutationDeleteProjectCollaboratorArgs = {
  input: DeleteProjectCollaboratorInput;
};


export type MutationSaveProjectContactArgs = {
  input: SaveProjectContactInput;
};


export type MutationSaveProjectInvoiceSettingArgs = {
  input: SaveProjectInvoiceSettingInput;
};


export type MutationSaveProjectItemsArgs = {
  input: ProjectItemsInput;
};


export type MutationDuplicateProjectItemsArgs = {
  input: DuplicateProjectItemsInput;
};


export type MutationDeleteProjectItemArgs = {
  input: DeleteProjectItemInput;
};


export type MutationDeleteProjectItemsArgs = {
  input: DeleteProjectItemsInput;
};


export type MutationSaveProjectLotDetailsArgs = {
  input: SaveProjectLotDetailsInput;
};


export type MutationSaveProjectReadyPlanConfigsArgs = {
  input: SaveProjectReadyPlanConfigsInput;
};


export type MutationApplyProjectReadyPlanConfigsArgs = {
  input: ApplyProjectReadyPlanConfigsInput;
};


export type MutationSaveProjectReadyPlanConfigOptionsArgs = {
  input: Array<SaveProjectReadyPlanConfigOptionInput>;
};


export type MutationSyncSalesforcePrpcArgs = {
  input: SyncSalesforcePrpcInput;
};


export type MutationSaveProjectSiteConditionArgs = {
  input: SaveProjectSiteConditionInput;
};


export type MutationSendProjectSiteConditionsNotificationArgs = {
  input: SendProjectSiteConditionsNotificationInput;
};


export type MutationSaveProjectSiteSpecificInfoArgs = {
  input: SaveProjectSiteSpecificInfoInput;
};


export type MutationSaveProjectStageArgs = {
  input: SaveProjectStageInput;
};


export type MutationCompleteStageArgs = {
  input: CompleteStageInput;
};


export type MutationSaveProjectStatusChangeReasonsArgs = {
  input: SaveProjectStatusChangeReasonsInput;
};


export type MutationUpdateProjectRoleArgs = {
  input: UpdateProjectRoleInput;
};


export type MutationBulkUpdateProjectRoleArgs = {
  input: BulkUpdateProjectRolesInput;
};


export type MutationSendProjectUpdateArgs = {
  input: ProjectUpdateInput;
};


export type MutationSavePunchlistItemTodosArgs = {
  input: SavePunchlistItemTodosInput;
};


export type MutationSendTradePartnerPunchlistEmailArgs = {
  input: SendTradePartnerPunchlistEmailInput;
};


export type MutationSendPunchlistExportEmailArgs = {
  input: SendPunchlistExportEmailInput;
};


export type MutationRegisterPushNotificationTokenArgs = {
  input: RegisterPushNotificationTokenInput;
};


export type MutationUnregisterPushNotificationTokenArgs = {
  input: UnregisterPushNotificationTokenInput;
};


export type MutationSaveReadyPlanArgs = {
  input: SaveReadyPlanInput;
};


export type MutationSaveReadyPlansArgs = {
  input: SaveReadyPlansInput;
};


export type MutationDeleteReadyPlansArgs = {
  input: DeleteReadyPlansInput;
};


export type MutationScopeGlobalOptionGroupsToReadyPlansArgs = {
  input: ScopeGlobalOptionGroupsToReadyPlansInput;
};


export type MutationSaveReadyPlanAggregateVersionArgs = {
  input: SaveReadyPlanAggregateVersionInput;
};


export type MutationDeleteReadyPlanAggregateVersionArgs = {
  input: DeleteReadyPlanAggregateVersionInput;
};


export type MutationSaveReadyPlanDesignNoteArgs = {
  input: SaveReadyPlanDesignNoteInput;
};


export type MutationSaveReadyPlanLocationsArgs = {
  inputs: Array<SaveReadyPlanLocationInput>;
};


export type MutationCreateDesignPackageAlternateLocationArgs = {
  input: CreateDesignPackageAlternateLocationInput;
};


export type MutationSaveDesignPackageLocationPlanMappingsArgs = {
  input: Array<SaveDesignPackageLocationPlanMappingInput>;
};


export type MutationDeleteDesignPackageAlternateLocationArgs = {
  altRplId: Scalars['ID'];
};


export type MutationSaveReadyPlanOptionsArgs = {
  input: SaveReadyPlanOptionsInput;
};


export type MutationMergeReadyPlanOptionsArgs = {
  input: MergeReadyPlanOptionsInput;
};


export type MutationSaveReadyPlanOptionGroupArgs = {
  input: SaveReadyPlanOptionGroupInput;
};


export type MutationSaveReadyPlanOptionGroupsArgs = {
  inputs: Array<SaveReadyPlanOptionGroupInput>;
};


export type MutationSaveReadyPlanOptionProgramDataModificationsArgs = {
  input: Array<SaveReadyPlanOptionProgramDataModificationInput>;
};


export type MutationDeleteReadyPlanOptionProgramDataModificationsArgs = {
  input: DeleteReadyPlanOptionProgramDataModificationsInput;
};


export type MutationSaveReadyPlanRequiredOptionsArgs = {
  input: Array<SaveReadyPlanRequiredOptionInput>;
};


export type MutationSaveReferencesArgs = {
  input: SaveReferencesInput;
};


export type MutationDeleteReferencesArgs = {
  input: DeleteReferencesInput;
};


export type MutationSaveRegionArgs = {
  input: SaveRegionInput;
};


export type MutationSaveRequiredTaskDocumentArgs = {
  input: SaveRequiredTaskDocumentInput;
};


export type MutationDeleteRequireTaskDocumentArgs = {
  input: DeleteRequireTaskDocumentInput;
};


export type MutationSaveRoomTypeArgs = {
  input: SaveRoomTypeInput;
};


export type MutationTestMutationArgs = {
  input: TestMutationInput;
};


export type MutationSyncSalesforceEntityArgs = {
  input: SyncSalesforceEntityInput;
};


export type MutationSaveScheduleArgs = {
  input: SaveScheduleInput;
};


export type MutationResetScheduleBaselinesArgs = {
  input: ResetScheduleBaselinesInput;
};


export type MutationScheduleSoftDeleteSubPhasesWithEmptyTasksArgs = {
  scheduleId?: InputMaybe<Scalars['Int']>;
};


export type MutationAddJobForSchedulesArgs = {
  input: AddJobsForSchedulesInput;
};


export type MutationSaveScheduleFlagArgs = {
  input: SaveScheduleFlagInput;
};


export type MutationDeleteScheduleFlagArgs = {
  input: DeleteScheduleFlagInput;
};


export type MutationSaveScheduleFlagReasonsArgs = {
  input: SaveScheduleFlagReasonsInput;
};


export type MutationSaveSchedulePhasesArgs = {
  input: SaveSchedulePhasesInput;
};


export type MutationDeleteSchedulePhasesArgs = {
  input: DeleteEntitiesInput;
};


export type MutationSaveScheduleSettingsArgs = {
  input: SaveScheduleSettingsInput;
};


export type MutationSaveScheduleSubPhasesArgs = {
  input: SaveScheduleSubPhasesInput;
};


export type MutationDeleteScheduleSubPhasesArgs = {
  input: DeleteEntitiesInput;
};


export type MutationMoveScheduleSubPhasesArgs = {
  input: MoveScheduleSubPhasesInput;
};


export type MutationSaveScheduleTasksArgs = {
  input: SaveScheduleTasksInput;
};


export type MutationSaveScheduleTaskChecklistItemArgs = {
  input: SaveScheduleTaskChecklistItemInput;
};


export type MutationDeleteScheduleTaskChecklistItemArgs = {
  input: DeleteScheduleTaskChecklistItemInput;
};


export type MutationApplyTemplateChecklistItemsArgs = {
  input: ApplyTemplateChecklistItems;
};


export type MutationSaveScheduleTemplatesArgs = {
  input: SaveScheduleTemplatesInput;
};


export type MutationDuplicateScheduleTemplateArgs = {
  input: DuplicateScheduleTemplateInput;
};


export type MutationApplyScheduleTemplatesArgs = {
  input: ApplyScheduleTemplatesInput;
};


export type MutationSaveScheduleTemplateItemMappingsArgs = {
  input: SaveScheduleTemplateItemMappingsInput;
};


export type MutationSaveScopeChangeReasonArgs = {
  input: SaveScopeChangeReasonInput;
};


export type MutationSetupDataArgs = {
  input: SetupDataInput;
};


export type MutationSaveSiteSpecificInfoArgs = {
  input: SaveSiteSpecificInfoInput;
};


export type MutationSaveStructureArgs = {
  input: SaveStructureInput;
};


export type MutationSaveSubdivisionArgs = {
  input: SaveSubdivisionInput;
};


export type MutationSaveSubmarketArgs = {
  input: SaveSubmarketInput;
};


export type MutationSaveTakeoffLineItemsArgs = {
  readyPlanId?: InputMaybe<Scalars['ID']>;
  input: Array<SaveTakeoffLineItemInput>;
  templateId?: InputMaybe<Scalars['ID']>;
  groupTotalsInput?: InputMaybe<TliGroupTotalsInput>;
};


export type MutationCopyTakeoffLineItemsArgs = {
  input: CopyTakeoffLineItemsInput;
};


export type MutationDeleteTaskArgs = {
  input: DeleteTaskInput;
};


export type MutationSaveTaskWorkDayArgs = {
  input: SaveTaskWorkDayInput;
};


export type MutationSaveToDosArgs = {
  input: SaveToDosInput;
};


export type MutationDeleteToDoArgs = {
  input: DeleteToDoInput;
};


export type MutationSaveToDoChecklistItemArgs = {
  input: SaveToDoChecklistItemInput;
};


export type MutationSaveTradeCategoryArgs = {
  input: SaveTradeCategoryInput;
};


export type MutationSaveTradeCategoryLeadTimesArgs = {
  input: SaveTradeCategoryLeadTimesInput;
};


export type MutationSaveTradePartnerArgs = {
  input: SaveTradePartnerInput;
};


export type MutationSaveTradePartnersArgs = {
  input: SaveTradePartnersInput;
};


export type MutationDeleteTradePartnerArgs = {
  input: DeleteTradePartnerInput;
};


export type MutationSaveTradePartnerAgreementArgs = {
  input: SaveTradePartnerAgreementInput;
};


export type MutationDeleteTradePartnerAgreementArgs = {
  input: DeleteTradePartnerAgreementInput;
};


export type MutationSaveTradePartnerAvailabilityRequestArgs = {
  input: SaveTradePartnerAvailabilityRequestInput;
};


export type MutationSaveTradePartnerAvailabilityRequestsArgs = {
  input: Array<SaveTradePartnerAvailabilityRequestInput>;
};


export type MutationUpdateTradePartnerAvailabilityRequestStatusArgs = {
  input: UpdateTradePartnerAvailabilityRequestStatusInput;
};


export type MutationApproveTradePartnerAvailabilityRequestArgs = {
  confirmationToken: Scalars['String'];
};


export type MutationSaveTradePartnerContactArgs = {
  input: SaveTradePartnerContactInput;
};


export type MutationDeleteTradePartnerContactArgs = {
  input: DeleteTradePartnerContactInput;
};


export type MutationSaveTradePartnerMarketContactArgs = {
  input: SaveTradePartnerMarketContactInput;
};


export type MutationDeleteTradePartnerMarketContactArgs = {
  input: DeleteTradePartnerMarketContactInput;
};


export type MutationSaveTradePartnerRequirementArgs = {
  input: SaveTradePartnerRequirementInput;
};


export type MutationSaveTradePartnerReviewArgs = {
  input: SaveTradePartnerReviewInput;
};


export type MutationSaveUnitArgs = {
  input: SaveUnitInput;
};


export type MutationSaveUnitsOfMeasureArgs = {
  input: SaveUnitsOfMeasureInput;
};


export type MutationDeleteUnitOfMeasureArgs = {
  input: DeleteUnitOfMeasureInput;
};


export type MutationSaveUserArgs = {
  input: SaveUserInput;
};


export type MutationActivateUserArgs = {
  input: ActivateUserInput;
};


export type MutationDeactivateUserArgs = {
  input: DeactivateUserInput;
};


export type MutationActivateUsersArgs = {
  input: ActivateUsersInput;
};


export type MutationDeactivateUsersArgs = {
  input: DeactivateUsersInput;
};


export type MutationSaveUserCommunicationPreferenceArgs = {
  input: SaveUserCommunicationPreferenceInput;
};


export type MutationSaveUserGroupArgs = {
  input: SaveUserGroupInput;
};


export type MutationRemoveUserGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteWarrantyTicketArgs = {
  input: DeleteWarrantyTicketInput;
};


export type MutationSaveWarrantyTicketArgs = {
  input: SaveWarrantyTicketInput;
};


export type MutationSaveWarrantyTicketItemArgs = {
  input: SaveWarrantyTicketItemInput;
};


export type MutationDeleteWarrantyTicketItemArgs = {
  input: DeleteWarrantyTicketItemInput;
};


export type MutationSaveWarrantyTicketItemsArgs = {
  input: SaveWarrantyTicketItemsInput;
};


export type MutationSaveWorkAuthorizationArgs = {
  input: SaveWorkAuthorizationInput;
};


export type MutationDeleteWorkAuthorizationArgs = {
  input: DeleteEntityInput;
};

export type SaveHomeownerContractLineItemsInput = {
  lineItems: Array<SaveHomeownerContractLineItemInput>;
};

export type HomeownerContractLineItem = {
  __typename?: 'HomeownerContractLineItem';
  id: Scalars['ID'];
  priceChangeInCents?: Maybe<Scalars['Int']>;
  budgetChangeInCents?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  costCode: CostCode;
  internalNote?: Maybe<Scalars['String']>;
  invoiceLineItems: Array<InvoiceLineItem>;
  projectItem: ProjectItem;
  /** @deprecated use `owner` because it's consistent with naming across the app */
  parent: HomeownerContractLike;
  owner: HomeownerContractLike;
  amountPaidInCents?: Maybe<Scalars['Int']>;
  invoicedAmountInCents: Scalars['Int'];
  changeEventLineItem?: Maybe<ChangeEventLineItem>;
  tradePartnerNote?: Maybe<Scalars['String']>;
  specifications?: Maybe<Scalars['String']>;
  bidItem?: Maybe<BidItem>;
  allocations: Array<HomeownerContractLineItemAllocation>;
};

export type SaveHomeownerContractLineItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  internalNote?: InputMaybe<Scalars['String']>;
  priceChangeInCents?: InputMaybe<Scalars['Int']>;
  budgetChangeInCents?: InputMaybe<Scalars['Int']>;
  costCodeId?: InputMaybe<Scalars['ID']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  changeEventLineItemId?: InputMaybe<Scalars['ID']>;
  isAllowance?: InputMaybe<Scalars['Boolean']>;
};

export type Address = {
  __typename?: 'Address';
  id: Scalars['ID'];
  street1: Scalars['String'];
  street2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  postalCode: Scalars['String'];
  country: Scalars['String'];
};

export type AddressInput = {
  /**  We don't include id b/c addresses are logically owned by their parent entities.  */
  street1?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
};

export type AiEntityProposalsPage = {
  __typename?: 'AiEntityProposalsPage';
  entities: Array<AiEntityProposal>;
  pageInfo: PageInfo;
};

export type AiEntityProposal = {
  __typename?: 'AiEntityProposal';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: AiEntityProposalTypeDetail;
  parent: AiProposal;
  entity?: Maybe<AiEntityProposalEntity>;
  fieldProposals: Array<AiFieldProposal>;
  entityType: AiEntityProposalEntityTypeDetail;
};

export type AiEntityProposalFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  createdAt?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt?: InputMaybe<Array<Scalars['DateTime']>>;
  type?: InputMaybe<Array<AiEntityProposalType>>;
  parentId?: InputMaybe<Array<Scalars['ID']>>;
  entityId?: InputMaybe<Array<Scalars['ID']>>;
  entityType?: InputMaybe<Array<AiEntityProposalEntityType>>;
};

export type AiEntityProposalEntity = MaterialVariant | ReadyPlanLocation | ReadyPlanOption | ReadyPlanProgramData;

export type AiFieldProposalsPage = {
  __typename?: 'AiFieldProposalsPage';
  entities: Array<AiFieldProposal>;
  pageInfo: PageInfo;
};

export type AiFieldProposal = {
  __typename?: 'AiFieldProposal';
  id: Scalars['ID'];
  fieldName: Scalars['String'];
  fieldValue: Scalars['String'];
  status: AiFieldProposalStatusDetail;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  parent: AiEntityProposal;
};

export type AiFieldProposalFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  fieldName?: InputMaybe<Array<Scalars['String']>>;
  fieldValue?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt?: InputMaybe<Array<Scalars['DateTime']>>;
  parentId?: InputMaybe<Array<Scalars['ID']>>;
};

export type ResolveAiFieldProposalInput = {
  id: Scalars['ID'];
  status: AiFieldProposalStatus;
};

export type ResolveAiFieldProposalsResult = {
  __typename?: 'ResolveAiFieldProposalsResult';
  aiFieldProposals: Array<AiFieldProposal>;
};

export type AiProposal = {
  __typename?: 'AiProposal';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  entityProposals: Array<AiEntityProposal>;
  type: AiProposalTypeDetail;
  status: AiProposalStatusDetail;
};

export type Approval = HasBlueprintUrl & Named & CanCollaborate & Commentable & Referencable & Followable & {
  __typename?: 'Approval';
  id: Scalars['ID'];
  name: Scalars['String'];
  requestedAt?: Maybe<Scalars['DateTime']>;
  dueOn?: Maybe<Scalars['Date']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  status: ApprovalStatusDetail;
  requestedBy?: Maybe<User>;
  rootProject?: Maybe<Project>;
  approvers: Array<Approver>;
  source?: Maybe<ApprovalSource>;
  subject: ApprovalSubject;
  blueprintUrl: Url;
  isFinalized: Scalars['Boolean'];
  userEvents: Array<UserEvent>;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
};

export type ApprovalPage = {
  __typename?: 'ApprovalPage';
  approvals: Array<Approval>;
  pageInfo: PageInfo;
};

export type ApprovalFilter = {
  /**  These all actually exist on Approvals  */
  id?: InputMaybe<Array<Scalars['ID']>>;
  requestedAt?: InputMaybe<DateFilter2>;
  dueOn?: InputMaybe<DateFilter2>;
  createdAt?: InputMaybe<DateFilter2>;
  status?: InputMaybe<Array<ApprovalStatus>>;
  /**  InternalUserId | TradePartnerUserId | HomeownerId | UserId  */
  requestedBy?: InputMaybe<Array<Scalars['ID']>>;
  rootProject?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Array<Scalars['ID']>>;
  subject?: InputMaybe<Array<Scalars['ID']>>;
  approvers?: InputMaybe<ApproverFilter>;
  subjectType?: InputMaybe<Array<ApprovalSubjectType>>;
  /**
   * Special Case: Returns approvals "relevant to" a given `InternalUserId` | `TradePartnerUserId` | `HomeownerId`
   * (based on internal logic)
   */
  relevantTo?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveApprovalInput = {
  /** Nullable to create a new Approval, otherwise required if one already exists for subjectId */
  id?: InputMaybe<Scalars['ID']>;
  dueOn?: InputMaybe<Scalars['Date']>;
  sourceId?: InputMaybe<Scalars['ID']>;
  subjectId?: InputMaybe<Scalars['ID']>;
  /** An ergonomic way to move an Approval from Changes Needed back to Requested */
  reopen?: InputMaybe<Scalars['Boolean']>;
  retract?: InputMaybe<Scalars['Boolean']>;
};

export type SaveApprovalResult = {
  __typename?: 'SaveApprovalResult';
  approval: Approval;
};

export type SaveApprovalsResult = {
  __typename?: 'SaveApprovalsResult';
  approvals: Array<Approval>;
};

export type ApprovalSource = BidContractRevision | ItemTemplate | ReadyPlanAggregateVersion;

export type ApprovalSubject = Bill | ChangeEvent | ChangeRequest | Invoice;

export enum ApprovalSubjectType {
  ChangeEvent = 'CHANGE_EVENT',
  Bill = 'BILL',
  Invoice = 'INVOICE',
  ChangeRequest = 'CHANGE_REQUEST'
}

export type Approver = {
  __typename?: 'Approver';
  id: Scalars['ID'];
  order: Scalars['Int'];
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  status: ApproverStatusDetail;
  nextApprover?: Maybe<Approver>;
  approval: Approval;
  user: ApproverUser;
  wasAutoApproved: Scalars['Boolean'];
  subjectData?: Maybe<ApproverSubjectData>;
  requireSignature: Scalars['Boolean'];
  pandaDocRecipient?: Maybe<PandaDocRecipient>;
};

export type ApproverFilter = {
  status?: InputMaybe<Array<ApproverStatus>>;
  /**  InternalUserId | TradePartnerUserId | HomeownerId  */
  user?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveApproverInput = {
  id: Scalars['ID'];
  status?: InputMaybe<ApproverStatus>;
  order?: InputMaybe<Scalars['Int']>;
  /** this will add a comment to the underlying approval */
  comment?: InputMaybe<SaveCommentInput>;
  requireSignature?: InputMaybe<Scalars['Boolean']>;
};

export type SaveApproverResult = {
  __typename?: 'SaveApproverResult';
  approver: Approver;
};

export type SaveApproversResult = {
  __typename?: 'SaveApproversResult';
  approvers: Array<Approver>;
};

export type ApproverSource = DevelopmentTeamMember | ProjectCollaborator | ProjectTeamMember | TradePartnerMarketContact;

export type ApproverSubjectData = ChangeRequestApproverSubjectData;

export type ApproverUser = Client | InternalUser | TradePartnerUser;

export type AssetsFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateAssetUploadUrlInput = {
  contentType: Scalars['String'];
  previewResizing?: InputMaybe<AssetResizing>;
};

export type CreateAssetUploadUrlResult = {
  __typename?: 'CreateAssetUploadUrlResult';
  s3Key: Scalars['String'];
  uploadUrl: Scalars['String'];
  /** After the asset is uploaded, it can be viewed at this URL. */
  downloadUrl: Scalars['String'];
  /** Similar to downloadUrl, but has a content-disposition that will download the file immediately */
  attachmentUrl: Scalars['String'];
  /**
   * Similar to downloadUrl, returns an S3 signed URL to a preview image resized as specified.
   * Only generated if previewResizing is provided as mutation input
   * Note that not all assets support previews, and this may return an undefined string
   */
  previewUrl?: Maybe<Scalars['String']>;
};

export type CreateAssetMultipartUploadUrlInput = {
  /** MIME type of the file (e.g., "video/mp4") */
  contentType: Scalars['String'];
  /** Original filename for tracking/debugging */
  fileName: Scalars['String'];
  /** Total file size in bytes */
  sizeInBytes: Scalars['Int'];
  /**
   * Number of parts for the upload. Client should calculate:
   * Math.ceil(sizeInBytes / partSize) where partSize >= 5MB
   * Server validates: partCount <= 10000 (S3 limit)
   */
  partCount: Scalars['Int'];
};

export type CreateAssetMultipartUploadUrlResult = {
  __typename?: 'CreateAssetMultipartUploadUrlResult';
  /** Unique identifier for this multipart upload session */
  uploadId: Scalars['String'];
  /** S3 key where file will be stored: assets/${UUID}.${ext} */
  s3Key: Scalars['String'];
  /** Total number of parts to upload */
  totalParts: Scalars['Int'];
  /** Presigned URLs for uploading each part via HTTP PUT */
  partUploadUrls: Array<MultipartPartUploadUrl>;
  /** When presigned URLs expire */
  expiresAt: Scalars['DateTime'];
};

export type MultipartPartUploadUrl = {
  __typename?: 'MultipartPartUploadUrl';
  /** Part number (1-indexed). Upload in any order. */
  partNumber: Scalars['Int'];
  /** Presigned URL for HTTP PUT of this part's file chunk */
  uploadUrl: Scalars['String'];
};

export type MultipartPartInput = {
  /** Part number (1-indexed, matching partNumber from MultipartPartUploadUrl) */
  partNumber: Scalars['Int'];
  /**
   * ETag header returned by S3 after uploading this part.
   * Required for S3 to verify and assemble the parts.
   * Format: quoted string like "abc123def456"
   */
  etag: Scalars['String'];
};

export type AbortAssetMultipartUploadInput = {
  /** Upload ID from createAssetMultipartUploadUrl */
  uploadId: Scalars['String'];
  /** S3 key from createAssetMultipartUploadUrl */
  s3Key: Scalars['String'];
  /** Optional reason for aborting (for logging) */
  reason?: InputMaybe<Scalars['String']>;
};

export type AbortAssetMultipartUploadResult = {
  __typename?: 'AbortAssetMultipartUploadResult';
  /** The aborted upload ID */
  uploadId: Scalars['String'];
  /** The abandoned S3 key */
  s3Key: Scalars['String'];
};

export type Asset = Entity & {
  __typename?: 'Asset';
  id: Scalars['ID'];
  contentType: Scalars['String'];
  /** Whether this asset is a video (its contentType starts with `video/`). Note: video assets have no `previewUrl`. */
  isVideo: Scalars['Boolean'];
  /**
   * After the asset is uploaded, it can be downloaded from this URL.
   *
   * This is an S3 signed url, which means the user has already been authed when
   * creating the returned URL, and so can directly access this URL without any extra auth.
   * However, that also means this URL is unique per request (it has timestamps in it)
   * and so won't be cached.
   *
   * It expires after 1 week.
   */
  downloadUrl: Scalars['String'];
  /** Similar to downloadUrl, but has a content-disposition that will download the file immediately */
  attachmentUrl: Scalars['String'];
  /**
   * Similar to downloadUrl, returns an S3 signed URL to a preview image resized as specified.
   * Note that not all assets support previews, and this may return an undefined string
   */
  previewUrl?: Maybe<Scalars['String']>;
  /**
   * Similar to downloadUrl, but is a consistent path like `/asset?id=assetId` so
   * that caching works.
   *
   * Note that auth will be done on access to `/asset` and so currently this only
   * works for internal users.
   */
  url: Scalars['String'];
  fileName?: Maybe<Scalars['String']>;
  sizeInBytes?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  version: Scalars['String'];
  /**
   * The S3 key where the asset is stored.  This is generally not needed for the applications,
   * but we need it when we need to do something like copy the asset to another bucket (PropCo App)
   */
  s3Key: Scalars['String'];
};


export type AssetPreviewUrlArgs = {
  resizing: AssetResizing;
};

export type AssetResizing = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<AssetResizingRegion>;
  /** Optional output image format, e.g. "jpg", "png", defaults to original asset format. */
  format?: InputMaybe<AssetResizingFormat>;
};

export enum AssetResizingFormat {
  Jpg = 'jpg',
  Png = 'png'
}

export enum AssetResizingRegion {
  Square = 'SQUARE',
  Full = 'FULL',
  Auto = 'AUTO'
}

export type AssetInput = {
  id?: InputMaybe<Scalars['ID']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  /** This field is only accepted for Asset creation */
  contentType?: InputMaybe<Scalars['String']>;
  /** This field is accepted for Asset creation and update */
  fileName?: InputMaybe<Scalars['String']>;
  /** This field is only accepted for Asset creation */
  s3Key?: InputMaybe<Scalars['String']>;
  /** This field is only accepted for Asset creation */
  sizeInBytes?: InputMaybe<Scalars['Int']>;
  /**
   * Upload ID from createAssetMultipartUploadUrl.
   * When provided with multipartParts, the multipart upload will be completed automatically.
   */
  multipartUploadId?: InputMaybe<Scalars['String']>;
  /**
   * Array of uploaded parts with ETags from S3 PUT responses.
   * Required when multipartUploadId is provided.
   */
  multipartParts?: InputMaybe<Array<MultipartPartInput>>;
};

export type CreateAssetResult = {
  __typename?: 'CreateAssetResult';
  asset: Asset;
};

export type Attachment = {
  __typename?: 'Attachment';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  asset: Asset;
  parent: AttachmentParent;
};

export type SaveAttachmentInput = {
  id?: InputMaybe<Scalars['ID']>;
  asset: AssetInput;
  parentId?: InputMaybe<Scalars['ID']>;
};

export type DeleteAttachmentInput = {
  id: Scalars['ID'];
};

export type SaveAttachmentResult = {
  __typename?: 'SaveAttachmentResult';
  attachment: Attachment;
};

export type DeleteAttachmentResult = {
  __typename?: 'DeleteAttachmentResult';
  parent?: Maybe<AttachmentParent>;
};

export type AttachmentParent = ChangeRequest | Comment | GlobalOption | ProjectSiteCondition | ScheduleFlag | ToDo | TradePartnerAvailabilityRequestEmail | TradePartnerRequirement | WarrantyTicket | WarrantyTicketItem;

export type DeleteAuditEventsInput = {
  table: Scalars['String'];
  columns: Array<Scalars['String']>;
  dryRun?: InputMaybe<Scalars['Boolean']>;
};

export type DeleteAuditEventsResult = {
  __typename?: 'DeleteAuditEventsResult';
  results: Array<DeleteAuditEventResult>;
};

export type DeleteAuditEventResult = {
  __typename?: 'DeleteAuditEventResult';
  table: Scalars['String'];
  column: Scalars['String'];
  deletedCount: Scalars['Int'];
};

/**
 * Implemented by ItemTemplate and ReadyPlanLike so that they can be used interchangeably in the UI,
 * which typically ony cares about the display name.
 */
export type BaseItemParent = {
  id: Scalars['ID'];
  name: Scalars['String'];
  displayName: Scalars['String'];
};

/**
 * Implemented by ItemTemplate and ReadyPlanAggregateVersion so that they can be used interchangeably in the UI,
 * which typically ony cares about the display name/version.
 */
export type BaseItemParentVersion = {
  id: Scalars['ID'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  displayVersion: Scalars['String'];
};

export type BaseItemLike = {
  id: Scalars['ID'];
  /**  Either the original ITI ID or the TLI ID.  */
  identityId: Scalars['ID'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  /**  TBD - Should this reach through to the RP even for OG RPs?  */
  parent: BaseItemParent;
  /**  The first version this line item was added.  */
  first: BaseItemParentVersion;
  readyPlan?: Maybe<ReadyPlanLike>;
  specifications?: Maybe<Scalars['String']>;
  tradePartnerNote?: Maybe<Scalars['String']>;
  slot: ItemSlot;
  item: Item;
  quantity?: Maybe<Scalars['Int']>;
  totalCostInCents: Scalars['Int'];
  unitCostInCents: Scalars['Int'];
  location: Location;
  unitOfMeasure: UnitOfMeasure;
  costType: CostType;
  costTypeDetail: CostTypeDetail;
  preferredBidContractLineItem?: Maybe<BidContractLineItem>;
  bidItem?: Maybe<BidItem>;
  options: Array<ReadyPlanOption>;
  materialVariant?: Maybe<MaterialVariant>;
  task?: Maybe<GlobalPlanTask>;
  bidItemTemplateItem?: Maybe<BaseItemLike>;
  blueprintUrl: Url;
  development?: Maybe<Development>;
  customPlaceholderName?: Maybe<Scalars['String']>;
  /**
   *  Helper for the FE multi-select dropdown
   * @deprecated Use options instead
   */
  elevationIds: Array<Scalars['ID']>;
  /**
   *  Helper for the FE multi-select dropdown
   * @deprecated Use options instead
   */
  specOptionIds: Array<Scalars['ID']>;
  /**
   *  Helper for the FE multi-select dropdown
   * @deprecated Use options instead
   */
  otherOptionIds: Array<Scalars['ID']>;
  costEstimate: CostEstimate;
};

export type BidContract = HasBlueprintUrl & Named & CanCollaborate & Commentable & Referencable & Followable & {
  __typename?: 'BidContract';
  id: Scalars['ID'];
  /**  Returns the trade partner name or `Homebound internal estimate` and the development name prefixed.  */
  name: Scalars['String'];
  blueprintUrl: Url;
  /**  Returns the trade partner name or `Homebound internal estimate`  */
  displayName: Scalars['String'];
  isPrimary?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  tradePartner?: Maybe<TradePartner>;
  revisions: Array<BidContractRevision>;
  /**  The current version, which will be draft if there is no signed revision yet or the latest signed revision. */
  currentRevision: BidContractRevision;
  latestSignedRevision?: Maybe<BidContractRevision>;
  /**  The current draft/pending/sent version, or unset if there is none.  */
  unsignedRevision?: Maybe<BidContractRevision>;
  /**  The latest revision with the highest version number */
  latestRevision: BidContractRevision;
  isInternalEstimate: Scalars['Boolean'];
  developments: Array<Development>;
  bidRequest?: Maybe<BidPackageRequest>;
  /**
   * The bidder for the bid contract (trade request or internal estimate).
   * Throws on legacy development-level bid contracts (deprecated workflow) — those have
   * no bid-package linkage and should not be queried for this field.
   */
  bidder: BidPackageBidder;
  type: BidContractTypeDetail;
  projects: Array<Project>;
  relevantMarket: Market;
  scopeSource?: Maybe<BidScopeSourceDetail>;
  isProjectLevelBidding: Scalars['Boolean'];
  internalEstimateBidPackage?: Maybe<BidPackage>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  internalEstimateType?: Maybe<InternalEstimateTypeDetail>;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
};

export type SaveBidContractInput = {
  id?: InputMaybe<Scalars['ID']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  tradePartnerId?: InputMaybe<Scalars['ID']>;
  isInternalEstimate?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['Date']>;
  developmentIds?: InputMaybe<Array<Scalars['ID']>>;
  bidRequestId?: InputMaybe<Scalars['ID']>;
  bidPackageId?: InputMaybe<Scalars['ID']>;
  internalEstimateBidPackageId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<BidContractType>;
  projects?: InputMaybe<Array<Scalars['ID']>>;
  scopeSource?: InputMaybe<BidScopeSource>;
  archive?: InputMaybe<Scalars['Boolean']>;
  /**
   * Upsert-only: creates new and updates existing plan-based line items on the
   * contract's current revision. Does not handle deletions (we assume changes like
   * 'remove a cost b/c of a dimension removal' will be handled by the dimension mutation
   * & not 'deleting a line' here) — omitted line items are left untouched
   */
  planBasedLineItems?: InputMaybe<Array<SavePlanBasedBidContractLineItemInput>>;
  internalEstimateType?: InputMaybe<InternalEstimateType>;
  /**  Copies plan-based line items from this source revision onto the new contract's revision.  */
  copyContractRevisionId?: InputMaybe<Scalars['ID']>;
};

export type SaveBidContractResult = {
  __typename?: 'SaveBidContractResult';
  bidContract: BidContract;
};

export type CopyPlanBasedBidCostsInput = {
  bidContractId: Scalars['ID'];
  sourceProductOfferingId: Scalars['ID'];
  targetProductOfferingIds: Array<Scalars['ID']>;
};

export type CopyPlanBasedBidCostsResult = {
  __typename?: 'CopyPlanBasedBidCostsResult';
  bidContract: BidContract;
};

export type BidContractItemsFilter = {
  itemTemplateStatus?: InputMaybe<Array<ItemTemplateStatus>>;
  itemTemplateItemId?: InputMaybe<Array<Scalars['ID']>>;
  excludeItemTemplateItemId?: InputMaybe<Array<Scalars['ID']>>;
  readyPlanId?: InputMaybe<Array<Scalars['ID']>>;
  readyPlanOptionId?: InputMaybe<Array<Scalars['ID']>>;
  costCodeId?: InputMaybe<Array<Scalars['ID']>>;
  itemId?: InputMaybe<Array<Scalars['ID']>>;
  updatedOnly?: InputMaybe<Scalars['Boolean']>;
};

export type BidContractPotentialItem = {
  __typename?: 'BidContractPotentialItem';
  item: Item;
  /**
   * If BidContractItemsFilter.updatedOnly is true, then only ITIs which need to be updated are included.
   * Otherwise, all of the latest ITIs for the associated Item are included
   */
  templateItemIds: Array<Scalars['ID']>;
  needsBid: Scalars['Boolean'];
};

export type BidContractsFilter = {
  search?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<Scalars['ID']>>;
  scopeSource?: InputMaybe<Array<BidScopeSource>>;
  includeRelatedProjectBids?: InputMaybe<Scalars['Boolean']>;
};

export type BidContractOrder = {
  id?: InputMaybe<Order>;
};

export type BidContractsPage = {
  __typename?: 'BidContractsPage';
  entities: Array<BidContract>;
  pageInfo: PageInfo;
};

export type BidContractLineItem = Named & {
  __typename?: 'BidContractLineItem';
  id: Scalars['ID'];
  name: Scalars['String'];
  totalCostInCents: Scalars['Int'];
  unitCostInCents: Scalars['Int'];
  unitCostInMills: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  itemTemplateItem?: Maybe<BaseItemLike>;
  revision: BidContractRevision;
  previousLineItem?: Maybe<BidContractLineItem>;
  bidItem?: Maybe<BidItem>;
  scopeUpdated: Scalars['Boolean'];
  ofIti: Scalars['Boolean'];
  ofBi: Scalars['Boolean'];
  preferredByItemTemplateItems: Array<BaseItemLike>;
  potentialUsages: Array<BaseItemLike>;
  isTaxExempt: Scalars['Boolean'];
  tradeLineItem?: Maybe<BidContractTradeLineItem>;
  forCoveringTakeoffs: Scalars['Boolean'];
  isNoCost: Scalars['Boolean'];
};

export type SaveBidContractLineItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  totalCostInCents?: InputMaybe<Scalars['Int']>;
  itemTemplateItemId?: InputMaybe<Scalars['ID']>;
  revisionId?: InputMaybe<Scalars['ID']>;
  bidItemId?: InputMaybe<Scalars['ID']>;
  isTaxExempt?: InputMaybe<Scalars['Boolean']>;
  isNoCost?: InputMaybe<Scalars['Boolean']>;
};

export type SaveBidContractLineItemResult = {
  __typename?: 'SaveBidContractLineItemResult';
  bidContractLineItem: BidContractLineItem;
};

export type SaveBidContractLineItemsResult = {
  __typename?: 'SaveBidContractLineItemsResult';
  bidContractRevision: BidContractRevision;
};

export type DeleteBidContractLineItemResult = {
  __typename?: 'DeleteBidContractLineItemResult';
  bidContractRevision: BidContractRevision;
};

export type BidContractLineItemFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  bidItemIds?: InputMaybe<Array<Scalars['ID']>>;
  itemTemplateItemId?: InputMaybe<Scalars['ID']>;
  tradePartnerId?: InputMaybe<Scalars['ID']>;
  developmentId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Array<BidContractRevisionStatus>>;
};

export type BidContractLineItemsPageResult = {
  __typename?: 'BidContractLineItemsPageResult';
  entities: Array<BidContractLineItem>;
  pageInfo: PageInfo;
};

export type BidContractRevision = HasBlueprintUrl & HasPandaDoc & {
  __typename?: 'BidContractRevision';
  id: Scalars['ID'];
  /**  Returns `Trade Name (Revision x) - Plan/Item Based`.  */
  displayName: Scalars['String'];
  version: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  status: BidContractRevisionStatusDetail;
  bidContract: BidContract;
  lineItems: Array<BidContractLineItem>;
  planBasedLineItems: Array<PlanBasedBidContractLineItem>;
  canEdit: PotentialOperation2;
  canReviseCosts: PotentialOperation2;
  costCodes: Array<CostCode>;
  costCodeAwards: Array<CostCodeAward>;
  pandaDocRecipients: Array<PandaDocIntendedRecipient>;
  pandaDoc?: Maybe<PandaDoc>;
  document?: Maybe<Document>;
  canCreatePandaDoc: PotentialOperation2;
  canDelete: PotentialOperation2;
  startDate: Scalars['Date'];
  endDate?: Maybe<Scalars['Date']>;
  isEffective: Scalars['Boolean'];
  commitments: Array<Commitment>;
  /**  When projectId is provided, it will search for the BCR corresponding to that project or within its hierarchy. */
  blueprintUrl: Url;
  hasOutdatedScope: Scalars['Boolean'];
  sourceForApprovals: Array<Approval>;
  tradeSignatory?: Maybe<TradePartnerContact>;
  potentialProjectItems: Array<PotentialProjectItem>;
  itemTemplateCostUpdates: Array<ItemTemplateCostUpdate>;
  signedOn?: Maybe<Scalars['Date']>;
  internalNote?: Maybe<Scalars['String']>;
  tradeLineItems: Array<BidContractTradeLineItem>;
  hasValidTradeCosts: Scalars['Boolean'];
  draws: Array<BidContractRevisionDraw>;
  canAddDraws: PotentialOperation2;
  canEditDraws: PotentialOperation2;
  primaryRevisionBidPackageAwards: Array<BidPackageAward>;
  bidPackageVersion?: Maybe<BidPackageVersion>;
  hasValidDrawTasks: Scalars['Boolean'];
  hasAwardedBidPackageVersion: Scalars['Boolean'];
};


export type BidContractRevisionBlueprintUrlArgs = {
  projectId?: InputMaybe<Scalars['ID']>;
};

export type SaveBidContractRevisionInput = {
  id?: InputMaybe<Scalars['ID']>;
  bidContractId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['Date']>;
  documentId?: InputMaybe<Scalars['ID']>;
  internalNote?: InputMaybe<Scalars['String']>;
  draws?: InputMaybe<Array<SaveBidContractRevisionDrawInput>>;
  lineItems?: InputMaybe<Array<SaveBidContractLineItemInput>>;
  bidPackageVersionId?: InputMaybe<Scalars['ID']>;
};

export type SaveBidContractRevisionResult = {
  __typename?: 'SaveBidContractRevisionResult';
  bidContractRevision: BidContractRevision;
};

export type PandaDocIntendedRecipient = {
  __typename?: 'PandaDocIntendedRecipient';
  name: Scalars['String'];
  email: Scalars['String'];
  role: PandaDocRole;
  tradePartnerContact?: Maybe<TradePartnerContact>;
  user?: Maybe<User>;
  signingOrder?: Maybe<Scalars['Int']>;
};

export type DeleteBidContractRevisionInput = {
  id: Scalars['ID'];
};

export type InternallySignBidContractRevisionInput = {
  id: Scalars['ID'];
};

/**  All project items whose scope of work could be fulfilled by this BCR.  */
export type PotentialProjectItem = {
  __typename?: 'PotentialProjectItem';
  projectItem: ProjectItem;
  /**  The cost for this Trade Partner to do the work  */
  totalCostInCents: Scalars['Int'];
};

export type CostCodeAward = {
  __typename?: 'CostCodeAward';
  costCode: CostCode;
  isPrimary: Scalars['Boolean'];
  isSecondary: Scalars['Boolean'];
};

export type BidContractRevisionDraw = {
  __typename?: 'BidContractRevisionDraw';
  id: Scalars['ID'];
  amountInBasisPoints: Scalars['Int'];
  isDeposit: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  bidContractRevision: BidContractRevision;
  globalPlanTask?: Maybe<GlobalPlanTask>;
  canEdit: PotentialOperation2;
};

export type SaveBidContractRevisionDrawInput = {
  id?: InputMaybe<Scalars['ID']>;
  amountInBasisPoints?: InputMaybe<Scalars['Int']>;
  isDeposit?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  bidContractRevisionId?: InputMaybe<Scalars['ID']>;
  globalPlanTaskId?: InputMaybe<Scalars['ID']>;
};

export type BidContractTradeLineItem = {
  __typename?: 'BidContractTradeLineItem';
  id: Scalars['ID'];
  totalCostInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  revision: BidContractRevision;
  productOffering: ProductOffering;
  options: Array<ReadyPlanOption>;
  hasValidCost: Scalars['Boolean'];
  lineItems: Array<BidContractLineItem>;
};

export type SaveBidContractTradeLineItemsInput = {
  bidContractTradeLineItems: Array<SaveBidContractTradeLineItemInput>;
};

export type SaveBidContractTradeLineItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  totalCostInCents?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['ID']>;
  productOfferingId?: InputMaybe<Scalars['ID']>;
  optionIds?: InputMaybe<Array<Scalars['ID']>>;
  /** This input is still used, but creates line items instead of prorations */
  prorations?: InputMaybe<Array<SaveBidContractTradeLineItemProrationInput>>;
};

export type SaveBidContractTradeLineItemProrationInput = {
  id?: InputMaybe<Scalars['ID']>;
  itemTemplateItemId?: InputMaybe<Scalars['ID']>;
  costInCents?: InputMaybe<Scalars['Int']>;
  userEntered?: InputMaybe<Scalars['Boolean']>;
};

export type SaveBidContractTradeLineItemsResult = {
  __typename?: 'SaveBidContractTradeLineItemsResult';
  bidContractTradeLineItems: Array<BidContractTradeLineItem>;
};

export type BidItem = Named & HasBlueprintUrl & HasDisplayName & CanCollaborate & Commentable & Referencable & Followable & {
  __typename?: 'BidItem';
  id: Scalars['ID'];
  name: Scalars['String'];
  code: Scalars['String'];
  displayName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  costType: CostTypeDetail;
  unitOfMeasure: UnitOfMeasure;
  items: Array<Item>;
  bidContractLineItems: Array<BidContractLineItem>;
  blueprintUrl: Url;
  parentMaterialVariant?: Maybe<MaterialVariant>;
  parentTask?: Maybe<GlobalPlanTask>;
  estimates: Array<BidItemEstimate>;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
};

export type BidItemsPage = {
  __typename?: 'BidItemsPage';
  bidItems: Array<BidItem>;
  pageInfo: PageInfo;
};

export type SaveBidItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  costType?: InputMaybe<CostType>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']>;
  items?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveBidItemResult = {
  __typename?: 'SaveBidItemResult';
  bidItem: BidItem;
};

export type BidItemOrder = {
  id?: InputMaybe<Order>;
  name?: InputMaybe<Order>;
  createdAt?: InputMaybe<Order>;
  updatedAt?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
};

export type BidItemFilter = {
  id?: InputMaybe<Scalars['ID']>;
  items?: InputMaybe<Array<Scalars['ID']>>;
  unitOfMeasure?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
  costType?: InputMaybe<Array<CostType>>;
  developmentId?: InputMaybe<Scalars['ID']>;
  materialType?: InputMaybe<Array<MaterialType>>;
  code?: InputMaybe<Array<Scalars['String']>>;
  materialVariantTags?: InputMaybe<Array<Scalars['ID']>>;
};

export type PotentialBidItemFilter = {
  projectItemId?: InputMaybe<Scalars['ID']>;
  itemTemplateItemId?: InputMaybe<Scalars['ID']>;
};

export type BidItemEstimate = {
  __typename?: 'BidItemEstimate';
  id: Scalars['ID'];
  costInMills: Scalars['Int'];
  sourceUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  bidItem: BidItem;
  createdBy: User;
  markets: Array<Market>;
};

export type SaveBidItemEstimateInput = {
  id?: InputMaybe<Scalars['ID']>;
  costInMills?: InputMaybe<Scalars['Int']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']>;
  materialVariantId?: InputMaybe<Scalars['ID']>;
  marketIds?: InputMaybe<Array<Scalars['ID']>>;
  globalPlanTaskId?: InputMaybe<Scalars['ID']>;
};

export type SaveBidItemEstimateResult = {
  __typename?: 'SaveBidItemEstimateResult';
  bidItemEstimate: BidItemEstimate;
};

export type BidItemEstimateFilter = {
  parent?: InputMaybe<Array<Scalars['ID']>>;
};

export type BidItemEstimatesPageResult = {
  __typename?: 'BidItemEstimatesPageResult';
  entities: Array<BidItemEstimate>;
  pageInfo: PageInfo;
};

export type MigrateBidPackageCostsInput = {
  bidPackageId: Scalars['ID'];
  sourceBidContractRevisionId: Scalars['ID'];
};

export type MigrateBidPackageCostsResult = {
  __typename?: 'MigrateBidPackageCostsResult';
  trackedJob: TrackedJob;
};

export type ReviewBidPackageIncomingUpdatesInput = {
  bidPackageId: Scalars['ID'];
  productOfferingId: Scalars['ID'];
};

export type BidPackage = Named & {
  __typename?: 'BidPackage';
  id: Scalars['ID'];
  name: Scalars['String'];
  costCodesName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  productOfferings: Array<ProductOffering>;
  status: BidPackageStatusDetail;
  lineItems: Array<BidPackageLineItem>;
  requests: Array<BidPackageRequest>;
  potentialBidPackageLineItems: Array<BidItem>;
  bidPackageGroup?: Maybe<BidPackageGroup>;
  scopeLines: Array<BidPackageScopeLine>;
  awards: Array<BidPackageAward>;
  costCodes: Array<CostCode>;
  costType: CostTypeDetail;
  basePlanGlobalPlanTasks: Array<GlobalPlanTask>;
  isUnitBased: Scalars['Boolean'];
  versions: Array<BidPackageVersion>;
  latestVersion: BidPackageVersion;
  canComplete: PotentialOperation2;
  versionNotes?: Maybe<Scalars['String']>;
  availableUpdates: Array<BidPackageIncomingUpdate>;
  activeRequests: Array<BidPackageRequest>;
  /**  Active requests plus the internal-estimate bid contract (when linked), as a unified list of bidders.  */
  activeBidders: Array<BidPackageBidder>;
  /**  All bidders on the bid package, including inactive requests and the internal-estimate bid contract (when linked).  */
  bidders: Array<BidPackageBidder>;
  scopeHasChanged: Scalars['Boolean'];
  canDelete: PotentialOperation2;
  canReviseCosts: PotentialOperation2;
  projects: Array<Project>;
  relevantMarket: Market;
  primaryHomeboundUser?: Maybe<User>;
  secondaryHomeboundUsers: Array<User>;
  overlappingBidPackages: Array<BidPackage>;
  latestAwards: Array<BidPackageAward>;
  scopeSource: BidScopeSourceDetail;
  isProjectLevelBidding: Scalars['Boolean'];
  isPlanBasedV2: Scalars['Boolean'];
  internalEstimateBidContract?: Maybe<BidContract>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  lastAwardedAt?: Maybe<Scalars['DateTime']>;
  bidPlanGroups: Array<BidPlanGroup>;
  /**
   * Groups the product offering's takeoff line items (within the bid package's scope) the way the
   * "Show Scope" view displays them.
   *
   * We first decide which bid plan group each line item belongs to, looking only at its meaningful
   * options (its add-on, or its personalization choice) and ignoring forDesignPackage options like spec
   * level and elevation. Add-on scope goes to that add-on's group, everything else to the base group.
   * Line items that don't fit any group aren't returned here.
   *
   * Then, inside each group, a line item that exactly matches one of the group's priced rows is
   * bucketed onto that row. Anything left over — extra scope the group covers but didn't price out as
   * its own row — is collected into a single "unmatched" bucket (where `groupLine` is null).
   *
   * Each bucket's `scopeLines` carry a `changeType` (added/updated/removed/null) computed by diffing the
   * accepted scope against the product offering's latest unaccepted incoming update, for FE diff rendering.
   *
   * When `showChangesOnly` is true, only changed scope lines (non-null `changeType`) are returned and
   * buckets that become empty are dropped.
   */
  scopedLineItems: Array<BidPlanChildGroupScopedLine>;
  /**
   * Add-on and structural GlobalOptions available on this BidPackage, each paired with the
   * ReadyPlanOptions included across all linked ProductOfferings.
   */
  potentialBidPlanOptions: Array<PotentialBidPlanOption>;
  /**
   * Add-on and structural GlobalOptions that have scope on the product offerings but are not yet anchored
   * by any BidPlanGroup.
   */
  optionsMissingFromPackage: Array<MissingBidPlanOption>;
  isMissingOptions: Scalars['Boolean'];
};


export type BidPackageScopedLineItemsArgs = {
  productOfferingId: Scalars['ID'];
  showChangesOnly?: InputMaybe<Scalars['Boolean']>;
};

export type PotentialBidPlanOption = {
  __typename?: 'PotentialBidPlanOption';
  globalOption: GlobalOption;
  readyPlanOptions: Array<ReadyPlanOption>;
};

export type MissingBidPlanOption = {
  __typename?: 'MissingBidPlanOption';
  globalOption: GlobalOption;
  /**  Product offerings whose in-scope takeoff lines reference this option (the 'detected in …' plans).  */
  productOfferings: Array<ProductOffering>;
};

export type BidPackageScopeLine = {
  __typename?: 'BidPackageScopeLine';
  takeoffLineItemVersion: TakeoffLineItemVersion;
  changeType?: Maybe<Scalars['String']>;
  previous?: Maybe<TakeoffLineItemVersion>;
};

export type BidPackageOrderBy = {
  id?: InputMaybe<Order>;
  updatedAt?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
};

export type SaveBidPackageInput = {
  id?: InputMaybe<Scalars['ID']>;
  productOfferings?: InputMaybe<Array<Scalars['ID']>>;
  costCodes?: InputMaybe<Array<Scalars['ID']>>;
  requests?: InputMaybe<Array<SaveBidPackageRequestInput>>;
  status?: InputMaybe<BidPackageStatus>;
  lineItems?: InputMaybe<Array<SaveBidPackageLineItemInput>>;
  bidPackageGroupId?: InputMaybe<Scalars['ID']>;
  costType?: InputMaybe<CostType>;
  delete?: InputMaybe<Scalars['Boolean']>;
  isUnitBased?: InputMaybe<Scalars['Boolean']>;
  versionNotes?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<Scalars['ID']>>;
  scopeSource?: InputMaybe<BidScopeSource>;
  internalEstimateBidContractId?: InputMaybe<Scalars['ID']>;
  isPlanBasedV2?: InputMaybe<Scalars['Boolean']>;
  archive?: InputMaybe<Scalars['Boolean']>;
  /**
   * Exhaustive list of bid plan groups (and their dimensions) for the bid package.
   * Any existing group whose id is not included is soft-deleted: its child group lines follow,
   * their line items on unsigned contract revisions are removed (signed revisions keep theirs as
   * history), and an awarded version reverts to "Bids Received" with its awards cleared.
   * Dimensions omitted from an included group are hard-deleted.
   */
  bidPlanGroups?: InputMaybe<Array<SaveBidPlanGroupInput>>;
  internalEstimateBidContract?: InputMaybe<SaveBidContractInput>;
};

export type PotentialBidItemsPageFilter = {
  bidPackageId: Scalars['ID'];
  isUsedUpstream?: InputMaybe<Scalars['Boolean']>;
  bidItemsFilter?: InputMaybe<BidItemFilter>;
};

export type AcceptBidPackageIncomingUpdatesInput = {
  bidPackageId: Scalars['ID'];
  bidPackageIncomingUpdateIds: Array<Scalars['ID']>;
};

export type SaveBidPackageResult = {
  __typename?: 'SaveBidPackageResult';
  bidPackage: BidPackage;
};

export type SaveBidPackagesResult = {
  __typename?: 'SaveBidPackagesResult';
  bidPackages: Array<BidPackage>;
};

export type OverlappingBidPackagesResult = {
  __typename?: 'OverlappingBidPackagesResult';
  bidPackages: Array<BidPackage>;
};

export type ReviseBidPackageCostsInput = {
  bidPackageId: Scalars['ID'];
};

export type ReviseBidPackageCostsResult = {
  __typename?: 'ReviseBidPackageCostsResult';
  bidPackage: BidPackage;
};

export type PotentialBidPlanDimensionResult = {
  __typename?: 'PotentialBidPlanDimensionResult';
  id: Scalars['ID'];
  kind: PotentialBidPlanDimensionKind;
  /**  Set for GlobalOptionType dimensions; null for personalization.  */
  type?: Maybe<GlobalOptionType>;
  /**  Set for personalization dimensions; null for GlobalOptionType.  */
  group?: Maybe<GlobalOptionGroup>;
  options: Array<GlobalOption>;
  /**  The selected product offerings that surface this dimension's options.  */
  productOfferings: Array<ProductOffering>;
  /**
   * For personalization, unique RPOG names from the selected offerings (comma-joined);
   * for type dimensions, the type name.
   */
  displayName: Scalars['String'];
};

export enum PotentialBidPlanDimensionKind {
  GlobalOptionType = 'GlobalOptionType',
  Personalization = 'Personalization'
}

/**
 * A bidder on a BidPackage — either a trade-partner request or the Homebound internal estimate.
 * Unified so the v2 UI can iterate one list and render one column per bidder without
 * branching on internal-estimate-vs-request at every call site.
 */
export type BidPackageBidder = {
  __typename?: 'BidPackageBidder';
  /**  Request id for requests; internalEstimateBidContract id for the estimate. Stable filter/column key.  */
  id: Scalars['ID'];
  /**  Trade partner name for requests, 'Internal Estimate' for the estimate.  */
  name: Scalars['String'];
  kind: BidPackageBidderKind;
  /**  For requests = request.bidContract; for the estimate = bidPackage.internalEstimateBidContract.  */
  bidContract?: Maybe<BidContract>;
  /**  Null for internal estimate.  */
  tradePartner?: Maybe<TradePartner>;
  /**  Set when kind = TradeRequest.  */
  request?: Maybe<BidPackageRequest>;
  /**  BCR archivedAt for requests; internalEstimateBidContract archivedAt for the estimate.  */
  archivedAt?: Maybe<Scalars['DateTime']>;
  /**  True when this bidder has costs entered on a BCR relevant to this bid package.  */
  hasCosts: Scalars['Boolean'];
};

export enum BidPackageBidderKind {
  TradeRequest = 'TradeRequest',
  InternalEstimate = 'InternalEstimate'
}

export type BidPlanChildGroupScopedLine = {
  __typename?: 'BidPlanChildGroupScopedLine';
  /**  Synthetic ID: `bpcgl.id` for matched line buckets, `unmatched:<childGroup.id>` for a child group's catch-all bucket.  */
  id: Scalars['ID'];
  /**
   *  The bid plan group this bucket belongs to. Always set.
   * @deprecated Use childGroup; the head group is reachable via childGroup.group.
   */
  group: BidPlanGroup;
  /**  The location-specific child group this bucket belongs to. Always set.  */
  childGroup: BidPlanChildGroup;
  /**
   * The BPCGL these takeoff line items map to. `null` for a child group's "unmatched" catch-all bucket.
   * For matched line buckets the owning (location-specific) child group is also reachable via `groupLine.group`.
   */
  groupLine?: Maybe<BidPlanChildGroupLine>;
  /**  Scope lines for this bucket, each carrying a changeType (added/updated/removed/null) for FE diff rendering.  */
  scopeLines: Array<BidPackageScopeLine>;
};

export type CostCodeBidCoverageResult = {
  __typename?: 'CostCodeBidCoverageResult';
  costCode?: Maybe<CostCode>;
  bidPackages: Array<BidPackage>;
  alerts: Array<CostCodeBidCoverageAlert>;
};

export type CostCodeBidCoverageFilter = {
  project: Array<Scalars['ID']>;
};

export type CostCodeBidCoverageAlert = {
  __typename?: 'CostCodeBidCoverageAlert';
  title: Scalars['String'];
  type: CostCodeBidCoverageAlertType;
  tooltip: Scalars['String'];
};

export enum CostCodeBidCoverageAlertType {
  MissingTakeoffs = 'MissingTakeoffs',
  MissingBidPackages = 'MissingBidPackages',
  PartialMissingBidPackages = 'PartialMissingBidPackages'
}

export type BidPackageAward = {
  __typename?: 'BidPackageAward';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  primaryRevision: BidContractRevision;
  secondaryRevision?: Maybe<BidContractRevision>;
  costCode: CostCode;
  bidPackageVersion?: Maybe<BidPackageVersion>;
};

export type SaveBidPackageAwardsInput = {
  bidPackageAwards: Array<SaveBidPackageAwardInput>;
};

export type SaveBidPackageAwardInput = {
  id?: InputMaybe<Scalars['ID']>;
  primaryRevisionId?: InputMaybe<Scalars['ID']>;
  secondaryRevisionId?: InputMaybe<Scalars['ID']>;
  costCodeId?: InputMaybe<Scalars['ID']>;
  bidPackageVersionId?: InputMaybe<Scalars['ID']>;
};

export type SaveBidPackageAwardsResult = {
  __typename?: 'SaveBidPackageAwardsResult';
  bidPackageAwards: Array<BidPackageAward>;
};

export type BidPackageGroup = {
  __typename?: 'BidPackageGroup';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  bidPackages: Array<BidPackage>;
  displayName: Scalars['String'];
  productOfferings: Array<ProductOffering>;
  projects: Array<Project>;
  status: BidPackageStatusDetail;
  isPlanBasedV2: Scalars['Boolean'];
};


export type BidPackageGroupBidPackagesArgs = {
  costCode?: InputMaybe<Array<Scalars['ID']>>;
  orderBy?: InputMaybe<BidPackageOrderBy>;
};

export type BidPackageGroupsFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  project?: InputMaybe<Array<Scalars['ID']>>;
  costCode?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
  scopeSource?: InputMaybe<Array<BidScopeSource>>;
  includeRelatedProjectBids?: InputMaybe<Scalars['Boolean']>;
};

export type BidPackageGroupOrderBy = {
  id?: InputMaybe<Order>;
  updatedAt?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
};

export type BidPackageGroupProductOfferingsResult = {
  __typename?: 'BidPackageGroupProductOfferingsResult';
  productOfferingInfos: Array<ProductOfferingInfo>;
};

export type ProductOfferingInfo = {
  __typename?: 'ProductOfferingInfo';
  productOffering: ProductOffering;
  bidPackage: BidPackage;
  numberOfLineItems: Scalars['Int'];
  relevantOptions: Array<ReadyPlanOption>;
};

export type BidPackageGroupsPageResult = {
  __typename?: 'BidPackageGroupsPageResult';
  entities: Array<BidPackageGroup>;
  pageInfo: PageInfo;
};

export type BidPackageIncomingUpdate = {
  __typename?: 'BidPackageIncomingUpdate';
  id: Scalars['ID'];
  accepted: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  bidPackage: BidPackage;
  source: ReadyPlanAggregateVersion;
  updateStats: BidPackageIncomingUpdateStats;
};

export type BidPackageIncomingUpdateStats = {
  __typename?: 'BidPackageIncomingUpdateStats';
  tlivs: IncomingChanges;
  rplvs: IncomingChanges;
};

export type IncomingChanges = {
  __typename?: 'IncomingChanges';
  added: Scalars['Int'];
  removed: Scalars['Int'];
  updated: Scalars['Int'];
};

export type BidPackageLineItem = {
  __typename?: 'BidPackageLineItem';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  bidItem: BidItem;
  bidPackageVersion?: Maybe<BidPackageVersion>;
  isInUse: Scalars['Boolean'];
  hasBidderCost: Scalars['Boolean'];
};

export type SaveBidPackageLineItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  bidItemId?: InputMaybe<Scalars['ID']>;
  bidPackageVersionId?: InputMaybe<Scalars['ID']>;
};

export type BidPackageRequest = Named & HasBlueprintUrl & CanCollaborate & Commentable & Referencable & Followable & {
  __typename?: 'BidPackageRequest';
  id: Scalars['ID'];
  name: Scalars['String'];
  blueprintUrl: Url;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  bidPackage: BidPackage;
  tradePartner: TradePartner;
  primaryContact?: Maybe<TradePartnerContact>;
  secondaryContact?: Maybe<TradePartnerContact>;
  bidContract?: Maybe<BidContract>;
  sentDate?: Maybe<Scalars['Date']>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
};

export type SaveBidPackageRequestInput = {
  id?: InputMaybe<Scalars['ID']>;
  bidPackageId?: InputMaybe<Scalars['ID']>;
  tradePartnerId?: InputMaybe<Scalars['ID']>;
  primaryContactId?: InputMaybe<Scalars['ID']>;
  secondaryContactId?: InputMaybe<Scalars['ID']>;
  archive?: InputMaybe<Scalars['Boolean']>;
};

export type SaveBidPackageRequestResult = {
  __typename?: 'SaveBidPackageRequestResult';
  bidPackageRequest: BidPackageRequest;
};

export type BpvScopeLinesFilter = {
  readyPlan?: InputMaybe<Array<Scalars['ID']>>;
};

export type BidPackageVersion = {
  __typename?: 'BidPackageVersion';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  displayVersion: Scalars['String'];
  version: Scalars['Int'];
  status: BidPackageStatusDetail;
  readyPlanAggregateVersions: Array<ReadyPlanAggregateVersion>;
  previous?: Maybe<BidPackageVersion>;
  lineItems: Array<BidPackageLineItem>;
  latestBidContractRevisions: Array<BidContractRevision>;
  relevantTakeoffLineItemVersions: Array<TakeoffLineItemVersion>;
  scopeLines: Array<BidPackageScopeLine>;
  basePlanGlobalPlanTasks: Array<GlobalPlanTask>;
  awards: Array<BidPackageAward>;
  bidPackage: BidPackage;
  canComplete: PotentialOperation2;
  canHaveDraws: PotentialOperation2;
  costCodes: Array<CostCode>;
};

export type BidPlanChildGroup = HasDisplayName & {
  __typename?: 'BidPlanChildGroup';
  id: Scalars['ID'];
  displayName: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  group: BidPlanGroup;
  productOffering: ProductOffering;
  /** The AddOn or Structural RPO, optional since the BPG may be a base plan */
  readyPlanOption?: Maybe<ReadyPlanOption>;
  readyPlanOptionGroup?: Maybe<ReadyPlanOptionGroup>;
  lines: Array<BidPlanChildGroupLine>;
};

export type BidPlanChildGroupLine = HasDisplayName & {
  __typename?: 'BidPlanChildGroupLine';
  id: Scalars['ID'];
  displayName: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  group: BidPlanChildGroup;
  options: Array<ReadyPlanOption>;
  planBasedBidContractLineItems: Array<PlanBasedBidContractLineItem>;
};

export type BidPlanGroup = HasDisplayName & {
  __typename?: 'BidPlanGroup';
  id: Scalars['ID'];
  displayName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  globalOption?: Maybe<GlobalOption>;
  productOfferings: Array<ProductOffering>;
  dimensions: Array<BidPlanGroupDimension>;
  order: Scalars['Int'];
  bidPackage: BidPackage;
  /**
   *  One child group per POF × RPO matching the BPG's `globalOption`, or — if the BPG is a base plan
   *  (no `globalOption`) — a single anchor-less group per POF with `readyPlanOption: null`.
   *  Each child group's `lines` (BidPlanChildGroupLine) are the cartesian product of the BPG's dimension
   *  RPOs on that POF, with combos violating option prerequisites dropped.
   *
   *  Example:
   *    BPG with "Add Bedroom" global option
   *    POFs:       A, B
   *    Dimensions: Spec     (Essential, Premium)
   *                Interior (Coastal,   Modern)
   *
   *    → 2 groups (one per POF's "Add Bedroom" global option), each with 4 lines:
   *        - [Essential, Coastal]
   *        - [Premium,   Coastal]
   *        - [Essential, Modern]
   *        - [Premium,   Modern]
   *
   * Support filtering by a specific product offering ID (the product offering bid tab)
   */
  childGroups: Array<BidPlanChildGroup>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  primaryOptionGroup?: Maybe<GlobalOptionGroup>;
  isNoCost: Scalars['Boolean'];
};


export type BidPlanGroupChildGroupsArgs = {
  productOfferingId?: InputMaybe<Scalars['ID']>;
};

export type SaveBidPlanGroupInput = {
  id?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['Int']>;
  bidPackageId?: InputMaybe<Scalars['ID']>;
  globalOptionId?: InputMaybe<Scalars['ID']>;
  dimensions?: InputMaybe<Array<SaveBidPlanGroupDimensionInput>>;
  primaryOptionGroupId?: InputMaybe<Scalars['ID']>;
  isNoCost?: InputMaybe<Scalars['Boolean']>;
};

export type BidPlanGroupDimension = {
  __typename?: 'BidPlanGroupDimension';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  group: BidPlanGroup;
  name: Scalars['String'];
  globalOptions: Array<GlobalOption>;
  globalOptionType?: Maybe<GlobalOptionType>;
  globalOptionGroup?: Maybe<GlobalOptionGroup>;
};

export type SaveBidPlanGroupDimensionInput = {
  id?: InputMaybe<Scalars['ID']>;
  groupId?: InputMaybe<Scalars['ID']>;
  globalOptionTypeId?: InputMaybe<Scalars['ID']>;
  globalOptionGroupId?: InputMaybe<Scalars['ID']>;
  globalOptionIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type BillMetricsResult = {
  __typename?: 'BillMetricsResult';
  openPayables: Array<BillMetric>;
  totalOpenPayables: Scalars['Int'];
  agingOfPayables: Array<BillMetric>;
  totalAgingOfPayables: Scalars['Int'];
  awaitingApprovals: Array<BillMetric>;
  totalAwaitingApprovals: Scalars['Int'];
};

export type BillMetric = {
  __typename?: 'BillMetric';
  label: Scalars['String'];
  totalCount: Scalars['Int'];
  totalAmount?: Maybe<Scalars['BigInt']>;
};

export type TradePartner = Entity & Named & {
  __typename?: 'TradePartner';
  bills: Array<Bill>;
  id: Scalars['ID'];
  name: Scalars['String'];
  internalNote?: Maybe<Scalars['String']>;
  commitments: Array<Commitment>;
  projects: Array<Project>;
  quickbooksId?: Maybe<Scalars['String']>;
  tasks: Array<Task>;
  markets: Array<Market>;
  users: Array<TradePartnerUser>;
  contacts: Array<TradePartnerContact>;
  doesMaterials: Scalars['Boolean'];
  doesLabor: Scalars['Boolean'];
  isSweetheart: Scalars['Boolean'];
  sourceNote?: Maybe<Scalars['String']>;
  source?: Maybe<InternalUser>;
  website?: Maybe<Scalars['String']>;
  agreements: Array<TradePartnerAgreement>;
  reviews: Array<TradePartnerReview>;
  reviewCount: Scalars['Int'];
  /** @deprecated Use `onboardingStatus`. */
  doNotUse: Scalars['Boolean'];
  intacctId?: Maybe<Scalars['String']>;
  developmentCommitments: Array<DevelopmentCommitment>;
  costCodes: Array<CostCode>;
  tradeCategories: Array<TradeCategory>;
  requirements: Array<TradePartnerRequirement>;
  meetsRequirements: Scalars['Boolean'];
  /** @deprecated renamed to meetsRequirementsExpiresOn */
  meetsRequirementsExpiresAt?: Maybe<Scalars['Date']>;
  meetsRequirementsExpiresOn?: Maybe<Scalars['Date']>;
  averageScore: Scalars['Float'];
  homeboundAccountNumber?: Maybe<Scalars['String']>;
  bidContracts: Array<BidContract>;
  createdAt: Scalars['DateTime'];
  onboardingStatus: TradePartnerOnboardingStatusDetail;
  /** returns contacts ordered by the specified roles.  roles that correspond to no contact will be null in the returned array */
  contactsForDevelopmentAndRoles: Array<Maybe<TradePartnerContact>>;
  /** returns contacts ordered by the specified roles.  roles that correspond to no contact will be null in the returned array */
  contactsForProjectAndRoles: Array<Maybe<TradePartnerContact>>;
  /**
   * projectDevelopmentMarketId: ProjectId | DevelopmentId | MarketId
   * returns all contacts within the associated market
   */
  contactsForMarket: Array<Maybe<TradePartnerContact>>;
  billDueDateFor: Scalars['Date'];
  /** @deprecated Use contactsForDevelopmentAndRoles instead */
  primaryForMarket?: Maybe<TradePartnerContact>;
  /** @deprecated Use contactsForDevelopmentAndRoles instead */
  signatoryForMarket?: Maybe<TradePartnerContact>;
  /** @deprecated Use contactsForDevelopmentAndRoles instead */
  primaryForDevelopment?: Maybe<TradePartnerContact>;
  /** @deprecated Use contactsForDevelopmentAndRoles instead */
  signatoryForDevelopment?: Maybe<TradePartnerContact>;
  /** @deprecated Use contactsForDevelopmentAndRoles instead */
  billApproverForDevelopment?: Maybe<TradePartnerContact>;
  /** @deprecated Use contactsForProjectAndRoles instead */
  primaryForProject?: Maybe<TradePartnerContact>;
  /** @deprecated Use contactsForProjectAndRoles instead */
  signatoryForProject?: Maybe<TradePartnerContact>;
  /** @deprecated Use `contactsForProjectAndRoles` or `contactsForMarket` */
  billApproverForProject?: Maybe<TradePartnerContact>;
  marketContacts: Array<TradePartnerMarketContact>;
  pendingChangeEventsToCreateCommitments: Array<ChangeEvent>;
  leadTimeInDays: Scalars['Int'];
  canLoginToPortal: Scalars['Boolean'];
  paymentTerm: PaymentTerm;
  lienWaivers: Array<LienWaiver>;
  enableClickToPay: Scalars['Boolean'];
  isLienWaiverReceiver: Scalars['Boolean'];
  activeTasksCount: Scalars['Int'];
  activeProjectsCount: Scalars['Int'];
  activeContractsCount: Scalars['Int'];
  totalBilledInCents: Scalars['Int'];
  totalPaidInCents: Scalars['Int'];
  totalCommittedInCents: Scalars['Int'];
  commitmentCountThisWeek: Scalars['Int'];
  commitmentCountLastWeek: Scalars['Int'];
  bidPackageRequests: Array<BidPackageRequest>;
};


export type TradePartnerContactsArgs = {
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
};


export type TradePartnerContactsForDevelopmentAndRolesArgs = {
  developmentId: Scalars['ID'];
  roles: Array<TradePartnerMarketRole>;
};


export type TradePartnerContactsForProjectAndRolesArgs = {
  projectId: Scalars['ID'];
  roles: Array<TradePartnerMarketRole>;
};


export type TradePartnerContactsForMarketArgs = {
  projectDevelopmentMarketId: Scalars['ID'];
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
};


export type TradePartnerBillDueDateForArgs = {
  billDate: Scalars['Date'];
};


export type TradePartnerPrimaryForMarketArgs = {
  developmentId?: InputMaybe<Scalars['ID']>;
};


export type TradePartnerSignatoryForMarketArgs = {
  developmentId?: InputMaybe<Scalars['ID']>;
};


export type TradePartnerPrimaryForDevelopmentArgs = {
  developmentId?: InputMaybe<Scalars['ID']>;
};


export type TradePartnerSignatoryForDevelopmentArgs = {
  developmentId?: InputMaybe<Scalars['ID']>;
};


export type TradePartnerBillApproverForDevelopmentArgs = {
  developmentId?: InputMaybe<Scalars['ID']>;
};


export type TradePartnerPrimaryForProjectArgs = {
  projectId: Scalars['ID'];
};


export type TradePartnerSignatoryForProjectArgs = {
  projectId: Scalars['ID'];
};


export type TradePartnerBillApproverForProjectArgs = {
  projectId: Scalars['ID'];
};

export type Bill = Entity & HasBlueprintUrl & Named & MaybeHasProject & CanCollaborate & Commentable & Referencable & Followable & {
  __typename?: 'Bill';
  id: Scalars['ID'];
  name: Scalars['String'];
  tradePartnerNumber: Scalars['String'];
  tradePartner: TradePartner;
  projectStage: ProjectStage;
  /** Returns all commitments/change orders via bill.lineItems.commitmentLineItem.owner. */
  parents: Array<CommitmentLike>;
  document?: Maybe<Document>;
  internalNote?: Maybe<Scalars['String']>;
  billDate: Scalars['Date'];
  dueDate?: Maybe<Scalars['Date']>;
  billedInCents: Scalars['Int'];
  paidInCents: Scalars['Int'];
  balanceInCents: Scalars['Int'];
  lineItems: Array<BillLineItem>;
  quickbooksId?: Maybe<Scalars['String']>;
  history: Array<History>;
  quickbooksPullOnly: Scalars['Boolean'];
  isTradePartnerCredit: Scalars['Boolean'];
  blueprintUrl: Url;
  project: Project;
  quickbooksAmountPaidInCents: Scalars['Int'];
  intacctAmountPaidInCents: Scalars['Int'];
  intacctSyncError?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  intacctId?: Maybe<Scalars['String']>;
  paidDate?: Maybe<Scalars['Date']>;
  documents: Array<Document>;
  postedDate?: Maybe<Scalars['Date']>;
  shouldSyncToIntacct: Scalars['Boolean'];
  predictedApprovers: Array<ApproverUser>;
  type: BillTypeDetail;
  status: BillStatusDetail;
  approval?: Maybe<Approval>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  sentDate?: Maybe<Scalars['Date']>;
  /** @deprecated Use canEdit instead. */
  isEditable: Scalars['Boolean'];
  isPendingOrBilled: Scalars['Boolean'];
  isProcessingReversal: Scalars['Boolean'];
  canSubmitForApproval: PotentialOperation2;
  canDelete: PotentialOperation2;
  canReverse: PotentialOperation2;
  updatedAt: Scalars['DateTime'];
  canEdit: PotentialOperation2;
  lienWaivers: Array<LienWaiver>;
  referenceNumber?: Maybe<Scalars['String']>;
  reversalIntacctId?: Maybe<Scalars['String']>;
  canCancel: PotentialOperation2;
  skipCostAccountDerivation?: Maybe<Scalars['Boolean']>;
  pendingReview: Scalars['Boolean'];
  reviewReason?: Maybe<BillReviewReason>;
  reviewReasonDetail?: Maybe<BillReviewReasonDetail>;
  isHeadless: Scalars['Boolean'];
  syncedToIntacctAt?: Maybe<Scalars['DateTime']>;
  isBilled: Scalars['Boolean'];
  proposedAmountInCents: Scalars['Int'];
  amountInCents: Scalars['Int'];
  changeEvents: Array<ChangeEvent>;
  source: BillSourceDetail;
  ocrs: Array<BillOcr>;
  isDeferred: Scalars['Boolean'];
  reviewers: Array<InternalUser>;
  erpAccountLines: Array<ErpAccountBillLineItem>;
  billOcr?: Maybe<BillOcr>;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
};

export type SaveBillInput = {
  id?: InputMaybe<Scalars['ID']>;
  projectStageId?: InputMaybe<Scalars['ID']>;
  /** @deprecated Replaced by documents. */
  documentId?: InputMaybe<Scalars['ID']>;
  tradePartnerId?: InputMaybe<Scalars['ID']>;
  tradePartnerNumber?: InputMaybe<Scalars['String']>;
  internalNote?: InputMaybe<Scalars['String']>;
  billDate?: InputMaybe<Scalars['Date']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  lineItems?: InputMaybe<Array<SaveBillLineItemInput>>;
  quickbooksAmountPaidInCents?: InputMaybe<Scalars['Int']>;
  quickbooksId?: InputMaybe<Scalars['String']>;
  quickbooksPullOnly?: InputMaybe<Scalars['Boolean']>;
  isTradePartnerCredit?: InputMaybe<Scalars['Boolean']>;
  intacctAmountPaidInCents?: InputMaybe<Scalars['Int']>;
  intacctSyncError?: InputMaybe<Scalars['String']>;
  intacctId?: InputMaybe<Scalars['String']>;
  paidDate?: InputMaybe<Scalars['Date']>;
  documents?: InputMaybe<Array<Scalars['ID']>>;
  assetId?: InputMaybe<Scalars['ID']>;
  postedDate?: InputMaybe<Scalars['Date']>;
  type?: InputMaybe<BillType>;
  status?: InputMaybe<BillStatus>;
  /** The source of the update (e.g intacct). Used to determine if the bill should be synced to Intacct. */
  updateSource?: InputMaybe<UpdateBillSource>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  balanceInCents?: InputMaybe<Scalars['Int']>;
  comment?: InputMaybe<SaveCommentInput>;
  /**
   * Used to create Repair & Maintenance or Warranty bills, this will create a single BLI with the specified amount.
   * Other bill types will ignore this input.
   */
  billedInCents?: InputMaybe<Scalars['Int']>;
  reversalIntacctId?: InputMaybe<Scalars['String']>;
  pendingReview?: InputMaybe<Scalars['Boolean']>;
  reviewReason?: InputMaybe<BillReviewReason>;
  proposedAmountInCents?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<BillSource>;
  isDeferred?: InputMaybe<Scalars['Boolean']>;
};

export type SaveBillResult = {
  __typename?: 'SaveBillResult';
  bill?: Maybe<Bill>;
};

export type SaveBillsInput = {
  bills: Array<SaveBillInput>;
};

export type SaveBillsResult = {
  __typename?: 'SaveBillsResult';
  bills: Array<Bill>;
};

export type DeleteBillInput = {
  id: Scalars['ID'];
};

export type ReverseBillInput = {
  id: Scalars['ID'];
};

export type SyncBillToIntacctInput = {
  id: Scalars['ID'];
};

export type BillFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  quickbooksId?: InputMaybe<Array<Scalars['String']>>;
  dueDate?: InputMaybe<DateFilter2>;
  marketId?: InputMaybe<Array<Scalars['ID']>>;
  projectId?: InputMaybe<Array<Scalars['ID']>>;
  requesterId?: InputMaybe<Array<Scalars['ID']>>;
  intacctId?: InputMaybe<Array<Scalars['String']>>;
  tradePartnerId?: InputMaybe<Array<Scalars['ID']>>;
  type?: InputMaybe<Array<BillType>>;
  status?: InputMaybe<Array<BillStatus>>;
  search?: InputMaybe<Scalars['String']>;
  billDate?: InputMaybe<DateFilter2>;
  hasBalanceDue?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated renamed to reviewer to move logic into backend */
  assignees?: InputMaybe<Array<BillAssigneeFilter>>;
  pendingReview?: InputMaybe<Scalars['Boolean']>;
  reviewReason?: InputMaybe<Array<BillReviewReason>>;
  createdBy?: InputMaybe<Array<Scalars['ID']>>;
  customerOwnerEntityId?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Array<BillSource>>;
  approver?: InputMaybe<Array<Scalars['ID']>>;
  isDeferred?: InputMaybe<Scalars['Boolean']>;
  reviewer?: InputMaybe<Array<Scalars['ID']>>;
};

export type BillOrder = {
  id?: InputMaybe<Order>;
  project?: InputMaybe<Order>;
  commitment?: InputMaybe<Order>;
  billDate?: InputMaybe<Order>;
  dueDate?: InputMaybe<Order>;
  billedInCents?: InputMaybe<Order>;
  paidInCents?: InputMaybe<Order>;
  balanceInCents?: InputMaybe<Order>;
  tradePartner?: InputMaybe<Order>;
  paidDate?: InputMaybe<Order>;
};

export enum UpdateBillSource {
  Intacct = 'INTACCT'
}

export type BillsPage = {
  __typename?: 'BillsPage';
  entities: Array<Bill>;
  pageInfo: PageInfo;
};

export type BillAssigneeFilter = {
  users: Array<Scalars['ID']>;
  roles: Array<ProjectRole>;
  reviewReasons: Array<BillReviewReason>;
};

/**
 * This type is returned by the protoBills field on Task, PlanTask, and Schedule Task. It is used by the frontend to
 * generate click to pay bills upon task completion.
 */
export type ProtoBill = {
  __typename?: 'ProtoBill';
  id: Scalars['ID'];
  existingBills: Array<Bill>;
  /** @deprecated use lineItems instead */
  commitmentLineItems: Array<CommitmentLineItem>;
  tradePartner: TradePartner;
  lineItems: Array<ProtoBillLineItem>;
};

export type HandleBillEmailNotificationInput = {
  items: Array<HandleBillEmailNotificationItem>;
};

export type HandleBillEmailNotificationItem = {
  id: Scalars['String'];
  userId: Scalars['String'];
};

export type ErpAccountBillLineItemErpSource = CommitmentDraw | CommitmentLineItem | ProjectItem | CostCode | Commitment;

export type ErpAccountBillLineItem = {
  __typename?: 'ErpAccountBillLineItem';
  amountInCents: Scalars['Int'];
  sourceLine: ErpAccrualLineItemSourceLine;
  erpSource: ErpAccountBillLineItemErpSource;
  costCode: CostCode;
  task?: Maybe<Task>;
  shouldAccrueAsComplete: Scalars['Boolean'];
};

export type BillGmailAttachment = {
  __typename?: 'BillGmailAttachment';
  id: Scalars['ID'];
  filename: Scalars['String'];
  mimeType: Scalars['String'];
  sizeInBytes?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  results: Array<BillGmailAttachmentResult>;
  message: BillGmailMessage;
  gmailPartId: Scalars['String'];
  gmailAttachmentId?: Maybe<Scalars['String']>;
  billOcrs: Array<BillOcr>;
  asset?: Maybe<Asset>;
};

export type BillGmailMessage = {
  __typename?: 'BillGmailMessage';
  id: Scalars['ID'];
  gmailMessageId: Scalars['String'];
  gmailUserId: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  receivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  result: BillGmailMessageResultDetail;
  attachments: Array<BillGmailAttachment>;
};

export type BillGmailMessageFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  gmailMessageId?: InputMaybe<Array<Scalars['String']>>;
  gmailUserId?: InputMaybe<Array<Scalars['String']>>;
};

export type BillGmailMessageOrderBy = {
  id?: InputMaybe<Order>;
  receivedAt?: InputMaybe<Order>;
  createdAt?: InputMaybe<Order>;
};

export type BillLineItem = {
  __typename?: 'BillLineItem';
  id: Scalars['ID'];
  bill: Bill;
  amountInCents: Scalars['Int'];
  commitmentLineItem?: Maybe<CommitmentLineItem>;
  paidInCents: Scalars['Int'];
  historicBillAmountInvoiced?: Maybe<Scalars['Int']>;
  /** @deprecated replaced by task */
  scheduleTask?: Maybe<Task>;
  projectItem: ProjectItem;
  commitmentDraw?: Maybe<CommitmentDraw>;
  task?: Maybe<Task>;
  shouldAccrueAsComplete: Scalars['Boolean'];
  isTaxExempt: Scalars['Boolean'];
  taxableAmountInCents: Scalars['Int'];
  taxInCents: Scalars['Int'];
  allocations: Array<BillLineItemAllocation>;
};

export type SaveBillLineItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  costCode?: InputMaybe<Scalars['ID']>;
  commitmentLineItemId?: InputMaybe<Scalars['ID']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  historicBillAmountInvoiced?: InputMaybe<Scalars['Int']>;
  /** @deprecated replaced by taskId */
  scheduleTaskId?: InputMaybe<Scalars['ID']>;
  projectItemId?: InputMaybe<Scalars['ID']>;
  commitmentDrawId?: InputMaybe<Scalars['ID']>;
  taskId?: InputMaybe<Scalars['ID']>;
  taxableAmountInCents?: InputMaybe<Scalars['Int']>;
};

/**
 * This type is returned by the protoBills field on Task, PlanTask, and Schedule Task. It is used by the frontend to
 * generate click to pay bills upon task completion.
 */
export type ProtoBillLineItem = {
  __typename?: 'ProtoBillLineItem';
  commitmentLineItem: CommitmentLineItem;
  commitmentDraw?: Maybe<CommitmentDraw>;
  amountInCents: Scalars['Int'];
};

export type BillLineItemAllocation = {
  __typename?: 'BillLineItemAllocation';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  costInCents: Scalars['Int'];
  paidCostInCents: Scalars['Int'];
  commitmentLineItemAllocation?: Maybe<CommitmentLineItemAllocation>;
  projectItemAllocation: ProjectItemAllocation;
};

export type BillOcr = {
  __typename?: 'BillOcr';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  asset: Asset;
  bill?: Maybe<Bill>;
  tradePartner?: Maybe<TradePartner>;
  project?: Maybe<Project>;
  commitmentLikes: Array<CommitmentLike>;
  invoiceNumber?: Maybe<Scalars['String']>;
  billDate?: Maybe<Scalars['Date']>;
  dueDate?: Maybe<Scalars['Date']>;
  totalInCents?: Maybe<Scalars['Int']>;
  type: BillTypeDetail;
  gmailAttachment?: Maybe<BillGmailAttachment>;
  billOcrBill?: Maybe<Bill>;
  trackedJobs: Array<TrackedJob>;
};

export type HandleBillParserResultInput = {
  workflowRunId: Scalars['String'];
};

export type RunBillParserInput = {
  assetId: Scalars['ID'];
  projectId?: InputMaybe<Scalars['ID']>;
};

export type RunBillParserResult = {
  __typename?: 'RunBillParserResult';
  trackedJob: TrackedJob;
};

/** I.e. "0100 Site Engineering Reports". */
export type PreConBudgetCostDivisionLineItem = {
  __typename?: 'PreConBudgetCostDivisionLineItem';
  costDivision: CostDivision;
  lines: Array<PreConBudgetCostCodeLineItem>;
  priceInCents?: Maybe<Scalars['Int']>;
  budgetInCents?: Maybe<Scalars['Int']>;
};

/** I.e. "0120 GeoTech report". */
export type PreConBudgetCostCodeLineItem = {
  __typename?: 'PreConBudgetCostCodeLineItem';
  costCode: CostCode;
  internalNote?: Maybe<Scalars['String']>;
  priceInCents?: Maybe<Scalars['Int']>;
  budgetInCents?: Maybe<Scalars['Int']>;
};

export type SavePreConBudgetLineItemInput = {
  projectId: Scalars['ID'];
  costCodeId: Scalars['ID'];
  /**
   *  `0` == keep the line item, but we don't have a budget for it? This doesn't really make sense.
   * `null` == delete the line item
   */
  budgetInCents?: InputMaybe<Scalars['Int']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  internalNote?: InputMaybe<Scalars['String']>;
};

export type SavePreConBudgetLineItemResult = {
  __typename?: 'SavePreConBudgetLineItemResult';
  lineItem: PreConBudgetCostCodeLineItem;
};

export type DeletePreConBudgetLineItemInput = {
  projectId: Scalars['ID'];
  costCodeId: Scalars['ID'];
};

export type DeletePreConBudgetLineItemResult = {
  __typename?: 'DeletePreConBudgetLineItemResult';
  emptyResult?: Maybe<EmptyResult>;
};

export type ApprovePreConBudgetLineItemInput = {
  projectId: Scalars['ID'];
  contractDocumentId: Scalars['ID'];
  executionDate: Scalars['Date'];
  internalNote?: InputMaybe<Scalars['String']>;
  contractType?: InputMaybe<ContractType>;
  costPlusMarkupBasisPoints?: InputMaybe<Scalars['Int']>;
};

export type ApprovePreConBudgetLineItemResult = {
  __typename?: 'ApprovePreConBudgetLineItemResult';
  contract: HomeownerContract;
};

export type Builder = {
  __typename?: 'Builder';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SaveBuilderInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type SaveBuilderResult = {
  __typename?: 'SaveBuilderResult';
  builder: Builder;
};

export type BusinessFunction = Named & HasBlueprintUrl & {
  __typename?: 'BusinessFunction';
  id: Scalars['ID'];
  name: Scalars['String'];
  priority: Scalars['Int'];
  autoApprovalAmountInCents?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  impactReviewer?: Maybe<ProjectRoleDetail>;
  initialReviewer?: Maybe<ProjectRoleDetail>;
  businessFunctionType: BusinessFunctionTypeDetail;
  blueprintUrl: Url;
  approverProjectRole?: Maybe<ProjectRoleDetail>;
  applicableChangeTypes: Array<ChangeTypeDetail>;
};

export type SaveBusinessFunctionInput = {
  id?: InputMaybe<Scalars['ID']>;
  priority?: InputMaybe<Scalars['Int']>;
  autoApprovalAmountInCents?: InputMaybe<Scalars['Int']>;
  impactReviewer?: InputMaybe<ProjectRole>;
  initialReviewer?: InputMaybe<ProjectRole>;
  businessFunctionType?: InputMaybe<BusinessFunctionType>;
  approverProjectRole?: InputMaybe<ProjectRole>;
};

export type SaveBusinessFunctionResult = {
  __typename?: 'SaveBusinessFunctionResult';
  businessFunction: BusinessFunction;
};

export type CalendarInterval = {
  __typename?: 'CalendarInterval';
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  durationInDays: Scalars['Int'];
  calendarProgress: Scalars['Int'];
};

export type CalendarInterval2 = {
  __typename?: 'CalendarInterval2';
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  durationInDays?: Maybe<Scalars['Int']>;
};

export type CreateChangeEventFromBidContractRevisionInput = {
  bidContractRevisionId: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type ChangeEvent = HasBlueprintUrl & Named & MaybeHasProject & CanCollaborate & Commentable & Referencable & Followable & {
  __typename?: 'ChangeEvent';
  id: Scalars['ID'];
  title: Scalars['String'];
  commitments: Array<CommitmentLike>;
  internalNote?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  status: ChangeEventStatus;
  statusDetail: ChangeEventStatusDetail;
  projectStage: ProjectStage;
  project: Project;
  lineItems: Array<ChangeEventLineItem>;
  homeownerContractChangeOrder?: Maybe<HomeownerContractChangeOrder>;
  blueprintUrl: Url;
  name: Scalars['String'];
  history: Array<History>;
  estimates: Array<Estimate>;
  canCreateFinalEstimate: Scalars['Boolean'];
  totalCostInCents: Scalars['Int'];
  totalPriceInCents: Scalars['Int'];
  originalTotalCostInCents: Scalars['Int'];
  originalTotalPriceInCents: Scalars['Int'];
  proposedTotalCostInCents: Scalars['Int'];
  proposedTotalPriceInCents: Scalars['Int'];
  budgetImpactInCents: Scalars['Int'];
  revisedBudgetInCents: Scalars['Int'];
  /** @deprecated replaced by type */
  isHomeownerChangeEvent: Scalars['Boolean'];
  isReadyHomeManaged: Scalars['Boolean'];
  canEditLineItems: PotentialOperation2;
  internalImpactInDays?: Maybe<Scalars['Int']>;
  homeownerImpactInDays?: Maybe<Scalars['Int']>;
  reasonDetails?: Maybe<Scalars['String']>;
  reason: ChangeEventReason;
  identifier: Scalars['Int'];
  appliedTemplates: Array<ItemTemplate>;
  templateConfigs: Array<ChangeEventTemplateConfig>;
  budgetPhase: ChangeEventBudgetPhaseDetail;
  acceptedAt?: Maybe<Scalars['DateTime']>;
  approval?: Maybe<Approval>;
  impactedCommitments: Array<CommitmentLike>;
  predictedApprovers: Array<ApproverUser>;
  type: ChangeEventTypeDetail;
  canBeLocked: PotentialOperation2;
  canSubmitForApproval: PotentialOperation2;
  tradesToDraftCommitmentsFor: Array<TradePartner>;
  impactedTrades: Array<TradePartner>;
  pandaDoc?: Maybe<PandaDoc>;
  requireSignature: Scalars['Boolean'];
  createdBy?: Maybe<ChangeEventCreatedBy>;
  readyPlan?: Maybe<ReadyPlanLike>;
  originalReadyPlan?: Maybe<ReadyPlanLike>;
  originalReadyPlanOptions: Array<ChangeEventOriginalOption>;
  proposedReadyPlanOptions: Array<ChangeEventProposedOption>;
  isContractAddendum: Scalars['Boolean'];
  removedReadyPlanOptions: Array<ChangeEventOriginalOption>;
  addedReadyPlanOptions: Array<ChangeEventProposedOption>;
  checkoutConfig?: Maybe<CheckoutConfig>;
  proposedOrientation?: Maybe<ProjectReadyPlanConfigOrientationDetail>;
  hasPreSignedContract: Scalars['Boolean'];
  document?: Maybe<Document>;
  aggregateVersion?: Maybe<ReadyPlanAggregateVersion>;
  workflow?: Maybe<ChangeEventWorkflowDetail>;
  materialVariantSwaps: Array<ChangeEventMaterialVariantSwap>;
  isTitleAutoGenerated: Scalars['Boolean'];
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
};

export type SaveChangeEventInput = {
  id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  internalNote?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ChangeEventStatus>;
  projectStageId?: InputMaybe<Scalars['ID']>;
  internalImpactInDays?: InputMaybe<Scalars['Int']>;
  homeownerImpactInDays?: InputMaybe<Scalars['Int']>;
  /** @deprecated replaced by type */
  isHomeownerChangeEvent?: InputMaybe<Scalars['Boolean']>;
  reasonDetails?: InputMaybe<Scalars['String']>;
  reasonId?: InputMaybe<Scalars['ID']>;
  lineItems?: InputMaybe<Array<SaveChangeEventLineItemInput>>;
  budgetPhase?: InputMaybe<ChangeEventBudgetPhase>;
  type?: InputMaybe<ChangeEventType>;
  tradesToDraftCommitmentsFor?: InputMaybe<Array<Scalars['ID']>>;
  createdById?: InputMaybe<Scalars['ID']>;
  readyPlanId?: InputMaybe<Scalars['ID']>;
  originalReadyPlanId?: InputMaybe<Scalars['ID']>;
  isContractAddendum?: InputMaybe<Scalars['Boolean']>;
  originalReadyPlanOptions?: InputMaybe<Array<ChangeEventReadyPlanOptionInput>>;
  proposedReadyPlanOptions?: InputMaybe<Array<ChangeEventReadyPlanOptionInput>>;
  checkoutConfigId?: InputMaybe<Scalars['ID']>;
  proposedOrientation?: InputMaybe<ProjectReadyPlanConfigOrientation>;
  hasPreSignedContract?: InputMaybe<Scalars['Boolean']>;
  documentId?: InputMaybe<Scalars['ID']>;
  workflow?: InputMaybe<ChangeEventWorkflow>;
  aggregateVersionId?: InputMaybe<Scalars['ID']>;
  /**
   * Swaps one product for another on existing scope, letting the swap create the line items for it.
   *
   * Exhaustive list: any existing swap whose id is not included is
   * hard-deleted, along with the CELIs it manages.
   */
  materialVariantSwaps?: InputMaybe<Array<SaveChangeEventMaterialVariantSwapInput>>;
};

/**  Input used for bulk updating change events as it only requires a subset of fields from SaveChangeEventInput.  */
export type SaveChangeEventsInput = {
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  internalNote?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ChangeEventStatus>;
  projectStageId?: InputMaybe<Scalars['ID']>;
  reasonId?: InputMaybe<Scalars['ID']>;
};

export type ChangeEventReadyPlanOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  readyPlanOptionId?: InputMaybe<Scalars['ID']>;
};

export type SaveChangeEventResult = {
  __typename?: 'SaveChangeEventResult';
  changeEvent: ChangeEvent;
};

export type SaveChangeEventsResult = {
  __typename?: 'SaveChangeEventsResult';
  changeEvents: Array<ChangeEvent>;
};

export type ChangeEventFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  projectId?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Array<ChangeEventStatus>>;
  /** @deprecated replaced by type */
  isHomeownerChangeEvent?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<ChangeEventType>>;
  stage?: InputMaybe<Array<Stage>>;
  workflow?: InputMaybe<Array<ChangeEventWorkflow>>;
};

export type ChangeEventLineItemFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
};

export type DeleteChangeEventInput = {
  id: Scalars['ID'];
  maybeVoid?: InputMaybe<Scalars['Boolean']>;
};

export type ChangeEventCreatedBy = Bill | Expense;

export type ChangeEventLineItem = Named & HasDisplayName & {
  __typename?: 'ChangeEventLineItem';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  changeEvent: ChangeEvent;
  projectItem: ProjectItem;
  /**  The change in quantity.  */
  quantity?: Maybe<Scalars['Int']>;
  /**  The change in total price.  */
  totalPriceInCents: Scalars['Int'];
  /**  The change in cost price.  */
  totalCostInCents: Scalars['Int'];
  /** @deprecated Unit cost on a delta doesn't make sense. */
  unitCostInCents: Scalars['Int'];
  originalQuantity?: Maybe<Scalars['Int']>;
  originalTotalCostInCents: Scalars['Int'];
  originalTotalPriceInCents: Scalars['Int'];
  proposedTotalCostInCents: Scalars['Int'];
  item: Item;
  /** name used to override projectItem name when CE merged */
  name: Scalars['String'];
  costType: CostType;
  location: Location;
  unitOfMeasure: UnitOfMeasure;
  displayName: Scalars['String'];
  /** @deprecated Use costConfidenceDetail instead. */
  costConfidence: CostConfidence;
  costConfidenceDetail: CostConfidenceDetail;
  type: ChangeEventLineItemType;
  typeDetail: ChangeEventLineItemTypeDetail;
  specifications?: Maybe<Scalars['String']>;
  tradePartnerNote?: Maybe<Scalars['String']>;
  canEditName: PotentialOperation2;
  canEditCost: PotentialOperation2;
  itemTemplateItem?: Maybe<BaseItemLike>;
  modifyingTemplateItems: Array<BaseItemLike>;
  tradePartner?: Maybe<TradePartner>;
  originalTradePartner?: Maybe<TradePartner>;
  internalNote?: Maybe<Scalars['String']>;
  originalBidItem?: Maybe<BidItem>;
  proposedBidItem?: Maybe<BidItem>;
  originalBidContractLineItem?: Maybe<BidContractLineItem>;
  proposedBidContractLineItem?: Maybe<BidContractLineItem>;
  originalTask?: Maybe<GlobalPlanTask>;
  proposedTask?: Maybe<GlobalPlanTask>;
  originalMaterialVariant?: Maybe<MaterialVariant>;
  proposedMaterialVariant?: Maybe<MaterialVariant>;
  allocations: Array<ChangeEventLineItemAllocation>;
  originalPackageDesignNotes?: Maybe<Scalars['String']>;
  proposedPackageDesignNotes?: Maybe<Scalars['String']>;
  /** True when the only change on this line item is an updated template item pointer (no cost, price, quantity, or name changes). */
  isMetadataChangeOnly: Scalars['Boolean'];
};

export type SaveChangeEventLineItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Int']>;
  changeEventId?: InputMaybe<Scalars['ID']>;
  totalPriceInCents?: InputMaybe<Scalars['Int']>;
  totalCostInCents?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  /**  projectItemId and itemId are mutually exclusive, and only used for initial creation (if using an existing project item or not)  */
  projectItemId?: InputMaybe<Scalars['ID']>;
  itemId?: InputMaybe<Scalars['ID']>;
  /**  the fields below here all belong to the project item object itself, not to the celi, so they are passed through to update when available */
  costType?: InputMaybe<CostType>;
  locationId?: InputMaybe<Scalars['ID']>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']>;
  costConfidence?: InputMaybe<CostConfidence>;
  specifications?: InputMaybe<Scalars['String']>;
  tradePartnerNote?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ChangeEventLineItemType>;
  tradePartnerId?: InputMaybe<Scalars['ID']>;
  internalNote?: InputMaybe<Scalars['String']>;
  proposedQuantity?: InputMaybe<Scalars['Int']>;
  proposedTotalCostInCents?: InputMaybe<Scalars['Int']>;
  proposedTotalPriceInCents?: InputMaybe<Scalars['Int']>;
  matchExisting?: InputMaybe<Scalars['Boolean']>;
  proposedBidItemId?: InputMaybe<Scalars['ID']>;
  proposedBidContractLineItemId?: InputMaybe<Scalars['ID']>;
  proposedTaskId?: InputMaybe<Scalars['ID']>;
  proposedMaterialVariantId?: InputMaybe<Scalars['ID']>;
  proposedPackageDesignNotes?: InputMaybe<Scalars['String']>;
};

export type SaveChangeEventLineItemsInput = {
  changeEventLineItems: Array<SaveChangeEventLineItemInput>;
  /**  flag indicating a celi should not be created for any matched project items with signed commitments from a file upload */
  ignoreContracted?: InputMaybe<Scalars['Boolean']>;
};

export type SaveChangeEventLineItemsResult = {
  __typename?: 'SaveChangeEventLineItemsResult';
  changeEventLineItems: Array<ChangeEventLineItem>;
  /**  Any CELIs which were auto-added to the CE due to the addition of a new material which requires labor.  */
  autoAddedLaborLines: Array<ChangeEventLineItem>;
};

export type ChangeEventLineItemAllocation = {
  __typename?: 'ChangeEventLineItemAllocation';
  id: Scalars['ID'];
  costInCents: Scalars['Int'];
  priceInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  changeEventLineItem: ChangeEventLineItem;
  projectItemAllocation: ProjectItemAllocation;
};

export type ChangeEventMaterialVariantSwap = {
  __typename?: 'ChangeEventMaterialVariantSwap';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  changeEvent: ChangeEvent;
  originalMaterialVariant: MaterialVariant;
  proposedMaterialVariant: MaterialVariant;
  originalProjectItem: ProjectItem;
  proposedProjectItem: ProjectItem;
  totalCostInCents: Scalars['Int'];
  totalPriceInCents: Scalars['Int'];
  canEditCost: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  /**  The managed Add line for the proposed product.  */
  addedLineItem: ChangeEventLineItem;
  /**  The managed removal (or true-up Modify) line against the original Project Item.  */
  removalLineItem: ChangeEventLineItem;
  /**  For BOYL, the price-only line carrying the OH&P / invoice-category price delta.  */
  priceOnlyLineItem?: Maybe<ChangeEventLineItem>;
  /**  True when the original is covered by a plan-based bid, so the swap needs a manual cost delta.  */
  isPlanBasedSwap: Scalars['Boolean'];
  /**  The Plan-based CELIs that hold the cost/price delta for the swap.  */
  planBasedLineItems: Array<ChangeEventLineItem>;
  /**  Whether the proposed MV satisfies the original's placeholder attribute requirements.  */
  matchesPlaceholder: Scalars['Boolean'];
  /**  Whether an awarded bid priced the Add line for the proposed MV.  */
  hasAwardedCost: Scalars['Boolean'];
  /**  Whether the user defined the proposed MV instead of picking it out of the catalog.  */
  proposedMaterialVariantWasCreated: Scalars['Boolean'];
};

export type SaveChangeEventMaterialVariantSwapInput = {
  id?: InputMaybe<Scalars['ID']>;
  originalProjectItemId?: InputMaybe<Scalars['ID']>;
  proposedMaterialVariantId?: InputMaybe<Scalars['ID']>;
  totalCostInCents?: InputMaybe<Scalars['Int']>;
  totalPriceInCents?: InputMaybe<Scalars['Int']>;
  proposedMaterialVariantWasCreated?: InputMaybe<Scalars['Boolean']>;
};

export type ChangeEventOriginalOption = {
  __typename?: 'ChangeEventOriginalOption';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  priceInCents: Scalars['Int'];
  changeEvent: ChangeEvent;
  readyPlanOption: ReadyPlanOption;
};

export type ChangeEventProposedOption = {
  __typename?: 'ChangeEventProposedOption';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  priceInCents: Scalars['Int'];
  changeEvent: ChangeEvent;
  readyPlanOption: ReadyPlanOption;
};

export type ChangeEventReason = Named & {
  __typename?: 'ChangeEventReason';
  id: Scalars['ID'];
  code: Scalars['String'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  changeEvents: Array<ChangeEvent>;
  isEpo: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  isIncludedInVariance?: Maybe<Scalars['Boolean']>;
  workflows: Array<ChangeEventWorkflow>;
};

export type SaveChangeEventReasonInput = {
  id?: InputMaybe<Scalars['ID']>;
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  isEpo?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  isIncludedInVariance?: InputMaybe<Scalars['Boolean']>;
  workflows?: InputMaybe<Array<ChangeEventWorkflow>>;
};

export type SaveChangeEventReasonResult = {
  __typename?: 'SaveChangeEventReasonResult';
  changeEventReason: ChangeEventReason;
};

export type ChangeEventReasonFilter = {
  workflows?: InputMaybe<Array<ChangeEventWorkflow>>;
};

export type ChangeEventTemplateConfig = ProjectStageTemplateConfigLike & Named & {
  __typename?: 'ChangeEventTemplateConfig';
  id: Scalars['ID'];
  onlyChangedInVersion?: Maybe<Scalars['Boolean']>;
  projectStage: ProjectStage;
  changeEvent: ChangeEvent;
  /** @deprecated Use the parent instead */
  itemTemplate: ItemTemplate;
  parent: BaseItemParentVersion;
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
};

export type ChangeRequest = Named & HasBlueprintUrl & CanCollaborate & Commentable & Referencable & Followable & {
  __typename?: 'ChangeRequest';
  id: Scalars['ID'];
  title: Scalars['String'];
  /** Resolves the `title` field */
  name: Scalars['String'];
  rationale: Scalars['String'];
  estimateBudgetImpactInCents?: Maybe<Scalars['Int']>;
  /** Falls back to 0 if a change request has no budget impact */
  estimateBudgetImpactInCentsFallback: Scalars['Int'];
  estimateScheduleImpactInDays?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  priority: ChangeRequestPriorityDetail;
  source: ChangeRequestSourceDetail;
  status: ChangeRequestStatusDetail;
  createdBy: User;
  blueprintUrl: Url;
  scopes: Array<ChangeRequestScope>;
  attachments: Array<Attachment>;
  blocking: Array<ChangeRequest>;
  blockers: Array<ChangeRequest>;
  changeRequestAssets: Array<ChangeRequestAsset>;
  toDos: Array<ChangeRequestToDo>;
  history: Array<History>;
  changeTypes: Array<ChangeType>;
  approval?: Maybe<Approval>;
  predictedApprovers: Array<ApproverUser>;
  estimateRevenueImpactInCents?: Maybe<Scalars['Int']>;
  estimateMarginImpactBasisPoints?: Maybe<Scalars['Int']>;
  linkedTo: Array<ChangeRequest>;
  groups: Array<ChangeRequestGroup>;
  isStandardOffering?: Maybe<Scalars['Boolean']>;
  salesforceOpportunityUrl?: Maybe<Scalars['String']>;
  isUnderContract?: Maybe<Scalars['Boolean']>;
  productSelection?: Maybe<Scalars['String']>;
  markupBasisPoints?: Maybe<Scalars['Int']>;
  estimatedBuyerOutOfPocketInCents?: Maybe<Scalars['Int']>;
  estimatedRetailPriceInCents?: Maybe<Scalars['Int']>;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
};

export type ChangeRequestsFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Array<ChangeRequestStatus>>;
  changeTypes?: InputMaybe<Array<ChangeType>>;
  source?: InputMaybe<Array<ChangeRequestSource>>;
  market?: InputMaybe<Array<Scalars['ID']>>;
  project?: InputMaybe<Array<Scalars['ID']>>;
  development?: InputMaybe<Array<Scalars['ID']>>;
  /** Non-tagged ids will be considered InternalUserIds */
  createdByUser?: InputMaybe<Array<Scalars['ID']>>;
  projectWithDevelopment?: InputMaybe<Array<Scalars['ID']>>;
  /** BusinessFunctionType Filter for BusinessFunctions that have ChangeRequestAssets associated to the ChangeRequest */
  businessFunction?: InputMaybe<Array<BusinessFunctionType>>;
  /**  InternalUser filter includes ChangeRequest.createdBy, any ToDo assignee and any Approver  */
  internalUser?: InputMaybe<Array<Scalars['ID']>>;
  group?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
};

export type ChangeRequestOrder = {
  id?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
  title?: InputMaybe<Order>;
  rationale?: InputMaybe<Order>;
  source?: InputMaybe<Order>;
  estimateBudgetImpactInCents?: InputMaybe<Order>;
  updatedAt?: InputMaybe<Order>;
  estimateRevenueImpactInCents?: InputMaybe<Order>;
  estimateMarginImpactBasisPoints?: InputMaybe<Order>;
};

export type ChangeRequestsPageResult = {
  __typename?: 'ChangeRequestsPageResult';
  entities: Array<ChangeRequest>;
  pageInfo: PageInfo;
};

export type SaveChangeRequestInput = {
  id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  rationale?: InputMaybe<Scalars['String']>;
  estimateBudgetImpactInCents?: InputMaybe<Scalars['Int']>;
  estimateScheduleImpactInDays?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<ChangeRequestPriority>;
  source?: InputMaybe<ChangeRequestSource>;
  status?: InputMaybe<ChangeRequestStatus>;
  scopes?: InputMaybe<Array<SaveChangeRequestScopeInput>>;
  attachments?: InputMaybe<Array<SaveChangeRequestAttachmentInput>>;
  blocking?: InputMaybe<Array<SaveChangeRequestDependencyInput>>;
  blockers?: InputMaybe<Array<SaveChangeRequestDependencyInput>>;
  linkedTo?: InputMaybe<Array<SaveChangeRequestLinkInput>>;
  changeTypes?: InputMaybe<Array<ChangeType>>;
  changeRequestAssets?: InputMaybe<Array<SaveChangeRequestAsset>>;
  estimateRevenueImpactInCents?: InputMaybe<Scalars['Int']>;
  estimateMarginImpactBasisPoints?: InputMaybe<Scalars['Int']>;
  groups?: InputMaybe<Array<SaveChangeRequestGroupsInput>>;
  isStandardOffering?: InputMaybe<Scalars['Boolean']>;
  salesforceOpportunityUrl?: InputMaybe<Scalars['String']>;
  isUnderContract?: InputMaybe<Scalars['Boolean']>;
  productSelection?: InputMaybe<Scalars['String']>;
  markup?: InputMaybe<Scalars['Int']>;
  estimatedBuyerOutOfPocketInCents?: InputMaybe<Scalars['Int']>;
  estimatedRetailPriceInCents?: InputMaybe<Scalars['Int']>;
  markupBasisPoints?: InputMaybe<Scalars['Int']>;
};

export type SaveChangeRequestsInput = {
  changeRequests: Array<SaveChangeRequestInput>;
};

export type SaveChangeRequestResult = {
  __typename?: 'SaveChangeRequestResult';
  changeRequest: ChangeRequest;
};

export type SaveChangeRequestsResult = {
  __typename?: 'SaveChangeRequestsResult';
  changeRequests: Array<ChangeRequest>;
};

export type ChangeRequestApproverSubjectData = {
  __typename?: 'ChangeRequestApproverSubjectData';
  businessFunction: Scalars['String'];
  autoApprovalAmountInCents?: Maybe<Scalars['Int']>;
};

export type SaveChangeRequestScopeInput = {
  /** The ID of the RequestScope record (only used for deletes) */
  id?: InputMaybe<Scalars['ID']>;
  /** The (tagged) ID of the Project or Development record */
  targetId?: InputMaybe<Scalars['ID']>;
  op: IncrementalCollectionOp;
};

export type SaveChangeRequestAttachmentInput = {
  /** The ID of the Attachment record (only used for deletes) */
  id?: InputMaybe<Scalars['ID']>;
  asset: AssetInput;
};

export type SaveChangeRequestDependencyInput = {
  id: Scalars['ID'];
  op: IncrementalCollectionOp;
};

export type SaveChangeRequestLinkInput = {
  id: Scalars['ID'];
  op: IncrementalCollectionOp;
};

export type SaveChangeRequestGroupsInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  op: IncrementalCollectionOp;
};

export type SaveChangeRequestAsset = {
  id: Scalars['ID'];
  op: IncrementalCollectionOp;
};

export enum ChangeRequestDependency {
  Block = 'BLOCK',
  Dependent = 'DEPENDENT',
  Link = 'LINK'
}

export type ChangeRequestAsset = Named & {
  __typename?: 'ChangeRequestAsset';
  id: Scalars['ID'];
  name: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  functionType: BusinessFunctionTypeDetail;
  platform: ChangeRequestAssetPlatformDetail;
  implementationReviewer?: Maybe<ProjectRoleDetail>;
  changeRequests: Array<ChangeRequest>;
  scopes: Array<ChangeRequestAssetScope>;
  implementer: ProjectRoleDetail;
  requiredForChangeRequestSource: Array<ChangeRequestSource>;
  systemChangeRequestAsset?: Maybe<SystemChangeRequestAssetDetail>;
};

export type SaveChangeRequestAssetInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  functionType?: InputMaybe<BusinessFunctionType>;
  platform?: InputMaybe<ChangeRequestAssetPlatform>;
  implementationReviewer?: InputMaybe<ProjectRole>;
  implementer?: InputMaybe<ProjectRole>;
  scopes?: InputMaybe<Array<ChangeRequestAssetScope>>;
  requiredForChangeRequestSource?: InputMaybe<Array<ChangeRequestSource>>;
  systemChangeRequestAsset?: InputMaybe<SystemChangeRequestAsset>;
};

export type SaveChangeRequestAssetsInput = {
  changeRequestAssets: Array<SaveChangeRequestAssetInput>;
};

export type SaveChangeRequestAssetsResult = {
  __typename?: 'SaveChangeRequestAssetsResult';
  changeRequestAssets: Array<ChangeRequestAsset>;
};

export type ChangeRequestAssetFilter = {
  functionType: BusinessFunctionType;
};

export type ChangeRequestAssetOrder = {
  id?: InputMaybe<Order>;
  name?: InputMaybe<Order>;
  scopes?: InputMaybe<Order>;
  implementer?: InputMaybe<Order>;
  implementationReviewer?: InputMaybe<Order>;
  platform?: InputMaybe<Order>;
  functionType?: InputMaybe<Order>;
};

export type ChangeRequestAssetsPageResult = {
  __typename?: 'ChangeRequestAssetsPageResult';
  entities: Array<ChangeRequestAsset>;
  pageInfo: PageInfo;
};

export type ChangeRequestGroup = {
  __typename?: 'ChangeRequestGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  changeRequests: Array<ChangeRequest>;
  salesforceOpportunityLink?: Maybe<Scalars['String']>;
  underContract?: Maybe<Scalars['Boolean']>;
};

export type SaveChangeRequestGroupInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  changeRequests?: InputMaybe<Array<SaveChangeRequestGroupChangeRequestInput>>;
  salesforceOpportunityLink?: InputMaybe<Scalars['String']>;
  underContract?: InputMaybe<Scalars['Boolean']>;
};

export type SaveChangeRequestGroupResult = {
  __typename?: 'SaveChangeRequestGroupResult';
  changeRequestGroup: ChangeRequestGroup;
};

export type SaveChangeRequestGroupsResult = {
  __typename?: 'SaveChangeRequestGroupsResult';
  changeRequestGroups: Array<ChangeRequestGroup>;
};

export type SaveChangeRequestGroupChangeRequestInput = {
  id: Scalars['ID'];
  op: IncrementalCollectionOp;
};

export type ChangeRequestScope = {
  __typename?: 'ChangeRequestScope';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  changeRequest: ChangeRequest;
  target: ChangeRequestScopeTarget;
  deletedAt?: Maybe<Scalars['DateTime']>;
};

export type ChangeRequestScopeTarget = StandaloneProject | Region | Development | Market | Community | Subdivision | Lot | Structure | Unit;

export type ChangeRequestToDo = Named & HasBlueprintUrl & CanCollaborate & Commentable & Referencable & Followable & {
  __typename?: 'ChangeRequestToDo';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  dueDate?: Maybe<Scalars['Date']>;
  order: Scalars['String'];
  urgent: Scalars['Boolean'];
  status: ToDoStatusDetail;
  type: ToDoTypeDetail;
  createdBy: User;
  attachments: Array<Attachment>;
  checklistItems: Array<ToDoChecklistItem>;
  assignees: Array<User>;
  parent?: Maybe<ToDoParent>;
  priorityGroup: Scalars['Int'];
  changeRequestToDoType: ChangeRequestToDoTypeDetail;
  businessFunction: BusinessFunction;
  changeRequest: ChangeRequest;
  changeRequestAsset?: Maybe<ChangeRequestAsset>;
  originalAssignee: User;
  blueprintUrl: Url;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
};

export type CheckoutConfig = HasCheckoutUrl & ReadyPlanConfigLike & {
  __typename?: 'CheckoutConfig';
  id: Scalars['ID'];
  /**  Should default the POF name, but then can be customized by homeowner.  */
  name?: Maybe<Scalars['String']>;
  reservedAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['Date']>;
  status: CheckoutConfigStatus;
  customerEmail?: Maybe<Scalars['String']>;
  customerFirstName?: Maybe<Scalars['String']>;
  customerLastName?: Maybe<Scalars['String']>;
  customerPhone?: Maybe<Scalars['String']>;
  structure: Structure;
  community: Community;
  productOffering?: Maybe<ProductOffering>;
  readyPlan?: Maybe<ReadyPlanLike>;
  readyPlanOptions: Array<ReadyPlanOption>;
  isReversed: Scalars['Boolean'];
  /** @deprecated Use optionGroups instead. */
  options: Array<ReadyPlanOption>;
  /**  All of the RPOGs, both selected and not selected, with contextual cutoffs/prices for this config.  */
  optionGroups: Array<CheckoutConfigOptionGroup>;
  /**  Same as optionGroups, but scoped to the option groups that belong to the main house product offering.  */
  mhOptionGroups: Array<CheckoutConfigOptionGroup>;
  /**  Same as optionGroups, but scoped to the option groups that belong to the ADU product offering. Empty when no ADU product offering is set.  */
  aduOptionGroups: Array<CheckoutConfigOptionGroup>;
  /**  The MH starting sales price (structure-specific if available, otherwise base config price).  */
  mhSalesPriceInCents: Scalars['Int'];
  /**  The ADU starting sales price. 0 if no ADU product offering is set.  */
  aduSalesPriceInCents: Scalars['Int'];
  /**  Combined sales price (mhSalesPriceInCents + aduSalesPriceInCents). Returns reserved price if config is reserved | expired.  */
  salesPriceInCents: Scalars['Int'];
  /**  MH total price including all selected MH options.  */
  mhTotalPriceInCents: Scalars['Int'];
  /**  ADU total price including all selected ADU options. 0 if no ADU product offering is set.  */
  aduTotalPriceInCents: Scalars['Int'];
  /**  Extra site-specific price (e.g. lot prep / site work) captured at Checkout. Used only when building the MH estimated invoice schedule (split 80% Foundation / 20% Exterior); it is NOT added to mh/adu/total price fields.  */
  additionalSitePriceInCents: Scalars['Int'];
  /**  Combined total price (mhTotalPriceInCents + aduTotalPriceInCents). Returns reserved price if config is reserved | expired. Does not include additionalSitePriceInCents.  */
  totalPriceInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  checkoutUrl: Url;
  /**  Only internal tech team users will have access to this */
  pricingTraceUrl?: Maybe<Url>;
  canChangeProductOffering: PotentialOperation2;
  canEdit: PotentialOperation2;
  programData?: Maybe<ProgramData>;
  aduProgramData?: Maybe<ProgramData>;
  rendering?: Maybe<Asset>;
  /**  Static interior rendering images for the checkout config, filtered by the selected config.  */
  interiorRenderings: Array<InteriorRoomRendering>;
  /** Returns renderings matched by selected RPO IDs. Parses filenames with format '{Type}-ids={id1}_{id2}.ext' and returns the best match per type. */
  renderings: Array<RenderingAsset>;
  /**  Stored price that calculates once. Used for listing endpoints (i.e Product Offering page)  */
  storedPriceInCents?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<User>;
  /**  Will always return package selection and whole house as the first two steps.  */
  interiorSubSteps: Array<CheckoutConfigInteriorSubStep>;
  /** Pre-computed texture swaps and camera data for InsideMaps rendering */
  insideMapsTextureSwaps?: Maybe<InsideMapsTextureSwaps>;
  insideMapsRoomRenderings: Array<InsideMapsRoomRendering>;
  homeowners: Array<Homeowner>;
  aggregateVersion?: Maybe<ReadyPlanAggregateVersion>;
  changeEvents: Array<ChangeEvent>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  useStackedPricing: Scalars['Boolean'];
  /** Main house estimated invoice schedule that distributes the MH total price pro-rata across cost code invoice categories based on the underlying cost breakdown. The persisted additionalSitePriceInCents is added after proration: 80% to Foundation and 20% to Exterior. */
  mhEstimatedInvoiceSchedule: Array<EstimatedInvoiceScheduleItem>;
  /** ADU estimated invoice schedule. Only construction phases prorated from ADU total price. */
  aduEstimatedInvoiceSchedule: Array<EstimatedInvoiceScheduleItem>;
  /** @deprecated Use mhEstimatedInvoiceSchedule and aduEstimatedInvoiceSchedule instead */
  estimatedInvoiceSchedule: Array<EstimatedInvoiceScheduleItem>;
  buildablePlans: Array<ProductOffering>;
  buildableAduPlans: Array<ProductOffering>;
  aduProductOffering?: Maybe<ProductOffering>;
  aduAggregateVersion?: Maybe<ReadyPlanAggregateVersion>;
  /**  All ADU ProductOfferings in the community that have showInCheckout enabled.  */
  potentialAdus: Array<ProductOffering>;
  isPinned: Scalars['Boolean'];
  isAduPinned: Scalars['Boolean'];
};


export type CheckoutConfigOptionGroupsArgs = {
  filter?: InputMaybe<CheckoutConfigOptionGroupFilter>;
  shallow?: InputMaybe<Scalars['Boolean']>;
  disablePackageOptions?: InputMaybe<Scalars['Boolean']>;
};


export type CheckoutConfigRenderingsArgs = {
  type: Array<ReadyPlanAssetType>;
};


export type CheckoutConfigInsideMapsTextureSwapsArgs = {
  debugParts?: InputMaybe<Array<Scalars['String']>>;
};


export type CheckoutConfigMhEstimatedInvoiceScheduleArgs = {
  additionalSitePriceInCents?: InputMaybe<Scalars['Int']>;
};


export type CheckoutConfigEstimatedInvoiceScheduleArgs = {
  additionalSitePriceInCents?: InputMaybe<Scalars['Int']>;
};

export type EstimatedInvoiceScheduleItem = {
  __typename?: 'EstimatedInvoiceScheduleItem';
  costCodeInvoiceCategory: CostCodeInvoiceCategory;
  invoiceAmountInCents: Scalars['Int'];
};

export type CheckoutConfigOptionGroupFilter = {
  rpogIds?: InputMaybe<Array<Scalars['ID']>>;
  hasDynamicProducts?: InputMaybe<Scalars['Boolean']>;
};

/**  Maps each CheckoutConfigOptionGroup to a specific step in checkout.  */
export enum CheckoutConfigOptionGroupStep {
  /**  I.e. Elevation and Exterior Design Package (exterior scheme/style)  */
  ExteriorElevation = 'EXTERIOR_ELEVATION',
  ExteriorDesignPackage = 'EXTERIOR_DESIGN_PACKAGE',
  /**  I.e. Add Bedroom, Add Bathroom, Add Garage, etc (permit changes).  */
  OptionsStructural = 'OPTIONS_STRUCTURAL',
  /**  I.e. Add Wet Bar, Add Washer & Dryer (non-permit takeoff changes).  */
  OptionsAddon = 'OPTIONS_ADDON',
  /**  I.e. Interior Design Package (interior scheme/spec level)  */
  InteriorDesignPackage = 'INTERIOR_DESIGN_PACKAGE',
  /**  I.e. Package Option & Product Option product swaps.  */
  InteriorPersonalization = 'INTERIOR_PERSONALIZATION',
  /**  I.e. All options specific to ADU locations are assigned here */
  Adu = 'ADU'
}

export type CheckoutConfigOptionGroup = PotentialOptionGroupLike & {
  __typename?: 'CheckoutConfigOptionGroup';
  id: Scalars['ID'];
  step: CheckoutConfigOptionGroupStep;
  subStepNumber?: Maybe<Scalars['Int']>;
  group: ReadyPlanOptionGroup;
  options: Array<CheckoutConfigPotentialOption>;
  selectedOption?: Maybe<CheckoutConfigPotentialOption>;
  cutoffDate?: Maybe<Scalars['Date']>;
  /**
   *  This option group is allowed to be selected if it has all necessary prerequisites met.
   * @deprecated Use canBeSelected instead.
   */
  isEnabled: Scalars['Boolean'];
  /**
   * Whether this option group can be selected, with human-readable reasons when it cannot, i.e. its
   * prerequisites are not met.
   */
  canBeSelected: PotentialOperation2;
  /**
   * Whether this option group should appear on the client-facing Home Summary
   * Lifecycle-agnostic form of showOnSummary: hides auto-applied Required Add-Ons and personalization that have been backed out
   * of the active scope, and it returns the same answer on draft and reserved/expired configs.
   */
  showOnCustomerSummary: Scalars['Boolean'];
  parentGroup?: Maybe<ReadyPlanOptionGroup>;
  childGroup?: Maybe<ReadyPlanOptionGroup>;
};

export type CheckoutConfigPotentialOption = PotentialOptionLike & {
  __typename?: 'CheckoutConfigPotentialOption';
  id: Scalars['ID'];
  option: ReadyPlanOption;
  /**  Whether this option is selected in the current checkout config.  */
  isSelected: Scalars['Boolean'];
  /**
   *  Whether this option should be shown to the user, based on the config-so-far.
   *
   * I.e. we disable options like SpecLevel=Premium based on earlier Interior/Exterior Scheme selections,
   * or InteriorScheme=Farmhouse based on earlier Elevation choices.
   * @deprecated Use canBeSelected instead.
   */
  isEnabled: Scalars['Boolean'];
  /**
   * Whether this option can be selected, with human-readable reasons when it cannot.
   *
   * Same gating as `isEnabled` (i.e. `allowed == isEnabled`), so use this when you want to tell the
   * user _why_ an option is unavailable.
   */
  canBeSelected: PotentialOperation2;
  /**
   * Whether this option should be shown on the summary.
   *
   * Normally this is true only for selected options, but optional base-config options that the
   * user has opted-opt of (i.e. they don't want Add Bedroom, so we need to reduce the price)
   * also need to be included, for the `base price +/- deltas = total price` math to work.
   */
  showOnSummary: Scalars['Boolean'];
  /**
   * The incremental price to add/remove this option.
   * When the CheckoutConfig is reserved (or expired), this price will be locked at the time of reservation.
   */
  totalPriceInCents: Scalars['Int'];
  /**  The incremental (builder) cost to add/remove this option.  */
  totalCostInCents: Scalars['Int'];
  /**  If this is a package option, e.g. Samsung Appliances, returns the unique products in slot order.  */
  packageOptionMaterials: Array<MaterialVariant>;
  primaryProduct?: Maybe<MaterialVariant>;
  displayProducts: Array<MaterialVariant>;
  includedBy?: Maybe<CheckoutConfigPotentialOption>;
  /**  if Spec 2 -> AddBedroom -> ConvertBath -> THIS, then returns spec 2 */
  includedByRoot?: Maybe<CheckoutConfigPotentialOption>;
};

export type CheckoutConfigPackageOptionSlot = {
  __typename?: 'CheckoutConfigPackageOptionSlot';
  /**  An opaque slot ID, i.e. for groupByFeature might be `Kitchen~Island~Range` or just `Kitchen~Range`.  */
  id: Scalars['ID'];
  /**  e.g., Whole House / Level 1 / Kitchen 101  */
  location: Location;
  /**  e.g., type=placeholder generic 36in fridge.  */
  materialVariant: MaterialVariant;
};

/**
 * One of the products in a package option, e.g., the Samsung Fridge SKU123 in the Samsung Appliances package option.
 *
 * Note that "the same product" might show up multiple times in a package option, i.e. if a Modern Tile package option
 * uses the same Blue tile SKU123 in multiple rooms/locations (slots).
 */
export type CheckoutConfigPackageOptionProduct = {
  __typename?: 'CheckoutConfigPackageOptionProduct';
  /**  The opaque ID of the 'cell' of slot/column x option/row.  */
  id: Scalars['ID'];
  /**
   * The slot/column id for this cell.
   *
   * Note this `slotId` should be the primary mechanism of mapping the "product SKU123 -> column/slot 36in Fridge
   * placeholder" because the mapping depends on per-RPOG flags like `groupByFeature` that mean seemingly-correct
   * "just compare by placeholder/location" heuristics may not work.
   */
  slotId: Scalars['ID'];
  /**  e.g., the type=placeholder generic 36in fridge.  */
  placeholder: MaterialVariant;
  /**  e.g., the location=Flex Room -> Interior Appliances.  */
  location: Location;
  /**  e.g., the type=product Fridge SKU1.  */
  product: MaterialVariant;
  /**  Whether this product should be displayed as a single product in checkout instead of separate package options  */
  displayPackageOptionsAsSingleProduct: Scalars['Boolean'];
};

export type SaveCheckoutConfigInput = {
  id?: InputMaybe<Scalars['ID']>;
  /**  Can only be set on create, then immutable.  */
  structureId?: InputMaybe<Scalars['ID']>;
  /**  Allow swapping plans (before structural cutoffs).  */
  productOfferingId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CheckoutConfigStatus>;
  customerEmail?: InputMaybe<Scalars['String']>;
  isReversed?: InputMaybe<Scalars['Boolean']>;
  optionIds?: InputMaybe<Array<Scalars['ID']>>;
  /** `expiresAt` is expected to be provided by the client when moving `status` to `Reserved` otherwise it will be set to 7 days from `reservedAt`. */
  expiresAt?: InputMaybe<Scalars['Date']>;
  customerFirstName?: InputMaybe<Scalars['String']>;
  customerLastName?: InputMaybe<Scalars['String']>;
  customerPhone?: InputMaybe<Scalars['String']>;
  homeownerId?: InputMaybe<Scalars['ID']>;
  /**  If true, return existing Draft config for homeowner + structure instead of creating a new one (used for QR code flow).  */
  reuseExistingConfig?: InputMaybe<Scalars['Boolean']>;
  /**  Set to true to archive, false to unarchive.  */
  archive?: InputMaybe<Scalars['Boolean']>;
  useStackedPricing?: InputMaybe<Scalars['Boolean']>;
  aduProductOfferingId?: InputMaybe<Scalars['ID']>;
  additionalSitePriceInCents?: InputMaybe<Scalars['Int']>;
};

export type SaveCheckoutConfigResult = {
  __typename?: 'SaveCheckoutConfigResult';
  checkoutConfig: CheckoutConfig;
};

export type UnreserveCheckoutConfigInput = {
  id: Scalars['ID'];
  /**  If true, preserves the expiresAt date instead of clearing it. Defaults to false.  */
  preserveExpiresAt?: InputMaybe<Scalars['Boolean']>;
};

export type SyncCheckoutConfigToVersionInput = {
  id: Scalars['ID'];
  rpavId: Scalars['ID'];
};

export type CheckoutConfigsFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  structure?: InputMaybe<Array<Scalars['ID']>>;
  productOffering?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Array<CheckoutConfigStatus>>;
  search?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Array<Scalars['ID']>>;
  /**  When false, excludes configs created by users in the 'Checkout Team Testers' user group  */
  isTechTeam?: InputMaybe<Scalars['Boolean']>;
  /**  When true, includes archived configs in the results. Defaults to false.  */
  includeArchived?: InputMaybe<Scalars['Boolean']>;
};

export type CheckoutConfigsOrder = {
  id?: InputMaybe<Order>;
  expiresAt?: InputMaybe<Order>;
  reservedAt?: InputMaybe<Order>;
  name?: InputMaybe<Order>;
  createdAt?: InputMaybe<Order>;
  structureAddress?: InputMaybe<Order>;
  customerFirstName?: InputMaybe<Order>;
};

export type CheckoutConfigsPage = {
  __typename?: 'CheckoutConfigsPage';
  entities: Array<CheckoutConfig>;
  pageInfo: PageInfo;
};

export type CheckoutPricingTraceInput = {
  /**  The ccfg to debug; we use this for the 'included' and 'selected' prices / drift calculation.  */
  checkoutConfigId: Scalars['ID'];
};

export type CheckoutPricingTrace = {
  __typename?: 'CheckoutPricingTrace';
  /**  The ccfg that drove this trace; optional b/c we might eventually support non-CCFG driven price tracing, i.e. with POCs.  */
  checkoutConfig?: Maybe<CheckoutConfig>;
  baseHousePriceInCents: Scalars['Int'];
  includedPriceInCents: Scalars['Int'];
  selectedPriceInCents: Scalars['Int'];
  optionGroups: Array<CheckoutPricingTraceOptionGroup>;
};

export type CheckoutPricingTraceOptionGroup = {
  __typename?: 'CheckoutPricingTraceOptionGroup';
  group: ReadyPlanOptionGroup;
  /**  Which option, if any, was included for this group.  */
  included?: Maybe<CheckoutPricingTraceOption>;
  /**  Which option, if any, was selected for this group.  */
  selected?: Maybe<CheckoutPricingTraceOption>;
  /**  The UW/base credit, i.e. the UW ElevationA caused $200k increase, so they can spend $200k.  */
  availableCreditInCents: Scalars['Int'];
  /**  The actual delta above their credit.  */
  priceChangeInCents: Scalars['Int'];
};

export type CheckoutPricingTraceOption = {
  __typename?: 'CheckoutPricingTraceOption';
  option?: Maybe<ReadyPlanOption>;
  /**  Full-home price with this option added.  */
  totalPriceInCents: Scalars['Int'];
  /**
   * The per-option pricing breakdown of what changed at this option group.
   *
   * For the first RPOG, this includes all groups. For subsequent RPOGs, only the current group and
   * any transitively-dirtied downstream groups whose selection or pricing changed appear here.
   *
   * Empty for groups like "Add Bedroom" that may not have a selection.
   */
  changed: Array<CheckoutPricingTraceOptionChange>;
};

export type CheckoutPricingTraceOptionChange = {
  __typename?: 'CheckoutPricingTraceOptionChange';
  group: ReadyPlanOptionGroup;
  /**  The new option (or null if the option was removed) that caused the price change at this group.  */
  option?: Maybe<ReadyPlanOption>;
  /**  The previous option (or null if an option wasn't selected).  */
  previousOption?: Maybe<ReadyPlanOption>;
  /**  The price change caused by this option.  */
  priceInCents: Scalars['Int'];
  /**  The stored/contracted price used for this option, if it overrides the calculated price.  */
  storedPriceInCents?: Maybe<Scalars['Int']>;
  /**  The cost change caused by this option.  */
  costInCents: Scalars['Int'];
  /**  The selection fee change caused by this option.  */
  selectionFeeInCents: Scalars['Int'];
  /**  The min price fee change caused by this option.  */
  minimumPriceInCents: Scalars['Int'];
};

export type CheckoutConfigInteriorSubStep = {
  __typename?: 'CheckoutConfigInteriorSubStep';
  id: Scalars['ID'];
  /**
   * Empty for the up-front Package, Whole House, and trailing Additional substeps, otherwise the room
   * like Great Room, Kitchen etc.
   */
  location?: Maybe<ReadyPlanLocation>;
  /**  'Interior Package', 'Whole House', or 'Great Room' etc.  */
  displayName: Scalars['String'];
  stepNumber: Scalars['Int'];
};

/**
 * Pre-computed texture swaps and camera data for InsideMaps rendering.
 * Replaces the need for frontend to process raw config + slot assignments.
 */
export type InsideMapsTextureSwaps = {
  __typename?: 'InsideMapsTextureSwaps';
  /** All cameras with their display info and relationships */
  cameras: Array<InsideMapsCamera>;
  /** Texture swaps grouped by camera name */
  textureSwapsByCamera: Array<InsideMapsCameraTextureSwaps>;
  /** The InsideMaps project ID needed for iframe URL */
  projectId?: Maybe<Scalars['String']>;
  /**
   * Optional debug information about slot assignments and texture changes.
   * Only populated when debug mode is enabled. Array of debug entries that can be logged.
   */
  debugSlots?: Maybe<Array<InsideMapsDebugSlot>>;
};

export type InsideMapsCamera = {
  __typename?: 'InsideMapsCamera';
  cameraName: Scalars['String'];
  displayName: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  /** Whether this is the default camera to use when no location is specified. */
  isDefault: Scalars['Boolean'];
  locationId?: Maybe<Scalars['ID']>;
  /** If this is an alternate view, the primary camera name it belongs to */
  alternateViewFor?: Maybe<Scalars['String']>;
  /** Alternate cameras for this primary camera (empty for alternate cameras) */
  alternateCameras: Array<InsideMapsCamera>;
};

export type InsideMapsCameraTextureSwaps = {
  __typename?: 'InsideMapsCameraTextureSwaps';
  cameraName: Scalars['String'];
  textureSwaps: Array<InsideMapsTextureSwap>;
};

export type InsideMapsTextureSwap = {
  __typename?: 'InsideMapsTextureSwap';
  part: Scalars['String'];
  texture: Scalars['String'];
};

/**
 * Formatted debug message string that can be logged directly to the console.
 *  Having this be an object rather than just debugSlots: [String!]! so we can add more details without breaking changes in the future (say we want to debug by camera view, etc)
 */
export type InsideMapsDebugSlot = {
  __typename?: 'InsideMapsDebugSlot';
  message: Scalars['String'];
};

export type InsideMapsSlotAuditInput = {
  productOfferingId: Scalars['ID'];
  rpavId?: InputMaybe<Scalars['ID']>;
};

export type InsideMapsSlotAuditResult = {
  __typename?: 'InsideMapsSlotAuditResult';
  /** Output a string with rows containing ${camera}.${part}.${texture} ${combo} ==> ${textureName} */
  audit: Array<Scalars['String']>;
};

export type InsideMapsSlotDiffInput = {
  productOfferingId: Scalars['ID'];
  rpavId1: Scalars['ID'];
  rpavId2: Scalars['ID'];
};

export type InsideMapsSlotDiffResult = {
  __typename?: 'InsideMapsSlotDiffResult';
  /** Get the slot audit for each version, then output only the keys that have changed/are different from rpavId1 / rpavId2 */
  diffs: Array<Scalars['String']>;
};

export type RunCheckoutPricingReportInput = {
  pofId: Scalars['String'];
  rpavId?: InputMaybe<Scalars['String']>;
  compareToRpavId?: InputMaybe<Scalars['String']>;
  onlyDeltas?: InputMaybe<Scalars['Boolean']>;
  skipCache?: InputMaybe<Scalars['Boolean']>;
};

export type RunCheckoutPricingReportResult = {
  __typename?: 'RunCheckoutPricingReportResult';
  report: TrackedJob;
};

export type CheckoutConfigOption = {
  __typename?: 'CheckoutConfigOption';
  id: Scalars['ID'];
  readyPlanOption: ReadyPlanOption;
  checkoutConfig: CheckoutConfig;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  reservedPriceInCents?: Maybe<Scalars['Int']>;
  isIncluded: Scalars['Boolean'];
  showOnSummary: Scalars['Boolean'];
  reservedCutoffDate?: Maybe<Scalars['Date']>;
  includedByCheckoutConfigOption?: Maybe<CheckoutConfigOption>;
  /**  if Spec 2 -> AddBedroom -> ConvertBath -> THIS, then returns spec 2 */
  includedByRoot?: Maybe<CheckoutConfigOption>;
};

/**
 * Note that `Homeowner` is the entity name on the backend, but it's still Client in GraphQL
 * because that would have been a large breaking API change.
 */
export type Client = Named & {
  __typename?: 'Client';
  id: Scalars['ID'];
  /**  alias of fullName for approvals and Named  */
  name: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  /**  Just last name. (I think `shortName` is from an original `displayName`-ish convention.)  */
  shortName: Scalars['String'];
  /**  First and last, if both are set.  */
  fullName: Scalars['String'];
  lastActiveAt?: Maybe<Scalars['DateTime']>;
  /** @deprecated use lastActiveAt instead */
  lastActive?: Maybe<Scalars['DateTime']>;
  address?: Maybe<Address>;
  phone?: Maybe<Scalars['String']>;
};

export type ClientInput = {
  /**  We don't include id because we use email as the primary identifier.  */
  email: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
};

export type CreateCredentialsForExistingClientInput = {
  email: Scalars['String'];
};

export type UpdateClientEmailInput = {
  id: Scalars['ID'];
  newEmail: Scalars['String'];
};

export type Cohort = Named & {
  __typename?: 'Cohort';
  id: Scalars['ID'];
  name: Scalars['String'];
  market: Market;
  projects: Array<Project>;
  developer?: Maybe<InternalUser>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  development?: Maybe<Development>;
  scopeMode: ScopeModeDetail;
  isBoolDefaultForDevelopment?: Maybe<Scalars['Boolean']>;
};

export type SaveCohortsResult = {
  __typename?: 'SaveCohortsResult';
  cohorts: Array<Cohort>;
};

export type CohortFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  developer?: InputMaybe<Array<Scalars['ID']>>;
  market?: InputMaybe<Array<Scalars['ID']>>;
  development?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveCohortsInput = {
  cohorts: Array<SaveCohortInput>;
};

export type SaveCohortInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  marketId?: InputMaybe<Scalars['ID']>;
  projectIds?: InputMaybe<Array<Scalars['ID']>>;
  developerId?: InputMaybe<Scalars['ID']>;
  developmentId?: InputMaybe<Scalars['ID']>;
  scopeMode?: InputMaybe<ScopeMode>;
  isBoolDefaultForDevelopment?: InputMaybe<Scalars['Boolean']>;
};

export type DeleteCohortInput = {
  id: Scalars['ID'];
};

/** Helper interface which implements all collaboration features */
export type CanCollaborate = {
  id: Scalars['ID'];
  name: Scalars['String'];
  blueprintUrl: Url;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
};

export type SchedulePhase = CanCollaborate & Commentable & Referencable & Followable & HasBlueprintUrl & ScheduleEntity & Named & MaybeHasInterval & MaybeHasBaselineInterval & {
  __typename?: 'SchedulePhase';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  parent: ScheduleParent;
  project?: Maybe<Project>;
  schedule: Schedule;
  interval?: Maybe<CalendarInterval>;
  baselineInterval?: Maybe<CalendarInterval>;
  blueprintUrl: Url;
  progress: SchedulePhaseProgress;
  cmsId?: Maybe<Scalars['String']>;
  scheduleSubPhases: Array<ScheduleSubPhase>;
  globalPhase: GlobalPhase;
  taskStatusRollup?: Maybe<TaskStatus>;
};


export type SchedulePhaseProgressArgs = {
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
};


export type SchedulePhaseScheduleSubPhasesArgs = {
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
};

export type ScheduleSubPhase = CanCollaborate & Commentable & Referencable & Followable & HasBlueprintUrl & ScheduleEntity & Named & MaybeHasInterval & MaybeHasBaselineInterval & {
  __typename?: 'ScheduleSubPhase';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  parent: ScheduleParent;
  project?: Maybe<Project>;
  schedule: Schedule;
  schedulePhase: SchedulePhase;
  scheduleTasks: Array<ScheduleTask>;
  globalSubPhase: GlobalSubPhase;
  blueprintUrl: Url;
  interval?: Maybe<CalendarInterval>;
  baselineInterval?: Maybe<CalendarInterval>;
  progress: ScheduleSubPhaseProgress;
  cmsId?: Maybe<Scalars['String']>;
};


export type ScheduleSubPhaseScheduleTasksArgs = {
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
};


export type ScheduleSubPhaseProgressArgs = {
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
};

export type Task = CanCollaborate & Commentable & Referencable & Followable & Named & HasBlueprintUrl & MaybeHasProject & MaybeHasInterval & {
  __typename?: 'Task';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  stage: ProjectStage;
  project?: Maybe<Project>;
  name: Scalars['String'];
  /** @deprecated All tasks now behave as user created. */
  userCreated: Scalars['Boolean'];
  status: TaskStatusDetail;
  homeownerVisible: Scalars['Boolean'];
  homeownerDescription?: Maybe<Scalars['String']>;
  interval: CalendarInterval;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  baselineInterval: CalendarInterval;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  baselineInterval2?: Maybe<CalendarInterval2>;
  completedAt?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
  assignee?: Maybe<InternalUser>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  internalNote?: Maybe<Scalars['String']>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  cmsId: Scalars['String'];
  slackInDays?: Maybe<Scalars['Int']>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  aheadOrBehindInDays?: Maybe<Scalars['Int']>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  isStale: Scalars['Boolean'];
  isCriticalPath: Scalars['Boolean'];
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  predecessors: Array<Task>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  successors: Array<Task>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  predecessorDependencies: Array<TaskDependency>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  successorDependencies: Array<TaskDependency>;
  homeownerContractDraws: Array<HomeownerContractDraw>;
  isManuallyScheduled: Scalars['Boolean'];
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  isBaselineManuallyScheduled?: Maybe<Scalars['Boolean']>;
  blueprintUrl: Url;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  isMilestone: Scalars['Boolean'];
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  salesforceId?: Maybe<Scalars['String']>;
  tradePartner?: Maybe<TradePartner>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  canEditStartDate: PotentialOperation2;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  canEditEndDate: PotentialOperation2;
  /**
   *  Convenience operation which is a logical OR of canEditStartDate || canEditEndDate
   * @deprecated Legacy attribute, will only be available on ScheduleTask going forward.
   */
  canEditDuration: PotentialOperation2;
  canComplete: PotentialOperation2;
  canStart: PotentialOperation2;
  canDelete: PotentialOperation2;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  canSetTraderPartner: PotentialOperation2;
  projectItems: Array<ProjectItem>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  deadlineType?: Maybe<TaskDeadlineType>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  deadlineTypeDetail?: Maybe<TaskDeadlineTypeDetail>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  templateProjectRole?: Maybe<ProjectRole>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  templateProjectRoleDetail?: Maybe<ProjectRoleDetail>;
  documents: Array<Document>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  globalTask?: Maybe<GlobalTask>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  isGlobalMilestoneTask: Scalars['Boolean'];
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  scheduleTemplateItemMappings: Array<ScheduleTemplateItemMapping>;
  requiredTaskDocuments: Array<RequiredTaskDocument>;
  scheduleTaskChecklistItems: Array<ScheduleTaskChecklistItem>;
  scheduleFlags: Array<ScheduleFlag>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  jobLogNotes: Array<JobLogNote>;
  /** @deprecated Use tradePartnerStatus instead */
  tradePartnerIsScheduled?: Maybe<Scalars['Boolean']>;
  hasScheduleFlags: Scalars['Boolean'];
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  systemTask?: Maybe<SystemTask>;
  tradePartners: Array<TradePartner>;
  committedTradePartners: Array<TradePartner>;
  billLineItems: Array<BillLineItem>;
  defaultedHomeownerDescription: Scalars['String'];
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  templateTask?: Maybe<Task>;
  tradePartnerStatus: TradePartnerTaskStatusDetail;
  tradePartnerAvailabilityRequests?: Maybe<Array<TradePartnerAvailabilityRequest>>;
  depositCommitments: Array<Commitment>;
  type: TaskTypeDetail;
  workDays: Array<TaskWorkDay>;
  commitmentDraws: Array<CommitmentDraw>;
  protoBills: Array<ProtoBill>;
  checklistComplete?: Maybe<Scalars['Boolean']>;
  schedule: ScheduleLike;
};

export type ScheduleTask = CanCollaborate & Commentable & Referencable & Followable & Entity & HasBlueprintUrl & ScheduleEntity & Named & MaybeHasInterval & MaybeHasBaselineInterval & {
  __typename?: 'ScheduleTask';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  globalPhase?: Maybe<GlobalPhase>;
  globalSubPhase?: Maybe<GlobalSubPhase>;
  schedulePhase?: Maybe<SchedulePhase>;
  scheduleSubPhase?: Maybe<ScheduleSubPhase>;
  schedule: Schedule;
  parent: ScheduleParent;
  project?: Maybe<Project>;
  name: Scalars['String'];
  status: TaskStatus;
  statusDetail: TaskStatusDetail;
  schedulingStatus: TaskSchedulingStatus;
  homeownerVisible: Scalars['Boolean'];
  homeownerDescription?: Maybe<Scalars['String']>;
  interval: CalendarInterval;
  /**  Prefer baselineInterval2 for better handling of undefined baselines.  */
  baselineInterval: CalendarInterval;
  baselineInterval2?: Maybe<CalendarInterval2>;
  completedAt?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
  assignee?: Maybe<InternalUser>;
  internalNote?: Maybe<Scalars['String']>;
  slackInDays?: Maybe<Scalars['Int']>;
  aheadOrBehindInDays?: Maybe<Scalars['Int']>;
  isStale: Scalars['Boolean'];
  isCriticalPath: Scalars['Boolean'];
  predecessors: Array<ScheduleTask>;
  successors: Array<ScheduleTask>;
  predecessorDependencies: Array<ScheduleTaskDependency>;
  successorDependencies: Array<ScheduleTaskDependency>;
  homeownerContractDraws: Array<HomeownerContractDraw>;
  blueprintUrl: Url;
  salesforceId?: Maybe<Scalars['String']>;
  tradePartner?: Maybe<TradePartner>;
  canEditStartDate: PotentialOperation2;
  canEditEndDate: PotentialOperation2;
  /**  Convenience operation which is a logical OR of canEditStartDate || canEditEndDate  */
  canEditDuration: PotentialOperation2;
  canComplete: PotentialOperation2;
  canStart: PotentialOperation2;
  canDelete: PotentialOperation2;
  canSetTraderPartner: PotentialOperation2;
  projectItems: Array<ProjectItem>;
  deadlineType?: Maybe<TaskDeadlineType>;
  templateProjectRole?: Maybe<ProjectRole>;
  documents: Array<Document>;
  globalTask?: Maybe<GlobalTask>;
  isGlobalMilestoneTask: Scalars['Boolean'];
  sortOrder: Scalars['Int'];
  requiredTaskDocuments: Array<RequiredTaskDocument>;
  history: Array<History>;
  scheduleTaskChecklistItems: Array<ScheduleTaskChecklistItem>;
  scheduleFlags: Array<ScheduleFlag>;
  jobLogNotes: Array<JobLogNote>;
  /** @deprecated Use tradePartnerStatus instead */
  tradePartnerIsScheduled?: Maybe<Scalars['Boolean']>;
  /** Null if there are no checklist items, true if all checklist items are complete, false otherwise */
  checklistComplete?: Maybe<Scalars['Boolean']>;
  hasScheduleFlags: Scalars['Boolean'];
  systemTask?: Maybe<SystemTask>;
  bills: Array<Bill>;
  tradePartners: Array<TradePartner>;
  /** Note: this is the sub-set of tradePartners that are signed */
  committedTradePartners: Array<TradePartner>;
  billLineItems: Array<BillLineItem>;
  defaultedHomeownerDescription: Scalars['String'];
  templateTask?: Maybe<Task>;
  tradePartnerStatus: TradePartnerTaskStatusDetail;
  tradePartnerAvailabilityRequests?: Maybe<Array<TradePartnerAvailabilityRequest>>;
  protoBills: Array<ProtoBill>;
  type: TaskTypeDetail;
  workDays: Array<TaskWorkDay>;
  commitmentDraws: Array<CommitmentDraw>;
};

export type PlanTask = CanCollaborate & Commentable & Referencable & Followable & Entity & HasBlueprintUrl & Named & {
  __typename?: 'PlanTask';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  durationInDays: Scalars['Int'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  completedAt?: Maybe<Scalars['DateTime']>;
  slackInDays?: Maybe<Scalars['Int']>;
  /** NOTE: `PlanTask` critical path is expanded to be `slackInDays <= 3` compared to `Task` critical path of `slackInDays === 0` */
  isCriticalPath: Scalars['Boolean'];
  homeownerVisible?: Maybe<Scalars['Boolean']>;
  status: TaskStatusDetail;
  type: TaskTypeDetail;
  sortOrder: Scalars['Int'];
  internalUser?: Maybe<InternalUser>;
  blueprintUrl: Url;
  schedule: PlanSchedule;
  globalPlanTask: GlobalPlanTask;
  /** A filtered subset of `globalPlanTask.checklistItems` that are required for this based on its completion date. */
  globalChecklistItems: Array<GlobalPlanTaskChecklistItem>;
  checklistItems: Array<PlanTaskChecklistItem>;
  requiredTaskDocuments: Array<RequiredTaskDocument>;
  documents: Array<Document>;
  history: Array<History>;
  earliestStartDate?: Maybe<Scalars['Date']>;
  knownDurationInDays?: Maybe<Scalars['Int']>;
  isManuallyScheduled?: Maybe<Scalars['Boolean']>;
  canStart: PotentialOperation2;
  canComplete: PotentialOperation2;
  canDeleteWithWarning: PotentialOperation2;
  canDelete: PotentialOperation2;
  canSetTraderPartner: PotentialOperation2;
  /**
   * Lists `GlobalPlanConstraintItems` that constrain this task.
   * Prefer this attribute vs. `globalTask.constraints` as this PlanTask may have market-specific overrides
   */
  constraintItems: Array<GlobalPlanConstraintItem>;
  /**
   * Lists `GlobalPlanConstraintItems` that allow this task.
   * Prefer this attribute vs. `globalTask.allowances` as this PlanTask may have market-specific overrides
   */
  allowanceItems: Array<GlobalPlanConstraintItem>;
  tradePartner?: Maybe<TradePartner>;
  tradePartners: Array<TradePartner>;
  /** Note: this is the sub-set of tradePartners that are signed */
  committedTradePartners: Array<TradePartner>;
  billLineItems: Array<BillLineItem>;
  tradePartnerStatus: TradePartnerTaskStatusDetail;
  tradePartnerAvailabilityRequests?: Maybe<Array<TradePartnerAvailabilityRequest>>;
  simulationProbability: SimulationProbability;
  scheduleFlags: Array<ScheduleFlag>;
  ignoredConstraintsOnTaskEnd: Array<GlobalPlanConstraintItem>;
  ignoredConstraintsOnTaskStart: Array<GlobalPlanConstraintItem>;
  workDays: Array<TaskWorkDay>;
  workingDaysProgress: Scalars['Int'];
  projectItems: Array<ProjectItem>;
  isStale: Scalars['Boolean'];
  isHiddenFromSchedule: Scalars['Boolean'];
  stage?: Maybe<GlobalPlanStage>;
  commitmentDraws: Array<CommitmentDraw>;
  protoBills: Array<ProtoBill>;
  taskPurchaseOrders: Array<TaskPurchaseOrderRow>;
  /** Defaults to Monday - Friday even if `customWorkableDaysOfWeek` is not set */
  customWorkableDays: Array<DayOfWeek>;
  /** PlanMilestones that this task contributes to via its 'allowances' */
  allowsPlanMilestones: Array<PlanMilestone>;
  knownSchedulingContacts: Array<TradePartnerContact>;
};

export type ToDo = CanCollaborate & Commentable & Referencable & Followable & HasBlueprintUrl & Named & {
  __typename?: 'ToDo';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  blueprintUrl: Url;
  description?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  dueDate?: Maybe<Scalars['Date']>;
  order: Scalars['String'];
  status: ToDoStatusDetail;
  type: ToDoTypeDetail;
  parent?: Maybe<ToDoParent>;
  createdBy: User;
  /** @deprecated Use assignees instead */
  assignee?: Maybe<User>;
  assignees: Array<User>;
  attachments: Array<Attachment>;
  urgent: Scalars['Boolean'];
  checklistItems: Array<ToDoChecklistItem>;
  checklistProgress: ToDoChecklistProgress;
  changeRequest?: Maybe<ChangeRequest>;
};

export type Invoice = CanCollaborate & Commentable & Referencable & Followable & HasBlueprintUrl & Named & MaybeHasProject & {
  __typename?: 'Invoice';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  invoiceDate: Scalars['Date'];
  dueDate: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  quickbooksId?: Maybe<Scalars['String']>;
  amountInCents: Scalars['Int'];
  accruedAmountInCents: Scalars['Int'];
  balanceInCents: Scalars['Int'];
  amountPaidInCents: Scalars['Int'];
  projectStage: ProjectStage;
  lineItems: Array<InvoiceLineItem>;
  lineItemsByCostCode: Array<InvoiceLineItemsByCostCode>;
  drawLineItems: Array<InvoiceDrawLineItem>;
  quickbooksPullOnly: Scalars['Boolean'];
  document?: Maybe<Document>;
  invoiceNumber: Scalars['String'];
  isHistoricalInvoiceNumber: Scalars['Boolean'];
  /** @deprecated Use `type == TRUE_UP` instead. */
  isFinalInvoice: Scalars['Boolean'];
  history: Array<History>;
  blueprintUrl: Url;
  project: Project;
  intacctAmountPaidInCents: Scalars['Int'];
  documents: Array<InvoiceDocument>;
  quickbooksAmountPaidInCents: Scalars['Int'];
  intacctSyncError?: Maybe<Scalars['String']>;
  approval?: Maybe<Approval>;
  status: InvoiceStatusDetail;
  lineItemCutoffDate?: Maybe<Scalars['Date']>;
  lineItemStartDate?: Maybe<Scalars['Date']>;
  predictedApprovers: Array<ApproverUser>;
  paidDate?: Maybe<Scalars['Date']>;
  creditForInvoice?: Maybe<Invoice>;
  shouldSyncToIntacct: Scalars['Boolean'];
  intacctId?: Maybe<Scalars['String']>;
  type: InvoiceTypeDetail;
  canEdit: PotentialOperation2;
  canDelete: PotentialOperation2;
  pandaDocs: Array<PandaDoc>;
  scheduledLineItems: Array<InvoiceScheduledLineItem>;
  accruedLineItems: Array<InvoiceAccruedLineItem>;
  /**
   * A unified view of all invoice line items (InvoiceLineItem, InvoiceDrawLineItem, InvoiceScheduledLineItem, InvoiceAccruedLineItem)
   * normalized into a single structure for UI display purposes (Pdf / Invoice / ERP).
   */
  displayLineItems: Array<InvoiceDisplayLineItem>;
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  isHistorical: Scalars['Boolean'];
  parent?: Maybe<InvoiceParent>;
  source: InvoiceSourceDetail;
  remainingDownPaymentInCents: Scalars['Int'];
  downPaymentConsumingLineItems: Array<InvoiceLineItem>;
  pocInvoicedToDateInCents: Scalars['Int'];
  contractPriceSnapshotInCents: Scalars['Int'];
};


export type InvoiceDisplayLineItemsArgs = {
  mode?: InputMaybe<InvoiceDisplayLineItemMode>;
};

export type Project = {
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  collaborators: Array<ProjectCollaborator>;
  coverImage?: Maybe<Asset>;
  buildAddress?: Maybe<Address>;
  market?: Maybe<Market>;
  teamMembers: Array<ProjectTeamMember>;
  projectLead?: Maybe<ProjectTeamMember>;
  activeStage: StageDetail;
  activeProjectStage?: Maybe<ProjectStage>;
  stages: Array<ProjectStage>;
  stage: ProjectStage;
  blueprintUrl: Url;
  hopUrl: Scalars['String'];
  /**  The address + client name  */
  name: Scalars['String'];
  displayName: Scalars['String'];
  availableAssignees: Array<InternalUser>;
  startDate: Scalars['Date'];
  /**  list of features which are enabled on this project  */
  features: Array<ProjectFeature>;
  isTest: Scalars['Boolean'];
  status: ProjectStatusDetail;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  project?: Maybe<Project>;
  googleDriveFolderId?: Maybe<Scalars['String']>;
  salesforceAccountId?: Maybe<Scalars['String']>;
  salesforceOpportunities: Array<ProjectSalesforceOpportunity>;
  projectStatusChange?: Maybe<ProjectStatusChange>;
  planRoomLink?: Maybe<Scalars['String']>;
  isDisaster?: Maybe<Scalars['Boolean']>;
  intakeStyleNotes?: Maybe<Scalars['String']>;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  productType?: Maybe<ProductType>;
  enableSchedulesV2: Scalars['Boolean'];
  tradePartners: Array<TradePartner>;
  jobLogs: Array<JobLog>;
  salesforcePropertyId?: Maybe<Scalars['String']>;
  schedules: Array<Schedule>;
  expenses: Array<Expense>;
  unallocatedExpenses: Array<Expense>;
  unallocatedAmountInCents: Scalars['Int'];
  enableSchedulesV2Gantt: Scalars['Boolean'];
  enableSchedulesCalendar: Scalars['Boolean'];
  readyPlanConfig?: Maybe<ProjectReadyPlanConfig>;
  earnedValueCurves: Array<EarnedValueCurve>;
  invoiceSettings?: Maybe<ProjectInvoiceSetting>;
  scopeMode: ScopeModeDetail;
  lotPartitionId?: Maybe<Scalars['String']>;
  budgetFinancials: ProjectBudgetFinancials;
  enableDelayFlags: Scalars['Boolean'];
  warrantyStartDate?: Maybe<Scalars['Date']>;
  warrantyEndDate?: Maybe<Scalars['Date']>;
  verticalCompleteDate?: Maybe<Scalars['Date']>;
  jobLogInsights: ProjectJobLogInsights;
  targetEndDate?: Maybe<Scalars['Date']>;
  latestActiveStage?: Maybe<ProjectStage>;
  primaryHomeowner?: Maybe<Client>;
  toDos?: Maybe<Array<ToDo>>;
  lotDetail: ProjectLotDetail;
  siteSpecificInfos: Array<ProjectSiteSpecificInfo>;
  projectSiteCondition?: Maybe<ProjectSiteCondition>;
  unassignedTaskCount: Scalars['Int'];
  enableHomeownerNotes: Scalars['Boolean'];
  checkoutCustomerConfigId?: Maybe<Scalars['String']>;
  canEditJobLogs: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  canHaveBudget: PotentialOperation2;
  homeownerNotes: Array<HomeownerNote>;
  enableHomeownerJourneyV2: Scalars['Boolean'];
  featureFlags: Array<FeatureFlag>;
  homeownerDeliveryDate?: Maybe<Scalars['Date']>;
  tasksCompletedThisWeek: Scalars['Int'];
  contacts: Array<ProjectContact>;
  warrantyTickets: Array<WarrantyTicket>;
  shouldAccrueAsComplete: Scalars['Boolean'];
  directCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']>;
  indirectCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']>;
  customer?: Maybe<Customer>;
  customerOwnerEntity?: Maybe<CustomerOwnerEntity>;
  invoiceSchedule?: Maybe<InvoiceSchedule>;
  allowExcludedCostCodesOnPurchaseOrders: Scalars['Boolean'];
  enableProductConfigPlan: Scalars['Boolean'];
  planSchedule?: Maybe<PlanSchedule>;
  builder?: Maybe<Builder>;
  bidOutPercentage: Scalars['Int'];
  enableChangeEventSignatures: Scalars['Boolean'];
  enablePocInvoiceSchedule: Scalars['Boolean'];
  enableBidPackagesV2: Scalars['Boolean'];
  softCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  indirectHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  directHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  legalDescription?: Maybe<Scalars['String']>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']>;
  salesTaxInBasisPoints: Scalars['Int'];
  projectItemAllocations: Array<ProjectItemAllocation>;
  allocationRules: Array<ProjectAllocationRule>;
  warrantyLengthInDays: Scalars['Int'];
  warrantyOverrideLengthInDays?: Maybe<Scalars['Int']>;
  bidPackages: Array<BidPackage>;
  bidContracts: Array<BidContract>;
  homeownerContracts: Array<HomeownerContract>;
  documents: Array<Document>;
  commitments: Array<Commitment>;
  directCostInCents: Scalars['Int'];
  directPriceInCents: Scalars['Int'];
  totalHardCostInCents: Scalars['Int'];
  totalSoftCostInCents: Scalars['Int'];
  totalCostInCents: Scalars['Int'];
  totalPriceInCents: Scalars['Int'];
  readyToStartDate?: Maybe<Scalars['Date']>;
  committedCostCodesAtStartInBasisPoints?: Maybe<Scalars['Int']>;
  directCostAtStartInCents?: Maybe<Scalars['Int']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']>;
  uncommittedCostInCents: Scalars['Int'];
  snapshots: Array<ProjectSnapshot>;
  companyInfo: CompanyInfo;
  invoicePaymentNetDays: Scalars['Int'];
  /**  return the first snapshot before or on the given date  */
  snapshotAsOf?: Maybe<ProjectSnapshot>;
  purchaseCostInCents?: Maybe<Scalars['Int']>;
  grossSalesPriceInCents?: Maybe<Scalars['Int']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']>;
  projectCostCodes: Array<ProjectCostCode>;
  /** Hierarchy Navigation */
  parent?: Maybe<Project>;
  children: Array<Project>;
  parentsRecursive: Array<Project>;
  childrenRecursive: Array<Project>;
  siblingProjects: Array<Project>;
  sellableProjects: Array<Project>;
  isSellableProject: Scalars['Boolean'];
  /** Hierarchy Budget Page Fields */
  originalCostInCents: Scalars['Int'];
  startCostInCents: Scalars['Int'];
  changeEventCostInCents: Scalars['Int'];
  projectedCostInCents: Scalars['Int'];
  revisedCostInCents: Scalars['Int'];
  committedCostInCents: Scalars['Int'];
  availableCostInCents: Scalars['Int'];
  billedCostInCents: Scalars['Int'];
  unbilledCostInCents: Scalars['Int'];
  /**
   * Deprecated fields for StandaloneProject. Do not add new fields below this.
   * @deprecated only implemented for StandaloneProject
   */
  cohort?: Maybe<Cohort>;
  /** @deprecated only implemented for StandaloneProject */
  constructionConfidenceFactor?: Maybe<Scalars['Int']>;
  /** @deprecated only implemented for StandaloneProject */
  lotRating?: Maybe<LotRating>;
  /** @deprecated only implemented for StandaloneProject */
  preConBudgetLineItems: Array<PreConBudgetCostDivisionLineItem>;
  /** @deprecated only implemented for StandaloneProject */
  preconContractType?: Maybe<PreconContractType>;
  /** @deprecated only implemented for StandaloneProject and Structure */
  primaryProject?: Maybe<Project>;
  /** @deprecated only implemented for StandaloneProject */
  quickbooksCustomerId?: Maybe<Scalars['String']>;
  /** @deprecated only implemented for StandaloneProject */
  shadowProjects: Array<Project>;
  /** @deprecated only implemented for StandaloneProject */
  submarket?: Maybe<Submarket>;
  /**
   * Deprecated fields. Do not add new fields below this.
   * @deprecated homeowner can be accessed through collaborators
   */
  client?: Maybe<Client>;
  /** @deprecated replaced by blueprintUrl */
  url: Scalars['String'];
  /**
   *  The same as name, just a previous name.
   * @deprecated replaced by name.
   */
  projectName: Scalars['String'];
  /** @deprecated replaced by activeSalesforceOpportunity */
  salesforceId?: Maybe<Scalars['String']>;
  /** @deprecated This field is being removed from our SFDC data model */
  activeSalesforceOpportunity?: Maybe<ProjectSalesforceOpportunity>;
  /** @deprecated use lotType instead */
  dictionary: ProjectDictionary;
};


export type ProjectTeamMembersArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']>;
};


export type ProjectStagesArgs = {
  stage?: InputMaybe<Stage>;
  filter?: InputMaybe<ProjectStagesFilter>;
};


export type ProjectStageArgs = {
  stage: Stage;
};


export type ProjectAvailableAssigneesArgs = {
  role?: InputMaybe<ProjectRole>;
};


export type ProjectToDosArgs = {
  type?: InputMaybe<ToDoType>;
};


export type ProjectDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};


export type ProjectSnapshotAsOfArgs = {
  date: Scalars['Date'];
};


export type ProjectOriginalCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type ProjectStartCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type ProjectChangeEventCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type ProjectProjectedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type ProjectRevisedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type ProjectCommittedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type ProjectAvailableCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type ProjectBilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type ProjectUnbilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type ProjectPreConBudgetLineItemsArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']>;
};

export type StandaloneProject = CanCollaborate & Commentable & Referencable & Followable & Project & HasBlueprintUrl & Named & HasDisplayName & MaybeHasProject & HasSchedules & Entity & HasHopUrl & MaybeHasPropcoUrl & {
  __typename?: 'StandaloneProject';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Overridden fields from Project */
  buildAddress: Address;
  market: Market;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  project: Project;
  cohort?: Maybe<Cohort>;
  constructionConfidenceFactor?: Maybe<Scalars['Int']>;
  lotRating?: Maybe<LotRating>;
  preConBudgetLineItems: Array<PreConBudgetCostDivisionLineItem>;
  preconContractType?: Maybe<PreconContractType>;
  primaryProject?: Maybe<Project>;
  quickbooksCustomerId?: Maybe<Scalars['String']>;
  shadowProjects: Array<Project>;
  submarket?: Maybe<Submarket>;
  /** Inherited fields from Project */
  collaborators: Array<ProjectCollaborator>;
  coverImage?: Maybe<Asset>;
  teamMembers: Array<ProjectTeamMember>;
  projectLead?: Maybe<ProjectTeamMember>;
  activeStage: StageDetail;
  activeProjectStage?: Maybe<ProjectStage>;
  stages: Array<ProjectStage>;
  stage: ProjectStage;
  blueprintUrl: Url;
  hopUrl: Scalars['String'];
  propcoUrl?: Maybe<Scalars['String']>;
  /**  The address + client name  */
  name: Scalars['String'];
  displayName: Scalars['String'];
  availableAssignees: Array<InternalUser>;
  startDate: Scalars['Date'];
  /**  list of features which are enabled on this project  */
  features: Array<ProjectFeature>;
  isTest: Scalars['Boolean'];
  status: ProjectStatusDetail;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  googleDriveFolderId?: Maybe<Scalars['String']>;
  salesforceAccountId?: Maybe<Scalars['String']>;
  salesforceOpportunities: Array<ProjectSalesforceOpportunity>;
  projectStatusChange?: Maybe<ProjectStatusChange>;
  planRoomLink?: Maybe<Scalars['String']>;
  isDisaster?: Maybe<Scalars['Boolean']>;
  intakeStyleNotes?: Maybe<Scalars['String']>;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  productType?: Maybe<ProductType>;
  enableSchedulesV2: Scalars['Boolean'];
  tradePartners: Array<TradePartner>;
  jobLogs: Array<JobLog>;
  salesforcePropertyId?: Maybe<Scalars['String']>;
  schedules: Array<Schedule>;
  expenses: Array<Expense>;
  unallocatedExpenses: Array<Expense>;
  unallocatedAmountInCents: Scalars['Int'];
  enableSchedulesV2Gantt: Scalars['Boolean'];
  enableSchedulesCalendar: Scalars['Boolean'];
  readyPlanConfig?: Maybe<ProjectReadyPlanConfig>;
  earnedValueCurves: Array<EarnedValueCurve>;
  enableBidPackagesV2: Scalars['Boolean'];
  invoiceSettings?: Maybe<ProjectInvoiceSetting>;
  scopeMode: ScopeModeDetail;
  lotPartitionId?: Maybe<Scalars['String']>;
  budgetFinancials: ProjectBudgetFinancials;
  enableDelayFlags: Scalars['Boolean'];
  warrantyStartDate?: Maybe<Scalars['Date']>;
  verticalCompleteDate?: Maybe<Scalars['Date']>;
  jobLogInsights: ProjectJobLogInsights;
  targetEndDate?: Maybe<Scalars['Date']>;
  latestActiveStage?: Maybe<ProjectStage>;
  primaryHomeowner?: Maybe<Client>;
  toDos?: Maybe<Array<ToDo>>;
  lotDetail: ProjectLotDetail;
  siteSpecificInfos: Array<ProjectSiteSpecificInfo>;
  projectSiteCondition?: Maybe<ProjectSiteCondition>;
  unassignedTaskCount: Scalars['Int'];
  enableHomeownerNotes: Scalars['Boolean'];
  checkoutCustomerConfigId?: Maybe<Scalars['String']>;
  canEditJobLogs: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  canHaveBudget: PotentialOperation2;
  homeownerNotes: Array<HomeownerNote>;
  enableHomeownerJourneyV2: Scalars['Boolean'];
  featureFlags: Array<FeatureFlag>;
  homeownerDeliveryDate?: Maybe<Scalars['Date']>;
  tasksCompletedThisWeek: Scalars['Int'];
  contacts: Array<ProjectContact>;
  warrantyTickets: Array<WarrantyTicket>;
  shouldAccrueAsComplete: Scalars['Boolean'];
  directCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']>;
  indirectCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']>;
  customer?: Maybe<Customer>;
  customerOwnerEntity?: Maybe<CustomerOwnerEntity>;
  invoiceSchedule?: Maybe<InvoiceSchedule>;
  allowExcludedCostCodesOnPurchaseOrders: Scalars['Boolean'];
  enableProductConfigPlan: Scalars['Boolean'];
  planSchedule?: Maybe<PlanSchedule>;
  builder?: Maybe<Builder>;
  bidOutPercentage: Scalars['Int'];
  enableChangeEventSignatures: Scalars['Boolean'];
  enablePocInvoiceSchedule: Scalars['Boolean'];
  softCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  indirectHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  directHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  legalDescription?: Maybe<Scalars['String']>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']>;
  salesTaxInBasisPoints: Scalars['Int'];
  projectItemAllocations: Array<ProjectItemAllocation>;
  allocationRules: Array<ProjectAllocationRule>;
  warrantyLengthInDays: Scalars['Int'];
  warrantyOverrideLengthInDays?: Maybe<Scalars['Int']>;
  bidPackages: Array<BidPackage>;
  bidContracts: Array<BidContract>;
  homeownerContracts: Array<HomeownerContract>;
  documents: Array<Document>;
  commitments: Array<Commitment>;
  directCostInCents: Scalars['Int'];
  directPriceInCents: Scalars['Int'];
  totalHardCostInCents: Scalars['Int'];
  totalSoftCostInCents: Scalars['Int'];
  totalCostInCents: Scalars['Int'];
  totalPriceInCents: Scalars['Int'];
  readyToStartDate?: Maybe<Scalars['Date']>;
  committedCostCodesAtStartInBasisPoints?: Maybe<Scalars['Int']>;
  directCostAtStartInCents?: Maybe<Scalars['Int']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']>;
  uncommittedCostInCents: Scalars['Int'];
  snapshots: Array<ProjectSnapshot>;
  warrantyEndDate?: Maybe<Scalars['Date']>;
  companyInfo: CompanyInfo;
  invoicePaymentNetDays: Scalars['Int'];
  /**  return the first snapshot before or on the given date  */
  snapshotAsOf?: Maybe<ProjectSnapshot>;
  purchaseCostInCents?: Maybe<Scalars['Int']>;
  grossSalesPriceInCents?: Maybe<Scalars['Int']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']>;
  projectCostCodes: Array<ProjectCostCode>;
  /** Hierarchy Navigation */
  parent?: Maybe<Project>;
  children: Array<Project>;
  parentsRecursive: Array<Project>;
  childrenRecursive: Array<Project>;
  siblingProjects: Array<Project>;
  sellableProjects: Array<Project>;
  isSellableProject: Scalars['Boolean'];
  /** Hierarchy Budget Page Fields */
  originalCostInCents: Scalars['Int'];
  startCostInCents: Scalars['Int'];
  changeEventCostInCents: Scalars['Int'];
  projectedCostInCents: Scalars['Int'];
  revisedCostInCents: Scalars['Int'];
  committedCostInCents: Scalars['Int'];
  availableCostInCents: Scalars['Int'];
  billedCostInCents: Scalars['Int'];
  unbilledCostInCents: Scalars['Int'];
  /**
   * Deprecated fields. Do not add new fields below this.
   * @deprecated homeowner can be accessed through collaborators
   */
  client?: Maybe<Client>;
  /** @deprecated replaced by blueprintUrl */
  url: Scalars['String'];
  /**
   *  The same as name, just a previous name.
   * @deprecated replaced by name.
   */
  projectName: Scalars['String'];
  /** @deprecated replaced by activeSalesforceOpportunity */
  salesforceId?: Maybe<Scalars['String']>;
  /** @deprecated This field is being removed from our SFDC data model */
  activeSalesforceOpportunity?: Maybe<ProjectSalesforceOpportunity>;
  /** @deprecated use lotType instead */
  dictionary: ProjectDictionary;
};


export type StandaloneProjectPreConBudgetLineItemsArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']>;
};


export type StandaloneProjectTeamMembersArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']>;
};


export type StandaloneProjectStagesArgs = {
  stage?: InputMaybe<Stage>;
  filter?: InputMaybe<ProjectStagesFilter>;
};


export type StandaloneProjectStageArgs = {
  stage: Stage;
};


export type StandaloneProjectAvailableAssigneesArgs = {
  role?: InputMaybe<ProjectRole>;
};


export type StandaloneProjectToDosArgs = {
  type?: InputMaybe<ToDoType>;
};


export type StandaloneProjectDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};


export type StandaloneProjectSnapshotAsOfArgs = {
  date: Scalars['Date'];
};


export type StandaloneProjectOriginalCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StandaloneProjectStartCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StandaloneProjectChangeEventCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StandaloneProjectProjectedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StandaloneProjectRevisedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StandaloneProjectCommittedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StandaloneProjectAvailableCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StandaloneProjectBilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StandaloneProjectUnbilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};

export type Region = CanCollaborate & Commentable & Referencable & Followable & Project & HasBlueprintUrl & Named & HasDisplayName & MaybeHasProject & HasSchedules & Entity & HasHopUrl & {
  __typename?: 'Region';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Region specific fields */
  abbreviation: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Overridden fields from Project */
  children: Array<Market>;
  /** Inherited fields from Project */
  collaborators: Array<ProjectCollaborator>;
  coverImage?: Maybe<Asset>;
  buildAddress?: Maybe<Address>;
  market?: Maybe<Market>;
  teamMembers: Array<ProjectTeamMember>;
  projectLead?: Maybe<ProjectTeamMember>;
  activeStage: StageDetail;
  activeProjectStage?: Maybe<ProjectStage>;
  stages: Array<ProjectStage>;
  stage: ProjectStage;
  blueprintUrl: Url;
  hopUrl: Scalars['String'];
  /**  The address + client name  */
  name: Scalars['String'];
  displayName: Scalars['String'];
  availableAssignees: Array<InternalUser>;
  startDate: Scalars['Date'];
  /**  list of features which are enabled on this project  */
  features: Array<ProjectFeature>;
  isTest: Scalars['Boolean'];
  status: ProjectStatusDetail;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  project?: Maybe<Project>;
  googleDriveFolderId?: Maybe<Scalars['String']>;
  salesforceAccountId?: Maybe<Scalars['String']>;
  salesforceOpportunities: Array<ProjectSalesforceOpportunity>;
  projectStatusChange?: Maybe<ProjectStatusChange>;
  planRoomLink?: Maybe<Scalars['String']>;
  isDisaster?: Maybe<Scalars['Boolean']>;
  intakeStyleNotes?: Maybe<Scalars['String']>;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  productType?: Maybe<ProductType>;
  enableSchedulesV2: Scalars['Boolean'];
  tradePartners: Array<TradePartner>;
  jobLogs: Array<JobLog>;
  salesforcePropertyId?: Maybe<Scalars['String']>;
  schedules: Array<Schedule>;
  expenses: Array<Expense>;
  unallocatedExpenses: Array<Expense>;
  unallocatedAmountInCents: Scalars['Int'];
  enableSchedulesV2Gantt: Scalars['Boolean'];
  enableSchedulesCalendar: Scalars['Boolean'];
  readyPlanConfig?: Maybe<ProjectReadyPlanConfig>;
  earnedValueCurves: Array<EarnedValueCurve>;
  enableBidPackagesV2: Scalars['Boolean'];
  invoiceSettings?: Maybe<ProjectInvoiceSetting>;
  scopeMode: ScopeModeDetail;
  lotPartitionId?: Maybe<Scalars['String']>;
  budgetFinancials: ProjectBudgetFinancials;
  enableDelayFlags: Scalars['Boolean'];
  warrantyStartDate?: Maybe<Scalars['Date']>;
  verticalCompleteDate?: Maybe<Scalars['Date']>;
  jobLogInsights: ProjectJobLogInsights;
  targetEndDate?: Maybe<Scalars['Date']>;
  latestActiveStage?: Maybe<ProjectStage>;
  primaryHomeowner?: Maybe<Client>;
  toDos?: Maybe<Array<ToDo>>;
  lotDetail: ProjectLotDetail;
  siteSpecificInfos: Array<ProjectSiteSpecificInfo>;
  projectSiteCondition?: Maybe<ProjectSiteCondition>;
  unassignedTaskCount: Scalars['Int'];
  enableHomeownerNotes: Scalars['Boolean'];
  checkoutCustomerConfigId?: Maybe<Scalars['String']>;
  canEditJobLogs: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  canHaveBudget: PotentialOperation2;
  homeownerNotes: Array<HomeownerNote>;
  enableHomeownerJourneyV2: Scalars['Boolean'];
  featureFlags: Array<FeatureFlag>;
  homeownerDeliveryDate?: Maybe<Scalars['Date']>;
  tasksCompletedThisWeek: Scalars['Int'];
  contacts: Array<ProjectContact>;
  warrantyTickets: Array<WarrantyTicket>;
  shouldAccrueAsComplete: Scalars['Boolean'];
  directCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']>;
  indirectCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']>;
  customer?: Maybe<Customer>;
  customerOwnerEntity?: Maybe<CustomerOwnerEntity>;
  invoiceSchedule?: Maybe<InvoiceSchedule>;
  allowExcludedCostCodesOnPurchaseOrders: Scalars['Boolean'];
  enableProductConfigPlan: Scalars['Boolean'];
  planSchedule?: Maybe<PlanSchedule>;
  builder?: Maybe<Builder>;
  bidOutPercentage: Scalars['Int'];
  enableChangeEventSignatures: Scalars['Boolean'];
  enablePocInvoiceSchedule: Scalars['Boolean'];
  softCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  indirectHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  directHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  legalDescription?: Maybe<Scalars['String']>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']>;
  salesTaxInBasisPoints: Scalars['Int'];
  projectItemAllocations: Array<ProjectItemAllocation>;
  allocationRules: Array<ProjectAllocationRule>;
  warrantyLengthInDays: Scalars['Int'];
  warrantyOverrideLengthInDays?: Maybe<Scalars['Int']>;
  bidPackages: Array<BidPackage>;
  bidContracts: Array<BidContract>;
  homeownerContracts: Array<HomeownerContract>;
  documents: Array<Document>;
  commitments: Array<Commitment>;
  directCostInCents: Scalars['Int'];
  directPriceInCents: Scalars['Int'];
  totalHardCostInCents: Scalars['Int'];
  totalSoftCostInCents: Scalars['Int'];
  totalCostInCents: Scalars['Int'];
  totalPriceInCents: Scalars['Int'];
  readyToStartDate?: Maybe<Scalars['Date']>;
  committedCostCodesAtStartInBasisPoints?: Maybe<Scalars['Int']>;
  directCostAtStartInCents?: Maybe<Scalars['Int']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']>;
  uncommittedCostInCents: Scalars['Int'];
  snapshots: Array<ProjectSnapshot>;
  companyInfo: CompanyInfo;
  invoicePaymentNetDays: Scalars['Int'];
  /**  return the first snapshot before or on the given date  */
  snapshotAsOf?: Maybe<ProjectSnapshot>;
  purchaseCostInCents?: Maybe<Scalars['Int']>;
  grossSalesPriceInCents?: Maybe<Scalars['Int']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']>;
  projectCostCodes: Array<ProjectCostCode>;
  /** Hierarchy Navigation */
  parent?: Maybe<Project>;
  parentsRecursive: Array<Project>;
  childrenRecursive: Array<Project>;
  siblingProjects: Array<Project>;
  sellableProjects: Array<Project>;
  isSellableProject: Scalars['Boolean'];
  /** Hierarchy Budget Page Fields */
  originalCostInCents: Scalars['Int'];
  startCostInCents: Scalars['Int'];
  changeEventCostInCents: Scalars['Int'];
  projectedCostInCents: Scalars['Int'];
  revisedCostInCents: Scalars['Int'];
  committedCostInCents: Scalars['Int'];
  availableCostInCents: Scalars['Int'];
  billedCostInCents: Scalars['Int'];
  unbilledCostInCents: Scalars['Int'];
  /**
   * Deprecated fields for StandaloneProject. Do not add new fields below this.
   * @deprecated only implemented for StandaloneProject
   */
  cohort?: Maybe<Cohort>;
  /** @deprecated only implemented for StandaloneProject */
  constructionConfidenceFactor?: Maybe<Scalars['Int']>;
  /** @deprecated only implemented for StandaloneProject */
  lotRating?: Maybe<LotRating>;
  /** @deprecated only implemented for StandaloneProject */
  preConBudgetLineItems: Array<PreConBudgetCostDivisionLineItem>;
  /** @deprecated only implemented for StandaloneProject */
  preconContractType?: Maybe<PreconContractType>;
  /** @deprecated only implemented for StandaloneProject and Structure */
  primaryProject?: Maybe<Project>;
  /** @deprecated only implemented for StandaloneProject */
  quickbooksCustomerId?: Maybe<Scalars['String']>;
  /** @deprecated only implemented for StandaloneProject */
  shadowProjects: Array<Project>;
  /** @deprecated only implemented for StandaloneProject */
  submarket?: Maybe<Submarket>;
  /**
   * Deprecated fields. Do not add new fields below this.
   * @deprecated homeowner can be accessed through collaborators
   */
  client?: Maybe<Client>;
  /** @deprecated replaced by blueprintUrl */
  url: Scalars['String'];
  /**
   *  The same as name, just a previous name.
   * @deprecated replaced by name.
   */
  projectName: Scalars['String'];
  /** @deprecated replaced by activeSalesforceOpportunity */
  salesforceId?: Maybe<Scalars['String']>;
  /** @deprecated This field is being removed from our SFDC data model */
  activeSalesforceOpportunity?: Maybe<ProjectSalesforceOpportunity>;
  /** @deprecated use lotType instead */
  dictionary: ProjectDictionary;
  warrantyEndDate?: Maybe<Scalars['Date']>;
  invoiceScheduleTemplates: Array<InvoiceScheduleTemplate>;
};


export type RegionTeamMembersArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']>;
};


export type RegionStagesArgs = {
  stage?: InputMaybe<Stage>;
  filter?: InputMaybe<ProjectStagesFilter>;
};


export type RegionStageArgs = {
  stage: Stage;
};


export type RegionAvailableAssigneesArgs = {
  role?: InputMaybe<ProjectRole>;
};


export type RegionToDosArgs = {
  type?: InputMaybe<ToDoType>;
};


export type RegionDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};


export type RegionSnapshotAsOfArgs = {
  date: Scalars['Date'];
};


export type RegionOriginalCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type RegionStartCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type RegionChangeEventCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type RegionProjectedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type RegionRevisedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type RegionCommittedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type RegionAvailableCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type RegionBilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type RegionUnbilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type RegionPreConBudgetLineItemsArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']>;
};

export type Market = CanCollaborate & Commentable & Referencable & Followable & Project & HasBlueprintUrl & Named & HasDisplayName & MaybeHasProject & HasSchedules & Entity & HasHopUrl & {
  __typename?: 'Market';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Market specific fields */
  abbreviation: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  salesforceMarketCode?: Maybe<Scalars['String']>;
  submarkets: Array<Submarket>;
  timeZone: Scalars['String'];
  msaName?: Maybe<Scalars['String']>;
  developments: Array<Development>;
  bidItemEstimates: Array<BidItemEstimate>;
  readyPlans: Array<ReadyPlan>;
  optionPricingConfigVariants: Array<OptionPricingConfigVariant>;
  state: Scalars['String'];
  materialLeadTimeConfigVariants: Array<MaterialLeadTimeConfigVariant>;
  standaloneProjects: Array<StandaloneProject>;
  marketDevelopmentContracts: Array<DevelopmentCommitment>;
  drops: Array<Drop>;
  /** Overridden fields from Project */
  market: Market;
  parent: Region;
  children: Array<Community>;
  /** Inherited fields from Project */
  collaborators: Array<ProjectCollaborator>;
  coverImage?: Maybe<Asset>;
  buildAddress?: Maybe<Address>;
  teamMembers: Array<ProjectTeamMember>;
  projectLead?: Maybe<ProjectTeamMember>;
  activeStage: StageDetail;
  activeProjectStage?: Maybe<ProjectStage>;
  stages: Array<ProjectStage>;
  stage: ProjectStage;
  blueprintUrl: Url;
  hopUrl: Scalars['String'];
  /**  The address + client name  */
  name: Scalars['String'];
  displayName: Scalars['String'];
  availableAssignees: Array<InternalUser>;
  startDate: Scalars['Date'];
  /**  list of features which are enabled on this project  */
  features: Array<ProjectFeature>;
  isTest: Scalars['Boolean'];
  status: ProjectStatusDetail;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  project?: Maybe<Project>;
  googleDriveFolderId?: Maybe<Scalars['String']>;
  salesforceAccountId?: Maybe<Scalars['String']>;
  salesforceOpportunities: Array<ProjectSalesforceOpportunity>;
  projectStatusChange?: Maybe<ProjectStatusChange>;
  planRoomLink?: Maybe<Scalars['String']>;
  isDisaster?: Maybe<Scalars['Boolean']>;
  intakeStyleNotes?: Maybe<Scalars['String']>;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  productType?: Maybe<ProductType>;
  enableSchedulesV2: Scalars['Boolean'];
  tradePartners: Array<TradePartner>;
  jobLogs: Array<JobLog>;
  salesforcePropertyId?: Maybe<Scalars['String']>;
  schedules: Array<Schedule>;
  expenses: Array<Expense>;
  unallocatedExpenses: Array<Expense>;
  unallocatedAmountInCents: Scalars['Int'];
  enableSchedulesV2Gantt: Scalars['Boolean'];
  enableSchedulesCalendar: Scalars['Boolean'];
  readyPlanConfig?: Maybe<ProjectReadyPlanConfig>;
  earnedValueCurves: Array<EarnedValueCurve>;
  enableBidPackagesV2: Scalars['Boolean'];
  invoiceSettings?: Maybe<ProjectInvoiceSetting>;
  scopeMode: ScopeModeDetail;
  lotPartitionId?: Maybe<Scalars['String']>;
  budgetFinancials: ProjectBudgetFinancials;
  enableDelayFlags: Scalars['Boolean'];
  warrantyStartDate?: Maybe<Scalars['Date']>;
  verticalCompleteDate?: Maybe<Scalars['Date']>;
  jobLogInsights: ProjectJobLogInsights;
  targetEndDate?: Maybe<Scalars['Date']>;
  latestActiveStage?: Maybe<ProjectStage>;
  primaryHomeowner?: Maybe<Client>;
  toDos?: Maybe<Array<ToDo>>;
  lotDetail: ProjectLotDetail;
  siteSpecificInfos: Array<ProjectSiteSpecificInfo>;
  projectSiteCondition?: Maybe<ProjectSiteCondition>;
  unassignedTaskCount: Scalars['Int'];
  enableHomeownerNotes: Scalars['Boolean'];
  checkoutCustomerConfigId?: Maybe<Scalars['String']>;
  canEditJobLogs: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  canHaveBudget: PotentialOperation2;
  homeownerNotes: Array<HomeownerNote>;
  enableHomeownerJourneyV2: Scalars['Boolean'];
  featureFlags: Array<FeatureFlag>;
  homeownerDeliveryDate?: Maybe<Scalars['Date']>;
  tasksCompletedThisWeek: Scalars['Int'];
  contacts: Array<ProjectContact>;
  warrantyTickets: Array<WarrantyTicket>;
  shouldAccrueAsComplete: Scalars['Boolean'];
  directCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']>;
  indirectCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']>;
  customer?: Maybe<Customer>;
  customerOwnerEntity?: Maybe<CustomerOwnerEntity>;
  invoiceSchedule?: Maybe<InvoiceSchedule>;
  allowExcludedCostCodesOnPurchaseOrders: Scalars['Boolean'];
  enableProductConfigPlan: Scalars['Boolean'];
  planSchedule?: Maybe<PlanSchedule>;
  builder?: Maybe<Builder>;
  bidOutPercentage: Scalars['Int'];
  enableChangeEventSignatures: Scalars['Boolean'];
  enablePocInvoiceSchedule: Scalars['Boolean'];
  softCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  indirectHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  directHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  legalDescription?: Maybe<Scalars['String']>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']>;
  salesTaxInBasisPoints: Scalars['Int'];
  projectItemAllocations: Array<ProjectItemAllocation>;
  allocationRules: Array<ProjectAllocationRule>;
  warrantyLengthInDays: Scalars['Int'];
  warrantyOverrideLengthInDays?: Maybe<Scalars['Int']>;
  bidPackages: Array<BidPackage>;
  bidContracts: Array<BidContract>;
  homeownerContracts: Array<HomeownerContract>;
  documents: Array<Document>;
  commitments: Array<Commitment>;
  directCostInCents: Scalars['Int'];
  directPriceInCents: Scalars['Int'];
  totalHardCostInCents: Scalars['Int'];
  totalSoftCostInCents: Scalars['Int'];
  totalCostInCents: Scalars['Int'];
  totalPriceInCents: Scalars['Int'];
  readyToStartDate?: Maybe<Scalars['Date']>;
  committedCostCodesAtStartInBasisPoints?: Maybe<Scalars['Int']>;
  directCostAtStartInCents?: Maybe<Scalars['Int']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']>;
  uncommittedCostInCents: Scalars['Int'];
  snapshots: Array<ProjectSnapshot>;
  warrantyEndDate?: Maybe<Scalars['Date']>;
  companyInfo: CompanyInfo;
  invoicePaymentNetDays: Scalars['Int'];
  /**  return the first snapshot before or on the given date  */
  snapshotAsOf?: Maybe<ProjectSnapshot>;
  purchaseCostInCents?: Maybe<Scalars['Int']>;
  grossSalesPriceInCents?: Maybe<Scalars['Int']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']>;
  projectCostCodes: Array<ProjectCostCode>;
  /** Hierarchy Navigation */
  parentsRecursive: Array<Project>;
  childrenRecursive: Array<Project>;
  siblingProjects: Array<Project>;
  sellableProjects: Array<Project>;
  isSellableProject: Scalars['Boolean'];
  /** Hierarchy Budget Page Fields */
  originalCostInCents: Scalars['Int'];
  startCostInCents: Scalars['Int'];
  changeEventCostInCents: Scalars['Int'];
  projectedCostInCents: Scalars['Int'];
  revisedCostInCents: Scalars['Int'];
  committedCostInCents: Scalars['Int'];
  availableCostInCents: Scalars['Int'];
  billedCostInCents: Scalars['Int'];
  unbilledCostInCents: Scalars['Int'];
  /**
   * Deprecated fields for StandaloneProject. Do not add new fields below this.
   * @deprecated only implemented for StandaloneProject
   */
  cohort?: Maybe<Cohort>;
  /** @deprecated only implemented for StandaloneProject */
  constructionConfidenceFactor?: Maybe<Scalars['Int']>;
  /** @deprecated only implemented for StandaloneProject */
  lotRating?: Maybe<LotRating>;
  /** @deprecated only implemented for StandaloneProject */
  preConBudgetLineItems: Array<PreConBudgetCostDivisionLineItem>;
  /** @deprecated only implemented for StandaloneProject */
  preconContractType?: Maybe<PreconContractType>;
  /** @deprecated only implemented for StandaloneProject and Structure */
  primaryProject?: Maybe<Project>;
  /** @deprecated only implemented for StandaloneProject */
  quickbooksCustomerId?: Maybe<Scalars['String']>;
  /** @deprecated only implemented for StandaloneProject */
  shadowProjects: Array<Project>;
  /** @deprecated only implemented for StandaloneProject */
  submarket?: Maybe<Submarket>;
  /**
   * Deprecated fields. Do not add new fields below this.
   * @deprecated homeowner can be accessed through collaborators
   */
  client?: Maybe<Client>;
  /** @deprecated replaced by blueprintUrl */
  url: Scalars['String'];
  /**
   *  The same as name, just a previous name.
   * @deprecated replaced by name.
   */
  projectName: Scalars['String'];
  /** @deprecated replaced by activeSalesforceOpportunity */
  salesforceId?: Maybe<Scalars['String']>;
  /** @deprecated This field is being removed from our SFDC data model */
  activeSalesforceOpportunity?: Maybe<ProjectSalesforceOpportunity>;
  /** @deprecated use lotType instead */
  dictionary: ProjectDictionary;
};


export type MarketTeamMembersArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']>;
};


export type MarketStagesArgs = {
  stage?: InputMaybe<Stage>;
  filter?: InputMaybe<ProjectStagesFilter>;
};


export type MarketStageArgs = {
  stage: Stage;
};


export type MarketAvailableAssigneesArgs = {
  role?: InputMaybe<ProjectRole>;
};


export type MarketToDosArgs = {
  type?: InputMaybe<ToDoType>;
};


export type MarketDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};


export type MarketSnapshotAsOfArgs = {
  date: Scalars['Date'];
};


export type MarketOriginalCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type MarketStartCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type MarketChangeEventCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type MarketProjectedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type MarketRevisedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type MarketCommittedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type MarketAvailableCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type MarketBilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type MarketUnbilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type MarketPreConBudgetLineItemsArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']>;
};

export type Community = CanCollaborate & Commentable & Referencable & Followable & Project & HasBlueprintUrl & Named & HasDisplayName & MaybeHasProject & HasSchedules & Entity & HasHopUrl & {
  __typename?: 'Community';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Community specific fields */
  productOfferings: Array<ProductOffering>;
  drops: Array<Drop>;
  costCodesWithDraws: Array<CostCode>;
  salesforceNeighborhoodId?: Maybe<Scalars['String']>;
  pricingTeaser?: Maybe<Scalars['String']>;
  /**  Raw SVG for the community's lot map  */
  lotMap?: Maybe<Scalars['String']>;
  /** Overridden fields from Project */
  market: Market;
  parent: Market;
  children: Array<Subdivision>;
  /** Inherited fields from Project */
  collaborators: Array<ProjectCollaborator>;
  coverImage?: Maybe<Asset>;
  buildAddress?: Maybe<Address>;
  teamMembers: Array<ProjectTeamMember>;
  projectLead?: Maybe<ProjectTeamMember>;
  activeStage: StageDetail;
  activeProjectStage?: Maybe<ProjectStage>;
  stages: Array<ProjectStage>;
  stage: ProjectStage;
  blueprintUrl: Url;
  hopUrl: Scalars['String'];
  /**  The address + client name  */
  name: Scalars['String'];
  displayName: Scalars['String'];
  availableAssignees: Array<InternalUser>;
  startDate: Scalars['Date'];
  /**  list of features which are enabled on this project  */
  features: Array<ProjectFeature>;
  isTest: Scalars['Boolean'];
  status: ProjectStatusDetail;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  project?: Maybe<Project>;
  googleDriveFolderId?: Maybe<Scalars['String']>;
  salesforceAccountId?: Maybe<Scalars['String']>;
  salesforceOpportunities: Array<ProjectSalesforceOpportunity>;
  projectStatusChange?: Maybe<ProjectStatusChange>;
  planRoomLink?: Maybe<Scalars['String']>;
  isDisaster?: Maybe<Scalars['Boolean']>;
  intakeStyleNotes?: Maybe<Scalars['String']>;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  productType?: Maybe<ProductType>;
  enableSchedulesV2: Scalars['Boolean'];
  tradePartners: Array<TradePartner>;
  jobLogs: Array<JobLog>;
  salesforcePropertyId?: Maybe<Scalars['String']>;
  schedules: Array<Schedule>;
  expenses: Array<Expense>;
  unallocatedExpenses: Array<Expense>;
  unallocatedAmountInCents: Scalars['Int'];
  enableSchedulesV2Gantt: Scalars['Boolean'];
  enableSchedulesCalendar: Scalars['Boolean'];
  readyPlanConfig?: Maybe<ProjectReadyPlanConfig>;
  earnedValueCurves: Array<EarnedValueCurve>;
  enableBidPackagesV2: Scalars['Boolean'];
  invoiceSettings?: Maybe<ProjectInvoiceSetting>;
  scopeMode: ScopeModeDetail;
  lotPartitionId?: Maybe<Scalars['String']>;
  budgetFinancials: ProjectBudgetFinancials;
  enableDelayFlags: Scalars['Boolean'];
  warrantyStartDate?: Maybe<Scalars['Date']>;
  verticalCompleteDate?: Maybe<Scalars['Date']>;
  jobLogInsights: ProjectJobLogInsights;
  targetEndDate?: Maybe<Scalars['Date']>;
  latestActiveStage?: Maybe<ProjectStage>;
  primaryHomeowner?: Maybe<Client>;
  toDos?: Maybe<Array<ToDo>>;
  lotDetail: ProjectLotDetail;
  siteSpecificInfos: Array<ProjectSiteSpecificInfo>;
  projectSiteCondition?: Maybe<ProjectSiteCondition>;
  unassignedTaskCount: Scalars['Int'];
  enableHomeownerNotes: Scalars['Boolean'];
  checkoutCustomerConfigId?: Maybe<Scalars['String']>;
  canEditJobLogs: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  canHaveBudget: PotentialOperation2;
  homeownerNotes: Array<HomeownerNote>;
  enableHomeownerJourneyV2: Scalars['Boolean'];
  featureFlags: Array<FeatureFlag>;
  homeownerDeliveryDate?: Maybe<Scalars['Date']>;
  tasksCompletedThisWeek: Scalars['Int'];
  contacts: Array<ProjectContact>;
  warrantyTickets: Array<WarrantyTicket>;
  shouldAccrueAsComplete: Scalars['Boolean'];
  directCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']>;
  indirectCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']>;
  customer?: Maybe<Customer>;
  customerOwnerEntity?: Maybe<CustomerOwnerEntity>;
  invoiceSchedule?: Maybe<InvoiceSchedule>;
  allowExcludedCostCodesOnPurchaseOrders: Scalars['Boolean'];
  enableProductConfigPlan: Scalars['Boolean'];
  planSchedule?: Maybe<PlanSchedule>;
  builder?: Maybe<Builder>;
  bidOutPercentage: Scalars['Int'];
  enableChangeEventSignatures: Scalars['Boolean'];
  enablePocInvoiceSchedule: Scalars['Boolean'];
  softCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  indirectHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  directHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  legalDescription?: Maybe<Scalars['String']>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']>;
  salesTaxInBasisPoints: Scalars['Int'];
  projectItemAllocations: Array<ProjectItemAllocation>;
  allocationRules: Array<ProjectAllocationRule>;
  warrantyLengthInDays: Scalars['Int'];
  warrantyOverrideLengthInDays?: Maybe<Scalars['Int']>;
  bidPackages: Array<BidPackage>;
  bidContracts: Array<BidContract>;
  homeownerContracts: Array<HomeownerContract>;
  documents: Array<Document>;
  commitments: Array<Commitment>;
  directCostInCents: Scalars['Int'];
  directPriceInCents: Scalars['Int'];
  totalHardCostInCents: Scalars['Int'];
  totalSoftCostInCents: Scalars['Int'];
  totalCostInCents: Scalars['Int'];
  totalPriceInCents: Scalars['Int'];
  readyToStartDate?: Maybe<Scalars['Date']>;
  committedCostCodesAtStartInBasisPoints?: Maybe<Scalars['Int']>;
  directCostAtStartInCents?: Maybe<Scalars['Int']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']>;
  uncommittedCostInCents: Scalars['Int'];
  snapshots: Array<ProjectSnapshot>;
  warrantyEndDate?: Maybe<Scalars['Date']>;
  companyInfo: CompanyInfo;
  invoicePaymentNetDays: Scalars['Int'];
  /**  return the first snapshot before or on the given date  */
  snapshotAsOf?: Maybe<ProjectSnapshot>;
  purchaseCostInCents?: Maybe<Scalars['Int']>;
  grossSalesPriceInCents?: Maybe<Scalars['Int']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']>;
  projectCostCodes: Array<ProjectCostCode>;
  showInCheckout: Scalars['Boolean'];
  /** Hierarchy Navigation */
  parentsRecursive: Array<Project>;
  childrenRecursive: Array<Project>;
  siblingProjects: Array<Project>;
  sellableProjects: Array<Project>;
  isSellableProject: Scalars['Boolean'];
  /** Hierarchy Budget Page Fields */
  originalCostInCents: Scalars['Int'];
  startCostInCents: Scalars['Int'];
  changeEventCostInCents: Scalars['Int'];
  projectedCostInCents: Scalars['Int'];
  revisedCostInCents: Scalars['Int'];
  committedCostInCents: Scalars['Int'];
  availableCostInCents: Scalars['Int'];
  billedCostInCents: Scalars['Int'];
  unbilledCostInCents: Scalars['Int'];
  /**
   * Deprecated fields for StandaloneProject. Do not add new fields below this.
   * @deprecated only implemented for StandaloneProject
   */
  cohort?: Maybe<Cohort>;
  /** @deprecated only implemented for StandaloneProject */
  constructionConfidenceFactor?: Maybe<Scalars['Int']>;
  /** @deprecated only implemented for StandaloneProject */
  lotRating?: Maybe<LotRating>;
  /** @deprecated only implemented for StandaloneProject */
  preConBudgetLineItems: Array<PreConBudgetCostDivisionLineItem>;
  /** @deprecated only implemented for StandaloneProject */
  preconContractType?: Maybe<PreconContractType>;
  /** @deprecated only implemented for StandaloneProject and Structure */
  primaryProject?: Maybe<Project>;
  /** @deprecated only implemented for StandaloneProject */
  quickbooksCustomerId?: Maybe<Scalars['String']>;
  /** @deprecated only implemented for StandaloneProject */
  shadowProjects: Array<Project>;
  /** @deprecated only implemented for StandaloneProject */
  submarket?: Maybe<Submarket>;
  /**
   * Deprecated fields. Do not add new fields below this.
   * @deprecated homeowner can be accessed through collaborators
   */
  client?: Maybe<Client>;
  /** @deprecated replaced by blueprintUrl */
  url: Scalars['String'];
  /**
   *  The same as name, just a previous name.
   * @deprecated replaced by name.
   */
  projectName: Scalars['String'];
  /** @deprecated replaced by activeSalesforceOpportunity */
  salesforceId?: Maybe<Scalars['String']>;
  /** @deprecated This field is being removed from our SFDC data model */
  activeSalesforceOpportunity?: Maybe<ProjectSalesforceOpportunity>;
  /** @deprecated use lotType instead */
  dictionary: ProjectDictionary;
  packageComparison?: Maybe<Asset>;
  globalPlanStageVariants: Array<GlobalPlanStageVariant>;
};


export type CommunityTeamMembersArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']>;
};


export type CommunityStagesArgs = {
  stage?: InputMaybe<Stage>;
  filter?: InputMaybe<ProjectStagesFilter>;
};


export type CommunityStageArgs = {
  stage: Stage;
};


export type CommunityAvailableAssigneesArgs = {
  role?: InputMaybe<ProjectRole>;
};


export type CommunityToDosArgs = {
  type?: InputMaybe<ToDoType>;
};


export type CommunityDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};


export type CommunitySnapshotAsOfArgs = {
  date: Scalars['Date'];
};


export type CommunityOriginalCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type CommunityStartCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type CommunityChangeEventCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type CommunityProjectedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type CommunityRevisedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type CommunityCommittedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type CommunityAvailableCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type CommunityBilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type CommunityUnbilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type CommunityPreConBudgetLineItemsArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']>;
};

export type Subdivision = CanCollaborate & Commentable & Referencable & Followable & Project & HasBlueprintUrl & Named & HasDisplayName & MaybeHasProject & HasSchedules & Entity & HasHopUrl & {
  __typename?: 'Subdivision';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Subdivision specific fields */
  salesforceBusinessDevelopmentOpportunityId?: Maybe<Scalars['String']>;
  salesforceTakedownId?: Maybe<Scalars['String']>;
  /** Overridden fields from Project */
  market: Market;
  parent: Community;
  children: Array<Lot>;
  /** Inherited fields from Project */
  collaborators: Array<ProjectCollaborator>;
  coverImage?: Maybe<Asset>;
  buildAddress?: Maybe<Address>;
  teamMembers: Array<ProjectTeamMember>;
  projectLead?: Maybe<ProjectTeamMember>;
  activeStage: StageDetail;
  activeProjectStage?: Maybe<ProjectStage>;
  stages: Array<ProjectStage>;
  stage: ProjectStage;
  blueprintUrl: Url;
  hopUrl: Scalars['String'];
  /**  The address + client name  */
  name: Scalars['String'];
  displayName: Scalars['String'];
  availableAssignees: Array<InternalUser>;
  startDate: Scalars['Date'];
  /**  list of features which are enabled on this project  */
  features: Array<ProjectFeature>;
  isTest: Scalars['Boolean'];
  status: ProjectStatusDetail;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  project?: Maybe<Project>;
  googleDriveFolderId?: Maybe<Scalars['String']>;
  salesforceAccountId?: Maybe<Scalars['String']>;
  salesforceOpportunities: Array<ProjectSalesforceOpportunity>;
  projectStatusChange?: Maybe<ProjectStatusChange>;
  planRoomLink?: Maybe<Scalars['String']>;
  isDisaster?: Maybe<Scalars['Boolean']>;
  intakeStyleNotes?: Maybe<Scalars['String']>;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  productType?: Maybe<ProductType>;
  enableSchedulesV2: Scalars['Boolean'];
  tradePartners: Array<TradePartner>;
  jobLogs: Array<JobLog>;
  salesforcePropertyId?: Maybe<Scalars['String']>;
  schedules: Array<Schedule>;
  expenses: Array<Expense>;
  unallocatedExpenses: Array<Expense>;
  unallocatedAmountInCents: Scalars['Int'];
  enableSchedulesV2Gantt: Scalars['Boolean'];
  enableSchedulesCalendar: Scalars['Boolean'];
  readyPlanConfig?: Maybe<ProjectReadyPlanConfig>;
  earnedValueCurves: Array<EarnedValueCurve>;
  enableBidPackagesV2: Scalars['Boolean'];
  invoiceSettings?: Maybe<ProjectInvoiceSetting>;
  scopeMode: ScopeModeDetail;
  lotPartitionId?: Maybe<Scalars['String']>;
  budgetFinancials: ProjectBudgetFinancials;
  enableDelayFlags: Scalars['Boolean'];
  warrantyStartDate?: Maybe<Scalars['Date']>;
  verticalCompleteDate?: Maybe<Scalars['Date']>;
  jobLogInsights: ProjectJobLogInsights;
  targetEndDate?: Maybe<Scalars['Date']>;
  latestActiveStage?: Maybe<ProjectStage>;
  primaryHomeowner?: Maybe<Client>;
  toDos?: Maybe<Array<ToDo>>;
  lotDetail: ProjectLotDetail;
  siteSpecificInfos: Array<ProjectSiteSpecificInfo>;
  projectSiteCondition?: Maybe<ProjectSiteCondition>;
  unassignedTaskCount: Scalars['Int'];
  enableHomeownerNotes: Scalars['Boolean'];
  checkoutCustomerConfigId?: Maybe<Scalars['String']>;
  canEditJobLogs: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  canHaveBudget: PotentialOperation2;
  homeownerNotes: Array<HomeownerNote>;
  enableHomeownerJourneyV2: Scalars['Boolean'];
  featureFlags: Array<FeatureFlag>;
  homeownerDeliveryDate?: Maybe<Scalars['Date']>;
  tasksCompletedThisWeek: Scalars['Int'];
  contacts: Array<ProjectContact>;
  warrantyTickets: Array<WarrantyTicket>;
  shouldAccrueAsComplete: Scalars['Boolean'];
  directCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']>;
  indirectCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']>;
  customer?: Maybe<Customer>;
  customerOwnerEntity?: Maybe<CustomerOwnerEntity>;
  invoiceSchedule?: Maybe<InvoiceSchedule>;
  allowExcludedCostCodesOnPurchaseOrders: Scalars['Boolean'];
  enableProductConfigPlan: Scalars['Boolean'];
  planSchedule?: Maybe<PlanSchedule>;
  builder?: Maybe<Builder>;
  bidOutPercentage: Scalars['Int'];
  enableChangeEventSignatures: Scalars['Boolean'];
  enablePocInvoiceSchedule: Scalars['Boolean'];
  softCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  indirectHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  directHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  legalDescription?: Maybe<Scalars['String']>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']>;
  salesTaxInBasisPoints: Scalars['Int'];
  projectItemAllocations: Array<ProjectItemAllocation>;
  allocationRules: Array<ProjectAllocationRule>;
  warrantyLengthInDays: Scalars['Int'];
  warrantyOverrideLengthInDays?: Maybe<Scalars['Int']>;
  bidPackages: Array<BidPackage>;
  bidContracts: Array<BidContract>;
  homeownerContracts: Array<HomeownerContract>;
  documents: Array<Document>;
  commitments: Array<Commitment>;
  directCostInCents: Scalars['Int'];
  directPriceInCents: Scalars['Int'];
  totalHardCostInCents: Scalars['Int'];
  totalSoftCostInCents: Scalars['Int'];
  totalCostInCents: Scalars['Int'];
  totalPriceInCents: Scalars['Int'];
  readyToStartDate?: Maybe<Scalars['Date']>;
  committedCostCodesAtStartInBasisPoints?: Maybe<Scalars['Int']>;
  directCostAtStartInCents?: Maybe<Scalars['Int']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']>;
  uncommittedCostInCents: Scalars['Int'];
  snapshots: Array<ProjectSnapshot>;
  warrantyEndDate?: Maybe<Scalars['Date']>;
  companyInfo: CompanyInfo;
  invoicePaymentNetDays: Scalars['Int'];
  /**  return the first snapshot before or on the given date  */
  snapshotAsOf?: Maybe<ProjectSnapshot>;
  purchaseCostInCents?: Maybe<Scalars['Int']>;
  grossSalesPriceInCents?: Maybe<Scalars['Int']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']>;
  projectCostCodes: Array<ProjectCostCode>;
  /** Hierarchy Navigation */
  parentsRecursive: Array<Project>;
  childrenRecursive: Array<Project>;
  siblingProjects: Array<Project>;
  sellableProjects: Array<Project>;
  isSellableProject: Scalars['Boolean'];
  /** Hierarchy Budget Page Fields */
  originalCostInCents: Scalars['Int'];
  startCostInCents: Scalars['Int'];
  changeEventCostInCents: Scalars['Int'];
  projectedCostInCents: Scalars['Int'];
  revisedCostInCents: Scalars['Int'];
  committedCostInCents: Scalars['Int'];
  availableCostInCents: Scalars['Int'];
  billedCostInCents: Scalars['Int'];
  unbilledCostInCents: Scalars['Int'];
  /**
   * Deprecated fields for StandaloneProject. Do not add new fields below this.
   * @deprecated only implemented for StandaloneProject
   */
  cohort?: Maybe<Cohort>;
  /** @deprecated only implemented for StandaloneProject */
  constructionConfidenceFactor?: Maybe<Scalars['Int']>;
  /** @deprecated only implemented for StandaloneProject */
  lotRating?: Maybe<LotRating>;
  /** @deprecated only implemented for StandaloneProject */
  preConBudgetLineItems: Array<PreConBudgetCostDivisionLineItem>;
  /** @deprecated only implemented for StandaloneProject */
  preconContractType?: Maybe<PreconContractType>;
  /** @deprecated only implemented for StandaloneProject and Structure */
  primaryProject?: Maybe<Project>;
  /** @deprecated only implemented for StandaloneProject */
  quickbooksCustomerId?: Maybe<Scalars['String']>;
  /** @deprecated only implemented for StandaloneProject */
  shadowProjects: Array<Project>;
  /** @deprecated only implemented for StandaloneProject */
  submarket?: Maybe<Submarket>;
  /**
   * Deprecated fields. Do not add new fields below this.
   * @deprecated homeowner can be accessed through collaborators
   */
  client?: Maybe<Client>;
  /** @deprecated replaced by blueprintUrl */
  url: Scalars['String'];
  /**
   *  The same as name, just a previous name.
   * @deprecated replaced by name.
   */
  projectName: Scalars['String'];
  /** @deprecated replaced by activeSalesforceOpportunity */
  salesforceId?: Maybe<Scalars['String']>;
  /** @deprecated This field is being removed from our SFDC data model */
  activeSalesforceOpportunity?: Maybe<ProjectSalesforceOpportunity>;
  /** @deprecated use lotType instead */
  dictionary: ProjectDictionary;
};


export type SubdivisionTeamMembersArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']>;
};


export type SubdivisionStagesArgs = {
  stage?: InputMaybe<Stage>;
  filter?: InputMaybe<ProjectStagesFilter>;
};


export type SubdivisionStageArgs = {
  stage: Stage;
};


export type SubdivisionAvailableAssigneesArgs = {
  role?: InputMaybe<ProjectRole>;
};


export type SubdivisionToDosArgs = {
  type?: InputMaybe<ToDoType>;
};


export type SubdivisionDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};


export type SubdivisionSnapshotAsOfArgs = {
  date: Scalars['Date'];
};


export type SubdivisionOriginalCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type SubdivisionStartCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type SubdivisionChangeEventCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type SubdivisionProjectedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type SubdivisionRevisedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type SubdivisionCommittedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type SubdivisionAvailableCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type SubdivisionBilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type SubdivisionUnbilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type SubdivisionPreConBudgetLineItemsArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']>;
};

export type Lot = CanCollaborate & Commentable & Referencable & Followable & Project & HasBlueprintUrl & Named & HasDisplayName & MaybeHasProject & HasSchedules & Entity & HasHopUrl & {
  __typename?: 'Lot';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Lot specific fields */
  buildablePlans: Array<ProductOffering>;
  buildableSfhPlans: Array<ProductOffering>;
  /** Overridden fields from Project */
  buildAddress: Address;
  market: Market;
  parent: Subdivision;
  children: Array<Structure>;
  /** Inherited fields from Project */
  collaborators: Array<ProjectCollaborator>;
  coverImage?: Maybe<Asset>;
  teamMembers: Array<ProjectTeamMember>;
  projectLead?: Maybe<ProjectTeamMember>;
  activeStage: StageDetail;
  activeProjectStage?: Maybe<ProjectStage>;
  stages: Array<ProjectStage>;
  stage: ProjectStage;
  blueprintUrl: Url;
  hopUrl: Scalars['String'];
  /**  The address + client name + suffix (e.g. - Lot)  */
  name: Scalars['String'];
  /**  The non-suffixed name  */
  displayName: Scalars['String'];
  availableAssignees: Array<InternalUser>;
  startDate: Scalars['Date'];
  /**  list of features which are enabled on this project  */
  features: Array<ProjectFeature>;
  isTest: Scalars['Boolean'];
  status: ProjectStatusDetail;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  project?: Maybe<Project>;
  googleDriveFolderId?: Maybe<Scalars['String']>;
  salesforceAccountId?: Maybe<Scalars['String']>;
  salesforceOpportunities: Array<ProjectSalesforceOpportunity>;
  projectStatusChange?: Maybe<ProjectStatusChange>;
  planRoomLink?: Maybe<Scalars['String']>;
  isDisaster?: Maybe<Scalars['Boolean']>;
  intakeStyleNotes?: Maybe<Scalars['String']>;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  productType?: Maybe<ProductType>;
  enableSchedulesV2: Scalars['Boolean'];
  tradePartners: Array<TradePartner>;
  jobLogs: Array<JobLog>;
  salesforcePropertyId?: Maybe<Scalars['String']>;
  schedules: Array<Schedule>;
  expenses: Array<Expense>;
  unallocatedExpenses: Array<Expense>;
  unallocatedAmountInCents: Scalars['Int'];
  enableSchedulesV2Gantt: Scalars['Boolean'];
  enableSchedulesCalendar: Scalars['Boolean'];
  readyPlanConfig?: Maybe<ProjectReadyPlanConfig>;
  earnedValueCurves: Array<EarnedValueCurve>;
  enableBidPackagesV2: Scalars['Boolean'];
  invoiceSettings?: Maybe<ProjectInvoiceSetting>;
  scopeMode: ScopeModeDetail;
  lotPartitionId?: Maybe<Scalars['String']>;
  budgetFinancials: ProjectBudgetFinancials;
  enableDelayFlags: Scalars['Boolean'];
  warrantyStartDate?: Maybe<Scalars['Date']>;
  verticalCompleteDate?: Maybe<Scalars['Date']>;
  jobLogInsights: ProjectJobLogInsights;
  targetEndDate?: Maybe<Scalars['Date']>;
  latestActiveStage?: Maybe<ProjectStage>;
  primaryHomeowner?: Maybe<Client>;
  toDos?: Maybe<Array<ToDo>>;
  lotDetail: ProjectLotDetail;
  siteSpecificInfos: Array<ProjectSiteSpecificInfo>;
  projectSiteCondition?: Maybe<ProjectSiteCondition>;
  unassignedTaskCount: Scalars['Int'];
  enableHomeownerNotes: Scalars['Boolean'];
  checkoutCustomerConfigId?: Maybe<Scalars['String']>;
  canEditJobLogs: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  canHaveBudget: PotentialOperation2;
  homeownerNotes: Array<HomeownerNote>;
  enableHomeownerJourneyV2: Scalars['Boolean'];
  featureFlags: Array<FeatureFlag>;
  homeownerDeliveryDate?: Maybe<Scalars['Date']>;
  tasksCompletedThisWeek: Scalars['Int'];
  contacts: Array<ProjectContact>;
  warrantyTickets: Array<WarrantyTicket>;
  shouldAccrueAsComplete: Scalars['Boolean'];
  directCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']>;
  indirectCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']>;
  customer?: Maybe<Customer>;
  customerOwnerEntity?: Maybe<CustomerOwnerEntity>;
  invoiceSchedule?: Maybe<InvoiceSchedule>;
  allowExcludedCostCodesOnPurchaseOrders: Scalars['Boolean'];
  enableProductConfigPlan: Scalars['Boolean'];
  planSchedule?: Maybe<PlanSchedule>;
  builder?: Maybe<Builder>;
  bidOutPercentage: Scalars['Int'];
  enableChangeEventSignatures: Scalars['Boolean'];
  enablePocInvoiceSchedule: Scalars['Boolean'];
  softCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  indirectHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  directHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  legalDescription?: Maybe<Scalars['String']>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']>;
  salesTaxInBasisPoints: Scalars['Int'];
  projectItemAllocations: Array<ProjectItemAllocation>;
  allocationRules: Array<ProjectAllocationRule>;
  warrantyLengthInDays: Scalars['Int'];
  warrantyOverrideLengthInDays?: Maybe<Scalars['Int']>;
  bidPackages: Array<BidPackage>;
  bidContracts: Array<BidContract>;
  homeownerContracts: Array<HomeownerContract>;
  documents: Array<Document>;
  commitments: Array<Commitment>;
  directCostInCents: Scalars['Int'];
  directPriceInCents: Scalars['Int'];
  totalHardCostInCents: Scalars['Int'];
  totalSoftCostInCents: Scalars['Int'];
  totalCostInCents: Scalars['Int'];
  totalPriceInCents: Scalars['Int'];
  readyToStartDate?: Maybe<Scalars['Date']>;
  committedCostCodesAtStartInBasisPoints?: Maybe<Scalars['Int']>;
  directCostAtStartInCents?: Maybe<Scalars['Int']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']>;
  uncommittedCostInCents: Scalars['Int'];
  snapshots: Array<ProjectSnapshot>;
  warrantyEndDate?: Maybe<Scalars['Date']>;
  companyInfo: CompanyInfo;
  invoicePaymentNetDays: Scalars['Int'];
  /**  return the first snapshot before or on the given date  */
  snapshotAsOf?: Maybe<ProjectSnapshot>;
  purchaseCostInCents?: Maybe<Scalars['Int']>;
  grossSalesPriceInCents?: Maybe<Scalars['Int']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']>;
  projectCostCodes: Array<ProjectCostCode>;
  /** Hierarchy Navigation */
  parentsRecursive: Array<Project>;
  childrenRecursive: Array<Project>;
  siblingProjects: Array<Project>;
  sellableProjects: Array<Project>;
  isSellableProject: Scalars['Boolean'];
  /** Hierarchy Budget Page Fields */
  originalCostInCents: Scalars['Int'];
  startCostInCents: Scalars['Int'];
  changeEventCostInCents: Scalars['Int'];
  projectedCostInCents: Scalars['Int'];
  revisedCostInCents: Scalars['Int'];
  committedCostInCents: Scalars['Int'];
  availableCostInCents: Scalars['Int'];
  billedCostInCents: Scalars['Int'];
  unbilledCostInCents: Scalars['Int'];
  /**
   * Deprecated fields for StandaloneProject. Do not add new fields below this.
   * @deprecated only implemented for StandaloneProject
   */
  cohort?: Maybe<Cohort>;
  /** @deprecated only implemented for StandaloneProject */
  constructionConfidenceFactor?: Maybe<Scalars['Int']>;
  /** @deprecated only implemented for StandaloneProject */
  lotRating?: Maybe<LotRating>;
  /** @deprecated only implemented for StandaloneProject */
  preConBudgetLineItems: Array<PreConBudgetCostDivisionLineItem>;
  /** @deprecated only implemented for StandaloneProject */
  preconContractType?: Maybe<PreconContractType>;
  /** @deprecated only implemented for StandaloneProject and Structure */
  primaryProject?: Maybe<Project>;
  /** @deprecated only implemented for StandaloneProject */
  quickbooksCustomerId?: Maybe<Scalars['String']>;
  /** @deprecated only implemented for StandaloneProject */
  shadowProjects: Array<Project>;
  /** @deprecated only implemented for StandaloneProject */
  submarket?: Maybe<Submarket>;
  /**
   * Deprecated fields. Do not add new fields below this.
   * @deprecated homeowner can be accessed through collaborators
   */
  client?: Maybe<Client>;
  /** @deprecated replaced by blueprintUrl */
  url: Scalars['String'];
  /**
   *  The same as name, just a previous name.
   * @deprecated replaced by name.
   */
  projectName: Scalars['String'];
  /** @deprecated replaced by activeSalesforceOpportunity */
  salesforceId?: Maybe<Scalars['String']>;
  /** @deprecated This field is being removed from our SFDC data model */
  activeSalesforceOpportunity?: Maybe<ProjectSalesforceOpportunity>;
  /** @deprecated use lotType instead */
  dictionary: ProjectDictionary;
  landPriceInCents: Scalars['Int'];
};


export type LotTeamMembersArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']>;
};


export type LotStagesArgs = {
  stage?: InputMaybe<Stage>;
  filter?: InputMaybe<ProjectStagesFilter>;
};


export type LotStageArgs = {
  stage: Stage;
};


export type LotAvailableAssigneesArgs = {
  role?: InputMaybe<ProjectRole>;
};


export type LotToDosArgs = {
  type?: InputMaybe<ToDoType>;
};


export type LotDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};


export type LotSnapshotAsOfArgs = {
  date: Scalars['Date'];
};


export type LotOriginalCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type LotStartCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type LotChangeEventCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type LotProjectedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type LotRevisedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type LotCommittedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type LotAvailableCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type LotBilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type LotUnbilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type LotPreConBudgetLineItemsArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']>;
};

export type Structure = CanCollaborate & Commentable & Referencable & Followable & Project & HasBlueprintUrl & Named & HasDisplayName & MaybeHasProject & HasSchedules & Entity & HasHopUrl & MaybeHasPropcoUrl & {
  __typename?: 'Structure';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Overridden fields from Project */
  buildAddress: Address;
  market: Market;
  parent: Lot;
  children: Array<Unit>;
  primaryProject?: Maybe<Project>;
  /** Fields unique to Structure */
  showInCheckout: Scalars['Boolean'];
  community: Community;
  modelHomeHardCostsInCents: Scalars['Int'];
  modelHomeSoftCostsInCents: Scalars['Int'];
  mainHouseStructure?: Maybe<Structure>;
  aduStructure?: Maybe<Structure>;
  /**  True when this structure is an ADU, i.e. it has a main house structure linked.  */
  isAdu: Scalars['Boolean'];
  planType?: Maybe<ReadyPlanTypeDetail>;
  /** Checks today against RTS date on the plan schedule */
  hasStartedConstruction: Scalars['Boolean'];
  isConstructionComplete: Scalars['Boolean'];
  canChangeProductOffering: PotentialOperation2;
  /** Inherited fields from Project */
  collaborators: Array<ProjectCollaborator>;
  coverImage?: Maybe<Asset>;
  teamMembers: Array<ProjectTeamMember>;
  projectLead?: Maybe<ProjectTeamMember>;
  activeStage: StageDetail;
  activeProjectStage?: Maybe<ProjectStage>;
  stages: Array<ProjectStage>;
  stage: ProjectStage;
  blueprintUrl: Url;
  hopUrl: Scalars['String'];
  propcoUrl?: Maybe<Scalars['String']>;
  /**  The address + client name + maybe-suffix (e.g. - ADU, - Main)  */
  name: Scalars['String'];
  /**  The non-suffixed name  */
  displayName: Scalars['String'];
  availableAssignees: Array<InternalUser>;
  startDate: Scalars['Date'];
  /**  list of features which are enabled on this project  */
  features: Array<ProjectFeature>;
  isTest: Scalars['Boolean'];
  status: ProjectStatusDetail;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  project?: Maybe<Project>;
  googleDriveFolderId?: Maybe<Scalars['String']>;
  salesforceAccountId?: Maybe<Scalars['String']>;
  salesforceOpportunities: Array<ProjectSalesforceOpportunity>;
  projectStatusChange?: Maybe<ProjectStatusChange>;
  planRoomLink?: Maybe<Scalars['String']>;
  isDisaster?: Maybe<Scalars['Boolean']>;
  intakeStyleNotes?: Maybe<Scalars['String']>;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  productType?: Maybe<ProductType>;
  enableSchedulesV2: Scalars['Boolean'];
  tradePartners: Array<TradePartner>;
  jobLogs: Array<JobLog>;
  salesforcePropertyId?: Maybe<Scalars['String']>;
  schedules: Array<Schedule>;
  expenses: Array<Expense>;
  unallocatedExpenses: Array<Expense>;
  unallocatedAmountInCents: Scalars['Int'];
  enableSchedulesV2Gantt: Scalars['Boolean'];
  enableSchedulesCalendar: Scalars['Boolean'];
  readyPlanConfig?: Maybe<ProjectReadyPlanConfig>;
  earnedValueCurves: Array<EarnedValueCurve>;
  enableBidPackagesV2: Scalars['Boolean'];
  invoiceSettings?: Maybe<ProjectInvoiceSetting>;
  scopeMode: ScopeModeDetail;
  lotPartitionId?: Maybe<Scalars['String']>;
  budgetFinancials: ProjectBudgetFinancials;
  enableDelayFlags: Scalars['Boolean'];
  warrantyStartDate?: Maybe<Scalars['Date']>;
  verticalCompleteDate?: Maybe<Scalars['Date']>;
  jobLogInsights: ProjectJobLogInsights;
  targetEndDate?: Maybe<Scalars['Date']>;
  latestActiveStage?: Maybe<ProjectStage>;
  primaryHomeowner?: Maybe<Client>;
  toDos?: Maybe<Array<ToDo>>;
  lotDetail: ProjectLotDetail;
  siteSpecificInfos: Array<ProjectSiteSpecificInfo>;
  projectSiteCondition?: Maybe<ProjectSiteCondition>;
  unassignedTaskCount: Scalars['Int'];
  enableHomeownerNotes: Scalars['Boolean'];
  checkoutCustomerConfigId?: Maybe<Scalars['String']>;
  canEditJobLogs: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  canHaveBudget: PotentialOperation2;
  homeownerNotes: Array<HomeownerNote>;
  enableHomeownerJourneyV2: Scalars['Boolean'];
  featureFlags: Array<FeatureFlag>;
  homeownerDeliveryDate?: Maybe<Scalars['Date']>;
  tasksCompletedThisWeek: Scalars['Int'];
  contacts: Array<ProjectContact>;
  warrantyTickets: Array<WarrantyTicket>;
  shouldAccrueAsComplete: Scalars['Boolean'];
  directCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']>;
  indirectCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']>;
  customer?: Maybe<Customer>;
  customerOwnerEntity?: Maybe<CustomerOwnerEntity>;
  invoiceSchedule?: Maybe<InvoiceSchedule>;
  allowExcludedCostCodesOnPurchaseOrders: Scalars['Boolean'];
  enableProductConfigPlan: Scalars['Boolean'];
  planSchedule?: Maybe<PlanSchedule>;
  builder?: Maybe<Builder>;
  bidOutPercentage: Scalars['Int'];
  enableChangeEventSignatures: Scalars['Boolean'];
  enablePocInvoiceSchedule: Scalars['Boolean'];
  softCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  indirectHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  directHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  legalDescription?: Maybe<Scalars['String']>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']>;
  salesTaxInBasisPoints: Scalars['Int'];
  projectItemAllocations: Array<ProjectItemAllocation>;
  allocationRules: Array<ProjectAllocationRule>;
  warrantyLengthInDays: Scalars['Int'];
  warrantyOverrideLengthInDays?: Maybe<Scalars['Int']>;
  bidPackages: Array<BidPackage>;
  bidContracts: Array<BidContract>;
  homeownerContracts: Array<HomeownerContract>;
  documents: Array<Document>;
  commitments: Array<Commitment>;
  directCostInCents: Scalars['Int'];
  directPriceInCents: Scalars['Int'];
  totalHardCostInCents: Scalars['Int'];
  totalSoftCostInCents: Scalars['Int'];
  totalCostInCents: Scalars['Int'];
  totalPriceInCents: Scalars['Int'];
  readyToStartDate?: Maybe<Scalars['Date']>;
  committedCostCodesAtStartInBasisPoints?: Maybe<Scalars['Int']>;
  directCostAtStartInCents?: Maybe<Scalars['Int']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']>;
  uncommittedCostInCents: Scalars['Int'];
  snapshots: Array<ProjectSnapshot>;
  warrantyEndDate?: Maybe<Scalars['Date']>;
  companyInfo: CompanyInfo;
  invoicePaymentNetDays: Scalars['Int'];
  /**  return the first snapshot before or on the given date  */
  snapshotAsOf?: Maybe<ProjectSnapshot>;
  purchaseCostInCents?: Maybe<Scalars['Int']>;
  grossSalesPriceInCents?: Maybe<Scalars['Int']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']>;
  projectCostCodes: Array<ProjectCostCode>;
  /** Hierarchy Navigation */
  parentsRecursive: Array<Project>;
  childrenRecursive: Array<Project>;
  siblingProjects: Array<Project>;
  sellableProjects: Array<Project>;
  isSellableProject: Scalars['Boolean'];
  /** Hierarchy Budget Page Fields */
  originalCostInCents: Scalars['Int'];
  startCostInCents: Scalars['Int'];
  changeEventCostInCents: Scalars['Int'];
  projectedCostInCents: Scalars['Int'];
  revisedCostInCents: Scalars['Int'];
  committedCostInCents: Scalars['Int'];
  availableCostInCents: Scalars['Int'];
  billedCostInCents: Scalars['Int'];
  unbilledCostInCents: Scalars['Int'];
  /**
   * Deprecated fields for StandaloneProject. Do not add new fields below this.
   * @deprecated only implemented for StandaloneProject
   */
  cohort?: Maybe<Cohort>;
  /** @deprecated only implemented for StandaloneProject */
  constructionConfidenceFactor?: Maybe<Scalars['Int']>;
  /** @deprecated only implemented for StandaloneProject */
  lotRating?: Maybe<LotRating>;
  /** @deprecated only implemented for StandaloneProject */
  preConBudgetLineItems: Array<PreConBudgetCostDivisionLineItem>;
  /** @deprecated only implemented for StandaloneProject */
  preconContractType?: Maybe<PreconContractType>;
  /** @deprecated only implemented for StandaloneProject */
  quickbooksCustomerId?: Maybe<Scalars['String']>;
  /** @deprecated only implemented for StandaloneProject */
  shadowProjects: Array<Project>;
  /** @deprecated only implemented for StandaloneProject */
  submarket?: Maybe<Submarket>;
  /**
   * Deprecated fields. Do not add new fields below this.
   * @deprecated homeowner can be accessed through collaborators
   */
  client?: Maybe<Client>;
  /** @deprecated replaced by blueprintUrl */
  url: Scalars['String'];
  /**
   *  The same as name, just a previous name.
   * @deprecated replaced by name.
   */
  projectName: Scalars['String'];
  /** @deprecated replaced by activeSalesforceOpportunity */
  salesforceId?: Maybe<Scalars['String']>;
  /** @deprecated This field is being removed from our SFDC data model */
  activeSalesforceOpportunity?: Maybe<ProjectSalesforceOpportunity>;
  /** @deprecated use lotType instead */
  dictionary: ProjectDictionary;
  suburbanAssetCategory?: Maybe<SuburbanAssetCategoryDetail>;
  lotSalesStatus?: Maybe<LotSalesStatusDetail>;
};


export type StructureTeamMembersArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']>;
};


export type StructureStagesArgs = {
  stage?: InputMaybe<Stage>;
  filter?: InputMaybe<ProjectStagesFilter>;
};


export type StructureStageArgs = {
  stage: Stage;
};


export type StructureAvailableAssigneesArgs = {
  role?: InputMaybe<ProjectRole>;
};


export type StructureToDosArgs = {
  type?: InputMaybe<ToDoType>;
};


export type StructureDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};


export type StructureSnapshotAsOfArgs = {
  date: Scalars['Date'];
};


export type StructureOriginalCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StructureStartCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StructureChangeEventCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StructureProjectedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StructureRevisedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StructureCommittedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StructureAvailableCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StructureBilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StructureUnbilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StructurePreConBudgetLineItemsArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']>;
};

export type Unit = CanCollaborate & Commentable & Referencable & Followable & Project & HasBlueprintUrl & Named & HasDisplayName & MaybeHasProject & HasSchedules & Entity & HasHopUrl & {
  __typename?: 'Unit';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Overridden fields from Project */
  buildAddress: Address;
  market: Market;
  parent: Structure;
  /** Inherited fields from Project */
  collaborators: Array<ProjectCollaborator>;
  coverImage?: Maybe<Asset>;
  teamMembers: Array<ProjectTeamMember>;
  projectLead?: Maybe<ProjectTeamMember>;
  activeStage: StageDetail;
  activeProjectStage?: Maybe<ProjectStage>;
  stages: Array<ProjectStage>;
  stage: ProjectStage;
  blueprintUrl: Url;
  hopUrl: Scalars['String'];
  /**  The address + client name  */
  name: Scalars['String'];
  displayName: Scalars['String'];
  availableAssignees: Array<InternalUser>;
  startDate: Scalars['Date'];
  /**  list of features which are enabled on this project  */
  features: Array<ProjectFeature>;
  isTest: Scalars['Boolean'];
  status: ProjectStatusDetail;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  project?: Maybe<Project>;
  googleDriveFolderId?: Maybe<Scalars['String']>;
  salesforceAccountId?: Maybe<Scalars['String']>;
  salesforceOpportunities: Array<ProjectSalesforceOpportunity>;
  projectStatusChange?: Maybe<ProjectStatusChange>;
  planRoomLink?: Maybe<Scalars['String']>;
  isDisaster?: Maybe<Scalars['Boolean']>;
  intakeStyleNotes?: Maybe<Scalars['String']>;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  productType?: Maybe<ProductType>;
  enableSchedulesV2: Scalars['Boolean'];
  tradePartners: Array<TradePartner>;
  jobLogs: Array<JobLog>;
  salesforcePropertyId?: Maybe<Scalars['String']>;
  schedules: Array<Schedule>;
  expenses: Array<Expense>;
  unallocatedExpenses: Array<Expense>;
  unallocatedAmountInCents: Scalars['Int'];
  enableSchedulesV2Gantt: Scalars['Boolean'];
  enableSchedulesCalendar: Scalars['Boolean'];
  readyPlanConfig?: Maybe<ProjectReadyPlanConfig>;
  earnedValueCurves: Array<EarnedValueCurve>;
  enableBidPackagesV2: Scalars['Boolean'];
  invoiceSettings?: Maybe<ProjectInvoiceSetting>;
  scopeMode: ScopeModeDetail;
  lotPartitionId?: Maybe<Scalars['String']>;
  budgetFinancials: ProjectBudgetFinancials;
  enableDelayFlags: Scalars['Boolean'];
  warrantyStartDate?: Maybe<Scalars['Date']>;
  verticalCompleteDate?: Maybe<Scalars['Date']>;
  jobLogInsights: ProjectJobLogInsights;
  targetEndDate?: Maybe<Scalars['Date']>;
  latestActiveStage?: Maybe<ProjectStage>;
  primaryHomeowner?: Maybe<Client>;
  toDos?: Maybe<Array<ToDo>>;
  lotDetail: ProjectLotDetail;
  siteSpecificInfos: Array<ProjectSiteSpecificInfo>;
  projectSiteCondition?: Maybe<ProjectSiteCondition>;
  unassignedTaskCount: Scalars['Int'];
  enableHomeownerNotes: Scalars['Boolean'];
  checkoutCustomerConfigId?: Maybe<Scalars['String']>;
  canEditJobLogs: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  canHaveBudget: PotentialOperation2;
  homeownerNotes: Array<HomeownerNote>;
  enableHomeownerJourneyV2: Scalars['Boolean'];
  featureFlags: Array<FeatureFlag>;
  homeownerDeliveryDate?: Maybe<Scalars['Date']>;
  tasksCompletedThisWeek: Scalars['Int'];
  contacts: Array<ProjectContact>;
  warrantyTickets: Array<WarrantyTicket>;
  shouldAccrueAsComplete: Scalars['Boolean'];
  directCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']>;
  indirectCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']>;
  customer?: Maybe<Customer>;
  customerOwnerEntity?: Maybe<CustomerOwnerEntity>;
  invoiceSchedule?: Maybe<InvoiceSchedule>;
  allowExcludedCostCodesOnPurchaseOrders: Scalars['Boolean'];
  enableProductConfigPlan: Scalars['Boolean'];
  planSchedule?: Maybe<PlanSchedule>;
  builder?: Maybe<Builder>;
  bidOutPercentage: Scalars['Int'];
  enableChangeEventSignatures: Scalars['Boolean'];
  enablePocInvoiceSchedule: Scalars['Boolean'];
  softCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  indirectHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  directHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']>;
  legalDescription?: Maybe<Scalars['String']>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']>;
  salesTaxInBasisPoints: Scalars['Int'];
  projectItemAllocations: Array<ProjectItemAllocation>;
  allocationRules: Array<ProjectAllocationRule>;
  warrantyLengthInDays: Scalars['Int'];
  warrantyOverrideLengthInDays?: Maybe<Scalars['Int']>;
  bidPackages: Array<BidPackage>;
  bidContracts: Array<BidContract>;
  homeownerContracts: Array<HomeownerContract>;
  documents: Array<Document>;
  commitments: Array<Commitment>;
  directCostInCents: Scalars['Int'];
  directPriceInCents: Scalars['Int'];
  totalHardCostInCents: Scalars['Int'];
  totalSoftCostInCents: Scalars['Int'];
  totalCostInCents: Scalars['Int'];
  totalPriceInCents: Scalars['Int'];
  readyToStartDate?: Maybe<Scalars['Date']>;
  committedCostCodesAtStartInBasisPoints?: Maybe<Scalars['Int']>;
  directCostAtStartInCents?: Maybe<Scalars['Int']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']>;
  uncommittedCostInCents: Scalars['Int'];
  snapshots: Array<ProjectSnapshot>;
  warrantyEndDate?: Maybe<Scalars['Date']>;
  companyInfo: CompanyInfo;
  invoicePaymentNetDays: Scalars['Int'];
  /**  return the first snapshot before or on the given date  */
  snapshotAsOf?: Maybe<ProjectSnapshot>;
  purchaseCostInCents?: Maybe<Scalars['Int']>;
  grossSalesPriceInCents?: Maybe<Scalars['Int']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']>;
  projectCostCodes: Array<ProjectCostCode>;
  /** Hierarchy Navigation */
  children: Array<Project>;
  parentsRecursive: Array<Project>;
  childrenRecursive: Array<Project>;
  siblingProjects: Array<Project>;
  sellableProjects: Array<Project>;
  isSellableProject: Scalars['Boolean'];
  /** Hierarchy Budget Page Fields */
  originalCostInCents: Scalars['Int'];
  startCostInCents: Scalars['Int'];
  changeEventCostInCents: Scalars['Int'];
  projectedCostInCents: Scalars['Int'];
  revisedCostInCents: Scalars['Int'];
  committedCostInCents: Scalars['Int'];
  availableCostInCents: Scalars['Int'];
  billedCostInCents: Scalars['Int'];
  unbilledCostInCents: Scalars['Int'];
  /**
   * Deprecated fields for StandaloneProject. Do not add new fields below this.
   * @deprecated only implemented for StandaloneProject
   */
  cohort?: Maybe<Cohort>;
  /** @deprecated only implemented for StandaloneProject */
  constructionConfidenceFactor?: Maybe<Scalars['Int']>;
  /** @deprecated only implemented for StandaloneProject */
  lotRating?: Maybe<LotRating>;
  /** @deprecated only implemented for StandaloneProject */
  preConBudgetLineItems: Array<PreConBudgetCostDivisionLineItem>;
  /** @deprecated only implemented for StandaloneProject */
  preconContractType?: Maybe<PreconContractType>;
  /** @deprecated only implemented for StandaloneProject and Structure */
  primaryProject?: Maybe<Project>;
  /** @deprecated only implemented for StandaloneProject */
  quickbooksCustomerId?: Maybe<Scalars['String']>;
  /** @deprecated only implemented for StandaloneProject */
  shadowProjects: Array<Project>;
  /** @deprecated only implemented for StandaloneProject */
  submarket?: Maybe<Submarket>;
  /**
   * Deprecated fields. Do not add new fields below this.
   * @deprecated homeowner can be accessed through collaborators
   */
  client?: Maybe<Client>;
  /** @deprecated replaced by blueprintUrl */
  url: Scalars['String'];
  /**
   *  The same as name, just a previous name.
   * @deprecated replaced by name.
   */
  projectName: Scalars['String'];
  /** @deprecated replaced by activeSalesforceOpportunity */
  salesforceId?: Maybe<Scalars['String']>;
  /** @deprecated This field is being removed from our SFDC data model */
  activeSalesforceOpportunity?: Maybe<ProjectSalesforceOpportunity>;
  /** @deprecated use lotType instead */
  dictionary: ProjectDictionary;
};


export type UnitTeamMembersArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']>;
};


export type UnitStagesArgs = {
  stage?: InputMaybe<Stage>;
  filter?: InputMaybe<ProjectStagesFilter>;
};


export type UnitStageArgs = {
  stage: Stage;
};


export type UnitAvailableAssigneesArgs = {
  role?: InputMaybe<ProjectRole>;
};


export type UnitToDosArgs = {
  type?: InputMaybe<ToDoType>;
};


export type UnitDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};


export type UnitSnapshotAsOfArgs = {
  date: Scalars['Date'];
};


export type UnitOriginalCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type UnitStartCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type UnitChangeEventCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type UnitProjectedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type UnitRevisedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type UnitCommittedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type UnitAvailableCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type UnitBilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type UnitUnbilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type UnitPreConBudgetLineItemsArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectItem = CanCollaborate & Commentable & Referencable & Followable & ProjectItemLike & Named & HasDisplayName & HasBlueprintUrl & MaybeHasProject & {
  __typename?: 'ProjectItem';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  projectStage: ProjectStage;
  slot: ItemSlot;
  item: Item;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /** @deprecated Replaced by totalMarkupInCents */
  markupInCents: Scalars['Int'];
  /** @deprecated Replaced by unitPriceInCents */
  priceInCents: Scalars['Int'];
  /** @deprecated Replaced by unitCostInCents */
  costInCents: Scalars['Int'];
  unitCostInCents: Scalars['Int'];
  unitPriceInCents: Scalars['Int'];
  totalCostInCents: Scalars['Int'];
  totalPriceInCents: Scalars['Int'];
  totalMarkupInCents: Scalars['Int'];
  markupBasisPoints?: Maybe<Scalars['Int']>;
  projectMarkupBasisPoints: Scalars['Int'];
  quantity?: Maybe<Scalars['Int']>;
  location: Location;
  quantityCalculated?: Maybe<Scalars['Int']>;
  billedBills: Array<Bill>;
  bills: Array<Bill>;
  /**  A derived display name incorporating the cost code and item code as well as its name  */
  displayName: Scalars['String'];
  billLineItems: Array<BillLineItem>;
  commitmentLineItems: Array<CommitmentLineItem>;
  signedCommitmentLineItems: Array<CommitmentLineItem>;
  /**  The total signed commitments.  */
  totalCommittedCostInCents: Scalars['Int'];
  /**  The total of signed/draft/send, but not voided, commitments.  */
  allCommittedCostInCents: Scalars['Int'];
  costType: CostType;
  costTypeDetail: CostTypeDetail;
  estimateLineItems: Array<EstimateLineItem>;
  blueprintUrl: Url;
  unitOfMeasure: UnitOfMeasure;
  homeownerPaidInCents?: Maybe<Scalars['Int']>;
  tradePartnerNote?: Maybe<Scalars['String']>;
  specifications?: Maybe<Scalars['String']>;
  history: Array<History>;
  changeEventLineItems: Array<ChangeEventLineItem>;
  isPendingChangeEvent: Scalars['Boolean'];
  internalNote?: Maybe<Scalars['String']>;
  project: Project;
  costConfidence: CostConfidenceDetail;
  buyoutStatus: BuyoutStatus;
  buyoutStatusDetail: BuyoutStatusDetail;
  canEditCost: PotentialOperation2;
  protoCommitmentLineItemToBuyout?: Maybe<ProtoCommitmentLineItemToBuyout>;
  scopeHistory: Array<ProjectItemScopeChange>;
  canEditScope: PotentialOperation2;
  canEditName: PotentialOperation2;
  canEditCostConfidence: PotentialOperation2;
  canEditBuyoutStatus: PotentialOperation2;
  itemTemplateItem?: Maybe<BaseItemLike>;
  modifyingTemplateItems: Array<BaseItemLike>;
  task?: Maybe<Task>;
  currentTradePartner?: Maybe<TradePartner>;
  currentCommitment?: Maybe<CommitmentLike>;
  originalBudgetInCents: Scalars['Int'];
  originalPriceInCents: Scalars['Int'];
  contractBudgetChangesInCents: Scalars['Int'];
  budgetReallocationsInCents: Scalars['Int'];
  revisedApprovedBudgetInCents: Scalars['Int'];
  uncommittedBudgetAmountInCents: Scalars['Int'];
  unbilledCommittedInCents: Scalars['Int'];
  /** @deprecated renamed to tradeBilledInCents */
  actualCostInCents: Scalars['Int'];
  costToCompleteInCents: Scalars['Int'];
  homeownerContractLineItems: Array<HomeownerContractLineItem>;
  internalBudgetChangeInCents: Scalars['Int'];
  /**  The pre-negotiated bid contract that is currently delivering this ProjectItem.  */
  bidContractLineItem?: Maybe<BidContractLineItem>;
  /**  The BCLI might already be set, but once a non-finalized, non-draft CE merges it might update the PI so that becomes the Probable BCLI.  */
  probableBidContractLineItem?: Maybe<BidContractLineItem>;
  /**  The bid contract line items that are available to deliver this ProjectItem's scope.  */
  potentialBidContractLineItems: Array<PotentialBidContractLineItem>;
  /**  This is a single selection from `potentialBidContractLineItems` that is a preferred choice to default to  */
  preferredPotentialBidContractLineItem?: Maybe<PotentialBidContractLineItem>;
  /**  If this ProjectItem has applied from a ReadyHome template, i.e. it will be locked, and can be bid on via a BidContract. */
  isFromReadyHomeTemplate: Scalars['Boolean'];
  /**  If this ProjectItem has originally in the contract, but has subsequently been removed by a ChangeEvent. */
  isRemovedScope: Scalars['Boolean'];
  expenseAllocations: Array<ExpenseAllocation>;
  /** @deprecated redundant and will be removed after budget screen rework */
  budgetRollupInCents: BudgetPhaseRollup;
  prebidBudgetChangeInCents: Scalars['Int'];
  awardedBudgetChangeInCents: Scalars['Int'];
  revisedBudgetChangeInCents: Scalars['Int'];
  costLineItems: Array<CostLineItem>;
  workAuthorizations: Array<WorkAuthorization>;
  bidItem?: Maybe<BidItem>;
  externalBudgetChangeInCents: Scalars['Int'];
  budgetFinancials: ProjectItemBudgetFinancials;
  tradePartnerPaidInCents: Scalars['Int'];
  tradeBilledInCents: Scalars['Int'];
  canAssignBidContractLineItem: PotentialOperation2;
  currentPriceInCents: Scalars['Int'];
  allocationReason?: Maybe<Scalars['String']>;
  configuredOptions: Array<ReadyPlanOption>;
  baseOrOptionName: Scalars['String'];
  materialVariant?: Maybe<MaterialVariant>;
  lastAcceptedChangeEventLineItem?: Maybe<ChangeEventLineItem>;
  allocations: Array<ProjectItemAllocation>;
  directCostAtStartInCents?: Maybe<Scalars['Int']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']>;
  projectCostCode: ProjectCostCode;
  /** Hierarchy Budget Fields */
  originalCostInCents: Scalars['Int'];
  startCostInCents: Scalars['Int'];
  changeEventCostInCents: Scalars['Int'];
  revisedCostInCents: Scalars['Int'];
  revisedPriceInCents: Scalars['Int'];
  projectedCostInCents: Scalars['Int'];
  committedCostInCents: Scalars['Int'];
  availableCostInCents: Scalars['Int'];
  billedCostInCents: Scalars['Int'];
  unbilledCostInCents: Scalars['Int'];
  bidTask?: Maybe<GlobalPlanTask>;
  packageDesignNotes?: Maybe<Scalars['String']>;
};

export type Estimate = CanCollaborate & Commentable & Referencable & Followable & HasBlueprintUrl & Named & MaybeHasProject & {
  __typename?: 'Estimate';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  blueprintUrl: Url;
  status: EstimateStatusDetail;
  type: EstimateTypeDetail;
  projectStage: ProjectStage;
  lineItems: Array<EstimateLineItem>;
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  totalCostInCents: Scalars['Int'];
  totalMarkupInCents: Scalars['Int'];
  totalPriceInCents: Scalars['Int'];
  project: Project;
  changeEvent?: Maybe<ChangeEvent>;
  history: Array<History>;
  homeownerContractChangeOrder?: Maybe<HomeownerContractChangeOrder>;
  canEditStatus: PotentialOperation2;
  softCostInCents: Scalars['Int'];
  hardCostInCents: Scalars['Int'];
  directHardCostInCents: Scalars['Int'];
  indirectHardCostInCents: Scalars['Int'];
  annotatedCosts: Array<AnnotatedCost>;
};

export type DevelopmentCommitment = CanCollaborate & Commentable & Referencable & Followable & HasBlueprintUrl & Named & HasPandaDoc & {
  __typename?: 'DevelopmentCommitment';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  tradePartner?: Maybe<TradePartner>;
  projects: Array<Project>;
  commitments: Array<Commitment>;
  tradeCategories: Array<TradeCategory>;
  market: Market;
  status: CommitmentStatus;
  statusDetail: CommitmentStatusDetail;
  statusText: Scalars['String'];
  type?: Maybe<DevelopmentCommitmentType>;
  typeDetail?: Maybe<DevelopmentCommitmentTypeDetail>;
  name: Scalars['String'];
  executionDate?: Maybe<Scalars['Date']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  releasedDate?: Maybe<Scalars['Date']>;
  /** @deprecated use releasedDate instead */
  releasedAt?: Maybe<Scalars['Date']>;
  contractExhibits?: Maybe<Scalars['String']>;
  contractSchedule?: Maybe<Scalars['String']>;
  contractTerms?: Maybe<Scalars['String']>;
  contractExclusions?: Maybe<Scalars['String']>;
  committedInCents: Scalars['Int'];
  pandaDoc?: Maybe<PandaDoc>;
  headOfConstruction?: Maybe<InternalUser>;
  homeboundAuthorizedSignatory?: Maybe<InternalUser>;
  conOpsProjectManager?: Maybe<InternalUser>;
  areaManager?: Maybe<InternalUser>;
  canCreatePandaDoc: PotentialOperation2;
  history: Array<History>;
  summary: DevelopmentCommitmentSummary;
  blueprintUrl: Url;
  stage: Stage;
  stageDetail: StageDetail;
  costTypes?: Maybe<Array<CostTypeDetail>>;
  internalNote?: Maybe<Scalars['String']>;
  costCodes: Array<CostCode>;
  costCodeSummary: Array<DevelopmentCommitmentCostCodeSummary>;
  canBeEdited: Scalars['Boolean'];
  development: Development;
  document?: Maybe<Document>;
  signatoryContact?: Maybe<TradePartnerContact>;
};

export type Commitment = CanCollaborate & Commentable & Referencable & Followable & Entity & CommitmentLike & Named & HasDisplayName & HasBlueprintUrl & HasPandaDoc & {
  __typename?: 'Commitment';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  accountingNumber: Scalars['Int'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  shortName: Scalars['String'];
  commitmentType: CommitmentTypeDetail;
  projectStage: ProjectStage;
  tradePartner?: Maybe<TradePartner>;
  internalNote?: Maybe<Scalars['String']>;
  costChangeInCents: Scalars['Int'];
  executionDate?: Maybe<Scalars['Date']>;
  createdAt: Scalars['DateTime'];
  document?: Maybe<Document>;
  pandaDoc?: Maybe<PandaDoc>;
  canCreatePandaDoc: PotentialOperation2;
  changeOrders: Array<CommitmentChangeOrder>;
  lineItems: Array<CommitmentLineItem>;
  bills: Array<Bill>;
  expenseAllocations: Array<ExpenseAllocation>;
  lineItemSummaries: Array<CommitmentLineItemSummary>;
  /**  Just the initial contract w/o any change orders (an alias of costChangeInCents)  */
  committedInCents: Scalars['Int'];
  taxableCostInCents: Scalars['Int'];
  remainingInCents: Scalars['Int'];
  pendingRemainingInCents: Scalars['Int'];
  billedInCents?: Maybe<Scalars['Int']>;
  pendingBilledInCents?: Maybe<Scalars['Int']>;
  unbilledInCents: Scalars['Int'];
  paidInCents?: Maybe<Scalars['Int']>;
  balanceInCents?: Maybe<Scalars['Int']>;
  blueprintUrl: Url;
  project: Project;
  protoCommitmentLineItemsToBuyout: Array<ProtoCommitmentLineItemToBuyout>;
  hasPartiallyBoughtOutScope: Scalars['Boolean'];
  status: CommitmentStatus;
  statusDetail: CommitmentStatusDetail;
  statusText: Scalars['String'];
  developmentCommitment?: Maybe<DevelopmentCommitment>;
  contractExhibits?: Maybe<Scalars['String']>;
  contractSchedule?: Maybe<Scalars['String']>;
  contractTerms?: Maybe<Scalars['String']>;
  contractExclusions?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  tradeCategories: Array<TradeCategory>;
  costTypes: Array<CostTypeDetail>;
  costCodeSummary: CommitmentCostCodeSummary;
  changeEvent?: Maybe<ChangeEvent>;
  canEditLineItems: PotentialOperation2;
  canBeReleased: PotentialOperation2;
  canBeReleasedWithinBudget: PotentialOperation2;
  isBidCommitment: Scalars['Boolean'];
  bidContractRevision?: Maybe<BidContractRevision>;
  canBeVoided: PotentialOperation2;
  canDelete: PotentialOperation2;
  canBeEdited: Scalars['Boolean'];
  costCodes: Array<CostCode>;
  items: Array<Item>;
  potentialBidContractRevisions: Array<PotentialBidContractRevision>;
  pandaDocRecipients: Array<PandaDocIntendedRecipient>;
  preferredBidContractRevision?: Maybe<PotentialBidContractRevision>;
  history?: Maybe<Array<History>>;
  tradeSignatory?: Maybe<TradePartnerContact>;
  readyPlanConfigOptions?: Maybe<Array<ProjectReadyPlanConfigOption>>;
  percentagePaid: Scalars['Int'];
  releaseWhenReady?: Maybe<Scalars['Boolean']>;
  eventuallyVoidedBy?: Maybe<Commitment>;
  voidsCommitments: Array<Commitment>;
  sentDate?: Maybe<Scalars['Date']>;
  depositInBasisPoints?: Maybe<Scalars['Float']>;
  depositScheduleTask?: Maybe<Task>;
  depositBill?: Maybe<Bill>;
  referenceNumber?: Maybe<Scalars['String']>;
  drop?: Maybe<Drop>;
  draws: Array<CommitmentDraw>;
  canEditDraws: PotentialOperation2;
  billingSchedule: Array<CommitmentBillingScheduleItem>;
};

export type Document = CanCollaborate & Commentable & Referencable & Followable & Entity & Named & HasDisplayName & HasBlueprintUrl & {
  __typename?: 'Document';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  documentType: DocumentTypeDetail;
  name: Scalars['String'];
  sizeInBytes: Scalars['Int'];
  /** @deprecated Use `asset` field */
  url: Scalars['String'];
  displayName: Scalars['String'];
  homeownerVisible: Scalars['Boolean'];
  asset: Asset;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: User;
  pandaDoc?: Maybe<PandaDoc>;
  assets: Array<Asset>;
  canDelete: PotentialOperation2;
  isDeleted?: Maybe<Scalars['Boolean']>;
  parent: DocumentParent;
  category: DocumentCategory;
  categoryDetail?: Maybe<DocumentCategoryDetail>;
  tasks: Array<Task>;
  isFavorited: Scalars['Boolean'];
  blueprintUrl: Url;
  issuanceDate?: Maybe<Scalars['Date']>;
  ownerWorkAuthorization?: Maybe<WorkAuthorization>;
  /**  Projects connected to a document via the ProjectDocumentAssociations entity. Must be in the document's development. */
  associatedProjects: Array<Project>;
  owner?: Maybe<DocumentOwner>;
  homeownerContract?: Maybe<HomeownerContract>;
  homeownerContractChangeOrder?: Maybe<HomeownerContractChangeOrder>;
  attachOn: Array<DocumentAttachmentPlace>;
  lienWaiver?: Maybe<LienWaiver>;
  active: Scalars['Boolean'];
  canEdit: PotentialOperation2;
  canArchive: PotentialOperation2;
};

export type ItemTemplateItemVersion = CanCollaborate & Commentable & Referencable & Followable & Named & HasDisplayName & HasBlueprintUrl & BaseItemLike & {
  __typename?: 'ItemTemplateItemVersion';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  identityId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  template: ItemTemplate;
  scope: ItemTemplateItem;
  scopeChangeType: ScopeChangeType;
  scopeChangeTypeDetail: ScopeChangeTypeDetail;
  scopeChangeReason?: Maybe<ScopeChangeReason>;
  slot: ItemSlot;
  item: Item;
  location: Location;
  quantity?: Maybe<Scalars['Int']>;
  costType: CostType;
  costTypeDetail: CostTypeDetail;
  specifications?: Maybe<Scalars['String']>;
  unitOfMeasure: UnitOfMeasure;
  tradePartnerNote?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  displayName: Scalars['String'];
  parent: ItemTemplate;
  readyPlan: ReadyPlanLike;
  first: ItemTemplate;
  basedOn?: Maybe<ItemTemplateItem>;
  totalCostInCents: Scalars['Int'];
  unitCostInCents: Scalars['Int'];
  canDeleteItem: PotentialOperation2;
  canEdit: PotentialOperation2;
  preferredBidContractLineItem?: Maybe<BidContractLineItem>;
  bidItem?: Maybe<BidItem>;
  bidItemTemplateItem?: Maybe<ItemTemplateItem>;
  potentialBidItems: Array<BidItem>;
  /**  Helper for the FE multi-select dropdown  */
  elevationIds: Array<Scalars['ID']>;
  /**  Helper for the FE multi-select dropdown  */
  specOptionIds: Array<Scalars['ID']>;
  /**  Helper for the FE multi-select dropdown  */
  otherOptionIds: Array<Scalars['ID']>;
  /**  All of the elevation + specOption + option RPOs as a single list.  */
  options: Array<ReadyPlanOption>;
  customPlaceholderName?: Maybe<Scalars['String']>;
  blueprintUrl: Url;
  scopeChangeReasonNote?: Maybe<Scalars['String']>;
  task?: Maybe<GlobalPlanTask>;
  materialVariant?: Maybe<MaterialVariant>;
  development?: Maybe<Development>;
  costEstimate: CostEstimate;
};

export type JobLogNote = CanCollaborate & Commentable & Referencable & Followable & Entity & Named & HasBlueprintUrl & {
  __typename?: 'JobLogNote';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  blueprintUrl: Url;
  title?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type?: Maybe<JobLogNoteType>;
  typeDetail?: Maybe<JobLogNoteTypeDetail>;
  internalUser: InternalUser;
  jobLog: JobLog;
  tradePartner?: Maybe<TradePartner>;
  jobLogImages?: Maybe<Array<JobLogImage>>;
  flags: Array<JobLogFlag>;
  scheduleTasks: Array<ScheduleTask>;
  history: Array<History>;
  clientPlatform: ClientPlatformDetail;
  additionalContext?: Maybe<Scalars['JSONObject']>;
  summarizedByAiNote?: Maybe<JobLogNote>;
  summarizedNotes: Array<JobLogNote>;
};

export type TradePartnerAvailabilityRequest = CanCollaborate & Commentable & Referencable & Followable & Named & HasBlueprintUrl & {
  __typename?: 'TradePartnerAvailabilityRequest';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  blueprintUrl: Url;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  internalUser: InternalUser;
  task: Task;
  tradePartnerContacts: Array<TradePartnerContact>;
  tradePartnerConfirmationDate?: Maybe<Scalars['Date']>;
  emails: Array<TradePartnerAvailabilityRequestEmail>;
  textMessages: Array<TradePartnerAvailabilityRequestTextMessage>;
  rescheduleDates?: Maybe<Array<Scalars['Date']>>;
  status: TradePartnerAvailabilityRequestStatusDetail;
  tradePartner: TradePartner;
  canSave: PotentialOperation2;
  rescheduleReasonNote?: Maybe<Scalars['String']>;
};

export type PunchlistItemTodo = CanCollaborate & Commentable & Referencable & Followable & Entity & Named & HasBlueprintUrl & {
  __typename?: 'PunchlistItemTodo';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  dueDate?: Maybe<Scalars['Date']>;
  order: Scalars['String'];
  urgent: Scalars['Boolean'];
  status: ToDoStatusDetail;
  type: ToDoTypeDetail;
  createdBy: User;
  attachments: Array<Attachment>;
  assignees: Array<User>;
  parent?: Maybe<ToDoParent>;
  location?: Maybe<Location>;
  tradePartner?: Maybe<TradePartner>;
  blueprintUrl: Url;
};

export type WarrantyTicket = CanCollaborate & Commentable & Referencable & Followable & HasBlueprintUrl & Named & {
  __typename?: 'WarrantyTicket';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  type?: Maybe<WarrantyTicketTypeDetail>;
  project: Project;
  projectContacts: Array<ProjectContact>;
  availabilities: Array<WarrantyTicketAvailability>;
  items: Array<WarrantyTicketItem>;
  title: Scalars['String'];
  homeownerVisible: Scalars['Boolean'];
  blueprintUrl: Url;
  urgent: Scalars['Boolean'];
  history: Array<History>;
  attachments: Array<Attachment>;
  totalItems: Scalars['Int'];
  totalAvailableItems: Scalars['Int'];
  totalCompletedItems: Scalars['Int'];
  totalRejectedItems: Scalars['Int'];
  status: WarrantyTicketStatusDetail;
  assignees: Array<InternalUser>;
};


export type WarrantyTicketItemsArgs = {
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
  statuses?: InputMaybe<Array<WarrantyTicketItemStatus>>;
  createdDateRange?: InputMaybe<DateFilter2>;
};

export type HomeownerContract = CanCollaborate & Commentable & Referencable & Followable & Named & HomeownerContractLike & HasBlueprintUrl & MaybeHasProject & {
  __typename?: 'HomeownerContract';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  projectStage: ProjectStage;
  name: Scalars['String'];
  internalNote?: Maybe<Scalars['String']>;
  priceChangeInCents: Scalars['Int'];
  budgetChangeInCents: Scalars['Int'];
  invoicedInCents?: Maybe<Scalars['Int']>;
  amountPaidInCents?: Maybe<Scalars['Int']>;
  balanceInCents?: Maybe<Scalars['Int']>;
  uninvoicedInCents?: Maybe<Scalars['Int']>;
  executionDate?: Maybe<Scalars['Date']>;
  contractType: ContractType;
  contractTypeDetail: ContractTypeDetail;
  costPlusMarkupBasisPoints?: Maybe<Scalars['Int']>;
  document?: Maybe<Document>;
  draws: Array<HomeownerContractDraw>;
  changeOrders: Array<HomeownerContractChangeOrder>;
  lineItems: Array<HomeownerContractLineItem>;
  /** Returns the non-draw original contract + change order line items for potential invoicing. */
  lineItemsByProjectItem: Array<HomeownerContractLineItemsByProjectItem>;
  title: Scalars['String'];
  blueprintUrl: Url;
  project: Project;
  softCostBudgetInCents: Scalars['Int'];
  directHardCostBudgetInCents: Scalars['Int'];
  indirectHardCostBudgetInCents: Scalars['Int'];
  totalMarkupInCents: Scalars['Int'];
  annotatedCosts: Array<AnnotatedCost>;
  projectFinancials: Array<ContractProjectFinancials>;
};


export type HomeownerContractLineItemsByProjectItemArgs = {
  contractType?: InputMaybe<ContractType>;
};

export type HomeownerContractChangeOrder = CanCollaborate & Commentable & Referencable & Followable & Named & HomeownerContractLike & HasBlueprintUrl & {
  __typename?: 'HomeownerContractChangeOrder';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  contract: HomeownerContract;
  identifier: Scalars['String'];
  name: Scalars['String'];
  shortName: Scalars['String'];
  internalNote?: Maybe<Scalars['String']>;
  priceChangeInCents: Scalars['Int'];
  budgetChangeInCents: Scalars['Int'];
  invoicedInCents?: Maybe<Scalars['Int']>;
  amountPaidInCents?: Maybe<Scalars['Int']>;
  balanceInCents?: Maybe<Scalars['Int']>;
  uninvoicedInCents?: Maybe<Scalars['Int']>;
  executionDate?: Maybe<Scalars['Date']>;
  contractType: ContractType;
  costPlusMarkupBasisPoints?: Maybe<Scalars['Int']>;
  document?: Maybe<Document>;
  draws: Array<HomeownerContractDraw>;
  lineItems: Array<HomeownerContractLineItem>;
  title: Scalars['String'];
  blueprintUrl: Url;
  changeEvent?: Maybe<ChangeEvent>;
  estimate?: Maybe<Estimate>;
  softCostBudgetInCents: Scalars['Int'];
  directHardCostBudgetInCents: Scalars['Int'];
  indirectHardCostBudgetInCents: Scalars['Int'];
  totalMarkupInCents: Scalars['Int'];
  annotatedCosts: Array<AnnotatedCost>;
  projectFinancials: Array<ContractProjectFinancials>;
  isContractAddendum: Scalars['Boolean'];
};

export type ReadyPlan = CanCollaborate & Commentable & Referencable & Followable & ReadyPlanLike & HasBlueprintUrl & Named & HasDisplayName & BaseItemParent & {
  __typename?: 'ReadyPlan';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  status: ReadyPlanStatusDetail;
  /**  The latest status based on the latest RPAV, which may be archived depending on the ReadyPlan's status.  */
  effectiveStatus: ReadyPlanStatusDetail;
  development?: Maybe<Development>;
  itemTemplates: Array<ItemTemplate>;
  options: Array<ReadyPlanOption>;
  hasOptions: Scalars['Boolean'];
  code?: Maybe<Scalars['String']>;
  activeOptionsCount: Scalars['Int'];
  type?: Maybe<ReadyPlanTypeDetail>;
  isValidForReadyPlanConfiguration: Scalars['Boolean'];
  /**  The `type` + `code`, i.e. SFH-TX-1-001  */
  displayCode?: Maybe<Scalars['String']>;
  programData: ProgramData;
  maxProgramData: ProgramData;
  minProgramData: ProgramData;
  optionGroups: Array<ReadyPlanOptionGroup>;
  userEvents: Array<UserEvent>;
  blueprintUrl: Url;
  /**  The current template version used for computing UW costs.  */
  underwritingTemplate?: Maybe<ItemTemplate>;
  constructionDocumentCompletePercentage: Scalars['Int'];
  programDatas: Array<ReadyPlanProgramData>;
  assets: Array<ReadyPlanAsset>;
  lotTypes: Array<LotType>;
  aggregateActive?: Maybe<ReadyPlanAggregateVersion>;
  aggregateDraft?: Maybe<ReadyPlanAggregateVersion>;
  aggregateLatest: ReadyPlanAggregateVersion;
  aggregateVersions: Array<ReadyPlanAggregateVersion>;
  version: ReadyPlanAggregateVersion;
  itemLocations: Array<Location>;
  costCodes: Array<CostCode>;
  canCreateNewVersion: PotentialOperation2;
  canEditLineItems: PotentialOperation2;
  contingencyMarkupPercentage?: Maybe<Scalars['Float']>;
  canEdit: PotentialOperation2;
  documents: Array<Document>;
  requiredOptions: Array<ReadyPlanRequiredOption>;
  /**  All downstream PRPCs referencing this ReadyPlan, either directly or indirectly via a ProductOffering  */
  projectConfigs: Array<ProjectReadyPlanConfig>;
  owner?: Maybe<InternalUser>;
  cloneInProgress: Scalars['Boolean'];
};


export type ReadyPlanOptionsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};


export type ReadyPlanOptionGroupsArgs = {
  filter?: InputMaybe<ReadyPlanOptionGroupsFilter>;
};

export type PlanPackage = CanCollaborate & Commentable & Referencable & Followable & ReadyPlanLike & HasBlueprintUrl & Named & HasDisplayName & BaseItemParent & {
  __typename?: 'PlanPackage';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ReadyPlanTypeDetail;
  code?: Maybe<Scalars['String']>;
  displayCode?: Maybe<Scalars['String']>;
  blueprintUrl: Url;
  constructionDocumentCompletePercentage: Scalars['Int'];
  status: ReadyPlanStatusDetail;
  /**  The latest status based on the latest RPAV, which may be archived depending on the ReadyPlan's status.  */
  effectiveStatus: ReadyPlanStatusDetail;
  development?: Maybe<Development>;
  maxProgramData: ProgramData;
  minProgramData: ProgramData;
  programData: ProgramData;
  itemTemplates: Array<ItemTemplate>;
  /**
   * Helper to get the latest takeoff item template for this plan package
   * @deprecated Use version and takeoffLineItems instead
   */
  takeoff: ItemTemplate;
  projectConfigs: Array<ProjectReadyPlanConfig>;
  options: Array<ReadyPlanOption>;
  optionGroups: Array<ReadyPlanOptionGroup>;
  productOfferings: Array<ProductOffering>;
  designPackages: Array<DesignPackage>;
  designPackageSources: Array<DesignPackageSource>;
  incomingSlots: Array<PlanPackageIncomingSlot>;
  lotTypes?: Maybe<Array<LotType>>;
  programDatas: Array<ReadyPlanProgramData>;
  assets: Array<ReadyPlanAsset>;
  activeOptionsCount: Scalars['Int'];
  projectCount: Scalars['Int'];
  designPackageCount: Scalars['Int'];
  productOfferingCount: Scalars['Int'];
  asGlobalOption?: Maybe<GlobalOption>;
  markets: Array<Market>;
  aggregateActive?: Maybe<ReadyPlanAggregateVersion>;
  aggregateDraft?: Maybe<ReadyPlanAggregateVersion>;
  aggregateLatest: ReadyPlanAggregateVersion;
  aggregateVersions: Array<ReadyPlanAggregateVersion>;
  version: ReadyPlanAggregateVersion;
  /**  The Locations in-use by the current TLIs  */
  itemLocations: Array<Location>;
  costCodes: Array<CostCode>;
  canEditLineItems: PotentialOperation2;
  locations: Array<Location>;
  /** Default filter is locationType: [Level, Room] */
  roomLocations: Array<ReadyPlanLocation>;
  contingencyMarkupPercentage?: Maybe<Scalars['Float']>;
  canEdit: PotentialOperation2;
  documents: Array<Document>;
  insideMapsProjectId?: Maybe<Scalars['String']>;
  /**  The number of InsideMaps rooms checkout can show, i.e. how many room `slots` the plan has  */
  maxInsideMapsRooms: Scalars['Int'];
  /**
   * JSON config for inside maps that will be parsed and validated on save.
   * This is a string value (along with the input) to enable easy copy/paste via a textbox field.
   * The fully typed version of this config can be accessed via `CheckoutConfig.insideMapsConfig`.
   * Note this is unversioned for the time being along with the other inside maps attributes.
   */
  insideMapsConfig?: Maybe<Scalars['String']>;
  requiredOptions: Array<ReadyPlanRequiredOption>;
  owner?: Maybe<InternalUser>;
  cloneInProgress: Scalars['Boolean'];
  /** @deprecated feature removed */
  slotDeletionRequests: Array<PlanPackageSlotDeletionRequest>;
  aiProposal?: Maybe<PlanPackageAiProposal>;
};


export type PlanPackageOptionsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};


export type PlanPackageRoomLocationsArgs = {
  filter?: InputMaybe<RoomLocationFilter>;
};

export type GlobalOption = CanCollaborate & Commentable & Referencable & Followable & Named & HasBlueprintUrl & {
  __typename?: 'GlobalOption';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  group: GlobalOptionGroup;
  readyPlanOptions: Array<ReadyPlanOption>;
  name: Scalars['String'];
  displayName: Scalars['String'];
  blueprintUrl: Url;
  description?: Maybe<Scalars['String']>;
  isPlanSpecific?: Maybe<Scalars['Boolean']>;
  standardDetailRequired?: Maybe<Scalars['Boolean']>;
  status: GlobalOptionStatus;
  statusDetail: GlobalOptionStatusDetail;
  type: GlobalOptionType;
  /** Only locations used in active `readyPlanOptions` */
  locations: Array<Location>;
  /** @deprecated Use locations instead */
  locationsInUse: Array<Location>;
  activeDate?: Maybe<Scalars['Date']>;
  archivedDate?: Maybe<Scalars['Date']>;
  elevationRequired?: Maybe<Scalars['Boolean']>;
  requiredInPlanDrawing?: Maybe<Scalars['Boolean']>;
  shopDrawingRequired?: Maybe<Scalars['Boolean']>;
  tags: Array<GlobalOptionTag>;
  /** List of tags which are allowed on this specific GlobalOption */
  supportedTags: Array<GlobalOptionTag>;
  canEditType: PotentialOperation2;
  /** @deprecated No longer used */
  canEditLocations: PotentialOperation2;
  code: Scalars['String'];
  designUpgradeIconName?: Maybe<Scalars['String']>;
  defaultOrder?: Maybe<Scalars['Int']>;
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  asset?: Maybe<Asset>;
  estimatedLeadTimeInDays: Scalars['Int'];
  marketingDescription?: Maybe<Scalars['String']>;
  permits: Array<Permit>;
  attachments: Array<Attachment>;
  /**  For product personalization options, the material this option represents.  */
  materialVariant?: Maybe<MaterialVariant>;
  optionPricingConfig?: Maybe<OptionPricingConfig>;
  version: Scalars['Int'];
  history: Array<History>;
  readyPlan?: Maybe<ReadyPlan>;
};

export type ProjectCostCode = CanCollaborate & Commentable & Referencable & Followable & Named & HasBlueprintUrl & {
  __typename?: 'ProjectCostCode';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  blueprintUrl: Url;
  costCode: CostCode;
  project: Project;
  projectItems: Array<ProjectItem>;
  committedAtStartInCents: Scalars['Int'];
  /** Hierarchy Budget Fields */
  originalCostInCents: Scalars['Int'];
  startCostInCents: Scalars['Int'];
  changeEventCostInCents: Scalars['Int'];
  revisedCostInCents: Scalars['Int'];
  projectedCostInCents: Scalars['Int'];
  committedCostInCents: Scalars['Int'];
  availableCostInCents: Scalars['Int'];
  billedCostInCents: Scalars['Int'];
  unbilledCostInCents: Scalars['Int'];
};

export type CollaborationParent = ScheduleSubPhase | Approval | BidContract | BidItem | BidPackageRequest | Bill | ChangeEvent | ChangeRequest | ChangeRequestToDo | Commitment | DevelopmentCommitment | Document | Estimate | GlobalOption | HomeownerContract | HomeownerContractChangeOrder | Invoice | ItemTemplateItemVersion | JobLogNote | StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | ProjectCostCode | ProjectItem | PunchlistItemTodo | ReadyPlan | Task | ToDo | TradePartnerAvailabilityRequest | SchedulePhase | WarrantyTicket;

export type Comment = Entity & {
  __typename?: 'Comment';
  id: Scalars['ID'];
  html: Scalars['String'];
  text: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  stream: CommentStream;
  author: User;
  permissions: Permissions;
  attachments: Array<Attachment>;
  tags: Array<CommentTag>;
};

export type SaveCommentInput = {
  id?: InputMaybe<Scalars['ID']>;
  html?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  commentStreamId?: InputMaybe<Scalars['ID']>;
  /** only used for stream creation, use commentStreamId for existing threads */
  tradePartnerContactIds?: InputMaybe<Array<Scalars['ID']>>;
  /** only used for homeowner/internal threads, use tradePartnerContacts instead */
  streamVisibility?: InputMaybe<CommentStreamVisibility>;
  commentableId?: InputMaybe<Scalars['ID']>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
  internalUserTags?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveCommentResult = {
  __typename?: 'SaveCommentResult';
  comment?: Maybe<Comment>;
  userErrors: Array<UserError>;
};

export type DeleteCommentInput = {
  id: Scalars['ID'];
};

export type DeleteCommentResult = {
  __typename?: 'DeleteCommentResult';
  stream?: Maybe<CommentStream>;
  userErrors: Array<UserError>;
};

export type CommentStream = {
  __typename?: 'CommentStream';
  id: Scalars['ID'];
  streamVisibility: CommentStreamVisibilityDetail;
  name: Scalars['String'];
  commentable: Commentable;
  comments: Array<Comment>;
  latestComment?: Maybe<Comment>;
  commentCount: Scalars['Int'];
  unreadCount: Scalars['Int'];
  fromAddress: Scalars['String'];
  tradePartnerUsers: Array<TradePartnerUser>;
};

export type MarkCommentStreamAsReadInput = {
  id: Scalars['ID'];
};

export type CommentStreams = {
  __typename?: 'CommentStreams';
  internalStream?: Maybe<CommentStream>;
  /** @deprecated more than 1 trades stream can now be present. use commentable.streams instead */
  tradesStream?: Maybe<CommentStream>;
  homeownerStream?: Maybe<CommentStream>;
  commentCount: Scalars['Int'];
};

export type UserRelevantCommentStreamsFilter = {
  internalUser: Array<Scalars['ID']>;
  projectIds?: InputMaybe<Array<Scalars['ID']>>;
  hasUnreads?: InputMaybe<Scalars['Boolean']>;
  parentTypeNames?: InputMaybe<Array<Scalars['String']>>;
};

export type UserRelevantCommentStreamsResult = {
  __typename?: 'UserRelevantCommentStreamsResult';
  entities: Array<CommentStream>;
  pageInfo: PageInfo;
};

export type CommentTag = {
  __typename?: 'CommentTag';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  comment: Comment;
  internalUser: InternalUser;
};

export type Commentable = {
  id: Scalars['ID'];
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  /**  We lazy create comment streams, so we might support internal/homeowner streams even though they don't exist yet.  */
  supportedVisibilities: Array<CommentStreamVisibility>;
  /** Implicitly contains all visible streams for the current user */
  streams: Array<CommentStream>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
};

export type ProjectStage = Entity & MaybeHasProject & MaybeHasInterval & {
  __typename?: 'ProjectStage';
  commitments: Array<Commitment>;
  /**  Returns commitment or commitment change orders for the stage.  */
  commitmentLikes: Array<CommitmentLike>;
  homeownerContracts: Array<HomeownerContract>;
  id: Scalars['ID'];
  project: Project;
  stage: StageDetail;
  hasSignedContract: Scalars['Boolean'];
  /**
   * If this is a false, a Homeowner final estimate and/or contract has locked in the
   * initial scope and change events must be used to edit project items.
   *
   * A better name for this is probably `canEditProjectScope`, i.e. specifically quantity
   * and price. We do let cost continue to "float" / be edited even while scope is locked,
   * as we get in new bids/etc. from Trade Partners. The cost becomes locked once we have
   * Commitments in place. (Or until we build bid/RFP support.)
   * @deprecated Deprecated in favor of canEditProjectScope
   */
  canEditProjectItemsDirectly: Scalars['Boolean'];
  canEditProjectScope: PotentialOperation2;
  canCreateFinalEstimate: Scalars['Boolean'];
  canCompleteStage: PotentialOperation2;
  canPublishSchedule: PotentialOperation;
  nextStage?: Maybe<ProjectStage>;
  previousStage?: Maybe<ProjectStage>;
  status: ProjectStageStatusDetail;
  interval: CalendarInterval;
  baselineInterval: CalendarInterval;
  schedulePhases: Array<SchedulePhase>;
  bills: Array<Bill>;
  priceInCents: Scalars['Int'];
  progress: StageProgress;
  /** @deprecated The CMS integration is being decommissioned - Do not use */
  cmsId?: Maybe<Scalars['String']>;
  invoices: Array<Invoice>;
  homeownerFinancials: ProjectStageHomeownerFinancials;
  estimates: Array<Estimate>;
  hocFinancials: ProjectStageHocFinancials;
  projectItems: Array<ProjectItem>;
  itemLocations: Array<Location>;
  costCodes: Array<CostCode>;
  changeEvents: Array<ChangeEvent>;
  totalCostInCents: Scalars['Int'];
  clientPresentationDate?: Maybe<Scalars['Date']>;
  /**  A list of 'dumb' / non-ReadyHome templates that have been applied to the project.  */
  appliedTemplates: Array<ItemTemplate>;
  /**  A list of ReadyHome 'smart' templates, i.e. they have spec levels and are re-configurable.  */
  templateConfigs: Array<ProjectStageTemplateConfig>;
  readyHomePlanTemplate?: Maybe<ProjectStageTemplateConfig>;
  /**  The percent of items that are bought out, i.e. on signed/released commitments.  */
  percentReleased: Scalars['Int'];
  unallocatedExpenses: Array<Expense>;
  hasDrawsToInvoice: Scalars['Boolean'];
  hasCostsToInvoice: Scalars['Boolean'];
  hasFixedToInvoice: Scalars['Boolean'];
  workAuthorizations: Array<WorkAuthorization>;
  allContractDraws: Array<HomeownerContractDraw>;
};


export type ProjectStageCommitmentsArgs = {
  filter?: InputMaybe<CommitmentsFilter>;
};


export type ProjectStageCommitmentLikesArgs = {
  isBidCommitment?: InputMaybe<Scalars['Boolean']>;
};


export type ProjectStageSchedulePhasesArgs = {
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
};


export type ProjectStageProgressArgs = {
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
};


export type ProjectStageInvoicesArgs = {
  filter?: InputMaybe<InvoiceFilter>;
  order?: InputMaybe<InvoiceOrder>;
};


export type ProjectStageProjectItemsArgs = {
  filter?: InputMaybe<ProjectItemFilter>;
};


export type ProjectStageItemLocationsArgs = {
  filter?: InputMaybe<ItemLocationsFilter>;
};


export type ProjectStageChangeEventsArgs = {
  filter?: InputMaybe<ChangeEventFilter>;
};


export type ProjectStageWorkAuthorizationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type CommitmentLike = {
  accountingNumber: Scalars['Int'];
  blueprintUrl: Url;
  project: Project;
  commitmentType: CommitmentTypeDetail;
  committedInCents: Scalars['Int'];
  taxableCostInCents: Scalars['Int'];
  displayName: Scalars['String'];
  shortName: Scalars['String'];
  executionDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  lineItems: Array<CommitmentLineItem>;
  costCodes: Array<CostCode>;
  items: Array<Item>;
  name: Scalars['String'];
  pandaDoc?: Maybe<PandaDoc>;
  document?: Maybe<Document>;
  status: CommitmentStatus;
  statusText: Scalars['String'];
  tradePartner?: Maybe<TradePartner>;
  updatedAt: Scalars['DateTime'];
  canCreatePandaDoc: PotentialOperation2;
  tradeSignatory?: Maybe<TradePartnerContact>;
  changeEvent?: Maybe<ChangeEvent>;
  referenceNumber?: Maybe<Scalars['String']>;
};

/**  A per-cost code summary of a commitment + its chan ge orders.  */
export type CommitmentLineItemSummary = {
  __typename?: 'CommitmentLineItemSummary';
  costCode: CostCode;
  /**  original commitment amount  */
  committedInCents: Scalars['Int'];
  /**  total across change orders  */
  changeOrderInCents: Scalars['Int'];
  /**  originalCommitmentInCents - changeOrderInCents  */
  totalCommittedInCents: Scalars['Int'];
  billedInCents: Scalars['Int'];
  paidInCents: Scalars['Int'];
  balanceInCents: Scalars['Int'];
};

export type CommitmentsPage = {
  __typename?: 'CommitmentsPage';
  commitments: Array<Commitment>;
  pageInfo: PageInfo;
};

export type PotentialBidContractRevision = {
  __typename?: 'PotentialBidContractRevision';
  bidContractRevision: BidContractRevision;
  totalCostInCents: Scalars['Int'];
};

export type CommitmentCostCodeSummary = {
  __typename?: 'CommitmentCostCodeSummary';
  lineItems: Array<CommitmentCostCodeSummaryLineItem>;
};

export type CommitmentCostCodeSummaryLineItem = {
  __typename?: 'CommitmentCostCodeSummaryLineItem';
  costCode: CostCode;
  quantity: Scalars['Int'];
};

export type SaveCommitmentInput = {
  id?: InputMaybe<Scalars['ID']>;
  accountingNumber?: InputMaybe<Scalars['Int']>;
  commitmentType?: InputMaybe<CommitmentType>;
  projectStageId?: InputMaybe<Scalars['ID']>;
  tradePartnerId?: InputMaybe<Scalars['ID']>;
  documentId?: InputMaybe<Scalars['ID']>;
  internalNote?: InputMaybe<Scalars['String']>;
  executionDate?: InputMaybe<Scalars['Date']>;
  lineItems?: InputMaybe<Array<SaveCommitmentLineItemInput>>;
  /**
   * The exhaustive list of draws for the commitment. When provided, draws in the list are created or
   * updated and any existing draw left out of the list is deleted. Omit the field entirely to leave the
   * commitment's draws untouched.
   */
  draws?: InputMaybe<Array<SaveCommitmentDrawInput>>;
  contractExhibits?: InputMaybe<Scalars['String']>;
  contractSchedule?: InputMaybe<Scalars['String']>;
  contractTerms?: InputMaybe<Scalars['String']>;
  contractExclusions?: InputMaybe<Scalars['String']>;
  costTypes?: InputMaybe<Array<CostType>>;
  status?: InputMaybe<CommitmentStatus>;
  releaseWhenReady?: InputMaybe<Scalars['Boolean']>;
  depositInBasisPoints?: InputMaybe<Scalars['Float']>;
  depositScheduleTaskId?: InputMaybe<Scalars['ID']>;
  referenceNumber?: InputMaybe<Scalars['String']>;
};

export type DeleteCommitmentLineItemsInput = {
  lineItemIds: Array<Scalars['ID']>;
};

export type DeleteCommitmentInput = {
  id: Scalars['ID'];
};

export type ReleaseCommitmentInput = {
  id: Scalars['ID'];
};

export type SaveCommitmentResult = {
  __typename?: 'SaveCommitmentResult';
  commitment: Commitment;
};

export type SaveBidToCommitmentsInput = {
  commitmentId: Scalars['ID'];
  bidContractRevisionId: Scalars['ID'];
};

export type AssignWorkToBidContractInput = {
  /**  If provided, will assign work to specified BCR (through PIs) and will void prior Commitment on New Commitment release  */
  commitmentId?: InputMaybe<Scalars['ID']>;
  /**  Assign these to a new BCR without creating a Commitment -- unless autoRelease is provided, in which case non-voiding Commitments are generated  */
  projectItemIds?: InputMaybe<Array<Scalars['ID']>>;
  bidContractRevisionId?: InputMaybe<Scalars['ID']>;
  bidContractLineItemIds?: InputMaybe<Array<Scalars['ID']>>;
  /**  Infers True (overridable) if a prior commitmentId is provided. For the projectItemIds flow, not-null will force non-voiding Commitments to be generated  */
  autoRelease?: InputMaybe<Scalars['Boolean']>;
};

export type UnassignWorkFromBidContractInput = {
  projectItemIds: Array<Scalars['ID']>;
};

export type AssignBidPackageWorkToBidContractInput = {
  bidContractRevisionIds: Array<Scalars['ID']>;
  projectId: Scalars['ID'];
};

export type SaveCommitmentsResult = {
  __typename?: 'SaveCommitmentsResult';
  commitments: Array<Commitment>;
};

export type CommitmentsFilter = {
  /** @deprecated More than one project could be related, use projectIds instead */
  projectId?: InputMaybe<Scalars['ID']>;
  stage?: InputMaybe<Array<Stage>>;
  developmentId?: InputMaybe<Scalars['ID']>;
  commitmentIds?: InputMaybe<Array<Scalars['ID']>>;
  tradePartners?: InputMaybe<Array<Scalars['ID']>>;
  costCodes?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<CommitmentStatus>>;
  executionDate?: InputMaybe<DateFilter2>;
  marketId?: InputMaybe<Array<Scalars['ID']>>;
  sentDate?: InputMaybe<DateFilter2>;
  /** used to query scenarios when commitment could appear in multiple projects */
  projectIds?: InputMaybe<Array<Scalars['ID']>>;
  projectCostCodes?: InputMaybe<Array<Scalars['ID']>>;
};

export type MoveCommitmentsToNewTradePartnerInput = {
  projectId: Scalars['ID'];
  sourceTradePartnerId: Scalars['ID'];
  targetTradePartnerId: Scalars['ID'];
};

export type CommitmentOrder = {
  id?: InputMaybe<Order>;
  accountingNumber?: InputMaybe<Order>;
  development?: InputMaybe<Order>;
  projectAddress?: InputMaybe<Order>;
  executionDate?: InputMaybe<Order>;
  bidContractRevision?: InputMaybe<Order>;
  committedInCents?: InputMaybe<Order>;
  billedInCents?: InputMaybe<Order>;
  remainingInCents?: InputMaybe<Order>;
  paidInCents?: InputMaybe<Order>;
  balanceInCents?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
};

export type CreateCommitmentFromBillInput = {
  billId: Scalars['ID'];
  lineItems?: InputMaybe<Array<SaveCommitmentLineItemInput>>;
  changeEvent?: InputMaybe<SaveChangeEventInput>;
};

export type CreateCommitmentFromBillResult = {
  __typename?: 'CreateCommitmentFromBillResult';
  commitment?: Maybe<Commitment>;
  changeEvent?: Maybe<ChangeEvent>;
};

export type CommitmentBillingScheduleItem = {
  __typename?: 'CommitmentBillingScheduleItem';
  commitmentDraw?: Maybe<CommitmentDraw>;
  isDeposit: Scalars['Boolean'];
  committedInCents: Scalars['Int'];
  pendingBilledInCents: Scalars['Int'];
  pendingUnbilledInCents: Scalars['Int'];
  lineItems: Array<CommitmentBillingScheduleLineItem>;
};

export type CommitmentBillingScheduleLineItem = {
  __typename?: 'CommitmentBillingScheduleLineItem';
  amountInCents: Scalars['Int'];
  commitmentLineItem: CommitmentLineItem;
};

export type TaskPurchaseOrderRow = {
  __typename?: 'TaskPurchaseOrderRow';
  commitmentLike: CommitmentLike;
  committedInCents: Scalars['Int'];
  unbilledInCents: Scalars['Int'];
  changeOrders: Array<TaskPurchaseOrderRow>;
};

export type CommitmentChangeOrder = CommitmentLike & HasBlueprintUrl & Named & HasDisplayName & HasPandaDoc & {
  __typename?: 'CommitmentChangeOrder';
  id: Scalars['ID'];
  accountingNumber: Scalars['Int'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  shortName: Scalars['String'];
  project: Project;
  commitment: Commitment;
  commitmentType: CommitmentTypeDetail;
  identifier: Scalars['String'];
  costChangeInCents: Scalars['Int'];
  internalNote?: Maybe<Scalars['String']>;
  executionDate?: Maybe<Scalars['Date']>;
  createdAt: Scalars['DateTime'];
  document?: Maybe<Document>;
  lineItems: Array<CommitmentLineItem>;
  bills: Array<Bill>;
  /**  An alias of costChangeInCents  */
  committedInCents: Scalars['Int'];
  taxableCostInCents: Scalars['Int'];
  remainingInCents: Scalars['Int'];
  pendingRemainingInCents: Scalars['Int'];
  billedInCents?: Maybe<Scalars['Int']>;
  pendingBilledInCents?: Maybe<Scalars['Int']>;
  unbilledInCents: Scalars['Int'];
  paidInCents?: Maybe<Scalars['Int']>;
  balanceInCents?: Maybe<Scalars['Int']>;
  blueprintUrl: Url;
  updatedAt: Scalars['DateTime'];
  tradeCategories: Array<TradeCategory>;
  tradePartner?: Maybe<TradePartner>;
  changeEvent?: Maybe<ChangeEvent>;
  status: CommitmentStatus;
  statusDetail: CommitmentStatusDetail;
  statusText: Scalars['String'];
  pandaDoc?: Maybe<PandaDoc>;
  canEditLineItems: PotentialOperation2;
  canCreatePandaDoc: PotentialOperation2;
  isBidCommitment: Scalars['Boolean'];
  canBeEdited: Scalars['Boolean'];
  costCodes: Array<CostCode>;
  items: Array<Item>;
  canDelete: PotentialOperation2;
  canVoid: PotentialOperation2;
  canBeReleased: PotentialOperation2;
  tradeSignatory?: Maybe<TradePartnerContact>;
  percentagePaid: Scalars['Int'];
  sentDate?: Maybe<Scalars['Date']>;
  referenceNumber?: Maybe<Scalars['String']>;
};

export type SaveCommitmentChangeOrderInput = {
  id?: InputMaybe<Scalars['ID']>;
  commitmentId?: InputMaybe<Scalars['ID']>;
  accountingNumber?: InputMaybe<Scalars['Int']>;
  documentId?: InputMaybe<Scalars['ID']>;
  internalNote?: InputMaybe<Scalars['String']>;
  executionDate?: InputMaybe<Scalars['Date']>;
  lineItems?: InputMaybe<Array<SaveCommitmentLineItemInput>>;
  status?: InputMaybe<CommitmentStatus>;
  referenceNumber?: InputMaybe<Scalars['String']>;
};

export type SaveCommitmentChangeOrderResult = {
  __typename?: 'SaveCommitmentChangeOrderResult';
  commitmentChangeOrder: CommitmentChangeOrder;
};

export type DeleteCommitmentChangeOrderInput = {
  id: Scalars['ID'];
};

export type CommitmentDraw = Entity & {
  __typename?: 'CommitmentDraw';
  id: Scalars['ID'];
  amountInBasisPoints: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /**  Empty for project-level draws (manual POs) that aren't tied to a bid contract revision draw.  */
  bidContractRevisionDraw?: Maybe<BidContractRevisionDraw>;
  commitment: Commitment;
  task: Task;
  costCode: CostCode;
};

export type SaveCommitmentDrawInput = {
  id?: InputMaybe<Scalars['ID']>;
  amountInBasisPoints?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  commitmentId?: InputMaybe<Scalars['ID']>;
  taskId?: InputMaybe<Scalars['ID']>;
};

export type CommitmentLineItem = {
  __typename?: 'CommitmentLineItem';
  id: Scalars['ID'];
  /**  The immediate parent, either a commitment or a change order.  */
  owner: CommitmentLike;
  /** The owning commitment, even if on a change order, that change order's original commitment. */
  ownerCommitment: Commitment;
  costChangeInCents?: Maybe<Scalars['Int']>;
  internalNote?: Maybe<Scalars['String']>;
  costCode: CostCode;
  /**  An alias of costChangeInCents  */
  committedInCents: Scalars['Int'];
  billedInCents?: Maybe<Scalars['Int']>;
  unbilledInCents: Scalars['Int'];
  pendingBilledInCents: Scalars['Int'];
  pendingUnbilledInCents: Scalars['Int'];
  billableLimitInCents: Scalars['Int'];
  paidInCents?: Maybe<Scalars['Int']>;
  balanceInCents?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  projectItem: ProjectItem;
  specifications?: Maybe<Scalars['String']>;
  tradePartnerNote?: Maybe<Scalars['String']>;
  changeEventLineItem?: Maybe<ChangeEventLineItem>;
  newTaxableCostInCents: Scalars['Int'];
  newTaxInCents: Scalars['Int'];
  newTotalCostInCents: Scalars['Int'];
  originalTaxableCostInCents: Scalars['Int'];
  originalTaxInCents: Scalars['Int'];
  originalTotalCostInCents: Scalars['Int'];
  originalQuantity: Scalars['Int'];
  newQuantity: Scalars['Int'];
  bidItem?: Maybe<BidItem>;
  primaryBidContractLineItem?: Maybe<BidContractLineItem>;
  modifyingBidContractLineItems: Array<BidContractLineItem>;
  /**  The plan-based bid line this CLI was committed against.  */
  planBasedLineItem?: Maybe<PlanBasedBidContractLineItem>;
  expenseAllocations: Array<ExpenseAllocation>;
  isTaxExempt: Scalars['Boolean'];
  taxableCostInCents: Scalars['Int'];
  taxInCents: Scalars['Int'];
  allocations: Array<CommitmentLineItemAllocation>;
};

export type ProtoCommitmentLineItemToBuyout = {
  __typename?: 'ProtoCommitmentLineItemToBuyout';
  projectItem: ProjectItem;
  quantity?: Maybe<Scalars['Int']>;
  costChangeInCents?: Maybe<Scalars['Int']>;
  specifications?: Maybe<Scalars['String']>;
  tradePartnerNote?: Maybe<Scalars['String']>;
};

export type SaveCommitmentLineItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  internalNote?: InputMaybe<Scalars['String']>;
  /** @deprecated replaced with taxableCostInCents */
  costChangeInCents?: InputMaybe<Scalars['Int']>;
  /** @deprecated Field no longer supported */
  costCodeId?: InputMaybe<Scalars['ID']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  quantity?: InputMaybe<Scalars['Int']>;
  projectItemId?: InputMaybe<Scalars['ID']>;
  isTaxExempt?: InputMaybe<Scalars['Boolean']>;
  taxableCostInCents?: InputMaybe<Scalars['Int']>;
};

export type CommitmentLineItemAllocation = {
  __typename?: 'CommitmentLineItemAllocation';
  id: Scalars['ID'];
  costInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  commitmentLineItem: CommitmentLineItem;
  projectItemAllocation: ProjectItemAllocation;
  billLineItemAllocations: Array<BillLineItemAllocation>;
};

export type SaveCommunityInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  buildAddress?: InputMaybe<AddressInput>;
  /**  Only used for creating the Project.  */
  client?: InputMaybe<ClientInput>;
  /**  Add's a new coverImage to a project.  */
  coverImage?: InputMaybe<AssetInput>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ProjectStatus>;
  /**  Only used for creating the Project.  */
  startDate?: InputMaybe<Scalars['Date']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']>;
  planRoomLink?: InputMaybe<Scalars['String']>;
  salesforceAccountId?: InputMaybe<Scalars['String']>;
  projectStatusChange?: InputMaybe<ProjectStatusChangeInput>;
  isDisaster?: InputMaybe<Scalars['Boolean']>;
  intakeStyleNotes?: InputMaybe<Scalars['String']>;
  lotType?: InputMaybe<LotType>;
  productTypeId?: InputMaybe<Scalars['ID']>;
  projectRoles?: InputMaybe<Array<UpdateProjectRoleInput>>;
  salesforcePropertyId?: InputMaybe<Scalars['String']>;
  scopeMode?: InputMaybe<ScopeMode>;
  lotPartitionId?: InputMaybe<Scalars['String']>;
  warrantyStartDate?: InputMaybe<Scalars['Date']>;
  checkoutCustomerConfigId?: InputMaybe<Scalars['String']>;
  directCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']>;
  indirectCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']>;
  customerId?: InputMaybe<Scalars['ID']>;
  customerOwnerEntityId?: InputMaybe<Scalars['ID']>;
  builderId?: InputMaybe<Scalars['ID']>;
  legalDescription?: InputMaybe<Scalars['String']>;
  salesTaxOverrideInBasisPoints?: InputMaybe<Scalars['Int']>;
  communityType?: InputMaybe<CommunityType>;
  salesforceNeighborhoodId?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  pricingTeaser?: InputMaybe<Scalars['String']>;
  /**  Raw SVG markup for the community's lot map  */
  lotMap?: InputMaybe<Scalars['String']>;
  showInCheckout?: InputMaybe<Scalars['Boolean']>;
  packageComparison?: InputMaybe<AssetInput>;
  companyName?: InputMaybe<Scalars['String']>;
  companyLicenseNumber?: InputMaybe<Scalars['String']>;
  invoicePaymentNetDays?: InputMaybe<Scalars['Int']>;
};

export type SaveCommunityResult = {
  __typename?: 'SaveCommunityResult';
  community: Community;
};

export type CommunitiesPageResult = {
  __typename?: 'CommunitiesPageResult';
  entities: Array<Community>;
  pageInfo: PageInfo;
};

export type CostCode = Named & HasDisplayName & HasMaterialLeadTimeConfigData & {
  __typename?: 'CostCode';
  id: Scalars['ID'];
  version: Scalars['Int'];
  division: CostDivision;
  number: Scalars['String'];
  name: Scalars['String'];
  /** The `number name`, i.e. `2101 Framing. */
  displayName: Scalars['String'];
  quickbooksCategoryId?: Maybe<Scalars['String']>;
  quickbooksItemId?: Maybe<Scalars['String']>;
  items: Array<Item>;
  tsaSpecifications?: Maybe<Scalars['String']>;
  intacctApAccountId?: Maybe<Scalars['String']>;
  costClassification: CostClassificationTypeDetail;
  costSubClassification?: Maybe<CostSubClassificationTypeDetail>;
  excludeFromPurchaseOrders: Scalars['Boolean'];
  billType?: Maybe<BillTypeDetail>;
  /** R&M and Warranty cost codes aren't part of the construction budget — they only exist to enter AP bills, so they're excluded from the budget, change events, and POs. */
  excludeFromBudget: Scalars['Boolean'];
  changeEventAutoAcceptThresholdInCents?: Maybe<Scalars['Int']>;
  isPriceOnly?: Maybe<Scalars['Boolean']>;
  optionPricingConfig?: Maybe<OptionPricingConfig>;
  materialLeadTimeConfig?: Maybe<MaterialLeadTimeConfig>;
  /** The minLeadTimeInDays for items under this CostCode, either defined directly by an MaterialLeadTimeConfig or falling back to a default value. */
  minLeadTimeInDays: Scalars['Int'];
  /** The expectedLeadTimeInDays for items under this CostCode, either defined directly by an MaterialLeadTimeConfig or falling back to a default value. */
  expectedLeadTimeInDays: Scalars['Int'];
  /** The maxLeadTimeInDays for items under this CostCode, either defined directly by an MaterialLeadTimeConfig or falling back to a default value. */
  maxLeadTimeInDays: Scalars['Int'];
  history: Array<History>;
  isUnderwritingBudget: Scalars['Boolean'];
  invoiceCategory?: Maybe<CostCodeInvoiceCategoryDetail>;
  interiorFinishScheduleConfigs: Array<FinishScheduleConfig>;
  exteriorFinishScheduleConfigs: Array<FinishScheduleConfig>;
  /**  Items this section renders as extra read-only columns, per the hardcoded custom cost code config, i.e. Cabinet Hardware inside Cabinets.  */
  finishScheduleChildItems: Array<Item>;
  interiorFinishScheduleLabel?: Maybe<Scalars['String']>;
  exteriorFinishScheduleLabel?: Maybe<Scalars['String']>;
  interiorFinishScheduleDescription?: Maybe<Scalars['String']>;
  exteriorFinishScheduleDescription?: Maybe<Scalars['String']>;
  interiorFinishScheduleOrder?: Maybe<Scalars['Int']>;
  exteriorFinishScheduleOrder?: Maybe<Scalars['Int']>;
  /** The cost types procurement always expects a bid for on any plan, regardless of whether takeoffs exist yet. */
  expectedBidCostTypes: Array<CostTypeDetail>;
};

export type CostCodeFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  version?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Array<Scalars['String']>>;
  costClassification?: InputMaybe<Array<CostClassificationType>>;
  costSubClassification?: InputMaybe<Array<CostSubClassificationType>>;
  tradePartnerIds?: InputMaybe<Array<Scalars['ID']>>;
  billType?: InputMaybe<Array<BillType>>;
  isUnderwritingBudget?: InputMaybe<Scalars['Boolean']>;
  interiorFinishScheduleOrder?: InputMaybe<Array<Scalars['Int']>>;
  exteriorFinishScheduleOrder?: InputMaybe<Array<Scalars['Int']>>;
};

export type SaveCostCodesInput = {
  costCodes: Array<SaveCostCodeInput>;
};

export type SaveCostCodeInput = {
  id?: InputMaybe<Scalars['ID']>;
  divisionId?: InputMaybe<Scalars['ID']>;
  number?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  quickbooksCategoryId?: InputMaybe<Scalars['String']>;
  quickbooksItemId?: InputMaybe<Scalars['String']>;
  tsaSpecifications?: InputMaybe<Scalars['String']>;
  intacctApAccountId?: InputMaybe<Scalars['String']>;
  costClassification?: InputMaybe<CostClassificationType>;
  costSubClassification?: InputMaybe<CostSubClassificationType>;
  excludeFromPurchaseOrders?: InputMaybe<Scalars['Boolean']>;
  billType?: InputMaybe<BillType>;
  changeEventAutoAcceptThresholdInCents?: InputMaybe<Scalars['Int']>;
  isPriceOnly?: InputMaybe<Scalars['Boolean']>;
  optionPricingConfig?: InputMaybe<SavePersonalizationOptionPricingConfigInput>;
  materialLeadTimeConfig?: InputMaybe<SavePersonalizationMaterialLeadTimeConfigInput>;
  isUnderwritingBudget?: InputMaybe<Scalars['Boolean']>;
  invoiceCategory?: InputMaybe<CostCodeInvoiceCategory>;
  finishScheduleConfigs?: InputMaybe<Array<SaveFinishScheduleConfigInput>>;
  interiorFinishScheduleLabel?: InputMaybe<Scalars['String']>;
  exteriorFinishScheduleLabel?: InputMaybe<Scalars['String']>;
  interiorFinishScheduleDescription?: InputMaybe<Scalars['String']>;
  exteriorFinishScheduleDescription?: InputMaybe<Scalars['String']>;
  interiorFinishScheduleOrder?: InputMaybe<Scalars['Int']>;
  exteriorFinishScheduleOrder?: InputMaybe<Scalars['Int']>;
  expectedBidCostTypes?: InputMaybe<Array<CostType>>;
};

export type SaveCostCodesResult = {
  __typename?: 'SaveCostCodesResult';
  costCodes: Array<CostCode>;
};

export type DeleteCostCodeInput = {
  id: Scalars['ID'];
};

export type CostDivision = Named & HasDisplayName & {
  __typename?: 'CostDivision';
  id: Scalars['ID'];
  version: Scalars['Int'];
  number: Scalars['String'];
  name: Scalars['String'];
  /** The `number name`, i.e. `2100 Framing`. */
  displayName: Scalars['String'];
  stage: StageDetail;
  selectionCutoff?: Maybe<SelectionCutoffDetail>;
  costCodes: Array<CostCode>;
  tsaPolicySection?: Maybe<Scalars['String']>;
  tsaPaymentSection?: Maybe<Scalars['String']>;
  tsaWarrantySection?: Maybe<Scalars['String']>;
  tsaGeneralScope?: Maybe<Scalars['String']>;
};

export type CostDivisionFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  version?: InputMaybe<Array<Scalars['Int']>>;
};

export type SaveCostDivisionsInput = {
  costDivisions: Array<SaveCostDivisionInput>;
};

export type SaveCostDivisionInput = {
  id?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<Stage>;
  selectionCutoff?: InputMaybe<SelectionCutoff>;
  tsaPolicySection?: InputMaybe<Scalars['String']>;
  tsaPaymentSection?: InputMaybe<Scalars['String']>;
  tsaWarrantySection?: InputMaybe<Scalars['String']>;
  tsaGeneralScope?: InputMaybe<Scalars['String']>;
};

export type SaveCostDivisionsResult = {
  __typename?: 'SaveCostDivisionsResult';
  costDivisions: Array<CostDivision>;
};

export type DeleteCostDivisionInput = {
  id: Scalars['ID'];
};

export type CostLineItemAllocation = {
  __typename?: 'CostLineItemAllocation';
  id: Scalars['ID'];
  invoicedAmountInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  billLineItem?: Maybe<BillLineItem>;
  expenseAllocation?: Maybe<ExpenseAllocation>;
  invoiceLineItem: InvoiceLineItem;
  costAmountInCents: Scalars['Int'];
  costLineItemId: Scalars['ID'];
};

export type Customer = Named & {
  __typename?: 'Customer';
  id: Scalars['ID'];
  name: Scalars['String'];
  softCostMarkupInBasisPoints: Scalars['Int'];
  indirectHardCostMarkupInBasisPoints: Scalars['Int'];
  directHardCostMarkupInBasisPoints: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  isHti?: Maybe<Scalars['Boolean']>;
  itemConfigs: Array<CustomerItemConfig>;
  shouldCoverConstructionCosts: Scalars['Boolean'];
};

export type SaveCustomerInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  softCostMarkupInBasisPoints?: InputMaybe<Scalars['Int']>;
  indirectHardCostMarkupInBasisPoints?: InputMaybe<Scalars['Int']>;
  directHardCostMarkupInBasisPoints?: InputMaybe<Scalars['Int']>;
  isHti?: InputMaybe<Scalars['Boolean']>;
  shouldCoverConstructionCosts?: InputMaybe<Scalars['Boolean']>;
};

export type SaveCustomerResult = {
  __typename?: 'SaveCustomerResult';
  customer: Customer;
};

export type CustomerItemConfig = {
  __typename?: 'CustomerItemConfig';
  id: Scalars['ID'];
  markupInBasisPoints: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  customer: Customer;
  item: Item;
};

export type SaveCustomerItemConfigInput = {
  id?: InputMaybe<Scalars['ID']>;
  markupInBasisPoints?: InputMaybe<Scalars['Int']>;
  customerId?: InputMaybe<Scalars['ID']>;
  itemId?: InputMaybe<Scalars['ID']>;
};

export type SaveCustomerItemConfigResult = {
  __typename?: 'SaveCustomerItemConfigResult';
  customerItemConfig: CustomerItemConfig;
};

export type CustomerOwnerEntity = Named & {
  __typename?: 'CustomerOwnerEntity';
  id: Scalars['ID'];
  name: Scalars['String'];
  intacctId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** @deprecated Replaced by customer.isHTI */
  isHti: Scalars['Boolean'];
  warrantyLengthInDays: Scalars['Int'];
};

export type SaveCustomerOwnerEntityInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  intacctId?: InputMaybe<Scalars['String']>;
  warrantyLengthInDays?: InputMaybe<Scalars['Int']>;
};

export type SaveCustomerOwnerEntityResult = {
  __typename?: 'SaveCustomerOwnerEntityResult';
  customerOwnerEntity: CustomerOwnerEntity;
};

export type CustomerOwnerEntityFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
};

export type SendTestDailyLotSummaryDigestInput = {
  users: Array<Scalars['ID']>;
  developments?: InputMaybe<Array<Scalars['ID']>>;
  date?: InputMaybe<Scalars['Date']>;
};

export type DeleteDataCacheEntryInput = {
  name: Scalars['String'];
  keyParts: Array<Scalars['String']>;
};

export type ClearDataCacheInput = {
  name: Scalars['String'];
};

export type DesignPackage = ReadyPlanLike & HasBlueprintUrl & Named & HasDisplayName & BaseItemParent & {
  __typename?: 'DesignPackage';
  id: Scalars['ID'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  code?: Maybe<Scalars['String']>;
  /**  The `type` + `code`, i.e. SFH-TX-1-001  */
  displayCode?: Maybe<Scalars['String']>;
  blueprintUrl: Url;
  status: ReadyPlanStatusDetail;
  /**  The latest status based on the latest RPAV, which may be archived depending on the ReadyPlan's status.  */
  effectiveStatus: ReadyPlanStatusDetail;
  options: Array<ReadyPlanOption>;
  optionGroups: Array<ReadyPlanOptionGroup>;
  interiorDesignPackageProductOfferings: Array<ProductOffering>;
  exteriorDesignPackageProductOfferings: Array<ProductOffering>;
  planPackages: Array<PlanPackage>;
  designPackageSources: Array<DesignPackageSource>;
  copyInProgress: Scalars['Boolean'];
  slots: Array<DesignPackageSlot>;
  assets: Array<ReadyPlanAsset>;
  lotTypes: Array<LotType>;
  location: DesignPackageLocationDetail;
  markets: Array<Market>;
  aggregateActive?: Maybe<ReadyPlanAggregateVersion>;
  aggregateDraft?: Maybe<ReadyPlanAggregateVersion>;
  aggregateLatest: ReadyPlanAggregateVersion;
  aggregateVersions: Array<ReadyPlanAggregateVersion>;
  availableUpdates: Array<DesignPackagePlanUpdate>;
  version: ReadyPlanAggregateVersion;
  itemLocations: Array<Location>;
  costCodes: Array<CostCode>;
  canEditLineItems: PotentialOperation2;
  contingencyMarkupPercentage?: Maybe<Scalars['Float']>;
  canEdit: PotentialOperation2;
  syncErrors?: Maybe<Scalars['String']>;
  readyPlanLocations: Array<ReadyPlanLocation>;
  potentialPersonalizationOptions: Array<ReadyPlanOptionGroup>;
  /**
   * List of potential add-on options associated with this design package via its source plans.
   * The active source plan RPOs are returned directly, mutated to the version of the source plan last sync'd into the DP.
   */
  potentialAddOnOptions: Array<ReadyPlanOption>;
  documents: Array<Document>;
  /**
   * By default generate combinations based on the RPOs and their prerequisites.
   * Use `fullCartesian: true` to bypass this and get the full cartesian product.
   * `optionGroupIds` can be used to limit the RPOGs used for combination generation.
   */
  combinations: Array<DesignPackageOptionCombination>;
  /**  List of relevant RPOGs that can be used as target groups for product cards and personalization options.  */
  availableTargetGroups: Array<ReadyPlanOptionGroup>;
  requiredOptions: Array<ReadyPlanRequiredOption>;
  /**  All downstream PRPCs referencing this DesignPackage via a ProductOffering  */
  projectConfigs: Array<ProjectReadyPlanConfig>;
  owner?: Maybe<InternalUser>;
  cabinetNotes?: Maybe<Scalars['String']>;
  cloneInProgress: Scalars['Boolean'];
};


export type DesignPackageOptionsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};


export type DesignPackageSlotsArgs = {
  rpavId?: InputMaybe<Scalars['ID']>;
  slotIds?: InputMaybe<Array<Scalars['ID']>>;
  optionIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type DesignPackageReadyPlanLocationsArgs = {
  filter?: InputMaybe<ReadyPlanLocationsSubFilter>;
};


export type DesignPackagePotentialPersonalizationOptionsArgs = {
  placeholderTliId: Scalars['ID'];
};


export type DesignPackageCombinationsArgs = {
  optionGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  fullCartesian?: InputMaybe<Scalars['Boolean']>;
};

export type ReadyPlanLocationsSubFilter = {
  /**  Only return RPLs with the same RoomType as this Location  */
  alternatesToLocationId?: InputMaybe<Scalars['ID']>;
};

export type SaveDesignPackageInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ReadyPlanStatus>;
  developmentId?: InputMaybe<Scalars['ID']>;
  planPackageIds?: InputMaybe<Array<Scalars['ID']>>;
  lotTypes?: InputMaybe<Array<LotType>>;
  location?: InputMaybe<DesignPackageLocation>;
  markets?: InputMaybe<Array<Scalars['ID']>>;
  contingencyMarkupPercentage?: InputMaybe<Scalars['Float']>;
  /**
   * The FE will send in 'two levels' of options; the `options` in this list will
   * always be the top-level Elevation (for Exterior DPs) or Interior Scheme (for
   * Interior DPs) and any child options (like Spec Levels) will always be nested
   * within the `optionPrereqChildren` arrays.
   */
  options?: InputMaybe<Array<SaveDesignPackageOptionInput>>;
  ownerId?: InputMaybe<Scalars['ID']>;
};

export type SaveDesignPackageOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  /**  The global option group ID to create a new RPO for.  */
  globalOptionGroupId?: InputMaybe<Scalars['ID']>;
  /**
   * The global option type ID to create a new RPO for. This is needed when creating scoped options for a new DP
   * (i.e., Interior Scheme and Exterior Scheme options). The GOG won't exist yet and will be created using the GOT ID.
   */
  globalOptionTypeId?: InputMaybe<Scalars['ID']>;
  /**  The name of the new RPO, it might create a new global option within the group.  */
  name?: InputMaybe<Scalars['String']>;
  /**  Custom code used for Interior/Exterior Scheme options.  */
  code?: InputMaybe<Scalars['String']>;
  /**  The list of RPOs that this RPO is a prereq for.  */
  optionPrereqChildren?: InputMaybe<Array<SaveDesignPackageOptionPrereqInput>>;
};

export type SaveDesignPackageOptionPrereqInput = {
  id?: InputMaybe<Scalars['ID']>;
  globalOptionGroupId?: InputMaybe<Scalars['ID']>;
  globalOptionTypeId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

/**  Usage: (slotId) | (itemId, locationId | locationPath, customSlotName) to identify an ItemSlot, then (attributeValueIds, templateId) to configure it.  */
export type CreateDesignPackagePlaceholderTliInput = {
  /**  Reuse and add to an existing slot  */
  itemSlotId?: InputMaybe<Scalars['ID']>;
  /**  For a net-new slot (i.e. LeftNav)  */
  itemId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
  locationPath?: InputMaybe<Scalars['String']>;
  /**  Differentiate a standard `Kitchen Sink` from a `Kitchen Bar Sink` by name.  */
  customSlotName?: InputMaybe<Scalars['String']>;
  /**  Required, as Attribute Values distinguish one family from another. Could technically be empty to allow `Any` values. May conflict with an existing `Any` family at this slot; should throw if necessary.  */
  attributeValueIds: Array<Scalars['ID']>;
  readyPlanId: Scalars['ID'];
  /** Omitted or [] => one PlanPackageIncomingSlot automatically created per PlanPackage linked via active DesignPackageSource. */
  applicablePlanPackageIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type CopyDesignPackageInput = {
  sourcePackageId: Scalars['ID'];
  sourcePackageVersionId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type CreateDesignPackagePlaceholderTliResult = {
  __typename?: 'CreateDesignPackagePlaceholderTliResult';
  placeholderTli: TakeoffLineItem;
  readyPlanAggregateVersion: ReadyPlanAggregateVersion;
  planPackageIncomingSlots: Array<PlanPackageIncomingSlot>;
};

export type SaveDesignPackageResult = {
  __typename?: 'SaveDesignPackageResult';
  designPackage: DesignPackage;
};

export type AcceptDesignPackageUpdatesInput = {
  designPackageId: Scalars['ID'];
  designPackagePlanUpdateIds: Array<Scalars['ID']>;
};

export type SaveDesignPackageUpdatesResult = {
  __typename?: 'SaveDesignPackageUpdatesResult';
  designPackage: DesignPackage;
};

export type DesignPackageFilter = {
  status?: InputMaybe<Array<ReadyPlanStatus>>;
};

export type DesignPackageOrderBy = {
  id?: InputMaybe<Order>;
  updatedAt?: InputMaybe<Order>;
};

export type DesignPackagesPageResult = {
  __typename?: 'DesignPackagesPageResult';
  entities: Array<DesignPackage>;
  pageInfo: PageInfo;
};

/**
 * Drives the left-nav of main Design Package UX, which focuses on "assigning products to slots".
 *
 * Disclaimer that "slot" is an overloaded term, insofar as within a DPS we may have multiple
 * family/requirement groups, i.e. "34in Kitchen Sink" or "36in Kitchen Sink" which have the same
 * `ItemSlot`, but a) different requirement placeholders/bid items, and b) are each their own "slot"
 * of a product for the user to fill-in.
 *
 * The label for these DPS slots is currently the material code, i.e. "Cabinet Hardware", and so
 * arguably the "best" identity for a DPS would be an `Item` + `Location` combination, i.e.
 * all of the "Cabinet Hardware" items/placeholders within the "Kitchen > Nook" location.
 *
 * This would also free-up the "slot regrouping" feature to use `ITI.name` to store the user-driven
 * placeholder names, i.e. to split/regroup `Cabinet Hardware` into `Door Hardware` vs. `Drawer Hardware`,
 * instead of our current `customPlaceholderName` field.
 */
export type DesignPackageSlot = {
  __typename?: 'DesignPackageSlot';
  /**  adhoc ID for ApolloCache to merge queries/mutation results together to keep a slot up to date. i.e. when adding/removing items from a slot auto-update with new items or coverage status via mutation results without having to refetch.  */
  id: Scalars['ID'];
  slot: ItemSlot;
  coverage: Scalars['Int'];
  isFullyAssigned: Scalars['Boolean'];
  items: Array<TakeoffLineItem>;
  hasPendingPlanPackageIncomingSlots: Scalars['Boolean'];
  isRejectedIncomingSlot: Scalars['Boolean'];
  /** @deprecated feature removed */
  pendingDeletion: Scalars['Boolean'];
};

export type DesignPackageOptionCombination = {
  __typename?: 'DesignPackageOptionCombination';
  id: Scalars['ID'];
  /** @deprecated use options instead */
  combination: Array<ReadyPlanOption>;
  options: Array<ReadyPlanOption>;
  name: Scalars['String'];
};

export type DesignPackageFinishScheduleFilter = {
  designRpavId: Scalars['ID'];
  planRpavIds?: InputMaybe<Array<Scalars['ID']>>;
  optionIds?: InputMaybe<Array<Scalars['ID']>>;
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  locationInPath?: InputMaybe<Array<Scalars['ID']>>;
  costCodeIds?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
  combinations?: InputMaybe<Array<Array<Scalars['ID']>>>;
};

export type DesignPackageFinishSchedulePageResult = {
  __typename?: 'DesignPackageFinishSchedulePageResult';
  entities: Array<TakeoffLineItem>;
  pageInfo: PageInfo;
};

export type PlaceholderCombinationsInput = {
  placeholderId: Scalars['ID'];
  productCardId?: InputMaybe<Scalars['ID']>;
  /**
   * The placeholder's target groups which determines the combinations available for its product cards.
   * This along with a product card's target combinations can be edited together and affects combinations on sibling cards.
   * If `productCardId` is not provided and `targetCombinations` is provided, it's assumed that we're adding a new product card.
   */
  targetGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  targetCombinations?: InputMaybe<Array<SaveTargetCombinationInput>>;
  /**  Determines which 'subgroup' of product cards to manage (i.e., all plans, Plan 1, Plan 2, etc.)  */
  targetPlanId?: InputMaybe<Scalars['ID']>;
};

export type PlaceholderCombinationsResult = {
  __typename?: 'PlaceholderCombinationsResult';
  takeoffLineItem: TakeoffLineItem;
  combinations: Array<DesignPackageOptionCombination>;
};

export type SavePersonalizationOptionGroupInput = {
  /**  The RPOG id to update, if updating.  */
  id?: InputMaybe<Scalars['ID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  /**  The design package id, if creating.  */
  designPackageId?: InputMaybe<Scalars['ID']>;
  /**  The personalization type, if creating.  */
  type?: InputMaybe<ReadyPlanOptionGroupPersonalizationType>;
  /**  Enable package options to group by feature  */
  groupByFeature?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  marketingDescription?: InputMaybe<Scalars['String']>;
  levels?: InputMaybe<Scalars['Int']>;
  /**  The list of (non-shadow) placeholders that this RPOG (and it's shadow placeholder) will drive, with optional ordering.  */
  controlledSlots?: InputMaybe<Array<SavePersonalizationControlledSlotInput>>;
  /**  The list of RPOGs that can be used to set target combinations for product/package options.  */
  personalizationTargetGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  /**  The list of products in the optional pool, for type=single & type=linked personalization options. */
  productOptions?: InputMaybe<Array<SavePersonalizationProductOptionInput>>;
  /**  The list of personalization options for type=package option groups (e.g. GE, Samsung, etc.).  */
  packageOptions?: InputMaybe<Array<SavePersonalizationPackageOptionInput>>;
  /**  If true, the RPO/TLI locations will be set to RPOG.location, even if the RPOG.location is currently correct.  */
  forceLocationCascade?: InputMaybe<Scalars['Boolean']>;
  /**  If true, displays this option group as a single product in checkout instead of separate package options  */
  displayPackageOptionsAsSingleProduct?: InputMaybe<Scalars['Boolean']>;
};

/**  A placeholder to be controlled by a personalization option group, with optional ordering.  */
export type SavePersonalizationControlledSlotInput = {
  placeholderId: Scalars['ID'];
  /**  The display order for this slot within the personalization option group.  */
  order?: InputMaybe<Scalars['Int']>;
};

export type SavePersonalizationPackageOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  /**  The list of product cards that this package option owns (e.g. Fridge SKU 123).  */
  products?: InputMaybe<Array<SavePersonalizationPackageOptionProductInput>>;
  /**  The list of option combinations that this package option is the default for.  */
  personalizationTargetCombinations?: InputMaybe<Array<SaveTargetCombinationInput>>;
  /**  The display order for this option in checkout.  */
  checkoutOrder?: InputMaybe<Scalars['Int']>;
};

/**  A cell/product in the table of package options (rows are options, columns are placeholders).  */
export type SavePersonalizationPackageOptionProductInput = {
  /**  The column, i.e. Sink (32in) or Tile. */
  placeholderMaterialId: Scalars['ID'];
  /**  The column's location, e.g. Bathroom > Floor or Bathroom > Shower, which is required for groupByFeature=true.  */
  locationId?: InputMaybe<Scalars['ID']>;
  /**  The product (e.g., GE Fridge SKU 123) or null for 'No Product'  */
  productMaterialId?: InputMaybe<Scalars['ID']>;
};

export type SavePersonalizationProductOptionInput = {
  materialVariantId: Scalars['ID'];
  personalizationTargetCombinations?: InputMaybe<Array<SaveTargetCombinationInput>>;
  /**  The display order for this option in checkout.  */
  checkoutOrder?: InputMaybe<Scalars['Int']>;
};

export type SaveTargetCombinationInput = {
  options: Array<Scalars['ID']>;
};

export type SavePersonalizationOptionGroupResult = {
  __typename?: 'SavePersonalizationOptionGroupResult';
  /**  The latest RPAV, which might be a new draft created by the save.  */
  version: ReadyPlanAggregateVersion;
  /**  The mutateToVersion-d option group.  */
  optionGroup: ReadyPlanOptionGroup;
};

export type CopyDesignPackageCardsInput = {
  sourcePlaceholderTliId: Scalars['ID'];
  targetPlaceholderTliIds: Array<Scalars['ID']>;
};

export type CopyDesignPackageCardsResult = {
  __typename?: 'CopyDesignPackageCardsResult';
  sourePlaceholderTli: TakeoffLineItem;
  targetPlaceholderTlis: Array<TakeoffLineItem>;
  addedTlis: Array<TakeoffLineItem>;
  /**  The latest RPAV, which might be a new draft created by the save.  */
  version: ReadyPlanAggregateVersion;
};

export type CopyDesignPackageSelectionsInput = {
  sourceOptionId: Scalars['ID'];
  targetOptionId: Scalars['ID'];
};

export type CopyDesignPackageSelectionsResult = {
  __typename?: 'CopyDesignPackageSelectionsResult';
  updatedTakeoffLineItems: Array<TakeoffLineItem>;
  updatedReadyPlanOptions: Array<ReadyPlanOption>;
  updatedReadyPlanRequiredOptions: Array<ReadyPlanRequiredOption>;
};

export type AutoAssignPackageOptionMaterialsInput = {
  designPackageOptionGroupIds: Array<Scalars['ID']>;
};

export type BackfillDesignPackageOptionCheckoutOrderInput = {
  /**  The product offering to copy checkoutOrder values from onto its interior/exterior design packages.  */
  productOfferingId: Scalars['ID'];
};

export type DesignPackagePlanUpdate = {
  __typename?: 'DesignPackagePlanUpdate';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  source: DesignPackageSource;
  /** @deprecated Prefer source instead */
  designPackage: DesignPackage;
  accepted: Scalars['Boolean'];
  /**  The PlanPackage RPAV that creates this update.  */
  planVersion: ReadyPlanAggregateVersion;
  /**  The DesignPackage RPAV that accepted this update.  */
  acceptedInVersion?: Maybe<ReadyPlanAggregateVersion>;
};

export type DesignPackageSource = {
  __typename?: 'DesignPackageSource';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  readyPlan: DesignPackage;
  planPackage: PlanPackage;
  copyInProgress: Scalars['Boolean'];
  active: Scalars['Boolean'];
  /**  We can version the DPS (turn it on/off) over time.  */
  versions: Array<DesignPackageSourceVersion>;
  /**  All incoming DPPUs that we've received from our PlanPackage. */
  planUpdates: Array<DesignPackagePlanUpdate>;
  planPackageVersion?: Maybe<ReadyPlanAggregateVersion>;
};

export type SaveDesignPackageSourceResult = {
  __typename?: 'SaveDesignPackageSourceResult';
  designPackageSource: DesignPackageSource;
};

export type DesignPackageSourceVersion = {
  __typename?: 'DesignPackageSourceVersion';
  id: Scalars['ID'];
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  identity: DesignPackageSource;
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
};

export type DesignPackageVersion = {
  __typename?: 'DesignPackageVersion';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  code?: Maybe<Scalars['String']>;
  contingencyMarkupPercentage?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  type: ReadyPlanTypeDetail;
  lotTypes: Array<LotType>;
  identity: DesignPackage;
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  markets: Array<Market>;
  owner?: Maybe<InternalUser>;
};

export type MaybeHasMarket = {
  id: Scalars['ID'];
  market?: Maybe<Market>;
};

export type Development = Named & HasSchedules & HasBlueprintUrl & MaybeHasMarket & {
  __typename?: 'Development';
  id: Scalars['ID'];
  name: Scalars['String'];
  blueprintUrl: Url;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  market: Market;
  cohorts?: Maybe<Array<Cohort>>;
  schedules: Array<Schedule>;
  /**  The list of all ReadyHome templates for this Development, both plans and options.  */
  itemTemplates: Array<ItemTemplate>;
  commitments: Array<DevelopmentCommitment>;
  documents: Array<Document>;
  bidContracts: Array<BidContract>;
  readyPlans: Array<ReadyPlan>;
  directorOfConstruction?: Maybe<InternalUser>;
  teamMembers: Array<DevelopmentTeamMember>;
  toDos: Array<ToDo>;
  options: Array<DevelopmentOption>;
  /**  For a development, the project-level schedule templates that may be used for projects.  */
  scheduleTemplates: Array<ScheduleTemplate>;
  sequenceSheetFollowers: Array<InternalUser>;
  /**
   * Indicates if the specified user will receive notifications,
   * based on either being a sequenceSheetFollowers or development team member
   */
  isSequenceSheetFollower: Scalars['Boolean'];
  /**  Indicates if the specified user is a team member.  */
  isTeamMember: Scalars['Boolean'];
  /**  Indicates if someone who is a follower can stop following. Returns false for development team members */
  canStopFollowingSequenceSheet: PotentialOperation2;
  /**  Indicates whether the development can generate templates from ready plans  */
  canGenerateTemplates: PotentialOperation2;
  itemMappings: Array<DevelopmentItemMapping>;
  /**
   * Obtains the cost mapping progress for a development
   * Not safe to be called for a large number of developments at once
   */
  costMappingProgress: CostMappingProgress;
  internalBudgetEstimate: BidContract;
  specOptions: Array<GlobalOption>;
  featureFlags: Array<FeatureFlag>;
  /**  Returns unique Trade Partners/Cost Codes related to all commitments within a development.  */
  tradePartners: Array<TradePartner>;
  costCodes: Array<CostCode>;
  drops: Array<Drop>;
  costCodesWithDraws: Array<CostCode>;
  schedulingExclusionDates: Array<SchedulingExclusionDate>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']>;
  salesTaxInBasisPoints: Scalars['Int'];
};


export type DevelopmentItemTemplatesArgs = {
  filter?: InputMaybe<DevelopmentItemTemplateFilter>;
};


export type DevelopmentIsSequenceSheetFollowerArgs = {
  internalUserId: Scalars['ID'];
};


export type DevelopmentIsTeamMemberArgs = {
  internalUserId: Scalars['ID'];
};


export type DevelopmentCanStopFollowingSequenceSheetArgs = {
  internalUserId: Scalars['ID'];
};


export type DevelopmentCanGenerateTemplatesArgs = {
  requireArchivedTemplatesAssigned?: InputMaybe<Scalars['Boolean']>;
};


export type DevelopmentItemMappingsArgs = {
  filter?: InputMaybe<DevelopmentItemMappingFilter>;
};

export type SaveDevelopmentInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  marketId?: InputMaybe<Scalars['ID']>;
  cohortIds?: InputMaybe<Array<Scalars['ID']>>;
  schedulingExclusionDates?: InputMaybe<Array<SaveSchedulingExclusionDateInput>>;
  salesTaxOverrideInBasisPoints?: InputMaybe<Scalars['Int']>;
};

export type SaveDevelopmentsInput = {
  developments: Array<SaveDevelopmentInput>;
};

export type SaveDevelopmentsResult = {
  __typename?: 'SaveDevelopmentsResult';
  developments: Array<Development>;
};

export type DevelopmentItemMapping = {
  __typename?: 'DevelopmentItemMapping';
  item: Item;
  costType: CostType;
  location: Location;
  stage: Stage;
  scheduleTemplateItemMappings: Array<ScheduleTemplateItemMapping>;
};

export type BulkTemplateFilter = {
  itemIds?: InputMaybe<Array<Scalars['ID']>>;
  planIds?: InputMaybe<Array<Scalars['ID']>>;
  /**  GlobalOption ids e.g. `go:115`  */
  optionIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type DevelopmentItemMappingFilter = {
  stage?: InputMaybe<Stage>;
};

export type DevelopmentFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  market?: InputMaybe<Array<Scalars['ID']>>;
};

export type DevelopmentItemTemplateFilter = {
  status?: InputMaybe<Array<ItemTemplateStatus>>;
};

export type CostMappingProgress = {
  __typename?: 'CostMappingProgress';
  totalScheduleTemplateItemMappings: Scalars['Int'];
  totalMappingsForDevelopment: Scalars['Int'];
  showCostMappingProgress: Scalars['Boolean'];
};

export type DevelopmentLotSummaryChartsResult = {
  __typename?: 'DevelopmentLotSummaryChartsResult';
  development: Development;
  acquired: Array<CohortLotSummaryChart>;
  totalAcquired: Scalars['Int'];
  permitSubmitted: Array<CohortLotSummaryChart>;
  totalPermitSubmitted: Scalars['Int'];
  permitReceived: Array<CohortLotSummaryChart>;
  totalPermitReceived: Scalars['Int'];
  verticalMobilization: Array<CohortLotSummaryChart>;
  totalVerticalMobilization: Scalars['Int'];
  verticalComplete: Array<CohortLotSummaryChart>;
  totalVerticalComplete: Scalars['Int'];
  delivered: Array<CohortLotSummaryChart>;
  totalDelivered: Scalars['Int'];
};

export type CohortLotSummaryChart = {
  __typename?: 'CohortLotSummaryChart';
  cohort: Cohort;
  total: Scalars['Int'];
};

export type DevelopmentCommitmentSummaryLineItem = {
  __typename?: 'DevelopmentCommitmentSummaryLineItem';
  costInCents: Scalars['Int'];
  numberOfProjects: Scalars['Int'];
  item: Item;
  quantity: Scalars['Int'];
};

export type DevelopmentCommitmentSummary = {
  __typename?: 'DevelopmentCommitmentSummary';
  lineItems: Array<DevelopmentCommitmentSummaryLineItem>;
};

export type SaveDevelopmentCommitmentInput = {
  id?: InputMaybe<Scalars['ID']>;
  marketId?: InputMaybe<Scalars['ID']>;
  tradePartnerId?: InputMaybe<Scalars['ID']>;
  costTypes?: InputMaybe<Array<CostType>>;
  tradeCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  /**  Combinations of item+location+cost type to bulk-add PIs to the new-or-existing dev commitment.  */
  potentialLineItems?: InputMaybe<Array<DevelopmentCommitmentPotentialLineItemInput>>;
  projectIds?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<CommitmentStatus>;
  type?: InputMaybe<DevelopmentCommitmentType>;
  name?: InputMaybe<Scalars['String']>;
  executionDate?: InputMaybe<Scalars['Date']>;
  contractExhibits?: InputMaybe<Scalars['String']>;
  contractSchedule?: InputMaybe<Scalars['String']>;
  contractTerms?: InputMaybe<Scalars['String']>;
  contractExclusions?: InputMaybe<Scalars['String']>;
  releasedDate?: InputMaybe<Scalars['Date']>;
  /** @deprecated use releasedDate instead */
  releasedAt?: InputMaybe<Scalars['Date']>;
  stage?: InputMaybe<Stage>;
  internalNote?: InputMaybe<Scalars['String']>;
  developmentId?: InputMaybe<Scalars['ID']>;
  documentId?: InputMaybe<Scalars['ID']>;
};

export type DeleteDevelopmentCommitmentInput = {
  id: Scalars['ID'];
  /**  Whether to delete signed (but not paid) commitments, for admins/tech coordinators, until we have a void feature.  */
  force?: InputMaybe<Scalars['Boolean']>;
};

export type SaveDevelopmentCommitmentResult = {
  __typename?: 'SaveDevelopmentCommitmentResult';
  developmentCommitment: DevelopmentCommitment;
};

export type DevelopmentCommitmentFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  market?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Array<CommitmentStatus>>;
  tradePartnerIds?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
};

/**
 * A flat list of item+cost type+location (grouped across all lots).
 *
 * The UI will client-side group these by the item's cost-code.
 */
export type DevelopmentCommitmentPotentialLineItem = {
  __typename?: 'DevelopmentCommitmentPotentialLineItem';
  item: Item;
  costType: CostType;
  location: Location;
  totalCostInCents: Scalars['Int'];
  projects: Array<Scalars['ID']>;
};

export type DevelopmentCommitmentPotentialLineItemInput = {
  itemId: Scalars['ID'];
  costType: CostType;
  locationId: Scalars['ID'];
};

export type DevelopmentCommitmentCostCodeSummary = {
  __typename?: 'DevelopmentCommitmentCostCodeSummary';
  costCode: CostCode;
  numberOfProjects: Scalars['Int'];
  quantity: Scalars['Int'];
};

export type DeleteDevelopmentCommitmentProjectsAndCommitmentsResult = {
  __typename?: 'DeleteDevelopmentCommitmentProjectsAndCommitmentsResult';
  developmentCommitment: DevelopmentCommitment;
};

export type DeleteDevelopmentCommitmentProjectsAndCommitmentsInput = {
  developmentCommitmentId: Scalars['ID'];
  projectIds: Array<Scalars['ID']>;
  commitmentIds: Array<Scalars['ID']>;
};

export type DevelopmentCommitmentsPage = {
  __typename?: 'DevelopmentCommitmentsPage';
  entities: Array<DevelopmentCommitment>;
  pageInfo: PageInfo;
};

export type DevelopmentOption = {
  __typename?: 'DevelopmentOption';
  id: Scalars['ID'];
  shortName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  development: Development;
  globalOption: GlobalOption;
};

export type SaveDevelopmentOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  shortName?: InputMaybe<Scalars['String']>;
  developmentId?: InputMaybe<Scalars['ID']>;
  globalOptionId?: InputMaybe<Scalars['ID']>;
};

export type SaveDevelopmentOptionsInput = {
  saveDevelopmentOptions: Array<SaveDevelopmentOptionInput>;
};

export type SaveDevelopmentOptionsResult = {
  __typename?: 'SaveDevelopmentOptionsResult';
  developmentOptions: Array<DevelopmentOption>;
};

export type DevelopmentTeamMember = {
  __typename?: 'DevelopmentTeamMember';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  projectRole: ProjectRoleDetail;
  development: Development;
  internalUser: InternalUser;
};

export type SaveDevelopmentTeamMemberInput = {
  projectRole: ProjectRole;
  developmentId: Scalars['ID'];
  internalUserId?: InputMaybe<Scalars['ID']>;
};

export type DocumentsPageResult = {
  __typename?: 'DocumentsPageResult';
  entities: Array<Document>;
  pageInfo: PageInfo;
};

export type DeleteDocumentsResult = {
  __typename?: 'DeleteDocumentsResult';
  parents: Array<DocumentParent>;
  /** @deprecated adding for backwards compatibility over the wire, should be removed in the future */
  emptyResult?: Maybe<Scalars['String']>;
  /** @deprecated adding for backwards compatibility over the wire, should be removed in the future */
  dummyString?: Maybe<Scalars['String']>;
};

export type CreateDocumentPendingUploadInput = {
  parentId: Scalars['ID'];
  name: Scalars['String'];
  sizeInBytes: Scalars['Int'];
  documentType: DocumentType;
  /** Optional. Will default to 'application/pdf' */
  contentType?: InputMaybe<Scalars['String']>;
};

export type CreateDocumentPendingUploadResult = {
  __typename?: 'CreateDocumentPendingUploadResult';
  signedUrl: Scalars['String'];
  documentId: Scalars['ID'];
};

export type MarkDocumentAsUploadedInput = {
  documentId: Scalars['ID'];
};

export type MarkDocumentAsUploadedResult = {
  __typename?: 'MarkDocumentAsUploadedResult';
  document: Document;
};

export type ToggleDocumentAsFavoritedInput = {
  documentId: Scalars['ID'];
};

export type ToggleDocumentAsFavoritedResult = {
  __typename?: 'ToggleDocumentAsFavoritedResult';
  document: Document;
};

export type SaveDocumentInput = {
  id?: InputMaybe<Scalars['ID']>;
  asset?: InputMaybe<AssetInput>;
  documentType?: InputMaybe<DocumentType>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  sizeInBytes?: InputMaybe<Scalars['Int']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['ID']>;
  /** @deprecated Setting category is now a no-op and will be derived by documentType */
  category?: InputMaybe<DocumentCategory>;
  taskIds?: InputMaybe<Array<Scalars['ID']>>;
  issuanceDate?: InputMaybe<Scalars['Date']>;
  ownerWorkAuthorizationId?: InputMaybe<Scalars['ID']>;
  projectDocumentAssociations?: InputMaybe<Array<ProjectDocumentAssociationInput>>;
  ownerId?: InputMaybe<Scalars['ID']>;
  attachOn?: InputMaybe<Array<DocumentAttachmentPlace>>;
};

export type SaveDocumentsInput = {
  documents: Array<SaveDocumentInput>;
};

export type SaveDocumentsResult = {
  __typename?: 'SaveDocumentsResult';
  documents: Array<Document>;
};

export type DocumentsFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  /** Request token type will take precedence */
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
  /** If an ID of a shadow project is provided, documents associated with its primary project will be included */
  parentIds?: InputMaybe<Array<Scalars['ID']>>;
  readyPlanId?: InputMaybe<Scalars['ID']>;
  versionId?: InputMaybe<Scalars['ID']>;
  documentType?: InputMaybe<Array<DocumentType>>;
  category?: InputMaybe<Array<DocumentCategory>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated includeUncategorized is now a no-op. All docs now have a category. */
  includeUncategorized?: InputMaybe<Scalars['Boolean']>;
};

export type DocumentsOrder = {
  createdAt?: InputMaybe<Order>;
};

export type DocumentParent = Development | PlanPackage | StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit;

export type DocumentOwner = HomeownerContract | HomeownerContractChangeOrder | Commitment | CommitmentChangeOrder | DevelopmentCommitment | InvoiceDocument | Development | PlanPackage | StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | BidContractRevision | LienWaiver | ChangeEvent;

export type Drop = {
  __typename?: 'Drop';
  id: Scalars['ID'];
  name: Scalars['String'];
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  costCode: CostCode;
  development?: Maybe<Development>;
  globalPlanTask: GlobalPlanTask;
  locations: Array<Location>;
  order: Scalars['Int'];
  commitments: Array<Commitment>;
  productOfferingIncomingUpdates: Array<ProductOfferingIncomingUpdate>;
  project?: Maybe<Project>;
};

export type SaveDropInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  costCodeId?: InputMaybe<Scalars['ID']>;
  developmentId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
  globalPlanTaskId?: InputMaybe<Scalars['ID']>;
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveDropResult = {
  __typename?: 'SaveDropResult';
  drop: Drop;
};

export type DeleteDropInput = {
  id: Scalars['ID'];
};

export type DropsFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  development?: InputMaybe<Array<Scalars['ID']>>;
  project?: InputMaybe<Array<Scalars['ID']>>;
};

export type Entity = {
  id: Scalars['ID'];
};

export enum ActivityPlanningState {
  Draft = 'DRAFT',
  ReadyForReview = 'READY_FOR_REVIEW',
  InReview = 'IN_REVIEW',
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type ActivityPlanningStateDetail = {
  __typename?: 'ActivityPlanningStateDetail';
  code: ActivityPlanningState;
  name: Scalars['String'];
};

export enum ActivityResponsibility {
  Homebound = 'HOMEBOUND',
  OwnersConsultant = 'OWNERS_CONSULTANT',
  NotApplicable = 'NOT_APPLICABLE'
}

export type ActivityResponsibilityDetail = {
  __typename?: 'ActivityResponsibilityDetail';
  code: ActivityResponsibility;
  name: Scalars['String'];
};

export enum ActivityType {
  PreconPlanning = 'PRECON_PLANNING',
  PreconConstructionDoc = 'PRECON_CONSTRUCTION_DOC'
}

export type ActivityTypeDetail = {
  __typename?: 'ActivityTypeDetail';
  code: ActivityType;
  name: Scalars['String'];
};

export enum AggregateVersionStatus {
  Draft = 'DRAFT',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type AggregateVersionStatusDetail = {
  __typename?: 'AggregateVersionStatusDetail';
  code: AggregateVersionStatus;
  name: Scalars['String'];
};

export enum AiEntityProposalEntityType {
  MaterialVariant = 'MATERIAL_VARIANT',
  ReadyPlanLocation = 'READY_PLAN_LOCATION',
  ReadyPlanOption = 'READY_PLAN_OPTION',
  ReadyPlanProgramData = 'READY_PLAN_PROGRAM_DATA'
}

export type AiEntityProposalEntityTypeDetail = {
  __typename?: 'AiEntityProposalEntityTypeDetail';
  code: AiEntityProposalEntityType;
  name: Scalars['String'];
};

export enum AiEntityProposalType {
  Create = 'CREATE',
  Update = 'UPDATE',
  Delete = 'DELETE'
}

export type AiEntityProposalTypeDetail = {
  __typename?: 'AiEntityProposalTypeDetail';
  code: AiEntityProposalType;
  name: Scalars['String'];
};

export enum AiFieldProposalStatus {
  Pending = 'PENDING',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED'
}

export type AiFieldProposalStatusDetail = {
  __typename?: 'AiFieldProposalStatusDetail';
  code: AiFieldProposalStatus;
  name: Scalars['String'];
};

export enum AiProposalStatus {
  Pending = 'PENDING',
  Complete = 'COMPLETE'
}

export type AiProposalStatusDetail = {
  __typename?: 'AiProposalStatusDetail';
  code: AiProposalStatus;
  name: Scalars['String'];
};

export enum AiProposalType {
  ConstructionDocumentImport = 'CONSTRUCTION_DOCUMENT_IMPORT',
  MaterialImport = 'MATERIAL_IMPORT'
}

export type AiProposalTypeDetail = {
  __typename?: 'AiProposalTypeDetail';
  code: AiProposalType;
  name: Scalars['String'];
};

export enum AllocationStrategy {
  SizeBased = 'SIZE_BASED',
  EqualShare = 'EQUAL_SHARE',
  MarketValue = 'MARKET_VALUE'
}

export type AllocationStrategyDetail = {
  __typename?: 'AllocationStrategyDetail';
  code: AllocationStrategy;
  name: Scalars['String'];
};

export enum ApprovalStatus {
  ChangesNeeded = 'CHANGES_NEEDED',
  Requested = 'REQUESTED',
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type ApprovalStatusDetail = {
  __typename?: 'ApprovalStatusDetail';
  code: ApprovalStatus;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export enum ApproverStatus {
  Pending = 'PENDING',
  ActionRequired = 'ACTION_REQUIRED',
  ChangesRequested = 'CHANGES_REQUESTED',
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type ApproverStatusDetail = {
  __typename?: 'ApproverStatusDetail';
  code: ApproverStatus;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export enum BidContractRevisionStatus {
  Draft = 'DRAFT',
  Uploaded = 'UPLOADED',
  Sent = 'SENT',
  Signed = 'SIGNED',
  PartiallySigned = 'PARTIALLY_SIGNED',
  Archived = 'ARCHIVED'
}

export type BidContractRevisionStatusDetail = {
  __typename?: 'BidContractRevisionStatusDetail';
  code: BidContractRevisionStatus;
  name: Scalars['String'];
};

export enum BidContractType {
  UnitBased = 'UNIT_BASED',
  ItemTemplateBased = 'ITEM_TEMPLATE_BASED',
  GroupedByPlanAndOption = 'GROUPED_BY_PLAN_AND_OPTION',
  UserCreatedGroupBased = 'USER_CREATED_GROUP_BASED',
  LegacyUnitAndTemplateBased = 'LEGACY_UNIT_AND_TEMPLATE_BASED'
}

export type BidContractTypeDetail = {
  __typename?: 'BidContractTypeDetail';
  code: BidContractType;
  name: Scalars['String'];
};

export enum BidPackageStatus {
  Draft = 'DRAFT',
  Open = 'OPEN',
  Received = 'RECEIVED',
  Awarded = 'AWARDED'
}

export type BidPackageStatusDetail = {
  __typename?: 'BidPackageStatusDetail';
  code: BidPackageStatus;
  name: Scalars['String'];
};

export enum BidScopeSource {
  Community = 'COMMUNITY',
  Subdivision = 'SUBDIVISION',
  Lot = 'LOT',
  ProductOffering = 'PRODUCT_OFFERING'
}

export type BidScopeSourceDetail = {
  __typename?: 'BidScopeSourceDetail';
  code: BidScopeSource;
  name: Scalars['String'];
};

export enum BillGmailAttachmentResult {
  NotPdf = 'NOT_PDF',
  MissingPo = 'MISSING_PO',
  MissingTrade = 'MISSING_TRADE',
  MissingProject = 'MISSING_PROJECT',
  MissingInvoiceNumber = 'MISSING_INVOICE_NUMBER',
  Duplicate = 'DUPLICATE',
  ClickToPay = 'CLICK_TO_PAY',
  BillCreated = 'BILL_CREATED',
  MissingConstructionStage = 'MISSING_CONSTRUCTION_STAGE',
  ProcessingError = 'PROCESSING_ERROR',
  NotAnInvoice = 'NOT_AN_INVOICE'
}

export type BillGmailAttachmentResultDetail = {
  __typename?: 'BillGmailAttachmentResultDetail';
  code: BillGmailAttachmentResult;
  name: Scalars['String'];
};

export enum BillGmailMessageResult {
  NotFound = 'NOT_FOUND',
  NoAttachments = 'NO_ATTACHMENTS',
  NoPdfs = 'NO_PDFS',
  Parsed = 'PARSED',
  Parsing = 'PARSING'
}

export type BillGmailMessageResultDetail = {
  __typename?: 'BillGmailMessageResultDetail';
  code: BillGmailMessageResult;
  name: Scalars['String'];
};

export enum BillReviewReason {
  MissingPo = 'MISSING_PO',
  UnsignedPo = 'UNSIGNED_PO',
  NeedVpo = 'NEED_VPO',
  InsufficientBudget = 'INSUFFICIENT_BUDGET',
  AutoParsed = 'AUTO_PARSED',
  NeedClarification = 'NEED_CLARIFICATION'
}

export type BillReviewReasonDetail = {
  __typename?: 'BillReviewReasonDetail';
  code: BillReviewReason;
  name: Scalars['String'];
};

export enum BillSource {
  Manual = 'MANUAL',
  ClickToPay = 'CLICK_TO_PAY',
  AutoParsed = 'AUTO_PARSED'
}

export type BillSourceDetail = {
  __typename?: 'BillSourceDetail';
  code: BillSource;
  name: Scalars['String'];
};

export enum BillStatus {
  Draft = 'DRAFT',
  ChangesRequested = 'CHANGES_REQUESTED',
  ReleaseScheduled = 'RELEASE_SCHEDULED',
  PendingApproval = 'PENDING_APPROVAL',
  ReadyToPay = 'READY_TO_PAY',
  Rejected = 'REJECTED',
  Paid = 'PAID',
  Reversed = 'REVERSED',
  Cancelled = 'CANCELLED',
  PendingConditionalLienWaiver = 'PENDING_CONDITIONAL_LIEN_WAIVER',
  PendingUnconditionalLienWaiver = 'PENDING_UNCONDITIONAL_LIEN_WAIVER',
  Unreleased = 'UNRELEASED',
  PartiallyPaid = 'PARTIALLY_PAID'
}

export type BillStatusDetail = {
  __typename?: 'BillStatusDetail';
  code: BillStatus;
  name: Scalars['String'];
};

export enum BillType {
  Standard = 'STANDARD',
  Deposit = 'DEPOSIT',
  Overhead = 'OVERHEAD',
  RepairAndMaintenance = 'REPAIR_AND_MAINTENANCE',
  Warranty = 'WARRANTY'
}

export type BillTypeDetail = {
  __typename?: 'BillTypeDetail';
  code: BillType;
  name: Scalars['String'];
};

export enum BusinessFunctionType {
  Architecture = 'ARCHITECTURE',
  Construction = 'CONSTRUCTION',
  Design = 'DESIGN',
  Marketing = 'MARKETING',
  Purchasing = 'PURCHASING',
  Accounting = 'ACCOUNTING',
  Sales = 'SALES',
  Warranty = 'WARRANTY',
  CustomerExperience = 'CUSTOMER_EXPERIENCE',
  Underwriting = 'UNDERWRITING',
  Precon = 'PRECON',
  MarketLaunch = 'MARKET_LAUNCH',
  LandAcquisition = 'LAND_ACQUISITION',
  Legal = 'LEGAL'
}

export type BusinessFunctionTypeDetail = {
  __typename?: 'BusinessFunctionTypeDetail';
  code: BusinessFunctionType;
  name: Scalars['String'];
};

export enum BuyoutStatus {
  NotBoughtOut = 'NOT_BOUGHT_OUT',
  BoughtOut = 'BOUGHT_OUT',
  PartiallyBoughtOut = 'PARTIALLY_BOUGHT_OUT'
}

export type BuyoutStatusDetail = {
  __typename?: 'BuyoutStatusDetail';
  code: BuyoutStatus;
  name: Scalars['String'];
  shortName: Scalars['String'];
};

export enum ChangeEventBudgetPhase {
  Prebid = 'PREBID',
  Awarded = 'AWARDED',
  Revised = 'REVISED'
}

export type ChangeEventBudgetPhaseDetail = {
  __typename?: 'ChangeEventBudgetPhaseDetail';
  code: ChangeEventBudgetPhase;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export enum ChangeEventLineItemType {
  Add = 'ADD',
  Modify = 'MODIFY',
  Cutoff = 'CUTOFF',
  Remove = 'REMOVE'
}

export type ChangeEventLineItemTypeDetail = {
  __typename?: 'ChangeEventLineItemTypeDetail';
  code: ChangeEventLineItemType;
  name: Scalars['String'];
};

export enum ChangeEventStatus {
  Draft = 'DRAFT',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Proposed = 'PROPOSED',
  Requested = 'REQUESTED',
  Void = 'VOID',
  PendingSignature = 'PENDING_SIGNATURE'
}

export type ChangeEventStatusDetail = {
  __typename?: 'ChangeEventStatusDetail';
  code: ChangeEventStatus;
  name: Scalars['String'];
};

export enum ChangeEventType {
  Internal = 'INTERNAL',
  External = 'EXTERNAL',
  BudgetReallocation = 'BUDGET_REALLOCATION'
}

export type ChangeEventTypeDetail = {
  __typename?: 'ChangeEventTypeDetail';
  code: ChangeEventType;
  name: Scalars['String'];
};

export enum ChangeEventWorkflow {
  ApplyFullConfiguration = 'APPLY_FULL_CONFIGURATION',
  ApplyPartialConfiguration = 'APPLY_PARTIAL_CONFIGURATION',
  AddOnBookOption = 'ADD_ON_BOOK_OPTION',
  ConfigurationTrueUp = 'CONFIGURATION_TRUE_UP',
  SwapProduct = 'SWAP_PRODUCT',
  FullLineCustomOption = 'FULL_LINE_CUSTOM_OPTION'
}

export type ChangeEventWorkflowDetail = {
  __typename?: 'ChangeEventWorkflowDetail';
  code: ChangeEventWorkflow;
  name: Scalars['String'];
  description: Scalars['String'];
};

export enum ChangeRequestAssetPlatform {
  Blueprint = 'BLUEPRINT',
  Salesforce = 'SALESFORCE',
  UnderwritingApp = 'UNDERWRITING_APP',
  Mls = 'MLS',
  Zillow = 'ZILLOW',
  Gdrive = 'GDRIVE',
  Figma = 'FIGMA',
  PhysicalColateral = 'PHYSICAL_COLATERAL',
  GoogleSlides = 'GOOGLE_SLIDES',
  GoogleSheet = 'GOOGLE_SHEET',
  Checkout = 'CHECKOUT',
  Airtable = 'AIRTABLE',
  HomeboundCom = 'HOMEBOUND_COM',
  LyonelaneCom = 'LYONELANE_COM',
  Air = 'AIR'
}

export type ChangeRequestAssetPlatformDetail = {
  __typename?: 'ChangeRequestAssetPlatformDetail';
  code: ChangeRequestAssetPlatform;
  name: Scalars['String'];
};

export enum ChangeRequestAssetScope {
  Project = 'PROJECT',
  Development = 'DEVELOPMENT'
}

export type ChangeRequestAssetScopeDetail = {
  __typename?: 'ChangeRequestAssetScopeDetail';
  code: ChangeRequestAssetScope;
  name: Scalars['String'];
};

export enum ChangeRequestPriority {
  Low = 'LOW',
  Medium = 'MEDIUM',
  High = 'HIGH',
  Urgent = 'URGENT',
  Expedited = 'EXPEDITED'
}

export type ChangeRequestPriorityDetail = {
  __typename?: 'ChangeRequestPriorityDetail';
  code: ChangeRequestPriority;
  name: Scalars['String'];
};

export enum ChangeRequestSource {
  Na = 'NA',
  ValueEngineering = 'VALUE_ENGINEERING',
  UpSpecing = 'UP_SPECING',
  CustomerRequestPersonalization = 'CUSTOMER_REQUEST_PERSONALIZATION',
  FieldDirective = 'FIELD_DIRECTIVE',
  FrameWalkAdjustments = 'FRAME_WALK_ADJUSTMENTS',
  ProviderUpdate = 'PROVIDER_UPDATE',
  InternalSalesFeedback = 'INTERNAL_SALES_FEEDBACK',
  BoylCustomerRequestPersonalization = 'BOYL_CUSTOMER_REQUEST_PERSONALIZATION',
  ProductRefresh = 'PRODUCT_REFRESH',
  InternalDesignFeedback = 'INTERNAL_DESIGN_FEEDBACK',
  FeeBuildProjectChange = 'FEE_BUILD_PROJECT_CHANGE'
}

export type ChangeRequestSourceDetail = {
  __typename?: 'ChangeRequestSourceDetail';
  code: ChangeRequestSource;
  name: Scalars['String'];
};

export enum ChangeRequestStatus {
  NeedsReview = 'NEEDS_REVIEW',
  ReadyForReview = 'READY_FOR_REVIEW',
  ReadyForApproval = 'READY_FOR_APPROVAL',
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Completed = 'COMPLETED',
  Reversed = 'REVERSED',
  Blocked = 'BLOCKED'
}

export type ChangeRequestStatusDetail = {
  __typename?: 'ChangeRequestStatusDetail';
  code: ChangeRequestStatus;
  name: Scalars['String'];
};

export enum ChangeRequestToDoType {
  InitialReview = 'INITIAL_REVIEW',
  ImpactEstimate = 'IMPACT_ESTIMATE',
  Implementation = 'IMPLEMENTATION',
  ImplementationReview = 'IMPLEMENTATION_REVIEW'
}

export type ChangeRequestToDoTypeDetail = {
  __typename?: 'ChangeRequestToDoTypeDetail';
  code: ChangeRequestToDoType;
  name: Scalars['String'];
};

export enum ChangeType {
  Na = 'NA',
  ProgramChange = 'PROGRAM_CHANGE',
  ArchitechturalDesign = 'ARCHITECHTURAL_DESIGN',
  StructuralDesign = 'STRUCTURAL_DESIGN',
  MepDesign = 'MEP_DESIGN',
  AddRemoveModifyProducts = 'ADD_REMOVE_MODIFY_PRODUCTS',
  ModifyOptionsProgram = 'MODIFY_OPTIONS_PROGRAM',
  NewDesignPackage = 'NEW_DESIGN_PACKAGE',
  UpdateExistingDesignPackage = 'UPDATE_EXISTING_DESIGN_PACKAGE',
  NewExteriorStyle = 'NEW_EXTERIOR_STYLE',
  ImplementationError = 'IMPLEMENTATION_ERROR',
  ProductRefresh = 'PRODUCT_REFRESH'
}

export type ChangeTypeDetail = {
  __typename?: 'ChangeTypeDetail';
  code: ChangeType;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type CheckoutConfigOptionGroupStepDetail = {
  __typename?: 'CheckoutConfigOptionGroupStepDetail';
  code: CheckoutConfigOptionGroupStep;
  name: Scalars['String'];
};

export enum CheckoutConfigStatus {
  Draft = 'DRAFT',
  Reserved = 'RESERVED',
  Expired = 'EXPIRED'
}

export type CheckoutConfigStatusDetail = {
  __typename?: 'CheckoutConfigStatusDetail';
  code: CheckoutConfigStatus;
  name: Scalars['String'];
};

export enum ClientPlatform {
  Web = 'WEB',
  Mobile = 'MOBILE'
}

export type ClientPlatformDetail = {
  __typename?: 'ClientPlatformDetail';
  code: ClientPlatform;
  name: Scalars['String'];
};

export enum CommentStreamVisibility {
  Internal = 'INTERNAL',
  Homeowner = 'HOMEOWNER',
  Trades = 'TRADES'
}

export type CommentStreamVisibilityDetail = {
  __typename?: 'CommentStreamVisibilityDetail';
  code: CommentStreamVisibility;
  name: Scalars['String'];
};

export enum CommitmentStatus {
  Draft = 'DRAFT',
  Uploaded = 'UPLOADED',
  Sent = 'SENT',
  Signed = 'SIGNED',
  Voided = 'VOIDED',
  PartiallySigned = 'PARTIALLY_SIGNED'
}

export type CommitmentStatusDetail = {
  __typename?: 'CommitmentStatusDetail';
  code: CommitmentStatus;
  name: Scalars['String'];
};

export enum CommitmentType {
  PurchaseOrder = 'PURCHASE_ORDER',
  Subcontract = 'SUBCONTRACT'
}

export type CommitmentTypeDetail = {
  __typename?: 'CommitmentTypeDetail';
  code: CommitmentType;
  name: Scalars['String'];
};

export enum CommunicationChannel {
  Email = 'EMAIL',
  Text = 'TEXT'
}

export type CommunicationChannelDetail = {
  __typename?: 'CommunicationChannelDetail';
  code: CommunicationChannel;
  name: Scalars['String'];
};

export enum CommunityType {
  Infill = 'INFILL',
  Suburban = 'SUBURBAN'
}

export type CommunityTypeDetail = {
  __typename?: 'CommunityTypeDetail';
  code: CommunityType;
  name: Scalars['String'];
};

export enum ConstructionType {
  TypeIii = 'TYPE_III',
  TypeIv = 'TYPE_IV',
  TypeV = 'TYPE_V'
}

export type ConstructionTypeDetail = {
  __typename?: 'ConstructionTypeDetail';
  code: ConstructionType;
  name: Scalars['String'];
};

export enum ContractType {
  Fixed = 'FIXED',
  CostPlus = 'COST_PLUS',
  BudgetReallocation = 'BUDGET_REALLOCATION'
}

export type ContractTypeDetail = {
  __typename?: 'ContractTypeDetail';
  code: ContractType;
  name: Scalars['String'];
};

export enum CostClassificationType {
  Soft = 'SOFT',
  Hard = 'HARD'
}

export type CostClassificationTypeDetail = {
  __typename?: 'CostClassificationTypeDetail';
  code: CostClassificationType;
  name: Scalars['String'];
};

export enum CostCodeInvoiceCategory {
  PreCon = 'PRE_CON',
  Foundation = 'FOUNDATION',
  Framing = 'FRAMING',
  Hardscape = 'HARDSCAPE',
  InsulationDrywall = 'INSULATION_DRYWALL',
  InteriorFinishes = 'INTERIOR_FINISHES',
  Roofing = 'ROOFING',
  RoughIn = 'ROUGH_IN',
  Siding = 'SIDING',
  SubstantialCompletion = 'SUBSTANTIAL_COMPLETION',
  ArchitecturePlan = 'ARCHITECTURE_PLAN',
  ArchitectureFee = 'ARCHITECTURE_FEE',
  Exterior = 'EXTERIOR',
  MechanicalSystems = 'MECHANICAL_SYSTEMS',
  GeneralConditions = 'GENERAL_CONDITIONS',
  Contingency = 'CONTINGENCY',
  HoldBack = 'HOLD_BACK',
  Deposit = 'DEPOSIT'
}

export type CostCodeInvoiceCategoryDetail = {
  __typename?: 'CostCodeInvoiceCategoryDetail';
  code: CostCodeInvoiceCategory;
  name: Scalars['String'];
  includeInInvoiceScheduleProration: Scalars['Boolean'];
  sortOrder: Scalars['Int'];
};

export enum CostConfidence {
  Low = 'LOW',
  High = 'HIGH',
  HardBid = 'HARD_BID'
}

export type CostConfidenceDetail = {
  __typename?: 'CostConfidenceDetail';
  code: CostConfidence;
  name: Scalars['String'];
};

export enum CostSubClassificationType {
  Indirect = 'INDIRECT',
  Direct = 'DIRECT'
}

export type CostSubClassificationTypeDetail = {
  __typename?: 'CostSubClassificationTypeDetail';
  code: CostSubClassificationType;
  name: Scalars['String'];
};

export enum CostType {
  Labor = 'LABOR',
  Materials = 'MATERIALS',
  Subcontractor = 'SUBCONTRACTOR',
  Equipment = 'EQUIPMENT',
  Other = 'OTHER'
}

export type CostTypeDetail = {
  __typename?: 'CostTypeDetail';
  code: CostType;
  name: Scalars['String'];
  tradePartnerName: Scalars['String'];
};

export enum DayOfWeek {
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY'
}

export type DayOfWeekDetail = {
  __typename?: 'DayOfWeekDetail';
  code: DayOfWeek;
  name: Scalars['String'];
  isBusinessDay: Scalars['Boolean'];
};

export enum DesignPackageLocation {
  Interior = 'INTERIOR',
  Exterior = 'EXTERIOR'
}

export type DesignPackageLocationDetail = {
  __typename?: 'DesignPackageLocationDetail';
  code: DesignPackageLocation;
  name: Scalars['String'];
};

export enum DevelopmentCommitmentType {
  Materials = 'MATERIALS',
  Labor = 'LABOR',
  LaborAndMaterials = 'LABOR_AND_MATERIALS'
}

export type DevelopmentCommitmentTypeDetail = {
  __typename?: 'DevelopmentCommitmentTypeDetail';
  code: DevelopmentCommitmentType;
  name: Scalars['String'];
};

export enum DocumentAttachmentPlace {
  PurchaseOrder = 'PURCHASE_ORDER',
  BidContract = 'BID_CONTRACT'
}

export type DocumentAttachmentPlaceDetail = {
  __typename?: 'DocumentAttachmentPlaceDetail';
  code: DocumentAttachmentPlace;
  name: Scalars['String'];
};

export enum DocumentCategory {
  Contractual = 'CONTRACTUAL',
  Permits = 'PERMITS',
  Design = 'DESIGN',
  Procurement = 'PROCUREMENT',
  Accounting = 'ACCOUNTING',
  SalesMarketing = 'SALES_MARKETING',
  Warranty = 'WARRANTY',
  Engineering = 'ENGINEERING',
  General = 'GENERAL',
  LotAcquisition = 'LOT_ACQUISITION',
  Valuation = 'VALUATION',
  Insurance = 'INSURANCE',
  AssetManagement = 'ASSET_MANAGEMENT'
}

export type DocumentCategoryDetail = {
  __typename?: 'DocumentCategoryDetail';
  code: DocumentCategory;
  name: Scalars['String'];
};

export enum DocumentType {
  PreconAgreement = 'PRECON_AGREEMENT',
  ConstructionAgreement = 'CONSTRUCTION_AGREEMENT',
  PurchaseOrder = 'PURCHASE_ORDER',
  Subcontract = 'SUBCONTRACT',
  PreconAgreementChangeOrder = 'PRECON_AGREEMENT_CHANGE_ORDER',
  ConstructionAgreementChangeOrder = 'CONSTRUCTION_AGREEMENT_CHANGE_ORDER',
  PurchaseOrderChangeOrder = 'PURCHASE_ORDER_CHANGE_ORDER',
  SubcontractChangeOrder = 'SUBCONTRACT_CHANGE_ORDER',
  Bill = 'BILL',
  Invoice = 'INVOICE',
  MeetingNote = 'MEETING_NOTE',
  Insurance = 'INSURANCE',
  Sales = 'SALES',
  ArchitectureAndEngineering = 'ARCHITECTURE_AND_ENGINEERING',
  SiteReport = 'SITE_REPORT',
  Correspondence = 'CORRESPONDENCE',
  General = 'GENERAL',
  Permitting = 'PERMITTING',
  ApprovedPlan = 'APPROVED_PLAN',
  Photo = 'PHOTO',
  DesignStudio = 'DESIGN_STUDIO',
  DevelopmentCommitment = 'DEVELOPMENT_COMMITMENT',
  BidContract = 'BID_CONTRACT',
  Expense = 'EXPENSE',
  WorkAuthorization = 'WORK_AUTHORIZATION',
  PriceAgreementChangeOrder = 'PRICE_AGREEMENT_CHANGE_ORDER',
  PriceAgreementBidContractRevision = 'PRICE_AGREEMENT_BID_CONTRACT_REVISION',
  PriceAgreementDevelopmentCommitment = 'PRICE_AGREEMENT_DEVELOPMENT_COMMITMENT',
  PriceAgreementCommitment = 'PRICE_AGREEMENT_COMMITMENT',
  Plan = 'PLAN',
  Drawing = 'DRAWING',
  FinishSchedule = 'FINISH_SCHEDULE',
  BoundarySurveys = 'BOUNDARY_SURVEYS',
  TopoSurveys = 'TOPO_SURVEYS',
  GeotechReportSoilsReport = 'GEOTECH_REPORT_SOILS_REPORT',
  ElevationCertificate = 'ELEVATION_CERTIFICATE',
  MiscellaneousGeneral = 'MISCELLANEOUS_GENERAL',
  Legal = 'LEGAL',
  CertificateOfOccupancy = 'CERTIFICATE_OF_OCCUPANCY',
  FloodInsurancePolicy = 'FLOOD_INSURANCE_POLICY',
  PreBuildAppraisal = 'PRE_BUILD_APPRAISAL',
  PurchaseAgreement = 'PURCHASE_AGREEMENT',
  PurchaseAgreementAmendmentLotAcq = 'PURCHASE_AGREEMENT_AMENDMENT_LOT_ACQ',
  SettlementStatementPreliminary = 'SETTLEMENT_STATEMENT_PRELIMINARY',
  SettlementStatementFinal = 'SETTLEMENT_STATEMENT_FINAL',
  Deed = 'DEED',
  RecordedDeed = 'RECORDED_DEED',
  TitleInsurancePolicy = 'TITLE_INSURANCE_POLICY',
  PropertySurvey = 'PROPERTY_SURVEY',
  EarnestMoneyReceiptLotAcq = 'EARNEST_MONEY_RECEIPT_LOT_ACQ',
  BuildingPermit = 'BUILDING_PERMIT',
  DemoPermit = 'DEMO_PERMIT',
  RetainingWallPermit = 'RETAINING_WALL_PERMIT',
  WaterPermit = 'WATER_PERMIT',
  GradingPermit = 'GRADING_PERMIT',
  PoolPermit = 'POOL_PERMIT',
  Vpo = 'VPO',
  PurchaseAgreementFinal = 'PURCHASE_AGREEMENT_FINAL',
  PurchaseAgreementCounterOffer = 'PURCHASE_AGREEMENT_COUNTER_OFFER',
  PurchaseAgreementAmendmentSales = 'PURCHASE_AGREEMENT_AMENDMENT_SALES',
  PurchaseAgreementAddendum = 'PURCHASE_AGREEMENT_ADDENDUM',
  EarnestMoneyReceiptSales = 'EARNEST_MONEY_RECEIPT_SALES',
  Disclosures = 'DISCLOSURES',
  MiscellaneousSales = 'MISCELLANEOUS_SALES',
  AppraisalPrecon = 'APPRAISAL_PRECON',
  AppraisalPostCoo = 'APPRAISAL_POST_COO',
  InsuranceHazard = 'INSURANCE_HAZARD',
  InsuranceBuildersRisk = 'INSURANCE_BUILDERS_RISK',
  HomeownerOrientation = 'HOMEOWNER_ORIENTATION',
  LienWaiver = 'LIEN_WAIVER',
  ChangeEvent = 'CHANGE_EVENT',
  ThirdPartyInspection = 'THIRD_PARTY_INSPECTION',
  CityInspection = 'CITY_INSPECTION',
  Warranty = 'WARRANTY',
  Rendering = 'RENDERING'
}

export type DocumentTypeDetail = {
  __typename?: 'DocumentTypeDetail';
  code: DocumentType;
  name: Scalars['String'];
  systemControlled: Scalars['Boolean'];
  defaultHomeownerVisible: Scalars['Boolean'];
  boolDefaultHomeownerVisible: Scalars['Boolean'];
};

export enum ErpAccrualType {
  TaskCompletion = 'TASK_COMPLETION',
  TaskAllocationChange = 'TASK_ALLOCATION_CHANGE',
  TaskReversal = 'TASK_REVERSAL',
  PurchaseOrderSigned = 'PURCHASE_ORDER_SIGNED',
  PurchaseOrderVoid = 'PURCHASE_ORDER_VOID',
  ChangeOrderVoid = 'CHANGE_ORDER_VOID',
  ChangeOrderSigned = 'CHANGE_ORDER_SIGNED',
  DepositBillPayment = 'DEPOSIT_BILL_PAYMENT',
  DepositBillPaymentVoid = 'DEPOSIT_BILL_PAYMENT_VOID',
  ApBillApproval = 'AP_BILL_APPROVAL',
  ApBillReversal = 'AP_BILL_REVERSAL',
  OverheadBillApproval = 'OVERHEAD_BILL_APPROVAL',
  OverheadBillReversal = 'OVERHEAD_BILL_REVERSAL',
  EomAccrual = 'EOM_ACCRUAL',
  BillLineItemAllocation = 'BILL_LINE_ITEM_ALLOCATION',
  BillLineItemAllocationReversal = 'BILL_LINE_ITEM_ALLOCATION_REVERSAL',
  EomAccrualReversal = 'EOM_ACCRUAL_REVERSAL',
  ExpenseCostAllocation = 'EXPENSE_COST_ALLOCATION',
  ExpenseCostAllocationReversal = 'EXPENSE_COST_ALLOCATION_REVERSAL'
}

export type ErpAccrualTypeDetail = {
  __typename?: 'ErpAccrualTypeDetail';
  code: ErpAccrualType;
  name: Scalars['String'];
};

export enum ErpRevenueLineItemSourceEvent {
  ContractPriceChange = 'CONTRACT_PRICE_CHANGE',
  ContractPriceChangeVoid = 'CONTRACT_PRICE_CHANGE_VOID',
  DirectExpense = 'DIRECT_EXPENSE',
  DirectExpenseVoid = 'DIRECT_EXPENSE_VOID',
  CostAccrual = 'COST_ACCRUAL',
  InitialBalance = 'INITIAL_BALANCE',
  OverheadBillApproval = 'OVERHEAD_BILL_APPROVAL',
  OverheadBillReversal = 'OVERHEAD_BILL_REVERSAL',
  BudgetChange = 'BUDGET_CHANGE',
  BudgetChangeVoid = 'BUDGET_CHANGE_VOID'
}

export type ErpRevenueLineItemSourceEventDetail = {
  __typename?: 'ErpRevenueLineItemSourceEventDetail';
  code: ErpRevenueLineItemSourceEvent;
  name: Scalars['String'];
};

export enum ErpTransactionGroupEvent {
  TaskCompletion = 'TASK_COMPLETION',
  DepositBill = 'DEPOSIT_BILL',
  ApBillApproval = 'AP_BILL_APPROVAL',
  EomAccrual = 'EOM_ACCRUAL',
  RevenueRecognition = 'REVENUE_RECOGNITION',
  RevenueEomAccrual = 'REVENUE_EOM_ACCRUAL',
  CostAllocation = 'COST_ALLOCATION'
}

export type ErpTransactionGroupEventDetail = {
  __typename?: 'ErpTransactionGroupEventDetail';
  code: ErpTransactionGroupEvent;
  name: Scalars['String'];
};

export enum ErpTransactionGroupStatus {
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Draft = 'DRAFT'
}

export type ErpTransactionGroupStatusDetail = {
  __typename?: 'ErpTransactionGroupStatusDetail';
  code: ErpTransactionGroupStatus;
  name: Scalars['String'];
};

export enum ErpTransactionStatus {
  Pending = 'PENDING',
  Mismatching = 'MISMATCHING',
  Synced = 'SYNCED'
}

export type ErpTransactionStatusDetail = {
  __typename?: 'ErpTransactionStatusDetail';
  code: ErpTransactionStatus;
  name: Scalars['String'];
};

export enum EstimateStatus {
  Draft = 'DRAFT',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED'
}

export type EstimateStatusDetail = {
  __typename?: 'EstimateStatusDetail';
  code: EstimateStatus;
  name: Scalars['String'];
};

export enum EstimateType {
  Preliminary = 'PRELIMINARY',
  Final = 'FINAL'
}

export type EstimateTypeDetail = {
  __typename?: 'EstimateTypeDetail';
  code: EstimateType;
  name: Scalars['String'];
};

export enum FeatureFlagStatus {
  Active = 'ACTIVE',
  Released = 'RELEASED',
  Archived = 'ARCHIVED'
}

export type FeatureFlagStatusDetail = {
  __typename?: 'FeatureFlagStatusDetail';
  code: FeatureFlagStatus;
  name: Scalars['String'];
};

export enum FeatureFlagType {
  TestFeature = 'TEST_FEATURE',
  TradePartnerCommunicationsSms = 'TRADE_PARTNER_COMMUNICATIONS_SMS',
  ChangeRequestMvp = 'CHANGE_REQUEST_MVP',
  DigitalBuildingExperiments = 'DIGITAL_BUILDING_EXPERIMENTS',
  TradePortalAccess = 'TRADE_PORTAL_ACCESS',
  MaterialCatalog = 'MATERIAL_CATALOG',
  DynamicSchedules = 'DYNAMIC_SCHEDULES',
  CostAccruals = 'COST_ACCRUALS',
  ProductConfig = 'PRODUCT_CONFIG',
  MobilePunchlistPolling = 'MOBILE_PUNCHLIST_POLLING',
  DynamicSchedulesTradeComms = 'DYNAMIC_SCHEDULES_TRADE_COMMS',
  RevenueRecognition = 'REVENUE_RECOGNITION',
  MobileProjectGeofence = 'MOBILE_PROJECT_GEOFENCE',
  OptionsCatalogV2 = 'OPTIONS_CATALOG_V2',
  DesignPackagePersonalization = 'DESIGN_PACKAGE_PERSONALIZATION',
  ProductionWarningBanner = 'PRODUCTION_WARNING_BANNER',
  MobileLeaderboard = 'MOBILE_LEADERBOARD',
  MobileScheduleSimDraftMode = 'MOBILE_SCHEDULE_SIM_DRAFT_MODE',
  MobileAiChatbotV2 = 'MOBILE_AI_CHATBOT_V2',
  VideoSightlineAnalysis = 'VIDEO_SIGHTLINE_ANALYSIS',
  MobileIncrementalSync = 'MOBILE_INCREMENTAL_SYNC',
  DesignerModifiedSlots = 'DESIGNER_MODIFIED_SLOTS',
  PreferLegacyProjects = 'PREFER_LEGACY_PROJECTS',
  BidPackagesV2 = 'BID_PACKAGES_V2',
  BlueprintAdmin = 'BLUEPRINT_ADMIN',
  MobileNavigationV2 = 'MOBILE_NAVIGATION_V2',
  CostCodesAdmin = 'COST_CODES_ADMIN',
  ItemCodesAdmin = 'ITEM_CODES_ADMIN',
  FeatureTypesAdmin = 'FEATURE_TYPES_ADMIN',
  TaskCatalogAdmin = 'TASK_CATALOG_ADMIN',
  ScheduleMilestoneTargets = 'SCHEDULE_MILESTONE_TARGETS',
  TakeoffRemovals = 'TAKEOFF_REMOVALS',
  MobileUploadObservability = 'MOBILE_UPLOAD_OBSERVABILITY',
  GuidedChangeEvent = 'GUIDED_CHANGE_EVENT',
  MobileSmartActionInbox = 'MOBILE_SMART_ACTION_INBOX',
  FinishSchedulesV2 = 'FINISH_SCHEDULES_V2',
  PlanPackagesV2 = 'PLAN_PACKAGES_V2',
  MobileSchedulesV2 = 'MOBILE_SCHEDULES_V2'
}

export type FeatureFlagTypeDetail = {
  __typename?: 'FeatureFlagTypeDetail';
  code: FeatureFlagType;
  name: Scalars['String'];
  description: Scalars['String'];
  presentational: Scalars['Boolean'];
};

export enum FinishScheduleColumnType {
  Core = 'CORE',
  Attribute = 'ATTRIBUTE'
}

export type FinishScheduleColumnTypeDetail = {
  __typename?: 'FinishScheduleColumnTypeDetail';
  code: FinishScheduleColumnType;
  name: Scalars['String'];
};

export enum FinishScheduleCoreColumn {
  Location = 'LOCATION',
  Image = 'IMAGE',
  Item = 'ITEM',
  Brand = 'BRAND',
  Product = 'PRODUCT',
  Trade = 'TRADE',
  Notes = 'NOTES',
  Link = 'LINK',
  Dimensions = 'DIMENSIONS'
}

export type FinishScheduleCoreColumnDetail = {
  __typename?: 'FinishScheduleCoreColumnDetail';
  code: FinishScheduleCoreColumn;
  name: Scalars['String'];
};

export enum FloodPlain {
  Fp_0 = 'FP_0',
  Fp_100 = 'FP_100',
  Fp_500 = 'FP_500'
}

export type FloodPlainDetail = {
  __typename?: 'FloodPlainDetail';
  code: FloodPlain;
  name: Scalars['String'];
};

export enum FloodZone {
  FzNone = 'FZ_NONE',
  FzAe = 'FZ_AE',
  FzCoastalA = 'FZ_COASTAL_A',
  FzVe = 'FZ_VE'
}

export type FloodZoneDetail = {
  __typename?: 'FloodZoneDetail';
  code: FloodZone;
  name: Scalars['String'];
};

export enum FoundationType {
  Slab = 'SLAB',
  Elevated = 'ELEVATED',
  Piers = 'PIERS'
}

export type FoundationTypeDetail = {
  __typename?: 'FoundationTypeDetail';
  code: FoundationType;
  name: Scalars['String'];
};

export enum GlobalOptionStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  PendingApproval = 'PENDING_APPROVAL'
}

export type GlobalOptionStatusDetail = {
  __typename?: 'GlobalOptionStatusDetail';
  code: GlobalOptionStatus;
  name: Scalars['String'];
};

export enum GlobalOptionTypeStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type GlobalOptionTypeStatusDetail = {
  __typename?: 'GlobalOptionTypeStatusDetail';
  code: GlobalOptionTypeStatus;
  name: Scalars['String'];
};

export enum GlobalPlanMilestoneType {
  Construction = 'CONSTRUCTION',
  Preconstruction = 'PRECONSTRUCTION',
  Community = 'COMMUNITY',
  Sales = 'SALES'
}

export type GlobalPlanMilestoneTypeDetail = {
  __typename?: 'GlobalPlanMilestoneTypeDetail';
  code: GlobalPlanMilestoneType;
  name: Scalars['String'];
};

export enum InboxItemStatus {
  Read = 'READ',
  Unread = 'UNREAD',
  Archived = 'ARCHIVED'
}

export type InboxItemStatusDetail = {
  __typename?: 'InboxItemStatusDetail';
  code: InboxItemStatus;
  name: Scalars['String'];
};

export enum InternalEstimateType {
  Temporary = 'TEMPORARY',
  LotDetermined = 'LOT_DETERMINED'
}

export type InternalEstimateTypeDetail = {
  __typename?: 'InternalEstimateTypeDetail';
  code: InternalEstimateType;
  name: Scalars['String'];
};

export enum InvoiceDocumentSource {
  Quickbooks = 'QUICKBOOKS',
  Intacct = 'INTACCT',
  Blueprint = 'BLUEPRINT'
}

export type InvoiceDocumentSourceDetail = {
  __typename?: 'InvoiceDocumentSourceDetail';
  code: InvoiceDocumentSource;
  name: Scalars['String'];
};

export enum InvoiceScheduleAmountType {
  Cost = 'COST',
  Margin = 'MARGIN',
  CostAndMargin = 'COST_AND_MARGIN'
}

export type InvoiceScheduleAmountTypeDetail = {
  __typename?: 'InvoiceScheduleAmountTypeDetail';
  code: InvoiceScheduleAmountType;
  name: Scalars['String'];
};

export enum InvoiceScheduleItemFrequency {
  Once = 'ONCE',
  Monthly = 'MONTHLY',
  Dynamic = 'DYNAMIC'
}

export type InvoiceScheduleItemFrequencyDetail = {
  __typename?: 'InvoiceScheduleItemFrequencyDetail';
  code: InvoiceScheduleItemFrequency;
  name: Scalars['String'];
};

export enum InvoiceScheduleTriggerType {
  Date = 'DATE',
  Task = 'TASK',
  Cost = 'COST',
  None = 'NONE',
  EndOfMonth = 'END_OF_MONTH',
  PercentageOfCompletion = 'PERCENTAGE_OF_COMPLETION'
}

export type InvoiceScheduleTriggerTypeDetail = {
  __typename?: 'InvoiceScheduleTriggerTypeDetail';
  code: InvoiceScheduleTriggerType;
  name: Scalars['String'];
};

export enum InvoiceSource {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export type InvoiceSourceDetail = {
  __typename?: 'InvoiceSourceDetail';
  code: InvoiceSource;
  name: Scalars['String'];
};

export enum InvoiceStatus {
  Draft = 'DRAFT',
  Requested = 'REQUESTED',
  ChangesRequested = 'CHANGES_REQUESTED',
  Approved = 'APPROVED',
  Paid = 'PAID',
  Rejected = 'REJECTED',
  Void = 'VOID'
}

export type InvoiceStatusDetail = {
  __typename?: 'InvoiceStatusDetail';
  code: InvoiceStatus;
  name: Scalars['String'];
};

export enum InvoiceType {
  PercentageOfCompletion = 'PERCENTAGE_OF_COMPLETION',
  DownPayment = 'DOWN_PAYMENT',
  Standard = 'STANDARD',
  WarrantyTrueUp = 'WARRANTY_TRUE_UP'
}

export type InvoiceTypeDetail = {
  __typename?: 'InvoiceTypeDetail';
  code: InvoiceType;
  name: Scalars['String'];
};

export enum ItemStatus {
  Draft = 'DRAFT',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type ItemStatusDetail = {
  __typename?: 'ItemStatusDetail';
  code: ItemStatus;
  name: Scalars['String'];
};

export enum ItemTemplateItemCostStatus {
  InternalEstimate = 'INTERNAL_ESTIMATE',
  Contracted = 'CONTRACTED',
  NoCostSource = 'NO_COST_SOURCE'
}

export type ItemTemplateItemCostStatusDetail = {
  __typename?: 'ItemTemplateItemCostStatusDetail';
  code: ItemTemplateItemCostStatus;
  name: Scalars['String'];
};

export enum ItemTemplateStatus {
  Draft = 'DRAFT',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  SystemDraft = 'SYSTEM_DRAFT'
}

export type ItemTemplateStatusDetail = {
  __typename?: 'ItemTemplateStatusDetail';
  code: ItemTemplateStatus;
  name: Scalars['String'];
};

export enum JobLogFlag {
  ChangeOrderDelay = 'CHANGE_ORDER_DELAY',
  ClientDelay = 'CLIENT_DELAY',
  ConsultantDelay = 'CONSULTANT_DELAY',
  DesignDelay = 'DESIGN_DELAY',
  GroundWet = 'GROUND_WET',
  HealthDelay = 'HEALTH_DELAY',
  MaterialsDelay = 'MATERIALS_DELAY',
  QualityControlDelay = 'QUALITY_CONTROL_DELAY',
  TradePartnerDelay = 'TRADE_PARTNER_DELAY',
  WeatherDelay = 'WEATHER_DELAY',
  DeliveryDelay = 'DELIVERY_DELAY',
  InspectionDelay = 'INSPECTION_DELAY',
  InternalDelay = 'INTERNAL_DELAY'
}

export type JobLogFlagDetail = {
  __typename?: 'JobLogFlagDetail';
  code: JobLogFlag;
  name: Scalars['String'];
};

export enum JobLogNoteType {
  Delay = 'DELAY',
  Delivery = 'DELIVERY',
  Incident = 'INCIDENT',
  Injury = 'INJURY',
  Inspection = 'INSPECTION',
  Issue = 'ISSUE',
  Holiday = 'HOLIDAY',
  RequestForInformation = 'REQUEST_FOR_INFORMATION',
  TradePartnerWork = 'TRADE_PARTNER_WORK',
  UpcomingActivity = 'UPCOMING_ACTIVITY',
  Visitor = 'VISITOR',
  Warranty = 'WARRANTY',
  Weather = 'WEATHER',
  Other = 'OTHER',
  ClientCommunication = 'CLIENT_COMMUNICATION',
  Internal = 'INTERNAL',
  PreCon = 'PRE_CON',
  AiSummary = 'AI_SUMMARY'
}

export type JobLogNoteTypeDetail = {
  __typename?: 'JobLogNoteTypeDetail';
  code: JobLogNoteType;
  name: Scalars['String'];
};

export enum LienWaiverCondition {
  Unconditional = 'UNCONDITIONAL',
  Conditional = 'CONDITIONAL'
}

export type LienWaiverConditionDetail = {
  __typename?: 'LienWaiverConditionDetail';
  code: LienWaiverCondition;
  name: Scalars['String'];
};

export enum LienWaiverStatus {
  Draft = 'DRAFT',
  Uploaded = 'UPLOADED',
  Sent = 'SENT',
  PartiallySigned = 'PARTIALLY_SIGNED',
  Signed = 'SIGNED',
  Pending = 'PENDING'
}

export type LienWaiverStatusDetail = {
  __typename?: 'LienWaiverStatusDetail';
  code: LienWaiverStatus;
  name: Scalars['String'];
};

export enum LienWaiverType {
  Progress = 'PROGRESS',
  Final = 'FINAL'
}

export type LienWaiverTypeDetail = {
  __typename?: 'LienWaiverTypeDetail';
  code: LienWaiverType;
  name: Scalars['String'];
};

export enum LocationType {
  Group = 'GROUP',
  Level = 'LEVEL',
  Room = 'ROOM',
  Feature = 'FEATURE',
  Scope = 'SCOPE'
}

export type LocationTypeDetail = {
  __typename?: 'LocationTypeDetail';
  code: LocationType;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export enum LotSalesStatus {
  NotAvailable = 'NOT_AVAILABLE',
  Available = 'AVAILABLE',
  ModelHome = 'MODEL_HOME',
  Reserved = 'RESERVED',
  Sold = 'SOLD'
}

export type LotSalesStatusDetail = {
  __typename?: 'LotSalesStatusDetail';
  code: LotSalesStatus;
  name: Scalars['String'];
};

export enum LotType {
  Boyl = 'BOYL',
  Bool = 'BOOL',
  Hbl = 'HBL',
  Btr = 'BTR',
  Fee = 'FEE'
}

export type LotTypeDetail = {
  __typename?: 'LotTypeDetail';
  code: LotType;
  name: Scalars['String'];
  clientContract: Scalars['String'];
  clientNoun: Scalars['String'];
  initialBudget: Scalars['String'];
  shortClientNoun: Scalars['String'];
  clientInvoice: Scalars['String'];
  description: Scalars['String'];
};

export enum MarkupApplicationMethod {
  PerLineItem = 'PER_LINE_ITEM',
  PerTotalCost = 'PER_TOTAL_COST'
}

export type MarkupApplicationMethodDetail = {
  __typename?: 'MarkupApplicationMethodDetail';
  code: MarkupApplicationMethod;
  name: Scalars['String'];
};

export enum MaterialAttributeDimensionType {
  Number = 'NUMBER',
  Select = 'SELECT',
  Boolean = 'BOOLEAN'
}

export type MaterialAttributeDimensionTypeDetail = {
  __typename?: 'MaterialAttributeDimensionTypeDetail';
  code: MaterialAttributeDimensionType;
  name: Scalars['String'];
};

export enum MaterialAttributeValueType {
  Exact = 'EXACT',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN',
  Between = 'BETWEEN'
}

export type MaterialAttributeValueTypeDetail = {
  __typename?: 'MaterialAttributeValueTypeDetail';
  code: MaterialAttributeValueType;
  name: Scalars['String'];
};

export enum MaterialType {
  Placeholder = 'PLACEHOLDER',
  Product = 'PRODUCT',
  Construction = 'CONSTRUCTION'
}

export type MaterialTypeDetail = {
  __typename?: 'MaterialTypeDetail';
  code: MaterialType;
  name: Scalars['String'];
};

export enum MobileSyncUpdateType {
  Created = 'CREATED',
  Updated = 'UPDATED',
  Deleted = 'DELETED'
}

export type MobileSyncUpdateTypeDetail = {
  __typename?: 'MobileSyncUpdateTypeDetail';
  code: MobileSyncUpdateType;
  name: Scalars['String'];
};

export enum PandaDocRole {
  User = 'USER',
  TradePartner = 'TRADE_PARTNER',
  HeadOfConstruction = 'HEAD_OF_CONSTRUCTION',
  ProjectManager = 'PROJECT_MANAGER',
  HomeboundAuthorizedSignatory = 'HOMEBOUND_AUTHORIZED_SIGNATORY',
  AreaManager = 'AREA_MANAGER',
  LeadEstimator = 'LEAD_ESTIMATOR',
  Homeowner = 'HOMEOWNER',
  Signatory = 'SIGNATORY'
}

export type PandaDocRoleDetail = {
  __typename?: 'PandaDocRoleDetail';
  code: PandaDocRole;
  name: Scalars['String'];
  shortName: Scalars['String'];
};

export enum PandaDocStatus {
  Pending = 'PENDING',
  Uploaded = 'UPLOADED',
  Sent = 'SENT',
  Viewed = 'VIEWED',
  WaitingApproval = 'WAITING_APPROVAL',
  Rejected = 'REJECTED',
  Approved = 'APPROVED',
  WaitingPay = 'WAITING_PAY',
  Paid = 'PAID',
  Completed = 'COMPLETED',
  Voided = 'VOIDED',
  Declined = 'DECLINED',
  AwaitingDelete = 'AWAITING_DELETE',
  UploadFailed = 'UPLOAD_FAILED',
  PartiallySigned = 'PARTIALLY_SIGNED',
  Draft = 'DRAFT'
}

export type PandaDocStatusDetail = {
  __typename?: 'PandaDocStatusDetail';
  code: PandaDocStatus;
  name: Scalars['String'];
  externalCode: Scalars['String'];
  externalNumber: Scalars['Int'];
};

export enum PandaDocWorkspace {
  Homebound = 'HOMEBOUND',
  HomeboundFinance = 'HOMEBOUND_FINANCE',
  HomeboundCalifornia = 'HOMEBOUND_CALIFORNIA'
}

export type PandaDocWorkspaceDetail = {
  __typename?: 'PandaDocWorkspaceDetail';
  code: PandaDocWorkspace;
  name: Scalars['String'];
};

export enum PaymentTermDueFrom {
  FromInvoiceBillDate = 'FROM_INVOICE_BILL_DATE',
  OfTheMonthOfInvoiceBillDate = 'OF_THE_MONTH_OF_INVOICE_BILL_DATE',
  OfNextMonthFromInvoiceBillDate = 'OF_NEXT_MONTH_FROM_INVOICE_BILL_DATE',
  Of_2NdMonthFromInvoiceBillDate = 'OF_2ND_MONTH_FROM_INVOICE_BILL_DATE',
  Of_3RdMonthFromInvoiceBillDate = 'OF_3RD_MONTH_FROM_INVOICE_BILL_DATE',
  Of_4ThMonthFromInvoiceBillDate = 'OF_4TH_MONTH_FROM_INVOICE_BILL_DATE',
  Of_5ThMonthFromInvoiceBillDate = 'OF_5TH_MONTH_FROM_INVOICE_BILL_DATE',
  Of_6ThMonthFromInvoiceBillDate = 'OF_6TH_MONTH_FROM_INVOICE_BILL_DATE'
}

export type PaymentTermDueFromDetail = {
  __typename?: 'PaymentTermDueFromDetail';
  code: PaymentTermDueFrom;
  name: Scalars['String'];
};

export enum Permit {
  Zoning = 'ZONING',
  Structural = 'STRUCTURAL',
  Electrical = 'ELECTRICAL',
  Plumbing = 'PLUMBING',
  Hvac = 'HVAC'
}

export type PermitDetail = {
  __typename?: 'PermitDetail';
  code: Permit;
  name: Scalars['String'];
};

export enum PlanPackageIncomingSlotStatus {
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Fulfilled = 'FULFILLED'
}

export type PlanPackageIncomingSlotStatusDetail = {
  __typename?: 'PlanPackageIncomingSlotStatusDetail';
  code: PlanPackageIncomingSlotStatus;
  name: Scalars['String'];
};

export enum ProgramDataBasementConfig {
  No = 'NO',
  PartialUnfinished = 'PARTIAL_UNFINISHED',
  FullFinished = 'FULL_FINISHED',
  FullUnfinished = 'FULL_UNFINISHED',
  WalkoutUnfinished = 'WALKOUT_UNFINISHED',
  WalkoutFinished = 'WALKOUT_FINISHED',
  GardenLevelUnfinished = 'GARDEN_LEVEL_UNFINISHED',
  GardenLevelFinished = 'GARDEN_LEVEL_FINISHED'
}

export type ProgramDataBasementConfigDetail = {
  __typename?: 'ProgramDataBasementConfigDetail';
  code: ProgramDataBasementConfig;
  name: Scalars['String'];
};

export enum ProgramDataGarageConfig {
  FrontLoad = 'FRONT_LOAD',
  AlleyLoad = 'ALLEY_LOAD',
  SideLoad = 'SIDE_LOAD',
  SplitLoad = 'SPLIT_LOAD'
}

export type ProgramDataGarageConfigDetail = {
  __typename?: 'ProgramDataGarageConfigDetail';
  code: ProgramDataGarageConfig;
  name: Scalars['String'];
};

export enum ProgramDataMatchState {
  Matches = 'MATCHES',
  DeviationPendingReview = 'DEVIATION_PENDING_REVIEW',
  DeviationAcknowledged = 'DEVIATION_ACKNOWLEDGED'
}

export type ProgramDataMatchStateDetail = {
  __typename?: 'ProgramDataMatchStateDetail';
  code: ProgramDataMatchState;
  name: Scalars['String'];
};

export enum ProgramDataPrimaryBedroomConfig {
  Up = 'UP',
  Down = 'DOWN'
}

export type ProgramDataPrimaryBedroomConfigDetail = {
  __typename?: 'ProgramDataPrimaryBedroomConfigDetail';
  code: ProgramDataPrimaryBedroomConfig;
  name: Scalars['String'];
};

export enum ProgramDataWindowColor {
  White = 'WHITE',
  Black = 'BLACK'
}

export type ProgramDataWindowColorDetail = {
  __typename?: 'ProgramDataWindowColorDetail';
  code: ProgramDataWindowColor;
  name: Scalars['String'];
};

export enum ProjectCollaboratorRole {
  Homeowner = 'HOMEOWNER',
  Family = 'FAMILY',
  Designer = 'DESIGNER',
  Legal = 'LEGAL',
  Other = 'OTHER'
}

export type ProjectCollaboratorRoleDetail = {
  __typename?: 'ProjectCollaboratorRoleDetail';
  code: ProjectCollaboratorRole;
  name: Scalars['String'];
};

export enum ProjectFeature {
  SelectionsV1 = 'SELECTIONS_V1',
  HopHideFinancials = 'HOP_HIDE_FINANCIALS',
  HopVizWalkthrough = 'HOP_VIZ_WALKTHROUGH',
  BpProjectSettings = 'BP_PROJECT_SETTINGS',
  HideAllHopPricing = 'HIDE_ALL_HOP_PRICING',
  HopPricingMsrpNoHb = 'HOP_PRICING_MSRP_NO_HB',
  HopPricingHbNoMsrp = 'HOP_PRICING_HB_NO_MSRP',
  HopSelectionsIncludedUpgradePricing = 'HOP_SELECTIONS_INCLUDED_UPGRADE_PRICING',
  SchedulesV2 = 'SCHEDULES_V2',
  SchedulesV2Gantt = 'SCHEDULES_V2_GANTT',
  SchedulesCalendar = 'SCHEDULES_CALENDAR',
  HopHidePreconFinancials = 'HOP_HIDE_PRECON_FINANCIALS',
  DelayFlags = 'DELAY_FLAGS',
  HomeownerNotes = 'HOMEOWNER_NOTES',
  HomeownerJourneyV2 = 'HOMEOWNER_JOURNEY_V2',
  ProductConfigPlan = 'PRODUCT_CONFIG_PLAN',
  ChangeEventSignatures = 'CHANGE_EVENT_SIGNATURES'
}

export type ProjectFeatureDetail = {
  __typename?: 'ProjectFeatureDetail';
  code: ProjectFeature;
  name: Scalars['String'];
};

export enum ProjectReadyPlanConfigOrientation {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type ProjectReadyPlanConfigOrientationDetail = {
  __typename?: 'ProjectReadyPlanConfigOrientationDetail';
  code: ProjectReadyPlanConfigOrientation;
  name: Scalars['String'];
};

export enum ProjectRole {
  HeadOfConstruction = 'HEAD_OF_CONSTRUCTION',
  AccountExecutive = 'ACCOUNT_EXECUTIVE',
  ConOpsProjectManager = 'CON_OPS_PROJECT_MANAGER',
  Designer = 'DESIGNER',
  Legal = 'LEGAL',
  AreaManager = 'AREA_MANAGER',
  Accounting = 'ACCOUNTING',
  PurchasingOne = 'PURCHASING_ONE',
  ConstructionCoordinator = 'CONSTRUCTION_COORDINATOR',
  Cx = 'CX',
  DesignLead = 'DESIGN_LEAD',
  HomeboundAuthorizedSignatory = 'HOMEBOUND_AUTHORIZED_SIGNATORY',
  AAndDProgramManager = 'A_AND_D_PROGRAM_MANAGER',
  WarrantyManager = 'WARRANTY_MANAGER',
  Superintendent = 'SUPERINTENDENT',
  PreConProjectManager = 'PRE_CON_PROJECT_MANAGER',
  PreConLead = 'PRE_CON_LEAD',
  PurchasingTwo = 'PURCHASING_TWO',
  HeadOfAccountsPayable = 'HEAD_OF_ACCOUNTS_PAYABLE',
  ApAccountant = 'AP_ACCOUNTANT',
  ArchitectAssociate = 'ARCHITECT_ASSOCIATE',
  MarketLead = 'MARKET_LEAD',
  ArchitectureLead = 'ARCHITECTURE_LEAD',
  OptionsManager = 'OPTIONS_MANAGER',
  AAndDOperations = 'A_AND_D_OPERATIONS',
  GraphicDesigner = 'GRAPHIC_DESIGNER',
  PurchasingManager = 'PURCHASING_MANAGER',
  SalesLead = 'SALES_LEAD',
  RiskManager = 'RISK_MANAGER',
  HeadOfPurchasing = 'HEAD_OF_PURCHASING',
  TransactionCoordinator = 'TRANSACTION_COORDINATOR',
  ConOpsProjectManagerTwo = 'CON_OPS_PROJECT_MANAGER_TWO',
  SuperintendentTwo = 'SUPERINTENDENT_TWO',
  GeneralManager = 'GENERAL_MANAGER',
  UnderwritingLead = 'UNDERWRITING_LEAD',
  AAndDStrategy = 'A_AND_D_STRATEGY',
  NationalNetworkManager = 'NATIONAL_NETWORK_MANAGER',
  ProductOps = 'PRODUCT_OPS',
  LwInvoiceSignatory = 'LW_INVOICE_SIGNATORY',
  LandAcquisitionLead = 'LAND_ACQUISITION_LEAD'
}

export type ProjectRoleDetail = {
  __typename?: 'ProjectRoleDetail';
  code: ProjectRole;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
  description: Scalars['String'];
};

export enum ProjectStageStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Draft = 'DRAFT'
}

export type ProjectStageStatusDetail = {
  __typename?: 'ProjectStageStatusDetail';
  code: ProjectStageStatus;
  name: Scalars['String'];
};

export enum ProjectStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Disqualified = 'DISQUALIFIED',
  Hold = 'HOLD',
  UnderWarranty = 'UNDER_WARRANTY'
}

export type ProjectStatusDetail = {
  __typename?: 'ProjectStatusDetail';
  code: ProjectStatus;
  name: Scalars['String'];
};

export enum ProjectUpdateActionType {
  ActivityComplete = 'ACTIVITY_COMPLETE',
  UnitComplete = 'UNIT_COMPLETE',
  DocumentAvailable = 'DOCUMENT_AVAILABLE',
  NewHomeownerNote = 'NEW_HOMEOWNER_NOTE'
}

export type ProjectUpdateActionTypeDetail = {
  __typename?: 'ProjectUpdateActionTypeDetail';
  code: ProjectUpdateActionType;
  name: Scalars['String'];
};

export enum PushNotificationEnvironment {
  Sandbox = 'SANDBOX',
  Production = 'PRODUCTION'
}

export type PushNotificationEnvironmentDetail = {
  __typename?: 'PushNotificationEnvironmentDetail';
  code: PushNotificationEnvironment;
  name: Scalars['String'];
};

export enum PushNotificationPlatform {
  Ios = 'IOS',
  Android = 'ANDROID',
  Web = 'WEB'
}

export type PushNotificationPlatformDetail = {
  __typename?: 'PushNotificationPlatformDetail';
  code: PushNotificationPlatform;
  name: Scalars['String'];
};

export enum ReadyPlanAssetType {
  CoverPhoto = 'COVER_PHOTO',
  Preview = 'PREVIEW',
  FloorPlan = 'FLOOR_PLAN',
  MoodBoard = 'MOOD_BOARD',
  GroundBasementFloorPlan = 'GROUND_BASEMENT_FLOOR_PLAN',
  FirstFloorPlan = 'FIRST_FLOOR_PLAN',
  SecondFloorPlan = 'SECOND_FLOOR_PLAN',
  AduFirstFloorPlan = 'ADU_FIRST_FLOOR_PLAN',
  AduSecondFloorPlan = 'ADU_SECOND_FLOOR_PLAN',
  AduExterior = 'ADU_EXTERIOR',
  AduKitchen = 'ADU_KITCHEN',
  AduLiving = 'ADU_LIVING',
  AduBathroom = 'ADU_BATHROOM',
  AduBedroom = 'ADU_BEDROOM'
}

export type ReadyPlanAssetTypeDetail = {
  __typename?: 'ReadyPlanAssetTypeDetail';
  code: ReadyPlanAssetType;
  name: Scalars['String'];
};

export enum ReadyPlanOptionGroupPersonalizationType {
  SingleProduct = 'SINGLE_PRODUCT',
  LinkedProduct = 'LINKED_PRODUCT',
  Package = 'PACKAGE'
}

export type ReadyPlanOptionGroupPersonalizationTypeDetail = {
  __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail';
  code: ReadyPlanOptionGroupPersonalizationType;
  name: Scalars['String'];
};

export enum ReadyPlanStatus {
  Draft = 'DRAFT',
  Archived = 'ARCHIVED',
  Active = 'ACTIVE'
}

export type ReadyPlanStatusDetail = {
  __typename?: 'ReadyPlanStatusDetail';
  code: ReadyPlanStatus;
  name: Scalars['String'];
};

export enum ReadyPlanType {
  Sfh = 'SFH',
  Adu = 'ADU',
  Mfu = 'MFU'
}

export type ReadyPlanTypeDetail = {
  __typename?: 'ReadyPlanTypeDetail';
  code: ReadyPlanType;
  name: Scalars['String'];
};

export enum ScheduleFlagReasonType {
  Client = 'CLIENT',
  Internal = 'INTERNAL',
  External = 'EXTERNAL',
  Permitting = 'PERMITTING',
  Field = 'FIELD',
  Inspection = 'INSPECTION',
  MaterialSupply = 'MATERIAL_SUPPLY',
  Other = 'OTHER',
  TradePartner = 'TRADE_PARTNER',
  Weather = 'WEATHER'
}

export type ScheduleFlagReasonTypeDetail = {
  __typename?: 'ScheduleFlagReasonTypeDetail';
  code: ScheduleFlagReasonType;
  name: Scalars['String'];
};

export enum ScheduleStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Draft = 'DRAFT'
}

export type ScheduleStatusDetail = {
  __typename?: 'ScheduleStatusDetail';
  code: ScheduleStatus;
  name: Scalars['String'];
};

export enum ScheduleTemplateStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Archived = 'ARCHIVED'
}

export type ScheduleTemplateStatusDetail = {
  __typename?: 'ScheduleTemplateStatusDetail';
  code: ScheduleTemplateStatus;
  name: Scalars['String'];
};

export enum ScopeChangeType {
  None = 'NONE',
  Add = 'ADD',
  Replace = 'REPLACE',
  Minor = 'MINOR',
  Major = 'MAJOR',
  Removed = 'REMOVED',
  System = 'SYSTEM'
}

export type ScopeChangeTypeDetail = {
  __typename?: 'ScopeChangeTypeDetail';
  code: ScopeChangeType;
  name: Scalars['String'];
};

export enum ScopeMode {
  None = 'NONE',
  ReleaseToTrades = 'RELEASE_TO_TRADES',
  Full = 'FULL',
  BudgetSafe = 'BUDGET_SAFE'
}

export type ScopeModeDetail = {
  __typename?: 'ScopeModeDetail';
  code: ScopeMode;
  name: Scalars['String'];
};

export enum SelectionCutoff {
  Cutoff_1 = 'CUTOFF_1',
  Cutoff_2A = 'CUTOFF_2A',
  Cutoff_2B = 'CUTOFF_2B',
  Cutoff_3 = 'CUTOFF_3'
}

export type SelectionCutoffDetail = {
  __typename?: 'SelectionCutoffDetail';
  code: SelectionCutoff;
  name: Scalars['String'];
};

export enum Stage {
  PreConPlanning = 'PRE_CON_PLANNING',
  PreConExecution = 'PRE_CON_EXECUTION',
  Construction = 'CONSTRUCTION',
  Development = 'DEVELOPMENT'
}

export type StageDetail = {
  __typename?: 'StageDetail';
  code: Stage;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
  slug: Scalars['String'];
  forDevelopment: Scalars['Boolean'];
  forProject: Scalars['Boolean'];
  isDeprecated: Scalars['Boolean'];
};

export enum SuburbanAssetCategory {
  Inventory = 'INVENTORY',
  ModelHome = 'MODEL_HOME',
  BuildToOrder = 'BUILD_TO_ORDER'
}

export type SuburbanAssetCategoryDetail = {
  __typename?: 'SuburbanAssetCategoryDetail';
  code: SuburbanAssetCategory;
  name: Scalars['String'];
};

export enum SystemChangeRequestAsset {
  PandaDoc = 'PANDA_DOC',
  UpdateClientAndContract = 'UPDATE_CLIENT_AND_CONTRACT',
  ChangeEvent = 'CHANGE_EVENT'
}

export type SystemChangeRequestAssetDetail = {
  __typename?: 'SystemChangeRequestAssetDetail';
  code: SystemChangeRequestAsset;
  name: Scalars['String'];
};

export enum SystemPlanMilestone {
  MobilizationStart = 'MOBILIZATION_START',
  VerticalComplete = 'VERTICAL_COMPLETE',
  PreMobilizationComplete = 'PRE_MOBILIZATION_COMPLETE',
  CustomerContractSigned = 'CUSTOMER_CONTRACT_SIGNED',
  BuildingPermitIssued = 'BUILDING_PERMIT_ISSUED',
  FinalPunchOut = 'FINAL_PUNCH_OUT',
  MobilizationComplete = 'MOBILIZATION_COMPLETE',
  DeliveryComplete = 'DELIVERY_COMPLETE',
  BuildingPermitSubmitted = 'BUILDING_PERMIT_SUBMITTED',
  FramingComplete = 'FRAMING_COMPLETE',
  DrywallComplete = 'DRYWALL_COMPLETE',
  SalesReady = 'SALES_READY',
  BuyerWalkthrough = 'BUYER_WALKTHROUGH',
  PreconReadyToStart = 'PRECON_READY_TO_START'
}

export type SystemPlanMilestoneDetail = {
  __typename?: 'SystemPlanMilestoneDetail';
  code: SystemPlanMilestone;
  name: Scalars['String'];
};

export enum SystemTask {
  ConstructionRts = 'CONSTRUCTION_RTS',
  FramingComplete = 'FRAMING_COMPLETE',
  DrywallComplete = 'DRYWALL_COMPLETE',
  DeliveryComplete = 'DELIVERY_COMPLETE',
  VerticalComplete = 'VERTICAL_COMPLETE',
  Acquired = 'ACQUIRED',
  PermitSubmitted = 'PERMIT_SUBMITTED',
  PermitReceived = 'PERMIT_RECEIVED',
  MlsDate = 'MLS_DATE',
  SalesReady = 'SALES_READY',
  BuyerWalkthrough = 'BUYER_WALKTHROUGH',
  PunchList = 'PUNCH_LIST',
  BuildingFinalInspection = 'BUILDING_FINAL_INSPECTION'
}

export type SystemTaskDetail = {
  __typename?: 'SystemTaskDetail';
  code: SystemTask;
  name: Scalars['String'];
};

export enum TakeoffLineItemAction {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export type TakeoffLineItemActionDetail = {
  __typename?: 'TakeoffLineItemActionDetail';
  code: TakeoffLineItemAction;
  name: Scalars['String'];
};

export enum TakeoffLineItemDesignPackageType {
  RegularPlaceholder = 'REGULAR_PLACEHOLDER',
  RegularProductCard = 'REGULAR_PRODUCT_CARD',
  IdpShadowPlaceholder = 'IDP_SHADOW_PLACEHOLDER',
  IdpShadowProductCard = 'IDP_SHADOW_PRODUCT_CARD',
  RpoShadowPlaceholder = 'RPO_SHADOW_PLACEHOLDER',
  RpoShadowProductCard = 'RPO_SHADOW_PRODUCT_CARD'
}

export type TakeoffLineItemDesignPackageTypeDetail = {
  __typename?: 'TakeoffLineItemDesignPackageTypeDetail';
  code: TakeoffLineItemDesignPackageType;
  name: Scalars['String'];
};

export enum TakeoffLineItemType {
  Iti = 'ITI',
  Tliv = 'TLIV'
}

export type TakeoffLineItemTypeDetail = {
  __typename?: 'TakeoffLineItemTypeDetail';
  code: TakeoffLineItemType;
  name: Scalars['String'];
};

export enum TaskDeadlineType {
  Cutoff = 'CUTOFF',
  KeyMilestone = 'KEY_MILESTONE'
}

export type TaskDeadlineTypeDetail = {
  __typename?: 'TaskDeadlineTypeDetail';
  code: TaskDeadlineType;
  name: Scalars['String'];
};

export enum TaskDependencyType {
  FinishStart = 'FINISH_START',
  StartStart = 'START_START',
  StartFinish = 'START_FINISH',
  FinishFinish = 'FINISH_FINISH'
}

export type TaskDependencyTypeDetail = {
  __typename?: 'TaskDependencyTypeDetail';
  code: TaskDependencyType;
  name: Scalars['String'];
  shorthand: Scalars['String'];
};

export enum TaskStatus {
  NotStarted = 'NOT_STARTED',
  InProgress = 'IN_PROGRESS',
  Complete = 'COMPLETE',
  OnHold = 'ON_HOLD',
  Delayed = 'DELAYED'
}

export type TaskStatusDetail = {
  __typename?: 'TaskStatusDetail';
  code: TaskStatus;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export enum TaskType {
  ScheduleTask = 'SCHEDULE_TASK',
  PlanTask = 'PLAN_TASK'
}

export type TaskTypeDetail = {
  __typename?: 'TaskTypeDetail';
  code: TaskType;
  name: Scalars['String'];
};

export enum TimeFrequency {
  Days = 'DAYS',
  Weeks = 'WEEKS',
  Months = 'MONTHS'
}

export type TimeFrequencyDetail = {
  __typename?: 'TimeFrequencyDetail';
  code: TimeFrequency;
  name: Scalars['String'];
};

export enum TimeOfDay {
  Morning = 'MORNING',
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING'
}

export type TimeOfDayDetail = {
  __typename?: 'TimeOfDayDetail';
  code: TimeOfDay;
  name: Scalars['String'];
};

export enum ToDoStatus {
  Backlog = 'BACKLOG',
  UpNext = 'UP_NEXT',
  InProgress = 'IN_PROGRESS',
  Complete = 'COMPLETE'
}

export type ToDoStatusDetail = {
  __typename?: 'ToDoStatusDetail';
  code: ToDoStatus;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export enum ToDoType {
  Submittals = 'SUBMITTALS',
  JobList = 'JOB_LIST',
  SkAsi = 'SK_ASI',
  RfiQuestions = 'RFI_QUESTIONS',
  MeetingNotes = 'MEETING_NOTES',
  Purchasing = 'PURCHASING',
  Design = 'DESIGN',
  Reviews = 'REVIEWS',
  Finance = 'FINANCE',
  General = 'GENERAL',
  ProductOps = 'PRODUCT_OPS',
  PunchList = 'PUNCH_LIST',
  Warranty = 'WARRANTY',
  Inspection = 'INSPECTION',
  Delivery = 'DELIVERY',
  ProductFeedback = 'PRODUCT_FEEDBACK',
  ScheduleReview = 'SCHEDULE_REVIEW'
}

export type ToDoTypeDetail = {
  __typename?: 'ToDoTypeDetail';
  code: ToDoType;
  name: Scalars['String'];
};

export enum TrackedJobStatus {
  Pending = 'PENDING',
  Running = 'RUNNING',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export type TrackedJobStatusDetail = {
  __typename?: 'TrackedJobStatusDetail';
  code: TrackedJobStatus;
  name: Scalars['String'];
};

export enum TradePartnerAvailabilityRequestStatus {
  Waiting = 'WAITING',
  RescheduleNeeded = 'RESCHEDULE_NEEDED',
  Confirmed = 'CONFIRMED',
  Canceled = 'CANCELED'
}

export type TradePartnerAvailabilityRequestStatusDetail = {
  __typename?: 'TradePartnerAvailabilityRequestStatusDetail';
  code: TradePartnerAvailabilityRequestStatus;
  name: Scalars['String'];
};

export enum TradePartnerMarketRole {
  BillApprover = 'BILL_APPROVER',
  ContractSignatory = 'CONTRACT_SIGNATORY',
  PoSignatory = 'PO_SIGNATORY',
  PoRecipient_1 = 'PO_RECIPIENT_1',
  PoRecipient_2 = 'PO_RECIPIENT_2',
  Estimating = 'ESTIMATING',
  Scheduling = 'SCHEDULING',
  LwSignatory = 'LW_SIGNATORY',
  SchedulingRecipient_2 = 'SCHEDULING_RECIPIENT_2'
}

export type TradePartnerMarketRoleDetail = {
  __typename?: 'TradePartnerMarketRoleDetail';
  code: TradePartnerMarketRole;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
  description: Scalars['String'];
};

export enum TradePartnerOnboardingStatus {
  InProgress = 'IN_PROGRESS',
  Complete = 'COMPLETE',
  DoNotUse = 'DO_NOT_USE',
  Inactive = 'INACTIVE'
}

export type TradePartnerOnboardingStatusDetail = {
  __typename?: 'TradePartnerOnboardingStatusDetail';
  code: TradePartnerOnboardingStatus;
  name: Scalars['String'];
};

export enum TradePartnerRequirementStatus {
  Meets = 'MEETS',
  DoesNotMeet = 'DOES_NOT_MEET',
  Na = 'NA',
  Waiver = 'WAIVER'
}

export type TradePartnerRequirementStatusDetail = {
  __typename?: 'TradePartnerRequirementStatusDetail';
  code: TradePartnerRequirementStatus;
  name: Scalars['String'];
};

export enum TradePartnerRequirementType {
  W9 = 'W9',
  WorkersComp = 'WORKERS_COMP',
  Msa = 'MSA',
  GeneralLiability = 'GENERAL_LIABILITY',
  ProfessionalLiability = 'PROFESSIONAL_LIABILITY',
  IndustryLicense = 'INDUSTRY_LICENSE',
  AutomobileLiability = 'AUTOMOBILE_LIABILITY',
  UmbrellaLiability = 'UMBRELLA_LIABILITY',
  TradeSpecificAgreement = 'TRADE_SPECIFIC_AGREEMENT',
  Appliances = 'APPLIANCES',
  CabinetsAndCabinetHardware = 'CABINETS_AND_CABINET_HARDWARE',
  CmuWalls = 'CMU_WALLS',
  Concrete = 'CONCRETE',
  Countertops = 'COUNTERTOPS',
  Drywall = 'DRYWALL',
  Electrical = 'ELECTRICAL',
  ExteriorSheatingFinishWindowsExtDoorsWaterproofing = 'EXTERIOR_SHEATING_FINISH_WINDOWS_EXT_DOORS_WATERPROOFING',
  FencesAndGates = 'FENCES_AND_GATES',
  FireplaceInstall = 'FIREPLACE_INSTALL',
  FireSupression = 'FIRE_SUPRESSION',
  FlooringAndWallSurfaces = 'FLOORING_AND_WALL_SURFACES',
  Framing = 'FRAMING',
  GarageDoors = 'GARAGE_DOORS',
  GeneralConditions = 'GENERAL_CONDITIONS',
  Gutters = 'GUTTERS',
  Hvac = 'HVAC',
  Insulation = 'INSULATION',
  InteriorMillworkDoorsHardware = 'INTERIOR_MILLWORK_DOORS_HARDWARE',
  LowVoltage = 'LOW_VOLTAGE',
  MasonryWallCladding = 'MASONRY_WALL_CLADDING',
  MirrorAndShowerEclosures = 'MIRROR_AND_SHOWER_ECLOSURES',
  Paint = 'PAINT',
  PlantingAndIrrigation = 'PLANTING_AND_IRRIGATION',
  Plumbing = 'PLUMBING',
  ProgressinveCleanup = 'PROGRESSINVE_CLEANUP',
  Roofing = 'ROOFING',
  Sitework = 'SITEWORK',
  SolarPanels = 'SOLAR_PANELS',
  StairRailings = 'STAIR_RAILINGS',
  StuccoAndThinVenner = 'STUCCO_AND_THIN_VENNER',
  SwppAndErosionControl = 'SWPP_AND_EROSION_CONTROL',
  Termite = 'TERMITE',
  WasteRemoval = 'WASTE_REMOVAL'
}

export type TradePartnerRequirementTypeDetail = {
  __typename?: 'TradePartnerRequirementTypeDetail';
  code: TradePartnerRequirementType;
  name: Scalars['String'];
  hasExpirationDate: Scalars['Boolean'];
  hasCoverageAmount: Scalars['Boolean'];
  hasLicenseNumber: Scalars['Boolean'];
  hasSignedDate: Scalars['Boolean'];
  isTsa: Scalars['Boolean'];
};

export enum TradePartnerTaskStatus {
  NeedsConfirmation = 'NEEDS_CONFIRMATION',
  Confirmed = 'CONFIRMED',
  Unavailable = 'UNAVAILABLE',
  CompletedJob = 'COMPLETED_JOB',
  NeedsReconfirmation = 'NEEDS_RECONFIRMATION',
  NotSent = 'NOT_SENT'
}

export type TradePartnerTaskStatusDetail = {
  __typename?: 'TradePartnerTaskStatusDetail';
  code: TradePartnerTaskStatus;
  name: Scalars['String'];
};

export enum UserEventType {
  Created = 'CREATED',
  Updated = 'UPDATED',
  Assigned = 'ASSIGNED',
  ScheduleChange = 'SCHEDULE_CHANGE',
  Completed = 'COMPLETED',
  Tagged = 'TAGGED',
  Finalized = 'FINALIZED',
  Approved = 'APPROVED',
  Commented = 'COMMENTED',
  Attached = 'ATTACHED',
  ProjectCohortChange = 'PROJECT_COHORT_CHANGE',
  LotRelease = 'LOT_RELEASE',
  PrpcApplied = 'PRPC_APPLIED',
  PrpcReset = 'PRPC_RESET',
  Flagged = 'FLAGGED',
  RequestedChanges = 'REQUESTED_CHANGES',
  Rejected = 'REJECTED',
  ItemAdded = 'ITEM_ADDED',
  ItemRemoved = 'ITEM_REMOVED',
  Published = 'PUBLISHED'
}

export type UserEventTypeDetail = {
  __typename?: 'UserEventTypeDetail';
  code: UserEventType;
  name: Scalars['String'];
  allowedEntities: Scalars['String'];
};

export enum UserType {
  Anonymous = 'ANONYMOUS',
  System = 'SYSTEM',
  Internal = 'INTERNAL',
  Homeowner = 'HOMEOWNER',
  TradePartner = 'TRADE_PARTNER'
}

export type UserTypeDetail = {
  __typename?: 'UserTypeDetail';
  code: UserType;
  name: Scalars['String'];
};

export enum VerificationMethod {
  VisualInput = 'VISUAL_INPUT',
  CloseUpVisualInput = 'CLOSE_UP_VISUAL_INPUT',
  DocumentUpload = 'DOCUMENT_UPLOAD',
  InPersonInspection = 'IN_PERSON_INSPECTION'
}

export type VerificationMethodDetail = {
  __typename?: 'VerificationMethodDetail';
  code: VerificationMethod;
  name: Scalars['String'];
};

export enum WarrantyTicketItemStatus {
  Submitted = 'SUBMITTED',
  Rejected = 'REJECTED',
  Accepted = 'ACCEPTED',
  OnHold = 'ON_HOLD',
  Scheduled = 'SCHEDULED',
  Completed = 'COMPLETED',
  MaterialsOrdered = 'MATERIALS_ORDERED',
  InProgress = 'IN_PROGRESS',
  TradeContacted = 'TRADE_CONTACTED',
  PendingInfoFromHomeowner = 'PENDING_INFO_FROM_HOMEOWNER'
}

export type WarrantyTicketItemStatusDetail = {
  __typename?: 'WarrantyTicketItemStatusDetail';
  code: WarrantyTicketItemStatus;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export enum WarrantyTicketItemType {
  Mechanical = 'MECHANICAL',
  Electrical = 'ELECTRICAL',
  Plumbing = 'PLUMBING',
  MiscInterior = 'MISC_INTERIOR',
  MiscExterior = 'MISC_EXTERIOR'
}

export type WarrantyTicketItemTypeDetail = {
  __typename?: 'WarrantyTicketItemTypeDetail';
  code: WarrantyTicketItemType;
  name: Scalars['String'];
};

export enum WarrantyTicketStatus {
  NotStarted = 'NOT_STARTED',
  InProgress = 'IN_PROGRESS',
  Closed = 'CLOSED'
}

export type WarrantyTicketStatusDetail = {
  __typename?: 'WarrantyTicketStatusDetail';
  code: WarrantyTicketStatus;
  name: Scalars['String'];
};

export enum WarrantyTicketType {
  ItemsOfContinuance = 'ITEMS_OF_CONTINUANCE',
  ThirtyDay = 'THIRTY_DAY',
  OneYear = 'ONE_YEAR',
  TwoYear = 'TWO_YEAR',
  TenYear = 'TEN_YEAR'
}

export type WarrantyTicketTypeDetail = {
  __typename?: 'WarrantyTicketTypeDetail';
  code: WarrantyTicketType;
  name: Scalars['String'];
};

export enum WarrantyTrueUpType {
  TimeOfSale = 'TIME_OF_SALE',
  SalePlus_30 = 'SALE_PLUS_30',
  SalePlus_60 = 'SALE_PLUS_60',
  Final = 'FINAL'
}

export type WarrantyTrueUpTypeDetail = {
  __typename?: 'WarrantyTrueUpTypeDetail';
  code: WarrantyTrueUpType;
  name: Scalars['String'];
  offsetInDays: Scalars['Int'];
};

export enum WeatherType {
  ClearDay = 'CLEAR_DAY',
  PartlyCloudyDay = 'PARTLY_CLOUDY_DAY',
  Cloudy = 'CLOUDY',
  Wind = 'WIND',
  Fog = 'FOG',
  ShowersDay = 'SHOWERS_DAY',
  Rain = 'RAIN',
  ThunderShowersDay = 'THUNDER_SHOWERS_DAY',
  ThunderDay = 'THUNDER_DAY',
  SnowShowersDay = 'SNOW_SHOWERS_DAY',
  Snow = 'SNOW',
  Sleet = 'SLEET',
  Hail = 'HAIL',
  Haze = 'HAZE',
  Ice = 'ICE',
  Smoke = 'SMOKE',
  Dust = 'DUST'
}

export type WeatherTypeDetail = {
  __typename?: 'WeatherTypeDetail';
  code: WeatherType;
  name: Scalars['String'];
};

export type AllEnumDetails = {
  __typename?: 'AllEnumDetails';
  activityPlanningState: Array<ActivityPlanningStateDetail>;
  activityResponsibility: Array<ActivityResponsibilityDetail>;
  activityType: Array<ActivityTypeDetail>;
  aggregateVersionStatus: Array<AggregateVersionStatusDetail>;
  aiEntityProposalEntityType: Array<AiEntityProposalEntityTypeDetail>;
  aiEntityProposalType: Array<AiEntityProposalTypeDetail>;
  aiFieldProposalStatus: Array<AiFieldProposalStatusDetail>;
  aiProposalStatus: Array<AiProposalStatusDetail>;
  aiProposalType: Array<AiProposalTypeDetail>;
  allocationStrategy: Array<AllocationStrategyDetail>;
  approvalStatus: Array<ApprovalStatusDetail>;
  approverStatus: Array<ApproverStatusDetail>;
  bidContractRevisionStatus: Array<BidContractRevisionStatusDetail>;
  bidContractType: Array<BidContractTypeDetail>;
  bidPackageStatus: Array<BidPackageStatusDetail>;
  bidScopeSource: Array<BidScopeSourceDetail>;
  billGmailAttachmentResult: Array<BillGmailAttachmentResultDetail>;
  billGmailMessageResult: Array<BillGmailMessageResultDetail>;
  billReviewReason: Array<BillReviewReasonDetail>;
  billSource: Array<BillSourceDetail>;
  billStatus: Array<BillStatusDetail>;
  billType: Array<BillTypeDetail>;
  businessFunctionType: Array<BusinessFunctionTypeDetail>;
  buyoutStatus: Array<BuyoutStatusDetail>;
  changeEventBudgetPhase: Array<ChangeEventBudgetPhaseDetail>;
  changeEventLineItemType: Array<ChangeEventLineItemTypeDetail>;
  changeEventStatus: Array<ChangeEventStatusDetail>;
  changeEventType: Array<ChangeEventTypeDetail>;
  changeEventWorkflow: Array<ChangeEventWorkflowDetail>;
  changeRequestAssetPlatform: Array<ChangeRequestAssetPlatformDetail>;
  changeRequestAssetScope: Array<ChangeRequestAssetScopeDetail>;
  changeRequestPriority: Array<ChangeRequestPriorityDetail>;
  changeRequestSource: Array<ChangeRequestSourceDetail>;
  changeRequestStatus: Array<ChangeRequestStatusDetail>;
  changeRequestToDoType: Array<ChangeRequestToDoTypeDetail>;
  changeType: Array<ChangeTypeDetail>;
  checkoutConfigOptionGroupStep: Array<CheckoutConfigOptionGroupStepDetail>;
  checkoutConfigStatus: Array<CheckoutConfigStatusDetail>;
  clientPlatform: Array<ClientPlatformDetail>;
  commentStreamVisibility: Array<CommentStreamVisibilityDetail>;
  commitmentStatus: Array<CommitmentStatusDetail>;
  commitmentType: Array<CommitmentTypeDetail>;
  communicationChannel: Array<CommunicationChannelDetail>;
  communityType: Array<CommunityTypeDetail>;
  constructionType: Array<ConstructionTypeDetail>;
  contractType: Array<ContractTypeDetail>;
  costClassificationType: Array<CostClassificationTypeDetail>;
  costCodeInvoiceCategory: Array<CostCodeInvoiceCategoryDetail>;
  costConfidence: Array<CostConfidenceDetail>;
  costSubClassificationType: Array<CostSubClassificationTypeDetail>;
  costType: Array<CostTypeDetail>;
  dayOfWeek: Array<DayOfWeekDetail>;
  designPackageLocation: Array<DesignPackageLocationDetail>;
  developmentCommitmentType: Array<DevelopmentCommitmentTypeDetail>;
  documentAttachmentPlace: Array<DocumentAttachmentPlaceDetail>;
  documentCategory: Array<DocumentCategoryDetail>;
  documentType: Array<DocumentTypeDetail>;
  erpAccrualType: Array<ErpAccrualTypeDetail>;
  erpRevenueLineItemSourceEvent: Array<ErpRevenueLineItemSourceEventDetail>;
  erpTransactionGroupEvent: Array<ErpTransactionGroupEventDetail>;
  erpTransactionGroupStatus: Array<ErpTransactionGroupStatusDetail>;
  erpTransactionStatus: Array<ErpTransactionStatusDetail>;
  estimateStatus: Array<EstimateStatusDetail>;
  estimateType: Array<EstimateTypeDetail>;
  featureFlagStatus: Array<FeatureFlagStatusDetail>;
  featureFlagType: Array<FeatureFlagTypeDetail>;
  finishScheduleColumnType: Array<FinishScheduleColumnTypeDetail>;
  finishScheduleCoreColumn: Array<FinishScheduleCoreColumnDetail>;
  floodPlain: Array<FloodPlainDetail>;
  floodZone: Array<FloodZoneDetail>;
  foundationType: Array<FoundationTypeDetail>;
  globalOptionStatus: Array<GlobalOptionStatusDetail>;
  globalOptionTypeStatus: Array<GlobalOptionTypeStatusDetail>;
  globalPlanMilestoneType: Array<GlobalPlanMilestoneTypeDetail>;
  inboxItemStatus: Array<InboxItemStatusDetail>;
  internalEstimateType: Array<InternalEstimateTypeDetail>;
  invoiceDocumentSource: Array<InvoiceDocumentSourceDetail>;
  invoiceScheduleAmountType: Array<InvoiceScheduleAmountTypeDetail>;
  invoiceScheduleItemFrequency: Array<InvoiceScheduleItemFrequencyDetail>;
  invoiceScheduleTriggerType: Array<InvoiceScheduleTriggerTypeDetail>;
  invoiceSource: Array<InvoiceSourceDetail>;
  invoiceStatus: Array<InvoiceStatusDetail>;
  invoiceType: Array<InvoiceTypeDetail>;
  itemStatus: Array<ItemStatusDetail>;
  itemTemplateItemCostStatus: Array<ItemTemplateItemCostStatusDetail>;
  itemTemplateStatus: Array<ItemTemplateStatusDetail>;
  jobLogFlag: Array<JobLogFlagDetail>;
  jobLogNoteType: Array<JobLogNoteTypeDetail>;
  lienWaiverCondition: Array<LienWaiverConditionDetail>;
  lienWaiverStatus: Array<LienWaiverStatusDetail>;
  lienWaiverType: Array<LienWaiverTypeDetail>;
  locationType: Array<LocationTypeDetail>;
  lotSalesStatus: Array<LotSalesStatusDetail>;
  lotType: Array<LotTypeDetail>;
  markupApplicationMethod: Array<MarkupApplicationMethodDetail>;
  materialAttributeDimensionType: Array<MaterialAttributeDimensionTypeDetail>;
  materialAttributeValueType: Array<MaterialAttributeValueTypeDetail>;
  materialType: Array<MaterialTypeDetail>;
  mobileSyncUpdateType: Array<MobileSyncUpdateTypeDetail>;
  pandaDocRole: Array<PandaDocRoleDetail>;
  pandaDocStatus: Array<PandaDocStatusDetail>;
  pandaDocWorkspace: Array<PandaDocWorkspaceDetail>;
  paymentTermDueFrom: Array<PaymentTermDueFromDetail>;
  permit: Array<PermitDetail>;
  planPackageIncomingSlotStatus: Array<PlanPackageIncomingSlotStatusDetail>;
  programDataBasementConfig: Array<ProgramDataBasementConfigDetail>;
  programDataGarageConfig: Array<ProgramDataGarageConfigDetail>;
  programDataMatchState: Array<ProgramDataMatchStateDetail>;
  programDataPrimaryBedroomConfig: Array<ProgramDataPrimaryBedroomConfigDetail>;
  programDataWindowColor: Array<ProgramDataWindowColorDetail>;
  projectCollaboratorRole: Array<ProjectCollaboratorRoleDetail>;
  projectFeature: Array<ProjectFeatureDetail>;
  projectReadyPlanConfigOrientation: Array<ProjectReadyPlanConfigOrientationDetail>;
  projectRole: Array<ProjectRoleDetail>;
  projectStageStatus: Array<ProjectStageStatusDetail>;
  projectStatus: Array<ProjectStatusDetail>;
  projectUpdateActionType: Array<ProjectUpdateActionTypeDetail>;
  pushNotificationEnvironment: Array<PushNotificationEnvironmentDetail>;
  pushNotificationPlatform: Array<PushNotificationPlatformDetail>;
  readyPlanAssetType: Array<ReadyPlanAssetTypeDetail>;
  readyPlanOptionGroupPersonalizationType: Array<ReadyPlanOptionGroupPersonalizationTypeDetail>;
  readyPlanStatus: Array<ReadyPlanStatusDetail>;
  readyPlanType: Array<ReadyPlanTypeDetail>;
  scheduleFlagReasonType: Array<ScheduleFlagReasonTypeDetail>;
  scheduleStatus: Array<ScheduleStatusDetail>;
  scheduleTemplateStatus: Array<ScheduleTemplateStatusDetail>;
  scopeChangeType: Array<ScopeChangeTypeDetail>;
  scopeMode: Array<ScopeModeDetail>;
  selectionCutoff: Array<SelectionCutoffDetail>;
  stage: Array<StageDetail>;
  suburbanAssetCategory: Array<SuburbanAssetCategoryDetail>;
  systemChangeRequestAsset: Array<SystemChangeRequestAssetDetail>;
  systemPlanMilestone: Array<SystemPlanMilestoneDetail>;
  systemTask: Array<SystemTaskDetail>;
  takeoffLineItemAction: Array<TakeoffLineItemActionDetail>;
  takeoffLineItemDesignPackageType: Array<TakeoffLineItemDesignPackageTypeDetail>;
  takeoffLineItemType: Array<TakeoffLineItemTypeDetail>;
  taskDeadlineType: Array<TaskDeadlineTypeDetail>;
  taskDependencyType: Array<TaskDependencyTypeDetail>;
  taskStatus: Array<TaskStatusDetail>;
  taskType: Array<TaskTypeDetail>;
  timeFrequency: Array<TimeFrequencyDetail>;
  timeOfDay: Array<TimeOfDayDetail>;
  toDoStatus: Array<ToDoStatusDetail>;
  toDoType: Array<ToDoTypeDetail>;
  trackedJobStatus: Array<TrackedJobStatusDetail>;
  tradePartnerAvailabilityRequestStatus: Array<TradePartnerAvailabilityRequestStatusDetail>;
  tradePartnerMarketRole: Array<TradePartnerMarketRoleDetail>;
  tradePartnerOnboardingStatus: Array<TradePartnerOnboardingStatusDetail>;
  tradePartnerRequirementStatus: Array<TradePartnerRequirementStatusDetail>;
  tradePartnerRequirementType: Array<TradePartnerRequirementTypeDetail>;
  tradePartnerTaskStatus: Array<TradePartnerTaskStatusDetail>;
  userEventType: Array<UserEventTypeDetail>;
  userType: Array<UserTypeDetail>;
  verificationMethod: Array<VerificationMethodDetail>;
  warrantyTicketItemStatus: Array<WarrantyTicketItemStatusDetail>;
  warrantyTicketItemType: Array<WarrantyTicketItemTypeDetail>;
  warrantyTicketStatus: Array<WarrantyTicketStatusDetail>;
  warrantyTicketType: Array<WarrantyTicketTypeDetail>;
  warrantyTrueUpType: Array<WarrantyTrueUpTypeDetail>;
  weatherType: Array<WeatherTypeDetail>;
};

export type IdentifyProjectAccrualAdjustmentsInput = {
  projectIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum CostAccrualAdjustmentType {
  TaskWithOverbilled = 'TASK_WITH_OVERBILLED',
  TaskCompleteWithUnbilled = 'TASK_COMPLETE_WITH_UNBILLED',
  UnallocatedWithUnbilled = 'UNALLOCATED_WITH_UNBILLED'
}

export type IdentifyProjectAccrualAdjustmentsResult = {
  __typename?: 'IdentifyProjectAccrualAdjustmentsResult';
  type: CostAccrualAdjustmentType;
  commitmentLineItem: CommitmentLineItem;
  commitmentLikeReference: Scalars['String'];
  adjustInCents: Scalars['Int'];
  intacctVendorId: Scalars['String'];
  intacctGLAccountNo: Scalars['String'];
  intacctProjectId: Scalars['String'];
  intacctItemId: Scalars['String'];
  intacctCustomerId: Scalars['String'];
  intacctLocationId: Scalars['String'];
};

export type ErpAccrualLineItemSourceLine = BillLineItemAllocation | CommitmentDraw | CommitmentLineItem | ExpenseAllocationAllocation | ProjectItem | CostCode;

export type ErpRevenueInitialBalanceInput = {
  projectIds: Array<Scalars['ID']>;
};

export type SaveEstimateInput = {
  id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EstimateStatus>;
  type?: InputMaybe<EstimateType>;
  projectStageId?: InputMaybe<Scalars['ID']>;
  changeEventId?: InputMaybe<Scalars['ID']>;
};

export type SaveEstimateResult = {
  __typename?: 'SaveEstimateResult';
  estimate: Estimate;
};

export type EstimateFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
};

export type AnnotatedCost = {
  __typename?: 'AnnotatedCost';
  item: Item;
  totalPriceInCents: Scalars['Int'];
};

export type EstimateLineItem = {
  __typename?: 'EstimateLineItem';
  id: Scalars['ID'];
  quantity?: Maybe<Scalars['Int']>;
  estimate: Estimate;
  projectItem: ProjectItem;
  projectItemHasDiverged: Scalars['Boolean'];
  isPlaceholder: Scalars['Boolean'];
  unitCostInCents: Scalars['Int'];
  unitPriceInCents: Scalars['Int'];
  totalCostInCents: Scalars['Int'];
  totalPriceInCents: Scalars['Int'];
  changeEventLineItem?: Maybe<ChangeEventLineItem>;
  unitOfMeasure: UnitOfMeasure;
  displayName: Scalars['String'];
};

export type Expense = {
  __typename?: 'Expense';
  id: Scalars['ID'];
  amountInCents: Scalars['Int'];
  unallocatedAmountInCents: Scalars['Int'];
  expenseDate: Scalars['Date'];
  dueDate?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  costCode?: Maybe<CostCode>;
  intacctApBillId: Scalars['String'];
  intacctApBillLineId: Scalars['String'];
  intacctItemId: Scalars['String'];
  intacctVendorName: Scalars['String'];
  intacctVendorBlueprintId?: Maybe<Scalars['String']>;
  amountPaidInCents: Scalars['Int'];
  stage: StageDetail;
  project: Project;
  potentialProjectItems: Array<ProjectItem>;
  intacctVendorId: Scalars['String'];
  document?: Maybe<Document>;
  allocations: Array<ExpenseAllocation>;
  changeEvents: Array<ChangeEvent>;
  documents: Array<Document>;
  tradeNumber?: Maybe<Scalars['String']>;
  allLineItemsAreExpenses: Scalars['Boolean'];
  canBeConvertedToBill: PotentialOperation2;
  isBrex: Scalars['Boolean'];
};

export type SaveExpenseInput = {
  id?: InputMaybe<Scalars['ID']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  expenseDate?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  costCodeId?: InputMaybe<Scalars['ID']>;
  intacctApBillId?: InputMaybe<Scalars['String']>;
  intacctApBillLineId?: InputMaybe<Scalars['String']>;
  intacctItemId?: InputMaybe<Scalars['String']>;
  intacctVendorName?: InputMaybe<Scalars['String']>;
  intacctVendorBlueprintId?: InputMaybe<Scalars['String']>;
  amountPaidInCents?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  projectId?: InputMaybe<Scalars['ID']>;
  intacctVendorId?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['ID']>;
  documents?: InputMaybe<Array<Scalars['ID']>>;
  tradeNumber?: InputMaybe<Scalars['String']>;
  allLineItemsAreExpenses?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['Date']>;
};

export type SaveExpensesInput = {
  expenses: Array<SaveExpenseInput>;
};

export type SaveExpensesResult = {
  __typename?: 'SaveExpensesResult';
  expenses: Array<Expense>;
};

export type ExpenseFilter = {
  intacctApBillId?: InputMaybe<Array<Scalars['String']>>;
  projectId?: InputMaybe<Array<Scalars['ID']>>;
  unallocated?: InputMaybe<Scalars['Boolean']>;
  allocated?: InputMaybe<Scalars['Boolean']>;
};

export type ConvertExpenseToBillInput = {
  expenseId: Scalars['ID'];
};

export type ConvertExpenseToBillResult = {
  __typename?: 'ConvertExpenseToBillResult';
  bill: Bill;
};

export type ExpensesPage = {
  __typename?: 'ExpensesPage';
  entities: Array<Expense>;
  pageInfo: PageInfo;
};

export type ExpenseAllocation = {
  __typename?: 'ExpenseAllocation';
  id: Scalars['ID'];
  amountInCents: Scalars['Int'];
  paidAmountInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  expense: Expense;
  projectItem: ProjectItem;
  historicExpenseAmountInvoiced?: Maybe<Scalars['Int']>;
  costLineItemAllocations: Array<CostLineItemAllocation>;
  commitmentLineItem?: Maybe<CommitmentLineItem>;
  invoiceAccruedLineItems: Array<InvoiceAccruedLineItem>;
  allocations: Array<ExpenseAllocationAllocation>;
};

export type SaveExpenseAllocationInput = {
  id?: InputMaybe<Scalars['ID']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  expenseId?: InputMaybe<Scalars['ID']>;
  projectItemId?: InputMaybe<Scalars['ID']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  historicExpenseAmountInvoiced?: InputMaybe<Scalars['Int']>;
  commitmentLineItemId?: InputMaybe<Scalars['ID']>;
};

export type SaveExpenseAllocationsInput = {
  expenseAllocations: Array<SaveExpenseAllocationInput>;
};

export type SaveExpenseAllocationsResult = {
  __typename?: 'SaveExpenseAllocationsResult';
  expenseAllocations: Array<ExpenseAllocation>;
};

export type ExpenseAllocationAllocation = {
  __typename?: 'ExpenseAllocationAllocation';
  id: Scalars['ID'];
  costInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  expenseAllocation: ExpenseAllocation;
  projectItemAllocation: ProjectItemAllocation;
};

export type FeatureFlag = Entity & {
  __typename?: 'FeatureFlag';
  id: Scalars['ID'];
  type: FeatureFlagTypeDetail;
  status: FeatureFlagStatusDetail;
  targets: Array<FeatureFlagTarget>;
  name: Scalars['String'];
  description: Scalars['String'];
  isPresentational: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  releaseVersion: Scalars['Int'];
};

export type SaveFeatureFlagInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FeatureFlagType>;
  isPresentational?: InputMaybe<Scalars['Boolean']>;
  targetIds?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<FeatureFlagStatus>;
  releaseVersion?: InputMaybe<Scalars['Int']>;
};

export type SaveFeatureFlagResult = {
  __typename?: 'SaveFeatureFlagResult';
  featureFlag: FeatureFlag;
};

export type FeatureFlagFilter = {
  type?: InputMaybe<Array<FeatureFlagType>>;
  status?: InputMaybe<Array<FeatureFlagStatus>>;
  isPresentational?: InputMaybe<Scalars['Boolean']>;
};

export type FeatureFlagTarget = {
  __typename?: 'FeatureFlagTarget';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  featureFlag: FeatureFlag;
  target?: Maybe<FeatureFlagTargetTarget>;
};

export type SaveFeatureFlagTargetInput = {
  id?: InputMaybe<Scalars['ID']>;
  featureFlagId?: InputMaybe<Scalars['ID']>;
  targetId?: InputMaybe<Scalars['ID']>;
};

export type SaveFeatureFlagTargetResult = {
  __typename?: 'SaveFeatureFlagTargetResult';
  featureFlagTarget: FeatureFlagTarget;
};

export type FeatureFlagTargetTarget = Development | StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | User | UserGroup;

export type FeatureType = {
  __typename?: 'FeatureType';
  id: Scalars['ID'];
  name: Scalars['String'];
  allowedInBuilding: Scalars['Boolean'];
  allowedInLevel: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  parent?: Maybe<FeatureType>;
  children: Array<FeatureType>;
  roomTypes: Array<RoomType>;
};

export type FeatureTypesFilter = {
  roomTypes?: InputMaybe<Array<Scalars['ID']>>;
  allowedInBuilding?: InputMaybe<Scalars['Boolean']>;
  allowedInLevel?: InputMaybe<Scalars['Boolean']>;
};

export type SaveFeatureTypeInput = {
  id?: InputMaybe<Scalars['ID']>;
  parentId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  allowedInBuilding?: InputMaybe<Scalars['Boolean']>;
  allowedInLevel?: InputMaybe<Scalars['Boolean']>;
  roomTypeIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveFeatureTypeResult = {
  __typename?: 'SaveFeatureTypeResult';
  featureType: FeatureType;
};

export type DeleteFeatureTypeInput = {
  id: Scalars['ID'];
};

export type DateFilter = {
  eq?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<Scalars['Date']>>;
  lte?: InputMaybe<Scalars['Date']>;
  lt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  gt?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
};

export enum DateOperation {
  Before = 'BEFORE',
  On = 'ON',
  After = 'AFTER',
  Between = 'BETWEEN',
  OnOrBefore = 'ON_OR_BEFORE',
  OnOrAfter = 'ON_OR_AFTER'
}

/**
 * An easier-to-data-bind DateFilter that value-izes the operation.
 *
 * Previously the DateFilter pattern of `someDay: { eq: jan1UTC } }` was fairly annoying
 * to data-bind UIs against b/c the value of the "on/before/after" drop-down would
 * mean dynamically changing which key to set in the filter, vs. just changing the
 * value of some basically-statically-identified key.
 *
 * This avoids that by making `op` an explicit key.
 */
export type DateFilter2 = {
  op: DateOperation;
  value: Scalars['Date'];
  value2?: InputMaybe<Scalars['Date']>;
};

export type IntFilter = {
  eq?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lte?: InputMaybe<Scalars['Int']>;
  lt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
};

export type IntervalFilter = {
  startDate?: InputMaybe<DateFilter>;
  endDate?: InputMaybe<DateFilter>;
  durationInDays?: InputMaybe<IntFilter>;
};

export type IntervalFilter2 = {
  startDate?: InputMaybe<DateFilter2>;
  endDate?: InputMaybe<DateFilter2>;
  durationInDays?: InputMaybe<IntFilter>;
};

/**
 * A per-cost-code finish schedule column config. Backed by STI (core vs attribute) on the entity, but
 * exposed as one flat type: `type` says which kind of column it is, and the subtype-specific fields
 * below are null on the other kind.
 */
export type FinishScheduleConfig = {
  __typename?: 'FinishScheduleConfig';
  id: Scalars['ID'];
  sortOrder: Scalars['Int'];
  shown: Scalars['Boolean'];
  useInVisualMode: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: FinishScheduleColumnTypeDetail;
  costCode: CostCode;
  /** CORE rows: which fixed column this is (null on attribute rows). */
  coreColumn?: Maybe<FinishScheduleCoreColumnDetail>;
  /** ATTRIBUTE rows: the material-attribute name to look up (null on core rows). */
  sourceAttribute?: Maybe<Scalars['String']>;
  /** Renames the column header, on core and attribute rows alike. */
  label?: Maybe<Scalars['String']>;
  designPackageLocation: DesignPackageLocationDetail;
};

/**
 * Updates to an existing finish schedule column config. Rows are created and kept in sync via hooks,
 * so the admin only ever edits them — never creates or deletes — hence `id` is required and there is
 * no `op`. Which kind of column it is (`type`, `coreColumn`) is fixed and not editable here
 */
export type SaveFinishScheduleConfigInput = {
  id: Scalars['ID'];
  /** Whether the column is shown in the export. */
  shown?: InputMaybe<Scalars['Boolean']>;
  useInVisualMode?: InputMaybe<Scalars['Boolean']>;
  /** Column order within the cost-code section. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** ATTRIBUTE rows: the material-attribute name to look up. */
  sourceAttribute?: InputMaybe<Scalars['String']>;
  /** Renames the column header, on core and attribute rows alike. */
  label?: InputMaybe<Scalars['String']>;
};

export type FollowSequenceSheetInput = {
  /**  Developments to be followed or unfollowed  */
  developmentIds: Array<Scalars['ID']>;
  /**  Users to be added/removed as followers */
  internalUserIds: Array<Scalars['ID']>;
  /**  Whether the users should be added or removed as followers  */
  follow: Scalars['Boolean'];
};

export type FollowSequenceSheetResult = {
  __typename?: 'FollowSequenceSheetResult';
  developments: Array<Development>;
  internalUsers: Array<InternalUser>;
};

export type Followable = {
  id: Scalars['ID'];
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean'];
};

export type SaveFollowersInput = {
  followableId: Scalars['ID'];
  followerIds: Array<Scalars['ID']>;
  /**  Whether this follow was a side-effect of being tagged. */
  fromTag?: InputMaybe<Scalars['Boolean']>;
};

export type SaveFollowersResult = {
  __typename?: 'SaveFollowersResult';
  /** @deprecated Placeholder to avoid a breaking change. */
  emptyResult?: Maybe<Scalars['String']>;
  /**
   * Returns the root commentable to allow refetching the latest followers.
   * @deprecated Use followable instead
   */
  commentable: Commentable;
  /** Returns the root followable to allow refetching the latest followers. */
  followable: Followable;
};

export type SaveGlobalOptionsInput = {
  globalOptions: Array<SaveGlobalOptionInput>;
};

export type SaveGlobalOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  isPlanSpecific?: InputMaybe<Scalars['Boolean']>;
  standardDetailRequired?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<GlobalOptionStatus>;
  typeId?: InputMaybe<Scalars['ID']>;
  locations?: InputMaybe<Array<Scalars['ID']>>;
  elevationRequired?: InputMaybe<Scalars['Boolean']>;
  requiredInPlanDrawing?: InputMaybe<Scalars['Boolean']>;
  shopDrawingRequired?: InputMaybe<Scalars['Boolean']>;
  /**
   * When specified, must include all tags you wish to have associated with the GlobalOptionType.
   * NOTE: May only be set to a sub-set of tags from the associated `GlobalOptionType.tags` list.
   */
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  code?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['ID']>;
  designUpgradeIconName?: InputMaybe<Scalars['String']>;
  defaultOrder?: InputMaybe<Scalars['Int']>;
  asset?: InputMaybe<AssetInput>;
  estimatedLeadTimeInDays?: InputMaybe<Scalars['Int']>;
  marketingDescription?: InputMaybe<Scalars['String']>;
  permits?: InputMaybe<Array<Permit>>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
  optionPricingConfig?: InputMaybe<SaveOptionPricingConfigInput>;
};

export type SaveGlobalOptionsResult = {
  __typename?: 'SaveGlobalOptionsResult';
  globalOptions: Array<GlobalOption>;
};

export type GlobalOptionsFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  isPlanSpecific?: InputMaybe<Scalars['Boolean']>;
  standardDetailRequired?: InputMaybe<Scalars['Boolean']>;
  elevationRequired?: InputMaybe<Scalars['Boolean']>;
  requiredInPlanDrawing?: InputMaybe<Scalars['Boolean']>;
  shopDrawingRequired?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Array<GlobalOptionStatus>>;
  type?: InputMaybe<Array<Scalars['ID']>>;
  locations?: InputMaybe<Array<Scalars['ID']>>;
  groups?: InputMaybe<Array<Scalars['ID']>>;
  activeDate?: InputMaybe<DateFilter>;
  archivedDate?: InputMaybe<DateFilter>;
  isElevation?: InputMaybe<Scalars['Boolean']>;
  isAddOnV2?: InputMaybe<Scalars['Boolean']>;
  isStructuralV2?: InputMaybe<Scalars['Boolean']>;
  /**  Indicates whether the option is managed by the catalog.  */
  isCatalogV2?: InputMaybe<Scalars['Boolean']>;
  /**  Indicates the version of the catalog that the option belongs to.  */
  version?: InputMaybe<Array<Scalars['Int']>>;
  isExteriorPalette?: InputMaybe<Scalars['Boolean']>;
  /**
   * Setting `isExteriorType` will trump `isElevation` and `isExteriorPalette` filters.
   * Setting `isExteriorType: true` filter will return GlobalOptionTypes where `isElevation` OR `isExteriorPalette` are true.
   * Setting `isExteriorType: false` will return GlobalOptionTypes where `isElevation` AND `isExteriorPalette` are false
   */
  isExteriorType?: InputMaybe<Scalars['Boolean']>;
  isPlanPackageType?: InputMaybe<Scalars['Boolean']>;
  hasDesignUpgradeIcon?: InputMaybe<Scalars['Boolean']>;
  developments?: InputMaybe<Array<Scalars['ID']>>;
  tags?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * GlobalOptionGroup.readyPlan is an optional relation that is used to scope GOGs to specific Ready Plans.
   * Allows null IDs to support filtering regular/non-scoped GOs and scoped GOs at the same time (e.g., [null, "rp:1"]).
   */
  readyPlan?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type MigrateGlobalOptionInput = {
  sourceId: Scalars['ID'];
  targetGroupId: Scalars['ID'];
  clearLocations?: InputMaybe<Scalars['Boolean']>;
};

export type MigrateGlobalOptionsInput = {
  sourceGroupId: Scalars['ID'];
  targetGroupId: Scalars['ID'];
  clearLocations?: InputMaybe<Scalars['Boolean']>;
};

export type GlobalOptionGroup = {
  __typename?: 'GlobalOptionGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  globalOptions: Array<GlobalOption>;
  type: GlobalOptionType;
  isSingleOptionGroup: Scalars['Boolean'];
  isMultiOptionGroup: Scalars['Boolean'];
  salesforceFieldName?: Maybe<Scalars['String']>;
  /** @deprecated use `forDesignInterior` instead */
  forDesignPackage: Scalars['Boolean'];
  forDesignInterior: Scalars['Boolean'];
  /** @deprecated No longer used */
  forDesignUpgrade: Scalars['Boolean'];
  /** @deprecated use `forDesignExterior` instead */
  forExteriors: Scalars['Boolean'];
  forDesignExterior: Scalars['Boolean'];
  /**  helper for `forDesignInterior || forDesignExterior` so you don't have to do it by hand everywhere  */
  forDesignPackages: Scalars['Boolean'];
  /**  Default value for ReadyPlanOptionGroup.required to be applied on creation  */
  defaultRequired: Scalars['Boolean'];
  designPackageTagColor?: Maybe<Scalars['String']>;
  version: Scalars['Int'];
  canEditType: PotentialOperation2;
  readyPlan?: Maybe<ReadyPlanLike>;
};

export type SaveGlobalOptionGroupInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  typeId?: InputMaybe<Scalars['ID']>;
  salesforceFieldName?: InputMaybe<Scalars['String']>;
  isSingleOptionGroup?: InputMaybe<Scalars['Boolean']>;
  defaultRequired?: InputMaybe<Scalars['Boolean']>;
  designPackageTagColor?: InputMaybe<Scalars['String']>;
};

export type SaveGlobalOptionGroupResult = {
  __typename?: 'SaveGlobalOptionGroupResult';
  entity: GlobalOptionGroup;
};

export type GlobalOptionGroupFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  isSingleOptionGroup?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<GlobalOptionTypesFilter>;
  /** @deprecated use `forDesignInterior` instead */
  forDesignPackage?: InputMaybe<Scalars['Boolean']>;
  forDesignInterior?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated No longer used */
  forDesignUpgrade?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated use `forDesignExterior` instead */
  forExteriors?: InputMaybe<Scalars['Boolean']>;
  forDesignExterior?: InputMaybe<Scalars['Boolean']>;
  /**  Indicates the version of the catalog that the option group belongs to.  */
  version?: InputMaybe<Array<Scalars['Int']>>;
  /**
   * GlobalOptionGroup.readyPlan is an optional relation that is used to scope GOGs to specific Ready Plans.
   * Setting readyPlan to null will filter regular/non-scoped GOGs.
   */
  readyPlan?: InputMaybe<Array<Scalars['ID']>>;
};

export type GlobalOptionTag = Named & {
  __typename?: 'GlobalOptionTag';
  id: Scalars['ID'];
  name: Scalars['String'];
  globalOptions: Array<GlobalOption>;
  globalOptionTypes: Array<GlobalOptionType>;
};

export type GlobalOptionTagsFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveGlobalOptionTagInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  globalOptionTypeIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveGlobalOptionTagsInput = {
  globalOptionTags: Array<SaveGlobalOptionTagInput>;
};

export type SaveGlobalOptionTagsResult = {
  __typename?: 'SaveGlobalOptionTagsResult';
  globalOptionTags: Array<GlobalOptionTag>;
};

export type GlobalOptionType = Named & {
  __typename?: 'GlobalOptionType';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  changesProgramData?: Maybe<Scalars['Boolean']>;
  changesSpecsAndSelections?: Maybe<Scalars['Boolean']>;
  status: GlobalOptionTypeStatus;
  statusDetail: GlobalOptionTypeStatusDetail;
  /**  Identifies the singular `GlobalOptionGroup` of Elevation: Farmhouse, Coastal, etc.  */
  isElevation: Scalars['Boolean'];
  /**  Identifies the singular `GlobalOptionGroup` of Exterior Palette: Gray, etc.  */
  isExteriorPalette: Scalars['Boolean'];
  /**  Identifies the singular `GlobalOptionGroup` of Spec Level: Essential, Deluxe, etc.  */
  isSpecLevel: Scalars['Boolean'];
  /**
   * Identifies the singular `GlobalOptionGroup` of Interior Scheme: Bold, Modern, Traditional, etc.
   *
   * Replaced the old Interior Style in H1 tech/version 2.
   */
  isInteriorScheme: Scalars['Boolean'];
  /**
   * Identifies the singular `GlobalOptionGroup` of Exterior Scheme: Gray Scheme, Red Scheme, etc.
   *
   * Replaced the old Exterior Palette in H1 tech/version 2.
   */
  isExteriorScheme: Scalars['Boolean'];
  /**  Identifies the singular `GlobalOptionGroup` of 'Plan Package' for Design Package plan-based tagging.  */
  isPlanPackage: Scalars['Boolean'];
  /**  Identifies `GlobalOptionGroup`s that are Interior Options, like Add Bedroom, or Garage.  */
  isInterior: Scalars['Boolean'];
  /**  Identifies `GlobalOptionGroup`s that change the floor plan, like Convert Attic to Bedroom.  */
  isFloorPlan: Scalars['Boolean'];
  tags: Array<GlobalOptionTag>;
  globalOptionsCount: Scalars['Int'];
  allowsLocations: Scalars['Boolean'];
  order: Scalars['Int'];
  /**  Identifies `GlobalOptionGroup`s that can form Interior Design Package IDPs, i.e. Spec Level & Interior Scheme.  */
  forDesignInterior: Scalars['Boolean'];
  /**  Identifies `GlobalOptionGroup`s that can form Exterior Design Package IDPs, i.e. Elevation & Exterior Scheme.  */
  forDesignExterior: Scalars['Boolean'];
  /**
   *  Identities `GlobalOptionGroup`s that are applicable to design upgrades, i.e. 'Add Bedroom Sink'.
   * @deprecated No longer used
   */
  forDesignUpgrade: Scalars['Boolean'];
  /** @deprecated use `forDesignInterior` instead */
  forDesignPackage: Scalars['Boolean'];
  /** @deprecated use `forDesignExterior` instead */
  forExteriors: Scalars['Boolean'];
  /**  Identifies `GlobalOptionGroup`s used for plan-based bids, i.e. Spec Level, Elevation, Interior Scheme, Exterior Scheme.  */
  forPlanBasedBids: Scalars['Boolean'];
  /** @deprecated Use GlobalOptionGroups instead */
  globalOptions: Array<GlobalOption>;
  isAddOnV2?: Maybe<Scalars['Boolean']>;
  isStructuralV2?: Maybe<Scalars['Boolean']>;
  isCatalogV2?: Maybe<Scalars['Boolean']>;
  isProductOptionV2: Scalars['Boolean'];
  isPackageOptionV2: Scalars['Boolean'];
  version: Scalars['Int'];
};

export type SaveGlobalOptionTypesInput = {
  globalOptionTypes: Array<SaveGlobalOptionTypeInput>;
  /**
   * Used to indicate consent that additional side effects may occur.
   * In this case, confirmation is required to remove a GlobalOptionTag from a GlobalOptionType, if it is currently in use by one or more GlobalOptions.
   */
  confirm?: InputMaybe<Scalars['Boolean']>;
};

export type SaveGlobalOptionTypeInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  changesProgramData?: InputMaybe<Scalars['Boolean']>;
  changesSpecsAndSelections?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<GlobalOptionTypeStatus>;
  isElevation?: InputMaybe<Scalars['Boolean']>;
  isExteriorPalette?: InputMaybe<Scalars['Boolean']>;
  isInterior?: InputMaybe<Scalars['Boolean']>;
  /**
   * When specified, must include all tags you wish to have associated with the GlobalOptionType
   * NOTE: Accepts IDs or tag names. When a String is specified for a `GlobalOptionTag` which does not yet exist, it will be created.
   * NOTE: If a tag is removed which is currently referenced by an associated GlobalOption, this operation will fail unless `SaveGlobalOptionTypesInput.confirm: true` is specified.
   */
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  allowsLocations?: InputMaybe<Scalars['Boolean']>;
  isFloorPlan?: InputMaybe<Scalars['Boolean']>;
  isSpecLevel?: InputMaybe<Scalars['Boolean']>;
  isInteriorScheme?: InputMaybe<Scalars['Boolean']>;
  isExteriorScheme?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  /** @deprecated use `forDesignInterior` instead */
  forDesignPackage?: InputMaybe<Scalars['Boolean']>;
  forDesignInterior?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated No longer used */
  forDesignUpgrade?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated use `forDesignExterior` instead */
  forExteriors?: InputMaybe<Scalars['Boolean']>;
  forDesignExterior?: InputMaybe<Scalars['Boolean']>;
  isAddOnV2?: InputMaybe<Scalars['Boolean']>;
  isStructuralV2?: InputMaybe<Scalars['Boolean']>;
  isCatalogV2?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
  forPlanBasedBids?: InputMaybe<Scalars['Boolean']>;
};

export type SaveGlobalOptionTypesResult = {
  __typename?: 'SaveGlobalOptionTypesResult';
  globalOptionTypes: Array<GlobalOptionType>;
};

export type GlobalOptionTypesFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  changesProgramData?: InputMaybe<Scalars['Boolean']>;
  changesSpecsAndSelections?: InputMaybe<Scalars['Boolean']>;
  isElevation?: InputMaybe<Scalars['Boolean']>;
  isExteriorPalette?: InputMaybe<Scalars['Boolean']>;
  isInterior?: InputMaybe<Scalars['Boolean']>;
  isSpecLevel?: InputMaybe<Scalars['Boolean']>;
  isAddOnV2?: InputMaybe<Scalars['Boolean']>;
  isStructuralV2?: InputMaybe<Scalars['Boolean']>;
  /**  Indicates whether the option is managed by the catalog.  */
  isCatalogV2?: InputMaybe<Scalars['Boolean']>;
  /**  Indicates the version of the catalog that the option type belongs to.  */
  version?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<Array<GlobalOptionTypeStatus>>;
  isPlanPackage?: InputMaybe<Scalars['Boolean']>;
  isProductOptionV2?: InputMaybe<Scalars['Boolean']>;
  isPackageOptionV2?: InputMaybe<Scalars['Boolean']>;
  isInteriorScheme?: InputMaybe<Scalars['Boolean']>;
  isExteriorScheme?: InputMaybe<Scalars['Boolean']>;
};

export type GlobalPhaseFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  /**  Limit to only active GlobalPhases  */
  active?: InputMaybe<Scalars['Boolean']>;
  /**  Obtain a list of GlobalPhases used on the specified parent(s)  */
  parent?: InputMaybe<Array<Scalars['ID']>>;
  /**  Obtain a list of GlobalPhases used on the specified schedule(s)  */
  schedule?: InputMaybe<Array<Scalars['ID']>>;
  /**  Limit by GlobalPhase stage  */
  stage?: InputMaybe<Array<Stage>>;
};

export type GlobalPhase = {
  __typename?: 'GlobalPhase';
  id: Scalars['ID'];
  active: Scalars['Boolean'];
  cmsId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  stage: Stage;
  stageDetail: StageDetail;
  displayOrder?: Maybe<Scalars['Int']>;
  globalSubPhases: Array<GlobalSubPhase>;
  globalTasks: Array<GlobalTask>;
};

export type SaveGlobalPhasesInput = {
  globalPhases: Array<SaveGlobalPhaseInput>;
};

export type SaveGlobalPhaseInput = {
  id?: InputMaybe<Scalars['ID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  cmsId?: InputMaybe<Scalars['String']>;
  /**  CAUTION - This will change the name of the GlobalPhase on all Schedules where it is used  */
  name?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<Stage>;
  displayOrder?: InputMaybe<Scalars['Int']>;
};

export type SaveGlobalPhasesResult = {
  __typename?: 'SaveGlobalPhasesResult';
  globalPhases: Array<GlobalPhase>;
};

export type GlobalPlanAllowance = HasGlobalConstraintItem & {
  __typename?: 'GlobalPlanAllowance';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  constraintItem: GlobalPlanConstraintItem;
  task: GlobalPlanTask;
};

export type GlobalPlanConstraint = HasGlobalConstraintItem & {
  __typename?: 'GlobalPlanConstraint';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  task: GlobalPlanTask;
  constraintItem: GlobalPlanConstraintItem;
};

export type GlobalPlanConstraintItem = Named & {
  __typename?: 'GlobalPlanConstraintItem';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  allowances: Array<GlobalPlanAllowance>;
  constraints: Array<GlobalPlanConstraint>;
  numberOfTimesUsed: Scalars['Int'];
  constrainedPlanTasks: Array<PlanTask>;
  allowingPlanTasks: Array<PlanTask>;
  lagInDays: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  canDelete: PotentialOperation2;
};


export type GlobalPlanConstraintItemConstrainedPlanTasksArgs = {
  scheduleOrTask: Scalars['ID'];
};


export type GlobalPlanConstraintItemAllowingPlanTasksArgs = {
  scheduleOrTask: Scalars['ID'];
};

export type SaveGlobalPlanConstraintItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  lagInDays?: InputMaybe<Scalars['Int']>;
};

export type SaveGlobalPlanConstraintItemResult = {
  __typename?: 'SaveGlobalPlanConstraintItemResult';
  globalPlanConstraintItem: GlobalPlanConstraintItem;
};

export type SaveGlobalPlanConstraintItemsResult = {
  __typename?: 'SaveGlobalPlanConstraintItemsResult';
  globalPlanConstraintItems: Array<GlobalPlanConstraintItem>;
};

export type HasGlobalConstraintItem = {
  id: Scalars['ID'];
  constraintItem: GlobalPlanConstraintItem;
};

export type DeleteGlobalPlanConstraintItemInput = {
  id: Scalars['ID'];
};

export type GlobalPlanMilestone = Named & {
  __typename?: 'GlobalPlanMilestone';
  id: Scalars['ID'];
  name: Scalars['String'];
  isDefault: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  planMilestones: Array<PlanMilestone>;
  groups: Array<GlobalPlanMilestoneGroup>;
  constraints: Array<GlobalPlanConstraintItem>;
  systemPlanMilestone?: Maybe<SystemPlanMilestoneDetail>;
  isHomeownerVisible: Scalars['Boolean'];
  isInvoiceMilestone: Scalars['Boolean'];
  homeownerName?: Maybe<Scalars['String']>;
  homeownerDescription?: Maybe<Scalars['String']>;
  homeownerIcon?: Maybe<Asset>;
  description?: Maybe<Scalars['String']>;
  type: GlobalPlanMilestoneTypeDetail;
};

export type SaveGlobalPlanMilestoneInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  groups?: InputMaybe<Array<SaveGlobalPlanMilestoneGroupInput>>;
  constraints?: InputMaybe<Array<SaveGlobalPlanMilestoneConstraintItemInput>>;
  systemPlanMilestone?: InputMaybe<SystemPlanMilestone>;
  isHomeownerVisible?: InputMaybe<Scalars['Boolean']>;
  isInvoiceMilestone?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  homeownerName?: InputMaybe<Scalars['String']>;
  homeownerDescription?: InputMaybe<Scalars['String']>;
  homeownerIcon?: InputMaybe<AssetInput>;
  type?: InputMaybe<GlobalPlanMilestoneType>;
};

export type SaveGlobalPlanMilestonesInput = {
  globalPlanMilestones: Array<SaveGlobalPlanMilestoneInput>;
};

export type SaveGlobalPlanMilestoneGroupInput = {
  id?: InputMaybe<Scalars['ID']>;
  op: IncrementalCollectionOp;
};

export type SaveGlobalPlanMilestoneConstraintItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  op: ConstraintItemIncrementalCollectionOp;
};

export type GlobalPlanMilestoneFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Array<Scalars['ID']>>;
  type?: InputMaybe<Array<GlobalPlanMilestoneType>>;
  /**  Defaults to false - only non-archived milestones are returned unless explicitly set to true  */
  archived?: InputMaybe<Scalars['Boolean']>;
  isFromInvoiceAutomation?: InputMaybe<Scalars['Boolean']>;
};

export type GlobalPlanMilestoneOrder = {
  createdAt?: InputMaybe<Order>;
};

export type SaveGlobalPlanMilestoneResult = {
  __typename?: 'SaveGlobalPlanMilestoneResult';
  globalPlanMilestone: GlobalPlanMilestone;
};

export type GlobalPlanMilestonesPageResult = {
  __typename?: 'GlobalPlanMilestonesPageResult';
  entities: Array<GlobalPlanMilestone>;
  pageInfo: PageInfo;
};

export type SaveGlobalPlanMilestonesResult = {
  __typename?: 'SaveGlobalPlanMilestonesResult';
  globalPlanMilestones: Array<GlobalPlanMilestone>;
};

export enum ConstraintItemIncrementalCollectionOp {
  Include = 'include',
  Remove = 'remove'
}

export type GlobalPlanMilestoneGroup = {
  __typename?: 'GlobalPlanMilestoneGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  businessFunctionType: BusinessFunctionTypeDetail;
  globalPlanMilestones: Array<GlobalPlanMilestone>;
};

export type SaveGlobalMilestoneGroupInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  businessFunctionType?: InputMaybe<BusinessFunctionType>;
};

export type SaveGlobalPlanMilestoneGroupResult = {
  __typename?: 'SaveGlobalPlanMilestoneGroupResult';
  globalPlanMilestoneGroup: GlobalPlanMilestoneGroup;
};

export type GlobalPlanStage = {
  __typename?: 'GlobalPlanStage';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  globalPlanTasks: Array<GlobalPlanTask>;
  globalPlanTaskVariants: Array<GlobalPlanTaskVariant>;
  variants: Array<GlobalPlanStageVariant>;
  orderForProject?: Maybe<Scalars['Int']>;
};


export type GlobalPlanStageOrderForProjectArgs = {
  projectId: Scalars['ID'];
};

export type SaveGlobalPlanStageInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  globalPlanTasks?: InputMaybe<Array<SaveGlobalPlanStageTaskInput>>;
};

export type SaveGlobalPlanStageTaskInput = {
  id?: InputMaybe<Scalars['ID']>;
  op: IncrementalCollectionOp;
};

export type SaveGlobalPlanStageResult = {
  __typename?: 'SaveGlobalPlanStageResult';
  globalPlanStage: GlobalPlanStage;
};

export type GlobalPlanStageVariant = {
  __typename?: 'GlobalPlanStageVariant';
  id: Scalars['ID'];
  order?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  globalPlanStage: GlobalPlanStage;
  project: Project;
};

export type SaveGlobalPlanStageVariantInput = {
  id?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['Int']>;
  globalPlanStageId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
};

export type SaveGlobalPlanStageVariantsInput = {
  globalPlanStageVariants: Array<SaveGlobalPlanStageVariantInput>;
};

export type SaveGlobalPlanStageVariantsResult = {
  __typename?: 'SaveGlobalPlanStageVariantsResult';
  globalPlanStageVariants: Array<GlobalPlanStageVariant>;
};

export type GlobalPlanTag = {
  __typename?: 'GlobalPlanTag';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  tasks: Array<GlobalPlanTask>;
  /** When true, tasks with this tag are excluded from schedule views and draft schedule results. */
  isHiddenFromSchedule: Scalars['Boolean'];
};

export type SaveGlobalPlanTagInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  tasks?: InputMaybe<Array<SaveGlobalPlanTagTaskInput>>;
  isHiddenFromSchedule?: InputMaybe<Scalars['Boolean']>;
};

export type SaveGlobalPlanTagTaskInput = {
  id?: InputMaybe<Scalars['ID']>;
  op: IncrementalCollectionOp;
};

export type SaveGlobalPlanTagResult = {
  __typename?: 'SaveGlobalPlanTagResult';
  globalPlanTag: GlobalPlanTag;
};

export type BulkSaveGlobalPlanTagsResult = {
  __typename?: 'BulkSaveGlobalPlanTagsResult';
  globalPlanTags: Array<GlobalPlanTag>;
};

export type GlobalPlanTask = Named & {
  __typename?: 'GlobalPlanTask';
  id: Scalars['ID'];
  name: Scalars['String'];
  /**
   * Returns the name within the context of the given entityId. entityId must either be a project id or an id for an
   * entity with a project or market relation.  This behavior is grandfathered in to support passing a development, it is
   * not recommended to replicate this behavior elsewhere.
   */
  nameForEntity: Scalars['String'];
  externalName?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  archived: Scalars['Boolean'];
  optimisticDurationInDays: Scalars['Int'];
  expectedDurationInDays: Scalars['Int'];
  pessimisticDurationInDays: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  businessFunctionType: BusinessFunctionTypeDetail;
  projectRole?: Maybe<ProjectRoleDetail>;
  tradeCategory?: Maybe<TradeCategory>;
  allowances: Array<GlobalPlanAllowance>;
  constraints: Array<GlobalPlanConstraint>;
  tags: Array<GlobalPlanTag>;
  scopes: Array<GlobalPlanTaskScope>;
  applyToAllSchedules: Scalars['Boolean'];
  budgetItem: Item;
  itemPlanTaskMappings: Array<ItemPlanTaskMapping>;
  planTasks: Array<PlanTask>;
  numberOfTimesUsed: Scalars['Int'];
  checklistItems: Array<GlobalPlanTaskChecklistItem>;
  globalRequiredTaskDocuments: Array<GlobalRequiredTaskDocument>;
  canEditBudgetItem: PotentialOperation2;
  bidContractRevisionDraws: Array<BidContractRevisionDraw>;
  stage?: Maybe<GlobalPlanStage>;
  variants: Array<GlobalPlanTaskVariant>;
  drops: Array<Drop>;
  parent?: Maybe<GlobalPlanTask>;
  children: Array<GlobalPlanTask>;
  systemTask?: Maybe<SystemTaskDetail>;
  /** How a GPT can be verified as complete. */
  verificationMethod?: Maybe<VerificationMethodDetail>;
  /**
   * Derived: true when `verificationMethod` is one of the AI-verifiable methods;
   * false when null or when `verificationMethod` requires human inspection.
   */
  aiVerifiable: Scalars['Boolean'];
};


export type GlobalPlanTaskNameForEntityArgs = {
  entityId?: InputMaybe<Scalars['ID']>;
};

export type SaveGlobalPlanTaskInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  externalName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  optimisticDurationInDays?: InputMaybe<Scalars['Int']>;
  expectedDurationInDays?: InputMaybe<Scalars['Int']>;
  pessimisticDurationInDays?: InputMaybe<Scalars['Int']>;
  businessFunctionType?: InputMaybe<BusinessFunctionType>;
  projectRole?: InputMaybe<ProjectRole>;
  tradeCategoryId?: InputMaybe<Scalars['ID']>;
  constraints?: InputMaybe<Array<SaveConstraintItemInput>>;
  allowances?: InputMaybe<Array<SaveConstraintItemInput>>;
  tags?: InputMaybe<Array<SaveGlobalPlanTaskTagInput>>;
  scopes?: InputMaybe<Array<SaveGlobalPlanTaskScopeInput>>;
  checklistItems?: InputMaybe<Array<SaveGlobalPlanTaskChecklistInputInput>>;
  applyToAllSchedules?: InputMaybe<Scalars['Boolean']>;
  budgetItemId?: InputMaybe<Scalars['ID']>;
  globalRequiredTaskDocuments?: InputMaybe<Array<SaveGlobalPlanTaskRequiredDocumentInput>>;
  itemPlanTaskMappings?: InputMaybe<Array<IncrementalSaveItemPlanTaskMappingInput>>;
  stageId?: InputMaybe<Scalars['ID']>;
  variants?: InputMaybe<Array<SaveGlobalPlanTaskVariantIncrementalInput>>;
  parentId?: InputMaybe<Scalars['ID']>;
  systemTask?: InputMaybe<SystemTask>;
  verificationMethod?: InputMaybe<VerificationMethod>;
};

export type SaveConstraintItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  op: IncrementalCollectionOp;
  constraintItemId?: InputMaybe<Scalars['ID']>;
};

export type SaveGlobalPlanTaskTagInput = {
  id?: InputMaybe<Scalars['ID']>;
  op: IncrementalCollectionOp;
};

export type GlobalPlanTaskFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  team?: InputMaybe<Array<BusinessFunctionType>>;
  tags?: InputMaybe<Array<Scalars['ID']>>;
  project?: InputMaybe<Array<Scalars['ID']>>;
  applyToAllSchedules?: InputMaybe<Scalars['Boolean']>;
  costCode?: InputMaybe<Array<Scalars['ID']>>;
  isChildTask?: InputMaybe<Scalars['Boolean']>;
  verificationMethod?: InputMaybe<Array<VerificationMethod>>;
  /**
   * Convenience filter — translated to the current set of AI-verifiable methods in the resolver.
   * `true` matches tasks whose method is one of those; `false` matches everything else (including null).
   */
  aiVerifiable?: InputMaybe<Scalars['Boolean']>;
};

export type SaveGlobalPlanTaskScopeInput = {
  /** The ID of the GlobalPlanTaskScope record (only used for deletes) */
  id?: InputMaybe<Scalars['ID']>;
  /** The (tagged) ID of the Region/Market/Community/Subdivision that this scope applies to. */
  targetId?: InputMaybe<Scalars['ID']>;
  op: IncrementalCollectionOp;
};

export type SaveGlobalPlanTaskChecklistInputInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  delete?: InputMaybe<Scalars['Boolean']>;
};

export type SaveGlobalPlanTaskRequiredDocumentInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<DocumentType>;
  watchers?: InputMaybe<Array<ProjectRole>>;
  /**  Remove is not a valid option for this field  */
  op: IncrementalCollectionOp;
};

export type IncrementalSaveItemPlanTaskMappingInput = {
  op: IncrementalCollectionOp;
  id?: InputMaybe<Scalars['ID']>;
  itemId?: InputMaybe<Scalars['ID']>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']>;
  estimatedLaborCostInCents?: InputMaybe<Scalars['Int']>;
};

export type SaveVariantConstraintItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  op: IncrementalCollectionOp;
};

export type SaveGlobalPlanTaskVariantIncrementalInput = {
  op: IncrementalCollectionOp;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  optimisticDurationInDays?: InputMaybe<Scalars['Int']>;
  expectedDurationInDays?: InputMaybe<Scalars['Int']>;
  pessimisticDurationInDays?: InputMaybe<Scalars['Int']>;
  constraints?: InputMaybe<Array<SaveVariantConstraintItemInput>>;
  allowances?: InputMaybe<Array<SaveVariantConstraintItemInput>>;
  stageId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
};

export type SaveGlobalPlanTaskResult = {
  __typename?: 'SaveGlobalPlanTaskResult';
  globalPlanTask: GlobalPlanTask;
};

export type SaveGlobalPlanTasksResult = {
  __typename?: 'SaveGlobalPlanTasksResult';
  globalPlanTasks: Array<GlobalPlanTask>;
};

export type GlobalPlanTasksPageResult = {
  __typename?: 'GlobalPlanTasksPageResult';
  entities: Array<GlobalPlanTask>;
  pageInfo: PageInfo;
};

export type GlobalPlanTaskChecklistItem = {
  __typename?: 'GlobalPlanTaskChecklistItem';
  id: Scalars['ID'];
  name: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  globalPlanTask: GlobalPlanTask;
};

export type GlobalPlanTaskScope = {
  __typename?: 'GlobalPlanTaskScope';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  globalPlanTask: GlobalPlanTask;
  target: Project;
};

export type GlobalPlanTaskScopeTarget = Community | Market | Region | Subdivision;

export type GlobalPlanTaskVariant = {
  __typename?: 'GlobalPlanTaskVariant';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  optimisticDurationInDays?: Maybe<Scalars['Int']>;
  expectedDurationInDays?: Maybe<Scalars['Int']>;
  pessimisticDurationInDays?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  globalPlanTask: GlobalPlanTask;
  allowances: Array<GlobalPlanConstraintItem>;
  constraints: Array<GlobalPlanConstraintItem>;
  stage?: Maybe<GlobalPlanStage>;
  project: Project;
};

export type GlobalRequiredTaskDocument = {
  __typename?: 'GlobalRequiredTaskDocument';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  documentType: DocumentTypeDetail;
  watchers: Array<ProjectRole>;
  canEditDocumentType: PotentialOperation2;
};

export type SaveGlobalRequiredTaskDocumentInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<DocumentType>;
  watchers?: InputMaybe<Array<ProjectRole>>;
  globalPlanTaskId?: InputMaybe<Scalars['ID']>;
};

export type SaveGlobalRequiredTaskDocumentResult = {
  __typename?: 'SaveGlobalRequiredTaskDocumentResult';
  globalRequiredTaskDocument: GlobalRequiredTaskDocument;
};

/** Wrap the low-level record to hold eventual metadata like matched substring. */
export type GlobalSearchResult = {
  __typename?: 'GlobalSearchResult';
  record: GlobalSearchRecord;
};

export type GlobalSearchRecord = {
  __typename?: 'GlobalSearchRecord';
  id: Scalars['ID'];
  search?: Maybe<Scalars['String']>;
  parent: GlobalSearchRecordParent;
};

export type GlobalSearchRecordParent = Bill | Commitment | CommitmentChangeOrder | Community | DesignPackage | Lot | Market | PlanPackage | ProductOffering | Region | StandaloneProject | Structure | Subdivision | TradePartner;

export type GlobalSubPhasesFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * TODO: Implement in sc-7912
   *
   * Obtain a list of GlobalSubPhases used on the specified parent(s)
   */
  parent?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * TODO: Implement in sc-7912
   *
   * NOT IMPLEMENTED - Obtain a list of GlobalSubPhases used on the specified schedules(s)
   */
  schedule?: InputMaybe<Array<Scalars['ID']>>;
};

export type GlobalSubPhase = {
  __typename?: 'GlobalSubPhase';
  id: Scalars['ID'];
  name: Scalars['String'];
  globalPhase: GlobalPhase;
  displayOrder?: Maybe<Scalars['Int']>;
  stage: Stage;
  stageDetail: StageDetail;
  cmsId?: Maybe<Scalars['String']>;
};

export type SaveGlobalSubPhasesInput = {
  globalSubPhases: Array<SaveGlobalSubPhaseInput>;
};

export type SaveGlobalSubPhaseInput = {
  id?: InputMaybe<Scalars['ID']>;
  globalPhase?: InputMaybe<Scalars['ID']>;
  /**  CAUTION - This will change the name of the GlobalSubPhase on all projects where it is used  */
  name?: InputMaybe<Scalars['String']>;
  cmsId?: InputMaybe<Scalars['String']>;
  globalPhaseId?: InputMaybe<Scalars['ID']>;
};

export type SaveGlobalSubPhasesResult = {
  __typename?: 'SaveGlobalSubPhasesResult';
  globalSubPhases: Array<GlobalSubPhase>;
};

export type ReplaceGlobalSubPhaseInput = {
  replace: Scalars['ID'];
  with: Scalars['ID'];
  /**  Will hard delete any activities which are left behind post-merge - by default they will be soft-deleted  */
  hardDeleteExisting?: InputMaybe<Scalars['Boolean']>;
};

export type ReplaceGlobalSubPhaseResult = {
  __typename?: 'ReplaceGlobalSubPhaseResult';
  replaced: GlobalSubPhase;
  with: GlobalSubPhase;
  impactedCount: Scalars['Int'];
  impacted: Array<ScheduleSubPhase>;
};

export type GlobalTask = Named & {
  __typename?: 'GlobalTask';
  id: Scalars['ID'];
  name: Scalars['String'];
  isMilestone: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  globalPhase: GlobalPhase;
  determinesStartDateForStage?: Maybe<Stage>;
  beginsStage?: Maybe<Stage>;
  systemTask?: Maybe<SystemTask>;
  sendEvent: Scalars['Boolean'];
  globalPlanMilestone?: Maybe<GlobalPlanMilestone>;
};

export type SaveGlobalTasksInput = {
  globalTasks: Array<SaveGlobalTaskInput>;
};

export type SaveGlobalTaskInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  isMilestone?: InputMaybe<Scalars['Boolean']>;
  globalPhaseId?: InputMaybe<Scalars['ID']>;
  determinesStartDateForStage?: InputMaybe<Stage>;
  beginsStage?: InputMaybe<Stage>;
  systemTask?: InputMaybe<SystemTask>;
  sendEvent?: InputMaybe<Scalars['Boolean']>;
  globalPlanMilestoneId?: InputMaybe<Scalars['ID']>;
};

export type SaveGlobalTasksResult = {
  __typename?: 'SaveGlobalTasksResult';
  globalTasks: Array<GlobalTask>;
};

export type GlobalTasksFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  isMilestone?: InputMaybe<Scalars['Boolean']>;
  globalPhase?: InputMaybe<Array<Scalars['ID']>>;
  systemTask?: InputMaybe<Array<SystemTask>>;
};

export type History = {
  __typename?: 'History';
  recordedAt: Scalars['DateTime'];
  avatar: Scalars['String'];
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type HomeboundHoliday = {
  __typename?: 'HomeboundHoliday';
  id: Scalars['ID'];
  date: Scalars['Date'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type SaveHomeboundHolidayInput = {
  id?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
};

export type SaveHomeboundHolidayResult = {
  __typename?: 'SaveHomeboundHolidayResult';
  homeboundHoliday: HomeboundHoliday;
};

export type Homeowner = {
  __typename?: 'Homeowner';
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  canViewCheckout: Scalars['Boolean'];
  checkoutConfigs: Array<CheckoutConfig>;
};


export type HomeownerCheckoutConfigsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
};

export type HomeownersFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  canViewCheckout?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<DateFilter2>;
};

export type HomeownersOrder = {
  id?: InputMaybe<Order>;
  firstName?: InputMaybe<Order>;
  lastName?: InputMaybe<Order>;
  createdAt?: InputMaybe<Order>;
};

export type HomeownersPage = {
  __typename?: 'HomeownersPage';
  entities: Array<Homeowner>;
  pageInfo: PageInfo;
};

export type SaveHomeownerInput = {
  id?: InputMaybe<Scalars['ID']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  canViewCheckout?: InputMaybe<Scalars['Boolean']>;
  /** Direct users magic link to checkout */
  redirectToCheckout?: InputMaybe<Scalars['Boolean']>;
};

export type SignUpHomeownerInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type SaveHomeownerResult = {
  __typename?: 'SaveHomeownerResult';
  homeowner: Homeowner;
};

/**  A per-project item summary of a homeowner contract + its change orders.  */
export type HomeownerContractLineItemsByProjectItem = {
  __typename?: 'HomeownerContractLineItemsByProjectItem';
  projectItem: ProjectItem;
  lineItems: Array<HomeownerContractLineItem>;
};

export type HomeownerContractLike = {
  id: Scalars['ID'];
  contractType: ContractType;
  costPlusMarkupBasisPoints?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  lineItems: Array<HomeownerContractLineItem>;
};

export type SaveHomeownerContractInput = {
  id?: InputMaybe<Scalars['ID']>;
  projectStageId?: InputMaybe<Scalars['ID']>;
  /**  When creating a new contract (in SpecsAndSelections), estimateId is required to copy/paste the line items from.  */
  estimateId?: InputMaybe<Scalars['ID']>;
  documentId?: InputMaybe<Scalars['ID']>;
  internalNote?: InputMaybe<Scalars['String']>;
  executionDate?: InputMaybe<Scalars['Date']>;
  contractType?: InputMaybe<ContractType>;
  costPlusMarkupBasisPoints?: InputMaybe<Scalars['Int']>;
  draws?: InputMaybe<Array<SaveHomeownerContractDrawInput>>;
  title?: InputMaybe<Scalars['String']>;
};

export type SaveHomeownerContractChangeOrderInput = {
  id?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  documentId?: InputMaybe<Scalars['ID']>;
  internalNote?: InputMaybe<Scalars['String']>;
  executionDate?: InputMaybe<Scalars['Date']>;
  contractType?: InputMaybe<ContractType>;
  costPlusMarkupBasisPoints?: InputMaybe<Scalars['Int']>;
  draws?: InputMaybe<Array<SaveHomeownerContractDrawInput>>;
  lineItems?: InputMaybe<Array<SaveHomeownerContractLineItemInput>>;
  title?: InputMaybe<Scalars['String']>;
  changeEventId?: InputMaybe<Scalars['ID']>;
  estimateId?: InputMaybe<Scalars['ID']>;
};

export type DeleteHomeownerContractChangeOrderInput = {
  id: Scalars['ID'];
};

export type SaveHomeownerContractResult = {
  __typename?: 'SaveHomeownerContractResult';
  homeownerContract: HomeownerContract;
};

export type SaveHomeownerContractChangeOrderResult = {
  __typename?: 'SaveHomeownerContractChangeOrderResult';
  homeownerContractChangeOrder: HomeownerContractChangeOrder;
};

export type HomeownerContractFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
};

export type HomeownerContractChangeOrderFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
};

export type ContractProjectFinancials = {
  __typename?: 'ContractProjectFinancials';
  project: Project;
  softCostBudgetInCents: Scalars['Int'];
  directHardCostBudgetInCents: Scalars['Int'];
  indirectHardCostBudgetInCents: Scalars['Int'];
  totalMarkupInCents: Scalars['Int'];
};

export type HomeownerContractDraw = Named & {
  __typename?: 'HomeownerContractDraw';
  id: Scalars['ID'];
  parent: HomeownerContractLike;
  task: Task;
  percent: Scalars['Int'];
  amountInCents: Scalars['Int'];
  order: Scalars['Int'];
  isDrawn: Scalars['Boolean'];
  /** The contract short name (i.e. 'Prime' or 'CO #1') + draw order number. */
  name: Scalars['String'];
  /** The draw name + the percentage/task milestone it's linked to. */
  description: Scalars['String'];
  /** The invoice line item that is collecting this draw, if drawn. */
  invoiceDrawLineItem?: Maybe<InvoiceDrawLineItem>;
};

export type SaveHomeownerContractDrawInput = {
  id?: InputMaybe<Scalars['ID']>;
  taskId?: InputMaybe<Scalars['ID']>;
  percent?: InputMaybe<Scalars['Int']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  delete?: InputMaybe<Scalars['Boolean']>;
};

export type HomeownerContractLineItemAllocation = {
  __typename?: 'HomeownerContractLineItemAllocation';
  id: Scalars['ID'];
  costInCents: Scalars['Int'];
  priceInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  homeownerContractLineItem: HomeownerContractLineItem;
  projectItemAllocation: ProjectItemAllocation;
  changeEventLineItemAllocation?: Maybe<ChangeEventLineItemAllocation>;
};

export type HomeownerNote = {
  __typename?: 'HomeownerNote';
  id: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
  /**
   * NOTE: In the future, there will be an `images` field that will either be a
   * `JobLogImage` or a `HomeownerImage`. For now, we're only supporting
   * `JobLogImage`.
   */
  jobLogImages: Array<JobLogImage>;
  scheduleTasks: Array<ScheduleTask>;
  project: Project;
  createdAt: Scalars['DateTime'];
  createdBy: User;
  schedulePhases: Array<SchedulePhase>;
};

export type SaveHomeownerNoteInput = {
  id?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  jobLogImageIds?: InputMaybe<Array<Scalars['ID']>>;
  scheduleTaskIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveHomeownerNoteResult = {
  __typename?: 'SaveHomeownerNoteResult';
  homeownerNote: HomeownerNote;
};

export type HomeownerNoteFilter = {
  project?: InputMaybe<Array<Scalars['ID']>>;
  createdDate?: InputMaybe<DateFilter2>;
};

export type InsideMapsRoomRendering = {
  __typename?: 'InsideMapsRoomRendering';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  asset?: Maybe<Asset>;
  readyPlanLocation: ReadyPlanLocation;
};

export type InternalUser = Named & {
  __typename?: 'InternalUser';
  id: Scalars['ID'];
  name: Scalars['String'];
  email: Scalars['String'];
  avatar: Scalars['String'];
  projectRole?: Maybe<ProjectRole>;
  projectRoleDetail?: Maybe<ProjectRoleDetail>;
  user: User;
  /** Approvals this user has SUBMIT */
  approvals: Array<Approval>;
  /** Approvals this user is an Approver on. Defaults to only ActionRequired status. */
  approvers: Array<Approver>;
  projectDashboardConfig?: Maybe<DashboardConfig>;
  warrantyTickets: Array<WarrantyTicket>;
  impersonateInternalUser?: Maybe<InternalUser>;
};


export type InternalUserApproversArgs = {
  status?: InputMaybe<Array<ApproverStatus>>;
};

export type SaveInternalUserInput = {
  /** email is inferred from the current/impersonating user if not explicitly passed */
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  avatarUrl?: InputMaybe<Scalars['String']>;
  projectRole?: InputMaybe<ProjectRole>;
  projectDashboardConfig?: InputMaybe<DashboardConfigInput>;
  impersonateTradePartnerUserId?: InputMaybe<Scalars['ID']>;
  impersonateInternalUserId?: InputMaybe<Scalars['ID']>;
};

export type InternalUserFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  email?: InputMaybe<Array<Scalars['String']>>;
  projectRole?: InputMaybe<Array<ProjectRole>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
};

export type SaveInternalUserResult = {
  __typename?: 'SaveInternalUserResult';
  internalUser: InternalUser;
};

export type DashboardConfigInput = {
  tileConfigs?: InputMaybe<Array<DashboardTileConfigInput>>;
};

export type DashboardTileConfigInput = {
  tile: DashboardTile;
  size: DashboardTileSize;
};

export type DashboardConfig = {
  __typename?: 'DashboardConfig';
  tileConfigs?: Maybe<Array<DashboardTileConfig>>;
};

export type DashboardTileConfig = {
  __typename?: 'DashboardTileConfig';
  tile: DashboardTile;
  size: DashboardTileSize;
};

export type ReassignTeamMembersInput = {
  sourceUserEmail: Scalars['String'];
  targetUserEmail: Scalars['String'];
};

export enum DashboardTile {
  ProjectSchedule = 'ProjectSchedule',
  ProjectInfo = 'ProjectInfo',
  ProjectFinances = 'ProjectFinances',
  ProjectDocuments = 'ProjectDocuments',
  ProjectToDos = 'ProjectToDos',
  ProjectJobLogs = 'ProjectJobLogs',
  ProjectTeamMembers = 'ProjectTeamMembers',
  ProjectPhotos = 'ProjectPhotos',
  ProjectHomeownerNotes = 'ProjectHomeownerNotes'
}

export enum DashboardTileSize {
  Small = 'SMALL',
  Medium = 'MEDIUM',
  Large = 'LARGE'
}

export type InvoiceParent = PlanMilestone | Task | ScheduleTask | PlanTask;

export type SaveInvoiceInput = {
  id?: InputMaybe<Scalars['ID']>;
  invoiceDate?: InputMaybe<Scalars['Date']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  quickbooksId?: InputMaybe<Scalars['String']>;
  amountPaidInCents?: InputMaybe<Scalars['Int']>;
  projectStageId?: InputMaybe<Scalars['ID']>;
  lineItems?: InputMaybe<Array<SaveInvoiceLineItemInput>>;
  drawLineItems?: InputMaybe<Array<SaveInvoiceDrawLineItemInput>>;
  quickbooksPullOnly?: InputMaybe<Scalars['Boolean']>;
  documentId?: InputMaybe<Scalars['ID']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  intacctAmountPaidInCents?: InputMaybe<Scalars['Int']>;
  quickbooksAmountPaidInCents?: InputMaybe<Scalars['Int']>;
  intacctSyncError?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<InvoiceStatus>;
  lineItemCutoffDate?: InputMaybe<Scalars['Date']>;
  lineItemStartDate?: InputMaybe<Scalars['Date']>;
  paidDate?: InputMaybe<Scalars['Date']>;
  creditForInvoiceId?: InputMaybe<Scalars['ID']>;
  intacctId?: InputMaybe<Scalars['String']>;
  /** The update source (e.g intacct). Used to determine if the invoice should be synced to Intacct. */
  updateSource?: InputMaybe<UpdateInvoiceSource>;
  type?: InputMaybe<InvoiceType>;
};

export type SaveInvoicesInput = {
  invoices: Array<SaveInvoiceInput>;
};

export type SyncInvoiceToIntacctInput = {
  id: Scalars['ID'];
};

export type SaveInvoiceResult = {
  __typename?: 'SaveInvoiceResult';
  invoice: Invoice;
};

export type SaveInvoicesResult = {
  __typename?: 'SaveInvoicesResult';
  invoices: Array<Invoice>;
};

export type InvoiceLineItemsByCostCode = {
  __typename?: 'InvoiceLineItemsByCostCode';
  costCode: CostCode;
  totalAmountInCents: Scalars['Int'];
  lineItems: Array<InvoiceLineItem>;
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  id: Scalars['ID'];
  amountInCents: Scalars['Int'];
  /** used for bool invoice sync to correctly calculate journal entries, can be ignored by non-bool invoices */
  marginInCents?: Maybe<Scalars['Int']>;
  homeownerContractLineItem: HomeownerContractLineItem;
  invoice: Invoice;
  costLineItemAllocations: Array<CostLineItemAllocation>;
  downPaymentInvoice?: Maybe<Invoice>;
  canEdit: PotentialOperation2;
};

export type SaveInvoiceLineItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  homeownerContractLineItemId?: InputMaybe<Scalars['ID']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  costLineItemAllocations?: InputMaybe<Array<SaveInvoiceCostLineItemAllocationInput>>;
};

export type SaveInvoiceCostLineItemAllocationInput = {
  id?: InputMaybe<Scalars['ID']>;
  costLineItemId?: InputMaybe<Scalars['ID']>;
  costAmountInCents?: InputMaybe<Scalars['Int']>;
  invoicedAmountInCents?: InputMaybe<Scalars['Int']>;
  delete?: InputMaybe<Scalars['Boolean']>;
};

export type InvoiceDrawLineItem = {
  __typename?: 'InvoiceDrawLineItem';
  id: Scalars['ID'];
  draw: HomeownerContractDraw;
  invoice: Invoice;
};

export type InvoiceScheduledLineItem = {
  __typename?: 'InvoiceScheduledLineItem';
  id: Scalars['ID'];
  amountInCents: Scalars['Int'];
  amountInBasisPoints: Scalars['Int'];
  marginInCents: Scalars['Int'];
  invoice: Invoice;
  invoiceScheduleItem: InvoiceScheduleItem;
  invoiceLineItems: Array<InvoiceLineItem>;
};

export type InvoiceAccruedLineItem = {
  __typename?: 'InvoiceAccruedLineItem';
  id: Scalars['ID'];
  amountInCents: Scalars['Int'];
  marginInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  costClassificationType: CostClassificationTypeDetail;
  invoice: Invoice;
  invoiceCategory?: Maybe<CostCodeInvoiceCategoryDetail>;
};

/**
 * A unified representation of invoice line items from different sources
 * (regular, scheduled, accrued, and draw) normalized for UI display.
 */
export type InvoiceDisplayLineItem = {
  __typename?: 'InvoiceDisplayLineItem';
  id: Scalars['ID'];
  name: Scalars['String'];
  costClassificationType?: Maybe<CostClassificationTypeDetail>;
  amountInCents: Scalars['Int'];
  marginInCents?: Maybe<Scalars['Int']>;
  canEdit: PotentialOperation2;
};

export type SaveInvoiceDrawLineItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  drawId?: InputMaybe<Scalars['ID']>;
  delete?: InputMaybe<Scalars['Boolean']>;
};

export type DeleteInvoiceInput = {
  id: Scalars['ID'];
};

export type InvoiceFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  quickbooksId?: InputMaybe<Array<Scalars['String']>>;
  dueDate?: InputMaybe<DateFilter2>;
  marketId?: InputMaybe<Array<Scalars['ID']>>;
  projectId?: InputMaybe<Array<Scalars['ID']>>;
  assigneeId?: InputMaybe<Array<Scalars['ID']>>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
  stage?: InputMaybe<Array<Stage>>;
  status?: InputMaybe<Array<InvoiceStatus>>;
};

export type InvoiceOrder = {
  id?: InputMaybe<Order>;
  invoiceDate?: InputMaybe<Order>;
  dueDate?: InputMaybe<Order>;
  paidDate?: InputMaybe<Order>;
};

export type InvoicesPage = {
  __typename?: 'InvoicesPage';
  entities: Array<Invoice>;
  pageInfo: PageInfo;
};

export enum UpdateInvoiceSource {
  Intacct = 'INTACCT'
}

export enum InvoiceDisplayLineItemMode {
  Pdf = 'PDF',
  Invoice = 'INVOICE'
}

export type InvoiceDocument = {
  __typename?: 'InvoiceDocument';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  documentSource: InvoiceDocumentSourceDetail;
  document: Document;
  invoice: Invoice;
};

export type SaveInvoiceDocumentInput = {
  id?: InputMaybe<Scalars['ID']>;
  documentSource?: InputMaybe<InvoiceDocumentSource>;
  documentId?: InputMaybe<Scalars['ID']>;
  invoiceId?: InputMaybe<Scalars['ID']>;
};

export type SaveInvoiceDocumentResult = {
  __typename?: 'SaveInvoiceDocumentResult';
  invoiceDocument: InvoiceDocument;
};

export type DeleteInvoiceScheduleInput = {
  projectIds: Array<Scalars['ID']>;
};

export type DeleteInvoiceScheduleResult = {
  __typename?: 'DeleteInvoiceScheduleResult';
  projects: Array<Project>;
};

export type InvoiceSchedule = {
  __typename?: 'InvoiceSchedule';
  id: Scalars['ID'];
  softCostDayOfMonth?: Maybe<Scalars['Int']>;
  hardCostDayOfMonth?: Maybe<Scalars['Int']>;
  hardCostAmountType: InvoiceScheduleAmountTypeDetail;
  softCostAmountType: InvoiceScheduleAmountTypeDetail;
  hardCostTriggerType: InvoiceScheduleTriggerTypeDetail;
  softCostTriggerType: InvoiceScheduleTriggerTypeDetail;
  invoiceScheduleTemplate: InvoiceScheduleTemplate;
  project: Project;
  items: Array<InvoiceScheduleItem>;
  invoiceItemsIndependently: Scalars['Boolean'];
};

export type InvoiceScheduleItem = {
  __typename?: 'InvoiceScheduleItem';
  id: Scalars['ID'];
  order: Scalars['Int'];
  iteration: Scalars['Int'];
  invoiceDate?: Maybe<Scalars['Date']>;
  amountInBasisPoints: Scalars['Int'];
  originalAmountInCents: Scalars['Int'];
  changeOrderAmountInCents: Scalars['Int'];
  revisedAmountInCents: Scalars['Int'];
  costClassificationType: CostClassificationTypeDetail;
  invoiceScheduleItemFrequency: InvoiceScheduleItemFrequencyDetail;
  invoiceSchedule: InvoiceSchedule;
  parent?: Maybe<InvoiceScheduleItemParent>;
  globalParent: InvoiceScheduleItemGlobalParent;
  invoiceScheduledLineItems: Array<InvoiceScheduledLineItem>;
  changeOrders: Array<HomeownerContractChangeOrder>;
  invoiceDelayInDays: Scalars['Int'];
};

export type InvoiceScheduleItemParent = PlanMilestone | ScheduleTask;

export type InvoiceScheduleItemGlobalParent = GlobalPlanMilestone | GlobalTask;

export type InvoiceScheduleTemplate = Named & {
  __typename?: 'InvoiceScheduleTemplate';
  id: Scalars['ID'];
  name: Scalars['String'];
  softCostDayOfMonth?: Maybe<Scalars['Int']>;
  hardCostDayOfMonth?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  hardCostAmountType: InvoiceScheduleAmountTypeDetail;
  softCostAmountType: InvoiceScheduleAmountTypeDetail;
  hardCostTriggerType: InvoiceScheduleTriggerTypeDetail;
  softCostTriggerType: InvoiceScheduleTriggerTypeDetail;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  customer?: Maybe<Customer>;
  items: Array<InvoiceScheduleTemplateItem>;
  invoiceSchedules: Array<InvoiceSchedule>;
  regions: Array<Region>;
  invoiceItemsIndependently: Scalars['Boolean'];
};

export type SaveInvoiceScheduleTemplateInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  softCostDayOfMonth?: InputMaybe<Scalars['Int']>;
  hardCostDayOfMonth?: InputMaybe<Scalars['Int']>;
  hardCostAmountType?: InputMaybe<InvoiceScheduleAmountType>;
  softCostAmountType?: InputMaybe<InvoiceScheduleAmountType>;
  hardCostTriggerType?: InputMaybe<InvoiceScheduleTriggerType>;
  softCostTriggerType?: InputMaybe<InvoiceScheduleTriggerType>;
  lotType?: InputMaybe<LotType>;
  customerId?: InputMaybe<Scalars['ID']>;
  items?: InputMaybe<Array<SaveInvoiceScheduleTemplateItemInput>>;
  regionIds?: InputMaybe<Array<Scalars['ID']>>;
  communityType?: InputMaybe<CommunityType>;
  invoiceItemsIndependently?: InputMaybe<Scalars['Boolean']>;
};

export type SaveInvoiceScheduleTemplateResult = {
  __typename?: 'SaveInvoiceScheduleTemplateResult';
  invoiceScheduleTemplate: InvoiceScheduleTemplate;
};

export type InvoiceScheduleTemplateItem = {
  __typename?: 'InvoiceScheduleTemplateItem';
  id: Scalars['ID'];
  iterations: Scalars['Int'];
  amountInBasisPoints: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  costClassificationType: CostClassificationTypeDetail;
  frequency: InvoiceScheduleItemFrequencyDetail;
  /** @deprecated use globalPlanMilestone instead */
  globalTask?: Maybe<GlobalTask>;
  invoiceScheduleTemplate: InvoiceScheduleTemplate;
  globalPlanMilestone: GlobalPlanMilestone;
  invoiceDelayInDays: Scalars['Int'];
};

export type SaveInvoiceScheduleTemplateItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  iterations?: InputMaybe<Scalars['Int']>;
  amountInBasisPoints?: InputMaybe<Scalars['Int']>;
  costClassificationType?: InputMaybe<CostClassificationType>;
  frequency?: InputMaybe<InvoiceScheduleItemFrequency>;
  invoiceScheduleTemplateId?: InputMaybe<Scalars['ID']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  globalPlanMilestoneId?: InputMaybe<Scalars['ID']>;
  invoiceDelayInDays?: InputMaybe<Scalars['Int']>;
};

export type SaveItemsInput = {
  items: Array<SaveItemInput>;
};

export type SaveItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  /**  Moving an item to a new cost code after creation is not supported.  */
  costCodeId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<ItemStatus>;
  internalNote?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Scalars['String']>;
  tradePartnerNote?: InputMaybe<Scalars['String']>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']>;
  tradeCategoryId?: InputMaybe<Scalars['ID']>;
  materialAttributeDimensions?: InputMaybe<Array<SaveItemMaterialAttributeDimensionInput>>;
  materialCodePrefix?: InputMaybe<Scalars['String']>;
  isAnnotated?: InputMaybe<Scalars['Boolean']>;
  materialNameFormat?: InputMaybe<Scalars['String']>;
  designPackageLocation?: InputMaybe<DesignPackageLocation>;
  isMaterialModifier?: InputMaybe<Scalars['Boolean']>;
  parentModifierItemIds?: InputMaybe<Array<Scalars['ID']>>;
  optionPricingConfig?: InputMaybe<SavePersonalizationOptionPricingConfigInput>;
  materialLeadTimeConfig?: InputMaybe<SavePersonalizationMaterialLeadTimeConfigInput>;
  isPlanBasedCost?: InputMaybe<Scalars['Boolean']>;
  finishScheduleOrder?: InputMaybe<Scalars['Int']>;
};

export type SaveItemMaterialAttributeDimensionInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['ID']>;
  isAdminManaged?: InputMaybe<Scalars['Boolean']>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  materialAttributeValues?: InputMaybe<Array<SaveMaterialAttributeDimensionValueInput>>;
  type?: InputMaybe<MaterialAttributeDimensionType>;
  useInTakeoff?: InputMaybe<Scalars['Boolean']>;
  useInVisualModePdf?: InputMaybe<Scalars['Boolean']>;
  showInFinishSchedule?: InputMaybe<Scalars['Boolean']>;
  op: IncrementalCollectionOp;
};

export type Item = Named & HasDisplayName & HasMaterialLeadTimeConfigData & {
  __typename?: 'Item';
  id: Scalars['ID'];
  name: Scalars['String'];
  /**  I.e. 3100.001 Appliance Installation  */
  displayName: Scalars['String'];
  shortName: Scalars['String'];
  costCode: CostCode;
  /**  Just the trailing `001` code of this item within it's cost code.  */
  itemCode: Scalars['Int'];
  /**  The cost code number + item code, i.e. `3100.001`.  */
  fullCode: Scalars['String'];
  status: ItemStatusDetail;
  internalNote?: Maybe<Scalars['String']>;
  specifications?: Maybe<Scalars['String']>;
  tradePartnerNote?: Maybe<Scalars['String']>;
  unitOfMeasure: UnitOfMeasure;
  tradeCategory?: Maybe<TradeCategory>;
  bidItems: Array<BidItem>;
  isContingency?: Maybe<Scalars['Boolean']>;
  materialAttributeDimensions: Array<MaterialAttributeDimension>;
  materialListings: Array<MaterialListing>;
  materialBrands: Array<MaterialBrand>;
  materialCodePrefix?: Maybe<Scalars['String']>;
  placeholderMaterialListing?: Maybe<MaterialListing>;
  isAnnotated: Scalars['Boolean'];
  planTaskMappings: Array<ItemPlanTaskMapping>;
  /**  Item version pulled from cost code  */
  version: Scalars['Int'];
  /**  Format used for materials related to this Item. For example: '{depth}x{width} - {length} {name}' where depth, width, and length are material attribute dimensions.  */
  materialNameFormat?: Maybe<Scalars['String']>;
  designPackageLocation: DesignPackageLocationDetail;
  isMaterialModifier: Scalars['Boolean'];
  /**  Determines if this is an Assembly parent-or-item (either a MAC assembly_id or component_id). Please only call this on a per-item basis and not in bulk.  */
  isAssemblyRelated: Scalars['Boolean'];
  /**  The parent Items that this modifier Item is allowed to modify.  */
  parentModifierItems: Array<Item>;
  /**  The modifier Items registered as children of this parent Item.  */
  childModifierItems: Array<Item>;
  canBecomeMaterialModifier: PotentialOperation2;
  optionPricingConfig?: Maybe<OptionPricingConfig>;
  materialLeadTimeConfig?: Maybe<MaterialLeadTimeConfig>;
  /**  The minLeadTimeInDays for this Item, either defined directly by an MaterialLeadTimeConfig or falling back to a default value as set on its CostCode.  */
  minLeadTimeInDays: Scalars['Int'];
  /**  The expectedLeadTimeInDays for this Item, either defined directly by an MaterialLeadTimeConfig or falling back to a default value as set on its CostCode.  */
  expectedLeadTimeInDays: Scalars['Int'];
  /**  The maxLeadTimeInDays for this Item, either defined directly by an MaterialLeadTimeConfig or falling back to a default value as set on its CostCode.  */
  maxLeadTimeInDays: Scalars['Int'];
  history: Array<History>;
  isPlanBasedCost: Scalars['Boolean'];
  finishScheduleOrder: Scalars['Int'];
};

export type DeleteItemInput = {
  id: Scalars['ID'];
};

export type ItemFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Array<Scalars['Int']>>;
  costCode?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Array<ItemStatus>>;
  designPackageLocation?: InputMaybe<DesignPackageLocation>;
};

export type ItemPlanTaskMapping = {
  __typename?: 'ItemPlanTaskMapping';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  item: Item;
  location?: Maybe<Location>;
  task: GlobalPlanTask;
  estimatedLaborCostInCents?: Maybe<Scalars['Int']>;
  unitOfMeasure?: Maybe<UnitOfMeasure>;
};

export type SaveItemPlanTaskMappingInput = {
  id?: InputMaybe<Scalars['ID']>;
  itemId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
  taskId?: InputMaybe<Scalars['ID']>;
  estimatedLaborCostInCents?: InputMaybe<Scalars['Int']>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']>;
};

export type DeleteItemPlanTaskMappingInput = {
  id: Scalars['ID'];
};

export type SaveItemPlanTaskMappingResult = {
  __typename?: 'SaveItemPlanTaskMappingResult';
  itemPlanTaskMapping: ItemPlanTaskMapping;
};

export type ItemPlanTaskMappingPage = {
  __typename?: 'ItemPlanTaskMappingPage';
  entities: Array<ItemPlanTaskMapping>;
  pageInfo: PageInfo;
};

export type ItemSlot = Named & {
  __typename?: 'ItemSlot';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  costType: CostType;
  costTypeDetail: CostTypeDetail;
  item: Item;
  location: Location;
  unitOfMeasure: UnitOfMeasure;
};

export type SaveItemSlotInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  costType?: InputMaybe<CostType>;
  itemId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']>;
};

export type SaveItemSlotResult = {
  __typename?: 'SaveItemSlotResult';
  itemSlot: ItemSlot;
};

export type ItemTemplate = Named & HasDisplayName & HasDisplayVersion & BaseItemParent & BaseItemParentVersion & {
  __typename?: 'ItemTemplate';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  items: Array<ItemTemplateItem>;
  status: ItemTemplateStatus;
  statusDetail: ItemTemplateStatusDetail;
  /**  Whether this is a plan template (only one per stage) or an option template (many per stage) */
  isPlanTemplate: Scalars['Boolean'];
  stage: Stage;
  stageDetail: StageDetail;
  description?: Maybe<Scalars['String']>;
  applyTemplatePlan: Array<ItemTemplateItemPlan>;
  applyTemplatePlanChangeEvent: Array<ItemTemplateItemPlan>;
  development?: Maybe<Development>;
  specOptions: Array<ReadyPlanOption>;
  totalCostInCents: Scalars['Int'];
  isReadyHomeTemplate: Scalars['Boolean'];
  /** @deprecated This operation is now always allowed */
  canCopyItemsToTemplate: PotentialOperation2;
  canApplyTo: PotentialOperation2;
  canUnlock: PotentialOperation2;
  /** Indicates whether this template can be activated */
  canActivate: PotentialOperation2;
  canCreateNewVersion: PotentialOperation2;
  canEditLineItems: PotentialOperation2;
  /** Indicates whether this template can be deleted individually */
  canDelete: PotentialOperation2;
  readyPlan?: Maybe<ReadyPlan>;
  displayName: Scalars['String'];
  /** Indicates if there are any templates which can be cloned to from this template */
  hasCloneToTargets: PotentialOperation2;
  /** List of templates within the development which can be cloned to from this template */
  cloneToTargets: Array<ItemTemplate>;
  /** Timestamp when the template was activated, if it has been activated */
  activatedAt?: Maybe<Scalars['DateTime']>;
  /** Timestamp when the template was archived, if it has been archived */
  archivedAt?: Maybe<Scalars['DateTime']>;
  /**
   * A collection of templates which represent the different versions of this template over time.
   *
   * Templates which do not have a collection are not versioned, but can become versioned if desired.
   */
  collection?: Maybe<ItemTemplateCollection>;
  /** ItemTemplateVersions in this particular template */
  itemVersions: Array<ItemTemplateItemVersion>;
  major: Scalars['Int'];
  minor: Scalars['Int'];
  scopeChangeType: ScopeChangeType;
  scopeChangeTypeDetail: ScopeChangeTypeDetail;
  scopeChangeReason?: Maybe<ScopeChangeReason>;
  /** The template on which this template was based */
  basedOn?: Maybe<ItemTemplate>;
  /** All templates which have been based off of this template */
  templatesBasedOn: Array<ItemTemplate>;
  isVersioned: Scalars['Boolean'];
  isLocked: Scalars['Boolean'];
  /** Returns the amount of projects this templates has being applied to */
  appliedToCount: Scalars['Int'];
  isLatest: Scalars['Boolean'];
  isLatestActive: Scalars['Boolean'];
  scopeChangeReasonNote?: Maybe<Scalars['String']>;
  /** Returns the unique options which are associated with ITIs in this template */
  options: Array<ReadyPlanOption>;
  /** Template version number in format v[major].[minor] */
  version: Scalars['String'];
  /** Template version number which includes whether the template is currently being drafted off a prior version. EX: Editing from v[major].[minor] */
  displayVersion: Scalars['String'];
  /** Experimental feature to detect issues in scope templates */
  anomalies: Array<ItemTemplateAnomaly>;
  contingencyMarkupPercentage?: Maybe<Scalars['Float']>;
  /** Flag that will be true if the template has any item template item using an item flagged as contingency */
  hasContingencyLineItem: Scalars['Boolean'];
  sourceForApprovals: Array<Approval>;
  /**  Whether this specific template version is used by UW to drive plan costs & project creation.  */
  isUnderwritingTemplate: Scalars['Boolean'];
  lastUsedAsUnderwritingTemplate?: Maybe<Scalars['Date']>;
  itemLocations: Array<Location>;
  tradeCategories: Array<TradeCategory>;
  costCodes: Array<CostCode>;
};


export type ItemTemplateApplyTemplatePlanArgs = {
  projectStageId: Scalars['ID'];
};


export type ItemTemplateApplyTemplatePlanChangeEventArgs = {
  changeEventId: Scalars['ID'];
};


export type ItemTemplateCanCopyItemsToTemplateArgs = {
  targetTemplate: Scalars['ID'];
};


export type ItemTemplateCanApplyToArgs = {
  projectStageId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
};

/**  For a given template item, where it can replace a project item on merge.  */
export type ItemTemplateItemPlan = {
  __typename?: 'ItemTemplateItemPlan';
  itemTemplateItem: ItemTemplateItem;
  projectItem?: Maybe<ProjectItem>;
};

export type SaveItemTemplateInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ItemTemplateStatus>;
  stage?: InputMaybe<Stage>;
  description?: InputMaybe<Scalars['String']>;
  developmentId?: InputMaybe<Scalars['ID']>;
  readyPlanId?: InputMaybe<Scalars['ID']>;
  displayName?: InputMaybe<Scalars['String']>;
  scopeChangeReasonId?: InputMaybe<Scalars['ID']>;
  scopeChangeReasonNote?: InputMaybe<Scalars['String']>;
  contingencyMarkupPercentage?: InputMaybe<Scalars['Float']>;
};

export type SaveItemTemplateResult = {
  __typename?: 'SaveItemTemplateResult';
  itemTemplate: ItemTemplate;
};

export type SaveItemTemplatesInput = {
  itemTemplates: Array<SaveItemTemplateInput>;
  /** If true, a reason code specified for a particular template will be propagated to all of its ITIVs */
  applyReasonToAllItems?: InputMaybe<Scalars['Boolean']>;
  /** If true, a reason code specified for a particular template will only be applied if the reason code has not already been set */
  applyReasonWhenNotSet?: InputMaybe<Scalars['Boolean']>;
};

export type SaveItemTemplatesResult = {
  __typename?: 'SaveItemTemplatesResult';
  itemTemplates?: Maybe<Array<Maybe<ItemTemplate>>>;
};

export type ApplyItemTemplateInput = {
  id: Scalars['ID'];
  projectStageId: Scalars['ID'];
  /**
   * An optional list of each item to apply, and an optional existing project item it should merge into.
   *
   * If `items` is not provided, then all items in the template are appended to the project scope.
   */
  items?: InputMaybe<Array<ApplyItemTemplateItemInput>>;
};

export type ApplyItemTemplateItemInput = {
  itemTemplateItemId: Scalars['ID'];
  projectItemId?: InputMaybe<Scalars['ID']>;
};

export type ApplyItemTemplateResult = {
  __typename?: 'ApplyItemTemplateResult';
  projectItems: Array<ProjectItem>;
  projectStage: ProjectStage;
  userErrors?: Maybe<Array<UserError>>;
};

export type ItemTemplateFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  development?: InputMaybe<Array<Scalars['ID']>>;
  stage?: InputMaybe<Array<Stage>>;
  status?: InputMaybe<Array<ItemTemplateStatus>>;
  isReadyHomeTemplate?: InputMaybe<Scalars['Boolean']>;
  canCopyItemsTo?: InputMaybe<Scalars['ID']>;
  readyPlan?: InputMaybe<Array<Scalars['ID']>>;
  isLatest?: InputMaybe<Scalars['Boolean']>;
  scopeChangeType?: InputMaybe<Array<ScopeChangeType>>;
};

export type ChildItemTemplateFilter = {
  status?: InputMaybe<Array<ItemTemplateStatus>>;
};

export type ApplyItemTemplateToChangeEventInput = {
  id: Scalars['ID'];
  changeEventId: Scalars['ID'];
  /**
   * An optional list of each item to apply, and an optional existing project item it should merge into.
   *
   * If `items` is not provided, then all items in the template are appended to the project scope.
   */
  items?: InputMaybe<Array<ApplyItemTemplateItemInput>>;
};

export type ApplyItemTemplateToChangeEventResult = {
  __typename?: 'ApplyItemTemplateToChangeEventResult';
  lineItems: Array<ChangeEventLineItem>;
  changeEvent: ChangeEvent;
};

export type CloneItemTemplateInput = {
  original: Scalars['ID'];
  /**
   * When cloneTo is specified, it must either:
   *
   * Reference another Whole House template for the same ReadyPlan, and must not be the same as original.
   *
   * This will have the following side effects:
   * 1) Any ItemTemplateItems in the Whole House template, or any Option Templates, will be deleted
   * 2) ItemTemplateItems from original, and its Option Templates (depending on the value of includeChildren), will be copied into cloneTo and its childTemplates.
   *
   * OR reference a different Development, in which case the cloned template will be created in a different development, and unassigned from any ReadyPlan/Options.
   */
  cloneTo?: InputMaybe<Scalars['ID']>;
  /** Name for the cloned template. Defaults to `[Original Name] Copy` */
  name?: InputMaybe<Scalars['String']>;
};

export type CloneItemTemplateResult = {
  __typename?: 'CloneItemTemplateResult';
  original: ItemTemplate;
  clone: ItemTemplate;
};

export type CopyItemTemplateItemsInput = {
  targetTemplateId: Scalars['ID'];
  sourceTemplateId?: InputMaybe<Scalars['ID']>;
  /** Accepts only ITIV IDs */
  sourceItemIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The RPO id to assign to the new items */
  targetOptionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** The RPO id to assign as elevation to the new items */
  targetElevationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type CopyItemTemplateItemsResult = {
  __typename?: 'CopyItemTemplateItemsResult';
  targetTemplate: ItemTemplate;
  /** The templates from which copied items originated from */
  sourceTemplates: Array<ItemTemplate>;
  /** The sourceItems which were cloned, when sourceItemIds was specified and contained ITIV IDs, otherwise [] */
  sourceItemVersions: Array<ItemTemplateItemVersion>;
  /** The ITIs that were copied during the operation */
  copiedItems: Array<ItemTemplateItem>;
  /** The ITIVs that were copied during the operation */
  copiedItemVersions: Array<ItemTemplateItemVersion>;
};

export type CreateNewItemTemplateVersionsInput = {
  id: Array<Scalars['ID']>;
  /** Optional ScopeChangeReason ID to be applied to all newly created templates/ITIVs */
  scopeChangeReasonId?: InputMaybe<Scalars['ID']>;
};

export type CreateNewItemTemplateVersionsResult = {
  __typename?: 'CreateNewItemTemplateVersionsResult';
  newTemplates: Array<ItemTemplate>;
};

export type ActivateItemTemplateVersionsInput = {
  /**
   * A list of templates to activate and push to projects.
   * If templates specified are already Active, they'll be ignored.
   */
  templateId: Array<Scalars['ID']>;
};

export type ActivateItemTemplateVersionsResult = {
  __typename?: 'ActivateItemTemplateVersionsResult';
  /** Templates which were successfully activated */
  activatedTemplates: Array<ItemTemplate>;
};

export type ArchiveItemTemplateVersionsInput = {
  /** A list of templates to archive. */
  templateId: Array<Scalars['ID']>;
  /**
   * When true, all active versions of this template will be archived. This is useful when an entire ReadyPlan is being archived and no longer needed.
   * When left unspecified or set to false, then only the specific versions of templates specified by `templateId` will be archived.
   */
  archiveAllVersions?: InputMaybe<Scalars['Boolean']>;
};

export type ItemTemplateOrder = {
  id?: InputMaybe<Order>;
  activatedAt?: InputMaybe<Order>;
};

export type ItemTemplateAnomalyParent = ItemTemplate | ItemTemplateItemVersion;

export type ItemTemplateAnomaly = {
  __typename?: 'ItemTemplateAnomaly';
  id: Scalars['ID'];
  type: ItemTemplateAnomalyType;
  parent: ItemTemplateAnomalyParent;
  description: Scalars['String'];
};

export enum ItemTemplateAnomalyType {
  TemplateMissingScopeForOption = 'TEMPLATE_MISSING_SCOPE_FOR_OPTION',
  TemplateIncludesScopeForArchivedOption = 'TEMPLATE_INCLUDES_SCOPE_FOR_ARCHIVED_OPTION',
  LineItemCostHigherThanOthers = 'LINE_ITEM_COST_HIGHER_THAN_OTHERS',
  LineItemCostLowerThanOthers = 'LINE_ITEM_COST_LOWER_THAN_OTHERS',
  LineItemNotPresentOnOthers = 'LINE_ITEM_NOT_PRESENT_ON_OTHERS',
  AddLineItemMissingModifiersFromOthers = 'ADD_LINE_ITEM_MISSING_MODIFIERS_FROM_OTHERS'
}

export type ItemTemplateCollection = {
  __typename?: 'ItemTemplateCollection';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** All templates in this collection */
  templates: Array<ItemTemplate>;
  /** The draft template if there's any, else highest version number that's active */
  latest?: Maybe<ItemTemplate>;
};

export type ItemTemplateCostUpdate = {
  __typename?: 'ItemTemplateCostUpdate';
  id: Scalars['ID'];
  completed: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  bidContractRevision: BidContractRevision;
  itemTemplate: ItemTemplate;
};

export type ItemTemplateItem = Named & HasDisplayName & HasBlueprintUrl & BaseItemLike & {
  __typename?: 'ItemTemplateItem';
  id: Scalars['ID'];
  identityId: Scalars['ID'];
  slot: ItemSlot;
  item: Item;
  template: ItemTemplate;
  location: Location;
  quantity?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  costType: CostType;
  costTypeDetail: CostTypeDetail;
  specifications?: Maybe<Scalars['String']>;
  unitOfMeasure: UnitOfMeasure;
  tradePartnerNote?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  displayName: Scalars['String'];
  /**
   * Returns the associated ItemTemplate.
   * The `displayVersion` field still reaches through to the `ReadyPlan.displayName` which is the most common use case of this field
   */
  parent: ItemTemplate;
  readyPlan?: Maybe<ReadyPlanLike>;
  /**  Same value as `parent`, but provides consistency with TLI[V] access patterns.  */
  first: ItemTemplate;
  totalCostInCents: Scalars['Int'];
  unitCostInCents: Scalars['Int'];
  canDeleteItem: PotentialOperation2;
  /** A convenience accessor for ItemTemplate.canEditLineItems to provide API consistency between ITI/ITIV. */
  canEdit: PotentialOperation2;
  preferredBidContractLineItem?: Maybe<BidContractLineItem>;
  /** Hash of the key fields which make up the logical identity of this ItemTemplateItem */
  identityHash?: Maybe<Scalars['String']>;
  /** Hash of the major fields of this ItemTemplateItem */
  majorHash?: Maybe<Scalars['String']>;
  /** Hash of the minor fields of this ItemTemplateItem */
  minorHash?: Maybe<Scalars['String']>;
  /** All ItemTemplateItemVersions which reference this ItemTemplateItem */
  versions: Array<ItemTemplateItemVersion>;
  /** The ItemTemplateItem on from which this ItemTemplateItem was based on */
  basedOn?: Maybe<ItemTemplateItem>;
  /** Collection of ItemTemplateItems which have been based on this ItemTemplateItem. In most cases it will be 0 or 1, unless someone branched from the same ItemTemplate multiple times. */
  itemsBasedOn: Array<ItemTemplateItem>;
  /** The original ItemTemplateItem from which others are based. */
  original?: Maybe<ItemTemplateItem>;
  bidItem?: Maybe<BidItem>;
  isDisabledMaterialVariant: Scalars['Boolean'];
  potentialBidItems: Array<BidItem>;
  /**  Helper for the FE multi-select dropdown  */
  elevationIds: Array<Scalars['ID']>;
  /**  Helper for the FE multi-select dropdown  */
  specOptionIds: Array<Scalars['ID']>;
  /**  Helper for the FE multi-select dropdown  */
  otherOptionIds: Array<Scalars['ID']>;
  /**  All of the elevation + specOption + option RPOs as a single list.  */
  options: Array<ReadyPlanOption>;
  blueprintUrl: Url;
  bidItemTemplateItem?: Maybe<ItemTemplateItem>;
  task?: Maybe<GlobalPlanTask>;
  costStatus: ItemTemplateItemCostStatusDetail;
  materialVariant?: Maybe<MaterialVariant>;
  development?: Maybe<Development>;
  costEstimate: CostEstimate;
  customPlaceholderName?: Maybe<Scalars['String']>;
};

export type CostEstimate = {
  __typename?: 'CostEstimate';
  costInCents: Scalars['Int'];
};

export type ItemTemplateItemVersionsPage = {
  __typename?: 'ItemTemplateItemVersionsPage';
  items: Array<ItemTemplateItemVersion>;
  pageInfo: PageInfo;
  /** These are totals for items in the template grouped by either cost code or option depending on the primary ordering */
  groupTotals: Array<ItemTemplateItemVersionGroupTotal>;
};

export type ItemTemplateItemVersionGroupTotal = {
  __typename?: 'ItemTemplateItemVersionGroupTotal';
  groupId: Scalars['String'];
  totalCostInCents: Scalars['Int'];
  itivsInGroup: Scalars['Int'];
  itivIdsInGroup: Array<Scalars['ID']>;
  displayName: Scalars['String'];
  /** The number of itis with costType = MATERIAL in the group */
  materialsInGroup: Scalars['Int'];
  /** The number of itis with costType = LABOR in the group */
  tasksInGroup: Scalars['Int'];
};

export type ItiAnomaly = {
  __typename?: 'ItiAnomaly';
  /** Descriptoin of the anomaly detected */
  description: Scalars['String'];
};

export type ItemTemplateItemVersionFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  template?: InputMaybe<Array<Scalars['ID']>>;
  scope?: InputMaybe<Array<Scalars['ID']>>;
  development?: InputMaybe<Array<Scalars['ID']>>;
  scopeChangeType?: InputMaybe<Array<ScopeChangeType>>;
  scopeChangeReason?: InputMaybe<Array<Scalars['ID']>>;
  location?: InputMaybe<Array<Scalars['ID']>>;
  /** Return any ITIV which includes the specified location IDs in its location path */
  locationInPath?: InputMaybe<Array<Scalars['ID']>>;
  item?: InputMaybe<Array<Scalars['ID']>>;
  unitOfMeasure?: InputMaybe<Array<Scalars['ID']>>;
  costType?: InputMaybe<Array<CostType>>;
  costCode?: InputMaybe<Array<Scalars['ID']>>;
  costDivision?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter based on the spec levels assigned to the item. Examples:
   * undefined => no filtering at all based on spec level
   * [] => no items will be returned
   * [null] => items without any associated spec level will be returned
   * [null, "gsl:1", "gsl:2"] => items with GSL 1/2 or no spec level at all will be returned
   */
  specOption?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /**
   * Used to leave itivs that have scopeChangeType = REMOVED out of the result,
   * providing this flag will override any scopeChangeType filter being used, as (all types except Removed)
   */
  excludeRemoved?: InputMaybe<Scalars['Boolean']>;
  /**
   * Include 'null' in the list of IDs to return items have elevation === null
   * (which means they are applicable to ALL elevations),
   * in addition to the specific elevation IDs requested
   */
  elevation?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /**
   * Include 'null' in the list of IDs to return items have option === null
   * (which means they are applicable to ALL options),
   * in addition to the specified option IDs requested
   */
  option?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /**
   * Include 'null' in the list of IDs to return items having no options assigned.
   * This means they are applicable to the plan generally, regardless of options chosen.
   * Unlike the option/specOption/elevation filters, this is applied to all assigned options regardless of type.
   */
  options?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /**
   * Filter based on underlying Global Option. Useful for loading similar options across multiple
   * templates. More general than `options` filter and IGNORED if `option` is non-empty.
   */
  globalOption?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter based on text search using SQL LIKE */
  search?: InputMaybe<Scalars['String']>;
  /** Filter based on whether the item have anomalies or not. Currently only true or undefined is supported */
  hasAnomalies?: InputMaybe<Scalars['Boolean']>;
  materialType?: InputMaybe<Array<MaterialType>>;
  globalPlanTask?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveItemTemplateItemVersionsInput = {
  /**
   * The template to which all ITIVs will be associated.
   * This is equivalent to specifying the templateId on each SaveItemTemplateItemVersionInput, and will override it if specified.
   */
  templateId?: InputMaybe<Scalars['ID']>;
  itemTemplateItemVersions: Array<SaveItemTemplateItemVersionInput>;
};

export type SaveItemTemplateItemVersionInput = {
  id?: InputMaybe<Scalars['ID']>;
  templateId?: InputMaybe<Scalars['ID']>;
  /** Used to associate an existing ITI with a version/template */
  scopeId?: InputMaybe<Scalars['ID']>;
  scopeChangeReasonId?: InputMaybe<Scalars['ID']>;
  scopeChangeReasonNote?: InputMaybe<Scalars['String']>;
  slotId?: InputMaybe<Scalars['ID']>;
  itemId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Int']>;
  costType?: InputMaybe<CostType>;
  specifications?: InputMaybe<Scalars['String']>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']>;
  tradePartnerNote?: InputMaybe<Scalars['String']>;
  internalNote?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  totalCostInCents?: InputMaybe<Scalars['Int']>;
  /**  Used to delete/remove an ITIV as appropriate based on whether it is hard-deletable  */
  remove?: InputMaybe<Scalars['Boolean']>;
  bidItemId?: InputMaybe<Scalars['ID']>;
  bidItemCode?: InputMaybe<Scalars['String']>;
  /**  Helper for the FE multi-select dropdown  */
  elevationIds?: InputMaybe<Array<Scalars['ID']>>;
  /**  Helper for the FE multi-select dropdown  */
  specOptionIds?: InputMaybe<Array<Scalars['ID']>>;
  /**  Helper for the FE multi-select dropdown  */
  otherOptionIds?: InputMaybe<Array<Scalars['ID']>>;
  optionIds?: InputMaybe<Array<Scalars['ID']>>;
  preferredBidContractLineItemId?: InputMaybe<Scalars['ID']>;
  taskId?: InputMaybe<Scalars['ID']>;
  materialVariantId?: InputMaybe<Scalars['ID']>;
  /** These are FE helpers for CSV imports, to get resolved from real entities */
  itemCode?: InputMaybe<Scalars['String']>;
  costTypeName?: InputMaybe<Scalars['String']>;
  materialVariantCode?: InputMaybe<Scalars['String']>;
  taskName?: InputMaybe<Scalars['String']>;
  unitOfMeasureName?: InputMaybe<Scalars['String']>;
  optionCodes?: InputMaybe<Array<Scalars['String']>>;
};

export type GroupTotalsInput = {
  filter?: InputMaybe<ItemTemplateItemVersionFilter>;
  order?: InputMaybe<Array<ItemTemplateItemVersionOrder>>;
};

export type SaveItemTemplateItemVersionsResult = {
  __typename?: 'SaveItemTemplateItemVersionsResult';
  itemTemplateItemVersions: Array<ItemTemplateItemVersion>;
  /** Any ITIVs that were removed from the template, but could not be deleted because they are used on a different version of the template. */
  removed: Array<ItemTemplateItemVersion>;
  /** Any ITIVs that were deleted from the template. */
  deleted: Array<Scalars['ID']>;
  /** Only calculated if groupTotalsInput is provided */
  groupTotals: Array<ItemTemplateItemVersionGroupTotal>;
};

export type DedupeReadyPlanItemTemplateItemVersionsInput = {
  template: Scalars['ID'];
  /** defaults to true, and will not merge items with different costs */
  requireCostMatch?: InputMaybe<Scalars['Boolean']>;
  /** A filter to apply to the ITIVs to be deduped. This is useful for deduping only a subset of the ITIVs in a template. */
  filter?: InputMaybe<ItemTemplateItemVersionFilter>;
  /** A list of options to dedupe across. Or special values "specOption" or "elevation" to dedupe across all spec options or elevations respectively. */
  acrossOptions?: InputMaybe<Array<Scalars['ID']>>;
};

export type DedupeReadyPlanItemTemplateItemVersionsResult = {
  __typename?: 'DedupeReadyPlanItemTemplateItemVersionsResult';
  dedupedItemTemplateItemVersions: Array<DedupedItemTemplateItemVersion>;
  affectedTemplates: Array<ItemTemplate>;
  affectedDevelopments: Array<Development>;
  affectedReadyPlans: Array<ReadyPlan>;
};

export type DedupedItemTemplateItemVersion = {
  __typename?: 'DedupedItemTemplateItemVersion';
  primary: ItemTemplateItemVersion;
  removes: Array<ItemTemplateItemVersion>;
};

/**
 * The FE will specify at most one of the following order fields, and optionally a groupBy value (defaults to None).
 * The BE will then order first by the groupBy value, and then by the specified order field, and then by whatever other fields
 * it deems appropriate to keep related items close to each other an in a convenient/consistent order.
 */
export type ItemTemplateItemVersionOrder = {
  field: ItivOrderField;
  direction: Order;
};

export enum ItivOrderField {
  Id = 'Id',
  CostCode = 'CostCode',
  CostDivision = 'CostDivision',
  Drop = 'Drop',
  Item = 'Item',
  Elevation = 'Elevation',
  SpecOption = 'SpecOption',
  /**  Orders by all options except spec/elevation options. Used by legacy ReadyPlan scope group by option view, which considered spec/elevation part of the base house.  */
  Option = 'Option',
  /**  Orders by all options regardless of type. Used by new PlanPackage scope group by option view, which considers spec/elevation as separate from base house.  */
  Options = 'Options',
  Location = 'Location',
  LocationPath = 'LocationPath',
  LocationLevel = 'LocationLevel',
  LocationRoom = 'LocationRoom',
  LocationFeature = 'LocationFeature',
  TotalCostInCents = 'TotalCostInCents',
  CostType = 'CostType',
  Quantity = 'Quantity',
  UnitOfMeasure = 'UnitOfMeasure',
  MaterialType = 'MaterialType',
  MaterialCode = 'MaterialCode',
  GlobalPlanTask = 'GlobalPlanTask',
  /**  NOTE: This does not account for changes which occurred to the underlying ITIV.scope  */
  UpdatedAt = 'UpdatedAt'
}

export type AddJobResult = {
  __typename?: 'AddJobResult';
  trackedJob?: Maybe<TrackedJob>;
  emptyResult?: Maybe<Scalars['String']>;
};

export type AddJobsResult = {
  __typename?: 'AddJobsResult';
  trackedJobs: Array<TrackedJob>;
  emptyResult?: Maybe<Scalars['String']>;
};

export type AddJobInput = {
  name: Scalars['String'];
  payload?: InputMaybe<Scalars['JSONObject']>;
  spec?: InputMaybe<JobTaskSpec>;
};

export type AddJobsInput = {
  name: Scalars['String'];
  payloads: Array<Scalars['JSONObject']>;
  spec?: InputMaybe<JobTaskSpec>;
};

export type JobTaskSpec = {
  /**
   * The queue to run this task under (only specify if you want jobs in this queue to run serially). (addJob default: null,
   * addJobsDefault: input.name)
   */
  queueName?: InputMaybe<Scalars['String']>;
  /** A Date to schedule this task to run in the future. (Default: now) */
  runAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * Jobs are executed in numerically ascending order of priority (jobs with a
   * numerically smaller priority are run first). (Default: 0)
   */
  priority?: InputMaybe<Scalars['Int']>;
  /** How many retries should this task get? (Default: 25) */
  maxAttempts?: InputMaybe<Scalars['Int']>;
  /**
   * Unique identifier for the job, can be used to update or remove it later if
   * needed. (Default: null)
   */
  jobKey?: InputMaybe<Scalars['String']>;
  /**
   * Modifies the behavior of `jobKey`; when 'replace' all attributes will be
   * updated, when 'preserve_run_at' all attributes except 'run_at' will be
   * updated, when 'unsafe_dedupe' a new job will only be added if no existing
   * job (including locked jobs and permanently failed jobs) with matching job
   * key exists. (Default: 'replace')
   */
  jobKeyMode?: InputMaybe<JobKeyMode>;
};

export enum JobKeyMode {
  Replace = 'REPLACE',
  PreserveRunAt = 'PRESERVE_RUN_AT',
  UnsafeDedupe = 'UNSAFE_DEDUPE'
}

export type JobLog = Entity & {
  __typename?: 'JobLog';
  id: Scalars['ID'];
  logDate: Scalars['Date'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  project: Project;
  notes: Array<JobLogNote>;
  images: Array<JobLogImage>;
  minTemperature?: Maybe<Scalars['String']>;
  maxTemperature?: Maybe<Scalars['String']>;
  humidity?: Maybe<Scalars['String']>;
  wind?: Maybe<Scalars['String']>;
  weatherType?: Maybe<WeatherType>;
  weatherTypeDetail?: Maybe<WeatherTypeDetail>;
  weatherTypeChanged?: Maybe<Scalars['Boolean']>;
};


export type JobLogNotesArgs = {
  filter?: InputMaybe<JobLogNoteFilter>;
};

export type JobLogFilter = {
  project?: InputMaybe<Array<Scalars['ID']>>;
  noteType?: InputMaybe<Array<JobLogNoteType>>;
  flags?: InputMaybe<Array<JobLogFlag>>;
  weatherType?: InputMaybe<Array<WeatherType>>;
  logDate?: InputMaybe<DateFilter2>;
  scheduleTasks?: InputMaybe<Array<Scalars['ID']>>;
};

export type JobLogNoteFilter = {
  flags?: InputMaybe<Array<JobLogFlag>>;
  includeSoftDeleted?: InputMaybe<Scalars['Boolean']>;
  scheduleTasks?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveJobLogInput = {
  id?: InputMaybe<Scalars['ID']>;
  logDate?: InputMaybe<Scalars['Date']>;
  projectId?: InputMaybe<Scalars['ID']>;
  minTemperature?: InputMaybe<Scalars['String']>;
  maxTemperature?: InputMaybe<Scalars['String']>;
  humidity?: InputMaybe<Scalars['String']>;
  wind?: InputMaybe<Scalars['String']>;
  weatherType?: InputMaybe<WeatherType>;
};

export type SaveJobLogResult = {
  __typename?: 'SaveJobLogResult';
  jobLog: JobLog;
};

export type DuplicateJobLogsInput = {
  jobLogId: Scalars['ID'];
  projectIds: Array<Scalars['ID']>;
  targetDates?: InputMaybe<Array<Scalars['Date']>>;
};

export type DuplicateJobLogsResult = {
  __typename?: 'DuplicateJobLogsResult';
  jobLog: JobLog;
  clonedJobLogs: Array<JobLog>;
  copiedJobLogs: Array<JobLog>;
};

export type JobLogImageFilter = {
  project?: InputMaybe<Array<Scalars['ID']>>;
};

export type JobLogImageOrder = {
  jobLogDate?: InputMaybe<Order>;
};

export type JobLogOrder = {
  id?: InputMaybe<Order>;
  logDate?: InputMaybe<Order>;
};

export type JobLogsPageResult = {
  __typename?: 'JobLogsPageResult';
  entities: Array<JobLog>;
  pageInfo: PageInfo;
  logDates: Array<Scalars['Date']>;
};

export type JobLogImage = Entity & {
  __typename?: 'JobLogImage';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  asset: Asset;
  jobLog: JobLog;
  parent?: Maybe<JobLogImageParent>;
  sightlineJobId?: Maybe<Scalars['String']>;
  sightlineUrl?: Maybe<Scalars['String']>;
  sightlineFrameId?: Maybe<Scalars['String']>;
};

export type SaveJobLogImageInput = {
  id?: InputMaybe<Scalars['ID']>;
  asset?: InputMaybe<AssetInput>;
  parentId: Scalars['ID'];
  /** When set (e.g. by iOS), forwarded to field-ai-service as the video pipeline job UUID. */
  sightlineJobId?: InputMaybe<Scalars['String']>;
};

export type DeleteJobLogImageInput = {
  id: Scalars['ID'];
};

export type SaveJobLogImageResult = {
  __typename?: 'SaveJobLogImageResult';
  jobLogImage: JobLogImage;
};

export type DeleteJobLogImageResult = {
  __typename?: 'DeleteJobLogImageResult';
  jobLog: JobLog;
  parent?: Maybe<JobLogImageParent>;
};

export type JobLogImageParent = JobLog | JobLogNote;

export type SaveJobLogNoteInput = {
  id?: InputMaybe<Scalars['ID']>;
  content?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<JobLogNoteType>;
  internalUserId?: InputMaybe<Scalars['ID']>;
  jobLogId?: InputMaybe<Scalars['ID']>;
  tradePartnerId?: InputMaybe<Scalars['ID']>;
  flags?: InputMaybe<Array<JobLogFlag>>;
  title?: InputMaybe<Scalars['String']>;
  scheduleTaskIds?: InputMaybe<Array<Scalars['ID']>>;
  clientPlatform?: InputMaybe<ClientPlatform>;
  additionalContext?: InputMaybe<Scalars['JSONObject']>;
};

export type SaveJobLogNoteResult = {
  __typename?: 'SaveJobLogNoteResult';
  jobLogNote: JobLogNote;
};

export type DeleteJobLogNoteInput = {
  id: Scalars['ID'];
};

export type DeleteJobLogNoteResult = {
  __typename?: 'DeleteJobLogNoteResult';
  jobLog: JobLog;
};

export type LienWaiver = {
  __typename?: 'LienWaiver';
  id: Scalars['ID'];
  amountInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  condition: LienWaiverConditionDetail;
  type: LienWaiverTypeDetail;
  pandaDoc?: Maybe<PandaDoc>;
  status: LienWaiverStatusDetail;
  document?: Maybe<Document>;
  parent: LienWaiverParent;
  project: Project;
  throughDate?: Maybe<Scalars['Date']>;
  claimant: LienWaiverClaimant;
  payer: LienWaiverPayer;
  /**  For payers of type Builder, this returns the project's effective company name  */
  payerName: Scalars['String'];
  owner: LienWaiverOwner;
  signatory?: Maybe<LienWaiverSignatory>;
  canCreatePandaDoc: PotentialOperation2;
};

export type SaveLienWaiverInput = {
  id?: InputMaybe<Scalars['ID']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  condition?: InputMaybe<LienWaiverCondition>;
  type?: InputMaybe<LienWaiverType>;
  parentId?: InputMaybe<Scalars['ID']>;
  throughDate?: InputMaybe<Scalars['Date']>;
  claimantId?: InputMaybe<Scalars['ID']>;
};

export type SaveLienWaiverResult = {
  __typename?: 'SaveLienWaiverResult';
  lienWaiver: LienWaiver;
};

export type LienWaiverFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  billId?: InputMaybe<Array<Scalars['ID']>>;
  market?: InputMaybe<Array<Scalars['ID']>>;
  project?: InputMaybe<Array<Scalars['ID']>>;
  tradePartner?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
};

export type LienWaiverOrder = {
  id?: InputMaybe<Order>;
  project?: InputMaybe<Order>;
};

export type LienWaiversPage = {
  __typename?: 'LienWaiversPage';
  entities: Array<LienWaiver>;
  pageInfo: PageInfo;
};

export type LienWaiverParent = StandaloneProject | Region | Bill | Invoice | Market | Community | Subdivision | Lot | Structure | Unit;

export type LienWaiverClaimant = Builder | TradePartner;

export type LienWaiverPayer = Builder | Client;

export type LienWaiverSignatory = InternalUser | TradePartnerContact;

export type LienWaiverOwner = Customer | Client;

export type SaveLocationsInput = {
  locations: Array<LocationInput>;
};

export type DeleteLocationInput = {
  id: Scalars['ID'];
};

export type CreateLocationsFromPathsInput = {
  /**
   * [
   *   'Whole House~First Floor~some location',
   *   'Whole House~Second Floor~some location'
   * ]
   */
  readyPlanId?: InputMaybe<Scalars['ID']>;
  newLocationPaths: Array<Scalars['String']>;
};

export type SaveLocationsResult = {
  __typename?: 'SaveLocationsResult';
  locations: Array<Location>;
};

export type LocationInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<AssetInput>;
  isWholeHouse?: InputMaybe<Scalars['Boolean']>;
  supportsRendering?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<LocationType>;
  readyPlanIds?: InputMaybe<Array<Scalars['ID']>>;
  roomTypeId?: InputMaybe<Scalars['ID']>;
};

export type Location = Entity & Named & {
  __typename?: 'Location';
  id: Scalars['ID'];
  name: Scalars['String'];
  image?: Maybe<Asset>;
  isWholeHouse: Scalars['Boolean'];
  supportsRendering: Scalars['Boolean'];
  code?: Maybe<Scalars['String']>;
  /** Falls back to `name` if `code` is unset */
  effectiveCode: Scalars['String'];
  version: Scalars['Int'];
  type: LocationTypeDetail;
  parent?: Maybe<Location>;
  parents: Array<Location>;
  path?: Maybe<Scalars['String']>;
  pathAsCode?: Maybe<Scalars['String']>;
  pathArray: Array<Scalars['String']>;
  pathIds: Array<Scalars['Int']>;
  group?: Maybe<Location>;
  level?: Maybe<Location>;
  room?: Maybe<Location>;
  displayLocationPath: Scalars['String'];
  locations: Array<Location>;
  feature?: Maybe<Location>;
  /**
   *  The first non-scope location.
   * @deprecated Use nonScopeLocation instead
   */
  effectiveLocation: Location;
  /**
   * For scope locations like `g:WH~r:Kitchen 101~f:Island~s:Top Drawer~s:Knob`,
   * returns the first non-scope location, i.e. Island.
   *
   * Fallbacks to itself if no non-scope parent location is found.
   */
  nonScopeLocation: Location;
  /**
   * There is only one non-structural location, and it is used to assign items that are non-structural like Miscellaneous/OH&P/Contingency.
   * This is always included in the locations query when effectiveLocations is true.
   */
  isNonStructural?: Maybe<Scalars['Boolean']>;
  /**  For scope locations, the MaterialVariant that is used for this location  */
  materialVariant?: Maybe<MaterialVariant>;
  isModifiedRoom: Scalars['Boolean'];
  roomType?: Maybe<RoomType>;
  featureType?: Maybe<FeatureType>;
};

export type LocationFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
};

export type LocationsFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  supportsRendering?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Array<Scalars['Int']>>;
  /** @deprecated tli-cutover: Use rpav instead */
  itemTemplate?: InputMaybe<Array<Scalars['ID']>>;
  rpav?: InputMaybe<Array<Scalars['ID']>>;
  parent?: InputMaybe<Array<Scalars['ID']>>;
  scope?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<LocationType>>;
  roomType?: InputMaybe<Array<Scalars['ID']>>;
  project?: InputMaybe<Array<Scalars['ID']>>;
  isNonStructural?: InputMaybe<Scalars['Boolean']>;
};

export type LocationOrderBy = {
  name?: InputMaybe<Order>;
  path?: InputMaybe<Order>;
  code?: InputMaybe<Order>;
};

export type SaveLotInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  buildAddress?: InputMaybe<AddressInput>;
  /**  Only used for creating the Project.  */
  client?: InputMaybe<ClientInput>;
  /**  Add's a new coverImage to a project.  */
  coverImage?: InputMaybe<AssetInput>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ProjectStatus>;
  /**  Only used for creating the Project.  */
  startDate?: InputMaybe<Scalars['Date']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']>;
  planRoomLink?: InputMaybe<Scalars['String']>;
  salesforceAccountId?: InputMaybe<Scalars['String']>;
  projectStatusChange?: InputMaybe<ProjectStatusChangeInput>;
  isDisaster?: InputMaybe<Scalars['Boolean']>;
  intakeStyleNotes?: InputMaybe<Scalars['String']>;
  lotType?: InputMaybe<LotType>;
  productTypeId?: InputMaybe<Scalars['ID']>;
  projectRoles?: InputMaybe<Array<UpdateProjectRoleInput>>;
  salesforcePropertyId?: InputMaybe<Scalars['String']>;
  scopeMode?: InputMaybe<ScopeMode>;
  lotPartitionId?: InputMaybe<Scalars['String']>;
  warrantyStartDate?: InputMaybe<Scalars['Date']>;
  checkoutCustomerConfigId?: InputMaybe<Scalars['String']>;
  directCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']>;
  indirectCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']>;
  customerId?: InputMaybe<Scalars['ID']>;
  customerOwnerEntityId?: InputMaybe<Scalars['ID']>;
  builderId?: InputMaybe<Scalars['ID']>;
  legalDescription?: InputMaybe<Scalars['String']>;
  salesTaxOverrideInBasisPoints?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['ID']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyLicenseNumber?: InputMaybe<Scalars['String']>;
  invoicePaymentNetDays?: InputMaybe<Scalars['Int']>;
  buildablePlanIds?: InputMaybe<Array<Scalars['ID']>>;
  landPriceInCents?: InputMaybe<Scalars['Int']>;
};

export type SaveLotResult = {
  __typename?: 'SaveLotResult';
  lot: Lot;
};

export type SaveBuildablePlanIncrementalInput = {
  id: Scalars['ID'];
  op: IncrementalCollectionOp;
};

export type LotRating = {
  __typename?: 'LotRating';
  id: Scalars['ID'];
  grade: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  projects: Array<StandaloneProject>;
};

export type SaveLotRatingInput = {
  id?: InputMaybe<Scalars['ID']>;
  grade?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
};

export type SaveLotRatingResult = {
  __typename?: 'SaveLotRatingResult';
  lotRating: LotRating;
};

export type SaveMarketResult = {
  __typename?: 'SaveMarketResult';
  market: Market;
};

export type SaveMarketInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  buildAddress?: InputMaybe<AddressInput>;
  /**  Only used for creating the Project.  */
  client?: InputMaybe<ClientInput>;
  /**  Add's a new coverImage to a project.  */
  coverImage?: InputMaybe<AssetInput>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ProjectStatus>;
  /**  Only used for creating the Project.  */
  startDate?: InputMaybe<Scalars['Date']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']>;
  planRoomLink?: InputMaybe<Scalars['String']>;
  salesforceAccountId?: InputMaybe<Scalars['String']>;
  projectStatusChange?: InputMaybe<ProjectStatusChangeInput>;
  isDisaster?: InputMaybe<Scalars['Boolean']>;
  intakeStyleNotes?: InputMaybe<Scalars['String']>;
  lotType?: InputMaybe<LotType>;
  productTypeId?: InputMaybe<Scalars['ID']>;
  projectRoles?: InputMaybe<Array<UpdateProjectRoleInput>>;
  salesforcePropertyId?: InputMaybe<Scalars['String']>;
  scopeMode?: InputMaybe<ScopeMode>;
  lotPartitionId?: InputMaybe<Scalars['String']>;
  warrantyStartDate?: InputMaybe<Scalars['Date']>;
  checkoutCustomerConfigId?: InputMaybe<Scalars['String']>;
  directCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']>;
  indirectCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']>;
  customerId?: InputMaybe<Scalars['ID']>;
  customerOwnerEntityId?: InputMaybe<Scalars['ID']>;
  builderId?: InputMaybe<Scalars['ID']>;
  legalDescription?: InputMaybe<Scalars['String']>;
  salesTaxOverrideInBasisPoints?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['ID']>;
  abbreviation?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  salesforceMarketCode?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
  msaName?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyLicenseNumber?: InputMaybe<Scalars['String']>;
  invoicePaymentNetDays?: InputMaybe<Scalars['Int']>;
};

export type MaterialAssemblyComponent = {
  __typename?: 'MaterialAssemblyComponent';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  assembly: MaterialVariant;
  component: MaterialVariant;
  name?: Maybe<Scalars['String']>;
  qualifier?: Maybe<Scalars['String']>;
};

export type SaveMaterialAssemblyComponentInput = {
  id?: InputMaybe<Scalars['ID']>;
  assemblyId?: InputMaybe<Scalars['ID']>;
  componentId?: InputMaybe<Scalars['ID']>;
  qualifier?: InputMaybe<Scalars['String']>;
};

export type SaveMaterialAssemblyComponentResult = {
  __typename?: 'SaveMaterialAssemblyComponentResult';
  materialAssemblyComponent: MaterialAssemblyComponent;
};

export type MaterialAttributeDimension = {
  __typename?: 'MaterialAttributeDimension';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  item: Item;
  values: Array<MaterialAttributeValue>;
  isAdminManaged: Scalars['Boolean'];
  unitOfMeasure?: Maybe<UnitOfMeasure>;
  sortOrder: Scalars['Int'];
  type: MaterialAttributeDimensionTypeDetail;
  useInTakeoff: Scalars['Boolean'];
  useInVisualModePdf: Scalars['Boolean'];
  showInFinishSchedule: Scalars['Boolean'];
  showInCabinetsInfo: Scalars['Boolean'];
  copiedFromChildModifier?: Maybe<MaterialAttributeDimension>;
  isDeprecated: Scalars['Boolean'];
};

export type SaveMaterialAttributeDimensionValueInput = {
  id?: InputMaybe<Scalars['ID']>;
  code?: InputMaybe<Scalars['String']>;
  textValue?: InputMaybe<Scalars['String']>;
  op: IncrementalCollectionOp;
};

export type SaveMaterialAttributeDimensionResult = {
  __typename?: 'SaveMaterialAttributeDimensionResult';
  materialAttributeDimension: MaterialAttributeDimension;
};

export type SaveMaterialAttributeDimensionResults = {
  __typename?: 'SaveMaterialAttributeDimensionResults';
  materialAttributeDimensions: Array<MaterialAttributeDimension>;
};

export type MaterialAttributeDimensionFilter = {
  itemId?: InputMaybe<Scalars['String']>;
  useInTakeoff?: InputMaybe<Scalars['Boolean']>;
};

export type SaveMaterialAttributeDimensionInput = {
  isDeprecated?: InputMaybe<Scalars['Boolean']>;
};

export type MaterialAttributeValue = {
  __typename?: 'MaterialAttributeValue';
  id: Scalars['ID'];
  /** @deprecated use `textValue` */
  value: Scalars['String'];
  /**
   * The `value` is stored and returned as a string to ensure the UI displays it exactly as entered.
   * A hook evaluates the value to determine if it represents a number or a range.
   */
  textValue: Scalars['String'];
  valueWithUom: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  dimension: MaterialAttributeDimension;
  materialVariants: Array<MaterialVariant>;
  code?: Maybe<Scalars['String']>;
  type: MaterialAttributeValueTypeDetail;
  min?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
};

export type SaveMaterialAttributeValueInput = {
  id?: InputMaybe<Scalars['ID']>;
  textValue?: InputMaybe<Scalars['String']>;
  dimensionId?: InputMaybe<Scalars['ID']>;
  code?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<MaterialAttributeValueType>;
  min?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['Int']>;
};

export type SaveMaterialAttributeValueResult = {
  __typename?: 'SaveMaterialAttributeValueResult';
  materialAttributeValue: MaterialAttributeValue;
};

export type BackfillResponse = {
  __typename?: 'BackfillResponse';
  processed: Scalars['Int'];
  skipped: Scalars['Int'];
};

export type MaterialBrandFilter = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  abbreviation?: InputMaybe<Scalars['String']>;
};

export type MaterialBrand = {
  __typename?: 'MaterialBrand';
  id: Scalars['ID'];
  name: Scalars['String'];
  abbreviation?: Maybe<Scalars['String']>;
  shortName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  materialListings: Array<MaterialListing>;
};

export type SaveMaterialBrandInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  abbreviation?: InputMaybe<Scalars['String']>;
};

export type SaveMaterialBrandResult = {
  __typename?: 'SaveMaterialBrandResult';
  materialBrand: MaterialBrand;
};

export type MaterialLeadTimeConfig = {
  __typename?: 'MaterialLeadTimeConfig';
  id: Scalars['ID'];
  minLeadTimeInDays: Scalars['Int'];
  expectedLeadTimeInDays: Scalars['Int'];
  maxLeadTimeInDays: Scalars['Int'];
  reasonNote?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  variants: Array<MaterialLeadTimeConfigVariant>;
  parent?: Maybe<MaterialLeadTimeConfigParent>;
};

export type SaveMaterialLeadTimeConfigInput = {
  id?: InputMaybe<Scalars['ID']>;
  minLeadTimeInDays?: InputMaybe<Scalars['Int']>;
  expectedLeadTimeInDays?: InputMaybe<Scalars['Int']>;
  maxLeadTimeInDays?: InputMaybe<Scalars['Int']>;
  reasonNote?: InputMaybe<Scalars['String']>;
  variants?: InputMaybe<Array<SaveMaterialLeadTimeConfigVariantIncrementalInput>>;
  parentId?: InputMaybe<Scalars['ID']>;
};

export type SavePersonalizationMaterialLeadTimeConfigInput = {
  id?: InputMaybe<Scalars['ID']>;
  minLeadTimeInDays?: InputMaybe<Scalars['Int']>;
  expectedLeadTimeInDays?: InputMaybe<Scalars['Int']>;
  maxLeadTimeInDays?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['ID']>;
  reasonNote?: InputMaybe<Scalars['String']>;
  variants?: InputMaybe<Array<SaveMaterialLeadTimeConfigVariantIncrementalInput>>;
  delete?: InputMaybe<Scalars['Boolean']>;
};

export type SaveMaterialLeadTimeConfigResult = {
  __typename?: 'SaveMaterialLeadTimeConfigResult';
  materialLeadTimeConfig: MaterialLeadTimeConfig;
};

export type MaterialLeadTimeConfigParent = CostCode | Item | MaterialListing;

export type HasMaterialLeadTimeConfigData = {
  minLeadTimeInDays: Scalars['Int'];
  expectedLeadTimeInDays: Scalars['Int'];
  maxLeadTimeInDays: Scalars['Int'];
};

export type MaterialLeadTimeConfigVariant = {
  __typename?: 'MaterialLeadTimeConfigVariant';
  id: Scalars['ID'];
  minLeadTimeInDays?: Maybe<Scalars['Int']>;
  expectedLeadTimeInDays?: Maybe<Scalars['Int']>;
  maxLeadTimeInDays?: Maybe<Scalars['Int']>;
  reasonNote?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  market?: Maybe<Market>;
  materialLeadTimeConfig: MaterialLeadTimeConfig;
};

export type SaveMaterialLeadTimeConfigVariantIncrementalInput = {
  op: IncrementalCollectionOp;
  id?: InputMaybe<Scalars['ID']>;
  minLeadTimeInDays?: InputMaybe<Scalars['Int']>;
  expectedLeadTimeInDays?: InputMaybe<Scalars['Int']>;
  maxLeadTimeInDays?: InputMaybe<Scalars['Int']>;
  reasonNote?: InputMaybe<Scalars['String']>;
  marketId?: InputMaybe<Scalars['ID']>;
  materialLeadTimeConfigId?: InputMaybe<Scalars['ID']>;
};

export type MaterialListing = HasOptionPricingData & HasMaterialLeadTimeConfigData & {
  __typename?: 'MaterialListing';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  item: Item;
  brand?: Maybe<MaterialBrand>;
  materialVariants: Array<MaterialVariant>;
  type: MaterialTypeDetail;
  /** @deprecated Use materialVariants.manufacturerUrl instead - returns the first variant's manufacturerUrl for compatibility with the old UI  */
  manufacturerUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  canEditItem: PotentialOperation2;
  optionPricingConfig?: Maybe<OptionPricingConfig>;
  /**  The pre-cutoff desired margin in basis points for this Material Listing, either defined directly by an OptionPricingConfig or falling back to a default value as set on its Item.  */
  preCutoffDesiredMarginInBasisPoints: Scalars['Int'];
  /**  The post-cutoff desired margin in basis points for this Material Listing, either defined directly by an OptionPricingConfig or falling back to a default value as set on its Item.  */
  postCutoffDesiredMarginInBasisPoints?: Maybe<Scalars['Int']>;
  /**  The selection fee this Material Listing, either defined directly by an OptionPricingConfig or falling back to a default value as set on its Item.  */
  selectionFeeInCents?: Maybe<Scalars['Int']>;
  /**  The minimum price in cents for this Material Listing, either defined directly by an OptionPricingConfig or falling back to a default value as set on its Item.  */
  minimumPriceInCents: Scalars['Int'];
  materialLeadTimeConfig?: Maybe<MaterialLeadTimeConfig>;
  /**  The minLeadTimeInDays for this Material Listing, either defined directly by an MaterialLeadTimeConfig or falling back to a default value as set on its Item.  */
  minLeadTimeInDays: Scalars['Int'];
  /**  The expectedLeadTimeInDays for this Material Listing, either defined directly by an MaterialLeadTimeConfig or falling back to a default value as set on its Item.  */
  expectedLeadTimeInDays: Scalars['Int'];
  /**  The maxLeadTimeInDays for this Material Listing, either defined directly by an MaterialLeadTimeConfig or falling back to a default value as set on its Item.  */
  maxLeadTimeInDays: Scalars['Int'];
  history: Array<History>;
  designNote?: Maybe<Scalars['String']>;
};


export type MaterialListingMaterialVariantsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type MaterialListingOrderBy = {
  name?: InputMaybe<Order>;
  updatedAt?: InputMaybe<Order>;
};

export type MaterialListingsFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  itemId?: InputMaybe<Array<Scalars['ID']>>;
  brandId?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<MaterialType>>;
  /**  Matches listings that have at least one variant with any of these attribute values  */
  attributeIds?: InputMaybe<Array<Scalars['ID']>>;
  /**  Matches listings that have at least one variant with an attribute value in any of these dimensions  */
  dimensionIds?: InputMaybe<Array<Scalars['ID']>>;
  /**  Matches listings that have at least one variant with any of these tags  */
  tags?: InputMaybe<Array<Scalars['ID']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type MaterialListingsPage = {
  __typename?: 'MaterialListingsPage';
  entities: Array<MaterialListing>;
  pageInfo: PageInfo;
};

export type SaveMaterialListingInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<MaterialType>;
  description?: InputMaybe<Scalars['String']>;
  /**  @deprecated Use materialVariants.manufacturerUrl instead  */
  manufacturerUrl?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['String']>;
  /**  This list of variants can be partial, FE can only send the variants that changed  */
  variants?: InputMaybe<Array<SaveMaterialListingVariantInput>>;
  optionPricingConfig?: InputMaybe<SavePersonalizationOptionPricingConfigInput>;
  materialLeadTimeConfig?: InputMaybe<SavePersonalizationMaterialLeadTimeConfigInput>;
  designNote?: InputMaybe<Scalars['String']>;
};

export type MigrateMaterialListingItemInput = {
  listingIds: Array<Scalars['ID']>;
  itemId: Scalars['ID'];
};

export type MigrateMaterialListingItemResult = {
  __typename?: 'MigrateMaterialListingItemResult';
  listings: Array<MaterialListing>;
};

export type SaveMaterialListingVariantInput = {
  id?: InputMaybe<Scalars['ID']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  manufacturerUrl?: InputMaybe<Scalars['String']>;
  codeOverride?: InputMaybe<Scalars['String']>;
  designFeedback?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  mavIds?: InputMaybe<Array<Scalars['ID']>>;
  /**  Accepts a list of tag IDs or the tag name, fails if the tag name does not exist  */
  tags?: InputMaybe<Array<Scalars['IdOrName']>>;
  /**  Images must be exhaustive if included  */
  images?: InputMaybe<Array<SaveMaterialVariantImageInput>>;
  /**  Components must be exhaustive if included  */
  components?: InputMaybe<Array<SaveMaterialVariantAssemblyComponentInput>>;
};

export type MergeMaterialListingsInput = {
  targetId: Scalars['ID'];
  sourceIds: Array<Scalars['ID']>;
};

export type MergeMaterialListingsResult = {
  __typename?: 'MergeMaterialListingsResult';
  target: MaterialListing;
};

export type PreviewMaterialVariantDisplayNameInput = {
  /** The listing whose name (and item materialNameFormat) drive the display name. */
  listingId: Scalars['ID'];
  /** The model number / SKU to use when materialNameFormat includes {modelNumber}. */
  modelNumber?: InputMaybe<Scalars['String']>;
  /** Exhaustive MAV ids for the previewed material. An empty list means no attributes. */
  mavIds: Array<Scalars['ID']>;
};

export type UploadMaterialVariantsInput = {
  dryRun?: InputMaybe<Scalars['Boolean']>;
  /**
   * Accepts a list of tag IDs or the tag name, creating the tag if needed
   * These tags will be applied to all MaterialVariants created from the uploaded data
   * Additional tags can be specified in the individual MaterialVariant inputs in the data array
   */
  tags?: InputMaybe<Array<Scalars['IdOrName']>>;
  data: Array<Scalars['JSONObject']>;
};

export type UploadMaterialVariantsResult = {
  __typename?: 'UploadMaterialVariantsResult';
  results: Array<UploadMaterialVariantResult>;
};

export type UploadMaterialVariantResult = {
  __typename?: 'UploadMaterialVariantResult';
  /**  Original data that was uploaded  */
  data: Scalars['JSONObject'];
  /**  Indicates whether the MaterialVariant was created or updated  */
  operation: Scalars['String'];
  /**  The MaterialVariant that was created or updated  */
  newMaterialVariant?: Maybe<MaterialVariant>;
  /**  The MaterialVariant that was updated  */
  updatedMaterialVariant?: Maybe<MaterialVariant>;
};

export type MergeMaterialVariantsInput = {
  /**  Material variants to merge. The survivor is chosen among those on selections.listingId.  */
  materialVariantIds: Array<Scalars['ID']>;
  /**  The values to keep on the surviving material variant.  */
  selections: MergeMaterialVariantSelectionsInput;
  /**
   * Label for how this merge was initiated. Defaults to MANUAL when omitted; callers should
   * pass whatever identifies their path.
   */
  source?: InputMaybe<Scalars['String']>;
};

export type MergeMaterialVariantSelectionsInput = {
  /**
   * The listing the surviving material variant must use.
   * Must belong to one of the material variants being merged. The winner is chosen among variants on this listing.
   */
  listingId: Scalars['ID'];
  /**
   * The brand to set on the surviving listing.
   * Omit or null to clear the brand.
   */
  brandId?: InputMaybe<Scalars['ID']>;
  /**  The model number / SKU to keep on the survivor. Omit or null to clear.  */
  modelNumber?: InputMaybe<Scalars['String']>;
  /**  The manufacturer website URL to keep on the survivor. Omit or null to clear.  */
  manufacturerUrl?: InputMaybe<Scalars['String']>;
  /**
   * The image to show as featured after the merge.
   * All images are preserved; this image is moved to the front of their sort order.
   * Must belong to one of the material variants being merged.
   * Omit when none of the variants have images.
   */
  featuredImageId?: InputMaybe<Scalars['ID']>;
  /**
   * The exhaustive final MAV collection for the winner.
   * MAVs may already be on any variant or may be unused, but their dimensions must belong to the shared item.
   * Only one MAV per dimension is allowed. An empty list removes all MAVs.
   */
  mavIds: Array<Scalars['ID']>;
};

export type MergeMaterialVariantsResult = {
  __typename?: 'MergeMaterialVariantsResult';
  trackedJob: TrackedJob;
};

export type MaterialVariant = HasBlueprintUrl & {
  __typename?: 'MaterialVariant';
  id: Scalars['ID'];
  code: Scalars['String'];
  displayName: Scalars['String'];
  modelNumber?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  listing: MaterialListing;
  materialAttributeValues: Array<MaterialAttributeValue>;
  bidItems: Array<BidItem>;
  codeOverride?: Maybe<Scalars['String']>;
  defaultBidItem: BidItem;
  featuredImage?: Maybe<MaterialVariantImage>;
  images: Array<MaterialVariantImage>;
  components: Array<MaterialAssemblyComponent>;
  componentOf: Array<MaterialAssemblyComponent>;
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  /**  For placeholders, the current MADs + any additional Item.mads that are have useInTakeoff set.  */
  effectiveMADs: Array<MaterialAttributeDimension>;
  designFeedback?: Maybe<Scalars['String']>;
  minCostInMills?: Maybe<Scalars['Int']>;
  maxCostInMills?: Maybe<Scalars['Int']>;
  canEdit: PotentialOperation2;
  tags: Array<MaterialVariantTag>;
  manufacturerUrl?: Maybe<Scalars['String']>;
  blueprintUrl: Url;
  sources: Array<MaterialVariant>;
  /**  Unique ReadyPlans whose takeoffs reference this material variant.  */
  takeoffUsages: Array<ReadyPlanLike>;
  /**
   * Whether this material product satisfies the material attribute requirements of `projectItemId`'s placeholder.
   * Always true when the scope isn't anchored on a Placeholder material, since a one-off SKU requires nothing.
   */
  matchesPlaceholder: Scalars['Boolean'];
  /**
   * Whether this material product has an awarded cost in `projectItemId`'s market. True for plan-based
   * scope, where there is no unit bid to resolve and the cost lives in a holding cost line.
   */
  hasAwardedCost: Scalars['Boolean'];
  /**
   * Variants that were merged away into this one. Includes indirect merges: because the underlying `winner_id` FK
   * is repointed when a winner is itself merged away, this returns the whole transitive set. Compare each row's
   * `mergedIntoId` to this variant's id to tell direct merges from ones that arrived via a chain.
   */
  merges: Array<MaterialVariantMerge>;
};


export type MaterialVariantMatchesPlaceholderArgs = {
  projectItemId: Scalars['ID'];
};


export type MaterialVariantHasAwardedCostArgs = {
  projectItemId: Scalars['ID'];
};

export type SaveMaterialVariantInput = {
  id?: InputMaybe<Scalars['ID']>;
  materialName?: InputMaybe<Scalars['String']>;
  manufacturerUrl?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<MaterialType>;
  codeOverride?: InputMaybe<Scalars['String']>;
  mavIds?: InputMaybe<Array<Scalars['ID']>>;
  images?: InputMaybe<Array<SaveMaterialVariantImageInput>>;
  components?: InputMaybe<Array<SaveMaterialVariantAssemblyComponentInput>>;
  designFeedback?: InputMaybe<Scalars['String']>;
  /**  Accepts a list of tag IDs or the tag name, creating the tag if needed  */
  tags?: InputMaybe<Array<Scalars['IdOrName']>>;
};

export type SaveMaterialVariantAssemblyComponentInput = {
  id?: InputMaybe<Scalars['ID']>;
  assemblyId?: InputMaybe<Scalars['ID']>;
  componentId?: InputMaybe<Scalars['ID']>;
  componentItemId?: InputMaybe<Scalars['ID']>;
  componentValues?: InputMaybe<Array<Scalars['ID']>>;
  qualifier?: InputMaybe<Scalars['String']>;
};

export type SaveMaterialVariantImageInput = {
  id?: InputMaybe<Scalars['ID']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  asset?: InputMaybe<AssetInput>;
};

export type SaveMaterialVariantResult = {
  __typename?: 'SaveMaterialVariantResult';
  materialVariant: MaterialVariant;
};

export type MaterialCostSourceOrderBy = {
  createdAt?: InputMaybe<Order>;
};

export type MaterialVariantOrderBy = {
  lastUsedAt?: InputMaybe<Order>;
};

export type MaterialVariantsFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  itemId?: InputMaybe<Array<Scalars['ID']>>;
  brandId?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  isMergedAssembly?: InputMaybe<Scalars['Boolean']>;
  attributeIds?: InputMaybe<Array<Scalars['ID']>>;
  dimensionIds?: InputMaybe<Array<Scalars['ID']>>;
  /**  Filter for materials that are included as-of the PP/DP/POF version `rpavId`.  */
  rpavId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<Array<MaterialType>>;
  code?: InputMaybe<Array<Scalars['String']>>;
  /**  Accepts a list of tag IDs or the tag name, fails if the tag name does not exist  */
  tags?: InputMaybe<Array<Scalars['IdOrName']>>;
};

export type MaterialVariantsForPlaceholderTliFilter = {
  takeoffLineItemId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  attributeIds?: InputMaybe<Array<Scalars['ID']>>;
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type MaterialVariantsForPlaceholderFilter = {
  /**  Either a TLI or a PI is required.  */
  takeoffLineItemId?: InputMaybe<Scalars['ID']>;
  projectItemId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  attributeIds?: InputMaybe<Array<Scalars['ID']>>;
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  /**  Exclude the current material variant from the results.  */
  excludeCurrent?: InputMaybe<Scalars['Boolean']>;
  /**  When provided with `projectItemId`, returns MVs that have either unit-based or plan-based v2 bids in the project's market.  */
  hasBids?: InputMaybe<Scalars['Boolean']>;
};

export type MaterialCostSource = BidItemEstimate | BidContractLineItem;

export type MaterialVariantsPage = {
  __typename?: 'MaterialVariantsPage';
  entities: Array<MaterialVariant>;
  pageInfo: PageInfo;
};

export type MaterialVariantCostSourcesPage = {
  __typename?: 'MaterialVariantCostSourcesPage';
  entities: Array<MaterialCostSource>;
  pageInfo: PageInfo;
};

export type MaterialVariantImage = {
  __typename?: 'MaterialVariantImage';
  id: Scalars['ID'];
  sortOrder: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  variant: MaterialVariant;
  asset?: Maybe<Asset>;
};

export type MaterialVariantMergesPage = {
  __typename?: 'MaterialVariantMergesPage';
  entities: Array<MaterialVariantMerge>;
  pageInfo: PageInfo;
};

/**
 * One row per material variant that was merged away, written by every path that merges MVs.
 *
 * The merged-away variant is hard-deleted by the merge, so its identity is denormalized here — there is no live
 * entity left to load. History starts from when this table shipped; merges before that are unrecoverable, and a
 * row is deleted if its whole lineage is later hard-deleted.
 *
 * Note there is deliberately no `saveMaterialVariantMerge`: this history is append-only and written only by the
 * merge paths themselves.
 */
export type MaterialVariantMerge = {
  __typename?: 'MaterialVariantMerge';
  id: Scalars['ID'];
  /**
   * Tagged id of the variant this one was merged into *at the time of the merge*. Differs from `winner.id` when
   * that variant was itself later merged away. Use `winner` to resolve a stale id; use this to read true lineage.
   */
  mergedIntoId: Scalars['String'];
  /**  Tagged id of the merged-away variant. No longer resolvable via `materialVariant(id)`.  */
  mergedFromId: Scalars['String'];
  /**  The merged-away variant's code, snapshotted before it was deleted.  */
  mergedFromCode: Scalars['String'];
  /**  The merged-away variant's display name, snapshotted before it was deleted.  */
  mergedFromDisplayName: Scalars['String'];
  /**  Tagged id of the merged-away variant's listing, which may itself have been deleted by the merge.  */
  mergedFromListingId: Scalars['String'];
  mergedFromListingName: Scalars['String'];
  /**  When this merge happened. For a collapsed row this is still the *original* merge's time.  */
  createdAt: Scalars['DateTime'];
  /**  Bumps when `winner` is repointed by a later merge in the same chain.  */
  updatedAt: Scalars['DateTime'];
  /**  Label for how the merge was initiated  */
  source: Scalars['String'];
  /**
   * The surviving variant. Follows merge chains: always the current survivor, never an intermediate, so resolving
   * a stale id never requires walking more than one hop.
   */
  winner: MaterialVariant;
  /**  Null for automated merges (the code-recalc job and assembly rebuilds).  */
  mergedBy?: Maybe<User>;
};

export type MaterialVariantMergeFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  mergedIntoId?: InputMaybe<Array<Scalars['String']>>;
  mergedFromId?: InputMaybe<Array<Scalars['String']>>;
  mergedFromCode?: InputMaybe<Array<Scalars['String']>>;
  mergedFromDisplayName?: InputMaybe<Array<Scalars['String']>>;
  mergedFromListingId?: InputMaybe<Array<Scalars['String']>>;
  mergedFromListingName?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt?: InputMaybe<Array<Scalars['DateTime']>>;
  source?: InputMaybe<Array<Scalars['String']>>;
  winnerId?: InputMaybe<Array<Scalars['ID']>>;
  mergedById?: InputMaybe<Array<Scalars['ID']>>;
};

export type MaterialVariantTag = Named & {
  __typename?: 'MaterialVariantTag';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  materialVariants: Array<MaterialVariant>;
};

export type SaveMaterialVariantTagInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type SaveMaterialVariantTagResult = {
  __typename?: 'SaveMaterialVariantTagResult';
  materialVariantTag: MaterialVariantTag;
};

export type MermaidResult = {
  __typename?: 'MermaidResult';
  url: Scalars['String'];
  code: Scalars['String'];
};

export type MermaidInput = {
  id: Array<Scalars['ID']>;
  graph: Scalars['JSONObject'];
};

export type MobileSyncUpdatesInput = {
  projectIds: Array<Scalars['ID']>;
  /** Fetch updates created after this timestamp. */
  since?: InputMaybe<Scalars['DateTime']>;
};

export type MobileSyncUpdatesPageResult = {
  __typename?: 'MobileSyncUpdatesPageResult';
  entities: Array<MobileSyncUpdate>;
  pageInfo: PageInfo;
};

export type MobileSyncUpdate = Entity & {
  __typename?: 'MobileSyncUpdate';
  id: Scalars['ID'];
  type: MobileSyncUpdateType;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The tagged Joist ID of the entity (e.g. jl:123). Always present, even for deletes. */
  entityId: Scalars['String'];
  /** The resolved entity. Null if the entity has been deleted. */
  entity?: Maybe<Entity>;
  project: Project;
};

export type OptionPricingConfig = {
  __typename?: 'OptionPricingConfig';
  id: Scalars['ID'];
  selectionFeeInCents?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  variants: Array<OptionPricingConfigVariant>;
  parent?: Maybe<OptionPricingConfigParent>;
  preCutoffDesiredMarginInBasisPoints: Scalars['Int'];
  postCutoffDesiredMarginInBasisPoints?: Maybe<Scalars['Int']>;
  reasonNote?: Maybe<Scalars['String']>;
  minimumPriceInCents: Scalars['Int'];
};

export type SaveOptionPricingConfigsInput = {
  optionPricingConfigs: Array<SaveOptionPricingConfigInput>;
};

export type SaveOptionPricingConfigInput = {
  id?: InputMaybe<Scalars['ID']>;
  preCutoffDesiredMarginInBasisPoints?: InputMaybe<Scalars['Int']>;
  postCutoffDesiredMarginInBasisPoints?: InputMaybe<Scalars['Int']>;
  selectionFeeInCents?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['ID']>;
  variants?: InputMaybe<Array<SaveOptionPricingConfigVariantIncrementalInput>>;
  reasonNote?: InputMaybe<Scalars['String']>;
  minimumPriceInCents?: InputMaybe<Scalars['Int']>;
};

/**  OptionPricingConfigs saved on MaterialListings, Items, and CostCodes should not have OptionPricingConfigVariants.  */
export type SavePersonalizationOptionPricingConfigInput = {
  id?: InputMaybe<Scalars['ID']>;
  preCutoffDesiredMarginInBasisPoints?: InputMaybe<Scalars['Int']>;
  postCutoffDesiredMarginInBasisPoints?: InputMaybe<Scalars['Int']>;
  selectionFeeInCents?: InputMaybe<Scalars['Int']>;
  minimumPriceInCents?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['ID']>;
  reasonNote?: InputMaybe<Scalars['String']>;
};

export type SaveOptionPricingConfigsResult = {
  __typename?: 'SaveOptionPricingConfigsResult';
  optionPricingConfigs: Array<OptionPricingConfig>;
};

export type DeleteOptionPricingConfigInput = {
  id: Scalars['ID'];
};

export type OptionPricingConfigParent = CostCode | GlobalOption | Item | MaterialListing;

export type HasOptionPricingData = {
  preCutoffDesiredMarginInBasisPoints: Scalars['Int'];
  postCutoffDesiredMarginInBasisPoints?: Maybe<Scalars['Int']>;
  selectionFeeInCents?: Maybe<Scalars['Int']>;
  minimumPriceInCents: Scalars['Int'];
};

export type OptionPricingConfigVariant = {
  __typename?: 'OptionPricingConfigVariant';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  optionPricingConfig: OptionPricingConfig;
  preCutoffDesiredMarginInBasisPoints: Scalars['Int'];
  postCutoffDesiredMarginInBasisPoints?: Maybe<Scalars['Int']>;
  selectionFeeInCents?: Maybe<Scalars['Int']>;
  reasonNote?: Maybe<Scalars['String']>;
  projects: Array<Project>;
  minimumPriceInCents?: Maybe<Scalars['Int']>;
};

export type SaveOptionPricingConfigVariantIncrementalInput = {
  op: IncrementalCollectionOp;
  id?: InputMaybe<Scalars['ID']>;
  optionPricingConfigId?: InputMaybe<Scalars['ID']>;
  preCutoffDesiredMarginInBasisPoints?: InputMaybe<Scalars['Int']>;
  postCutoffDesiredMarginInBasisPoints?: InputMaybe<Scalars['Int']>;
  selectionFeeInCents?: InputMaybe<Scalars['Int']>;
  minimumPriceInCents?: InputMaybe<Scalars['Int']>;
  reasonNote?: InputMaybe<Scalars['String']>;
  projectIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Pagination info. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /**  Soft-deprecated b/c the caller should use their current page + totalCount to know hasNextPage.  */
  hasNextPage: Scalars['Boolean'];
  /**  The total number of rows available for this query.  */
  totalCount: Scalars['Int'];
  /**  The next page to query, unless this is the last page.  */
  nextPage?: Maybe<Page>;
};

/** A generic `page: Page` argument for paginated queries to return as "the next page". */
export type Page = {
  __typename?: 'Page';
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

/** A generic `page: PageFilter` argument for paginated queries to use. */
export type PageFilter = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PandaDocSession = {
  __typename?: 'PandaDocSession';
  sessionId: Scalars['String'];
};

export type PandaDoc = Named & {
  __typename?: 'PandaDoc';
  id: Scalars['ID'];
  name: Scalars['String'];
  externalPandaDocId?: Maybe<Scalars['String']>;
  externalPandaDocUrl?: Maybe<Scalars['String']>;
  status: PandaDocStatus;
  statusDetail: PandaDocStatusDetail;
  recipients: Array<PandaDocRecipient>;
  /** @deprecated replaced by owner */
  commitment?: Maybe<Commitment>;
  /** @deprecated replaced by owner */
  developmentCommitment?: Maybe<DevelopmentCommitment>;
  /** @deprecated replaced by owner */
  commitmentChangeOrder?: Maybe<CommitmentChangeOrder>;
  tags: Array<Scalars['String']>;
  document?: Maybe<Document>;
  owner?: Maybe<PandaDocOwner>;
  externalError?: Maybe<Scalars['String']>;
  canUpload?: Maybe<PotentialOperation2>;
  canCreatePandaDocSession?: Maybe<PotentialOperation2>;
};

export type CreatePandaDocSessionInput = {
  pandaDocId: Scalars['ID'];
};

export type SavePandaDocInput = {
  id?: InputMaybe<Scalars['ID']>;
  externalPandaDocId?: InputMaybe<Scalars['String']>;
  externalPandaDocStatus?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PandaDocStatus>;
  ownerId?: InputMaybe<Scalars['ID']>;
  /** @deprecated replaced by ownerId */
  developmentCommitmentId?: InputMaybe<Scalars['ID']>;
  /** @deprecated replaced by ownerId */
  commitmentChangeOrderId?: InputMaybe<Scalars['ID']>;
  /** @deprecated replaced by ownerId */
  commitmentId?: InputMaybe<Scalars['ID']>;
  externalError?: InputMaybe<Scalars['String']>;
};

export type DeletePandaDocInput = {
  id: Scalars['ID'];
};

export type UploadPandaDocInput = {
  id: Scalars['ID'];
};

export type HandlePandaDocWebhookInput = {
  items: Array<PandaDocWebhookItem>;
};

export type PandaDocWebhookItem = {
  id: Scalars['ID'];
  event: PandaDocWebhookEvent;
};

/**  see: https://developers.pandadoc.com/reference/on-document-status-change  */
export enum PandaDocWebhookEvent {
  DocumentStateChanged = 'document_state_changed',
  DocumentUpdated = 'document_updated',
  RecipientCompleted = 'recipient_completed',
  DocumentDeleted = 'document_deleted',
  DocumentCreationFailed = 'document_creation_failed'
}

export type SavePandaDocResult = {
  __typename?: 'SavePandaDocResult';
  pandaDoc: PandaDoc;
};

export type DeletePandaDocResult = {
  __typename?: 'DeletePandaDocResult';
  owner: PandaDocOwner;
};

export type UploadPandaDocResult = {
  __typename?: 'UploadPandaDocResult';
  pandaDoc: PandaDoc;
};

export type PandaDocFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
};

export type PandaDocOwner = BidContractRevision | ChangeEvent | Commitment | CommitmentChangeOrder | DevelopmentCommitment | Invoice | LienWaiver;

export type HasPandaDoc = {
  id: Scalars['ID'];
  pandaDoc?: Maybe<PandaDoc>;
  document?: Maybe<Document>;
  canCreatePandaDoc: PotentialOperation2;
};

export type PandaDocRecipient = Named & {
  __typename?: 'PandaDocRecipient';
  id: Scalars['ID'];
  name: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  role: PandaDocRole;
  roleDetail: PandaDocRoleDetail;
  pandaDoc: PandaDoc;
  signingOrder?: Maybe<Scalars['Int']>;
  hasCompleted: Scalars['Boolean'];
};

export type PaymentTerm = {
  __typename?: 'PaymentTerm';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  intacctId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  alignWithPaymentCycle: Scalars['Boolean'];
  dueDay: Scalars['Int'];
  dueFrom: PaymentTermDueFromDetail;
};

export type SavePaymentTermInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  alignWithPaymentCycle?: InputMaybe<Scalars['Boolean']>;
  dueDay?: InputMaybe<Scalars['Int']>;
  dueFrom?: InputMaybe<PaymentTermDueFrom>;
};

export type PaymentTermFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
};

export type SavePaymentTermResult = {
  __typename?: 'SavePaymentTermResult';
  paymentTerm: PaymentTerm;
};

/** Current user's permissions for actions on a given entity */
export type Permissions = {
  __typename?: 'Permissions';
  canEdit: Scalars['Boolean'];
  canDelete: Scalars['Boolean'];
};

export type PlanBasedBidContractLineItem = {
  __typename?: 'PlanBasedBidContractLineItem';
  id: Scalars['ID'];
  totalCostInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  revision: BidContractRevision;
  costCode: CostCode;
  groupLine: BidPlanChildGroupLine;
  forCoveringTakeoffs: Scalars['Boolean'];
  isNoCost: Scalars['Boolean'];
};

export type SavePlanBasedBidContractLineItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  totalCostInCents?: InputMaybe<Scalars['Int']>;
  costCodeId?: InputMaybe<Scalars['ID']>;
  groupLineId?: InputMaybe<Scalars['ID']>;
  forCoveringTakeoffs?: InputMaybe<Scalars['Boolean']>;
  isNoCost?: InputMaybe<Scalars['Boolean']>;
};

export type PlanMilestone = Named & {
  __typename?: 'PlanMilestone';
  id: Scalars['ID'];
  name: Scalars['String'];
  estStartDate?: Maybe<Scalars['Date']>;
  estEndDate?: Maybe<Scalars['Date']>;
  totalDays: Scalars['Int'];
  progress: Scalars['Int'];
  confidence: Scalars['Int'];
  durationInDays: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  globalPlanMilestone: GlobalPlanMilestone;
  planSchedule: PlanSchedule;
  allowingPlanTasks: Array<PlanTask>;
  taskStatusRollup: TaskStatusDetail;
  completedAt?: Maybe<Scalars['DateTime']>;
};

export type PlanMilestoneFilter = {
  name?: InputMaybe<Scalars['String']>;
  scheduleParent?: InputMaybe<Array<Scalars['ID']>>;
  startDateRange?: InputMaybe<DateFilter2>;
  endDateRange?: InputMaybe<DateFilter2>;
  team?: InputMaybe<Array<BusinessFunctionType>>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
};

export type PlanMilestoneOrder = {
  estStartDate?: InputMaybe<Order>;
};

export type PlanMilestonesResult = {
  __typename?: 'PlanMilestonesResult';
  entities: Array<PlanMilestone>;
  pageInfo: PageInfo;
};

export type PlanMilestoneSnapshot = {
  __typename?: 'PlanMilestoneSnapshot';
  id: Scalars['ID'];
  range: Scalars['String'];
  estStartDate?: Maybe<Scalars['Date']>;
  estEndDate?: Maybe<Scalars['Date']>;
  durationInDays: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  planMilestone: PlanMilestone;
};

export type PlanMilestoneTarget = {
  __typename?: 'PlanMilestoneTarget';
  id: Scalars['ID'];
  /** Expected *calendar days* from the relevant RTS to milestone completion.  */
  targetDaysFromRts: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  globalPlanMilestone: GlobalPlanMilestone;
  planSchedule: PlanSchedule;
  /** The Community schedule's milestone target this row was based on. Undefined on community schedules and on targets with no community counterpart. */
  communityTarget?: Maybe<PlanMilestoneTarget>;
  /** The plan milestone on this schedule for the same global plan milestone, may be undefined until the schedule has been simulated. */
  planMilestone?: Maybe<PlanMilestone>;
  targetDaysFromRtsSetByUser?: Maybe<Scalars['Boolean']>;
};

export type PlanMilestoneTargetInput = {
  id?: InputMaybe<Scalars['ID']>;
  globalPlanMilestoneId?: InputMaybe<Scalars['ID']>;
  targetDaysFromRts?: InputMaybe<Scalars['Int']>;
  targetDaysFromRtsSetByUser?: InputMaybe<Scalars['Boolean']>;
  op: IncrementalCollectionOp;
};

export type RoomLocationFilter = {
  locationType?: InputMaybe<Array<LocationType>>;
};

export type SavePlanPackageInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  constructionDocumentCompletePercentage?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ReadyPlanStatus>;
  type?: InputMaybe<ReadyPlanType>;
  developmentId?: InputMaybe<Scalars['ID']>;
  /**
   *  Deprecated - prefer programDatas - Remove in SC-57703
   * @deprecated Use programDatas instead
   */
  programData?: InputMaybe<SaveProgramDataInput>;
  programDatas?: InputMaybe<Array<SaveReadyPlanProgramDataInput>>;
  lotTypes?: InputMaybe<Array<LotType>>;
  assets?: InputMaybe<Array<SaveReadyPlanAssetInput>>;
  markets?: InputMaybe<Array<Scalars['ID']>>;
  contingencyMarkupPercentage?: InputMaybe<Scalars['Float']>;
  options?: InputMaybe<Array<SaveReadyPlanOptionInput>>;
  insideMapsProjectId?: InputMaybe<Scalars['String']>;
  insideMapsConfig?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['ID']>;
  proposals?: InputMaybe<Array<ResolveAiFieldProposalInput>>;
};

export type CopyPlanPackageInput = {
  sourcePackageId: Scalars['ID'];
  sourcePackageVersionId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  code: Scalars['String'];
};

export type SavePlanPackageResult = {
  __typename?: 'SavePlanPackageResult';
  planPackage: PlanPackage;
};

export type PlanPackageFilter = {
  status?: InputMaybe<Array<ReadyPlanStatus>>;
  /**  The latest status based on the latest RPAV  */
  effectiveStatus?: InputMaybe<Array<ReadyPlanStatus>>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  markets?: InputMaybe<Array<Scalars['ID']>>;
  type?: InputMaybe<Array<ReadyPlanType>>;
  /**  Matches PPs with TLIs whose task_id points to this GlobalPlanTask.  */
  globalTaskId?: InputMaybe<Scalars['ID']>;
};

export type PlanPackageOrderBy = {
  id?: InputMaybe<Order>;
  updatedAt?: InputMaybe<Order>;
};

export type PlanPackagesPageResult = {
  __typename?: 'PlanPackagesPageResult';
  entities: Array<PlanPackage>;
  pageInfo: PageInfo;
};

export type BackfillPlanPackageOptionGroupLocationsInput = {
  planPackageIds: Array<Scalars['ID']>;
};

export type PlanPackageAiProposal = {
  __typename?: 'PlanPackageAiProposal';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  entityProposals: Array<AiEntityProposal>;
  status: AiProposalStatusDetail;
  planPackage: PlanPackage;
  asset: Asset;
};

export type CreatePlanPackageAiProposalInput = {
  planPackageId: Scalars['ID'];
  asset: AssetInput;
};

export type PlanPackageIncomingSlot = {
  __typename?: 'PlanPackageIncomingSlot';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  createdBy: User;
  planPackage: PlanPackage;
  designPackage: DesignPackage;
  designPackagePlaceholder: TakeoffLineItem;
  status: PlanPackageIncomingSlotStatusDetail;
  /**  The PP's ReadyPlanLocation (room, level, or group) this slot targets  */
  planPackageRpl: ReadyPlanLocation;
};

export type PlanPackageIncomingSlotIdsInput = {
  ids: Array<Scalars['ID']>;
};

export type CreatePlanPackageIncomingSlotsInput = {
  designPackagePlaceholderId: Scalars['ID'];
  planPackageIds: Array<Scalars['ID']>;
};

export type PlanPackageSlotDeletionRequest = {
  __typename?: 'PlanPackageSlotDeletionRequest';
  id: Scalars['ID'];
};

export type PlanPackageVersion = {
  __typename?: 'PlanPackageVersion';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  code?: Maybe<Scalars['String']>;
  contingencyMarkupPercentage?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  type: ReadyPlanTypeDetail;
  lotTypes: Array<LotType>;
  identity: ReadyPlan;
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  markets: Array<Market>;
  insideMapsProjectId?: Maybe<Scalars['String']>;
  owner?: Maybe<InternalUser>;
};

export type PlanSchedule = {
  __typename?: 'PlanSchedule';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  tasks: Array<PlanTask>;
  parent: PlanScheduleParent;
  planMilestones: Array<PlanMilestone>;
  recalculatedAt?: Maybe<Scalars['DateTime']>;
  recalculatedBy?: Maybe<User>;
  targetStartDate: Scalars['Date'];
  targetEndDate: Scalars['Date'];
  currentBaselineDate: Scalars['Date'];
  /** `targetCycleTimeInDays` (as input by the user) is in calendar days */
  targetCycleTimeInDays: Scalars['Int'];
  targetCycleTimeInCalendarDays: Scalars['Int'];
  targetCycleTimeInWorkingDays: Scalars['Int'];
  communityTargetCycleTimeInDays: Scalars['Int'];
  cycleTimeInWorkingDays?: Maybe<Scalars['Int']>;
  cycleTimeInCalendarDays?: Maybe<Scalars['Int']>;
  verticalCompleteDate?: Maybe<Scalars['Date']>;
  readyToStartDate?: Maybe<Scalars['Date']>;
  preconReadyToStartDate?: Maybe<Scalars['Date']>;
  targetEndDateProbability?: Maybe<Scalars['Int']>;
  schedulingExclusionDates: Array<SchedulingExclusionDate>;
  canSendTradePartnerAvailabilityRequestEmail: PotentialOperation2;
  targetConstructionRtsDate?: Maybe<Scalars['Date']>;
  targetPreconRtsDate?: Maybe<Scalars['Date']>;
  planMilestoneTargets: Array<PlanMilestoneTarget>;
  childVerticalCompleteInDays?: Maybe<Scalars['Int']>;
};

export type SavePlanScheduleInput = {
  id?: InputMaybe<Scalars['ID']>;
  parentId?: InputMaybe<Scalars['ID']>;
  targetStartDate?: InputMaybe<Scalars['Date']>;
  currentBaselineDate?: InputMaybe<Scalars['Date']>;
  /** Target cycle time 'days' unit is calendar days */
  targetCycleTimeInDays?: InputMaybe<Scalars['Int']>;
  targetConstructionRtsDate?: InputMaybe<Scalars['Date']>;
  targetPreconRtsDate?: InputMaybe<Scalars['Date']>;
  planMilestoneTargets?: InputMaybe<Array<PlanMilestoneTargetInput>>;
};

export type SavePlanScheduleResult = {
  __typename?: 'SavePlanScheduleResult';
  planSchedule: PlanSchedule;
};

export type PlanScheduleParent = StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit;

export type DraftScheduleInput = {
  scheduleParentId: Scalars['ID'];
  draftTaskChanges: Array<DraftPlanTaskInput>;
  tradePartnerAvailabilityRequests?: InputMaybe<Array<DraftTradePartnerAvailabilityRequestInput>>;
  bills?: InputMaybe<Array<SaveBillInput>>;
  /**
   * Used to single out a task to load additional *draft* data for that is too expensive to load for all tasks
   * Primary use case is the task detail sidebar
   */
  taskDetailId?: InputMaybe<Scalars['ID']>;
  /**  Defaults to false, intended to be used to repair schedules that have been neglected for a while by removing the automatic pinning of stale tasks  */
  skipStaleTaskAutoPin?: InputMaybe<Scalars['Boolean']>;
  /**  Used to override what the simulator thinks is 'today'  */
  currentDate?: InputMaybe<Scalars['Date']>;
};

export type DraftTradePartnerAvailabilityRequestInput = {
  taskId?: InputMaybe<Scalars['ID']>;
  tradePartnerId?: InputMaybe<Scalars['ID']>;
  tradePartnerContactIds?: InputMaybe<Array<Scalars['ID']>>;
  confirmRequestedReschedule?: InputMaybe<Scalars['Boolean']>;
};

export type DraftScheduleResult = {
  __typename?: 'DraftScheduleResult';
  planTasks: Array<PlanTask>;
  /** Separate from `planTasks` to more efficiently support data heavy views, like the C2P publish step */
  newlyCompletedPlanTasks: Array<PlanTask>;
  /**  Subset of tasks that have changes requiring trade partner confirmation  */
  tradeConfirmPlanTasks: Array<PlanTask>;
  planSchedule: PlanSchedule;
  bills?: Maybe<Array<Bill>>;
  /** Optionally loads additional *draft* data for a single task when `taskDetailId` is provided */
  planTaskDetail?: Maybe<PlanTask>;
};

export type PlanScheduleSnapshotsInput = {
  scheduleParentId: Scalars['ID'];
  /** Default is `PlanSchedule.currentBaselineDate` */
  asOfDate?: InputMaybe<Scalars['Date']>;
};

export type PlanScheduleSnapshotsResult = {
  __typename?: 'PlanScheduleSnapshotsResult';
  taskSnapshots: Array<TaskSnapshot>;
  planMilestoneSnapshots: Array<PlanMilestoneSnapshot>;
};

export type ResetPlanScheduleDatesInput = {
  planScheduleId: Scalars['ID'];
  /**
   * Optional date to use as "today" for simulation purposes.
   * Use this to backdate a schedule (e.g., simulate as if the schedule started in the past).
   */
  scheduleStartOverride?: InputMaybe<Scalars['Date']>;
};

export type ForceScalePlanMilestoneTargetsInput = {
  projectIds: Array<Scalars['ID']>;
};

export type ForceScalePlanMilestoneTargetsResult = {
  __typename?: 'ForceScalePlanMilestoneTargetsResult';
  planSchedules: Array<PlanSchedule>;
};

export type SavePlanTaskInput = {
  id?: InputMaybe<Scalars['ID']>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<TaskStatus>;
  internalUserId?: InputMaybe<Scalars['ID']>;
  documents?: InputMaybe<Array<Scalars['ID']>>;
  tradePartnerStatus?: InputMaybe<TradePartnerTaskStatus>;
  workDays?: InputMaybe<Array<TaskWorkDayIncrementalInput>>;
  tradePartnerId?: InputMaybe<Scalars['ID']>;
  customWorkableDaysOfWeek?: InputMaybe<Array<DayOfWeek>>;
};

export type SavePlanTaskResult = {
  __typename?: 'SavePlanTaskResult';
  planTask: PlanTask;
};

export type PlanTasksOrder = {
  id?: InputMaybe<Order>;
  parent?: InputMaybe<Order>;
  internalUser?: InputMaybe<Order>;
  startDate?: InputMaybe<Order>;
  endDate?: InputMaybe<Order>;
};

export type PlanTasksFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  myTasks?: InputMaybe<Scalars['Boolean']>;
  startDateRange?: InputMaybe<DateFilter2>;
  endDateRange?: InputMaybe<DateFilter2>;
  status?: InputMaybe<Array<TaskStatus>>;
  scheduleParent?: InputMaybe<Array<Scalars['ID']>>;
  project?: InputMaybe<Array<Scalars['ID']>>;
  budgetItem?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
  tradePartnerStatus?: InputMaybe<Array<TradePartnerTaskStatus>>;
};

export type PlanTasksResult = {
  __typename?: 'PlanTasksResult';
  entities: Array<PlanTask>;
  pageInfo: PageInfo;
};

export type SavePlanTaskScheduleFlagInput = {
  id?: InputMaybe<Scalars['ID']>;
  clientId?: InputMaybe<Scalars['ID']>;
  durationInDays?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  reasonId?: InputMaybe<Scalars['ID']>;
  oldTaskStartDate?: InputMaybe<Scalars['Date']>;
  newTaskStartDate?: InputMaybe<Scalars['Date']>;
  oldTaskEndDate?: InputMaybe<Scalars['Date']>;
  newTaskEndDate?: InputMaybe<Scalars['Date']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
};

/** Subset of fields from PlanTaskInput, including those that are only updatable via the draft flow */
export type DraftPlanTaskInput = {
  id?: InputMaybe<Scalars['ID']>;
  clientId?: InputMaybe<Scalars['ID']>;
  globalPlanTaskId?: InputMaybe<Scalars['ID']>;
  isManuallyScheduled?: InputMaybe<Scalars['Boolean']>;
  earliestStartDate?: InputMaybe<Scalars['Date']>;
  knownDurationInDays?: InputMaybe<Scalars['Int']>;
  /**
   * Effectively sets `knownDurationInDays` to achieve the desired `endDate`
   * @deprecated There is a known issue when combining this input with other changes that indirectly affect this task's startDate. Instrumenting this behavior on the frontend instead for now.
   */
  desiredEndDate?: InputMaybe<Scalars['Date']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  scheduleFlags?: InputMaybe<Array<SavePlanTaskScheduleFlagInput>>;
  status?: InputMaybe<TaskStatus>;
  /** Full list of custom workable days; should only be set as an exception to the default Monday-Friday */
  customWorkableDaysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  tradePartnerStatus?: InputMaybe<TradePartnerTaskStatus>;
  tradePartnerId?: InputMaybe<Scalars['ID']>;
  internalUserId?: InputMaybe<Scalars['ID']>;
};

export type SimulationProbability = {
  __typename?: 'SimulationProbability';
  startDateBasisPoints?: Maybe<Scalars['Int']>;
  endDateBasisPoints?: Maybe<Scalars['Int']>;
  /** Similar to `startDateBasisPoints`, but includes the full range of potential dates and their probabilities vs. the most probable date */
  potentialStartDateBasisPoints?: Maybe<Array<PotentialDateBasisPoints>>;
  /** Similar to `endDateBasisPoints`, but includes the full range of potential dates and their probabilities vs. the most probable date */
  potentialEndDateBasisPoints?: Maybe<Array<PotentialDateBasisPoints>>;
};

export type PotentialDateBasisPoints = {
  __typename?: 'PotentialDateBasisPoints';
  date: Scalars['Date'];
  basisPoints: Scalars['Int'];
};

/**
 * This input should only implement behaviors that are safe for an admin user to modify tasks
 * across schedules without being in the draft context of a particular schedule.
 * Attributes with side effects on trade scheduling or bills should not be included in this input.
 */
export type BulkSavePlanTaskInput = {
  id?: InputMaybe<Scalars['ID']>;
  /** Add only, required when id is absent */
  planScheduleId?: InputMaybe<Scalars['ID']>;
  /** Add only, required when id is absent. */
  globalPlanTaskId?: InputMaybe<Scalars['ID']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  internalUserId?: InputMaybe<Scalars['ID']>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
};

export type BulkSavePlanTasksResult = {
  __typename?: 'BulkSavePlanTasksResult';
  planTasks: Array<PlanTask>;
};

export type PlanTaskChecklistItem = {
  __typename?: 'PlanTaskChecklistItem';
  id: Scalars['ID'];
  /**  Derived from GlobalPlanTaskChecklistItem  */
  name: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  planTask: PlanTask;
  completedBy?: Maybe<User>;
  globalItem: GlobalPlanTaskChecklistItem;
};

export type SavePlanTaskChecklistItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  globalItemId?: InputMaybe<Scalars['ID']>;
  planTaskId?: InputMaybe<Scalars['ID']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DeletePlanTaskChecklistItemInput = {
  id: Scalars['ID'];
};

export type SavePlanTaskChecklistItemResult = {
  __typename?: 'SavePlanTaskChecklistItemResult';
  planTaskChecklistItem: PlanTaskChecklistItem;
};

export type PreconContractType = {
  __typename?: 'PreconContractType';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  projects: Array<StandaloneProject>;
  inviteHomeowners: Scalars['Boolean'];
  needsWeeklyUpdate: Scalars['Boolean'];
};

export type SavePreconContractTypeInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  inviteHomeowners?: InputMaybe<Scalars['Boolean']>;
  needsWeeklyUpdate?: InputMaybe<Scalars['Boolean']>;
};

export type SavePreconContractTypeResult = {
  __typename?: 'SavePreconContractTypeResult';
  preconContractType: PreconContractType;
};

export type ProductOffering = ReadyPlanLike & HasBlueprintUrl & Named & HasDisplayName & BaseItemParent & {
  __typename?: 'ProductOffering';
  id: Scalars['ID'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ReadyPlanTypeDetail;
  code?: Maybe<Scalars['String']>;
  /**  The `type` + `code`, i.e. SFH-TX-1-001  */
  displayCode?: Maybe<Scalars['String']>;
  blueprintUrl: Url;
  constructionDocumentCompletePercentage: Scalars['Int'];
  status: ReadyPlanStatusDetail;
  /**  The latest status based on the latest RPAV, which may be archived depending on the ReadyPlan's status.  */
  effectiveStatus: ReadyPlanStatusDetail;
  development?: Maybe<Development>;
  underwritingTemplate?: Maybe<ItemTemplate>;
  maxProgramData: ProgramData;
  minProgramData: ProgramData;
  programData: ProgramData;
  itemTemplates: Array<ItemTemplate>;
  options: Array<ReadyPlanOption>;
  optionGroups: Array<ReadyPlanOptionGroup>;
  userEvents: Array<UserEvent>;
  planPackage: PlanPackage;
  planPackageVersion: ReadyPlanAggregateVersion;
  programDatas: Array<ReadyPlanProgramData>;
  copyInProgress: Scalars['Boolean'];
  bidPackages: Array<BidPackage>;
  assets: Array<ReadyPlanAsset>;
  lotTypes: Array<LotType>;
  baseConfig?: Maybe<ProductOfferingConfig>;
  configs: Array<ProductOfferingConfig>;
  /**  All downstream PRPCs referencing this ProductOffering  */
  projectConfigs: Array<ProjectReadyPlanConfig>;
  bidOutPercentage: Scalars['Int'];
  coverAsset?: Maybe<Asset>;
  /**  TODO: Deprecate once we move to floorPlanAssets  */
  floorPlanAsset?: Maybe<Asset>;
  /**  Array of floor plan assets for each level (Full, Ground/Basement, First, Second)  */
  floorPlanAssets: Array<ReadyPlanAsset>;
  interiorDesignPackage: DesignPackage;
  interiorDesignPackageVersion: ReadyPlanAggregateVersion;
  exteriorDesignPackage: DesignPackage;
  exteriorDesignPackageVersion: ReadyPlanAggregateVersion;
  designPackageCombinations: Array<DesignPackageCombination>;
  aggregateActive?: Maybe<ReadyPlanAggregateVersion>;
  aggregateDraft?: Maybe<ReadyPlanAggregateVersion>;
  aggregateLatest: ReadyPlanAggregateVersion;
  aggregateCheckout?: Maybe<ReadyPlanAggregateVersion>;
  aggregateVersions: Array<ReadyPlanAggregateVersion>;
  version: ReadyPlanAggregateVersion;
  availableUpdates: Array<ProductOfferingIncomingUpdate>;
  itemLocations: Array<Location>;
  costCodes: Array<CostCode>;
  canEditLineItems: PotentialOperation2;
  contingencyMarkupPercentage?: Maybe<Scalars['Float']>;
  canEdit: PotentialOperation2;
  canEditOptions: PotentialOperation2;
  publishToUnderwriting: Scalars['Boolean'];
  tourUrl?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
  checkoutConfigs: Array<CheckoutConfig>;
  showInCheckout: Scalars['Boolean'];
  documents: Array<Document>;
  /**  The latest (exterior) rendering image for the product offering.  */
  rendering?: Maybe<Asset>;
  /**  Interior rendering images for the product offering, used for static renderings in checkout (select communities).  */
  interiorRenderings: Array<InteriorRoomRendering>;
  /**  Generic renderings query that filters by ReadyPlanAssetType and matches by ready plan option IDs. Only matches files with the '-ids=' token format (e.g., 'AduExterior-ids=123_456.png'). Returns type+asset pairs with the highest match score per type.  */
  renderings: Array<RenderingAsset>;
  requiredOptions: Array<ReadyPlanRequiredOption>;
  owner?: Maybe<InternalUser>;
  cloneInProgress: Scalars['Boolean'];
  insideMapsMissingLocations: Array<Scalars['String']>;
  promoteInProgress: Scalars['Boolean'];
  buildableLots: Array<Lot>;
  /**  Computed JSON output for InsideMaps package containing rooms, locations, and material variants.  */
  insideMapsPacket?: Maybe<Scalars['JSONObject']>;
  architectureFeePriceInCents?: Maybe<Scalars['Int']>;
  preconServicesPriceInCents?: Maybe<Scalars['Int']>;
  trackedJobs: Array<TrackedJob>;
  activeElevationCount: Scalars['Int'];
  checkoutBlockingErrors: Array<Scalars['String']>;
};


export type ProductOfferingOptionsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};


export type ProductOfferingCheckoutConfigsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
};


export type ProductOfferingRenderingsArgs = {
  type: Array<ReadyPlanAssetType>;
};


export type ProductOfferingTrackedJobsArgs = {
  status: Array<TrackedJobStatus>;
};

export type ProductOfferingsFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  development?: InputMaybe<Array<Scalars['ID']>>;
  project?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Array<ReadyPlanStatus>>;
  /**  The latest status based on the latest RPAV; prefer this for list filtering on versioned product offerings  */
  effectiveStatus?: InputMaybe<Array<ReadyPlanStatus>>;
  type?: InputMaybe<Array<ReadyPlanType>>;
  showInCheckout?: InputMaybe<Scalars['Boolean']>;
  publishToUnderwriting?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated Use versionMode: CHECKOUT instead */
  isCheckout?: InputMaybe<Scalars['Boolean']>;
  /**  Specifies which aggregate version to pin to for query results  */
  versionMode?: InputMaybe<ProductOfferingVersionMode>;
  search?: InputMaybe<Scalars['String']>;
  marketIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type ProductOfferingOrder = {
  id?: InputMaybe<Order>;
  updatedAt?: InputMaybe<Order>;
  name?: InputMaybe<Order>;
};

export type ProductOfferingsPageResult = {
  __typename?: 'ProductOfferingsPageResult';
  entities: Array<ProductOffering>;
  pageInfo: PageInfo;
};

export type SaveProductOfferingInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ReadyPlanStatus>;
  developmentId?: InputMaybe<Scalars['ID']>;
  options?: InputMaybe<Array<SaveProductOfferingOptionInput>>;
  optionGroups?: InputMaybe<Array<SaveProductOfferingOptionGroupInput>>;
  planPackageId?: InputMaybe<Scalars['ID']>;
  lotTypes?: InputMaybe<Array<LotType>>;
  baseConfigId?: InputMaybe<Scalars['ID']>;
  interiorDesignPackageId?: InputMaybe<Scalars['ID']>;
  exteriorDesignPackageId?: InputMaybe<Scalars['ID']>;
  contingencyMarkupPercentage?: InputMaybe<Scalars['Float']>;
  publishToUnderwriting?: InputMaybe<Scalars['Boolean']>;
  tourUrl?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['ID']>;
  showInCheckout?: InputMaybe<Scalars['Boolean']>;
  showInCheckoutAllOptions?: InputMaybe<Scalars['Boolean']>;
  ownerId?: InputMaybe<Scalars['ID']>;
  architectureFeePriceInCents?: InputMaybe<Scalars['Int']>;
  preconServicesPriceInCents?: InputMaybe<Scalars['Int']>;
  /**  Restore or set the checkout-pinned aggregate version (must be a previously promoted RPAV).  */
  aggregateCheckoutId?: InputMaybe<Scalars['ID']>;
};

export type AcceptProductOfferingUpdatesInput = {
  productOfferingId: Scalars['ID'];
  productOfferingUpdateIds: Array<Scalars['ID']>;
};

export type SaveProductOfferingOptionInput = {
  id: Scalars['ID'];
  optionDefaultsIfIds?: InputMaybe<Array<Scalars['ID']>>;
  publishToUnderwriting?: InputMaybe<Scalars['Boolean']>;
  showInCheckout?: InputMaybe<Scalars['Boolean']>;
  missingInsideMapsRendering?: InputMaybe<Scalars['Boolean']>;
  checkoutOrder?: InputMaybe<Scalars['Int']>;
};

export type SaveProductOfferingOptionGroupInput = {
  id: Scalars['ID'];
  checkoutOrder?: InputMaybe<Scalars['Int']>;
  overrideStep?: InputMaybe<CheckoutConfigOptionGroupStep>;
  overrideSubstepNumber?: InputMaybe<Scalars['Int']>;
};

export type SaveProductOfferingResult = {
  __typename?: 'SaveProductOfferingResult';
  productOffering: ProductOffering;
};

export type DesignPackageCombination = {
  __typename?: 'DesignPackageCombination';
  readyPlanOptions: Array<ReadyPlanOption>;
  bidOutPercentage: Scalars['Int'];
};

export type PotentialOptionsInput = {
  planPackageId: Scalars['ID'];
  designPackageIds: Array<Scalars['ID']>;
};

export type ComputeProductOfferingCostsAndPricesInput = {
  productOfferingId: Scalars['ID'];
  readyPlanOptionIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type ReadyPlanOptionCostAndPriceDelta = {
  __typename?: 'ReadyPlanOptionCostAndPriceDelta';
  readyPlanOption: ReadyPlanOption;
  totalCostInCents: Scalars['Int'];
  totalPriceInCents: Scalars['Int'];
  preCutoffTotalPriceInCents: Scalars['Int'];
  preCutoffDesiredMarginInBasisPoints: Scalars['Int'];
  postCutoffTotalPriceInCents?: Maybe<Scalars['Int']>;
  postCutoffDesiredMarginInBasisPoints?: Maybe<Scalars['Int']>;
  selectionFeeInCents: Scalars['Int'];
  minimumPriceInCents: Scalars['Int'];
};

export type ComputeProductOfferingCostsAndPricesResponse = {
  __typename?: 'ComputeProductOfferingCostsAndPricesResponse';
  productOffering: ProductOffering;
  baseCostInCents: Scalars['Int'];
  basePriceInCents: Scalars['Int'];
  totalCostInCents: Scalars['Int'];
  /** @deprecated Not applicable to the plan-level. */
  preCutoffTotalPriceInCents: Scalars['Int'];
  /** @deprecated Not applicable to the plan-level. */
  postCutoffTotalPriceInCents: Scalars['Int'];
  selectedOptions: Array<ReadyPlanOptionCostAndPriceDelta>;
  unselectedOptions: Array<ReadyPlanOptionCostAndPriceDelta>;
  /**  Combined list of `selectedOptions` and `unselectedOptions`  */
  allOptions: Array<ReadyPlanOptionCostAndPriceDelta>;
};

export type CalculateDefaultOfferingOptionsInput = {
  productOfferingId: Scalars['ID'];
  currentOptionIds: Array<Scalars['ID']>;
};

export type CalculateScopeChangeInput = {
  productOfferingId: Scalars['ID'];
  rpavId?: InputMaybe<Scalars['ID']>;
  oldConfig: Array<Scalars['ID']>;
  newConfig: Array<Scalars['ID']>;
};

export type CalculateScopeChangeResult = {
  __typename?: 'CalculateScopeChangeResult';
  added: Array<TakeoffLineItemVersion>;
  removed: Array<TakeoffLineItemVersion>;
};

export type InteriorRoomRendering = {
  __typename?: 'InteriorRoomRendering';
  /**  The room name this rendering is for (e.g., 'Kitchen', 'Primary Bedroom')  */
  roomName: Scalars['String'];
  /**  The interior scheme this rendering uses (from base config)  */
  interiorScheme: Scalars['String'];
  /**  The rendering asset for this room (null if no matching rendering exists)  */
  asset?: Maybe<Asset>;
};

export type PromoteToCheckoutInput = {
  aggregateVersionId: Scalars['ID'];
};

export type RenderingAsset = {
  __typename?: 'RenderingAsset';
  /**  The ReadyPlanAssetType extracted from the filename (e.g., AduExterior, AduKitchen, AduLiving, AduBathroom, AduBedroom)  */
  type: ReadyPlanAssetTypeDetail;
  /**  The rendering asset  */
  asset: Asset;
};

/**  Specifies which aggregate version to use when querying ProductOfferings  */
export enum ProductOfferingVersionMode {
  /**  Use the latest version (draft if exists, otherwise active) - default behavior  */
  Latest = 'LATEST',
  /**  Use the checkout-pinned version (aggregateCheckout)  */
  Checkout = 'CHECKOUT',
  /**  Use the active/published version only  */
  Active = 'ACTIVE'
}

export type ProductOfferingConfig = ReadyPlanConfigLike & {
  __typename?: 'ProductOfferingConfig';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: User;
  productOffering: ProductOffering;
  readyPlan: ReadyPlanLike;
  readyPlanOptions: Array<ReadyPlanOption>;
  baseConfigProductOffering?: Maybe<ProductOffering>;
  archive: Scalars['Boolean'];
  isBaseConfig: Scalars['Boolean'];
  programData: ProgramData;
  totalCostInCents: Scalars['Int'];
  /**  Useful for showing the base config's price in checkout.  */
  totalPriceInCents: Scalars['Int'];
  hasCompleteCost: Scalars['Boolean'];
  publishToUnderwriting: Scalars['Boolean'];
  salesPriceInCents?: Maybe<Scalars['Int']>;
  /** Pre-computed texture swaps and camera data for InsideMaps rendering */
  insideMapsTextureSwaps?: Maybe<InsideMapsTextureSwaps>;
};


export type ProductOfferingConfigInsideMapsTextureSwapsArgs = {
  debugParts?: InputMaybe<Array<Scalars['String']>>;
};

export type SaveProductOfferingConfigInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  productOfferingId?: InputMaybe<Scalars['ID']>;
  readyPlanOptionIds?: InputMaybe<Array<Scalars['ID']>>;
  isBaseConfig?: InputMaybe<Scalars['Boolean']>;
  archive?: InputMaybe<Scalars['Boolean']>;
  publishToUnderwriting?: InputMaybe<Scalars['Boolean']>;
  salesPriceInCents?: InputMaybe<Scalars['Int']>;
};

export type SaveProductOfferingConfigResult = {
  __typename?: 'SaveProductOfferingConfigResult';
  productOfferingConfig: ProductOfferingConfig;
};

export type ProductOfferingConfigOrder = {
  updatedAt?: InputMaybe<Order>;
};

export type ProductOfferingConfigsFilter = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  productOfferings?: InputMaybe<Array<Scalars['ID']>>;
  developments?: InputMaybe<Array<Scalars['ID']>>;
  projects?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
  publishToUnderwriting?: InputMaybe<Scalars['Boolean']>;
};

export type ProductOfferingConfigsPage = {
  __typename?: 'ProductOfferingConfigsPage';
  entities: Array<ProductOfferingConfig>;
  pageInfo: PageInfo;
};

export type ProductOfferingConfigCostsInput = {
  productOfferingConfigIds: Array<Scalars['ID']>;
};

export type ComputeProductOfferingConfigCostsResult = {
  __typename?: 'ComputeProductOfferingConfigCostsResult';
  configCosts: Array<ConfigCostsResult>;
};

export type ConfigCostsResult = {
  __typename?: 'ConfigCostsResult';
  productOfferingConfig: ProductOfferingConfig;
  /** @deprecated Use baseHouseCostInCents instead. */
  computedBaseCost: Scalars['Int'];
  baseHouseCostInCents: Scalars['Int'];
  /**  Whether the base scope lines, with options=[], all have bids.  */
  baseHouseHasCompleteCost: Scalars['Boolean'];
  computedOptionCosts: Array<ReadyPlanOptionConfigCosts>;
};

export type ReadyPlanOptionConfigCosts = {
  __typename?: 'ReadyPlanOptionConfigCosts';
  readyPlanOption: ReadyPlanOption;
  totalCostInCents: Scalars['Int'];
  hasCompleteCost: Scalars['Boolean'];
};

export type ProductOfferingIncomingUpdate = {
  __typename?: 'ProductOfferingIncomingUpdate';
  id: Scalars['ID'];
  accepted: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  offering: ProductOffering;
  forDesignPackageUpdate: Scalars['Boolean'];
  forPlanPackageUpdate: Scalars['Boolean'];
  source: ProductOfferingIncomingUpdateSource;
};

export type ProductOfferingIncomingUpdateSource = Drop | ReadyPlanAggregateVersion;

export type ProductOfferingVersion = {
  __typename?: 'ProductOfferingVersion';
  id: Scalars['ID'];
  identity: ReadyPlan;
  name: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  type?: Maybe<ReadyPlanType>;
  lotTypes?: Maybe<Array<LotType>>;
  exteriorDesignPackageVersion: ReadyPlanAggregateVersion;
  interiorDesignPackageVersion: ReadyPlanAggregateVersion;
  planPackageVersion: ReadyPlanAggregateVersion;
  contingencyMarkupPercentage?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  markets: Array<Market>;
  owner?: Maybe<InternalUser>;
};

export type ProductType = {
  __typename?: 'ProductType';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  projects: Array<Project>;
};

export type SaveProductTypeInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type SaveProductTypeResult = {
  __typename?: 'SaveProductTypeResult';
  productType: ProductType;
};

export type ProgramData = ProgramDataLike & {
  __typename?: 'ProgramData';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  stories?: Maybe<Scalars['Int']>;
  bedrooms?: Maybe<Scalars['Int']>;
  closetsInPrimarySuite?: Maybe<Scalars['Int']>;
  fullBaths?: Maybe<Scalars['Int']>;
  halfBaths?: Maybe<Scalars['Int']>;
  /** @deprecated Replaced by depthInFeet. */
  depthInInches?: Maybe<Scalars['Int']>;
  depthInFeet?: Maybe<Scalars['Float']>;
  /** @deprecated Replaced by widthInFeet. */
  widthInInches?: Maybe<Scalars['Int']>;
  widthInFeet?: Maybe<Scalars['Float']>;
  /** @deprecated Replaced by minLotWidthInFeet. */
  minLotWidthInInches?: Maybe<Scalars['Int']>;
  minLotWidthInFeet?: Maybe<Scalars['Float']>;
  /** @deprecated Replaced by minLotDepthInFeet. */
  minLotDepthInInches?: Maybe<Scalars['Int']>;
  minLotDepthInFeet?: Maybe<Scalars['Float']>;
  minLotSizeInSqft?: Maybe<Scalars['Int']>;
  garageAttached?: Maybe<Scalars['Int']>;
  garageDetached?: Maybe<Scalars['Int']>;
  garagePort?: Maybe<Scalars['Int']>;
  garageConfiguration?: Maybe<ProgramDataGarageConfigDetail>;
  basementConfig?: Maybe<ProgramDataBasementConfigDetail>;
  /** @deprecated Replaced by sellableBelowGroundSqft. */
  sellableBasementSqft?: Maybe<Scalars['Int']>;
  permittableSqft?: Maybe<Scalars['Int']>;
  sellableSqft?: Maybe<Scalars['Int']>;
  netBuildableSqft?: Maybe<Scalars['Int']>;
  grossBuildableSqft?: Maybe<Scalars['Int']>;
  /** @deprecated Replaced by sellableAboveGroundSqft. */
  aboveGroundSqft?: Maybe<Scalars['Int']>;
  /** @deprecated Replaced by sellableBelowGroundSqft. */
  belowGroundSqft?: Maybe<Scalars['Int']>;
  sellableAboveGroundSqft?: Maybe<Scalars['Int']>;
  sellableBelowGroundSqft?: Maybe<Scalars['Int']>;
  unfinishedBelowGroundSqft?: Maybe<Scalars['Int']>;
  grossBelowGroundSqft?: Maybe<Scalars['Int']>;
  imperviousSqft?: Maybe<Scalars['Int']>;
  windowColor?: Maybe<ProgramDataWindowColorDetail>;
  firstFloorBedrooms?: Maybe<Scalars['Int']>;
  diningRoom?: Maybe<Scalars['Int']>;
  casualDining?: Maybe<Scalars['Int']>;
  mediaRooms?: Maybe<Scalars['Int']>;
  loftGameFlexRooms?: Maybe<Scalars['Int']>;
  offices?: Maybe<Scalars['Int']>;
  workspaces?: Maybe<Scalars['Int']>;
  primaryBedroom?: Maybe<ProgramDataPrimaryBedroomConfigDetail>;
  /** @deprecated Field no longer supported */
  multiUseBedrooms?: Maybe<Scalars['Int']>;
  /** @deprecated Field no longer supported */
  primarySuiteDown?: Maybe<Scalars['Int']>;
  buildingHeightInFeet?: Maybe<Scalars['Float']>;
  readyPlanProgramData?: Maybe<ReadyPlanProgramData>;
};

export type ProgramDataLike = {
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  stories?: Maybe<Scalars['Int']>;
  bedrooms?: Maybe<Scalars['Int']>;
  closetsInPrimarySuite?: Maybe<Scalars['Int']>;
  fullBaths?: Maybe<Scalars['Int']>;
  halfBaths?: Maybe<Scalars['Int']>;
  /** @deprecated Replaced by depthInFeet. */
  depthInInches?: Maybe<Scalars['Int']>;
  depthInFeet?: Maybe<Scalars['Float']>;
  /** @deprecated Replaced by widthInFeet. */
  widthInInches?: Maybe<Scalars['Int']>;
  widthInFeet?: Maybe<Scalars['Float']>;
  /** @deprecated Replaced by minLotWidthInFeet. */
  minLotWidthInInches?: Maybe<Scalars['Int']>;
  minLotWidthInFeet?: Maybe<Scalars['Float']>;
  /** @deprecated Replaced by minLotDepthInFeet. */
  minLotDepthInInches?: Maybe<Scalars['Int']>;
  minLotDepthInFeet?: Maybe<Scalars['Float']>;
  minLotSizeInSqft?: Maybe<Scalars['Int']>;
  garageAttached?: Maybe<Scalars['Int']>;
  garageDetached?: Maybe<Scalars['Int']>;
  garagePort?: Maybe<Scalars['Int']>;
  garageConfiguration?: Maybe<ProgramDataGarageConfigDetail>;
  basementConfig?: Maybe<ProgramDataBasementConfigDetail>;
  /** @deprecated Replaced by sellableBelowGroundSqft. */
  sellableBasementSqft?: Maybe<Scalars['Int']>;
  permittableSqft?: Maybe<Scalars['Int']>;
  sellableSqft?: Maybe<Scalars['Int']>;
  netBuildableSqft?: Maybe<Scalars['Int']>;
  grossBuildableSqft?: Maybe<Scalars['Int']>;
  /** @deprecated Replaced by sellableAboveGroundSqft. */
  aboveGroundSqft?: Maybe<Scalars['Int']>;
  /** @deprecated Replaced by sellableBelowGroundSqft. */
  belowGroundSqft?: Maybe<Scalars['Int']>;
  sellableAboveGroundSqft?: Maybe<Scalars['Int']>;
  sellableBelowGroundSqft?: Maybe<Scalars['Int']>;
  unfinishedBelowGroundSqft?: Maybe<Scalars['Int']>;
  grossBelowGroundSqft?: Maybe<Scalars['Int']>;
  imperviousSqft?: Maybe<Scalars['Int']>;
  windowColor?: Maybe<ProgramDataWindowColorDetail>;
  firstFloorBedrooms?: Maybe<Scalars['Int']>;
  diningRoom?: Maybe<Scalars['Int']>;
  casualDining?: Maybe<Scalars['Int']>;
  mediaRooms?: Maybe<Scalars['Int']>;
  loftGameFlexRooms?: Maybe<Scalars['Int']>;
  offices?: Maybe<Scalars['Int']>;
  workspaces?: Maybe<Scalars['Int']>;
  primaryBedroom?: Maybe<ProgramDataPrimaryBedroomConfigDetail>;
  /** @deprecated Field no longer supported */
  multiUseBedrooms?: Maybe<Scalars['Int']>;
  /** @deprecated Field no longer supported */
  primarySuiteDown?: Maybe<Scalars['Int']>;
  buildingHeightInFeet?: Maybe<Scalars['Float']>;
};

export type SaveProgramDataInput = {
  stories?: InputMaybe<Scalars['Int']>;
  bedrooms?: InputMaybe<Scalars['Int']>;
  closetsInPrimarySuite?: InputMaybe<Scalars['Int']>;
  fullBaths?: InputMaybe<Scalars['Int']>;
  halfBaths?: InputMaybe<Scalars['Int']>;
  /** @deprecated Replaced by depthInFeet. */
  depthInInches?: InputMaybe<Scalars['Int']>;
  depthInFeet?: InputMaybe<Scalars['Float']>;
  /** @deprecated Replaced by widthInFeet. */
  widthInInches?: InputMaybe<Scalars['Int']>;
  widthInFeet?: InputMaybe<Scalars['Float']>;
  /** @deprecated Replaced by minLotWidthInFeet. */
  minLotWidthInInches?: InputMaybe<Scalars['Int']>;
  minLotWidthInFeet?: InputMaybe<Scalars['Float']>;
  /** @deprecated Replaced by minLotDepthInFeet. */
  minLotDepthInInches?: InputMaybe<Scalars['Int']>;
  minLotDepthInFeet?: InputMaybe<Scalars['Float']>;
  minLotSizeInSqft?: InputMaybe<Scalars['Int']>;
  garageAttached?: InputMaybe<Scalars['Int']>;
  garageDetached?: InputMaybe<Scalars['Int']>;
  garagePort?: InputMaybe<Scalars['Int']>;
  garageConfiguration?: InputMaybe<ProgramDataGarageConfig>;
  basementConfig?: InputMaybe<ProgramDataBasementConfig>;
  /** @deprecated Replaced by sellableBelowGroundSqft. */
  sellableBasementSqft?: InputMaybe<Scalars['Int']>;
  permittableSqft?: InputMaybe<Scalars['Int']>;
  /** @deprecated This field is derived now, and can no longer be manually updated. */
  sellableSqft?: InputMaybe<Scalars['Int']>;
  netBuildableSqft?: InputMaybe<Scalars['Int']>;
  grossBuildableSqft?: InputMaybe<Scalars['Int']>;
  /** @deprecated Replaced by sellableAboveGroundSqft. */
  aboveGroundSqft?: InputMaybe<Scalars['Int']>;
  /** @deprecated Replaced by sellableBelowGroundSqft. */
  belowGroundSqft?: InputMaybe<Scalars['Int']>;
  sellableAboveGroundSqft?: InputMaybe<Scalars['Int']>;
  sellableBelowGroundSqft?: InputMaybe<Scalars['Int']>;
  grossBelowGroundSqft?: InputMaybe<Scalars['Int']>;
  imperviousSqft?: InputMaybe<Scalars['Int']>;
  windowColor?: InputMaybe<ProgramDataWindowColor>;
  firstFloorBedrooms?: InputMaybe<Scalars['Int']>;
  diningRoom?: InputMaybe<Scalars['Int']>;
  casualDining?: InputMaybe<Scalars['Int']>;
  mediaRooms?: InputMaybe<Scalars['Int']>;
  loftGameFlexRooms?: InputMaybe<Scalars['Int']>;
  offices?: InputMaybe<Scalars['Int']>;
  workspaces?: InputMaybe<Scalars['Int']>;
  primaryBedroom?: InputMaybe<ProgramDataPrimaryBedroomConfig>;
  buildingHeightInFeet?: InputMaybe<Scalars['Float']>;
};

export type ComputeProgramDataInput = {
  readyPlan: Scalars['ID'];
  readyPlanOptions: Array<Scalars['ID']>;
  /**  For ProductOfferings, specifies which aggregate version to use  */
  versionMode?: InputMaybe<ProductOfferingVersionMode>;
};

export type NewProgramData = ProgramDataLike & {
  __typename?: 'NewProgramData';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  stories?: Maybe<Scalars['Int']>;
  bedrooms?: Maybe<Scalars['Int']>;
  closetsInPrimarySuite?: Maybe<Scalars['Int']>;
  fullBaths?: Maybe<Scalars['Int']>;
  halfBaths?: Maybe<Scalars['Int']>;
  /** @deprecated Replaced by depthInFeet. */
  depthInInches?: Maybe<Scalars['Int']>;
  depthInFeet?: Maybe<Scalars['Float']>;
  /** @deprecated Replaced by widthInFeet. */
  widthInInches?: Maybe<Scalars['Int']>;
  widthInFeet?: Maybe<Scalars['Float']>;
  /** @deprecated Replaced by minLotWidthInFeet. */
  minLotWidthInInches?: Maybe<Scalars['Int']>;
  minLotWidthInFeet?: Maybe<Scalars['Float']>;
  /** @deprecated Replaced by minLotDepthInFeet. */
  minLotDepthInInches?: Maybe<Scalars['Int']>;
  minLotDepthInFeet?: Maybe<Scalars['Float']>;
  minLotSizeInSqft?: Maybe<Scalars['Int']>;
  garageAttached?: Maybe<Scalars['Int']>;
  garageDetached?: Maybe<Scalars['Int']>;
  garagePort?: Maybe<Scalars['Int']>;
  garageConfiguration?: Maybe<ProgramDataGarageConfigDetail>;
  basementConfig?: Maybe<ProgramDataBasementConfigDetail>;
  /** @deprecated Replaced by sellableBelowGroundSqft. */
  sellableBasementSqft?: Maybe<Scalars['Int']>;
  permittableSqft?: Maybe<Scalars['Int']>;
  sellableSqft?: Maybe<Scalars['Int']>;
  netBuildableSqft?: Maybe<Scalars['Int']>;
  grossBuildableSqft?: Maybe<Scalars['Int']>;
  /** @deprecated Replaced by sellableAboveGroundSqft. */
  aboveGroundSqft?: Maybe<Scalars['Int']>;
  /** @deprecated Replaced by sellableBelowGroundSqft. */
  belowGroundSqft?: Maybe<Scalars['Int']>;
  sellableAboveGroundSqft?: Maybe<Scalars['Int']>;
  sellableBelowGroundSqft?: Maybe<Scalars['Int']>;
  unfinishedBelowGroundSqft?: Maybe<Scalars['Int']>;
  grossBelowGroundSqft?: Maybe<Scalars['Int']>;
  imperviousSqft?: Maybe<Scalars['Int']>;
  windowColor?: Maybe<ProgramDataWindowColorDetail>;
  firstFloorBedrooms?: Maybe<Scalars['Int']>;
  diningRoom?: Maybe<Scalars['Int']>;
  casualDining?: Maybe<Scalars['Int']>;
  mediaRooms?: Maybe<Scalars['Int']>;
  loftGameFlexRooms?: Maybe<Scalars['Int']>;
  offices?: Maybe<Scalars['Int']>;
  workspaces?: Maybe<Scalars['Int']>;
  primaryBedroom?: Maybe<ProgramDataPrimaryBedroomConfigDetail>;
  /** @deprecated Field no longer supported */
  multiUseBedrooms?: Maybe<Scalars['Int']>;
  /** @deprecated Field no longer supported */
  primarySuiteDown?: Maybe<Scalars['Int']>;
  buildingHeightInFeet?: Maybe<Scalars['Float']>;
};

export type ProjectJobLogInsights = {
  __typename?: 'ProjectJobLogInsights';
  delayFlagCount: Scalars['Int'];
  popularFlagReason?: Maybe<ScheduleFlagReason>;
  partnerWithMostDelays?: Maybe<TradePartner>;
  topJobLogCreator?: Maybe<InternalUser>;
  notesToday: Scalars['Int'];
  weekJobLogs: Scalars['Int'];
};

export type ProjectDictionary = {
  __typename?: 'ProjectDictionary';
  clientContract: Scalars['String'];
  clientNoun: Scalars['String'];
  initialBudget: Scalars['String'];
  shortClientNoun: Scalars['String'];
};

export type ProjectInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  buildAddress?: InputMaybe<AddressInput>;
  marketId?: InputMaybe<Scalars['ID']>;
  /**  Only used for creating the Project.  */
  client?: InputMaybe<ClientInput>;
  /**  Add's a new coverImage to a project.  */
  coverImage?: InputMaybe<AssetInput>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ProjectStatus>;
  /**  Only used for creating the Project.  */
  startDate?: InputMaybe<Scalars['Date']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']>;
  planRoomLink?: InputMaybe<Scalars['String']>;
  salesforceAccountId?: InputMaybe<Scalars['String']>;
  projectStatusChange?: InputMaybe<ProjectStatusChangeInput>;
  isDisaster?: InputMaybe<Scalars['Boolean']>;
  intakeStyleNotes?: InputMaybe<Scalars['String']>;
  lotType?: InputMaybe<LotType>;
  productTypeId?: InputMaybe<Scalars['ID']>;
  projectRoles?: InputMaybe<Array<UpdateProjectRoleInput>>;
  salesforcePropertyId?: InputMaybe<Scalars['String']>;
  scopeMode?: InputMaybe<ScopeMode>;
  lotPartitionId?: InputMaybe<Scalars['String']>;
  warrantyStartDate?: InputMaybe<Scalars['Date']>;
  checkoutCustomerConfigId?: InputMaybe<Scalars['String']>;
  directCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']>;
  indirectCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']>;
  customerId?: InputMaybe<Scalars['ID']>;
  customerOwnerEntityId?: InputMaybe<Scalars['ID']>;
  builderId?: InputMaybe<Scalars['ID']>;
  legalDescription?: InputMaybe<Scalars['String']>;
  salesTaxOverrideInBasisPoints?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['ID']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyLicenseNumber?: InputMaybe<Scalars['String']>;
  /**
   *  Deprecated inputs for StandaloneProject
   * @deprecated only implemented for StandaloneProject
   */
  cohortId?: InputMaybe<Scalars['ID']>;
  /** @deprecated only implemented for StandaloneProject */
  lotRatingId?: InputMaybe<Scalars['ID']>;
  /** @deprecated only implemented for StandaloneProject */
  preconContractTypeId?: InputMaybe<Scalars['ID']>;
  /** @deprecated only implemented for StandaloneProject */
  primaryProjectId?: InputMaybe<Scalars['ID']>;
  /** @deprecated only implemented for StandaloneProject */
  quickbooksCustomerId?: InputMaybe<Scalars['String']>;
  /** @deprecated only implemented for StandaloneProject */
  submarketId?: InputMaybe<Scalars['ID']>;
  /**  These fields are only used on Structure and StandaloneProject for now */
  grossSalesPriceInCents?: InputMaybe<Scalars['Int']>;
  closingCostsForDirectMarginInCents?: InputMaybe<Scalars['Int']>;
  purchaseCostInCents?: InputMaybe<Scalars['Int']>;
  includedPriceInCents?: InputMaybe<Scalars['Int']>;
  includedOptions?: InputMaybe<Array<Scalars['ID']>>;
  invoicePaymentNetDays?: InputMaybe<Scalars['Int']>;
};

export type SaveProjectResult = {
  __typename?: 'SaveProjectResult';
  project: Project;
};

export type DeleteProjectInput = {
  projectId: Scalars['ID'];
};

/**  Generic progress of any SchedulePhase, ScheduleSubPhase or Task.  */
export enum ProgressSummaryStatus {
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Complete = 'COMPLETE'
}

export type ProgressSummary = {
  __typename?: 'ProgressSummary';
  inProgress: Scalars['Int'];
  notStarted: Scalars['Int'];
  completed: Scalars['Int'];
  total: Scalars['Int'];
  status: ProgressSummaryStatus;
};

export type ToggleProjectFeatureInput = {
  projectId: Scalars['ID'];
  feature: ProjectFeature;
  enable: Scalars['Boolean'];
};

export type RecalcProjectDatesInput = {
  projectIds: Array<Scalars['ID']>;
};

export enum SearchBy {
  Project = 'PROJECT',
  Stage = 'STAGE'
}

export type GeocodeProjectsInput = {
  projectIds: Array<Scalars['ID']>;
};

export type ResyncProjectFinancialsInput = {
  projectIds?: InputMaybe<Array<Scalars['ID']>>;
  developmentId?: InputMaybe<Scalars['ID']>;
  resyncExternals?: InputMaybe<Scalars['Boolean']>;
};

export type ResyncPreconProjectItemCostInput = {
  projectIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type ResyncPreconProjectItemCostResult = {
  __typename?: 'ResyncPreconProjectItemCostResult';
  projects: Array<Project>;
  projectItems: Array<ProjectItem>;
};

export type CloneProjectCostAllocationsInput = {
  sourceId: Scalars['ID'];
  targetIds: Array<Scalars['ID']>;
  stage: Array<Stage>;
};

export type CloneProjectCostAllocationsResult = {
  __typename?: 'CloneProjectCostAllocationsResult';
  source: Project;
  targets: Array<Project>;
};

export enum ProjectTypeFilter {
  Region = 'Region',
  Market = 'Market',
  Community = 'Community',
  Subdivision = 'Subdivision',
  Lot = 'Lot',
  Structure = 'Structure',
  Unit = 'Unit',
  StandaloneProject = 'StandaloneProject'
}

export type ProjectFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  type?: InputMaybe<Array<ProjectTypeFilter>>;
  status?: InputMaybe<Array<ProjectStatus>>;
  market?: InputMaybe<Array<Scalars['ID']>>;
  stage?: InputMaybe<Array<Stage>>;
  teamMembers?: InputMaybe<Array<Scalars['ID']>>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  productType?: InputMaybe<Array<Scalars['ID']>>;
  latestActiveStage?: InputMaybe<Array<Stage>>;
  lotType?: InputMaybe<Array<LotType>>;
  cohort?: InputMaybe<Array<Scalars['ID']>>;
  development?: InputMaybe<Array<Scalars['ID']>>;
  lotPartitionId?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  tradePartnerIds?: InputMaybe<Array<Scalars['ID']>>;
  readyPlans?: InputMaybe<Array<Scalars['ID']>>;
  readyPlanOptions?: InputMaybe<Array<Scalars['ID']>>;
  showInCheckout?: InputMaybe<Scalars['Boolean']>;
  parentRecursive?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Apply specific filters for user-facing construction view (for mobile app and rag system).
   * When true, then:
   *   - set preferShadow as true
   *   - filter out BTR lot type
   *   - filter by [StandaloneProject, Structure] types
   */
  constructionView?: InputMaybe<Scalars['Boolean']>;
  /**
   * When true, then prefer shadow projects over primary projects
   * E.g. 123 Main Street (primary) and Pilot 123 Main Street (shadow), returns the latter.
   */
  preferShadow?: InputMaybe<Scalars['Boolean']>;
  /** Filter projects that have any of the specified feature flags enabled with Active status. */
  hasActiveFeatureFlag?: InputMaybe<Array<FeatureFlagType>>;
};

export type ProjectOrder = {
  id?: InputMaybe<Order>;
  buildAddress?: InputMaybe<Order>;
  name?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
  latestActiveStage?: InputMaybe<Order>;
  cohort?: InputMaybe<Order>;
  targetEndDate?: InputMaybe<Order>;
  projectLead?: InputMaybe<Order>;
  homeowner?: InputMaybe<Order>;
  market?: InputMaybe<Order>;
};

export type ProjectsPageResult = {
  __typename?: 'ProjectsPageResult';
  entities: Array<Project>;
  pageInfo: PageInfo;
};

export type ProjectTeamMemberByRoleFilter = {
  userId: Scalars['ID'];
  role: ProjectRole;
};

export type ProjectStagesFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  stage?: InputMaybe<Array<Stage>>;
};

export type EarnedValueCurve = {
  __typename?: 'EarnedValueCurve';
  label: Scalars['String'];
  data: Array<EarnedValueDataPoint>;
};

export type EarnedValueDataPoint = {
  __typename?: 'EarnedValueDataPoint';
  date: Scalars['Date'];
  value: Scalars['Int'];
};

export type ExportProjectBillsInput = {
  id: Array<Scalars['ID']>;
  title: Scalars['String'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  minBillAmountInCents?: InputMaybe<Scalars['Int']>;
};

export type SiteSpecificCostInput = {
  costCode: Scalars['String'];
  costInCents: Scalars['Int'];
};

export type CreateProjectFromReadyPlanConfigInput = {
  lotPartitionId: Scalars['String'];
  rpcId: Scalars['ID'];
  siteSpecificCosts: Array<SiteSpecificCostInput>;
  buildAddress: AddressInput;
  buildType: Scalars['String'];
  startDate: Scalars['Date'];
};

export type CreateProjectFromReadyPlanInput = {
  /** lotPartitionId is required for non-test projects */
  lotPartitionId?: InputMaybe<Scalars['String']>;
  /**  Used to create projects from Community product offerings.  */
  parentId?: InputMaybe<Scalars['ID']>;
  rpId: Scalars['ID'];
  rpoIds: Array<Scalars['ID']>;
  siteSpecificCosts: Array<SiteSpecificCostInput>;
  buildAddress: AddressInput;
  buildType: Scalars['String'];
  startDate: Scalars['Date'];
  orientation?: InputMaybe<ProjectReadyPlanConfigOrientation>;
  directCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']>;
  indirectCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']>;
  customerId?: InputMaybe<Scalars['ID']>;
  customerOwnerEntityId?: InputMaybe<Scalars['ID']>;
  enableProductConfigPlan?: InputMaybe<Scalars['Boolean']>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  primaryProjectId?: InputMaybe<Scalars['ID']>;
};

export type ProjectsToUpdateByTemplatesInput = {
  /**  The template that will be applied to the project, should only be 1.  */
  templates: Array<Scalars['ID']>;
  milestones?: InputMaybe<Array<Scalars['ID']>>;
  milestoneStartDate?: InputMaybe<DateFilter2>;
};

export type ProjectsToUpdateByTemplatesResult = {
  __typename?: 'ProjectsToUpdateByTemplatesResult';
  projectsToUpdate: Array<ProjectToUpdate>;
};

export type ProjectToUpdate = {
  __typename?: 'ProjectToUpdate';
  project: Project;
  /** @deprecated This is expensive to calculate, so returning empty for now */
  optionsToUpdate: Array<OptionToUpdate>;
  /** @deprecated Project do not really have a unified 'current template' */
  currentTemplate?: Maybe<ItemTemplate>;
  /**  The version of the template that will be applied to the project.  */
  proposedTemplate: ItemTemplate;
};

export type OptionToUpdate = {
  __typename?: 'OptionToUpdate';
  affectedPOs: Array<Commitment>;
  affectedPOsCount: Scalars['Int'];
  optionOrReadyPlan: HasDisplayName;
};

export type ProjectBudgetFinancials = {
  __typename?: 'ProjectBudgetFinancials';
  originalBudgetInCents: Scalars['Int'];
  currentBudgetInCents: Scalars['Int'];
  originalRevenueInCents: Scalars['Int'];
  currentRevenueInCents: Scalars['Int'];
};

export type ApplyInvoiceScheduleInput = {
  projectId: Scalars['ID'];
};

export type ApplyInvoiceScheduleResult = {
  __typename?: 'ApplyInvoiceScheduleResult';
  invoiceSchedule?: Maybe<InvoiceSchedule>;
};

export type ExportProjectBillsResult = {
  __typename?: 'ExportProjectBillsResult';
  googleDriveFolderId: Scalars['String'];
};

export type OptionWithCutoffDate = {
  __typename?: 'OptionWithCutoffDate';
  option: ReadyPlanOption;
  cutoffDate?: Maybe<Scalars['Date']>;
};

export type ProjectCompletedTaskBudgetReview = {
  __typename?: 'ProjectCompletedTaskBudgetReview';
  bucket: Scalars['String'];
  costInCents: Scalars['Int'];
};

export type ProjectBudgetFilter = {
  costCodes?: InputMaybe<Array<Scalars['ID']>>;
};

export type ProjectDirectMarginGraphFilter = {
  childProject?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Array<ProjectStatus>>;
  fromDate?: InputMaybe<Scalars['Date']>;
};

export type ProjectDirectMarginGraph = {
  __typename?: 'ProjectDirectMarginGraph';
  resolution: ProjectDirectMarginGraphResolution;
  data: Array<ProjectDirectMarginGraphData>;
};

export type ProjectDirectMarginGraphData = {
  __typename?: 'ProjectDirectMarginGraphData';
  date: Scalars['Date'];
  directMarginInBasisPoints?: Maybe<Scalars['Int']>;
};

export enum ProjectDirectMarginGraphResolution {
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly'
}

export type ProjectChangeEventGraphsFilter = {
  projectIds?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Array<ProjectStatus>>;
  fromDate?: InputMaybe<Scalars['Date']>;
};

export type ProjectChangeEventGraphsResult = {
  __typename?: 'ProjectChangeEventGraphsResult';
  graphs: Array<ProjectChangeEventGraph>;
};

export type ProjectChangeEventGraph = {
  __typename?: 'ProjectChangeEventGraph';
  type: ProjectChangeEventGraphType;
  data: Array<ProjectChangeEventGraphData>;
};

export type ProjectChangeEventGraphData = {
  __typename?: 'ProjectChangeEventGraphData';
  name: Scalars['String'];
  totalCostInCents: Scalars['Int'];
  timesUsed?: Maybe<Scalars['Int']>;
};

export enum ProjectChangeEventGraphType {
  Reason = 'Reason',
  CostDivision = 'CostDivision'
}

export type CompanyInfo = {
  __typename?: 'CompanyInfo';
  name: Scalars['String'];
  licenseNumber: Scalars['String'];
  phoneNumber: Scalars['String'];
  email: Scalars['String'];
  accountNumber: Scalars['String'];
  federalId: Scalars['String'];
};

export type RelevantProjectBidPackage = {
  __typename?: 'RelevantProjectBidPackage';
  id: Scalars['ID'];
  bidPackage: BidPackage;
  totalCostInCents: Scalars['Int'];
  preferredBidContractRevision: BidContractRevision;
  existingCommitments: Array<CommitmentLike>;
};

export type ProjectAllocationRule = {
  __typename?: 'ProjectAllocationRule';
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  allocationStrategy: AllocationStrategyDetail;
  project: Project;
  costCodes: Array<CostCode>;
  canDelete: PotentialOperation2;
};

export type SaveProjectAllocationRuleInput = {
  id?: InputMaybe<Scalars['ID']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  allocationStrategy?: InputMaybe<AllocationStrategy>;
  projectId?: InputMaybe<Scalars['ID']>;
  costCodes?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveProjectAllocationRuleResult = {
  __typename?: 'SaveProjectAllocationRuleResult';
  projectAllocationRule: ProjectAllocationRule;
};

export type ProjectCollaborator = MaybeHasProject & {
  __typename?: 'ProjectCollaborator';
  id: Scalars['ID'];
  project: Project;
  collaborator: Client;
  role: ProjectCollaboratorRole;
  roleDetail: ProjectCollaboratorRoleDetail;
  /** @deprecated use inviteSentAt instead */
  inviteSent?: Maybe<Scalars['DateTime']>;
  inviteSentAt?: Maybe<Scalars['DateTime']>;
};

export type SaveProjectCollaboratorInput = {
  projectId: Scalars['ID'];
  client: ClientInput;
  role: ProjectCollaboratorRole;
};

export type SendInviteEmailInput = {
  projectCollaboratorId: Scalars['ID'];
};

export type SendInviteEmailResult = {
  __typename?: 'SendInviteEmailResult';
  projectCollaborator: ProjectCollaborator;
};

export type DeleteProjectCollaboratorInput = {
  projectCollaboratorId: Scalars['ID'];
};

export type ProjectContact = {
  __typename?: 'ProjectContact';
  id: Scalars['ID'];
  fullName: Scalars['String'];
  phoneNumber: Scalars['String'];
  email: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  project: Project;
  warrantyTickets: Array<WarrantyTicket>;
};

export type SaveProjectContactInput = {
  id?: InputMaybe<Scalars['ID']>;
  fullName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['ID']>;
};

export type SaveProjectContactResult = {
  __typename?: 'SaveProjectContactResult';
  projectContact: ProjectContact;
};

export type ProjectCostCodeFilter = {
  id?: InputMaybe<Scalars['ID']>;
  project?: InputMaybe<Array<Scalars['ID']>>;
  projectRecursive?: InputMaybe<Array<Scalars['ID']>>;
  costCode?: InputMaybe<Array<Scalars['ID']>>;
};

export type ProjectCostCodesPageResult = {
  __typename?: 'ProjectCostCodesPageResult';
  entities: Array<ProjectCostCode>;
  pageInfo: PageInfo;
};

export type ProjectDocumentAssociation = {
  __typename?: 'ProjectDocumentAssociation';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  document: Document;
  project: Project;
};

export type ProjectDocumentAssociationInput = {
  projectId: Scalars['ID'];
  delete?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectInvoiceSetting = {
  __typename?: 'ProjectInvoiceSetting';
  id: Scalars['ID'];
  markupValuePercent?: Maybe<Scalars['Int']>;
  insuranceCostInCents?: Maybe<Scalars['Int']>;
  insuranceMarkupPercent?: Maybe<Scalars['Int']>;
  requireWorkAuthorization?: Maybe<Scalars['Boolean']>;
  includesContractIncludesRetainage?: Maybe<Scalars['Boolean']>;
  retainageAmountPercent?: Maybe<Scalars['Int']>;
  requireGFormat?: Maybe<Scalars['Boolean']>;
  requireTpCopiesBills?: Maybe<Scalars['Boolean']>;
  requireTpSummaryListBills?: Maybe<Scalars['Boolean']>;
  requireTpConditionalLw?: Maybe<Scalars['Boolean']>;
  requireTpUnconditionalLw?: Maybe<Scalars['Boolean']>;
  requireHbConditionalLw?: Maybe<Scalars['Boolean']>;
  requireHbUnconditionalLw?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  markupApplicationMethod?: Maybe<MarkupApplicationMethodDetail>;
  project: Project;
};

export type SaveProjectInvoiceSettingInput = {
  id?: InputMaybe<Scalars['ID']>;
  markupValuePercent?: InputMaybe<Scalars['Int']>;
  insuranceCostInCents?: InputMaybe<Scalars['Int']>;
  insuranceMarkupPercent?: InputMaybe<Scalars['Int']>;
  requireWorkAuthorization?: InputMaybe<Scalars['Boolean']>;
  includesContractIncludesRetainage?: InputMaybe<Scalars['Boolean']>;
  retainageAmountPercent?: InputMaybe<Scalars['Int']>;
  requireGFormat?: InputMaybe<Scalars['Boolean']>;
  requireTpCopiesBills?: InputMaybe<Scalars['Boolean']>;
  requireTpSummaryListBills?: InputMaybe<Scalars['Boolean']>;
  requireTpConditionalLw?: InputMaybe<Scalars['Boolean']>;
  requireTpUnconditionalLw?: InputMaybe<Scalars['Boolean']>;
  requireHbConditionalLw?: InputMaybe<Scalars['Boolean']>;
  requireHbUnconditionalLw?: InputMaybe<Scalars['Boolean']>;
  markupApplicationMethod?: InputMaybe<MarkupApplicationMethod>;
  projectId?: InputMaybe<Scalars['ID']>;
};

export type SaveProjectInvoiceSettingResult = {
  __typename?: 'SaveProjectInvoiceSettingResult';
  projectInvoiceSetting: ProjectInvoiceSetting;
};

/**  The pre-negotiated bid contract for this scope of work.  */
export type PotentialBidContractLineItem = {
  __typename?: 'PotentialBidContractLineItem';
  /**  The primary add BCLI for this scope (i.e. there could be other option modifications.) */
  bidContractLineItem: BidContractLineItem;
  /**  All BCLIs for this scope, i.e. the plan item + any option modifications item.  */
  bidContractLineItems: Array<BidContractLineItem>;
  /**  The cost for this Trade Partner to do the work (including any option modifications).  */
  totalCostInCents: Scalars['Int'];
};

export type ProjectItemScopeChange = {
  __typename?: 'ProjectItemScopeChange';
  quantity?: Maybe<Scalars['Int']>;
  costInCents: Scalars['Int'];
  priceInCents: Scalars['Int'];
  tradePartnerNote?: Maybe<Scalars['String']>;
  specifications?: Maybe<Scalars['String']>;
  shortName: Scalars['String'];
};

export type BudgetPhaseRollup = {
  __typename?: 'BudgetPhaseRollup';
  original: Scalars['Int'];
  prebid: Scalars['Int'];
  prebidChange: Scalars['Int'];
  awarded: Scalars['Int'];
  awardedChange: Scalars['Int'];
  revised: Scalars['Int'];
  revisedChange: Scalars['Int'];
};

export type ProjectItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  projectStageId?: InputMaybe<Scalars['ID']>;
  slotId?: InputMaybe<Scalars['ID']>;
  itemId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /**  priceInCents deprecated in favor of totalPriceInCents and quantity  */
  priceInCents?: InputMaybe<Scalars['Int']>;
  totalPriceInCents?: InputMaybe<Scalars['Int']>;
  /**  costInCents deprecated in favor of totalCostInCents and quantity */
  costInCents?: InputMaybe<Scalars['Int']>;
  /**  unitCostInCents deprecated in favor of totalCostInCents and quantity */
  unitCostInCents?: InputMaybe<Scalars['Int']>;
  totalCostInCents?: InputMaybe<Scalars['Int']>;
  markupBasisPoints?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['ID']>;
  costType?: InputMaybe<CostType>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']>;
  tradePartnerNote?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Scalars['String']>;
  internalNote?: InputMaybe<Scalars['String']>;
  costConfidence?: InputMaybe<CostConfidence>;
  buyoutStatus?: InputMaybe<BuyoutStatus>;
  /**  The bid contract to use for auto-creating a pre-negotiated Commitment.  */
  bidContractLineItemId?: InputMaybe<Scalars['ID']>;
  taskId?: InputMaybe<Scalars['ID']>;
  bidItemId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  allocationReason?: InputMaybe<Scalars['String']>;
  materialVariantId?: InputMaybe<Scalars['ID']>;
  globalPlanTaskId?: InputMaybe<Scalars['ID']>;
  packageDesignNotes?: InputMaybe<Scalars['String']>;
};

export type ProjectItemsInput = {
  projectItems: Array<ProjectItemInput>;
  bidItemId?: InputMaybe<Scalars['ID']>;
};

export type DuplicateProjectItemsInput = {
  projectItemIds: Array<Scalars['ID']>;
};

export type DuplicateProjectItemsResult = {
  __typename?: 'DuplicateProjectItemsResult';
  projectItems: Array<ProjectItem>;
};

export type SaveProjectItemsResult = HasUserErrors & {
  __typename?: 'SaveProjectItemsResult';
  projectItems?: Maybe<Array<ProjectItem>>;
  userErrors?: Maybe<Array<UserError>>;
};

export type ProjectItemFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  projectStage?: InputMaybe<Array<Scalars['ID']>>;
  project?: InputMaybe<Array<Scalars['ID']>>;
  item?: InputMaybe<ItemFilter>;
  location?: InputMaybe<LocationFilter>;
  locationInPath?: InputMaybe<Array<Scalars['ID']>>;
  buyoutStatus?: InputMaybe<Array<BuyoutStatus>>;
  costCode?: InputMaybe<Array<Scalars['ID']>>;
  costType?: InputMaybe<Array<CostType>>;
  costClassification?: InputMaybe<Array<CostClassificationType>>;
  division?: InputMaybe<Array<Scalars['ID']>>;
  /** Indicates that the ProjectItem has been essentially removed from the project, but is not hard/soft-deleted due to other constraints. */
  isRemovedScope?: InputMaybe<Scalars['Boolean']>;
  /**  @deprecated  */
  isAllowance?: InputMaybe<Scalars['Boolean']>;
  isProduct?: InputMaybe<Scalars['Boolean']>;
  templateId?: InputMaybe<Array<Scalars['ID']>>;
  includeCreatedFromProposedChangeEvent?: InputMaybe<Scalars['Boolean']>;
  excludeBillTypes?: InputMaybe<Array<BillType>>;
  excludeFromPurchaseOrders?: InputMaybe<Scalars['Boolean']>;
  excludeUnderwritingBudget?: InputMaybe<Scalars['Boolean']>;
  /**  Returns ProjectItems that have either unit-based or plan-based v2 bids in the project's market.  */
  hasBids?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type DeleteProjectItemInput = {
  id: Scalars['ID'];
};

export type ProjectItemLike = {
  name: Scalars['String'];
  specifications?: Maybe<Scalars['String']>;
  tradePartnerNote?: Maybe<Scalars['String']>;
  slot: ItemSlot;
  item: Item;
  quantity?: Maybe<Scalars['Int']>;
  totalPriceInCents: Scalars['Int'];
  totalCostInCents: Scalars['Int'];
  location: Location;
  unitOfMeasure: UnitOfMeasure;
  costType: CostType;
  preferredPotentialBidContractLineItem?: Maybe<PotentialBidContractLineItem>;
  itemTemplateItem?: Maybe<BaseItemLike>;
  modifyingTemplateItems: Array<BaseItemLike>;
  bidItem?: Maybe<BidItem>;
};

export type DeleteProjectItemsInput = {
  id: Array<Scalars['ID']>;
};

export type CostLineItemEntity = Bill | Expense;

export type CostLineItem = {
  __typename?: 'CostLineItem';
  id: Scalars['ID'];
  amountInCents: Scalars['Int'];
  historicAmountInvoiced: Scalars['Int'];
  costDate: Scalars['Date'];
  isTradePartnerCredit: Scalars['Boolean'];
  entity: CostLineItemEntity;
  tradePartnerNumber: Scalars['String'];
};

export type ProjectItemBudgetFinancials = {
  __typename?: 'ProjectItemBudgetFinancials';
  original: Scalars['Int'];
  awarded: Scalars['Int'];
  changeEvents: Scalars['Int'];
  nonChargeableChangeEvents: Scalars['Int'];
  chargeableChangeEvents: Scalars['Int'];
  proposedChangeEvents: Scalars['Int'];
  reallocations: Scalars['Int'];
  revisedInternalBudget: Scalars['Int'];
  revisedExternalBudget: Scalars['Int'];
  committed: Scalars['Int'];
  uncommitted: Scalars['Int'];
  tradeBilled: Scalars['Int'];
  tradePaidToDate: Scalars['Int'];
  unpaidCommitments: Scalars['Int'];
  projected: Scalars['Int'];
};

export type ProjectItemsPage = {
  __typename?: 'ProjectItemsPage';
  projectItems: Array<ProjectItem>;
  pageInfo: PageInfo;
};

export type ProjectItemAllocation = {
  __typename?: 'ProjectItemAllocation';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  childProject: Project;
  parentProjectItem: ProjectItem;
  commitmentLineItemAllocations: Array<CommitmentLineItemAllocation>;
  homeownerContractLineItemAllocations: Array<HomeownerContractLineItemAllocation>;
  changeEventLineItemAllocations: Array<ChangeEventLineItemAllocation>;
  billLineItemAllocations: Array<BillLineItemAllocation>;
  expenseAllocationAllocations: Array<ExpenseAllocationAllocation>;
  isActive: Scalars['Boolean'];
  revisedPriceInCents: Scalars['Int'];
  /** Hierarchy Budget Fields */
  originalCostInCents: Scalars['Int'];
  startCostInCents: Scalars['Int'];
  changeEventCostInCents: Scalars['Int'];
  revisedCostInCents: Scalars['Int'];
  projectedCostInCents: Scalars['Int'];
  committedCostInCents: Scalars['Int'];
  availableCostInCents: Scalars['Int'];
  billedCostInCents: Scalars['Int'];
  unbilledCostInCents: Scalars['Int'];
  /**
   * Deprecated Fields
   * @deprecated renamed to revisedCostInCents
   */
  revisedApprovedBudgetInCents: Scalars['Int'];
};

export type ProjectLotDetail = {
  __typename?: 'ProjectLotDetail';
  id: Scalars['ID'];
  lotNumber?: Maybe<Scalars['Int']>;
  block?: Maybe<Scalars['Int']>;
  section?: Maybe<Scalars['Int']>;
  lotSquareFootage?: Maybe<Scalars['Int']>;
  elevationCertificateDocumentRequired?: Maybe<Scalars['Boolean']>;
  /** @deprecated Replaced by setBackFrontInFeet. */
  setBackFront?: Maybe<Scalars['Int']>;
  /** @deprecated Replaced by setBackRightInFeet. */
  setBackRight?: Maybe<Scalars['Int']>;
  /** @deprecated Replaced by setBackLeftInFeet. */
  setBackLeft?: Maybe<Scalars['Int']>;
  /** @deprecated Replaced by setBackRearInFeet. */
  setBackRear?: Maybe<Scalars['Int']>;
  hoa?: Maybe<Scalars['Boolean']>;
  hoaSpecificModifications?: Maybe<Scalars['String']>;
  siteSpecificModifications?: Maybe<Scalars['String']>;
  fireSprinklersRequired?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  constructionType?: Maybe<ConstructionTypeDetail>;
  floodPlain?: Maybe<FloodPlainDetail>;
  foundationType?: Maybe<FoundationTypeDetail>;
  project: Project;
  userEvents: Array<UserEvent>;
  floodZone?: Maybe<FloodZoneDetail>;
  setBackFrontInFeet?: Maybe<Scalars['Float']>;
  setBackLeftInFeet?: Maybe<Scalars['Float']>;
  setBackRightInFeet?: Maybe<Scalars['Float']>;
  setBackRearInFeet?: Maybe<Scalars['Float']>;
};

export type SaveProjectLotDetailsInput = {
  projectLotDetails: Array<SaveProjectLotDetailInput>;
};

export type SaveProjectLotDetailInput = {
  id?: InputMaybe<Scalars['ID']>;
  lotNumber?: InputMaybe<Scalars['Int']>;
  block?: InputMaybe<Scalars['Int']>;
  section?: InputMaybe<Scalars['Int']>;
  lotSquareFootage?: InputMaybe<Scalars['Int']>;
  /** @deprecated Replaced by setBackFrontInFeet. */
  setBackFront?: InputMaybe<Scalars['Int']>;
  /** @deprecated Replaced by setBackRightInFeet. */
  setBackRight?: InputMaybe<Scalars['Int']>;
  /** @deprecated Replaced by setBackLeftInFeet. */
  setBackLeft?: InputMaybe<Scalars['Int']>;
  /** @deprecated Replaced by setBackRearInFeet. */
  setBackRear?: InputMaybe<Scalars['Int']>;
  hoa?: InputMaybe<Scalars['Boolean']>;
  hoaSpecificModifications?: InputMaybe<Scalars['String']>;
  siteSpecificModifications?: InputMaybe<Scalars['String']>;
  fireSprinklersRequired?: InputMaybe<Scalars['Boolean']>;
  constructionType?: InputMaybe<ConstructionType>;
  floodPlain?: InputMaybe<FloodPlain>;
  foundationType?: InputMaybe<FoundationType>;
  projectId?: InputMaybe<Scalars['ID']>;
  floodZone?: InputMaybe<FloodZone>;
  setBackFrontInFeet?: InputMaybe<Scalars['Float']>;
  setBackLeftInFeet?: InputMaybe<Scalars['Float']>;
  setBackRightInFeet?: InputMaybe<Scalars['Float']>;
  setBackRearInFeet?: InputMaybe<Scalars['Float']>;
};

export type SaveProjectLotDetailsResult = {
  __typename?: 'SaveProjectLotDetailsResult';
  projectLotDetails: Array<ProjectLotDetail>;
};

export type ProjectLotDetailFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  project?: InputMaybe<Array<Scalars['ID']>>;
};

export type ProjectReadyPlanConfig = HasBlueprintUrl & ReadyPlanConfigLike & {
  __typename?: 'ProjectReadyPlanConfig';
  id: Scalars['ID'];
  /**  Not defined for now, satisfies the ReadyPlanConfigLike interface.  */
  name?: Maybe<Scalars['String']>;
  project: Project;
  /**  Projects as new as p:1558 still have PRPCs w/o `readyPlan`s set, so leave this as nullable.  */
  readyPlan?: Maybe<ReadyPlanLike>;
  /**
   * The ProductOffering (ReadyPlan v2) associated with this ProjectReadyPlanConfig.
   *
   * This should only be used in H1 tech-only codepaths, as in ReadyPlan v1 codepaths the ReadyPlan
   * won't be a ProductOffering, and for legacy data might also be undefined.
   */
  productOffering?: Maybe<ProductOffering>;
  blueprintUrl: Url;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  orientation: ProjectReadyPlanConfigOrientation;
  orientationDetail: ProjectReadyPlanConfigOrientationDetail;
  constructionStartDate?: Maybe<Scalars['Date']>;
  internalNote?: Maybe<Scalars['String']>;
  /** @deprecated Use options and option types */
  specOption?: Maybe<ProjectReadyPlanConfigOption>;
  /** @deprecated Use options and option types */
  elevationOption?: Maybe<ProjectReadyPlanConfigOption>;
  /** @deprecated Use options and option types */
  exteriorPaletteOption?: Maybe<ProjectReadyPlanConfigOption>;
  /** @deprecated Use options and option types */
  interiorOption?: Maybe<ProjectReadyPlanConfigOption>;
  options: Array<ProjectReadyPlanConfigOption>;
  /**  Returns the ReadyPlanOptions directly, sorted by group order.  */
  readyPlanOptions: Array<ReadyPlanOption>;
  supportedSpecOptions: Array<ReadyPlanOption>;
  applied: Scalars['Boolean'];
  lastAppliedAt?: Maybe<Scalars['DateTime']>;
  /**
   * Indicates whether the current configuration can be applied. Allowed if:
   * 1) An initial `ObligationDocument` has been signed.
   * 2) The configuration is `Complete`, IE a ReadyPlan, spec level, elevation and palette option have been selected at a minimum
   * 3) There are Active templates for all configured options
   * 4) Project effective scope mode is Full
   */
  canApply: PotentialOperation2;
  /**
   * Indicates whether the current configuration can be released to trades. Allowed if the same 3 first reasons from canApply plus:
   * 4) Project effective scope mode is Full or Release to Trades
   */
  canRelease: PotentialOperation2;
  /**
   * When there is a CE open on a Project that was generated from a previous Lot Config, disable
   * edits to that project's configuraiton so we don't end up duplicating changes on a proejct.
   */
  canEdit: PotentialOperation2;
  programData?: Maybe<ProgramData>;
  deliveryDate?: Maybe<Scalars['Date']>;
  configurationUpdatedAt: Scalars['DateTime'];
  programDataMatchState: ProgramDataMatchStateDetail;
  computedProgramData: ProgramData;
  /**
   * This flag will be used in the FE to know wether to auto populate the empty program data fields
   * right now we will only set it to true for newly added configurations, never updated before (createdAt = updatedAt)
   */
  autoPopulateWithComputedProgramData: Scalars['Boolean'];
  insideMapsRoomRenderings: Array<InsideMapsRoomRendering>;
  includedPriceInCents?: Maybe<Scalars['Int']>;
  /** Pre-computed texture swaps and camera data for InsideMaps rendering */
  insideMapsTextureSwaps?: Maybe<InsideMapsTextureSwaps>;
  includedOptions: Array<ReadyPlanOption>;
  /** POF only: Exterior rendering asset for this config */
  exteriorRendering?: Maybe<Asset>;
  aggregateVersion?: Maybe<ReadyPlanAggregateVersion>;
  /**
   * The offering's option groups that have active options, each option paired with whether it's already
   * on the project (`isSelected`), whether it can be selected (conflicts / unmet prerequisites against
   * the project's current options) and its cost/price delta.
   * Reflects the offering's pinned version, so for versioned offerings this errors unless it is reached
   * via the `projectReadyPlanConfig` query, which pins the config's version.
   */
  potentialOptionGroups: Array<ProjectReadyPlanConfigPotentialOptionGroup>;
};


export type ProjectReadyPlanConfigReadyPlanOptionsArgs = {
  forDesignPackages?: InputMaybe<Scalars['Boolean']>;
};


export type ProjectReadyPlanConfigInsideMapsTextureSwapsArgs = {
  debugParts?: InputMaybe<Array<Scalars['String']>>;
};

/**  A ReadyPlanOptionGroup with the offering's active options within it, in the context of a project.  */
export type ProjectReadyPlanConfigPotentialOptionGroup = PotentialOptionGroupLike & {
  __typename?: 'ProjectReadyPlanConfigPotentialOptionGroup';
  id: Scalars['ID'];
  group: ReadyPlanOptionGroup;
  options: Array<ProjectReadyPlanConfigPotentialOption>;
  /**
   *  This option group is allowed to be selected if it has all necessary prerequisites met.
   * @deprecated Use canBeSelected instead.
   */
  isEnabled: Scalars['Boolean'];
  /**
   * Whether this option group can be selected, with human-readable reasons when it cannot, i.e. its
   * prerequisites are not met.
   */
  canBeSelected: PotentialOperation2;
};

/**  An offering option in the context of a project, with why it's disabled (if so) and the incremental cost/price.  */
export type ProjectReadyPlanConfigPotentialOption = PotentialOptionLike & {
  __typename?: 'ProjectReadyPlanConfigPotentialOption';
  id: Scalars['ID'];
  option: ReadyPlanOption;
  /**  Whether the project already has this option, i.e. clients can use this to show/hide already-added options.  */
  isSelected: Scalars['Boolean'];
  /**
   *  Whether this option can be selected, i.e. `canBeSelected.allowed`.
   * @deprecated Use canBeSelected instead.
   */
  isEnabled: Scalars['Boolean'];
  /**  allowed=false with disabledReasons when the option conflicts with / is missing prerequisites for the project's current options.  */
  canBeSelected: PotentialOperation2;
  /**  Incremental cost of this option against the project's current configuration.  */
  totalCostInCents: Scalars['Int'];
  /**  Incremental price of this option against the project's current configuration.  */
  totalPriceInCents: Scalars['Int'];
};

export type SaveProjectReadyPlanConfigsInput = {
  projectReadyPlanConfigs: Array<SaveProjectReadyPlanConfigInput>;
  /**  Indicates whether to overwrite the existing program data with the computed ones automatically  */
  overwriteProgramDataWithComputed?: InputMaybe<Scalars['Boolean']>;
};

export type SaveProjectReadyPlanConfigInput = {
  id?: InputMaybe<Scalars['ID']>;
  internalNote?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['ID']>;
  readyPlanId?: InputMaybe<Scalars['ID']>;
  aggregateVersionId?: InputMaybe<Scalars['ID']>;
  /**
   * When specified, must include all `ProjectReadyPlanConfigOptions` which should be associated.
   * Any existing entities which are omitted will be deleted.
   */
  options?: InputMaybe<Array<SaveProjectReadyPlanConfigOptionInput>>;
  /** When specified, updates the PD data associated with the PRPC. */
  programData?: InputMaybe<SaveProgramDataInput>;
  orientation?: InputMaybe<ProjectReadyPlanConfigOrientation>;
  originalReadyPlanConfigurationId?: InputMaybe<Scalars['ID']>;
  programDataMatchState?: InputMaybe<ProgramDataMatchState>;
  includedPriceInCents?: InputMaybe<Scalars['Int']>;
};

export type SaveProjectReadyPlanConfigsResult = {
  __typename?: 'SaveProjectReadyPlanConfigsResult';
  projectReadyPlanConfigs: Array<ProjectReadyPlanConfig>;
};

export type ProjectReadyPlanConfigFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  readyPlan?: InputMaybe<Array<Scalars['ID']>>;
  development?: InputMaybe<Array<Scalars['ID']>>;
  cohort?: InputMaybe<Array<Scalars['ID']>>;
  globalOption?: InputMaybe<Array<Scalars['ID']>>;
  constructionStartDate?: InputMaybe<DateFilter2>;
};

export type ApplyProjectReadyPlanConfigsInput = {
  /**
   *  Apply the latest ItemTemplate versions for the specified PRPCs.
   * @deprecated Use filter instead
   */
  projectReadyPlanConfigs?: InputMaybe<Array<Scalars['ID']>>;
  /**  Apply the latest ItemTemplate version for PRPCs matching the provided filter.  */
  filter?: InputMaybe<ProjectReadyPlanConfigFilter>;
  /**  Apply specific ItemTemplate versions for the specified PRPCs.  */
  prpcAtVersions?: InputMaybe<Array<ProjectReadyPlanConfigVersion>>;
  /**  Indicates whether to automatically accept change events for the related changes. Defaults to false.  */
  autoAcceptChangeEvents?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectReadyPlanConfigVersion = {
  prpcId: Scalars['ID'];
  /** The ItemTemplate version to apply, it must be associated with the ReadyPlan of the PRPC */
  itemTemplateId: Scalars['ID'];
  /**
   * This option will only apply items which have changed in the specified version of the template.
   *
   * NOTE: For changed modifying option line items, the associated PI will be updated to include the version of the base and other modifying line items from this template, even if those lines were not modified in the specified version.
   */
  onlyChangedInVersion?: InputMaybe<Scalars['Boolean']>;
};

export type ApplyProjectReadyPlanConfigsResult = {
  __typename?: 'ApplyProjectReadyPlanConfigsResult';
  projectReadyPlanConfigs: Array<ProjectReadyPlanConfig>;
};

export type SyncSalesforcePrpcInput = {
  projectId: Scalars['ID'];
  /**  Will sync the PRPC even if the Opportunity has passed Closed Won  */
  force?: InputMaybe<Scalars['Boolean']>;
};

export type SaveProjectReadyPlanConfigOptionsResult = {
  __typename?: 'SaveProjectReadyPlanConfigOptionsResult';
  projectReadyPlanConfigOptions: Array<ProjectReadyPlanConfigOption>;
};

export type ProjectReadyPlanConfigOption = {
  __typename?: 'ProjectReadyPlanConfigOption';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  projectRpConfig: ProjectReadyPlanConfig;
  readyPlanOption: ReadyPlanOption;
  priceInCents: Scalars['Int'];
};

export type SaveProjectReadyPlanConfigOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  projectRpConfigId?: InputMaybe<Scalars['ID']>;
  readyPlanOptionId?: InputMaybe<Scalars['ID']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
};

export type ProjectSalesforceOpportunity = {
  __typename?: 'ProjectSalesforceOpportunity';
  id: Scalars['ID'];
  salesforceOpportunityId: Scalars['String'];
  salesforceOpportunityRecordType: Scalars['String'];
  active: Scalars['Boolean'];
  project: Project;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type ProjectSiteCondition = HasBlueprintUrl & {
  __typename?: 'ProjectSiteCondition';
  id: Scalars['ID'];
  expectedSlabPourDate?: Maybe<Scalars['Date']>;
  blueprintUrl: Url;
  drivewaySwing?: Maybe<Scalars['String']>;
  gasLocation?: Maybe<Scalars['String']>;
  electricLocation?: Maybe<Scalars['String']>;
  waterLocation?: Maybe<Scalars['String']>;
  curbGutterLinearFoot?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  project: Project;
  additionalNotes?: Maybe<Scalars['String']>;
  attachments: Array<Attachment>;
};

export type SaveProjectSiteConditionInput = {
  id?: InputMaybe<Scalars['ID']>;
  expectedSlabPourDate?: InputMaybe<Scalars['Date']>;
  drivewaySwing?: InputMaybe<Scalars['String']>;
  gasLocation?: InputMaybe<Scalars['String']>;
  electricLocation?: InputMaybe<Scalars['String']>;
  waterLocation?: InputMaybe<Scalars['String']>;
  curbGutterLinearFoot?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['ID']>;
  additionalNotes?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
};

export type SaveProjectSiteConditionResult = {
  __typename?: 'SaveProjectSiteConditionResult';
  projectSiteCondition: ProjectSiteCondition;
};

export type SendProjectSiteConditionsNotificationInput = {
  projectSiteConditionId: Scalars['ID'];
  internalUserIds: Array<Scalars['ID']>;
};

export type ProjectSiteSpecificInfo = {
  __typename?: 'ProjectSiteSpecificInfo';
  id: Scalars['ID'];
  perSiteBudgetInCents?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  project: Project;
  siteSpecificInfo: SiteSpecificInfo;
};

export type SaveProjectSiteSpecificInfoInput = {
  id?: InputMaybe<Scalars['ID']>;
  perSiteBudgetInCents?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
  siteSpecificInfoId: Scalars['ID'];
};

export type SaveProjectSiteSpecificInfoResult = {
  __typename?: 'SaveProjectSiteSpecificInfoResult';
  projectSiteSpecificInfo: ProjectSiteSpecificInfo;
};

export type ProjectSnapshot = {
  __typename?: 'ProjectSnapshot';
  id: Scalars['ID'];
  grossSalesPriceInCents?: Maybe<Scalars['Int']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']>;
  totalCostInCents?: Maybe<Scalars['Int']>;
  totalHardCostInCents?: Maybe<Scalars['Int']>;
  totalSoftCostInCents?: Maybe<Scalars['Int']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']>;
  purchaseCostInCents?: Maybe<Scalars['Int']>;
  startDate: Scalars['Date'];
  endDate?: Maybe<Scalars['Date']>;
};

export type DeprecatedUnitFilter = {
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
};

export type StageProgress = {
  __typename?: 'StageProgress';
  /** This will be the associated ProjectStage id */
  id: Scalars['ID'];
  taskProgress: ProgressSummary;
};

export type CompleteStageInput = {
  projectId: Scalars['ID'];
  stage: Stage;
};

export type SaveProjectStageInput = {
  id?: InputMaybe<Scalars['ID']>;
  /**  Some legacy callers pass in projectId+stage to update the project stage.  */
  projectId?: InputMaybe<Scalars['ID']>;
  stage?: InputMaybe<Stage>;
  projectStageStatus?: InputMaybe<ProjectStageStatus>;
  clientPresentationDate?: InputMaybe<Scalars['Date']>;
  /** Confirms that an unusual status change transition is intentionally being performed */
  confirmStatusException?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<Scalars['Int']>;
  baselineDuration?: InputMaybe<Scalars['Int']>;
};

export type ProjectStageHomeownerFinancials = {
  __typename?: 'ProjectStageHomeownerFinancials';
  homeownerPriceInCents: Scalars['Int'];
  amountInvoicedInCents: Scalars['Int'];
  amountPaidInCents: Scalars['Int'];
  balanceInCents: Scalars['Int'];
  financialsLastUpdate: Scalars['Date'];
};

export type ProjectStageHocFinancials = {
  __typename?: 'ProjectStageHocFinancials';
  originalContractValueInCents: Scalars['Int'];
  originalBudgetedCostInCents: Scalars['Int'];
  originalGrossMarginBasisPoints: Scalars['Int'];
  valueInCents: Scalars['Int'];
  costInCents: Scalars['Int'];
  grossMarginBasisPoints: Scalars['Int'];
  paidFromHomeownerInCents: Scalars['Int'];
  paidToTradesInCents: Scalars['Int'];
  paidNetInCents: Scalars['Int'];
  marginErosionBasisPoints: Scalars['Int'];
};

export type ItemLocationsFilter = {
  isProduct?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectStageTemplateConfig = ProjectStageTemplateConfigLike & Named & {
  __typename?: 'ProjectStageTemplateConfig';
  id: Scalars['ID'];
  /** @deprecated Use the parent instead */
  itemTemplate: ItemTemplate;
  parent: BaseItemParentVersion;
  projectStage: ProjectStage;
  /**  Whether this template can be removed/changed, or false if it's too late to change b/c the work is already billed.  */
  canEdit: PotentialOperation2;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  totalCostInCents: Scalars['Int'];
  onlyChangedInVersion?: Maybe<Scalars['Boolean']>;
  changeEvent?: Maybe<ChangeEvent>;
};

/** Allows for the frontend to work with ProjectStageTemplateConfig and ChangeEventTemplateConfig in a polymorphic way. */
export type ProjectStageTemplateConfigLike = {
  id: Scalars['ID'];
  /** @deprecated Use the parent instead */
  itemTemplate: ItemTemplate;
  projectStage: ProjectStage;
  changeEvent?: Maybe<ChangeEvent>;
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  onlyChangedInVersion?: Maybe<Scalars['Boolean']>;
};

export type ProjectStatusChange = {
  __typename?: 'ProjectStatusChange';
  id: Scalars['ID'];
  internalNote?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  project: Project;
  reason?: Maybe<ProjectStatusChangeReason>;
  date?: Maybe<Scalars['Date']>;
};

export type ProjectStatusChangeInput = {
  reasonId?: InputMaybe<Scalars['ID']>;
  internalNote?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
};

export type ProjectStatusChangeReason = Named & {
  __typename?: 'ProjectStatusChangeReason';
  id: Scalars['ID'];
  code: Scalars['String'];
  name: Scalars['String'];
  projectStatus: ProjectStatus;
  projectStatusDetail: ProjectStatusDetail;
  projectStage: Stage;
  projectStageDetail: StageDetail;
};

export type SaveProjectStatusChangeReasonsInput = {
  projectStatusChangeReasons: Array<SaveProjectStatusChangeReasonInput>;
};

export type SaveProjectStatusChangeReasonInput = {
  code: Scalars['String'];
  name: Scalars['String'];
  projectStatus: ProjectStatus;
  projectStage: Stage;
};

export type SaveProjectStatusChangeReasonsResult = {
  __typename?: 'SaveProjectStatusChangeReasonsResult';
  projectStatusChangeReasons: Array<ProjectStatusChangeReason>;
  userErrors: Array<Maybe<UserError>>;
};

export type ProjectStatusChangeReasonsFilter = {
  projectStatus?: InputMaybe<Array<ProjectStatus>>;
  projectStage?: InputMaybe<Array<Stage>>;
};

export type ProjectTeamMember = {
  __typename?: 'ProjectTeamMember';
  /**
   * Note/TODO This user field really is required at the db level, it is only nullable
   * here because we're semi-abusing the ProjectTeamMember-the-entity type for a
   * ProjectTeamMember-the-UI-row on the Project Roles page, as it wants to render
   * as roles, even if there is no team member assigned to that role yet.
   */
  user?: Maybe<InternalUser>;
  role: ProjectRoleDetail;
};

export type UpdateProjectRoleInput = {
  projectId: Scalars['ID'];
  role: ProjectRole;
  userId?: InputMaybe<Scalars['ID']>;
};

export type UpdateProjectRoleResult = {
  __typename?: 'UpdateProjectRoleResult';
  teamMember: ProjectTeamMember;
  /** @deprecated unused in practice, returns empty array */
  tasks: Array<Task>;
};

export type BulkUpdateProjectRoleResult = {
  __typename?: 'BulkUpdateProjectRoleResult';
  teamMember: ProjectTeamMember;
  /** @deprecated unused in practice, returns empty array */
  tasks: Array<Task>;
  project: Project;
};

export type BulkUpdateProjectRolesInput = {
  developmentId?: InputMaybe<Array<Scalars['ID']>>;
  cohortId?: InputMaybe<Array<Scalars['ID']>>;
  projectId?: InputMaybe<Array<Scalars['ID']>>;
  projectStatus?: InputMaybe<Array<ProjectStatus>>;
  role: ProjectRole;
  userId: Scalars['ID'];
};

export type ProjectUpdate = MaybeHasProject & {
  __typename?: 'ProjectUpdate';
  id: Scalars['ID'];
  project: Project;
  createdAt: Scalars['DateTime'];
  /** @deprecated Use createdAt instead */
  eventTime: Scalars['DateTime'];
  actionType: ProjectUpdateActionType;
  actionTypeDetail: ProjectUpdateActionTypeDetail;
  schedulePhase?: Maybe<SchedulePhase>;
  document?: Maybe<Document>;
  scheduleSubPhase?: Maybe<ScheduleSubPhase>;
  homeownerNote?: Maybe<HomeownerNote>;
};

export type EntityReferenceInput = {
  activityId?: InputMaybe<Scalars['ID']>;
  unitId?: InputMaybe<Scalars['ID']>;
  documentId?: InputMaybe<Scalars['ID']>;
};

export type ProjectUpdateInput = {
  projectId: Scalars['ID'];
  /**  defaults to now if not set  */
  eventTime?: InputMaybe<Scalars['DateTime']>;
  actionType: ProjectUpdateActionType;
  entityReference: EntityReferenceInput;
};

export type PunchlistItemFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  project?: InputMaybe<Array<Scalars['ID']>>;
  createdBy?: InputMaybe<Array<Scalars['ID']>>;
  assignee?: InputMaybe<Array<Scalars['ID']>>;
};

export type SavePunchlistItemTodosInput = {
  punchlistItemTodos: Array<SavePunchlistItemTodoInput>;
};

export type SavePunchlistItemTodoInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  order?: InputMaybe<Scalars['String']>;
  urgent?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ToDoStatus>;
  type?: InputMaybe<ToDoType>;
  createdById?: InputMaybe<Scalars['ID']>;
  assigneeId?: InputMaybe<Scalars['ID']>;
  parentId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
  tradePartnerId?: InputMaybe<Scalars['ID']>;
  attachments?: InputMaybe<Array<SaveToDoAttachmentInput>>;
  assigneeIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type SavePunchlistItemTodosResult = {
  __typename?: 'SavePunchlistItemTodosResult';
  punchlistItemTodos: Array<PunchlistItemTodo>;
};

export type SavePunchlistItemTodoResult = {
  __typename?: 'SavePunchlistItemTodoResult';
  punchlistItemTodo: PunchlistItemTodo;
};

export type SendTradePartnerPunchlistEmailInput = {
  /** list of punchlistItemTodoIds, must be assigned to a trade partner and project */
  punchlistItemTodoId: Array<Scalars['ID']>;
  /** additional trade partner contact ids to include in the email */
  tradePartnerContactId?: InputMaybe<Array<Scalars['ID']>>;
  /** additional emails to include in the email */
  additionalEmails?: InputMaybe<Array<Scalars['String']>>;
};

export type SendTradePartnerPunchlistEmailResults = {
  __typename?: 'SendTradePartnerPunchlistEmailResults';
  results?: Maybe<Array<SendTradePartnerPunchlistEmailResult>>;
};

export type SendTradePartnerPunchlistEmailResult = SendTradePartnerPunchlistEmailSuccess | SendTradePartnerPunchlistEmailFailure;

export type SendTradePartnerPunchlistEmailSuccess = {
  __typename?: 'SendTradePartnerPunchlistEmailSuccess';
  punchlistItemTodo: PunchlistItemTodo;
  emails: Array<Scalars['String']>;
};

export type SendTradePartnerPunchlistEmailFailure = {
  __typename?: 'SendTradePartnerPunchlistEmailFailure';
  punchlistItemTodoId: Scalars['ID'];
  error: Scalars['String'];
};

export type SendPunchlistExportEmailInput = {
  punchlistItemTodoId: Array<Scalars['ID']>;
  emails: Array<Scalars['String']>;
};

export type SendPunchlistExportEmailResults = {
  __typename?: 'SendPunchlistExportEmailResults';
  results?: Maybe<Array<SendPunchlistExportEmailResult>>;
};

export type SendPunchlistExportEmailResult = SendPunchlistExportEmailSuccess | SendPunchlistExportEmailFailure;

export type SendPunchlistExportEmailSuccess = {
  __typename?: 'SendPunchlistExportEmailSuccess';
  punchlistItemTodo: PunchlistItemTodo;
};

export type SendPunchlistExportEmailFailure = {
  __typename?: 'SendPunchlistExportEmailFailure';
  punchlistItemTodoId: Scalars['ID'];
  error: Scalars['String'];
};

export type RegisterPushNotificationTokenInput = {
  token: Scalars['String'];
  platform: PushNotificationPlatform;
  environment: PushNotificationEnvironment;
};

export type RegisterPushNotificationTokenResult = {
  __typename?: 'RegisterPushNotificationTokenResult';
  pushNotificationToken: PushNotificationToken;
};

export type UnregisterPushNotificationTokenInput = {
  token: Scalars['String'];
};

export type PushNotificationToken = {
  __typename?: 'PushNotificationToken';
  id: Scalars['ID'];
  token: Scalars['String'];
  lastSeenAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  platform: PushNotificationPlatformDetail;
  user: User;
  environment: PushNotificationEnvironmentDetail;
  snsEndpointArn?: Maybe<Scalars['String']>;
};

export type SavePushNotificationTokenInput = {
  environment?: InputMaybe<PushNotificationEnvironment>;
  snsEndpointArn?: InputMaybe<Scalars['String']>;
};

export type TriggerQaDatabaseResetResult = {
  __typename?: 'TriggerQaDatabaseResetResult';
  triggered: Scalars['Boolean'];
  message: Scalars['String'];
};

export type ReadyPlanLike = {
  id: Scalars['ID'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  code?: Maybe<Scalars['String']>;
  /**  The `type` + `code`, i.e. SFH-TX-1-001  */
  displayCode?: Maybe<Scalars['String']>;
  status: ReadyPlanStatusDetail;
  /**  The latest status based on the latest RPAV, which may be archived depending on the ReadyPlan's status.  */
  effectiveStatus: ReadyPlanStatusDetail;
  /**  Pass `includeInactive: true` to also return archived options, e.g. to reactivate them. Defaults to false (true for ProductOfferings).  */
  options: Array<ReadyPlanOption>;
  contingencyMarkupPercentage?: Maybe<Scalars['Float']>;
  aggregateActive?: Maybe<ReadyPlanAggregateVersion>;
  aggregateDraft?: Maybe<ReadyPlanAggregateVersion>;
  aggregateLatest: ReadyPlanAggregateVersion;
  aggregateVersions: Array<ReadyPlanAggregateVersion>;
  /**
   * This was a String! but that was when some v4 ItemTemplate contained an `it.version` and `it.scopeChangeReason` which are
   * better articulated in whatever "this aggregate I'm viewing" is. So version should now be "this version." This implies if
   * we `query { readyPlan(id: "rp:1", version: 3) { ... } }` then we'll get `rp.version.version = 3` back.
   */
  version: ReadyPlanAggregateVersion;
  /**  Locations used by TLIs in this ReadyPlan.  */
  itemLocations: Array<Location>;
  /**  CostCodes used by TLIs in this ReadyPlan.  */
  costCodes: Array<CostCode>;
  canEditLineItems: PotentialOperation2;
  canEdit: PotentialOperation2;
  documents: Array<Document>;
  /**  All downstream PRPCs referencing this ReadyPlan, either directly or indirectly via a ProductOffering  */
  projectConfigs: Array<ProjectReadyPlanConfig>;
};


export type ReadyPlanLikeOptionsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};

export type SaveReadyPlanInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  defaultVariationId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<ReadyPlanStatus>;
  developmentId?: InputMaybe<Scalars['ID']>;
  code?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ReadyPlanType>;
  /**  Deprecated - prefer programDatas - Remove in SC-57703  */
  programData?: InputMaybe<SaveProgramDataInput>;
  programDatas?: InputMaybe<Array<SaveReadyPlanProgramDataInput>>;
  /**  Deprecated - now computed - Remove in SC-57703  */
  maxProgramData?: InputMaybe<SaveProgramDataInput>;
  /**  Deprecated - now computed - Remove in SC-57703  */
  minProgramData?: InputMaybe<SaveProgramDataInput>;
  underwritingTemplateId?: InputMaybe<Scalars['ID']>;
  constructionDocumentCompletePercentage?: InputMaybe<Scalars['Int']>;
  lotTypes?: InputMaybe<Array<LotType>>;
  contingencyMarkupPercentage?: InputMaybe<Scalars['Float']>;
  ownerId?: InputMaybe<Scalars['ID']>;
};

export type SaveReadyPlansInput = {
  readyPlans: Array<SaveReadyPlanInput>;
};

export type ReadyPlanFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  development?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Array<ReadyPlanStatus>>;
  hasActiveTemplates?: InputMaybe<Scalars['Boolean']>;
  hasUnderwritingTemplate?: InputMaybe<Scalars['Boolean']>;
};

export type SaveReadyPlansResult = {
  __typename?: 'SaveReadyPlansResult';
  readyPlans: Array<ReadyPlan>;
};

export type SaveReadyPlanResult = {
  __typename?: 'SaveReadyPlanResult';
  readyPlan: ReadyPlan;
};

export type DeleteReadyPlansInput = {
  ids: Array<Scalars['ID']>;
  deleteNonDraft?: InputMaybe<Scalars['Boolean']>;
  clearPrpc?: InputMaybe<Scalars['Boolean']>;
  deleteBcli?: InputMaybe<Scalars['Boolean']>;
};

export type ComputeReadyPlanCostInput = {
  readyPlanId: Scalars['ID'];
  readyPlanOptionIds: Array<Scalars['ID']>;
  /**  Optionally the version of the ReadyPlan to compute costs for, otherwise the latest version will be used.  */
  itemTemplateId?: InputMaybe<Scalars['ID']>;
  /**  Optionally the ReadyPlanAggregateVersion to compute costs for. Ignored if versionMode is specified.  */
  versionId?: InputMaybe<Scalars['ID']>;
  /**  For ProductOfferings, specifies which aggregate version to use. Takes precedence over versionId.  */
  versionMode?: InputMaybe<ProductOfferingVersionMode>;
  /** A list of the RPO IDs that you wish to calculate the cost delta for. If specified as ["all"], all RPOs not included in readyPlanOptionIds will be included. */
  deltaForReadyPlanOptionIds?: InputMaybe<Array<Scalars['ID']>>;
  /** When provided, detects DP changes and resets personalization defaults. */
  originalReadyPlanOptionIds?: InputMaybe<Array<Scalars['ID']>>;
};

/**  This returns the raw trade costs of a ReadyPlan, based on the latest scope template costs, without any opco markup or overhead.  */
export type ComputeReadyPlanCostResult = ReadyPlanCostData & {
  __typename?: 'ComputeReadyPlanCostResult';
  readyPlan: ReadyPlan;
  readyPlanOptions: Array<ReadyPlanOption>;
  /**  Options added while expanding a partial RPv2 config; always empty for RPv1.  */
  includedOptions: Array<ReadyPlanOption>;
  /**  Total cost of the ReadyPlan and specified options, including contingency.  */
  totalCostInCents: Scalars['Int'];
  softCostInCents: Scalars['Int'];
  /**  Direct hard costs of the ReadyPlan and specified options, including contingency.  */
  directHardCostInCents: Scalars['Int'];
  indirectHardCostInCents: Scalars['Int'];
  /**  Contingency amount (also included in the totalCostInCents and directHardCostInCents).  */
  contingencyCostInCents: Scalars['Int'];
  /**  Whether or not the contingency was computed or based on a static contingency ITI.  */
  contingencyComputed: Scalars['Boolean'];
  deltas: Array<ReadyPlanOptionCostDelta>;
  protoProjectItems: Array<ProtoProjectItem>;
  configurationErrors: Array<Scalars['String']>;
};

export type ReadyPlanOptionCostDelta = ReadyPlanCostData & {
  __typename?: 'ReadyPlanOptionCostDelta';
  readyPlanOption: ReadyPlanOption;
  /**  Delta total cost of the ReadyPlan and specified options, including contingency.  */
  totalCostInCents: Scalars['Int'];
  softCostInCents: Scalars['Int'];
  /**  Delta direct hard costs of the ReadyPlan and specified options, including contingency.  */
  directHardCostInCents: Scalars['Int'];
  indirectHardCostInCents: Scalars['Int'];
  /**  Delta contingency amount (also included in the totalCostInCents and directHardCostInCents).  */
  contingencyCostInCents: Scalars['Int'];
  /**  Whether or not the contingency was computed or based on a static contingency ITI.  */
  contingencyComputed: Scalars['Boolean'];
};

export type ReadyPlanCostData = {
  /**  Includes contingency.  */
  totalCostInCents: Scalars['Int'];
  softCostInCents: Scalars['Int'];
  /**  Includes contingency.  */
  directHardCostInCents: Scalars['Int'];
  indirectHardCostInCents: Scalars['Int'];
  /**  Contingency amount (also included in the totalCostInCents and directHardCostInCents).  */
  contingencyCostInCents: Scalars['Int'];
  /**  Whether or not the contingency was computed or based on a static contingency ITI.  */
  contingencyComputed: Scalars['Boolean'];
};

/**  A concrete 1-to-1 implementation of ProjectItemLike to satisfy GraphQL's requirement for return values.  */
export type ProtoProjectItem = ProjectItemLike & {
  __typename?: 'ProtoProjectItem';
  name: Scalars['String'];
  specifications?: Maybe<Scalars['String']>;
  tradePartnerNote?: Maybe<Scalars['String']>;
  slot: ItemSlot;
  item: Item;
  quantity?: Maybe<Scalars['Int']>;
  totalPriceInCents: Scalars['Int'];
  totalCostInCents: Scalars['Int'];
  location: Location;
  unitOfMeasure: UnitOfMeasure;
  costType: CostType;
  preferredPotentialBidContractLineItem?: Maybe<PotentialBidContractLineItem>;
  itemTemplateItem?: Maybe<BaseItemLike>;
  modifyingTemplateItems: Array<BaseItemLike>;
  bidItem?: Maybe<BidItem>;
};

export type ScopeGlobalOptionGroupsToReadyPlansInput = {
  globalOptionGroupIds: Array<Scalars['ID']>;
};

export type ScopeGlobalOptionGroupsToReadyPlansResult = {
  __typename?: 'ScopeGlobalOptionGroupsToReadyPlansResult';
  globalOptionGroups: Array<GlobalOptionGroup>;
};

export type GenerateReadyPlanVersionNotesResult = {
  __typename?: 'GenerateReadyPlanVersionNotesResult';
  notes: Scalars['String'];
};

export type ReadyPlanAggregateVersion = Named & HasDisplayName & HasDisplayVersion & BaseItemParentVersion & {
  __typename?: 'ReadyPlanAggregateVersion';
  id: Scalars['ID'];
  version?: Maybe<Scalars['Int']>;
  /**  Pass through of readyPlan.name  */
  name: Scalars['String'];
  /**  Pass through of readyPlan.displayName  */
  displayName: Scalars['String'];
  /**  rp replacement for `it.displayVersion  */
  displayVersion: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  status: AggregateVersionStatusDetail;
  readyPlan: ReadyPlanLike;
  optionGroupVersions: Array<ReadyPlanOptionGroupVersion>;
  optionVersions: Array<ReadyPlanOptionVersion>;
  finalReadyPlanOptionVersions: Array<ReadyPlanOptionVersion>;
  versions: Array<ReadyPlanVersion>;
  removedTliVersions: Array<TakeoffLineItemVersion>;
  tliVersions: Array<TakeoffLineItemVersion>;
  versionNotes?: Maybe<Scalars['String']>;
  designPackagePlanUpdates: Array<DesignPackagePlanUpdate>;
  productOfferingIncomingUpdates: Array<ProductOfferingIncomingUpdate>;
  programDataVersions: Array<ReadyPlanProgramDataVersion>;
  removedProgramDataVersions: Array<ReadyPlanProgramDataVersion>;
  assetVersions: Array<ReadyPlanAssetVersion>;
  designPackageSourceVersions: Array<DesignPackageSourceVersion>;
  tliVersionsCount: Scalars['Int'];
  /**
   * Per-change-type summary of TLIV changes in this version, broken down by effective location.
   * A cheap overview alternative to loading the full `tliVersions` collection.
   */
  tlivChangeSummary: Array<TlivChangeSummary>;
  /**
   * Same as `tlivChangeSummary`, but only counting product-material TLIVs
   * (materialVariant.listing.type = Product) — backs the "Product updates" overview section.
   * The per-product detail rows are loaded on drill-in via `readyPlanAggregateVersion(id:).tliVersions`.
   */
  productTlivChangeSummary: Array<TlivChangeSummary>;
  rplVersions: Array<ReadyPlanLocationVersion>;
  /**   Whether the current RPAV, and all related changes, can be deleted.   */
  canDelete: PotentialOperation2;
  canPublish: PotentialOperation2;
  /**  Whether this version can be promoted to checkout. Blocked by non-active versions and upstream config errors (e.g., RPOG dependency cycles).  */
  canPromote: PotentialOperation2;
  /**  Only for a DesignPackage RPAV, the incoming DPPUs that we accepted in this version. */
  acceptedDesignPackageUpdates: Array<DesignPackagePlanUpdate>;
  /**  Only for a PlanPackage RPAV, the outgoing DPPUs that we created/pushed out in this version.  */
  outgoingDesignPackageUpdates: Array<DesignPackagePlanUpdate>;
  /**  For a PlanPackage draft, the pending incoming slots that publishing this draft would auto-accept. Empty for non-draft or non-PlanPackage versions.  */
  incomingSlotsFulfilledByPublish: Array<PlanPackageIncomingSlot>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  finalReadyPlanRequiredOptionVersions: Array<ReadyPlanRequiredOptionVersion>;
  requiredOptionVersions: Array<ReadyPlanRequiredOptionVersion>;
  designNoteVersions: Array<ReadyPlanDesignNoteVersion>;
  designPackageSources: Array<DesignPackageSource>;
  promotedAt?: Maybe<Scalars['DateTime']>;
  promotedBy?: Maybe<User>;
  createdByPromotion: Scalars['Boolean'];
};

/**
 * FWIW/TODO: today we return the raw shape (changeType + counts + locations) and the FE
 * formats it into display strings. If it turns out every consumer just interpolates these
 * into a sentence anyway, consider collapsing this to something like `summaryLines: [String!]!`
 * where the server owns the wording — fewer fields to keep in sync, and one place to change
 * the copy. Left as-is for now since the raw counts are still useful for drill-in links.
 */
export type TlivChangeSummary = {
  __typename?: 'TlivChangeSummary';
  changeType: Scalars['String'];
  total: Scalars['Int'];
  byLocation: Array<TlivLocationCount>;
};

export type TlivLocationCount = {
  __typename?: 'TlivLocationCount';
  location: Location;
  count: Scalars['Int'];
};

/**  We only allow marking a version as status=active.  */
export type SaveReadyPlanAggregateVersionInput = {
  id: Scalars['ID'];
  status?: InputMaybe<AggregateVersionStatus>;
  versionNotes?: InputMaybe<Scalars['String']>;
};

export type SaveReadyPlanAggregateVersionResult = {
  __typename?: 'SaveReadyPlanAggregateVersionResult';
  readyPlanAggregateVersion: ReadyPlanAggregateVersion;
};

export type ReadyPlanAggregateVersionsFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  readyPlanId?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Array<AggregateVersionStatus>>;
};

export type DeleteReadyPlanAggregateVersionInput = {
  /**  The ID of the version to delete.  */
  id: Scalars['ID'];
  /**  Allows deletion of the entire plan, if it is still in its first draft and has not been referenced elsewhere  */
  deleteReadyPlan?: InputMaybe<Scalars['Boolean']>;
  /**  Allows deletion of non-draft versions, as long as it is the latest version.  */
  deleteNonDraft?: InputMaybe<Scalars['Boolean']>;
};

export type DeleteReadyPlanAggregateVersionResult = {
  __typename?: 'DeleteReadyPlanAggregateVersionResult';
  /** Returns the latest */
  latestReadyPlanAggregateVersion?: Maybe<ReadyPlanAggregateVersion>;
};

export type ReadyPlanAggregateVersionsPageResult = {
  __typename?: 'ReadyPlanAggregateVersionsPageResult';
  entities: Array<ReadyPlanAggregateVersion>;
  pageInfo: PageInfo;
};

export type ReadyPlanAsset = {
  __typename?: 'ReadyPlanAsset';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ReadyPlanAssetTypeDetail;
  asset: Asset;
  parent?: Maybe<ReadyPlanAssetParent>;
  isCoverPhoto: Scalars['Boolean'];
  versions: Array<ReadyPlanAssetVersion>;
  active: Scalars['Boolean'];
  options: Array<ReadyPlanOption>;
};

export type SaveReadyPlanAssetInput = {
  id?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<ReadyPlanAssetType>;
  asset?: InputMaybe<AssetInput>;
  parentId?: InputMaybe<Scalars['ID']>;
  active?: InputMaybe<Scalars['Boolean']>;
};

export type ReadyPlanAssetParent = ReadyPlan | ReadyPlanLocation | ReadyPlanOption | PlanPackage | DesignPackage | ProductOffering;

export type ReadyPlanAssetVersion = {
  __typename?: 'ReadyPlanAssetVersion';
  id: Scalars['ID'];
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  identity: ReadyPlanAsset;
  asset: Asset;
};

export type ReadyPlanConfigLike = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  readyPlan?: Maybe<ReadyPlanLike>;
  readyPlanOptions: Array<ReadyPlanOption>;
  /** Pre-computed texture swaps and camera data for InsideMaps rendering */
  insideMapsTextureSwaps?: Maybe<InsideMapsTextureSwaps>;
  productOffering?: Maybe<ProductOffering>;
  programData?: Maybe<ProgramData>;
};


export type ReadyPlanConfigLikeInsideMapsTextureSwapsArgs = {
  debugParts?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * An option a config (CheckoutConfig, ProjectReadyPlanConfig) could select, with why it
 * cannot be (if so). Each config type applies its own gating policy in `canBeSelected`.
 */
export type PotentialOptionLike = {
  id: Scalars['ID'];
  option: ReadyPlanOption;
  /**  Price of this option in the context of the config's current selections.  */
  totalPriceInCents?: Maybe<Scalars['Int']>;
  /**  Cost of this option in the context of the config's current selections.  */
  totalCostInCents?: Maybe<Scalars['Int']>;
  /**
   * Whether this option can be selected, with human-readable reasons when it cannot.
   *
   * Same gating as `isEnabled` (i.e. `allowed == isEnabled`), so use this when you want to tell the
   * user _why_ an option is unavailable.
   */
  canBeSelected: PotentialOperation2;
  /** @deprecated Use canBeSelected instead. */
  isEnabled: Scalars['Boolean'];
  /**  Whether this option is selected in the config.  */
  isSelected: Scalars['Boolean'];
};

/**  A ReadyPlanOptionGroup paired with a config's potential options within it.  */
export type PotentialOptionGroupLike = {
  id: Scalars['ID'];
  group: ReadyPlanOptionGroup;
  options: Array<PotentialOptionLike>;
  /**
   * Whether this option group can be selected, with human-readable reasons when it cannot, i.e. its
   * prerequisites are not met.
   */
  canBeSelected: PotentialOperation2;
  /**
   *  This option group is allowed to be selected if it has all necessary prerequisites met.
   * @deprecated Use canBeSelected instead.
   */
  isEnabled: Scalars['Boolean'];
};

export type ReadyPlanDesignNote = {
  __typename?: 'ReadyPlanDesignNote';
  id: Scalars['ID'];
  active: Scalars['Boolean'];
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  readyPlan: ReadyPlanLike;
  takeoffLineItem: TakeoffLineItem;
  targetGroups: Array<ReadyPlanOptionGroup>;
  targetCombinations: Array<DesignPackageOptionCombination>;
};

export type SaveReadyPlanDesignNoteInput = {
  id?: InputMaybe<Scalars['ID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Scalars['String']>;
  readyPlanId?: InputMaybe<Scalars['ID']>;
  takeoffLineItemId?: InputMaybe<Scalars['ID']>;
  targetGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  targetCombinations?: InputMaybe<Array<SaveTargetCombinationInput>>;
};

export type SaveReadyPlanDesignNoteResult = {
  __typename?: 'SaveReadyPlanDesignNoteResult';
  readyPlanDesignNote: ReadyPlanDesignNote;
};

export type ReadyPlanDesignNoteVersion = {
  __typename?: 'ReadyPlanDesignNoteVersion';
  id: Scalars['ID'];
  active: Scalars['Boolean'];
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  identity: ReadyPlanDesignNote;
  targetGroups: Array<ReadyPlanOptionGroup>;
  targetCombinations: Array<DesignPackageOptionCombination>;
};

export type ReadyPlanDesignPackage = {
  __typename?: 'ReadyPlanDesignPackage';
  id: Scalars['ID'];
  active: Scalars['Boolean'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  readyPlan: ReadyPlanLike;
  options: Array<ReadyPlanOption>;
  optionDefaultsIfChildren: Array<ReadyPlanOption>;
  optionVersionDefaultsIfChildren: Array<ReadyPlanOptionVersion>;
};

export type ReadyPlanDesignPackageVersion = {
  __typename?: 'ReadyPlanDesignPackageVersion';
  id: Scalars['ID'];
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  identity: ReadyPlanDesignPackage;
};

export type ReadyPlanDocumentVersion = {
  __typename?: 'ReadyPlanDocumentVersion';
  id: Scalars['ID'];
  asset: Asset;
  identity: Document;
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  active: Scalars['Boolean'];
  name: Scalars['String'];
  uploaded: Scalars['Boolean'];
  sizeInBytes: Scalars['Int'];
  documentType: DocumentTypeDetail;
  category: DocumentCategoryDetail;
};

export type ReadyPlanLocation = Named & {
  __typename?: 'ReadyPlanLocation';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  location: Location;
  readyPlan: ReadyPlan;
  roomNumber?: Maybe<Scalars['Int']>;
  fullRoomNumber?: Maybe<Scalars['Int']>;
  level?: Maybe<Location>;
  roomType?: Maybe<RoomType>;
  versions: Array<ReadyPlanLocationVersion>;
  active: Scalars['Boolean'];
  relatedTakeoffLineItemsCount: Scalars['Int'];
  readyPlanAssets: Array<ReadyPlanAsset>;
  readyPlanOptions: Array<ReadyPlanOption>;
  /**  Only non-empty for PlanPackage RPLs  */
  designPackageLocations: Array<ReadyPlanLocation>;
  /**  Only non-empty for DesignPackage RPLs  */
  planLocations: Array<ReadyPlanLocation>;
  name: Scalars['String'];
  isInsideMapsRoom?: Maybe<Scalars['Boolean']>;
  insideMapsRoomOrder?: Maybe<Scalars['Int']>;
  canDelete: PotentialOperation2;
  /**  When no marketingName is set, the location name is returned */
  marketingName: Scalars['String'];
};

export type SaveReadyPlanLocationInput = {
  /**
   * Either call with `id` to update `roomNumber`, or with `readyPlanId+roomType+levelId` to create a
   * RoomRPL, or `readyPlanId+locationId` to create LevelRPL. `delete` cannot be used without `id`.
   */
  id?: InputMaybe<Scalars['ID']>;
  readyPlanId?: InputMaybe<Scalars['ID']>;
  roomTypeId?: InputMaybe<Scalars['ID']>;
  levelId?: InputMaybe<Scalars['ID']>;
  /**  Only used on create for LevelRPLs. Should be a type=Level location  */
  locationId?: InputMaybe<Scalars['ID']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  roomNumber?: InputMaybe<Scalars['Int']>;
  isInsideMapsRoom?: InputMaybe<Scalars['Boolean']>;
  insideMapsRoomOrder?: InputMaybe<Scalars['Int']>;
  marketingName?: InputMaybe<Scalars['String']>;
};

export type SaveReadyPlanLocationBulkResult = {
  __typename?: 'SaveReadyPlanLocationBulkResult';
  readyPlanLocations: Array<ReadyPlanLocation>;
  affectedTlis: Array<TakeoffLineItem>;
};

/** Specify id/planLocations to remap an existing RPL */
export type SaveDesignPackageLocationPlanMappingInput = {
  id: Scalars['ID'];
  planLocations: Array<Scalars['ID']>;
};

export type SaveDesignPackageLocationPlanMappingsResult = {
  __typename?: 'SaveDesignPackageLocationPlanMappingsResult';
  readyPlanLocations: Array<ReadyPlanLocation>;
  affectedPlaceholders: Array<TakeoffLineItem>;
};

export type CreateDesignPackageAlternateLocationInput = {
  designPackageId: Scalars['ID'];
  /** Right now, the design package left nav UI relies on global locations, so we fetch the RPL using the global location ID. */
  locationId: Scalars['ID'];
};

export type CreateDesignPackageAlternateLocationResult = {
  __typename?: 'CreateDesignPackageAlternateLocationResult';
  readyPlanLocation: ReadyPlanLocation;
};

export type ReadyPlanLocationVersion = {
  __typename?: 'ReadyPlanLocationVersion';
  id: Scalars['ID'];
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  identity: ReadyPlanLocation;
  roomNumber?: Maybe<Scalars['Int']>;
  location: Location;
  changeType: Scalars['String'];
  previous?: Maybe<ReadyPlanLocationVersion>;
  fullRoomNumber?: Maybe<Scalars['Int']>;
  /**  Only non-empty for DesignPackage RPLs  */
  planLocations: Array<ReadyPlanLocation>;
};

export type ReadyPlanOption = HasBlueprintUrl & Named & HasDisplayName & HasOptionPricingData & {
  __typename?: 'ReadyPlanOption';
  id: Scalars['ID'];
  /** Helper to get the GlobalOption.code directly */
  code: Scalars['String'];
  /**
   * The `code`, made unique within the ReadyPlan by suffixing the option's location abbreviation.
   *
   * I.e. if `TRMCLG0004` is used in both `Level 1` and `Primary Bedroom 113`, they become `TRMCLG0004-L1` and
   * `TRMCLG0004-PB113`; codes that are not shared within the plan are left as-is.
   */
  displayCode: Scalars['String'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  homeownerChoice: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** @deprecated Replaced by prerequisites */
  isChildOption: Scalars['Boolean'];
  /** @deprecated Replaced by prerequisites */
  parentOption?: Maybe<ReadyPlanOption>;
  /** @deprecated Replaced by prerequisites */
  isParentOption: Scalars['Boolean'];
  /** @deprecated Replaced by prerequisites */
  childOptions: Array<ReadyPlanOption>;
  globalOption: GlobalOption;
  type: GlobalOptionType;
  readyPlan: ReadyPlan;
  /**  V2 ReadyPlans have RPLs which drive the location of the RPOs. V1 ReadyPlans will not have a RPL, but may have a V1 location.  */
  readyPlanLocation?: Maybe<ReadyPlanLocation>;
  /**  For V2 ReadyPlans, the location of the RPO is driven by the RPL.location. For V1 ReadyPlans, the location could be a V1 location.  */
  location?: Maybe<Location>;
  description?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  /** Returns the assigned short name for an elevation option, if it exists */
  shortName?: Maybe<Scalars['String']>;
  /** Returns the assigned short name for an elevation option, or the name field if there is no short name assigned */
  maybeShortName: Scalars['String'];
  programData: ProgramData;
  optionGroup: ReadyPlanOptionGroup;
  userEvents: Array<UserEvent>;
  blueprintUrl: Url;
  programDataModifiedBy: Array<ReadyPlanOptionProgramDataModification>;
  modifiesProgramDataFor: Array<ReadyPlanOptionProgramDataModification>;
  optionPrereqChildren: Array<ReadyPlanOption>;
  optionPrerequisites: Array<ReadyPlanOption>;
  optionConflictChildren: Array<ReadyPlanOption>;
  optionConflicts: Array<ReadyPlanOption>;
  optionDefaultChildren: Array<ReadyPlanOption>;
  optionDefaultsIf: Array<ReadyPlanOption>;
  optionRequiredIf: Array<ReadyPlanRequiredOption>;
  personalizationTargetCombinations: Array<DesignPackageOptionCombination>;
  order: Scalars['Int'];
  programDatas: Array<ReadyPlanProgramData>;
  assets: Array<ReadyPlanAsset>;
  bidOutPercentage: Scalars['Int'];
  latestVersion?: Maybe<ReadyPlanOptionVersion>;
  draftVersion?: Maybe<ReadyPlanOptionVersion>;
  publishToUnderwriting: Scalars['Boolean'];
  /**  Either plan-specific Assets or its global fallback Asset.  */
  optionImages: Array<Asset>;
  /**  Preferred single image to display from `optionImages` */
  optionImage?: Maybe<Asset>;
  /**  For product personalization options, the material this option represents, via the global option.  */
  materialVariant?: Maybe<MaterialVariant>;
  /**  For personalization options, the material this option represents, via the global option.  */
  materialVariants: Array<MaterialVariant>;
  /**  The desired margin in basis points for this Option before the cutoff date, either defined directly by a (non-market / non-community level) OptionPricingConfig or falling back to a default value. */
  preCutoffDesiredMarginInBasisPoints: Scalars['Int'];
  /**  The desired margin in basis points for this Option after the cutoff date, either defined directly by a (non-market / non-community level) OptionPricingConfig or falling back to a default value. */
  postCutoffDesiredMarginInBasisPoints?: Maybe<Scalars['Int']>;
  /**  The selection fee for this Option, either defined directly by a (non-market / non-community level) OptionPricingConfig or falling back to a default value. */
  selectionFeeInCents?: Maybe<Scalars['Int']>;
  minimumPriceInCents: Scalars['Int'];
  showInCheckout: Scalars['Boolean'];
  /**
   * Escape hatch: when true, checkout should show that this option does not have an Inside Maps rendering.
   * Defaults to false (rendering available). Not versioned.
   */
  missingInsideMapsRendering: Scalars['Boolean'];
  canDelete: PotentialOperation2;
  packageOptionMaterial?: Maybe<MaterialVariant>;
  /**  Whether this is a newly-imported POF RPO.  */
  isNewFromUpstream: Scalars['Boolean'];
  /**
   * Indicates if the POF RPO should be hidden behind the "Show Archived" toggle on the edit options screen.
   * This flag was initially used to tell if the copiedFrom/upstream RPO was inactive, but it now encompasses
   * more cases, like if the personalization RPO is no longer relevant.
   */
  isUpstreamInactive: Scalars['Boolean'];
  checkoutOrder?: Maybe<Scalars['Int']>;
};

export type ReadyPlanOptionsFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  readyPlan?: InputMaybe<Array<Scalars['ID']>>;
  type?: InputMaybe<Array<Scalars['ID']>>;
  /**  We allow null IDs to represent querying for [1, null].  */
  location?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /**  All ReadyPlanOptions including all of the requested options  */
  tag?: InputMaybe<Array<Scalars['ID']>>;
  isParentOption?: InputMaybe<Scalars['Boolean']>;
  isElevation?: InputMaybe<Scalars['Boolean']>;
  isExteriorPalette?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  /** Get all ReadyPlanOptions in the specified developments */
  development?: InputMaybe<Array<Scalars['ID']>>;
  createdAt?: InputMaybe<DateFilter2>;
  isInterior?: InputMaybe<Scalars['Boolean']>;
  isFloorPlan?: InputMaybe<Scalars['Boolean']>;
  isPlanPackage?: InputMaybe<Scalars['Boolean']>;
  isAddOnV2?: InputMaybe<Scalars['Boolean']>;
  isStructuralV2?: InputMaybe<Scalars['Boolean']>;
  isCatalogV2?: InputMaybe<Scalars['Boolean']>;
  publishToUnderwriting?: InputMaybe<Scalars['Boolean']>;
};

export type SaveReadyPlanOptionsInput = {
  readyPlanOptions: Array<SaveReadyPlanOptionInput>;
};

export type SaveReadyPlanOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  homeownerChoice?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated Replaced by optionPrerequisites */
  parentOptionId?: InputMaybe<Scalars['ID']>;
  globalOptionId?: InputMaybe<Scalars['ID']>;
  readyPlanId?: InputMaybe<Scalars['ID']>;
  /**  Used for V2 ReadyPlans  */
  readyPlanLocationId?: InputMaybe<Scalars['ID']>;
  /**  Used for V1 ReadyPlans  */
  locationId?: InputMaybe<Scalars['ID']>;
  /**
   *  All existing childOptions are required when defining childOptions property in mutation
   * @deprecated Replaced by optionPrerequisites
   */
  childOptions?: InputMaybe<Array<SaveReadyPlanChildOptionInput>>;
  description?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  /**  Deprecated - use globalOptionId - Remove in SC-57703  */
  programData?: InputMaybe<SaveProgramDataInput>;
  programDatas?: InputMaybe<Array<SaveReadyPlanProgramDataInput>>;
  order?: InputMaybe<Scalars['Int']>;
  optionPrereqChildIds?: InputMaybe<Array<Scalars['ID']>>;
  optionPrerequisiteIds?: InputMaybe<Array<Scalars['ID']>>;
  optionConflictChildIds?: InputMaybe<Array<Scalars['ID']>>;
  optionConflictIds?: InputMaybe<Array<Scalars['ID']>>;
  optionDefaultsIfIds?: InputMaybe<Array<Scalars['ID']>>;
  optionGroupId?: InputMaybe<Scalars['ID']>;
  assets?: InputMaybe<Array<SaveReadyPlanAssetInput>>;
  publishToUnderwriting?: InputMaybe<Scalars['Boolean']>;
  showInCheckout?: InputMaybe<Scalars['Boolean']>;
  missingInsideMapsRendering?: InputMaybe<Scalars['Boolean']>;
  requiredOptionId?: InputMaybe<Scalars['ID']>;
  packageOptionMaterialId?: InputMaybe<Scalars['ID']>;
  /**  POF RPOs only  */
  checkoutOrder?: InputMaybe<Scalars['Int']>;
};

export type SaveReadyPlanChildOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  homeownerChoice?: InputMaybe<Scalars['Boolean']>;
  globalOptionId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
};

export type SaveReadyPlanOptionsResult = {
  __typename?: 'SaveReadyPlanOptionsResult';
  readyPlanOptions: Array<ReadyPlanOption>;
};

export type MergeReadyPlanOptionsInput = {
  targetId: Scalars['ID'];
  sourceIds: Array<Scalars['ID']>;
};

export type MergeReadyPlanOptionsResult = {
  __typename?: 'MergeReadyPlanOptionsResult';
  readyPlanOption: ReadyPlanOption;
};

export type ReadyPlanOptionGroup = {
  __typename?: 'ReadyPlanOptionGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
  marketingDescription?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
  order: Scalars['Int'];
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  group: GlobalOptionGroup;
  location?: Maybe<Location>;
  readyPlan: ReadyPlan;
  options: Array<ReadyPlanOption>;
  isSingleOptionGroup: Scalars['Boolean'];
  isMultiOptionGroup: Scalars['Boolean'];
  /** @deprecated No longer used */
  forDesignUpgrade: Scalars['Boolean'];
  /** @deprecated use `forDesignInterior` instead */
  forDesignPackage: Scalars['Boolean'];
  forDesignInterior: Scalars['Boolean'];
  forDesignExterior: Scalars['Boolean'];
  /**  helper for `forDesignInterior || forDesignExterior` so you don't have to do it by hand everywhere  */
  forDesignPackages: Scalars['Boolean'];
  isPlanPackage: Scalars['Boolean'];
  /**  Only applicable to Design Package-owned personalization RPOGs.  */
  personalizationType?: Maybe<ReadyPlanOptionGroupPersonalizationTypeDetail>;
  groupByFeature: Scalars['Boolean'];
  /**  If this is a personalization RPOG, these are the placeholder slots that holds our defaults.  */
  personalizationPlaceholders: Array<TakeoffLineItem>;
  /**
   * If this is a product personalization RPOG, the material variants that are in our pool of options.
   *
   * These MVs all have their own backing RPOs, but this lets the FE directly get at the material variants.
   */
  personalizationMaterialVariants: Array<MaterialVariant>;
  groupPrerequisites: Array<ReadyPlanOptionGroup>;
  groupPrereqChildren: Array<ReadyPlanOptionGroup>;
  levels?: Maybe<Scalars['Int']>;
  personalizationTargetGroups: Array<ReadyPlanOptionGroup>;
  readyPlanLocation?: Maybe<ReadyPlanLocation>;
  displayPackageOptionsAsSingleProduct?: Maybe<Scalars['Boolean']>;
  checkoutOrder?: Maybe<Scalars['Int']>;
  step?: Maybe<CheckoutConfigOptionGroupStepDetail>;
  substepNumber?: Maybe<Scalars['Int']>;
  hasDynamicProducts: Scalars['Boolean'];
  overrideStep?: Maybe<CheckoutConfigOptionGroupStepDetail>;
  overrideSubstepNumber?: Maybe<Scalars['Int']>;
  /**
   * The conditions under which this personalization group requires a selection.
   *
   * This is a disjunction, i.e. the group is required when *any* one of the clauses matches. A `null` means the group has
   * no expression, so the legacy `required` flag applies instead; an empty list means the group is never required.
   */
  requiredWhen?: Maybe<Array<ReadyPlanOptionGroupRequiredWhen>>;
};


export type ReadyPlanOptionGroupOptionsArgs = {
  filter?: InputMaybe<OptionFilter>;
};

/**
 * One clause of a `ReadyPlanOptionGroup.requiredWhen` expression.
 *
 * The clause matches when every option in `all` is selected and no option in `none` is, so a clause with both empty (the
 * only clause that can appear on its own) means the group is always required.
 */
export type ReadyPlanOptionGroupRequiredWhen = {
  __typename?: 'ReadyPlanOptionGroupRequiredWhen';
  all: Array<ReadyPlanOption>;
  none: Array<ReadyPlanOption>;
};

export type ReadyPlanOptionGroupsFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  required?: InputMaybe<Scalars['Boolean']>;
};

/**  These will only be applied to RPOs on RPOGs that are in a ProductOffering. These filters are only used for the underwriting api. */
export type OptionFilter = {
  publishToUnderwriting?: InputMaybe<Scalars['Boolean']>;
};

export type SaveReadyPlanOptionGroupInput = {
  id?: InputMaybe<Scalars['ID']>;
  required?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
  options?: InputMaybe<Array<SaveReadyPlanOptionInput>>;
  marketingDescription?: InputMaybe<Scalars['String']>;
  levels?: InputMaybe<Scalars['Int']>;
  groupByFeature?: InputMaybe<Scalars['Boolean']>;
  readyPlanId?: InputMaybe<Scalars['ID']>;
  checkoutOrder?: InputMaybe<Scalars['Int']>;
  overrideStep?: InputMaybe<CheckoutConfigOptionGroupStep>;
  overrideSubstepNumber?: InputMaybe<Scalars['Int']>;
};

export type SaveReadyPlanOptionGroupResult = {
  __typename?: 'SaveReadyPlanOptionGroupResult';
  optionGroup: ReadyPlanOptionGroup;
};

export type SaveReadyPlanOptionGroupsResult = {
  __typename?: 'SaveReadyPlanOptionGroupsResult';
  entities: Array<ReadyPlanOptionGroup>;
};

export type ReadyPlanOptionGroupVersion = {
  __typename?: 'ReadyPlanOptionGroupVersion';
  id: Scalars['ID'];
  identity: ReadyPlanOptionGroup;
  first: ReadyPlanAggregateVersion;
  final?: Maybe<ReadyPlanAggregateVersion>;
  required: Scalars['Boolean'];
  order: Scalars['Int'];
  active: Scalars['Boolean'];
  name: Scalars['String'];
  marketingDescription?: Maybe<Scalars['String']>;
  levels?: Maybe<Scalars['Int']>;
  personalizationTargetGroups: Array<ReadyPlanOptionGroup>;
  location?: Maybe<Location>;
  readyPlanLocation?: Maybe<ReadyPlanLocation>;
  displayPackageOptionsAsSingleProduct?: Maybe<Scalars['Boolean']>;
  substepNumber?: Maybe<Scalars['Int']>;
  step?: Maybe<CheckoutConfigOptionGroupStepDetail>;
  overrideStep?: Maybe<CheckoutConfigOptionGroupStepDetail>;
  overrideSubstepNumber?: Maybe<Scalars['Int']>;
};

export type ReadyPlanOptionProgramDataModification = Named & {
  __typename?: 'ReadyPlanOptionProgramDataModification';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  programData: ProgramData;
  modifiedOption: ReadyPlanOption;
  matchesOption: ReadyPlanOption;
  userEvents: Array<UserEvent>;
  name: Scalars['String'];
};

export type SaveReadyPlanOptionProgramDataModificationInput = {
  id?: InputMaybe<Scalars['ID']>;
  programData?: InputMaybe<SaveProgramDataInput>;
  modifiedOptionId?: InputMaybe<Scalars['ID']>;
  matchesOptionId?: InputMaybe<Scalars['ID']>;
};

export type SaveReadyPlanOptionProgramDataModificationsResult = {
  __typename?: 'SaveReadyPlanOptionProgramDataModificationsResult';
  entities: Array<ReadyPlanOptionProgramDataModification>;
};

export type DeleteReadyPlanOptionProgramDataModificationsInput = {
  ids: Array<Scalars['ID']>;
};

export type DeleteReadyPlanOptionProgramDataModificationsResult = {
  __typename?: 'DeleteReadyPlanOptionProgramDataModificationsResult';
  id: Scalars['ID'];
  modifiedOptionId: Scalars['ID'];
};

export type ReadyPlanOptionVersion = {
  __typename?: 'ReadyPlanOptionVersion';
  id: Scalars['ID'];
  identity: ReadyPlanOption;
  first: ReadyPlanAggregateVersion;
  final?: Maybe<ReadyPlanAggregateVersion>;
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  customName?: Maybe<Scalars['String']>;
  /**  The `ReadyPlanOption.displayCode` as of this version, i.e. `TRMCLG0004-PB113`.  */
  displayCode?: Maybe<Scalars['String']>;
  /** @deprecated Use RPO.isNewFromUpstream */
  isNewFromUpstream: Scalars['Boolean'];
  /**
   * Indicates if the POF RPO should be hidden behind the "Show Archived" toggle on the edit options screen.
   * This flag was initially used to tell if the copiedFrom/upstream RPO was inactive, but it now encompasses
   * more cases, like if the personalization RPO is no longer relevant.
   * @deprecated Use RPO.isUpstreamInactive
   */
  isUpstreamInactive: Scalars['Boolean'];
  isOfferingInactive?: Maybe<Scalars['Boolean']>;
  optionConflicts?: Maybe<Array<ReadyPlanOption>>;
  optionPrerequisites?: Maybe<Array<ReadyPlanOption>>;
  optionDefaultsIf?: Maybe<Array<ReadyPlanOption>>;
  publishToUnderwriting: Scalars['Boolean'];
  location?: Maybe<Location>;
  showInCheckout: Scalars['Boolean'];
};

export type ReadyPlanProgramData = {
  __typename?: 'ReadyPlanProgramData';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  readyPlan: ReadyPlan;
  readyPlanOptions: Array<ReadyPlanOption>;
  programData: ProgramData;
  versions: Array<ReadyPlanProgramDataVersion>;
  active: Scalars['Boolean'];
};

export type SaveReadyPlanProgramDataInput = {
  id?: InputMaybe<Scalars['ID']>;
  readyPlanOptionIds?: InputMaybe<Array<Scalars['ID']>>;
  programData?: InputMaybe<SaveProgramDataInput>;
  op: IncrementalCollectionOp;
  active?: InputMaybe<Scalars['Boolean']>;
};

export type ReadyPlanProgramDataVersion = {
  __typename?: 'ReadyPlanProgramDataVersion';
  id: Scalars['ID'];
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  identity: ReadyPlanProgramData;
  programData: ProgramData;
};

export type ReadyPlanRequiredOption = {
  __typename?: 'ReadyPlanRequiredOption';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  readyPlan: ReadyPlanLike;
  planAddOns: Array<ReadyPlanOption>;
  targetGroups: Array<ReadyPlanOptionGroup>;
  targetCombinations: Array<DesignPackageOptionCombination>;
  active: Scalars['Boolean'];
  usePersonalizationGroups: Scalars['Boolean'];
};

export type SaveReadyPlanRequiredOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  designPackageId?: InputMaybe<Scalars['ID']>;
  targetGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  targetCombinations?: InputMaybe<Array<SaveTargetCombinationInput>>;
  planAddOnIds?: InputMaybe<Array<Scalars['ID']>>;
  usePersonalizationGroups?: InputMaybe<Scalars['Boolean']>;
};

export type SaveReadyPlanRequiredOptionsResult = {
  __typename?: 'SaveReadyPlanRequiredOptionsResult';
  readyPlanRequiredOptions: Array<ReadyPlanRequiredOption>;
};

export type ReadyPlanRequiredOptionVersion = {
  __typename?: 'ReadyPlanRequiredOptionVersion';
  id: Scalars['ID'];
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  identity: ReadyPlanRequiredOption;
  targetGroups: Array<ReadyPlanOptionGroup>;
  targetCombinations: Array<DesignPackageOptionCombination>;
};

export type ReadyPlanVersion = {
  __typename?: 'ReadyPlanVersion';
  id: Scalars['ID'];
  identity: ReadyPlan;
  name: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  type: ReadyPlanTypeDetail;
  lotTypes: Array<LotType>;
  contingencyMarkupPercentage?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  markets: Array<Market>;
  owner?: Maybe<InternalUser>;
};

export type Referencable = {
  id: Scalars['ID'];
  name: Scalars['String'];
  blueprintUrl: Url;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
};

export type SaveReferencesInput = {
  references: Array<ReferenceInput>;
};

export type ReferenceInput = {
  source: Scalars['ID'];
  target: Scalars['ID'];
};

export type SaveReferencesResult = {
  __typename?: 'SaveReferencesResult';
  references: Array<Reference>;
};

export type Reference = {
  __typename?: 'Reference';
  source: Referencable;
  target: Referencable;
};

export type DeleteReferencesInput = {
  references: Array<ReferenceInput>;
};

export type SaveRegionInput = {
  id?: InputMaybe<Scalars['ID']>;
  abbreviation?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  buildAddress?: InputMaybe<AddressInput>;
  /**  Only used for creating the Project.  */
  client?: InputMaybe<ClientInput>;
  /**  Add's a new coverImage to a project.  */
  coverImage?: InputMaybe<AssetInput>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ProjectStatus>;
  /**  Only used for creating the Project.  */
  startDate?: InputMaybe<Scalars['Date']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']>;
  planRoomLink?: InputMaybe<Scalars['String']>;
  salesforceAccountId?: InputMaybe<Scalars['String']>;
  projectStatusChange?: InputMaybe<ProjectStatusChangeInput>;
  isDisaster?: InputMaybe<Scalars['Boolean']>;
  intakeStyleNotes?: InputMaybe<Scalars['String']>;
  lotType?: InputMaybe<LotType>;
  productTypeId?: InputMaybe<Scalars['ID']>;
  projectRoles?: InputMaybe<Array<UpdateProjectRoleInput>>;
  salesforcePropertyId?: InputMaybe<Scalars['String']>;
  scopeMode?: InputMaybe<ScopeMode>;
  lotPartitionId?: InputMaybe<Scalars['String']>;
  warrantyStartDate?: InputMaybe<Scalars['Date']>;
  checkoutCustomerConfigId?: InputMaybe<Scalars['String']>;
  directCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']>;
  indirectCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']>;
  customerId?: InputMaybe<Scalars['ID']>;
  customerOwnerEntityId?: InputMaybe<Scalars['ID']>;
  builderId?: InputMaybe<Scalars['ID']>;
  legalDescription?: InputMaybe<Scalars['String']>;
  salesTaxOverrideInBasisPoints?: InputMaybe<Scalars['Int']>;
  communityType?: InputMaybe<CommunityType>;
  parentId?: InputMaybe<Scalars['ID']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyLicenseNumber?: InputMaybe<Scalars['String']>;
  invoicePaymentNetDays?: InputMaybe<Scalars['Int']>;
};

export type SaveRegionResult = {
  __typename?: 'SaveRegionResult';
  region: Region;
};

export type RequiredTaskDocument = {
  __typename?: 'RequiredTaskDocument';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  watchers: Array<ProjectRole>;
  documentType: DocumentTypeDetail;
  sampleAsset?: Maybe<Asset>;
  task: Task;
  document?: Maybe<Document>;
  globalRequiredTaskDocument?: Maybe<GlobalRequiredTaskDocument>;
};

export type SaveRequiredTaskDocumentInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  watchers?: InputMaybe<Array<ProjectRole>>;
  /** @deprecated Will be removed in favor of documentType */
  documentCategory?: InputMaybe<DocumentCategory>;
  documentType?: InputMaybe<DocumentType>;
  sampleAsset?: InputMaybe<AssetInput>;
  taskId?: InputMaybe<Scalars['ID']>;
  documentId?: InputMaybe<Scalars['ID']>;
  globalRequiredTaskDocumentId?: InputMaybe<Scalars['ID']>;
};

export type SaveRequiredTaskDocumentResult = {
  __typename?: 'SaveRequiredTaskDocumentResult';
  requiredTaskDocument: RequiredTaskDocument;
};

export type DeleteRequiredTaskDocumentResult = {
  __typename?: 'DeleteRequiredTaskDocumentResult';
  task: Task;
};

export type DeleteRequireTaskDocumentInput = {
  id: Scalars['ID'];
};

export type RoomType = {
  __typename?: 'RoomType';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  locations: Array<Location>;
  canDesignPackageRemap?: Maybe<Scalars['Boolean']>;
};

export type SaveRoomTypeInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  canDesignPackageRemap?: InputMaybe<Scalars['Boolean']>;
};

export type SaveRoomTypeResult = {
  __typename?: 'SaveRoomTypeResult';
  roomType: RoomType;
};

export type TestMutationInput = {
  datetime?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['Date']>;
};

export type TestMutationResult = {
  __typename?: 'TestMutationResult';
  datetime: Scalars['DateTime'];
  date: Scalars['Date'];
};

export type HasUserErrors = {
  userErrors?: Maybe<Array<UserError>>;
};

export type UserError = {
  __typename?: 'UserError';
  message: Scalars['String'];
};

/**  A standard result for when we're not returning any user errors, and instead will just fail the request.  */
export type EmptyResult = {
  __typename?: 'EmptyResult';
  emptyResult?: Maybe<Scalars['String']>;
  /** @deprecated clients should prefer `emptyResult` in queries */
  dummyString?: Maybe<Scalars['String']>;
};

/** Generic bulk delete input type */
export type DeleteEntitiesInput = {
  id: Array<Scalars['ID']>;
};

/** Generic simple delete input type */
export type DeleteEntityInput = {
  id: Scalars['ID'];
  /** An 'admin' flag, i.e. for eng/tech coordinators to do deletions that typically aren't allowed. */
  force?: InputMaybe<Scalars['Boolean']>;
};

export enum Order {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Named = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type HasDisplayName = {
  id: Scalars['ID'];
  displayName: Scalars['String'];
};

export type HasDisplayVersion = {
  id: Scalars['ID'];
  displayVersion: Scalars['String'];
};

export type Url = {
  __typename?: 'Url';
  /** Absolute path of the url, e.g. `/projects/p:1/` */
  path: Scalars['String'];
  /** Fully qualified http url, e.g. `https://blueprint.homebound.com/projects/p:1/` */
  url: Scalars['String'];
};

/**  Represents both whether an operation is performable, and if not the reasons.  */
export type PotentialOperation = {
  __typename?: 'PotentialOperation';
  shown: Scalars['Boolean'];
  hiddenReasons: Array<Scalars['String']>;
  enabled: Scalars['Boolean'];
  disabledReasons: Array<Scalars['String']>;
};

/**
 * Represents both whether an operation is performable, and if not the reasons.
 * When the reason relates to a specific entity, we return it for convenient UI navigation.
 */
export type PotentialOperation2 = {
  __typename?: 'PotentialOperation2';
  allowed: Scalars['Boolean'];
  disabledReasons: Array<Reason>;
};

export type Reason = {
  __typename?: 'Reason';
  message: Scalars['String'];
  entity?: Maybe<HasBlueprintUrl>;
};

export type HasBlueprintUrl = {
  id: Scalars['ID'];
  blueprintUrl: Url;
};

export type HasCheckoutUrl = {
  id: Scalars['ID'];
  checkoutUrl: Url;
};

export type HasHopUrl = {
  id: Scalars['ID'];
  hopUrl: Scalars['String'];
};

export type MaybeHasPropcoUrl = {
  id: Scalars['ID'];
  propcoUrl?: Maybe<Scalars['String']>;
};

export type MaybeHasProject = {
  project?: Maybe<Project>;
};

/**  Represents the valid joist 'op' options for updating a nested collection. */
export enum IncrementalCollectionOp {
  Include = 'include',
  Delete = 'delete',
  Remove = 'remove',
  Incremental = 'incremental'
}

export type SyncSalesforceEntityInput = {
  entityType: Scalars['String'];
  entityId: Scalars['ID'];
  operation: SalesforceEntityOperation;
  modifiedBy: SalesforceEntityModifiedByInput;
};

export enum SalesforceEntityOperation {
  Insert = 'INSERT',
  Update = 'UPDATE',
  Delete = 'DELETE',
  Undelete = 'UNDELETE'
}

export type SalesforceEntityModifiedByInput = {
  id: Scalars['ID'];
  email: Scalars['String'];
  name: Scalars['String'];
};

export type Schedule = ScheduleEntity & Named & MaybeHasInterval & MaybeHasBaselineInterval & {
  __typename?: 'Schedule';
  id: Scalars['ID'];
  name: Scalars['String'];
  interval?: Maybe<CalendarInterval>;
  baselineInterval?: Maybe<CalendarInterval>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  status: ScheduleStatus;
  statusDetail: ScheduleStatusDetail;
  stage: Stage;
  stageDetail: StageDetail;
  parent: ScheduleParent;
  scheduleSetting?: Maybe<ScheduleSetting>;
  canPublishSchedule: PotentialOperation2;
  canCompleteSchedule: PotentialOperation2;
  duration?: Maybe<Scalars['Int']>;
  baselineDuration?: Maybe<Scalars['Int']>;
  phases: Array<SchedulePhase>;
  isLocked: Scalars['Boolean'];
  flagCount: Scalars['Int'];
  templateSchedule?: Maybe<Schedule>;
  enableReviewReminders: Scalars['Boolean'];
  reviewReminderDays: Array<DayOfWeek>;
  market?: Maybe<Market>;
};

export type SchedulesFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  parent?: InputMaybe<Array<Scalars['ID']>>;
  stage?: InputMaybe<Array<Stage>>;
  status?: InputMaybe<Array<ScheduleStatus>>;
};

export type SchedulesResult = {
  __typename?: 'SchedulesResult';
  schedules: Array<Schedule>;
};

export type SaveScheduleInput = {
  id?: InputMaybe<Scalars['ID']>;
  parentId?: InputMaybe<Scalars['ID']>;
  stage?: InputMaybe<Stage>;
  status?: InputMaybe<ScheduleStatus>;
  /** Confirms that an unusual status change transition is intentionally being performed */
  confirmStatusException?: InputMaybe<Scalars['Boolean']>;
  reviewReminderDays?: InputMaybe<Array<DayOfWeek>>;
};

export type SaveScheduleResult = {
  __typename?: 'SaveScheduleResult';
  schedule: Schedule;
};

export type ScheduleParent = StandaloneProject | Region | Development | Market | Community | Subdivision | Lot | Structure | Unit | ScheduleTemplate;

export type HasScheduleImpact = {
  impactedScheduleTasks: Array<ScheduleTask>;
  impactedScheduleSubPhases: Array<ScheduleSubPhase>;
  impactedSchedulePhases: Array<SchedulePhase>;
  impactedSchedules: Array<Schedule>;
  impacted: Array<ScheduleEntity>;
};

export type HasSchedules = {
  id: Scalars['ID'];
  schedules: Array<Schedule>;
};

export type ScheduleCorrectScheduleBaselines = {
  scheduleIds: Array<Scalars['ID']>;
  dryRun: Scalars['Boolean'];
};

export type ResetScheduleBaselinesInput = {
  projectIds: Array<Scalars['ID']>;
};

export type ResetScheduleBaselinesResult = {
  __typename?: 'ResetScheduleBaselinesResult';
  projectIds: Array<Scalars['ID']>;
};

export type AddJobsForSchedulesInput = {
  jobName: Scalars['String'];
  /**  These optional args will be merged with `scheduleId` before being passed to the job `payload`  */
  args?: InputMaybe<Scalars['JSONObject']>;
  scheduleFilter: SchedulesFilter;
};

export type ScheduleEntity = {
  id: Scalars['ID'];
  name: Scalars['String'];
  interval?: Maybe<CalendarInterval>;
  baselineInterval?: Maybe<CalendarInterval>;
  parent: ScheduleParent;
};

export type MaybeHasInterval = {
  id: Scalars['ID'];
  interval?: Maybe<CalendarInterval>;
};

export type MaybeHasBaselineInterval = {
  id: Scalars['ID'];
  baselineInterval?: Maybe<CalendarInterval>;
};

export type ScheduleFlag = Entity & {
  __typename?: 'ScheduleFlag';
  id: Scalars['ID'];
  durationInDays?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  reason?: Maybe<ScheduleFlagReason>;
  scheduleTask?: Maybe<ScheduleTask>;
  task: Task;
  attachments: Array<Attachment>;
};

export type SaveScheduleFlagInput = {
  id?: InputMaybe<Scalars['ID']>;
  durationInDays?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  reasonId?: InputMaybe<Scalars['ID']>;
  /** @deprecated use taskId instead */
  scheduleTaskId?: InputMaybe<Scalars['ID']>;
  taskId?: InputMaybe<Scalars['ID']>;
  /** @deprecated use oldTaskStartDate instead */
  oldTaskStart?: InputMaybe<Scalars['Date']>;
  /** @deprecated use newTaskStartDate instead */
  newTaskStart?: InputMaybe<Scalars['Date']>;
  /** @deprecated use oldTaskEndDate instead */
  oldTaskEnd?: InputMaybe<Scalars['Date']>;
  /** @deprecated use newTaskEndDate instead */
  newTaskEnd?: InputMaybe<Scalars['Date']>;
  oldTaskStartDate?: InputMaybe<Scalars['Date']>;
  newTaskStartDate?: InputMaybe<Scalars['Date']>;
  oldTaskEndDate?: InputMaybe<Scalars['Date']>;
  newTaskEndDate?: InputMaybe<Scalars['Date']>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
};

export type SaveScheduleFlagResult = {
  __typename?: 'SaveScheduleFlagResult';
  scheduleFlag: ScheduleFlag;
};

export type DeleteScheduleFlagInput = {
  id: Scalars['ID'];
};

export type DeleteScheduleFlagResult = {
  __typename?: 'DeleteScheduleFlagResult';
  /** @deprecated use task instead */
  scheduleTask?: Maybe<ScheduleTask>;
  task: Task;
};

export type ScheduleFlagFilter = {
  scheduleParent?: InputMaybe<Array<Scalars['ID']>>;
  internalUser?: InputMaybe<Array<Scalars['ID']>>;
  scheduleIsActive?: InputMaybe<Scalars['Boolean']>;
  taskStatus?: InputMaybe<Array<TaskStatus>>;
  /** @deprecated use task instead */
  scheduleTask?: InputMaybe<Array<Scalars['ID']>>;
  task?: InputMaybe<Array<Scalars['ID']>>;
};

export type ScheduleFlagImpact = {
  __typename?: 'ScheduleFlagImpact';
  id: Scalars['ID'];
  oldStartDate?: Maybe<Scalars['Date']>;
  newStartDate: Scalars['Date'];
  oldEndDate?: Maybe<Scalars['Date']>;
  newEndDate: Scalars['Date'];
  oldDurationInDays?: Maybe<Scalars['Int']>;
  newDurationInDays: Scalars['Int'];
  oldSlackInDays?: Maybe<Scalars['Int']>;
  newSlackInDays?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  scheduleFlag: ScheduleFlag;
  impacted?: Maybe<ScheduleFlagImpactImpacted>;
};

export type ScheduleFlagImpactImpacted = PlanMilestone | Task;

export type ScheduleFlagReason = Entity & {
  __typename?: 'ScheduleFlagReason';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  scheduleFlagReasonType: ScheduleFlagReasonTypeDetail;
  stages: Array<Stage>;
  scheduleFlags: Array<ScheduleFlag>;
  title: Scalars['String'];
  attachmentIsRequired: Scalars['Boolean'];
  descriptionIsRequired: Scalars['Boolean'];
};

export type ScheduleFlagReasonsFilter = {
  stage?: InputMaybe<Array<Stage>>;
};

export type SaveScheduleFlagReasonsInput = {
  scheduleFlagReasons: Array<SaveScheduleFlagReasonInput>;
};

export type SaveScheduleFlagReasonsResult = {
  __typename?: 'SaveScheduleFlagReasonsResult';
  scheduleFlagReasons: Array<ScheduleFlagReason>;
};

export type SaveScheduleFlagReasonInput = {
  id?: InputMaybe<Scalars['ID']>;
  scheduleFlagReasonType?: InputMaybe<ScheduleFlagReasonType>;
  stages?: InputMaybe<Array<Stage>>;
  title?: InputMaybe<Scalars['String']>;
  attachmentIsRequired?: InputMaybe<Scalars['Boolean']>;
  descriptionIsRequired?: InputMaybe<Scalars['Boolean']>;
};

export type SchedulePhaseProgress = {
  __typename?: 'SchedulePhaseProgress';
  scheduleSubPhaseProgress: ProgressSummary;
  taskProgress: ProgressSummary;
};

export type SchedulePhasesFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  /**  Obtain a list of SchedulePhases used on the specified parent(s)  */
  parent?: InputMaybe<Array<Scalars['ID']>>;
  /**  Obtain a list of SchedulePhases used on the specified schedule(s)  */
  schedule?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveSchedulePhasesResult = {
  __typename?: 'SaveSchedulePhasesResult';
  schedulePhases: Array<SchedulePhase>;
};

export type DeleteSchedulePhasesResult = HasScheduleImpact & {
  __typename?: 'DeleteSchedulePhasesResult';
  impactedScheduleTasks: Array<ScheduleTask>;
  impactedScheduleSubPhases: Array<ScheduleSubPhase>;
  impactedSchedulePhases: Array<SchedulePhase>;
  impactedSchedules: Array<Schedule>;
  impacted: Array<ScheduleEntity>;
};

export type SaveSchedulePhasesInput = {
  schedulePhases: Array<SaveSchedulePhaseInput>;
};

export type SaveSchedulePhaseInput = {
  id?: InputMaybe<Scalars['ID']>;
  schedule?: InputMaybe<Scalars['ID']>;
  globalPhase?: InputMaybe<Scalars['ID']>;
  globalPhaseId?: InputMaybe<Scalars['ID']>;
};

export type ScheduleSetting = {
  __typename?: 'ScheduleSetting';
  id: Scalars['ID'];
  workingDays: Array<DayOfWeek>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  schedule: Schedule;
  exceptions?: Maybe<Scalars['JSONObject']>;
};

export type SaveScheduleSettingInput = {
  id?: InputMaybe<Scalars['ID']>;
  workingDays?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
  scheduleId?: InputMaybe<Scalars['ID']>;
};

export type SaveScheduleSettingsInput = {
  scheduleSettings: Array<SaveScheduleSettingInput>;
};

export type SaveScheduleSettingsResult = {
  __typename?: 'SaveScheduleSettingsResult';
  scheduleSettings: Array<ScheduleSetting>;
};

export type ScheduleSubPhaseProgress = {
  __typename?: 'ScheduleSubPhaseProgress';
  taskProgress: ProgressSummary;
};

export type SaveScheduleSubPhasesInput = {
  scheduleSubPhases: Array<SaveScheduleSubPhaseInput>;
};

export type SaveScheduleSubPhaseInput = {
  id?: InputMaybe<Scalars['ID']>;
  /** Can specify either a SubPhase tagged ID or the name of an existing/new SubPhase */
  globalSubPhaseId?: InputMaybe<Scalars['ID']>;
  schedulePhaseId?: InputMaybe<Scalars['ID']>;
};

export type SaveScheduleSubPhasesResult = {
  __typename?: 'SaveScheduleSubPhasesResult';
  scheduleSubPhases: Array<ScheduleSubPhase>;
};

export type ScheduleSubPhasesFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  /**  Obtain a list of ScheduleSubPhases used on the specified parent(s)  */
  parent?: InputMaybe<Array<Scalars['ID']>>;
  /**  Obtain a list of ScheduleSubPhases used on the specified schedule(s)  */
  schedule?: InputMaybe<Array<Scalars['ID']>>;
};

export type DeleteScheduleSubPhasesResult = HasScheduleImpact & {
  __typename?: 'DeleteScheduleSubPhasesResult';
  impactedScheduleTasks: Array<ScheduleTask>;
  impactedScheduleSubPhases: Array<ScheduleSubPhase>;
  impactedSchedulePhases: Array<SchedulePhase>;
  impactedSchedules: Array<Schedule>;
  impacted: Array<ScheduleEntity>;
};

export type MoveScheduleSubPhasesInput = {
  schedule: Scalars['ID'];
  moves: Array<MoveScheduleSubPhasesMovesInput>;
};

export type MoveScheduleSubPhasesMovesInput = {
  scheduleSubPhase: Scalars['ID'];
  targetGlobalPhase: Scalars['ID'];
};

export type MoveScheduleSubPhasesResult = HasScheduleImpact & {
  __typename?: 'MoveScheduleSubPhasesResult';
  impactedScheduleTasks: Array<ScheduleTask>;
  impactedScheduleSubPhases: Array<ScheduleSubPhase>;
  impactedSchedulePhases: Array<SchedulePhase>;
  impactedSchedules: Array<Schedule>;
  impacted: Array<ScheduleEntity>;
};

export type SaveScheduleTasksInput = {
  tasks: Array<SaveScheduleTaskInput>;
};

export type SaveScheduleTaskInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  durationInDays?: InputMaybe<Scalars['Int']>;
  complete?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<TaskStatus>;
  internalNote?: InputMaybe<Scalars['String']>;
  internalUserId?: InputMaybe<Scalars['ID']>;
  /** Incremental predecessors updates, i.e. either delete or append instead of an exhaustive set. */
  predecessorDependencies?: InputMaybe<Array<TaskDependencyInput>>;
  /** Incremental successor updates, i.e. either delete or append instead of an exhaustive set. */
  successorDependencies?: InputMaybe<Array<TaskDependencyInput>>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
  homeownerDescription?: InputMaybe<Scalars['String']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Note: allowMilestoneDelete must also include delete as true, will currently only work when the tasks schedule stage is DEVELOPMENT */
  allowMilestoneDelete?: InputMaybe<Scalars['Boolean']>;
  /**
   * Note: if this task has predecessors, setting `startDate` will updated predecessor dependency lag to derive the desired start date.
   * Therefore `startDate` shouldn't be combined with `predecessorDependencies` as it will override any `predecessorDependencies` values.
   */
  startDate?: InputMaybe<Scalars['Date']>;
  salesforceId?: InputMaybe<Scalars['String']>;
  tradePartnerId?: InputMaybe<Scalars['ID']>;
  /**
   * Must be specified when creating a new task without specifying an activityId,
   * in which case it is expected that one or both of phase/subPhase will be specified
   */
  scheduleId?: InputMaybe<Scalars['ID']>;
  projectStageId?: InputMaybe<Scalars['ID']>;
  /**
   * Sets the phase of the task appropriately based on what is specified:
   *
   * `null` - disassociates from any `Phase` or `SubPhase`
   * (in the backend this is equivalent to associating with the default
   * `Phase` and `SubPhase`)
   * `[Tagged Phase ID]` - finds or creates an associated `SchedulePhase` for the
   * specified `Phase` and assigns the task appropriately.
   *
   * NOTE: When setting only this field, subPhase will be cleared
   * (aka set to the default `SubPhase`/`ScheduleSubPhase` for the selected phase)
   */
  schedulePhase?: InputMaybe<Scalars['ID']>;
  /**
   * Sets the subPhase (and sometimes phase) appropriately based on what is specified:
   *
   * `null` - disassociates from any `SubPhase`
   * (in the backend this is equivalent to associating with the default `SubPhase`
   * for the currently selected `Phase`)
   * `[Tagged SubPhase ID]` - finds or creates an associated `ScheduleSubPhase` for the
   * specified `SubPhase` and assigns the task appropriately.
   * NOTE: This may also result in changing the Phase/SchedulePhase associated with the task
   * `[NEW SubCategoryName]` - Attempts to find/create a new global `SubPhase` with the provided value as it's name.
   * It will then proceed as though the tagged ID of the new global `SubPhase` had been specified.
   * NOTE: This will be used as the way the schedule UI creates new `SubPhases`/`ScheduleSubPhases`, and
   * only works if a non-default `Phase` is associated with the task.
   */
  scheduleSubPhase?: InputMaybe<Scalars['ID']>;
  projectItems?: InputMaybe<Array<Scalars['ID']>>;
  deadlineType?: InputMaybe<TaskDeadlineType>;
  templateProjectRole?: InputMaybe<ProjectRole>;
  documents?: InputMaybe<Array<Scalars['ID']>>;
  globalTaskId?: InputMaybe<Scalars['ID']>;
  /** @deprecated Use tradePartnerStatus instead */
  tradePartnerIsScheduled?: InputMaybe<Scalars['Boolean']>;
  scheduleTaskChecklistItems?: InputMaybe<Array<SaveScheduleTaskChecklistItemInput>>;
  tradePartnerStatus?: InputMaybe<TradePartnerTaskStatus>;
  workDays?: InputMaybe<Array<TaskWorkDayIncrementalInput>>;
};

export type SaveScheduleTasksResult = HasScheduleImpact & {
  __typename?: 'SaveScheduleTasksResult';
  scheduleTasks: Array<ScheduleTask>;
  impactedScheduleTasks: Array<ScheduleTask>;
  impactedScheduleSubPhases: Array<ScheduleSubPhase>;
  impactedSchedulePhases: Array<SchedulePhase>;
  impactedSchedules: Array<Schedule>;
  impacted: Array<ScheduleEntity>;
  resultingDelays: Array<ResultingDelay>;
  generatedInvoices: Array<Invoice>;
  generatedDepositBills: Array<Bill>;
};

export type ResultingDelay = {
  __typename?: 'ResultingDelay';
  scheduleTask: ScheduleTask;
  durationInDays: Scalars['Int'];
  oldTaskStart: Scalars['Date'];
  oldTaskEnd: Scalars['Date'];
};

export type ScheduleTaskFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  internalUser?: InputMaybe<Array<Scalars['ID']>>;
  /**  Only tasks assigned to the currently-logged-in user.  */
  myTasks?: InputMaybe<Scalars['Boolean']>;
  /**  Only return tasks whose activity / stage / project are all active; Candidate to drop from this filter?  */
  effectivelyActive?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Array<TaskStatus>>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
  /**  Candidate to drop from this filter?  */
  stale?: InputMaybe<Scalars['Boolean']>;
  /**  Note: Flipped the names on these interval filters so we can deprecate interval2 in the future  */
  interval?: InputMaybe<IntervalFilter2>;
  interval2?: InputMaybe<IntervalFilter>;
  slackInDays?: InputMaybe<IntFilter>;
  market?: InputMaybe<Array<Scalars['ID']>>;
  project?: InputMaybe<Array<Scalars['ID']>>;
  stage?: InputMaybe<Array<Stage>>;
  tradePartner?: InputMaybe<Array<Scalars['ID']>>;
  scheduleSubPhase?: InputMaybe<Array<Scalars['ID']>>;
  schedulePhase?: InputMaybe<Array<Scalars['ID']>>;
  deadlineType?: InputMaybe<Array<TaskDeadlineType>>;
  schedule?: InputMaybe<Array<Scalars['ID']>>;
  scheduleParent?: InputMaybe<Array<Scalars['ID']>>;
  isCriticalPath?: InputMaybe<Scalars['Boolean']>;
  isGlobalMilestoneTask?: InputMaybe<Scalars['Boolean']>;
  startDateRange?: InputMaybe<DateFilter2>;
  endDateRange?: InputMaybe<DateFilter2>;
  /** @deprecated Use tradePartnerStatus instead */
  tradePartnerIsScheduled?: InputMaybe<Scalars['Boolean']>;
  /**  Filter for tasks through the `parent: Project -> Development` relationship (vs `parent: Development`)  */
  projectTasksForDevelopment?: InputMaybe<Scalars['ID']>;
  scheduleIsActive?: InputMaybe<Scalars['Boolean']>;
  hasChecklist?: InputMaybe<Scalars['Boolean']>;
  hasScheduleFlags?: InputMaybe<Scalars['Boolean']>;
  systemTask?: InputMaybe<Array<SystemTask>>;
  projectStatus?: InputMaybe<Array<ProjectStatus>>;
  tradePartnerStatus?: InputMaybe<Array<TradePartnerTaskStatus>>;
};

/**
 * Supported ordering for tasks.
 *
 * Currently we don't support ordering by:
 *
 * - name, b/c we'd to do `COALESCE(task_def.name, task.name) - though we are likely to address that soon
 * - status, b/c it's a combination of stale & overdue that is calc'd in TS
 */
export type ScheduleTaskOrder = {
  id?: InputMaybe<Order>;
  project?: InputMaybe<Order>;
  internalUser?: InputMaybe<Order>;
  endDate?: InputMaybe<Order>;
  /**  Sorts by the ~deprecated? sort order.  */
  sortOrder?: InputMaybe<Order>;
};

export type MilestoneTasksForTemplatesInput = {
  templates: Array<Scalars['ID']>;
};

export type ScheduleTaskChecklistItem = Entity & {
  __typename?: 'ScheduleTaskChecklistItem';
  id: Scalars['ID'];
  description: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  completedBy?: Maybe<InternalUser>;
  isCompleted: Scalars['Boolean'];
  task: ScheduleTask;
  templateChecklistItem?: Maybe<ScheduleTaskChecklistItem>;
  scheduleTaskChecklistItems: Array<ScheduleTaskChecklistItem>;
  canDelete: PotentialOperation2;
};

export type SaveScheduleTaskChecklistItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  taskId?: InputMaybe<Scalars['ID']>;
};

export type SaveScheduleTaskChecklistItemResult = {
  __typename?: 'SaveScheduleTaskChecklistItemResult';
  scheduleTaskChecklistItem: ScheduleTaskChecklistItem;
};

export type DeleteScheduleTaskChecklistItemInput = {
  id: Scalars['ID'];
};

export type ApplyTemplateChecklistItems = {
  scheduleParentIds: Array<Scalars['ID']>;
  stages?: InputMaybe<Array<Stage>>;
};

export type ScheduleTaskDependency = {
  __typename?: 'ScheduleTaskDependency';
  type: TaskDependencyType;
  lagInDays: Scalars['Int'];
  predecessor: ScheduleTask;
  successor: ScheduleTask;
  /** ID of the dependency record (not the dependency task) - only used for keeping the apollo cache up to date */
  id: Scalars['ID'];
};

export type TaskDependencyInput = {
  delete?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<TaskDependencyType>;
  lagInDays?: InputMaybe<Scalars['Int']>;
  predecessorId?: InputMaybe<Scalars['ID']>;
  successorId?: InputMaybe<Scalars['ID']>;
};

export type ScheduleTemplate = Named & HasSchedules & MaybeHasMarket & {
  __typename?: 'ScheduleTemplate';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  status: ScheduleTemplateStatus;
  statusDetail: ScheduleTemplateStatusDetail;
  stage: Stage;
  stageDetail: StageDetail;
  market?: Maybe<Market>;
  schedules: Array<Schedule>;
  /**  For a project-level schedule template, the developments that the schedule template might be used in.  */
  developments: Array<Development>;
  itemMappings: Array<ScheduleTemplateItemMapping>;
};

export type ScheduleTemplatesFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  market?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Array<ScheduleTemplateStatus>>;
  stage?: InputMaybe<Array<Stage>>;
};

export type SaveScheduleTemplateInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ScheduleTemplateStatus>;
  stage?: InputMaybe<Stage>;
  marketId?: InputMaybe<Scalars['ID']>;
  developmentIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveScheduleTemplatesInput = {
  scheduleTemplates: Array<SaveScheduleTemplateInput>;
};

export type DuplicateScheduleTemplateInput = {
  scheduleTemplateId: Scalars['ID'];
  name: Scalars['String'];
  market?: InputMaybe<Scalars['ID']>;
};

export type SaveScheduleTemplatesResult = {
  __typename?: 'SaveScheduleTemplatesResult';
  scheduleTemplates: Array<ScheduleTemplate>;
  userErrors?: Maybe<Array<UserError>>;
};

export type DuplicateScheduleTemplateResult = {
  __typename?: 'DuplicateScheduleTemplateResult';
  scheduleTemplate?: Maybe<ScheduleTemplate>;
  userErrors?: Maybe<Array<UserError>>;
};

export type ApplyScheduleTemplateInput = {
  scheduleTemplateId: Scalars['ID'];
  scheduleParentId: Scalars['ID'];
  stage: Stage;
  replaceExisting?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['Date']>;
};

export type ApplyScheduleTemplatesInput = {
  scheduleTemplates: Array<ApplyScheduleTemplateInput>;
};

export type ApplyScheduleTemplatesResult = {
  __typename?: 'ApplyScheduleTemplatesResult';
  /**  ScheduleParents updated by the operation  */
  scheduleParents: Array<ScheduleParent>;
  /**  Schedules updated by the operation  */
  schedules: Array<Schedule>;
};

export type ScheduleTemplateItemMapping = {
  __typename?: 'ScheduleTemplateItemMapping';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  costType: CostTypeDetail;
  item: Item;
  location: Location;
  scheduleTemplate: ScheduleTemplate;
  task: Task;
};

export type SaveScheduleTemplateItemMappingInput = {
  id?: InputMaybe<Scalars['ID']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  costType?: InputMaybe<CostType>;
  itemId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
  scheduleTemplateId?: InputMaybe<Scalars['ID']>;
  taskId?: InputMaybe<Scalars['ID']>;
};

export type SaveScheduleTemplateItemMappingsInput = {
  scheduleTemplateItemMappings: Array<SaveScheduleTemplateItemMappingInput>;
};

export type SaveScheduleTemplateItemMappingsResult = {
  __typename?: 'SaveScheduleTemplateItemMappingsResult';
  scheduleTemplateItemMappings: Array<ScheduleTemplateItemMapping>;
};

export type SchedulingExclusionDate = {
  __typename?: 'SchedulingExclusionDate';
  id: Scalars['ID'];
  date: Scalars['Date'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  parent: SchedulingExclusionDateParent;
};

export type SchedulingExclusionDateFilter = {
  id?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['ID']>;
};

export type SaveSchedulingExclusionDateInput = {
  id?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  op: IncrementalCollectionOp;
};

export type SchedulingExclusionDateParent = StandaloneProject | Region | Development | Market | Community | Subdivision | Lot | Structure | Unit;

export type ScopeChangeReason = {
  __typename?: 'ScopeChangeReason';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type SaveScopeChangeReasonInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type SaveScopeChangeReasonResult = {
  __typename?: 'SaveScopeChangeReasonResult';
  scopeChangeReason: ScopeChangeReason;
};

export type SetupDataInput = {
  factoryScript: Scalars['String'];
};

export type SiteSpecificInfo = {
  __typename?: 'SiteSpecificInfo';
  id: Scalars['ID'];
  description: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type SaveSiteSpecificInfoInput = {
  id?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
};

export type SaveSiteSpecificInfoResult = {
  __typename?: 'SaveSiteSpecificInfoResult';
  siteSpecificInfo: SiteSpecificInfo;
};

export type SaveStructureInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  buildAddress?: InputMaybe<AddressInput>;
  /**  Only used for creating the Project.  */
  client?: InputMaybe<ClientInput>;
  /**  Add's a new coverImage to a project.  */
  coverImage?: InputMaybe<AssetInput>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ProjectStatus>;
  /**  Only used for creating the Project.  */
  startDate?: InputMaybe<Scalars['Date']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']>;
  planRoomLink?: InputMaybe<Scalars['String']>;
  salesforceAccountId?: InputMaybe<Scalars['String']>;
  projectStatusChange?: InputMaybe<ProjectStatusChangeInput>;
  isDisaster?: InputMaybe<Scalars['Boolean']>;
  intakeStyleNotes?: InputMaybe<Scalars['String']>;
  lotType?: InputMaybe<LotType>;
  productTypeId?: InputMaybe<Scalars['ID']>;
  projectRoles?: InputMaybe<Array<UpdateProjectRoleInput>>;
  salesforcePropertyId?: InputMaybe<Scalars['String']>;
  scopeMode?: InputMaybe<ScopeMode>;
  lotPartitionId?: InputMaybe<Scalars['String']>;
  warrantyStartDate?: InputMaybe<Scalars['Date']>;
  checkoutCustomerConfigId?: InputMaybe<Scalars['String']>;
  directCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']>;
  indirectCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']>;
  customerId?: InputMaybe<Scalars['ID']>;
  customerOwnerEntityId?: InputMaybe<Scalars['ID']>;
  builderId?: InputMaybe<Scalars['ID']>;
  legalDescription?: InputMaybe<Scalars['String']>;
  salesTaxOverrideInBasisPoints?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['ID']>;
  grossSalesPriceInCents?: InputMaybe<Scalars['Int']>;
  closingCostsForDirectMarginInCents?: InputMaybe<Scalars['Int']>;
  purchaseCostInCents?: InputMaybe<Scalars['Int']>;
  showInCheckout?: InputMaybe<Scalars['Boolean']>;
  primaryProjectId?: InputMaybe<Scalars['ID']>;
  suburbanAssetCategory?: InputMaybe<SuburbanAssetCategory>;
  modelHomeHardCostsInCents?: InputMaybe<Scalars['Int']>;
  modelHomeSoftCostsInCents?: InputMaybe<Scalars['Int']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyLicenseNumber?: InputMaybe<Scalars['String']>;
  lotSalesStatus?: InputMaybe<LotSalesStatus>;
  /**  Saves to the Structure's projectReadyPlanConfig.  */
  includedPriceInCents?: InputMaybe<Scalars['Int']>;
  includedOptions?: InputMaybe<Array<Scalars['ID']>>;
  invoicePaymentNetDays?: InputMaybe<Scalars['Int']>;
  /**  Links this (ADU) structure to its main house structure, which must be an SFH within the same Lot.  */
  mainHouseStructureId?: InputMaybe<Scalars['ID']>;
};

export type SaveStructureResult = {
  __typename?: 'SaveStructureResult';
  structure: Structure;
};

export type StructuresPageResult = {
  __typename?: 'StructuresPageResult';
  entities: Array<Structure>;
  pageInfo: PageInfo;
};

export type SaveSubdivisionInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  buildAddress?: InputMaybe<AddressInput>;
  /**  Only used for creating the Project.  */
  client?: InputMaybe<ClientInput>;
  /**  Add's a new coverImage to a project.  */
  coverImage?: InputMaybe<AssetInput>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ProjectStatus>;
  /**  Only used for creating the Project.  */
  startDate?: InputMaybe<Scalars['Date']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']>;
  planRoomLink?: InputMaybe<Scalars['String']>;
  salesforceAccountId?: InputMaybe<Scalars['String']>;
  projectStatusChange?: InputMaybe<ProjectStatusChangeInput>;
  isDisaster?: InputMaybe<Scalars['Boolean']>;
  intakeStyleNotes?: InputMaybe<Scalars['String']>;
  lotType?: InputMaybe<LotType>;
  productTypeId?: InputMaybe<Scalars['ID']>;
  projectRoles?: InputMaybe<Array<UpdateProjectRoleInput>>;
  salesforcePropertyId?: InputMaybe<Scalars['String']>;
  scopeMode?: InputMaybe<ScopeMode>;
  lotPartitionId?: InputMaybe<Scalars['String']>;
  warrantyStartDate?: InputMaybe<Scalars['Date']>;
  checkoutCustomerConfigId?: InputMaybe<Scalars['String']>;
  directCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']>;
  indirectCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']>;
  customerId?: InputMaybe<Scalars['ID']>;
  customerOwnerEntityId?: InputMaybe<Scalars['ID']>;
  builderId?: InputMaybe<Scalars['ID']>;
  legalDescription?: InputMaybe<Scalars['String']>;
  salesTaxOverrideInBasisPoints?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['ID']>;
  salesforceBusinessDevelopmentOpportunityId?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyLicenseNumber?: InputMaybe<Scalars['String']>;
  invoicePaymentNetDays?: InputMaybe<Scalars['Int']>;
  salesforceTakedownId?: InputMaybe<Scalars['String']>;
};

export type SaveSubdivisionResult = {
  __typename?: 'SaveSubdivisionResult';
  subdivision: Subdivision;
};

export type Submarket = Named & {
  __typename?: 'Submarket';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  market: Market;
};

export type SaveSubmarketInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  marketId?: InputMaybe<Scalars['ID']>;
};

export type SaveSubmarketResult = {
  __typename?: 'SaveSubmarketResult';
  submarket: Submarket;
};

export type CopyTakeoffLineItemsInput = {
  targetReadyPlanId: Scalars['ID'];
  sourceReadyPlanId?: InputMaybe<Scalars['ID']>;
  sourceItemIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type CopyTakeoffLineItemsResult = {
  __typename?: 'CopyTakeoffLineItemsResult';
  targetReadyPlan: ReadyPlan;
  sourceReadyPlans: Array<ReadyPlan>;
  /** The sourceItems which were cloned, when sourceItemIds was specified and contained TLI IDs, otherwise [] */
  sourceItems: Array<TakeoffLineItem>;
  /** The new TLIs that were copied during the operation */
  copiedItems: Array<TakeoffLineItem>;
};

export type TliGroupTotalsInput = {
  filter?: InputMaybe<TakeoffLineItemFilter>;
  order?: InputMaybe<Array<TakeoffLineItemOrder>>;
};

export type TakeoffLineItemFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  readyPlan?: InputMaybe<Array<Scalars['ID']>>;
  development?: InputMaybe<Array<Scalars['ID']>>;
  location?: InputMaybe<Array<Scalars['ID']>>;
  /**  Return any TLI which includes the specified location IDs in its location path.  */
  locationInPath?: InputMaybe<Array<Scalars['ID']>>;
  item?: InputMaybe<Array<Scalars['ID']>>;
  unitOfMeasure?: InputMaybe<Array<Scalars['ID']>>;
  costType?: InputMaybe<Array<CostType>>;
  costCode?: InputMaybe<Array<Scalars['ID']>>;
  costDivision?: InputMaybe<Array<Scalars['ID']>>;
  materialVariant?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Include 'null' in the list of IDs to return items having no options assigned.
   * This means they are applicable to the plan generally, regardless of options chosen.
   * Unlike the option/specOption/elevation filters, this is applied to all assigned options regardless of type.
   */
  options?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /**
   * Filter based on underlying Global Option. Useful for loading similar options across multiple
   * templates. More general than `options` filter and IGNORED if `option` is non-empty.
   */
  globalOption?: InputMaybe<Array<Scalars['ID']>>;
  /**  Filter based on text search using SQL LIKE.  */
  search?: InputMaybe<Scalars['String']>;
  /**  Filter based on whether the item have anomalies or not. Currently only true or undefined is supported.  */
  hasAnomalies?: InputMaybe<Scalars['Boolean']>;
  materialType?: InputMaybe<Array<MaterialType>>;
  globalPlanTask?: InputMaybe<Array<Scalars['ID']>>;
  /**  Filter to only TLIs with or without plan lines.  Implicitly sets materialType to [PLACEHOLDER] if not present.  */
  hasPlanLines?: InputMaybe<Scalars['Boolean']>;
  designPackageType?: InputMaybe<Array<TakeoffLineItemDesignPackageType>>;
  isMissingPreferredBid?: InputMaybe<Scalars['Boolean']>;
  modifiedInCurrentVersion?: InputMaybe<Scalars['Boolean']>;
  /**  When true, includes TLIs that were removed in this version. Useful for highlighting changes. */
  includeRemoved?: InputMaybe<Scalars['Boolean']>;
};

export type TakeoffLineItemsPage = {
  __typename?: 'TakeoffLineItemsPage';
  items: Array<TakeoffLineItem>;
  pageInfo: PageInfo;
  groupTotals: Array<TakeoffLineItemGroupTotal>;
};

export type TakeoffLineItemGroupTotal = {
  __typename?: 'TakeoffLineItemGroupTotal';
  groupId: Scalars['String'];
  totalCostInCents: Scalars['Int'];
  tlisInGroup: Scalars['Int'];
  tliIdsInGroup: Array<Scalars['ID']>;
  activeTliIdsInGroup: Array<Scalars['ID']>;
  displayName: Scalars['String'];
  /**  The number of TLIs with costType = MATERIAL in the group.  */
  materialsInGroup: Scalars['Int'];
  /**  The number of TLIs with costType = LABOR in the group.  */
  tasksInGroup: Scalars['Int'];
};

/**
 * The FE will specify at most one of the following order fields, and optionally a groupBy value (defaults to None).
 * The BE will then order first by the groupBy value, and then by the specified order field, and then by whatever other fields
 * it deems appropriate to keep related items close to each other an in a convenient/consistent order.
 */
export type TakeoffLineItemOrder = {
  field: ItivOrderField;
  direction: Order;
};

export type TestGroupDependenciesLineItemsInput = {
  addonOptionId: Scalars['ID'];
  personalizationOptionGroupId: Scalars['ID'];
};

/**  TODO: Inspect this type to ensure only desired fields are included  */
export type TakeoffLineItem = Named & HasDisplayName & HasBlueprintUrl & BaseItemLike & {
  __typename?: 'TakeoffLineItem';
  id: Scalars['ID'];
  identityId: Scalars['ID'];
  active: Scalars['Boolean'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  parent: ReadyPlanLike;
  readyPlan: ReadyPlanLike;
  first: ReadyPlanAggregateVersion;
  customPlaceholderName?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  totalCostInCents: Scalars['Int'];
  unitCostInCents: Scalars['Int'];
  isDisabledMaterialVariant: Scalars['Boolean'];
  tradePartnerNote?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  specifications?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  costType: CostType;
  costTypeDetail: CostTypeDetail;
  costStatus: ItemTemplateItemCostStatusDetail;
  placeholder?: Maybe<TakeoffLineItem>;
  preferredBidContractLineItem?: Maybe<BidContractLineItem>;
  bidItem?: Maybe<BidItem>;
  /**  Only for BaseItemLike compatibility, always returns null.  */
  bidItemTemplateItem?: Maybe<TakeoffLineItem>;
  development?: Maybe<Development>;
  drop?: Maybe<Drop>;
  item: Item;
  slot: ItemSlot;
  location: Location;
  materialVariant?: Maybe<MaterialVariant>;
  /**  Optional b/c this being required was making FE Apollo factories fill it in, which many tests don't have mocks for.  */
  task?: Maybe<GlobalPlanTask>;
  unitOfMeasure: UnitOfMeasure;
  products: Array<TakeoffLineItem>;
  options: Array<ReadyPlanOption>;
  /** @deprecated renamed to assemblyRootItem */
  rootAssemblyItem?: Maybe<TakeoffLineItem>;
  assemblyRootItem?: Maybe<TakeoffLineItem>;
  childItems: Array<TakeoffLineItem>;
  /**  Added by Tyler for FE compatibility (PP).  */
  canEdit: PotentialOperation2;
  canEditLocation: PotentialOperation2;
  canEditOptions: PotentialOperation2;
  canEditQuantity: PotentialOperation2;
  canEditMaterial: PotentialOperation2;
  canDuplicate: PotentialOperation2;
  /**  Added by Tyler for FE compatibility (DP).  */
  canDeleteFromDesignPackage: PotentialOperation2;
  canHaveActiveProductCards: PotentialOperation2;
  dpSignature: Scalars['String'];
  /**  Added by Chris for idk.  */
  blueprintUrl: Url;
  /**
   *  Helper for the FE multi-select dropdown
   * @deprecated Use options instead
   */
  elevationIds: Array<Scalars['ID']>;
  /**
   *  Helper for the FE multi-select dropdown
   * @deprecated Use options instead
   */
  specOptionIds: Array<Scalars['ID']>;
  /**
   *  Helper for the FE multi-select dropdown
   * @deprecated Use options instead
   */
  otherOptionIds: Array<Scalars['ID']>;
  costEstimate: CostEstimate;
  isPlaceholderMaterial: Scalars['Boolean'];
  isProductMaterial: Scalars['Boolean'];
  changeType: Scalars['String'];
  previous?: Maybe<TakeoffLineItemVersion>;
  planLines: Array<TakeoffLineItem>;
  personalizationOptionGroup?: Maybe<ReadyPlanOptionGroup>;
  personalizationPlaceholderControlledSlots: Array<TakeoffLineItem>;
  /**  For a regular placeholder, returns it's controlling IDP-based placeholder (if it's personalized). */
  personalizationShadowPlaceholder?: Maybe<TakeoffLineItem>;
  /**  For a RPO-based personalization placeholder, returns its IDP-based pair.  */
  personalizationIdpShadowPlaceholder?: Maybe<TakeoffLineItem>;
  /**  For a IDP-based personalization placeholder, returns its RPO-based pair.  */
  personalizationRpoShadowPlaceholder?: Maybe<TakeoffLineItem>;
  designPackageType?: Maybe<TakeoffLineItemDesignPackageTypeDetail>;
  targetGroups: Array<ReadyPlanOptionGroup>;
  targetCombinations: Array<DesignPackageOptionCombination>;
  missingCombinations: Array<DesignPackageOptionCombination>;
  designNotes: Array<ReadyPlanDesignNote>;
  packageDesignNotes?: Maybe<Scalars['String']>;
  targetPlan?: Maybe<PlanPackage>;
  personalizationSlotOrder?: Maybe<Scalars['Int']>;
  isTaxExempt: Scalars['Boolean'];
  taxableCostInCents: Scalars['Int'];
  taxInCents: Scalars['Int'];
  planPackageIncomingSlots: Array<PlanPackageIncomingSlot>;
  managingBidPackage?: Maybe<BidPackage>;
  action: TakeoffLineItemActionDetail;
  /**  The plan packages that are not covered by a design package placeholder's plan lines or incoming plan package slots.  */
  missingPlanPackages: Array<PlanPackage>;
};

export type SaveTakeoffLineItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  customPlaceholderName?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  /** @deprecated replaced by isTaxExempt/taxableCostInCents */
  totalCostInCents?: InputMaybe<Scalars['Int']>;
  isTaxExempt?: InputMaybe<Scalars['Boolean']>;
  taxableCostInCents?: InputMaybe<Scalars['Int']>;
  isDisabledMaterialVariant?: InputMaybe<Scalars['Boolean']>;
  tradePartnerNote?: InputMaybe<Scalars['String']>;
  internalNote?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Scalars['String']>;
  /** @deprecated Will be inferred from material/task */
  costType?: InputMaybe<CostType>;
  costStatus?: InputMaybe<ItemTemplateItemCostStatus>;
  placeholderId?: InputMaybe<Scalars['ID']>;
  preferredBidContractLineItemId?: InputMaybe<Scalars['ID']>;
  bidItemId?: InputMaybe<Scalars['ID']>;
  /**  Only required for placeholders defining a new variant, otherwise inferred for tasks & construction materials.  */
  itemId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
  materialVariantId?: InputMaybe<Scalars['ID']>;
  readyPlanId?: InputMaybe<Scalars['ID']>;
  /** @deprecated Added (but not implemented) for type-parity with TLIVFilter. Use readyPlanId instead */
  templateId?: InputMaybe<Scalars['ID']>;
  taskId?: InputMaybe<Scalars['ID']>;
  /**  Allows creating new placeholders, i.e. a Fridge that is 52in wide, from the takeoff UI.  */
  placeholderMaterialAttributeValues?: InputMaybe<Array<SaveMaterialAttributeValueInput>>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']>;
  /**  Added by Tyler for FE compatibility.  */
  remove?: InputMaybe<Scalars['Boolean']>;
  optionIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   *  Added by Tyler for FE compatibility with CSV Import.
   * @deprecated Will be inferred from material/task
   */
  costTypeName?: InputMaybe<Scalars['String']>;
  /** @deprecated Will be inferred from material */
  itemCode?: InputMaybe<Scalars['String']>;
  locationPath?: InputMaybe<Scalars['String']>;
  materialVariantCode?: InputMaybe<Scalars['String']>;
  optionCodes?: InputMaybe<Array<Scalars['String']>>;
  taskName?: InputMaybe<Scalars['String']>;
  unitOfMeasureName?: InputMaybe<Scalars['String']>;
  targetGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  targetCombinations?: InputMaybe<Array<SaveTargetCombinationInput>>;
  targetPlanId?: InputMaybe<Scalars['ID']>;
  /**  Creates PP placeholders and deletes pending PlanPackageIncomingSlot  */
  fulfillsPlanPackageIncomingSlotId?: InputMaybe<Scalars['ID']>;
  action?: InputMaybe<TakeoffLineItemAction>;
};

export type SaveTakeoffLineItemResult = {
  __typename?: 'SaveTakeoffLineItemResult';
  /**  The latest RPAV, which might be a new draft created by the save.  */
  version: ReadyPlanAggregateVersion;
  /**  The impacted TLIs that were just created/updated.  */
  takeoffLineItems: Array<TakeoffLineItem>;
  /**  Any TLIVs which were auto-added to the template due to the addition of a new material which requires labor.  */
  autoAddedLaborLines: Array<TakeoffLineItem>;
  /**  Any TLIVs that were removed from the template, but could not be deleted because they are used on a different version of the template.  */
  removed: Array<TakeoffLineItem>;
  /**  Any TLIVs that were deleted from the template.  */
  deleted: Array<Scalars['ID']>;
  /**  Only calculated if groupTotalsInput is provided.  */
  groupTotals: Array<TakeoffLineItemGroupTotal>;
};

export type TakeoffLineItemVersion = Named & HasDisplayName & HasBlueprintUrl & BaseItemLike & {
  __typename?: 'TakeoffLineItemVersion';
  id: Scalars['ID'];
  identityId: Scalars['ID'];
  quantity?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  specifications?: Maybe<Scalars['String']>;
  totalCostInCents: Scalars['Int'];
  unitCostInCents: Scalars['Int'];
  tradePartnerNote?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  displayName: Scalars['String'];
  parent: ReadyPlanLike;
  readyPlan: ReadyPlanLike;
  isDisabledMaterialVariant: Scalars['Boolean'];
  placeholder?: Maybe<TakeoffLineItem>;
  customPlaceholderName?: Maybe<Scalars['String']>;
  costType: CostType;
  costTypeDetail: CostTypeDetail;
  type: TakeoffLineItemTypeDetail;
  preferredBidContractLineItem?: Maybe<BidContractLineItem>;
  bidItem?: Maybe<BidItem>;
  bidItemTemplateItem?: Maybe<TakeoffLineItemVersion>;
  item: Item;
  slot: ItemSlot;
  location: Location;
  unitOfMeasure: UnitOfMeasure;
  dpSignature: Scalars['String'];
  canDeleteFromDesignPackage: PotentialOperation2;
  options: Array<ReadyPlanOption>;
  costStatus?: Maybe<ItemTemplateItemCostStatusDetail>;
  development?: Maybe<Development>;
  drop?: Maybe<Drop>;
  task?: Maybe<GlobalPlanTask>;
  materialVariant?: Maybe<MaterialVariant>;
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  identity: TakeoffLineItem;
  active: Scalars['Boolean'];
  blueprintUrl: Url;
  /**
   *  Helper for the FE multi-select dropdown
   * @deprecated Use options instead
   */
  elevationIds: Array<Scalars['ID']>;
  /**
   *  Helper for the FE multi-select dropdown
   * @deprecated Use options instead
   */
  specOptionIds: Array<Scalars['ID']>;
  /**
   *  Helper for the FE multi-select dropdown
   * @deprecated Use options instead
   */
  otherOptionIds: Array<Scalars['ID']>;
  costEstimate: CostEstimate;
  changeType: Scalars['String'];
  planLines: Array<TakeoffLineItem>;
  targetGroups: Array<ReadyPlanOptionGroup>;
  targetCombinations: Array<DesignPackageOptionCombination>;
  missingCombinations: Array<DesignPackageOptionCombination>;
  packageDesignNotes?: Maybe<Scalars['String']>;
  isTaxExempt: Scalars['Boolean'];
  taxableCostInCents: Scalars['Int'];
  taxInCents: Scalars['Int'];
  action: TakeoffLineItemActionDetail;
};

export enum TaskSchedulingStatus {
  Stale = 'STALE',
  OverBaseline = 'OVER_BASELINE',
  OnSchedule = 'ON_SCHEDULE'
}

export type DeleteTaskInput = {
  id: Scalars['ID'];
};

export type TaskPage = {
  __typename?: 'TaskPage';
  tasks: Array<Task>;
  pageInfo: PageInfo;
};

export type TaskFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  internalUser?: InputMaybe<Array<Scalars['ID']>>;
  /**  Only tasks assigned to the currently-logged-in user.  */
  myTasks?: InputMaybe<Scalars['Boolean']>;
  /**
   *  Only return tasks whose activity / stage / project are all active.
   * @deprecated Legacy attribute, will only return ScheduleTasks.
   */
  effectivelyActive?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Array<TaskStatus>>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated Legacy attribute, will only return ScheduleTasks. */
  isMilestone?: InputMaybe<Scalars['Boolean']>;
  stale?: InputMaybe<Scalars['Boolean']>;
  interval?: InputMaybe<IntervalFilter>;
  interval2?: InputMaybe<IntervalFilter2>;
  slackInDays?: InputMaybe<IntFilter>;
  /**  Todo: Rename this to marketId.  */
  market?: InputMaybe<Array<Scalars['ID']>>;
  /** Use scheduleParent instead */
  projectId?: InputMaybe<Array<Scalars['ID']>>;
  /** @deprecated Legacy attribute, will only return ScheduleTasks. */
  stage?: InputMaybe<Array<Stage>>;
  tradePartner?: InputMaybe<Array<Scalars['ID']>>;
  hasTradePartner?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated Legacy attribute, will only return ScheduleTasks. */
  scheduleSubPhase?: InputMaybe<Array<Scalars['ID']>>;
  /** @deprecated Legacy attribute, will only return ScheduleTasks. */
  deadlineType?: InputMaybe<Array<TaskDeadlineType>>;
  schedule?: InputMaybe<Array<Scalars['ID']>>;
  scheduleParent?: InputMaybe<Array<Scalars['ID']>>;
  /** @deprecated Legacy attribute, will only return ScheduleTasks. */
  schedulePhase?: InputMaybe<Array<Scalars['ID']>>;
  isCriticalPath?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated Legacy attribute, will only return ScheduleTasks. */
  isGlobalMilestoneTask?: InputMaybe<Scalars['Boolean']>;
  startDateRange?: InputMaybe<DateFilter2>;
  endDateRange?: InputMaybe<DateFilter2>;
  /** @deprecated Use tradePartnerStatus instead */
  tradePartnerIsScheduled?: InputMaybe<Scalars['Boolean']>;
  /**  Filter for tasks through the `parent: Project -> Development` relationship (vs `parent: Development`)  */
  projectTasksForDevelopment?: InputMaybe<Scalars['ID']>;
  /** @deprecated Legacy attribute, will only return ScheduleTasks. */
  scheduleIsActive?: InputMaybe<Scalars['Boolean']>;
  hasChecklist?: InputMaybe<Scalars['Boolean']>;
  hasScheduleFlags?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated Legacy attribute, will only return ScheduleTasks. */
  systemTask?: InputMaybe<Array<SystemTask>>;
  projectStatus?: InputMaybe<Array<ProjectStatus>>;
  tradePartnerStatus?: InputMaybe<Array<TradePartnerTaskStatus>>;
  /**  When true, include tasks tagged with a 'Hide From Schedule' GlobalPlanTag. Defaults to false (they are excluded).  */
  includeHiddenFromSchedule?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Supported ordering for tasks.
 *
 * Currently we don't support ordering by:
 *
 * - name, b/c we'd to do `COALESCE(task_def.name, task.name)
 * - status, b/c it's a combination of stale & overdue that is calc'd in TS
 */
export type TaskOrder = {
  id?: InputMaybe<Order>;
  project?: InputMaybe<Order>;
  internalUser?: InputMaybe<Order>;
  endDate?: InputMaybe<Order>;
  /**  Sorts by the ~deprecated? sort order.  */
  sortOrder?: InputMaybe<Order>;
};

export type ScheduleLike = Schedule | PlanSchedule;

export type TaskDependency = {
  __typename?: 'TaskDependency';
  type: TaskDependencyType;
  typeDetail: TaskDependencyTypeDetail;
  lagInDays: Scalars['Int'];
  predecessor: Task;
  successor: Task;
};

export type TaskSnapshot = {
  __typename?: 'TaskSnapshot';
  id: Scalars['ID'];
  range: Scalars['String'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  durationInDays: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  task: Task;
};

export type TaskWorkDay = Entity & {
  __typename?: 'TaskWorkDay';
  id: Scalars['ID'];
  workDay: Scalars['Date'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  task: Task;
};

export type SaveTaskWorkDayInput = {
  id?: InputMaybe<Scalars['ID']>;
  workDay?: InputMaybe<Scalars['Date']>;
  taskId?: InputMaybe<Scalars['ID']>;
};

export type SaveTaskWorkDayResult = {
  __typename?: 'SaveTaskWorkDayResult';
  taskWorkDay: TaskWorkDay;
};

export type TaskWorkDayIncrementalInput = {
  id?: InputMaybe<Scalars['ID']>;
  workDay?: InputMaybe<Scalars['Date']>;
  op: IncrementalCollectionOp;
};

export type SaveToDosInput = {
  toDos: Array<SaveToDoInput>;
};

export type SaveToDosResult = {
  __typename?: 'SaveToDosResult';
  toDos: Array<ToDo>;
};

export type SaveToDoAttachmentInput = {
  asset: AssetInput;
  /** `create` to add, `delete` to remove */
  op: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
};

export type SaveTodoChecklistItem = {
  id?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  isComplete?: InputMaybe<Scalars['Boolean']>;
  op: IncrementalCollectionOp;
};

export type SaveToDoInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ToDoStatus>;
  type?: InputMaybe<ToDoType>;
  dueDate?: InputMaybe<Scalars['Date']>;
  moveAfterId?: InputMaybe<Scalars['ID']>;
  moveBeforeId?: InputMaybe<Scalars['ID']>;
  /** @deprecated Use assigneeIds instead */
  assigneeId?: InputMaybe<Scalars['ID']>;
  assigneeIds?: InputMaybe<Array<Scalars['ID']>>;
  parentId?: InputMaybe<Scalars['ID']>;
  attachments?: InputMaybe<Array<SaveToDoAttachmentInput>>;
  urgent?: InputMaybe<Scalars['Boolean']>;
  checklistItems?: InputMaybe<Array<SaveTodoChecklistItem>>;
};

export type ToDoFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Array<ToDoStatus>>;
  type?: InputMaybe<Array<ToDoType>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  project?: InputMaybe<Array<Scalars['ID']>>;
  cohort?: InputMaybe<Array<Scalars['ID']>>;
  createdBy?: InputMaybe<Array<Scalars['ID']>>;
  assignee?: InputMaybe<Array<Scalars['ID']>>;
  market?: InputMaybe<Array<Scalars['ID']>>;
  dueDate?: InputMaybe<DateFilter2>;
  development?: InputMaybe<Array<Scalars['ID']>>;
  watching?: InputMaybe<Scalars['Boolean']>;
  urgent?: InputMaybe<Scalars['Boolean']>;
};

export type DeleteToDoInput = {
  id: Scalars['ID'];
};

export type ToDoParent = StandaloneProject | Region | Cohort | Development | Market | Community | Subdivision | Lot | Structure | Unit;

export type ToDoChecklistProgress = {
  __typename?: 'ToDoChecklistProgress';
  total: Scalars['Int'];
  completed: Scalars['Int'];
};

export type ToDoChecklistItem = {
  __typename?: 'ToDoChecklistItem';
  id: Scalars['ID'];
  description: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  toDo: ToDo;
  isComplete: Scalars['Boolean'];
};

export type SaveToDoChecklistItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  toDoId?: InputMaybe<Scalars['ID']>;
  isComplete?: InputMaybe<Scalars['Boolean']>;
};

export type SaveToDoChecklistItemResult = {
  __typename?: 'SaveToDoChecklistItemResult';
  toDoChecklistItem: ToDoChecklistItem;
};

export type TrackedJobFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Array<TrackedJobStatus>>;
  parent?: InputMaybe<Array<Scalars['ID']>>;
};

export type TrackedJob = {
  __typename?: 'TrackedJob';
  id: Scalars['ID'];
  pollIntervalInMs: Scalars['Int'];
  progressCurrent?: Maybe<Scalars['Int']>;
  progressTotal?: Maybe<Scalars['Int']>;
  progressMessage?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  status: TrackedJobStatusDetail;
  user: User;
  result?: Maybe<TrackedJobResult>;
  parent?: Maybe<TrackedJobParent>;
};

export type TrackedJobResult = Asset | BillOcr;

export type TrackedJobParent = ProductOffering;

export type TradeCategory = Named & HasDisplayName & {
  __typename?: 'TradeCategory';
  id: Scalars['ID'];
  number: Scalars['String'];
  name: Scalars['String'];
  /**  The number + name combined.  */
  displayName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  items: Array<Item>;
  tradePartners: Array<TradePartner>;
  developmentCommitments: Array<DevelopmentCommitment>;
  leadTimes: Array<TradeCategoryLeadTime>;
};

export type SaveTradeCategoryInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
};

export type SaveTradeCategoryResult = {
  __typename?: 'SaveTradeCategoryResult';
  tradeCategory: TradeCategory;
};

export type TradeCategoryLeadTimeLike = {
  leadTimeInDays: Scalars['Int'];
  market: Market;
  tradeCategory: TradeCategory;
  leadTimeFrequency: TimeFrequencyDetail;
};

export type TradeCategoryLeadTimeDefault = TradeCategoryLeadTimeLike & {
  __typename?: 'TradeCategoryLeadTimeDefault';
  leadTimeInDays: Scalars['Int'];
  market: Market;
  tradeCategory: TradeCategory;
  leadTimeFrequency: TimeFrequencyDetail;
};

export type TradeCategoryLeadTime = TradeCategoryLeadTimeLike & {
  __typename?: 'TradeCategoryLeadTime';
  id: Scalars['ID'];
  leadTimeInDays: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  leadTimeFrequency: TimeFrequencyDetail;
  market: Market;
  tradeCategory: TradeCategory;
};

export type SaveTradeCategoryLeadTimesInput = {
  tradeCategoryLeadTimes: Array<SaveTradeCategoryLeadTimeInput>;
};

export type SaveTradeCategoryLeadTimeInput = {
  id?: InputMaybe<Scalars['ID']>;
  leadTimeInDays?: InputMaybe<Scalars['Int']>;
  leadTimeFrequency?: InputMaybe<TimeFrequency>;
  marketId: Scalars['ID'];
  tradeCategoryId: Scalars['ID'];
};

export type SaveTradeCategoryLeadTimesResult = {
  __typename?: 'SaveTradeCategoryLeadTimesResult';
  tradeCategoryLeadTimes: Array<TradeCategoryLeadTime>;
};

export type TradeCategoryLeadTimeFilter = {
  market: Scalars['ID'];
  tradeCategory?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveTradePartnerInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  internalNote?: InputMaybe<Scalars['String']>;
  quickbooksId?: InputMaybe<Scalars['String']>;
  marketIds?: InputMaybe<Array<Scalars['ID']>>;
  contacts?: InputMaybe<Array<SaveTradePartnerContactChildInput>>;
  agreements?: InputMaybe<Array<SaveTradePartnerAgreementChildInput>>;
  doesMaterials?: InputMaybe<Scalars['Boolean']>;
  doesLabor?: InputMaybe<Scalars['Boolean']>;
  isSweetheart?: InputMaybe<Scalars['Boolean']>;
  sourceNote?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['ID']>;
  website?: InputMaybe<Scalars['String']>;
  doNotUse?: InputMaybe<Scalars['Boolean']>;
  intacctId?: InputMaybe<Scalars['String']>;
  costCodeIds?: InputMaybe<Array<Scalars['ID']>>;
  tradeCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  homeboundAccountNumber?: InputMaybe<Scalars['String']>;
  onboardingStatus?: InputMaybe<TradePartnerOnboardingStatus>;
  paymentTermId?: InputMaybe<Scalars['ID']>;
  enableClickToPay?: InputMaybe<Scalars['Boolean']>;
  isLienWaiverReceiver?: InputMaybe<Scalars['Boolean']>;
};

export type SaveTradePartnersInput = {
  tradePartners: Array<SaveTradePartnerInput>;
};

export type SaveTradePartnerResult = {
  __typename?: 'SaveTradePartnerResult';
  tradePartner: TradePartner;
};

export type SaveTradePartnersResult = {
  __typename?: 'SaveTradePartnersResult';
  tradePartners: Array<TradePartner>;
};

export type DeleteTradePartnerInput = {
  id: Scalars['ID'];
};

export type TradePartnerFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  markets?: InputMaybe<Array<Scalars['ID']>>;
  developmentIds?: InputMaybe<Array<Scalars['ID']>>;
  cohortIds?: InputMaybe<Array<Scalars['ID']>>;
  doNotUse?: InputMaybe<Scalars['Boolean']>;
  isSweetheart?: InputMaybe<Scalars['Boolean']>;
  averageScore?: InputMaybe<IntFilter>;
  costCodes?: InputMaybe<Array<Scalars['ID']>>;
  /**  Returns trade partners that cover all of the given cost codes.  */
  coversCostCodes?: InputMaybe<Array<Scalars['ID']>>;
  tradeCategories?: InputMaybe<Array<Scalars['ID']>>;
  workingOn?: InputMaybe<Array<Scalars['ID']>>;
  onboardingStatus?: InputMaybe<Array<InputMaybe<TradePartnerOnboardingStatus>>>;
  canLoginToPortal?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type SaveTradePartnerContactChildInput = {
  id?: InputMaybe<Scalars['ID']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  officePhone?: InputMaybe<Scalars['String']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  marketIds?: InputMaybe<Array<Scalars['ID']>>;
  mailingListIds?: InputMaybe<Array<Scalars['ID']>>;
  address?: InputMaybe<AddressInput>;
};

export type SaveTradePartnerAgreementChildInput = {
  id?: InputMaybe<Scalars['ID']>;
  costDivisionId?: InputMaybe<Scalars['ID']>;
  isNationalAgreement?: InputMaybe<Scalars['Boolean']>;
  internalNote?: InputMaybe<Scalars['String']>;
  delete?: InputMaybe<Scalars['Boolean']>;
};

export type TradePartnersPage = {
  __typename?: 'TradePartnersPage';
  entities: Array<TradePartner>;
  pageInfo: PageInfo;
};

export type TradePartnerAgreement = {
  __typename?: 'TradePartnerAgreement';
  id: Scalars['ID'];
  isNationalAgreement: Scalars['Boolean'];
  internalNote?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  costDivision: CostDivision;
  tradePartner: TradePartner;
};

export type SaveTradePartnerAgreementInput = {
  id?: InputMaybe<Scalars['ID']>;
  isNationalAgreement?: InputMaybe<Scalars['Boolean']>;
  internalNote?: InputMaybe<Scalars['String']>;
  costDivisionId?: InputMaybe<Scalars['ID']>;
  tradePartnerId?: InputMaybe<Scalars['ID']>;
};

export type SaveTradePartnerAgreementResult = {
  __typename?: 'SaveTradePartnerAgreementResult';
  tradePartnerAgreement: TradePartnerAgreement;
};

export type DeleteTradePartnerAgreementInput = {
  id: Scalars['ID'];
};

export type DeleteTradePartnerAgreementResult = {
  __typename?: 'DeleteTradePartnerAgreementResult';
  tradePartner: TradePartner;
};

export type SaveTradePartnerAvailabilityRequestInput = {
  id?: InputMaybe<Scalars['ID']>;
  emails?: InputMaybe<Array<SaveTradePartnerEmailInput>>;
  internalUserId?: InputMaybe<Scalars['ID']>;
  tradePartnerId?: InputMaybe<Scalars['ID']>;
  taskId?: InputMaybe<Scalars['ID']>;
  tradePartnerContactIds?: InputMaybe<Array<Scalars['ID']>>;
  tradePartnerConfirmationDate?: InputMaybe<Scalars['Date']>;
  rescheduleDates?: InputMaybe<Array<Scalars['Date']>>;
  status?: InputMaybe<TradePartnerAvailabilityRequestStatus>;
  rescheduleReasonNote?: InputMaybe<Scalars['String']>;
};

export type SaveTradePartnerAvailabilityRequestResult = {
  __typename?: 'SaveTradePartnerAvailabilityRequestResult';
  tradePartnerAvailabilityRequest: TradePartnerAvailabilityRequest;
};

export type SaveTradePartnerAvailabilityRequestsResult = {
  __typename?: 'SaveTradePartnerAvailabilityRequestsResult';
  tradePartnerAvailabilityRequests: Array<TradePartnerAvailabilityRequest>;
};

export type SaveTradePartnerEmailInput = {
  id?: InputMaybe<Scalars['ID']>;
  subject?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
};

export type UpdateTradePartnerAvailabilityRequestStatusInput = {
  ids: Array<Scalars['ID']>;
  status: TradePartnerAvailabilityRequestStatus;
};

export type TradePartnerAvailabilityRequestEmail = {
  __typename?: 'TradePartnerAvailabilityRequestEmail';
  id: Scalars['ID'];
  subject: Scalars['String'];
  message: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  tradePartnerAvailabilityRequest: TradePartnerAvailabilityRequest;
  attachments: Array<Attachment>;
};

export type TradePartnerAvailabilityRequestTextMessage = {
  __typename?: 'TradePartnerAvailabilityRequestTextMessage';
  id: Scalars['ID'];
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  tradePartnerAvailabilityRequest: TradePartnerAvailabilityRequest;
};

export type TradePartnerContactsFilter = {
  email?: InputMaybe<Scalars['String']>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
};

export type TradePartnerContact = Entity & Named & {
  __typename?: 'TradePartnerContact';
  id: Scalars['ID'];
  /** @deprecated Use tradePartnerMarketContacts instead */
  isPrimary: Scalars['Boolean'];
  /** @deprecated Use tradePartnerMarketContacts instead */
  isBillingSignatory: Scalars['Boolean'];
  name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  officePhone?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  canDelete: PotentialOperation2;
  canDeactivate: PotentialOperation2;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  tradePartner: TradePartner;
  title?: Maybe<Scalars['String']>;
  maybeBillingSignatory: Scalars['Boolean'];
  address?: Maybe<Address>;
  markets: Array<Market>;
  /** @deprecated Use mailingLists */
  tradePartnerMailingLists: Array<TradePartnerMailingList>;
  mailingLists: Array<TradePartnerMailingList>;
  tradePartnerUser?: Maybe<TradePartnerUser>;
  tradePartnerMarketContacts: Array<TradePartnerMarketContact>;
  canLoginToPortal: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
};

export type SaveTradePartnerContactInput = {
  id?: InputMaybe<Scalars['ID']>;
  address?: InputMaybe<AddressInput>;
  name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  officePhone?: InputMaybe<Scalars['String']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  tradePartnerId?: InputMaybe<Scalars['ID']>;
  maybeBillingSignatory?: InputMaybe<Scalars['Boolean']>;
  marketIds?: InputMaybe<Array<Scalars['ID']>>;
  mailingListIds?: InputMaybe<Array<Scalars['ID']>>;
  tradePartnerUserId?: InputMaybe<Scalars['ID']>;
  canLoginToPortal?: InputMaybe<Scalars['Boolean']>;
  reactivate?: InputMaybe<Scalars['Boolean']>;
};

export type SaveTradePartnerContactResult = {
  __typename?: 'SaveTradePartnerContactResult';
  tradePartnerContact: TradePartnerContact;
};

export type DeleteTradePartnerContactInput = {
  id: Scalars['ID'];
};

export type DeleteTradePartnerContactResult = {
  __typename?: 'DeleteTradePartnerContactResult';
  tradePartner: TradePartner;
  tradePartnerContact?: Maybe<TradePartnerContact>;
};

export type MarketContactWithRoles = {
  __typename?: 'MarketContactWithRoles';
  contact: TradePartnerContact;
  roles: Array<TradePartnerMarketRole>;
};

export type TradePartnerMailingList = Named & {
  __typename?: 'TradePartnerMailingList';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  tradePartnerContacts: Array<TradePartnerContact>;
};

export type TradePartnerMarketContact = {
  __typename?: 'TradePartnerMarketContact';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  role: TradePartnerMarketRoleDetail;
  market: Market;
  tradePartner: TradePartner;
  contact: TradePartnerContact;
};

export type SaveTradePartnerMarketContactInput = {
  id?: InputMaybe<Scalars['ID']>;
  role: TradePartnerMarketRole;
  marketId: Scalars['ID'];
  tradePartnerId: Scalars['ID'];
  contactId?: InputMaybe<Scalars['ID']>;
};

export type SaveTradePartnerMarketContactResult = {
  __typename?: 'SaveTradePartnerMarketContactResult';
  tradePartnerMarketContact: TradePartnerMarketContact;
};

export type DeleteTradePartnerMarketContactInput = {
  id: Scalars['ID'];
};

export type DeleteTradePartnerMarketContactResult = {
  __typename?: 'DeleteTradePartnerMarketContactResult';
  tradePartner: TradePartner;
};

export type TradePartnerRequirement = {
  __typename?: 'TradePartnerRequirement';
  id: Scalars['ID'];
  signedDate?: Maybe<Scalars['Date']>;
  expirationDate?: Maybe<Scalars['Date']>;
  licenseNumber?: Maybe<Scalars['String']>;
  coverageAmountInCents?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: TradePartnerRequirementTypeDetail;
  tradePartner: TradePartner;
  status: TradePartnerRequirementStatusDetail;
  internalNote?: Maybe<Scalars['String']>;
  attachments: Array<Attachment>;
};

export type SaveTradePartnerRequirementInput = {
  id?: InputMaybe<Scalars['ID']>;
  signedDate?: InputMaybe<Scalars['Date']>;
  expirationDate?: InputMaybe<Scalars['Date']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  coverageAmountInCents?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<TradePartnerRequirementType>;
  tradePartnerId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<TradePartnerRequirementStatus>;
  internalNote?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
};

export type SaveTradePartnerRequirementResult = {
  __typename?: 'SaveTradePartnerRequirementResult';
  tradePartnerRequirement: TradePartnerRequirement;
};

export type TradePartnerRequirementFilter = {
  tradePartnerId?: InputMaybe<Scalars['ID']>;
};

export type TradePartnerReview = {
  __typename?: 'TradePartnerReview';
  id: Scalars['ID'];
  recommended?: Maybe<Scalars['Boolean']>;
  score: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  internalUser: InternalUser;
  tradePartner: TradePartner;
  project: Project;
  internalNote?: Maybe<Scalars['String']>;
};

export type SaveTradePartnerReviewInput = {
  id?: InputMaybe<Scalars['ID']>;
  recommended?: InputMaybe<Scalars['Boolean']>;
  score?: InputMaybe<Scalars['Int']>;
  internalUserId?: InputMaybe<Scalars['ID']>;
  tradePartnerId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
  internalNote?: InputMaybe<Scalars['String']>;
};

export type SaveTradePartnerReviewResult = {
  __typename?: 'SaveTradePartnerReviewResult';
  tradePartnerReview: TradePartnerReview;
};

export type TradePartnerUser = Entity & Named & {
  __typename?: 'TradePartnerUser';
  id: Scalars['ID'];
  user: User;
  tradePartner: TradePartner;
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  commentStreams: Array<CommentStream>;
  tradePartnerContact?: Maybe<TradePartnerContact>;
  approvers: Array<Approver>;
  /** @deprecated renamed to lastActiveAt */
  lastActive?: Maybe<Scalars['DateTime']>;
  lastActiveAt?: Maybe<Scalars['DateTime']>;
};

export type SaveUnitInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  buildAddress?: InputMaybe<AddressInput>;
  /**  Only used for creating the Project.  */
  client?: InputMaybe<ClientInput>;
  /**  Add's a new coverImage to a project.  */
  coverImage?: InputMaybe<AssetInput>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ProjectStatus>;
  /**  Only used for creating the Project.  */
  startDate?: InputMaybe<Scalars['Date']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']>;
  planRoomLink?: InputMaybe<Scalars['String']>;
  salesforceAccountId?: InputMaybe<Scalars['String']>;
  projectStatusChange?: InputMaybe<ProjectStatusChangeInput>;
  isDisaster?: InputMaybe<Scalars['Boolean']>;
  intakeStyleNotes?: InputMaybe<Scalars['String']>;
  lotType?: InputMaybe<LotType>;
  productTypeId?: InputMaybe<Scalars['ID']>;
  projectRoles?: InputMaybe<Array<UpdateProjectRoleInput>>;
  salesforcePropertyId?: InputMaybe<Scalars['String']>;
  scopeMode?: InputMaybe<ScopeMode>;
  lotPartitionId?: InputMaybe<Scalars['String']>;
  warrantyStartDate?: InputMaybe<Scalars['Date']>;
  checkoutCustomerConfigId?: InputMaybe<Scalars['String']>;
  directCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']>;
  indirectCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']>;
  customerId?: InputMaybe<Scalars['ID']>;
  customerOwnerEntityId?: InputMaybe<Scalars['ID']>;
  builderId?: InputMaybe<Scalars['ID']>;
  legalDescription?: InputMaybe<Scalars['String']>;
  salesTaxOverrideInBasisPoints?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['ID']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyLicenseNumber?: InputMaybe<Scalars['String']>;
  invoicePaymentNetDays?: InputMaybe<Scalars['Int']>;
};

export type SaveUnitResult = {
  __typename?: 'SaveUnitResult';
  unit: Unit;
};

export type SaveUnitsOfMeasureInput = {
  unitsOfMeasure: Array<UnitOfMeasureInput>;
};

export type UnitOfMeasureInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  abbreviation?: InputMaybe<Scalars['String']>;
  /**  Can only be set when creating the unit of measure  */
  useQuantity?: InputMaybe<Scalars['Boolean']>;
  sageName?: InputMaybe<Scalars['String']>;
  shouldMultiplySelectionFee?: InputMaybe<Scalars['Boolean']>;
};

export type SaveUnitsOfMeasureResult = {
  __typename?: 'SaveUnitsOfMeasureResult';
  unitsOfMeasure: Array<UnitOfMeasure>;
};

export type DeleteUnitOfMeasureInput = {
  id: Scalars['ID'];
};

export type UnitOfMeasure = Named & {
  __typename?: 'UnitOfMeasure';
  id: Scalars['ID'];
  name: Scalars['String'];
  /**  Indicates that this unit of measure is independent of quantity. For example: Lump Sum/Allowance  */
  useQuantity: Scalars['Boolean'];
  /**  Sage analogue of our units  */
  sageName?: Maybe<Scalars['String']>;
  abbreviation: Scalars['String'];
  /**  Alias for abbreviation  */
  shortName: Scalars['String'];
  shouldMultiplySelectionFee: Scalars['Boolean'];
};

export type User = Named & {
  __typename?: 'User';
  /**
   * Either the InternalUser ID, the Homeowner ID, or the underlying user id (for trade/system/anonymous users).
   *
   * For PMs/engs that have a User w/both an InternalUser and a Homeowner, the Homeowner ID takes
   * precedence (for backwards compatibility).
   *
   * This exists for historical reasons from long ago where user types were entirely separated
   */
  id: Scalars['ID'];
  userId: Scalars['ID'];
  /** @deprecated replaced with just type */
  userType: UserType;
  name: Scalars['String'];
  email: Scalars['String'];
  /** @deprecated renamed to just avatar for consistency with internal user */
  avatarUrl: Scalars['String'];
  avatar: Scalars['String'];
  /** only present when user type is internal */
  internalUser?: Maybe<InternalUser>;
  type: UserType;
  typeDetail: UserTypeDetail;
  isActive: Scalars['Boolean'];
  /** @deprecated replaced by tradePartnerUsers */
  tradePartnerUser?: Maybe<TradePartnerUser>;
  tradePartnerUsers: Array<TradePartnerUser>;
  zendeskJwt: Scalars['String'];
  userCommunicationPreference?: Maybe<UserCommunicationPreference>;
  isBeingImpersonated: Scalars['Boolean'];
  /** True for all internal users, otherwise pulls down from homeowner */
  hasCheckoutAccess: Scalars['Boolean'];
  pushNotificationTokens: Array<PushNotificationToken>;
};

export type SaveUserInput = {
  internalUserId?: InputMaybe<Scalars['ID']>;
  userType?: InputMaybe<UserType>;
  email: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  avatarUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<UserType>;
  gsuiteEmailAlias?: InputMaybe<Scalars['String']>;
};

export type SaveUserResult = {
  __typename?: 'SaveUserResult';
  userErrors: Array<UserError>;
};

export type DeactivateUserInput = {
  email: Scalars['String'];
};

export type DeactivateUserResult = {
  __typename?: 'DeactivateUserResult';
  userErrors: Array<UserError>;
};

export type ActivateUserInput = {
  email: Scalars['String'];
};

export type ActivateUserResult = {
  __typename?: 'ActivateUserResult';
  userErrors: Array<UserError>;
};

export type DeactivateUsersInput = {
  id: Array<Scalars['ID']>;
};

export type DeactivateUsersResult = {
  __typename?: 'DeactivateUsersResult';
  users: Array<User>;
};

export type ActivateUsersInput = {
  id: Array<Scalars['ID']>;
};

export type ActivateUsersResult = {
  __typename?: 'ActivateUsersResult';
  users: Array<User>;
};

export type UserCommunicationPreference = {
  __typename?: 'UserCommunicationPreference';
  id: Scalars['ID'];
  user: User;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  tpAvailabilityRequestPreference?: Maybe<Array<CommunicationChannel>>;
  commentPreference?: Maybe<Array<CommunicationChannel>>;
};

export type SaveUserCommunicationPreferenceInput = {
  id?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
  tpAvailabilityRequestPreference?: InputMaybe<Array<CommunicationChannel>>;
  commentPreference?: InputMaybe<Array<CommunicationChannel>>;
};

export type SaveUserCommunicationPreferenceResult = {
  __typename?: 'SaveUserCommunicationPreferenceResult';
  userCommunicationPreference: UserCommunicationPreference;
};

export type UserEventParent = Approval | Bill | ChangeEvent | Commitment | CommitmentChangeOrder | Document | Estimate | HomeownerContractChangeOrder | Invoice | ItemTemplate | JobLog | JobLogImage | JobLogNote | StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | ProjectItem | ProjectLotDetail | ProjectReadyPlanConfig | ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanOption | ToDo | ChangeRequestToDo | PunchlistItemTodo | Task | ScheduleTask | PlanTask | WarrantyTicket;

export type UserEvent = {
  __typename?: 'UserEvent';
  id: Scalars['ID'];
  parent: UserEventParent;
  parentTypeName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: User;
  createdFor?: Maybe<User>;
  type: UserEventType;
  typeDetail: UserEventTypeDetail;
  development?: Maybe<Development>;
  cohort?: Maybe<Cohort>;
  project?: Maybe<Project>;
  notifiedAt?: Maybe<Scalars['DateTime']>;
  comment?: Maybe<Comment>;
  payload?: Maybe<Scalars['JSONObject']>;
  attachment?: Maybe<Attachment>;
};

export type UserEventParentType = {
  __typename?: 'UserEventParentType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UserEventFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  createdAt?: InputMaybe<DateFilter2>;
  development?: InputMaybe<Array<Scalars['ID']>>;
  project?: InputMaybe<Array<Scalars['ID']>>;
  cohort?: InputMaybe<Array<Scalars['ID']>>;
  type?: InputMaybe<Array<UserEventType>>;
  createdBy?: InputMaybe<Array<Scalars['ID']>>;
  createdFor?: InputMaybe<Array<Scalars['ID']>>;
  relevantTo?: InputMaybe<Array<Scalars['ID']>>;
  parentType?: InputMaybe<Array<Scalars['ID']>>;
  parent?: InputMaybe<Array<Scalars['ID']>>;
};

export type UserEventOrder = {
  createdAt?: InputMaybe<Order>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  featureFlagTargets: Array<FeatureFlagTarget>;
  users: Array<User>;
};

export type SaveUserGroupInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveUserGroupResult = {
  __typename?: 'SaveUserGroupResult';
  userGroup: UserGroup;
};

export type UserGroupFilter = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type SaveWarrantyTicketInput = {
  id?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<WarrantyTicketType>;
  projectId?: InputMaybe<Scalars['ID']>;
  projectContactIds?: InputMaybe<Array<Scalars['ID']>>;
  availabilities?: InputMaybe<Array<SaveWarrantyTicketAvailabilityInput>>;
  items?: InputMaybe<Array<SaveWarrantyTicketItemInput>>;
  title?: InputMaybe<Scalars['String']>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
  urgent?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
  assigneeIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type WarrantyTicketFilter = {
  projectId?: InputMaybe<Scalars['ID']>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
  itemStatuses?: InputMaybe<Array<WarrantyTicketItemStatus>>;
  urgent?: InputMaybe<Scalars['Boolean']>;
  marketIds?: InputMaybe<Array<Scalars['ID']>>;
  itemCreatedDateRange?: InputMaybe<DateFilter2>;
  statuses?: InputMaybe<Array<WarrantyTicketStatus>>;
  projectLotType?: InputMaybe<Array<LotType>>;
  assigneeIds?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
};

export type DeleteWarrantyTicketInput = {
  id: Scalars['ID'];
};

export type SaveWarrantyTicketResult = {
  __typename?: 'SaveWarrantyTicketResult';
  warrantyTicket: WarrantyTicket;
};

export type WarrantyTicketsPage = {
  __typename?: 'WarrantyTicketsPage';
  entities: Array<WarrantyTicket>;
  pageInfo: PageInfo;
};

export type WarrantyTicketAvailability = {
  __typename?: 'WarrantyTicketAvailability';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  dayOfWeek: DayOfWeekDetail;
  timeOfDay: TimeOfDayDetail;
  warrantyTicket: WarrantyTicket;
};

export type SaveWarrantyTicketAvailabilityInput = {
  id?: InputMaybe<Scalars['ID']>;
  dayOfWeek?: InputMaybe<DayOfWeek>;
  timeOfDay?: InputMaybe<TimeOfDay>;
  warrantyTicket?: InputMaybe<Scalars['ID']>;
};

export type WarrantyTicketItem = {
  __typename?: 'WarrantyTicketItem';
  id: Scalars['ID'];
  product?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  status: WarrantyTicketItemStatusDetail;
  warrantyTicket: WarrantyTicket;
  attachments: Array<Attachment>;
  type: WarrantyTicketItemTypeDetail;
  homeownerVisible: Scalars['Boolean'];
  statusUpdatedAt: Scalars['DateTime'];
};

export type SaveWarrantyTicketItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  product?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<WarrantyTicketItemStatus>;
  warrantyTicketId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<WarrantyTicketItemType>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']>;
};

export type SaveWarrantyTicketItemResult = {
  __typename?: 'SaveWarrantyTicketItemResult';
  warrantyTicketItem: WarrantyTicketItem;
};

export type DeleteWarrantyTicketItemInput = {
  id: Scalars['ID'];
};

export type SaveWarrantyTicketItemsInput = {
  warrantyTicketItems: Array<SaveWarrantyTicketItemInput>;
};

export type SaveWarrantyTicketItemsResult = {
  __typename?: 'SaveWarrantyTicketItemsResult';
  warrantyTicketItems: Array<WarrantyTicketItem>;
};

export type WorkAuthorization = {
  __typename?: 'WorkAuthorization';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  projectStage: ProjectStage;
  documents: Array<Document>;
  projectItems: Array<ProjectItem>;
};

export type SaveWorkAuthorizationInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  projectStageId?: InputMaybe<Scalars['ID']>;
  projectItems?: InputMaybe<Array<Scalars['ID']>>;
  documents?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveWorkAuthorizationResult = {
  __typename?: 'SaveWorkAuthorizationResult';
  workAuthorization: WorkAuthorization;
};

export type WorkAuthorizationFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  stage?: InputMaybe<Array<Stage>>;
};

type CompanyInfoField_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type CompanyInfoField_Region_Fragment = { __typename?: 'Region', id: string, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type CompanyInfoField_Market_Fragment = { __typename?: 'Market', id: string, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type CompanyInfoField_Community_Fragment = { __typename?: 'Community', id: string, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type CompanyInfoField_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type CompanyInfoField_Lot_Fragment = { __typename?: 'Lot', id: string, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type CompanyInfoField_Structure_Fragment = { __typename?: 'Structure', id: string, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type CompanyInfoField_Unit_Fragment = { __typename?: 'Unit', id: string, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

export type CompanyInfoFieldFragment = CompanyInfoField_StandaloneProject_Fragment | CompanyInfoField_Region_Fragment | CompanyInfoField_Market_Fragment | CompanyInfoField_Community_Fragment | CompanyInfoField_Subdivision_Fragment | CompanyInfoField_Lot_Fragment | CompanyInfoField_Structure_Fragment | CompanyInfoField_Unit_Fragment;

export type UserFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserFeatureFlagsQuery = { __typename?: 'Query', userFeatureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType } }> };

export type EnabledFeatureFlagFragment = { __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType } };

export type CreateAssetUploadUrlMutationVariables = Exact<{
  input: CreateAssetUploadUrlInput;
}>;


export type CreateAssetUploadUrlMutation = { __typename?: 'Mutation', createAssetUploadUrl: { __typename?: 'CreateAssetUploadUrlResult', s3Key: string, uploadUrl: string, downloadUrl: string, previewUrl?: string | null | undefined } };

export type ApproverDetailsFragment = { __typename?: 'Approver', id: string, user: { __typename?: 'Client', id: string, name: string } | { __typename?: 'InternalUser', id: string, name: string } | { __typename?: 'TradePartnerUser', id: string, name: string } };

type ApprovalSubject_Bill_Fragment = { __typename: 'Bill', id: string, tradePartnerNumber: string };

type ApprovalSubject_ChangeEvent_Fragment = { __typename: 'ChangeEvent' };

type ApprovalSubject_ChangeRequest_Fragment = { __typename: 'ChangeRequest' };

type ApprovalSubject_Invoice_Fragment = { __typename: 'Invoice' };

export type ApprovalSubjectFragment = ApprovalSubject_Bill_Fragment | ApprovalSubject_ChangeEvent_Fragment | ApprovalSubject_ChangeRequest_Fragment | ApprovalSubject_Invoice_Fragment;

export type ApprovalSubject_BillFragment = { __typename?: 'Bill', id: string, tradePartnerNumber: string };

type Named_Approval_Fragment = { __typename?: 'Approval', id: string, name: string };

type Named_BidContract_Fragment = { __typename?: 'BidContract', id: string, name: string };

type Named_BidContractLineItem_Fragment = { __typename?: 'BidContractLineItem', id: string, name: string };

type Named_BidItem_Fragment = { __typename?: 'BidItem', id: string, name: string };

type Named_BidPackage_Fragment = { __typename?: 'BidPackage', id: string, name: string };

type Named_BidPackageRequest_Fragment = { __typename?: 'BidPackageRequest', id: string, name: string };

type Named_TradePartner_Fragment = { __typename?: 'TradePartner', id: string, name: string };

type Named_Bill_Fragment = { __typename?: 'Bill', id: string, name: string };

type Named_BusinessFunction_Fragment = { __typename?: 'BusinessFunction', id: string, name: string };

type Named_ChangeEvent_Fragment = { __typename?: 'ChangeEvent', id: string, name: string };

type Named_ChangeEventLineItem_Fragment = { __typename?: 'ChangeEventLineItem', id: string, name: string };

type Named_ChangeEventReason_Fragment = { __typename?: 'ChangeEventReason', id: string, name: string };

type Named_ChangeEventTemplateConfig_Fragment = { __typename?: 'ChangeEventTemplateConfig', id: string, name: string };

type Named_ChangeRequest_Fragment = { __typename?: 'ChangeRequest', id: string, name: string };

type Named_ChangeRequestAsset_Fragment = { __typename?: 'ChangeRequestAsset', id: string, name: string };

type Named_ChangeRequestToDo_Fragment = { __typename?: 'ChangeRequestToDo', id: string, name: string };

type Named_Client_Fragment = { __typename?: 'Client', id: string, name: string };

type Named_Cohort_Fragment = { __typename?: 'Cohort', id: string, name: string };

type Named_SchedulePhase_Fragment = { __typename?: 'SchedulePhase', id: string, name: string };

type Named_ScheduleSubPhase_Fragment = { __typename?: 'ScheduleSubPhase', id: string, name: string };

type Named_Task_Fragment = { __typename?: 'Task', id: string, name: string };

type Named_ScheduleTask_Fragment = { __typename?: 'ScheduleTask', id: string, name: string };

type Named_PlanTask_Fragment = { __typename?: 'PlanTask', id: string, name: string };

type Named_ToDo_Fragment = { __typename?: 'ToDo', id: string, name: string };

type Named_Invoice_Fragment = { __typename?: 'Invoice', id: string, name: string };

type Named_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string };

type Named_Region_Fragment = { __typename?: 'Region', id: string, name: string };

type Named_Market_Fragment = { __typename?: 'Market', id: string, name: string };

type Named_Community_Fragment = { __typename?: 'Community', id: string, name: string };

type Named_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string };

type Named_Lot_Fragment = { __typename?: 'Lot', id: string, name: string };

type Named_Structure_Fragment = { __typename?: 'Structure', id: string, name: string };

type Named_Unit_Fragment = { __typename?: 'Unit', id: string, name: string };

type Named_ProjectItem_Fragment = { __typename?: 'ProjectItem', id: string, name: string };

type Named_Estimate_Fragment = { __typename?: 'Estimate', id: string, name: string };

type Named_DevelopmentCommitment_Fragment = { __typename?: 'DevelopmentCommitment', id: string, name: string };

type Named_Commitment_Fragment = { __typename?: 'Commitment', id: string, name: string };

type Named_Document_Fragment = { __typename?: 'Document', id: string, name: string };

type Named_ItemTemplateItemVersion_Fragment = { __typename?: 'ItemTemplateItemVersion', id: string, name: string };

type Named_JobLogNote_Fragment = { __typename?: 'JobLogNote', id: string, name: string };

type Named_TradePartnerAvailabilityRequest_Fragment = { __typename?: 'TradePartnerAvailabilityRequest', id: string, name: string };

type Named_PunchlistItemTodo_Fragment = { __typename?: 'PunchlistItemTodo', id: string, name: string };

type Named_WarrantyTicket_Fragment = { __typename?: 'WarrantyTicket', id: string, name: string };

type Named_HomeownerContract_Fragment = { __typename?: 'HomeownerContract', id: string, name: string };

type Named_HomeownerContractChangeOrder_Fragment = { __typename?: 'HomeownerContractChangeOrder', id: string, name: string };

type Named_ReadyPlan_Fragment = { __typename?: 'ReadyPlan', id: string, name: string };

type Named_PlanPackage_Fragment = { __typename?: 'PlanPackage', id: string, name: string };

type Named_GlobalOption_Fragment = { __typename?: 'GlobalOption', id: string, name: string };

type Named_ProjectCostCode_Fragment = { __typename?: 'ProjectCostCode', id: string, name: string };

type Named_CommitmentChangeOrder_Fragment = { __typename?: 'CommitmentChangeOrder', id: string, name: string };

type Named_CostCode_Fragment = { __typename?: 'CostCode', id: string, name: string };

type Named_CostDivision_Fragment = { __typename?: 'CostDivision', id: string, name: string };

type Named_Customer_Fragment = { __typename?: 'Customer', id: string, name: string };

type Named_CustomerOwnerEntity_Fragment = { __typename?: 'CustomerOwnerEntity', id: string, name: string };

type Named_DesignPackage_Fragment = { __typename?: 'DesignPackage', id: string, name: string };

type Named_Development_Fragment = { __typename?: 'Development', id: string, name: string };

type Named_GlobalOptionTag_Fragment = { __typename?: 'GlobalOptionTag', id: string, name: string };

type Named_GlobalOptionType_Fragment = { __typename?: 'GlobalOptionType', id: string, name: string };

type Named_GlobalPlanConstraintItem_Fragment = { __typename?: 'GlobalPlanConstraintItem', id: string, name: string };

type Named_GlobalPlanMilestone_Fragment = { __typename?: 'GlobalPlanMilestone', id: string, name: string };

type Named_GlobalPlanTask_Fragment = { __typename?: 'GlobalPlanTask', id: string, name: string };

type Named_GlobalTask_Fragment = { __typename?: 'GlobalTask', id: string, name: string };

type Named_HomeownerContractDraw_Fragment = { __typename?: 'HomeownerContractDraw', id: string, name: string };

type Named_InternalUser_Fragment = { __typename?: 'InternalUser', id: string, name: string };

type Named_InvoiceScheduleTemplate_Fragment = { __typename?: 'InvoiceScheduleTemplate', id: string, name: string };

type Named_Item_Fragment = { __typename?: 'Item', id: string, name: string };

type Named_ItemSlot_Fragment = { __typename?: 'ItemSlot', id: string, name: string };

type Named_ItemTemplate_Fragment = { __typename?: 'ItemTemplate', id: string, name: string };

type Named_ItemTemplateItem_Fragment = { __typename?: 'ItemTemplateItem', id: string, name: string };

type Named_Location_Fragment = { __typename?: 'Location', id: string, name: string };

type Named_MaterialVariantTag_Fragment = { __typename?: 'MaterialVariantTag', id: string, name: string };

type Named_PandaDoc_Fragment = { __typename?: 'PandaDoc', id: string, name: string };

type Named_PandaDocRecipient_Fragment = { __typename?: 'PandaDocRecipient', id: string, name: string };

type Named_PlanMilestone_Fragment = { __typename?: 'PlanMilestone', id: string, name: string };

type Named_ProductOffering_Fragment = { __typename?: 'ProductOffering', id: string, name: string };

type Named_ProjectStageTemplateConfig_Fragment = { __typename?: 'ProjectStageTemplateConfig', id: string, name: string };

type Named_ProjectStatusChangeReason_Fragment = { __typename?: 'ProjectStatusChangeReason', id: string, name: string };

type Named_ReadyPlanAggregateVersion_Fragment = { __typename?: 'ReadyPlanAggregateVersion', id: string, name: string };

type Named_ReadyPlanLocation_Fragment = { __typename?: 'ReadyPlanLocation', id: string, name: string };

type Named_ReadyPlanOption_Fragment = { __typename?: 'ReadyPlanOption', id: string, name: string };

type Named_ReadyPlanOptionProgramDataModification_Fragment = { __typename?: 'ReadyPlanOptionProgramDataModification', id: string, name: string };

type Named_Schedule_Fragment = { __typename?: 'Schedule', id: string, name: string };

type Named_ScheduleTemplate_Fragment = { __typename?: 'ScheduleTemplate', id: string, name: string };

type Named_Submarket_Fragment = { __typename?: 'Submarket', id: string, name: string };

type Named_TakeoffLineItem_Fragment = { __typename?: 'TakeoffLineItem', id: string, name: string };

type Named_TakeoffLineItemVersion_Fragment = { __typename?: 'TakeoffLineItemVersion', id: string, name: string };

type Named_TradeCategory_Fragment = { __typename?: 'TradeCategory', id: string, name: string };

type Named_TradePartnerContact_Fragment = { __typename?: 'TradePartnerContact', id: string, name: string };

type Named_TradePartnerMailingList_Fragment = { __typename?: 'TradePartnerMailingList', id: string, name: string };

type Named_TradePartnerUser_Fragment = { __typename?: 'TradePartnerUser', id: string, name: string };

type Named_UnitOfMeasure_Fragment = { __typename?: 'UnitOfMeasure', id: string, name: string };

type Named_User_Fragment = { __typename?: 'User', id: string, name: string };

export type NamedFragment = Named_Approval_Fragment | Named_BidContract_Fragment | Named_BidContractLineItem_Fragment | Named_BidItem_Fragment | Named_BidPackage_Fragment | Named_BidPackageRequest_Fragment | Named_TradePartner_Fragment | Named_Bill_Fragment | Named_BusinessFunction_Fragment | Named_ChangeEvent_Fragment | Named_ChangeEventLineItem_Fragment | Named_ChangeEventReason_Fragment | Named_ChangeEventTemplateConfig_Fragment | Named_ChangeRequest_Fragment | Named_ChangeRequestAsset_Fragment | Named_ChangeRequestToDo_Fragment | Named_Client_Fragment | Named_Cohort_Fragment | Named_SchedulePhase_Fragment | Named_ScheduleSubPhase_Fragment | Named_Task_Fragment | Named_ScheduleTask_Fragment | Named_PlanTask_Fragment | Named_ToDo_Fragment | Named_Invoice_Fragment | Named_StandaloneProject_Fragment | Named_Region_Fragment | Named_Market_Fragment | Named_Community_Fragment | Named_Subdivision_Fragment | Named_Lot_Fragment | Named_Structure_Fragment | Named_Unit_Fragment | Named_ProjectItem_Fragment | Named_Estimate_Fragment | Named_DevelopmentCommitment_Fragment | Named_Commitment_Fragment | Named_Document_Fragment | Named_ItemTemplateItemVersion_Fragment | Named_JobLogNote_Fragment | Named_TradePartnerAvailabilityRequest_Fragment | Named_PunchlistItemTodo_Fragment | Named_WarrantyTicket_Fragment | Named_HomeownerContract_Fragment | Named_HomeownerContractChangeOrder_Fragment | Named_ReadyPlan_Fragment | Named_PlanPackage_Fragment | Named_GlobalOption_Fragment | Named_ProjectCostCode_Fragment | Named_CommitmentChangeOrder_Fragment | Named_CostCode_Fragment | Named_CostDivision_Fragment | Named_Customer_Fragment | Named_CustomerOwnerEntity_Fragment | Named_DesignPackage_Fragment | Named_Development_Fragment | Named_GlobalOptionTag_Fragment | Named_GlobalOptionType_Fragment | Named_GlobalPlanConstraintItem_Fragment | Named_GlobalPlanMilestone_Fragment | Named_GlobalPlanTask_Fragment | Named_GlobalTask_Fragment | Named_HomeownerContractDraw_Fragment | Named_InternalUser_Fragment | Named_InvoiceScheduleTemplate_Fragment | Named_Item_Fragment | Named_ItemSlot_Fragment | Named_ItemTemplate_Fragment | Named_ItemTemplateItem_Fragment | Named_Location_Fragment | Named_MaterialVariantTag_Fragment | Named_PandaDoc_Fragment | Named_PandaDocRecipient_Fragment | Named_PlanMilestone_Fragment | Named_ProductOffering_Fragment | Named_ProjectStageTemplateConfig_Fragment | Named_ProjectStatusChangeReason_Fragment | Named_ReadyPlanAggregateVersion_Fragment | Named_ReadyPlanLocation_Fragment | Named_ReadyPlanOption_Fragment | Named_ReadyPlanOptionProgramDataModification_Fragment | Named_Schedule_Fragment | Named_ScheduleTemplate_Fragment | Named_Submarket_Fragment | Named_TakeoffLineItem_Fragment | Named_TakeoffLineItemVersion_Fragment | Named_TradeCategory_Fragment | Named_TradePartnerContact_Fragment | Named_TradePartnerMailingList_Fragment | Named_TradePartnerUser_Fragment | Named_UnitOfMeasure_Fragment | Named_User_Fragment;

export type UnitOfMeasureDetailsFragment = { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string };

export type PandaDocDetailsFragment = { __typename?: 'PandaDoc', externalPandaDocUrl?: string | null | undefined, externalPandaDocId?: string | null | undefined, status: PandaDocStatus, id: string, name: string, canCreatePandaDocSession?: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } | null | undefined };

export type DocumentDetailsFragment = { __typename?: 'Document', isDeleted?: boolean | null | undefined, id: string, name: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } };

export type AssetDetailsFragment = { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined };

type ProjectAddress_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string };

type ProjectAddress_Region_Fragment = { __typename?: 'Region', id: string, name: string };

type ProjectAddress_Market_Fragment = { __typename?: 'Market', id: string, name: string };

type ProjectAddress_Community_Fragment = { __typename?: 'Community', id: string, name: string };

type ProjectAddress_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string };

type ProjectAddress_Lot_Fragment = { __typename?: 'Lot', id: string, name: string };

type ProjectAddress_Structure_Fragment = { __typename?: 'Structure', id: string, name: string };

type ProjectAddress_Unit_Fragment = { __typename?: 'Unit', id: string, name: string };

export type ProjectAddressFragment = ProjectAddress_StandaloneProject_Fragment | ProjectAddress_Region_Fragment | ProjectAddress_Market_Fragment | ProjectAddress_Community_Fragment | ProjectAddress_Subdivision_Fragment | ProjectAddress_Lot_Fragment | ProjectAddress_Structure_Fragment | ProjectAddress_Unit_Fragment;

export type ProjectRoleDetailFragment = { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string };

export type ProjectTeamMemberFragment = { __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } };

export type TradePartnerContactFragment = { __typename?: 'TradePartnerContact', email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string } | null | undefined };

export type AddressDetailsFragment = { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string };

export type BillStatusAndTypeFragment = { __typename?: 'Bill', id: string, status: { __typename?: 'BillStatusDetail', code: BillStatus }, type: { __typename?: 'BillTypeDetail', code: BillType } };

type CommentFeed_Approval_Fragment = { __typename?: 'Approval', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_BidContract_Fragment = { __typename?: 'BidContract', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_BidItem_Fragment = { __typename?: 'BidItem', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_BidPackageRequest_Fragment = { __typename?: 'BidPackageRequest', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_Bill_Fragment = { __typename?: 'Bill', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_ChangeEvent_Fragment = { __typename?: 'ChangeEvent', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_ChangeRequest_Fragment = { __typename?: 'ChangeRequest', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_ChangeRequestToDo_Fragment = { __typename?: 'ChangeRequestToDo', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_SchedulePhase_Fragment = { __typename?: 'SchedulePhase', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_ScheduleSubPhase_Fragment = { __typename?: 'ScheduleSubPhase', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_Task_Fragment = { __typename?: 'Task', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_ScheduleTask_Fragment = { __typename?: 'ScheduleTask', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_PlanTask_Fragment = { __typename?: 'PlanTask', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_ToDo_Fragment = { __typename?: 'ToDo', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_Invoice_Fragment = { __typename?: 'Invoice', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_Region_Fragment = { __typename?: 'Region', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_Market_Fragment = { __typename?: 'Market', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_Community_Fragment = { __typename?: 'Community', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_Lot_Fragment = { __typename?: 'Lot', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_Structure_Fragment = { __typename?: 'Structure', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_Unit_Fragment = { __typename?: 'Unit', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_ProjectItem_Fragment = { __typename?: 'ProjectItem', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_Estimate_Fragment = { __typename?: 'Estimate', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_DevelopmentCommitment_Fragment = { __typename?: 'DevelopmentCommitment', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_Commitment_Fragment = { __typename?: 'Commitment', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_Document_Fragment = { __typename?: 'Document', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_ItemTemplateItemVersion_Fragment = { __typename?: 'ItemTemplateItemVersion', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_JobLogNote_Fragment = { __typename?: 'JobLogNote', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_TradePartnerAvailabilityRequest_Fragment = { __typename?: 'TradePartnerAvailabilityRequest', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_PunchlistItemTodo_Fragment = { __typename?: 'PunchlistItemTodo', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_WarrantyTicket_Fragment = { __typename?: 'WarrantyTicket', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_HomeownerContract_Fragment = { __typename?: 'HomeownerContract', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_HomeownerContractChangeOrder_Fragment = { __typename?: 'HomeownerContractChangeOrder', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_ReadyPlan_Fragment = { __typename?: 'ReadyPlan', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_PlanPackage_Fragment = { __typename?: 'PlanPackage', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_GlobalOption_Fragment = { __typename?: 'GlobalOption', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

type CommentFeed_ProjectCostCode_Fragment = { __typename?: 'ProjectCostCode', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> };

export type CommentFeedFragment = CommentFeed_Approval_Fragment | CommentFeed_BidContract_Fragment | CommentFeed_BidItem_Fragment | CommentFeed_BidPackageRequest_Fragment | CommentFeed_Bill_Fragment | CommentFeed_ChangeEvent_Fragment | CommentFeed_ChangeRequest_Fragment | CommentFeed_ChangeRequestToDo_Fragment | CommentFeed_SchedulePhase_Fragment | CommentFeed_ScheduleSubPhase_Fragment | CommentFeed_Task_Fragment | CommentFeed_ScheduleTask_Fragment | CommentFeed_PlanTask_Fragment | CommentFeed_ToDo_Fragment | CommentFeed_Invoice_Fragment | CommentFeed_StandaloneProject_Fragment | CommentFeed_Region_Fragment | CommentFeed_Market_Fragment | CommentFeed_Community_Fragment | CommentFeed_Subdivision_Fragment | CommentFeed_Lot_Fragment | CommentFeed_Structure_Fragment | CommentFeed_Unit_Fragment | CommentFeed_ProjectItem_Fragment | CommentFeed_Estimate_Fragment | CommentFeed_DevelopmentCommitment_Fragment | CommentFeed_Commitment_Fragment | CommentFeed_Document_Fragment | CommentFeed_ItemTemplateItemVersion_Fragment | CommentFeed_JobLogNote_Fragment | CommentFeed_TradePartnerAvailabilityRequest_Fragment | CommentFeed_PunchlistItemTodo_Fragment | CommentFeed_WarrantyTicket_Fragment | CommentFeed_HomeownerContract_Fragment | CommentFeed_HomeownerContractChangeOrder_Fragment | CommentFeed_ReadyPlan_Fragment | CommentFeed_PlanPackage_Fragment | CommentFeed_GlobalOption_Fragment | CommentFeed_ProjectCostCode_Fragment;

export type CommentStreamDetailFragment = { __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> };

export type CommentFragment = { __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> };

export type PotentialOperationDetailsFragment = { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, name: string, email: string, userType: UserType, avatarUrl: string, isBeingImpersonated: boolean, tradePartnerUsers: Array<{ __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', leadTimeInDays: number, id: string, name: string }, tradePartnerContact?: { __typename?: 'TradePartnerContact', id: string, markets: Array<{ __typename?: 'Market', id: string }> } | null | undefined }> } | null | undefined };

export type UserDetailsFragment = { __typename?: 'User', id: string, name: string, email: string, userType: UserType, avatarUrl: string, isBeingImpersonated: boolean, tradePartnerUsers: Array<{ __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', leadTimeInDays: number, id: string, name: string }, tradePartnerContact?: { __typename?: 'TradePartnerContact', id: string, markets: Array<{ __typename?: 'Market', id: string }> } | null | undefined }> };

export type User_TradePartnerUserFragment = { __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', leadTimeInDays: number, id: string, name: string }, tradePartnerContact?: { __typename?: 'TradePartnerContact', id: string, markets: Array<{ __typename?: 'Market', id: string }> } | null | undefined };

export type User_TradePartnerFragment = { __typename?: 'TradePartner', leadTimeInDays: number, id: string, name: string };

export type ApproveTradePartnerAvailabilityRequestMutationVariables = Exact<{
  confirmationToken: Scalars['String'];
}>;


export type ApproveTradePartnerAvailabilityRequestMutation = { __typename?: 'Mutation', approveTradePartnerAvailabilityRequest: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type InvoicePageQueryVariables = Exact<{
  billId: Scalars['ID'];
  projectId: Scalars['ID'];
}>;


export type InvoicePageQuery = { __typename?: 'Query', bill: { __typename?: 'Bill', id: string, sentDate?: DateOnly | null | undefined, tradePartnerNumber: string, billedInCents: number, isTradePartnerCredit: boolean, referenceNumber?: string | null | undefined, lineItems: Array<{ __typename?: 'BillLineItem', id: string, taxInCents: number, taxableAmountInCents: number, amountInCents: number, projectItem: { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | null | undefined }, commitmentLineItem?: { __typename?: 'CommitmentLineItem', id: string, committedInCents: number, newQuantity: number, quantity?: number | null | undefined, newTaxableCostInCents: number, costChangeInCents?: number | null | undefined, projectItem: { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | null | undefined }, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string } } | null | undefined } | null | undefined, owner: { __typename?: 'Commitment', id: string, accountingNumber: number } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number } } | null | undefined, scheduleTask?: { __typename?: 'Task', id: string, name: string, projectItems: Array<{ __typename?: 'ProjectItem', id: string, name: string }> } | null | undefined, bill: { __typename?: 'Bill', id: string, isTradePartnerCredit: boolean }, commitmentDraw?: { __typename?: 'CommitmentDraw', id: string, task: { __typename?: 'Task', id: string, name: string } } | null | undefined }>, project: { __typename?: 'StandaloneProject', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Region', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Market', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Community', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Subdivision', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Lot', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Structure', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Unit', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } }, tradePartner: { __typename?: 'TradePartner', id: string, contactsForProjectAndRoles: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string } | null | undefined } | null | undefined> }, parents: Array<{ __typename?: 'Commitment', id: string, accountingNumber: number } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, commitment: { __typename?: 'Commitment', id: string } }>, documents: Array<{ __typename?: 'Document', isDeleted?: boolean | null | undefined, id: string, name: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, approval?: { __typename?: 'Approval', id: string, approvers: Array<{ __typename?: 'Approver', id: string, user: { __typename?: 'Client', id: string, name: string } | { __typename?: 'InternalUser', id: string, name: string } | { __typename?: 'TradePartnerUser', id: string, name: string } }> } | null | undefined, lienWaivers: Array<{ __typename?: 'LienWaiver', id: string, status: { __typename?: 'LienWaiverStatusDetail', code: LienWaiverStatus, name: string }, condition: { __typename?: 'LienWaiverConditionDetail', code: LienWaiverCondition, name: string }, pandaDoc?: { __typename?: 'PandaDoc', externalPandaDocUrl?: string | null | undefined, externalPandaDocId?: string | null | undefined, status: PandaDocStatus, id: string, name: string, canCreatePandaDocSession?: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } | null | undefined } | null | undefined }>, status: { __typename?: 'BillStatusDetail', code: BillStatus }, type: { __typename?: 'BillTypeDetail', code: BillType } } };

export type PollLienWaiverQueryVariables = Exact<{
  filter: LienWaiverFilter;
}>;


export type PollLienWaiverQuery = { __typename?: 'Query', lienWaivers: Array<{ __typename?: 'LienWaiver', id: string, status: { __typename?: 'LienWaiverStatusDetail', code: LienWaiverStatus, name: string }, condition: { __typename?: 'LienWaiverConditionDetail', code: LienWaiverCondition, name: string }, pandaDoc?: { __typename?: 'PandaDoc', externalPandaDocUrl?: string | null | undefined, externalPandaDocId?: string | null | undefined, status: PandaDocStatus, id: string, name: string, canCreatePandaDocSession?: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } | null | undefined } | null | undefined }> };

export type InvoicePage_LienWaiversFragment = { __typename?: 'LienWaiver', id: string, status: { __typename?: 'LienWaiverStatusDetail', code: LienWaiverStatus, name: string }, condition: { __typename?: 'LienWaiverConditionDetail', code: LienWaiverCondition, name: string }, pandaDoc?: { __typename?: 'PandaDoc', externalPandaDocUrl?: string | null | undefined, externalPandaDocId?: string | null | undefined, status: PandaDocStatus, id: string, name: string, canCreatePandaDocSession?: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } | null | undefined } | null | undefined };

export type SaveInvoiceMutationVariables = Exact<{
  input: SaveBillInput;
  projectId: Scalars['ID'];
}>;


export type SaveInvoiceMutation = { __typename?: 'Mutation', saveBill: { __typename?: 'SaveBillResult', bill?: { __typename?: 'Bill', id: string, sentDate?: DateOnly | null | undefined, tradePartnerNumber: string, billedInCents: number, isTradePartnerCredit: boolean, referenceNumber?: string | null | undefined, lineItems: Array<{ __typename?: 'BillLineItem', id: string, taxInCents: number, taxableAmountInCents: number, amountInCents: number, projectItem: { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | null | undefined }, commitmentLineItem?: { __typename?: 'CommitmentLineItem', id: string, committedInCents: number, newQuantity: number, quantity?: number | null | undefined, newTaxableCostInCents: number, costChangeInCents?: number | null | undefined, projectItem: { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | null | undefined }, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string } } | null | undefined } | null | undefined, owner: { __typename?: 'Commitment', id: string, accountingNumber: number } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number } } | null | undefined, scheduleTask?: { __typename?: 'Task', id: string, name: string, projectItems: Array<{ __typename?: 'ProjectItem', id: string, name: string }> } | null | undefined, bill: { __typename?: 'Bill', id: string, isTradePartnerCredit: boolean }, commitmentDraw?: { __typename?: 'CommitmentDraw', id: string, task: { __typename?: 'Task', id: string, name: string } } | null | undefined }>, project: { __typename?: 'StandaloneProject', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Region', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Market', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Community', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Subdivision', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Lot', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Structure', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Unit', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } }, tradePartner: { __typename?: 'TradePartner', id: string, contactsForProjectAndRoles: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string } | null | undefined } | null | undefined> }, parents: Array<{ __typename?: 'Commitment', id: string, accountingNumber: number } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, commitment: { __typename?: 'Commitment', id: string } }>, documents: Array<{ __typename?: 'Document', isDeleted?: boolean | null | undefined, id: string, name: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, approval?: { __typename?: 'Approval', id: string, approvers: Array<{ __typename?: 'Approver', id: string, user: { __typename?: 'Client', id: string, name: string } | { __typename?: 'InternalUser', id: string, name: string } | { __typename?: 'TradePartnerUser', id: string, name: string } }> } | null | undefined, lienWaivers: Array<{ __typename?: 'LienWaiver', id: string, status: { __typename?: 'LienWaiverStatusDetail', code: LienWaiverStatus, name: string }, condition: { __typename?: 'LienWaiverConditionDetail', code: LienWaiverCondition, name: string }, pandaDoc?: { __typename?: 'PandaDoc', externalPandaDocUrl?: string | null | undefined, externalPandaDocId?: string | null | undefined, status: PandaDocStatus, id: string, name: string, canCreatePandaDocSession?: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } | null | undefined } | null | undefined }>, status: { __typename?: 'BillStatusDetail', code: BillStatus }, type: { __typename?: 'BillTypeDetail', code: BillType } } | null | undefined } };

export type InvoicePage_SaveApproverMutationVariables = Exact<{
  input: SaveApproverInput;
}>;


export type InvoicePage_SaveApproverMutation = { __typename?: 'Mutation', saveApprover: { __typename?: 'SaveApproverResult', approver: { __typename?: 'Approver', id: string, status: { __typename?: 'ApproverStatusDetail', code: ApproverStatus }, approval: { __typename?: 'Approval', id: string, name: string } } } };

export type InvoicePageFragment = { __typename?: 'Bill', id: string, sentDate?: DateOnly | null | undefined, tradePartnerNumber: string, billedInCents: number, isTradePartnerCredit: boolean, referenceNumber?: string | null | undefined, lineItems: Array<{ __typename?: 'BillLineItem', id: string, taxInCents: number, taxableAmountInCents: number, amountInCents: number, projectItem: { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | null | undefined }, commitmentLineItem?: { __typename?: 'CommitmentLineItem', id: string, committedInCents: number, newQuantity: number, quantity?: number | null | undefined, newTaxableCostInCents: number, costChangeInCents?: number | null | undefined, projectItem: { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | null | undefined }, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string } } | null | undefined } | null | undefined, owner: { __typename?: 'Commitment', id: string, accountingNumber: number } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number } } | null | undefined, scheduleTask?: { __typename?: 'Task', id: string, name: string, projectItems: Array<{ __typename?: 'ProjectItem', id: string, name: string }> } | null | undefined, bill: { __typename?: 'Bill', id: string, isTradePartnerCredit: boolean }, commitmentDraw?: { __typename?: 'CommitmentDraw', id: string, task: { __typename?: 'Task', id: string, name: string } } | null | undefined }>, project: { __typename?: 'StandaloneProject', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Region', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Market', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Community', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Subdivision', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Lot', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Structure', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Unit', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } }, tradePartner: { __typename?: 'TradePartner', id: string, contactsForProjectAndRoles: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string } | null | undefined } | null | undefined> }, parents: Array<{ __typename?: 'Commitment', id: string, accountingNumber: number } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, commitment: { __typename?: 'Commitment', id: string } }>, documents: Array<{ __typename?: 'Document', isDeleted?: boolean | null | undefined, id: string, name: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, approval?: { __typename?: 'Approval', id: string, approvers: Array<{ __typename?: 'Approver', id: string, user: { __typename?: 'Client', id: string, name: string } | { __typename?: 'InternalUser', id: string, name: string } | { __typename?: 'TradePartnerUser', id: string, name: string } }> } | null | undefined, lienWaivers: Array<{ __typename?: 'LienWaiver', id: string, status: { __typename?: 'LienWaiverStatusDetail', code: LienWaiverStatus, name: string }, condition: { __typename?: 'LienWaiverConditionDetail', code: LienWaiverCondition, name: string }, pandaDoc?: { __typename?: 'PandaDoc', externalPandaDocUrl?: string | null | undefined, externalPandaDocId?: string | null | undefined, status: PandaDocStatus, id: string, name: string, canCreatePandaDocSession?: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } | null | undefined } | null | undefined }>, status: { __typename?: 'BillStatusDetail', code: BillStatus }, type: { __typename?: 'BillTypeDetail', code: BillType } };

export type InvoicePage_ChangeOrderFragment = { __typename?: 'CommitmentChangeOrder', id: string, commitment: { __typename?: 'Commitment', id: string } };

export type InvoicePage_TradePartnerUserFragment = { __typename?: 'TradePartnerUser', id: string, tradePartnerContact?: { __typename?: 'TradePartnerContact', email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string } | null | undefined } | null | undefined };

export type InvoicePage_BillLineItemsFragment = { __typename?: 'BillLineItem', id: string, taxInCents: number, taxableAmountInCents: number, amountInCents: number, projectItem: { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | null | undefined }, commitmentLineItem?: { __typename?: 'CommitmentLineItem', id: string, committedInCents: number, newQuantity: number, quantity?: number | null | undefined, newTaxableCostInCents: number, costChangeInCents?: number | null | undefined, projectItem: { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | null | undefined }, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string } } | null | undefined } | null | undefined, owner: { __typename?: 'Commitment', id: string, accountingNumber: number } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number } } | null | undefined, scheduleTask?: { __typename?: 'Task', id: string, name: string, projectItems: Array<{ __typename?: 'ProjectItem', id: string, name: string }> } | null | undefined, bill: { __typename?: 'Bill', id: string, isTradePartnerCredit: boolean }, commitmentDraw?: { __typename?: 'CommitmentDraw', id: string, task: { __typename?: 'Task', id: string, name: string } } | null | undefined };

export type InvoicePage_CommitmentLineItemsFragment = { __typename?: 'CommitmentLineItem', id: string, committedInCents: number, newQuantity: number, quantity?: number | null | undefined, newTaxableCostInCents: number, costChangeInCents?: number | null | undefined, projectItem: { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | null | undefined }, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string } } | null | undefined } | null | undefined, owner: { __typename?: 'Commitment', id: string, accountingNumber: number } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number } };

type InvoicePage_Project_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type InvoicePage_Project_Region_Fragment = { __typename?: 'Region', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type InvoicePage_Project_Market_Fragment = { __typename?: 'Market', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type InvoicePage_Project_Community_Fragment = { __typename?: 'Community', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type InvoicePage_Project_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type InvoicePage_Project_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type InvoicePage_Project_Structure_Fragment = { __typename?: 'Structure', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type InvoicePage_Project_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

export type InvoicePage_ProjectFragment = InvoicePage_Project_StandaloneProject_Fragment | InvoicePage_Project_Region_Fragment | InvoicePage_Project_Market_Fragment | InvoicePage_Project_Community_Fragment | InvoicePage_Project_Subdivision_Fragment | InvoicePage_Project_Lot_Fragment | InvoicePage_Project_Structure_Fragment | InvoicePage_Project_Unit_Fragment;

export type InvoicePage_BidContractLineItemFragment = { __typename?: 'BidContractLineItem', id: string, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string } } | null | undefined };

export type InvoicePage_TradeLineItemFragment = { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string } };

export type InvoicePage_ProjectItemFragment = { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } } | null | undefined };

type InvoicePage_ItemTemplateItems_ItemTemplateItemVersion_Fragment = { __typename?: 'ItemTemplateItemVersion', displayName: string, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } };

type InvoicePage_ItemTemplateItems_ItemTemplateItem_Fragment = { __typename?: 'ItemTemplateItem', displayName: string, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } };

type InvoicePage_ItemTemplateItems_TakeoffLineItem_Fragment = { __typename?: 'TakeoffLineItem', displayName: string, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } };

type InvoicePage_ItemTemplateItems_TakeoffLineItemVersion_Fragment = { __typename?: 'TakeoffLineItemVersion', displayName: string, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string } };

export type InvoicePage_ItemTemplateItemsFragment = InvoicePage_ItemTemplateItems_ItemTemplateItemVersion_Fragment | InvoicePage_ItemTemplateItems_ItemTemplateItem_Fragment | InvoicePage_ItemTemplateItems_TakeoffLineItem_Fragment | InvoicePage_ItemTemplateItems_TakeoffLineItemVersion_Fragment;

export type InvoicePage_TradePartnerContactFragment = { __typename?: 'TradePartnerContact', email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string } | null | undefined };

export type InvoicesPageQueryVariables = Exact<{
  filter: BillFilter;
}>;


export type InvoicesPageQuery = { __typename?: 'Query', bills: Array<{ __typename?: 'Bill', id: string, billedInCents: number, tradePartnerNumber: string, billDate: DateOnly, paidDate?: DateOnly | null | undefined, dueDate?: DateOnly | null | undefined, sentDate?: DateOnly | null | undefined, approvedAt?: DateTime | null | undefined, isTradePartnerCredit: boolean, referenceNumber?: string | null | undefined, parents: Array<{ __typename?: 'Commitment', id: string, accountingNumber: number } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number }>, project: { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined } | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }, status: { __typename?: 'BillStatusDetail', code: BillStatus }, type: { __typename?: 'BillTypeDetail', code: BillType } }> };

export type InvoicesPage_BillFragment = { __typename?: 'Bill', id: string, billedInCents: number, tradePartnerNumber: string, billDate: DateOnly, paidDate?: DateOnly | null | undefined, dueDate?: DateOnly | null | undefined, sentDate?: DateOnly | null | undefined, approvedAt?: DateTime | null | undefined, isTradePartnerCredit: boolean, referenceNumber?: string | null | undefined, parents: Array<{ __typename?: 'Commitment', id: string, accountingNumber: number } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number }>, project: { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined } | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }, status: { __typename?: 'BillStatusDetail', code: BillStatus }, type: { __typename?: 'BillTypeDetail', code: BillType } };

export type PurchaseOrderPageQueryVariables = Exact<{
  commitmentId: Scalars['ID'];
  changeOrderId: Scalars['ID'];
  projectId: Scalars['ID'];
  skipCommitment: Scalars['Boolean'];
  skipChangeOrder: Scalars['Boolean'];
}>;


export type PurchaseOrderPageQuery = { __typename?: 'Query', commitment?: { __typename?: 'Commitment', id: string, referenceNumber?: string | null | undefined, status: CommitmentStatus, accountingNumber: number, committedInCents: number, balanceInCents?: number | null | undefined, remainingInCents: number, sentDate?: DateOnly | null | undefined, executionDate?: DateOnly | null | undefined, depositInBasisPoints?: number | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, signatoryForProject?: { __typename?: 'TradePartnerContact', email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string } | null | undefined } | null | undefined } | null | undefined, document?: { __typename?: 'Document', isDeleted?: boolean | null | undefined, id: string, name: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } } | null | undefined, pandaDoc?: { __typename?: 'PandaDoc', externalPandaDocUrl?: string | null | undefined, externalPandaDocId?: string | null | undefined, status: PandaDocStatus, id: string, name: string, canCreatePandaDocSession?: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } | null | undefined } | null | undefined, project: { __typename?: 'StandaloneProject', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Region', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Market', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Community', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Subdivision', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Lot', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Structure', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Unit', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } }, bills: Array<{ __typename?: 'Bill', id: string, balanceInCents: number }>, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, committedInCents: number, quantity?: number | null | undefined, taxableCostInCents: number, taxInCents: number, costChangeInCents?: number | null | undefined, specifications?: string | null | undefined, bidItem?: { __typename?: 'BidItem', id: string, displayName: string } | null | undefined, projectItem: { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, unitCostInCents: number, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, name: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, costTypeDetail: { __typename?: 'CostTypeDetail', code: CostType, name: string, tradePartnerName: string }, location: { __typename?: 'Location', id: string, name: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string, modelNumber?: string | null | undefined } | null | undefined, configuredOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> }, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined } | null | undefined, modifyingBidContractLineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined }> }>, draws: Array<{ __typename?: 'CommitmentDraw', id: string, amountInBasisPoints: number, description?: string | null | undefined, task: { __typename?: 'Task', id: string, name: string } }>, bidContractRevision?: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, type: { __typename?: 'BidContractTypeDetail', code: BidContractType } } } | null | undefined }, commitmentChangeOrder?: { __typename?: 'CommitmentChangeOrder', id: string, referenceNumber?: string | null | undefined, status: CommitmentStatus, accountingNumber: number, committedInCents: number, balanceInCents?: number | null | undefined, remainingInCents: number, sentDate?: DateOnly | null | undefined, executionDate?: DateOnly | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, signatoryForProject?: { __typename?: 'TradePartnerContact', email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string } | null | undefined } | null | undefined } | null | undefined, document?: { __typename?: 'Document', isDeleted?: boolean | null | undefined, id: string, name: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } } | null | undefined, pandaDoc?: { __typename?: 'PandaDoc', externalPandaDocUrl?: string | null | undefined, externalPandaDocId?: string | null | undefined, status: PandaDocStatus, id: string, name: string, canCreatePandaDocSession?: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } | null | undefined } | null | undefined, commitment: { __typename?: 'Commitment', id: string, project: { __typename?: 'StandaloneProject', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Region', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Market', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Community', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Subdivision', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Lot', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Structure', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Unit', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } }, bills: Array<{ __typename?: 'Bill', id: string, balanceInCents: number }> }, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, committedInCents: number, quantity?: number | null | undefined, taxableCostInCents: number, taxInCents: number, costChangeInCents?: number | null | undefined, specifications?: string | null | undefined, bidItem?: { __typename?: 'BidItem', id: string, displayName: string } | null | undefined, projectItem: { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, unitCostInCents: number, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, name: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, costTypeDetail: { __typename?: 'CostTypeDetail', code: CostType, name: string, tradePartnerName: string }, location: { __typename?: 'Location', id: string, name: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string, modelNumber?: string | null | undefined } | null | undefined, configuredOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> }, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined } | null | undefined, modifyingBidContractLineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined }> }> } };

export type CreatePandaDocSessionMutationVariables = Exact<{
  input: CreatePandaDocSessionInput;
}>;


export type CreatePandaDocSessionMutation = { __typename?: 'Mutation', createPandaDocSession: { __typename?: 'PandaDocSession', sessionId: string } };

export type SaveCommitmentMutationVariables = Exact<{
  input: SaveCommitmentInput;
  projectId: Scalars['ID'];
}>;


export type SaveCommitmentMutation = { __typename?: 'Mutation', saveCommitment: { __typename?: 'SaveCommitmentResult', commitment: { __typename?: 'Commitment', id: string, referenceNumber?: string | null | undefined, status: CommitmentStatus, accountingNumber: number, committedInCents: number, balanceInCents?: number | null | undefined, remainingInCents: number, sentDate?: DateOnly | null | undefined, executionDate?: DateOnly | null | undefined, depositInBasisPoints?: number | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, signatoryForProject?: { __typename?: 'TradePartnerContact', email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string } | null | undefined } | null | undefined } | null | undefined, document?: { __typename?: 'Document', isDeleted?: boolean | null | undefined, id: string, name: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } } | null | undefined, pandaDoc?: { __typename?: 'PandaDoc', externalPandaDocUrl?: string | null | undefined, externalPandaDocId?: string | null | undefined, status: PandaDocStatus, id: string, name: string, canCreatePandaDocSession?: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } | null | undefined } | null | undefined, project: { __typename?: 'StandaloneProject', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Region', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Market', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Community', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Subdivision', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Lot', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Structure', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Unit', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } }, bills: Array<{ __typename?: 'Bill', id: string, balanceInCents: number }>, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, committedInCents: number, quantity?: number | null | undefined, taxableCostInCents: number, taxInCents: number, costChangeInCents?: number | null | undefined, specifications?: string | null | undefined, bidItem?: { __typename?: 'BidItem', id: string, displayName: string } | null | undefined, projectItem: { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, unitCostInCents: number, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, name: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, costTypeDetail: { __typename?: 'CostTypeDetail', code: CostType, name: string, tradePartnerName: string }, location: { __typename?: 'Location', id: string, name: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string, modelNumber?: string | null | undefined } | null | undefined, configuredOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> }, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined } | null | undefined, modifyingBidContractLineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined }> }>, draws: Array<{ __typename?: 'CommitmentDraw', id: string, amountInBasisPoints: number, description?: string | null | undefined, task: { __typename?: 'Task', id: string, name: string } }>, bidContractRevision?: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, type: { __typename?: 'BidContractTypeDetail', code: BidContractType } } } | null | undefined } } };

export type SaveCommitmentChangeOrderMutationVariables = Exact<{
  input: SaveCommitmentChangeOrderInput;
  projectId: Scalars['ID'];
}>;


export type SaveCommitmentChangeOrderMutation = { __typename?: 'Mutation', saveCommitmentChangeOrder: { __typename?: 'SaveCommitmentChangeOrderResult', commitmentChangeOrder: { __typename?: 'CommitmentChangeOrder', id: string, referenceNumber?: string | null | undefined, status: CommitmentStatus, accountingNumber: number, committedInCents: number, balanceInCents?: number | null | undefined, remainingInCents: number, sentDate?: DateOnly | null | undefined, executionDate?: DateOnly | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, signatoryForProject?: { __typename?: 'TradePartnerContact', email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string } | null | undefined } | null | undefined } | null | undefined, document?: { __typename?: 'Document', isDeleted?: boolean | null | undefined, id: string, name: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } } | null | undefined, pandaDoc?: { __typename?: 'PandaDoc', externalPandaDocUrl?: string | null | undefined, externalPandaDocId?: string | null | undefined, status: PandaDocStatus, id: string, name: string, canCreatePandaDocSession?: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } | null | undefined } | null | undefined, commitment: { __typename?: 'Commitment', id: string, project: { __typename?: 'StandaloneProject', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Region', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Market', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Community', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Subdivision', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Lot', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Structure', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Unit', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } }, bills: Array<{ __typename?: 'Bill', id: string, balanceInCents: number }> }, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, committedInCents: number, quantity?: number | null | undefined, taxableCostInCents: number, taxInCents: number, costChangeInCents?: number | null | undefined, specifications?: string | null | undefined, bidItem?: { __typename?: 'BidItem', id: string, displayName: string } | null | undefined, projectItem: { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, unitCostInCents: number, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, name: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, costTypeDetail: { __typename?: 'CostTypeDetail', code: CostType, name: string, tradePartnerName: string }, location: { __typename?: 'Location', id: string, name: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string, modelNumber?: string | null | undefined } | null | undefined, configuredOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> }, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined } | null | undefined, modifyingBidContractLineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined }> }> } } };

type PurchaseOrderPage_CommitmentLike_Commitment_Fragment = { __typename?: 'Commitment', id: string, referenceNumber?: string | null | undefined, status: CommitmentStatus, accountingNumber: number, committedInCents: number, balanceInCents?: number | null | undefined, remainingInCents: number, sentDate?: DateOnly | null | undefined, executionDate?: DateOnly | null | undefined, depositInBasisPoints?: number | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, signatoryForProject?: { __typename?: 'TradePartnerContact', email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string } | null | undefined } | null | undefined } | null | undefined, document?: { __typename?: 'Document', isDeleted?: boolean | null | undefined, id: string, name: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } } | null | undefined, pandaDoc?: { __typename?: 'PandaDoc', externalPandaDocUrl?: string | null | undefined, externalPandaDocId?: string | null | undefined, status: PandaDocStatus, id: string, name: string, canCreatePandaDocSession?: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } | null | undefined } | null | undefined, project: { __typename?: 'StandaloneProject', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Region', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Market', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Community', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Subdivision', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Lot', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Structure', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Unit', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } }, bills: Array<{ __typename?: 'Bill', id: string, balanceInCents: number }>, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, committedInCents: number, quantity?: number | null | undefined, taxableCostInCents: number, taxInCents: number, costChangeInCents?: number | null | undefined, specifications?: string | null | undefined, bidItem?: { __typename?: 'BidItem', id: string, displayName: string } | null | undefined, projectItem: { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, unitCostInCents: number, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, name: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, costTypeDetail: { __typename?: 'CostTypeDetail', code: CostType, name: string, tradePartnerName: string }, location: { __typename?: 'Location', id: string, name: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string, modelNumber?: string | null | undefined } | null | undefined, configuredOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> }, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined } | null | undefined, modifyingBidContractLineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined }> }>, draws: Array<{ __typename?: 'CommitmentDraw', id: string, amountInBasisPoints: number, description?: string | null | undefined, task: { __typename?: 'Task', id: string, name: string } }>, bidContractRevision?: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, type: { __typename?: 'BidContractTypeDetail', code: BidContractType } } } | null | undefined };

type PurchaseOrderPage_CommitmentLike_CommitmentChangeOrder_Fragment = { __typename?: 'CommitmentChangeOrder', id: string, referenceNumber?: string | null | undefined, status: CommitmentStatus, accountingNumber: number, committedInCents: number, balanceInCents?: number | null | undefined, remainingInCents: number, sentDate?: DateOnly | null | undefined, executionDate?: DateOnly | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, signatoryForProject?: { __typename?: 'TradePartnerContact', email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string } | null | undefined } | null | undefined } | null | undefined, document?: { __typename?: 'Document', isDeleted?: boolean | null | undefined, id: string, name: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } } | null | undefined, pandaDoc?: { __typename?: 'PandaDoc', externalPandaDocUrl?: string | null | undefined, externalPandaDocId?: string | null | undefined, status: PandaDocStatus, id: string, name: string, canCreatePandaDocSession?: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } | null | undefined } | null | undefined, commitment: { __typename?: 'Commitment', id: string, project: { __typename?: 'StandaloneProject', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Region', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Market', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Community', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Subdivision', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Lot', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Structure', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Unit', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } }, bills: Array<{ __typename?: 'Bill', id: string, balanceInCents: number }> }, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, committedInCents: number, quantity?: number | null | undefined, taxableCostInCents: number, taxInCents: number, costChangeInCents?: number | null | undefined, specifications?: string | null | undefined, bidItem?: { __typename?: 'BidItem', id: string, displayName: string } | null | undefined, projectItem: { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, unitCostInCents: number, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, name: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, costTypeDetail: { __typename?: 'CostTypeDetail', code: CostType, name: string, tradePartnerName: string }, location: { __typename?: 'Location', id: string, name: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string, modelNumber?: string | null | undefined } | null | undefined, configuredOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> }, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined } | null | undefined, modifyingBidContractLineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined }> }> };

export type PurchaseOrderPage_CommitmentLikeFragment = PurchaseOrderPage_CommitmentLike_Commitment_Fragment | PurchaseOrderPage_CommitmentLike_CommitmentChangeOrder_Fragment;

export type PurchaseOrderPage_CommitmentFragment = { __typename?: 'Commitment', id: string, status: CommitmentStatus, accountingNumber: number, committedInCents: number, balanceInCents?: number | null | undefined, remainingInCents: number, sentDate?: DateOnly | null | undefined, executionDate?: DateOnly | null | undefined, depositInBasisPoints?: number | null | undefined, project: { __typename?: 'StandaloneProject', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Region', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Market', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Community', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Subdivision', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Lot', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Structure', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Unit', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } }, bills: Array<{ __typename?: 'Bill', id: string, balanceInCents: number }>, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, committedInCents: number, quantity?: number | null | undefined, taxableCostInCents: number, taxInCents: number, costChangeInCents?: number | null | undefined, specifications?: string | null | undefined, bidItem?: { __typename?: 'BidItem', id: string, displayName: string } | null | undefined, projectItem: { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, unitCostInCents: number, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, name: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, costTypeDetail: { __typename?: 'CostTypeDetail', code: CostType, name: string, tradePartnerName: string }, location: { __typename?: 'Location', id: string, name: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string, modelNumber?: string | null | undefined } | null | undefined, configuredOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> }, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined } | null | undefined, modifyingBidContractLineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined }> }>, draws: Array<{ __typename?: 'CommitmentDraw', id: string, amountInBasisPoints: number, description?: string | null | undefined, task: { __typename?: 'Task', id: string, name: string } }>, bidContractRevision?: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, type: { __typename?: 'BidContractTypeDetail', code: BidContractType } } } | null | undefined };

export type PurchaseOrderPage_DrawFragment = { __typename?: 'CommitmentDraw', id: string, amountInBasisPoints: number, description?: string | null | undefined, task: { __typename?: 'Task', id: string, name: string } };

export type PurchaseOrderPage_TaskFragment = { __typename?: 'Task', id: string, name: string };

export type PurchaseOrderPage_ChangeOrderFragment = { __typename?: 'CommitmentChangeOrder', id: string, status: CommitmentStatus, accountingNumber: number, committedInCents: number, balanceInCents?: number | null | undefined, remainingInCents: number, sentDate?: DateOnly | null | undefined, executionDate?: DateOnly | null | undefined, commitment: { __typename?: 'Commitment', id: string, project: { __typename?: 'StandaloneProject', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Region', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Market', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Community', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Subdivision', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Lot', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Structure', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } } | { __typename?: 'Unit', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } }, bills: Array<{ __typename?: 'Bill', id: string, balanceInCents: number }> }, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, committedInCents: number, quantity?: number | null | undefined, taxableCostInCents: number, taxInCents: number, costChangeInCents?: number | null | undefined, specifications?: string | null | undefined, bidItem?: { __typename?: 'BidItem', id: string, displayName: string } | null | undefined, projectItem: { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, unitCostInCents: number, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, name: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, costTypeDetail: { __typename?: 'CostTypeDetail', code: CostType, name: string, tradePartnerName: string }, location: { __typename?: 'Location', id: string, name: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string, modelNumber?: string | null | undefined } | null | undefined, configuredOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> }, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined } | null | undefined, modifyingBidContractLineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined }> }> };

export type PurchaseOrderPage_LineItemsFragment = { __typename?: 'CommitmentLineItem', id: string, committedInCents: number, quantity?: number | null | undefined, taxableCostInCents: number, taxInCents: number, costChangeInCents?: number | null | undefined, specifications?: string | null | undefined, bidItem?: { __typename?: 'BidItem', id: string, displayName: string } | null | undefined, projectItem: { __typename?: 'ProjectItem', displayName: string, baseOrOptionName: string, unitCostInCents: number, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, name: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, costTypeDetail: { __typename?: 'CostTypeDetail', code: CostType, name: string, tradePartnerName: string }, location: { __typename?: 'Location', id: string, name: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string, modelNumber?: string | null | undefined } | null | undefined, configuredOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> }, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined } | null | undefined, modifyingBidContractLineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined }> };

export type PurchaseOrderPage_BidContractLineItemFragment = { __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> } | null | undefined, tradeLineItem?: { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> } | null | undefined };

export type PurchaseOrderPage_TradeLineItemFragment = { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> };

export type PurchaseOrderPage_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } };

type PurchaseOrderPage_ItemTemplateItems_ItemTemplateItemVersion_Fragment = { __typename?: 'ItemTemplateItemVersion', displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> };

type PurchaseOrderPage_ItemTemplateItems_ItemTemplateItem_Fragment = { __typename?: 'ItemTemplateItem', displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> };

type PurchaseOrderPage_ItemTemplateItems_TakeoffLineItem_Fragment = { __typename?: 'TakeoffLineItem', displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> };

type PurchaseOrderPage_ItemTemplateItems_TakeoffLineItemVersion_Fragment = { __typename?: 'TakeoffLineItemVersion', displayName: string, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, id: string, name: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, abbreviation: string, id: string, name: string }, item: { __typename?: 'Item', id: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } } } }> };

export type PurchaseOrderPage_ItemTemplateItemsFragment = PurchaseOrderPage_ItemTemplateItems_ItemTemplateItemVersion_Fragment | PurchaseOrderPage_ItemTemplateItems_ItemTemplateItem_Fragment | PurchaseOrderPage_ItemTemplateItems_TakeoffLineItem_Fragment | PurchaseOrderPage_ItemTemplateItems_TakeoffLineItemVersion_Fragment;

export type PurchaseOrderPage_ItemFragment = { __typename?: 'Item', id: string, name: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } };

type PurchaseOrderPage_Project_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type PurchaseOrderPage_Project_Region_Fragment = { __typename?: 'Region', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type PurchaseOrderPage_Project_Market_Fragment = { __typename?: 'Market', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type PurchaseOrderPage_Project_Community_Fragment = { __typename?: 'Community', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type PurchaseOrderPage_Project_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type PurchaseOrderPage_Project_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type PurchaseOrderPage_Project_Structure_Fragment = { __typename?: 'Structure', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

type PurchaseOrderPage_Project_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, enableProductConfigPlan: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'PlanPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'DesignPackage', id: string, displayName: string, description?: string | null | undefined } | { __typename?: 'ProductOffering', id: string, displayName: string, description?: string | null | undefined } | null | undefined, specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined } | null | undefined, companyInfo: { __typename?: 'CompanyInfo', name: string, email: string, phoneNumber: string } };

export type PurchaseOrderPage_ProjectFragment = PurchaseOrderPage_Project_StandaloneProject_Fragment | PurchaseOrderPage_Project_Region_Fragment | PurchaseOrderPage_Project_Market_Fragment | PurchaseOrderPage_Project_Community_Fragment | PurchaseOrderPage_Project_Subdivision_Fragment | PurchaseOrderPage_Project_Lot_Fragment | PurchaseOrderPage_Project_Structure_Fragment | PurchaseOrderPage_Project_Unit_Fragment;

export type PurchaseOrderPage_TradePartnerFragment = { __typename?: 'TradePartner', id: string, signatoryForProject?: { __typename?: 'TradePartnerContact', email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string } | null | undefined } | null | undefined };

export type PurchaseOrdersPageQueryVariables = Exact<{
  filter?: InputMaybe<CommitmentsFilter>;
  order?: InputMaybe<CommitmentOrder>;
  page?: InputMaybe<PageFilter>;
}>;


export type PurchaseOrdersPageQuery = { __typename?: 'Query', commitmentsPage: { __typename?: 'CommitmentsPage', commitments: Array<{ __typename?: 'Commitment', id: string, accountingNumber: number, createdAt: DateTime, sentDate?: DateOnly | null | undefined, executionDate?: DateOnly | null | undefined, status: CommitmentStatus, committedInCents: number, billedInCents?: number | null | undefined, unbilledInCents: number, paidInCents?: number | null | undefined, balanceInCents?: number | null | undefined, referenceNumber?: string | null | undefined, project: { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined } | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }, changeOrders: Array<{ __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, executionDate?: DateOnly | null | undefined, createdAt: DateTime, sentDate?: DateOnly | null | undefined, status: CommitmentStatus, committedInCents: number, billedInCents?: number | null | undefined, unbilledInCents: number, paidInCents?: number | null | undefined, balanceInCents?: number | null | undefined, referenceNumber?: string | null | undefined, bills: Array<{ __typename?: 'Bill', id: string, balanceInCents: number, paidDate?: DateOnly | null | undefined, status: { __typename?: 'BillStatusDetail', code: BillStatus } }>, commitment: { __typename?: 'Commitment', id: string, project: { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined } | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } } }>, bills: Array<{ __typename?: 'Bill', id: string, balanceInCents: number, paidDate?: DateOnly | null | undefined, status: { __typename?: 'BillStatusDetail', code: BillStatus } }> }>, pageInfo: { __typename?: 'PageInfo', totalCount: number, hasNextPage: boolean } }, currentUser?: { __typename?: 'User', id: string, tradePartnerUsers: Array<{ __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, activeTasksCount: number, activeProjectsCount: number, totalCommittedInCents: number, totalBilledInCents: number, totalPaidInCents: number, commitmentCountThisWeek: number, commitmentCountLastWeek: number }, tradePartnerContact?: { __typename?: 'TradePartnerContact', id: string, markets: Array<{ __typename?: 'Market', id: string }> } | null | undefined }> } | null | undefined, projects: Array<{ __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined } | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }> };

type PurchaseOrdersPage_Projects_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

type PurchaseOrdersPage_Projects_Region_Fragment = { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined };

type PurchaseOrdersPage_Projects_Market_Fragment = { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

type PurchaseOrdersPage_Projects_Community_Fragment = { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

type PurchaseOrdersPage_Projects_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

type PurchaseOrdersPage_Projects_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

type PurchaseOrdersPage_Projects_Structure_Fragment = { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

type PurchaseOrdersPage_Projects_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type PurchaseOrdersPage_ProjectsFragment = PurchaseOrdersPage_Projects_StandaloneProject_Fragment | PurchaseOrdersPage_Projects_Region_Fragment | PurchaseOrdersPage_Projects_Market_Fragment | PurchaseOrdersPage_Projects_Community_Fragment | PurchaseOrdersPage_Projects_Subdivision_Fragment | PurchaseOrdersPage_Projects_Lot_Fragment | PurchaseOrdersPage_Projects_Structure_Fragment | PurchaseOrdersPage_Projects_Unit_Fragment;

export type PurchaseOrdersPage_CurrentUserFragment = { __typename?: 'User', id: string, tradePartnerUsers: Array<{ __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, activeTasksCount: number, activeProjectsCount: number, totalCommittedInCents: number, totalBilledInCents: number, totalPaidInCents: number, commitmentCountThisWeek: number, commitmentCountLastWeek: number }, tradePartnerContact?: { __typename?: 'TradePartnerContact', id: string, markets: Array<{ __typename?: 'Market', id: string }> } | null | undefined }> };

export type PurchaseOrdersPage_TradePartnerUserFragment = { __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, activeTasksCount: number, activeProjectsCount: number, totalCommittedInCents: number, totalBilledInCents: number, totalPaidInCents: number, commitmentCountThisWeek: number, commitmentCountLastWeek: number }, tradePartnerContact?: { __typename?: 'TradePartnerContact', id: string, markets: Array<{ __typename?: 'Market', id: string }> } | null | undefined };

export type PurchaseOrdersPage_CommitmentFragment = { __typename?: 'Commitment', id: string, accountingNumber: number, createdAt: DateTime, sentDate?: DateOnly | null | undefined, executionDate?: DateOnly | null | undefined, status: CommitmentStatus, committedInCents: number, billedInCents?: number | null | undefined, unbilledInCents: number, paidInCents?: number | null | undefined, balanceInCents?: number | null | undefined, referenceNumber?: string | null | undefined, project: { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined } | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }, changeOrders: Array<{ __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, executionDate?: DateOnly | null | undefined, createdAt: DateTime, sentDate?: DateOnly | null | undefined, status: CommitmentStatus, committedInCents: number, billedInCents?: number | null | undefined, unbilledInCents: number, paidInCents?: number | null | undefined, balanceInCents?: number | null | undefined, referenceNumber?: string | null | undefined, bills: Array<{ __typename?: 'Bill', id: string, balanceInCents: number, paidDate?: DateOnly | null | undefined, status: { __typename?: 'BillStatusDetail', code: BillStatus } }>, commitment: { __typename?: 'Commitment', id: string, project: { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined } | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } } }>, bills: Array<{ __typename?: 'Bill', id: string, balanceInCents: number, paidDate?: DateOnly | null | undefined, status: { __typename?: 'BillStatusDetail', code: BillStatus } }> };

export type PurchaseOrdersPage_ChangeOrderFragment = { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, executionDate?: DateOnly | null | undefined, createdAt: DateTime, sentDate?: DateOnly | null | undefined, status: CommitmentStatus, committedInCents: number, billedInCents?: number | null | undefined, unbilledInCents: number, paidInCents?: number | null | undefined, balanceInCents?: number | null | undefined, referenceNumber?: string | null | undefined, bills: Array<{ __typename?: 'Bill', id: string, balanceInCents: number, paidDate?: DateOnly | null | undefined, status: { __typename?: 'BillStatusDetail', code: BillStatus } }>, commitment: { __typename?: 'Commitment', id: string, project: { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined } | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } | { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } } } };

type PurchaseOrdersPage_Project_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

type PurchaseOrdersPage_Project_Region_Fragment = { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined };

type PurchaseOrdersPage_Project_Market_Fragment = { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

type PurchaseOrdersPage_Project_Community_Fragment = { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

type PurchaseOrdersPage_Project_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

type PurchaseOrdersPage_Project_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

type PurchaseOrdersPage_Project_Structure_Fragment = { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

type PurchaseOrdersPage_Project_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type PurchaseOrdersPage_ProjectFragment = PurchaseOrdersPage_Project_StandaloneProject_Fragment | PurchaseOrdersPage_Project_Region_Fragment | PurchaseOrdersPage_Project_Market_Fragment | PurchaseOrdersPage_Project_Community_Fragment | PurchaseOrdersPage_Project_Subdivision_Fragment | PurchaseOrdersPage_Project_Lot_Fragment | PurchaseOrdersPage_Project_Structure_Fragment | PurchaseOrdersPage_Project_Unit_Fragment;

export type PurchaseOrdersPage_TradePartnerFragment = { __typename?: 'TradePartner', id: string, activeTasksCount: number, activeProjectsCount: number, totalCommittedInCents: number, totalBilledInCents: number, totalPaidInCents: number, commitmentCountThisWeek: number, commitmentCountLastWeek: number };

export type UpdateTradePartnerAvailabilityRequestStatusMutationVariables = Exact<{
  input: UpdateTradePartnerAvailabilityRequestStatusInput;
}>;


export type UpdateTradePartnerAvailabilityRequestStatusMutation = { __typename?: 'Mutation', updateTradePartnerAvailabilityRequestStatus: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type SaveTradePartnerAvailabilityRequestMutationVariables = Exact<{
  input: SaveTradePartnerAvailabilityRequestInput;
}>;


export type SaveTradePartnerAvailabilityRequestMutation = { __typename?: 'Mutation', saveTradePartnerAvailabilityRequest: { __typename?: 'SaveTradePartnerAvailabilityRequestResult', tradePartnerAvailabilityRequest: { __typename?: 'TradePartnerAvailabilityRequest', id: string } } };

export type SchedulesPageQueryVariables = Exact<{
  market?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  tradePartner?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  tradePartnerStatus?: InputMaybe<Array<TradePartnerTaskStatus> | TradePartnerTaskStatus>;
  projectStatus?: InputMaybe<Array<ProjectStatus> | ProjectStatus>;
}>;


export type SchedulesPageQuery = { __typename?: 'Query', tasks: Array<{ __typename?: 'Task', name: string, id: string, status: { __typename?: 'TaskStatusDetail', code: TaskStatus, name: string }, project?: { __typename?: 'StandaloneProject', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> } | { __typename?: 'Region', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> } | { __typename?: 'Market', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> } | { __typename?: 'Community', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> } | { __typename?: 'Subdivision', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> } | { __typename?: 'Lot', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> } | { __typename?: 'Structure', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> } | { __typename?: 'Unit', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> } | null | undefined, interval: { __typename?: 'CalendarInterval', startDate: DateOnly, endDate: DateOnly }, tradePartnerStatus: { __typename?: 'TradePartnerTaskStatusDetail', code: TradePartnerTaskStatus, name: string }, tradePartnerAvailabilityRequests?: Array<{ __typename?: 'TradePartnerAvailabilityRequest', id: string, rescheduleDates?: Array<DateOnly> | null | undefined, status: { __typename?: 'TradePartnerAvailabilityRequestStatusDetail', code: TradePartnerAvailabilityRequestStatus }, canSave: { __typename?: 'PotentialOperation2', disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string } | null | undefined }> };

export type SchedulesPage_TaskFragment = { __typename?: 'Task', name: string, id: string, status: { __typename?: 'TaskStatusDetail', code: TaskStatus, name: string }, project?: { __typename?: 'StandaloneProject', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> } | { __typename?: 'Region', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> } | { __typename?: 'Market', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> } | { __typename?: 'Community', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> } | { __typename?: 'Subdivision', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> } | { __typename?: 'Lot', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> } | { __typename?: 'Structure', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> } | { __typename?: 'Unit', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> } | null | undefined, interval: { __typename?: 'CalendarInterval', startDate: DateOnly, endDate: DateOnly }, tradePartnerStatus: { __typename?: 'TradePartnerTaskStatusDetail', code: TradePartnerTaskStatus, name: string }, tradePartnerAvailabilityRequests?: Array<{ __typename?: 'TradePartnerAvailabilityRequest', id: string, rescheduleDates?: Array<DateOnly> | null | undefined, status: { __typename?: 'TradePartnerAvailabilityRequestStatusDetail', code: TradePartnerAvailabilityRequestStatus }, canSave: { __typename?: 'PotentialOperation2', disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string } | null | undefined };

type SchedulesPage_Project_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> };

type SchedulesPage_Project_Region_Fragment = { __typename?: 'Region', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> };

type SchedulesPage_Project_Market_Fragment = { __typename?: 'Market', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> };

type SchedulesPage_Project_Community_Fragment = { __typename?: 'Community', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> };

type SchedulesPage_Project_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> };

type SchedulesPage_Project_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> };

type SchedulesPage_Project_Structure_Fragment = { __typename?: 'Structure', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> };

type SchedulesPage_Project_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, shadowProjects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, type: { __typename?: 'FeatureFlagTypeDetail', code: FeatureFlagType }, status: { __typename?: 'FeatureFlagStatusDetail', code: FeatureFlagStatus } }> };

export type SchedulesPage_ProjectFragment = SchedulesPage_Project_StandaloneProject_Fragment | SchedulesPage_Project_Region_Fragment | SchedulesPage_Project_Market_Fragment | SchedulesPage_Project_Community_Fragment | SchedulesPage_Project_Subdivision_Fragment | SchedulesPage_Project_Lot_Fragment | SchedulesPage_Project_Structure_Fragment | SchedulesPage_Project_Unit_Fragment;

export type SchedulesPage_TradePartnerAvailabilityRequestFragment = { __typename?: 'TradePartnerAvailabilityRequest', id: string, rescheduleDates?: Array<DateOnly> | null | undefined, status: { __typename?: 'TradePartnerAvailabilityRequestStatusDetail', code: TradePartnerAvailabilityRequestStatus }, canSave: { __typename?: 'PotentialOperation2', disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type TradePartnerContactsRolesPanelMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type TradePartnerContactsRolesPanelMetadataQuery = { __typename?: 'Query', tradePartnerMarketRoles: Array<{ __typename?: 'TradePartnerMarketRoleDetail', code: TradePartnerMarketRole, name: string, sortOrder: number }> };

export type TradePartnerContactsQueryVariables = Exact<{
  tradePartnerId: Scalars['ID'];
}>;


export type TradePartnerContactsQuery = { __typename?: 'Query', tradePartner: { __typename?: 'TradePartner', id: string, contacts: Array<{ __typename?: 'TradePartnerContact', title?: string | null | undefined, email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, canLoginToPortal: boolean, maybeBillingSignatory: boolean, id: string, name: string, markets: Array<{ __typename?: 'Market', id: string, name: string }>, tradePartnerUser?: { __typename?: 'TradePartnerUser', id: string, user: { __typename?: 'User', id: string, userCommunicationPreference?: { __typename?: 'UserCommunicationPreference', id: string, tpAvailabilityRequestPreference?: Array<CommunicationChannel> | null | undefined, commentPreference?: Array<CommunicationChannel> | null | undefined } | null | undefined } } | null | undefined, address?: { __typename?: 'Address', id: string, street1: string, city: string, state: string, postalCode: string, country: string } | null | undefined, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean }, canDeactivate: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }>, marketContacts: Array<{ __typename?: 'TradePartnerMarketContact', id: string, role: { __typename?: 'TradePartnerMarketRoleDetail', code: TradePartnerMarketRole, name: string }, contact: { __typename?: 'TradePartnerContact', id: string, name: string }, market: { __typename?: 'Market', id: string, name: string }, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }>, markets: Array<{ __typename?: 'Market', id: string, name: string }> }, markets: Array<{ __typename?: 'Market', id: string, name: string }> };

export type SaveTradePartnerContactMutationVariables = Exact<{
  input: SaveTradePartnerContactInput;
}>;


export type SaveTradePartnerContactMutation = { __typename?: 'Mutation', saveTradePartnerContact: { __typename?: 'SaveTradePartnerContactResult', tradePartnerContact: { __typename?: 'TradePartnerContact', id: string, tradePartner: { __typename?: 'TradePartner', id: string, contacts: Array<{ __typename?: 'TradePartnerContact', title?: string | null | undefined, email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, canLoginToPortal: boolean, maybeBillingSignatory: boolean, id: string, name: string, markets: Array<{ __typename?: 'Market', id: string, name: string }>, tradePartnerUser?: { __typename?: 'TradePartnerUser', id: string, user: { __typename?: 'User', id: string, userCommunicationPreference?: { __typename?: 'UserCommunicationPreference', id: string, tpAvailabilityRequestPreference?: Array<CommunicationChannel> | null | undefined, commentPreference?: Array<CommunicationChannel> | null | undefined } | null | undefined } } | null | undefined, address?: { __typename?: 'Address', id: string, street1: string, city: string, state: string, postalCode: string, country: string } | null | undefined, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean }, canDeactivate: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> } } } };

export type SaveTradePartnerMarketContactMutationVariables = Exact<{
  input: SaveTradePartnerMarketContactInput;
}>;


export type SaveTradePartnerMarketContactMutation = { __typename?: 'Mutation', saveTradePartnerMarketContact: { __typename?: 'SaveTradePartnerMarketContactResult', tradePartnerMarketContact: { __typename?: 'TradePartnerMarketContact', id: string, tradePartner: { __typename?: 'TradePartner', id: string, marketContacts: Array<{ __typename?: 'TradePartnerMarketContact', id: string, role: { __typename?: 'TradePartnerMarketRoleDetail', code: TradePartnerMarketRole, name: string }, contact: { __typename?: 'TradePartnerContact', id: string, name: string }, market: { __typename?: 'Market', id: string, name: string }, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }> } } } };

export type SaveUserCommunicationPreferenceMutationVariables = Exact<{
  input: SaveUserCommunicationPreferenceInput;
}>;


export type SaveUserCommunicationPreferenceMutation = { __typename?: 'Mutation', saveUserCommunicationPreference: { __typename?: 'SaveUserCommunicationPreferenceResult', userCommunicationPreference: { __typename?: 'UserCommunicationPreference', id: string, tpAvailabilityRequestPreference?: Array<CommunicationChannel> | null | undefined, commentPreference?: Array<CommunicationChannel> | null | undefined } } };

export type DeleteTradePartnerContactMutationVariables = Exact<{
  input: DeleteTradePartnerContactInput;
}>;


export type DeleteTradePartnerContactMutation = { __typename?: 'Mutation', deleteTradePartnerContact: { __typename?: 'DeleteTradePartnerContactResult', tradePartner: { __typename?: 'TradePartner', id: string, contacts: Array<{ __typename?: 'TradePartnerContact', id: string }> }, tradePartnerContact?: { __typename?: 'TradePartnerContact', title?: string | null | undefined, email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, canLoginToPortal: boolean, maybeBillingSignatory: boolean, id: string, name: string, markets: Array<{ __typename?: 'Market', id: string, name: string }>, tradePartnerUser?: { __typename?: 'TradePartnerUser', id: string, user: { __typename?: 'User', id: string, userCommunicationPreference?: { __typename?: 'UserCommunicationPreference', id: string, tpAvailabilityRequestPreference?: Array<CommunicationChannel> | null | undefined, commentPreference?: Array<CommunicationChannel> | null | undefined } | null | undefined } } | null | undefined, address?: { __typename?: 'Address', id: string, street1: string, city: string, state: string, postalCode: string, country: string } | null | undefined, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean }, canDeactivate: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined } };

export type ContactsTabTradePartnerFragment = { __typename?: 'TradePartner', id: string, contacts: Array<{ __typename?: 'TradePartnerContact', title?: string | null | undefined, email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, canLoginToPortal: boolean, maybeBillingSignatory: boolean, id: string, name: string, markets: Array<{ __typename?: 'Market', id: string, name: string }>, tradePartnerUser?: { __typename?: 'TradePartnerUser', id: string, user: { __typename?: 'User', id: string, userCommunicationPreference?: { __typename?: 'UserCommunicationPreference', id: string, tpAvailabilityRequestPreference?: Array<CommunicationChannel> | null | undefined, commentPreference?: Array<CommunicationChannel> | null | undefined } | null | undefined } } | null | undefined, address?: { __typename?: 'Address', id: string, street1: string, city: string, state: string, postalCode: string, country: string } | null | undefined, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean }, canDeactivate: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }>, marketContacts: Array<{ __typename?: 'TradePartnerMarketContact', id: string, role: { __typename?: 'TradePartnerMarketRoleDetail', code: TradePartnerMarketRole, name: string }, contact: { __typename?: 'TradePartnerContact', id: string, name: string }, market: { __typename?: 'Market', id: string, name: string }, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }>, markets: Array<{ __typename?: 'Market', id: string, name: string }> };

export type ContactsTabTradePartnerContactFragment = { __typename?: 'TradePartnerContact', title?: string | null | undefined, email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, canLoginToPortal: boolean, maybeBillingSignatory: boolean, id: string, name: string, markets: Array<{ __typename?: 'Market', id: string, name: string }>, tradePartnerUser?: { __typename?: 'TradePartnerUser', id: string, user: { __typename?: 'User', id: string, userCommunicationPreference?: { __typename?: 'UserCommunicationPreference', id: string, tpAvailabilityRequestPreference?: Array<CommunicationChannel> | null | undefined, commentPreference?: Array<CommunicationChannel> | null | undefined } | null | undefined } } | null | undefined, address?: { __typename?: 'Address', id: string, street1: string, city: string, state: string, postalCode: string, country: string } | null | undefined, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean }, canDeactivate: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type ContactsTabTradePartnerMarketRolesFragment = { __typename?: 'TradePartnerMarketContact', id: string, role: { __typename?: 'TradePartnerMarketRoleDetail', code: TradePartnerMarketRole, name: string }, contact: { __typename?: 'TradePartnerContact', id: string, name: string }, market: { __typename?: 'Market', id: string, name: string }, tradePartner: { __typename?: 'TradePartner', id: string, name: string } };

export type ContactsTabTradePartnerMarketFragment = { __typename?: 'Market', id: string, name: string };

export type ImpersonateTradeUserModalQueryVariables = Exact<{ [key: string]: never; }>;


export type ImpersonateTradeUserModalQuery = { __typename?: 'Query', tradePartners: Array<{ __typename?: 'TradePartner', id: string, name: string, users: Array<{ __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string }, tradePartnerContact?: { __typename?: 'TradePartnerContact', isActive: boolean, id: string, name: string } | null | undefined }> }> };

export type ImpersonateTradeUserModal_SaveInternalUserMutationVariables = Exact<{
  input: SaveInternalUserInput;
}>;


export type ImpersonateTradeUserModal_SaveInternalUserMutation = { __typename?: 'Mutation', saveInternalUser: { __typename?: 'SaveInternalUserResult', internalUser: { __typename?: 'InternalUser', id: string, name: string } } };

export type InvoiceRequestChangesQueryVariables = Exact<{
  billId: Scalars['ID'];
}>;


export type InvoiceRequestChangesQuery = { __typename?: 'Query', bill: { __typename?: 'Bill', id: string, tradePartnerNumber: string, project: { __typename?: 'StandaloneProject', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Region', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Market', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Community', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Subdivision', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Lot', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Structure', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Unit', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> }, parents: Array<{ __typename?: 'Commitment', id: string, accountingNumber: number } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number }>, approval?: { __typename?: 'Approval', id: string, approvers: Array<{ __typename?: 'Approver', id: string, user: { __typename?: 'Client', id: string, name: string } | { __typename?: 'InternalUser', id: string, name: string } | { __typename?: 'TradePartnerUser', id: string, name: string } }>, streams: Array<{ __typename?: 'CommentStream', id: string, comments: Array<{ __typename?: 'Comment', id: string, html: string, text: string, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }> }> }> } | null | undefined, status: { __typename?: 'BillStatusDetail', code: BillStatus }, type: { __typename?: 'BillTypeDetail', code: BillType } } };

export type InvoiceRequestChanges_BillFragment = { __typename?: 'Bill', id: string, tradePartnerNumber: string, project: { __typename?: 'StandaloneProject', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Region', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Market', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Community', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Subdivision', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Lot', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Structure', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Unit', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> }, parents: Array<{ __typename?: 'Commitment', id: string, accountingNumber: number } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number }>, approval?: { __typename?: 'Approval', id: string, approvers: Array<{ __typename?: 'Approver', id: string, user: { __typename?: 'Client', id: string, name: string } | { __typename?: 'InternalUser', id: string, name: string } | { __typename?: 'TradePartnerUser', id: string, name: string } }>, streams: Array<{ __typename?: 'CommentStream', id: string, comments: Array<{ __typename?: 'Comment', id: string, html: string, text: string, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }> }> }> } | null | undefined, status: { __typename?: 'BillStatusDetail', code: BillStatus }, type: { __typename?: 'BillTypeDetail', code: BillType } };

export type InvoiceRequestChanges_CommentsFragment = { __typename?: 'Comment', id: string, html: string, text: string, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }> };

export type InvoiceRequestChangesPane_SaveApproverMutationVariables = Exact<{
  input: SaveApproverInput;
}>;


export type InvoiceRequestChangesPane_SaveApproverMutation = { __typename?: 'Mutation', saveApprover: { __typename?: 'SaveApproverResult', approver: { __typename?: 'Approver', id: string, status: { __typename?: 'ApproverStatusDetail', code: ApproverStatus }, approval: { __typename?: 'Approval', id: string, name: string } } } };

export type InvoiceRequestChangesPane_SaveCommentMutationVariables = Exact<{
  input: SaveCommentInput;
}>;


export type InvoiceRequestChangesPane_SaveCommentMutation = { __typename?: 'Mutation', saveComment: { __typename?: 'SaveCommentResult', comment?: { __typename?: 'Comment', id: string, stream: { __typename?: 'CommentStream', id: string, commentable: { __typename?: 'Approval', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'BidContract', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'BidItem', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'BidPackageRequest', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'Bill', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'ChangeEvent', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'ChangeRequest', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'ChangeRequestToDo', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'SchedulePhase', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'ScheduleSubPhase', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'Task', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'ScheduleTask', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'PlanTask', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'ToDo', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'Invoice', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'StandaloneProject', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'Region', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'Market', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'Community', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'Subdivision', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'Lot', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'Structure', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'Unit', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'ProjectItem', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'Estimate', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'DevelopmentCommitment', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'Commitment', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'Document', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'ItemTemplateItemVersion', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'JobLogNote', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'TradePartnerAvailabilityRequest', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'PunchlistItemTodo', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'WarrantyTicket', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'HomeownerContract', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'HomeownerContractChangeOrder', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'ReadyPlan', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'PlanPackage', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'GlobalOption', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } | { __typename?: 'ProjectCostCode', id: string, streams: Array<{ __typename?: 'CommentStream', id: string, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: CommentStreamVisibility }, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: DateTime, updatedAt: DateTime, author: { __typename?: 'User', id: string, avatarUrl: string, email: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string }> }> }> } } } | null | undefined } };

export type PlanBasedLineItemsTabQueryVariables = Exact<{
  commitmentId: Scalars['ID'];
}>;


export type PlanBasedLineItemsTabQuery = { __typename?: 'Query', commitment: { __typename?: 'Commitment', id: string, depositInBasisPoints?: number | null | undefined, draws: Array<{ __typename?: 'CommitmentDraw', id: string, amountInBasisPoints: number, description?: string | null | undefined, task: { __typename?: 'Task', id: string, name: string } }>, project: { __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, quantity?: number | null | undefined, taxableCostInCents: number, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, forCoveringTakeoffs: boolean } | null | undefined, planBasedLineItem?: { __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, groupLine: { __typename?: 'BidPlanChildGroupLine', id: string, group: { __typename?: 'BidPlanChildGroup', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } } | null | undefined, projectItem: { __typename?: 'ProjectItem', id: string, displayName: string, item: { __typename?: 'Item', id: string, fullCode: string }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, task?: { __typename?: 'Task', id: string, name: string } | null | undefined, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } | null | undefined } }> } };

export type PlanBasedLineItemsTab_CommitmentFragment = { __typename?: 'Commitment', id: string, depositInBasisPoints?: number | null | undefined, draws: Array<{ __typename?: 'CommitmentDraw', id: string, amountInBasisPoints: number, description?: string | null | undefined, task: { __typename?: 'Task', id: string, name: string } }>, project: { __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, quantity?: number | null | undefined, taxableCostInCents: number, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, forCoveringTakeoffs: boolean } | null | undefined, planBasedLineItem?: { __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, groupLine: { __typename?: 'BidPlanChildGroupLine', id: string, group: { __typename?: 'BidPlanChildGroup', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } } | null | undefined, projectItem: { __typename?: 'ProjectItem', id: string, displayName: string, item: { __typename?: 'Item', id: string, fullCode: string }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, task?: { __typename?: 'Task', id: string, name: string } | null | undefined, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } | null | undefined } }> };

export type PlanBasedLineItemsTab_PlanBasedLineItemFragment = { __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, groupLine: { __typename?: 'BidPlanChildGroupLine', id: string, group: { __typename?: 'BidPlanChildGroup', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } };

export type PlanBasedLineItemsTab_LineItemFragment = { __typename?: 'CommitmentLineItem', id: string, quantity?: number | null | undefined, taxableCostInCents: number, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, forCoveringTakeoffs: boolean } | null | undefined, planBasedLineItem?: { __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, groupLine: { __typename?: 'BidPlanChildGroupLine', id: string, group: { __typename?: 'BidPlanChildGroup', id: string, displayName: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } } | null | undefined, projectItem: { __typename?: 'ProjectItem', id: string, displayName: string, item: { __typename?: 'Item', id: string, fullCode: string }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, task?: { __typename?: 'Task', id: string, name: string } | null | undefined, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } | null | undefined } };

export type PurchaseOrderDetailPane_DetailsTabQueryVariables = Exact<{
  commitmentId: Scalars['ID'];
  changeOrderId: Scalars['ID'];
  skipCommitment: Scalars['Boolean'];
  skipChangeOrder: Scalars['Boolean'];
}>;


export type PurchaseOrderDetailPane_DetailsTabQuery = { __typename?: 'Query', commitment?: { __typename?: 'Commitment', id: string, sentDate?: DateOnly | null | undefined, executionDate?: DateOnly | null | undefined, balanceInCents?: number | null | undefined, project: { __typename?: 'StandaloneProject', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Region', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Market', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Community', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Subdivision', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Lot', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Structure', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Unit', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> }, document?: { __typename?: 'Document', id: string, createdAt: DateTime, updatedAt: DateTime, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } } | null | undefined }, commitmentChangeOrder?: { __typename?: 'CommitmentChangeOrder', id: string, sentDate?: DateOnly | null | undefined, executionDate?: DateOnly | null | undefined, commitment: { __typename?: 'Commitment', id: string, sentDate?: DateOnly | null | undefined, executionDate?: DateOnly | null | undefined, balanceInCents?: number | null | undefined, project: { __typename?: 'StandaloneProject', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Region', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Market', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Community', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Subdivision', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Lot', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Structure', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Unit', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> }, document?: { __typename?: 'Document', id: string, createdAt: DateTime, updatedAt: DateTime, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } } | null | undefined }, document?: { __typename?: 'Document', id: string, createdAt: DateTime, updatedAt: DateTime, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } } | null | undefined } };

export type DetailPane_DetailsTab_CommitmentFragment = { __typename?: 'Commitment', id: string, sentDate?: DateOnly | null | undefined, executionDate?: DateOnly | null | undefined, balanceInCents?: number | null | undefined, project: { __typename?: 'StandaloneProject', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Region', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Market', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Community', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Subdivision', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Lot', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Structure', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> } | { __typename?: 'Unit', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> }, document?: { __typename?: 'Document', id: string, createdAt: DateTime, updatedAt: DateTime, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } } | null | undefined };

export type PurchaseOrderDetailPane_DocumentFragment = { __typename?: 'Document', id: string, createdAt: DateTime, updatedAt: DateTime, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined } };

type PurchaseOrderDetailPane_Project_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> };

type PurchaseOrderDetailPane_Project_Region_Fragment = { __typename?: 'Region', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> };

type PurchaseOrderDetailPane_Project_Market_Fragment = { __typename?: 'Market', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> };

type PurchaseOrderDetailPane_Project_Community_Fragment = { __typename?: 'Community', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> };

type PurchaseOrderDetailPane_Project_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> };

type PurchaseOrderDetailPane_Project_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> };

type PurchaseOrderDetailPane_Project_Structure_Fragment = { __typename?: 'Structure', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> };

type PurchaseOrderDetailPane_Project_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', avatar: string, email: string, id: string, name: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: ProjectRole, name: string } }> };

export type PurchaseOrderDetailPane_ProjectFragment = PurchaseOrderDetailPane_Project_StandaloneProject_Fragment | PurchaseOrderDetailPane_Project_Region_Fragment | PurchaseOrderDetailPane_Project_Market_Fragment | PurchaseOrderDetailPane_Project_Community_Fragment | PurchaseOrderDetailPane_Project_Subdivision_Fragment | PurchaseOrderDetailPane_Project_Lot_Fragment | PurchaseOrderDetailPane_Project_Structure_Fragment | PurchaseOrderDetailPane_Project_Unit_Fragment;

export type PurchaseOrderDetailPane_InvoicesTabQueryVariables = Exact<{
  commitmentId: Scalars['ID'];
  changeOrderId: Scalars['ID'];
  skipCommitment: Scalars['Boolean'];
  skipChangeOrder: Scalars['Boolean'];
}>;


export type PurchaseOrderDetailPane_InvoicesTabQuery = { __typename?: 'Query', commitment?: { __typename?: 'Commitment', id: string, balanceInCents?: number | null | undefined, bills: Array<{ __typename?: 'Bill', id: string, billedInCents: number, paidDate?: DateOnly | null | undefined, tradePartnerNumber: string, status: { __typename?: 'BillStatusDetail', code: BillStatus }, type: { __typename?: 'BillTypeDetail', code: BillType } }> }, commitmentChangeOrder?: { __typename?: 'CommitmentChangeOrder', id: string, balanceInCents?: number | null | undefined, bills: Array<{ __typename?: 'Bill', id: string, billedInCents: number, paidDate?: DateOnly | null | undefined, tradePartnerNumber: string, status: { __typename?: 'BillStatusDetail', code: BillStatus }, type: { __typename?: 'BillTypeDetail', code: BillType } }> } };

export type PurchaseOrderDetailPane_BillFragment = { __typename?: 'Bill', id: string, billedInCents: number, paidDate?: DateOnly | null | undefined, tradePartnerNumber: string, status: { __typename?: 'BillStatusDetail', code: BillStatus }, type: { __typename?: 'BillTypeDetail', code: BillType } };

export type PurchaseOrderDetailPane_SpecsTabQueryVariables = Exact<{
  commitmentId: Scalars['ID'];
  changeOrderId: Scalars['ID'];
  skipCommitment: Scalars['Boolean'];
  skipChangeOrder: Scalars['Boolean'];
}>;


export type PurchaseOrderDetailPane_SpecsTabQuery = { __typename?: 'Query', commitment?: { __typename?: 'Commitment', id: string, balanceInCents?: number | null | undefined, contractExhibits?: string | null | undefined, contractExclusions?: string | null | undefined, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, task?: { __typename?: 'Task', startDate?: DateOnly | null | undefined, completedAt?: DateOnly | null | undefined, id: string, name: string } | null | undefined } }>, project: { __typename?: 'StandaloneProject', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Region', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Market', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Community', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Subdivision', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Lot', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Structure', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Unit', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } }, commitmentChangeOrder?: { __typename?: 'CommitmentChangeOrder', id: string, balanceInCents?: number | null | undefined, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, task?: { __typename?: 'Task', startDate?: DateOnly | null | undefined, completedAt?: DateOnly | null | undefined, id: string, name: string } | null | undefined } }>, commitment: { __typename?: 'Commitment', id: string, contractExhibits?: string | null | undefined, contractExclusions?: string | null | undefined, project: { __typename?: 'StandaloneProject', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Region', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Market', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Community', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Subdivision', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Lot', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Structure', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Unit', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } } } };

export type DetailPane_SpecsTab_CommitmentFragment = { __typename?: 'Commitment', id: string, balanceInCents?: number | null | undefined, contractExhibits?: string | null | undefined, contractExclusions?: string | null | undefined, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, task?: { __typename?: 'Task', startDate?: DateOnly | null | undefined, completedAt?: DateOnly | null | undefined, id: string, name: string } | null | undefined } }>, project: { __typename?: 'StandaloneProject', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Region', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Market', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Community', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Subdivision', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Lot', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Structure', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Unit', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } };

export type DetailPane_SpecsTab_ChangeOrderFragment = { __typename?: 'CommitmentChangeOrder', id: string, balanceInCents?: number | null | undefined, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, task?: { __typename?: 'Task', startDate?: DateOnly | null | undefined, completedAt?: DateOnly | null | undefined, id: string, name: string } | null | undefined } }>, commitment: { __typename?: 'Commitment', id: string, contractExhibits?: string | null | undefined, contractExclusions?: string | null | undefined, project: { __typename?: 'StandaloneProject', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Region', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Market', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Community', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Subdivision', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Lot', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Structure', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } | { __typename?: 'Unit', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined } | null | undefined } } };

export type PurchaseOrderDetailPane_ProjectReadyPlanConfigFragment = { __typename?: 'ProjectReadyPlanConfig', id: string, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string } | null | undefined };

export type PurchaseOrderDetailPane_ProjectReadyPlanConfigOptionFragment = { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } };

export const EnabledFeatureFlagFragmentDoc = gql`
    fragment EnabledFeatureFlag on FeatureFlag {
  id
  type {
    code
  }
}
    `;
export const ApprovalSubject_BillFragmentDoc = gql`
    fragment ApprovalSubject_Bill on Bill {
  id
  tradePartnerNumber
}
    `;
export const ApprovalSubjectFragmentDoc = gql`
    fragment ApprovalSubject on ApprovalSubject {
  __typename
  ...ApprovalSubject_Bill
}
    ${ApprovalSubject_BillFragmentDoc}`;
export const AssetDetailsFragmentDoc = gql`
    fragment AssetDetails on Asset {
  id
  version
  contentType
  downloadUrl
  attachmentUrl
  fileName
  createdAt
  previewUrl(resizing: {width: 250, height: 250, region: FULL})
}
    `;
export const CommentFragmentDoc = gql`
    fragment Comment on Comment {
  id
  author {
    id
    avatarUrl
    email
    name
  }
  text
  html
  createdAt
  updatedAt
  attachments {
    id
    asset {
      ...AssetDetails
    }
  }
  tags {
    id
  }
}
    ${AssetDetailsFragmentDoc}`;
export const CommentStreamDetailFragmentDoc = gql`
    fragment CommentStreamDetail on CommentStream {
  id
  streamVisibility {
    code
  }
  comments {
    ...Comment
  }
}
    ${CommentFragmentDoc}`;
export const CommentFeedFragmentDoc = gql`
    fragment CommentFeed on Commentable {
  id
  streams {
    ...CommentStreamDetail
  }
}
    ${CommentStreamDetailFragmentDoc}`;
export const NamedFragmentDoc = gql`
    fragment Named on Named {
  id
  name
}
    `;
export const User_TradePartnerFragmentDoc = gql`
    fragment User_TradePartner on TradePartner {
  ...Named
  leadTimeInDays
}
    ${NamedFragmentDoc}`;
export const User_TradePartnerUserFragmentDoc = gql`
    fragment User_TradePartnerUser on TradePartnerUser {
  ...Named
  tradePartner {
    ...User_TradePartner
  }
  tradePartnerContact {
    id
    markets {
      id
    }
  }
}
    ${NamedFragmentDoc}
${User_TradePartnerFragmentDoc}`;
export const UserDetailsFragmentDoc = gql`
    fragment UserDetails on User {
  id
  name
  email
  userType
  avatarUrl
  isBeingImpersonated
  tradePartnerUsers {
    ...User_TradePartnerUser
  }
}
    ${User_TradePartnerUserFragmentDoc}`;
export const UnitOfMeasureDetailsFragmentDoc = gql`
    fragment UnitOfMeasureDetails on UnitOfMeasure {
  ...Named
  useQuantity
  abbreviation
}
    ${NamedFragmentDoc}`;
export const InvoicePage_ItemTemplateItemsFragmentDoc = gql`
    fragment InvoicePage_ItemTemplateItems on BaseItemLike {
  ...Named
  displayName
  unitOfMeasure {
    ...UnitOfMeasureDetails
  }
  item {
    id
    fullCode
  }
}
    ${NamedFragmentDoc}
${UnitOfMeasureDetailsFragmentDoc}`;
export const InvoicePage_ProjectItemFragmentDoc = gql`
    fragment InvoicePage_ProjectItem on ProjectItem {
  ...Named
  displayName
  baseOrOptionName
  unitOfMeasure {
    ...UnitOfMeasureDetails
  }
  item {
    id
    fullCode
    costCode {
      id
      displayName
    }
  }
  itemTemplateItem {
    id
    ...InvoicePage_ItemTemplateItems
  }
}
    ${NamedFragmentDoc}
${UnitOfMeasureDetailsFragmentDoc}
${InvoicePage_ItemTemplateItemsFragmentDoc}`;
export const InvoicePage_TradeLineItemFragmentDoc = gql`
    fragment InvoicePage_TradeLineItem on BidContractTradeLineItem {
  id
  totalCostInCents
  productOffering {
    id
    displayName
  }
}
    `;
export const InvoicePage_BidContractLineItemFragmentDoc = gql`
    fragment InvoicePage_BidContractLineItem on BidContractLineItem {
  id
  tradeLineItem {
    ...InvoicePage_TradeLineItem
  }
}
    ${InvoicePage_TradeLineItemFragmentDoc}`;
export const InvoicePage_CommitmentLineItemsFragmentDoc = gql`
    fragment InvoicePage_CommitmentLineItems on CommitmentLineItem {
  id
  committedInCents
  newQuantity
  quantity
  newTaxableCostInCents
  costChangeInCents
  projectItem {
    ...InvoicePage_ProjectItem
  }
  primaryBidContractLineItem {
    ...InvoicePage_BidContractLineItem
  }
  owner {
    id
    accountingNumber
  }
}
    ${InvoicePage_ProjectItemFragmentDoc}
${InvoicePage_BidContractLineItemFragmentDoc}`;
export const InvoicePage_BillLineItemsFragmentDoc = gql`
    fragment InvoicePage_BillLineItems on BillLineItem {
  id
  taxInCents
  taxableAmountInCents
  amountInCents
  projectItem {
    ...InvoicePage_ProjectItem
  }
  commitmentLineItem {
    ...InvoicePage_CommitmentLineItems
  }
  scheduleTask {
    ...Named
    projectItems {
      ...Named
    }
  }
  bill {
    id
    isTradePartnerCredit
  }
  commitmentDraw {
    id
    task {
      id
      name
    }
  }
}
    ${InvoicePage_ProjectItemFragmentDoc}
${InvoicePage_CommitmentLineItemsFragmentDoc}
${NamedFragmentDoc}`;
export const CompanyInfoFieldFragmentDoc = gql`
    fragment CompanyInfoField on Project {
  id
  companyInfo {
    name
    email
    phoneNumber
  }
}
    `;
export const InvoicePage_ProjectFragmentDoc = gql`
    fragment InvoicePage_Project on Project {
  id
  name
  readyPlanConfig {
    id
    readyPlan {
      id
      displayName
      description
    }
  }
  enableProductConfigPlan
  ...CompanyInfoField
}
    ${CompanyInfoFieldFragmentDoc}`;
export const AddressDetailsFragmentDoc = gql`
    fragment AddressDetails on Address {
  id
  street1
  street2
  city
  state
  postalCode
  country
}
    `;
export const TradePartnerContactFragmentDoc = gql`
    fragment TradePartnerContact on TradePartnerContact {
  ...Named
  email
  officePhone
  mobilePhone
  tradePartner {
    ...Named
  }
  address {
    ...AddressDetails
  }
}
    ${NamedFragmentDoc}
${AddressDetailsFragmentDoc}`;
export const InvoicePage_ChangeOrderFragmentDoc = gql`
    fragment InvoicePage_ChangeOrder on CommitmentChangeOrder {
  id
  commitment {
    id
  }
}
    `;
export const DocumentDetailsFragmentDoc = gql`
    fragment DocumentDetails on Document {
  ...Named
  isDeleted
  asset {
    ...AssetDetails
  }
}
    ${NamedFragmentDoc}
${AssetDetailsFragmentDoc}`;
export const BillStatusAndTypeFragmentDoc = gql`
    fragment BillStatusAndType on Bill {
  id
  status {
    code
  }
  type {
    code
  }
}
    `;
export const ApproverDetailsFragmentDoc = gql`
    fragment ApproverDetails on Approver {
  id
  user {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const PandaDocDetailsFragmentDoc = gql`
    fragment PandaDocDetails on PandaDoc {
  ...Named
  externalPandaDocUrl
  externalPandaDocId
  status
  canCreatePandaDocSession {
    allowed
    disabledReasons {
      message
    }
  }
}
    ${NamedFragmentDoc}`;
export const InvoicePage_LienWaiversFragmentDoc = gql`
    fragment InvoicePage_LienWaivers on LienWaiver {
  id
  status {
    code
    name
  }
  condition {
    code
    name
  }
  pandaDoc {
    ...PandaDocDetails
  }
}
    ${PandaDocDetailsFragmentDoc}`;
export const InvoicePageFragmentDoc = gql`
    fragment InvoicePage on Bill {
  id
  sentDate
  tradePartnerNumber
  billedInCents
  lineItems {
    ...InvoicePage_BillLineItems
  }
  project {
    ...InvoicePage_Project
  }
  tradePartner {
    id
    contactsForProjectAndRoles(roles: [BILL_APPROVER], projectId: $projectId) {
      id
      name
      ...TradePartnerContact
    }
  }
  parents {
    id
    accountingNumber
    ... on CommitmentChangeOrder {
      ...InvoicePage_ChangeOrder
    }
  }
  documents {
    ...DocumentDetails
  }
  ...BillStatusAndType
  approval {
    id
    approvers {
      ...ApproverDetails
    }
  }
  isTradePartnerCredit
  referenceNumber
  lienWaivers {
    ...InvoicePage_LienWaivers
  }
}
    ${InvoicePage_BillLineItemsFragmentDoc}
${InvoicePage_ProjectFragmentDoc}
${TradePartnerContactFragmentDoc}
${InvoicePage_ChangeOrderFragmentDoc}
${DocumentDetailsFragmentDoc}
${BillStatusAndTypeFragmentDoc}
${ApproverDetailsFragmentDoc}
${InvoicePage_LienWaiversFragmentDoc}`;
export const InvoicePage_TradePartnerContactFragmentDoc = gql`
    fragment InvoicePage_TradePartnerContact on TradePartnerContact {
  ...TradePartnerContact
  tradePartner {
    ...Named
  }
}
    ${TradePartnerContactFragmentDoc}
${NamedFragmentDoc}`;
export const InvoicePage_TradePartnerUserFragmentDoc = gql`
    fragment InvoicePage_TradePartnerUser on TradePartnerUser {
  id
  tradePartnerContact {
    ...InvoicePage_TradePartnerContact
  }
}
    ${InvoicePage_TradePartnerContactFragmentDoc}`;
export const InvoicesPage_BillFragmentDoc = gql`
    fragment InvoicesPage_Bill on Bill {
  id
  billedInCents
  ...BillStatusAndType
  tradePartnerNumber
  parents {
    id
    accountingNumber
  }
  project {
    id
    name
    market {
      ...Named
    }
  }
  billDate
  paidDate
  dueDate
  billedInCents
  sentDate
  approvedAt
  isTradePartnerCredit
  referenceNumber
}
    ${BillStatusAndTypeFragmentDoc}
${NamedFragmentDoc}`;
export const PurchaseOrderPage_TradePartnerFragmentDoc = gql`
    fragment PurchaseOrderPage_TradePartner on TradePartner {
  id
  signatoryForProject(projectId: $projectId) {
    ...TradePartnerContact
  }
}
    ${TradePartnerContactFragmentDoc}`;
export const PurchaseOrderPage_ProjectFragmentDoc = gql`
    fragment PurchaseOrderPage_Project on Project {
  id
  name
  readyPlanConfig {
    id
    readyPlan {
      id
      displayName
      description
    }
    specOption {
      id
      readyPlanOption {
        id
      }
    }
  }
  enableProductConfigPlan
  ...CompanyInfoField
}
    ${CompanyInfoFieldFragmentDoc}`;
export const PurchaseOrderPage_ItemFragmentDoc = gql`
    fragment PurchaseOrderPage_Item on Item {
  id
  name
  fullCode
  costCode {
    id
    displayName
  }
}
    `;
export const PurchaseOrderPage_ReadyPlanOptionFragmentDoc = gql`
    fragment PurchaseOrderPage_ReadyPlanOption on ReadyPlanOption {
  id
  order
  displayName
  optionGroup {
    id
    order
    group {
      id
      type {
        id
        isElevation
      }
    }
  }
}
    `;
export const PurchaseOrderPage_ItemTemplateItemsFragmentDoc = gql`
    fragment PurchaseOrderPage_ItemTemplateItems on BaseItemLike {
  ...Named
  displayName
  quantity
  unitOfMeasure {
    ...UnitOfMeasureDetails
  }
  item {
    id
    fullCode
    costCode {
      id
      displayName
    }
  }
  unitCostInCents
  totalCostInCents
  location {
    id
    displayLocationPath
  }
  options {
    ...PurchaseOrderPage_ReadyPlanOption
  }
}
    ${NamedFragmentDoc}
${UnitOfMeasureDetailsFragmentDoc}
${PurchaseOrderPage_ReadyPlanOptionFragmentDoc}`;
export const PurchaseOrderPage_TradeLineItemFragmentDoc = gql`
    fragment PurchaseOrderPage_TradeLineItem on BidContractTradeLineItem {
  id
  productOffering {
    id
    displayName
  }
  totalCostInCents
  options {
    id
    displayName
  }
}
    `;
export const PurchaseOrderPage_BidContractLineItemFragmentDoc = gql`
    fragment PurchaseOrderPage_BidContractLineItem on BidContractLineItem {
  id
  totalCostInCents
  itemTemplateItem {
    id
    options {
      ...PurchaseOrderPage_ReadyPlanOption
    }
  }
  tradeLineItem {
    ...PurchaseOrderPage_TradeLineItem
  }
}
    ${PurchaseOrderPage_ReadyPlanOptionFragmentDoc}
${PurchaseOrderPage_TradeLineItemFragmentDoc}`;
export const PurchaseOrderPage_LineItemsFragmentDoc = gql`
    fragment PurchaseOrderPage_LineItems on CommitmentLineItem {
  id
  committedInCents
  quantity
  taxableCostInCents
  taxInCents
  costChangeInCents
  specifications
  bidItem {
    id
    displayName
  }
  projectItem {
    ...Named
    displayName
    baseOrOptionName
    unitOfMeasure {
      ...UnitOfMeasureDetails
    }
    unitCostInCents
    item {
      ...PurchaseOrderPage_Item
    }
    itemTemplateItem {
      id
      ...PurchaseOrderPage_ItemTemplateItems
    }
    costTypeDetail {
      code
      name
      tradePartnerName
    }
    location {
      id
      name
    }
    materialVariant {
      id
      modelNumber
    }
    configuredOptions {
      ...PurchaseOrderPage_ReadyPlanOption
    }
  }
  primaryBidContractLineItem {
    ...PurchaseOrderPage_BidContractLineItem
  }
  modifyingBidContractLineItems {
    ...PurchaseOrderPage_BidContractLineItem
  }
}
    ${NamedFragmentDoc}
${UnitOfMeasureDetailsFragmentDoc}
${PurchaseOrderPage_ItemFragmentDoc}
${PurchaseOrderPage_ItemTemplateItemsFragmentDoc}
${PurchaseOrderPage_ReadyPlanOptionFragmentDoc}
${PurchaseOrderPage_BidContractLineItemFragmentDoc}`;
export const PurchaseOrderPage_TaskFragmentDoc = gql`
    fragment PurchaseOrderPage_Task on Task {
  id
  name
}
    `;
export const PurchaseOrderPage_DrawFragmentDoc = gql`
    fragment PurchaseOrderPage_Draw on CommitmentDraw {
  id
  amountInBasisPoints
  description
  task {
    ...PurchaseOrderPage_Task
  }
}
    ${PurchaseOrderPage_TaskFragmentDoc}`;
export const PurchaseOrderPage_CommitmentFragmentDoc = gql`
    fragment PurchaseOrderPage_Commitment on Commitment {
  id
  status
  accountingNumber
  committedInCents
  balanceInCents
  remainingInCents
  sentDate
  executionDate
  depositInBasisPoints
  project {
    ...PurchaseOrderPage_Project
  }
  bills {
    id
    balanceInCents
  }
  lineItems {
    ...PurchaseOrderPage_LineItems
  }
  draws {
    ...PurchaseOrderPage_Draw
  }
  bidContractRevision {
    id
    bidContract {
      id
      type {
        code
      }
    }
  }
}
    ${PurchaseOrderPage_ProjectFragmentDoc}
${PurchaseOrderPage_LineItemsFragmentDoc}
${PurchaseOrderPage_DrawFragmentDoc}`;
export const PurchaseOrderPage_ChangeOrderFragmentDoc = gql`
    fragment PurchaseOrderPage_ChangeOrder on CommitmentChangeOrder {
  id
  status
  accountingNumber
  committedInCents
  balanceInCents
  remainingInCents
  sentDate
  executionDate
  commitment {
    id
    project {
      ...PurchaseOrderPage_Project
    }
    bills {
      id
      balanceInCents
    }
  }
  lineItems {
    ...PurchaseOrderPage_LineItems
  }
}
    ${PurchaseOrderPage_ProjectFragmentDoc}
${PurchaseOrderPage_LineItemsFragmentDoc}`;
export const PurchaseOrderPage_CommitmentLikeFragmentDoc = gql`
    fragment PurchaseOrderPage_CommitmentLike on CommitmentLike {
  id
  referenceNumber
  tradePartner {
    ...PurchaseOrderPage_TradePartner
  }
  document {
    ...DocumentDetails
  }
  pandaDoc {
    ...PandaDocDetails
  }
  ... on Commitment {
    ...PurchaseOrderPage_Commitment
  }
  ... on CommitmentChangeOrder {
    ...PurchaseOrderPage_ChangeOrder
  }
}
    ${PurchaseOrderPage_TradePartnerFragmentDoc}
${DocumentDetailsFragmentDoc}
${PandaDocDetailsFragmentDoc}
${PurchaseOrderPage_CommitmentFragmentDoc}
${PurchaseOrderPage_ChangeOrderFragmentDoc}`;
export const PurchaseOrdersPage_ProjectsFragmentDoc = gql`
    fragment PurchaseOrdersPage_Projects on Project {
  id
  name
  market {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const PurchaseOrdersPage_TradePartnerFragmentDoc = gql`
    fragment PurchaseOrdersPage_TradePartner on TradePartner {
  id
  activeTasksCount
  activeProjectsCount
  totalCommittedInCents
  totalBilledInCents
  totalPaidInCents
  commitmentCountThisWeek
  commitmentCountLastWeek
}
    `;
export const PurchaseOrdersPage_TradePartnerUserFragmentDoc = gql`
    fragment PurchaseOrdersPage_TradePartnerUser on TradePartnerUser {
  ...Named
  tradePartner {
    ...PurchaseOrdersPage_TradePartner
  }
  tradePartnerContact {
    id
    markets {
      id
    }
  }
}
    ${NamedFragmentDoc}
${PurchaseOrdersPage_TradePartnerFragmentDoc}`;
export const PurchaseOrdersPage_CurrentUserFragmentDoc = gql`
    fragment PurchaseOrdersPage_CurrentUser on User {
  id
  tradePartnerUsers {
    ...PurchaseOrdersPage_TradePartnerUser
  }
}
    ${PurchaseOrdersPage_TradePartnerUserFragmentDoc}`;
export const PurchaseOrdersPage_ProjectFragmentDoc = gql`
    fragment PurchaseOrdersPage_Project on Project {
  id
  name
  market {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const PurchaseOrdersPage_ChangeOrderFragmentDoc = gql`
    fragment PurchaseOrdersPage_ChangeOrder on CommitmentChangeOrder {
  id
  accountingNumber
  executionDate
  createdAt
  sentDate
  status
  committedInCents
  billedInCents
  unbilledInCents
  paidInCents
  balanceInCents
  referenceNumber
  bills {
    id
    balanceInCents
    status {
      code
    }
    paidDate
  }
  commitment {
    id
    project {
      ...PurchaseOrdersPage_Project
    }
  }
}
    ${PurchaseOrdersPage_ProjectFragmentDoc}`;
export const PurchaseOrdersPage_CommitmentFragmentDoc = gql`
    fragment PurchaseOrdersPage_Commitment on Commitment {
  id
  accountingNumber
  createdAt
  sentDate
  executionDate
  status
  committedInCents
  billedInCents
  unbilledInCents
  paidInCents
  balanceInCents
  referenceNumber
  project {
    ...PurchaseOrdersPage_Project
  }
  changeOrders {
    id
    ...PurchaseOrdersPage_ChangeOrder
  }
  bills {
    id
    balanceInCents
    status {
      code
    }
    paidDate
  }
}
    ${PurchaseOrdersPage_ProjectFragmentDoc}
${PurchaseOrdersPage_ChangeOrderFragmentDoc}`;
export const SchedulesPage_ProjectFragmentDoc = gql`
    fragment SchedulesPage_Project on Project {
  id
  shadowProjects {
    id
  }
  name
  featureFlags {
    id
    type {
      code
    }
    status {
      code
    }
  }
}
    `;
export const SchedulesPage_TradePartnerAvailabilityRequestFragmentDoc = gql`
    fragment SchedulesPage_TradePartnerAvailabilityRequest on TradePartnerAvailabilityRequest {
  id
  status {
    code
  }
  rescheduleDates
  canSave {
    disabledReasons {
      message
    }
  }
}
    `;
export const SchedulesPage_TaskFragmentDoc = gql`
    fragment SchedulesPage_Task on Task {
  name
  id
  status {
    code
    name
  }
  project {
    ...SchedulesPage_Project
  }
  interval {
    startDate
    endDate
  }
  tradePartnerStatus {
    code
    name
  }
  tradePartnerAvailabilityRequests {
    ...SchedulesPage_TradePartnerAvailabilityRequest
  }
  tradePartner {
    id
  }
}
    ${SchedulesPage_ProjectFragmentDoc}
${SchedulesPage_TradePartnerAvailabilityRequestFragmentDoc}`;
export const PotentialOperationDetailsFragmentDoc = gql`
    fragment PotentialOperationDetails on PotentialOperation2 {
  allowed
  disabledReasons {
    message
  }
}
    `;
export const ContactsTabTradePartnerContactFragmentDoc = gql`
    fragment ContactsTabTradePartnerContact on TradePartnerContact {
  ...Named
  title
  email
  officePhone
  mobilePhone
  canLoginToPortal
  maybeBillingSignatory
  markets {
    ...Named
  }
  tradePartnerUser {
    id
    user {
      id
      userCommunicationPreference {
        id
        tpAvailabilityRequestPreference
        commentPreference
      }
    }
  }
  address {
    id
    street1
    city
    state
    postalCode
    country
  }
  canDelete {
    allowed
  }
  canDeactivate {
    ...PotentialOperationDetails
  }
}
    ${NamedFragmentDoc}
${PotentialOperationDetailsFragmentDoc}`;
export const ContactsTabTradePartnerMarketRolesFragmentDoc = gql`
    fragment ContactsTabTradePartnerMarketRoles on TradePartnerMarketContact {
  id
  role {
    code
    name
  }
  contact {
    ...Named
  }
  market {
    ...Named
  }
  tradePartner {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const ContactsTabTradePartnerMarketFragmentDoc = gql`
    fragment ContactsTabTradePartnerMarket on Market {
  ...Named
}
    ${NamedFragmentDoc}`;
export const ContactsTabTradePartnerFragmentDoc = gql`
    fragment ContactsTabTradePartner on TradePartner {
  id
  contacts {
    ...ContactsTabTradePartnerContact
  }
  marketContacts {
    ...ContactsTabTradePartnerMarketRoles
  }
  markets {
    ...ContactsTabTradePartnerMarket
  }
}
    ${ContactsTabTradePartnerContactFragmentDoc}
${ContactsTabTradePartnerMarketRolesFragmentDoc}
${ContactsTabTradePartnerMarketFragmentDoc}`;
export const ProjectRoleDetailFragmentDoc = gql`
    fragment ProjectRoleDetail on ProjectRoleDetail {
  code
  name
}
    `;
export const ProjectTeamMemberFragmentDoc = gql`
    fragment ProjectTeamMember on ProjectTeamMember {
  user {
    ...Named
    avatar
    email
  }
  role {
    ...ProjectRoleDetail
  }
}
    ${NamedFragmentDoc}
${ProjectRoleDetailFragmentDoc}`;
export const InvoiceRequestChanges_CommentsFragmentDoc = gql`
    fragment InvoiceRequestChanges_Comments on Comment {
  id
  html
  text
  attachments {
    id
    asset {
      ...AssetDetails
    }
  }
}
    ${AssetDetailsFragmentDoc}`;
export const InvoiceRequestChanges_BillFragmentDoc = gql`
    fragment InvoiceRequestChanges_Bill on Bill {
  id
  tradePartnerNumber
  project {
    id
    teamMembers(includeUnassigned: false) {
      ...ProjectTeamMember
    }
  }
  parents {
    id
    accountingNumber
  }
  ...BillStatusAndType
  approval {
    id
    approvers {
      ...ApproverDetails
    }
    streams {
      id
      comments {
        ...InvoiceRequestChanges_Comments
      }
    }
  }
}
    ${ProjectTeamMemberFragmentDoc}
${BillStatusAndTypeFragmentDoc}
${ApproverDetailsFragmentDoc}
${InvoiceRequestChanges_CommentsFragmentDoc}`;
export const PlanBasedLineItemsTab_PlanBasedLineItemFragmentDoc = gql`
    fragment PlanBasedLineItemsTab_PlanBasedLineItem on PlanBasedBidContractLineItem {
  id
  totalCostInCents
  groupLine {
    id
    group {
      id
      displayName
    }
    options {
      id
      name
    }
  }
}
    `;
export const PlanBasedLineItemsTab_LineItemFragmentDoc = gql`
    fragment PlanBasedLineItemsTab_LineItem on CommitmentLineItem {
  id
  quantity
  taxableCostInCents
  primaryBidContractLineItem {
    id
    forCoveringTakeoffs
  }
  planBasedLineItem {
    ...PlanBasedLineItemsTab_PlanBasedLineItem
  }
  projectItem {
    id
    displayName
    item {
      id
      fullCode
    }
    location {
      id
      displayLocationPath
    }
    unitOfMeasure {
      id
      name
    }
    task {
      id
      name
    }
    materialVariant {
      id
      code
    }
    itemTemplateItem {
      id
      options {
        id
        name
      }
    }
  }
}
    ${PlanBasedLineItemsTab_PlanBasedLineItemFragmentDoc}`;
export const PlanBasedLineItemsTab_CommitmentFragmentDoc = gql`
    fragment PlanBasedLineItemsTab_Commitment on Commitment {
  id
  depositInBasisPoints
  draws {
    ...PurchaseOrderPage_Draw
  }
  project {
    id
  }
  lineItems {
    ...PlanBasedLineItemsTab_LineItem
  }
}
    ${PurchaseOrderPage_DrawFragmentDoc}
${PlanBasedLineItemsTab_LineItemFragmentDoc}`;
export const ProjectAddressFragmentDoc = gql`
    fragment ProjectAddress on Project {
  id
  name
}
    `;
export const PurchaseOrderDetailPane_ProjectFragmentDoc = gql`
    fragment PurchaseOrderDetailPane_Project on Project {
  id
  ...ProjectAddress
  teamMembers(includeUnassigned: false) {
    ...ProjectTeamMember
  }
}
    ${ProjectAddressFragmentDoc}
${ProjectTeamMemberFragmentDoc}`;
export const PurchaseOrderDetailPane_DocumentFragmentDoc = gql`
    fragment PurchaseOrderDetailPane_Document on Document {
  id
  createdAt
  updatedAt
  asset {
    ...AssetDetails
  }
}
    ${AssetDetailsFragmentDoc}`;
export const DetailPane_DetailsTab_CommitmentFragmentDoc = gql`
    fragment DetailPane_DetailsTab_Commitment on Commitment {
  id
  sentDate
  executionDate
  project {
    ...PurchaseOrderDetailPane_Project
  }
  balanceInCents
  document {
    ...PurchaseOrderDetailPane_Document
  }
}
    ${PurchaseOrderDetailPane_ProjectFragmentDoc}
${PurchaseOrderDetailPane_DocumentFragmentDoc}`;
export const PurchaseOrderDetailPane_BillFragmentDoc = gql`
    fragment PurchaseOrderDetailPane_Bill on Bill {
  id
  ...BillStatusAndType
  billedInCents
  paidDate
  tradePartnerNumber
}
    ${BillStatusAndTypeFragmentDoc}`;
export const PurchaseOrderDetailPane_ProjectReadyPlanConfigOptionFragmentDoc = gql`
    fragment PurchaseOrderDetailPane_ProjectReadyPlanConfigOption on ProjectReadyPlanConfigOption {
  id
  readyPlanOption {
    id
    displayName
    globalOption {
      id
      type {
        id
        name
      }
    }
  }
}
    `;
export const PurchaseOrderDetailPane_ProjectReadyPlanConfigFragmentDoc = gql`
    fragment PurchaseOrderDetailPane_ProjectReadyPlanConfig on ProjectReadyPlanConfig {
  id
  options {
    ...PurchaseOrderDetailPane_ProjectReadyPlanConfigOption
  }
  readyPlan {
    id
    displayName
  }
}
    ${PurchaseOrderDetailPane_ProjectReadyPlanConfigOptionFragmentDoc}`;
export const DetailPane_SpecsTab_CommitmentFragmentDoc = gql`
    fragment DetailPane_SpecsTab_Commitment on Commitment {
  id
  balanceInCents
  lineItems {
    id
    projectItem {
      id
      task {
        ...Named
        startDate
        completedAt
      }
    }
  }
  project {
    id
    readyPlanConfig {
      ...PurchaseOrderDetailPane_ProjectReadyPlanConfig
    }
  }
  contractExhibits
  contractExclusions
}
    ${NamedFragmentDoc}
${PurchaseOrderDetailPane_ProjectReadyPlanConfigFragmentDoc}`;
export const DetailPane_SpecsTab_ChangeOrderFragmentDoc = gql`
    fragment DetailPane_SpecsTab_ChangeOrder on CommitmentChangeOrder {
  id
  balanceInCents
  lineItems {
    id
    projectItem {
      id
      task {
        ...Named
        startDate
        completedAt
      }
    }
  }
  commitment {
    id
    project {
      id
      readyPlanConfig {
        ...PurchaseOrderDetailPane_ProjectReadyPlanConfig
      }
    }
    contractExhibits
    contractExclusions
  }
}
    ${NamedFragmentDoc}
${PurchaseOrderDetailPane_ProjectReadyPlanConfigFragmentDoc}`;
export const UserFeatureFlagsDocument = gql`
    query UserFeatureFlags {
  userFeatureFlags {
    ...EnabledFeatureFlag
  }
}
    ${EnabledFeatureFlagFragmentDoc}`;

/**
 * __useUserFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useUserFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserFeatureFlagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>(UserFeatureFlagsDocument, options);
      }
export function useUserFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>(UserFeatureFlagsDocument, options);
        }
export type UserFeatureFlagsQueryHookResult = ReturnType<typeof useUserFeatureFlagsQuery>;
export type UserFeatureFlagsLazyQueryHookResult = ReturnType<typeof useUserFeatureFlagsLazyQuery>;
export type UserFeatureFlagsQueryResult = Apollo.QueryResult<UserFeatureFlagsQuery, UserFeatureFlagsQueryVariables>;
export const CreateAssetUploadUrlDocument = gql`
    mutation CreateAssetUploadUrl($input: CreateAssetUploadUrlInput!) {
  createAssetUploadUrl(input: $input) {
    s3Key
    uploadUrl
    downloadUrl
    previewUrl
  }
}
    `;
export type CreateAssetUploadUrlMutationFn = Apollo.MutationFunction<CreateAssetUploadUrlMutation, CreateAssetUploadUrlMutationVariables>;

/**
 * __useCreateAssetUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateAssetUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetUploadUrlMutation, { data, loading, error }] = useCreateAssetUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssetUploadUrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAssetUploadUrlMutation, CreateAssetUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAssetUploadUrlMutation, CreateAssetUploadUrlMutationVariables>(CreateAssetUploadUrlDocument, options);
      }
export type CreateAssetUploadUrlMutationHookResult = ReturnType<typeof useCreateAssetUploadUrlMutation>;
export type CreateAssetUploadUrlMutationResult = Apollo.MutationResult<CreateAssetUploadUrlMutation>;
export type CreateAssetUploadUrlMutationOptions = Apollo.BaseMutationOptions<CreateAssetUploadUrlMutation, CreateAssetUploadUrlMutationVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const ApproveTradePartnerAvailabilityRequestDocument = gql`
    mutation ApproveTradePartnerAvailabilityRequest($confirmationToken: String!) {
  approveTradePartnerAvailabilityRequest(confirmationToken: $confirmationToken) {
    emptyResult
  }
}
    `;
export type ApproveTradePartnerAvailabilityRequestMutationFn = Apollo.MutationFunction<ApproveTradePartnerAvailabilityRequestMutation, ApproveTradePartnerAvailabilityRequestMutationVariables>;

/**
 * __useApproveTradePartnerAvailabilityRequestMutation__
 *
 * To run a mutation, you first call `useApproveTradePartnerAvailabilityRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveTradePartnerAvailabilityRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveTradePartnerAvailabilityRequestMutation, { data, loading, error }] = useApproveTradePartnerAvailabilityRequestMutation({
 *   variables: {
 *      confirmationToken: // value for 'confirmationToken'
 *   },
 * });
 */
export function useApproveTradePartnerAvailabilityRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApproveTradePartnerAvailabilityRequestMutation, ApproveTradePartnerAvailabilityRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApproveTradePartnerAvailabilityRequestMutation, ApproveTradePartnerAvailabilityRequestMutationVariables>(ApproveTradePartnerAvailabilityRequestDocument, options);
      }
export type ApproveTradePartnerAvailabilityRequestMutationHookResult = ReturnType<typeof useApproveTradePartnerAvailabilityRequestMutation>;
export type ApproveTradePartnerAvailabilityRequestMutationResult = Apollo.MutationResult<ApproveTradePartnerAvailabilityRequestMutation>;
export type ApproveTradePartnerAvailabilityRequestMutationOptions = Apollo.BaseMutationOptions<ApproveTradePartnerAvailabilityRequestMutation, ApproveTradePartnerAvailabilityRequestMutationVariables>;
export const InvoicePageDocument = gql`
    query InvoicePage($billId: ID!, $projectId: ID!) {
  bill(id: $billId) {
    ...InvoicePage
  }
}
    ${InvoicePageFragmentDoc}`;

/**
 * __useInvoicePageQuery__
 *
 * To run a query within a React component, call `useInvoicePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicePageQuery({
 *   variables: {
 *      billId: // value for 'billId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useInvoicePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InvoicePageQuery, InvoicePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvoicePageQuery, InvoicePageQueryVariables>(InvoicePageDocument, options);
      }
export function useInvoicePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvoicePageQuery, InvoicePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvoicePageQuery, InvoicePageQueryVariables>(InvoicePageDocument, options);
        }
export type InvoicePageQueryHookResult = ReturnType<typeof useInvoicePageQuery>;
export type InvoicePageLazyQueryHookResult = ReturnType<typeof useInvoicePageLazyQuery>;
export type InvoicePageQueryResult = Apollo.QueryResult<InvoicePageQuery, InvoicePageQueryVariables>;
export const PollLienWaiverDocument = gql`
    query PollLienWaiver($filter: LienWaiverFilter!) {
  lienWaivers(filter: $filter) {
    ...InvoicePage_LienWaivers
  }
}
    ${InvoicePage_LienWaiversFragmentDoc}`;

/**
 * __usePollLienWaiverQuery__
 *
 * To run a query within a React component, call `usePollLienWaiverQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollLienWaiverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollLienWaiverQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePollLienWaiverQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PollLienWaiverQuery, PollLienWaiverQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PollLienWaiverQuery, PollLienWaiverQueryVariables>(PollLienWaiverDocument, options);
      }
export function usePollLienWaiverLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PollLienWaiverQuery, PollLienWaiverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PollLienWaiverQuery, PollLienWaiverQueryVariables>(PollLienWaiverDocument, options);
        }
export type PollLienWaiverQueryHookResult = ReturnType<typeof usePollLienWaiverQuery>;
export type PollLienWaiverLazyQueryHookResult = ReturnType<typeof usePollLienWaiverLazyQuery>;
export type PollLienWaiverQueryResult = Apollo.QueryResult<PollLienWaiverQuery, PollLienWaiverQueryVariables>;
export const SaveInvoiceDocument = gql`
    mutation SaveInvoice($input: SaveBillInput!, $projectId: ID!) {
  saveBill(input: $input) {
    bill {
      ...InvoicePage
    }
  }
}
    ${InvoicePageFragmentDoc}`;
export type SaveInvoiceMutationFn = Apollo.MutationFunction<SaveInvoiceMutation, SaveInvoiceMutationVariables>;

/**
 * __useSaveInvoiceMutation__
 *
 * To run a mutation, you first call `useSaveInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInvoiceMutation, { data, loading, error }] = useSaveInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSaveInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveInvoiceMutation, SaveInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveInvoiceMutation, SaveInvoiceMutationVariables>(SaveInvoiceDocument, options);
      }
export type SaveInvoiceMutationHookResult = ReturnType<typeof useSaveInvoiceMutation>;
export type SaveInvoiceMutationResult = Apollo.MutationResult<SaveInvoiceMutation>;
export type SaveInvoiceMutationOptions = Apollo.BaseMutationOptions<SaveInvoiceMutation, SaveInvoiceMutationVariables>;
export const InvoicePage_SaveApproverDocument = gql`
    mutation InvoicePage_SaveApprover($input: SaveApproverInput!) {
  saveApprover(input: $input) {
    approver {
      id
      status {
        code
      }
      approval {
        ...Named
      }
    }
  }
}
    ${NamedFragmentDoc}`;
export type InvoicePage_SaveApproverMutationFn = Apollo.MutationFunction<InvoicePage_SaveApproverMutation, InvoicePage_SaveApproverMutationVariables>;

/**
 * __useInvoicePage_SaveApproverMutation__
 *
 * To run a mutation, you first call `useInvoicePage_SaveApproverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoicePage_SaveApproverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoicePageSaveApproverMutation, { data, loading, error }] = useInvoicePage_SaveApproverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoicePage_SaveApproverMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InvoicePage_SaveApproverMutation, InvoicePage_SaveApproverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InvoicePage_SaveApproverMutation, InvoicePage_SaveApproverMutationVariables>(InvoicePage_SaveApproverDocument, options);
      }
export type InvoicePage_SaveApproverMutationHookResult = ReturnType<typeof useInvoicePage_SaveApproverMutation>;
export type InvoicePage_SaveApproverMutationResult = Apollo.MutationResult<InvoicePage_SaveApproverMutation>;
export type InvoicePage_SaveApproverMutationOptions = Apollo.BaseMutationOptions<InvoicePage_SaveApproverMutation, InvoicePage_SaveApproverMutationVariables>;
export const InvoicesPageDocument = gql`
    query InvoicesPage($filter: BillFilter!) {
  bills(page: {limit: 100000}, filter: $filter) {
    ...InvoicesPage_Bill
  }
}
    ${InvoicesPage_BillFragmentDoc}`;

/**
 * __useInvoicesPageQuery__
 *
 * To run a query within a React component, call `useInvoicesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useInvoicesPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InvoicesPageQuery, InvoicesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvoicesPageQuery, InvoicesPageQueryVariables>(InvoicesPageDocument, options);
      }
export function useInvoicesPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvoicesPageQuery, InvoicesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvoicesPageQuery, InvoicesPageQueryVariables>(InvoicesPageDocument, options);
        }
export type InvoicesPageQueryHookResult = ReturnType<typeof useInvoicesPageQuery>;
export type InvoicesPageLazyQueryHookResult = ReturnType<typeof useInvoicesPageLazyQuery>;
export type InvoicesPageQueryResult = Apollo.QueryResult<InvoicesPageQuery, InvoicesPageQueryVariables>;
export const PurchaseOrderPageDocument = gql`
    query PurchaseOrderPage($commitmentId: ID!, $changeOrderId: ID!, $projectId: ID!, $skipCommitment: Boolean!, $skipChangeOrder: Boolean!) {
  commitment(id: $commitmentId) @skip(if: $skipCommitment) {
    ...PurchaseOrderPage_CommitmentLike
  }
  commitmentChangeOrder(id: $changeOrderId) @skip(if: $skipChangeOrder) {
    ...PurchaseOrderPage_CommitmentLike
  }
}
    ${PurchaseOrderPage_CommitmentLikeFragmentDoc}`;

/**
 * __usePurchaseOrderPageQuery__
 *
 * To run a query within a React component, call `usePurchaseOrderPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOrderPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseOrderPageQuery({
 *   variables: {
 *      commitmentId: // value for 'commitmentId'
 *      changeOrderId: // value for 'changeOrderId'
 *      projectId: // value for 'projectId'
 *      skipCommitment: // value for 'skipCommitment'
 *      skipChangeOrder: // value for 'skipChangeOrder'
 *   },
 * });
 */
export function usePurchaseOrderPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PurchaseOrderPageQuery, PurchaseOrderPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PurchaseOrderPageQuery, PurchaseOrderPageQueryVariables>(PurchaseOrderPageDocument, options);
      }
export function usePurchaseOrderPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PurchaseOrderPageQuery, PurchaseOrderPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PurchaseOrderPageQuery, PurchaseOrderPageQueryVariables>(PurchaseOrderPageDocument, options);
        }
export type PurchaseOrderPageQueryHookResult = ReturnType<typeof usePurchaseOrderPageQuery>;
export type PurchaseOrderPageLazyQueryHookResult = ReturnType<typeof usePurchaseOrderPageLazyQuery>;
export type PurchaseOrderPageQueryResult = Apollo.QueryResult<PurchaseOrderPageQuery, PurchaseOrderPageQueryVariables>;
export const CreatePandaDocSessionDocument = gql`
    mutation CreatePandaDocSession($input: CreatePandaDocSessionInput!) {
  createPandaDocSession(input: $input) {
    sessionId
  }
}
    `;
export type CreatePandaDocSessionMutationFn = Apollo.MutationFunction<CreatePandaDocSessionMutation, CreatePandaDocSessionMutationVariables>;

/**
 * __useCreatePandaDocSessionMutation__
 *
 * To run a mutation, you first call `useCreatePandaDocSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePandaDocSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPandaDocSessionMutation, { data, loading, error }] = useCreatePandaDocSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePandaDocSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePandaDocSessionMutation, CreatePandaDocSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePandaDocSessionMutation, CreatePandaDocSessionMutationVariables>(CreatePandaDocSessionDocument, options);
      }
export type CreatePandaDocSessionMutationHookResult = ReturnType<typeof useCreatePandaDocSessionMutation>;
export type CreatePandaDocSessionMutationResult = Apollo.MutationResult<CreatePandaDocSessionMutation>;
export type CreatePandaDocSessionMutationOptions = Apollo.BaseMutationOptions<CreatePandaDocSessionMutation, CreatePandaDocSessionMutationVariables>;
export const SaveCommitmentDocument = gql`
    mutation SaveCommitment($input: SaveCommitmentInput!, $projectId: ID!) {
  saveCommitment(input: $input) {
    commitment {
      ...PurchaseOrderPage_CommitmentLike
    }
  }
}
    ${PurchaseOrderPage_CommitmentLikeFragmentDoc}`;
export type SaveCommitmentMutationFn = Apollo.MutationFunction<SaveCommitmentMutation, SaveCommitmentMutationVariables>;

/**
 * __useSaveCommitmentMutation__
 *
 * To run a mutation, you first call `useSaveCommitmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCommitmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCommitmentMutation, { data, loading, error }] = useSaveCommitmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSaveCommitmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveCommitmentMutation, SaveCommitmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveCommitmentMutation, SaveCommitmentMutationVariables>(SaveCommitmentDocument, options);
      }
export type SaveCommitmentMutationHookResult = ReturnType<typeof useSaveCommitmentMutation>;
export type SaveCommitmentMutationResult = Apollo.MutationResult<SaveCommitmentMutation>;
export type SaveCommitmentMutationOptions = Apollo.BaseMutationOptions<SaveCommitmentMutation, SaveCommitmentMutationVariables>;
export const SaveCommitmentChangeOrderDocument = gql`
    mutation SaveCommitmentChangeOrder($input: SaveCommitmentChangeOrderInput!, $projectId: ID!) {
  saveCommitmentChangeOrder(input: $input) {
    commitmentChangeOrder {
      ...PurchaseOrderPage_CommitmentLike
    }
  }
}
    ${PurchaseOrderPage_CommitmentLikeFragmentDoc}`;
export type SaveCommitmentChangeOrderMutationFn = Apollo.MutationFunction<SaveCommitmentChangeOrderMutation, SaveCommitmentChangeOrderMutationVariables>;

/**
 * __useSaveCommitmentChangeOrderMutation__
 *
 * To run a mutation, you first call `useSaveCommitmentChangeOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCommitmentChangeOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCommitmentChangeOrderMutation, { data, loading, error }] = useSaveCommitmentChangeOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSaveCommitmentChangeOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveCommitmentChangeOrderMutation, SaveCommitmentChangeOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveCommitmentChangeOrderMutation, SaveCommitmentChangeOrderMutationVariables>(SaveCommitmentChangeOrderDocument, options);
      }
export type SaveCommitmentChangeOrderMutationHookResult = ReturnType<typeof useSaveCommitmentChangeOrderMutation>;
export type SaveCommitmentChangeOrderMutationResult = Apollo.MutationResult<SaveCommitmentChangeOrderMutation>;
export type SaveCommitmentChangeOrderMutationOptions = Apollo.BaseMutationOptions<SaveCommitmentChangeOrderMutation, SaveCommitmentChangeOrderMutationVariables>;
export const PurchaseOrdersPageDocument = gql`
    query PurchaseOrdersPage($filter: CommitmentsFilter, $order: CommitmentOrder, $page: PageFilter) {
  commitmentsPage(filter: $filter, orderBy: $order, page: $page) {
    commitments {
      ...PurchaseOrdersPage_Commitment
    }
    pageInfo {
      totalCount
      hasNextPage
    }
  }
  currentUser {
    ...PurchaseOrdersPage_CurrentUser
  }
  projects {
    ...PurchaseOrdersPage_Projects
  }
}
    ${PurchaseOrdersPage_CommitmentFragmentDoc}
${PurchaseOrdersPage_CurrentUserFragmentDoc}
${PurchaseOrdersPage_ProjectsFragmentDoc}`;

/**
 * __usePurchaseOrdersPageQuery__
 *
 * To run a query within a React component, call `usePurchaseOrdersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOrdersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseOrdersPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePurchaseOrdersPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PurchaseOrdersPageQuery, PurchaseOrdersPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PurchaseOrdersPageQuery, PurchaseOrdersPageQueryVariables>(PurchaseOrdersPageDocument, options);
      }
export function usePurchaseOrdersPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PurchaseOrdersPageQuery, PurchaseOrdersPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PurchaseOrdersPageQuery, PurchaseOrdersPageQueryVariables>(PurchaseOrdersPageDocument, options);
        }
export type PurchaseOrdersPageQueryHookResult = ReturnType<typeof usePurchaseOrdersPageQuery>;
export type PurchaseOrdersPageLazyQueryHookResult = ReturnType<typeof usePurchaseOrdersPageLazyQuery>;
export type PurchaseOrdersPageQueryResult = Apollo.QueryResult<PurchaseOrdersPageQuery, PurchaseOrdersPageQueryVariables>;
export const UpdateTradePartnerAvailabilityRequestStatusDocument = gql`
    mutation UpdateTradePartnerAvailabilityRequestStatus($input: UpdateTradePartnerAvailabilityRequestStatusInput!) {
  updateTradePartnerAvailabilityRequestStatus(input: $input) {
    emptyResult
  }
}
    `;
export type UpdateTradePartnerAvailabilityRequestStatusMutationFn = Apollo.MutationFunction<UpdateTradePartnerAvailabilityRequestStatusMutation, UpdateTradePartnerAvailabilityRequestStatusMutationVariables>;

/**
 * __useUpdateTradePartnerAvailabilityRequestStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTradePartnerAvailabilityRequestStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTradePartnerAvailabilityRequestStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTradePartnerAvailabilityRequestStatusMutation, { data, loading, error }] = useUpdateTradePartnerAvailabilityRequestStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTradePartnerAvailabilityRequestStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTradePartnerAvailabilityRequestStatusMutation, UpdateTradePartnerAvailabilityRequestStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTradePartnerAvailabilityRequestStatusMutation, UpdateTradePartnerAvailabilityRequestStatusMutationVariables>(UpdateTradePartnerAvailabilityRequestStatusDocument, options);
      }
export type UpdateTradePartnerAvailabilityRequestStatusMutationHookResult = ReturnType<typeof useUpdateTradePartnerAvailabilityRequestStatusMutation>;
export type UpdateTradePartnerAvailabilityRequestStatusMutationResult = Apollo.MutationResult<UpdateTradePartnerAvailabilityRequestStatusMutation>;
export type UpdateTradePartnerAvailabilityRequestStatusMutationOptions = Apollo.BaseMutationOptions<UpdateTradePartnerAvailabilityRequestStatusMutation, UpdateTradePartnerAvailabilityRequestStatusMutationVariables>;
export const SaveTradePartnerAvailabilityRequestDocument = gql`
    mutation SaveTradePartnerAvailabilityRequest($input: SaveTradePartnerAvailabilityRequestInput!) {
  saveTradePartnerAvailabilityRequest(input: $input) {
    tradePartnerAvailabilityRequest {
      id
    }
  }
}
    `;
export type SaveTradePartnerAvailabilityRequestMutationFn = Apollo.MutationFunction<SaveTradePartnerAvailabilityRequestMutation, SaveTradePartnerAvailabilityRequestMutationVariables>;

/**
 * __useSaveTradePartnerAvailabilityRequestMutation__
 *
 * To run a mutation, you first call `useSaveTradePartnerAvailabilityRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTradePartnerAvailabilityRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTradePartnerAvailabilityRequestMutation, { data, loading, error }] = useSaveTradePartnerAvailabilityRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTradePartnerAvailabilityRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveTradePartnerAvailabilityRequestMutation, SaveTradePartnerAvailabilityRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveTradePartnerAvailabilityRequestMutation, SaveTradePartnerAvailabilityRequestMutationVariables>(SaveTradePartnerAvailabilityRequestDocument, options);
      }
export type SaveTradePartnerAvailabilityRequestMutationHookResult = ReturnType<typeof useSaveTradePartnerAvailabilityRequestMutation>;
export type SaveTradePartnerAvailabilityRequestMutationResult = Apollo.MutationResult<SaveTradePartnerAvailabilityRequestMutation>;
export type SaveTradePartnerAvailabilityRequestMutationOptions = Apollo.BaseMutationOptions<SaveTradePartnerAvailabilityRequestMutation, SaveTradePartnerAvailabilityRequestMutationVariables>;
export const SchedulesPageDocument = gql`
    query SchedulesPage($market: [ID!], $tradePartner: [ID!], $tradePartnerStatus: [TradePartnerTaskStatus!], $projectStatus: [ProjectStatus!]) {
  tasks(
    first: 1000
    filter: {market: $market, tradePartner: $tradePartner, tradePartnerStatus: $tradePartnerStatus, projectStatus: $projectStatus}
  ) {
    ...SchedulesPage_Task
  }
}
    ${SchedulesPage_TaskFragmentDoc}`;

/**
 * __useSchedulesPageQuery__
 *
 * To run a query within a React component, call `useSchedulesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchedulesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulesPageQuery({
 *   variables: {
 *      market: // value for 'market'
 *      tradePartner: // value for 'tradePartner'
 *      tradePartnerStatus: // value for 'tradePartnerStatus'
 *      projectStatus: // value for 'projectStatus'
 *   },
 * });
 */
export function useSchedulesPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SchedulesPageQuery, SchedulesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SchedulesPageQuery, SchedulesPageQueryVariables>(SchedulesPageDocument, options);
      }
export function useSchedulesPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SchedulesPageQuery, SchedulesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SchedulesPageQuery, SchedulesPageQueryVariables>(SchedulesPageDocument, options);
        }
export type SchedulesPageQueryHookResult = ReturnType<typeof useSchedulesPageQuery>;
export type SchedulesPageLazyQueryHookResult = ReturnType<typeof useSchedulesPageLazyQuery>;
export type SchedulesPageQueryResult = Apollo.QueryResult<SchedulesPageQuery, SchedulesPageQueryVariables>;
export const TradePartnerContactsRolesPanelMetadataDocument = gql`
    query TradePartnerContactsRolesPanelMetadata {
  tradePartnerMarketRoles {
    code
    name
    sortOrder
  }
}
    `;

/**
 * __useTradePartnerContactsRolesPanelMetadataQuery__
 *
 * To run a query within a React component, call `useTradePartnerContactsRolesPanelMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradePartnerContactsRolesPanelMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradePartnerContactsRolesPanelMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useTradePartnerContactsRolesPanelMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TradePartnerContactsRolesPanelMetadataQuery, TradePartnerContactsRolesPanelMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradePartnerContactsRolesPanelMetadataQuery, TradePartnerContactsRolesPanelMetadataQueryVariables>(TradePartnerContactsRolesPanelMetadataDocument, options);
      }
export function useTradePartnerContactsRolesPanelMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradePartnerContactsRolesPanelMetadataQuery, TradePartnerContactsRolesPanelMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradePartnerContactsRolesPanelMetadataQuery, TradePartnerContactsRolesPanelMetadataQueryVariables>(TradePartnerContactsRolesPanelMetadataDocument, options);
        }
export type TradePartnerContactsRolesPanelMetadataQueryHookResult = ReturnType<typeof useTradePartnerContactsRolesPanelMetadataQuery>;
export type TradePartnerContactsRolesPanelMetadataLazyQueryHookResult = ReturnType<typeof useTradePartnerContactsRolesPanelMetadataLazyQuery>;
export type TradePartnerContactsRolesPanelMetadataQueryResult = Apollo.QueryResult<TradePartnerContactsRolesPanelMetadataQuery, TradePartnerContactsRolesPanelMetadataQueryVariables>;
export const TradePartnerContactsDocument = gql`
    query TradePartnerContacts($tradePartnerId: ID!) {
  tradePartner(id: $tradePartnerId) {
    ...ContactsTabTradePartner
  }
  markets {
    ...Named
  }
}
    ${ContactsTabTradePartnerFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useTradePartnerContactsQuery__
 *
 * To run a query within a React component, call `useTradePartnerContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradePartnerContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradePartnerContactsQuery({
 *   variables: {
 *      tradePartnerId: // value for 'tradePartnerId'
 *   },
 * });
 */
export function useTradePartnerContactsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradePartnerContactsQuery, TradePartnerContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradePartnerContactsQuery, TradePartnerContactsQueryVariables>(TradePartnerContactsDocument, options);
      }
export function useTradePartnerContactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradePartnerContactsQuery, TradePartnerContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradePartnerContactsQuery, TradePartnerContactsQueryVariables>(TradePartnerContactsDocument, options);
        }
export type TradePartnerContactsQueryHookResult = ReturnType<typeof useTradePartnerContactsQuery>;
export type TradePartnerContactsLazyQueryHookResult = ReturnType<typeof useTradePartnerContactsLazyQuery>;
export type TradePartnerContactsQueryResult = Apollo.QueryResult<TradePartnerContactsQuery, TradePartnerContactsQueryVariables>;
export const SaveTradePartnerContactDocument = gql`
    mutation SaveTradePartnerContact($input: SaveTradePartnerContactInput!) {
  saveTradePartnerContact(input: $input) {
    tradePartnerContact {
      id
      tradePartner {
        id
        contacts {
          ...ContactsTabTradePartnerContact
        }
      }
    }
  }
}
    ${ContactsTabTradePartnerContactFragmentDoc}`;
export type SaveTradePartnerContactMutationFn = Apollo.MutationFunction<SaveTradePartnerContactMutation, SaveTradePartnerContactMutationVariables>;

/**
 * __useSaveTradePartnerContactMutation__
 *
 * To run a mutation, you first call `useSaveTradePartnerContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTradePartnerContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTradePartnerContactMutation, { data, loading, error }] = useSaveTradePartnerContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTradePartnerContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveTradePartnerContactMutation, SaveTradePartnerContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveTradePartnerContactMutation, SaveTradePartnerContactMutationVariables>(SaveTradePartnerContactDocument, options);
      }
export type SaveTradePartnerContactMutationHookResult = ReturnType<typeof useSaveTradePartnerContactMutation>;
export type SaveTradePartnerContactMutationResult = Apollo.MutationResult<SaveTradePartnerContactMutation>;
export type SaveTradePartnerContactMutationOptions = Apollo.BaseMutationOptions<SaveTradePartnerContactMutation, SaveTradePartnerContactMutationVariables>;
export const SaveTradePartnerMarketContactDocument = gql`
    mutation SaveTradePartnerMarketContact($input: SaveTradePartnerMarketContactInput!) {
  saveTradePartnerMarketContact(input: $input) {
    tradePartnerMarketContact {
      id
      tradePartner {
        id
        marketContacts {
          ...ContactsTabTradePartnerMarketRoles
        }
      }
    }
  }
}
    ${ContactsTabTradePartnerMarketRolesFragmentDoc}`;
export type SaveTradePartnerMarketContactMutationFn = Apollo.MutationFunction<SaveTradePartnerMarketContactMutation, SaveTradePartnerMarketContactMutationVariables>;

/**
 * __useSaveTradePartnerMarketContactMutation__
 *
 * To run a mutation, you first call `useSaveTradePartnerMarketContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTradePartnerMarketContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTradePartnerMarketContactMutation, { data, loading, error }] = useSaveTradePartnerMarketContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTradePartnerMarketContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveTradePartnerMarketContactMutation, SaveTradePartnerMarketContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveTradePartnerMarketContactMutation, SaveTradePartnerMarketContactMutationVariables>(SaveTradePartnerMarketContactDocument, options);
      }
export type SaveTradePartnerMarketContactMutationHookResult = ReturnType<typeof useSaveTradePartnerMarketContactMutation>;
export type SaveTradePartnerMarketContactMutationResult = Apollo.MutationResult<SaveTradePartnerMarketContactMutation>;
export type SaveTradePartnerMarketContactMutationOptions = Apollo.BaseMutationOptions<SaveTradePartnerMarketContactMutation, SaveTradePartnerMarketContactMutationVariables>;
export const SaveUserCommunicationPreferenceDocument = gql`
    mutation SaveUserCommunicationPreference($input: SaveUserCommunicationPreferenceInput!) {
  saveUserCommunicationPreference(input: $input) {
    userCommunicationPreference {
      id
      tpAvailabilityRequestPreference
      commentPreference
    }
  }
}
    `;
export type SaveUserCommunicationPreferenceMutationFn = Apollo.MutationFunction<SaveUserCommunicationPreferenceMutation, SaveUserCommunicationPreferenceMutationVariables>;

/**
 * __useSaveUserCommunicationPreferenceMutation__
 *
 * To run a mutation, you first call `useSaveUserCommunicationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserCommunicationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserCommunicationPreferenceMutation, { data, loading, error }] = useSaveUserCommunicationPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveUserCommunicationPreferenceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveUserCommunicationPreferenceMutation, SaveUserCommunicationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveUserCommunicationPreferenceMutation, SaveUserCommunicationPreferenceMutationVariables>(SaveUserCommunicationPreferenceDocument, options);
      }
export type SaveUserCommunicationPreferenceMutationHookResult = ReturnType<typeof useSaveUserCommunicationPreferenceMutation>;
export type SaveUserCommunicationPreferenceMutationResult = Apollo.MutationResult<SaveUserCommunicationPreferenceMutation>;
export type SaveUserCommunicationPreferenceMutationOptions = Apollo.BaseMutationOptions<SaveUserCommunicationPreferenceMutation, SaveUserCommunicationPreferenceMutationVariables>;
export const DeleteTradePartnerContactDocument = gql`
    mutation DeleteTradePartnerContact($input: DeleteTradePartnerContactInput!) {
  deleteTradePartnerContact(input: $input) {
    tradePartner {
      id
      contacts {
        id
      }
    }
    tradePartnerContact {
      ...ContactsTabTradePartnerContact
    }
  }
}
    ${ContactsTabTradePartnerContactFragmentDoc}`;
export type DeleteTradePartnerContactMutationFn = Apollo.MutationFunction<DeleteTradePartnerContactMutation, DeleteTradePartnerContactMutationVariables>;

/**
 * __useDeleteTradePartnerContactMutation__
 *
 * To run a mutation, you first call `useDeleteTradePartnerContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTradePartnerContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTradePartnerContactMutation, { data, loading, error }] = useDeleteTradePartnerContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTradePartnerContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTradePartnerContactMutation, DeleteTradePartnerContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTradePartnerContactMutation, DeleteTradePartnerContactMutationVariables>(DeleteTradePartnerContactDocument, options);
      }
export type DeleteTradePartnerContactMutationHookResult = ReturnType<typeof useDeleteTradePartnerContactMutation>;
export type DeleteTradePartnerContactMutationResult = Apollo.MutationResult<DeleteTradePartnerContactMutation>;
export type DeleteTradePartnerContactMutationOptions = Apollo.BaseMutationOptions<DeleteTradePartnerContactMutation, DeleteTradePartnerContactMutationVariables>;
export const ImpersonateTradeUserModalDocument = gql`
    query ImpersonateTradeUserModal {
  tradePartners {
    ...Named
    users {
      ...Named
      tradePartner {
        id
      }
      tradePartnerContact {
        ...Named
        isActive
      }
    }
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useImpersonateTradeUserModalQuery__
 *
 * To run a query within a React component, call `useImpersonateTradeUserModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpersonateTradeUserModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpersonateTradeUserModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useImpersonateTradeUserModalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ImpersonateTradeUserModalQuery, ImpersonateTradeUserModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ImpersonateTradeUserModalQuery, ImpersonateTradeUserModalQueryVariables>(ImpersonateTradeUserModalDocument, options);
      }
export function useImpersonateTradeUserModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ImpersonateTradeUserModalQuery, ImpersonateTradeUserModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ImpersonateTradeUserModalQuery, ImpersonateTradeUserModalQueryVariables>(ImpersonateTradeUserModalDocument, options);
        }
export type ImpersonateTradeUserModalQueryHookResult = ReturnType<typeof useImpersonateTradeUserModalQuery>;
export type ImpersonateTradeUserModalLazyQueryHookResult = ReturnType<typeof useImpersonateTradeUserModalLazyQuery>;
export type ImpersonateTradeUserModalQueryResult = Apollo.QueryResult<ImpersonateTradeUserModalQuery, ImpersonateTradeUserModalQueryVariables>;
export const ImpersonateTradeUserModal_SaveInternalUserDocument = gql`
    mutation ImpersonateTradeUserModal_SaveInternalUser($input: SaveInternalUserInput!) {
  saveInternalUser(input: $input) {
    internalUser {
      ...Named
    }
  }
}
    ${NamedFragmentDoc}`;
export type ImpersonateTradeUserModal_SaveInternalUserMutationFn = Apollo.MutationFunction<ImpersonateTradeUserModal_SaveInternalUserMutation, ImpersonateTradeUserModal_SaveInternalUserMutationVariables>;

/**
 * __useImpersonateTradeUserModal_SaveInternalUserMutation__
 *
 * To run a mutation, you first call `useImpersonateTradeUserModal_SaveInternalUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImpersonateTradeUserModal_SaveInternalUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [impersonateTradeUserModalSaveInternalUserMutation, { data, loading, error }] = useImpersonateTradeUserModal_SaveInternalUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImpersonateTradeUserModal_SaveInternalUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ImpersonateTradeUserModal_SaveInternalUserMutation, ImpersonateTradeUserModal_SaveInternalUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ImpersonateTradeUserModal_SaveInternalUserMutation, ImpersonateTradeUserModal_SaveInternalUserMutationVariables>(ImpersonateTradeUserModal_SaveInternalUserDocument, options);
      }
export type ImpersonateTradeUserModal_SaveInternalUserMutationHookResult = ReturnType<typeof useImpersonateTradeUserModal_SaveInternalUserMutation>;
export type ImpersonateTradeUserModal_SaveInternalUserMutationResult = Apollo.MutationResult<ImpersonateTradeUserModal_SaveInternalUserMutation>;
export type ImpersonateTradeUserModal_SaveInternalUserMutationOptions = Apollo.BaseMutationOptions<ImpersonateTradeUserModal_SaveInternalUserMutation, ImpersonateTradeUserModal_SaveInternalUserMutationVariables>;
export const InvoiceRequestChangesDocument = gql`
    query InvoiceRequestChanges($billId: ID!) {
  bill(id: $billId) {
    ...InvoiceRequestChanges_Bill
  }
}
    ${InvoiceRequestChanges_BillFragmentDoc}`;

/**
 * __useInvoiceRequestChangesQuery__
 *
 * To run a query within a React component, call `useInvoiceRequestChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceRequestChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceRequestChangesQuery({
 *   variables: {
 *      billId: // value for 'billId'
 *   },
 * });
 */
export function useInvoiceRequestChangesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InvoiceRequestChangesQuery, InvoiceRequestChangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvoiceRequestChangesQuery, InvoiceRequestChangesQueryVariables>(InvoiceRequestChangesDocument, options);
      }
export function useInvoiceRequestChangesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvoiceRequestChangesQuery, InvoiceRequestChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvoiceRequestChangesQuery, InvoiceRequestChangesQueryVariables>(InvoiceRequestChangesDocument, options);
        }
export type InvoiceRequestChangesQueryHookResult = ReturnType<typeof useInvoiceRequestChangesQuery>;
export type InvoiceRequestChangesLazyQueryHookResult = ReturnType<typeof useInvoiceRequestChangesLazyQuery>;
export type InvoiceRequestChangesQueryResult = Apollo.QueryResult<InvoiceRequestChangesQuery, InvoiceRequestChangesQueryVariables>;
export const InvoiceRequestChangesPane_SaveApproverDocument = gql`
    mutation InvoiceRequestChangesPane_SaveApprover($input: SaveApproverInput!) {
  saveApprover(input: $input) {
    approver {
      id
      status {
        code
      }
      approval {
        ...Named
      }
    }
  }
}
    ${NamedFragmentDoc}`;
export type InvoiceRequestChangesPane_SaveApproverMutationFn = Apollo.MutationFunction<InvoiceRequestChangesPane_SaveApproverMutation, InvoiceRequestChangesPane_SaveApproverMutationVariables>;

/**
 * __useInvoiceRequestChangesPane_SaveApproverMutation__
 *
 * To run a mutation, you first call `useInvoiceRequestChangesPane_SaveApproverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceRequestChangesPane_SaveApproverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceRequestChangesPaneSaveApproverMutation, { data, loading, error }] = useInvoiceRequestChangesPane_SaveApproverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceRequestChangesPane_SaveApproverMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InvoiceRequestChangesPane_SaveApproverMutation, InvoiceRequestChangesPane_SaveApproverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InvoiceRequestChangesPane_SaveApproverMutation, InvoiceRequestChangesPane_SaveApproverMutationVariables>(InvoiceRequestChangesPane_SaveApproverDocument, options);
      }
export type InvoiceRequestChangesPane_SaveApproverMutationHookResult = ReturnType<typeof useInvoiceRequestChangesPane_SaveApproverMutation>;
export type InvoiceRequestChangesPane_SaveApproverMutationResult = Apollo.MutationResult<InvoiceRequestChangesPane_SaveApproverMutation>;
export type InvoiceRequestChangesPane_SaveApproverMutationOptions = Apollo.BaseMutationOptions<InvoiceRequestChangesPane_SaveApproverMutation, InvoiceRequestChangesPane_SaveApproverMutationVariables>;
export const InvoiceRequestChangesPane_SaveCommentDocument = gql`
    mutation InvoiceRequestChangesPane_SaveComment($input: SaveCommentInput!) {
  saveComment(input: $input) {
    comment {
      id
      stream {
        id
        commentable {
          ...CommentFeed
        }
      }
    }
  }
}
    ${CommentFeedFragmentDoc}`;
export type InvoiceRequestChangesPane_SaveCommentMutationFn = Apollo.MutationFunction<InvoiceRequestChangesPane_SaveCommentMutation, InvoiceRequestChangesPane_SaveCommentMutationVariables>;

/**
 * __useInvoiceRequestChangesPane_SaveCommentMutation__
 *
 * To run a mutation, you first call `useInvoiceRequestChangesPane_SaveCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceRequestChangesPane_SaveCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceRequestChangesPaneSaveCommentMutation, { data, loading, error }] = useInvoiceRequestChangesPane_SaveCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceRequestChangesPane_SaveCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InvoiceRequestChangesPane_SaveCommentMutation, InvoiceRequestChangesPane_SaveCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InvoiceRequestChangesPane_SaveCommentMutation, InvoiceRequestChangesPane_SaveCommentMutationVariables>(InvoiceRequestChangesPane_SaveCommentDocument, options);
      }
export type InvoiceRequestChangesPane_SaveCommentMutationHookResult = ReturnType<typeof useInvoiceRequestChangesPane_SaveCommentMutation>;
export type InvoiceRequestChangesPane_SaveCommentMutationResult = Apollo.MutationResult<InvoiceRequestChangesPane_SaveCommentMutation>;
export type InvoiceRequestChangesPane_SaveCommentMutationOptions = Apollo.BaseMutationOptions<InvoiceRequestChangesPane_SaveCommentMutation, InvoiceRequestChangesPane_SaveCommentMutationVariables>;
export const PlanBasedLineItemsTabDocument = gql`
    query PlanBasedLineItemsTab($commitmentId: ID!) {
  commitment(id: $commitmentId) {
    ...PlanBasedLineItemsTab_Commitment
  }
}
    ${PlanBasedLineItemsTab_CommitmentFragmentDoc}`;

/**
 * __usePlanBasedLineItemsTabQuery__
 *
 * To run a query within a React component, call `usePlanBasedLineItemsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanBasedLineItemsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanBasedLineItemsTabQuery({
 *   variables: {
 *      commitmentId: // value for 'commitmentId'
 *   },
 * });
 */
export function usePlanBasedLineItemsTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanBasedLineItemsTabQuery, PlanBasedLineItemsTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanBasedLineItemsTabQuery, PlanBasedLineItemsTabQueryVariables>(PlanBasedLineItemsTabDocument, options);
      }
export function usePlanBasedLineItemsTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanBasedLineItemsTabQuery, PlanBasedLineItemsTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanBasedLineItemsTabQuery, PlanBasedLineItemsTabQueryVariables>(PlanBasedLineItemsTabDocument, options);
        }
export type PlanBasedLineItemsTabQueryHookResult = ReturnType<typeof usePlanBasedLineItemsTabQuery>;
export type PlanBasedLineItemsTabLazyQueryHookResult = ReturnType<typeof usePlanBasedLineItemsTabLazyQuery>;
export type PlanBasedLineItemsTabQueryResult = Apollo.QueryResult<PlanBasedLineItemsTabQuery, PlanBasedLineItemsTabQueryVariables>;
export const PurchaseOrderDetailPane_DetailsTabDocument = gql`
    query PurchaseOrderDetailPane_DetailsTab($commitmentId: ID!, $changeOrderId: ID!, $skipCommitment: Boolean!, $skipChangeOrder: Boolean!) {
  commitment(id: $commitmentId) @skip(if: $skipCommitment) {
    ...DetailPane_DetailsTab_Commitment
  }
  commitmentChangeOrder(id: $changeOrderId) @skip(if: $skipChangeOrder) {
    id
    sentDate
    executionDate
    commitment {
      ...DetailPane_DetailsTab_Commitment
    }
    document {
      ...PurchaseOrderDetailPane_Document
    }
  }
}
    ${DetailPane_DetailsTab_CommitmentFragmentDoc}
${PurchaseOrderDetailPane_DocumentFragmentDoc}`;

/**
 * __usePurchaseOrderDetailPane_DetailsTabQuery__
 *
 * To run a query within a React component, call `usePurchaseOrderDetailPane_DetailsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOrderDetailPane_DetailsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseOrderDetailPane_DetailsTabQuery({
 *   variables: {
 *      commitmentId: // value for 'commitmentId'
 *      changeOrderId: // value for 'changeOrderId'
 *      skipCommitment: // value for 'skipCommitment'
 *      skipChangeOrder: // value for 'skipChangeOrder'
 *   },
 * });
 */
export function usePurchaseOrderDetailPane_DetailsTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PurchaseOrderDetailPane_DetailsTabQuery, PurchaseOrderDetailPane_DetailsTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PurchaseOrderDetailPane_DetailsTabQuery, PurchaseOrderDetailPane_DetailsTabQueryVariables>(PurchaseOrderDetailPane_DetailsTabDocument, options);
      }
export function usePurchaseOrderDetailPane_DetailsTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PurchaseOrderDetailPane_DetailsTabQuery, PurchaseOrderDetailPane_DetailsTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PurchaseOrderDetailPane_DetailsTabQuery, PurchaseOrderDetailPane_DetailsTabQueryVariables>(PurchaseOrderDetailPane_DetailsTabDocument, options);
        }
export type PurchaseOrderDetailPane_DetailsTabQueryHookResult = ReturnType<typeof usePurchaseOrderDetailPane_DetailsTabQuery>;
export type PurchaseOrderDetailPane_DetailsTabLazyQueryHookResult = ReturnType<typeof usePurchaseOrderDetailPane_DetailsTabLazyQuery>;
export type PurchaseOrderDetailPane_DetailsTabQueryResult = Apollo.QueryResult<PurchaseOrderDetailPane_DetailsTabQuery, PurchaseOrderDetailPane_DetailsTabQueryVariables>;
export const PurchaseOrderDetailPane_InvoicesTabDocument = gql`
    query PurchaseOrderDetailPane_InvoicesTab($commitmentId: ID!, $changeOrderId: ID!, $skipCommitment: Boolean!, $skipChangeOrder: Boolean!) {
  commitment(id: $commitmentId) @skip(if: $skipCommitment) {
    id
    balanceInCents
    bills {
      ...PurchaseOrderDetailPane_Bill
    }
  }
  commitmentChangeOrder(id: $changeOrderId) @skip(if: $skipChangeOrder) {
    id
    balanceInCents
    bills {
      ...PurchaseOrderDetailPane_Bill
    }
  }
}
    ${PurchaseOrderDetailPane_BillFragmentDoc}`;

/**
 * __usePurchaseOrderDetailPane_InvoicesTabQuery__
 *
 * To run a query within a React component, call `usePurchaseOrderDetailPane_InvoicesTabQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOrderDetailPane_InvoicesTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseOrderDetailPane_InvoicesTabQuery({
 *   variables: {
 *      commitmentId: // value for 'commitmentId'
 *      changeOrderId: // value for 'changeOrderId'
 *      skipCommitment: // value for 'skipCommitment'
 *      skipChangeOrder: // value for 'skipChangeOrder'
 *   },
 * });
 */
export function usePurchaseOrderDetailPane_InvoicesTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PurchaseOrderDetailPane_InvoicesTabQuery, PurchaseOrderDetailPane_InvoicesTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PurchaseOrderDetailPane_InvoicesTabQuery, PurchaseOrderDetailPane_InvoicesTabQueryVariables>(PurchaseOrderDetailPane_InvoicesTabDocument, options);
      }
export function usePurchaseOrderDetailPane_InvoicesTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PurchaseOrderDetailPane_InvoicesTabQuery, PurchaseOrderDetailPane_InvoicesTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PurchaseOrderDetailPane_InvoicesTabQuery, PurchaseOrderDetailPane_InvoicesTabQueryVariables>(PurchaseOrderDetailPane_InvoicesTabDocument, options);
        }
export type PurchaseOrderDetailPane_InvoicesTabQueryHookResult = ReturnType<typeof usePurchaseOrderDetailPane_InvoicesTabQuery>;
export type PurchaseOrderDetailPane_InvoicesTabLazyQueryHookResult = ReturnType<typeof usePurchaseOrderDetailPane_InvoicesTabLazyQuery>;
export type PurchaseOrderDetailPane_InvoicesTabQueryResult = Apollo.QueryResult<PurchaseOrderDetailPane_InvoicesTabQuery, PurchaseOrderDetailPane_InvoicesTabQueryVariables>;
export const PurchaseOrderDetailPane_SpecsTabDocument = gql`
    query PurchaseOrderDetailPane_SpecsTab($commitmentId: ID!, $changeOrderId: ID!, $skipCommitment: Boolean!, $skipChangeOrder: Boolean!) {
  commitment(id: $commitmentId) @skip(if: $skipCommitment) {
    ...DetailPane_SpecsTab_Commitment
  }
  commitmentChangeOrder(id: $changeOrderId) @skip(if: $skipChangeOrder) {
    ...DetailPane_SpecsTab_ChangeOrder
  }
}
    ${DetailPane_SpecsTab_CommitmentFragmentDoc}
${DetailPane_SpecsTab_ChangeOrderFragmentDoc}`;

/**
 * __usePurchaseOrderDetailPane_SpecsTabQuery__
 *
 * To run a query within a React component, call `usePurchaseOrderDetailPane_SpecsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOrderDetailPane_SpecsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseOrderDetailPane_SpecsTabQuery({
 *   variables: {
 *      commitmentId: // value for 'commitmentId'
 *      changeOrderId: // value for 'changeOrderId'
 *      skipCommitment: // value for 'skipCommitment'
 *      skipChangeOrder: // value for 'skipChangeOrder'
 *   },
 * });
 */
export function usePurchaseOrderDetailPane_SpecsTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PurchaseOrderDetailPane_SpecsTabQuery, PurchaseOrderDetailPane_SpecsTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PurchaseOrderDetailPane_SpecsTabQuery, PurchaseOrderDetailPane_SpecsTabQueryVariables>(PurchaseOrderDetailPane_SpecsTabDocument, options);
      }
export function usePurchaseOrderDetailPane_SpecsTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PurchaseOrderDetailPane_SpecsTabQuery, PurchaseOrderDetailPane_SpecsTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PurchaseOrderDetailPane_SpecsTabQuery, PurchaseOrderDetailPane_SpecsTabQueryVariables>(PurchaseOrderDetailPane_SpecsTabDocument, options);
        }
export type PurchaseOrderDetailPane_SpecsTabQueryHookResult = ReturnType<typeof usePurchaseOrderDetailPane_SpecsTabQuery>;
export type PurchaseOrderDetailPane_SpecsTabLazyQueryHookResult = ReturnType<typeof usePurchaseOrderDetailPane_SpecsTabLazyQuery>;
export type PurchaseOrderDetailPane_SpecsTabQueryResult = Apollo.QueryResult<PurchaseOrderDetailPane_SpecsTabQuery, PurchaseOrderDetailPane_SpecsTabQueryVariables>;
import { newDate, newDateTime } from "src/utils/tests/testDates";

const factories: Record<string, Function> = {};
type RequireTypename<T extends { __typename?: string }> = Omit<T, "__typename"> & Required<Pick<T, "__typename">>;
export interface HomeownerContractLineItemOptions {
  __typename?: "HomeownerContractLineItem";
  id?: HomeownerContractLineItem["id"];
  priceChangeInCents?: HomeownerContractLineItem["priceChangeInCents"];
  budgetChangeInCents?: HomeownerContractLineItem["budgetChangeInCents"];
  quantity?: HomeownerContractLineItem["quantity"];
  costCode?: CostCode | CostCodeOptions;
  internalNote?: HomeownerContractLineItem["internalNote"];
  invoiceLineItems?: Array<InvoiceLineItem | InvoiceLineItemOptions>;
  projectItem?: ProjectItem | ProjectItemOptions;
  parent?: HomeownerContract | HomeownerContractChangeOrder | HomeownerContractLike | HomeownerContractLikeOptions;
  owner?: HomeownerContract | HomeownerContractChangeOrder | HomeownerContractLike | HomeownerContractLikeOptions;
  amountPaidInCents?: HomeownerContractLineItem["amountPaidInCents"];
  invoicedAmountInCents?: HomeownerContractLineItem["invoicedAmountInCents"];
  changeEventLineItem?: ChangeEventLineItem | ChangeEventLineItemOptions | null;
  tradePartnerNote?: HomeownerContractLineItem["tradePartnerNote"];
  specifications?: HomeownerContractLineItem["specifications"];
  bidItem?: BidItem | BidItemOptions | null;
  allocations?: Array<HomeownerContractLineItemAllocation | HomeownerContractLineItemAllocationOptions>;
}

export function newHomeownerContractLineItem(
  options: HomeownerContractLineItemOptions = {},
  cache: Record<string, any> = {},
): HomeownerContractLineItem {
  const o = (options.__typename ? options : cache["HomeownerContractLineItem"] = {}) as HomeownerContractLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerContractLineItem";
  o.id = options.id ?? nextFactoryId("HomeownerContractLineItem");
  o.priceChangeInCents = options.priceChangeInCents ?? null;
  o.budgetChangeInCents = options.budgetChangeInCents ?? null;
  o.quantity = options.quantity ?? null;
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.internalNote = options.internalNote ?? null;
  o.invoiceLineItems = (options.invoiceLineItems ?? []).map((i) =>
    maybeNew("InvoiceLineItem", i, cache, options.hasOwnProperty("invoiceLineItems"))
  );
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.parent = maybeNew("HomeownerContractLike", options.parent, cache, options.hasOwnProperty("parent"));
  o.owner = maybeNew("HomeownerContractLike", options.owner, cache, options.hasOwnProperty("owner"));
  o.amountPaidInCents = options.amountPaidInCents ?? null;
  o.invoicedAmountInCents = options.invoicedAmountInCents ?? 0;
  o.changeEventLineItem = maybeNewOrNull("ChangeEventLineItem", options.changeEventLineItem, cache);
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.specifications = options.specifications ?? null;
  o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
  o.allocations = (options.allocations ?? []).map((i) =>
    maybeNew("HomeownerContractLineItemAllocation", i, cache, options.hasOwnProperty("allocations"))
  );
  return o;
}

factories["HomeownerContractLineItem"] = newHomeownerContractLineItem;

export interface AddressOptions {
  __typename?: "Address";
  id?: Address["id"];
  street1?: Address["street1"];
  street2?: Address["street2"];
  city?: Address["city"];
  state?: Address["state"];
  postalCode?: Address["postalCode"];
  country?: Address["country"];
}

export function newAddress(options: AddressOptions = {}, cache: Record<string, any> = {}): Address {
  const o = (options.__typename ? options : cache["Address"] = {}) as Address;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Address";
  o.id = options.id ?? nextFactoryId("Address");
  o.street1 = options.street1 ?? "street1";
  o.street2 = options.street2 ?? null;
  o.city = options.city ?? "city";
  o.state = options.state ?? "state";
  o.postalCode = options.postalCode ?? "postalCode";
  o.country = options.country ?? "country";
  return o;
}

factories["Address"] = newAddress;

export interface AiEntityProposalsPageOptions {
  __typename?: "AiEntityProposalsPage";
  entities?: Array<AiEntityProposal | AiEntityProposalOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newAiEntityProposalsPage(
  options: AiEntityProposalsPageOptions = {},
  cache: Record<string, any> = {},
): AiEntityProposalsPage {
  const o = (options.__typename ? options : cache["AiEntityProposalsPage"] = {}) as AiEntityProposalsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AiEntityProposalsPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("AiEntityProposal", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["AiEntityProposalsPage"] = newAiEntityProposalsPage;

export interface AiEntityProposalOptions {
  __typename?: "AiEntityProposal";
  id?: AiEntityProposal["id"];
  createdAt?: AiEntityProposal["createdAt"];
  updatedAt?: AiEntityProposal["updatedAt"];
  type?: AiEntityProposalTypeDetailOptions | AiEntityProposalType;
  parent?: AiProposal | AiProposalOptions;
  entity?:
    | AiEntityProposalEntity
    | MaterialVariantOptions
    | RequireTypename<ReadyPlanLocationOptions>
    | RequireTypename<ReadyPlanOptionOptions>
    | RequireTypename<ReadyPlanProgramDataOptions>
    | null;
  fieldProposals?: Array<AiFieldProposal | AiFieldProposalOptions>;
  entityType?: AiEntityProposalEntityTypeDetailOptions | AiEntityProposalEntityType;
}

export function newAiEntityProposal(
  options: AiEntityProposalOptions = {},
  cache: Record<string, any> = {},
): AiEntityProposal {
  const o = (options.__typename ? options : cache["AiEntityProposal"] = {}) as AiEntityProposal;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AiEntityProposal";
  o.id = options.id ?? nextFactoryId("AiEntityProposal");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.type = enumOrDetailOfAiEntityProposalType(options.type);
  o.parent = maybeNew("AiProposal", options.parent, cache, options.hasOwnProperty("parent"));
  o.entity = maybeNewOrNull(options.entity?.__typename ?? "MaterialVariant", options.entity, cache);
  o.fieldProposals = (options.fieldProposals ?? []).map((i) =>
    maybeNew("AiFieldProposal", i, cache, options.hasOwnProperty("fieldProposals"))
  );
  o.entityType = enumOrDetailOfAiEntityProposalEntityType(options.entityType);
  return o;
}

factories["AiEntityProposal"] = newAiEntityProposal;

export interface AiFieldProposalsPageOptions {
  __typename?: "AiFieldProposalsPage";
  entities?: Array<AiFieldProposal | AiFieldProposalOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newAiFieldProposalsPage(
  options: AiFieldProposalsPageOptions = {},
  cache: Record<string, any> = {},
): AiFieldProposalsPage {
  const o = (options.__typename ? options : cache["AiFieldProposalsPage"] = {}) as AiFieldProposalsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AiFieldProposalsPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("AiFieldProposal", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["AiFieldProposalsPage"] = newAiFieldProposalsPage;

export interface AiFieldProposalOptions {
  __typename?: "AiFieldProposal";
  id?: AiFieldProposal["id"];
  fieldName?: AiFieldProposal["fieldName"];
  fieldValue?: AiFieldProposal["fieldValue"];
  status?: AiFieldProposalStatusDetailOptions | AiFieldProposalStatus;
  createdAt?: AiFieldProposal["createdAt"];
  updatedAt?: AiFieldProposal["updatedAt"];
  parent?: AiEntityProposal | AiEntityProposalOptions;
}

export function newAiFieldProposal(
  options: AiFieldProposalOptions = {},
  cache: Record<string, any> = {},
): AiFieldProposal {
  const o = (options.__typename ? options : cache["AiFieldProposal"] = {}) as AiFieldProposal;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AiFieldProposal";
  o.id = options.id ?? nextFactoryId("AiFieldProposal");
  o.fieldName = options.fieldName ?? "fieldName";
  o.fieldValue = options.fieldValue ?? "fieldValue";
  o.status = enumOrDetailOfAiFieldProposalStatus(options.status);
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.parent = maybeNew("AiEntityProposal", options.parent, cache, options.hasOwnProperty("parent"));
  return o;
}

factories["AiFieldProposal"] = newAiFieldProposal;

export interface ResolveAiFieldProposalsResultOptions {
  __typename?: "ResolveAiFieldProposalsResult";
  aiFieldProposals?: Array<AiFieldProposal | AiFieldProposalOptions>;
}

export function newResolveAiFieldProposalsResult(
  options: ResolveAiFieldProposalsResultOptions = {},
  cache: Record<string, any> = {},
): ResolveAiFieldProposalsResult {
  const o =
    (options.__typename ? options : cache["ResolveAiFieldProposalsResult"] = {}) as ResolveAiFieldProposalsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ResolveAiFieldProposalsResult";
  o.aiFieldProposals = (options.aiFieldProposals ?? []).map((i) =>
    maybeNew("AiFieldProposal", i, cache, options.hasOwnProperty("aiFieldProposals"))
  );
  return o;
}

factories["ResolveAiFieldProposalsResult"] = newResolveAiFieldProposalsResult;

export interface AiProposalOptions {
  __typename?: "AiProposal";
  id?: AiProposal["id"];
  createdAt?: AiProposal["createdAt"];
  updatedAt?: AiProposal["updatedAt"];
  entityProposals?: Array<AiEntityProposal | AiEntityProposalOptions>;
  type?: AiProposalTypeDetailOptions | AiProposalType;
  status?: AiProposalStatusDetailOptions | AiProposalStatus;
}

export function newAiProposal(options: AiProposalOptions = {}, cache: Record<string, any> = {}): AiProposal {
  const o = (options.__typename ? options : cache["AiProposal"] = {}) as AiProposal;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AiProposal";
  o.id = options.id ?? nextFactoryId("AiProposal");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.entityProposals = (options.entityProposals ?? []).map((i) =>
    maybeNew("AiEntityProposal", i, cache, options.hasOwnProperty("entityProposals"))
  );
  o.type = enumOrDetailOfAiProposalType(options.type);
  o.status = enumOrDetailOfAiProposalStatus(options.status);
  return o;
}

factories["AiProposal"] = newAiProposal;

export interface ApprovalOptions {
  __typename?: "Approval";
  id?: Approval["id"];
  name?: Approval["name"];
  requestedAt?: Approval["requestedAt"];
  dueOn?: Approval["dueOn"];
  createdAt?: Approval["createdAt"];
  updatedAt?: Approval["updatedAt"];
  status?: ApprovalStatusDetailOptions | ApprovalStatus;
  requestedBy?: User | UserOptions | null;
  rootProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  approvers?: Array<Approver | ApproverOptions>;
  source?:
    | ApprovalSource
    | BidContractRevisionOptions
    | RequireTypename<ItemTemplateOptions>
    | RequireTypename<ReadyPlanAggregateVersionOptions>
    | null;
  subject?:
    | ApprovalSubject
    | BillOptions
    | RequireTypename<ChangeEventOptions>
    | RequireTypename<ChangeRequestOptions>
    | RequireTypename<InvoiceOptions>;
  blueprintUrl?: Url | UrlOptions;
  isFinalized?: Approval["isFinalized"];
  userEvents?: Array<UserEvent | UserEventOptions>;
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Approval["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Approval["isFollowed"];
}

export function newApproval(options: ApprovalOptions = {}, cache: Record<string, any> = {}): Approval {
  const o = (options.__typename ? options : cache["Approval"] = {}) as Approval;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Approval";
  o.id = options.id ?? nextFactoryId("Approval");
  o.name = options.name ?? "name";
  o.requestedAt = options.requestedAt ?? null;
  o.dueOn = options.dueOn ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = enumOrDetailOfApprovalStatus(options.status);
  o.requestedBy = maybeNewOrNull("User", options.requestedBy, cache);
  o.rootProject = maybeNewOrNull("Project", options.rootProject, cache);
  o.approvers = (options.approvers ?? []).map((i) =>
    maybeNew("Approver", i, cache, options.hasOwnProperty("approvers"))
  );
  o.source = maybeNewOrNull(options.source?.__typename ?? "BidContractRevision", options.source, cache);
  o.subject = maybeNew(options.subject?.__typename ?? "Bill", options.subject, cache);
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.isFinalized = options.isFinalized ?? false;
  o.userEvents = (options.userEvents ?? []).map((i) =>
    maybeNew("UserEvent", i, cache, options.hasOwnProperty("userEvents"))
  );
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  return o;
}

factories["Approval"] = newApproval;

export interface ApprovalPageOptions {
  __typename?: "ApprovalPage";
  approvals?: Array<Approval | ApprovalOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newApprovalPage(options: ApprovalPageOptions = {}, cache: Record<string, any> = {}): ApprovalPage {
  const o = (options.__typename ? options : cache["ApprovalPage"] = {}) as ApprovalPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ApprovalPage";
  o.approvals = (options.approvals ?? []).map((i) =>
    maybeNew("Approval", i, cache, options.hasOwnProperty("approvals"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ApprovalPage"] = newApprovalPage;

export interface SaveApprovalResultOptions {
  __typename?: "SaveApprovalResult";
  approval?: Approval | ApprovalOptions;
}

export function newSaveApprovalResult(
  options: SaveApprovalResultOptions = {},
  cache: Record<string, any> = {},
): SaveApprovalResult {
  const o = (options.__typename ? options : cache["SaveApprovalResult"] = {}) as SaveApprovalResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveApprovalResult";
  o.approval = maybeNew("Approval", options.approval, cache, options.hasOwnProperty("approval"));
  return o;
}

factories["SaveApprovalResult"] = newSaveApprovalResult;

export interface SaveApprovalsResultOptions {
  __typename?: "SaveApprovalsResult";
  approvals?: Array<Approval | ApprovalOptions>;
}

export function newSaveApprovalsResult(
  options: SaveApprovalsResultOptions = {},
  cache: Record<string, any> = {},
): SaveApprovalsResult {
  const o = (options.__typename ? options : cache["SaveApprovalsResult"] = {}) as SaveApprovalsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveApprovalsResult";
  o.approvals = (options.approvals ?? []).map((i) =>
    maybeNew("Approval", i, cache, options.hasOwnProperty("approvals"))
  );
  return o;
}

factories["SaveApprovalsResult"] = newSaveApprovalsResult;

export interface ApproverOptions {
  __typename?: "Approver";
  id?: Approver["id"];
  order?: Approver["order"];
  statusUpdatedAt?: Approver["statusUpdatedAt"];
  createdAt?: Approver["createdAt"];
  updatedAt?: Approver["updatedAt"];
  status?: ApproverStatusDetailOptions | ApproverStatus;
  nextApprover?: Approver | ApproverOptions | null;
  approval?: Approval | ApprovalOptions;
  user?: ApproverUser | ClientOptions | RequireTypename<InternalUserOptions> | RequireTypename<TradePartnerUserOptions>;
  wasAutoApproved?: Approver["wasAutoApproved"];
  subjectData?: ApproverSubjectData | ChangeRequestApproverSubjectDataOptions | null;
  requireSignature?: Approver["requireSignature"];
  pandaDocRecipient?: PandaDocRecipient | PandaDocRecipientOptions | null;
}

export function newApprover(options: ApproverOptions = {}, cache: Record<string, any> = {}): Approver {
  const o = (options.__typename ? options : cache["Approver"] = {}) as Approver;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Approver";
  o.id = options.id ?? nextFactoryId("Approver");
  o.order = options.order ?? 0;
  o.statusUpdatedAt = options.statusUpdatedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = enumOrDetailOfApproverStatus(options.status);
  o.nextApprover = maybeNewOrNull("Approver", options.nextApprover, cache);
  o.approval = maybeNew("Approval", options.approval, cache, options.hasOwnProperty("approval"));
  o.user = maybeNew(options.user?.__typename ?? "Client", options.user, cache);
  o.wasAutoApproved = options.wasAutoApproved ?? false;
  o.subjectData = maybeNewOrNull(
    options.subjectData?.__typename ?? "ChangeRequestApproverSubjectData",
    options.subjectData,
    cache,
  );
  o.requireSignature = options.requireSignature ?? false;
  o.pandaDocRecipient = maybeNewOrNull("PandaDocRecipient", options.pandaDocRecipient, cache);
  return o;
}

factories["Approver"] = newApprover;

export interface SaveApproverResultOptions {
  __typename?: "SaveApproverResult";
  approver?: Approver | ApproverOptions;
}

export function newSaveApproverResult(
  options: SaveApproverResultOptions = {},
  cache: Record<string, any> = {},
): SaveApproverResult {
  const o = (options.__typename ? options : cache["SaveApproverResult"] = {}) as SaveApproverResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveApproverResult";
  o.approver = maybeNew("Approver", options.approver, cache, options.hasOwnProperty("approver"));
  return o;
}

factories["SaveApproverResult"] = newSaveApproverResult;

export interface SaveApproversResultOptions {
  __typename?: "SaveApproversResult";
  approvers?: Array<Approver | ApproverOptions>;
}

export function newSaveApproversResult(
  options: SaveApproversResultOptions = {},
  cache: Record<string, any> = {},
): SaveApproversResult {
  const o = (options.__typename ? options : cache["SaveApproversResult"] = {}) as SaveApproversResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveApproversResult";
  o.approvers = (options.approvers ?? []).map((i) =>
    maybeNew("Approver", i, cache, options.hasOwnProperty("approvers"))
  );
  return o;
}

factories["SaveApproversResult"] = newSaveApproversResult;

export interface CreateAssetUploadUrlResultOptions {
  __typename?: "CreateAssetUploadUrlResult";
  s3Key?: CreateAssetUploadUrlResult["s3Key"];
  uploadUrl?: CreateAssetUploadUrlResult["uploadUrl"];
  downloadUrl?: CreateAssetUploadUrlResult["downloadUrl"];
  attachmentUrl?: CreateAssetUploadUrlResult["attachmentUrl"];
  previewUrl?: CreateAssetUploadUrlResult["previewUrl"];
}

export function newCreateAssetUploadUrlResult(
  options: CreateAssetUploadUrlResultOptions = {},
  cache: Record<string, any> = {},
): CreateAssetUploadUrlResult {
  const o = (options.__typename ? options : cache["CreateAssetUploadUrlResult"] = {}) as CreateAssetUploadUrlResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateAssetUploadUrlResult";
  o.s3Key = options.s3Key ?? "s3Key";
  o.uploadUrl = options.uploadUrl ?? "uploadUrl";
  o.downloadUrl = options.downloadUrl ?? "downloadUrl";
  o.attachmentUrl = options.attachmentUrl ?? "attachmentUrl";
  o.previewUrl = options.previewUrl ?? null;
  return o;
}

factories["CreateAssetUploadUrlResult"] = newCreateAssetUploadUrlResult;

export interface CreateAssetMultipartUploadUrlResultOptions {
  __typename?: "CreateAssetMultipartUploadUrlResult";
  uploadId?: CreateAssetMultipartUploadUrlResult["uploadId"];
  s3Key?: CreateAssetMultipartUploadUrlResult["s3Key"];
  totalParts?: CreateAssetMultipartUploadUrlResult["totalParts"];
  partUploadUrls?: Array<MultipartPartUploadUrl | MultipartPartUploadUrlOptions>;
  expiresAt?: CreateAssetMultipartUploadUrlResult["expiresAt"];
}

export function newCreateAssetMultipartUploadUrlResult(
  options: CreateAssetMultipartUploadUrlResultOptions = {},
  cache: Record<string, any> = {},
): CreateAssetMultipartUploadUrlResult {
  const o =
    (options.__typename
      ? options
      : cache["CreateAssetMultipartUploadUrlResult"] = {}) as CreateAssetMultipartUploadUrlResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateAssetMultipartUploadUrlResult";
  o.uploadId = options.uploadId ?? "uploadId";
  o.s3Key = options.s3Key ?? "s3Key";
  o.totalParts = options.totalParts ?? 0;
  o.partUploadUrls = (options.partUploadUrls ?? []).map((i) =>
    maybeNew("MultipartPartUploadUrl", i, cache, options.hasOwnProperty("partUploadUrls"))
  );
  o.expiresAt = options.expiresAt ?? newDateTime();
  return o;
}

factories["CreateAssetMultipartUploadUrlResult"] = newCreateAssetMultipartUploadUrlResult;

export interface MultipartPartUploadUrlOptions {
  __typename?: "MultipartPartUploadUrl";
  partNumber?: MultipartPartUploadUrl["partNumber"];
  uploadUrl?: MultipartPartUploadUrl["uploadUrl"];
}

export function newMultipartPartUploadUrl(
  options: MultipartPartUploadUrlOptions = {},
  cache: Record<string, any> = {},
): MultipartPartUploadUrl {
  const o = (options.__typename ? options : cache["MultipartPartUploadUrl"] = {}) as MultipartPartUploadUrl;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MultipartPartUploadUrl";
  o.partNumber = options.partNumber ?? 0;
  o.uploadUrl = options.uploadUrl ?? "uploadUrl";
  return o;
}

factories["MultipartPartUploadUrl"] = newMultipartPartUploadUrl;

export interface AbortAssetMultipartUploadResultOptions {
  __typename?: "AbortAssetMultipartUploadResult";
  uploadId?: AbortAssetMultipartUploadResult["uploadId"];
  s3Key?: AbortAssetMultipartUploadResult["s3Key"];
}

export function newAbortAssetMultipartUploadResult(
  options: AbortAssetMultipartUploadResultOptions = {},
  cache: Record<string, any> = {},
): AbortAssetMultipartUploadResult {
  const o =
    (options.__typename ? options : cache["AbortAssetMultipartUploadResult"] = {}) as AbortAssetMultipartUploadResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AbortAssetMultipartUploadResult";
  o.uploadId = options.uploadId ?? "uploadId";
  o.s3Key = options.s3Key ?? "s3Key";
  return o;
}

factories["AbortAssetMultipartUploadResult"] = newAbortAssetMultipartUploadResult;

export interface AssetOptions {
  __typename?: "Asset";
  id?: Asset["id"];
  contentType?: Asset["contentType"];
  isVideo?: Asset["isVideo"];
  downloadUrl?: Asset["downloadUrl"];
  attachmentUrl?: Asset["attachmentUrl"];
  previewUrl?: Asset["previewUrl"];
  url?: Asset["url"];
  fileName?: Asset["fileName"];
  sizeInBytes?: Asset["sizeInBytes"];
  createdAt?: Asset["createdAt"];
  updatedAt?: Asset["updatedAt"];
  version?: Asset["version"];
  s3Key?: Asset["s3Key"];
}

export function newAsset(options: AssetOptions = {}, cache: Record<string, any> = {}): Asset {
  const o = (options.__typename ? options : cache["Asset"] = {}) as Asset;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Asset";
  o.id = options.id ?? nextFactoryId("Asset");
  o.contentType = options.contentType ?? "contentType";
  o.isVideo = options.isVideo ?? false;
  o.downloadUrl = options.downloadUrl ?? "downloadUrl";
  o.attachmentUrl = options.attachmentUrl ?? "attachmentUrl";
  o.previewUrl = options.previewUrl ?? null;
  o.url = options.url ?? "url";
  o.fileName = options.fileName ?? null;
  o.sizeInBytes = options.sizeInBytes ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.version = options.version ?? "version";
  o.s3Key = options.s3Key ?? "s3Key";
  return o;
}

factories["Asset"] = newAsset;

export interface CreateAssetResultOptions {
  __typename?: "CreateAssetResult";
  asset?: Asset | AssetOptions;
}

export function newCreateAssetResult(
  options: CreateAssetResultOptions = {},
  cache: Record<string, any> = {},
): CreateAssetResult {
  const o = (options.__typename ? options : cache["CreateAssetResult"] = {}) as CreateAssetResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateAssetResult";
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  return o;
}

factories["CreateAssetResult"] = newCreateAssetResult;

export interface AttachmentOptions {
  __typename?: "Attachment";
  id?: Attachment["id"];
  createdAt?: Attachment["createdAt"];
  updatedAt?: Attachment["updatedAt"];
  asset?: Asset | AssetOptions;
  parent?:
    | AttachmentParent
    | ChangeRequestOptions
    | RequireTypename<CommentOptions>
    | RequireTypename<GlobalOptionOptions>
    | RequireTypename<ProjectSiteConditionOptions>
    | RequireTypename<ScheduleFlagOptions>
    | RequireTypename<ToDoOptions>
    | RequireTypename<TradePartnerAvailabilityRequestEmailOptions>
    | RequireTypename<TradePartnerRequirementOptions>
    | RequireTypename<WarrantyTicketOptions>
    | RequireTypename<WarrantyTicketItemOptions>;
}

export function newAttachment(options: AttachmentOptions = {}, cache: Record<string, any> = {}): Attachment {
  const o = (options.__typename ? options : cache["Attachment"] = {}) as Attachment;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Attachment";
  o.id = options.id ?? nextFactoryId("Attachment");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  o.parent = maybeNew(options.parent?.__typename ?? "ChangeRequest", options.parent, cache);
  return o;
}

factories["Attachment"] = newAttachment;

export interface SaveAttachmentResultOptions {
  __typename?: "SaveAttachmentResult";
  attachment?: Attachment | AttachmentOptions;
}

export function newSaveAttachmentResult(
  options: SaveAttachmentResultOptions = {},
  cache: Record<string, any> = {},
): SaveAttachmentResult {
  const o = (options.__typename ? options : cache["SaveAttachmentResult"] = {}) as SaveAttachmentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveAttachmentResult";
  o.attachment = maybeNew("Attachment", options.attachment, cache, options.hasOwnProperty("attachment"));
  return o;
}

factories["SaveAttachmentResult"] = newSaveAttachmentResult;

export interface DeleteAttachmentResultOptions {
  __typename?: "DeleteAttachmentResult";
  parent?:
    | AttachmentParent
    | ChangeRequestOptions
    | RequireTypename<CommentOptions>
    | RequireTypename<GlobalOptionOptions>
    | RequireTypename<ProjectSiteConditionOptions>
    | RequireTypename<ScheduleFlagOptions>
    | RequireTypename<ToDoOptions>
    | RequireTypename<TradePartnerAvailabilityRequestEmailOptions>
    | RequireTypename<TradePartnerRequirementOptions>
    | RequireTypename<WarrantyTicketOptions>
    | RequireTypename<WarrantyTicketItemOptions>
    | null;
}

export function newDeleteAttachmentResult(
  options: DeleteAttachmentResultOptions = {},
  cache: Record<string, any> = {},
): DeleteAttachmentResult {
  const o = (options.__typename ? options : cache["DeleteAttachmentResult"] = {}) as DeleteAttachmentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteAttachmentResult";
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "ChangeRequest", options.parent, cache);
  return o;
}

factories["DeleteAttachmentResult"] = newDeleteAttachmentResult;

export interface DeleteAuditEventsResultOptions {
  __typename?: "DeleteAuditEventsResult";
  results?: Array<DeleteAuditEventResult | DeleteAuditEventResultOptions>;
}

export function newDeleteAuditEventsResult(
  options: DeleteAuditEventsResultOptions = {},
  cache: Record<string, any> = {},
): DeleteAuditEventsResult {
  const o = (options.__typename ? options : cache["DeleteAuditEventsResult"] = {}) as DeleteAuditEventsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteAuditEventsResult";
  o.results = (options.results ?? []).map((i) =>
    maybeNew("DeleteAuditEventResult", i, cache, options.hasOwnProperty("results"))
  );
  return o;
}

factories["DeleteAuditEventsResult"] = newDeleteAuditEventsResult;

export interface DeleteAuditEventResultOptions {
  __typename?: "DeleteAuditEventResult";
  table?: DeleteAuditEventResult["table"];
  column?: DeleteAuditEventResult["column"];
  deletedCount?: DeleteAuditEventResult["deletedCount"];
}

export function newDeleteAuditEventResult(
  options: DeleteAuditEventResultOptions = {},
  cache: Record<string, any> = {},
): DeleteAuditEventResult {
  const o = (options.__typename ? options : cache["DeleteAuditEventResult"] = {}) as DeleteAuditEventResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteAuditEventResult";
  o.table = options.table ?? "table";
  o.column = options.column ?? "column";
  o.deletedCount = options.deletedCount ?? 0;
  return o;
}

factories["DeleteAuditEventResult"] = newDeleteAuditEventResult;

export interface BidContractOptions {
  __typename?: "BidContract";
  id?: BidContract["id"];
  name?: BidContract["name"];
  blueprintUrl?: Url | UrlOptions;
  displayName?: BidContract["displayName"];
  isPrimary?: BidContract["isPrimary"];
  createdAt?: BidContract["createdAt"];
  updatedAt?: BidContract["updatedAt"];
  tradePartner?: TradePartner | TradePartnerOptions | null;
  revisions?: Array<BidContractRevision | BidContractRevisionOptions>;
  currentRevision?: BidContractRevision | BidContractRevisionOptions;
  latestSignedRevision?: BidContractRevision | BidContractRevisionOptions | null;
  unsignedRevision?: BidContractRevision | BidContractRevisionOptions | null;
  latestRevision?: BidContractRevision | BidContractRevisionOptions;
  isInternalEstimate?: BidContract["isInternalEstimate"];
  developments?: Array<Development | DevelopmentOptions>;
  bidRequest?: BidPackageRequest | BidPackageRequestOptions | null;
  bidder?: BidPackageBidder | BidPackageBidderOptions;
  type?: BidContractTypeDetailOptions | BidContractType;
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  relevantMarket?: Market | MarketOptions;
  scopeSource?: BidScopeSourceDetailOptions | BidScopeSource | null;
  isProjectLevelBidding?: BidContract["isProjectLevelBidding"];
  internalEstimateBidPackage?: BidPackage | BidPackageOptions | null;
  archivedAt?: BidContract["archivedAt"];
  internalEstimateType?: InternalEstimateTypeDetailOptions | InternalEstimateType | null;
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: BidContract["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: BidContract["isFollowed"];
}

export function newBidContract(options: BidContractOptions = {}, cache: Record<string, any> = {}): BidContract {
  const o = (options.__typename ? options : cache["BidContract"] = {}) as BidContract;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContract";
  o.id = options.id ?? nextFactoryId("BidContract");
  o.name = options.name ?? "name";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.displayName = options.displayName ?? "displayName";
  o.isPrimary = options.isPrimary ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.revisions = (options.revisions ?? []).map((i) =>
    maybeNew("BidContractRevision", i, cache, options.hasOwnProperty("revisions"))
  );
  o.currentRevision = maybeNew(
    "BidContractRevision",
    options.currentRevision,
    cache,
    options.hasOwnProperty("currentRevision"),
  );
  o.latestSignedRevision = maybeNewOrNull("BidContractRevision", options.latestSignedRevision, cache);
  o.unsignedRevision = maybeNewOrNull("BidContractRevision", options.unsignedRevision, cache);
  o.latestRevision = maybeNew(
    "BidContractRevision",
    options.latestRevision,
    cache,
    options.hasOwnProperty("latestRevision"),
  );
  o.isInternalEstimate = options.isInternalEstimate ?? false;
  o.developments = (options.developments ?? []).map((i) =>
    maybeNew("Development", i, cache, options.hasOwnProperty("developments"))
  );
  o.bidRequest = maybeNewOrNull("BidPackageRequest", options.bidRequest, cache);
  o.bidder = maybeNew("BidPackageBidder", options.bidder, cache, options.hasOwnProperty("bidder"));
  o.type = enumOrDetailOfBidContractType(options.type);
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  o.relevantMarket = maybeNew("Market", options.relevantMarket, cache, options.hasOwnProperty("relevantMarket"));
  o.scopeSource = enumOrDetailOrNullOfBidScopeSource(options.scopeSource);
  o.isProjectLevelBidding = options.isProjectLevelBidding ?? false;
  o.internalEstimateBidPackage = maybeNewOrNull("BidPackage", options.internalEstimateBidPackage, cache);
  o.archivedAt = options.archivedAt ?? null;
  o.internalEstimateType = enumOrDetailOrNullOfInternalEstimateType(options.internalEstimateType);
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  return o;
}

factories["BidContract"] = newBidContract;

export interface SaveBidContractResultOptions {
  __typename?: "SaveBidContractResult";
  bidContract?: BidContract | BidContractOptions;
}

export function newSaveBidContractResult(
  options: SaveBidContractResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidContractResult {
  const o = (options.__typename ? options : cache["SaveBidContractResult"] = {}) as SaveBidContractResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidContractResult";
  o.bidContract = maybeNew("BidContract", options.bidContract, cache, options.hasOwnProperty("bidContract"));
  return o;
}

factories["SaveBidContractResult"] = newSaveBidContractResult;

export interface CopyPlanBasedBidCostsResultOptions {
  __typename?: "CopyPlanBasedBidCostsResult";
  bidContract?: BidContract | BidContractOptions;
}

export function newCopyPlanBasedBidCostsResult(
  options: CopyPlanBasedBidCostsResultOptions = {},
  cache: Record<string, any> = {},
): CopyPlanBasedBidCostsResult {
  const o = (options.__typename ? options : cache["CopyPlanBasedBidCostsResult"] = {}) as CopyPlanBasedBidCostsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CopyPlanBasedBidCostsResult";
  o.bidContract = maybeNew("BidContract", options.bidContract, cache, options.hasOwnProperty("bidContract"));
  return o;
}

factories["CopyPlanBasedBidCostsResult"] = newCopyPlanBasedBidCostsResult;

export interface BidContractPotentialItemOptions {
  __typename?: "BidContractPotentialItem";
  item?: Item | ItemOptions;
  templateItemIds?: BidContractPotentialItem["templateItemIds"];
  needsBid?: BidContractPotentialItem["needsBid"];
}

export function newBidContractPotentialItem(
  options: BidContractPotentialItemOptions = {},
  cache: Record<string, any> = {},
): BidContractPotentialItem {
  const o = (options.__typename ? options : cache["BidContractPotentialItem"] = {}) as BidContractPotentialItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContractPotentialItem";
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.templateItemIds = options.templateItemIds ?? [];
  o.needsBid = options.needsBid ?? false;
  return o;
}

factories["BidContractPotentialItem"] = newBidContractPotentialItem;

export interface BidContractsPageOptions {
  __typename?: "BidContractsPage";
  entities?: Array<BidContract | BidContractOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newBidContractsPage(
  options: BidContractsPageOptions = {},
  cache: Record<string, any> = {},
): BidContractsPage {
  const o = (options.__typename ? options : cache["BidContractsPage"] = {}) as BidContractsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContractsPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["BidContractsPage"] = newBidContractsPage;

export interface BidContractLineItemOptions {
  __typename?: "BidContractLineItem";
  id?: BidContractLineItem["id"];
  name?: BidContractLineItem["name"];
  totalCostInCents?: BidContractLineItem["totalCostInCents"];
  unitCostInCents?: BidContractLineItem["unitCostInCents"];
  unitCostInMills?: BidContractLineItem["unitCostInMills"];
  createdAt?: BidContractLineItem["createdAt"];
  updatedAt?: BidContractLineItem["updatedAt"];
  itemTemplateItem?:
    | ItemTemplateItemVersion
    | ItemTemplateItem
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | BaseItemLike
    | BaseItemLikeOptions
    | null;
  revision?: BidContractRevision | BidContractRevisionOptions;
  previousLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  bidItem?: BidItem | BidItemOptions | null;
  scopeUpdated?: BidContractLineItem["scopeUpdated"];
  ofIti?: BidContractLineItem["ofIti"];
  ofBi?: BidContractLineItem["ofBi"];
  preferredByItemTemplateItems?: Array<
    | ItemTemplateItemVersion
    | ItemTemplateItem
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | BaseItemLike
    | BaseItemLikeOptions
  >;
  potentialUsages?: Array<
    | ItemTemplateItemVersion
    | ItemTemplateItem
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | BaseItemLike
    | BaseItemLikeOptions
  >;
  isTaxExempt?: BidContractLineItem["isTaxExempt"];
  tradeLineItem?: BidContractTradeLineItem | BidContractTradeLineItemOptions | null;
  forCoveringTakeoffs?: BidContractLineItem["forCoveringTakeoffs"];
  isNoCost?: BidContractLineItem["isNoCost"];
}

export function newBidContractLineItem(
  options: BidContractLineItemOptions = {},
  cache: Record<string, any> = {},
): BidContractLineItem {
  const o = (options.__typename ? options : cache["BidContractLineItem"] = {}) as BidContractLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContractLineItem";
  o.id = options.id ?? nextFactoryId("BidContractLineItem");
  o.name = options.name ?? "name";
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.unitCostInCents = options.unitCostInCents ?? 0;
  o.unitCostInMills = options.unitCostInMills ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.itemTemplateItem = maybeNewOrNull("BaseItemLike", options.itemTemplateItem, cache);
  o.revision = maybeNew("BidContractRevision", options.revision, cache, options.hasOwnProperty("revision"));
  o.previousLineItem = maybeNewOrNull("BidContractLineItem", options.previousLineItem, cache);
  o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
  o.scopeUpdated = options.scopeUpdated ?? false;
  o.ofIti = options.ofIti ?? false;
  o.ofBi = options.ofBi ?? false;
  o.preferredByItemTemplateItems = (options.preferredByItemTemplateItems ?? []).map((i) =>
    maybeNew("BaseItemLike", i, cache, options.hasOwnProperty("preferredByItemTemplateItems"))
  );
  o.potentialUsages = (options.potentialUsages ?? []).map((i) =>
    maybeNew("BaseItemLike", i, cache, options.hasOwnProperty("potentialUsages"))
  );
  o.isTaxExempt = options.isTaxExempt ?? false;
  o.tradeLineItem = maybeNewOrNull("BidContractTradeLineItem", options.tradeLineItem, cache);
  o.forCoveringTakeoffs = options.forCoveringTakeoffs ?? false;
  o.isNoCost = options.isNoCost ?? false;
  return o;
}

factories["BidContractLineItem"] = newBidContractLineItem;

export interface SaveBidContractLineItemResultOptions {
  __typename?: "SaveBidContractLineItemResult";
  bidContractLineItem?: BidContractLineItem | BidContractLineItemOptions;
}

export function newSaveBidContractLineItemResult(
  options: SaveBidContractLineItemResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidContractLineItemResult {
  const o =
    (options.__typename ? options : cache["SaveBidContractLineItemResult"] = {}) as SaveBidContractLineItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidContractLineItemResult";
  o.bidContractLineItem = maybeNew(
    "BidContractLineItem",
    options.bidContractLineItem,
    cache,
    options.hasOwnProperty("bidContractLineItem"),
  );
  return o;
}

factories["SaveBidContractLineItemResult"] = newSaveBidContractLineItemResult;

export interface SaveBidContractLineItemsResultOptions {
  __typename?: "SaveBidContractLineItemsResult";
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newSaveBidContractLineItemsResult(
  options: SaveBidContractLineItemsResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidContractLineItemsResult {
  const o =
    (options.__typename ? options : cache["SaveBidContractLineItemsResult"] = {}) as SaveBidContractLineItemsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidContractLineItemsResult";
  o.bidContractRevision = maybeNew(
    "BidContractRevision",
    options.bidContractRevision,
    cache,
    options.hasOwnProperty("bidContractRevision"),
  );
  return o;
}

factories["SaveBidContractLineItemsResult"] = newSaveBidContractLineItemsResult;

export interface DeleteBidContractLineItemResultOptions {
  __typename?: "DeleteBidContractLineItemResult";
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newDeleteBidContractLineItemResult(
  options: DeleteBidContractLineItemResultOptions = {},
  cache: Record<string, any> = {},
): DeleteBidContractLineItemResult {
  const o =
    (options.__typename ? options : cache["DeleteBidContractLineItemResult"] = {}) as DeleteBidContractLineItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteBidContractLineItemResult";
  o.bidContractRevision = maybeNew(
    "BidContractRevision",
    options.bidContractRevision,
    cache,
    options.hasOwnProperty("bidContractRevision"),
  );
  return o;
}

factories["DeleteBidContractLineItemResult"] = newDeleteBidContractLineItemResult;

export interface BidContractLineItemsPageResultOptions {
  __typename?: "BidContractLineItemsPageResult";
  entities?: Array<BidContractLineItem | BidContractLineItemOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newBidContractLineItemsPageResult(
  options: BidContractLineItemsPageResultOptions = {},
  cache: Record<string, any> = {},
): BidContractLineItemsPageResult {
  const o =
    (options.__typename ? options : cache["BidContractLineItemsPageResult"] = {}) as BidContractLineItemsPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContractLineItemsPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("BidContractLineItem", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["BidContractLineItemsPageResult"] = newBidContractLineItemsPageResult;

export interface BidContractRevisionOptions {
  __typename?: "BidContractRevision";
  id?: BidContractRevision["id"];
  displayName?: BidContractRevision["displayName"];
  version?: BidContractRevision["version"];
  createdAt?: BidContractRevision["createdAt"];
  updatedAt?: BidContractRevision["updatedAt"];
  status?: BidContractRevisionStatusDetailOptions | BidContractRevisionStatus;
  bidContract?: BidContract | BidContractOptions;
  lineItems?: Array<BidContractLineItem | BidContractLineItemOptions>;
  planBasedLineItems?: Array<PlanBasedBidContractLineItem | PlanBasedBidContractLineItemOptions>;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  canReviseCosts?: PotentialOperation2 | PotentialOperation2Options;
  costCodes?: Array<CostCode | CostCodeOptions>;
  costCodeAwards?: Array<CostCodeAward | CostCodeAwardOptions>;
  pandaDocRecipients?: Array<PandaDocIntendedRecipient | PandaDocIntendedRecipientOptions>;
  pandaDoc?: PandaDoc | PandaDocOptions | null;
  document?: Document | DocumentOptions | null;
  canCreatePandaDoc?: PotentialOperation2 | PotentialOperation2Options;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  startDate?: BidContractRevision["startDate"];
  endDate?: BidContractRevision["endDate"];
  isEffective?: BidContractRevision["isEffective"];
  commitments?: Array<Commitment | CommitmentOptions>;
  blueprintUrl?: Url | UrlOptions;
  hasOutdatedScope?: BidContractRevision["hasOutdatedScope"];
  sourceForApprovals?: Array<Approval | ApprovalOptions>;
  tradeSignatory?: TradePartnerContact | TradePartnerContactOptions | null;
  potentialProjectItems?: Array<PotentialProjectItem | PotentialProjectItemOptions>;
  itemTemplateCostUpdates?: Array<ItemTemplateCostUpdate | ItemTemplateCostUpdateOptions>;
  signedOn?: BidContractRevision["signedOn"];
  internalNote?: BidContractRevision["internalNote"];
  tradeLineItems?: Array<BidContractTradeLineItem | BidContractTradeLineItemOptions>;
  hasValidTradeCosts?: BidContractRevision["hasValidTradeCosts"];
  draws?: Array<BidContractRevisionDraw | BidContractRevisionDrawOptions>;
  canAddDraws?: PotentialOperation2 | PotentialOperation2Options;
  canEditDraws?: PotentialOperation2 | PotentialOperation2Options;
  primaryRevisionBidPackageAwards?: Array<BidPackageAward | BidPackageAwardOptions>;
  bidPackageVersion?: BidPackageVersion | BidPackageVersionOptions | null;
  hasValidDrawTasks?: BidContractRevision["hasValidDrawTasks"];
  hasAwardedBidPackageVersion?: BidContractRevision["hasAwardedBidPackageVersion"];
}

export function newBidContractRevision(
  options: BidContractRevisionOptions = {},
  cache: Record<string, any> = {},
): BidContractRevision {
  const o = (options.__typename ? options : cache["BidContractRevision"] = {}) as BidContractRevision;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContractRevision";
  o.id = options.id ?? nextFactoryId("BidContractRevision");
  o.displayName = options.displayName ?? "displayName";
  o.version = options.version ?? "version";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = enumOrDetailOfBidContractRevisionStatus(options.status);
  o.bidContract = maybeNew("BidContract", options.bidContract, cache, options.hasOwnProperty("bidContract"));
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("BidContractLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.planBasedLineItems = (options.planBasedLineItems ?? []).map((i) =>
    maybeNew("PlanBasedBidContractLineItem", i, cache, options.hasOwnProperty("planBasedLineItems"))
  );
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.canReviseCosts = maybeNew(
    "PotentialOperation2",
    options.canReviseCosts,
    cache,
    options.hasOwnProperty("canReviseCosts"),
  );
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.costCodeAwards = (options.costCodeAwards ?? []).map((i) =>
    maybeNew("CostCodeAward", i, cache, options.hasOwnProperty("costCodeAwards"))
  );
  o.pandaDocRecipients = (options.pandaDocRecipients ?? []).map((i) =>
    maybeNew("PandaDocIntendedRecipient", i, cache, options.hasOwnProperty("pandaDocRecipients"))
  );
  o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.canCreatePandaDoc = maybeNew(
    "PotentialOperation2",
    options.canCreatePandaDoc,
    cache,
    options.hasOwnProperty("canCreatePandaDoc"),
  );
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.startDate = options.startDate ?? newDate();
  o.endDate = options.endDate ?? null;
  o.isEffective = options.isEffective ?? false;
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.hasOutdatedScope = options.hasOutdatedScope ?? false;
  o.sourceForApprovals = (options.sourceForApprovals ?? []).map((i) =>
    maybeNew("Approval", i, cache, options.hasOwnProperty("sourceForApprovals"))
  );
  o.tradeSignatory = maybeNewOrNull("TradePartnerContact", options.tradeSignatory, cache);
  o.potentialProjectItems = (options.potentialProjectItems ?? []).map((i) =>
    maybeNew("PotentialProjectItem", i, cache, options.hasOwnProperty("potentialProjectItems"))
  );
  o.itemTemplateCostUpdates = (options.itemTemplateCostUpdates ?? []).map((i) =>
    maybeNew("ItemTemplateCostUpdate", i, cache, options.hasOwnProperty("itemTemplateCostUpdates"))
  );
  o.signedOn = options.signedOn ?? null;
  o.internalNote = options.internalNote ?? null;
  o.tradeLineItems = (options.tradeLineItems ?? []).map((i) =>
    maybeNew("BidContractTradeLineItem", i, cache, options.hasOwnProperty("tradeLineItems"))
  );
  o.hasValidTradeCosts = options.hasValidTradeCosts ?? false;
  o.draws = (options.draws ?? []).map((i) =>
    maybeNew("BidContractRevisionDraw", i, cache, options.hasOwnProperty("draws"))
  );
  o.canAddDraws = maybeNew("PotentialOperation2", options.canAddDraws, cache, options.hasOwnProperty("canAddDraws"));
  o.canEditDraws = maybeNew("PotentialOperation2", options.canEditDraws, cache, options.hasOwnProperty("canEditDraws"));
  o.primaryRevisionBidPackageAwards = (options.primaryRevisionBidPackageAwards ?? []).map((i) =>
    maybeNew("BidPackageAward", i, cache, options.hasOwnProperty("primaryRevisionBidPackageAwards"))
  );
  o.bidPackageVersion = maybeNewOrNull("BidPackageVersion", options.bidPackageVersion, cache);
  o.hasValidDrawTasks = options.hasValidDrawTasks ?? false;
  o.hasAwardedBidPackageVersion = options.hasAwardedBidPackageVersion ?? false;
  return o;
}

factories["BidContractRevision"] = newBidContractRevision;

export interface SaveBidContractRevisionResultOptions {
  __typename?: "SaveBidContractRevisionResult";
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newSaveBidContractRevisionResult(
  options: SaveBidContractRevisionResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidContractRevisionResult {
  const o =
    (options.__typename ? options : cache["SaveBidContractRevisionResult"] = {}) as SaveBidContractRevisionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidContractRevisionResult";
  o.bidContractRevision = maybeNew(
    "BidContractRevision",
    options.bidContractRevision,
    cache,
    options.hasOwnProperty("bidContractRevision"),
  );
  return o;
}

factories["SaveBidContractRevisionResult"] = newSaveBidContractRevisionResult;

export interface PandaDocIntendedRecipientOptions {
  __typename?: "PandaDocIntendedRecipient";
  name?: PandaDocIntendedRecipient["name"];
  email?: PandaDocIntendedRecipient["email"];
  role?: PandaDocIntendedRecipient["role"];
  tradePartnerContact?: TradePartnerContact | TradePartnerContactOptions | null;
  user?: User | UserOptions | null;
  signingOrder?: PandaDocIntendedRecipient["signingOrder"];
}

export function newPandaDocIntendedRecipient(
  options: PandaDocIntendedRecipientOptions = {},
  cache: Record<string, any> = {},
): PandaDocIntendedRecipient {
  const o = (options.__typename ? options : cache["PandaDocIntendedRecipient"] = {}) as PandaDocIntendedRecipient;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PandaDocIntendedRecipient";
  o.name = options.name ?? "name";
  o.email = options.email ?? "email";
  o.role = options.role ?? PandaDocRole.User;
  o.tradePartnerContact = maybeNewOrNull("TradePartnerContact", options.tradePartnerContact, cache);
  o.user = maybeNewOrNull("User", options.user, cache);
  o.signingOrder = options.signingOrder ?? null;
  return o;
}

factories["PandaDocIntendedRecipient"] = newPandaDocIntendedRecipient;

export interface PotentialProjectItemOptions {
  __typename?: "PotentialProjectItem";
  projectItem?: ProjectItem | ProjectItemOptions;
  totalCostInCents?: PotentialProjectItem["totalCostInCents"];
}

export function newPotentialProjectItem(
  options: PotentialProjectItemOptions = {},
  cache: Record<string, any> = {},
): PotentialProjectItem {
  const o = (options.__typename ? options : cache["PotentialProjectItem"] = {}) as PotentialProjectItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PotentialProjectItem";
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.totalCostInCents = options.totalCostInCents ?? 0;
  return o;
}

factories["PotentialProjectItem"] = newPotentialProjectItem;

export interface CostCodeAwardOptions {
  __typename?: "CostCodeAward";
  costCode?: CostCode | CostCodeOptions;
  isPrimary?: CostCodeAward["isPrimary"];
  isSecondary?: CostCodeAward["isSecondary"];
}

export function newCostCodeAward(options: CostCodeAwardOptions = {}, cache: Record<string, any> = {}): CostCodeAward {
  const o = (options.__typename ? options : cache["CostCodeAward"] = {}) as CostCodeAward;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostCodeAward";
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.isPrimary = options.isPrimary ?? false;
  o.isSecondary = options.isSecondary ?? false;
  return o;
}

factories["CostCodeAward"] = newCostCodeAward;

export interface BidContractRevisionDrawOptions {
  __typename?: "BidContractRevisionDraw";
  id?: BidContractRevisionDraw["id"];
  amountInBasisPoints?: BidContractRevisionDraw["amountInBasisPoints"];
  isDeposit?: BidContractRevisionDraw["isDeposit"];
  description?: BidContractRevisionDraw["description"];
  createdAt?: BidContractRevisionDraw["createdAt"];
  updatedAt?: BidContractRevisionDraw["updatedAt"];
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
  globalPlanTask?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
}

export function newBidContractRevisionDraw(
  options: BidContractRevisionDrawOptions = {},
  cache: Record<string, any> = {},
): BidContractRevisionDraw {
  const o = (options.__typename ? options : cache["BidContractRevisionDraw"] = {}) as BidContractRevisionDraw;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContractRevisionDraw";
  o.id = options.id ?? nextFactoryId("BidContractRevisionDraw");
  o.amountInBasisPoints = options.amountInBasisPoints ?? 0;
  o.isDeposit = options.isDeposit ?? false;
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.bidContractRevision = maybeNew(
    "BidContractRevision",
    options.bidContractRevision,
    cache,
    options.hasOwnProperty("bidContractRevision"),
  );
  o.globalPlanTask = maybeNewOrNull("GlobalPlanTask", options.globalPlanTask, cache);
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  return o;
}

factories["BidContractRevisionDraw"] = newBidContractRevisionDraw;

export interface BidContractTradeLineItemOptions {
  __typename?: "BidContractTradeLineItem";
  id?: BidContractTradeLineItem["id"];
  totalCostInCents?: BidContractTradeLineItem["totalCostInCents"];
  createdAt?: BidContractTradeLineItem["createdAt"];
  updatedAt?: BidContractTradeLineItem["updatedAt"];
  revision?: BidContractRevision | BidContractRevisionOptions;
  productOffering?: ProductOffering | ProductOfferingOptions;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  hasValidCost?: BidContractTradeLineItem["hasValidCost"];
  lineItems?: Array<BidContractLineItem | BidContractLineItemOptions>;
}

export function newBidContractTradeLineItem(
  options: BidContractTradeLineItemOptions = {},
  cache: Record<string, any> = {},
): BidContractTradeLineItem {
  const o = (options.__typename ? options : cache["BidContractTradeLineItem"] = {}) as BidContractTradeLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContractTradeLineItem";
  o.id = options.id ?? nextFactoryId("BidContractTradeLineItem");
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.revision = maybeNew("BidContractRevision", options.revision, cache, options.hasOwnProperty("revision"));
  o.productOffering = maybeNew(
    "ProductOffering",
    options.productOffering,
    cache,
    options.hasOwnProperty("productOffering"),
  );
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.hasValidCost = options.hasValidCost ?? false;
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("BidContractLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  return o;
}

factories["BidContractTradeLineItem"] = newBidContractTradeLineItem;

export interface SaveBidContractTradeLineItemsResultOptions {
  __typename?: "SaveBidContractTradeLineItemsResult";
  bidContractTradeLineItems?: Array<BidContractTradeLineItem | BidContractTradeLineItemOptions>;
}

export function newSaveBidContractTradeLineItemsResult(
  options: SaveBidContractTradeLineItemsResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidContractTradeLineItemsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveBidContractTradeLineItemsResult"] = {}) as SaveBidContractTradeLineItemsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidContractTradeLineItemsResult";
  o.bidContractTradeLineItems = (options.bidContractTradeLineItems ?? []).map((i) =>
    maybeNew("BidContractTradeLineItem", i, cache, options.hasOwnProperty("bidContractTradeLineItems"))
  );
  return o;
}

factories["SaveBidContractTradeLineItemsResult"] = newSaveBidContractTradeLineItemsResult;

export interface BidItemOptions {
  __typename?: "BidItem";
  id?: BidItem["id"];
  name?: BidItem["name"];
  code?: BidItem["code"];
  displayName?: BidItem["displayName"];
  createdAt?: BidItem["createdAt"];
  updatedAt?: BidItem["updatedAt"];
  costType?: CostTypeDetailOptions | CostType;
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  items?: Array<Item | ItemOptions>;
  bidContractLineItems?: Array<BidContractLineItem | BidContractLineItemOptions>;
  blueprintUrl?: Url | UrlOptions;
  parentMaterialVariant?: MaterialVariant | MaterialVariantOptions | null;
  parentTask?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  estimates?: Array<BidItemEstimate | BidItemEstimateOptions>;
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: BidItem["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: BidItem["isFollowed"];
}

export function newBidItem(options: BidItemOptions = {}, cache: Record<string, any> = {}): BidItem {
  const o = (options.__typename ? options : cache["BidItem"] = {}) as BidItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidItem";
  o.id = options.id ?? nextFactoryId("BidItem");
  o.name = options.name ?? "name";
  o.code = options.code ?? "code";
  o.displayName = options.displayName ?? "displayName";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costType = enumOrDetailOfCostType(options.costType);
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.items = (options.items ?? []).map((i) => maybeNew("Item", i, cache, options.hasOwnProperty("items")));
  o.bidContractLineItems = (options.bidContractLineItems ?? []).map((i) =>
    maybeNew("BidContractLineItem", i, cache, options.hasOwnProperty("bidContractLineItems"))
  );
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.parentMaterialVariant = maybeNewOrNull("MaterialVariant", options.parentMaterialVariant, cache);
  o.parentTask = maybeNewOrNull("GlobalPlanTask", options.parentTask, cache);
  o.estimates = (options.estimates ?? []).map((i) =>
    maybeNew("BidItemEstimate", i, cache, options.hasOwnProperty("estimates"))
  );
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  return o;
}

factories["BidItem"] = newBidItem;

export interface BidItemsPageOptions {
  __typename?: "BidItemsPage";
  bidItems?: Array<BidItem | BidItemOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newBidItemsPage(options: BidItemsPageOptions = {}, cache: Record<string, any> = {}): BidItemsPage {
  const o = (options.__typename ? options : cache["BidItemsPage"] = {}) as BidItemsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidItemsPage";
  o.bidItems = (options.bidItems ?? []).map((i) => maybeNew("BidItem", i, cache, options.hasOwnProperty("bidItems")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["BidItemsPage"] = newBidItemsPage;

export interface SaveBidItemResultOptions {
  __typename?: "SaveBidItemResult";
  bidItem?: BidItem | BidItemOptions;
}

export function newSaveBidItemResult(
  options: SaveBidItemResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidItemResult {
  const o = (options.__typename ? options : cache["SaveBidItemResult"] = {}) as SaveBidItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidItemResult";
  o.bidItem = maybeNew("BidItem", options.bidItem, cache, options.hasOwnProperty("bidItem"));
  return o;
}

factories["SaveBidItemResult"] = newSaveBidItemResult;

export interface BidItemEstimateOptions {
  __typename?: "BidItemEstimate";
  id?: BidItemEstimate["id"];
  costInMills?: BidItemEstimate["costInMills"];
  sourceUrl?: BidItemEstimate["sourceUrl"];
  createdAt?: BidItemEstimate["createdAt"];
  updatedAt?: BidItemEstimate["updatedAt"];
  bidItem?: BidItem | BidItemOptions;
  createdBy?: User | UserOptions;
  markets?: Array<Market | MarketOptions>;
}

export function newBidItemEstimate(
  options: BidItemEstimateOptions = {},
  cache: Record<string, any> = {},
): BidItemEstimate {
  const o = (options.__typename ? options : cache["BidItemEstimate"] = {}) as BidItemEstimate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidItemEstimate";
  o.id = options.id ?? nextFactoryId("BidItemEstimate");
  o.costInMills = options.costInMills ?? 0;
  o.sourceUrl = options.sourceUrl ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.bidItem = maybeNew("BidItem", options.bidItem, cache, options.hasOwnProperty("bidItem"));
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
  return o;
}

factories["BidItemEstimate"] = newBidItemEstimate;

export interface SaveBidItemEstimateResultOptions {
  __typename?: "SaveBidItemEstimateResult";
  bidItemEstimate?: BidItemEstimate | BidItemEstimateOptions;
}

export function newSaveBidItemEstimateResult(
  options: SaveBidItemEstimateResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidItemEstimateResult {
  const o = (options.__typename ? options : cache["SaveBidItemEstimateResult"] = {}) as SaveBidItemEstimateResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidItemEstimateResult";
  o.bidItemEstimate = maybeNew(
    "BidItemEstimate",
    options.bidItemEstimate,
    cache,
    options.hasOwnProperty("bidItemEstimate"),
  );
  return o;
}

factories["SaveBidItemEstimateResult"] = newSaveBidItemEstimateResult;

export interface BidItemEstimatesPageResultOptions {
  __typename?: "BidItemEstimatesPageResult";
  entities?: Array<BidItemEstimate | BidItemEstimateOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newBidItemEstimatesPageResult(
  options: BidItemEstimatesPageResultOptions = {},
  cache: Record<string, any> = {},
): BidItemEstimatesPageResult {
  const o = (options.__typename ? options : cache["BidItemEstimatesPageResult"] = {}) as BidItemEstimatesPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidItemEstimatesPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("BidItemEstimate", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["BidItemEstimatesPageResult"] = newBidItemEstimatesPageResult;

export interface MigrateBidPackageCostsResultOptions {
  __typename?: "MigrateBidPackageCostsResult";
  trackedJob?: TrackedJob | TrackedJobOptions;
}

export function newMigrateBidPackageCostsResult(
  options: MigrateBidPackageCostsResultOptions = {},
  cache: Record<string, any> = {},
): MigrateBidPackageCostsResult {
  const o = (options.__typename ? options : cache["MigrateBidPackageCostsResult"] = {}) as MigrateBidPackageCostsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MigrateBidPackageCostsResult";
  o.trackedJob = maybeNew("TrackedJob", options.trackedJob, cache, options.hasOwnProperty("trackedJob"));
  return o;
}

factories["MigrateBidPackageCostsResult"] = newMigrateBidPackageCostsResult;

export interface BidPackageOptions {
  __typename?: "BidPackage";
  id?: BidPackage["id"];
  name?: BidPackage["name"];
  costCodesName?: BidPackage["costCodesName"];
  createdAt?: BidPackage["createdAt"];
  updatedAt?: BidPackage["updatedAt"];
  productOfferings?: Array<ProductOffering | ProductOfferingOptions>;
  status?: BidPackageStatusDetailOptions | BidPackageStatus;
  lineItems?: Array<BidPackageLineItem | BidPackageLineItemOptions>;
  requests?: Array<BidPackageRequest | BidPackageRequestOptions>;
  potentialBidPackageLineItems?: Array<BidItem | BidItemOptions>;
  bidPackageGroup?: BidPackageGroup | BidPackageGroupOptions | null;
  scopeLines?: Array<BidPackageScopeLine | BidPackageScopeLineOptions>;
  awards?: Array<BidPackageAward | BidPackageAwardOptions>;
  costCodes?: Array<CostCode | CostCodeOptions>;
  costType?: CostTypeDetailOptions | CostType;
  basePlanGlobalPlanTasks?: Array<GlobalPlanTask | GlobalPlanTaskOptions>;
  isUnitBased?: BidPackage["isUnitBased"];
  versions?: Array<BidPackageVersion | BidPackageVersionOptions>;
  latestVersion?: BidPackageVersion | BidPackageVersionOptions;
  canComplete?: PotentialOperation2 | PotentialOperation2Options;
  versionNotes?: BidPackage["versionNotes"];
  availableUpdates?: Array<BidPackageIncomingUpdate | BidPackageIncomingUpdateOptions>;
  activeRequests?: Array<BidPackageRequest | BidPackageRequestOptions>;
  activeBidders?: Array<BidPackageBidder | BidPackageBidderOptions>;
  bidders?: Array<BidPackageBidder | BidPackageBidderOptions>;
  scopeHasChanged?: BidPackage["scopeHasChanged"];
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  canReviseCosts?: PotentialOperation2 | PotentialOperation2Options;
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  relevantMarket?: Market | MarketOptions;
  primaryHomeboundUser?: User | UserOptions | null;
  secondaryHomeboundUsers?: Array<User | UserOptions>;
  overlappingBidPackages?: Array<BidPackage | BidPackageOptions>;
  latestAwards?: Array<BidPackageAward | BidPackageAwardOptions>;
  scopeSource?: BidScopeSourceDetailOptions | BidScopeSource;
  isProjectLevelBidding?: BidPackage["isProjectLevelBidding"];
  isPlanBasedV2?: BidPackage["isPlanBasedV2"];
  internalEstimateBidContract?: BidContract | BidContractOptions | null;
  archivedAt?: BidPackage["archivedAt"];
  lastAwardedAt?: BidPackage["lastAwardedAt"];
  bidPlanGroups?: Array<BidPlanGroup | BidPlanGroupOptions>;
  scopedLineItems?: Array<BidPlanChildGroupScopedLine | BidPlanChildGroupScopedLineOptions>;
  potentialBidPlanOptions?: Array<PotentialBidPlanOption | PotentialBidPlanOptionOptions>;
  optionsMissingFromPackage?: Array<MissingBidPlanOption | MissingBidPlanOptionOptions>;
  isMissingOptions?: BidPackage["isMissingOptions"];
}

export function newBidPackage(options: BidPackageOptions = {}, cache: Record<string, any> = {}): BidPackage {
  const o = (options.__typename ? options : cache["BidPackage"] = {}) as BidPackage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackage";
  o.id = options.id ?? nextFactoryId("BidPackage");
  o.name = options.name ?? "name";
  o.costCodesName = options.costCodesName ?? "costCodesName";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.productOfferings = (options.productOfferings ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("productOfferings"))
  );
  o.status = enumOrDetailOfBidPackageStatus(options.status);
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("BidPackageLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.requests = (options.requests ?? []).map((i) =>
    maybeNew("BidPackageRequest", i, cache, options.hasOwnProperty("requests"))
  );
  o.potentialBidPackageLineItems = (options.potentialBidPackageLineItems ?? []).map((i) =>
    maybeNew("BidItem", i, cache, options.hasOwnProperty("potentialBidPackageLineItems"))
  );
  o.bidPackageGroup = maybeNewOrNull("BidPackageGroup", options.bidPackageGroup, cache);
  o.scopeLines = (options.scopeLines ?? []).map((i) =>
    maybeNew("BidPackageScopeLine", i, cache, options.hasOwnProperty("scopeLines"))
  );
  o.awards = (options.awards ?? []).map((i) => maybeNew("BidPackageAward", i, cache, options.hasOwnProperty("awards")));
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.costType = enumOrDetailOfCostType(options.costType);
  o.basePlanGlobalPlanTasks = (options.basePlanGlobalPlanTasks ?? []).map((i) =>
    maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("basePlanGlobalPlanTasks"))
  );
  o.isUnitBased = options.isUnitBased ?? false;
  o.versions = (options.versions ?? []).map((i) =>
    maybeNew("BidPackageVersion", i, cache, options.hasOwnProperty("versions"))
  );
  o.latestVersion = maybeNew(
    "BidPackageVersion",
    options.latestVersion,
    cache,
    options.hasOwnProperty("latestVersion"),
  );
  o.canComplete = maybeNew("PotentialOperation2", options.canComplete, cache, options.hasOwnProperty("canComplete"));
  o.versionNotes = options.versionNotes ?? null;
  o.availableUpdates = (options.availableUpdates ?? []).map((i) =>
    maybeNew("BidPackageIncomingUpdate", i, cache, options.hasOwnProperty("availableUpdates"))
  );
  o.activeRequests = (options.activeRequests ?? []).map((i) =>
    maybeNew("BidPackageRequest", i, cache, options.hasOwnProperty("activeRequests"))
  );
  o.activeBidders = (options.activeBidders ?? []).map((i) =>
    maybeNew("BidPackageBidder", i, cache, options.hasOwnProperty("activeBidders"))
  );
  o.bidders = (options.bidders ?? []).map((i) =>
    maybeNew("BidPackageBidder", i, cache, options.hasOwnProperty("bidders"))
  );
  o.scopeHasChanged = options.scopeHasChanged ?? false;
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.canReviseCosts = maybeNew(
    "PotentialOperation2",
    options.canReviseCosts,
    cache,
    options.hasOwnProperty("canReviseCosts"),
  );
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  o.relevantMarket = maybeNew("Market", options.relevantMarket, cache, options.hasOwnProperty("relevantMarket"));
  o.primaryHomeboundUser = maybeNewOrNull("User", options.primaryHomeboundUser, cache);
  o.secondaryHomeboundUsers = (options.secondaryHomeboundUsers ?? []).map((i) =>
    maybeNew("User", i, cache, options.hasOwnProperty("secondaryHomeboundUsers"))
  );
  o.overlappingBidPackages = (options.overlappingBidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("overlappingBidPackages"))
  );
  o.latestAwards = (options.latestAwards ?? []).map((i) =>
    maybeNew("BidPackageAward", i, cache, options.hasOwnProperty("latestAwards"))
  );
  o.scopeSource = enumOrDetailOfBidScopeSource(options.scopeSource);
  o.isProjectLevelBidding = options.isProjectLevelBidding ?? false;
  o.isPlanBasedV2 = options.isPlanBasedV2 ?? false;
  o.internalEstimateBidContract = maybeNewOrNull("BidContract", options.internalEstimateBidContract, cache);
  o.archivedAt = options.archivedAt ?? null;
  o.lastAwardedAt = options.lastAwardedAt ?? null;
  o.bidPlanGroups = (options.bidPlanGroups ?? []).map((i) =>
    maybeNew("BidPlanGroup", i, cache, options.hasOwnProperty("bidPlanGroups"))
  );
  o.scopedLineItems = (options.scopedLineItems ?? []).map((i) =>
    maybeNew("BidPlanChildGroupScopedLine", i, cache, options.hasOwnProperty("scopedLineItems"))
  );
  o.potentialBidPlanOptions = (options.potentialBidPlanOptions ?? []).map((i) =>
    maybeNew("PotentialBidPlanOption", i, cache, options.hasOwnProperty("potentialBidPlanOptions"))
  );
  o.optionsMissingFromPackage = (options.optionsMissingFromPackage ?? []).map((i) =>
    maybeNew("MissingBidPlanOption", i, cache, options.hasOwnProperty("optionsMissingFromPackage"))
  );
  o.isMissingOptions = options.isMissingOptions ?? false;
  return o;
}

factories["BidPackage"] = newBidPackage;

export interface PotentialBidPlanOptionOptions {
  __typename?: "PotentialBidPlanOption";
  globalOption?: GlobalOption | GlobalOptionOptions;
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
}

export function newPotentialBidPlanOption(
  options: PotentialBidPlanOptionOptions = {},
  cache: Record<string, any> = {},
): PotentialBidPlanOption {
  const o = (options.__typename ? options : cache["PotentialBidPlanOption"] = {}) as PotentialBidPlanOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PotentialBidPlanOption";
  o.globalOption = maybeNew("GlobalOption", options.globalOption, cache, options.hasOwnProperty("globalOption"));
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  return o;
}

factories["PotentialBidPlanOption"] = newPotentialBidPlanOption;

export interface MissingBidPlanOptionOptions {
  __typename?: "MissingBidPlanOption";
  globalOption?: GlobalOption | GlobalOptionOptions;
  productOfferings?: Array<ProductOffering | ProductOfferingOptions>;
}

export function newMissingBidPlanOption(
  options: MissingBidPlanOptionOptions = {},
  cache: Record<string, any> = {},
): MissingBidPlanOption {
  const o = (options.__typename ? options : cache["MissingBidPlanOption"] = {}) as MissingBidPlanOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MissingBidPlanOption";
  o.globalOption = maybeNew("GlobalOption", options.globalOption, cache, options.hasOwnProperty("globalOption"));
  o.productOfferings = (options.productOfferings ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("productOfferings"))
  );
  return o;
}

factories["MissingBidPlanOption"] = newMissingBidPlanOption;

export interface BidPackageScopeLineOptions {
  __typename?: "BidPackageScopeLine";
  takeoffLineItemVersion?: TakeoffLineItemVersion | TakeoffLineItemVersionOptions;
  changeType?: BidPackageScopeLine["changeType"];
  previous?: TakeoffLineItemVersion | TakeoffLineItemVersionOptions | null;
}

export function newBidPackageScopeLine(
  options: BidPackageScopeLineOptions = {},
  cache: Record<string, any> = {},
): BidPackageScopeLine {
  const o = (options.__typename ? options : cache["BidPackageScopeLine"] = {}) as BidPackageScopeLine;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageScopeLine";
  o.takeoffLineItemVersion = maybeNew(
    "TakeoffLineItemVersion",
    options.takeoffLineItemVersion,
    cache,
    options.hasOwnProperty("takeoffLineItemVersion"),
  );
  o.changeType = options.changeType ?? null;
  o.previous = maybeNewOrNull("TakeoffLineItemVersion", options.previous, cache);
  return o;
}

factories["BidPackageScopeLine"] = newBidPackageScopeLine;

export interface SaveBidPackageResultOptions {
  __typename?: "SaveBidPackageResult";
  bidPackage?: BidPackage | BidPackageOptions;
}

export function newSaveBidPackageResult(
  options: SaveBidPackageResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidPackageResult {
  const o = (options.__typename ? options : cache["SaveBidPackageResult"] = {}) as SaveBidPackageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidPackageResult";
  o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
  return o;
}

factories["SaveBidPackageResult"] = newSaveBidPackageResult;

export interface SaveBidPackagesResultOptions {
  __typename?: "SaveBidPackagesResult";
  bidPackages?: Array<BidPackage | BidPackageOptions>;
}

export function newSaveBidPackagesResult(
  options: SaveBidPackagesResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidPackagesResult {
  const o = (options.__typename ? options : cache["SaveBidPackagesResult"] = {}) as SaveBidPackagesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidPackagesResult";
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  return o;
}

factories["SaveBidPackagesResult"] = newSaveBidPackagesResult;

export interface OverlappingBidPackagesResultOptions {
  __typename?: "OverlappingBidPackagesResult";
  bidPackages?: Array<BidPackage | BidPackageOptions>;
}

export function newOverlappingBidPackagesResult(
  options: OverlappingBidPackagesResultOptions = {},
  cache: Record<string, any> = {},
): OverlappingBidPackagesResult {
  const o = (options.__typename ? options : cache["OverlappingBidPackagesResult"] = {}) as OverlappingBidPackagesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "OverlappingBidPackagesResult";
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  return o;
}

factories["OverlappingBidPackagesResult"] = newOverlappingBidPackagesResult;

export interface ReviseBidPackageCostsResultOptions {
  __typename?: "ReviseBidPackageCostsResult";
  bidPackage?: BidPackage | BidPackageOptions;
}

export function newReviseBidPackageCostsResult(
  options: ReviseBidPackageCostsResultOptions = {},
  cache: Record<string, any> = {},
): ReviseBidPackageCostsResult {
  const o = (options.__typename ? options : cache["ReviseBidPackageCostsResult"] = {}) as ReviseBidPackageCostsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReviseBidPackageCostsResult";
  o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
  return o;
}

factories["ReviseBidPackageCostsResult"] = newReviseBidPackageCostsResult;

export interface PotentialBidPlanDimensionResultOptions {
  __typename?: "PotentialBidPlanDimensionResult";
  id?: PotentialBidPlanDimensionResult["id"];
  kind?: PotentialBidPlanDimensionResult["kind"];
  type?: GlobalOptionType | GlobalOptionTypeOptions | null;
  group?: GlobalOptionGroup | GlobalOptionGroupOptions | null;
  options?: Array<GlobalOption | GlobalOptionOptions>;
  productOfferings?: Array<ProductOffering | ProductOfferingOptions>;
  displayName?: PotentialBidPlanDimensionResult["displayName"];
}

export function newPotentialBidPlanDimensionResult(
  options: PotentialBidPlanDimensionResultOptions = {},
  cache: Record<string, any> = {},
): PotentialBidPlanDimensionResult {
  const o =
    (options.__typename ? options : cache["PotentialBidPlanDimensionResult"] = {}) as PotentialBidPlanDimensionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PotentialBidPlanDimensionResult";
  o.id = options.id ?? nextFactoryId("PotentialBidPlanDimensionResult");
  o.kind = options.kind ?? PotentialBidPlanDimensionKind.GlobalOptionType;
  o.type = maybeNewOrNull("GlobalOptionType", options.type, cache);
  o.group = maybeNewOrNull("GlobalOptionGroup", options.group, cache);
  o.options = (options.options ?? []).map((i) => maybeNew("GlobalOption", i, cache, options.hasOwnProperty("options")));
  o.productOfferings = (options.productOfferings ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("productOfferings"))
  );
  o.displayName = options.displayName ?? "displayName";
  return o;
}

factories["PotentialBidPlanDimensionResult"] = newPotentialBidPlanDimensionResult;

export interface BidPackageBidderOptions {
  __typename?: "BidPackageBidder";
  id?: BidPackageBidder["id"];
  name?: BidPackageBidder["name"];
  kind?: BidPackageBidder["kind"];
  bidContract?: BidContract | BidContractOptions | null;
  tradePartner?: TradePartner | TradePartnerOptions | null;
  request?: BidPackageRequest | BidPackageRequestOptions | null;
  archivedAt?: BidPackageBidder["archivedAt"];
  hasCosts?: BidPackageBidder["hasCosts"];
}

export function newBidPackageBidder(
  options: BidPackageBidderOptions = {},
  cache: Record<string, any> = {},
): BidPackageBidder {
  const o = (options.__typename ? options : cache["BidPackageBidder"] = {}) as BidPackageBidder;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageBidder";
  o.id = options.id ?? nextFactoryId("BidPackageBidder");
  o.name = options.name ?? "name";
  o.kind = options.kind ?? BidPackageBidderKind.TradeRequest;
  o.bidContract = maybeNewOrNull("BidContract", options.bidContract, cache);
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.request = maybeNewOrNull("BidPackageRequest", options.request, cache);
  o.archivedAt = options.archivedAt ?? null;
  o.hasCosts = options.hasCosts ?? false;
  return o;
}

factories["BidPackageBidder"] = newBidPackageBidder;

export interface BidPlanChildGroupScopedLineOptions {
  __typename?: "BidPlanChildGroupScopedLine";
  id?: BidPlanChildGroupScopedLine["id"];
  group?: BidPlanGroup | BidPlanGroupOptions;
  childGroup?: BidPlanChildGroup | BidPlanChildGroupOptions;
  groupLine?: BidPlanChildGroupLine | BidPlanChildGroupLineOptions | null;
  scopeLines?: Array<BidPackageScopeLine | BidPackageScopeLineOptions>;
}

export function newBidPlanChildGroupScopedLine(
  options: BidPlanChildGroupScopedLineOptions = {},
  cache: Record<string, any> = {},
): BidPlanChildGroupScopedLine {
  const o = (options.__typename ? options : cache["BidPlanChildGroupScopedLine"] = {}) as BidPlanChildGroupScopedLine;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPlanChildGroupScopedLine";
  o.id = options.id ?? nextFactoryId("BidPlanChildGroupScopedLine");
  o.group = maybeNew("BidPlanGroup", options.group, cache, options.hasOwnProperty("group"));
  o.childGroup = maybeNew("BidPlanChildGroup", options.childGroup, cache, options.hasOwnProperty("childGroup"));
  o.groupLine = maybeNewOrNull("BidPlanChildGroupLine", options.groupLine, cache);
  o.scopeLines = (options.scopeLines ?? []).map((i) =>
    maybeNew("BidPackageScopeLine", i, cache, options.hasOwnProperty("scopeLines"))
  );
  return o;
}

factories["BidPlanChildGroupScopedLine"] = newBidPlanChildGroupScopedLine;

export interface CostCodeBidCoverageResultOptions {
  __typename?: "CostCodeBidCoverageResult";
  costCode?: CostCode | CostCodeOptions | null;
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  alerts?: Array<CostCodeBidCoverageAlert | CostCodeBidCoverageAlertOptions>;
}

export function newCostCodeBidCoverageResult(
  options: CostCodeBidCoverageResultOptions = {},
  cache: Record<string, any> = {},
): CostCodeBidCoverageResult {
  const o = (options.__typename ? options : cache["CostCodeBidCoverageResult"] = {}) as CostCodeBidCoverageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostCodeBidCoverageResult";
  o.costCode = maybeNewOrNull("CostCode", options.costCode, cache);
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.alerts = (options.alerts ?? []).map((i) =>
    maybeNew("CostCodeBidCoverageAlert", i, cache, options.hasOwnProperty("alerts"))
  );
  return o;
}

factories["CostCodeBidCoverageResult"] = newCostCodeBidCoverageResult;

export interface CostCodeBidCoverageAlertOptions {
  __typename?: "CostCodeBidCoverageAlert";
  title?: CostCodeBidCoverageAlert["title"];
  type?: CostCodeBidCoverageAlert["type"];
  tooltip?: CostCodeBidCoverageAlert["tooltip"];
}

export function newCostCodeBidCoverageAlert(
  options: CostCodeBidCoverageAlertOptions = {},
  cache: Record<string, any> = {},
): CostCodeBidCoverageAlert {
  const o = (options.__typename ? options : cache["CostCodeBidCoverageAlert"] = {}) as CostCodeBidCoverageAlert;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostCodeBidCoverageAlert";
  o.title = options.title ?? "title";
  o.type = options.type ?? CostCodeBidCoverageAlertType.MissingTakeoffs;
  o.tooltip = options.tooltip ?? "tooltip";
  return o;
}

factories["CostCodeBidCoverageAlert"] = newCostCodeBidCoverageAlert;

export interface BidPackageAwardOptions {
  __typename?: "BidPackageAward";
  id?: BidPackageAward["id"];
  createdAt?: BidPackageAward["createdAt"];
  updatedAt?: BidPackageAward["updatedAt"];
  primaryRevision?: BidContractRevision | BidContractRevisionOptions;
  secondaryRevision?: BidContractRevision | BidContractRevisionOptions | null;
  costCode?: CostCode | CostCodeOptions;
  bidPackageVersion?: BidPackageVersion | BidPackageVersionOptions | null;
}

export function newBidPackageAward(
  options: BidPackageAwardOptions = {},
  cache: Record<string, any> = {},
): BidPackageAward {
  const o = (options.__typename ? options : cache["BidPackageAward"] = {}) as BidPackageAward;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageAward";
  o.id = options.id ?? nextFactoryId("BidPackageAward");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.primaryRevision = maybeNew(
    "BidContractRevision",
    options.primaryRevision,
    cache,
    options.hasOwnProperty("primaryRevision"),
  );
  o.secondaryRevision = maybeNewOrNull("BidContractRevision", options.secondaryRevision, cache);
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.bidPackageVersion = maybeNewOrNull("BidPackageVersion", options.bidPackageVersion, cache);
  return o;
}

factories["BidPackageAward"] = newBidPackageAward;

export interface SaveBidPackageAwardsResultOptions {
  __typename?: "SaveBidPackageAwardsResult";
  bidPackageAwards?: Array<BidPackageAward | BidPackageAwardOptions>;
}

export function newSaveBidPackageAwardsResult(
  options: SaveBidPackageAwardsResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidPackageAwardsResult {
  const o = (options.__typename ? options : cache["SaveBidPackageAwardsResult"] = {}) as SaveBidPackageAwardsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidPackageAwardsResult";
  o.bidPackageAwards = (options.bidPackageAwards ?? []).map((i) =>
    maybeNew("BidPackageAward", i, cache, options.hasOwnProperty("bidPackageAwards"))
  );
  return o;
}

factories["SaveBidPackageAwardsResult"] = newSaveBidPackageAwardsResult;

export interface BidPackageGroupOptions {
  __typename?: "BidPackageGroup";
  id?: BidPackageGroup["id"];
  createdAt?: BidPackageGroup["createdAt"];
  updatedAt?: BidPackageGroup["updatedAt"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  displayName?: BidPackageGroup["displayName"];
  productOfferings?: Array<ProductOffering | ProductOfferingOptions>;
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  status?: BidPackageStatusDetailOptions | BidPackageStatus;
  isPlanBasedV2?: BidPackageGroup["isPlanBasedV2"];
}

export function newBidPackageGroup(
  options: BidPackageGroupOptions = {},
  cache: Record<string, any> = {},
): BidPackageGroup {
  const o = (options.__typename ? options : cache["BidPackageGroup"] = {}) as BidPackageGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageGroup";
  o.id = options.id ?? nextFactoryId("BidPackageGroup");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.displayName = options.displayName ?? "displayName";
  o.productOfferings = (options.productOfferings ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("productOfferings"))
  );
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  o.status = enumOrDetailOfBidPackageStatus(options.status);
  o.isPlanBasedV2 = options.isPlanBasedV2 ?? false;
  return o;
}

factories["BidPackageGroup"] = newBidPackageGroup;

export interface BidPackageGroupProductOfferingsResultOptions {
  __typename?: "BidPackageGroupProductOfferingsResult";
  productOfferingInfos?: Array<ProductOfferingInfo | ProductOfferingInfoOptions>;
}

export function newBidPackageGroupProductOfferingsResult(
  options: BidPackageGroupProductOfferingsResultOptions = {},
  cache: Record<string, any> = {},
): BidPackageGroupProductOfferingsResult {
  const o =
    (options.__typename
      ? options
      : cache["BidPackageGroupProductOfferingsResult"] = {}) as BidPackageGroupProductOfferingsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageGroupProductOfferingsResult";
  o.productOfferingInfos = (options.productOfferingInfos ?? []).map((i) =>
    maybeNew("ProductOfferingInfo", i, cache, options.hasOwnProperty("productOfferingInfos"))
  );
  return o;
}

factories["BidPackageGroupProductOfferingsResult"] = newBidPackageGroupProductOfferingsResult;

export interface ProductOfferingInfoOptions {
  __typename?: "ProductOfferingInfo";
  productOffering?: ProductOffering | ProductOfferingOptions;
  bidPackage?: BidPackage | BidPackageOptions;
  numberOfLineItems?: ProductOfferingInfo["numberOfLineItems"];
  relevantOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
}

export function newProductOfferingInfo(
  options: ProductOfferingInfoOptions = {},
  cache: Record<string, any> = {},
): ProductOfferingInfo {
  const o = (options.__typename ? options : cache["ProductOfferingInfo"] = {}) as ProductOfferingInfo;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductOfferingInfo";
  o.productOffering = maybeNew(
    "ProductOffering",
    options.productOffering,
    cache,
    options.hasOwnProperty("productOffering"),
  );
  o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
  o.numberOfLineItems = options.numberOfLineItems ?? 0;
  o.relevantOptions = (options.relevantOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("relevantOptions"))
  );
  return o;
}

factories["ProductOfferingInfo"] = newProductOfferingInfo;

export interface BidPackageGroupsPageResultOptions {
  __typename?: "BidPackageGroupsPageResult";
  entities?: Array<BidPackageGroup | BidPackageGroupOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newBidPackageGroupsPageResult(
  options: BidPackageGroupsPageResultOptions = {},
  cache: Record<string, any> = {},
): BidPackageGroupsPageResult {
  const o = (options.__typename ? options : cache["BidPackageGroupsPageResult"] = {}) as BidPackageGroupsPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageGroupsPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("BidPackageGroup", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["BidPackageGroupsPageResult"] = newBidPackageGroupsPageResult;

export interface BidPackageIncomingUpdateOptions {
  __typename?: "BidPackageIncomingUpdate";
  id?: BidPackageIncomingUpdate["id"];
  accepted?: BidPackageIncomingUpdate["accepted"];
  createdAt?: BidPackageIncomingUpdate["createdAt"];
  updatedAt?: BidPackageIncomingUpdate["updatedAt"];
  bidPackage?: BidPackage | BidPackageOptions;
  source?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  updateStats?: BidPackageIncomingUpdateStats | BidPackageIncomingUpdateStatsOptions;
}

export function newBidPackageIncomingUpdate(
  options: BidPackageIncomingUpdateOptions = {},
  cache: Record<string, any> = {},
): BidPackageIncomingUpdate {
  const o = (options.__typename ? options : cache["BidPackageIncomingUpdate"] = {}) as BidPackageIncomingUpdate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageIncomingUpdate";
  o.id = options.id ?? nextFactoryId("BidPackageIncomingUpdate");
  o.accepted = options.accepted ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
  o.source = maybeNew("ReadyPlanAggregateVersion", options.source, cache, options.hasOwnProperty("source"));
  o.updateStats = maybeNew(
    "BidPackageIncomingUpdateStats",
    options.updateStats,
    cache,
    options.hasOwnProperty("updateStats"),
  );
  return o;
}

factories["BidPackageIncomingUpdate"] = newBidPackageIncomingUpdate;

export interface BidPackageIncomingUpdateStatsOptions {
  __typename?: "BidPackageIncomingUpdateStats";
  tlivs?: IncomingChanges | IncomingChangesOptions;
  rplvs?: IncomingChanges | IncomingChangesOptions;
}

export function newBidPackageIncomingUpdateStats(
  options: BidPackageIncomingUpdateStatsOptions = {},
  cache: Record<string, any> = {},
): BidPackageIncomingUpdateStats {
  const o =
    (options.__typename ? options : cache["BidPackageIncomingUpdateStats"] = {}) as BidPackageIncomingUpdateStats;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageIncomingUpdateStats";
  o.tlivs = maybeNew("IncomingChanges", options.tlivs, cache, options.hasOwnProperty("tlivs"));
  o.rplvs = maybeNew("IncomingChanges", options.rplvs, cache, options.hasOwnProperty("rplvs"));
  return o;
}

factories["BidPackageIncomingUpdateStats"] = newBidPackageIncomingUpdateStats;

export interface IncomingChangesOptions {
  __typename?: "IncomingChanges";
  added?: IncomingChanges["added"];
  removed?: IncomingChanges["removed"];
  updated?: IncomingChanges["updated"];
}

export function newIncomingChanges(
  options: IncomingChangesOptions = {},
  cache: Record<string, any> = {},
): IncomingChanges {
  const o = (options.__typename ? options : cache["IncomingChanges"] = {}) as IncomingChanges;
  (cache.all ??= new Set()).add(o);
  o.__typename = "IncomingChanges";
  o.added = options.added ?? 0;
  o.removed = options.removed ?? 0;
  o.updated = options.updated ?? 0;
  return o;
}

factories["IncomingChanges"] = newIncomingChanges;

export interface BidPackageLineItemOptions {
  __typename?: "BidPackageLineItem";
  id?: BidPackageLineItem["id"];
  createdAt?: BidPackageLineItem["createdAt"];
  updatedAt?: BidPackageLineItem["updatedAt"];
  bidItem?: BidItem | BidItemOptions;
  bidPackageVersion?: BidPackageVersion | BidPackageVersionOptions | null;
  isInUse?: BidPackageLineItem["isInUse"];
  hasBidderCost?: BidPackageLineItem["hasBidderCost"];
}

export function newBidPackageLineItem(
  options: BidPackageLineItemOptions = {},
  cache: Record<string, any> = {},
): BidPackageLineItem {
  const o = (options.__typename ? options : cache["BidPackageLineItem"] = {}) as BidPackageLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageLineItem";
  o.id = options.id ?? nextFactoryId("BidPackageLineItem");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.bidItem = maybeNew("BidItem", options.bidItem, cache, options.hasOwnProperty("bidItem"));
  o.bidPackageVersion = maybeNewOrNull("BidPackageVersion", options.bidPackageVersion, cache);
  o.isInUse = options.isInUse ?? false;
  o.hasBidderCost = options.hasBidderCost ?? false;
  return o;
}

factories["BidPackageLineItem"] = newBidPackageLineItem;

export interface BidPackageRequestOptions {
  __typename?: "BidPackageRequest";
  id?: BidPackageRequest["id"];
  name?: BidPackageRequest["name"];
  blueprintUrl?: Url | UrlOptions;
  createdAt?: BidPackageRequest["createdAt"];
  updatedAt?: BidPackageRequest["updatedAt"];
  bidPackage?: BidPackage | BidPackageOptions;
  tradePartner?: TradePartner | TradePartnerOptions;
  primaryContact?: TradePartnerContact | TradePartnerContactOptions | null;
  secondaryContact?: TradePartnerContact | TradePartnerContactOptions | null;
  bidContract?: BidContract | BidContractOptions | null;
  sentDate?: BidPackageRequest["sentDate"];
  archivedAt?: BidPackageRequest["archivedAt"];
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: BidPackageRequest["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: BidPackageRequest["isFollowed"];
}

export function newBidPackageRequest(
  options: BidPackageRequestOptions = {},
  cache: Record<string, any> = {},
): BidPackageRequest {
  const o = (options.__typename ? options : cache["BidPackageRequest"] = {}) as BidPackageRequest;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageRequest";
  o.id = options.id ?? nextFactoryId("BidPackageRequest");
  o.name = options.name ?? "name";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.primaryContact = maybeNewOrNull("TradePartnerContact", options.primaryContact, cache);
  o.secondaryContact = maybeNewOrNull("TradePartnerContact", options.secondaryContact, cache);
  o.bidContract = maybeNewOrNull("BidContract", options.bidContract, cache);
  o.sentDate = options.sentDate ?? null;
  o.archivedAt = options.archivedAt ?? null;
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  return o;
}

factories["BidPackageRequest"] = newBidPackageRequest;

export interface SaveBidPackageRequestResultOptions {
  __typename?: "SaveBidPackageRequestResult";
  bidPackageRequest?: BidPackageRequest | BidPackageRequestOptions;
}

export function newSaveBidPackageRequestResult(
  options: SaveBidPackageRequestResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidPackageRequestResult {
  const o = (options.__typename ? options : cache["SaveBidPackageRequestResult"] = {}) as SaveBidPackageRequestResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidPackageRequestResult";
  o.bidPackageRequest = maybeNew(
    "BidPackageRequest",
    options.bidPackageRequest,
    cache,
    options.hasOwnProperty("bidPackageRequest"),
  );
  return o;
}

factories["SaveBidPackageRequestResult"] = newSaveBidPackageRequestResult;

export interface BidPackageVersionOptions {
  __typename?: "BidPackageVersion";
  id?: BidPackageVersion["id"];
  createdAt?: BidPackageVersion["createdAt"];
  updatedAt?: BidPackageVersion["updatedAt"];
  displayVersion?: BidPackageVersion["displayVersion"];
  version?: BidPackageVersion["version"];
  status?: BidPackageStatusDetailOptions | BidPackageStatus;
  readyPlanAggregateVersions?: Array<ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions>;
  previous?: BidPackageVersion | BidPackageVersionOptions | null;
  lineItems?: Array<BidPackageLineItem | BidPackageLineItemOptions>;
  latestBidContractRevisions?: Array<BidContractRevision | BidContractRevisionOptions>;
  relevantTakeoffLineItemVersions?: Array<TakeoffLineItemVersion | TakeoffLineItemVersionOptions>;
  scopeLines?: Array<BidPackageScopeLine | BidPackageScopeLineOptions>;
  basePlanGlobalPlanTasks?: Array<GlobalPlanTask | GlobalPlanTaskOptions>;
  awards?: Array<BidPackageAward | BidPackageAwardOptions>;
  bidPackage?: BidPackage | BidPackageOptions;
  canComplete?: PotentialOperation2 | PotentialOperation2Options;
  canHaveDraws?: PotentialOperation2 | PotentialOperation2Options;
  costCodes?: Array<CostCode | CostCodeOptions>;
}

export function newBidPackageVersion(
  options: BidPackageVersionOptions = {},
  cache: Record<string, any> = {},
): BidPackageVersion {
  const o = (options.__typename ? options : cache["BidPackageVersion"] = {}) as BidPackageVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageVersion";
  o.id = options.id ?? nextFactoryId("BidPackageVersion");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.displayVersion = options.displayVersion ?? "displayVersion";
  o.version = options.version ?? 0;
  o.status = enumOrDetailOfBidPackageStatus(options.status);
  o.readyPlanAggregateVersions = (options.readyPlanAggregateVersions ?? []).map((i) =>
    maybeNew("ReadyPlanAggregateVersion", i, cache, options.hasOwnProperty("readyPlanAggregateVersions"))
  );
  o.previous = maybeNewOrNull("BidPackageVersion", options.previous, cache);
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("BidPackageLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.latestBidContractRevisions = (options.latestBidContractRevisions ?? []).map((i) =>
    maybeNew("BidContractRevision", i, cache, options.hasOwnProperty("latestBidContractRevisions"))
  );
  o.relevantTakeoffLineItemVersions = (options.relevantTakeoffLineItemVersions ?? []).map((i) =>
    maybeNew("TakeoffLineItemVersion", i, cache, options.hasOwnProperty("relevantTakeoffLineItemVersions"))
  );
  o.scopeLines = (options.scopeLines ?? []).map((i) =>
    maybeNew("BidPackageScopeLine", i, cache, options.hasOwnProperty("scopeLines"))
  );
  o.basePlanGlobalPlanTasks = (options.basePlanGlobalPlanTasks ?? []).map((i) =>
    maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("basePlanGlobalPlanTasks"))
  );
  o.awards = (options.awards ?? []).map((i) => maybeNew("BidPackageAward", i, cache, options.hasOwnProperty("awards")));
  o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
  o.canComplete = maybeNew("PotentialOperation2", options.canComplete, cache, options.hasOwnProperty("canComplete"));
  o.canHaveDraws = maybeNew("PotentialOperation2", options.canHaveDraws, cache, options.hasOwnProperty("canHaveDraws"));
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  return o;
}

factories["BidPackageVersion"] = newBidPackageVersion;

export interface BidPlanChildGroupOptions {
  __typename?: "BidPlanChildGroup";
  id?: BidPlanChildGroup["id"];
  displayName?: BidPlanChildGroup["displayName"];
  deletedAt?: BidPlanChildGroup["deletedAt"];
  createdAt?: BidPlanChildGroup["createdAt"];
  updatedAt?: BidPlanChildGroup["updatedAt"];
  group?: BidPlanGroup | BidPlanGroupOptions;
  productOffering?: ProductOffering | ProductOfferingOptions;
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions | null;
  readyPlanOptionGroup?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions | null;
  lines?: Array<BidPlanChildGroupLine | BidPlanChildGroupLineOptions>;
}

export function newBidPlanChildGroup(
  options: BidPlanChildGroupOptions = {},
  cache: Record<string, any> = {},
): BidPlanChildGroup {
  const o = (options.__typename ? options : cache["BidPlanChildGroup"] = {}) as BidPlanChildGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPlanChildGroup";
  o.id = options.id ?? nextFactoryId("BidPlanChildGroup");
  o.displayName = options.displayName ?? "displayName";
  o.deletedAt = options.deletedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.group = maybeNew("BidPlanGroup", options.group, cache, options.hasOwnProperty("group"));
  o.productOffering = maybeNew(
    "ProductOffering",
    options.productOffering,
    cache,
    options.hasOwnProperty("productOffering"),
  );
  o.readyPlanOption = maybeNewOrNull("ReadyPlanOption", options.readyPlanOption, cache);
  o.readyPlanOptionGroup = maybeNewOrNull("ReadyPlanOptionGroup", options.readyPlanOptionGroup, cache);
  o.lines = (options.lines ?? []).map((i) =>
    maybeNew("BidPlanChildGroupLine", i, cache, options.hasOwnProperty("lines"))
  );
  return o;
}

factories["BidPlanChildGroup"] = newBidPlanChildGroup;

export interface BidPlanChildGroupLineOptions {
  __typename?: "BidPlanChildGroupLine";
  id?: BidPlanChildGroupLine["id"];
  displayName?: BidPlanChildGroupLine["displayName"];
  deletedAt?: BidPlanChildGroupLine["deletedAt"];
  createdAt?: BidPlanChildGroupLine["createdAt"];
  updatedAt?: BidPlanChildGroupLine["updatedAt"];
  group?: BidPlanChildGroup | BidPlanChildGroupOptions;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  planBasedBidContractLineItems?: Array<PlanBasedBidContractLineItem | PlanBasedBidContractLineItemOptions>;
}

export function newBidPlanChildGroupLine(
  options: BidPlanChildGroupLineOptions = {},
  cache: Record<string, any> = {},
): BidPlanChildGroupLine {
  const o = (options.__typename ? options : cache["BidPlanChildGroupLine"] = {}) as BidPlanChildGroupLine;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPlanChildGroupLine";
  o.id = options.id ?? nextFactoryId("BidPlanChildGroupLine");
  o.displayName = options.displayName ?? "displayName";
  o.deletedAt = options.deletedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.group = maybeNew("BidPlanChildGroup", options.group, cache, options.hasOwnProperty("group"));
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.planBasedBidContractLineItems = (options.planBasedBidContractLineItems ?? []).map((i) =>
    maybeNew("PlanBasedBidContractLineItem", i, cache, options.hasOwnProperty("planBasedBidContractLineItems"))
  );
  return o;
}

factories["BidPlanChildGroupLine"] = newBidPlanChildGroupLine;

export interface BidPlanGroupOptions {
  __typename?: "BidPlanGroup";
  id?: BidPlanGroup["id"];
  displayName?: BidPlanGroup["displayName"];
  createdAt?: BidPlanGroup["createdAt"];
  updatedAt?: BidPlanGroup["updatedAt"];
  globalOption?: GlobalOption | GlobalOptionOptions | null;
  productOfferings?: Array<ProductOffering | ProductOfferingOptions>;
  dimensions?: Array<BidPlanGroupDimension | BidPlanGroupDimensionOptions>;
  order?: BidPlanGroup["order"];
  bidPackage?: BidPackage | BidPackageOptions;
  childGroups?: Array<BidPlanChildGroup | BidPlanChildGroupOptions>;
  deletedAt?: BidPlanGroup["deletedAt"];
  primaryOptionGroup?: GlobalOptionGroup | GlobalOptionGroupOptions | null;
  isNoCost?: BidPlanGroup["isNoCost"];
}

export function newBidPlanGroup(options: BidPlanGroupOptions = {}, cache: Record<string, any> = {}): BidPlanGroup {
  const o = (options.__typename ? options : cache["BidPlanGroup"] = {}) as BidPlanGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPlanGroup";
  o.id = options.id ?? nextFactoryId("BidPlanGroup");
  o.displayName = options.displayName ?? "displayName";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.globalOption = maybeNewOrNull("GlobalOption", options.globalOption, cache);
  o.productOfferings = (options.productOfferings ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("productOfferings"))
  );
  o.dimensions = (options.dimensions ?? []).map((i) =>
    maybeNew("BidPlanGroupDimension", i, cache, options.hasOwnProperty("dimensions"))
  );
  o.order = options.order ?? 0;
  o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
  o.childGroups = (options.childGroups ?? []).map((i) =>
    maybeNew("BidPlanChildGroup", i, cache, options.hasOwnProperty("childGroups"))
  );
  o.deletedAt = options.deletedAt ?? null;
  o.primaryOptionGroup = maybeNewOrNull("GlobalOptionGroup", options.primaryOptionGroup, cache);
  o.isNoCost = options.isNoCost ?? false;
  return o;
}

factories["BidPlanGroup"] = newBidPlanGroup;

export interface BidPlanGroupDimensionOptions {
  __typename?: "BidPlanGroupDimension";
  id?: BidPlanGroupDimension["id"];
  createdAt?: BidPlanGroupDimension["createdAt"];
  updatedAt?: BidPlanGroupDimension["updatedAt"];
  group?: BidPlanGroup | BidPlanGroupOptions;
  name?: BidPlanGroupDimension["name"];
  globalOptions?: Array<GlobalOption | GlobalOptionOptions>;
  globalOptionType?: GlobalOptionType | GlobalOptionTypeOptions | null;
  globalOptionGroup?: GlobalOptionGroup | GlobalOptionGroupOptions | null;
}

export function newBidPlanGroupDimension(
  options: BidPlanGroupDimensionOptions = {},
  cache: Record<string, any> = {},
): BidPlanGroupDimension {
  const o = (options.__typename ? options : cache["BidPlanGroupDimension"] = {}) as BidPlanGroupDimension;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPlanGroupDimension";
  o.id = options.id ?? nextFactoryId("BidPlanGroupDimension");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.group = maybeNew("BidPlanGroup", options.group, cache, options.hasOwnProperty("group"));
  o.name = options.name ?? "name";
  o.globalOptions = (options.globalOptions ?? []).map((i) =>
    maybeNew("GlobalOption", i, cache, options.hasOwnProperty("globalOptions"))
  );
  o.globalOptionType = maybeNewOrNull("GlobalOptionType", options.globalOptionType, cache);
  o.globalOptionGroup = maybeNewOrNull("GlobalOptionGroup", options.globalOptionGroup, cache);
  return o;
}

factories["BidPlanGroupDimension"] = newBidPlanGroupDimension;

export interface BillMetricsResultOptions {
  __typename?: "BillMetricsResult";
  openPayables?: Array<BillMetric | BillMetricOptions>;
  totalOpenPayables?: BillMetricsResult["totalOpenPayables"];
  agingOfPayables?: Array<BillMetric | BillMetricOptions>;
  totalAgingOfPayables?: BillMetricsResult["totalAgingOfPayables"];
  awaitingApprovals?: Array<BillMetric | BillMetricOptions>;
  totalAwaitingApprovals?: BillMetricsResult["totalAwaitingApprovals"];
}

export function newBillMetricsResult(
  options: BillMetricsResultOptions = {},
  cache: Record<string, any> = {},
): BillMetricsResult {
  const o = (options.__typename ? options : cache["BillMetricsResult"] = {}) as BillMetricsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillMetricsResult";
  o.openPayables = (options.openPayables ?? []).map((i) =>
    maybeNew("BillMetric", i, cache, options.hasOwnProperty("openPayables"))
  );
  o.totalOpenPayables = options.totalOpenPayables ?? 0;
  o.agingOfPayables = (options.agingOfPayables ?? []).map((i) =>
    maybeNew("BillMetric", i, cache, options.hasOwnProperty("agingOfPayables"))
  );
  o.totalAgingOfPayables = options.totalAgingOfPayables ?? 0;
  o.awaitingApprovals = (options.awaitingApprovals ?? []).map((i) =>
    maybeNew("BillMetric", i, cache, options.hasOwnProperty("awaitingApprovals"))
  );
  o.totalAwaitingApprovals = options.totalAwaitingApprovals ?? 0;
  return o;
}

factories["BillMetricsResult"] = newBillMetricsResult;

export interface BillMetricOptions {
  __typename?: "BillMetric";
  label?: BillMetric["label"];
  totalCount?: BillMetric["totalCount"];
  totalAmount?: BillMetric["totalAmount"];
}

export function newBillMetric(options: BillMetricOptions = {}, cache: Record<string, any> = {}): BillMetric {
  const o = (options.__typename ? options : cache["BillMetric"] = {}) as BillMetric;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillMetric";
  o.label = options.label ?? "label";
  o.totalCount = options.totalCount ?? 0;
  o.totalAmount = options.totalAmount ?? null;
  return o;
}

factories["BillMetric"] = newBillMetric;

export interface TradePartnerOptions {
  __typename?: "TradePartner";
  bills?: Array<Bill | BillOptions>;
  id?: TradePartner["id"];
  name?: TradePartner["name"];
  internalNote?: TradePartner["internalNote"];
  commitments?: Array<Commitment | CommitmentOptions>;
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  quickbooksId?: TradePartner["quickbooksId"];
  tasks?: Array<Task | TaskOptions>;
  markets?: Array<Market | MarketOptions>;
  users?: Array<TradePartnerUser | TradePartnerUserOptions>;
  contacts?: Array<TradePartnerContact | TradePartnerContactOptions>;
  doesMaterials?: TradePartner["doesMaterials"];
  doesLabor?: TradePartner["doesLabor"];
  isSweetheart?: TradePartner["isSweetheart"];
  sourceNote?: TradePartner["sourceNote"];
  source?: InternalUser | InternalUserOptions | null;
  website?: TradePartner["website"];
  agreements?: Array<TradePartnerAgreement | TradePartnerAgreementOptions>;
  reviews?: Array<TradePartnerReview | TradePartnerReviewOptions>;
  reviewCount?: TradePartner["reviewCount"];
  doNotUse?: TradePartner["doNotUse"];
  intacctId?: TradePartner["intacctId"];
  developmentCommitments?: Array<DevelopmentCommitment | DevelopmentCommitmentOptions>;
  costCodes?: Array<CostCode | CostCodeOptions>;
  tradeCategories?: Array<TradeCategory | TradeCategoryOptions>;
  requirements?: Array<TradePartnerRequirement | TradePartnerRequirementOptions>;
  meetsRequirements?: TradePartner["meetsRequirements"];
  meetsRequirementsExpiresAt?: TradePartner["meetsRequirementsExpiresAt"];
  meetsRequirementsExpiresOn?: TradePartner["meetsRequirementsExpiresOn"];
  averageScore?: TradePartner["averageScore"];
  homeboundAccountNumber?: TradePartner["homeboundAccountNumber"];
  bidContracts?: Array<BidContract | BidContractOptions>;
  createdAt?: TradePartner["createdAt"];
  onboardingStatus?: TradePartnerOnboardingStatusDetailOptions | TradePartnerOnboardingStatus;
  contactsForDevelopmentAndRoles?: Array<Maybe<TradePartnerContact | TradePartnerContactOptions>>;
  contactsForProjectAndRoles?: Array<Maybe<TradePartnerContact | TradePartnerContactOptions>>;
  contactsForMarket?: Array<Maybe<TradePartnerContact | TradePartnerContactOptions>>;
  billDueDateFor?: TradePartner["billDueDateFor"];
  primaryForMarket?: TradePartnerContact | TradePartnerContactOptions | null;
  signatoryForMarket?: TradePartnerContact | TradePartnerContactOptions | null;
  primaryForDevelopment?: TradePartnerContact | TradePartnerContactOptions | null;
  signatoryForDevelopment?: TradePartnerContact | TradePartnerContactOptions | null;
  billApproverForDevelopment?: TradePartnerContact | TradePartnerContactOptions | null;
  primaryForProject?: TradePartnerContact | TradePartnerContactOptions | null;
  signatoryForProject?: TradePartnerContact | TradePartnerContactOptions | null;
  billApproverForProject?: TradePartnerContact | TradePartnerContactOptions | null;
  marketContacts?: Array<TradePartnerMarketContact | TradePartnerMarketContactOptions>;
  pendingChangeEventsToCreateCommitments?: Array<ChangeEvent | ChangeEventOptions>;
  leadTimeInDays?: TradePartner["leadTimeInDays"];
  canLoginToPortal?: TradePartner["canLoginToPortal"];
  paymentTerm?: PaymentTerm | PaymentTermOptions;
  lienWaivers?: Array<LienWaiver | LienWaiverOptions>;
  enableClickToPay?: TradePartner["enableClickToPay"];
  isLienWaiverReceiver?: TradePartner["isLienWaiverReceiver"];
  activeTasksCount?: TradePartner["activeTasksCount"];
  activeProjectsCount?: TradePartner["activeProjectsCount"];
  activeContractsCount?: TradePartner["activeContractsCount"];
  totalBilledInCents?: TradePartner["totalBilledInCents"];
  totalPaidInCents?: TradePartner["totalPaidInCents"];
  totalCommittedInCents?: TradePartner["totalCommittedInCents"];
  commitmentCountThisWeek?: TradePartner["commitmentCountThisWeek"];
  commitmentCountLastWeek?: TradePartner["commitmentCountLastWeek"];
  bidPackageRequests?: Array<BidPackageRequest | BidPackageRequestOptions>;
}

export function newTradePartner(options: TradePartnerOptions = {}, cache: Record<string, any> = {}): TradePartner {
  const o = (options.__typename ? options : cache["TradePartner"] = {}) as TradePartner;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartner";
  o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
  o.id = options.id ?? nextFactoryId("TradePartner");
  o.name = options.name ?? "name";
  o.internalNote = options.internalNote ?? null;
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  o.quickbooksId = options.quickbooksId ?? null;
  o.tasks = (options.tasks ?? []).map((i) => maybeNew("Task", i, cache, options.hasOwnProperty("tasks")));
  o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
  o.users = (options.users ?? []).map((i) => maybeNew("TradePartnerUser", i, cache, options.hasOwnProperty("users")));
  o.contacts = (options.contacts ?? []).map((i) =>
    maybeNew("TradePartnerContact", i, cache, options.hasOwnProperty("contacts"))
  );
  o.doesMaterials = options.doesMaterials ?? false;
  o.doesLabor = options.doesLabor ?? false;
  o.isSweetheart = options.isSweetheart ?? false;
  o.sourceNote = options.sourceNote ?? null;
  o.source = maybeNewOrNull("InternalUser", options.source, cache);
  o.website = options.website ?? null;
  o.agreements = (options.agreements ?? []).map((i) =>
    maybeNew("TradePartnerAgreement", i, cache, options.hasOwnProperty("agreements"))
  );
  o.reviews = (options.reviews ?? []).map((i) =>
    maybeNew("TradePartnerReview", i, cache, options.hasOwnProperty("reviews"))
  );
  o.reviewCount = options.reviewCount ?? 0;
  o.doNotUse = options.doNotUse ?? false;
  o.intacctId = options.intacctId ?? null;
  o.developmentCommitments = (options.developmentCommitments ?? []).map((i) =>
    maybeNew("DevelopmentCommitment", i, cache, options.hasOwnProperty("developmentCommitments"))
  );
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.tradeCategories = (options.tradeCategories ?? []).map((i) =>
    maybeNew("TradeCategory", i, cache, options.hasOwnProperty("tradeCategories"))
  );
  o.requirements = (options.requirements ?? []).map((i) =>
    maybeNew("TradePartnerRequirement", i, cache, options.hasOwnProperty("requirements"))
  );
  o.meetsRequirements = options.meetsRequirements ?? false;
  o.meetsRequirementsExpiresAt = options.meetsRequirementsExpiresAt ?? null;
  o.meetsRequirementsExpiresOn = options.meetsRequirementsExpiresOn ?? null;
  o.averageScore = options.averageScore ?? "" as any;
  o.homeboundAccountNumber = options.homeboundAccountNumber ?? null;
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.createdAt = options.createdAt ?? newDateTime();
  o.onboardingStatus = enumOrDetailOfTradePartnerOnboardingStatus(options.onboardingStatus);
  o.contactsForDevelopmentAndRoles = (options.contactsForDevelopmentAndRoles ?? []).map((i) =>
    maybeNewOrNull("TradePartnerContact", i, cache)
  );
  o.contactsForProjectAndRoles = (options.contactsForProjectAndRoles ?? []).map((i) =>
    maybeNewOrNull("TradePartnerContact", i, cache)
  );
  o.contactsForMarket = (options.contactsForMarket ?? []).map((i) => maybeNewOrNull("TradePartnerContact", i, cache));
  o.billDueDateFor = options.billDueDateFor ?? newDate();
  o.primaryForMarket = maybeNewOrNull("TradePartnerContact", options.primaryForMarket, cache);
  o.signatoryForMarket = maybeNewOrNull("TradePartnerContact", options.signatoryForMarket, cache);
  o.primaryForDevelopment = maybeNewOrNull("TradePartnerContact", options.primaryForDevelopment, cache);
  o.signatoryForDevelopment = maybeNewOrNull("TradePartnerContact", options.signatoryForDevelopment, cache);
  o.billApproverForDevelopment = maybeNewOrNull("TradePartnerContact", options.billApproverForDevelopment, cache);
  o.primaryForProject = maybeNewOrNull("TradePartnerContact", options.primaryForProject, cache);
  o.signatoryForProject = maybeNewOrNull("TradePartnerContact", options.signatoryForProject, cache);
  o.billApproverForProject = maybeNewOrNull("TradePartnerContact", options.billApproverForProject, cache);
  o.marketContacts = (options.marketContacts ?? []).map((i) =>
    maybeNew("TradePartnerMarketContact", i, cache, options.hasOwnProperty("marketContacts"))
  );
  o.pendingChangeEventsToCreateCommitments = (options.pendingChangeEventsToCreateCommitments ?? []).map((i) =>
    maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("pendingChangeEventsToCreateCommitments"))
  );
  o.leadTimeInDays = options.leadTimeInDays ?? 0;
  o.canLoginToPortal = options.canLoginToPortal ?? false;
  o.paymentTerm = maybeNew("PaymentTerm", options.paymentTerm, cache, options.hasOwnProperty("paymentTerm"));
  o.lienWaivers = (options.lienWaivers ?? []).map((i) =>
    maybeNew("LienWaiver", i, cache, options.hasOwnProperty("lienWaivers"))
  );
  o.enableClickToPay = options.enableClickToPay ?? false;
  o.isLienWaiverReceiver = options.isLienWaiverReceiver ?? false;
  o.activeTasksCount = options.activeTasksCount ?? 0;
  o.activeProjectsCount = options.activeProjectsCount ?? 0;
  o.activeContractsCount = options.activeContractsCount ?? 0;
  o.totalBilledInCents = options.totalBilledInCents ?? 0;
  o.totalPaidInCents = options.totalPaidInCents ?? 0;
  o.totalCommittedInCents = options.totalCommittedInCents ?? 0;
  o.commitmentCountThisWeek = options.commitmentCountThisWeek ?? 0;
  o.commitmentCountLastWeek = options.commitmentCountLastWeek ?? 0;
  o.bidPackageRequests = (options.bidPackageRequests ?? []).map((i) =>
    maybeNew("BidPackageRequest", i, cache, options.hasOwnProperty("bidPackageRequests"))
  );
  return o;
}

factories["TradePartner"] = newTradePartner;

export interface BillOptions {
  __typename?: "Bill";
  id?: Bill["id"];
  name?: Bill["name"];
  tradePartnerNumber?: Bill["tradePartnerNumber"];
  tradePartner?: TradePartner | TradePartnerOptions;
  projectStage?: ProjectStage | ProjectStageOptions;
  parents?: Array<Commitment | CommitmentChangeOrder | CommitmentLike | CommitmentLikeOptions>;
  document?: Document | DocumentOptions | null;
  internalNote?: Bill["internalNote"];
  billDate?: Bill["billDate"];
  dueDate?: Bill["dueDate"];
  billedInCents?: Bill["billedInCents"];
  paidInCents?: Bill["paidInCents"];
  balanceInCents?: Bill["balanceInCents"];
  lineItems?: Array<BillLineItem | BillLineItemOptions>;
  quickbooksId?: Bill["quickbooksId"];
  history?: Array<History | HistoryOptions>;
  quickbooksPullOnly?: Bill["quickbooksPullOnly"];
  isTradePartnerCredit?: Bill["isTradePartnerCredit"];
  blueprintUrl?: Url | UrlOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  quickbooksAmountPaidInCents?: Bill["quickbooksAmountPaidInCents"];
  intacctAmountPaidInCents?: Bill["intacctAmountPaidInCents"];
  intacctSyncError?: Bill["intacctSyncError"];
  createdBy?: User | UserOptions | null;
  intacctId?: Bill["intacctId"];
  paidDate?: Bill["paidDate"];
  documents?: Array<Document | DocumentOptions>;
  postedDate?: Bill["postedDate"];
  shouldSyncToIntacct?: Bill["shouldSyncToIntacct"];
  predictedApprovers?: Array<
    ApproverUser | ClientOptions | RequireTypename<InternalUserOptions> | RequireTypename<TradePartnerUserOptions>
  >;
  type?: BillTypeDetailOptions | BillType;
  status?: BillStatusDetailOptions | BillStatus;
  approval?: Approval | ApprovalOptions | null;
  approvedAt?: Bill["approvedAt"];
  sentDate?: Bill["sentDate"];
  isEditable?: Bill["isEditable"];
  isPendingOrBilled?: Bill["isPendingOrBilled"];
  isProcessingReversal?: Bill["isProcessingReversal"];
  canSubmitForApproval?: PotentialOperation2 | PotentialOperation2Options;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  canReverse?: PotentialOperation2 | PotentialOperation2Options;
  updatedAt?: Bill["updatedAt"];
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  lienWaivers?: Array<LienWaiver | LienWaiverOptions>;
  referenceNumber?: Bill["referenceNumber"];
  reversalIntacctId?: Bill["reversalIntacctId"];
  canCancel?: PotentialOperation2 | PotentialOperation2Options;
  skipCostAccountDerivation?: Bill["skipCostAccountDerivation"];
  pendingReview?: Bill["pendingReview"];
  reviewReason?: Bill["reviewReason"];
  reviewReasonDetail?: BillReviewReasonDetailOptions | BillReviewReason | null;
  isHeadless?: Bill["isHeadless"];
  syncedToIntacctAt?: Bill["syncedToIntacctAt"];
  isBilled?: Bill["isBilled"];
  proposedAmountInCents?: Bill["proposedAmountInCents"];
  amountInCents?: Bill["amountInCents"];
  changeEvents?: Array<ChangeEvent | ChangeEventOptions>;
  source?: BillSourceDetailOptions | BillSource;
  ocrs?: Array<BillOcr | BillOcrOptions>;
  isDeferred?: Bill["isDeferred"];
  reviewers?: Array<InternalUser | InternalUserOptions>;
  erpAccountLines?: Array<ErpAccountBillLineItem | ErpAccountBillLineItemOptions>;
  billOcr?: BillOcr | BillOcrOptions | null;
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Bill["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Bill["isFollowed"];
}

export function newBill(options: BillOptions = {}, cache: Record<string, any> = {}): Bill {
  const o = (options.__typename ? options : cache["Bill"] = {}) as Bill;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Bill";
  o.id = options.id ?? nextFactoryId("Bill");
  o.name = options.name ?? "name";
  o.tradePartnerNumber = options.tradePartnerNumber ?? "tradePartnerNumber";
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.parents = (options.parents ?? []).map((i) =>
    maybeNew("CommitmentLike", i, cache, options.hasOwnProperty("parents"))
  );
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.internalNote = options.internalNote ?? null;
  o.billDate = options.billDate ?? newDate();
  o.dueDate = options.dueDate ?? null;
  o.billedInCents = options.billedInCents ?? 0;
  o.paidInCents = options.paidInCents ?? 0;
  o.balanceInCents = options.balanceInCents ?? 0;
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("BillLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.quickbooksId = options.quickbooksId ?? null;
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.quickbooksPullOnly = options.quickbooksPullOnly ?? false;
  o.isTradePartnerCredit = options.isTradePartnerCredit ?? false;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.quickbooksAmountPaidInCents = options.quickbooksAmountPaidInCents ?? 0;
  o.intacctAmountPaidInCents = options.intacctAmountPaidInCents ?? 0;
  o.intacctSyncError = options.intacctSyncError ?? null;
  o.createdBy = maybeNewOrNull("User", options.createdBy, cache);
  o.intacctId = options.intacctId ?? null;
  o.paidDate = options.paidDate ?? null;
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.postedDate = options.postedDate ?? null;
  o.shouldSyncToIntacct = options.shouldSyncToIntacct ?? false;
  o.predictedApprovers = (options.predictedApprovers ?? []).map((i) =>
    maybeNew(i?.__typename ?? "{Client", i, cache, options.hasOwnProperty("predictedApprovers"))
  );
  o.type = enumOrDetailOfBillType(options.type);
  o.status = enumOrDetailOfBillStatus(options.status);
  o.approval = maybeNewOrNull("Approval", options.approval, cache);
  o.approvedAt = options.approvedAt ?? null;
  o.sentDate = options.sentDate ?? null;
  o.isEditable = options.isEditable ?? false;
  o.isPendingOrBilled = options.isPendingOrBilled ?? false;
  o.isProcessingReversal = options.isProcessingReversal ?? false;
  o.canSubmitForApproval = maybeNew(
    "PotentialOperation2",
    options.canSubmitForApproval,
    cache,
    options.hasOwnProperty("canSubmitForApproval"),
  );
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.canReverse = maybeNew("PotentialOperation2", options.canReverse, cache, options.hasOwnProperty("canReverse"));
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.lienWaivers = (options.lienWaivers ?? []).map((i) =>
    maybeNew("LienWaiver", i, cache, options.hasOwnProperty("lienWaivers"))
  );
  o.referenceNumber = options.referenceNumber ?? null;
  o.reversalIntacctId = options.reversalIntacctId ?? null;
  o.canCancel = maybeNew("PotentialOperation2", options.canCancel, cache, options.hasOwnProperty("canCancel"));
  o.skipCostAccountDerivation = options.skipCostAccountDerivation ?? null;
  o.pendingReview = options.pendingReview ?? false;
  o.reviewReason = options.reviewReason ?? null;
  o.reviewReasonDetail = enumOrDetailOrNullOfBillReviewReason(options.reviewReasonDetail);
  o.isHeadless = options.isHeadless ?? false;
  o.syncedToIntacctAt = options.syncedToIntacctAt ?? null;
  o.isBilled = options.isBilled ?? false;
  o.proposedAmountInCents = options.proposedAmountInCents ?? 0;
  o.amountInCents = options.amountInCents ?? 0;
  o.changeEvents = (options.changeEvents ?? []).map((i) =>
    maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("changeEvents"))
  );
  o.source = enumOrDetailOfBillSource(options.source);
  o.ocrs = (options.ocrs ?? []).map((i) => maybeNew("BillOcr", i, cache, options.hasOwnProperty("ocrs")));
  o.isDeferred = options.isDeferred ?? false;
  o.reviewers = (options.reviewers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("reviewers"))
  );
  o.erpAccountLines = (options.erpAccountLines ?? []).map((i) =>
    maybeNew("ErpAccountBillLineItem", i, cache, options.hasOwnProperty("erpAccountLines"))
  );
  o.billOcr = maybeNewOrNull("BillOcr", options.billOcr, cache);
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  return o;
}

factories["Bill"] = newBill;

export interface SaveBillResultOptions {
  __typename?: "SaveBillResult";
  bill?: Bill | BillOptions | null;
}

export function newSaveBillResult(
  options: SaveBillResultOptions = {},
  cache: Record<string, any> = {},
): SaveBillResult {
  const o = (options.__typename ? options : cache["SaveBillResult"] = {}) as SaveBillResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBillResult";
  o.bill = maybeNewOrNull("Bill", options.bill, cache);
  return o;
}

factories["SaveBillResult"] = newSaveBillResult;

export interface SaveBillsResultOptions {
  __typename?: "SaveBillsResult";
  bills?: Array<Bill | BillOptions>;
}

export function newSaveBillsResult(
  options: SaveBillsResultOptions = {},
  cache: Record<string, any> = {},
): SaveBillsResult {
  const o = (options.__typename ? options : cache["SaveBillsResult"] = {}) as SaveBillsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBillsResult";
  o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
  return o;
}

factories["SaveBillsResult"] = newSaveBillsResult;

export interface BillsPageOptions {
  __typename?: "BillsPage";
  entities?: Array<Bill | BillOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newBillsPage(options: BillsPageOptions = {}, cache: Record<string, any> = {}): BillsPage {
  const o = (options.__typename ? options : cache["BillsPage"] = {}) as BillsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillsPage";
  o.entities = (options.entities ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["BillsPage"] = newBillsPage;

export interface ProtoBillOptions {
  __typename?: "ProtoBill";
  id?: ProtoBill["id"];
  existingBills?: Array<Bill | BillOptions>;
  commitmentLineItems?: Array<CommitmentLineItem | CommitmentLineItemOptions>;
  tradePartner?: TradePartner | TradePartnerOptions;
  lineItems?: Array<ProtoBillLineItem | ProtoBillLineItemOptions>;
}

export function newProtoBill(options: ProtoBillOptions = {}, cache: Record<string, any> = {}): ProtoBill {
  const o = (options.__typename ? options : cache["ProtoBill"] = {}) as ProtoBill;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProtoBill";
  o.id = options.id ?? nextFactoryId("ProtoBill");
  o.existingBills = (options.existingBills ?? []).map((i) =>
    maybeNew("Bill", i, cache, options.hasOwnProperty("existingBills"))
  );
  o.commitmentLineItems = (options.commitmentLineItems ?? []).map((i) =>
    maybeNew("CommitmentLineItem", i, cache, options.hasOwnProperty("commitmentLineItems"))
  );
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("ProtoBillLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  return o;
}

factories["ProtoBill"] = newProtoBill;

export interface ErpAccountBillLineItemOptions {
  __typename?: "ErpAccountBillLineItem";
  amountInCents?: ErpAccountBillLineItem["amountInCents"];
  sourceLine?:
    | ErpAccrualLineItemSourceLine
    | BillLineItemAllocationOptions
    | RequireTypename<CommitmentDrawOptions>
    | RequireTypename<CommitmentLineItemOptions>
    | RequireTypename<ExpenseAllocationAllocationOptions>
    | RequireTypename<ProjectItemOptions>
    | RequireTypename<CostCodeOptions>;
  erpSource?:
    | ErpAccountBillLineItemErpSource
    | CommitmentDrawOptions
    | RequireTypename<CommitmentLineItemOptions>
    | RequireTypename<ProjectItemOptions>
    | RequireTypename<CostCodeOptions>
    | RequireTypename<CommitmentOptions>;
  costCode?: CostCode | CostCodeOptions;
  task?: Task | TaskOptions | null;
  shouldAccrueAsComplete?: ErpAccountBillLineItem["shouldAccrueAsComplete"];
}

export function newErpAccountBillLineItem(
  options: ErpAccountBillLineItemOptions = {},
  cache: Record<string, any> = {},
): ErpAccountBillLineItem {
  const o = (options.__typename ? options : cache["ErpAccountBillLineItem"] = {}) as ErpAccountBillLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ErpAccountBillLineItem";
  o.amountInCents = options.amountInCents ?? 0;
  o.sourceLine = maybeNew(options.sourceLine?.__typename ?? "BillLineItemAllocation", options.sourceLine, cache);
  o.erpSource = maybeNew(options.erpSource?.__typename ?? "CommitmentDraw", options.erpSource, cache);
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.task = maybeNewOrNull("Task", options.task, cache);
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  return o;
}

factories["ErpAccountBillLineItem"] = newErpAccountBillLineItem;

export interface BillGmailAttachmentOptions {
  __typename?: "BillGmailAttachment";
  id?: BillGmailAttachment["id"];
  filename?: BillGmailAttachment["filename"];
  mimeType?: BillGmailAttachment["mimeType"];
  sizeInBytes?: BillGmailAttachment["sizeInBytes"];
  createdAt?: BillGmailAttachment["createdAt"];
  updatedAt?: BillGmailAttachment["updatedAt"];
  results?: BillGmailAttachment["results"];
  message?: BillGmailMessage | BillGmailMessageOptions;
  gmailPartId?: BillGmailAttachment["gmailPartId"];
  gmailAttachmentId?: BillGmailAttachment["gmailAttachmentId"];
  billOcrs?: Array<BillOcr | BillOcrOptions>;
  asset?: Asset | AssetOptions | null;
}

export function newBillGmailAttachment(
  options: BillGmailAttachmentOptions = {},
  cache: Record<string, any> = {},
): BillGmailAttachment {
  const o = (options.__typename ? options : cache["BillGmailAttachment"] = {}) as BillGmailAttachment;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillGmailAttachment";
  o.id = options.id ?? nextFactoryId("BillGmailAttachment");
  o.filename = options.filename ?? "filename";
  o.mimeType = options.mimeType ?? "mimeType";
  o.sizeInBytes = options.sizeInBytes ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.results = options.results ?? [];
  o.message = maybeNew("BillGmailMessage", options.message, cache, options.hasOwnProperty("message"));
  o.gmailPartId = options.gmailPartId ?? "gmailPartId";
  o.gmailAttachmentId = options.gmailAttachmentId ?? null;
  o.billOcrs = (options.billOcrs ?? []).map((i) => maybeNew("BillOcr", i, cache, options.hasOwnProperty("billOcrs")));
  o.asset = maybeNewOrNull("Asset", options.asset, cache);
  return o;
}

factories["BillGmailAttachment"] = newBillGmailAttachment;

export interface BillGmailMessageOptions {
  __typename?: "BillGmailMessage";
  id?: BillGmailMessage["id"];
  gmailMessageId?: BillGmailMessage["gmailMessageId"];
  gmailUserId?: BillGmailMessage["gmailUserId"];
  subject?: BillGmailMessage["subject"];
  sender?: BillGmailMessage["sender"];
  receivedAt?: BillGmailMessage["receivedAt"];
  createdAt?: BillGmailMessage["createdAt"];
  updatedAt?: BillGmailMessage["updatedAt"];
  result?: BillGmailMessageResultDetailOptions | BillGmailMessageResult;
  attachments?: Array<BillGmailAttachment | BillGmailAttachmentOptions>;
}

export function newBillGmailMessage(
  options: BillGmailMessageOptions = {},
  cache: Record<string, any> = {},
): BillGmailMessage {
  const o = (options.__typename ? options : cache["BillGmailMessage"] = {}) as BillGmailMessage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillGmailMessage";
  o.id = options.id ?? nextFactoryId("BillGmailMessage");
  o.gmailMessageId = options.gmailMessageId ?? "gmailMessageId";
  o.gmailUserId = options.gmailUserId ?? "gmailUserId";
  o.subject = options.subject ?? null;
  o.sender = options.sender ?? null;
  o.receivedAt = options.receivedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.result = enumOrDetailOfBillGmailMessageResult(options.result);
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("BillGmailAttachment", i, cache, options.hasOwnProperty("attachments"))
  );
  return o;
}

factories["BillGmailMessage"] = newBillGmailMessage;

export interface BillLineItemOptions {
  __typename?: "BillLineItem";
  id?: BillLineItem["id"];
  bill?: Bill | BillOptions;
  amountInCents?: BillLineItem["amountInCents"];
  commitmentLineItem?: CommitmentLineItem | CommitmentLineItemOptions | null;
  paidInCents?: BillLineItem["paidInCents"];
  historicBillAmountInvoiced?: BillLineItem["historicBillAmountInvoiced"];
  scheduleTask?: Task | TaskOptions | null;
  projectItem?: ProjectItem | ProjectItemOptions;
  commitmentDraw?: CommitmentDraw | CommitmentDrawOptions | null;
  task?: Task | TaskOptions | null;
  shouldAccrueAsComplete?: BillLineItem["shouldAccrueAsComplete"];
  isTaxExempt?: BillLineItem["isTaxExempt"];
  taxableAmountInCents?: BillLineItem["taxableAmountInCents"];
  taxInCents?: BillLineItem["taxInCents"];
  allocations?: Array<BillLineItemAllocation | BillLineItemAllocationOptions>;
}

export function newBillLineItem(options: BillLineItemOptions = {}, cache: Record<string, any> = {}): BillLineItem {
  const o = (options.__typename ? options : cache["BillLineItem"] = {}) as BillLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillLineItem";
  o.id = options.id ?? nextFactoryId("BillLineItem");
  o.bill = maybeNew("Bill", options.bill, cache, options.hasOwnProperty("bill"));
  o.amountInCents = options.amountInCents ?? 0;
  o.commitmentLineItem = maybeNewOrNull("CommitmentLineItem", options.commitmentLineItem, cache);
  o.paidInCents = options.paidInCents ?? 0;
  o.historicBillAmountInvoiced = options.historicBillAmountInvoiced ?? null;
  o.scheduleTask = maybeNewOrNull("Task", options.scheduleTask, cache);
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.commitmentDraw = maybeNewOrNull("CommitmentDraw", options.commitmentDraw, cache);
  o.task = maybeNewOrNull("Task", options.task, cache);
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  o.isTaxExempt = options.isTaxExempt ?? false;
  o.taxableAmountInCents = options.taxableAmountInCents ?? 0;
  o.taxInCents = options.taxInCents ?? 0;
  o.allocations = (options.allocations ?? []).map((i) =>
    maybeNew("BillLineItemAllocation", i, cache, options.hasOwnProperty("allocations"))
  );
  return o;
}

factories["BillLineItem"] = newBillLineItem;

export interface ProtoBillLineItemOptions {
  __typename?: "ProtoBillLineItem";
  commitmentLineItem?: CommitmentLineItem | CommitmentLineItemOptions;
  commitmentDraw?: CommitmentDraw | CommitmentDrawOptions | null;
  amountInCents?: ProtoBillLineItem["amountInCents"];
}

export function newProtoBillLineItem(
  options: ProtoBillLineItemOptions = {},
  cache: Record<string, any> = {},
): ProtoBillLineItem {
  const o = (options.__typename ? options : cache["ProtoBillLineItem"] = {}) as ProtoBillLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProtoBillLineItem";
  o.commitmentLineItem = maybeNew(
    "CommitmentLineItem",
    options.commitmentLineItem,
    cache,
    options.hasOwnProperty("commitmentLineItem"),
  );
  o.commitmentDraw = maybeNewOrNull("CommitmentDraw", options.commitmentDraw, cache);
  o.amountInCents = options.amountInCents ?? 0;
  return o;
}

factories["ProtoBillLineItem"] = newProtoBillLineItem;

export interface BillLineItemAllocationOptions {
  __typename?: "BillLineItemAllocation";
  id?: BillLineItemAllocation["id"];
  createdAt?: BillLineItemAllocation["createdAt"];
  updatedAt?: BillLineItemAllocation["updatedAt"];
  costInCents?: BillLineItemAllocation["costInCents"];
  paidCostInCents?: BillLineItemAllocation["paidCostInCents"];
  commitmentLineItemAllocation?: CommitmentLineItemAllocation | CommitmentLineItemAllocationOptions | null;
  projectItemAllocation?: ProjectItemAllocation | ProjectItemAllocationOptions;
}

export function newBillLineItemAllocation(
  options: BillLineItemAllocationOptions = {},
  cache: Record<string, any> = {},
): BillLineItemAllocation {
  const o = (options.__typename ? options : cache["BillLineItemAllocation"] = {}) as BillLineItemAllocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillLineItemAllocation";
  o.id = options.id ?? nextFactoryId("BillLineItemAllocation");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costInCents = options.costInCents ?? 0;
  o.paidCostInCents = options.paidCostInCents ?? 0;
  o.commitmentLineItemAllocation = maybeNewOrNull(
    "CommitmentLineItemAllocation",
    options.commitmentLineItemAllocation,
    cache,
  );
  o.projectItemAllocation = maybeNew(
    "ProjectItemAllocation",
    options.projectItemAllocation,
    cache,
    options.hasOwnProperty("projectItemAllocation"),
  );
  return o;
}

factories["BillLineItemAllocation"] = newBillLineItemAllocation;

export interface BillOcrOptions {
  __typename?: "BillOcr";
  id?: BillOcr["id"];
  createdAt?: BillOcr["createdAt"];
  updatedAt?: BillOcr["updatedAt"];
  asset?: Asset | AssetOptions;
  bill?: Bill | BillOptions | null;
  tradePartner?: TradePartner | TradePartnerOptions | null;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  commitmentLikes?: Array<Commitment | CommitmentChangeOrder | CommitmentLike | CommitmentLikeOptions>;
  invoiceNumber?: BillOcr["invoiceNumber"];
  billDate?: BillOcr["billDate"];
  dueDate?: BillOcr["dueDate"];
  totalInCents?: BillOcr["totalInCents"];
  type?: BillTypeDetailOptions | BillType;
  gmailAttachment?: BillGmailAttachment | BillGmailAttachmentOptions | null;
  billOcrBill?: Bill | BillOptions | null;
  trackedJobs?: Array<TrackedJob | TrackedJobOptions>;
}

export function newBillOcr(options: BillOcrOptions = {}, cache: Record<string, any> = {}): BillOcr {
  const o = (options.__typename ? options : cache["BillOcr"] = {}) as BillOcr;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillOcr";
  o.id = options.id ?? nextFactoryId("BillOcr");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  o.bill = maybeNewOrNull("Bill", options.bill, cache);
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.commitmentLikes = (options.commitmentLikes ?? []).map((i) =>
    maybeNew("CommitmentLike", i, cache, options.hasOwnProperty("commitmentLikes"))
  );
  o.invoiceNumber = options.invoiceNumber ?? null;
  o.billDate = options.billDate ?? null;
  o.dueDate = options.dueDate ?? null;
  o.totalInCents = options.totalInCents ?? null;
  o.type = enumOrDetailOfBillType(options.type);
  o.gmailAttachment = maybeNewOrNull("BillGmailAttachment", options.gmailAttachment, cache);
  o.billOcrBill = maybeNewOrNull("Bill", options.billOcrBill, cache);
  o.trackedJobs = (options.trackedJobs ?? []).map((i) =>
    maybeNew("TrackedJob", i, cache, options.hasOwnProperty("trackedJobs"))
  );
  return o;
}

factories["BillOcr"] = newBillOcr;

export interface RunBillParserResultOptions {
  __typename?: "RunBillParserResult";
  trackedJob?: TrackedJob | TrackedJobOptions;
}

export function newRunBillParserResult(
  options: RunBillParserResultOptions = {},
  cache: Record<string, any> = {},
): RunBillParserResult {
  const o = (options.__typename ? options : cache["RunBillParserResult"] = {}) as RunBillParserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "RunBillParserResult";
  o.trackedJob = maybeNew("TrackedJob", options.trackedJob, cache, options.hasOwnProperty("trackedJob"));
  return o;
}

factories["RunBillParserResult"] = newRunBillParserResult;

export interface PreConBudgetCostDivisionLineItemOptions {
  __typename?: "PreConBudgetCostDivisionLineItem";
  costDivision?: CostDivision | CostDivisionOptions;
  lines?: Array<PreConBudgetCostCodeLineItem | PreConBudgetCostCodeLineItemOptions>;
  priceInCents?: PreConBudgetCostDivisionLineItem["priceInCents"];
  budgetInCents?: PreConBudgetCostDivisionLineItem["budgetInCents"];
}

export function newPreConBudgetCostDivisionLineItem(
  options: PreConBudgetCostDivisionLineItemOptions = {},
  cache: Record<string, any> = {},
): PreConBudgetCostDivisionLineItem {
  const o =
    (options.__typename ? options : cache["PreConBudgetCostDivisionLineItem"] = {}) as PreConBudgetCostDivisionLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PreConBudgetCostDivisionLineItem";
  o.costDivision = maybeNew("CostDivision", options.costDivision, cache, options.hasOwnProperty("costDivision"));
  o.lines = (options.lines ?? []).map((i) =>
    maybeNew("PreConBudgetCostCodeLineItem", i, cache, options.hasOwnProperty("lines"))
  );
  o.priceInCents = options.priceInCents ?? null;
  o.budgetInCents = options.budgetInCents ?? null;
  return o;
}

factories["PreConBudgetCostDivisionLineItem"] = newPreConBudgetCostDivisionLineItem;

export interface PreConBudgetCostCodeLineItemOptions {
  __typename?: "PreConBudgetCostCodeLineItem";
  costCode?: CostCode | CostCodeOptions;
  internalNote?: PreConBudgetCostCodeLineItem["internalNote"];
  priceInCents?: PreConBudgetCostCodeLineItem["priceInCents"];
  budgetInCents?: PreConBudgetCostCodeLineItem["budgetInCents"];
}

export function newPreConBudgetCostCodeLineItem(
  options: PreConBudgetCostCodeLineItemOptions = {},
  cache: Record<string, any> = {},
): PreConBudgetCostCodeLineItem {
  const o = (options.__typename ? options : cache["PreConBudgetCostCodeLineItem"] = {}) as PreConBudgetCostCodeLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PreConBudgetCostCodeLineItem";
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.internalNote = options.internalNote ?? null;
  o.priceInCents = options.priceInCents ?? null;
  o.budgetInCents = options.budgetInCents ?? null;
  return o;
}

factories["PreConBudgetCostCodeLineItem"] = newPreConBudgetCostCodeLineItem;

export interface SavePreConBudgetLineItemResultOptions {
  __typename?: "SavePreConBudgetLineItemResult";
  lineItem?: PreConBudgetCostCodeLineItem | PreConBudgetCostCodeLineItemOptions;
}

export function newSavePreConBudgetLineItemResult(
  options: SavePreConBudgetLineItemResultOptions = {},
  cache: Record<string, any> = {},
): SavePreConBudgetLineItemResult {
  const o =
    (options.__typename ? options : cache["SavePreConBudgetLineItemResult"] = {}) as SavePreConBudgetLineItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePreConBudgetLineItemResult";
  o.lineItem = maybeNew("PreConBudgetCostCodeLineItem", options.lineItem, cache, options.hasOwnProperty("lineItem"));
  return o;
}

factories["SavePreConBudgetLineItemResult"] = newSavePreConBudgetLineItemResult;

export interface DeletePreConBudgetLineItemResultOptions {
  __typename?: "DeletePreConBudgetLineItemResult";
  emptyResult?: EmptyResult | EmptyResultOptions | null;
}

export function newDeletePreConBudgetLineItemResult(
  options: DeletePreConBudgetLineItemResultOptions = {},
  cache: Record<string, any> = {},
): DeletePreConBudgetLineItemResult {
  const o =
    (options.__typename ? options : cache["DeletePreConBudgetLineItemResult"] = {}) as DeletePreConBudgetLineItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeletePreConBudgetLineItemResult";
  o.emptyResult = maybeNewOrNull("EmptyResult", options.emptyResult, cache);
  return o;
}

factories["DeletePreConBudgetLineItemResult"] = newDeletePreConBudgetLineItemResult;

export interface ApprovePreConBudgetLineItemResultOptions {
  __typename?: "ApprovePreConBudgetLineItemResult";
  contract?: HomeownerContract | HomeownerContractOptions;
}

export function newApprovePreConBudgetLineItemResult(
  options: ApprovePreConBudgetLineItemResultOptions = {},
  cache: Record<string, any> = {},
): ApprovePreConBudgetLineItemResult {
  const o =
    (options.__typename
      ? options
      : cache["ApprovePreConBudgetLineItemResult"] = {}) as ApprovePreConBudgetLineItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ApprovePreConBudgetLineItemResult";
  o.contract = maybeNew("HomeownerContract", options.contract, cache, options.hasOwnProperty("contract"));
  return o;
}

factories["ApprovePreConBudgetLineItemResult"] = newApprovePreConBudgetLineItemResult;

export interface BuilderOptions {
  __typename?: "Builder";
  id?: Builder["id"];
  name?: Builder["name"];
}

export function newBuilder(options: BuilderOptions = {}, cache: Record<string, any> = {}): Builder {
  const o = (options.__typename ? options : cache["Builder"] = {}) as Builder;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Builder";
  o.id = options.id ?? nextFactoryId("Builder");
  o.name = options.name ?? "name";
  return o;
}

factories["Builder"] = newBuilder;

export interface SaveBuilderResultOptions {
  __typename?: "SaveBuilderResult";
  builder?: Builder | BuilderOptions;
}

export function newSaveBuilderResult(
  options: SaveBuilderResultOptions = {},
  cache: Record<string, any> = {},
): SaveBuilderResult {
  const o = (options.__typename ? options : cache["SaveBuilderResult"] = {}) as SaveBuilderResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBuilderResult";
  o.builder = maybeNew("Builder", options.builder, cache, options.hasOwnProperty("builder"));
  return o;
}

factories["SaveBuilderResult"] = newSaveBuilderResult;

export interface BusinessFunctionOptions {
  __typename?: "BusinessFunction";
  id?: BusinessFunction["id"];
  name?: BusinessFunction["name"];
  priority?: BusinessFunction["priority"];
  autoApprovalAmountInCents?: BusinessFunction["autoApprovalAmountInCents"];
  createdAt?: BusinessFunction["createdAt"];
  updatedAt?: BusinessFunction["updatedAt"];
  impactReviewer?: ProjectRoleDetailOptions | ProjectRole | null;
  initialReviewer?: ProjectRoleDetailOptions | ProjectRole | null;
  businessFunctionType?: BusinessFunctionTypeDetailOptions | BusinessFunctionType;
  blueprintUrl?: Url | UrlOptions;
  approverProjectRole?: ProjectRoleDetailOptions | ProjectRole | null;
  applicableChangeTypes?: Array<ChangeTypeDetail | ChangeTypeDetailOptions>;
}

export function newBusinessFunction(
  options: BusinessFunctionOptions = {},
  cache: Record<string, any> = {},
): BusinessFunction {
  const o = (options.__typename ? options : cache["BusinessFunction"] = {}) as BusinessFunction;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BusinessFunction";
  o.id = options.id ?? nextFactoryId("BusinessFunction");
  o.name = options.name ?? "name";
  o.priority = options.priority ?? 0;
  o.autoApprovalAmountInCents = options.autoApprovalAmountInCents ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.impactReviewer = enumOrDetailOrNullOfProjectRole(options.impactReviewer);
  o.initialReviewer = enumOrDetailOrNullOfProjectRole(options.initialReviewer);
  o.businessFunctionType = enumOrDetailOfBusinessFunctionType(options.businessFunctionType);
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.approverProjectRole = enumOrDetailOrNullOfProjectRole(options.approverProjectRole);
  o.applicableChangeTypes = (options.applicableChangeTypes ?? []).map((i) => enumOrDetailOfChangeType(i));
  return o;
}

factories["BusinessFunction"] = newBusinessFunction;

export interface SaveBusinessFunctionResultOptions {
  __typename?: "SaveBusinessFunctionResult";
  businessFunction?: BusinessFunction | BusinessFunctionOptions;
}

export function newSaveBusinessFunctionResult(
  options: SaveBusinessFunctionResultOptions = {},
  cache: Record<string, any> = {},
): SaveBusinessFunctionResult {
  const o = (options.__typename ? options : cache["SaveBusinessFunctionResult"] = {}) as SaveBusinessFunctionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBusinessFunctionResult";
  o.businessFunction = maybeNew(
    "BusinessFunction",
    options.businessFunction,
    cache,
    options.hasOwnProperty("businessFunction"),
  );
  return o;
}

factories["SaveBusinessFunctionResult"] = newSaveBusinessFunctionResult;

export interface CalendarIntervalOptions {
  __typename?: "CalendarInterval";
  startDate?: CalendarInterval["startDate"];
  endDate?: CalendarInterval["endDate"];
  durationInDays?: CalendarInterval["durationInDays"];
  calendarProgress?: CalendarInterval["calendarProgress"];
}

export function newCalendarInterval(
  options: CalendarIntervalOptions = {},
  cache: Record<string, any> = {},
): CalendarInterval {
  const o = (options.__typename ? options : cache["CalendarInterval"] = {}) as CalendarInterval;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CalendarInterval";
  o.startDate = options.startDate ?? newDate();
  o.endDate = options.endDate ?? newDate();
  o.durationInDays = options.durationInDays ?? 0;
  o.calendarProgress = options.calendarProgress ?? 0;
  return o;
}

factories["CalendarInterval"] = newCalendarInterval;

export interface CalendarInterval2Options {
  __typename?: "CalendarInterval2";
  startDate?: CalendarInterval2["startDate"];
  endDate?: CalendarInterval2["endDate"];
  durationInDays?: CalendarInterval2["durationInDays"];
}

export function newCalendarInterval2(
  options: CalendarInterval2Options = {},
  cache: Record<string, any> = {},
): CalendarInterval2 {
  const o = (options.__typename ? options : cache["CalendarInterval2"] = {}) as CalendarInterval2;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CalendarInterval2";
  o.startDate = options.startDate ?? null;
  o.endDate = options.endDate ?? null;
  o.durationInDays = options.durationInDays ?? null;
  return o;
}

factories["CalendarInterval2"] = newCalendarInterval2;

export interface ChangeEventOptions {
  __typename?: "ChangeEvent";
  id?: ChangeEvent["id"];
  title?: ChangeEvent["title"];
  commitments?: Array<Commitment | CommitmentChangeOrder | CommitmentLike | CommitmentLikeOptions>;
  internalNote?: ChangeEvent["internalNote"];
  createdAt?: ChangeEvent["createdAt"];
  displayName?: ChangeEvent["displayName"];
  updatedAt?: ChangeEvent["updatedAt"];
  status?: ChangeEvent["status"];
  statusDetail?: ChangeEventStatusDetailOptions | ChangeEventStatus;
  projectStage?: ProjectStage | ProjectStageOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  lineItems?: Array<ChangeEventLineItem | ChangeEventLineItemOptions>;
  homeownerContractChangeOrder?: HomeownerContractChangeOrder | HomeownerContractChangeOrderOptions | null;
  blueprintUrl?: Url | UrlOptions;
  name?: ChangeEvent["name"];
  history?: Array<History | HistoryOptions>;
  estimates?: Array<Estimate | EstimateOptions>;
  canCreateFinalEstimate?: ChangeEvent["canCreateFinalEstimate"];
  totalCostInCents?: ChangeEvent["totalCostInCents"];
  totalPriceInCents?: ChangeEvent["totalPriceInCents"];
  originalTotalCostInCents?: ChangeEvent["originalTotalCostInCents"];
  originalTotalPriceInCents?: ChangeEvent["originalTotalPriceInCents"];
  proposedTotalCostInCents?: ChangeEvent["proposedTotalCostInCents"];
  proposedTotalPriceInCents?: ChangeEvent["proposedTotalPriceInCents"];
  budgetImpactInCents?: ChangeEvent["budgetImpactInCents"];
  revisedBudgetInCents?: ChangeEvent["revisedBudgetInCents"];
  isHomeownerChangeEvent?: ChangeEvent["isHomeownerChangeEvent"];
  isReadyHomeManaged?: ChangeEvent["isReadyHomeManaged"];
  canEditLineItems?: PotentialOperation2 | PotentialOperation2Options;
  internalImpactInDays?: ChangeEvent["internalImpactInDays"];
  homeownerImpactInDays?: ChangeEvent["homeownerImpactInDays"];
  reasonDetails?: ChangeEvent["reasonDetails"];
  reason?: ChangeEventReason | ChangeEventReasonOptions;
  identifier?: ChangeEvent["identifier"];
  appliedTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
  templateConfigs?: Array<ChangeEventTemplateConfig | ChangeEventTemplateConfigOptions>;
  budgetPhase?: ChangeEventBudgetPhaseDetailOptions | ChangeEventBudgetPhase;
  acceptedAt?: ChangeEvent["acceptedAt"];
  approval?: Approval | ApprovalOptions | null;
  impactedCommitments?: Array<Commitment | CommitmentChangeOrder | CommitmentLike | CommitmentLikeOptions>;
  predictedApprovers?: Array<
    ApproverUser | ClientOptions | RequireTypename<InternalUserOptions> | RequireTypename<TradePartnerUserOptions>
  >;
  type?: ChangeEventTypeDetailOptions | ChangeEventType;
  canBeLocked?: PotentialOperation2 | PotentialOperation2Options;
  canSubmitForApproval?: PotentialOperation2 | PotentialOperation2Options;
  tradesToDraftCommitmentsFor?: Array<TradePartner | TradePartnerOptions>;
  impactedTrades?: Array<TradePartner | TradePartnerOptions>;
  pandaDoc?: PandaDoc | PandaDocOptions | null;
  requireSignature?: ChangeEvent["requireSignature"];
  createdBy?: ChangeEventCreatedBy | BillOptions | RequireTypename<ExpenseOptions> | null;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions | null;
  originalReadyPlan?:
    | ReadyPlan
    | PlanPackage
    | DesignPackage
    | ProductOffering
    | ReadyPlanLike
    | ReadyPlanLikeOptions
    | null;
  originalReadyPlanOptions?: Array<ChangeEventOriginalOption | ChangeEventOriginalOptionOptions>;
  proposedReadyPlanOptions?: Array<ChangeEventProposedOption | ChangeEventProposedOptionOptions>;
  isContractAddendum?: ChangeEvent["isContractAddendum"];
  removedReadyPlanOptions?: Array<ChangeEventOriginalOption | ChangeEventOriginalOptionOptions>;
  addedReadyPlanOptions?: Array<ChangeEventProposedOption | ChangeEventProposedOptionOptions>;
  checkoutConfig?: CheckoutConfig | CheckoutConfigOptions | null;
  proposedOrientation?: ProjectReadyPlanConfigOrientationDetailOptions | ProjectReadyPlanConfigOrientation | null;
  hasPreSignedContract?: ChangeEvent["hasPreSignedContract"];
  document?: Document | DocumentOptions | null;
  aggregateVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  workflow?: ChangeEventWorkflowDetailOptions | ChangeEventWorkflow | null;
  materialVariantSwaps?: Array<ChangeEventMaterialVariantSwap | ChangeEventMaterialVariantSwapOptions>;
  isTitleAutoGenerated?: ChangeEvent["isTitleAutoGenerated"];
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ChangeEvent["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ChangeEvent["isFollowed"];
}

export function newChangeEvent(options: ChangeEventOptions = {}, cache: Record<string, any> = {}): ChangeEvent {
  const o = (options.__typename ? options : cache["ChangeEvent"] = {}) as ChangeEvent;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEvent";
  o.id = options.id ?? nextFactoryId("ChangeEvent");
  o.title = options.title ?? "title";
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("CommitmentLike", i, cache, options.hasOwnProperty("commitments"))
  );
  o.internalNote = options.internalNote ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.displayName = options.displayName ?? "displayName";
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = options.status ?? ChangeEventStatus.Draft;
  o.statusDetail = enumOrDetailOfChangeEventStatus(options.statusDetail);
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("ChangeEventLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.homeownerContractChangeOrder = maybeNewOrNull(
    "HomeownerContractChangeOrder",
    options.homeownerContractChangeOrder,
    cache,
  );
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.name = options.name ?? "name";
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.estimates = (options.estimates ?? []).map((i) =>
    maybeNew("Estimate", i, cache, options.hasOwnProperty("estimates"))
  );
  o.canCreateFinalEstimate = options.canCreateFinalEstimate ?? false;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.originalTotalCostInCents = options.originalTotalCostInCents ?? 0;
  o.originalTotalPriceInCents = options.originalTotalPriceInCents ?? 0;
  o.proposedTotalCostInCents = options.proposedTotalCostInCents ?? 0;
  o.proposedTotalPriceInCents = options.proposedTotalPriceInCents ?? 0;
  o.budgetImpactInCents = options.budgetImpactInCents ?? 0;
  o.revisedBudgetInCents = options.revisedBudgetInCents ?? 0;
  o.isHomeownerChangeEvent = options.isHomeownerChangeEvent ?? false;
  o.isReadyHomeManaged = options.isReadyHomeManaged ?? false;
  o.canEditLineItems = maybeNew(
    "PotentialOperation2",
    options.canEditLineItems,
    cache,
    options.hasOwnProperty("canEditLineItems"),
  );
  o.internalImpactInDays = options.internalImpactInDays ?? null;
  o.homeownerImpactInDays = options.homeownerImpactInDays ?? null;
  o.reasonDetails = options.reasonDetails ?? null;
  o.reason = maybeNew("ChangeEventReason", options.reason, cache, options.hasOwnProperty("reason"));
  o.identifier = options.identifier ?? 0;
  o.appliedTemplates = (options.appliedTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("appliedTemplates"))
  );
  o.templateConfigs = (options.templateConfigs ?? []).map((i) =>
    maybeNew("ChangeEventTemplateConfig", i, cache, options.hasOwnProperty("templateConfigs"))
  );
  o.budgetPhase = enumOrDetailOfChangeEventBudgetPhase(options.budgetPhase);
  o.acceptedAt = options.acceptedAt ?? null;
  o.approval = maybeNewOrNull("Approval", options.approval, cache);
  o.impactedCommitments = (options.impactedCommitments ?? []).map((i) =>
    maybeNew("CommitmentLike", i, cache, options.hasOwnProperty("impactedCommitments"))
  );
  o.predictedApprovers = (options.predictedApprovers ?? []).map((i) =>
    maybeNew(i?.__typename ?? "{Client", i, cache, options.hasOwnProperty("predictedApprovers"))
  );
  o.type = enumOrDetailOfChangeEventType(options.type);
  o.canBeLocked = maybeNew("PotentialOperation2", options.canBeLocked, cache, options.hasOwnProperty("canBeLocked"));
  o.canSubmitForApproval = maybeNew(
    "PotentialOperation2",
    options.canSubmitForApproval,
    cache,
    options.hasOwnProperty("canSubmitForApproval"),
  );
  o.tradesToDraftCommitmentsFor = (options.tradesToDraftCommitmentsFor ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradesToDraftCommitmentsFor"))
  );
  o.impactedTrades = (options.impactedTrades ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("impactedTrades"))
  );
  o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
  o.requireSignature = options.requireSignature ?? false;
  o.createdBy = maybeNewOrNull(options.createdBy?.__typename ?? "Bill", options.createdBy, cache);
  o.readyPlan = maybeNewOrNull("ReadyPlanLike", options.readyPlan, cache);
  o.originalReadyPlan = maybeNewOrNull("ReadyPlanLike", options.originalReadyPlan, cache);
  o.originalReadyPlanOptions = (options.originalReadyPlanOptions ?? []).map((i) =>
    maybeNew("ChangeEventOriginalOption", i, cache, options.hasOwnProperty("originalReadyPlanOptions"))
  );
  o.proposedReadyPlanOptions = (options.proposedReadyPlanOptions ?? []).map((i) =>
    maybeNew("ChangeEventProposedOption", i, cache, options.hasOwnProperty("proposedReadyPlanOptions"))
  );
  o.isContractAddendum = options.isContractAddendum ?? false;
  o.removedReadyPlanOptions = (options.removedReadyPlanOptions ?? []).map((i) =>
    maybeNew("ChangeEventOriginalOption", i, cache, options.hasOwnProperty("removedReadyPlanOptions"))
  );
  o.addedReadyPlanOptions = (options.addedReadyPlanOptions ?? []).map((i) =>
    maybeNew("ChangeEventProposedOption", i, cache, options.hasOwnProperty("addedReadyPlanOptions"))
  );
  o.checkoutConfig = maybeNewOrNull("CheckoutConfig", options.checkoutConfig, cache);
  o.proposedOrientation = enumOrDetailOrNullOfProjectReadyPlanConfigOrientation(options.proposedOrientation);
  o.hasPreSignedContract = options.hasPreSignedContract ?? false;
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.aggregateVersion = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateVersion, cache);
  o.workflow = enumOrDetailOrNullOfChangeEventWorkflow(options.workflow);
  o.materialVariantSwaps = (options.materialVariantSwaps ?? []).map((i) =>
    maybeNew("ChangeEventMaterialVariantSwap", i, cache, options.hasOwnProperty("materialVariantSwaps"))
  );
  o.isTitleAutoGenerated = options.isTitleAutoGenerated ?? false;
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  return o;
}

factories["ChangeEvent"] = newChangeEvent;

export interface SaveChangeEventResultOptions {
  __typename?: "SaveChangeEventResult";
  changeEvent?: ChangeEvent | ChangeEventOptions;
}

export function newSaveChangeEventResult(
  options: SaveChangeEventResultOptions = {},
  cache: Record<string, any> = {},
): SaveChangeEventResult {
  const o = (options.__typename ? options : cache["SaveChangeEventResult"] = {}) as SaveChangeEventResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveChangeEventResult";
  o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
  return o;
}

factories["SaveChangeEventResult"] = newSaveChangeEventResult;

export interface SaveChangeEventsResultOptions {
  __typename?: "SaveChangeEventsResult";
  changeEvents?: Array<ChangeEvent | ChangeEventOptions>;
}

export function newSaveChangeEventsResult(
  options: SaveChangeEventsResultOptions = {},
  cache: Record<string, any> = {},
): SaveChangeEventsResult {
  const o = (options.__typename ? options : cache["SaveChangeEventsResult"] = {}) as SaveChangeEventsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveChangeEventsResult";
  o.changeEvents = (options.changeEvents ?? []).map((i) =>
    maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("changeEvents"))
  );
  return o;
}

factories["SaveChangeEventsResult"] = newSaveChangeEventsResult;

export interface ChangeEventLineItemOptions {
  __typename?: "ChangeEventLineItem";
  id?: ChangeEventLineItem["id"];
  createdAt?: ChangeEventLineItem["createdAt"];
  updatedAt?: ChangeEventLineItem["updatedAt"];
  changeEvent?: ChangeEvent | ChangeEventOptions;
  projectItem?: ProjectItem | ProjectItemOptions;
  quantity?: ChangeEventLineItem["quantity"];
  totalPriceInCents?: ChangeEventLineItem["totalPriceInCents"];
  totalCostInCents?: ChangeEventLineItem["totalCostInCents"];
  unitCostInCents?: ChangeEventLineItem["unitCostInCents"];
  originalQuantity?: ChangeEventLineItem["originalQuantity"];
  originalTotalCostInCents?: ChangeEventLineItem["originalTotalCostInCents"];
  originalTotalPriceInCents?: ChangeEventLineItem["originalTotalPriceInCents"];
  proposedTotalCostInCents?: ChangeEventLineItem["proposedTotalCostInCents"];
  item?: Item | ItemOptions;
  name?: ChangeEventLineItem["name"];
  costType?: ChangeEventLineItem["costType"];
  location?: Location | LocationOptions;
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  displayName?: ChangeEventLineItem["displayName"];
  costConfidence?: ChangeEventLineItem["costConfidence"];
  costConfidenceDetail?: CostConfidenceDetailOptions | CostConfidence;
  type?: ChangeEventLineItem["type"];
  typeDetail?: ChangeEventLineItemTypeDetailOptions | ChangeEventLineItemType;
  specifications?: ChangeEventLineItem["specifications"];
  tradePartnerNote?: ChangeEventLineItem["tradePartnerNote"];
  canEditName?: PotentialOperation2 | PotentialOperation2Options;
  canEditCost?: PotentialOperation2 | PotentialOperation2Options;
  itemTemplateItem?:
    | ItemTemplateItemVersion
    | ItemTemplateItem
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | BaseItemLike
    | BaseItemLikeOptions
    | null;
  modifyingTemplateItems?: Array<
    | ItemTemplateItemVersion
    | ItemTemplateItem
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | BaseItemLike
    | BaseItemLikeOptions
  >;
  tradePartner?: TradePartner | TradePartnerOptions | null;
  originalTradePartner?: TradePartner | TradePartnerOptions | null;
  internalNote?: ChangeEventLineItem["internalNote"];
  originalBidItem?: BidItem | BidItemOptions | null;
  proposedBidItem?: BidItem | BidItemOptions | null;
  originalBidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  proposedBidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  originalTask?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  proposedTask?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  originalMaterialVariant?: MaterialVariant | MaterialVariantOptions | null;
  proposedMaterialVariant?: MaterialVariant | MaterialVariantOptions | null;
  allocations?: Array<ChangeEventLineItemAllocation | ChangeEventLineItemAllocationOptions>;
  originalPackageDesignNotes?: ChangeEventLineItem["originalPackageDesignNotes"];
  proposedPackageDesignNotes?: ChangeEventLineItem["proposedPackageDesignNotes"];
  isMetadataChangeOnly?: ChangeEventLineItem["isMetadataChangeOnly"];
}

export function newChangeEventLineItem(
  options: ChangeEventLineItemOptions = {},
  cache: Record<string, any> = {},
): ChangeEventLineItem {
  const o = (options.__typename ? options : cache["ChangeEventLineItem"] = {}) as ChangeEventLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventLineItem";
  o.id = options.id ?? nextFactoryId("ChangeEventLineItem");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.quantity = options.quantity ?? null;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.unitCostInCents = options.unitCostInCents ?? 0;
  o.originalQuantity = options.originalQuantity ?? null;
  o.originalTotalCostInCents = options.originalTotalCostInCents ?? 0;
  o.originalTotalPriceInCents = options.originalTotalPriceInCents ?? 0;
  o.proposedTotalCostInCents = options.proposedTotalCostInCents ?? 0;
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.name = options.name ?? "name";
  o.costType = options.costType ?? CostType.Labor;
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.displayName = options.displayName ?? "displayName";
  o.costConfidence = options.costConfidence ?? CostConfidence.Low;
  o.costConfidenceDetail = enumOrDetailOfCostConfidence(options.costConfidenceDetail);
  o.type = options.type ?? ChangeEventLineItemType.Add;
  o.typeDetail = enumOrDetailOfChangeEventLineItemType(options.typeDetail);
  o.specifications = options.specifications ?? null;
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.canEditName = maybeNew("PotentialOperation2", options.canEditName, cache, options.hasOwnProperty("canEditName"));
  o.canEditCost = maybeNew("PotentialOperation2", options.canEditCost, cache, options.hasOwnProperty("canEditCost"));
  o.itemTemplateItem = maybeNewOrNull("BaseItemLike", options.itemTemplateItem, cache);
  o.modifyingTemplateItems = (options.modifyingTemplateItems ?? []).map((i) =>
    maybeNew("BaseItemLike", i, cache, options.hasOwnProperty("modifyingTemplateItems"))
  );
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.originalTradePartner = maybeNewOrNull("TradePartner", options.originalTradePartner, cache);
  o.internalNote = options.internalNote ?? null;
  o.originalBidItem = maybeNewOrNull("BidItem", options.originalBidItem, cache);
  o.proposedBidItem = maybeNewOrNull("BidItem", options.proposedBidItem, cache);
  o.originalBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.originalBidContractLineItem, cache);
  o.proposedBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.proposedBidContractLineItem, cache);
  o.originalTask = maybeNewOrNull("GlobalPlanTask", options.originalTask, cache);
  o.proposedTask = maybeNewOrNull("GlobalPlanTask", options.proposedTask, cache);
  o.originalMaterialVariant = maybeNewOrNull("MaterialVariant", options.originalMaterialVariant, cache);
  o.proposedMaterialVariant = maybeNewOrNull("MaterialVariant", options.proposedMaterialVariant, cache);
  o.allocations = (options.allocations ?? []).map((i) =>
    maybeNew("ChangeEventLineItemAllocation", i, cache, options.hasOwnProperty("allocations"))
  );
  o.originalPackageDesignNotes = options.originalPackageDesignNotes ?? null;
  o.proposedPackageDesignNotes = options.proposedPackageDesignNotes ?? null;
  o.isMetadataChangeOnly = options.isMetadataChangeOnly ?? false;
  return o;
}

factories["ChangeEventLineItem"] = newChangeEventLineItem;

export interface SaveChangeEventLineItemsResultOptions {
  __typename?: "SaveChangeEventLineItemsResult";
  changeEventLineItems?: Array<ChangeEventLineItem | ChangeEventLineItemOptions>;
  autoAddedLaborLines?: Array<ChangeEventLineItem | ChangeEventLineItemOptions>;
}

export function newSaveChangeEventLineItemsResult(
  options: SaveChangeEventLineItemsResultOptions = {},
  cache: Record<string, any> = {},
): SaveChangeEventLineItemsResult {
  const o =
    (options.__typename ? options : cache["SaveChangeEventLineItemsResult"] = {}) as SaveChangeEventLineItemsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveChangeEventLineItemsResult";
  o.changeEventLineItems = (options.changeEventLineItems ?? []).map((i) =>
    maybeNew("ChangeEventLineItem", i, cache, options.hasOwnProperty("changeEventLineItems"))
  );
  o.autoAddedLaborLines = (options.autoAddedLaborLines ?? []).map((i) =>
    maybeNew("ChangeEventLineItem", i, cache, options.hasOwnProperty("autoAddedLaborLines"))
  );
  return o;
}

factories["SaveChangeEventLineItemsResult"] = newSaveChangeEventLineItemsResult;

export interface ChangeEventLineItemAllocationOptions {
  __typename?: "ChangeEventLineItemAllocation";
  id?: ChangeEventLineItemAllocation["id"];
  costInCents?: ChangeEventLineItemAllocation["costInCents"];
  priceInCents?: ChangeEventLineItemAllocation["priceInCents"];
  createdAt?: ChangeEventLineItemAllocation["createdAt"];
  updatedAt?: ChangeEventLineItemAllocation["updatedAt"];
  changeEventLineItem?: ChangeEventLineItem | ChangeEventLineItemOptions;
  projectItemAllocation?: ProjectItemAllocation | ProjectItemAllocationOptions;
}

export function newChangeEventLineItemAllocation(
  options: ChangeEventLineItemAllocationOptions = {},
  cache: Record<string, any> = {},
): ChangeEventLineItemAllocation {
  const o =
    (options.__typename ? options : cache["ChangeEventLineItemAllocation"] = {}) as ChangeEventLineItemAllocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventLineItemAllocation";
  o.id = options.id ?? nextFactoryId("ChangeEventLineItemAllocation");
  o.costInCents = options.costInCents ?? 0;
  o.priceInCents = options.priceInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.changeEventLineItem = maybeNew(
    "ChangeEventLineItem",
    options.changeEventLineItem,
    cache,
    options.hasOwnProperty("changeEventLineItem"),
  );
  o.projectItemAllocation = maybeNew(
    "ProjectItemAllocation",
    options.projectItemAllocation,
    cache,
    options.hasOwnProperty("projectItemAllocation"),
  );
  return o;
}

factories["ChangeEventLineItemAllocation"] = newChangeEventLineItemAllocation;

export interface ChangeEventMaterialVariantSwapOptions {
  __typename?: "ChangeEventMaterialVariantSwap";
  id?: ChangeEventMaterialVariantSwap["id"];
  createdAt?: ChangeEventMaterialVariantSwap["createdAt"];
  updatedAt?: ChangeEventMaterialVariantSwap["updatedAt"];
  changeEvent?: ChangeEvent | ChangeEventOptions;
  originalMaterialVariant?: MaterialVariant | MaterialVariantOptions;
  proposedMaterialVariant?: MaterialVariant | MaterialVariantOptions;
  originalProjectItem?: ProjectItem | ProjectItemOptions;
  proposedProjectItem?: ProjectItem | ProjectItemOptions;
  totalCostInCents?: ChangeEventMaterialVariantSwap["totalCostInCents"];
  totalPriceInCents?: ChangeEventMaterialVariantSwap["totalPriceInCents"];
  canEditCost?: PotentialOperation2 | PotentialOperation2Options;
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  addedLineItem?: ChangeEventLineItem | ChangeEventLineItemOptions;
  removalLineItem?: ChangeEventLineItem | ChangeEventLineItemOptions;
  priceOnlyLineItem?: ChangeEventLineItem | ChangeEventLineItemOptions | null;
  isPlanBasedSwap?: ChangeEventMaterialVariantSwap["isPlanBasedSwap"];
  planBasedLineItems?: Array<ChangeEventLineItem | ChangeEventLineItemOptions>;
  matchesPlaceholder?: ChangeEventMaterialVariantSwap["matchesPlaceholder"];
  hasAwardedCost?: ChangeEventMaterialVariantSwap["hasAwardedCost"];
  proposedMaterialVariantWasCreated?: ChangeEventMaterialVariantSwap["proposedMaterialVariantWasCreated"];
}

export function newChangeEventMaterialVariantSwap(
  options: ChangeEventMaterialVariantSwapOptions = {},
  cache: Record<string, any> = {},
): ChangeEventMaterialVariantSwap {
  const o =
    (options.__typename ? options : cache["ChangeEventMaterialVariantSwap"] = {}) as ChangeEventMaterialVariantSwap;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventMaterialVariantSwap";
  o.id = options.id ?? nextFactoryId("ChangeEventMaterialVariantSwap");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
  o.originalMaterialVariant = maybeNew(
    "MaterialVariant",
    options.originalMaterialVariant,
    cache,
    options.hasOwnProperty("originalMaterialVariant"),
  );
  o.proposedMaterialVariant = maybeNew(
    "MaterialVariant",
    options.proposedMaterialVariant,
    cache,
    options.hasOwnProperty("proposedMaterialVariant"),
  );
  o.originalProjectItem = maybeNew(
    "ProjectItem",
    options.originalProjectItem,
    cache,
    options.hasOwnProperty("originalProjectItem"),
  );
  o.proposedProjectItem = maybeNew(
    "ProjectItem",
    options.proposedProjectItem,
    cache,
    options.hasOwnProperty("proposedProjectItem"),
  );
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.canEditCost = maybeNew("PotentialOperation2", options.canEditCost, cache, options.hasOwnProperty("canEditCost"));
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.addedLineItem = maybeNew(
    "ChangeEventLineItem",
    options.addedLineItem,
    cache,
    options.hasOwnProperty("addedLineItem"),
  );
  o.removalLineItem = maybeNew(
    "ChangeEventLineItem",
    options.removalLineItem,
    cache,
    options.hasOwnProperty("removalLineItem"),
  );
  o.priceOnlyLineItem = maybeNewOrNull("ChangeEventLineItem", options.priceOnlyLineItem, cache);
  o.isPlanBasedSwap = options.isPlanBasedSwap ?? false;
  o.planBasedLineItems = (options.planBasedLineItems ?? []).map((i) =>
    maybeNew("ChangeEventLineItem", i, cache, options.hasOwnProperty("planBasedLineItems"))
  );
  o.matchesPlaceholder = options.matchesPlaceholder ?? false;
  o.hasAwardedCost = options.hasAwardedCost ?? false;
  o.proposedMaterialVariantWasCreated = options.proposedMaterialVariantWasCreated ?? false;
  return o;
}

factories["ChangeEventMaterialVariantSwap"] = newChangeEventMaterialVariantSwap;

export interface ChangeEventOriginalOptionOptions {
  __typename?: "ChangeEventOriginalOption";
  id?: ChangeEventOriginalOption["id"];
  createdAt?: ChangeEventOriginalOption["createdAt"];
  priceInCents?: ChangeEventOriginalOption["priceInCents"];
  changeEvent?: ChangeEvent | ChangeEventOptions;
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions;
}

export function newChangeEventOriginalOption(
  options: ChangeEventOriginalOptionOptions = {},
  cache: Record<string, any> = {},
): ChangeEventOriginalOption {
  const o = (options.__typename ? options : cache["ChangeEventOriginalOption"] = {}) as ChangeEventOriginalOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventOriginalOption";
  o.id = options.id ?? nextFactoryId("ChangeEventOriginalOption");
  o.createdAt = options.createdAt ?? newDateTime();
  o.priceInCents = options.priceInCents ?? 0;
  o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
  o.readyPlanOption = maybeNew(
    "ReadyPlanOption",
    options.readyPlanOption,
    cache,
    options.hasOwnProperty("readyPlanOption"),
  );
  return o;
}

factories["ChangeEventOriginalOption"] = newChangeEventOriginalOption;

export interface ChangeEventProposedOptionOptions {
  __typename?: "ChangeEventProposedOption";
  id?: ChangeEventProposedOption["id"];
  createdAt?: ChangeEventProposedOption["createdAt"];
  priceInCents?: ChangeEventProposedOption["priceInCents"];
  changeEvent?: ChangeEvent | ChangeEventOptions;
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions;
}

export function newChangeEventProposedOption(
  options: ChangeEventProposedOptionOptions = {},
  cache: Record<string, any> = {},
): ChangeEventProposedOption {
  const o = (options.__typename ? options : cache["ChangeEventProposedOption"] = {}) as ChangeEventProposedOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventProposedOption";
  o.id = options.id ?? nextFactoryId("ChangeEventProposedOption");
  o.createdAt = options.createdAt ?? newDateTime();
  o.priceInCents = options.priceInCents ?? 0;
  o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
  o.readyPlanOption = maybeNew(
    "ReadyPlanOption",
    options.readyPlanOption,
    cache,
    options.hasOwnProperty("readyPlanOption"),
  );
  return o;
}

factories["ChangeEventProposedOption"] = newChangeEventProposedOption;

export interface ChangeEventReasonOptions {
  __typename?: "ChangeEventReason";
  id?: ChangeEventReason["id"];
  code?: ChangeEventReason["code"];
  name?: ChangeEventReason["name"];
  createdAt?: ChangeEventReason["createdAt"];
  updatedAt?: ChangeEventReason["updatedAt"];
  changeEvents?: Array<ChangeEvent | ChangeEventOptions>;
  isEpo?: ChangeEventReason["isEpo"];
  archived?: ChangeEventReason["archived"];
  isIncludedInVariance?: ChangeEventReason["isIncludedInVariance"];
  workflows?: ChangeEventReason["workflows"];
}

export function newChangeEventReason(
  options: ChangeEventReasonOptions = {},
  cache: Record<string, any> = {},
): ChangeEventReason {
  const o = (options.__typename ? options : cache["ChangeEventReason"] = {}) as ChangeEventReason;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventReason";
  o.id = options.id ?? nextFactoryId("ChangeEventReason");
  o.code = options.code ?? "code";
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.changeEvents = (options.changeEvents ?? []).map((i) =>
    maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("changeEvents"))
  );
  o.isEpo = options.isEpo ?? false;
  o.archived = options.archived ?? false;
  o.isIncludedInVariance = options.isIncludedInVariance ?? null;
  o.workflows = options.workflows ?? [];
  return o;
}

factories["ChangeEventReason"] = newChangeEventReason;

export interface SaveChangeEventReasonResultOptions {
  __typename?: "SaveChangeEventReasonResult";
  changeEventReason?: ChangeEventReason | ChangeEventReasonOptions;
}

export function newSaveChangeEventReasonResult(
  options: SaveChangeEventReasonResultOptions = {},
  cache: Record<string, any> = {},
): SaveChangeEventReasonResult {
  const o = (options.__typename ? options : cache["SaveChangeEventReasonResult"] = {}) as SaveChangeEventReasonResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveChangeEventReasonResult";
  o.changeEventReason = maybeNew(
    "ChangeEventReason",
    options.changeEventReason,
    cache,
    options.hasOwnProperty("changeEventReason"),
  );
  return o;
}

factories["SaveChangeEventReasonResult"] = newSaveChangeEventReasonResult;

export interface ChangeEventTemplateConfigOptions {
  __typename?: "ChangeEventTemplateConfig";
  id?: ChangeEventTemplateConfig["id"];
  onlyChangedInVersion?: ChangeEventTemplateConfig["onlyChangedInVersion"];
  projectStage?: ProjectStage | ProjectStageOptions;
  changeEvent?: ChangeEvent | ChangeEventOptions;
  itemTemplate?: ItemTemplate | ItemTemplateOptions;
  parent?: ItemTemplate | ReadyPlanAggregateVersion | BaseItemParentVersion | BaseItemParentVersionOptions;
  name?: ChangeEventTemplateConfig["name"];
  createdAt?: ChangeEventTemplateConfig["createdAt"];
}

export function newChangeEventTemplateConfig(
  options: ChangeEventTemplateConfigOptions = {},
  cache: Record<string, any> = {},
): ChangeEventTemplateConfig {
  const o = (options.__typename ? options : cache["ChangeEventTemplateConfig"] = {}) as ChangeEventTemplateConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventTemplateConfig";
  o.id = options.id ?? nextFactoryId("ChangeEventTemplateConfig");
  o.onlyChangedInVersion = options.onlyChangedInVersion ?? null;
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
  o.itemTemplate = maybeNew("ItemTemplate", options.itemTemplate, cache, options.hasOwnProperty("itemTemplate"));
  o.parent = maybeNew("BaseItemParentVersion", options.parent, cache, options.hasOwnProperty("parent"));
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  return o;
}

factories["ChangeEventTemplateConfig"] = newChangeEventTemplateConfig;

export interface ChangeRequestOptions {
  __typename?: "ChangeRequest";
  id?: ChangeRequest["id"];
  title?: ChangeRequest["title"];
  name?: ChangeRequest["name"];
  rationale?: ChangeRequest["rationale"];
  estimateBudgetImpactInCents?: ChangeRequest["estimateBudgetImpactInCents"];
  estimateBudgetImpactInCentsFallback?: ChangeRequest["estimateBudgetImpactInCentsFallback"];
  estimateScheduleImpactInDays?: ChangeRequest["estimateScheduleImpactInDays"];
  createdAt?: ChangeRequest["createdAt"];
  updatedAt?: ChangeRequest["updatedAt"];
  priority?: ChangeRequestPriorityDetailOptions | ChangeRequestPriority;
  source?: ChangeRequestSourceDetailOptions | ChangeRequestSource;
  status?: ChangeRequestStatusDetailOptions | ChangeRequestStatus;
  createdBy?: User | UserOptions;
  blueprintUrl?: Url | UrlOptions;
  scopes?: Array<ChangeRequestScope | ChangeRequestScopeOptions>;
  attachments?: Array<Attachment | AttachmentOptions>;
  blocking?: Array<ChangeRequest | ChangeRequestOptions>;
  blockers?: Array<ChangeRequest | ChangeRequestOptions>;
  changeRequestAssets?: Array<ChangeRequestAsset | ChangeRequestAssetOptions>;
  toDos?: Array<ChangeRequestToDo | ChangeRequestToDoOptions>;
  history?: Array<History | HistoryOptions>;
  changeTypes?: ChangeRequest["changeTypes"];
  approval?: Approval | ApprovalOptions | null;
  predictedApprovers?: Array<
    ApproverUser | ClientOptions | RequireTypename<InternalUserOptions> | RequireTypename<TradePartnerUserOptions>
  >;
  estimateRevenueImpactInCents?: ChangeRequest["estimateRevenueImpactInCents"];
  estimateMarginImpactBasisPoints?: ChangeRequest["estimateMarginImpactBasisPoints"];
  linkedTo?: Array<ChangeRequest | ChangeRequestOptions>;
  groups?: Array<ChangeRequestGroup | ChangeRequestGroupOptions>;
  isStandardOffering?: ChangeRequest["isStandardOffering"];
  salesforceOpportunityUrl?: ChangeRequest["salesforceOpportunityUrl"];
  isUnderContract?: ChangeRequest["isUnderContract"];
  productSelection?: ChangeRequest["productSelection"];
  markupBasisPoints?: ChangeRequest["markupBasisPoints"];
  estimatedBuyerOutOfPocketInCents?: ChangeRequest["estimatedBuyerOutOfPocketInCents"];
  estimatedRetailPriceInCents?: ChangeRequest["estimatedRetailPriceInCents"];
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ChangeRequest["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ChangeRequest["isFollowed"];
}

export function newChangeRequest(options: ChangeRequestOptions = {}, cache: Record<string, any> = {}): ChangeRequest {
  const o = (options.__typename ? options : cache["ChangeRequest"] = {}) as ChangeRequest;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequest";
  o.id = options.id ?? nextFactoryId("ChangeRequest");
  o.title = options.title ?? "title";
  o.name = options.name ?? "name";
  o.rationale = options.rationale ?? "rationale";
  o.estimateBudgetImpactInCents = options.estimateBudgetImpactInCents ?? null;
  o.estimateBudgetImpactInCentsFallback = options.estimateBudgetImpactInCentsFallback ?? 0;
  o.estimateScheduleImpactInDays = options.estimateScheduleImpactInDays ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.priority = enumOrDetailOfChangeRequestPriority(options.priority);
  o.source = enumOrDetailOfChangeRequestSource(options.source);
  o.status = enumOrDetailOfChangeRequestStatus(options.status);
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.scopes = (options.scopes ?? []).map((i) =>
    maybeNew("ChangeRequestScope", i, cache, options.hasOwnProperty("scopes"))
  );
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  o.blocking = (options.blocking ?? []).map((i) =>
    maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("blocking"))
  );
  o.blockers = (options.blockers ?? []).map((i) =>
    maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("blockers"))
  );
  o.changeRequestAssets = (options.changeRequestAssets ?? []).map((i) =>
    maybeNew("ChangeRequestAsset", i, cache, options.hasOwnProperty("changeRequestAssets"))
  );
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ChangeRequestToDo", i, cache, options.hasOwnProperty("toDos")));
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.changeTypes = options.changeTypes ?? [];
  o.approval = maybeNewOrNull("Approval", options.approval, cache);
  o.predictedApprovers = (options.predictedApprovers ?? []).map((i) =>
    maybeNew(i?.__typename ?? "{Client", i, cache, options.hasOwnProperty("predictedApprovers"))
  );
  o.estimateRevenueImpactInCents = options.estimateRevenueImpactInCents ?? null;
  o.estimateMarginImpactBasisPoints = options.estimateMarginImpactBasisPoints ?? null;
  o.linkedTo = (options.linkedTo ?? []).map((i) =>
    maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("linkedTo"))
  );
  o.groups = (options.groups ?? []).map((i) =>
    maybeNew("ChangeRequestGroup", i, cache, options.hasOwnProperty("groups"))
  );
  o.isStandardOffering = options.isStandardOffering ?? null;
  o.salesforceOpportunityUrl = options.salesforceOpportunityUrl ?? null;
  o.isUnderContract = options.isUnderContract ?? null;
  o.productSelection = options.productSelection ?? null;
  o.markupBasisPoints = options.markupBasisPoints ?? null;
  o.estimatedBuyerOutOfPocketInCents = options.estimatedBuyerOutOfPocketInCents ?? null;
  o.estimatedRetailPriceInCents = options.estimatedRetailPriceInCents ?? null;
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  return o;
}

factories["ChangeRequest"] = newChangeRequest;

export interface ChangeRequestsPageResultOptions {
  __typename?: "ChangeRequestsPageResult";
  entities?: Array<ChangeRequest | ChangeRequestOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newChangeRequestsPageResult(
  options: ChangeRequestsPageResultOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestsPageResult {
  const o = (options.__typename ? options : cache["ChangeRequestsPageResult"] = {}) as ChangeRequestsPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestsPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ChangeRequestsPageResult"] = newChangeRequestsPageResult;

export interface SaveChangeRequestResultOptions {
  __typename?: "SaveChangeRequestResult";
  changeRequest?: ChangeRequest | ChangeRequestOptions;
}

export function newSaveChangeRequestResult(
  options: SaveChangeRequestResultOptions = {},
  cache: Record<string, any> = {},
): SaveChangeRequestResult {
  const o = (options.__typename ? options : cache["SaveChangeRequestResult"] = {}) as SaveChangeRequestResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveChangeRequestResult";
  o.changeRequest = maybeNew("ChangeRequest", options.changeRequest, cache, options.hasOwnProperty("changeRequest"));
  return o;
}

factories["SaveChangeRequestResult"] = newSaveChangeRequestResult;

export interface SaveChangeRequestsResultOptions {
  __typename?: "SaveChangeRequestsResult";
  changeRequests?: Array<ChangeRequest | ChangeRequestOptions>;
}

export function newSaveChangeRequestsResult(
  options: SaveChangeRequestsResultOptions = {},
  cache: Record<string, any> = {},
): SaveChangeRequestsResult {
  const o = (options.__typename ? options : cache["SaveChangeRequestsResult"] = {}) as SaveChangeRequestsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveChangeRequestsResult";
  o.changeRequests = (options.changeRequests ?? []).map((i) =>
    maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("changeRequests"))
  );
  return o;
}

factories["SaveChangeRequestsResult"] = newSaveChangeRequestsResult;

export interface ChangeRequestApproverSubjectDataOptions {
  __typename?: "ChangeRequestApproverSubjectData";
  businessFunction?: ChangeRequestApproverSubjectData["businessFunction"];
  autoApprovalAmountInCents?: ChangeRequestApproverSubjectData["autoApprovalAmountInCents"];
}

export function newChangeRequestApproverSubjectData(
  options: ChangeRequestApproverSubjectDataOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestApproverSubjectData {
  const o =
    (options.__typename ? options : cache["ChangeRequestApproverSubjectData"] = {}) as ChangeRequestApproverSubjectData;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestApproverSubjectData";
  o.businessFunction = options.businessFunction ?? "businessFunction";
  o.autoApprovalAmountInCents = options.autoApprovalAmountInCents ?? null;
  return o;
}

factories["ChangeRequestApproverSubjectData"] = newChangeRequestApproverSubjectData;

export interface ChangeRequestAssetOptions {
  __typename?: "ChangeRequestAsset";
  id?: ChangeRequestAsset["id"];
  name?: ChangeRequestAsset["name"];
  deletedAt?: ChangeRequestAsset["deletedAt"];
  createdAt?: ChangeRequestAsset["createdAt"];
  updatedAt?: ChangeRequestAsset["updatedAt"];
  functionType?: BusinessFunctionTypeDetailOptions | BusinessFunctionType;
  platform?: ChangeRequestAssetPlatformDetailOptions | ChangeRequestAssetPlatform;
  implementationReviewer?: ProjectRoleDetailOptions | ProjectRole | null;
  changeRequests?: Array<ChangeRequest | ChangeRequestOptions>;
  scopes?: ChangeRequestAsset["scopes"];
  implementer?: ProjectRoleDetailOptions | ProjectRole;
  requiredForChangeRequestSource?: ChangeRequestAsset["requiredForChangeRequestSource"];
  systemChangeRequestAsset?: SystemChangeRequestAssetDetailOptions | SystemChangeRequestAsset | null;
}

export function newChangeRequestAsset(
  options: ChangeRequestAssetOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestAsset {
  const o = (options.__typename ? options : cache["ChangeRequestAsset"] = {}) as ChangeRequestAsset;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestAsset";
  o.id = options.id ?? nextFactoryId("ChangeRequestAsset");
  o.name = options.name ?? "name";
  o.deletedAt = options.deletedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.functionType = enumOrDetailOfBusinessFunctionType(options.functionType);
  o.platform = enumOrDetailOfChangeRequestAssetPlatform(options.platform);
  o.implementationReviewer = enumOrDetailOrNullOfProjectRole(options.implementationReviewer);
  o.changeRequests = (options.changeRequests ?? []).map((i) =>
    maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("changeRequests"))
  );
  o.scopes = options.scopes ?? [];
  o.implementer = enumOrDetailOfProjectRole(options.implementer);
  o.requiredForChangeRequestSource = options.requiredForChangeRequestSource ?? [];
  o.systemChangeRequestAsset = enumOrDetailOrNullOfSystemChangeRequestAsset(options.systemChangeRequestAsset);
  return o;
}

factories["ChangeRequestAsset"] = newChangeRequestAsset;

export interface SaveChangeRequestAssetsResultOptions {
  __typename?: "SaveChangeRequestAssetsResult";
  changeRequestAssets?: Array<ChangeRequestAsset | ChangeRequestAssetOptions>;
}

export function newSaveChangeRequestAssetsResult(
  options: SaveChangeRequestAssetsResultOptions = {},
  cache: Record<string, any> = {},
): SaveChangeRequestAssetsResult {
  const o =
    (options.__typename ? options : cache["SaveChangeRequestAssetsResult"] = {}) as SaveChangeRequestAssetsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveChangeRequestAssetsResult";
  o.changeRequestAssets = (options.changeRequestAssets ?? []).map((i) =>
    maybeNew("ChangeRequestAsset", i, cache, options.hasOwnProperty("changeRequestAssets"))
  );
  return o;
}

factories["SaveChangeRequestAssetsResult"] = newSaveChangeRequestAssetsResult;

export interface ChangeRequestAssetsPageResultOptions {
  __typename?: "ChangeRequestAssetsPageResult";
  entities?: Array<ChangeRequestAsset | ChangeRequestAssetOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newChangeRequestAssetsPageResult(
  options: ChangeRequestAssetsPageResultOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestAssetsPageResult {
  const o =
    (options.__typename ? options : cache["ChangeRequestAssetsPageResult"] = {}) as ChangeRequestAssetsPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestAssetsPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("ChangeRequestAsset", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ChangeRequestAssetsPageResult"] = newChangeRequestAssetsPageResult;

export interface ChangeRequestGroupOptions {
  __typename?: "ChangeRequestGroup";
  id?: ChangeRequestGroup["id"];
  name?: ChangeRequestGroup["name"];
  createdAt?: ChangeRequestGroup["createdAt"];
  updatedAt?: ChangeRequestGroup["updatedAt"];
  changeRequests?: Array<ChangeRequest | ChangeRequestOptions>;
  salesforceOpportunityLink?: ChangeRequestGroup["salesforceOpportunityLink"];
  underContract?: ChangeRequestGroup["underContract"];
}

export function newChangeRequestGroup(
  options: ChangeRequestGroupOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestGroup {
  const o = (options.__typename ? options : cache["ChangeRequestGroup"] = {}) as ChangeRequestGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestGroup";
  o.id = options.id ?? nextFactoryId("ChangeRequestGroup");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.changeRequests = (options.changeRequests ?? []).map((i) =>
    maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("changeRequests"))
  );
  o.salesforceOpportunityLink = options.salesforceOpportunityLink ?? null;
  o.underContract = options.underContract ?? null;
  return o;
}

factories["ChangeRequestGroup"] = newChangeRequestGroup;

export interface SaveChangeRequestGroupResultOptions {
  __typename?: "SaveChangeRequestGroupResult";
  changeRequestGroup?: ChangeRequestGroup | ChangeRequestGroupOptions;
}

export function newSaveChangeRequestGroupResult(
  options: SaveChangeRequestGroupResultOptions = {},
  cache: Record<string, any> = {},
): SaveChangeRequestGroupResult {
  const o = (options.__typename ? options : cache["SaveChangeRequestGroupResult"] = {}) as SaveChangeRequestGroupResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveChangeRequestGroupResult";
  o.changeRequestGroup = maybeNew(
    "ChangeRequestGroup",
    options.changeRequestGroup,
    cache,
    options.hasOwnProperty("changeRequestGroup"),
  );
  return o;
}

factories["SaveChangeRequestGroupResult"] = newSaveChangeRequestGroupResult;

export interface SaveChangeRequestGroupsResultOptions {
  __typename?: "SaveChangeRequestGroupsResult";
  changeRequestGroups?: Array<ChangeRequestGroup | ChangeRequestGroupOptions>;
}

export function newSaveChangeRequestGroupsResult(
  options: SaveChangeRequestGroupsResultOptions = {},
  cache: Record<string, any> = {},
): SaveChangeRequestGroupsResult {
  const o =
    (options.__typename ? options : cache["SaveChangeRequestGroupsResult"] = {}) as SaveChangeRequestGroupsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveChangeRequestGroupsResult";
  o.changeRequestGroups = (options.changeRequestGroups ?? []).map((i) =>
    maybeNew("ChangeRequestGroup", i, cache, options.hasOwnProperty("changeRequestGroups"))
  );
  return o;
}

factories["SaveChangeRequestGroupsResult"] = newSaveChangeRequestGroupsResult;

export interface ChangeRequestScopeOptions {
  __typename?: "ChangeRequestScope";
  id?: ChangeRequestScope["id"];
  createdAt?: ChangeRequestScope["createdAt"];
  updatedAt?: ChangeRequestScope["updatedAt"];
  changeRequest?: ChangeRequest | ChangeRequestOptions;
  target?:
    | ChangeRequestScopeTarget
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>;
  deletedAt?: ChangeRequestScope["deletedAt"];
}

export function newChangeRequestScope(
  options: ChangeRequestScopeOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestScope {
  const o = (options.__typename ? options : cache["ChangeRequestScope"] = {}) as ChangeRequestScope;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestScope";
  o.id = options.id ?? nextFactoryId("ChangeRequestScope");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.changeRequest = maybeNew("ChangeRequest", options.changeRequest, cache, options.hasOwnProperty("changeRequest"));
  o.target = maybeNew(options.target?.__typename ?? "StandaloneProject", options.target, cache);
  o.deletedAt = options.deletedAt ?? null;
  return o;
}

factories["ChangeRequestScope"] = newChangeRequestScope;

export interface ChangeRequestToDoOptions {
  __typename?: "ChangeRequestToDo";
  id?: ChangeRequestToDo["id"];
  name?: ChangeRequestToDo["name"];
  description?: ChangeRequestToDo["description"];
  deletedAt?: ChangeRequestToDo["deletedAt"];
  createdAt?: ChangeRequestToDo["createdAt"];
  updatedAt?: ChangeRequestToDo["updatedAt"];
  dueDate?: ChangeRequestToDo["dueDate"];
  order?: ChangeRequestToDo["order"];
  urgent?: ChangeRequestToDo["urgent"];
  status?: ToDoStatusDetailOptions | ToDoStatus;
  type?: ToDoTypeDetailOptions | ToDoType;
  createdBy?: User | UserOptions;
  attachments?: Array<Attachment | AttachmentOptions>;
  checklistItems?: Array<ToDoChecklistItem | ToDoChecklistItemOptions>;
  assignees?: Array<User | UserOptions>;
  parent?:
    | ToDoParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<CohortOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | null;
  priorityGroup?: ChangeRequestToDo["priorityGroup"];
  changeRequestToDoType?: ChangeRequestToDoTypeDetailOptions | ChangeRequestToDoType;
  businessFunction?: BusinessFunction | BusinessFunctionOptions;
  changeRequest?: ChangeRequest | ChangeRequestOptions;
  changeRequestAsset?: ChangeRequestAsset | ChangeRequestAssetOptions | null;
  originalAssignee?: User | UserOptions;
  blueprintUrl?: Url | UrlOptions;
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ChangeRequestToDo["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ChangeRequestToDo["isFollowed"];
}

export function newChangeRequestToDo(
  options: ChangeRequestToDoOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestToDo {
  const o = (options.__typename ? options : cache["ChangeRequestToDo"] = {}) as ChangeRequestToDo;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestToDo";
  o.id = options.id ?? nextFactoryId("ChangeRequestToDo");
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.deletedAt = options.deletedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.dueDate = options.dueDate ?? null;
  o.order = options.order ?? "order";
  o.urgent = options.urgent ?? false;
  o.status = enumOrDetailOfToDoStatus(options.status);
  o.type = enumOrDetailOfToDoType(options.type);
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  o.checklistItems = (options.checklistItems ?? []).map((i) =>
    maybeNew("ToDoChecklistItem", i, cache, options.hasOwnProperty("checklistItems"))
  );
  o.assignees = (options.assignees ?? []).map((i) => maybeNew("User", i, cache, options.hasOwnProperty("assignees")));
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  o.priorityGroup = options.priorityGroup ?? 0;
  o.changeRequestToDoType = enumOrDetailOfChangeRequestToDoType(options.changeRequestToDoType);
  o.businessFunction = maybeNew(
    "BusinessFunction",
    options.businessFunction,
    cache,
    options.hasOwnProperty("businessFunction"),
  );
  o.changeRequest = maybeNew("ChangeRequest", options.changeRequest, cache, options.hasOwnProperty("changeRequest"));
  o.changeRequestAsset = maybeNewOrNull("ChangeRequestAsset", options.changeRequestAsset, cache);
  o.originalAssignee = maybeNew("User", options.originalAssignee, cache, options.hasOwnProperty("originalAssignee"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  return o;
}

factories["ChangeRequestToDo"] = newChangeRequestToDo;

export interface CheckoutConfigOptions {
  __typename?: "CheckoutConfig";
  id?: CheckoutConfig["id"];
  name?: CheckoutConfig["name"];
  reservedAt?: CheckoutConfig["reservedAt"];
  expiresAt?: CheckoutConfig["expiresAt"];
  status?: CheckoutConfig["status"];
  customerEmail?: CheckoutConfig["customerEmail"];
  customerFirstName?: CheckoutConfig["customerFirstName"];
  customerLastName?: CheckoutConfig["customerLastName"];
  customerPhone?: CheckoutConfig["customerPhone"];
  structure?: Structure | StructureOptions;
  community?: Community | CommunityOptions;
  productOffering?: ProductOffering | ProductOfferingOptions | null;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions | null;
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  isReversed?: CheckoutConfig["isReversed"];
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionGroups?: Array<CheckoutConfigOptionGroup | CheckoutConfigOptionGroupOptions>;
  mhOptionGroups?: Array<CheckoutConfigOptionGroup | CheckoutConfigOptionGroupOptions>;
  aduOptionGroups?: Array<CheckoutConfigOptionGroup | CheckoutConfigOptionGroupOptions>;
  mhSalesPriceInCents?: CheckoutConfig["mhSalesPriceInCents"];
  aduSalesPriceInCents?: CheckoutConfig["aduSalesPriceInCents"];
  salesPriceInCents?: CheckoutConfig["salesPriceInCents"];
  mhTotalPriceInCents?: CheckoutConfig["mhTotalPriceInCents"];
  aduTotalPriceInCents?: CheckoutConfig["aduTotalPriceInCents"];
  additionalSitePriceInCents?: CheckoutConfig["additionalSitePriceInCents"];
  totalPriceInCents?: CheckoutConfig["totalPriceInCents"];
  createdAt?: CheckoutConfig["createdAt"];
  updatedAt?: CheckoutConfig["updatedAt"];
  checkoutUrl?: Url | UrlOptions;
  pricingTraceUrl?: Url | UrlOptions | null;
  canChangeProductOffering?: PotentialOperation2 | PotentialOperation2Options;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  programData?: ProgramData | ProgramDataOptions | null;
  aduProgramData?: ProgramData | ProgramDataOptions | null;
  rendering?: Asset | AssetOptions | null;
  interiorRenderings?: Array<InteriorRoomRendering | InteriorRoomRenderingOptions>;
  renderings?: Array<RenderingAsset | RenderingAssetOptions>;
  storedPriceInCents?: CheckoutConfig["storedPriceInCents"];
  createdBy?: User | UserOptions | null;
  interiorSubSteps?: Array<CheckoutConfigInteriorSubStep | CheckoutConfigInteriorSubStepOptions>;
  insideMapsTextureSwaps?: InsideMapsTextureSwaps | InsideMapsTextureSwapsOptions | null;
  insideMapsRoomRenderings?: Array<InsideMapsRoomRendering | InsideMapsRoomRenderingOptions>;
  homeowners?: Array<Homeowner | HomeownerOptions>;
  aggregateVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  changeEvents?: Array<ChangeEvent | ChangeEventOptions>;
  archivedAt?: CheckoutConfig["archivedAt"];
  useStackedPricing?: CheckoutConfig["useStackedPricing"];
  mhEstimatedInvoiceSchedule?: Array<EstimatedInvoiceScheduleItem | EstimatedInvoiceScheduleItemOptions>;
  aduEstimatedInvoiceSchedule?: Array<EstimatedInvoiceScheduleItem | EstimatedInvoiceScheduleItemOptions>;
  estimatedInvoiceSchedule?: Array<EstimatedInvoiceScheduleItem | EstimatedInvoiceScheduleItemOptions>;
  buildablePlans?: Array<ProductOffering | ProductOfferingOptions>;
  buildableAduPlans?: Array<ProductOffering | ProductOfferingOptions>;
  aduProductOffering?: ProductOffering | ProductOfferingOptions | null;
  aduAggregateVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  potentialAdus?: Array<ProductOffering | ProductOfferingOptions>;
  isPinned?: CheckoutConfig["isPinned"];
  isAduPinned?: CheckoutConfig["isAduPinned"];
}

export function newCheckoutConfig(
  options: CheckoutConfigOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfig {
  const o = (options.__typename ? options : cache["CheckoutConfig"] = {}) as CheckoutConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfig";
  o.id = options.id ?? nextFactoryId("CheckoutConfig");
  o.name = options.name ?? null;
  o.reservedAt = options.reservedAt ?? null;
  o.expiresAt = options.expiresAt ?? null;
  o.status = options.status ?? CheckoutConfigStatus.Draft;
  o.customerEmail = options.customerEmail ?? null;
  o.customerFirstName = options.customerFirstName ?? null;
  o.customerLastName = options.customerLastName ?? null;
  o.customerPhone = options.customerPhone ?? null;
  o.structure = maybeNew("Structure", options.structure, cache, options.hasOwnProperty("structure"));
  o.community = maybeNew("Community", options.community, cache, options.hasOwnProperty("community"));
  o.productOffering = maybeNewOrNull("ProductOffering", options.productOffering, cache);
  o.readyPlan = maybeNewOrNull("ReadyPlanLike", options.readyPlan, cache);
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  o.isReversed = options.isReversed ?? false;
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.optionGroups = (options.optionGroups ?? []).map((i) =>
    maybeNew("CheckoutConfigOptionGroup", i, cache, options.hasOwnProperty("optionGroups"))
  );
  o.mhOptionGroups = (options.mhOptionGroups ?? []).map((i) =>
    maybeNew("CheckoutConfigOptionGroup", i, cache, options.hasOwnProperty("mhOptionGroups"))
  );
  o.aduOptionGroups = (options.aduOptionGroups ?? []).map((i) =>
    maybeNew("CheckoutConfigOptionGroup", i, cache, options.hasOwnProperty("aduOptionGroups"))
  );
  o.mhSalesPriceInCents = options.mhSalesPriceInCents ?? 0;
  o.aduSalesPriceInCents = options.aduSalesPriceInCents ?? 0;
  o.salesPriceInCents = options.salesPriceInCents ?? 0;
  o.mhTotalPriceInCents = options.mhTotalPriceInCents ?? 0;
  o.aduTotalPriceInCents = options.aduTotalPriceInCents ?? 0;
  o.additionalSitePriceInCents = options.additionalSitePriceInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.checkoutUrl = maybeNew("Url", options.checkoutUrl, cache, options.hasOwnProperty("checkoutUrl"));
  o.pricingTraceUrl = maybeNewOrNull("Url", options.pricingTraceUrl, cache);
  o.canChangeProductOffering = maybeNew(
    "PotentialOperation2",
    options.canChangeProductOffering,
    cache,
    options.hasOwnProperty("canChangeProductOffering"),
  );
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.programData = maybeNewOrNull("ProgramData", options.programData, cache);
  o.aduProgramData = maybeNewOrNull("ProgramData", options.aduProgramData, cache);
  o.rendering = maybeNewOrNull("Asset", options.rendering, cache);
  o.interiorRenderings = (options.interiorRenderings ?? []).map((i) =>
    maybeNew("InteriorRoomRendering", i, cache, options.hasOwnProperty("interiorRenderings"))
  );
  o.renderings = (options.renderings ?? []).map((i) =>
    maybeNew("RenderingAsset", i, cache, options.hasOwnProperty("renderings"))
  );
  o.storedPriceInCents = options.storedPriceInCents ?? null;
  o.createdBy = maybeNewOrNull("User", options.createdBy, cache);
  o.interiorSubSteps = (options.interiorSubSteps ?? []).map((i) =>
    maybeNew("CheckoutConfigInteriorSubStep", i, cache, options.hasOwnProperty("interiorSubSteps"))
  );
  o.insideMapsTextureSwaps = maybeNewOrNull("InsideMapsTextureSwaps", options.insideMapsTextureSwaps, cache);
  o.insideMapsRoomRenderings = (options.insideMapsRoomRenderings ?? []).map((i) =>
    maybeNew("InsideMapsRoomRendering", i, cache, options.hasOwnProperty("insideMapsRoomRenderings"))
  );
  o.homeowners = (options.homeowners ?? []).map((i) =>
    maybeNew("Homeowner", i, cache, options.hasOwnProperty("homeowners"))
  );
  o.aggregateVersion = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateVersion, cache);
  o.changeEvents = (options.changeEvents ?? []).map((i) =>
    maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("changeEvents"))
  );
  o.archivedAt = options.archivedAt ?? null;
  o.useStackedPricing = options.useStackedPricing ?? false;
  o.mhEstimatedInvoiceSchedule = (options.mhEstimatedInvoiceSchedule ?? []).map((i) =>
    maybeNew("EstimatedInvoiceScheduleItem", i, cache, options.hasOwnProperty("mhEstimatedInvoiceSchedule"))
  );
  o.aduEstimatedInvoiceSchedule = (options.aduEstimatedInvoiceSchedule ?? []).map((i) =>
    maybeNew("EstimatedInvoiceScheduleItem", i, cache, options.hasOwnProperty("aduEstimatedInvoiceSchedule"))
  );
  o.estimatedInvoiceSchedule = (options.estimatedInvoiceSchedule ?? []).map((i) =>
    maybeNew("EstimatedInvoiceScheduleItem", i, cache, options.hasOwnProperty("estimatedInvoiceSchedule"))
  );
  o.buildablePlans = (options.buildablePlans ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("buildablePlans"))
  );
  o.buildableAduPlans = (options.buildableAduPlans ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("buildableAduPlans"))
  );
  o.aduProductOffering = maybeNewOrNull("ProductOffering", options.aduProductOffering, cache);
  o.aduAggregateVersion = maybeNewOrNull("ReadyPlanAggregateVersion", options.aduAggregateVersion, cache);
  o.potentialAdus = (options.potentialAdus ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("potentialAdus"))
  );
  o.isPinned = options.isPinned ?? false;
  o.isAduPinned = options.isAduPinned ?? false;
  return o;
}

factories["CheckoutConfig"] = newCheckoutConfig;

export interface EstimatedInvoiceScheduleItemOptions {
  __typename?: "EstimatedInvoiceScheduleItem";
  costCodeInvoiceCategory?: EstimatedInvoiceScheduleItem["costCodeInvoiceCategory"];
  invoiceAmountInCents?: EstimatedInvoiceScheduleItem["invoiceAmountInCents"];
}

export function newEstimatedInvoiceScheduleItem(
  options: EstimatedInvoiceScheduleItemOptions = {},
  cache: Record<string, any> = {},
): EstimatedInvoiceScheduleItem {
  const o = (options.__typename ? options : cache["EstimatedInvoiceScheduleItem"] = {}) as EstimatedInvoiceScheduleItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EstimatedInvoiceScheduleItem";
  o.costCodeInvoiceCategory = options.costCodeInvoiceCategory ?? CostCodeInvoiceCategory.PreCon;
  o.invoiceAmountInCents = options.invoiceAmountInCents ?? 0;
  return o;
}

factories["EstimatedInvoiceScheduleItem"] = newEstimatedInvoiceScheduleItem;

export interface CheckoutConfigOptionGroupOptions {
  __typename?: "CheckoutConfigOptionGroup";
  id?: CheckoutConfigOptionGroup["id"];
  step?: CheckoutConfigOptionGroup["step"];
  subStepNumber?: CheckoutConfigOptionGroup["subStepNumber"];
  group?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions;
  options?: Array<CheckoutConfigPotentialOption | CheckoutConfigPotentialOptionOptions>;
  selectedOption?: CheckoutConfigPotentialOption | CheckoutConfigPotentialOptionOptions | null;
  cutoffDate?: CheckoutConfigOptionGroup["cutoffDate"];
  isEnabled?: CheckoutConfigOptionGroup["isEnabled"];
  canBeSelected?: PotentialOperation2 | PotentialOperation2Options;
  showOnCustomerSummary?: CheckoutConfigOptionGroup["showOnCustomerSummary"];
  parentGroup?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions | null;
  childGroup?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions | null;
}

export function newCheckoutConfigOptionGroup(
  options: CheckoutConfigOptionGroupOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfigOptionGroup {
  const o = (options.__typename ? options : cache["CheckoutConfigOptionGroup"] = {}) as CheckoutConfigOptionGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfigOptionGroup";
  o.id = options.id ?? nextFactoryId("CheckoutConfigOptionGroup");
  o.step = options.step ?? CheckoutConfigOptionGroupStep.ExteriorElevation;
  o.subStepNumber = options.subStepNumber ?? null;
  o.group = maybeNew("ReadyPlanOptionGroup", options.group, cache, options.hasOwnProperty("group"));
  o.options = (options.options ?? []).map((i) =>
    maybeNew("CheckoutConfigPotentialOption", i, cache, options.hasOwnProperty("options"))
  );
  o.selectedOption = maybeNewOrNull("CheckoutConfigPotentialOption", options.selectedOption, cache);
  o.cutoffDate = options.cutoffDate ?? null;
  o.isEnabled = options.isEnabled ?? false;
  o.canBeSelected = maybeNew(
    "PotentialOperation2",
    options.canBeSelected,
    cache,
    options.hasOwnProperty("canBeSelected"),
  );
  o.showOnCustomerSummary = options.showOnCustomerSummary ?? false;
  o.parentGroup = maybeNewOrNull("ReadyPlanOptionGroup", options.parentGroup, cache);
  o.childGroup = maybeNewOrNull("ReadyPlanOptionGroup", options.childGroup, cache);
  return o;
}

factories["CheckoutConfigOptionGroup"] = newCheckoutConfigOptionGroup;

export interface CheckoutConfigPotentialOptionOptions {
  __typename?: "CheckoutConfigPotentialOption";
  id?: CheckoutConfigPotentialOption["id"];
  option?: ReadyPlanOption | ReadyPlanOptionOptions;
  isSelected?: CheckoutConfigPotentialOption["isSelected"];
  isEnabled?: CheckoutConfigPotentialOption["isEnabled"];
  canBeSelected?: PotentialOperation2 | PotentialOperation2Options;
  showOnSummary?: CheckoutConfigPotentialOption["showOnSummary"];
  totalPriceInCents?: CheckoutConfigPotentialOption["totalPriceInCents"];
  totalCostInCents?: CheckoutConfigPotentialOption["totalCostInCents"];
  packageOptionMaterials?: Array<MaterialVariant | MaterialVariantOptions>;
  primaryProduct?: MaterialVariant | MaterialVariantOptions | null;
  displayProducts?: Array<MaterialVariant | MaterialVariantOptions>;
  includedBy?: CheckoutConfigPotentialOption | CheckoutConfigPotentialOptionOptions | null;
  includedByRoot?: CheckoutConfigPotentialOption | CheckoutConfigPotentialOptionOptions | null;
}

export function newCheckoutConfigPotentialOption(
  options: CheckoutConfigPotentialOptionOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfigPotentialOption {
  const o =
    (options.__typename ? options : cache["CheckoutConfigPotentialOption"] = {}) as CheckoutConfigPotentialOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfigPotentialOption";
  o.id = options.id ?? nextFactoryId("CheckoutConfigPotentialOption");
  o.option = maybeNew("ReadyPlanOption", options.option, cache, options.hasOwnProperty("option"));
  o.isSelected = options.isSelected ?? false;
  o.isEnabled = options.isEnabled ?? false;
  o.canBeSelected = maybeNew(
    "PotentialOperation2",
    options.canBeSelected,
    cache,
    options.hasOwnProperty("canBeSelected"),
  );
  o.showOnSummary = options.showOnSummary ?? false;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.packageOptionMaterials = (options.packageOptionMaterials ?? []).map((i) =>
    maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("packageOptionMaterials"))
  );
  o.primaryProduct = maybeNewOrNull("MaterialVariant", options.primaryProduct, cache);
  o.displayProducts = (options.displayProducts ?? []).map((i) =>
    maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("displayProducts"))
  );
  o.includedBy = maybeNewOrNull("CheckoutConfigPotentialOption", options.includedBy, cache);
  o.includedByRoot = maybeNewOrNull("CheckoutConfigPotentialOption", options.includedByRoot, cache);
  return o;
}

factories["CheckoutConfigPotentialOption"] = newCheckoutConfigPotentialOption;

export interface CheckoutConfigPackageOptionSlotOptions {
  __typename?: "CheckoutConfigPackageOptionSlot";
  id?: CheckoutConfigPackageOptionSlot["id"];
  location?: Location | LocationOptions;
  materialVariant?: MaterialVariant | MaterialVariantOptions;
}

export function newCheckoutConfigPackageOptionSlot(
  options: CheckoutConfigPackageOptionSlotOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfigPackageOptionSlot {
  const o =
    (options.__typename ? options : cache["CheckoutConfigPackageOptionSlot"] = {}) as CheckoutConfigPackageOptionSlot;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfigPackageOptionSlot";
  o.id = options.id ?? nextFactoryId("CheckoutConfigPackageOptionSlot");
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.materialVariant = maybeNew(
    "MaterialVariant",
    options.materialVariant,
    cache,
    options.hasOwnProperty("materialVariant"),
  );
  return o;
}

factories["CheckoutConfigPackageOptionSlot"] = newCheckoutConfigPackageOptionSlot;

export interface CheckoutConfigPackageOptionProductOptions {
  __typename?: "CheckoutConfigPackageOptionProduct";
  id?: CheckoutConfigPackageOptionProduct["id"];
  slotId?: CheckoutConfigPackageOptionProduct["slotId"];
  placeholder?: MaterialVariant | MaterialVariantOptions;
  location?: Location | LocationOptions;
  product?: MaterialVariant | MaterialVariantOptions;
  displayPackageOptionsAsSingleProduct?: CheckoutConfigPackageOptionProduct["displayPackageOptionsAsSingleProduct"];
}

export function newCheckoutConfigPackageOptionProduct(
  options: CheckoutConfigPackageOptionProductOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfigPackageOptionProduct {
  const o =
    (options.__typename
      ? options
      : cache["CheckoutConfigPackageOptionProduct"] = {}) as CheckoutConfigPackageOptionProduct;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfigPackageOptionProduct";
  o.id = options.id ?? nextFactoryId("CheckoutConfigPackageOptionProduct");
  o.slotId = options.slotId ?? "slotId";
  o.placeholder = maybeNew("MaterialVariant", options.placeholder, cache, options.hasOwnProperty("placeholder"));
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.product = maybeNew("MaterialVariant", options.product, cache, options.hasOwnProperty("product"));
  o.displayPackageOptionsAsSingleProduct = options.displayPackageOptionsAsSingleProduct ?? false;
  return o;
}

factories["CheckoutConfigPackageOptionProduct"] = newCheckoutConfigPackageOptionProduct;

export interface SaveCheckoutConfigResultOptions {
  __typename?: "SaveCheckoutConfigResult";
  checkoutConfig?: CheckoutConfig | CheckoutConfigOptions;
}

export function newSaveCheckoutConfigResult(
  options: SaveCheckoutConfigResultOptions = {},
  cache: Record<string, any> = {},
): SaveCheckoutConfigResult {
  const o = (options.__typename ? options : cache["SaveCheckoutConfigResult"] = {}) as SaveCheckoutConfigResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCheckoutConfigResult";
  o.checkoutConfig = maybeNew(
    "CheckoutConfig",
    options.checkoutConfig,
    cache,
    options.hasOwnProperty("checkoutConfig"),
  );
  return o;
}

factories["SaveCheckoutConfigResult"] = newSaveCheckoutConfigResult;

export interface CheckoutConfigsPageOptions {
  __typename?: "CheckoutConfigsPage";
  entities?: Array<CheckoutConfig | CheckoutConfigOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newCheckoutConfigsPage(
  options: CheckoutConfigsPageOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfigsPage {
  const o = (options.__typename ? options : cache["CheckoutConfigsPage"] = {}) as CheckoutConfigsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfigsPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("CheckoutConfig", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["CheckoutConfigsPage"] = newCheckoutConfigsPage;

export interface CheckoutPricingTraceOptions {
  __typename?: "CheckoutPricingTrace";
  checkoutConfig?: CheckoutConfig | CheckoutConfigOptions | null;
  baseHousePriceInCents?: CheckoutPricingTrace["baseHousePriceInCents"];
  includedPriceInCents?: CheckoutPricingTrace["includedPriceInCents"];
  selectedPriceInCents?: CheckoutPricingTrace["selectedPriceInCents"];
  optionGroups?: Array<CheckoutPricingTraceOptionGroup | CheckoutPricingTraceOptionGroupOptions>;
}

export function newCheckoutPricingTrace(
  options: CheckoutPricingTraceOptions = {},
  cache: Record<string, any> = {},
): CheckoutPricingTrace {
  const o = (options.__typename ? options : cache["CheckoutPricingTrace"] = {}) as CheckoutPricingTrace;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutPricingTrace";
  o.checkoutConfig = maybeNewOrNull("CheckoutConfig", options.checkoutConfig, cache);
  o.baseHousePriceInCents = options.baseHousePriceInCents ?? 0;
  o.includedPriceInCents = options.includedPriceInCents ?? 0;
  o.selectedPriceInCents = options.selectedPriceInCents ?? 0;
  o.optionGroups = (options.optionGroups ?? []).map((i) =>
    maybeNew("CheckoutPricingTraceOptionGroup", i, cache, options.hasOwnProperty("optionGroups"))
  );
  return o;
}

factories["CheckoutPricingTrace"] = newCheckoutPricingTrace;

export interface CheckoutPricingTraceOptionGroupOptions {
  __typename?: "CheckoutPricingTraceOptionGroup";
  group?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions;
  included?: CheckoutPricingTraceOption | CheckoutPricingTraceOptionOptions | null;
  selected?: CheckoutPricingTraceOption | CheckoutPricingTraceOptionOptions | null;
  availableCreditInCents?: CheckoutPricingTraceOptionGroup["availableCreditInCents"];
  priceChangeInCents?: CheckoutPricingTraceOptionGroup["priceChangeInCents"];
}

export function newCheckoutPricingTraceOptionGroup(
  options: CheckoutPricingTraceOptionGroupOptions = {},
  cache: Record<string, any> = {},
): CheckoutPricingTraceOptionGroup {
  const o =
    (options.__typename ? options : cache["CheckoutPricingTraceOptionGroup"] = {}) as CheckoutPricingTraceOptionGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutPricingTraceOptionGroup";
  o.group = maybeNew("ReadyPlanOptionGroup", options.group, cache, options.hasOwnProperty("group"));
  o.included = maybeNewOrNull("CheckoutPricingTraceOption", options.included, cache);
  o.selected = maybeNewOrNull("CheckoutPricingTraceOption", options.selected, cache);
  o.availableCreditInCents = options.availableCreditInCents ?? 0;
  o.priceChangeInCents = options.priceChangeInCents ?? 0;
  return o;
}

factories["CheckoutPricingTraceOptionGroup"] = newCheckoutPricingTraceOptionGroup;

export interface CheckoutPricingTraceOptionOptions {
  __typename?: "CheckoutPricingTraceOption";
  option?: ReadyPlanOption | ReadyPlanOptionOptions | null;
  totalPriceInCents?: CheckoutPricingTraceOption["totalPriceInCents"];
  changed?: Array<CheckoutPricingTraceOptionChange | CheckoutPricingTraceOptionChangeOptions>;
}

export function newCheckoutPricingTraceOption(
  options: CheckoutPricingTraceOptionOptions = {},
  cache: Record<string, any> = {},
): CheckoutPricingTraceOption {
  const o = (options.__typename ? options : cache["CheckoutPricingTraceOption"] = {}) as CheckoutPricingTraceOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutPricingTraceOption";
  o.option = maybeNewOrNull("ReadyPlanOption", options.option, cache);
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.changed = (options.changed ?? []).map((i) =>
    maybeNew("CheckoutPricingTraceOptionChange", i, cache, options.hasOwnProperty("changed"))
  );
  return o;
}

factories["CheckoutPricingTraceOption"] = newCheckoutPricingTraceOption;

export interface CheckoutPricingTraceOptionChangeOptions {
  __typename?: "CheckoutPricingTraceOptionChange";
  group?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions;
  option?: ReadyPlanOption | ReadyPlanOptionOptions | null;
  previousOption?: ReadyPlanOption | ReadyPlanOptionOptions | null;
  priceInCents?: CheckoutPricingTraceOptionChange["priceInCents"];
  storedPriceInCents?: CheckoutPricingTraceOptionChange["storedPriceInCents"];
  costInCents?: CheckoutPricingTraceOptionChange["costInCents"];
  selectionFeeInCents?: CheckoutPricingTraceOptionChange["selectionFeeInCents"];
  minimumPriceInCents?: CheckoutPricingTraceOptionChange["minimumPriceInCents"];
}

export function newCheckoutPricingTraceOptionChange(
  options: CheckoutPricingTraceOptionChangeOptions = {},
  cache: Record<string, any> = {},
): CheckoutPricingTraceOptionChange {
  const o =
    (options.__typename ? options : cache["CheckoutPricingTraceOptionChange"] = {}) as CheckoutPricingTraceOptionChange;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutPricingTraceOptionChange";
  o.group = maybeNew("ReadyPlanOptionGroup", options.group, cache, options.hasOwnProperty("group"));
  o.option = maybeNewOrNull("ReadyPlanOption", options.option, cache);
  o.previousOption = maybeNewOrNull("ReadyPlanOption", options.previousOption, cache);
  o.priceInCents = options.priceInCents ?? 0;
  o.storedPriceInCents = options.storedPriceInCents ?? null;
  o.costInCents = options.costInCents ?? 0;
  o.selectionFeeInCents = options.selectionFeeInCents ?? 0;
  o.minimumPriceInCents = options.minimumPriceInCents ?? 0;
  return o;
}

factories["CheckoutPricingTraceOptionChange"] = newCheckoutPricingTraceOptionChange;

export interface CheckoutConfigInteriorSubStepOptions {
  __typename?: "CheckoutConfigInteriorSubStep";
  id?: CheckoutConfigInteriorSubStep["id"];
  location?: ReadyPlanLocation | ReadyPlanLocationOptions | null;
  displayName?: CheckoutConfigInteriorSubStep["displayName"];
  stepNumber?: CheckoutConfigInteriorSubStep["stepNumber"];
}

export function newCheckoutConfigInteriorSubStep(
  options: CheckoutConfigInteriorSubStepOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfigInteriorSubStep {
  const o =
    (options.__typename ? options : cache["CheckoutConfigInteriorSubStep"] = {}) as CheckoutConfigInteriorSubStep;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfigInteriorSubStep";
  o.id = options.id ?? nextFactoryId("CheckoutConfigInteriorSubStep");
  o.location = maybeNewOrNull("ReadyPlanLocation", options.location, cache);
  o.displayName = options.displayName ?? "displayName";
  o.stepNumber = options.stepNumber ?? 0;
  return o;
}

factories["CheckoutConfigInteriorSubStep"] = newCheckoutConfigInteriorSubStep;

export interface InsideMapsTextureSwapsOptions {
  __typename?: "InsideMapsTextureSwaps";
  cameras?: Array<InsideMapsCamera | InsideMapsCameraOptions>;
  textureSwapsByCamera?: Array<InsideMapsCameraTextureSwaps | InsideMapsCameraTextureSwapsOptions>;
  projectId?: InsideMapsTextureSwaps["projectId"];
  debugSlots?: Array<InsideMapsDebugSlot | InsideMapsDebugSlotOptions> | null;
}

export function newInsideMapsTextureSwaps(
  options: InsideMapsTextureSwapsOptions = {},
  cache: Record<string, any> = {},
): InsideMapsTextureSwaps {
  const o = (options.__typename ? options : cache["InsideMapsTextureSwaps"] = {}) as InsideMapsTextureSwaps;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InsideMapsTextureSwaps";
  o.cameras = (options.cameras ?? []).map((i) =>
    maybeNew("InsideMapsCamera", i, cache, options.hasOwnProperty("cameras"))
  );
  o.textureSwapsByCamera = (options.textureSwapsByCamera ?? []).map((i) =>
    maybeNew("InsideMapsCameraTextureSwaps", i, cache, options.hasOwnProperty("textureSwapsByCamera"))
  );
  o.projectId = options.projectId ?? null;
  o.debugSlots = (options.debugSlots ?? []).map((i) =>
    maybeNew("InsideMapsDebugSlot", i, cache, options.hasOwnProperty("debugSlots"))
  );
  return o;
}

factories["InsideMapsTextureSwaps"] = newInsideMapsTextureSwaps;

export interface InsideMapsCameraOptions {
  __typename?: "InsideMapsCamera";
  cameraName?: InsideMapsCamera["cameraName"];
  displayName?: InsideMapsCamera["displayName"];
  isPrimary?: InsideMapsCamera["isPrimary"];
  isDefault?: InsideMapsCamera["isDefault"];
  locationId?: InsideMapsCamera["locationId"];
  alternateViewFor?: InsideMapsCamera["alternateViewFor"];
  alternateCameras?: Array<InsideMapsCamera | InsideMapsCameraOptions>;
}

export function newInsideMapsCamera(
  options: InsideMapsCameraOptions = {},
  cache: Record<string, any> = {},
): InsideMapsCamera {
  const o = (options.__typename ? options : cache["InsideMapsCamera"] = {}) as InsideMapsCamera;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InsideMapsCamera";
  o.cameraName = options.cameraName ?? "cameraName";
  o.displayName = options.displayName ?? "displayName";
  o.isPrimary = options.isPrimary ?? false;
  o.isDefault = options.isDefault ?? false;
  o.locationId = options.locationId ?? null;
  o.alternateViewFor = options.alternateViewFor ?? null;
  o.alternateCameras = (options.alternateCameras ?? []).map((i) =>
    maybeNew("InsideMapsCamera", i, cache, options.hasOwnProperty("alternateCameras"))
  );
  return o;
}

factories["InsideMapsCamera"] = newInsideMapsCamera;

export interface InsideMapsCameraTextureSwapsOptions {
  __typename?: "InsideMapsCameraTextureSwaps";
  cameraName?: InsideMapsCameraTextureSwaps["cameraName"];
  textureSwaps?: Array<InsideMapsTextureSwap | InsideMapsTextureSwapOptions>;
}

export function newInsideMapsCameraTextureSwaps(
  options: InsideMapsCameraTextureSwapsOptions = {},
  cache: Record<string, any> = {},
): InsideMapsCameraTextureSwaps {
  const o = (options.__typename ? options : cache["InsideMapsCameraTextureSwaps"] = {}) as InsideMapsCameraTextureSwaps;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InsideMapsCameraTextureSwaps";
  o.cameraName = options.cameraName ?? "cameraName";
  o.textureSwaps = (options.textureSwaps ?? []).map((i) =>
    maybeNew("InsideMapsTextureSwap", i, cache, options.hasOwnProperty("textureSwaps"))
  );
  return o;
}

factories["InsideMapsCameraTextureSwaps"] = newInsideMapsCameraTextureSwaps;

export interface InsideMapsTextureSwapOptions {
  __typename?: "InsideMapsTextureSwap";
  part?: InsideMapsTextureSwap["part"];
  texture?: InsideMapsTextureSwap["texture"];
}

export function newInsideMapsTextureSwap(
  options: InsideMapsTextureSwapOptions = {},
  cache: Record<string, any> = {},
): InsideMapsTextureSwap {
  const o = (options.__typename ? options : cache["InsideMapsTextureSwap"] = {}) as InsideMapsTextureSwap;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InsideMapsTextureSwap";
  o.part = options.part ?? "part";
  o.texture = options.texture ?? "texture";
  return o;
}

factories["InsideMapsTextureSwap"] = newInsideMapsTextureSwap;

export interface InsideMapsDebugSlotOptions {
  __typename?: "InsideMapsDebugSlot";
  message?: InsideMapsDebugSlot["message"];
}

export function newInsideMapsDebugSlot(
  options: InsideMapsDebugSlotOptions = {},
  cache: Record<string, any> = {},
): InsideMapsDebugSlot {
  const o = (options.__typename ? options : cache["InsideMapsDebugSlot"] = {}) as InsideMapsDebugSlot;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InsideMapsDebugSlot";
  o.message = options.message ?? "message";
  return o;
}

factories["InsideMapsDebugSlot"] = newInsideMapsDebugSlot;

export interface InsideMapsSlotAuditResultOptions {
  __typename?: "InsideMapsSlotAuditResult";
  audit?: InsideMapsSlotAuditResult["audit"];
}

export function newInsideMapsSlotAuditResult(
  options: InsideMapsSlotAuditResultOptions = {},
  cache: Record<string, any> = {},
): InsideMapsSlotAuditResult {
  const o = (options.__typename ? options : cache["InsideMapsSlotAuditResult"] = {}) as InsideMapsSlotAuditResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InsideMapsSlotAuditResult";
  o.audit = options.audit ?? [];
  return o;
}

factories["InsideMapsSlotAuditResult"] = newInsideMapsSlotAuditResult;

export interface InsideMapsSlotDiffResultOptions {
  __typename?: "InsideMapsSlotDiffResult";
  diffs?: InsideMapsSlotDiffResult["diffs"];
}

export function newInsideMapsSlotDiffResult(
  options: InsideMapsSlotDiffResultOptions = {},
  cache: Record<string, any> = {},
): InsideMapsSlotDiffResult {
  const o = (options.__typename ? options : cache["InsideMapsSlotDiffResult"] = {}) as InsideMapsSlotDiffResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InsideMapsSlotDiffResult";
  o.diffs = options.diffs ?? [];
  return o;
}

factories["InsideMapsSlotDiffResult"] = newInsideMapsSlotDiffResult;

export interface RunCheckoutPricingReportResultOptions {
  __typename?: "RunCheckoutPricingReportResult";
  report?: TrackedJob | TrackedJobOptions;
}

export function newRunCheckoutPricingReportResult(
  options: RunCheckoutPricingReportResultOptions = {},
  cache: Record<string, any> = {},
): RunCheckoutPricingReportResult {
  const o =
    (options.__typename ? options : cache["RunCheckoutPricingReportResult"] = {}) as RunCheckoutPricingReportResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "RunCheckoutPricingReportResult";
  o.report = maybeNew("TrackedJob", options.report, cache, options.hasOwnProperty("report"));
  return o;
}

factories["RunCheckoutPricingReportResult"] = newRunCheckoutPricingReportResult;

export interface CheckoutConfigOptionOptions {
  __typename?: "CheckoutConfigOption";
  id?: CheckoutConfigOption["id"];
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions;
  checkoutConfig?: CheckoutConfig | CheckoutConfigOptions;
  createdAt?: CheckoutConfigOption["createdAt"];
  updatedAt?: CheckoutConfigOption["updatedAt"];
  reservedPriceInCents?: CheckoutConfigOption["reservedPriceInCents"];
  isIncluded?: CheckoutConfigOption["isIncluded"];
  showOnSummary?: CheckoutConfigOption["showOnSummary"];
  reservedCutoffDate?: CheckoutConfigOption["reservedCutoffDate"];
  includedByCheckoutConfigOption?: CheckoutConfigOption | CheckoutConfigOptionOptions | null;
  includedByRoot?: CheckoutConfigOption | CheckoutConfigOptionOptions | null;
}

export function newCheckoutConfigOption(
  options: CheckoutConfigOptionOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfigOption {
  const o = (options.__typename ? options : cache["CheckoutConfigOption"] = {}) as CheckoutConfigOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfigOption";
  o.id = options.id ?? nextFactoryId("CheckoutConfigOption");
  o.readyPlanOption = maybeNew(
    "ReadyPlanOption",
    options.readyPlanOption,
    cache,
    options.hasOwnProperty("readyPlanOption"),
  );
  o.checkoutConfig = maybeNew(
    "CheckoutConfig",
    options.checkoutConfig,
    cache,
    options.hasOwnProperty("checkoutConfig"),
  );
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.reservedPriceInCents = options.reservedPriceInCents ?? null;
  o.isIncluded = options.isIncluded ?? false;
  o.showOnSummary = options.showOnSummary ?? false;
  o.reservedCutoffDate = options.reservedCutoffDate ?? null;
  o.includedByCheckoutConfigOption = maybeNewOrNull(
    "CheckoutConfigOption",
    options.includedByCheckoutConfigOption,
    cache,
  );
  o.includedByRoot = maybeNewOrNull("CheckoutConfigOption", options.includedByRoot, cache);
  return o;
}

factories["CheckoutConfigOption"] = newCheckoutConfigOption;

export interface ClientOptions {
  __typename?: "Client";
  id?: Client["id"];
  name?: Client["name"];
  email?: Client["email"];
  firstName?: Client["firstName"];
  lastName?: Client["lastName"];
  shortName?: Client["shortName"];
  fullName?: Client["fullName"];
  lastActiveAt?: Client["lastActiveAt"];
  lastActive?: Client["lastActive"];
  address?: Address | AddressOptions | null;
  phone?: Client["phone"];
}

export function newClient(options: ClientOptions = {}, cache: Record<string, any> = {}): Client {
  const o = (options.__typename ? options : cache["Client"] = {}) as Client;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Client";
  o.id = options.id ?? nextFactoryId("Client");
  o.name = options.name ?? "name";
  o.email = options.email ?? "email";
  o.firstName = options.firstName ?? "firstName";
  o.lastName = options.lastName ?? "lastName";
  o.shortName = options.shortName ?? "shortName";
  o.fullName = options.fullName ?? "fullName";
  o.lastActiveAt = options.lastActiveAt ?? null;
  o.lastActive = options.lastActive ?? null;
  o.address = maybeNewOrNull("Address", options.address, cache);
  o.phone = options.phone ?? null;
  return o;
}

factories["Client"] = newClient;

export interface CohortOptions {
  __typename?: "Cohort";
  id?: Cohort["id"];
  name?: Cohort["name"];
  market?: Market | MarketOptions;
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  developer?: InternalUser | InternalUserOptions | null;
  createdAt?: Cohort["createdAt"];
  updatedAt?: Cohort["updatedAt"];
  development?: Development | DevelopmentOptions | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  isBoolDefaultForDevelopment?: Cohort["isBoolDefaultForDevelopment"];
}

export function newCohort(options: CohortOptions = {}, cache: Record<string, any> = {}): Cohort {
  const o = (options.__typename ? options : cache["Cohort"] = {}) as Cohort;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Cohort";
  o.id = options.id ?? nextFactoryId("Cohort");
  o.name = options.name ?? "name";
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  o.developer = maybeNewOrNull("InternalUser", options.developer, cache);
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
  o.isBoolDefaultForDevelopment = options.isBoolDefaultForDevelopment ?? null;
  return o;
}

factories["Cohort"] = newCohort;

export interface SaveCohortsResultOptions {
  __typename?: "SaveCohortsResult";
  cohorts?: Array<Cohort | CohortOptions>;
}

export function newSaveCohortsResult(
  options: SaveCohortsResultOptions = {},
  cache: Record<string, any> = {},
): SaveCohortsResult {
  const o = (options.__typename ? options : cache["SaveCohortsResult"] = {}) as SaveCohortsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCohortsResult";
  o.cohorts = (options.cohorts ?? []).map((i) => maybeNew("Cohort", i, cache, options.hasOwnProperty("cohorts")));
  return o;
}

factories["SaveCohortsResult"] = newSaveCohortsResult;

export interface SchedulePhaseOptions {
  __typename?: "SchedulePhase";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: SchedulePhase["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: SchedulePhase["isFollowed"];
  id?: SchedulePhase["id"];
  name?: SchedulePhase["name"];
  parent?:
    | ScheduleParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<ScheduleTemplateOptions>;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  schedule?: Schedule | ScheduleOptions;
  interval?: CalendarInterval | CalendarIntervalOptions | null;
  baselineInterval?: CalendarInterval | CalendarIntervalOptions | null;
  blueprintUrl?: Url | UrlOptions;
  progress?: SchedulePhaseProgress | SchedulePhaseProgressOptions;
  cmsId?: SchedulePhase["cmsId"];
  scheduleSubPhases?: Array<ScheduleSubPhase | ScheduleSubPhaseOptions>;
  globalPhase?: GlobalPhase | GlobalPhaseOptions;
  taskStatusRollup?: SchedulePhase["taskStatusRollup"];
}

export function newSchedulePhase(options: SchedulePhaseOptions = {}, cache: Record<string, any> = {}): SchedulePhase {
  const o = (options.__typename ? options : cache["SchedulePhase"] = {}) as SchedulePhase;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SchedulePhase";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("SchedulePhase");
  o.name = options.name ?? "name";
  o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.schedule = maybeNew("Schedule", options.schedule, cache, options.hasOwnProperty("schedule"));
  o.interval = maybeNewOrNull("CalendarInterval", options.interval, cache);
  o.baselineInterval = maybeNewOrNull("CalendarInterval", options.baselineInterval, cache);
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.progress = maybeNew("SchedulePhaseProgress", options.progress, cache, options.hasOwnProperty("progress"));
  o.cmsId = options.cmsId ?? null;
  o.scheduleSubPhases = (options.scheduleSubPhases ?? []).map((i) =>
    maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("scheduleSubPhases"))
  );
  o.globalPhase = maybeNew("GlobalPhase", options.globalPhase, cache, options.hasOwnProperty("globalPhase"));
  o.taskStatusRollup = options.taskStatusRollup ?? null;
  return o;
}

factories["SchedulePhase"] = newSchedulePhase;

export interface ScheduleSubPhaseOptions {
  __typename?: "ScheduleSubPhase";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ScheduleSubPhase["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ScheduleSubPhase["isFollowed"];
  id?: ScheduleSubPhase["id"];
  name?: ScheduleSubPhase["name"];
  parent?:
    | ScheduleParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<ScheduleTemplateOptions>;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  schedule?: Schedule | ScheduleOptions;
  schedulePhase?: SchedulePhase | SchedulePhaseOptions;
  scheduleTasks?: Array<ScheduleTask | ScheduleTaskOptions>;
  globalSubPhase?: GlobalSubPhase | GlobalSubPhaseOptions;
  blueprintUrl?: Url | UrlOptions;
  interval?: CalendarInterval | CalendarIntervalOptions | null;
  baselineInterval?: CalendarInterval | CalendarIntervalOptions | null;
  progress?: ScheduleSubPhaseProgress | ScheduleSubPhaseProgressOptions;
  cmsId?: ScheduleSubPhase["cmsId"];
}

export function newScheduleSubPhase(
  options: ScheduleSubPhaseOptions = {},
  cache: Record<string, any> = {},
): ScheduleSubPhase {
  const o = (options.__typename ? options : cache["ScheduleSubPhase"] = {}) as ScheduleSubPhase;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleSubPhase";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("ScheduleSubPhase");
  o.name = options.name ?? "name";
  o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.schedule = maybeNew("Schedule", options.schedule, cache, options.hasOwnProperty("schedule"));
  o.schedulePhase = maybeNew("SchedulePhase", options.schedulePhase, cache, options.hasOwnProperty("schedulePhase"));
  o.scheduleTasks = (options.scheduleTasks ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("scheduleTasks"))
  );
  o.globalSubPhase = maybeNew(
    "GlobalSubPhase",
    options.globalSubPhase,
    cache,
    options.hasOwnProperty("globalSubPhase"),
  );
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.interval = maybeNewOrNull("CalendarInterval", options.interval, cache);
  o.baselineInterval = maybeNewOrNull("CalendarInterval", options.baselineInterval, cache);
  o.progress = maybeNew("ScheduleSubPhaseProgress", options.progress, cache, options.hasOwnProperty("progress"));
  o.cmsId = options.cmsId ?? null;
  return o;
}

factories["ScheduleSubPhase"] = newScheduleSubPhase;

export interface TaskOptions {
  __typename?: "Task";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Task["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Task["isFollowed"];
  id?: Task["id"];
  stage?: ProjectStage | ProjectStageOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  name?: Task["name"];
  userCreated?: Task["userCreated"];
  status?: TaskStatusDetailOptions | TaskStatus;
  homeownerVisible?: Task["homeownerVisible"];
  homeownerDescription?: Task["homeownerDescription"];
  interval?: CalendarInterval | CalendarIntervalOptions;
  baselineInterval?: CalendarInterval | CalendarIntervalOptions;
  baselineInterval2?: CalendarInterval2 | CalendarInterval2Options | null;
  completedAt?: Task["completedAt"];
  startDate?: Task["startDate"];
  assignee?: InternalUser | InternalUserOptions | null;
  internalNote?: Task["internalNote"];
  cmsId?: Task["cmsId"];
  slackInDays?: Task["slackInDays"];
  aheadOrBehindInDays?: Task["aheadOrBehindInDays"];
  isStale?: Task["isStale"];
  isCriticalPath?: Task["isCriticalPath"];
  predecessors?: Array<Task | TaskOptions>;
  successors?: Array<Task | TaskOptions>;
  predecessorDependencies?: Array<TaskDependency | TaskDependencyOptions>;
  successorDependencies?: Array<TaskDependency | TaskDependencyOptions>;
  homeownerContractDraws?: Array<HomeownerContractDraw | HomeownerContractDrawOptions>;
  isManuallyScheduled?: Task["isManuallyScheduled"];
  isBaselineManuallyScheduled?: Task["isBaselineManuallyScheduled"];
  blueprintUrl?: Url | UrlOptions;
  isMilestone?: Task["isMilestone"];
  salesforceId?: Task["salesforceId"];
  tradePartner?: TradePartner | TradePartnerOptions | null;
  canEditStartDate?: PotentialOperation2 | PotentialOperation2Options;
  canEditEndDate?: PotentialOperation2 | PotentialOperation2Options;
  canEditDuration?: PotentialOperation2 | PotentialOperation2Options;
  canComplete?: PotentialOperation2 | PotentialOperation2Options;
  canStart?: PotentialOperation2 | PotentialOperation2Options;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  canSetTraderPartner?: PotentialOperation2 | PotentialOperation2Options;
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
  deadlineType?: Task["deadlineType"];
  deadlineTypeDetail?: TaskDeadlineTypeDetailOptions | TaskDeadlineType | null;
  templateProjectRole?: Task["templateProjectRole"];
  templateProjectRoleDetail?: ProjectRoleDetailOptions | ProjectRole | null;
  documents?: Array<Document | DocumentOptions>;
  globalTask?: GlobalTask | GlobalTaskOptions | null;
  isGlobalMilestoneTask?: Task["isGlobalMilestoneTask"];
  scheduleTemplateItemMappings?: Array<ScheduleTemplateItemMapping | ScheduleTemplateItemMappingOptions>;
  requiredTaskDocuments?: Array<RequiredTaskDocument | RequiredTaskDocumentOptions>;
  scheduleTaskChecklistItems?: Array<ScheduleTaskChecklistItem | ScheduleTaskChecklistItemOptions>;
  scheduleFlags?: Array<ScheduleFlag | ScheduleFlagOptions>;
  jobLogNotes?: Array<JobLogNote | JobLogNoteOptions>;
  tradePartnerIsScheduled?: Task["tradePartnerIsScheduled"];
  hasScheduleFlags?: Task["hasScheduleFlags"];
  systemTask?: Task["systemTask"];
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  committedTradePartners?: Array<TradePartner | TradePartnerOptions>;
  billLineItems?: Array<BillLineItem | BillLineItemOptions>;
  defaultedHomeownerDescription?: Task["defaultedHomeownerDescription"];
  templateTask?: Task | TaskOptions | null;
  tradePartnerStatus?: TradePartnerTaskStatusDetailOptions | TradePartnerTaskStatus;
  tradePartnerAvailabilityRequests?:
    | Array<TradePartnerAvailabilityRequest | TradePartnerAvailabilityRequestOptions>
    | null;
  depositCommitments?: Array<Commitment | CommitmentOptions>;
  type?: TaskTypeDetailOptions | TaskType;
  workDays?: Array<TaskWorkDay | TaskWorkDayOptions>;
  commitmentDraws?: Array<CommitmentDraw | CommitmentDrawOptions>;
  protoBills?: Array<ProtoBill | ProtoBillOptions>;
  checklistComplete?: Task["checklistComplete"];
  schedule?: ScheduleLike | ScheduleOptions | RequireTypename<PlanScheduleOptions>;
}

export function newTask(options: TaskOptions = {}, cache: Record<string, any> = {}): Task {
  const o = (options.__typename ? options : cache["Task"] = {}) as Task;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Task";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Task");
  o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.name = options.name ?? "name";
  o.userCreated = options.userCreated ?? false;
  o.status = enumOrDetailOfTaskStatus(options.status);
  o.homeownerVisible = options.homeownerVisible ?? false;
  o.homeownerDescription = options.homeownerDescription ?? null;
  o.interval = maybeNew("CalendarInterval", options.interval, cache, options.hasOwnProperty("interval"));
  o.baselineInterval = maybeNew(
    "CalendarInterval",
    options.baselineInterval,
    cache,
    options.hasOwnProperty("baselineInterval"),
  );
  o.baselineInterval2 = maybeNewOrNull("CalendarInterval2", options.baselineInterval2, cache);
  o.completedAt = options.completedAt ?? null;
  o.startDate = options.startDate ?? null;
  o.assignee = maybeNewOrNull("InternalUser", options.assignee, cache);
  o.internalNote = options.internalNote ?? null;
  o.cmsId = options.cmsId ?? "cmsId";
  o.slackInDays = options.slackInDays ?? null;
  o.aheadOrBehindInDays = options.aheadOrBehindInDays ?? null;
  o.isStale = options.isStale ?? false;
  o.isCriticalPath = options.isCriticalPath ?? false;
  o.predecessors = (options.predecessors ?? []).map((i) =>
    maybeNew("Task", i, cache, options.hasOwnProperty("predecessors"))
  );
  o.successors = (options.successors ?? []).map((i) =>
    maybeNew("Task", i, cache, options.hasOwnProperty("successors"))
  );
  o.predecessorDependencies = (options.predecessorDependencies ?? []).map((i) =>
    maybeNew("TaskDependency", i, cache, options.hasOwnProperty("predecessorDependencies"))
  );
  o.successorDependencies = (options.successorDependencies ?? []).map((i) =>
    maybeNew("TaskDependency", i, cache, options.hasOwnProperty("successorDependencies"))
  );
  o.homeownerContractDraws = (options.homeownerContractDraws ?? []).map((i) =>
    maybeNew("HomeownerContractDraw", i, cache, options.hasOwnProperty("homeownerContractDraws"))
  );
  o.isManuallyScheduled = options.isManuallyScheduled ?? false;
  o.isBaselineManuallyScheduled = options.isBaselineManuallyScheduled ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.isMilestone = options.isMilestone ?? false;
  o.salesforceId = options.salesforceId ?? null;
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.canEditStartDate = maybeNew(
    "PotentialOperation2",
    options.canEditStartDate,
    cache,
    options.hasOwnProperty("canEditStartDate"),
  );
  o.canEditEndDate = maybeNew(
    "PotentialOperation2",
    options.canEditEndDate,
    cache,
    options.hasOwnProperty("canEditEndDate"),
  );
  o.canEditDuration = maybeNew(
    "PotentialOperation2",
    options.canEditDuration,
    cache,
    options.hasOwnProperty("canEditDuration"),
  );
  o.canComplete = maybeNew("PotentialOperation2", options.canComplete, cache, options.hasOwnProperty("canComplete"));
  o.canStart = maybeNew("PotentialOperation2", options.canStart, cache, options.hasOwnProperty("canStart"));
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.canSetTraderPartner = maybeNew(
    "PotentialOperation2",
    options.canSetTraderPartner,
    cache,
    options.hasOwnProperty("canSetTraderPartner"),
  );
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  o.deadlineType = options.deadlineType ?? null;
  o.deadlineTypeDetail = enumOrDetailOrNullOfTaskDeadlineType(options.deadlineTypeDetail);
  o.templateProjectRole = options.templateProjectRole ?? null;
  o.templateProjectRoleDetail = enumOrDetailOrNullOfProjectRole(options.templateProjectRoleDetail);
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.globalTask = maybeNewOrNull("GlobalTask", options.globalTask, cache);
  o.isGlobalMilestoneTask = options.isGlobalMilestoneTask ?? false;
  o.scheduleTemplateItemMappings = (options.scheduleTemplateItemMappings ?? []).map((i) =>
    maybeNew("ScheduleTemplateItemMapping", i, cache, options.hasOwnProperty("scheduleTemplateItemMappings"))
  );
  o.requiredTaskDocuments = (options.requiredTaskDocuments ?? []).map((i) =>
    maybeNew("RequiredTaskDocument", i, cache, options.hasOwnProperty("requiredTaskDocuments"))
  );
  o.scheduleTaskChecklistItems = (options.scheduleTaskChecklistItems ?? []).map((i) =>
    maybeNew("ScheduleTaskChecklistItem", i, cache, options.hasOwnProperty("scheduleTaskChecklistItems"))
  );
  o.scheduleFlags = (options.scheduleFlags ?? []).map((i) =>
    maybeNew("ScheduleFlag", i, cache, options.hasOwnProperty("scheduleFlags"))
  );
  o.jobLogNotes = (options.jobLogNotes ?? []).map((i) =>
    maybeNew("JobLogNote", i, cache, options.hasOwnProperty("jobLogNotes"))
  );
  o.tradePartnerIsScheduled = options.tradePartnerIsScheduled ?? null;
  o.hasScheduleFlags = options.hasScheduleFlags ?? false;
  o.systemTask = options.systemTask ?? null;
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.committedTradePartners = (options.committedTradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("committedTradePartners"))
  );
  o.billLineItems = (options.billLineItems ?? []).map((i) =>
    maybeNew("BillLineItem", i, cache, options.hasOwnProperty("billLineItems"))
  );
  o.defaultedHomeownerDescription = options.defaultedHomeownerDescription ?? "defaultedHomeownerDescription";
  o.templateTask = maybeNewOrNull("Task", options.templateTask, cache);
  o.tradePartnerStatus = enumOrDetailOfTradePartnerTaskStatus(options.tradePartnerStatus);
  o.tradePartnerAvailabilityRequests = (options.tradePartnerAvailabilityRequests ?? []).map((i) =>
    maybeNew("TradePartnerAvailabilityRequest", i, cache, options.hasOwnProperty("tradePartnerAvailabilityRequests"))
  );
  o.depositCommitments = (options.depositCommitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("depositCommitments"))
  );
  o.type = enumOrDetailOfTaskType(options.type);
  o.workDays = (options.workDays ?? []).map((i) =>
    maybeNew("TaskWorkDay", i, cache, options.hasOwnProperty("workDays"))
  );
  o.commitmentDraws = (options.commitmentDraws ?? []).map((i) =>
    maybeNew("CommitmentDraw", i, cache, options.hasOwnProperty("commitmentDraws"))
  );
  o.protoBills = (options.protoBills ?? []).map((i) =>
    maybeNew("ProtoBill", i, cache, options.hasOwnProperty("protoBills"))
  );
  o.checklistComplete = options.checklistComplete ?? null;
  o.schedule = maybeNew(options.schedule?.__typename ?? "Schedule", options.schedule, cache);
  return o;
}

factories["Task"] = newTask;

export interface ScheduleTaskOptions {
  __typename?: "ScheduleTask";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ScheduleTask["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ScheduleTask["isFollowed"];
  id?: ScheduleTask["id"];
  globalPhase?: GlobalPhase | GlobalPhaseOptions | null;
  globalSubPhase?: GlobalSubPhase | GlobalSubPhaseOptions | null;
  schedulePhase?: SchedulePhase | SchedulePhaseOptions | null;
  scheduleSubPhase?: ScheduleSubPhase | ScheduleSubPhaseOptions | null;
  schedule?: Schedule | ScheduleOptions;
  parent?:
    | ScheduleParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<ScheduleTemplateOptions>;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  name?: ScheduleTask["name"];
  status?: ScheduleTask["status"];
  statusDetail?: TaskStatusDetailOptions | TaskStatus;
  schedulingStatus?: ScheduleTask["schedulingStatus"];
  homeownerVisible?: ScheduleTask["homeownerVisible"];
  homeownerDescription?: ScheduleTask["homeownerDescription"];
  interval?: CalendarInterval | CalendarIntervalOptions;
  baselineInterval?: CalendarInterval | CalendarIntervalOptions;
  baselineInterval2?: CalendarInterval2 | CalendarInterval2Options | null;
  completedAt?: ScheduleTask["completedAt"];
  startDate?: ScheduleTask["startDate"];
  assignee?: InternalUser | InternalUserOptions | null;
  internalNote?: ScheduleTask["internalNote"];
  slackInDays?: ScheduleTask["slackInDays"];
  aheadOrBehindInDays?: ScheduleTask["aheadOrBehindInDays"];
  isStale?: ScheduleTask["isStale"];
  isCriticalPath?: ScheduleTask["isCriticalPath"];
  predecessors?: Array<ScheduleTask | ScheduleTaskOptions>;
  successors?: Array<ScheduleTask | ScheduleTaskOptions>;
  predecessorDependencies?: Array<ScheduleTaskDependency | ScheduleTaskDependencyOptions>;
  successorDependencies?: Array<ScheduleTaskDependency | ScheduleTaskDependencyOptions>;
  homeownerContractDraws?: Array<HomeownerContractDraw | HomeownerContractDrawOptions>;
  blueprintUrl?: Url | UrlOptions;
  salesforceId?: ScheduleTask["salesforceId"];
  tradePartner?: TradePartner | TradePartnerOptions | null;
  canEditStartDate?: PotentialOperation2 | PotentialOperation2Options;
  canEditEndDate?: PotentialOperation2 | PotentialOperation2Options;
  canEditDuration?: PotentialOperation2 | PotentialOperation2Options;
  canComplete?: PotentialOperation2 | PotentialOperation2Options;
  canStart?: PotentialOperation2 | PotentialOperation2Options;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  canSetTraderPartner?: PotentialOperation2 | PotentialOperation2Options;
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
  deadlineType?: ScheduleTask["deadlineType"];
  templateProjectRole?: ScheduleTask["templateProjectRole"];
  documents?: Array<Document | DocumentOptions>;
  globalTask?: GlobalTask | GlobalTaskOptions | null;
  isGlobalMilestoneTask?: ScheduleTask["isGlobalMilestoneTask"];
  sortOrder?: ScheduleTask["sortOrder"];
  requiredTaskDocuments?: Array<RequiredTaskDocument | RequiredTaskDocumentOptions>;
  history?: Array<History | HistoryOptions>;
  scheduleTaskChecklistItems?: Array<ScheduleTaskChecklistItem | ScheduleTaskChecklistItemOptions>;
  scheduleFlags?: Array<ScheduleFlag | ScheduleFlagOptions>;
  jobLogNotes?: Array<JobLogNote | JobLogNoteOptions>;
  tradePartnerIsScheduled?: ScheduleTask["tradePartnerIsScheduled"];
  checklistComplete?: ScheduleTask["checklistComplete"];
  hasScheduleFlags?: ScheduleTask["hasScheduleFlags"];
  systemTask?: ScheduleTask["systemTask"];
  bills?: Array<Bill | BillOptions>;
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  committedTradePartners?: Array<TradePartner | TradePartnerOptions>;
  billLineItems?: Array<BillLineItem | BillLineItemOptions>;
  defaultedHomeownerDescription?: ScheduleTask["defaultedHomeownerDescription"];
  templateTask?: Task | TaskOptions | null;
  tradePartnerStatus?: TradePartnerTaskStatusDetailOptions | TradePartnerTaskStatus;
  tradePartnerAvailabilityRequests?:
    | Array<TradePartnerAvailabilityRequest | TradePartnerAvailabilityRequestOptions>
    | null;
  protoBills?: Array<ProtoBill | ProtoBillOptions>;
  type?: TaskTypeDetailOptions | TaskType;
  workDays?: Array<TaskWorkDay | TaskWorkDayOptions>;
  commitmentDraws?: Array<CommitmentDraw | CommitmentDrawOptions>;
}

export function newScheduleTask(options: ScheduleTaskOptions = {}, cache: Record<string, any> = {}): ScheduleTask {
  const o = (options.__typename ? options : cache["ScheduleTask"] = {}) as ScheduleTask;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleTask";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("ScheduleTask");
  o.globalPhase = maybeNewOrNull("GlobalPhase", options.globalPhase, cache);
  o.globalSubPhase = maybeNewOrNull("GlobalSubPhase", options.globalSubPhase, cache);
  o.schedulePhase = maybeNewOrNull("SchedulePhase", options.schedulePhase, cache);
  o.scheduleSubPhase = maybeNewOrNull("ScheduleSubPhase", options.scheduleSubPhase, cache);
  o.schedule = maybeNew("Schedule", options.schedule, cache, options.hasOwnProperty("schedule"));
  o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.name = options.name ?? "name";
  o.status = options.status ?? TaskStatus.NotStarted;
  o.statusDetail = enumOrDetailOfTaskStatus(options.statusDetail);
  o.schedulingStatus = options.schedulingStatus ?? TaskSchedulingStatus.Stale;
  o.homeownerVisible = options.homeownerVisible ?? false;
  o.homeownerDescription = options.homeownerDescription ?? null;
  o.interval = maybeNew("CalendarInterval", options.interval, cache, options.hasOwnProperty("interval"));
  o.baselineInterval = maybeNew(
    "CalendarInterval",
    options.baselineInterval,
    cache,
    options.hasOwnProperty("baselineInterval"),
  );
  o.baselineInterval2 = maybeNewOrNull("CalendarInterval2", options.baselineInterval2, cache);
  o.completedAt = options.completedAt ?? null;
  o.startDate = options.startDate ?? null;
  o.assignee = maybeNewOrNull("InternalUser", options.assignee, cache);
  o.internalNote = options.internalNote ?? null;
  o.slackInDays = options.slackInDays ?? null;
  o.aheadOrBehindInDays = options.aheadOrBehindInDays ?? null;
  o.isStale = options.isStale ?? false;
  o.isCriticalPath = options.isCriticalPath ?? false;
  o.predecessors = (options.predecessors ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("predecessors"))
  );
  o.successors = (options.successors ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("successors"))
  );
  o.predecessorDependencies = (options.predecessorDependencies ?? []).map((i) =>
    maybeNew("ScheduleTaskDependency", i, cache, options.hasOwnProperty("predecessorDependencies"))
  );
  o.successorDependencies = (options.successorDependencies ?? []).map((i) =>
    maybeNew("ScheduleTaskDependency", i, cache, options.hasOwnProperty("successorDependencies"))
  );
  o.homeownerContractDraws = (options.homeownerContractDraws ?? []).map((i) =>
    maybeNew("HomeownerContractDraw", i, cache, options.hasOwnProperty("homeownerContractDraws"))
  );
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.salesforceId = options.salesforceId ?? null;
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.canEditStartDate = maybeNew(
    "PotentialOperation2",
    options.canEditStartDate,
    cache,
    options.hasOwnProperty("canEditStartDate"),
  );
  o.canEditEndDate = maybeNew(
    "PotentialOperation2",
    options.canEditEndDate,
    cache,
    options.hasOwnProperty("canEditEndDate"),
  );
  o.canEditDuration = maybeNew(
    "PotentialOperation2",
    options.canEditDuration,
    cache,
    options.hasOwnProperty("canEditDuration"),
  );
  o.canComplete = maybeNew("PotentialOperation2", options.canComplete, cache, options.hasOwnProperty("canComplete"));
  o.canStart = maybeNew("PotentialOperation2", options.canStart, cache, options.hasOwnProperty("canStart"));
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.canSetTraderPartner = maybeNew(
    "PotentialOperation2",
    options.canSetTraderPartner,
    cache,
    options.hasOwnProperty("canSetTraderPartner"),
  );
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  o.deadlineType = options.deadlineType ?? null;
  o.templateProjectRole = options.templateProjectRole ?? null;
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.globalTask = maybeNewOrNull("GlobalTask", options.globalTask, cache);
  o.isGlobalMilestoneTask = options.isGlobalMilestoneTask ?? false;
  o.sortOrder = options.sortOrder ?? 0;
  o.requiredTaskDocuments = (options.requiredTaskDocuments ?? []).map((i) =>
    maybeNew("RequiredTaskDocument", i, cache, options.hasOwnProperty("requiredTaskDocuments"))
  );
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.scheduleTaskChecklistItems = (options.scheduleTaskChecklistItems ?? []).map((i) =>
    maybeNew("ScheduleTaskChecklistItem", i, cache, options.hasOwnProperty("scheduleTaskChecklistItems"))
  );
  o.scheduleFlags = (options.scheduleFlags ?? []).map((i) =>
    maybeNew("ScheduleFlag", i, cache, options.hasOwnProperty("scheduleFlags"))
  );
  o.jobLogNotes = (options.jobLogNotes ?? []).map((i) =>
    maybeNew("JobLogNote", i, cache, options.hasOwnProperty("jobLogNotes"))
  );
  o.tradePartnerIsScheduled = options.tradePartnerIsScheduled ?? null;
  o.checklistComplete = options.checklistComplete ?? null;
  o.hasScheduleFlags = options.hasScheduleFlags ?? false;
  o.systemTask = options.systemTask ?? null;
  o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.committedTradePartners = (options.committedTradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("committedTradePartners"))
  );
  o.billLineItems = (options.billLineItems ?? []).map((i) =>
    maybeNew("BillLineItem", i, cache, options.hasOwnProperty("billLineItems"))
  );
  o.defaultedHomeownerDescription = options.defaultedHomeownerDescription ?? "defaultedHomeownerDescription";
  o.templateTask = maybeNewOrNull("Task", options.templateTask, cache);
  o.tradePartnerStatus = enumOrDetailOfTradePartnerTaskStatus(options.tradePartnerStatus);
  o.tradePartnerAvailabilityRequests = (options.tradePartnerAvailabilityRequests ?? []).map((i) =>
    maybeNew("TradePartnerAvailabilityRequest", i, cache, options.hasOwnProperty("tradePartnerAvailabilityRequests"))
  );
  o.protoBills = (options.protoBills ?? []).map((i) =>
    maybeNew("ProtoBill", i, cache, options.hasOwnProperty("protoBills"))
  );
  o.type = enumOrDetailOfTaskType(options.type);
  o.workDays = (options.workDays ?? []).map((i) =>
    maybeNew("TaskWorkDay", i, cache, options.hasOwnProperty("workDays"))
  );
  o.commitmentDraws = (options.commitmentDraws ?? []).map((i) =>
    maybeNew("CommitmentDraw", i, cache, options.hasOwnProperty("commitmentDraws"))
  );
  return o;
}

factories["ScheduleTask"] = newScheduleTask;

export interface PlanTaskOptions {
  __typename?: "PlanTask";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: PlanTask["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: PlanTask["isFollowed"];
  id?: PlanTask["id"];
  name?: PlanTask["name"];
  createdAt?: PlanTask["createdAt"];
  updatedAt?: PlanTask["updatedAt"];
  durationInDays?: PlanTask["durationInDays"];
  startDate?: PlanTask["startDate"];
  endDate?: PlanTask["endDate"];
  completedAt?: PlanTask["completedAt"];
  slackInDays?: PlanTask["slackInDays"];
  isCriticalPath?: PlanTask["isCriticalPath"];
  homeownerVisible?: PlanTask["homeownerVisible"];
  status?: TaskStatusDetailOptions | TaskStatus;
  type?: TaskTypeDetailOptions | TaskType;
  sortOrder?: PlanTask["sortOrder"];
  internalUser?: InternalUser | InternalUserOptions | null;
  blueprintUrl?: Url | UrlOptions;
  schedule?: PlanSchedule | PlanScheduleOptions;
  globalPlanTask?: GlobalPlanTask | GlobalPlanTaskOptions;
  globalChecklistItems?: Array<GlobalPlanTaskChecklistItem | GlobalPlanTaskChecklistItemOptions>;
  checklistItems?: Array<PlanTaskChecklistItem | PlanTaskChecklistItemOptions>;
  requiredTaskDocuments?: Array<RequiredTaskDocument | RequiredTaskDocumentOptions>;
  documents?: Array<Document | DocumentOptions>;
  history?: Array<History | HistoryOptions>;
  earliestStartDate?: PlanTask["earliestStartDate"];
  knownDurationInDays?: PlanTask["knownDurationInDays"];
  isManuallyScheduled?: PlanTask["isManuallyScheduled"];
  canStart?: PotentialOperation2 | PotentialOperation2Options;
  canComplete?: PotentialOperation2 | PotentialOperation2Options;
  canDeleteWithWarning?: PotentialOperation2 | PotentialOperation2Options;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  canSetTraderPartner?: PotentialOperation2 | PotentialOperation2Options;
  constraintItems?: Array<GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions>;
  allowanceItems?: Array<GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions>;
  tradePartner?: TradePartner | TradePartnerOptions | null;
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  committedTradePartners?: Array<TradePartner | TradePartnerOptions>;
  billLineItems?: Array<BillLineItem | BillLineItemOptions>;
  tradePartnerStatus?: TradePartnerTaskStatusDetailOptions | TradePartnerTaskStatus;
  tradePartnerAvailabilityRequests?:
    | Array<TradePartnerAvailabilityRequest | TradePartnerAvailabilityRequestOptions>
    | null;
  simulationProbability?: SimulationProbability | SimulationProbabilityOptions;
  scheduleFlags?: Array<ScheduleFlag | ScheduleFlagOptions>;
  ignoredConstraintsOnTaskEnd?: Array<GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions>;
  ignoredConstraintsOnTaskStart?: Array<GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions>;
  workDays?: Array<TaskWorkDay | TaskWorkDayOptions>;
  workingDaysProgress?: PlanTask["workingDaysProgress"];
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
  isStale?: PlanTask["isStale"];
  isHiddenFromSchedule?: PlanTask["isHiddenFromSchedule"];
  stage?: GlobalPlanStage | GlobalPlanStageOptions | null;
  commitmentDraws?: Array<CommitmentDraw | CommitmentDrawOptions>;
  protoBills?: Array<ProtoBill | ProtoBillOptions>;
  taskPurchaseOrders?: Array<TaskPurchaseOrderRow | TaskPurchaseOrderRowOptions>;
  customWorkableDays?: PlanTask["customWorkableDays"];
  allowsPlanMilestones?: Array<PlanMilestone | PlanMilestoneOptions>;
  knownSchedulingContacts?: Array<TradePartnerContact | TradePartnerContactOptions>;
}

export function newPlanTask(options: PlanTaskOptions = {}, cache: Record<string, any> = {}): PlanTask {
  const o = (options.__typename ? options : cache["PlanTask"] = {}) as PlanTask;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanTask";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("PlanTask");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.durationInDays = options.durationInDays ?? 0;
  o.startDate = options.startDate ?? newDate();
  o.endDate = options.endDate ?? newDate();
  o.completedAt = options.completedAt ?? null;
  o.slackInDays = options.slackInDays ?? null;
  o.isCriticalPath = options.isCriticalPath ?? false;
  o.homeownerVisible = options.homeownerVisible ?? null;
  o.status = enumOrDetailOfTaskStatus(options.status);
  o.type = enumOrDetailOfTaskType(options.type);
  o.sortOrder = options.sortOrder ?? 0;
  o.internalUser = maybeNewOrNull("InternalUser", options.internalUser, cache);
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.schedule = maybeNew("PlanSchedule", options.schedule, cache, options.hasOwnProperty("schedule"));
  o.globalPlanTask = maybeNew(
    "GlobalPlanTask",
    options.globalPlanTask,
    cache,
    options.hasOwnProperty("globalPlanTask"),
  );
  o.globalChecklistItems = (options.globalChecklistItems ?? []).map((i) =>
    maybeNew("GlobalPlanTaskChecklistItem", i, cache, options.hasOwnProperty("globalChecklistItems"))
  );
  o.checklistItems = (options.checklistItems ?? []).map((i) =>
    maybeNew("PlanTaskChecklistItem", i, cache, options.hasOwnProperty("checklistItems"))
  );
  o.requiredTaskDocuments = (options.requiredTaskDocuments ?? []).map((i) =>
    maybeNew("RequiredTaskDocument", i, cache, options.hasOwnProperty("requiredTaskDocuments"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.earliestStartDate = options.earliestStartDate ?? null;
  o.knownDurationInDays = options.knownDurationInDays ?? null;
  o.isManuallyScheduled = options.isManuallyScheduled ?? null;
  o.canStart = maybeNew("PotentialOperation2", options.canStart, cache, options.hasOwnProperty("canStart"));
  o.canComplete = maybeNew("PotentialOperation2", options.canComplete, cache, options.hasOwnProperty("canComplete"));
  o.canDeleteWithWarning = maybeNew(
    "PotentialOperation2",
    options.canDeleteWithWarning,
    cache,
    options.hasOwnProperty("canDeleteWithWarning"),
  );
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.canSetTraderPartner = maybeNew(
    "PotentialOperation2",
    options.canSetTraderPartner,
    cache,
    options.hasOwnProperty("canSetTraderPartner"),
  );
  o.constraintItems = (options.constraintItems ?? []).map((i) =>
    maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("constraintItems"))
  );
  o.allowanceItems = (options.allowanceItems ?? []).map((i) =>
    maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("allowanceItems"))
  );
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.committedTradePartners = (options.committedTradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("committedTradePartners"))
  );
  o.billLineItems = (options.billLineItems ?? []).map((i) =>
    maybeNew("BillLineItem", i, cache, options.hasOwnProperty("billLineItems"))
  );
  o.tradePartnerStatus = enumOrDetailOfTradePartnerTaskStatus(options.tradePartnerStatus);
  o.tradePartnerAvailabilityRequests = (options.tradePartnerAvailabilityRequests ?? []).map((i) =>
    maybeNew("TradePartnerAvailabilityRequest", i, cache, options.hasOwnProperty("tradePartnerAvailabilityRequests"))
  );
  o.simulationProbability = maybeNew(
    "SimulationProbability",
    options.simulationProbability,
    cache,
    options.hasOwnProperty("simulationProbability"),
  );
  o.scheduleFlags = (options.scheduleFlags ?? []).map((i) =>
    maybeNew("ScheduleFlag", i, cache, options.hasOwnProperty("scheduleFlags"))
  );
  o.ignoredConstraintsOnTaskEnd = (options.ignoredConstraintsOnTaskEnd ?? []).map((i) =>
    maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("ignoredConstraintsOnTaskEnd"))
  );
  o.ignoredConstraintsOnTaskStart = (options.ignoredConstraintsOnTaskStart ?? []).map((i) =>
    maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("ignoredConstraintsOnTaskStart"))
  );
  o.workDays = (options.workDays ?? []).map((i) =>
    maybeNew("TaskWorkDay", i, cache, options.hasOwnProperty("workDays"))
  );
  o.workingDaysProgress = options.workingDaysProgress ?? 0;
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  o.isStale = options.isStale ?? false;
  o.isHiddenFromSchedule = options.isHiddenFromSchedule ?? false;
  o.stage = maybeNewOrNull("GlobalPlanStage", options.stage, cache);
  o.commitmentDraws = (options.commitmentDraws ?? []).map((i) =>
    maybeNew("CommitmentDraw", i, cache, options.hasOwnProperty("commitmentDraws"))
  );
  o.protoBills = (options.protoBills ?? []).map((i) =>
    maybeNew("ProtoBill", i, cache, options.hasOwnProperty("protoBills"))
  );
  o.taskPurchaseOrders = (options.taskPurchaseOrders ?? []).map((i) =>
    maybeNew("TaskPurchaseOrderRow", i, cache, options.hasOwnProperty("taskPurchaseOrders"))
  );
  o.customWorkableDays = options.customWorkableDays ?? [];
  o.allowsPlanMilestones = (options.allowsPlanMilestones ?? []).map((i) =>
    maybeNew("PlanMilestone", i, cache, options.hasOwnProperty("allowsPlanMilestones"))
  );
  o.knownSchedulingContacts = (options.knownSchedulingContacts ?? []).map((i) =>
    maybeNew("TradePartnerContact", i, cache, options.hasOwnProperty("knownSchedulingContacts"))
  );
  return o;
}

factories["PlanTask"] = newPlanTask;

export interface ToDoOptions {
  __typename?: "ToDo";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ToDo["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ToDo["isFollowed"];
  id?: ToDo["id"];
  name?: ToDo["name"];
  blueprintUrl?: Url | UrlOptions;
  description?: ToDo["description"];
  deletedAt?: ToDo["deletedAt"];
  createdAt?: ToDo["createdAt"];
  updatedAt?: ToDo["updatedAt"];
  dueDate?: ToDo["dueDate"];
  order?: ToDo["order"];
  status?: ToDoStatusDetailOptions | ToDoStatus;
  type?: ToDoTypeDetailOptions | ToDoType;
  parent?:
    | ToDoParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<CohortOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | null;
  createdBy?: User | UserOptions;
  assignee?: User | UserOptions | null;
  assignees?: Array<User | UserOptions>;
  attachments?: Array<Attachment | AttachmentOptions>;
  urgent?: ToDo["urgent"];
  checklistItems?: Array<ToDoChecklistItem | ToDoChecklistItemOptions>;
  checklistProgress?: ToDoChecklistProgress | ToDoChecklistProgressOptions;
  changeRequest?: ChangeRequest | ChangeRequestOptions | null;
}

export function newToDo(options: ToDoOptions = {}, cache: Record<string, any> = {}): ToDo {
  const o = (options.__typename ? options : cache["ToDo"] = {}) as ToDo;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ToDo";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("ToDo");
  o.name = options.name ?? "name";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.description = options.description ?? null;
  o.deletedAt = options.deletedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.dueDate = options.dueDate ?? null;
  o.order = options.order ?? "order";
  o.status = enumOrDetailOfToDoStatus(options.status);
  o.type = enumOrDetailOfToDoType(options.type);
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.assignee = maybeNewOrNull("User", options.assignee, cache);
  o.assignees = (options.assignees ?? []).map((i) => maybeNew("User", i, cache, options.hasOwnProperty("assignees")));
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  o.urgent = options.urgent ?? false;
  o.checklistItems = (options.checklistItems ?? []).map((i) =>
    maybeNew("ToDoChecklistItem", i, cache, options.hasOwnProperty("checklistItems"))
  );
  o.checklistProgress = maybeNew(
    "ToDoChecklistProgress",
    options.checklistProgress,
    cache,
    options.hasOwnProperty("checklistProgress"),
  );
  o.changeRequest = maybeNewOrNull("ChangeRequest", options.changeRequest, cache);
  return o;
}

factories["ToDo"] = newToDo;

export interface InvoiceOptions {
  __typename?: "Invoice";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Invoice["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Invoice["isFollowed"];
  id?: Invoice["id"];
  name?: Invoice["name"];
  invoiceDate?: Invoice["invoiceDate"];
  dueDate?: Invoice["dueDate"];
  description?: Invoice["description"];
  title?: Invoice["title"];
  quickbooksId?: Invoice["quickbooksId"];
  amountInCents?: Invoice["amountInCents"];
  accruedAmountInCents?: Invoice["accruedAmountInCents"];
  balanceInCents?: Invoice["balanceInCents"];
  amountPaidInCents?: Invoice["amountPaidInCents"];
  projectStage?: ProjectStage | ProjectStageOptions;
  lineItems?: Array<InvoiceLineItem | InvoiceLineItemOptions>;
  lineItemsByCostCode?: Array<InvoiceLineItemsByCostCode | InvoiceLineItemsByCostCodeOptions>;
  drawLineItems?: Array<InvoiceDrawLineItem | InvoiceDrawLineItemOptions>;
  quickbooksPullOnly?: Invoice["quickbooksPullOnly"];
  document?: Document | DocumentOptions | null;
  invoiceNumber?: Invoice["invoiceNumber"];
  isHistoricalInvoiceNumber?: Invoice["isHistoricalInvoiceNumber"];
  isFinalInvoice?: Invoice["isFinalInvoice"];
  history?: Array<History | HistoryOptions>;
  blueprintUrl?: Url | UrlOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  intacctAmountPaidInCents?: Invoice["intacctAmountPaidInCents"];
  documents?: Array<InvoiceDocument | InvoiceDocumentOptions>;
  quickbooksAmountPaidInCents?: Invoice["quickbooksAmountPaidInCents"];
  intacctSyncError?: Invoice["intacctSyncError"];
  approval?: Approval | ApprovalOptions | null;
  status?: InvoiceStatusDetailOptions | InvoiceStatus;
  lineItemCutoffDate?: Invoice["lineItemCutoffDate"];
  lineItemStartDate?: Invoice["lineItemStartDate"];
  predictedApprovers?: Array<
    ApproverUser | ClientOptions | RequireTypename<InternalUserOptions> | RequireTypename<TradePartnerUserOptions>
  >;
  paidDate?: Invoice["paidDate"];
  creditForInvoice?: Invoice | InvoiceOptions | null;
  shouldSyncToIntacct?: Invoice["shouldSyncToIntacct"];
  intacctId?: Invoice["intacctId"];
  type?: InvoiceTypeDetailOptions | InvoiceType;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  pandaDocs?: Array<PandaDoc | PandaDocOptions>;
  scheduledLineItems?: Array<InvoiceScheduledLineItem | InvoiceScheduledLineItemOptions>;
  accruedLineItems?: Array<InvoiceAccruedLineItem | InvoiceAccruedLineItemOptions>;
  displayLineItems?: Array<InvoiceDisplayLineItem | InvoiceDisplayLineItemOptions>;
  updatedAt?: Invoice["updatedAt"];
  createdAt?: Invoice["createdAt"];
  isHistorical?: Invoice["isHistorical"];
  parent?:
    | InvoiceParent
    | PlanMilestoneOptions
    | RequireTypename<TaskOptions>
    | RequireTypename<ScheduleTaskOptions>
    | RequireTypename<PlanTaskOptions>
    | null;
  source?: InvoiceSourceDetailOptions | InvoiceSource;
  remainingDownPaymentInCents?: Invoice["remainingDownPaymentInCents"];
  downPaymentConsumingLineItems?: Array<InvoiceLineItem | InvoiceLineItemOptions>;
  pocInvoicedToDateInCents?: Invoice["pocInvoicedToDateInCents"];
  contractPriceSnapshotInCents?: Invoice["contractPriceSnapshotInCents"];
}

export function newInvoice(options: InvoiceOptions = {}, cache: Record<string, any> = {}): Invoice {
  const o = (options.__typename ? options : cache["Invoice"] = {}) as Invoice;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Invoice";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Invoice");
  o.name = options.name ?? "name";
  o.invoiceDate = options.invoiceDate ?? newDate();
  o.dueDate = options.dueDate ?? newDate();
  o.description = options.description ?? null;
  o.title = options.title ?? "title";
  o.quickbooksId = options.quickbooksId ?? null;
  o.amountInCents = options.amountInCents ?? 0;
  o.accruedAmountInCents = options.accruedAmountInCents ?? 0;
  o.balanceInCents = options.balanceInCents ?? 0;
  o.amountPaidInCents = options.amountPaidInCents ?? 0;
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("InvoiceLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.lineItemsByCostCode = (options.lineItemsByCostCode ?? []).map((i) =>
    maybeNew("InvoiceLineItemsByCostCode", i, cache, options.hasOwnProperty("lineItemsByCostCode"))
  );
  o.drawLineItems = (options.drawLineItems ?? []).map((i) =>
    maybeNew("InvoiceDrawLineItem", i, cache, options.hasOwnProperty("drawLineItems"))
  );
  o.quickbooksPullOnly = options.quickbooksPullOnly ?? false;
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.invoiceNumber = options.invoiceNumber ?? "invoiceNumber";
  o.isHistoricalInvoiceNumber = options.isHistoricalInvoiceNumber ?? false;
  o.isFinalInvoice = options.isFinalInvoice ?? false;
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.intacctAmountPaidInCents = options.intacctAmountPaidInCents ?? 0;
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("InvoiceDocument", i, cache, options.hasOwnProperty("documents"))
  );
  o.quickbooksAmountPaidInCents = options.quickbooksAmountPaidInCents ?? 0;
  o.intacctSyncError = options.intacctSyncError ?? null;
  o.approval = maybeNewOrNull("Approval", options.approval, cache);
  o.status = enumOrDetailOfInvoiceStatus(options.status);
  o.lineItemCutoffDate = options.lineItemCutoffDate ?? null;
  o.lineItemStartDate = options.lineItemStartDate ?? null;
  o.predictedApprovers = (options.predictedApprovers ?? []).map((i) =>
    maybeNew(i?.__typename ?? "{Client", i, cache, options.hasOwnProperty("predictedApprovers"))
  );
  o.paidDate = options.paidDate ?? null;
  o.creditForInvoice = maybeNewOrNull("Invoice", options.creditForInvoice, cache);
  o.shouldSyncToIntacct = options.shouldSyncToIntacct ?? false;
  o.intacctId = options.intacctId ?? null;
  o.type = enumOrDetailOfInvoiceType(options.type);
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.pandaDocs = (options.pandaDocs ?? []).map((i) =>
    maybeNew("PandaDoc", i, cache, options.hasOwnProperty("pandaDocs"))
  );
  o.scheduledLineItems = (options.scheduledLineItems ?? []).map((i) =>
    maybeNew("InvoiceScheduledLineItem", i, cache, options.hasOwnProperty("scheduledLineItems"))
  );
  o.accruedLineItems = (options.accruedLineItems ?? []).map((i) =>
    maybeNew("InvoiceAccruedLineItem", i, cache, options.hasOwnProperty("accruedLineItems"))
  );
  o.displayLineItems = (options.displayLineItems ?? []).map((i) =>
    maybeNew("InvoiceDisplayLineItem", i, cache, options.hasOwnProperty("displayLineItems"))
  );
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.createdAt = options.createdAt ?? newDateTime();
  o.isHistorical = options.isHistorical ?? false;
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "PlanMilestone", options.parent, cache);
  o.source = enumOrDetailOfInvoiceSource(options.source);
  o.remainingDownPaymentInCents = options.remainingDownPaymentInCents ?? 0;
  o.downPaymentConsumingLineItems = (options.downPaymentConsumingLineItems ?? []).map((i) =>
    maybeNew("InvoiceLineItem", i, cache, options.hasOwnProperty("downPaymentConsumingLineItems"))
  );
  o.pocInvoicedToDateInCents = options.pocInvoicedToDateInCents ?? 0;
  o.contractPriceSnapshotInCents = options.contractPriceSnapshotInCents ?? 0;
  return o;
}

factories["Invoice"] = newInvoice;

export interface StandaloneProjectOptions {
  __typename?: "StandaloneProject";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: StandaloneProject["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: StandaloneProject["isFollowed"];
  id?: StandaloneProject["id"];
  buildAddress?: Address | AddressOptions;
  market?: Market | MarketOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  cohort?: Cohort | CohortOptions | null;
  constructionConfidenceFactor?: StandaloneProject["constructionConfidenceFactor"];
  lotRating?: LotRating | LotRatingOptions | null;
  preConBudgetLineItems?: Array<PreConBudgetCostDivisionLineItem | PreConBudgetCostDivisionLineItemOptions>;
  preconContractType?: PreconContractType | PreconContractTypeOptions | null;
  primaryProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  quickbooksCustomerId?: StandaloneProject["quickbooksCustomerId"];
  shadowProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  submarket?: Submarket | SubmarketOptions | null;
  collaborators?: Array<ProjectCollaborator | ProjectCollaboratorOptions>;
  coverImage?: Asset | AssetOptions | null;
  teamMembers?: Array<ProjectTeamMember | ProjectTeamMemberOptions>;
  projectLead?: ProjectTeamMember | ProjectTeamMemberOptions | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: ProjectStage | ProjectStageOptions | null;
  stages?: Array<ProjectStage | ProjectStageOptions>;
  stage?: ProjectStage | ProjectStageOptions;
  blueprintUrl?: Url | UrlOptions;
  hopUrl?: StandaloneProject["hopUrl"];
  propcoUrl?: StandaloneProject["propcoUrl"];
  name?: StandaloneProject["name"];
  displayName?: StandaloneProject["displayName"];
  availableAssignees?: Array<InternalUser | InternalUserOptions>;
  startDate?: StandaloneProject["startDate"];
  features?: StandaloneProject["features"];
  isTest?: StandaloneProject["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: StandaloneProject["latitude"];
  longitude?: StandaloneProject["longitude"];
  googleDriveFolderId?: StandaloneProject["googleDriveFolderId"];
  salesforceAccountId?: StandaloneProject["salesforceAccountId"];
  salesforceOpportunities?: Array<ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions>;
  projectStatusChange?: ProjectStatusChange | ProjectStatusChangeOptions | null;
  planRoomLink?: StandaloneProject["planRoomLink"];
  isDisaster?: StandaloneProject["isDisaster"];
  intakeStyleNotes?: StandaloneProject["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: ProductType | ProductTypeOptions | null;
  enableSchedulesV2?: StandaloneProject["enableSchedulesV2"];
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  jobLogs?: Array<JobLog | JobLogOptions>;
  salesforcePropertyId?: StandaloneProject["salesforcePropertyId"];
  schedules?: Array<Schedule | ScheduleOptions>;
  expenses?: Array<Expense | ExpenseOptions>;
  unallocatedExpenses?: Array<Expense | ExpenseOptions>;
  unallocatedAmountInCents?: StandaloneProject["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: StandaloneProject["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: StandaloneProject["enableSchedulesCalendar"];
  readyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions | null;
  earnedValueCurves?: Array<EarnedValueCurve | EarnedValueCurveOptions>;
  enableBidPackagesV2?: StandaloneProject["enableBidPackagesV2"];
  invoiceSettings?: ProjectInvoiceSetting | ProjectInvoiceSettingOptions | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: StandaloneProject["lotPartitionId"];
  budgetFinancials?: ProjectBudgetFinancials | ProjectBudgetFinancialsOptions;
  enableDelayFlags?: StandaloneProject["enableDelayFlags"];
  warrantyStartDate?: StandaloneProject["warrantyStartDate"];
  verticalCompleteDate?: StandaloneProject["verticalCompleteDate"];
  jobLogInsights?: ProjectJobLogInsights | ProjectJobLogInsightsOptions;
  targetEndDate?: StandaloneProject["targetEndDate"];
  latestActiveStage?: ProjectStage | ProjectStageOptions | null;
  primaryHomeowner?: Client | ClientOptions | null;
  toDos?: Array<ToDo | ToDoOptions> | null;
  lotDetail?: ProjectLotDetail | ProjectLotDetailOptions;
  siteSpecificInfos?: Array<ProjectSiteSpecificInfo | ProjectSiteSpecificInfoOptions>;
  projectSiteCondition?: ProjectSiteCondition | ProjectSiteConditionOptions | null;
  unassignedTaskCount?: StandaloneProject["unassignedTaskCount"];
  enableHomeownerNotes?: StandaloneProject["enableHomeownerNotes"];
  checkoutCustomerConfigId?: StandaloneProject["checkoutCustomerConfigId"];
  canEditJobLogs?: PotentialOperation2 | PotentialOperation2Options;
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  canHaveBudget?: PotentialOperation2 | PotentialOperation2Options;
  homeownerNotes?: Array<HomeownerNote | HomeownerNoteOptions>;
  enableHomeownerJourneyV2?: StandaloneProject["enableHomeownerJourneyV2"];
  featureFlags?: Array<FeatureFlag | FeatureFlagOptions>;
  homeownerDeliveryDate?: StandaloneProject["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: StandaloneProject["tasksCompletedThisWeek"];
  contacts?: Array<ProjectContact | ProjectContactOptions>;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
  shouldAccrueAsComplete?: StandaloneProject["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: StandaloneProject["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: StandaloneProject["indirectCostMarkupOverrideBasisPoints"];
  customer?: Customer | CustomerOptions | null;
  customerOwnerEntity?: CustomerOwnerEntity | CustomerOwnerEntityOptions | null;
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions | null;
  allowExcludedCostCodesOnPurchaseOrders?: StandaloneProject["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: StandaloneProject["enableProductConfigPlan"];
  planSchedule?: PlanSchedule | PlanScheduleOptions | null;
  builder?: Builder | BuilderOptions | null;
  bidOutPercentage?: StandaloneProject["bidOutPercentage"];
  enableChangeEventSignatures?: StandaloneProject["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: StandaloneProject["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: StandaloneProject["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: StandaloneProject["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: StandaloneProject["directHardCostMarkupInBasisPoints"];
  legalDescription?: StandaloneProject["legalDescription"];
  salesTaxOverrideInBasisPoints?: StandaloneProject["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: StandaloneProject["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<ProjectItemAllocation | ProjectItemAllocationOptions>;
  allocationRules?: Array<ProjectAllocationRule | ProjectAllocationRuleOptions>;
  warrantyLengthInDays?: StandaloneProject["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: StandaloneProject["warrantyOverrideLengthInDays"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  bidContracts?: Array<BidContract | BidContractOptions>;
  homeownerContracts?: Array<HomeownerContract | HomeownerContractOptions>;
  documents?: Array<Document | DocumentOptions>;
  commitments?: Array<Commitment | CommitmentOptions>;
  directCostInCents?: StandaloneProject["directCostInCents"];
  directPriceInCents?: StandaloneProject["directPriceInCents"];
  totalHardCostInCents?: StandaloneProject["totalHardCostInCents"];
  totalSoftCostInCents?: StandaloneProject["totalSoftCostInCents"];
  totalCostInCents?: StandaloneProject["totalCostInCents"];
  totalPriceInCents?: StandaloneProject["totalPriceInCents"];
  readyToStartDate?: StandaloneProject["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: StandaloneProject["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: StandaloneProject["directCostAtStartInCents"];
  directCostVarianceInCents?: StandaloneProject["directCostVarianceInCents"];
  uncommittedCostInCents?: StandaloneProject["uncommittedCostInCents"];
  snapshots?: Array<ProjectSnapshot | ProjectSnapshotOptions>;
  warrantyEndDate?: StandaloneProject["warrantyEndDate"];
  companyInfo?: CompanyInfo | CompanyInfoOptions;
  invoicePaymentNetDays?: StandaloneProject["invoicePaymentNetDays"];
  snapshotAsOf?: ProjectSnapshot | ProjectSnapshotOptions | null;
  purchaseCostInCents?: StandaloneProject["purchaseCostInCents"];
  grossSalesPriceInCents?: StandaloneProject["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: StandaloneProject["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: StandaloneProject["directMarginInBasisPoints"];
  projectCostCodes?: Array<ProjectCostCode | ProjectCostCodeOptions>;
  parent?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  children?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  parentsRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  childrenRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  siblingProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  sellableProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  isSellableProject?: StandaloneProject["isSellableProject"];
  originalCostInCents?: StandaloneProject["originalCostInCents"];
  startCostInCents?: StandaloneProject["startCostInCents"];
  changeEventCostInCents?: StandaloneProject["changeEventCostInCents"];
  projectedCostInCents?: StandaloneProject["projectedCostInCents"];
  revisedCostInCents?: StandaloneProject["revisedCostInCents"];
  committedCostInCents?: StandaloneProject["committedCostInCents"];
  availableCostInCents?: StandaloneProject["availableCostInCents"];
  billedCostInCents?: StandaloneProject["billedCostInCents"];
  unbilledCostInCents?: StandaloneProject["unbilledCostInCents"];
  client?: Client | ClientOptions | null;
  url?: StandaloneProject["url"];
  projectName?: StandaloneProject["projectName"];
  salesforceId?: StandaloneProject["salesforceId"];
  activeSalesforceOpportunity?: ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions | null;
  dictionary?: ProjectDictionary | ProjectDictionaryOptions;
}

export function newStandaloneProject(
  options: StandaloneProjectOptions = {},
  cache: Record<string, any> = {},
): StandaloneProject {
  const o = (options.__typename ? options : cache["StandaloneProject"] = {}) as StandaloneProject;
  (cache.all ??= new Set()).add(o);
  o.__typename = "StandaloneProject";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("StandaloneProject");
  o.buildAddress = maybeNew("Address", options.buildAddress, cache, options.hasOwnProperty("buildAddress"));
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
  o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
  o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
  o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
    maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
  );
  o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
  o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
  o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
  o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
  );
  o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
  o.collaborators = (options.collaborators ?? []).map((i) =>
    maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
  );
  o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
  o.teamMembers = (options.teamMembers ?? []).map((i) =>
    maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
  );
  o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
  o.activeStage = enumOrDetailOfStage(options.activeStage);
  o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
  o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
  o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.hopUrl = options.hopUrl ?? "hopUrl";
  o.propcoUrl = options.propcoUrl ?? null;
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
  );
  o.startDate = options.startDate ?? newDate();
  o.features = options.features ?? [];
  o.isTest = options.isTest ?? false;
  o.status = enumOrDetailOfProjectStatus(options.status);
  o.latitude = options.latitude ?? null;
  o.longitude = options.longitude ?? null;
  o.googleDriveFolderId = options.googleDriveFolderId ?? null;
  o.salesforceAccountId = options.salesforceAccountId ?? null;
  o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
    maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
  );
  o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
  o.planRoomLink = options.planRoomLink ?? null;
  o.isDisaster = options.isDisaster ?? null;
  o.intakeStyleNotes = options.intakeStyleNotes ?? null;
  o.lotType = enumOrDetailOfLotType(options.lotType);
  o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
  o.productType = maybeNewOrNull("ProductType", options.productType, cache);
  o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
  o.salesforcePropertyId = options.salesforcePropertyId ?? null;
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
  o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
    maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
  );
  o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
  o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
  o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
  o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
  o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
    maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
  );
  o.enableBidPackagesV2 = options.enableBidPackagesV2 ?? false;
  o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
  o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
  o.lotPartitionId = options.lotPartitionId ?? null;
  o.budgetFinancials = maybeNew(
    "ProjectBudgetFinancials",
    options.budgetFinancials,
    cache,
    options.hasOwnProperty("budgetFinancials"),
  );
  o.enableDelayFlags = options.enableDelayFlags ?? false;
  o.warrantyStartDate = options.warrantyStartDate ?? null;
  o.verticalCompleteDate = options.verticalCompleteDate ?? null;
  o.jobLogInsights = maybeNew(
    "ProjectJobLogInsights",
    options.jobLogInsights,
    cache,
    options.hasOwnProperty("jobLogInsights"),
  );
  o.targetEndDate = options.targetEndDate ?? null;
  o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
  o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
  o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
    maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
  );
  o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
  o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
  o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
  o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
  o.canEditJobLogs = maybeNew(
    "PotentialOperation2",
    options.canEditJobLogs,
    cache,
    options.hasOwnProperty("canEditJobLogs"),
  );
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.canHaveBudget = maybeNew(
    "PotentialOperation2",
    options.canHaveBudget,
    cache,
    options.hasOwnProperty("canHaveBudget"),
  );
  o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
    maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
  );
  o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
  o.featureFlags = (options.featureFlags ?? []).map((i) =>
    maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
  );
  o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
  o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
  o.contacts = (options.contacts ?? []).map((i) =>
    maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
  );
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
  o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
  o.customer = maybeNewOrNull("Customer", options.customer, cache);
  o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
  o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
  o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
  o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
  o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
  o.builder = maybeNewOrNull("Builder", options.builder, cache);
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
  o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
  o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
  o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
  o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
  o.legalDescription = options.legalDescription ?? null;
  o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
  o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
  o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
    maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
  );
  o.allocationRules = (options.allocationRules ?? []).map((i) =>
    maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
  );
  o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
  o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
    maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.directCostInCents = options.directCostInCents ?? 0;
  o.directPriceInCents = options.directPriceInCents ?? 0;
  o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
  o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.readyToStartDate = options.readyToStartDate ?? null;
  o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
  o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
  o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
  o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
  o.snapshots = (options.snapshots ?? []).map((i) =>
    maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
  );
  o.warrantyEndDate = options.warrantyEndDate ?? null;
  o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
  o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
  o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
  o.purchaseCostInCents = options.purchaseCostInCents ?? null;
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
    maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
  );
  o.parent = maybeNewOrNull("Project", options.parent, cache);
  o.children = (options.children ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("children")));
  o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
  );
  o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
  );
  o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
  );
  o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
  );
  o.isSellableProject = options.isSellableProject ?? false;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.client = maybeNewOrNull("Client", options.client, cache);
  o.url = options.url ?? "url";
  o.projectName = options.projectName ?? "projectName";
  o.salesforceId = options.salesforceId ?? null;
  o.activeSalesforceOpportunity = maybeNewOrNull(
    "ProjectSalesforceOpportunity",
    options.activeSalesforceOpportunity,
    cache,
  );
  o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
  return o;
}

factories["StandaloneProject"] = newStandaloneProject;

export interface RegionOptions {
  __typename?: "Region";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Region["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Region["isFollowed"];
  id?: Region["id"];
  abbreviation?: Region["abbreviation"];
  createdAt?: Region["createdAt"];
  updatedAt?: Region["updatedAt"];
  children?: Array<Market | MarketOptions>;
  collaborators?: Array<ProjectCollaborator | ProjectCollaboratorOptions>;
  coverImage?: Asset | AssetOptions | null;
  buildAddress?: Address | AddressOptions | null;
  market?: Market | MarketOptions | null;
  teamMembers?: Array<ProjectTeamMember | ProjectTeamMemberOptions>;
  projectLead?: ProjectTeamMember | ProjectTeamMemberOptions | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: ProjectStage | ProjectStageOptions | null;
  stages?: Array<ProjectStage | ProjectStageOptions>;
  stage?: ProjectStage | ProjectStageOptions;
  blueprintUrl?: Url | UrlOptions;
  hopUrl?: Region["hopUrl"];
  name?: Region["name"];
  displayName?: Region["displayName"];
  availableAssignees?: Array<InternalUser | InternalUserOptions>;
  startDate?: Region["startDate"];
  features?: Region["features"];
  isTest?: Region["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Region["latitude"];
  longitude?: Region["longitude"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  googleDriveFolderId?: Region["googleDriveFolderId"];
  salesforceAccountId?: Region["salesforceAccountId"];
  salesforceOpportunities?: Array<ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions>;
  projectStatusChange?: ProjectStatusChange | ProjectStatusChangeOptions | null;
  planRoomLink?: Region["planRoomLink"];
  isDisaster?: Region["isDisaster"];
  intakeStyleNotes?: Region["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: ProductType | ProductTypeOptions | null;
  enableSchedulesV2?: Region["enableSchedulesV2"];
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  jobLogs?: Array<JobLog | JobLogOptions>;
  salesforcePropertyId?: Region["salesforcePropertyId"];
  schedules?: Array<Schedule | ScheduleOptions>;
  expenses?: Array<Expense | ExpenseOptions>;
  unallocatedExpenses?: Array<Expense | ExpenseOptions>;
  unallocatedAmountInCents?: Region["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Region["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Region["enableSchedulesCalendar"];
  readyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions | null;
  earnedValueCurves?: Array<EarnedValueCurve | EarnedValueCurveOptions>;
  enableBidPackagesV2?: Region["enableBidPackagesV2"];
  invoiceSettings?: ProjectInvoiceSetting | ProjectInvoiceSettingOptions | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Region["lotPartitionId"];
  budgetFinancials?: ProjectBudgetFinancials | ProjectBudgetFinancialsOptions;
  enableDelayFlags?: Region["enableDelayFlags"];
  warrantyStartDate?: Region["warrantyStartDate"];
  verticalCompleteDate?: Region["verticalCompleteDate"];
  jobLogInsights?: ProjectJobLogInsights | ProjectJobLogInsightsOptions;
  targetEndDate?: Region["targetEndDate"];
  latestActiveStage?: ProjectStage | ProjectStageOptions | null;
  primaryHomeowner?: Client | ClientOptions | null;
  toDos?: Array<ToDo | ToDoOptions> | null;
  lotDetail?: ProjectLotDetail | ProjectLotDetailOptions;
  siteSpecificInfos?: Array<ProjectSiteSpecificInfo | ProjectSiteSpecificInfoOptions>;
  projectSiteCondition?: ProjectSiteCondition | ProjectSiteConditionOptions | null;
  unassignedTaskCount?: Region["unassignedTaskCount"];
  enableHomeownerNotes?: Region["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Region["checkoutCustomerConfigId"];
  canEditJobLogs?: PotentialOperation2 | PotentialOperation2Options;
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  canHaveBudget?: PotentialOperation2 | PotentialOperation2Options;
  homeownerNotes?: Array<HomeownerNote | HomeownerNoteOptions>;
  enableHomeownerJourneyV2?: Region["enableHomeownerJourneyV2"];
  featureFlags?: Array<FeatureFlag | FeatureFlagOptions>;
  homeownerDeliveryDate?: Region["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Region["tasksCompletedThisWeek"];
  contacts?: Array<ProjectContact | ProjectContactOptions>;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
  shouldAccrueAsComplete?: Region["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Region["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Region["indirectCostMarkupOverrideBasisPoints"];
  customer?: Customer | CustomerOptions | null;
  customerOwnerEntity?: CustomerOwnerEntity | CustomerOwnerEntityOptions | null;
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions | null;
  allowExcludedCostCodesOnPurchaseOrders?: Region["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Region["enableProductConfigPlan"];
  planSchedule?: PlanSchedule | PlanScheduleOptions | null;
  builder?: Builder | BuilderOptions | null;
  bidOutPercentage?: Region["bidOutPercentage"];
  enableChangeEventSignatures?: Region["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Region["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Region["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Region["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Region["directHardCostMarkupInBasisPoints"];
  legalDescription?: Region["legalDescription"];
  salesTaxOverrideInBasisPoints?: Region["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Region["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<ProjectItemAllocation | ProjectItemAllocationOptions>;
  allocationRules?: Array<ProjectAllocationRule | ProjectAllocationRuleOptions>;
  warrantyLengthInDays?: Region["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Region["warrantyOverrideLengthInDays"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  bidContracts?: Array<BidContract | BidContractOptions>;
  homeownerContracts?: Array<HomeownerContract | HomeownerContractOptions>;
  documents?: Array<Document | DocumentOptions>;
  commitments?: Array<Commitment | CommitmentOptions>;
  directCostInCents?: Region["directCostInCents"];
  directPriceInCents?: Region["directPriceInCents"];
  totalHardCostInCents?: Region["totalHardCostInCents"];
  totalSoftCostInCents?: Region["totalSoftCostInCents"];
  totalCostInCents?: Region["totalCostInCents"];
  totalPriceInCents?: Region["totalPriceInCents"];
  readyToStartDate?: Region["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Region["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Region["directCostAtStartInCents"];
  directCostVarianceInCents?: Region["directCostVarianceInCents"];
  uncommittedCostInCents?: Region["uncommittedCostInCents"];
  snapshots?: Array<ProjectSnapshot | ProjectSnapshotOptions>;
  companyInfo?: CompanyInfo | CompanyInfoOptions;
  invoicePaymentNetDays?: Region["invoicePaymentNetDays"];
  snapshotAsOf?: ProjectSnapshot | ProjectSnapshotOptions | null;
  purchaseCostInCents?: Region["purchaseCostInCents"];
  grossSalesPriceInCents?: Region["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Region["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Region["directMarginInBasisPoints"];
  projectCostCodes?: Array<ProjectCostCode | ProjectCostCodeOptions>;
  parent?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  parentsRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  childrenRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  siblingProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  sellableProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  isSellableProject?: Region["isSellableProject"];
  originalCostInCents?: Region["originalCostInCents"];
  startCostInCents?: Region["startCostInCents"];
  changeEventCostInCents?: Region["changeEventCostInCents"];
  projectedCostInCents?: Region["projectedCostInCents"];
  revisedCostInCents?: Region["revisedCostInCents"];
  committedCostInCents?: Region["committedCostInCents"];
  availableCostInCents?: Region["availableCostInCents"];
  billedCostInCents?: Region["billedCostInCents"];
  unbilledCostInCents?: Region["unbilledCostInCents"];
  cohort?: Cohort | CohortOptions | null;
  constructionConfidenceFactor?: Region["constructionConfidenceFactor"];
  lotRating?: LotRating | LotRatingOptions | null;
  preConBudgetLineItems?: Array<PreConBudgetCostDivisionLineItem | PreConBudgetCostDivisionLineItemOptions>;
  preconContractType?: PreconContractType | PreconContractTypeOptions | null;
  primaryProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  quickbooksCustomerId?: Region["quickbooksCustomerId"];
  shadowProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  submarket?: Submarket | SubmarketOptions | null;
  client?: Client | ClientOptions | null;
  url?: Region["url"];
  projectName?: Region["projectName"];
  salesforceId?: Region["salesforceId"];
  activeSalesforceOpportunity?: ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions | null;
  dictionary?: ProjectDictionary | ProjectDictionaryOptions;
  warrantyEndDate?: Region["warrantyEndDate"];
  invoiceScheduleTemplates?: Array<InvoiceScheduleTemplate | InvoiceScheduleTemplateOptions>;
}

export function newRegion(options: RegionOptions = {}, cache: Record<string, any> = {}): Region {
  const o = (options.__typename ? options : cache["Region"] = {}) as Region;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Region";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Region");
  o.abbreviation = options.abbreviation ?? "abbreviation";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.children = (options.children ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("children")));
  o.collaborators = (options.collaborators ?? []).map((i) =>
    maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
  );
  o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
  o.buildAddress = maybeNewOrNull("Address", options.buildAddress, cache);
  o.market = maybeNewOrNull("Market", options.market, cache);
  o.teamMembers = (options.teamMembers ?? []).map((i) =>
    maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
  );
  o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
  o.activeStage = enumOrDetailOfStage(options.activeStage);
  o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
  o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
  o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.hopUrl = options.hopUrl ?? "hopUrl";
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
  );
  o.startDate = options.startDate ?? newDate();
  o.features = options.features ?? [];
  o.isTest = options.isTest ?? false;
  o.status = enumOrDetailOfProjectStatus(options.status);
  o.latitude = options.latitude ?? null;
  o.longitude = options.longitude ?? null;
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.googleDriveFolderId = options.googleDriveFolderId ?? null;
  o.salesforceAccountId = options.salesforceAccountId ?? null;
  o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
    maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
  );
  o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
  o.planRoomLink = options.planRoomLink ?? null;
  o.isDisaster = options.isDisaster ?? null;
  o.intakeStyleNotes = options.intakeStyleNotes ?? null;
  o.lotType = enumOrDetailOfLotType(options.lotType);
  o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
  o.productType = maybeNewOrNull("ProductType", options.productType, cache);
  o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
  o.salesforcePropertyId = options.salesforcePropertyId ?? null;
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
  o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
    maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
  );
  o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
  o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
  o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
  o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
  o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
    maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
  );
  o.enableBidPackagesV2 = options.enableBidPackagesV2 ?? false;
  o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
  o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
  o.lotPartitionId = options.lotPartitionId ?? null;
  o.budgetFinancials = maybeNew(
    "ProjectBudgetFinancials",
    options.budgetFinancials,
    cache,
    options.hasOwnProperty("budgetFinancials"),
  );
  o.enableDelayFlags = options.enableDelayFlags ?? false;
  o.warrantyStartDate = options.warrantyStartDate ?? null;
  o.verticalCompleteDate = options.verticalCompleteDate ?? null;
  o.jobLogInsights = maybeNew(
    "ProjectJobLogInsights",
    options.jobLogInsights,
    cache,
    options.hasOwnProperty("jobLogInsights"),
  );
  o.targetEndDate = options.targetEndDate ?? null;
  o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
  o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
  o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
    maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
  );
  o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
  o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
  o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
  o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
  o.canEditJobLogs = maybeNew(
    "PotentialOperation2",
    options.canEditJobLogs,
    cache,
    options.hasOwnProperty("canEditJobLogs"),
  );
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.canHaveBudget = maybeNew(
    "PotentialOperation2",
    options.canHaveBudget,
    cache,
    options.hasOwnProperty("canHaveBudget"),
  );
  o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
    maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
  );
  o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
  o.featureFlags = (options.featureFlags ?? []).map((i) =>
    maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
  );
  o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
  o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
  o.contacts = (options.contacts ?? []).map((i) =>
    maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
  );
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
  o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
  o.customer = maybeNewOrNull("Customer", options.customer, cache);
  o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
  o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
  o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
  o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
  o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
  o.builder = maybeNewOrNull("Builder", options.builder, cache);
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
  o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
  o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
  o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
  o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
  o.legalDescription = options.legalDescription ?? null;
  o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
  o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
  o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
    maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
  );
  o.allocationRules = (options.allocationRules ?? []).map((i) =>
    maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
  );
  o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
  o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
    maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.directCostInCents = options.directCostInCents ?? 0;
  o.directPriceInCents = options.directPriceInCents ?? 0;
  o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
  o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.readyToStartDate = options.readyToStartDate ?? null;
  o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
  o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
  o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
  o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
  o.snapshots = (options.snapshots ?? []).map((i) =>
    maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
  );
  o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
  o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
  o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
  o.purchaseCostInCents = options.purchaseCostInCents ?? null;
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
    maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
  );
  o.parent = maybeNewOrNull("Project", options.parent, cache);
  o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
  );
  o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
  );
  o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
  );
  o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
  );
  o.isSellableProject = options.isSellableProject ?? false;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
  o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
  o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
  o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
    maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
  );
  o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
  o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
  o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
  o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
  );
  o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
  o.client = maybeNewOrNull("Client", options.client, cache);
  o.url = options.url ?? "url";
  o.projectName = options.projectName ?? "projectName";
  o.salesforceId = options.salesforceId ?? null;
  o.activeSalesforceOpportunity = maybeNewOrNull(
    "ProjectSalesforceOpportunity",
    options.activeSalesforceOpportunity,
    cache,
  );
  o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
  o.warrantyEndDate = options.warrantyEndDate ?? null;
  o.invoiceScheduleTemplates = (options.invoiceScheduleTemplates ?? []).map((i) =>
    maybeNew("InvoiceScheduleTemplate", i, cache, options.hasOwnProperty("invoiceScheduleTemplates"))
  );
  return o;
}

factories["Region"] = newRegion;

export interface MarketOptions {
  __typename?: "Market";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Market["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Market["isFollowed"];
  id?: Market["id"];
  abbreviation?: Market["abbreviation"];
  phone?: Market["phone"];
  salesforceMarketCode?: Market["salesforceMarketCode"];
  submarkets?: Array<Submarket | SubmarketOptions>;
  timeZone?: Market["timeZone"];
  msaName?: Market["msaName"];
  developments?: Array<Development | DevelopmentOptions>;
  bidItemEstimates?: Array<BidItemEstimate | BidItemEstimateOptions>;
  readyPlans?: Array<ReadyPlan | ReadyPlanOptions>;
  optionPricingConfigVariants?: Array<OptionPricingConfigVariant | OptionPricingConfigVariantOptions>;
  state?: Market["state"];
  materialLeadTimeConfigVariants?: Array<MaterialLeadTimeConfigVariant | MaterialLeadTimeConfigVariantOptions>;
  standaloneProjects?: Array<StandaloneProject | StandaloneProjectOptions>;
  marketDevelopmentContracts?: Array<DevelopmentCommitment | DevelopmentCommitmentOptions>;
  drops?: Array<Drop | DropOptions>;
  market?: Market | MarketOptions;
  parent?: Region | RegionOptions;
  children?: Array<Community | CommunityOptions>;
  collaborators?: Array<ProjectCollaborator | ProjectCollaboratorOptions>;
  coverImage?: Asset | AssetOptions | null;
  buildAddress?: Address | AddressOptions | null;
  teamMembers?: Array<ProjectTeamMember | ProjectTeamMemberOptions>;
  projectLead?: ProjectTeamMember | ProjectTeamMemberOptions | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: ProjectStage | ProjectStageOptions | null;
  stages?: Array<ProjectStage | ProjectStageOptions>;
  stage?: ProjectStage | ProjectStageOptions;
  blueprintUrl?: Url | UrlOptions;
  hopUrl?: Market["hopUrl"];
  name?: Market["name"];
  displayName?: Market["displayName"];
  availableAssignees?: Array<InternalUser | InternalUserOptions>;
  startDate?: Market["startDate"];
  features?: Market["features"];
  isTest?: Market["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Market["latitude"];
  longitude?: Market["longitude"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  googleDriveFolderId?: Market["googleDriveFolderId"];
  salesforceAccountId?: Market["salesforceAccountId"];
  salesforceOpportunities?: Array<ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions>;
  projectStatusChange?: ProjectStatusChange | ProjectStatusChangeOptions | null;
  planRoomLink?: Market["planRoomLink"];
  isDisaster?: Market["isDisaster"];
  intakeStyleNotes?: Market["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: ProductType | ProductTypeOptions | null;
  enableSchedulesV2?: Market["enableSchedulesV2"];
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  jobLogs?: Array<JobLog | JobLogOptions>;
  salesforcePropertyId?: Market["salesforcePropertyId"];
  schedules?: Array<Schedule | ScheduleOptions>;
  expenses?: Array<Expense | ExpenseOptions>;
  unallocatedExpenses?: Array<Expense | ExpenseOptions>;
  unallocatedAmountInCents?: Market["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Market["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Market["enableSchedulesCalendar"];
  readyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions | null;
  earnedValueCurves?: Array<EarnedValueCurve | EarnedValueCurveOptions>;
  enableBidPackagesV2?: Market["enableBidPackagesV2"];
  invoiceSettings?: ProjectInvoiceSetting | ProjectInvoiceSettingOptions | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Market["lotPartitionId"];
  budgetFinancials?: ProjectBudgetFinancials | ProjectBudgetFinancialsOptions;
  enableDelayFlags?: Market["enableDelayFlags"];
  warrantyStartDate?: Market["warrantyStartDate"];
  verticalCompleteDate?: Market["verticalCompleteDate"];
  jobLogInsights?: ProjectJobLogInsights | ProjectJobLogInsightsOptions;
  targetEndDate?: Market["targetEndDate"];
  latestActiveStage?: ProjectStage | ProjectStageOptions | null;
  primaryHomeowner?: Client | ClientOptions | null;
  toDos?: Array<ToDo | ToDoOptions> | null;
  lotDetail?: ProjectLotDetail | ProjectLotDetailOptions;
  siteSpecificInfos?: Array<ProjectSiteSpecificInfo | ProjectSiteSpecificInfoOptions>;
  projectSiteCondition?: ProjectSiteCondition | ProjectSiteConditionOptions | null;
  unassignedTaskCount?: Market["unassignedTaskCount"];
  enableHomeownerNotes?: Market["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Market["checkoutCustomerConfigId"];
  canEditJobLogs?: PotentialOperation2 | PotentialOperation2Options;
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  canHaveBudget?: PotentialOperation2 | PotentialOperation2Options;
  homeownerNotes?: Array<HomeownerNote | HomeownerNoteOptions>;
  enableHomeownerJourneyV2?: Market["enableHomeownerJourneyV2"];
  featureFlags?: Array<FeatureFlag | FeatureFlagOptions>;
  homeownerDeliveryDate?: Market["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Market["tasksCompletedThisWeek"];
  contacts?: Array<ProjectContact | ProjectContactOptions>;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
  shouldAccrueAsComplete?: Market["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Market["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Market["indirectCostMarkupOverrideBasisPoints"];
  customer?: Customer | CustomerOptions | null;
  customerOwnerEntity?: CustomerOwnerEntity | CustomerOwnerEntityOptions | null;
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions | null;
  allowExcludedCostCodesOnPurchaseOrders?: Market["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Market["enableProductConfigPlan"];
  planSchedule?: PlanSchedule | PlanScheduleOptions | null;
  builder?: Builder | BuilderOptions | null;
  bidOutPercentage?: Market["bidOutPercentage"];
  enableChangeEventSignatures?: Market["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Market["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Market["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Market["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Market["directHardCostMarkupInBasisPoints"];
  legalDescription?: Market["legalDescription"];
  salesTaxOverrideInBasisPoints?: Market["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Market["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<ProjectItemAllocation | ProjectItemAllocationOptions>;
  allocationRules?: Array<ProjectAllocationRule | ProjectAllocationRuleOptions>;
  warrantyLengthInDays?: Market["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Market["warrantyOverrideLengthInDays"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  bidContracts?: Array<BidContract | BidContractOptions>;
  homeownerContracts?: Array<HomeownerContract | HomeownerContractOptions>;
  documents?: Array<Document | DocumentOptions>;
  commitments?: Array<Commitment | CommitmentOptions>;
  directCostInCents?: Market["directCostInCents"];
  directPriceInCents?: Market["directPriceInCents"];
  totalHardCostInCents?: Market["totalHardCostInCents"];
  totalSoftCostInCents?: Market["totalSoftCostInCents"];
  totalCostInCents?: Market["totalCostInCents"];
  totalPriceInCents?: Market["totalPriceInCents"];
  readyToStartDate?: Market["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Market["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Market["directCostAtStartInCents"];
  directCostVarianceInCents?: Market["directCostVarianceInCents"];
  uncommittedCostInCents?: Market["uncommittedCostInCents"];
  snapshots?: Array<ProjectSnapshot | ProjectSnapshotOptions>;
  warrantyEndDate?: Market["warrantyEndDate"];
  companyInfo?: CompanyInfo | CompanyInfoOptions;
  invoicePaymentNetDays?: Market["invoicePaymentNetDays"];
  snapshotAsOf?: ProjectSnapshot | ProjectSnapshotOptions | null;
  purchaseCostInCents?: Market["purchaseCostInCents"];
  grossSalesPriceInCents?: Market["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Market["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Market["directMarginInBasisPoints"];
  projectCostCodes?: Array<ProjectCostCode | ProjectCostCodeOptions>;
  parentsRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  childrenRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  siblingProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  sellableProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  isSellableProject?: Market["isSellableProject"];
  originalCostInCents?: Market["originalCostInCents"];
  startCostInCents?: Market["startCostInCents"];
  changeEventCostInCents?: Market["changeEventCostInCents"];
  projectedCostInCents?: Market["projectedCostInCents"];
  revisedCostInCents?: Market["revisedCostInCents"];
  committedCostInCents?: Market["committedCostInCents"];
  availableCostInCents?: Market["availableCostInCents"];
  billedCostInCents?: Market["billedCostInCents"];
  unbilledCostInCents?: Market["unbilledCostInCents"];
  cohort?: Cohort | CohortOptions | null;
  constructionConfidenceFactor?: Market["constructionConfidenceFactor"];
  lotRating?: LotRating | LotRatingOptions | null;
  preConBudgetLineItems?: Array<PreConBudgetCostDivisionLineItem | PreConBudgetCostDivisionLineItemOptions>;
  preconContractType?: PreconContractType | PreconContractTypeOptions | null;
  primaryProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  quickbooksCustomerId?: Market["quickbooksCustomerId"];
  shadowProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  submarket?: Submarket | SubmarketOptions | null;
  client?: Client | ClientOptions | null;
  url?: Market["url"];
  projectName?: Market["projectName"];
  salesforceId?: Market["salesforceId"];
  activeSalesforceOpportunity?: ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions | null;
  dictionary?: ProjectDictionary | ProjectDictionaryOptions;
}

export function newMarket(options: MarketOptions = {}, cache: Record<string, any> = {}): Market {
  const o = (options.__typename ? options : cache["Market"] = {}) as Market;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Market";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Market");
  o.abbreviation = options.abbreviation ?? "abbreviation";
  o.phone = options.phone ?? null;
  o.salesforceMarketCode = options.salesforceMarketCode ?? null;
  o.submarkets = (options.submarkets ?? []).map((i) =>
    maybeNew("Submarket", i, cache, options.hasOwnProperty("submarkets"))
  );
  o.timeZone = options.timeZone ?? "timeZone";
  o.msaName = options.msaName ?? null;
  o.developments = (options.developments ?? []).map((i) =>
    maybeNew("Development", i, cache, options.hasOwnProperty("developments"))
  );
  o.bidItemEstimates = (options.bidItemEstimates ?? []).map((i) =>
    maybeNew("BidItemEstimate", i, cache, options.hasOwnProperty("bidItemEstimates"))
  );
  o.readyPlans = (options.readyPlans ?? []).map((i) =>
    maybeNew("ReadyPlan", i, cache, options.hasOwnProperty("readyPlans"))
  );
  o.optionPricingConfigVariants = (options.optionPricingConfigVariants ?? []).map((i) =>
    maybeNew("OptionPricingConfigVariant", i, cache, options.hasOwnProperty("optionPricingConfigVariants"))
  );
  o.state = options.state ?? "state";
  o.materialLeadTimeConfigVariants = (options.materialLeadTimeConfigVariants ?? []).map((i) =>
    maybeNew("MaterialLeadTimeConfigVariant", i, cache, options.hasOwnProperty("materialLeadTimeConfigVariants"))
  );
  o.standaloneProjects = (options.standaloneProjects ?? []).map((i) =>
    maybeNew("StandaloneProject", i, cache, options.hasOwnProperty("standaloneProjects"))
  );
  o.marketDevelopmentContracts = (options.marketDevelopmentContracts ?? []).map((i) =>
    maybeNew("DevelopmentCommitment", i, cache, options.hasOwnProperty("marketDevelopmentContracts"))
  );
  o.drops = (options.drops ?? []).map((i) => maybeNew("Drop", i, cache, options.hasOwnProperty("drops")));
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.parent = maybeNew("Region", options.parent, cache, options.hasOwnProperty("parent"));
  o.children = (options.children ?? []).map((i) => maybeNew("Community", i, cache, options.hasOwnProperty("children")));
  o.collaborators = (options.collaborators ?? []).map((i) =>
    maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
  );
  o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
  o.buildAddress = maybeNewOrNull("Address", options.buildAddress, cache);
  o.teamMembers = (options.teamMembers ?? []).map((i) =>
    maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
  );
  o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
  o.activeStage = enumOrDetailOfStage(options.activeStage);
  o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
  o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
  o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.hopUrl = options.hopUrl ?? "hopUrl";
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
  );
  o.startDate = options.startDate ?? newDate();
  o.features = options.features ?? [];
  o.isTest = options.isTest ?? false;
  o.status = enumOrDetailOfProjectStatus(options.status);
  o.latitude = options.latitude ?? null;
  o.longitude = options.longitude ?? null;
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.googleDriveFolderId = options.googleDriveFolderId ?? null;
  o.salesforceAccountId = options.salesforceAccountId ?? null;
  o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
    maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
  );
  o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
  o.planRoomLink = options.planRoomLink ?? null;
  o.isDisaster = options.isDisaster ?? null;
  o.intakeStyleNotes = options.intakeStyleNotes ?? null;
  o.lotType = enumOrDetailOfLotType(options.lotType);
  o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
  o.productType = maybeNewOrNull("ProductType", options.productType, cache);
  o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
  o.salesforcePropertyId = options.salesforcePropertyId ?? null;
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
  o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
    maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
  );
  o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
  o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
  o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
  o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
  o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
    maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
  );
  o.enableBidPackagesV2 = options.enableBidPackagesV2 ?? false;
  o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
  o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
  o.lotPartitionId = options.lotPartitionId ?? null;
  o.budgetFinancials = maybeNew(
    "ProjectBudgetFinancials",
    options.budgetFinancials,
    cache,
    options.hasOwnProperty("budgetFinancials"),
  );
  o.enableDelayFlags = options.enableDelayFlags ?? false;
  o.warrantyStartDate = options.warrantyStartDate ?? null;
  o.verticalCompleteDate = options.verticalCompleteDate ?? null;
  o.jobLogInsights = maybeNew(
    "ProjectJobLogInsights",
    options.jobLogInsights,
    cache,
    options.hasOwnProperty("jobLogInsights"),
  );
  o.targetEndDate = options.targetEndDate ?? null;
  o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
  o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
  o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
    maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
  );
  o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
  o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
  o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
  o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
  o.canEditJobLogs = maybeNew(
    "PotentialOperation2",
    options.canEditJobLogs,
    cache,
    options.hasOwnProperty("canEditJobLogs"),
  );
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.canHaveBudget = maybeNew(
    "PotentialOperation2",
    options.canHaveBudget,
    cache,
    options.hasOwnProperty("canHaveBudget"),
  );
  o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
    maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
  );
  o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
  o.featureFlags = (options.featureFlags ?? []).map((i) =>
    maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
  );
  o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
  o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
  o.contacts = (options.contacts ?? []).map((i) =>
    maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
  );
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
  o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
  o.customer = maybeNewOrNull("Customer", options.customer, cache);
  o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
  o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
  o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
  o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
  o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
  o.builder = maybeNewOrNull("Builder", options.builder, cache);
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
  o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
  o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
  o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
  o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
  o.legalDescription = options.legalDescription ?? null;
  o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
  o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
  o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
    maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
  );
  o.allocationRules = (options.allocationRules ?? []).map((i) =>
    maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
  );
  o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
  o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
    maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.directCostInCents = options.directCostInCents ?? 0;
  o.directPriceInCents = options.directPriceInCents ?? 0;
  o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
  o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.readyToStartDate = options.readyToStartDate ?? null;
  o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
  o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
  o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
  o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
  o.snapshots = (options.snapshots ?? []).map((i) =>
    maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
  );
  o.warrantyEndDate = options.warrantyEndDate ?? null;
  o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
  o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
  o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
  o.purchaseCostInCents = options.purchaseCostInCents ?? null;
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
    maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
  );
  o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
  );
  o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
  );
  o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
  );
  o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
  );
  o.isSellableProject = options.isSellableProject ?? false;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
  o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
  o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
  o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
    maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
  );
  o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
  o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
  o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
  o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
  );
  o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
  o.client = maybeNewOrNull("Client", options.client, cache);
  o.url = options.url ?? "url";
  o.projectName = options.projectName ?? "projectName";
  o.salesforceId = options.salesforceId ?? null;
  o.activeSalesforceOpportunity = maybeNewOrNull(
    "ProjectSalesforceOpportunity",
    options.activeSalesforceOpportunity,
    cache,
  );
  o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
  return o;
}

factories["Market"] = newMarket;

export interface CommunityOptions {
  __typename?: "Community";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Community["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Community["isFollowed"];
  id?: Community["id"];
  productOfferings?: Array<ProductOffering | ProductOfferingOptions>;
  drops?: Array<Drop | DropOptions>;
  costCodesWithDraws?: Array<CostCode | CostCodeOptions>;
  salesforceNeighborhoodId?: Community["salesforceNeighborhoodId"];
  pricingTeaser?: Community["pricingTeaser"];
  lotMap?: Community["lotMap"];
  market?: Market | MarketOptions;
  parent?: Market | MarketOptions;
  children?: Array<Subdivision | SubdivisionOptions>;
  collaborators?: Array<ProjectCollaborator | ProjectCollaboratorOptions>;
  coverImage?: Asset | AssetOptions | null;
  buildAddress?: Address | AddressOptions | null;
  teamMembers?: Array<ProjectTeamMember | ProjectTeamMemberOptions>;
  projectLead?: ProjectTeamMember | ProjectTeamMemberOptions | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: ProjectStage | ProjectStageOptions | null;
  stages?: Array<ProjectStage | ProjectStageOptions>;
  stage?: ProjectStage | ProjectStageOptions;
  blueprintUrl?: Url | UrlOptions;
  hopUrl?: Community["hopUrl"];
  name?: Community["name"];
  displayName?: Community["displayName"];
  availableAssignees?: Array<InternalUser | InternalUserOptions>;
  startDate?: Community["startDate"];
  features?: Community["features"];
  isTest?: Community["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Community["latitude"];
  longitude?: Community["longitude"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  googleDriveFolderId?: Community["googleDriveFolderId"];
  salesforceAccountId?: Community["salesforceAccountId"];
  salesforceOpportunities?: Array<ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions>;
  projectStatusChange?: ProjectStatusChange | ProjectStatusChangeOptions | null;
  planRoomLink?: Community["planRoomLink"];
  isDisaster?: Community["isDisaster"];
  intakeStyleNotes?: Community["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: ProductType | ProductTypeOptions | null;
  enableSchedulesV2?: Community["enableSchedulesV2"];
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  jobLogs?: Array<JobLog | JobLogOptions>;
  salesforcePropertyId?: Community["salesforcePropertyId"];
  schedules?: Array<Schedule | ScheduleOptions>;
  expenses?: Array<Expense | ExpenseOptions>;
  unallocatedExpenses?: Array<Expense | ExpenseOptions>;
  unallocatedAmountInCents?: Community["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Community["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Community["enableSchedulesCalendar"];
  readyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions | null;
  earnedValueCurves?: Array<EarnedValueCurve | EarnedValueCurveOptions>;
  enableBidPackagesV2?: Community["enableBidPackagesV2"];
  invoiceSettings?: ProjectInvoiceSetting | ProjectInvoiceSettingOptions | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Community["lotPartitionId"];
  budgetFinancials?: ProjectBudgetFinancials | ProjectBudgetFinancialsOptions;
  enableDelayFlags?: Community["enableDelayFlags"];
  warrantyStartDate?: Community["warrantyStartDate"];
  verticalCompleteDate?: Community["verticalCompleteDate"];
  jobLogInsights?: ProjectJobLogInsights | ProjectJobLogInsightsOptions;
  targetEndDate?: Community["targetEndDate"];
  latestActiveStage?: ProjectStage | ProjectStageOptions | null;
  primaryHomeowner?: Client | ClientOptions | null;
  toDos?: Array<ToDo | ToDoOptions> | null;
  lotDetail?: ProjectLotDetail | ProjectLotDetailOptions;
  siteSpecificInfos?: Array<ProjectSiteSpecificInfo | ProjectSiteSpecificInfoOptions>;
  projectSiteCondition?: ProjectSiteCondition | ProjectSiteConditionOptions | null;
  unassignedTaskCount?: Community["unassignedTaskCount"];
  enableHomeownerNotes?: Community["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Community["checkoutCustomerConfigId"];
  canEditJobLogs?: PotentialOperation2 | PotentialOperation2Options;
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  canHaveBudget?: PotentialOperation2 | PotentialOperation2Options;
  homeownerNotes?: Array<HomeownerNote | HomeownerNoteOptions>;
  enableHomeownerJourneyV2?: Community["enableHomeownerJourneyV2"];
  featureFlags?: Array<FeatureFlag | FeatureFlagOptions>;
  homeownerDeliveryDate?: Community["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Community["tasksCompletedThisWeek"];
  contacts?: Array<ProjectContact | ProjectContactOptions>;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
  shouldAccrueAsComplete?: Community["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Community["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Community["indirectCostMarkupOverrideBasisPoints"];
  customer?: Customer | CustomerOptions | null;
  customerOwnerEntity?: CustomerOwnerEntity | CustomerOwnerEntityOptions | null;
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions | null;
  allowExcludedCostCodesOnPurchaseOrders?: Community["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Community["enableProductConfigPlan"];
  planSchedule?: PlanSchedule | PlanScheduleOptions | null;
  builder?: Builder | BuilderOptions | null;
  bidOutPercentage?: Community["bidOutPercentage"];
  enableChangeEventSignatures?: Community["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Community["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Community["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Community["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Community["directHardCostMarkupInBasisPoints"];
  legalDescription?: Community["legalDescription"];
  salesTaxOverrideInBasisPoints?: Community["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Community["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<ProjectItemAllocation | ProjectItemAllocationOptions>;
  allocationRules?: Array<ProjectAllocationRule | ProjectAllocationRuleOptions>;
  warrantyLengthInDays?: Community["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Community["warrantyOverrideLengthInDays"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  bidContracts?: Array<BidContract | BidContractOptions>;
  homeownerContracts?: Array<HomeownerContract | HomeownerContractOptions>;
  documents?: Array<Document | DocumentOptions>;
  commitments?: Array<Commitment | CommitmentOptions>;
  directCostInCents?: Community["directCostInCents"];
  directPriceInCents?: Community["directPriceInCents"];
  totalHardCostInCents?: Community["totalHardCostInCents"];
  totalSoftCostInCents?: Community["totalSoftCostInCents"];
  totalCostInCents?: Community["totalCostInCents"];
  totalPriceInCents?: Community["totalPriceInCents"];
  readyToStartDate?: Community["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Community["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Community["directCostAtStartInCents"];
  directCostVarianceInCents?: Community["directCostVarianceInCents"];
  uncommittedCostInCents?: Community["uncommittedCostInCents"];
  snapshots?: Array<ProjectSnapshot | ProjectSnapshotOptions>;
  warrantyEndDate?: Community["warrantyEndDate"];
  companyInfo?: CompanyInfo | CompanyInfoOptions;
  invoicePaymentNetDays?: Community["invoicePaymentNetDays"];
  snapshotAsOf?: ProjectSnapshot | ProjectSnapshotOptions | null;
  purchaseCostInCents?: Community["purchaseCostInCents"];
  grossSalesPriceInCents?: Community["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Community["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Community["directMarginInBasisPoints"];
  projectCostCodes?: Array<ProjectCostCode | ProjectCostCodeOptions>;
  showInCheckout?: Community["showInCheckout"];
  parentsRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  childrenRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  siblingProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  sellableProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  isSellableProject?: Community["isSellableProject"];
  originalCostInCents?: Community["originalCostInCents"];
  startCostInCents?: Community["startCostInCents"];
  changeEventCostInCents?: Community["changeEventCostInCents"];
  projectedCostInCents?: Community["projectedCostInCents"];
  revisedCostInCents?: Community["revisedCostInCents"];
  committedCostInCents?: Community["committedCostInCents"];
  availableCostInCents?: Community["availableCostInCents"];
  billedCostInCents?: Community["billedCostInCents"];
  unbilledCostInCents?: Community["unbilledCostInCents"];
  cohort?: Cohort | CohortOptions | null;
  constructionConfidenceFactor?: Community["constructionConfidenceFactor"];
  lotRating?: LotRating | LotRatingOptions | null;
  preConBudgetLineItems?: Array<PreConBudgetCostDivisionLineItem | PreConBudgetCostDivisionLineItemOptions>;
  preconContractType?: PreconContractType | PreconContractTypeOptions | null;
  primaryProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  quickbooksCustomerId?: Community["quickbooksCustomerId"];
  shadowProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  submarket?: Submarket | SubmarketOptions | null;
  client?: Client | ClientOptions | null;
  url?: Community["url"];
  projectName?: Community["projectName"];
  salesforceId?: Community["salesforceId"];
  activeSalesforceOpportunity?: ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions | null;
  dictionary?: ProjectDictionary | ProjectDictionaryOptions;
  packageComparison?: Asset | AssetOptions | null;
  globalPlanStageVariants?: Array<GlobalPlanStageVariant | GlobalPlanStageVariantOptions>;
}

export function newCommunity(options: CommunityOptions = {}, cache: Record<string, any> = {}): Community {
  const o = (options.__typename ? options : cache["Community"] = {}) as Community;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Community";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Community");
  o.productOfferings = (options.productOfferings ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("productOfferings"))
  );
  o.drops = (options.drops ?? []).map((i) => maybeNew("Drop", i, cache, options.hasOwnProperty("drops")));
  o.costCodesWithDraws = (options.costCodesWithDraws ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodesWithDraws"))
  );
  o.salesforceNeighborhoodId = options.salesforceNeighborhoodId ?? null;
  o.pricingTeaser = options.pricingTeaser ?? null;
  o.lotMap = options.lotMap ?? null;
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.parent = maybeNew("Market", options.parent, cache, options.hasOwnProperty("parent"));
  o.children = (options.children ?? []).map((i) =>
    maybeNew("Subdivision", i, cache, options.hasOwnProperty("children"))
  );
  o.collaborators = (options.collaborators ?? []).map((i) =>
    maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
  );
  o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
  o.buildAddress = maybeNewOrNull("Address", options.buildAddress, cache);
  o.teamMembers = (options.teamMembers ?? []).map((i) =>
    maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
  );
  o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
  o.activeStage = enumOrDetailOfStage(options.activeStage);
  o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
  o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
  o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.hopUrl = options.hopUrl ?? "hopUrl";
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
  );
  o.startDate = options.startDate ?? newDate();
  o.features = options.features ?? [];
  o.isTest = options.isTest ?? false;
  o.status = enumOrDetailOfProjectStatus(options.status);
  o.latitude = options.latitude ?? null;
  o.longitude = options.longitude ?? null;
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.googleDriveFolderId = options.googleDriveFolderId ?? null;
  o.salesforceAccountId = options.salesforceAccountId ?? null;
  o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
    maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
  );
  o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
  o.planRoomLink = options.planRoomLink ?? null;
  o.isDisaster = options.isDisaster ?? null;
  o.intakeStyleNotes = options.intakeStyleNotes ?? null;
  o.lotType = enumOrDetailOfLotType(options.lotType);
  o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
  o.productType = maybeNewOrNull("ProductType", options.productType, cache);
  o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
  o.salesforcePropertyId = options.salesforcePropertyId ?? null;
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
  o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
    maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
  );
  o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
  o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
  o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
  o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
  o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
    maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
  );
  o.enableBidPackagesV2 = options.enableBidPackagesV2 ?? false;
  o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
  o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
  o.lotPartitionId = options.lotPartitionId ?? null;
  o.budgetFinancials = maybeNew(
    "ProjectBudgetFinancials",
    options.budgetFinancials,
    cache,
    options.hasOwnProperty("budgetFinancials"),
  );
  o.enableDelayFlags = options.enableDelayFlags ?? false;
  o.warrantyStartDate = options.warrantyStartDate ?? null;
  o.verticalCompleteDate = options.verticalCompleteDate ?? null;
  o.jobLogInsights = maybeNew(
    "ProjectJobLogInsights",
    options.jobLogInsights,
    cache,
    options.hasOwnProperty("jobLogInsights"),
  );
  o.targetEndDate = options.targetEndDate ?? null;
  o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
  o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
  o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
    maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
  );
  o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
  o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
  o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
  o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
  o.canEditJobLogs = maybeNew(
    "PotentialOperation2",
    options.canEditJobLogs,
    cache,
    options.hasOwnProperty("canEditJobLogs"),
  );
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.canHaveBudget = maybeNew(
    "PotentialOperation2",
    options.canHaveBudget,
    cache,
    options.hasOwnProperty("canHaveBudget"),
  );
  o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
    maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
  );
  o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
  o.featureFlags = (options.featureFlags ?? []).map((i) =>
    maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
  );
  o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
  o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
  o.contacts = (options.contacts ?? []).map((i) =>
    maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
  );
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
  o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
  o.customer = maybeNewOrNull("Customer", options.customer, cache);
  o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
  o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
  o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
  o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
  o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
  o.builder = maybeNewOrNull("Builder", options.builder, cache);
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
  o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
  o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
  o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
  o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
  o.legalDescription = options.legalDescription ?? null;
  o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
  o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
  o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
    maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
  );
  o.allocationRules = (options.allocationRules ?? []).map((i) =>
    maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
  );
  o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
  o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
    maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.directCostInCents = options.directCostInCents ?? 0;
  o.directPriceInCents = options.directPriceInCents ?? 0;
  o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
  o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.readyToStartDate = options.readyToStartDate ?? null;
  o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
  o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
  o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
  o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
  o.snapshots = (options.snapshots ?? []).map((i) =>
    maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
  );
  o.warrantyEndDate = options.warrantyEndDate ?? null;
  o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
  o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
  o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
  o.purchaseCostInCents = options.purchaseCostInCents ?? null;
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
    maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
  );
  o.showInCheckout = options.showInCheckout ?? false;
  o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
  );
  o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
  );
  o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
  );
  o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
  );
  o.isSellableProject = options.isSellableProject ?? false;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
  o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
  o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
  o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
    maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
  );
  o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
  o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
  o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
  o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
  );
  o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
  o.client = maybeNewOrNull("Client", options.client, cache);
  o.url = options.url ?? "url";
  o.projectName = options.projectName ?? "projectName";
  o.salesforceId = options.salesforceId ?? null;
  o.activeSalesforceOpportunity = maybeNewOrNull(
    "ProjectSalesforceOpportunity",
    options.activeSalesforceOpportunity,
    cache,
  );
  o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
  o.packageComparison = maybeNewOrNull("Asset", options.packageComparison, cache);
  o.globalPlanStageVariants = (options.globalPlanStageVariants ?? []).map((i) =>
    maybeNew("GlobalPlanStageVariant", i, cache, options.hasOwnProperty("globalPlanStageVariants"))
  );
  return o;
}

factories["Community"] = newCommunity;

export interface SubdivisionOptions {
  __typename?: "Subdivision";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Subdivision["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Subdivision["isFollowed"];
  id?: Subdivision["id"];
  salesforceBusinessDevelopmentOpportunityId?: Subdivision["salesforceBusinessDevelopmentOpportunityId"];
  salesforceTakedownId?: Subdivision["salesforceTakedownId"];
  market?: Market | MarketOptions;
  parent?: Community | CommunityOptions;
  children?: Array<Lot | LotOptions>;
  collaborators?: Array<ProjectCollaborator | ProjectCollaboratorOptions>;
  coverImage?: Asset | AssetOptions | null;
  buildAddress?: Address | AddressOptions | null;
  teamMembers?: Array<ProjectTeamMember | ProjectTeamMemberOptions>;
  projectLead?: ProjectTeamMember | ProjectTeamMemberOptions | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: ProjectStage | ProjectStageOptions | null;
  stages?: Array<ProjectStage | ProjectStageOptions>;
  stage?: ProjectStage | ProjectStageOptions;
  blueprintUrl?: Url | UrlOptions;
  hopUrl?: Subdivision["hopUrl"];
  name?: Subdivision["name"];
  displayName?: Subdivision["displayName"];
  availableAssignees?: Array<InternalUser | InternalUserOptions>;
  startDate?: Subdivision["startDate"];
  features?: Subdivision["features"];
  isTest?: Subdivision["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Subdivision["latitude"];
  longitude?: Subdivision["longitude"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  googleDriveFolderId?: Subdivision["googleDriveFolderId"];
  salesforceAccountId?: Subdivision["salesforceAccountId"];
  salesforceOpportunities?: Array<ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions>;
  projectStatusChange?: ProjectStatusChange | ProjectStatusChangeOptions | null;
  planRoomLink?: Subdivision["planRoomLink"];
  isDisaster?: Subdivision["isDisaster"];
  intakeStyleNotes?: Subdivision["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: ProductType | ProductTypeOptions | null;
  enableSchedulesV2?: Subdivision["enableSchedulesV2"];
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  jobLogs?: Array<JobLog | JobLogOptions>;
  salesforcePropertyId?: Subdivision["salesforcePropertyId"];
  schedules?: Array<Schedule | ScheduleOptions>;
  expenses?: Array<Expense | ExpenseOptions>;
  unallocatedExpenses?: Array<Expense | ExpenseOptions>;
  unallocatedAmountInCents?: Subdivision["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Subdivision["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Subdivision["enableSchedulesCalendar"];
  readyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions | null;
  earnedValueCurves?: Array<EarnedValueCurve | EarnedValueCurveOptions>;
  enableBidPackagesV2?: Subdivision["enableBidPackagesV2"];
  invoiceSettings?: ProjectInvoiceSetting | ProjectInvoiceSettingOptions | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Subdivision["lotPartitionId"];
  budgetFinancials?: ProjectBudgetFinancials | ProjectBudgetFinancialsOptions;
  enableDelayFlags?: Subdivision["enableDelayFlags"];
  warrantyStartDate?: Subdivision["warrantyStartDate"];
  verticalCompleteDate?: Subdivision["verticalCompleteDate"];
  jobLogInsights?: ProjectJobLogInsights | ProjectJobLogInsightsOptions;
  targetEndDate?: Subdivision["targetEndDate"];
  latestActiveStage?: ProjectStage | ProjectStageOptions | null;
  primaryHomeowner?: Client | ClientOptions | null;
  toDos?: Array<ToDo | ToDoOptions> | null;
  lotDetail?: ProjectLotDetail | ProjectLotDetailOptions;
  siteSpecificInfos?: Array<ProjectSiteSpecificInfo | ProjectSiteSpecificInfoOptions>;
  projectSiteCondition?: ProjectSiteCondition | ProjectSiteConditionOptions | null;
  unassignedTaskCount?: Subdivision["unassignedTaskCount"];
  enableHomeownerNotes?: Subdivision["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Subdivision["checkoutCustomerConfigId"];
  canEditJobLogs?: PotentialOperation2 | PotentialOperation2Options;
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  canHaveBudget?: PotentialOperation2 | PotentialOperation2Options;
  homeownerNotes?: Array<HomeownerNote | HomeownerNoteOptions>;
  enableHomeownerJourneyV2?: Subdivision["enableHomeownerJourneyV2"];
  featureFlags?: Array<FeatureFlag | FeatureFlagOptions>;
  homeownerDeliveryDate?: Subdivision["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Subdivision["tasksCompletedThisWeek"];
  contacts?: Array<ProjectContact | ProjectContactOptions>;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
  shouldAccrueAsComplete?: Subdivision["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Subdivision["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Subdivision["indirectCostMarkupOverrideBasisPoints"];
  customer?: Customer | CustomerOptions | null;
  customerOwnerEntity?: CustomerOwnerEntity | CustomerOwnerEntityOptions | null;
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions | null;
  allowExcludedCostCodesOnPurchaseOrders?: Subdivision["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Subdivision["enableProductConfigPlan"];
  planSchedule?: PlanSchedule | PlanScheduleOptions | null;
  builder?: Builder | BuilderOptions | null;
  bidOutPercentage?: Subdivision["bidOutPercentage"];
  enableChangeEventSignatures?: Subdivision["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Subdivision["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Subdivision["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Subdivision["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Subdivision["directHardCostMarkupInBasisPoints"];
  legalDescription?: Subdivision["legalDescription"];
  salesTaxOverrideInBasisPoints?: Subdivision["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Subdivision["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<ProjectItemAllocation | ProjectItemAllocationOptions>;
  allocationRules?: Array<ProjectAllocationRule | ProjectAllocationRuleOptions>;
  warrantyLengthInDays?: Subdivision["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Subdivision["warrantyOverrideLengthInDays"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  bidContracts?: Array<BidContract | BidContractOptions>;
  homeownerContracts?: Array<HomeownerContract | HomeownerContractOptions>;
  documents?: Array<Document | DocumentOptions>;
  commitments?: Array<Commitment | CommitmentOptions>;
  directCostInCents?: Subdivision["directCostInCents"];
  directPriceInCents?: Subdivision["directPriceInCents"];
  totalHardCostInCents?: Subdivision["totalHardCostInCents"];
  totalSoftCostInCents?: Subdivision["totalSoftCostInCents"];
  totalCostInCents?: Subdivision["totalCostInCents"];
  totalPriceInCents?: Subdivision["totalPriceInCents"];
  readyToStartDate?: Subdivision["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Subdivision["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Subdivision["directCostAtStartInCents"];
  directCostVarianceInCents?: Subdivision["directCostVarianceInCents"];
  uncommittedCostInCents?: Subdivision["uncommittedCostInCents"];
  snapshots?: Array<ProjectSnapshot | ProjectSnapshotOptions>;
  warrantyEndDate?: Subdivision["warrantyEndDate"];
  companyInfo?: CompanyInfo | CompanyInfoOptions;
  invoicePaymentNetDays?: Subdivision["invoicePaymentNetDays"];
  snapshotAsOf?: ProjectSnapshot | ProjectSnapshotOptions | null;
  purchaseCostInCents?: Subdivision["purchaseCostInCents"];
  grossSalesPriceInCents?: Subdivision["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Subdivision["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Subdivision["directMarginInBasisPoints"];
  projectCostCodes?: Array<ProjectCostCode | ProjectCostCodeOptions>;
  parentsRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  childrenRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  siblingProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  sellableProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  isSellableProject?: Subdivision["isSellableProject"];
  originalCostInCents?: Subdivision["originalCostInCents"];
  startCostInCents?: Subdivision["startCostInCents"];
  changeEventCostInCents?: Subdivision["changeEventCostInCents"];
  projectedCostInCents?: Subdivision["projectedCostInCents"];
  revisedCostInCents?: Subdivision["revisedCostInCents"];
  committedCostInCents?: Subdivision["committedCostInCents"];
  availableCostInCents?: Subdivision["availableCostInCents"];
  billedCostInCents?: Subdivision["billedCostInCents"];
  unbilledCostInCents?: Subdivision["unbilledCostInCents"];
  cohort?: Cohort | CohortOptions | null;
  constructionConfidenceFactor?: Subdivision["constructionConfidenceFactor"];
  lotRating?: LotRating | LotRatingOptions | null;
  preConBudgetLineItems?: Array<PreConBudgetCostDivisionLineItem | PreConBudgetCostDivisionLineItemOptions>;
  preconContractType?: PreconContractType | PreconContractTypeOptions | null;
  primaryProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  quickbooksCustomerId?: Subdivision["quickbooksCustomerId"];
  shadowProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  submarket?: Submarket | SubmarketOptions | null;
  client?: Client | ClientOptions | null;
  url?: Subdivision["url"];
  projectName?: Subdivision["projectName"];
  salesforceId?: Subdivision["salesforceId"];
  activeSalesforceOpportunity?: ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions | null;
  dictionary?: ProjectDictionary | ProjectDictionaryOptions;
}

export function newSubdivision(options: SubdivisionOptions = {}, cache: Record<string, any> = {}): Subdivision {
  const o = (options.__typename ? options : cache["Subdivision"] = {}) as Subdivision;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Subdivision";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Subdivision");
  o.salesforceBusinessDevelopmentOpportunityId = options.salesforceBusinessDevelopmentOpportunityId ?? null;
  o.salesforceTakedownId = options.salesforceTakedownId ?? null;
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.parent = maybeNew("Community", options.parent, cache, options.hasOwnProperty("parent"));
  o.children = (options.children ?? []).map((i) => maybeNew("Lot", i, cache, options.hasOwnProperty("children")));
  o.collaborators = (options.collaborators ?? []).map((i) =>
    maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
  );
  o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
  o.buildAddress = maybeNewOrNull("Address", options.buildAddress, cache);
  o.teamMembers = (options.teamMembers ?? []).map((i) =>
    maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
  );
  o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
  o.activeStage = enumOrDetailOfStage(options.activeStage);
  o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
  o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
  o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.hopUrl = options.hopUrl ?? "hopUrl";
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
  );
  o.startDate = options.startDate ?? newDate();
  o.features = options.features ?? [];
  o.isTest = options.isTest ?? false;
  o.status = enumOrDetailOfProjectStatus(options.status);
  o.latitude = options.latitude ?? null;
  o.longitude = options.longitude ?? null;
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.googleDriveFolderId = options.googleDriveFolderId ?? null;
  o.salesforceAccountId = options.salesforceAccountId ?? null;
  o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
    maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
  );
  o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
  o.planRoomLink = options.planRoomLink ?? null;
  o.isDisaster = options.isDisaster ?? null;
  o.intakeStyleNotes = options.intakeStyleNotes ?? null;
  o.lotType = enumOrDetailOfLotType(options.lotType);
  o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
  o.productType = maybeNewOrNull("ProductType", options.productType, cache);
  o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
  o.salesforcePropertyId = options.salesforcePropertyId ?? null;
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
  o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
    maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
  );
  o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
  o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
  o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
  o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
  o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
    maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
  );
  o.enableBidPackagesV2 = options.enableBidPackagesV2 ?? false;
  o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
  o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
  o.lotPartitionId = options.lotPartitionId ?? null;
  o.budgetFinancials = maybeNew(
    "ProjectBudgetFinancials",
    options.budgetFinancials,
    cache,
    options.hasOwnProperty("budgetFinancials"),
  );
  o.enableDelayFlags = options.enableDelayFlags ?? false;
  o.warrantyStartDate = options.warrantyStartDate ?? null;
  o.verticalCompleteDate = options.verticalCompleteDate ?? null;
  o.jobLogInsights = maybeNew(
    "ProjectJobLogInsights",
    options.jobLogInsights,
    cache,
    options.hasOwnProperty("jobLogInsights"),
  );
  o.targetEndDate = options.targetEndDate ?? null;
  o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
  o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
  o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
    maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
  );
  o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
  o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
  o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
  o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
  o.canEditJobLogs = maybeNew(
    "PotentialOperation2",
    options.canEditJobLogs,
    cache,
    options.hasOwnProperty("canEditJobLogs"),
  );
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.canHaveBudget = maybeNew(
    "PotentialOperation2",
    options.canHaveBudget,
    cache,
    options.hasOwnProperty("canHaveBudget"),
  );
  o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
    maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
  );
  o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
  o.featureFlags = (options.featureFlags ?? []).map((i) =>
    maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
  );
  o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
  o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
  o.contacts = (options.contacts ?? []).map((i) =>
    maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
  );
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
  o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
  o.customer = maybeNewOrNull("Customer", options.customer, cache);
  o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
  o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
  o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
  o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
  o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
  o.builder = maybeNewOrNull("Builder", options.builder, cache);
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
  o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
  o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
  o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
  o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
  o.legalDescription = options.legalDescription ?? null;
  o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
  o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
  o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
    maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
  );
  o.allocationRules = (options.allocationRules ?? []).map((i) =>
    maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
  );
  o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
  o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
    maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.directCostInCents = options.directCostInCents ?? 0;
  o.directPriceInCents = options.directPriceInCents ?? 0;
  o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
  o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.readyToStartDate = options.readyToStartDate ?? null;
  o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
  o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
  o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
  o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
  o.snapshots = (options.snapshots ?? []).map((i) =>
    maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
  );
  o.warrantyEndDate = options.warrantyEndDate ?? null;
  o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
  o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
  o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
  o.purchaseCostInCents = options.purchaseCostInCents ?? null;
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
    maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
  );
  o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
  );
  o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
  );
  o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
  );
  o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
  );
  o.isSellableProject = options.isSellableProject ?? false;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
  o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
  o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
  o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
    maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
  );
  o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
  o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
  o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
  o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
  );
  o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
  o.client = maybeNewOrNull("Client", options.client, cache);
  o.url = options.url ?? "url";
  o.projectName = options.projectName ?? "projectName";
  o.salesforceId = options.salesforceId ?? null;
  o.activeSalesforceOpportunity = maybeNewOrNull(
    "ProjectSalesforceOpportunity",
    options.activeSalesforceOpportunity,
    cache,
  );
  o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
  return o;
}

factories["Subdivision"] = newSubdivision;

export interface LotOptions {
  __typename?: "Lot";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Lot["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Lot["isFollowed"];
  id?: Lot["id"];
  buildablePlans?: Array<ProductOffering | ProductOfferingOptions>;
  buildableSfhPlans?: Array<ProductOffering | ProductOfferingOptions>;
  buildAddress?: Address | AddressOptions;
  market?: Market | MarketOptions;
  parent?: Subdivision | SubdivisionOptions;
  children?: Array<Structure | StructureOptions>;
  collaborators?: Array<ProjectCollaborator | ProjectCollaboratorOptions>;
  coverImage?: Asset | AssetOptions | null;
  teamMembers?: Array<ProjectTeamMember | ProjectTeamMemberOptions>;
  projectLead?: ProjectTeamMember | ProjectTeamMemberOptions | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: ProjectStage | ProjectStageOptions | null;
  stages?: Array<ProjectStage | ProjectStageOptions>;
  stage?: ProjectStage | ProjectStageOptions;
  blueprintUrl?: Url | UrlOptions;
  hopUrl?: Lot["hopUrl"];
  name?: Lot["name"];
  displayName?: Lot["displayName"];
  availableAssignees?: Array<InternalUser | InternalUserOptions>;
  startDate?: Lot["startDate"];
  features?: Lot["features"];
  isTest?: Lot["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Lot["latitude"];
  longitude?: Lot["longitude"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  googleDriveFolderId?: Lot["googleDriveFolderId"];
  salesforceAccountId?: Lot["salesforceAccountId"];
  salesforceOpportunities?: Array<ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions>;
  projectStatusChange?: ProjectStatusChange | ProjectStatusChangeOptions | null;
  planRoomLink?: Lot["planRoomLink"];
  isDisaster?: Lot["isDisaster"];
  intakeStyleNotes?: Lot["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: ProductType | ProductTypeOptions | null;
  enableSchedulesV2?: Lot["enableSchedulesV2"];
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  jobLogs?: Array<JobLog | JobLogOptions>;
  salesforcePropertyId?: Lot["salesforcePropertyId"];
  schedules?: Array<Schedule | ScheduleOptions>;
  expenses?: Array<Expense | ExpenseOptions>;
  unallocatedExpenses?: Array<Expense | ExpenseOptions>;
  unallocatedAmountInCents?: Lot["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Lot["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Lot["enableSchedulesCalendar"];
  readyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions | null;
  earnedValueCurves?: Array<EarnedValueCurve | EarnedValueCurveOptions>;
  enableBidPackagesV2?: Lot["enableBidPackagesV2"];
  invoiceSettings?: ProjectInvoiceSetting | ProjectInvoiceSettingOptions | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Lot["lotPartitionId"];
  budgetFinancials?: ProjectBudgetFinancials | ProjectBudgetFinancialsOptions;
  enableDelayFlags?: Lot["enableDelayFlags"];
  warrantyStartDate?: Lot["warrantyStartDate"];
  verticalCompleteDate?: Lot["verticalCompleteDate"];
  jobLogInsights?: ProjectJobLogInsights | ProjectJobLogInsightsOptions;
  targetEndDate?: Lot["targetEndDate"];
  latestActiveStage?: ProjectStage | ProjectStageOptions | null;
  primaryHomeowner?: Client | ClientOptions | null;
  toDos?: Array<ToDo | ToDoOptions> | null;
  lotDetail?: ProjectLotDetail | ProjectLotDetailOptions;
  siteSpecificInfos?: Array<ProjectSiteSpecificInfo | ProjectSiteSpecificInfoOptions>;
  projectSiteCondition?: ProjectSiteCondition | ProjectSiteConditionOptions | null;
  unassignedTaskCount?: Lot["unassignedTaskCount"];
  enableHomeownerNotes?: Lot["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Lot["checkoutCustomerConfigId"];
  canEditJobLogs?: PotentialOperation2 | PotentialOperation2Options;
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  canHaveBudget?: PotentialOperation2 | PotentialOperation2Options;
  homeownerNotes?: Array<HomeownerNote | HomeownerNoteOptions>;
  enableHomeownerJourneyV2?: Lot["enableHomeownerJourneyV2"];
  featureFlags?: Array<FeatureFlag | FeatureFlagOptions>;
  homeownerDeliveryDate?: Lot["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Lot["tasksCompletedThisWeek"];
  contacts?: Array<ProjectContact | ProjectContactOptions>;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
  shouldAccrueAsComplete?: Lot["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Lot["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Lot["indirectCostMarkupOverrideBasisPoints"];
  customer?: Customer | CustomerOptions | null;
  customerOwnerEntity?: CustomerOwnerEntity | CustomerOwnerEntityOptions | null;
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions | null;
  allowExcludedCostCodesOnPurchaseOrders?: Lot["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Lot["enableProductConfigPlan"];
  planSchedule?: PlanSchedule | PlanScheduleOptions | null;
  builder?: Builder | BuilderOptions | null;
  bidOutPercentage?: Lot["bidOutPercentage"];
  enableChangeEventSignatures?: Lot["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Lot["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Lot["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Lot["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Lot["directHardCostMarkupInBasisPoints"];
  legalDescription?: Lot["legalDescription"];
  salesTaxOverrideInBasisPoints?: Lot["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Lot["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<ProjectItemAllocation | ProjectItemAllocationOptions>;
  allocationRules?: Array<ProjectAllocationRule | ProjectAllocationRuleOptions>;
  warrantyLengthInDays?: Lot["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Lot["warrantyOverrideLengthInDays"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  bidContracts?: Array<BidContract | BidContractOptions>;
  homeownerContracts?: Array<HomeownerContract | HomeownerContractOptions>;
  documents?: Array<Document | DocumentOptions>;
  commitments?: Array<Commitment | CommitmentOptions>;
  directCostInCents?: Lot["directCostInCents"];
  directPriceInCents?: Lot["directPriceInCents"];
  totalHardCostInCents?: Lot["totalHardCostInCents"];
  totalSoftCostInCents?: Lot["totalSoftCostInCents"];
  totalCostInCents?: Lot["totalCostInCents"];
  totalPriceInCents?: Lot["totalPriceInCents"];
  readyToStartDate?: Lot["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Lot["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Lot["directCostAtStartInCents"];
  directCostVarianceInCents?: Lot["directCostVarianceInCents"];
  uncommittedCostInCents?: Lot["uncommittedCostInCents"];
  snapshots?: Array<ProjectSnapshot | ProjectSnapshotOptions>;
  warrantyEndDate?: Lot["warrantyEndDate"];
  companyInfo?: CompanyInfo | CompanyInfoOptions;
  invoicePaymentNetDays?: Lot["invoicePaymentNetDays"];
  snapshotAsOf?: ProjectSnapshot | ProjectSnapshotOptions | null;
  purchaseCostInCents?: Lot["purchaseCostInCents"];
  grossSalesPriceInCents?: Lot["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Lot["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Lot["directMarginInBasisPoints"];
  projectCostCodes?: Array<ProjectCostCode | ProjectCostCodeOptions>;
  parentsRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  childrenRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  siblingProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  sellableProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  isSellableProject?: Lot["isSellableProject"];
  originalCostInCents?: Lot["originalCostInCents"];
  startCostInCents?: Lot["startCostInCents"];
  changeEventCostInCents?: Lot["changeEventCostInCents"];
  projectedCostInCents?: Lot["projectedCostInCents"];
  revisedCostInCents?: Lot["revisedCostInCents"];
  committedCostInCents?: Lot["committedCostInCents"];
  availableCostInCents?: Lot["availableCostInCents"];
  billedCostInCents?: Lot["billedCostInCents"];
  unbilledCostInCents?: Lot["unbilledCostInCents"];
  cohort?: Cohort | CohortOptions | null;
  constructionConfidenceFactor?: Lot["constructionConfidenceFactor"];
  lotRating?: LotRating | LotRatingOptions | null;
  preConBudgetLineItems?: Array<PreConBudgetCostDivisionLineItem | PreConBudgetCostDivisionLineItemOptions>;
  preconContractType?: PreconContractType | PreconContractTypeOptions | null;
  primaryProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  quickbooksCustomerId?: Lot["quickbooksCustomerId"];
  shadowProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  submarket?: Submarket | SubmarketOptions | null;
  client?: Client | ClientOptions | null;
  url?: Lot["url"];
  projectName?: Lot["projectName"];
  salesforceId?: Lot["salesforceId"];
  activeSalesforceOpportunity?: ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions | null;
  dictionary?: ProjectDictionary | ProjectDictionaryOptions;
  landPriceInCents?: Lot["landPriceInCents"];
}

export function newLot(options: LotOptions = {}, cache: Record<string, any> = {}): Lot {
  const o = (options.__typename ? options : cache["Lot"] = {}) as Lot;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Lot";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Lot");
  o.buildablePlans = (options.buildablePlans ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("buildablePlans"))
  );
  o.buildableSfhPlans = (options.buildableSfhPlans ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("buildableSfhPlans"))
  );
  o.buildAddress = maybeNew("Address", options.buildAddress, cache, options.hasOwnProperty("buildAddress"));
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.parent = maybeNew("Subdivision", options.parent, cache, options.hasOwnProperty("parent"));
  o.children = (options.children ?? []).map((i) => maybeNew("Structure", i, cache, options.hasOwnProperty("children")));
  o.collaborators = (options.collaborators ?? []).map((i) =>
    maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
  );
  o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
  o.teamMembers = (options.teamMembers ?? []).map((i) =>
    maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
  );
  o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
  o.activeStage = enumOrDetailOfStage(options.activeStage);
  o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
  o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
  o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.hopUrl = options.hopUrl ?? "hopUrl";
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
  );
  o.startDate = options.startDate ?? newDate();
  o.features = options.features ?? [];
  o.isTest = options.isTest ?? false;
  o.status = enumOrDetailOfProjectStatus(options.status);
  o.latitude = options.latitude ?? null;
  o.longitude = options.longitude ?? null;
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.googleDriveFolderId = options.googleDriveFolderId ?? null;
  o.salesforceAccountId = options.salesforceAccountId ?? null;
  o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
    maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
  );
  o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
  o.planRoomLink = options.planRoomLink ?? null;
  o.isDisaster = options.isDisaster ?? null;
  o.intakeStyleNotes = options.intakeStyleNotes ?? null;
  o.lotType = enumOrDetailOfLotType(options.lotType);
  o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
  o.productType = maybeNewOrNull("ProductType", options.productType, cache);
  o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
  o.salesforcePropertyId = options.salesforcePropertyId ?? null;
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
  o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
    maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
  );
  o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
  o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
  o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
  o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
  o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
    maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
  );
  o.enableBidPackagesV2 = options.enableBidPackagesV2 ?? false;
  o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
  o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
  o.lotPartitionId = options.lotPartitionId ?? null;
  o.budgetFinancials = maybeNew(
    "ProjectBudgetFinancials",
    options.budgetFinancials,
    cache,
    options.hasOwnProperty("budgetFinancials"),
  );
  o.enableDelayFlags = options.enableDelayFlags ?? false;
  o.warrantyStartDate = options.warrantyStartDate ?? null;
  o.verticalCompleteDate = options.verticalCompleteDate ?? null;
  o.jobLogInsights = maybeNew(
    "ProjectJobLogInsights",
    options.jobLogInsights,
    cache,
    options.hasOwnProperty("jobLogInsights"),
  );
  o.targetEndDate = options.targetEndDate ?? null;
  o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
  o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
  o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
    maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
  );
  o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
  o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
  o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
  o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
  o.canEditJobLogs = maybeNew(
    "PotentialOperation2",
    options.canEditJobLogs,
    cache,
    options.hasOwnProperty("canEditJobLogs"),
  );
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.canHaveBudget = maybeNew(
    "PotentialOperation2",
    options.canHaveBudget,
    cache,
    options.hasOwnProperty("canHaveBudget"),
  );
  o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
    maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
  );
  o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
  o.featureFlags = (options.featureFlags ?? []).map((i) =>
    maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
  );
  o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
  o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
  o.contacts = (options.contacts ?? []).map((i) =>
    maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
  );
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
  o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
  o.customer = maybeNewOrNull("Customer", options.customer, cache);
  o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
  o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
  o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
  o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
  o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
  o.builder = maybeNewOrNull("Builder", options.builder, cache);
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
  o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
  o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
  o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
  o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
  o.legalDescription = options.legalDescription ?? null;
  o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
  o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
  o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
    maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
  );
  o.allocationRules = (options.allocationRules ?? []).map((i) =>
    maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
  );
  o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
  o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
    maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.directCostInCents = options.directCostInCents ?? 0;
  o.directPriceInCents = options.directPriceInCents ?? 0;
  o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
  o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.readyToStartDate = options.readyToStartDate ?? null;
  o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
  o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
  o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
  o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
  o.snapshots = (options.snapshots ?? []).map((i) =>
    maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
  );
  o.warrantyEndDate = options.warrantyEndDate ?? null;
  o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
  o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
  o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
  o.purchaseCostInCents = options.purchaseCostInCents ?? null;
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
    maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
  );
  o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
  );
  o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
  );
  o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
  );
  o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
  );
  o.isSellableProject = options.isSellableProject ?? false;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
  o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
  o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
  o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
    maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
  );
  o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
  o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
  o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
  o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
  );
  o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
  o.client = maybeNewOrNull("Client", options.client, cache);
  o.url = options.url ?? "url";
  o.projectName = options.projectName ?? "projectName";
  o.salesforceId = options.salesforceId ?? null;
  o.activeSalesforceOpportunity = maybeNewOrNull(
    "ProjectSalesforceOpportunity",
    options.activeSalesforceOpportunity,
    cache,
  );
  o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
  o.landPriceInCents = options.landPriceInCents ?? 0;
  return o;
}

factories["Lot"] = newLot;

export interface StructureOptions {
  __typename?: "Structure";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Structure["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Structure["isFollowed"];
  id?: Structure["id"];
  buildAddress?: Address | AddressOptions;
  market?: Market | MarketOptions;
  parent?: Lot | LotOptions;
  children?: Array<Unit | UnitOptions>;
  primaryProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  showInCheckout?: Structure["showInCheckout"];
  community?: Community | CommunityOptions;
  modelHomeHardCostsInCents?: Structure["modelHomeHardCostsInCents"];
  modelHomeSoftCostsInCents?: Structure["modelHomeSoftCostsInCents"];
  mainHouseStructure?: Structure | StructureOptions | null;
  aduStructure?: Structure | StructureOptions | null;
  isAdu?: Structure["isAdu"];
  planType?: ReadyPlanTypeDetailOptions | ReadyPlanType | null;
  hasStartedConstruction?: Structure["hasStartedConstruction"];
  isConstructionComplete?: Structure["isConstructionComplete"];
  canChangeProductOffering?: PotentialOperation2 | PotentialOperation2Options;
  collaborators?: Array<ProjectCollaborator | ProjectCollaboratorOptions>;
  coverImage?: Asset | AssetOptions | null;
  teamMembers?: Array<ProjectTeamMember | ProjectTeamMemberOptions>;
  projectLead?: ProjectTeamMember | ProjectTeamMemberOptions | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: ProjectStage | ProjectStageOptions | null;
  stages?: Array<ProjectStage | ProjectStageOptions>;
  stage?: ProjectStage | ProjectStageOptions;
  blueprintUrl?: Url | UrlOptions;
  hopUrl?: Structure["hopUrl"];
  propcoUrl?: Structure["propcoUrl"];
  name?: Structure["name"];
  displayName?: Structure["displayName"];
  availableAssignees?: Array<InternalUser | InternalUserOptions>;
  startDate?: Structure["startDate"];
  features?: Structure["features"];
  isTest?: Structure["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Structure["latitude"];
  longitude?: Structure["longitude"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  googleDriveFolderId?: Structure["googleDriveFolderId"];
  salesforceAccountId?: Structure["salesforceAccountId"];
  salesforceOpportunities?: Array<ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions>;
  projectStatusChange?: ProjectStatusChange | ProjectStatusChangeOptions | null;
  planRoomLink?: Structure["planRoomLink"];
  isDisaster?: Structure["isDisaster"];
  intakeStyleNotes?: Structure["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: ProductType | ProductTypeOptions | null;
  enableSchedulesV2?: Structure["enableSchedulesV2"];
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  jobLogs?: Array<JobLog | JobLogOptions>;
  salesforcePropertyId?: Structure["salesforcePropertyId"];
  schedules?: Array<Schedule | ScheduleOptions>;
  expenses?: Array<Expense | ExpenseOptions>;
  unallocatedExpenses?: Array<Expense | ExpenseOptions>;
  unallocatedAmountInCents?: Structure["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Structure["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Structure["enableSchedulesCalendar"];
  readyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions | null;
  earnedValueCurves?: Array<EarnedValueCurve | EarnedValueCurveOptions>;
  enableBidPackagesV2?: Structure["enableBidPackagesV2"];
  invoiceSettings?: ProjectInvoiceSetting | ProjectInvoiceSettingOptions | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Structure["lotPartitionId"];
  budgetFinancials?: ProjectBudgetFinancials | ProjectBudgetFinancialsOptions;
  enableDelayFlags?: Structure["enableDelayFlags"];
  warrantyStartDate?: Structure["warrantyStartDate"];
  verticalCompleteDate?: Structure["verticalCompleteDate"];
  jobLogInsights?: ProjectJobLogInsights | ProjectJobLogInsightsOptions;
  targetEndDate?: Structure["targetEndDate"];
  latestActiveStage?: ProjectStage | ProjectStageOptions | null;
  primaryHomeowner?: Client | ClientOptions | null;
  toDos?: Array<ToDo | ToDoOptions> | null;
  lotDetail?: ProjectLotDetail | ProjectLotDetailOptions;
  siteSpecificInfos?: Array<ProjectSiteSpecificInfo | ProjectSiteSpecificInfoOptions>;
  projectSiteCondition?: ProjectSiteCondition | ProjectSiteConditionOptions | null;
  unassignedTaskCount?: Structure["unassignedTaskCount"];
  enableHomeownerNotes?: Structure["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Structure["checkoutCustomerConfigId"];
  canEditJobLogs?: PotentialOperation2 | PotentialOperation2Options;
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  canHaveBudget?: PotentialOperation2 | PotentialOperation2Options;
  homeownerNotes?: Array<HomeownerNote | HomeownerNoteOptions>;
  enableHomeownerJourneyV2?: Structure["enableHomeownerJourneyV2"];
  featureFlags?: Array<FeatureFlag | FeatureFlagOptions>;
  homeownerDeliveryDate?: Structure["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Structure["tasksCompletedThisWeek"];
  contacts?: Array<ProjectContact | ProjectContactOptions>;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
  shouldAccrueAsComplete?: Structure["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Structure["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Structure["indirectCostMarkupOverrideBasisPoints"];
  customer?: Customer | CustomerOptions | null;
  customerOwnerEntity?: CustomerOwnerEntity | CustomerOwnerEntityOptions | null;
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions | null;
  allowExcludedCostCodesOnPurchaseOrders?: Structure["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Structure["enableProductConfigPlan"];
  planSchedule?: PlanSchedule | PlanScheduleOptions | null;
  builder?: Builder | BuilderOptions | null;
  bidOutPercentage?: Structure["bidOutPercentage"];
  enableChangeEventSignatures?: Structure["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Structure["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Structure["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Structure["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Structure["directHardCostMarkupInBasisPoints"];
  legalDescription?: Structure["legalDescription"];
  salesTaxOverrideInBasisPoints?: Structure["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Structure["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<ProjectItemAllocation | ProjectItemAllocationOptions>;
  allocationRules?: Array<ProjectAllocationRule | ProjectAllocationRuleOptions>;
  warrantyLengthInDays?: Structure["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Structure["warrantyOverrideLengthInDays"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  bidContracts?: Array<BidContract | BidContractOptions>;
  homeownerContracts?: Array<HomeownerContract | HomeownerContractOptions>;
  documents?: Array<Document | DocumentOptions>;
  commitments?: Array<Commitment | CommitmentOptions>;
  directCostInCents?: Structure["directCostInCents"];
  directPriceInCents?: Structure["directPriceInCents"];
  totalHardCostInCents?: Structure["totalHardCostInCents"];
  totalSoftCostInCents?: Structure["totalSoftCostInCents"];
  totalCostInCents?: Structure["totalCostInCents"];
  totalPriceInCents?: Structure["totalPriceInCents"];
  readyToStartDate?: Structure["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Structure["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Structure["directCostAtStartInCents"];
  directCostVarianceInCents?: Structure["directCostVarianceInCents"];
  uncommittedCostInCents?: Structure["uncommittedCostInCents"];
  snapshots?: Array<ProjectSnapshot | ProjectSnapshotOptions>;
  warrantyEndDate?: Structure["warrantyEndDate"];
  companyInfo?: CompanyInfo | CompanyInfoOptions;
  invoicePaymentNetDays?: Structure["invoicePaymentNetDays"];
  snapshotAsOf?: ProjectSnapshot | ProjectSnapshotOptions | null;
  purchaseCostInCents?: Structure["purchaseCostInCents"];
  grossSalesPriceInCents?: Structure["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Structure["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Structure["directMarginInBasisPoints"];
  projectCostCodes?: Array<ProjectCostCode | ProjectCostCodeOptions>;
  parentsRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  childrenRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  siblingProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  sellableProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  isSellableProject?: Structure["isSellableProject"];
  originalCostInCents?: Structure["originalCostInCents"];
  startCostInCents?: Structure["startCostInCents"];
  changeEventCostInCents?: Structure["changeEventCostInCents"];
  projectedCostInCents?: Structure["projectedCostInCents"];
  revisedCostInCents?: Structure["revisedCostInCents"];
  committedCostInCents?: Structure["committedCostInCents"];
  availableCostInCents?: Structure["availableCostInCents"];
  billedCostInCents?: Structure["billedCostInCents"];
  unbilledCostInCents?: Structure["unbilledCostInCents"];
  cohort?: Cohort | CohortOptions | null;
  constructionConfidenceFactor?: Structure["constructionConfidenceFactor"];
  lotRating?: LotRating | LotRatingOptions | null;
  preConBudgetLineItems?: Array<PreConBudgetCostDivisionLineItem | PreConBudgetCostDivisionLineItemOptions>;
  preconContractType?: PreconContractType | PreconContractTypeOptions | null;
  quickbooksCustomerId?: Structure["quickbooksCustomerId"];
  shadowProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  submarket?: Submarket | SubmarketOptions | null;
  client?: Client | ClientOptions | null;
  url?: Structure["url"];
  projectName?: Structure["projectName"];
  salesforceId?: Structure["salesforceId"];
  activeSalesforceOpportunity?: ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions | null;
  dictionary?: ProjectDictionary | ProjectDictionaryOptions;
  suburbanAssetCategory?: SuburbanAssetCategoryDetailOptions | SuburbanAssetCategory | null;
  lotSalesStatus?: LotSalesStatusDetailOptions | LotSalesStatus | null;
}

export function newStructure(options: StructureOptions = {}, cache: Record<string, any> = {}): Structure {
  const o = (options.__typename ? options : cache["Structure"] = {}) as Structure;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Structure";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Structure");
  o.buildAddress = maybeNew("Address", options.buildAddress, cache, options.hasOwnProperty("buildAddress"));
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.parent = maybeNew("Lot", options.parent, cache, options.hasOwnProperty("parent"));
  o.children = (options.children ?? []).map((i) => maybeNew("Unit", i, cache, options.hasOwnProperty("children")));
  o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
  o.showInCheckout = options.showInCheckout ?? false;
  o.community = maybeNew("Community", options.community, cache, options.hasOwnProperty("community"));
  o.modelHomeHardCostsInCents = options.modelHomeHardCostsInCents ?? 0;
  o.modelHomeSoftCostsInCents = options.modelHomeSoftCostsInCents ?? 0;
  o.mainHouseStructure = maybeNewOrNull("Structure", options.mainHouseStructure, cache);
  o.aduStructure = maybeNewOrNull("Structure", options.aduStructure, cache);
  o.isAdu = options.isAdu ?? false;
  o.planType = enumOrDetailOrNullOfReadyPlanType(options.planType);
  o.hasStartedConstruction = options.hasStartedConstruction ?? false;
  o.isConstructionComplete = options.isConstructionComplete ?? false;
  o.canChangeProductOffering = maybeNew(
    "PotentialOperation2",
    options.canChangeProductOffering,
    cache,
    options.hasOwnProperty("canChangeProductOffering"),
  );
  o.collaborators = (options.collaborators ?? []).map((i) =>
    maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
  );
  o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
  o.teamMembers = (options.teamMembers ?? []).map((i) =>
    maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
  );
  o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
  o.activeStage = enumOrDetailOfStage(options.activeStage);
  o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
  o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
  o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.hopUrl = options.hopUrl ?? "hopUrl";
  o.propcoUrl = options.propcoUrl ?? null;
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
  );
  o.startDate = options.startDate ?? newDate();
  o.features = options.features ?? [];
  o.isTest = options.isTest ?? false;
  o.status = enumOrDetailOfProjectStatus(options.status);
  o.latitude = options.latitude ?? null;
  o.longitude = options.longitude ?? null;
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.googleDriveFolderId = options.googleDriveFolderId ?? null;
  o.salesforceAccountId = options.salesforceAccountId ?? null;
  o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
    maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
  );
  o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
  o.planRoomLink = options.planRoomLink ?? null;
  o.isDisaster = options.isDisaster ?? null;
  o.intakeStyleNotes = options.intakeStyleNotes ?? null;
  o.lotType = enumOrDetailOfLotType(options.lotType);
  o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
  o.productType = maybeNewOrNull("ProductType", options.productType, cache);
  o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
  o.salesforcePropertyId = options.salesforcePropertyId ?? null;
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
  o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
    maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
  );
  o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
  o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
  o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
  o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
  o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
    maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
  );
  o.enableBidPackagesV2 = options.enableBidPackagesV2 ?? false;
  o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
  o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
  o.lotPartitionId = options.lotPartitionId ?? null;
  o.budgetFinancials = maybeNew(
    "ProjectBudgetFinancials",
    options.budgetFinancials,
    cache,
    options.hasOwnProperty("budgetFinancials"),
  );
  o.enableDelayFlags = options.enableDelayFlags ?? false;
  o.warrantyStartDate = options.warrantyStartDate ?? null;
  o.verticalCompleteDate = options.verticalCompleteDate ?? null;
  o.jobLogInsights = maybeNew(
    "ProjectJobLogInsights",
    options.jobLogInsights,
    cache,
    options.hasOwnProperty("jobLogInsights"),
  );
  o.targetEndDate = options.targetEndDate ?? null;
  o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
  o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
  o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
    maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
  );
  o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
  o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
  o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
  o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
  o.canEditJobLogs = maybeNew(
    "PotentialOperation2",
    options.canEditJobLogs,
    cache,
    options.hasOwnProperty("canEditJobLogs"),
  );
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.canHaveBudget = maybeNew(
    "PotentialOperation2",
    options.canHaveBudget,
    cache,
    options.hasOwnProperty("canHaveBudget"),
  );
  o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
    maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
  );
  o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
  o.featureFlags = (options.featureFlags ?? []).map((i) =>
    maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
  );
  o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
  o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
  o.contacts = (options.contacts ?? []).map((i) =>
    maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
  );
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
  o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
  o.customer = maybeNewOrNull("Customer", options.customer, cache);
  o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
  o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
  o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
  o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
  o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
  o.builder = maybeNewOrNull("Builder", options.builder, cache);
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
  o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
  o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
  o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
  o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
  o.legalDescription = options.legalDescription ?? null;
  o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
  o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
  o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
    maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
  );
  o.allocationRules = (options.allocationRules ?? []).map((i) =>
    maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
  );
  o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
  o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
    maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.directCostInCents = options.directCostInCents ?? 0;
  o.directPriceInCents = options.directPriceInCents ?? 0;
  o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
  o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.readyToStartDate = options.readyToStartDate ?? null;
  o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
  o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
  o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
  o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
  o.snapshots = (options.snapshots ?? []).map((i) =>
    maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
  );
  o.warrantyEndDate = options.warrantyEndDate ?? null;
  o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
  o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
  o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
  o.purchaseCostInCents = options.purchaseCostInCents ?? null;
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
    maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
  );
  o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
  );
  o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
  );
  o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
  );
  o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
  );
  o.isSellableProject = options.isSellableProject ?? false;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
  o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
  o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
  o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
    maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
  );
  o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
  o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
  o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
  );
  o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
  o.client = maybeNewOrNull("Client", options.client, cache);
  o.url = options.url ?? "url";
  o.projectName = options.projectName ?? "projectName";
  o.salesforceId = options.salesforceId ?? null;
  o.activeSalesforceOpportunity = maybeNewOrNull(
    "ProjectSalesforceOpportunity",
    options.activeSalesforceOpportunity,
    cache,
  );
  o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
  o.suburbanAssetCategory = enumOrDetailOrNullOfSuburbanAssetCategory(options.suburbanAssetCategory);
  o.lotSalesStatus = enumOrDetailOrNullOfLotSalesStatus(options.lotSalesStatus);
  return o;
}

factories["Structure"] = newStructure;

export interface UnitOptions {
  __typename?: "Unit";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Unit["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Unit["isFollowed"];
  id?: Unit["id"];
  buildAddress?: Address | AddressOptions;
  market?: Market | MarketOptions;
  parent?: Structure | StructureOptions;
  collaborators?: Array<ProjectCollaborator | ProjectCollaboratorOptions>;
  coverImage?: Asset | AssetOptions | null;
  teamMembers?: Array<ProjectTeamMember | ProjectTeamMemberOptions>;
  projectLead?: ProjectTeamMember | ProjectTeamMemberOptions | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: ProjectStage | ProjectStageOptions | null;
  stages?: Array<ProjectStage | ProjectStageOptions>;
  stage?: ProjectStage | ProjectStageOptions;
  blueprintUrl?: Url | UrlOptions;
  hopUrl?: Unit["hopUrl"];
  name?: Unit["name"];
  displayName?: Unit["displayName"];
  availableAssignees?: Array<InternalUser | InternalUserOptions>;
  startDate?: Unit["startDate"];
  features?: Unit["features"];
  isTest?: Unit["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Unit["latitude"];
  longitude?: Unit["longitude"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  googleDriveFolderId?: Unit["googleDriveFolderId"];
  salesforceAccountId?: Unit["salesforceAccountId"];
  salesforceOpportunities?: Array<ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions>;
  projectStatusChange?: ProjectStatusChange | ProjectStatusChangeOptions | null;
  planRoomLink?: Unit["planRoomLink"];
  isDisaster?: Unit["isDisaster"];
  intakeStyleNotes?: Unit["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: ProductType | ProductTypeOptions | null;
  enableSchedulesV2?: Unit["enableSchedulesV2"];
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  jobLogs?: Array<JobLog | JobLogOptions>;
  salesforcePropertyId?: Unit["salesforcePropertyId"];
  schedules?: Array<Schedule | ScheduleOptions>;
  expenses?: Array<Expense | ExpenseOptions>;
  unallocatedExpenses?: Array<Expense | ExpenseOptions>;
  unallocatedAmountInCents?: Unit["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Unit["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Unit["enableSchedulesCalendar"];
  readyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions | null;
  earnedValueCurves?: Array<EarnedValueCurve | EarnedValueCurveOptions>;
  enableBidPackagesV2?: Unit["enableBidPackagesV2"];
  invoiceSettings?: ProjectInvoiceSetting | ProjectInvoiceSettingOptions | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Unit["lotPartitionId"];
  budgetFinancials?: ProjectBudgetFinancials | ProjectBudgetFinancialsOptions;
  enableDelayFlags?: Unit["enableDelayFlags"];
  warrantyStartDate?: Unit["warrantyStartDate"];
  verticalCompleteDate?: Unit["verticalCompleteDate"];
  jobLogInsights?: ProjectJobLogInsights | ProjectJobLogInsightsOptions;
  targetEndDate?: Unit["targetEndDate"];
  latestActiveStage?: ProjectStage | ProjectStageOptions | null;
  primaryHomeowner?: Client | ClientOptions | null;
  toDos?: Array<ToDo | ToDoOptions> | null;
  lotDetail?: ProjectLotDetail | ProjectLotDetailOptions;
  siteSpecificInfos?: Array<ProjectSiteSpecificInfo | ProjectSiteSpecificInfoOptions>;
  projectSiteCondition?: ProjectSiteCondition | ProjectSiteConditionOptions | null;
  unassignedTaskCount?: Unit["unassignedTaskCount"];
  enableHomeownerNotes?: Unit["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Unit["checkoutCustomerConfigId"];
  canEditJobLogs?: PotentialOperation2 | PotentialOperation2Options;
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  canHaveBudget?: PotentialOperation2 | PotentialOperation2Options;
  homeownerNotes?: Array<HomeownerNote | HomeownerNoteOptions>;
  enableHomeownerJourneyV2?: Unit["enableHomeownerJourneyV2"];
  featureFlags?: Array<FeatureFlag | FeatureFlagOptions>;
  homeownerDeliveryDate?: Unit["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Unit["tasksCompletedThisWeek"];
  contacts?: Array<ProjectContact | ProjectContactOptions>;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
  shouldAccrueAsComplete?: Unit["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Unit["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Unit["indirectCostMarkupOverrideBasisPoints"];
  customer?: Customer | CustomerOptions | null;
  customerOwnerEntity?: CustomerOwnerEntity | CustomerOwnerEntityOptions | null;
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions | null;
  allowExcludedCostCodesOnPurchaseOrders?: Unit["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Unit["enableProductConfigPlan"];
  planSchedule?: PlanSchedule | PlanScheduleOptions | null;
  builder?: Builder | BuilderOptions | null;
  bidOutPercentage?: Unit["bidOutPercentage"];
  enableChangeEventSignatures?: Unit["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Unit["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Unit["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Unit["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Unit["directHardCostMarkupInBasisPoints"];
  legalDescription?: Unit["legalDescription"];
  salesTaxOverrideInBasisPoints?: Unit["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Unit["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<ProjectItemAllocation | ProjectItemAllocationOptions>;
  allocationRules?: Array<ProjectAllocationRule | ProjectAllocationRuleOptions>;
  warrantyLengthInDays?: Unit["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Unit["warrantyOverrideLengthInDays"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  bidContracts?: Array<BidContract | BidContractOptions>;
  homeownerContracts?: Array<HomeownerContract | HomeownerContractOptions>;
  documents?: Array<Document | DocumentOptions>;
  commitments?: Array<Commitment | CommitmentOptions>;
  directCostInCents?: Unit["directCostInCents"];
  directPriceInCents?: Unit["directPriceInCents"];
  totalHardCostInCents?: Unit["totalHardCostInCents"];
  totalSoftCostInCents?: Unit["totalSoftCostInCents"];
  totalCostInCents?: Unit["totalCostInCents"];
  totalPriceInCents?: Unit["totalPriceInCents"];
  readyToStartDate?: Unit["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Unit["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Unit["directCostAtStartInCents"];
  directCostVarianceInCents?: Unit["directCostVarianceInCents"];
  uncommittedCostInCents?: Unit["uncommittedCostInCents"];
  snapshots?: Array<ProjectSnapshot | ProjectSnapshotOptions>;
  warrantyEndDate?: Unit["warrantyEndDate"];
  companyInfo?: CompanyInfo | CompanyInfoOptions;
  invoicePaymentNetDays?: Unit["invoicePaymentNetDays"];
  snapshotAsOf?: ProjectSnapshot | ProjectSnapshotOptions | null;
  purchaseCostInCents?: Unit["purchaseCostInCents"];
  grossSalesPriceInCents?: Unit["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Unit["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Unit["directMarginInBasisPoints"];
  projectCostCodes?: Array<ProjectCostCode | ProjectCostCodeOptions>;
  children?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  parentsRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  childrenRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  siblingProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  sellableProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  isSellableProject?: Unit["isSellableProject"];
  originalCostInCents?: Unit["originalCostInCents"];
  startCostInCents?: Unit["startCostInCents"];
  changeEventCostInCents?: Unit["changeEventCostInCents"];
  projectedCostInCents?: Unit["projectedCostInCents"];
  revisedCostInCents?: Unit["revisedCostInCents"];
  committedCostInCents?: Unit["committedCostInCents"];
  availableCostInCents?: Unit["availableCostInCents"];
  billedCostInCents?: Unit["billedCostInCents"];
  unbilledCostInCents?: Unit["unbilledCostInCents"];
  cohort?: Cohort | CohortOptions | null;
  constructionConfidenceFactor?: Unit["constructionConfidenceFactor"];
  lotRating?: LotRating | LotRatingOptions | null;
  preConBudgetLineItems?: Array<PreConBudgetCostDivisionLineItem | PreConBudgetCostDivisionLineItemOptions>;
  preconContractType?: PreconContractType | PreconContractTypeOptions | null;
  primaryProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  quickbooksCustomerId?: Unit["quickbooksCustomerId"];
  shadowProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  submarket?: Submarket | SubmarketOptions | null;
  client?: Client | ClientOptions | null;
  url?: Unit["url"];
  projectName?: Unit["projectName"];
  salesforceId?: Unit["salesforceId"];
  activeSalesforceOpportunity?: ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions | null;
  dictionary?: ProjectDictionary | ProjectDictionaryOptions;
}

export function newUnit(options: UnitOptions = {}, cache: Record<string, any> = {}): Unit {
  const o = (options.__typename ? options : cache["Unit"] = {}) as Unit;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Unit";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Unit");
  o.buildAddress = maybeNew("Address", options.buildAddress, cache, options.hasOwnProperty("buildAddress"));
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.parent = maybeNew("Structure", options.parent, cache, options.hasOwnProperty("parent"));
  o.collaborators = (options.collaborators ?? []).map((i) =>
    maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
  );
  o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
  o.teamMembers = (options.teamMembers ?? []).map((i) =>
    maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
  );
  o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
  o.activeStage = enumOrDetailOfStage(options.activeStage);
  o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
  o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
  o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.hopUrl = options.hopUrl ?? "hopUrl";
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
  );
  o.startDate = options.startDate ?? newDate();
  o.features = options.features ?? [];
  o.isTest = options.isTest ?? false;
  o.status = enumOrDetailOfProjectStatus(options.status);
  o.latitude = options.latitude ?? null;
  o.longitude = options.longitude ?? null;
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.googleDriveFolderId = options.googleDriveFolderId ?? null;
  o.salesforceAccountId = options.salesforceAccountId ?? null;
  o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
    maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
  );
  o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
  o.planRoomLink = options.planRoomLink ?? null;
  o.isDisaster = options.isDisaster ?? null;
  o.intakeStyleNotes = options.intakeStyleNotes ?? null;
  o.lotType = enumOrDetailOfLotType(options.lotType);
  o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
  o.productType = maybeNewOrNull("ProductType", options.productType, cache);
  o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
  o.salesforcePropertyId = options.salesforcePropertyId ?? null;
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
  o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
    maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
  );
  o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
  o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
  o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
  o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
  o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
    maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
  );
  o.enableBidPackagesV2 = options.enableBidPackagesV2 ?? false;
  o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
  o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
  o.lotPartitionId = options.lotPartitionId ?? null;
  o.budgetFinancials = maybeNew(
    "ProjectBudgetFinancials",
    options.budgetFinancials,
    cache,
    options.hasOwnProperty("budgetFinancials"),
  );
  o.enableDelayFlags = options.enableDelayFlags ?? false;
  o.warrantyStartDate = options.warrantyStartDate ?? null;
  o.verticalCompleteDate = options.verticalCompleteDate ?? null;
  o.jobLogInsights = maybeNew(
    "ProjectJobLogInsights",
    options.jobLogInsights,
    cache,
    options.hasOwnProperty("jobLogInsights"),
  );
  o.targetEndDate = options.targetEndDate ?? null;
  o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
  o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
  o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
    maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
  );
  o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
  o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
  o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
  o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
  o.canEditJobLogs = maybeNew(
    "PotentialOperation2",
    options.canEditJobLogs,
    cache,
    options.hasOwnProperty("canEditJobLogs"),
  );
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.canHaveBudget = maybeNew(
    "PotentialOperation2",
    options.canHaveBudget,
    cache,
    options.hasOwnProperty("canHaveBudget"),
  );
  o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
    maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
  );
  o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
  o.featureFlags = (options.featureFlags ?? []).map((i) =>
    maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
  );
  o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
  o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
  o.contacts = (options.contacts ?? []).map((i) =>
    maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
  );
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
  o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
  o.customer = maybeNewOrNull("Customer", options.customer, cache);
  o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
  o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
  o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
  o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
  o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
  o.builder = maybeNewOrNull("Builder", options.builder, cache);
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
  o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
  o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
  o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
  o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
  o.legalDescription = options.legalDescription ?? null;
  o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
  o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
  o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
    maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
  );
  o.allocationRules = (options.allocationRules ?? []).map((i) =>
    maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
  );
  o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
  o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
    maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.directCostInCents = options.directCostInCents ?? 0;
  o.directPriceInCents = options.directPriceInCents ?? 0;
  o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
  o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.readyToStartDate = options.readyToStartDate ?? null;
  o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
  o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
  o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
  o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
  o.snapshots = (options.snapshots ?? []).map((i) =>
    maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
  );
  o.warrantyEndDate = options.warrantyEndDate ?? null;
  o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
  o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
  o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
  o.purchaseCostInCents = options.purchaseCostInCents ?? null;
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
    maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
  );
  o.children = (options.children ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("children")));
  o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
  );
  o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
  );
  o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
  );
  o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
  );
  o.isSellableProject = options.isSellableProject ?? false;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
  o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
  o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
  o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
    maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
  );
  o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
  o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
  o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
  o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
  );
  o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
  o.client = maybeNewOrNull("Client", options.client, cache);
  o.url = options.url ?? "url";
  o.projectName = options.projectName ?? "projectName";
  o.salesforceId = options.salesforceId ?? null;
  o.activeSalesforceOpportunity = maybeNewOrNull(
    "ProjectSalesforceOpportunity",
    options.activeSalesforceOpportunity,
    cache,
  );
  o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
  return o;
}

factories["Unit"] = newUnit;

export interface ProjectItemOptions {
  __typename?: "ProjectItem";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ProjectItem["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ProjectItem["isFollowed"];
  id?: ProjectItem["id"];
  projectStage?: ProjectStage | ProjectStageOptions;
  slot?: ItemSlot | ItemSlotOptions;
  item?: Item | ItemOptions;
  name?: ProjectItem["name"];
  description?: ProjectItem["description"];
  markupInCents?: ProjectItem["markupInCents"];
  priceInCents?: ProjectItem["priceInCents"];
  costInCents?: ProjectItem["costInCents"];
  unitCostInCents?: ProjectItem["unitCostInCents"];
  unitPriceInCents?: ProjectItem["unitPriceInCents"];
  totalCostInCents?: ProjectItem["totalCostInCents"];
  totalPriceInCents?: ProjectItem["totalPriceInCents"];
  totalMarkupInCents?: ProjectItem["totalMarkupInCents"];
  markupBasisPoints?: ProjectItem["markupBasisPoints"];
  projectMarkupBasisPoints?: ProjectItem["projectMarkupBasisPoints"];
  quantity?: ProjectItem["quantity"];
  location?: Location | LocationOptions;
  quantityCalculated?: ProjectItem["quantityCalculated"];
  billedBills?: Array<Bill | BillOptions>;
  bills?: Array<Bill | BillOptions>;
  displayName?: ProjectItem["displayName"];
  billLineItems?: Array<BillLineItem | BillLineItemOptions>;
  commitmentLineItems?: Array<CommitmentLineItem | CommitmentLineItemOptions>;
  signedCommitmentLineItems?: Array<CommitmentLineItem | CommitmentLineItemOptions>;
  totalCommittedCostInCents?: ProjectItem["totalCommittedCostInCents"];
  allCommittedCostInCents?: ProjectItem["allCommittedCostInCents"];
  costType?: ProjectItem["costType"];
  costTypeDetail?: CostTypeDetailOptions | CostType;
  estimateLineItems?: Array<EstimateLineItem | EstimateLineItemOptions>;
  blueprintUrl?: Url | UrlOptions;
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  homeownerPaidInCents?: ProjectItem["homeownerPaidInCents"];
  tradePartnerNote?: ProjectItem["tradePartnerNote"];
  specifications?: ProjectItem["specifications"];
  history?: Array<History | HistoryOptions>;
  changeEventLineItems?: Array<ChangeEventLineItem | ChangeEventLineItemOptions>;
  isPendingChangeEvent?: ProjectItem["isPendingChangeEvent"];
  internalNote?: ProjectItem["internalNote"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  costConfidence?: CostConfidenceDetailOptions | CostConfidence;
  buyoutStatus?: ProjectItem["buyoutStatus"];
  buyoutStatusDetail?: BuyoutStatusDetailOptions | BuyoutStatus;
  canEditCost?: PotentialOperation2 | PotentialOperation2Options;
  protoCommitmentLineItemToBuyout?: ProtoCommitmentLineItemToBuyout | ProtoCommitmentLineItemToBuyoutOptions | null;
  scopeHistory?: Array<ProjectItemScopeChange | ProjectItemScopeChangeOptions>;
  canEditScope?: PotentialOperation2 | PotentialOperation2Options;
  canEditName?: PotentialOperation2 | PotentialOperation2Options;
  canEditCostConfidence?: PotentialOperation2 | PotentialOperation2Options;
  canEditBuyoutStatus?: PotentialOperation2 | PotentialOperation2Options;
  itemTemplateItem?:
    | ItemTemplateItemVersion
    | ItemTemplateItem
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | BaseItemLike
    | BaseItemLikeOptions
    | null;
  modifyingTemplateItems?: Array<
    | ItemTemplateItemVersion
    | ItemTemplateItem
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | BaseItemLike
    | BaseItemLikeOptions
  >;
  task?: Task | TaskOptions | null;
  currentTradePartner?: TradePartner | TradePartnerOptions | null;
  currentCommitment?: Commitment | CommitmentChangeOrder | CommitmentLike | CommitmentLikeOptions | null;
  originalBudgetInCents?: ProjectItem["originalBudgetInCents"];
  originalPriceInCents?: ProjectItem["originalPriceInCents"];
  contractBudgetChangesInCents?: ProjectItem["contractBudgetChangesInCents"];
  budgetReallocationsInCents?: ProjectItem["budgetReallocationsInCents"];
  revisedApprovedBudgetInCents?: ProjectItem["revisedApprovedBudgetInCents"];
  uncommittedBudgetAmountInCents?: ProjectItem["uncommittedBudgetAmountInCents"];
  unbilledCommittedInCents?: ProjectItem["unbilledCommittedInCents"];
  actualCostInCents?: ProjectItem["actualCostInCents"];
  costToCompleteInCents?: ProjectItem["costToCompleteInCents"];
  homeownerContractLineItems?: Array<HomeownerContractLineItem | HomeownerContractLineItemOptions>;
  internalBudgetChangeInCents?: ProjectItem["internalBudgetChangeInCents"];
  bidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  probableBidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  potentialBidContractLineItems?: Array<PotentialBidContractLineItem | PotentialBidContractLineItemOptions>;
  preferredPotentialBidContractLineItem?: PotentialBidContractLineItem | PotentialBidContractLineItemOptions | null;
  isFromReadyHomeTemplate?: ProjectItem["isFromReadyHomeTemplate"];
  isRemovedScope?: ProjectItem["isRemovedScope"];
  expenseAllocations?: Array<ExpenseAllocation | ExpenseAllocationOptions>;
  budgetRollupInCents?: BudgetPhaseRollup | BudgetPhaseRollupOptions;
  prebidBudgetChangeInCents?: ProjectItem["prebidBudgetChangeInCents"];
  awardedBudgetChangeInCents?: ProjectItem["awardedBudgetChangeInCents"];
  revisedBudgetChangeInCents?: ProjectItem["revisedBudgetChangeInCents"];
  costLineItems?: Array<CostLineItem | CostLineItemOptions>;
  workAuthorizations?: Array<WorkAuthorization | WorkAuthorizationOptions>;
  bidItem?: BidItem | BidItemOptions | null;
  externalBudgetChangeInCents?: ProjectItem["externalBudgetChangeInCents"];
  budgetFinancials?: ProjectItemBudgetFinancials | ProjectItemBudgetFinancialsOptions;
  tradePartnerPaidInCents?: ProjectItem["tradePartnerPaidInCents"];
  tradeBilledInCents?: ProjectItem["tradeBilledInCents"];
  canAssignBidContractLineItem?: PotentialOperation2 | PotentialOperation2Options;
  currentPriceInCents?: ProjectItem["currentPriceInCents"];
  allocationReason?: ProjectItem["allocationReason"];
  configuredOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  baseOrOptionName?: ProjectItem["baseOrOptionName"];
  materialVariant?: MaterialVariant | MaterialVariantOptions | null;
  lastAcceptedChangeEventLineItem?: ChangeEventLineItem | ChangeEventLineItemOptions | null;
  allocations?: Array<ProjectItemAllocation | ProjectItemAllocationOptions>;
  directCostAtStartInCents?: ProjectItem["directCostAtStartInCents"];
  directCostVarianceInCents?: ProjectItem["directCostVarianceInCents"];
  projectCostCode?: ProjectCostCode | ProjectCostCodeOptions;
  originalCostInCents?: ProjectItem["originalCostInCents"];
  startCostInCents?: ProjectItem["startCostInCents"];
  changeEventCostInCents?: ProjectItem["changeEventCostInCents"];
  revisedCostInCents?: ProjectItem["revisedCostInCents"];
  revisedPriceInCents?: ProjectItem["revisedPriceInCents"];
  projectedCostInCents?: ProjectItem["projectedCostInCents"];
  committedCostInCents?: ProjectItem["committedCostInCents"];
  availableCostInCents?: ProjectItem["availableCostInCents"];
  billedCostInCents?: ProjectItem["billedCostInCents"];
  unbilledCostInCents?: ProjectItem["unbilledCostInCents"];
  bidTask?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  packageDesignNotes?: ProjectItem["packageDesignNotes"];
}

export function newProjectItem(options: ProjectItemOptions = {}, cache: Record<string, any> = {}): ProjectItem {
  const o = (options.__typename ? options : cache["ProjectItem"] = {}) as ProjectItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectItem";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("ProjectItem");
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.markupInCents = options.markupInCents ?? 0;
  o.priceInCents = options.priceInCents ?? 0;
  o.costInCents = options.costInCents ?? 0;
  o.unitCostInCents = options.unitCostInCents ?? 0;
  o.unitPriceInCents = options.unitPriceInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.totalMarkupInCents = options.totalMarkupInCents ?? 0;
  o.markupBasisPoints = options.markupBasisPoints ?? null;
  o.projectMarkupBasisPoints = options.projectMarkupBasisPoints ?? 0;
  o.quantity = options.quantity ?? null;
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.quantityCalculated = options.quantityCalculated ?? null;
  o.billedBills = (options.billedBills ?? []).map((i) =>
    maybeNew("Bill", i, cache, options.hasOwnProperty("billedBills"))
  );
  o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
  o.displayName = options.displayName ?? "displayName";
  o.billLineItems = (options.billLineItems ?? []).map((i) =>
    maybeNew("BillLineItem", i, cache, options.hasOwnProperty("billLineItems"))
  );
  o.commitmentLineItems = (options.commitmentLineItems ?? []).map((i) =>
    maybeNew("CommitmentLineItem", i, cache, options.hasOwnProperty("commitmentLineItems"))
  );
  o.signedCommitmentLineItems = (options.signedCommitmentLineItems ?? []).map((i) =>
    maybeNew("CommitmentLineItem", i, cache, options.hasOwnProperty("signedCommitmentLineItems"))
  );
  o.totalCommittedCostInCents = options.totalCommittedCostInCents ?? 0;
  o.allCommittedCostInCents = options.allCommittedCostInCents ?? 0;
  o.costType = options.costType ?? CostType.Labor;
  o.costTypeDetail = enumOrDetailOfCostType(options.costTypeDetail);
  o.estimateLineItems = (options.estimateLineItems ?? []).map((i) =>
    maybeNew("EstimateLineItem", i, cache, options.hasOwnProperty("estimateLineItems"))
  );
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.homeownerPaidInCents = options.homeownerPaidInCents ?? null;
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.specifications = options.specifications ?? null;
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.changeEventLineItems = (options.changeEventLineItems ?? []).map((i) =>
    maybeNew("ChangeEventLineItem", i, cache, options.hasOwnProperty("changeEventLineItems"))
  );
  o.isPendingChangeEvent = options.isPendingChangeEvent ?? false;
  o.internalNote = options.internalNote ?? null;
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.costConfidence = enumOrDetailOfCostConfidence(options.costConfidence);
  o.buyoutStatus = options.buyoutStatus ?? BuyoutStatus.NotBoughtOut;
  o.buyoutStatusDetail = enumOrDetailOfBuyoutStatus(options.buyoutStatusDetail);
  o.canEditCost = maybeNew("PotentialOperation2", options.canEditCost, cache, options.hasOwnProperty("canEditCost"));
  o.protoCommitmentLineItemToBuyout = maybeNewOrNull(
    "ProtoCommitmentLineItemToBuyout",
    options.protoCommitmentLineItemToBuyout,
    cache,
  );
  o.scopeHistory = (options.scopeHistory ?? []).map((i) =>
    maybeNew("ProjectItemScopeChange", i, cache, options.hasOwnProperty("scopeHistory"))
  );
  o.canEditScope = maybeNew("PotentialOperation2", options.canEditScope, cache, options.hasOwnProperty("canEditScope"));
  o.canEditName = maybeNew("PotentialOperation2", options.canEditName, cache, options.hasOwnProperty("canEditName"));
  o.canEditCostConfidence = maybeNew(
    "PotentialOperation2",
    options.canEditCostConfidence,
    cache,
    options.hasOwnProperty("canEditCostConfidence"),
  );
  o.canEditBuyoutStatus = maybeNew(
    "PotentialOperation2",
    options.canEditBuyoutStatus,
    cache,
    options.hasOwnProperty("canEditBuyoutStatus"),
  );
  o.itemTemplateItem = maybeNewOrNull("BaseItemLike", options.itemTemplateItem, cache);
  o.modifyingTemplateItems = (options.modifyingTemplateItems ?? []).map((i) =>
    maybeNew("BaseItemLike", i, cache, options.hasOwnProperty("modifyingTemplateItems"))
  );
  o.task = maybeNewOrNull("Task", options.task, cache);
  o.currentTradePartner = maybeNewOrNull("TradePartner", options.currentTradePartner, cache);
  o.currentCommitment = maybeNewOrNull("CommitmentLike", options.currentCommitment, cache);
  o.originalBudgetInCents = options.originalBudgetInCents ?? 0;
  o.originalPriceInCents = options.originalPriceInCents ?? 0;
  o.contractBudgetChangesInCents = options.contractBudgetChangesInCents ?? 0;
  o.budgetReallocationsInCents = options.budgetReallocationsInCents ?? 0;
  o.revisedApprovedBudgetInCents = options.revisedApprovedBudgetInCents ?? 0;
  o.uncommittedBudgetAmountInCents = options.uncommittedBudgetAmountInCents ?? 0;
  o.unbilledCommittedInCents = options.unbilledCommittedInCents ?? 0;
  o.actualCostInCents = options.actualCostInCents ?? 0;
  o.costToCompleteInCents = options.costToCompleteInCents ?? 0;
  o.homeownerContractLineItems = (options.homeownerContractLineItems ?? []).map((i) =>
    maybeNew("HomeownerContractLineItem", i, cache, options.hasOwnProperty("homeownerContractLineItems"))
  );
  o.internalBudgetChangeInCents = options.internalBudgetChangeInCents ?? 0;
  o.bidContractLineItem = maybeNewOrNull("BidContractLineItem", options.bidContractLineItem, cache);
  o.probableBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.probableBidContractLineItem, cache);
  o.potentialBidContractLineItems = (options.potentialBidContractLineItems ?? []).map((i) =>
    maybeNew("PotentialBidContractLineItem", i, cache, options.hasOwnProperty("potentialBidContractLineItems"))
  );
  o.preferredPotentialBidContractLineItem = maybeNewOrNull(
    "PotentialBidContractLineItem",
    options.preferredPotentialBidContractLineItem,
    cache,
  );
  o.isFromReadyHomeTemplate = options.isFromReadyHomeTemplate ?? false;
  o.isRemovedScope = options.isRemovedScope ?? false;
  o.expenseAllocations = (options.expenseAllocations ?? []).map((i) =>
    maybeNew("ExpenseAllocation", i, cache, options.hasOwnProperty("expenseAllocations"))
  );
  o.budgetRollupInCents = maybeNew(
    "BudgetPhaseRollup",
    options.budgetRollupInCents,
    cache,
    options.hasOwnProperty("budgetRollupInCents"),
  );
  o.prebidBudgetChangeInCents = options.prebidBudgetChangeInCents ?? 0;
  o.awardedBudgetChangeInCents = options.awardedBudgetChangeInCents ?? 0;
  o.revisedBudgetChangeInCents = options.revisedBudgetChangeInCents ?? 0;
  o.costLineItems = (options.costLineItems ?? []).map((i) =>
    maybeNew("CostLineItem", i, cache, options.hasOwnProperty("costLineItems"))
  );
  o.workAuthorizations = (options.workAuthorizations ?? []).map((i) =>
    maybeNew("WorkAuthorization", i, cache, options.hasOwnProperty("workAuthorizations"))
  );
  o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
  o.externalBudgetChangeInCents = options.externalBudgetChangeInCents ?? 0;
  o.budgetFinancials = maybeNew(
    "ProjectItemBudgetFinancials",
    options.budgetFinancials,
    cache,
    options.hasOwnProperty("budgetFinancials"),
  );
  o.tradePartnerPaidInCents = options.tradePartnerPaidInCents ?? 0;
  o.tradeBilledInCents = options.tradeBilledInCents ?? 0;
  o.canAssignBidContractLineItem = maybeNew(
    "PotentialOperation2",
    options.canAssignBidContractLineItem,
    cache,
    options.hasOwnProperty("canAssignBidContractLineItem"),
  );
  o.currentPriceInCents = options.currentPriceInCents ?? 0;
  o.allocationReason = options.allocationReason ?? null;
  o.configuredOptions = (options.configuredOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("configuredOptions"))
  );
  o.baseOrOptionName = options.baseOrOptionName ?? "baseOrOptionName";
  o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
  o.lastAcceptedChangeEventLineItem = maybeNewOrNull(
    "ChangeEventLineItem",
    options.lastAcceptedChangeEventLineItem,
    cache,
  );
  o.allocations = (options.allocations ?? []).map((i) =>
    maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("allocations"))
  );
  o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
  o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
  o.projectCostCode = maybeNew(
    "ProjectCostCode",
    options.projectCostCode,
    cache,
    options.hasOwnProperty("projectCostCode"),
  );
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.revisedPriceInCents = options.revisedPriceInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.bidTask = maybeNewOrNull("GlobalPlanTask", options.bidTask, cache);
  o.packageDesignNotes = options.packageDesignNotes ?? null;
  return o;
}

factories["ProjectItem"] = newProjectItem;

export interface EstimateOptions {
  __typename?: "Estimate";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Estimate["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Estimate["isFollowed"];
  id?: Estimate["id"];
  name?: Estimate["name"];
  blueprintUrl?: Url | UrlOptions;
  status?: EstimateStatusDetailOptions | EstimateStatus;
  type?: EstimateTypeDetailOptions | EstimateType;
  projectStage?: ProjectStage | ProjectStageOptions;
  lineItems?: Array<EstimateLineItem | EstimateLineItemOptions>;
  title?: Estimate["title"];
  description?: Estimate["description"];
  createdAt?: Estimate["createdAt"];
  updatedAt?: Estimate["updatedAt"];
  totalCostInCents?: Estimate["totalCostInCents"];
  totalMarkupInCents?: Estimate["totalMarkupInCents"];
  totalPriceInCents?: Estimate["totalPriceInCents"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  changeEvent?: ChangeEvent | ChangeEventOptions | null;
  history?: Array<History | HistoryOptions>;
  homeownerContractChangeOrder?: HomeownerContractChangeOrder | HomeownerContractChangeOrderOptions | null;
  canEditStatus?: PotentialOperation2 | PotentialOperation2Options;
  softCostInCents?: Estimate["softCostInCents"];
  hardCostInCents?: Estimate["hardCostInCents"];
  directHardCostInCents?: Estimate["directHardCostInCents"];
  indirectHardCostInCents?: Estimate["indirectHardCostInCents"];
  annotatedCosts?: Array<AnnotatedCost | AnnotatedCostOptions>;
}

export function newEstimate(options: EstimateOptions = {}, cache: Record<string, any> = {}): Estimate {
  const o = (options.__typename ? options : cache["Estimate"] = {}) as Estimate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Estimate";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Estimate");
  o.name = options.name ?? "name";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.status = enumOrDetailOfEstimateStatus(options.status);
  o.type = enumOrDetailOfEstimateType(options.type);
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("EstimateLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.title = options.title ?? "title";
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalMarkupInCents = options.totalMarkupInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.homeownerContractChangeOrder = maybeNewOrNull(
    "HomeownerContractChangeOrder",
    options.homeownerContractChangeOrder,
    cache,
  );
  o.canEditStatus = maybeNew(
    "PotentialOperation2",
    options.canEditStatus,
    cache,
    options.hasOwnProperty("canEditStatus"),
  );
  o.softCostInCents = options.softCostInCents ?? 0;
  o.hardCostInCents = options.hardCostInCents ?? 0;
  o.directHardCostInCents = options.directHardCostInCents ?? 0;
  o.indirectHardCostInCents = options.indirectHardCostInCents ?? 0;
  o.annotatedCosts = (options.annotatedCosts ?? []).map((i) =>
    maybeNew("AnnotatedCost", i, cache, options.hasOwnProperty("annotatedCosts"))
  );
  return o;
}

factories["Estimate"] = newEstimate;

export interface DevelopmentCommitmentOptions {
  __typename?: "DevelopmentCommitment";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: DevelopmentCommitment["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: DevelopmentCommitment["isFollowed"];
  id?: DevelopmentCommitment["id"];
  tradePartner?: TradePartner | TradePartnerOptions | null;
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  commitments?: Array<Commitment | CommitmentOptions>;
  tradeCategories?: Array<TradeCategory | TradeCategoryOptions>;
  market?: Market | MarketOptions;
  status?: DevelopmentCommitment["status"];
  statusDetail?: CommitmentStatusDetailOptions | CommitmentStatus;
  statusText?: DevelopmentCommitment["statusText"];
  type?: DevelopmentCommitment["type"];
  typeDetail?: DevelopmentCommitmentTypeDetailOptions | DevelopmentCommitmentType | null;
  name?: DevelopmentCommitment["name"];
  executionDate?: DevelopmentCommitment["executionDate"];
  createdAt?: DevelopmentCommitment["createdAt"];
  updatedAt?: DevelopmentCommitment["updatedAt"];
  releasedDate?: DevelopmentCommitment["releasedDate"];
  releasedAt?: DevelopmentCommitment["releasedAt"];
  contractExhibits?: DevelopmentCommitment["contractExhibits"];
  contractSchedule?: DevelopmentCommitment["contractSchedule"];
  contractTerms?: DevelopmentCommitment["contractTerms"];
  contractExclusions?: DevelopmentCommitment["contractExclusions"];
  committedInCents?: DevelopmentCommitment["committedInCents"];
  pandaDoc?: PandaDoc | PandaDocOptions | null;
  headOfConstruction?: InternalUser | InternalUserOptions | null;
  homeboundAuthorizedSignatory?: InternalUser | InternalUserOptions | null;
  conOpsProjectManager?: InternalUser | InternalUserOptions | null;
  areaManager?: InternalUser | InternalUserOptions | null;
  canCreatePandaDoc?: PotentialOperation2 | PotentialOperation2Options;
  history?: Array<History | HistoryOptions>;
  summary?: DevelopmentCommitmentSummary | DevelopmentCommitmentSummaryOptions;
  blueprintUrl?: Url | UrlOptions;
  stage?: DevelopmentCommitment["stage"];
  stageDetail?: StageDetailOptions | Stage;
  costTypes?: Array<CostTypeDetail | CostTypeDetailOptions> | null;
  internalNote?: DevelopmentCommitment["internalNote"];
  costCodes?: Array<CostCode | CostCodeOptions>;
  costCodeSummary?: Array<DevelopmentCommitmentCostCodeSummary | DevelopmentCommitmentCostCodeSummaryOptions>;
  canBeEdited?: DevelopmentCommitment["canBeEdited"];
  development?: Development | DevelopmentOptions;
  document?: Document | DocumentOptions | null;
  signatoryContact?: TradePartnerContact | TradePartnerContactOptions | null;
}

export function newDevelopmentCommitment(
  options: DevelopmentCommitmentOptions = {},
  cache: Record<string, any> = {},
): DevelopmentCommitment {
  const o = (options.__typename ? options : cache["DevelopmentCommitment"] = {}) as DevelopmentCommitment;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentCommitment";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("DevelopmentCommitment");
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.tradeCategories = (options.tradeCategories ?? []).map((i) =>
    maybeNew("TradeCategory", i, cache, options.hasOwnProperty("tradeCategories"))
  );
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.status = options.status ?? CommitmentStatus.Draft;
  o.statusDetail = enumOrDetailOfCommitmentStatus(options.statusDetail);
  o.statusText = options.statusText ?? "statusText";
  o.type = options.type ?? null;
  o.typeDetail = enumOrDetailOrNullOfDevelopmentCommitmentType(options.typeDetail);
  o.name = options.name ?? "name";
  o.executionDate = options.executionDate ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.releasedDate = options.releasedDate ?? null;
  o.releasedAt = options.releasedAt ?? null;
  o.contractExhibits = options.contractExhibits ?? null;
  o.contractSchedule = options.contractSchedule ?? null;
  o.contractTerms = options.contractTerms ?? null;
  o.contractExclusions = options.contractExclusions ?? null;
  o.committedInCents = options.committedInCents ?? 0;
  o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
  o.headOfConstruction = maybeNewOrNull("InternalUser", options.headOfConstruction, cache);
  o.homeboundAuthorizedSignatory = maybeNewOrNull("InternalUser", options.homeboundAuthorizedSignatory, cache);
  o.conOpsProjectManager = maybeNewOrNull("InternalUser", options.conOpsProjectManager, cache);
  o.areaManager = maybeNewOrNull("InternalUser", options.areaManager, cache);
  o.canCreatePandaDoc = maybeNew(
    "PotentialOperation2",
    options.canCreatePandaDoc,
    cache,
    options.hasOwnProperty("canCreatePandaDoc"),
  );
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.summary = maybeNew("DevelopmentCommitmentSummary", options.summary, cache, options.hasOwnProperty("summary"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.stage = options.stage ?? Stage.PreConPlanning;
  o.stageDetail = enumOrDetailOfStage(options.stageDetail);
  o.costTypes = (options.costTypes ?? []).map((i) => enumOrDetailOfCostType(i));
  o.internalNote = options.internalNote ?? null;
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.costCodeSummary = (options.costCodeSummary ?? []).map((i) =>
    maybeNew("DevelopmentCommitmentCostCodeSummary", i, cache, options.hasOwnProperty("costCodeSummary"))
  );
  o.canBeEdited = options.canBeEdited ?? false;
  o.development = maybeNew("Development", options.development, cache, options.hasOwnProperty("development"));
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.signatoryContact = maybeNewOrNull("TradePartnerContact", options.signatoryContact, cache);
  return o;
}

factories["DevelopmentCommitment"] = newDevelopmentCommitment;

export interface CommitmentOptions {
  __typename?: "Commitment";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Commitment["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Commitment["isFollowed"];
  id?: Commitment["id"];
  accountingNumber?: Commitment["accountingNumber"];
  name?: Commitment["name"];
  displayName?: Commitment["displayName"];
  shortName?: Commitment["shortName"];
  commitmentType?: CommitmentTypeDetailOptions | CommitmentType;
  projectStage?: ProjectStage | ProjectStageOptions;
  tradePartner?: TradePartner | TradePartnerOptions | null;
  internalNote?: Commitment["internalNote"];
  costChangeInCents?: Commitment["costChangeInCents"];
  executionDate?: Commitment["executionDate"];
  createdAt?: Commitment["createdAt"];
  document?: Document | DocumentOptions | null;
  pandaDoc?: PandaDoc | PandaDocOptions | null;
  canCreatePandaDoc?: PotentialOperation2 | PotentialOperation2Options;
  changeOrders?: Array<CommitmentChangeOrder | CommitmentChangeOrderOptions>;
  lineItems?: Array<CommitmentLineItem | CommitmentLineItemOptions>;
  bills?: Array<Bill | BillOptions>;
  expenseAllocations?: Array<ExpenseAllocation | ExpenseAllocationOptions>;
  lineItemSummaries?: Array<CommitmentLineItemSummary | CommitmentLineItemSummaryOptions>;
  committedInCents?: Commitment["committedInCents"];
  taxableCostInCents?: Commitment["taxableCostInCents"];
  remainingInCents?: Commitment["remainingInCents"];
  pendingRemainingInCents?: Commitment["pendingRemainingInCents"];
  billedInCents?: Commitment["billedInCents"];
  pendingBilledInCents?: Commitment["pendingBilledInCents"];
  unbilledInCents?: Commitment["unbilledInCents"];
  paidInCents?: Commitment["paidInCents"];
  balanceInCents?: Commitment["balanceInCents"];
  blueprintUrl?: Url | UrlOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  protoCommitmentLineItemsToBuyout?: Array<ProtoCommitmentLineItemToBuyout | ProtoCommitmentLineItemToBuyoutOptions>;
  hasPartiallyBoughtOutScope?: Commitment["hasPartiallyBoughtOutScope"];
  status?: Commitment["status"];
  statusDetail?: CommitmentStatusDetailOptions | CommitmentStatus;
  statusText?: Commitment["statusText"];
  developmentCommitment?: DevelopmentCommitment | DevelopmentCommitmentOptions | null;
  contractExhibits?: Commitment["contractExhibits"];
  contractSchedule?: Commitment["contractSchedule"];
  contractTerms?: Commitment["contractTerms"];
  contractExclusions?: Commitment["contractExclusions"];
  updatedAt?: Commitment["updatedAt"];
  tradeCategories?: Array<TradeCategory | TradeCategoryOptions>;
  costTypes?: Array<CostTypeDetail | CostTypeDetailOptions>;
  costCodeSummary?: CommitmentCostCodeSummary | CommitmentCostCodeSummaryOptions;
  changeEvent?: ChangeEvent | ChangeEventOptions | null;
  canEditLineItems?: PotentialOperation2 | PotentialOperation2Options;
  canBeReleased?: PotentialOperation2 | PotentialOperation2Options;
  canBeReleasedWithinBudget?: PotentialOperation2 | PotentialOperation2Options;
  isBidCommitment?: Commitment["isBidCommitment"];
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions | null;
  canBeVoided?: PotentialOperation2 | PotentialOperation2Options;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  canBeEdited?: Commitment["canBeEdited"];
  costCodes?: Array<CostCode | CostCodeOptions>;
  items?: Array<Item | ItemOptions>;
  potentialBidContractRevisions?: Array<PotentialBidContractRevision | PotentialBidContractRevisionOptions>;
  pandaDocRecipients?: Array<PandaDocIntendedRecipient | PandaDocIntendedRecipientOptions>;
  preferredBidContractRevision?: PotentialBidContractRevision | PotentialBidContractRevisionOptions | null;
  history?: Array<History | HistoryOptions> | null;
  tradeSignatory?: TradePartnerContact | TradePartnerContactOptions | null;
  readyPlanConfigOptions?: Array<ProjectReadyPlanConfigOption | ProjectReadyPlanConfigOptionOptions> | null;
  percentagePaid?: Commitment["percentagePaid"];
  releaseWhenReady?: Commitment["releaseWhenReady"];
  eventuallyVoidedBy?: Commitment | CommitmentOptions | null;
  voidsCommitments?: Array<Commitment | CommitmentOptions>;
  sentDate?: Commitment["sentDate"];
  depositInBasisPoints?: Commitment["depositInBasisPoints"];
  depositScheduleTask?: Task | TaskOptions | null;
  depositBill?: Bill | BillOptions | null;
  referenceNumber?: Commitment["referenceNumber"];
  drop?: Drop | DropOptions | null;
  draws?: Array<CommitmentDraw | CommitmentDrawOptions>;
  canEditDraws?: PotentialOperation2 | PotentialOperation2Options;
  billingSchedule?: Array<CommitmentBillingScheduleItem | CommitmentBillingScheduleItemOptions>;
}

export function newCommitment(options: CommitmentOptions = {}, cache: Record<string, any> = {}): Commitment {
  const o = (options.__typename ? options : cache["Commitment"] = {}) as Commitment;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Commitment";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Commitment");
  o.accountingNumber = options.accountingNumber ?? 0;
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.shortName = options.shortName ?? "shortName";
  o.commitmentType = enumOrDetailOfCommitmentType(options.commitmentType);
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.internalNote = options.internalNote ?? null;
  o.costChangeInCents = options.costChangeInCents ?? 0;
  o.executionDate = options.executionDate ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
  o.canCreatePandaDoc = maybeNew(
    "PotentialOperation2",
    options.canCreatePandaDoc,
    cache,
    options.hasOwnProperty("canCreatePandaDoc"),
  );
  o.changeOrders = (options.changeOrders ?? []).map((i) =>
    maybeNew("CommitmentChangeOrder", i, cache, options.hasOwnProperty("changeOrders"))
  );
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("CommitmentLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
  o.expenseAllocations = (options.expenseAllocations ?? []).map((i) =>
    maybeNew("ExpenseAllocation", i, cache, options.hasOwnProperty("expenseAllocations"))
  );
  o.lineItemSummaries = (options.lineItemSummaries ?? []).map((i) =>
    maybeNew("CommitmentLineItemSummary", i, cache, options.hasOwnProperty("lineItemSummaries"))
  );
  o.committedInCents = options.committedInCents ?? 0;
  o.taxableCostInCents = options.taxableCostInCents ?? 0;
  o.remainingInCents = options.remainingInCents ?? 0;
  o.pendingRemainingInCents = options.pendingRemainingInCents ?? 0;
  o.billedInCents = options.billedInCents ?? null;
  o.pendingBilledInCents = options.pendingBilledInCents ?? null;
  o.unbilledInCents = options.unbilledInCents ?? 0;
  o.paidInCents = options.paidInCents ?? null;
  o.balanceInCents = options.balanceInCents ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.protoCommitmentLineItemsToBuyout = (options.protoCommitmentLineItemsToBuyout ?? []).map((i) =>
    maybeNew("ProtoCommitmentLineItemToBuyout", i, cache, options.hasOwnProperty("protoCommitmentLineItemsToBuyout"))
  );
  o.hasPartiallyBoughtOutScope = options.hasPartiallyBoughtOutScope ?? false;
  o.status = options.status ?? CommitmentStatus.Draft;
  o.statusDetail = enumOrDetailOfCommitmentStatus(options.statusDetail);
  o.statusText = options.statusText ?? "statusText";
  o.developmentCommitment = maybeNewOrNull("DevelopmentCommitment", options.developmentCommitment, cache);
  o.contractExhibits = options.contractExhibits ?? null;
  o.contractSchedule = options.contractSchedule ?? null;
  o.contractTerms = options.contractTerms ?? null;
  o.contractExclusions = options.contractExclusions ?? null;
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tradeCategories = (options.tradeCategories ?? []).map((i) =>
    maybeNew("TradeCategory", i, cache, options.hasOwnProperty("tradeCategories"))
  );
  o.costTypes = (options.costTypes ?? []).map((i) => enumOrDetailOfCostType(i));
  o.costCodeSummary = maybeNew(
    "CommitmentCostCodeSummary",
    options.costCodeSummary,
    cache,
    options.hasOwnProperty("costCodeSummary"),
  );
  o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
  o.canEditLineItems = maybeNew(
    "PotentialOperation2",
    options.canEditLineItems,
    cache,
    options.hasOwnProperty("canEditLineItems"),
  );
  o.canBeReleased = maybeNew(
    "PotentialOperation2",
    options.canBeReleased,
    cache,
    options.hasOwnProperty("canBeReleased"),
  );
  o.canBeReleasedWithinBudget = maybeNew(
    "PotentialOperation2",
    options.canBeReleasedWithinBudget,
    cache,
    options.hasOwnProperty("canBeReleasedWithinBudget"),
  );
  o.isBidCommitment = options.isBidCommitment ?? false;
  o.bidContractRevision = maybeNewOrNull("BidContractRevision", options.bidContractRevision, cache);
  o.canBeVoided = maybeNew("PotentialOperation2", options.canBeVoided, cache, options.hasOwnProperty("canBeVoided"));
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.canBeEdited = options.canBeEdited ?? false;
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.items = (options.items ?? []).map((i) => maybeNew("Item", i, cache, options.hasOwnProperty("items")));
  o.potentialBidContractRevisions = (options.potentialBidContractRevisions ?? []).map((i) =>
    maybeNew("PotentialBidContractRevision", i, cache, options.hasOwnProperty("potentialBidContractRevisions"))
  );
  o.pandaDocRecipients = (options.pandaDocRecipients ?? []).map((i) =>
    maybeNew("PandaDocIntendedRecipient", i, cache, options.hasOwnProperty("pandaDocRecipients"))
  );
  o.preferredBidContractRevision = maybeNewOrNull(
    "PotentialBidContractRevision",
    options.preferredBidContractRevision,
    cache,
  );
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.tradeSignatory = maybeNewOrNull("TradePartnerContact", options.tradeSignatory, cache);
  o.readyPlanConfigOptions = (options.readyPlanConfigOptions ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfigOption", i, cache, options.hasOwnProperty("readyPlanConfigOptions"))
  );
  o.percentagePaid = options.percentagePaid ?? 0;
  o.releaseWhenReady = options.releaseWhenReady ?? null;
  o.eventuallyVoidedBy = maybeNewOrNull("Commitment", options.eventuallyVoidedBy, cache);
  o.voidsCommitments = (options.voidsCommitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("voidsCommitments"))
  );
  o.sentDate = options.sentDate ?? null;
  o.depositInBasisPoints = options.depositInBasisPoints ?? null;
  o.depositScheduleTask = maybeNewOrNull("Task", options.depositScheduleTask, cache);
  o.depositBill = maybeNewOrNull("Bill", options.depositBill, cache);
  o.referenceNumber = options.referenceNumber ?? null;
  o.drop = maybeNewOrNull("Drop", options.drop, cache);
  o.draws = (options.draws ?? []).map((i) => maybeNew("CommitmentDraw", i, cache, options.hasOwnProperty("draws")));
  o.canEditDraws = maybeNew("PotentialOperation2", options.canEditDraws, cache, options.hasOwnProperty("canEditDraws"));
  o.billingSchedule = (options.billingSchedule ?? []).map((i) =>
    maybeNew("CommitmentBillingScheduleItem", i, cache, options.hasOwnProperty("billingSchedule"))
  );
  return o;
}

factories["Commitment"] = newCommitment;

export interface DocumentOptions {
  __typename?: "Document";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Document["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Document["isFollowed"];
  id?: Document["id"];
  documentType?: DocumentTypeDetailOptions | DocumentType;
  name?: Document["name"];
  sizeInBytes?: Document["sizeInBytes"];
  url?: Document["url"];
  displayName?: Document["displayName"];
  homeownerVisible?: Document["homeownerVisible"];
  asset?: Asset | AssetOptions;
  createdAt?: Document["createdAt"];
  updatedAt?: Document["updatedAt"];
  createdBy?: User | UserOptions;
  pandaDoc?: PandaDoc | PandaDocOptions | null;
  assets?: Array<Asset | AssetOptions>;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  isDeleted?: Document["isDeleted"];
  parent?:
    | DocumentParent
    | DevelopmentOptions
    | RequireTypename<PlanPackageOptions>
    | RequireTypename<StandaloneProjectOptions>
    | RequireTypename<RegionOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>;
  category?: Document["category"];
  categoryDetail?: DocumentCategoryDetailOptions | DocumentCategory | null;
  tasks?: Array<Task | TaskOptions>;
  isFavorited?: Document["isFavorited"];
  blueprintUrl?: Url | UrlOptions;
  issuanceDate?: Document["issuanceDate"];
  ownerWorkAuthorization?: WorkAuthorization | WorkAuthorizationOptions | null;
  associatedProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  owner?:
    | DocumentOwner
    | HomeownerContractOptions
    | RequireTypename<HomeownerContractChangeOrderOptions>
    | RequireTypename<CommitmentOptions>
    | RequireTypename<CommitmentChangeOrderOptions>
    | RequireTypename<DevelopmentCommitmentOptions>
    | RequireTypename<InvoiceDocumentOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<PlanPackageOptions>
    | RequireTypename<StandaloneProjectOptions>
    | RequireTypename<RegionOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<BidContractRevisionOptions>
    | RequireTypename<LienWaiverOptions>
    | RequireTypename<ChangeEventOptions>
    | null;
  homeownerContract?: HomeownerContract | HomeownerContractOptions | null;
  homeownerContractChangeOrder?: HomeownerContractChangeOrder | HomeownerContractChangeOrderOptions | null;
  attachOn?: Document["attachOn"];
  lienWaiver?: LienWaiver | LienWaiverOptions | null;
  active?: Document["active"];
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  canArchive?: PotentialOperation2 | PotentialOperation2Options;
}

export function newDocument(options: DocumentOptions = {}, cache: Record<string, any> = {}): Document {
  const o = (options.__typename ? options : cache["Document"] = {}) as Document;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Document";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Document");
  o.documentType = enumOrDetailOfDocumentType(options.documentType);
  o.name = options.name ?? "name";
  o.sizeInBytes = options.sizeInBytes ?? 0;
  o.url = options.url ?? "url";
  o.displayName = options.displayName ?? "displayName";
  o.homeownerVisible = options.homeownerVisible ?? false;
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
  o.assets = (options.assets ?? []).map((i) => maybeNew("Asset", i, cache, options.hasOwnProperty("assets")));
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.isDeleted = options.isDeleted ?? null;
  o.parent = maybeNew(options.parent?.__typename ?? "Development", options.parent, cache);
  o.category = options.category ?? DocumentCategory.Contractual;
  o.categoryDetail = enumOrDetailOrNullOfDocumentCategory(options.categoryDetail);
  o.tasks = (options.tasks ?? []).map((i) => maybeNew("Task", i, cache, options.hasOwnProperty("tasks")));
  o.isFavorited = options.isFavorited ?? false;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.issuanceDate = options.issuanceDate ?? null;
  o.ownerWorkAuthorization = maybeNewOrNull("WorkAuthorization", options.ownerWorkAuthorization, cache);
  o.associatedProjects = (options.associatedProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("associatedProjects"))
  );
  o.owner = maybeNewOrNull(options.owner?.__typename ?? "HomeownerContract", options.owner, cache);
  o.homeownerContract = maybeNewOrNull("HomeownerContract", options.homeownerContract, cache);
  o.homeownerContractChangeOrder = maybeNewOrNull(
    "HomeownerContractChangeOrder",
    options.homeownerContractChangeOrder,
    cache,
  );
  o.attachOn = options.attachOn ?? [];
  o.lienWaiver = maybeNewOrNull("LienWaiver", options.lienWaiver, cache);
  o.active = options.active ?? false;
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.canArchive = maybeNew("PotentialOperation2", options.canArchive, cache, options.hasOwnProperty("canArchive"));
  return o;
}

factories["Document"] = newDocument;

export interface ItemTemplateItemVersionOptions {
  __typename?: "ItemTemplateItemVersion";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ItemTemplateItemVersion["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ItemTemplateItemVersion["isFollowed"];
  id?: ItemTemplateItemVersion["id"];
  identityId?: ItemTemplateItemVersion["identityId"];
  createdAt?: ItemTemplateItemVersion["createdAt"];
  updatedAt?: ItemTemplateItemVersion["updatedAt"];
  template?: ItemTemplate | ItemTemplateOptions;
  scope?: ItemTemplateItem | ItemTemplateItemOptions;
  scopeChangeType?: ItemTemplateItemVersion["scopeChangeType"];
  scopeChangeTypeDetail?: ScopeChangeTypeDetailOptions | ScopeChangeType;
  scopeChangeReason?: ScopeChangeReason | ScopeChangeReasonOptions | null;
  slot?: ItemSlot | ItemSlotOptions;
  item?: Item | ItemOptions;
  location?: Location | LocationOptions;
  quantity?: ItemTemplateItemVersion["quantity"];
  costType?: ItemTemplateItemVersion["costType"];
  costTypeDetail?: CostTypeDetailOptions | CostType;
  specifications?: ItemTemplateItemVersion["specifications"];
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  tradePartnerNote?: ItemTemplateItemVersion["tradePartnerNote"];
  internalNote?: ItemTemplateItemVersion["internalNote"];
  name?: ItemTemplateItemVersion["name"];
  displayName?: ItemTemplateItemVersion["displayName"];
  parent?: ItemTemplate | ItemTemplateOptions;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  first?: ItemTemplate | ItemTemplateOptions;
  basedOn?: ItemTemplateItem | ItemTemplateItemOptions | null;
  totalCostInCents?: ItemTemplateItemVersion["totalCostInCents"];
  unitCostInCents?: ItemTemplateItemVersion["unitCostInCents"];
  canDeleteItem?: PotentialOperation2 | PotentialOperation2Options;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  preferredBidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  bidItem?: BidItem | BidItemOptions | null;
  bidItemTemplateItem?: ItemTemplateItem | ItemTemplateItemOptions | null;
  potentialBidItems?: Array<BidItem | BidItemOptions>;
  elevationIds?: ItemTemplateItemVersion["elevationIds"];
  specOptionIds?: ItemTemplateItemVersion["specOptionIds"];
  otherOptionIds?: ItemTemplateItemVersion["otherOptionIds"];
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  customPlaceholderName?: ItemTemplateItemVersion["customPlaceholderName"];
  blueprintUrl?: Url | UrlOptions;
  scopeChangeReasonNote?: ItemTemplateItemVersion["scopeChangeReasonNote"];
  task?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  materialVariant?: MaterialVariant | MaterialVariantOptions | null;
  development?: Development | DevelopmentOptions | null;
  costEstimate?: CostEstimate | CostEstimateOptions;
}

export function newItemTemplateItemVersion(
  options: ItemTemplateItemVersionOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateItemVersion {
  const o = (options.__typename ? options : cache["ItemTemplateItemVersion"] = {}) as ItemTemplateItemVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateItemVersion";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("ItemTemplateItemVersion");
  o.identityId = options.identityId ?? "identityId";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.template = maybeNew("ItemTemplate", options.template, cache, options.hasOwnProperty("template"));
  o.scope = maybeNew("ItemTemplateItem", options.scope, cache, options.hasOwnProperty("scope"));
  o.scopeChangeType = options.scopeChangeType ?? ScopeChangeType.None;
  o.scopeChangeTypeDetail = enumOrDetailOfScopeChangeType(options.scopeChangeTypeDetail);
  o.scopeChangeReason = maybeNewOrNull("ScopeChangeReason", options.scopeChangeReason, cache);
  o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.quantity = options.quantity ?? null;
  o.costType = options.costType ?? CostType.Labor;
  o.costTypeDetail = enumOrDetailOfCostType(options.costTypeDetail);
  o.specifications = options.specifications ?? null;
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.internalNote = options.internalNote ?? null;
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.parent = maybeNew("ItemTemplate", options.parent, cache, options.hasOwnProperty("parent"));
  o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.first = maybeNew("ItemTemplate", options.first, cache, options.hasOwnProperty("first"));
  o.basedOn = maybeNewOrNull("ItemTemplateItem", options.basedOn, cache);
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.unitCostInCents = options.unitCostInCents ?? 0;
  o.canDeleteItem = maybeNew(
    "PotentialOperation2",
    options.canDeleteItem,
    cache,
    options.hasOwnProperty("canDeleteItem"),
  );
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.preferredBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.preferredBidContractLineItem, cache);
  o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
  o.bidItemTemplateItem = maybeNewOrNull("ItemTemplateItem", options.bidItemTemplateItem, cache);
  o.potentialBidItems = (options.potentialBidItems ?? []).map((i) =>
    maybeNew("BidItem", i, cache, options.hasOwnProperty("potentialBidItems"))
  );
  o.elevationIds = options.elevationIds ?? [];
  o.specOptionIds = options.specOptionIds ?? [];
  o.otherOptionIds = options.otherOptionIds ?? [];
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.customPlaceholderName = options.customPlaceholderName ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.scopeChangeReasonNote = options.scopeChangeReasonNote ?? null;
  o.task = maybeNewOrNull("GlobalPlanTask", options.task, cache);
  o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.costEstimate = maybeNew("CostEstimate", options.costEstimate, cache, options.hasOwnProperty("costEstimate"));
  return o;
}

factories["ItemTemplateItemVersion"] = newItemTemplateItemVersion;

export interface JobLogNoteOptions {
  __typename?: "JobLogNote";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: JobLogNote["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: JobLogNote["isFollowed"];
  id?: JobLogNote["id"];
  name?: JobLogNote["name"];
  blueprintUrl?: Url | UrlOptions;
  title?: JobLogNote["title"];
  content?: JobLogNote["content"];
  createdAt?: JobLogNote["createdAt"];
  updatedAt?: JobLogNote["updatedAt"];
  type?: JobLogNote["type"];
  typeDetail?: JobLogNoteTypeDetailOptions | JobLogNoteType | null;
  internalUser?: InternalUser | InternalUserOptions;
  jobLog?: JobLog | JobLogOptions;
  tradePartner?: TradePartner | TradePartnerOptions | null;
  jobLogImages?: Array<JobLogImage | JobLogImageOptions> | null;
  flags?: JobLogNote["flags"];
  scheduleTasks?: Array<ScheduleTask | ScheduleTaskOptions>;
  history?: Array<History | HistoryOptions>;
  clientPlatform?: ClientPlatformDetailOptions | ClientPlatform;
  additionalContext?: JobLogNote["additionalContext"];
  summarizedByAiNote?: JobLogNote | JobLogNoteOptions | null;
  summarizedNotes?: Array<JobLogNote | JobLogNoteOptions>;
}

export function newJobLogNote(options: JobLogNoteOptions = {}, cache: Record<string, any> = {}): JobLogNote {
  const o = (options.__typename ? options : cache["JobLogNote"] = {}) as JobLogNote;
  (cache.all ??= new Set()).add(o);
  o.__typename = "JobLogNote";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("JobLogNote");
  o.name = options.name ?? "name";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.title = options.title ?? null;
  o.content = options.content ?? "content";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.type = options.type ?? null;
  o.typeDetail = enumOrDetailOrNullOfJobLogNoteType(options.typeDetail);
  o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
  o.jobLog = maybeNew("JobLog", options.jobLog, cache, options.hasOwnProperty("jobLog"));
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.jobLogImages = (options.jobLogImages ?? []).map((i) =>
    maybeNew("JobLogImage", i, cache, options.hasOwnProperty("jobLogImages"))
  );
  o.flags = options.flags ?? [];
  o.scheduleTasks = (options.scheduleTasks ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("scheduleTasks"))
  );
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.clientPlatform = enumOrDetailOfClientPlatform(options.clientPlatform);
  o.additionalContext = options.additionalContext ?? null;
  o.summarizedByAiNote = maybeNewOrNull("JobLogNote", options.summarizedByAiNote, cache);
  o.summarizedNotes = (options.summarizedNotes ?? []).map((i) =>
    maybeNew("JobLogNote", i, cache, options.hasOwnProperty("summarizedNotes"))
  );
  return o;
}

factories["JobLogNote"] = newJobLogNote;

export interface TradePartnerAvailabilityRequestOptions {
  __typename?: "TradePartnerAvailabilityRequest";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: TradePartnerAvailabilityRequest["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: TradePartnerAvailabilityRequest["isFollowed"];
  id?: TradePartnerAvailabilityRequest["id"];
  name?: TradePartnerAvailabilityRequest["name"];
  blueprintUrl?: Url | UrlOptions;
  createdAt?: TradePartnerAvailabilityRequest["createdAt"];
  updatedAt?: TradePartnerAvailabilityRequest["updatedAt"];
  internalUser?: InternalUser | InternalUserOptions;
  task?: Task | TaskOptions;
  tradePartnerContacts?: Array<TradePartnerContact | TradePartnerContactOptions>;
  tradePartnerConfirmationDate?: TradePartnerAvailabilityRequest["tradePartnerConfirmationDate"];
  emails?: Array<TradePartnerAvailabilityRequestEmail | TradePartnerAvailabilityRequestEmailOptions>;
  textMessages?: Array<TradePartnerAvailabilityRequestTextMessage | TradePartnerAvailabilityRequestTextMessageOptions>;
  rescheduleDates?: TradePartnerAvailabilityRequest["rescheduleDates"] | null;
  status?: TradePartnerAvailabilityRequestStatusDetailOptions | TradePartnerAvailabilityRequestStatus;
  tradePartner?: TradePartner | TradePartnerOptions;
  canSave?: PotentialOperation2 | PotentialOperation2Options;
  rescheduleReasonNote?: TradePartnerAvailabilityRequest["rescheduleReasonNote"];
}

export function newTradePartnerAvailabilityRequest(
  options: TradePartnerAvailabilityRequestOptions = {},
  cache: Record<string, any> = {},
): TradePartnerAvailabilityRequest {
  const o =
    (options.__typename ? options : cache["TradePartnerAvailabilityRequest"] = {}) as TradePartnerAvailabilityRequest;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerAvailabilityRequest";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("TradePartnerAvailabilityRequest");
  o.name = options.name ?? "name";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  o.tradePartnerContacts = (options.tradePartnerContacts ?? []).map((i) =>
    maybeNew("TradePartnerContact", i, cache, options.hasOwnProperty("tradePartnerContacts"))
  );
  o.tradePartnerConfirmationDate = options.tradePartnerConfirmationDate ?? null;
  o.emails = (options.emails ?? []).map((i) =>
    maybeNew("TradePartnerAvailabilityRequestEmail", i, cache, options.hasOwnProperty("emails"))
  );
  o.textMessages = (options.textMessages ?? []).map((i) =>
    maybeNew("TradePartnerAvailabilityRequestTextMessage", i, cache, options.hasOwnProperty("textMessages"))
  );
  o.rescheduleDates = options.rescheduleDates ?? [];
  o.status = enumOrDetailOfTradePartnerAvailabilityRequestStatus(options.status);
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.canSave = maybeNew("PotentialOperation2", options.canSave, cache, options.hasOwnProperty("canSave"));
  o.rescheduleReasonNote = options.rescheduleReasonNote ?? null;
  return o;
}

factories["TradePartnerAvailabilityRequest"] = newTradePartnerAvailabilityRequest;

export interface PunchlistItemTodoOptions {
  __typename?: "PunchlistItemTodo";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: PunchlistItemTodo["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: PunchlistItemTodo["isFollowed"];
  id?: PunchlistItemTodo["id"];
  name?: PunchlistItemTodo["name"];
  description?: PunchlistItemTodo["description"];
  deletedAt?: PunchlistItemTodo["deletedAt"];
  createdAt?: PunchlistItemTodo["createdAt"];
  updatedAt?: PunchlistItemTodo["updatedAt"];
  dueDate?: PunchlistItemTodo["dueDate"];
  order?: PunchlistItemTodo["order"];
  urgent?: PunchlistItemTodo["urgent"];
  status?: ToDoStatusDetailOptions | ToDoStatus;
  type?: ToDoTypeDetailOptions | ToDoType;
  createdBy?: User | UserOptions;
  attachments?: Array<Attachment | AttachmentOptions>;
  assignees?: Array<User | UserOptions>;
  parent?:
    | ToDoParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<CohortOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | null;
  location?: Location | LocationOptions | null;
  tradePartner?: TradePartner | TradePartnerOptions | null;
  blueprintUrl?: Url | UrlOptions;
}

export function newPunchlistItemTodo(
  options: PunchlistItemTodoOptions = {},
  cache: Record<string, any> = {},
): PunchlistItemTodo {
  const o = (options.__typename ? options : cache["PunchlistItemTodo"] = {}) as PunchlistItemTodo;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PunchlistItemTodo";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("PunchlistItemTodo");
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.deletedAt = options.deletedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.dueDate = options.dueDate ?? null;
  o.order = options.order ?? "order";
  o.urgent = options.urgent ?? false;
  o.status = enumOrDetailOfToDoStatus(options.status);
  o.type = enumOrDetailOfToDoType(options.type);
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  o.assignees = (options.assignees ?? []).map((i) => maybeNew("User", i, cache, options.hasOwnProperty("assignees")));
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  o.location = maybeNewOrNull("Location", options.location, cache);
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  return o;
}

factories["PunchlistItemTodo"] = newPunchlistItemTodo;

export interface WarrantyTicketOptions {
  __typename?: "WarrantyTicket";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: WarrantyTicket["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: WarrantyTicket["isFollowed"];
  id?: WarrantyTicket["id"];
  createdAt?: WarrantyTicket["createdAt"];
  updatedAt?: WarrantyTicket["updatedAt"];
  name?: WarrantyTicket["name"];
  type?: WarrantyTicketTypeDetailOptions | WarrantyTicketType | null;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  projectContacts?: Array<ProjectContact | ProjectContactOptions>;
  availabilities?: Array<WarrantyTicketAvailability | WarrantyTicketAvailabilityOptions>;
  items?: Array<WarrantyTicketItem | WarrantyTicketItemOptions>;
  title?: WarrantyTicket["title"];
  homeownerVisible?: WarrantyTicket["homeownerVisible"];
  blueprintUrl?: Url | UrlOptions;
  urgent?: WarrantyTicket["urgent"];
  history?: Array<History | HistoryOptions>;
  attachments?: Array<Attachment | AttachmentOptions>;
  totalItems?: WarrantyTicket["totalItems"];
  totalAvailableItems?: WarrantyTicket["totalAvailableItems"];
  totalCompletedItems?: WarrantyTicket["totalCompletedItems"];
  totalRejectedItems?: WarrantyTicket["totalRejectedItems"];
  status?: WarrantyTicketStatusDetailOptions | WarrantyTicketStatus;
  assignees?: Array<InternalUser | InternalUserOptions>;
}

export function newWarrantyTicket(
  options: WarrantyTicketOptions = {},
  cache: Record<string, any> = {},
): WarrantyTicket {
  const o = (options.__typename ? options : cache["WarrantyTicket"] = {}) as WarrantyTicket;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WarrantyTicket";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("WarrantyTicket");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.name = options.name ?? "name";
  o.type = enumOrDetailOrNullOfWarrantyTicketType(options.type);
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.projectContacts = (options.projectContacts ?? []).map((i) =>
    maybeNew("ProjectContact", i, cache, options.hasOwnProperty("projectContacts"))
  );
  o.availabilities = (options.availabilities ?? []).map((i) =>
    maybeNew("WarrantyTicketAvailability", i, cache, options.hasOwnProperty("availabilities"))
  );
  o.items = (options.items ?? []).map((i) => maybeNew("WarrantyTicketItem", i, cache, options.hasOwnProperty("items")));
  o.title = options.title ?? "title";
  o.homeownerVisible = options.homeownerVisible ?? false;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.urgent = options.urgent ?? false;
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  o.totalItems = options.totalItems ?? 0;
  o.totalAvailableItems = options.totalAvailableItems ?? 0;
  o.totalCompletedItems = options.totalCompletedItems ?? 0;
  o.totalRejectedItems = options.totalRejectedItems ?? 0;
  o.status = enumOrDetailOfWarrantyTicketStatus(options.status);
  o.assignees = (options.assignees ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("assignees"))
  );
  return o;
}

factories["WarrantyTicket"] = newWarrantyTicket;

export interface HomeownerContractOptions {
  __typename?: "HomeownerContract";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: HomeownerContract["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: HomeownerContract["isFollowed"];
  id?: HomeownerContract["id"];
  projectStage?: ProjectStage | ProjectStageOptions;
  name?: HomeownerContract["name"];
  internalNote?: HomeownerContract["internalNote"];
  priceChangeInCents?: HomeownerContract["priceChangeInCents"];
  budgetChangeInCents?: HomeownerContract["budgetChangeInCents"];
  invoicedInCents?: HomeownerContract["invoicedInCents"];
  amountPaidInCents?: HomeownerContract["amountPaidInCents"];
  balanceInCents?: HomeownerContract["balanceInCents"];
  uninvoicedInCents?: HomeownerContract["uninvoicedInCents"];
  executionDate?: HomeownerContract["executionDate"];
  contractType?: HomeownerContract["contractType"];
  contractTypeDetail?: ContractTypeDetailOptions | ContractType;
  costPlusMarkupBasisPoints?: HomeownerContract["costPlusMarkupBasisPoints"];
  document?: Document | DocumentOptions | null;
  draws?: Array<HomeownerContractDraw | HomeownerContractDrawOptions>;
  changeOrders?: Array<HomeownerContractChangeOrder | HomeownerContractChangeOrderOptions>;
  lineItems?: Array<HomeownerContractLineItem | HomeownerContractLineItemOptions>;
  lineItemsByProjectItem?: Array<
    HomeownerContractLineItemsByProjectItem | HomeownerContractLineItemsByProjectItemOptions
  >;
  title?: HomeownerContract["title"];
  blueprintUrl?: Url | UrlOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  softCostBudgetInCents?: HomeownerContract["softCostBudgetInCents"];
  directHardCostBudgetInCents?: HomeownerContract["directHardCostBudgetInCents"];
  indirectHardCostBudgetInCents?: HomeownerContract["indirectHardCostBudgetInCents"];
  totalMarkupInCents?: HomeownerContract["totalMarkupInCents"];
  annotatedCosts?: Array<AnnotatedCost | AnnotatedCostOptions>;
  projectFinancials?: Array<ContractProjectFinancials | ContractProjectFinancialsOptions>;
}

export function newHomeownerContract(
  options: HomeownerContractOptions = {},
  cache: Record<string, any> = {},
): HomeownerContract {
  const o = (options.__typename ? options : cache["HomeownerContract"] = {}) as HomeownerContract;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerContract";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("HomeownerContract");
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.name = options.name ?? "name";
  o.internalNote = options.internalNote ?? null;
  o.priceChangeInCents = options.priceChangeInCents ?? 0;
  o.budgetChangeInCents = options.budgetChangeInCents ?? 0;
  o.invoicedInCents = options.invoicedInCents ?? null;
  o.amountPaidInCents = options.amountPaidInCents ?? null;
  o.balanceInCents = options.balanceInCents ?? null;
  o.uninvoicedInCents = options.uninvoicedInCents ?? null;
  o.executionDate = options.executionDate ?? null;
  o.contractType = options.contractType ?? ContractType.Fixed;
  o.contractTypeDetail = enumOrDetailOfContractType(options.contractTypeDetail);
  o.costPlusMarkupBasisPoints = options.costPlusMarkupBasisPoints ?? null;
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.draws = (options.draws ?? []).map((i) =>
    maybeNew("HomeownerContractDraw", i, cache, options.hasOwnProperty("draws"))
  );
  o.changeOrders = (options.changeOrders ?? []).map((i) =>
    maybeNew("HomeownerContractChangeOrder", i, cache, options.hasOwnProperty("changeOrders"))
  );
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("HomeownerContractLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.lineItemsByProjectItem = (options.lineItemsByProjectItem ?? []).map((i) =>
    maybeNew("HomeownerContractLineItemsByProjectItem", i, cache, options.hasOwnProperty("lineItemsByProjectItem"))
  );
  o.title = options.title ?? "title";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.softCostBudgetInCents = options.softCostBudgetInCents ?? 0;
  o.directHardCostBudgetInCents = options.directHardCostBudgetInCents ?? 0;
  o.indirectHardCostBudgetInCents = options.indirectHardCostBudgetInCents ?? 0;
  o.totalMarkupInCents = options.totalMarkupInCents ?? 0;
  o.annotatedCosts = (options.annotatedCosts ?? []).map((i) =>
    maybeNew("AnnotatedCost", i, cache, options.hasOwnProperty("annotatedCosts"))
  );
  o.projectFinancials = (options.projectFinancials ?? []).map((i) =>
    maybeNew("ContractProjectFinancials", i, cache, options.hasOwnProperty("projectFinancials"))
  );
  return o;
}

factories["HomeownerContract"] = newHomeownerContract;

export interface HomeownerContractChangeOrderOptions {
  __typename?: "HomeownerContractChangeOrder";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: HomeownerContractChangeOrder["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: HomeownerContractChangeOrder["isFollowed"];
  id?: HomeownerContractChangeOrder["id"];
  contract?: HomeownerContract | HomeownerContractOptions;
  identifier?: HomeownerContractChangeOrder["identifier"];
  name?: HomeownerContractChangeOrder["name"];
  shortName?: HomeownerContractChangeOrder["shortName"];
  internalNote?: HomeownerContractChangeOrder["internalNote"];
  priceChangeInCents?: HomeownerContractChangeOrder["priceChangeInCents"];
  budgetChangeInCents?: HomeownerContractChangeOrder["budgetChangeInCents"];
  invoicedInCents?: HomeownerContractChangeOrder["invoicedInCents"];
  amountPaidInCents?: HomeownerContractChangeOrder["amountPaidInCents"];
  balanceInCents?: HomeownerContractChangeOrder["balanceInCents"];
  uninvoicedInCents?: HomeownerContractChangeOrder["uninvoicedInCents"];
  executionDate?: HomeownerContractChangeOrder["executionDate"];
  contractType?: HomeownerContractChangeOrder["contractType"];
  costPlusMarkupBasisPoints?: HomeownerContractChangeOrder["costPlusMarkupBasisPoints"];
  document?: Document | DocumentOptions | null;
  draws?: Array<HomeownerContractDraw | HomeownerContractDrawOptions>;
  lineItems?: Array<HomeownerContractLineItem | HomeownerContractLineItemOptions>;
  title?: HomeownerContractChangeOrder["title"];
  blueprintUrl?: Url | UrlOptions;
  changeEvent?: ChangeEvent | ChangeEventOptions | null;
  estimate?: Estimate | EstimateOptions | null;
  softCostBudgetInCents?: HomeownerContractChangeOrder["softCostBudgetInCents"];
  directHardCostBudgetInCents?: HomeownerContractChangeOrder["directHardCostBudgetInCents"];
  indirectHardCostBudgetInCents?: HomeownerContractChangeOrder["indirectHardCostBudgetInCents"];
  totalMarkupInCents?: HomeownerContractChangeOrder["totalMarkupInCents"];
  annotatedCosts?: Array<AnnotatedCost | AnnotatedCostOptions>;
  projectFinancials?: Array<ContractProjectFinancials | ContractProjectFinancialsOptions>;
  isContractAddendum?: HomeownerContractChangeOrder["isContractAddendum"];
}

export function newHomeownerContractChangeOrder(
  options: HomeownerContractChangeOrderOptions = {},
  cache: Record<string, any> = {},
): HomeownerContractChangeOrder {
  const o = (options.__typename ? options : cache["HomeownerContractChangeOrder"] = {}) as HomeownerContractChangeOrder;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerContractChangeOrder";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("HomeownerContractChangeOrder");
  o.contract = maybeNew("HomeownerContract", options.contract, cache, options.hasOwnProperty("contract"));
  o.identifier = options.identifier ?? "identifier";
  o.name = options.name ?? "name";
  o.shortName = options.shortName ?? "shortName";
  o.internalNote = options.internalNote ?? null;
  o.priceChangeInCents = options.priceChangeInCents ?? 0;
  o.budgetChangeInCents = options.budgetChangeInCents ?? 0;
  o.invoicedInCents = options.invoicedInCents ?? null;
  o.amountPaidInCents = options.amountPaidInCents ?? null;
  o.balanceInCents = options.balanceInCents ?? null;
  o.uninvoicedInCents = options.uninvoicedInCents ?? null;
  o.executionDate = options.executionDate ?? null;
  o.contractType = options.contractType ?? ContractType.Fixed;
  o.costPlusMarkupBasisPoints = options.costPlusMarkupBasisPoints ?? null;
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.draws = (options.draws ?? []).map((i) =>
    maybeNew("HomeownerContractDraw", i, cache, options.hasOwnProperty("draws"))
  );
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("HomeownerContractLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.title = options.title ?? "title";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
  o.estimate = maybeNewOrNull("Estimate", options.estimate, cache);
  o.softCostBudgetInCents = options.softCostBudgetInCents ?? 0;
  o.directHardCostBudgetInCents = options.directHardCostBudgetInCents ?? 0;
  o.indirectHardCostBudgetInCents = options.indirectHardCostBudgetInCents ?? 0;
  o.totalMarkupInCents = options.totalMarkupInCents ?? 0;
  o.annotatedCosts = (options.annotatedCosts ?? []).map((i) =>
    maybeNew("AnnotatedCost", i, cache, options.hasOwnProperty("annotatedCosts"))
  );
  o.projectFinancials = (options.projectFinancials ?? []).map((i) =>
    maybeNew("ContractProjectFinancials", i, cache, options.hasOwnProperty("projectFinancials"))
  );
  o.isContractAddendum = options.isContractAddendum ?? false;
  return o;
}

factories["HomeownerContractChangeOrder"] = newHomeownerContractChangeOrder;

export interface ReadyPlanOptions {
  __typename?: "ReadyPlan";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ReadyPlan["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ReadyPlan["isFollowed"];
  id?: ReadyPlan["id"];
  name?: ReadyPlan["name"];
  displayName?: ReadyPlan["displayName"];
  description?: ReadyPlan["description"];
  createdAt?: ReadyPlan["createdAt"];
  updatedAt?: ReadyPlan["updatedAt"];
  status?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  effectiveStatus?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  development?: Development | DevelopmentOptions | null;
  itemTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  hasOptions?: ReadyPlan["hasOptions"];
  code?: ReadyPlan["code"];
  activeOptionsCount?: ReadyPlan["activeOptionsCount"];
  type?: ReadyPlanTypeDetailOptions | ReadyPlanType | null;
  isValidForReadyPlanConfiguration?: ReadyPlan["isValidForReadyPlanConfiguration"];
  displayCode?: ReadyPlan["displayCode"];
  programData?: ProgramData | ProgramDataOptions;
  maxProgramData?: ProgramData | ProgramDataOptions;
  minProgramData?: ProgramData | ProgramDataOptions;
  optionGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  userEvents?: Array<UserEvent | UserEventOptions>;
  blueprintUrl?: Url | UrlOptions;
  underwritingTemplate?: ItemTemplate | ItemTemplateOptions | null;
  constructionDocumentCompletePercentage?: ReadyPlan["constructionDocumentCompletePercentage"];
  programDatas?: Array<ReadyPlanProgramData | ReadyPlanProgramDataOptions>;
  assets?: Array<ReadyPlanAsset | ReadyPlanAssetOptions>;
  lotTypes?: ReadyPlan["lotTypes"];
  aggregateActive?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  aggregateDraft?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  aggregateLatest?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  aggregateVersions?: Array<ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions>;
  version?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  itemLocations?: Array<Location | LocationOptions>;
  costCodes?: Array<CostCode | CostCodeOptions>;
  canCreateNewVersion?: PotentialOperation2 | PotentialOperation2Options;
  canEditLineItems?: PotentialOperation2 | PotentialOperation2Options;
  contingencyMarkupPercentage?: ReadyPlan["contingencyMarkupPercentage"];
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  documents?: Array<Document | DocumentOptions>;
  requiredOptions?: Array<ReadyPlanRequiredOption | ReadyPlanRequiredOptionOptions>;
  projectConfigs?: Array<ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions>;
  owner?: InternalUser | InternalUserOptions | null;
  cloneInProgress?: ReadyPlan["cloneInProgress"];
}

export function newReadyPlan(options: ReadyPlanOptions = {}, cache: Record<string, any> = {}): ReadyPlan {
  const o = (options.__typename ? options : cache["ReadyPlan"] = {}) as ReadyPlan;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlan";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("ReadyPlan");
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = enumOrDetailOfReadyPlanStatus(options.status);
  o.effectiveStatus = enumOrDetailOfReadyPlanStatus(options.effectiveStatus);
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.itemTemplates = (options.itemTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("itemTemplates"))
  );
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.hasOptions = options.hasOptions ?? false;
  o.code = options.code ?? null;
  o.activeOptionsCount = options.activeOptionsCount ?? 0;
  o.type = enumOrDetailOrNullOfReadyPlanType(options.type);
  o.isValidForReadyPlanConfiguration = options.isValidForReadyPlanConfiguration ?? false;
  o.displayCode = options.displayCode ?? null;
  o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
  o.maxProgramData = maybeNew("ProgramData", options.maxProgramData, cache, options.hasOwnProperty("maxProgramData"));
  o.minProgramData = maybeNew("ProgramData", options.minProgramData, cache, options.hasOwnProperty("minProgramData"));
  o.optionGroups = (options.optionGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("optionGroups"))
  );
  o.userEvents = (options.userEvents ?? []).map((i) =>
    maybeNew("UserEvent", i, cache, options.hasOwnProperty("userEvents"))
  );
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.underwritingTemplate = maybeNewOrNull("ItemTemplate", options.underwritingTemplate, cache);
  o.constructionDocumentCompletePercentage = options.constructionDocumentCompletePercentage ?? 0;
  o.programDatas = (options.programDatas ?? []).map((i) =>
    maybeNew("ReadyPlanProgramData", i, cache, options.hasOwnProperty("programDatas"))
  );
  o.assets = (options.assets ?? []).map((i) => maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("assets")));
  o.lotTypes = options.lotTypes ?? [];
  o.aggregateActive = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateActive, cache);
  o.aggregateDraft = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateDraft, cache);
  o.aggregateLatest = maybeNew(
    "ReadyPlanAggregateVersion",
    options.aggregateLatest,
    cache,
    options.hasOwnProperty("aggregateLatest"),
  );
  o.aggregateVersions = (options.aggregateVersions ?? []).map((i) =>
    maybeNew("ReadyPlanAggregateVersion", i, cache, options.hasOwnProperty("aggregateVersions"))
  );
  o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
  o.itemLocations = (options.itemLocations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("itemLocations"))
  );
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.canCreateNewVersion = maybeNew(
    "PotentialOperation2",
    options.canCreateNewVersion,
    cache,
    options.hasOwnProperty("canCreateNewVersion"),
  );
  o.canEditLineItems = maybeNew(
    "PotentialOperation2",
    options.canEditLineItems,
    cache,
    options.hasOwnProperty("canEditLineItems"),
  );
  o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.requiredOptions = (options.requiredOptions ?? []).map((i) =>
    maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("requiredOptions"))
  );
  o.projectConfigs = (options.projectConfigs ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfig", i, cache, options.hasOwnProperty("projectConfigs"))
  );
  o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
  o.cloneInProgress = options.cloneInProgress ?? false;
  return o;
}

factories["ReadyPlan"] = newReadyPlan;

export interface PlanPackageOptions {
  __typename?: "PlanPackage";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: PlanPackage["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: PlanPackage["isFollowed"];
  id?: PlanPackage["id"];
  name?: PlanPackage["name"];
  displayName?: PlanPackage["displayName"];
  description?: PlanPackage["description"];
  createdAt?: PlanPackage["createdAt"];
  updatedAt?: PlanPackage["updatedAt"];
  type?: ReadyPlanTypeDetailOptions | ReadyPlanType;
  code?: PlanPackage["code"];
  displayCode?: PlanPackage["displayCode"];
  blueprintUrl?: Url | UrlOptions;
  constructionDocumentCompletePercentage?: PlanPackage["constructionDocumentCompletePercentage"];
  status?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  effectiveStatus?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  development?: Development | DevelopmentOptions | null;
  maxProgramData?: ProgramData | ProgramDataOptions;
  minProgramData?: ProgramData | ProgramDataOptions;
  programData?: ProgramData | ProgramDataOptions;
  itemTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
  takeoff?: ItemTemplate | ItemTemplateOptions;
  projectConfigs?: Array<ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions>;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  productOfferings?: Array<ProductOffering | ProductOfferingOptions>;
  designPackages?: Array<DesignPackage | DesignPackageOptions>;
  designPackageSources?: Array<DesignPackageSource | DesignPackageSourceOptions>;
  incomingSlots?: Array<PlanPackageIncomingSlot | PlanPackageIncomingSlotOptions>;
  lotTypes?: PlanPackage["lotTypes"] | null;
  programDatas?: Array<ReadyPlanProgramData | ReadyPlanProgramDataOptions>;
  assets?: Array<ReadyPlanAsset | ReadyPlanAssetOptions>;
  activeOptionsCount?: PlanPackage["activeOptionsCount"];
  projectCount?: PlanPackage["projectCount"];
  designPackageCount?: PlanPackage["designPackageCount"];
  productOfferingCount?: PlanPackage["productOfferingCount"];
  asGlobalOption?: GlobalOption | GlobalOptionOptions | null;
  markets?: Array<Market | MarketOptions>;
  aggregateActive?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  aggregateDraft?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  aggregateLatest?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  aggregateVersions?: Array<ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions>;
  version?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  itemLocations?: Array<Location | LocationOptions>;
  costCodes?: Array<CostCode | CostCodeOptions>;
  canEditLineItems?: PotentialOperation2 | PotentialOperation2Options;
  locations?: Array<Location | LocationOptions>;
  roomLocations?: Array<ReadyPlanLocation | ReadyPlanLocationOptions>;
  contingencyMarkupPercentage?: PlanPackage["contingencyMarkupPercentage"];
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  documents?: Array<Document | DocumentOptions>;
  insideMapsProjectId?: PlanPackage["insideMapsProjectId"];
  maxInsideMapsRooms?: PlanPackage["maxInsideMapsRooms"];
  insideMapsConfig?: PlanPackage["insideMapsConfig"];
  requiredOptions?: Array<ReadyPlanRequiredOption | ReadyPlanRequiredOptionOptions>;
  owner?: InternalUser | InternalUserOptions | null;
  cloneInProgress?: PlanPackage["cloneInProgress"];
  slotDeletionRequests?: Array<PlanPackageSlotDeletionRequest | PlanPackageSlotDeletionRequestOptions>;
  aiProposal?: PlanPackageAiProposal | PlanPackageAiProposalOptions | null;
}

export function newPlanPackage(options: PlanPackageOptions = {}, cache: Record<string, any> = {}): PlanPackage {
  const o = (options.__typename ? options : cache["PlanPackage"] = {}) as PlanPackage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanPackage";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("PlanPackage");
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.type = enumOrDetailOfReadyPlanType(options.type);
  o.code = options.code ?? null;
  o.displayCode = options.displayCode ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.constructionDocumentCompletePercentage = options.constructionDocumentCompletePercentage ?? 0;
  o.status = enumOrDetailOfReadyPlanStatus(options.status);
  o.effectiveStatus = enumOrDetailOfReadyPlanStatus(options.effectiveStatus);
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.maxProgramData = maybeNew("ProgramData", options.maxProgramData, cache, options.hasOwnProperty("maxProgramData"));
  o.minProgramData = maybeNew("ProgramData", options.minProgramData, cache, options.hasOwnProperty("minProgramData"));
  o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
  o.itemTemplates = (options.itemTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("itemTemplates"))
  );
  o.takeoff = maybeNew("ItemTemplate", options.takeoff, cache, options.hasOwnProperty("takeoff"));
  o.projectConfigs = (options.projectConfigs ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfig", i, cache, options.hasOwnProperty("projectConfigs"))
  );
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.optionGroups = (options.optionGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("optionGroups"))
  );
  o.productOfferings = (options.productOfferings ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("productOfferings"))
  );
  o.designPackages = (options.designPackages ?? []).map((i) =>
    maybeNew("DesignPackage", i, cache, options.hasOwnProperty("designPackages"))
  );
  o.designPackageSources = (options.designPackageSources ?? []).map((i) =>
    maybeNew("DesignPackageSource", i, cache, options.hasOwnProperty("designPackageSources"))
  );
  o.incomingSlots = (options.incomingSlots ?? []).map((i) =>
    maybeNew("PlanPackageIncomingSlot", i, cache, options.hasOwnProperty("incomingSlots"))
  );
  o.lotTypes = options.lotTypes ?? [];
  o.programDatas = (options.programDatas ?? []).map((i) =>
    maybeNew("ReadyPlanProgramData", i, cache, options.hasOwnProperty("programDatas"))
  );
  o.assets = (options.assets ?? []).map((i) => maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("assets")));
  o.activeOptionsCount = options.activeOptionsCount ?? 0;
  o.projectCount = options.projectCount ?? 0;
  o.designPackageCount = options.designPackageCount ?? 0;
  o.productOfferingCount = options.productOfferingCount ?? 0;
  o.asGlobalOption = maybeNewOrNull("GlobalOption", options.asGlobalOption, cache);
  o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
  o.aggregateActive = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateActive, cache);
  o.aggregateDraft = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateDraft, cache);
  o.aggregateLatest = maybeNew(
    "ReadyPlanAggregateVersion",
    options.aggregateLatest,
    cache,
    options.hasOwnProperty("aggregateLatest"),
  );
  o.aggregateVersions = (options.aggregateVersions ?? []).map((i) =>
    maybeNew("ReadyPlanAggregateVersion", i, cache, options.hasOwnProperty("aggregateVersions"))
  );
  o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
  o.itemLocations = (options.itemLocations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("itemLocations"))
  );
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.canEditLineItems = maybeNew(
    "PotentialOperation2",
    options.canEditLineItems,
    cache,
    options.hasOwnProperty("canEditLineItems"),
  );
  o.locations = (options.locations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("locations"))
  );
  o.roomLocations = (options.roomLocations ?? []).map((i) =>
    maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("roomLocations"))
  );
  o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.insideMapsProjectId = options.insideMapsProjectId ?? null;
  o.maxInsideMapsRooms = options.maxInsideMapsRooms ?? 0;
  o.insideMapsConfig = options.insideMapsConfig ?? null;
  o.requiredOptions = (options.requiredOptions ?? []).map((i) =>
    maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("requiredOptions"))
  );
  o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
  o.cloneInProgress = options.cloneInProgress ?? false;
  o.slotDeletionRequests = (options.slotDeletionRequests ?? []).map((i) =>
    maybeNew("PlanPackageSlotDeletionRequest", i, cache, options.hasOwnProperty("slotDeletionRequests"))
  );
  o.aiProposal = maybeNewOrNull("PlanPackageAiProposal", options.aiProposal, cache);
  return o;
}

factories["PlanPackage"] = newPlanPackage;

export interface GlobalOptionOptions {
  __typename?: "GlobalOption";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: GlobalOption["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: GlobalOption["isFollowed"];
  id?: GlobalOption["id"];
  group?: GlobalOptionGroup | GlobalOptionGroupOptions;
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  name?: GlobalOption["name"];
  displayName?: GlobalOption["displayName"];
  blueprintUrl?: Url | UrlOptions;
  description?: GlobalOption["description"];
  isPlanSpecific?: GlobalOption["isPlanSpecific"];
  standardDetailRequired?: GlobalOption["standardDetailRequired"];
  status?: GlobalOption["status"];
  statusDetail?: GlobalOptionStatusDetailOptions | GlobalOptionStatus;
  type?: GlobalOptionType | GlobalOptionTypeOptions;
  locations?: Array<Location | LocationOptions>;
  locationsInUse?: Array<Location | LocationOptions>;
  activeDate?: GlobalOption["activeDate"];
  archivedDate?: GlobalOption["archivedDate"];
  elevationRequired?: GlobalOption["elevationRequired"];
  requiredInPlanDrawing?: GlobalOption["requiredInPlanDrawing"];
  shopDrawingRequired?: GlobalOption["shopDrawingRequired"];
  tags?: Array<GlobalOptionTag | GlobalOptionTagOptions>;
  supportedTags?: Array<GlobalOptionTag | GlobalOptionTagOptions>;
  canEditType?: PotentialOperation2 | PotentialOperation2Options;
  canEditLocations?: PotentialOperation2 | PotentialOperation2Options;
  code?: GlobalOption["code"];
  designUpgradeIconName?: GlobalOption["designUpgradeIconName"];
  defaultOrder?: GlobalOption["defaultOrder"];
  lastUsedAt?: GlobalOption["lastUsedAt"];
  createdAt?: GlobalOption["createdAt"];
  updatedAt?: GlobalOption["updatedAt"];
  asset?: Asset | AssetOptions | null;
  estimatedLeadTimeInDays?: GlobalOption["estimatedLeadTimeInDays"];
  marketingDescription?: GlobalOption["marketingDescription"];
  permits?: GlobalOption["permits"];
  attachments?: Array<Attachment | AttachmentOptions>;
  materialVariant?: MaterialVariant | MaterialVariantOptions | null;
  optionPricingConfig?: OptionPricingConfig | OptionPricingConfigOptions | null;
  version?: GlobalOption["version"];
  history?: Array<History | HistoryOptions>;
  readyPlan?: ReadyPlan | ReadyPlanOptions | null;
}

export function newGlobalOption(options: GlobalOptionOptions = {}, cache: Record<string, any> = {}): GlobalOption {
  const o = (options.__typename ? options : cache["GlobalOption"] = {}) as GlobalOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalOption";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("GlobalOption");
  o.group = maybeNew("GlobalOptionGroup", options.group, cache, options.hasOwnProperty("group"));
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.description = options.description ?? null;
  o.isPlanSpecific = options.isPlanSpecific ?? null;
  o.standardDetailRequired = options.standardDetailRequired ?? null;
  o.status = options.status ?? GlobalOptionStatus.Active;
  o.statusDetail = enumOrDetailOfGlobalOptionStatus(options.statusDetail);
  o.type = maybeNew("GlobalOptionType", options.type, cache, options.hasOwnProperty("type"));
  o.locations = (options.locations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("locations"))
  );
  o.locationsInUse = (options.locationsInUse ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("locationsInUse"))
  );
  o.activeDate = options.activeDate ?? null;
  o.archivedDate = options.archivedDate ?? null;
  o.elevationRequired = options.elevationRequired ?? null;
  o.requiredInPlanDrawing = options.requiredInPlanDrawing ?? null;
  o.shopDrawingRequired = options.shopDrawingRequired ?? null;
  o.tags = (options.tags ?? []).map((i) => maybeNew("GlobalOptionTag", i, cache, options.hasOwnProperty("tags")));
  o.supportedTags = (options.supportedTags ?? []).map((i) =>
    maybeNew("GlobalOptionTag", i, cache, options.hasOwnProperty("supportedTags"))
  );
  o.canEditType = maybeNew("PotentialOperation2", options.canEditType, cache, options.hasOwnProperty("canEditType"));
  o.canEditLocations = maybeNew(
    "PotentialOperation2",
    options.canEditLocations,
    cache,
    options.hasOwnProperty("canEditLocations"),
  );
  o.code = options.code ?? "code";
  o.designUpgradeIconName = options.designUpgradeIconName ?? null;
  o.defaultOrder = options.defaultOrder ?? null;
  o.lastUsedAt = options.lastUsedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.asset = maybeNewOrNull("Asset", options.asset, cache);
  o.estimatedLeadTimeInDays = options.estimatedLeadTimeInDays ?? 0;
  o.marketingDescription = options.marketingDescription ?? null;
  o.permits = options.permits ?? [];
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
  o.optionPricingConfig = maybeNewOrNull("OptionPricingConfig", options.optionPricingConfig, cache);
  o.version = options.version ?? 0;
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.readyPlan = maybeNewOrNull("ReadyPlan", options.readyPlan, cache);
  return o;
}

factories["GlobalOption"] = newGlobalOption;

export interface ProjectCostCodeOptions {
  __typename?: "ProjectCostCode";
  references?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ProjectCostCode["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ProjectCostCode["isFollowed"];
  id?: ProjectCostCode["id"];
  name?: ProjectCostCode["name"];
  blueprintUrl?: Url | UrlOptions;
  costCode?: CostCode | CostCodeOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
  committedAtStartInCents?: ProjectCostCode["committedAtStartInCents"];
  originalCostInCents?: ProjectCostCode["originalCostInCents"];
  startCostInCents?: ProjectCostCode["startCostInCents"];
  changeEventCostInCents?: ProjectCostCode["changeEventCostInCents"];
  revisedCostInCents?: ProjectCostCode["revisedCostInCents"];
  projectedCostInCents?: ProjectCostCode["projectedCostInCents"];
  committedCostInCents?: ProjectCostCode["committedCostInCents"];
  availableCostInCents?: ProjectCostCode["availableCostInCents"];
  billedCostInCents?: ProjectCostCode["billedCostInCents"];
  unbilledCostInCents?: ProjectCostCode["unbilledCostInCents"];
}

export function newProjectCostCode(
  options: ProjectCostCodeOptions = {},
  cache: Record<string, any> = {},
): ProjectCostCode {
  const o = (options.__typename ? options : cache["ProjectCostCode"] = {}) as ProjectCostCode;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectCostCode";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("ProjectCostCode");
  o.name = options.name ?? "name";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  o.committedAtStartInCents = options.committedAtStartInCents ?? 0;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  return o;
}

factories["ProjectCostCode"] = newProjectCostCode;

export interface CommentOptions {
  __typename?: "Comment";
  id?: Comment["id"];
  html?: Comment["html"];
  text?: Comment["text"];
  createdAt?: Comment["createdAt"];
  updatedAt?: Comment["updatedAt"];
  stream?: CommentStream | CommentStreamOptions;
  author?: User | UserOptions;
  permissions?: Permissions | PermissionsOptions;
  attachments?: Array<Attachment | AttachmentOptions>;
  tags?: Array<CommentTag | CommentTagOptions>;
}

export function newComment(options: CommentOptions = {}, cache: Record<string, any> = {}): Comment {
  const o = (options.__typename ? options : cache["Comment"] = {}) as Comment;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Comment";
  o.id = options.id ?? nextFactoryId("Comment");
  o.html = options.html ?? "html";
  o.text = options.text ?? "text";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.stream = maybeNew("CommentStream", options.stream, cache, options.hasOwnProperty("stream"));
  o.author = maybeNew("User", options.author, cache, options.hasOwnProperty("author"));
  o.permissions = maybeNew("Permissions", options.permissions, cache, options.hasOwnProperty("permissions"));
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  o.tags = (options.tags ?? []).map((i) => maybeNew("CommentTag", i, cache, options.hasOwnProperty("tags")));
  return o;
}

factories["Comment"] = newComment;

export interface SaveCommentResultOptions {
  __typename?: "SaveCommentResult";
  comment?: Comment | CommentOptions | null;
  userErrors?: Array<UserError | UserErrorOptions>;
}

export function newSaveCommentResult(
  options: SaveCommentResultOptions = {},
  cache: Record<string, any> = {},
): SaveCommentResult {
  const o = (options.__typename ? options : cache["SaveCommentResult"] = {}) as SaveCommentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCommentResult";
  o.comment = maybeNewOrNull("Comment", options.comment, cache);
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["SaveCommentResult"] = newSaveCommentResult;

export interface DeleteCommentResultOptions {
  __typename?: "DeleteCommentResult";
  stream?: CommentStream | CommentStreamOptions | null;
  userErrors?: Array<UserError | UserErrorOptions>;
}

export function newDeleteCommentResult(
  options: DeleteCommentResultOptions = {},
  cache: Record<string, any> = {},
): DeleteCommentResult {
  const o = (options.__typename ? options : cache["DeleteCommentResult"] = {}) as DeleteCommentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteCommentResult";
  o.stream = maybeNewOrNull("CommentStream", options.stream, cache);
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["DeleteCommentResult"] = newDeleteCommentResult;

export interface CommentStreamOptions {
  __typename?: "CommentStream";
  id?: CommentStream["id"];
  streamVisibility?: CommentStreamVisibilityDetailOptions | CommentStreamVisibility;
  name?: CommentStream["name"];
  commentable?:
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Commentable
    | CommentableOptions;
  comments?: Array<Comment | CommentOptions>;
  latestComment?: Comment | CommentOptions | null;
  commentCount?: CommentStream["commentCount"];
  unreadCount?: CommentStream["unreadCount"];
  fromAddress?: CommentStream["fromAddress"];
  tradePartnerUsers?: Array<TradePartnerUser | TradePartnerUserOptions>;
}

export function newCommentStream(options: CommentStreamOptions = {}, cache: Record<string, any> = {}): CommentStream {
  const o = (options.__typename ? options : cache["CommentStream"] = {}) as CommentStream;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommentStream";
  o.id = options.id ?? nextFactoryId("CommentStream");
  o.streamVisibility = enumOrDetailOfCommentStreamVisibility(options.streamVisibility);
  o.name = options.name ?? "name";
  o.commentable = maybeNew("Commentable", options.commentable, cache, options.hasOwnProperty("commentable"));
  o.comments = (options.comments ?? []).map((i) => maybeNew("Comment", i, cache, options.hasOwnProperty("comments")));
  o.latestComment = maybeNewOrNull("Comment", options.latestComment, cache);
  o.commentCount = options.commentCount ?? 0;
  o.unreadCount = options.unreadCount ?? 0;
  o.fromAddress = options.fromAddress ?? "fromAddress";
  o.tradePartnerUsers = (options.tradePartnerUsers ?? []).map((i) =>
    maybeNew("TradePartnerUser", i, cache, options.hasOwnProperty("tradePartnerUsers"))
  );
  return o;
}

factories["CommentStream"] = newCommentStream;

export interface CommentStreamsOptions {
  __typename?: "CommentStreams";
  internalStream?: CommentStream | CommentStreamOptions | null;
  tradesStream?: CommentStream | CommentStreamOptions | null;
  homeownerStream?: CommentStream | CommentStreamOptions | null;
  commentCount?: CommentStreams["commentCount"];
}

export function newCommentStreams(
  options: CommentStreamsOptions = {},
  cache: Record<string, any> = {},
): CommentStreams {
  const o = (options.__typename ? options : cache["CommentStreams"] = {}) as CommentStreams;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommentStreams";
  o.internalStream = maybeNewOrNull("CommentStream", options.internalStream, cache);
  o.tradesStream = maybeNewOrNull("CommentStream", options.tradesStream, cache);
  o.homeownerStream = maybeNewOrNull("CommentStream", options.homeownerStream, cache);
  o.commentCount = options.commentCount ?? 0;
  return o;
}

factories["CommentStreams"] = newCommentStreams;

export interface UserRelevantCommentStreamsResultOptions {
  __typename?: "UserRelevantCommentStreamsResult";
  entities?: Array<CommentStream | CommentStreamOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newUserRelevantCommentStreamsResult(
  options: UserRelevantCommentStreamsResultOptions = {},
  cache: Record<string, any> = {},
): UserRelevantCommentStreamsResult {
  const o =
    (options.__typename ? options : cache["UserRelevantCommentStreamsResult"] = {}) as UserRelevantCommentStreamsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserRelevantCommentStreamsResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["UserRelevantCommentStreamsResult"] = newUserRelevantCommentStreamsResult;

export interface CommentTagOptions {
  __typename?: "CommentTag";
  id?: CommentTag["id"];
  createdAt?: CommentTag["createdAt"];
  updatedAt?: CommentTag["updatedAt"];
  comment?: Comment | CommentOptions;
  internalUser?: InternalUser | InternalUserOptions;
}

export function newCommentTag(options: CommentTagOptions = {}, cache: Record<string, any> = {}): CommentTag {
  const o = (options.__typename ? options : cache["CommentTag"] = {}) as CommentTag;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommentTag";
  o.id = options.id ?? nextFactoryId("CommentTag");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.comment = maybeNew("Comment", options.comment, cache, options.hasOwnProperty("comment"));
  o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
  return o;
}

factories["CommentTag"] = newCommentTag;

export interface ProjectStageOptions {
  __typename?: "ProjectStage";
  commitments?: Array<Commitment | CommitmentOptions>;
  commitmentLikes?: Array<Commitment | CommitmentChangeOrder | CommitmentLike | CommitmentLikeOptions>;
  homeownerContracts?: Array<HomeownerContract | HomeownerContractOptions>;
  id?: ProjectStage["id"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  stage?: StageDetailOptions | Stage;
  hasSignedContract?: ProjectStage["hasSignedContract"];
  canEditProjectItemsDirectly?: ProjectStage["canEditProjectItemsDirectly"];
  canEditProjectScope?: PotentialOperation2 | PotentialOperation2Options;
  canCreateFinalEstimate?: ProjectStage["canCreateFinalEstimate"];
  canCompleteStage?: PotentialOperation2 | PotentialOperation2Options;
  canPublishSchedule?: PotentialOperation | PotentialOperationOptions;
  nextStage?: ProjectStage | ProjectStageOptions | null;
  previousStage?: ProjectStage | ProjectStageOptions | null;
  status?: ProjectStageStatusDetailOptions | ProjectStageStatus;
  interval?: CalendarInterval | CalendarIntervalOptions;
  baselineInterval?: CalendarInterval | CalendarIntervalOptions;
  schedulePhases?: Array<SchedulePhase | SchedulePhaseOptions>;
  bills?: Array<Bill | BillOptions>;
  priceInCents?: ProjectStage["priceInCents"];
  progress?: StageProgress | StageProgressOptions;
  cmsId?: ProjectStage["cmsId"];
  invoices?: Array<Invoice | InvoiceOptions>;
  homeownerFinancials?: ProjectStageHomeownerFinancials | ProjectStageHomeownerFinancialsOptions;
  estimates?: Array<Estimate | EstimateOptions>;
  hocFinancials?: ProjectStageHocFinancials | ProjectStageHocFinancialsOptions;
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
  itemLocations?: Array<Location | LocationOptions>;
  costCodes?: Array<CostCode | CostCodeOptions>;
  changeEvents?: Array<ChangeEvent | ChangeEventOptions>;
  totalCostInCents?: ProjectStage["totalCostInCents"];
  clientPresentationDate?: ProjectStage["clientPresentationDate"];
  appliedTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
  templateConfigs?: Array<ProjectStageTemplateConfig | ProjectStageTemplateConfigOptions>;
  readyHomePlanTemplate?: ProjectStageTemplateConfig | ProjectStageTemplateConfigOptions | null;
  percentReleased?: ProjectStage["percentReleased"];
  unallocatedExpenses?: Array<Expense | ExpenseOptions>;
  hasDrawsToInvoice?: ProjectStage["hasDrawsToInvoice"];
  hasCostsToInvoice?: ProjectStage["hasCostsToInvoice"];
  hasFixedToInvoice?: ProjectStage["hasFixedToInvoice"];
  workAuthorizations?: Array<WorkAuthorization | WorkAuthorizationOptions>;
  allContractDraws?: Array<HomeownerContractDraw | HomeownerContractDrawOptions>;
}

export function newProjectStage(options: ProjectStageOptions = {}, cache: Record<string, any> = {}): ProjectStage {
  const o = (options.__typename ? options : cache["ProjectStage"] = {}) as ProjectStage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectStage";
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.commitmentLikes = (options.commitmentLikes ?? []).map((i) =>
    maybeNew("CommitmentLike", i, cache, options.hasOwnProperty("commitmentLikes"))
  );
  o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
    maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
  );
  o.id = options.id ?? nextFactoryId("ProjectStage");
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.stage = enumOrDetailOfStage(options.stage);
  o.hasSignedContract = options.hasSignedContract ?? false;
  o.canEditProjectItemsDirectly = options.canEditProjectItemsDirectly ?? false;
  o.canEditProjectScope = maybeNew(
    "PotentialOperation2",
    options.canEditProjectScope,
    cache,
    options.hasOwnProperty("canEditProjectScope"),
  );
  o.canCreateFinalEstimate = options.canCreateFinalEstimate ?? false;
  o.canCompleteStage = maybeNew(
    "PotentialOperation2",
    options.canCompleteStage,
    cache,
    options.hasOwnProperty("canCompleteStage"),
  );
  o.canPublishSchedule = maybeNew(
    "PotentialOperation",
    options.canPublishSchedule,
    cache,
    options.hasOwnProperty("canPublishSchedule"),
  );
  o.nextStage = maybeNewOrNull("ProjectStage", options.nextStage, cache);
  o.previousStage = maybeNewOrNull("ProjectStage", options.previousStage, cache);
  o.status = enumOrDetailOfProjectStageStatus(options.status);
  o.interval = maybeNew("CalendarInterval", options.interval, cache, options.hasOwnProperty("interval"));
  o.baselineInterval = maybeNew(
    "CalendarInterval",
    options.baselineInterval,
    cache,
    options.hasOwnProperty("baselineInterval"),
  );
  o.schedulePhases = (options.schedulePhases ?? []).map((i) =>
    maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("schedulePhases"))
  );
  o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
  o.priceInCents = options.priceInCents ?? 0;
  o.progress = maybeNew("StageProgress", options.progress, cache, options.hasOwnProperty("progress"));
  o.cmsId = options.cmsId ?? null;
  o.invoices = (options.invoices ?? []).map((i) => maybeNew("Invoice", i, cache, options.hasOwnProperty("invoices")));
  o.homeownerFinancials = maybeNew(
    "ProjectStageHomeownerFinancials",
    options.homeownerFinancials,
    cache,
    options.hasOwnProperty("homeownerFinancials"),
  );
  o.estimates = (options.estimates ?? []).map((i) =>
    maybeNew("Estimate", i, cache, options.hasOwnProperty("estimates"))
  );
  o.hocFinancials = maybeNew(
    "ProjectStageHocFinancials",
    options.hocFinancials,
    cache,
    options.hasOwnProperty("hocFinancials"),
  );
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  o.itemLocations = (options.itemLocations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("itemLocations"))
  );
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.changeEvents = (options.changeEvents ?? []).map((i) =>
    maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("changeEvents"))
  );
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.clientPresentationDate = options.clientPresentationDate ?? null;
  o.appliedTemplates = (options.appliedTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("appliedTemplates"))
  );
  o.templateConfigs = (options.templateConfigs ?? []).map((i) =>
    maybeNew("ProjectStageTemplateConfig", i, cache, options.hasOwnProperty("templateConfigs"))
  );
  o.readyHomePlanTemplate = maybeNewOrNull("ProjectStageTemplateConfig", options.readyHomePlanTemplate, cache);
  o.percentReleased = options.percentReleased ?? 0;
  o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
    maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
  );
  o.hasDrawsToInvoice = options.hasDrawsToInvoice ?? false;
  o.hasCostsToInvoice = options.hasCostsToInvoice ?? false;
  o.hasFixedToInvoice = options.hasFixedToInvoice ?? false;
  o.workAuthorizations = (options.workAuthorizations ?? []).map((i) =>
    maybeNew("WorkAuthorization", i, cache, options.hasOwnProperty("workAuthorizations"))
  );
  o.allContractDraws = (options.allContractDraws ?? []).map((i) =>
    maybeNew("HomeownerContractDraw", i, cache, options.hasOwnProperty("allContractDraws"))
  );
  return o;
}

factories["ProjectStage"] = newProjectStage;

export interface CommitmentLineItemSummaryOptions {
  __typename?: "CommitmentLineItemSummary";
  costCode?: CostCode | CostCodeOptions;
  committedInCents?: CommitmentLineItemSummary["committedInCents"];
  changeOrderInCents?: CommitmentLineItemSummary["changeOrderInCents"];
  totalCommittedInCents?: CommitmentLineItemSummary["totalCommittedInCents"];
  billedInCents?: CommitmentLineItemSummary["billedInCents"];
  paidInCents?: CommitmentLineItemSummary["paidInCents"];
  balanceInCents?: CommitmentLineItemSummary["balanceInCents"];
}

export function newCommitmentLineItemSummary(
  options: CommitmentLineItemSummaryOptions = {},
  cache: Record<string, any> = {},
): CommitmentLineItemSummary {
  const o = (options.__typename ? options : cache["CommitmentLineItemSummary"] = {}) as CommitmentLineItemSummary;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentLineItemSummary";
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.committedInCents = options.committedInCents ?? 0;
  o.changeOrderInCents = options.changeOrderInCents ?? 0;
  o.totalCommittedInCents = options.totalCommittedInCents ?? 0;
  o.billedInCents = options.billedInCents ?? 0;
  o.paidInCents = options.paidInCents ?? 0;
  o.balanceInCents = options.balanceInCents ?? 0;
  return o;
}

factories["CommitmentLineItemSummary"] = newCommitmentLineItemSummary;

export interface CommitmentsPageOptions {
  __typename?: "CommitmentsPage";
  commitments?: Array<Commitment | CommitmentOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newCommitmentsPage(
  options: CommitmentsPageOptions = {},
  cache: Record<string, any> = {},
): CommitmentsPage {
  const o = (options.__typename ? options : cache["CommitmentsPage"] = {}) as CommitmentsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentsPage";
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["CommitmentsPage"] = newCommitmentsPage;

export interface PotentialBidContractRevisionOptions {
  __typename?: "PotentialBidContractRevision";
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
  totalCostInCents?: PotentialBidContractRevision["totalCostInCents"];
}

export function newPotentialBidContractRevision(
  options: PotentialBidContractRevisionOptions = {},
  cache: Record<string, any> = {},
): PotentialBidContractRevision {
  const o = (options.__typename ? options : cache["PotentialBidContractRevision"] = {}) as PotentialBidContractRevision;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PotentialBidContractRevision";
  o.bidContractRevision = maybeNew(
    "BidContractRevision",
    options.bidContractRevision,
    cache,
    options.hasOwnProperty("bidContractRevision"),
  );
  o.totalCostInCents = options.totalCostInCents ?? 0;
  return o;
}

factories["PotentialBidContractRevision"] = newPotentialBidContractRevision;

export interface CommitmentCostCodeSummaryOptions {
  __typename?: "CommitmentCostCodeSummary";
  lineItems?: Array<CommitmentCostCodeSummaryLineItem | CommitmentCostCodeSummaryLineItemOptions>;
}

export function newCommitmentCostCodeSummary(
  options: CommitmentCostCodeSummaryOptions = {},
  cache: Record<string, any> = {},
): CommitmentCostCodeSummary {
  const o = (options.__typename ? options : cache["CommitmentCostCodeSummary"] = {}) as CommitmentCostCodeSummary;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentCostCodeSummary";
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("CommitmentCostCodeSummaryLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  return o;
}

factories["CommitmentCostCodeSummary"] = newCommitmentCostCodeSummary;

export interface CommitmentCostCodeSummaryLineItemOptions {
  __typename?: "CommitmentCostCodeSummaryLineItem";
  costCode?: CostCode | CostCodeOptions;
  quantity?: CommitmentCostCodeSummaryLineItem["quantity"];
}

export function newCommitmentCostCodeSummaryLineItem(
  options: CommitmentCostCodeSummaryLineItemOptions = {},
  cache: Record<string, any> = {},
): CommitmentCostCodeSummaryLineItem {
  const o =
    (options.__typename
      ? options
      : cache["CommitmentCostCodeSummaryLineItem"] = {}) as CommitmentCostCodeSummaryLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentCostCodeSummaryLineItem";
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.quantity = options.quantity ?? 0;
  return o;
}

factories["CommitmentCostCodeSummaryLineItem"] = newCommitmentCostCodeSummaryLineItem;

export interface SaveCommitmentResultOptions {
  __typename?: "SaveCommitmentResult";
  commitment?: Commitment | CommitmentOptions;
}

export function newSaveCommitmentResult(
  options: SaveCommitmentResultOptions = {},
  cache: Record<string, any> = {},
): SaveCommitmentResult {
  const o = (options.__typename ? options : cache["SaveCommitmentResult"] = {}) as SaveCommitmentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCommitmentResult";
  o.commitment = maybeNew("Commitment", options.commitment, cache, options.hasOwnProperty("commitment"));
  return o;
}

factories["SaveCommitmentResult"] = newSaveCommitmentResult;

export interface SaveCommitmentsResultOptions {
  __typename?: "SaveCommitmentsResult";
  commitments?: Array<Commitment | CommitmentOptions>;
}

export function newSaveCommitmentsResult(
  options: SaveCommitmentsResultOptions = {},
  cache: Record<string, any> = {},
): SaveCommitmentsResult {
  const o = (options.__typename ? options : cache["SaveCommitmentsResult"] = {}) as SaveCommitmentsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCommitmentsResult";
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  return o;
}

factories["SaveCommitmentsResult"] = newSaveCommitmentsResult;

export interface CreateCommitmentFromBillResultOptions {
  __typename?: "CreateCommitmentFromBillResult";
  commitment?: Commitment | CommitmentOptions | null;
  changeEvent?: ChangeEvent | ChangeEventOptions | null;
}

export function newCreateCommitmentFromBillResult(
  options: CreateCommitmentFromBillResultOptions = {},
  cache: Record<string, any> = {},
): CreateCommitmentFromBillResult {
  const o =
    (options.__typename ? options : cache["CreateCommitmentFromBillResult"] = {}) as CreateCommitmentFromBillResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateCommitmentFromBillResult";
  o.commitment = maybeNewOrNull("Commitment", options.commitment, cache);
  o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
  return o;
}

factories["CreateCommitmentFromBillResult"] = newCreateCommitmentFromBillResult;

export interface CommitmentBillingScheduleItemOptions {
  __typename?: "CommitmentBillingScheduleItem";
  commitmentDraw?: CommitmentDraw | CommitmentDrawOptions | null;
  isDeposit?: CommitmentBillingScheduleItem["isDeposit"];
  committedInCents?: CommitmentBillingScheduleItem["committedInCents"];
  pendingBilledInCents?: CommitmentBillingScheduleItem["pendingBilledInCents"];
  pendingUnbilledInCents?: CommitmentBillingScheduleItem["pendingUnbilledInCents"];
  lineItems?: Array<CommitmentBillingScheduleLineItem | CommitmentBillingScheduleLineItemOptions>;
}

export function newCommitmentBillingScheduleItem(
  options: CommitmentBillingScheduleItemOptions = {},
  cache: Record<string, any> = {},
): CommitmentBillingScheduleItem {
  const o =
    (options.__typename ? options : cache["CommitmentBillingScheduleItem"] = {}) as CommitmentBillingScheduleItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentBillingScheduleItem";
  o.commitmentDraw = maybeNewOrNull("CommitmentDraw", options.commitmentDraw, cache);
  o.isDeposit = options.isDeposit ?? false;
  o.committedInCents = options.committedInCents ?? 0;
  o.pendingBilledInCents = options.pendingBilledInCents ?? 0;
  o.pendingUnbilledInCents = options.pendingUnbilledInCents ?? 0;
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("CommitmentBillingScheduleLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  return o;
}

factories["CommitmentBillingScheduleItem"] = newCommitmentBillingScheduleItem;

export interface CommitmentBillingScheduleLineItemOptions {
  __typename?: "CommitmentBillingScheduleLineItem";
  amountInCents?: CommitmentBillingScheduleLineItem["amountInCents"];
  commitmentLineItem?: CommitmentLineItem | CommitmentLineItemOptions;
}

export function newCommitmentBillingScheduleLineItem(
  options: CommitmentBillingScheduleLineItemOptions = {},
  cache: Record<string, any> = {},
): CommitmentBillingScheduleLineItem {
  const o =
    (options.__typename
      ? options
      : cache["CommitmentBillingScheduleLineItem"] = {}) as CommitmentBillingScheduleLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentBillingScheduleLineItem";
  o.amountInCents = options.amountInCents ?? 0;
  o.commitmentLineItem = maybeNew(
    "CommitmentLineItem",
    options.commitmentLineItem,
    cache,
    options.hasOwnProperty("commitmentLineItem"),
  );
  return o;
}

factories["CommitmentBillingScheduleLineItem"] = newCommitmentBillingScheduleLineItem;

export interface TaskPurchaseOrderRowOptions {
  __typename?: "TaskPurchaseOrderRow";
  commitmentLike?: Commitment | CommitmentChangeOrder | CommitmentLike | CommitmentLikeOptions;
  committedInCents?: TaskPurchaseOrderRow["committedInCents"];
  unbilledInCents?: TaskPurchaseOrderRow["unbilledInCents"];
  changeOrders?: Array<TaskPurchaseOrderRow | TaskPurchaseOrderRowOptions>;
}

export function newTaskPurchaseOrderRow(
  options: TaskPurchaseOrderRowOptions = {},
  cache: Record<string, any> = {},
): TaskPurchaseOrderRow {
  const o = (options.__typename ? options : cache["TaskPurchaseOrderRow"] = {}) as TaskPurchaseOrderRow;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TaskPurchaseOrderRow";
  o.commitmentLike = maybeNew(
    "CommitmentLike",
    options.commitmentLike,
    cache,
    options.hasOwnProperty("commitmentLike"),
  );
  o.committedInCents = options.committedInCents ?? 0;
  o.unbilledInCents = options.unbilledInCents ?? 0;
  o.changeOrders = (options.changeOrders ?? []).map((i) =>
    maybeNew("TaskPurchaseOrderRow", i, cache, options.hasOwnProperty("changeOrders"))
  );
  return o;
}

factories["TaskPurchaseOrderRow"] = newTaskPurchaseOrderRow;

export interface CommitmentChangeOrderOptions {
  __typename?: "CommitmentChangeOrder";
  id?: CommitmentChangeOrder["id"];
  accountingNumber?: CommitmentChangeOrder["accountingNumber"];
  name?: CommitmentChangeOrder["name"];
  displayName?: CommitmentChangeOrder["displayName"];
  shortName?: CommitmentChangeOrder["shortName"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  commitment?: Commitment | CommitmentOptions;
  commitmentType?: CommitmentTypeDetailOptions | CommitmentType;
  identifier?: CommitmentChangeOrder["identifier"];
  costChangeInCents?: CommitmentChangeOrder["costChangeInCents"];
  internalNote?: CommitmentChangeOrder["internalNote"];
  executionDate?: CommitmentChangeOrder["executionDate"];
  createdAt?: CommitmentChangeOrder["createdAt"];
  document?: Document | DocumentOptions | null;
  lineItems?: Array<CommitmentLineItem | CommitmentLineItemOptions>;
  bills?: Array<Bill | BillOptions>;
  committedInCents?: CommitmentChangeOrder["committedInCents"];
  taxableCostInCents?: CommitmentChangeOrder["taxableCostInCents"];
  remainingInCents?: CommitmentChangeOrder["remainingInCents"];
  pendingRemainingInCents?: CommitmentChangeOrder["pendingRemainingInCents"];
  billedInCents?: CommitmentChangeOrder["billedInCents"];
  pendingBilledInCents?: CommitmentChangeOrder["pendingBilledInCents"];
  unbilledInCents?: CommitmentChangeOrder["unbilledInCents"];
  paidInCents?: CommitmentChangeOrder["paidInCents"];
  balanceInCents?: CommitmentChangeOrder["balanceInCents"];
  blueprintUrl?: Url | UrlOptions;
  updatedAt?: CommitmentChangeOrder["updatedAt"];
  tradeCategories?: Array<TradeCategory | TradeCategoryOptions>;
  tradePartner?: TradePartner | TradePartnerOptions | null;
  changeEvent?: ChangeEvent | ChangeEventOptions | null;
  status?: CommitmentChangeOrder["status"];
  statusDetail?: CommitmentStatusDetailOptions | CommitmentStatus;
  statusText?: CommitmentChangeOrder["statusText"];
  pandaDoc?: PandaDoc | PandaDocOptions | null;
  canEditLineItems?: PotentialOperation2 | PotentialOperation2Options;
  canCreatePandaDoc?: PotentialOperation2 | PotentialOperation2Options;
  isBidCommitment?: CommitmentChangeOrder["isBidCommitment"];
  canBeEdited?: CommitmentChangeOrder["canBeEdited"];
  costCodes?: Array<CostCode | CostCodeOptions>;
  items?: Array<Item | ItemOptions>;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  canVoid?: PotentialOperation2 | PotentialOperation2Options;
  canBeReleased?: PotentialOperation2 | PotentialOperation2Options;
  tradeSignatory?: TradePartnerContact | TradePartnerContactOptions | null;
  percentagePaid?: CommitmentChangeOrder["percentagePaid"];
  sentDate?: CommitmentChangeOrder["sentDate"];
  referenceNumber?: CommitmentChangeOrder["referenceNumber"];
}

export function newCommitmentChangeOrder(
  options: CommitmentChangeOrderOptions = {},
  cache: Record<string, any> = {},
): CommitmentChangeOrder {
  const o = (options.__typename ? options : cache["CommitmentChangeOrder"] = {}) as CommitmentChangeOrder;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentChangeOrder";
  o.id = options.id ?? nextFactoryId("CommitmentChangeOrder");
  o.accountingNumber = options.accountingNumber ?? 0;
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.shortName = options.shortName ?? "shortName";
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.commitment = maybeNew("Commitment", options.commitment, cache, options.hasOwnProperty("commitment"));
  o.commitmentType = enumOrDetailOfCommitmentType(options.commitmentType);
  o.identifier = options.identifier ?? "identifier";
  o.costChangeInCents = options.costChangeInCents ?? 0;
  o.internalNote = options.internalNote ?? null;
  o.executionDate = options.executionDate ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("CommitmentLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
  o.committedInCents = options.committedInCents ?? 0;
  o.taxableCostInCents = options.taxableCostInCents ?? 0;
  o.remainingInCents = options.remainingInCents ?? 0;
  o.pendingRemainingInCents = options.pendingRemainingInCents ?? 0;
  o.billedInCents = options.billedInCents ?? null;
  o.pendingBilledInCents = options.pendingBilledInCents ?? null;
  o.unbilledInCents = options.unbilledInCents ?? 0;
  o.paidInCents = options.paidInCents ?? null;
  o.balanceInCents = options.balanceInCents ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tradeCategories = (options.tradeCategories ?? []).map((i) =>
    maybeNew("TradeCategory", i, cache, options.hasOwnProperty("tradeCategories"))
  );
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
  o.status = options.status ?? CommitmentStatus.Draft;
  o.statusDetail = enumOrDetailOfCommitmentStatus(options.statusDetail);
  o.statusText = options.statusText ?? "statusText";
  o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
  o.canEditLineItems = maybeNew(
    "PotentialOperation2",
    options.canEditLineItems,
    cache,
    options.hasOwnProperty("canEditLineItems"),
  );
  o.canCreatePandaDoc = maybeNew(
    "PotentialOperation2",
    options.canCreatePandaDoc,
    cache,
    options.hasOwnProperty("canCreatePandaDoc"),
  );
  o.isBidCommitment = options.isBidCommitment ?? false;
  o.canBeEdited = options.canBeEdited ?? false;
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.items = (options.items ?? []).map((i) => maybeNew("Item", i, cache, options.hasOwnProperty("items")));
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.canVoid = maybeNew("PotentialOperation2", options.canVoid, cache, options.hasOwnProperty("canVoid"));
  o.canBeReleased = maybeNew(
    "PotentialOperation2",
    options.canBeReleased,
    cache,
    options.hasOwnProperty("canBeReleased"),
  );
  o.tradeSignatory = maybeNewOrNull("TradePartnerContact", options.tradeSignatory, cache);
  o.percentagePaid = options.percentagePaid ?? 0;
  o.sentDate = options.sentDate ?? null;
  o.referenceNumber = options.referenceNumber ?? null;
  return o;
}

factories["CommitmentChangeOrder"] = newCommitmentChangeOrder;

export interface SaveCommitmentChangeOrderResultOptions {
  __typename?: "SaveCommitmentChangeOrderResult";
  commitmentChangeOrder?: CommitmentChangeOrder | CommitmentChangeOrderOptions;
}

export function newSaveCommitmentChangeOrderResult(
  options: SaveCommitmentChangeOrderResultOptions = {},
  cache: Record<string, any> = {},
): SaveCommitmentChangeOrderResult {
  const o =
    (options.__typename ? options : cache["SaveCommitmentChangeOrderResult"] = {}) as SaveCommitmentChangeOrderResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCommitmentChangeOrderResult";
  o.commitmentChangeOrder = maybeNew(
    "CommitmentChangeOrder",
    options.commitmentChangeOrder,
    cache,
    options.hasOwnProperty("commitmentChangeOrder"),
  );
  return o;
}

factories["SaveCommitmentChangeOrderResult"] = newSaveCommitmentChangeOrderResult;

export interface CommitmentDrawOptions {
  __typename?: "CommitmentDraw";
  id?: CommitmentDraw["id"];
  amountInBasisPoints?: CommitmentDraw["amountInBasisPoints"];
  description?: CommitmentDraw["description"];
  createdAt?: CommitmentDraw["createdAt"];
  updatedAt?: CommitmentDraw["updatedAt"];
  bidContractRevisionDraw?: BidContractRevisionDraw | BidContractRevisionDrawOptions | null;
  commitment?: Commitment | CommitmentOptions;
  task?: Task | TaskOptions;
  costCode?: CostCode | CostCodeOptions;
}

export function newCommitmentDraw(
  options: CommitmentDrawOptions = {},
  cache: Record<string, any> = {},
): CommitmentDraw {
  const o = (options.__typename ? options : cache["CommitmentDraw"] = {}) as CommitmentDraw;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentDraw";
  o.id = options.id ?? nextFactoryId("CommitmentDraw");
  o.amountInBasisPoints = options.amountInBasisPoints ?? 0;
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.bidContractRevisionDraw = maybeNewOrNull("BidContractRevisionDraw", options.bidContractRevisionDraw, cache);
  o.commitment = maybeNew("Commitment", options.commitment, cache, options.hasOwnProperty("commitment"));
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  return o;
}

factories["CommitmentDraw"] = newCommitmentDraw;

export interface CommitmentLineItemOptions {
  __typename?: "CommitmentLineItem";
  id?: CommitmentLineItem["id"];
  owner?: Commitment | CommitmentChangeOrder | CommitmentLike | CommitmentLikeOptions;
  ownerCommitment?: Commitment | CommitmentOptions;
  costChangeInCents?: CommitmentLineItem["costChangeInCents"];
  internalNote?: CommitmentLineItem["internalNote"];
  costCode?: CostCode | CostCodeOptions;
  committedInCents?: CommitmentLineItem["committedInCents"];
  billedInCents?: CommitmentLineItem["billedInCents"];
  unbilledInCents?: CommitmentLineItem["unbilledInCents"];
  pendingBilledInCents?: CommitmentLineItem["pendingBilledInCents"];
  pendingUnbilledInCents?: CommitmentLineItem["pendingUnbilledInCents"];
  billableLimitInCents?: CommitmentLineItem["billableLimitInCents"];
  paidInCents?: CommitmentLineItem["paidInCents"];
  balanceInCents?: CommitmentLineItem["balanceInCents"];
  quantity?: CommitmentLineItem["quantity"];
  projectItem?: ProjectItem | ProjectItemOptions;
  specifications?: CommitmentLineItem["specifications"];
  tradePartnerNote?: CommitmentLineItem["tradePartnerNote"];
  changeEventLineItem?: ChangeEventLineItem | ChangeEventLineItemOptions | null;
  newTaxableCostInCents?: CommitmentLineItem["newTaxableCostInCents"];
  newTaxInCents?: CommitmentLineItem["newTaxInCents"];
  newTotalCostInCents?: CommitmentLineItem["newTotalCostInCents"];
  originalTaxableCostInCents?: CommitmentLineItem["originalTaxableCostInCents"];
  originalTaxInCents?: CommitmentLineItem["originalTaxInCents"];
  originalTotalCostInCents?: CommitmentLineItem["originalTotalCostInCents"];
  originalQuantity?: CommitmentLineItem["originalQuantity"];
  newQuantity?: CommitmentLineItem["newQuantity"];
  bidItem?: BidItem | BidItemOptions | null;
  primaryBidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  modifyingBidContractLineItems?: Array<BidContractLineItem | BidContractLineItemOptions>;
  planBasedLineItem?: PlanBasedBidContractLineItem | PlanBasedBidContractLineItemOptions | null;
  expenseAllocations?: Array<ExpenseAllocation | ExpenseAllocationOptions>;
  isTaxExempt?: CommitmentLineItem["isTaxExempt"];
  taxableCostInCents?: CommitmentLineItem["taxableCostInCents"];
  taxInCents?: CommitmentLineItem["taxInCents"];
  allocations?: Array<CommitmentLineItemAllocation | CommitmentLineItemAllocationOptions>;
}

export function newCommitmentLineItem(
  options: CommitmentLineItemOptions = {},
  cache: Record<string, any> = {},
): CommitmentLineItem {
  const o = (options.__typename ? options : cache["CommitmentLineItem"] = {}) as CommitmentLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentLineItem";
  o.id = options.id ?? nextFactoryId("CommitmentLineItem");
  o.owner = maybeNew("CommitmentLike", options.owner, cache, options.hasOwnProperty("owner"));
  o.ownerCommitment = maybeNew("Commitment", options.ownerCommitment, cache, options.hasOwnProperty("ownerCommitment"));
  o.costChangeInCents = options.costChangeInCents ?? null;
  o.internalNote = options.internalNote ?? null;
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.committedInCents = options.committedInCents ?? 0;
  o.billedInCents = options.billedInCents ?? null;
  o.unbilledInCents = options.unbilledInCents ?? 0;
  o.pendingBilledInCents = options.pendingBilledInCents ?? 0;
  o.pendingUnbilledInCents = options.pendingUnbilledInCents ?? 0;
  o.billableLimitInCents = options.billableLimitInCents ?? 0;
  o.paidInCents = options.paidInCents ?? null;
  o.balanceInCents = options.balanceInCents ?? null;
  o.quantity = options.quantity ?? null;
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.specifications = options.specifications ?? null;
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.changeEventLineItem = maybeNewOrNull("ChangeEventLineItem", options.changeEventLineItem, cache);
  o.newTaxableCostInCents = options.newTaxableCostInCents ?? 0;
  o.newTaxInCents = options.newTaxInCents ?? 0;
  o.newTotalCostInCents = options.newTotalCostInCents ?? 0;
  o.originalTaxableCostInCents = options.originalTaxableCostInCents ?? 0;
  o.originalTaxInCents = options.originalTaxInCents ?? 0;
  o.originalTotalCostInCents = options.originalTotalCostInCents ?? 0;
  o.originalQuantity = options.originalQuantity ?? 0;
  o.newQuantity = options.newQuantity ?? 0;
  o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
  o.primaryBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.primaryBidContractLineItem, cache);
  o.modifyingBidContractLineItems = (options.modifyingBidContractLineItems ?? []).map((i) =>
    maybeNew("BidContractLineItem", i, cache, options.hasOwnProperty("modifyingBidContractLineItems"))
  );
  o.planBasedLineItem = maybeNewOrNull("PlanBasedBidContractLineItem", options.planBasedLineItem, cache);
  o.expenseAllocations = (options.expenseAllocations ?? []).map((i) =>
    maybeNew("ExpenseAllocation", i, cache, options.hasOwnProperty("expenseAllocations"))
  );
  o.isTaxExempt = options.isTaxExempt ?? false;
  o.taxableCostInCents = options.taxableCostInCents ?? 0;
  o.taxInCents = options.taxInCents ?? 0;
  o.allocations = (options.allocations ?? []).map((i) =>
    maybeNew("CommitmentLineItemAllocation", i, cache, options.hasOwnProperty("allocations"))
  );
  return o;
}

factories["CommitmentLineItem"] = newCommitmentLineItem;

export interface ProtoCommitmentLineItemToBuyoutOptions {
  __typename?: "ProtoCommitmentLineItemToBuyout";
  projectItem?: ProjectItem | ProjectItemOptions;
  quantity?: ProtoCommitmentLineItemToBuyout["quantity"];
  costChangeInCents?: ProtoCommitmentLineItemToBuyout["costChangeInCents"];
  specifications?: ProtoCommitmentLineItemToBuyout["specifications"];
  tradePartnerNote?: ProtoCommitmentLineItemToBuyout["tradePartnerNote"];
}

export function newProtoCommitmentLineItemToBuyout(
  options: ProtoCommitmentLineItemToBuyoutOptions = {},
  cache: Record<string, any> = {},
): ProtoCommitmentLineItemToBuyout {
  const o =
    (options.__typename ? options : cache["ProtoCommitmentLineItemToBuyout"] = {}) as ProtoCommitmentLineItemToBuyout;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProtoCommitmentLineItemToBuyout";
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.quantity = options.quantity ?? null;
  o.costChangeInCents = options.costChangeInCents ?? null;
  o.specifications = options.specifications ?? null;
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  return o;
}

factories["ProtoCommitmentLineItemToBuyout"] = newProtoCommitmentLineItemToBuyout;

export interface CommitmentLineItemAllocationOptions {
  __typename?: "CommitmentLineItemAllocation";
  id?: CommitmentLineItemAllocation["id"];
  costInCents?: CommitmentLineItemAllocation["costInCents"];
  createdAt?: CommitmentLineItemAllocation["createdAt"];
  updatedAt?: CommitmentLineItemAllocation["updatedAt"];
  commitmentLineItem?: CommitmentLineItem | CommitmentLineItemOptions;
  projectItemAllocation?: ProjectItemAllocation | ProjectItemAllocationOptions;
  billLineItemAllocations?: Array<BillLineItemAllocation | BillLineItemAllocationOptions>;
}

export function newCommitmentLineItemAllocation(
  options: CommitmentLineItemAllocationOptions = {},
  cache: Record<string, any> = {},
): CommitmentLineItemAllocation {
  const o = (options.__typename ? options : cache["CommitmentLineItemAllocation"] = {}) as CommitmentLineItemAllocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentLineItemAllocation";
  o.id = options.id ?? nextFactoryId("CommitmentLineItemAllocation");
  o.costInCents = options.costInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.commitmentLineItem = maybeNew(
    "CommitmentLineItem",
    options.commitmentLineItem,
    cache,
    options.hasOwnProperty("commitmentLineItem"),
  );
  o.projectItemAllocation = maybeNew(
    "ProjectItemAllocation",
    options.projectItemAllocation,
    cache,
    options.hasOwnProperty("projectItemAllocation"),
  );
  o.billLineItemAllocations = (options.billLineItemAllocations ?? []).map((i) =>
    maybeNew("BillLineItemAllocation", i, cache, options.hasOwnProperty("billLineItemAllocations"))
  );
  return o;
}

factories["CommitmentLineItemAllocation"] = newCommitmentLineItemAllocation;

export interface SaveCommunityResultOptions {
  __typename?: "SaveCommunityResult";
  community?: Community | CommunityOptions;
}

export function newSaveCommunityResult(
  options: SaveCommunityResultOptions = {},
  cache: Record<string, any> = {},
): SaveCommunityResult {
  const o = (options.__typename ? options : cache["SaveCommunityResult"] = {}) as SaveCommunityResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCommunityResult";
  o.community = maybeNew("Community", options.community, cache, options.hasOwnProperty("community"));
  return o;
}

factories["SaveCommunityResult"] = newSaveCommunityResult;

export interface CommunitiesPageResultOptions {
  __typename?: "CommunitiesPageResult";
  entities?: Array<Community | CommunityOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newCommunitiesPageResult(
  options: CommunitiesPageResultOptions = {},
  cache: Record<string, any> = {},
): CommunitiesPageResult {
  const o = (options.__typename ? options : cache["CommunitiesPageResult"] = {}) as CommunitiesPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommunitiesPageResult";
  o.entities = (options.entities ?? []).map((i) => maybeNew("Community", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["CommunitiesPageResult"] = newCommunitiesPageResult;

export interface CostCodeOptions {
  __typename?: "CostCode";
  id?: CostCode["id"];
  version?: CostCode["version"];
  division?: CostDivision | CostDivisionOptions;
  number?: CostCode["number"];
  name?: CostCode["name"];
  displayName?: CostCode["displayName"];
  quickbooksCategoryId?: CostCode["quickbooksCategoryId"];
  quickbooksItemId?: CostCode["quickbooksItemId"];
  items?: Array<Item | ItemOptions>;
  tsaSpecifications?: CostCode["tsaSpecifications"];
  intacctApAccountId?: CostCode["intacctApAccountId"];
  costClassification?: CostClassificationTypeDetailOptions | CostClassificationType;
  costSubClassification?: CostSubClassificationTypeDetailOptions | CostSubClassificationType | null;
  excludeFromPurchaseOrders?: CostCode["excludeFromPurchaseOrders"];
  billType?: BillTypeDetailOptions | BillType | null;
  excludeFromBudget?: CostCode["excludeFromBudget"];
  changeEventAutoAcceptThresholdInCents?: CostCode["changeEventAutoAcceptThresholdInCents"];
  isPriceOnly?: CostCode["isPriceOnly"];
  optionPricingConfig?: OptionPricingConfig | OptionPricingConfigOptions | null;
  materialLeadTimeConfig?: MaterialLeadTimeConfig | MaterialLeadTimeConfigOptions | null;
  minLeadTimeInDays?: CostCode["minLeadTimeInDays"];
  expectedLeadTimeInDays?: CostCode["expectedLeadTimeInDays"];
  maxLeadTimeInDays?: CostCode["maxLeadTimeInDays"];
  history?: Array<History | HistoryOptions>;
  isUnderwritingBudget?: CostCode["isUnderwritingBudget"];
  invoiceCategory?: CostCodeInvoiceCategoryDetailOptions | CostCodeInvoiceCategory | null;
  interiorFinishScheduleConfigs?: Array<FinishScheduleConfig | FinishScheduleConfigOptions>;
  exteriorFinishScheduleConfigs?: Array<FinishScheduleConfig | FinishScheduleConfigOptions>;
  finishScheduleChildItems?: Array<Item | ItemOptions>;
  interiorFinishScheduleLabel?: CostCode["interiorFinishScheduleLabel"];
  exteriorFinishScheduleLabel?: CostCode["exteriorFinishScheduleLabel"];
  interiorFinishScheduleDescription?: CostCode["interiorFinishScheduleDescription"];
  exteriorFinishScheduleDescription?: CostCode["exteriorFinishScheduleDescription"];
  interiorFinishScheduleOrder?: CostCode["interiorFinishScheduleOrder"];
  exteriorFinishScheduleOrder?: CostCode["exteriorFinishScheduleOrder"];
  expectedBidCostTypes?: Array<CostTypeDetail | CostTypeDetailOptions>;
}

export function newCostCode(options: CostCodeOptions = {}, cache: Record<string, any> = {}): CostCode {
  const o = (options.__typename ? options : cache["CostCode"] = {}) as CostCode;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostCode";
  o.id = options.id ?? nextFactoryId("CostCode");
  o.version = options.version ?? 0;
  o.division = maybeNew("CostDivision", options.division, cache, options.hasOwnProperty("division"));
  o.number = options.number ?? "number";
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.quickbooksCategoryId = options.quickbooksCategoryId ?? null;
  o.quickbooksItemId = options.quickbooksItemId ?? null;
  o.items = (options.items ?? []).map((i) => maybeNew("Item", i, cache, options.hasOwnProperty("items")));
  o.tsaSpecifications = options.tsaSpecifications ?? null;
  o.intacctApAccountId = options.intacctApAccountId ?? null;
  o.costClassification = enumOrDetailOfCostClassificationType(options.costClassification);
  o.costSubClassification = enumOrDetailOrNullOfCostSubClassificationType(options.costSubClassification);
  o.excludeFromPurchaseOrders = options.excludeFromPurchaseOrders ?? false;
  o.billType = enumOrDetailOrNullOfBillType(options.billType);
  o.excludeFromBudget = options.excludeFromBudget ?? false;
  o.changeEventAutoAcceptThresholdInCents = options.changeEventAutoAcceptThresholdInCents ?? null;
  o.isPriceOnly = options.isPriceOnly ?? null;
  o.optionPricingConfig = maybeNewOrNull("OptionPricingConfig", options.optionPricingConfig, cache);
  o.materialLeadTimeConfig = maybeNewOrNull("MaterialLeadTimeConfig", options.materialLeadTimeConfig, cache);
  o.minLeadTimeInDays = options.minLeadTimeInDays ?? 0;
  o.expectedLeadTimeInDays = options.expectedLeadTimeInDays ?? 0;
  o.maxLeadTimeInDays = options.maxLeadTimeInDays ?? 0;
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.isUnderwritingBudget = options.isUnderwritingBudget ?? false;
  o.invoiceCategory = enumOrDetailOrNullOfCostCodeInvoiceCategory(options.invoiceCategory);
  o.interiorFinishScheduleConfigs = (options.interiorFinishScheduleConfigs ?? []).map((i) =>
    maybeNew("FinishScheduleConfig", i, cache, options.hasOwnProperty("interiorFinishScheduleConfigs"))
  );
  o.exteriorFinishScheduleConfigs = (options.exteriorFinishScheduleConfigs ?? []).map((i) =>
    maybeNew("FinishScheduleConfig", i, cache, options.hasOwnProperty("exteriorFinishScheduleConfigs"))
  );
  o.finishScheduleChildItems = (options.finishScheduleChildItems ?? []).map((i) =>
    maybeNew("Item", i, cache, options.hasOwnProperty("finishScheduleChildItems"))
  );
  o.interiorFinishScheduleLabel = options.interiorFinishScheduleLabel ?? null;
  o.exteriorFinishScheduleLabel = options.exteriorFinishScheduleLabel ?? null;
  o.interiorFinishScheduleDescription = options.interiorFinishScheduleDescription ?? null;
  o.exteriorFinishScheduleDescription = options.exteriorFinishScheduleDescription ?? null;
  o.interiorFinishScheduleOrder = options.interiorFinishScheduleOrder ?? null;
  o.exteriorFinishScheduleOrder = options.exteriorFinishScheduleOrder ?? null;
  o.expectedBidCostTypes = (options.expectedBidCostTypes ?? []).map((i) => enumOrDetailOfCostType(i));
  return o;
}

factories["CostCode"] = newCostCode;

export interface SaveCostCodesResultOptions {
  __typename?: "SaveCostCodesResult";
  costCodes?: Array<CostCode | CostCodeOptions>;
}

export function newSaveCostCodesResult(
  options: SaveCostCodesResultOptions = {},
  cache: Record<string, any> = {},
): SaveCostCodesResult {
  const o = (options.__typename ? options : cache["SaveCostCodesResult"] = {}) as SaveCostCodesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCostCodesResult";
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  return o;
}

factories["SaveCostCodesResult"] = newSaveCostCodesResult;

export interface CostDivisionOptions {
  __typename?: "CostDivision";
  id?: CostDivision["id"];
  version?: CostDivision["version"];
  number?: CostDivision["number"];
  name?: CostDivision["name"];
  displayName?: CostDivision["displayName"];
  stage?: StageDetailOptions | Stage;
  selectionCutoff?: SelectionCutoffDetailOptions | SelectionCutoff | null;
  costCodes?: Array<CostCode | CostCodeOptions>;
  tsaPolicySection?: CostDivision["tsaPolicySection"];
  tsaPaymentSection?: CostDivision["tsaPaymentSection"];
  tsaWarrantySection?: CostDivision["tsaWarrantySection"];
  tsaGeneralScope?: CostDivision["tsaGeneralScope"];
}

export function newCostDivision(options: CostDivisionOptions = {}, cache: Record<string, any> = {}): CostDivision {
  const o = (options.__typename ? options : cache["CostDivision"] = {}) as CostDivision;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostDivision";
  o.id = options.id ?? nextFactoryId("CostDivision");
  o.version = options.version ?? 0;
  o.number = options.number ?? "number";
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.stage = enumOrDetailOfStage(options.stage);
  o.selectionCutoff = enumOrDetailOrNullOfSelectionCutoff(options.selectionCutoff);
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.tsaPolicySection = options.tsaPolicySection ?? null;
  o.tsaPaymentSection = options.tsaPaymentSection ?? null;
  o.tsaWarrantySection = options.tsaWarrantySection ?? null;
  o.tsaGeneralScope = options.tsaGeneralScope ?? null;
  return o;
}

factories["CostDivision"] = newCostDivision;

export interface SaveCostDivisionsResultOptions {
  __typename?: "SaveCostDivisionsResult";
  costDivisions?: Array<CostDivision | CostDivisionOptions>;
}

export function newSaveCostDivisionsResult(
  options: SaveCostDivisionsResultOptions = {},
  cache: Record<string, any> = {},
): SaveCostDivisionsResult {
  const o = (options.__typename ? options : cache["SaveCostDivisionsResult"] = {}) as SaveCostDivisionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCostDivisionsResult";
  o.costDivisions = (options.costDivisions ?? []).map((i) =>
    maybeNew("CostDivision", i, cache, options.hasOwnProperty("costDivisions"))
  );
  return o;
}

factories["SaveCostDivisionsResult"] = newSaveCostDivisionsResult;

export interface CostLineItemAllocationOptions {
  __typename?: "CostLineItemAllocation";
  id?: CostLineItemAllocation["id"];
  invoicedAmountInCents?: CostLineItemAllocation["invoicedAmountInCents"];
  createdAt?: CostLineItemAllocation["createdAt"];
  updatedAt?: CostLineItemAllocation["updatedAt"];
  billLineItem?: BillLineItem | BillLineItemOptions | null;
  expenseAllocation?: ExpenseAllocation | ExpenseAllocationOptions | null;
  invoiceLineItem?: InvoiceLineItem | InvoiceLineItemOptions;
  costAmountInCents?: CostLineItemAllocation["costAmountInCents"];
  costLineItemId?: CostLineItemAllocation["costLineItemId"];
}

export function newCostLineItemAllocation(
  options: CostLineItemAllocationOptions = {},
  cache: Record<string, any> = {},
): CostLineItemAllocation {
  const o = (options.__typename ? options : cache["CostLineItemAllocation"] = {}) as CostLineItemAllocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostLineItemAllocation";
  o.id = options.id ?? nextFactoryId("CostLineItemAllocation");
  o.invoicedAmountInCents = options.invoicedAmountInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.billLineItem = maybeNewOrNull("BillLineItem", options.billLineItem, cache);
  o.expenseAllocation = maybeNewOrNull("ExpenseAllocation", options.expenseAllocation, cache);
  o.invoiceLineItem = maybeNew(
    "InvoiceLineItem",
    options.invoiceLineItem,
    cache,
    options.hasOwnProperty("invoiceLineItem"),
  );
  o.costAmountInCents = options.costAmountInCents ?? 0;
  o.costLineItemId = options.costLineItemId ?? "costLineItemId";
  return o;
}

factories["CostLineItemAllocation"] = newCostLineItemAllocation;

export interface CustomerOptions {
  __typename?: "Customer";
  id?: Customer["id"];
  name?: Customer["name"];
  softCostMarkupInBasisPoints?: Customer["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Customer["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Customer["directHardCostMarkupInBasisPoints"];
  createdAt?: Customer["createdAt"];
  updatedAt?: Customer["updatedAt"];
  isHti?: Customer["isHti"];
  itemConfigs?: Array<CustomerItemConfig | CustomerItemConfigOptions>;
  shouldCoverConstructionCosts?: Customer["shouldCoverConstructionCosts"];
}

export function newCustomer(options: CustomerOptions = {}, cache: Record<string, any> = {}): Customer {
  const o = (options.__typename ? options : cache["Customer"] = {}) as Customer;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Customer";
  o.id = options.id ?? nextFactoryId("Customer");
  o.name = options.name ?? "name";
  o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? 0;
  o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? 0;
  o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.isHti = options.isHti ?? null;
  o.itemConfigs = (options.itemConfigs ?? []).map((i) =>
    maybeNew("CustomerItemConfig", i, cache, options.hasOwnProperty("itemConfigs"))
  );
  o.shouldCoverConstructionCosts = options.shouldCoverConstructionCosts ?? false;
  return o;
}

factories["Customer"] = newCustomer;

export interface SaveCustomerResultOptions {
  __typename?: "SaveCustomerResult";
  customer?: Customer | CustomerOptions;
}

export function newSaveCustomerResult(
  options: SaveCustomerResultOptions = {},
  cache: Record<string, any> = {},
): SaveCustomerResult {
  const o = (options.__typename ? options : cache["SaveCustomerResult"] = {}) as SaveCustomerResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCustomerResult";
  o.customer = maybeNew("Customer", options.customer, cache, options.hasOwnProperty("customer"));
  return o;
}

factories["SaveCustomerResult"] = newSaveCustomerResult;

export interface CustomerItemConfigOptions {
  __typename?: "CustomerItemConfig";
  id?: CustomerItemConfig["id"];
  markupInBasisPoints?: CustomerItemConfig["markupInBasisPoints"];
  createdAt?: CustomerItemConfig["createdAt"];
  updatedAt?: CustomerItemConfig["updatedAt"];
  customer?: Customer | CustomerOptions;
  item?: Item | ItemOptions;
}

export function newCustomerItemConfig(
  options: CustomerItemConfigOptions = {},
  cache: Record<string, any> = {},
): CustomerItemConfig {
  const o = (options.__typename ? options : cache["CustomerItemConfig"] = {}) as CustomerItemConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CustomerItemConfig";
  o.id = options.id ?? nextFactoryId("CustomerItemConfig");
  o.markupInBasisPoints = options.markupInBasisPoints ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.customer = maybeNew("Customer", options.customer, cache, options.hasOwnProperty("customer"));
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  return o;
}

factories["CustomerItemConfig"] = newCustomerItemConfig;

export interface SaveCustomerItemConfigResultOptions {
  __typename?: "SaveCustomerItemConfigResult";
  customerItemConfig?: CustomerItemConfig | CustomerItemConfigOptions;
}

export function newSaveCustomerItemConfigResult(
  options: SaveCustomerItemConfigResultOptions = {},
  cache: Record<string, any> = {},
): SaveCustomerItemConfigResult {
  const o = (options.__typename ? options : cache["SaveCustomerItemConfigResult"] = {}) as SaveCustomerItemConfigResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCustomerItemConfigResult";
  o.customerItemConfig = maybeNew(
    "CustomerItemConfig",
    options.customerItemConfig,
    cache,
    options.hasOwnProperty("customerItemConfig"),
  );
  return o;
}

factories["SaveCustomerItemConfigResult"] = newSaveCustomerItemConfigResult;

export interface CustomerOwnerEntityOptions {
  __typename?: "CustomerOwnerEntity";
  id?: CustomerOwnerEntity["id"];
  name?: CustomerOwnerEntity["name"];
  intacctId?: CustomerOwnerEntity["intacctId"];
  createdAt?: CustomerOwnerEntity["createdAt"];
  updatedAt?: CustomerOwnerEntity["updatedAt"];
  isHti?: CustomerOwnerEntity["isHti"];
  warrantyLengthInDays?: CustomerOwnerEntity["warrantyLengthInDays"];
}

export function newCustomerOwnerEntity(
  options: CustomerOwnerEntityOptions = {},
  cache: Record<string, any> = {},
): CustomerOwnerEntity {
  const o = (options.__typename ? options : cache["CustomerOwnerEntity"] = {}) as CustomerOwnerEntity;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CustomerOwnerEntity";
  o.id = options.id ?? nextFactoryId("CustomerOwnerEntity");
  o.name = options.name ?? "name";
  o.intacctId = options.intacctId ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.isHti = options.isHti ?? false;
  o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
  return o;
}

factories["CustomerOwnerEntity"] = newCustomerOwnerEntity;

export interface SaveCustomerOwnerEntityResultOptions {
  __typename?: "SaveCustomerOwnerEntityResult";
  customerOwnerEntity?: CustomerOwnerEntity | CustomerOwnerEntityOptions;
}

export function newSaveCustomerOwnerEntityResult(
  options: SaveCustomerOwnerEntityResultOptions = {},
  cache: Record<string, any> = {},
): SaveCustomerOwnerEntityResult {
  const o =
    (options.__typename ? options : cache["SaveCustomerOwnerEntityResult"] = {}) as SaveCustomerOwnerEntityResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCustomerOwnerEntityResult";
  o.customerOwnerEntity = maybeNew(
    "CustomerOwnerEntity",
    options.customerOwnerEntity,
    cache,
    options.hasOwnProperty("customerOwnerEntity"),
  );
  return o;
}

factories["SaveCustomerOwnerEntityResult"] = newSaveCustomerOwnerEntityResult;

export interface DesignPackageOptions {
  __typename?: "DesignPackage";
  id?: DesignPackage["id"];
  name?: DesignPackage["name"];
  displayName?: DesignPackage["displayName"];
  description?: DesignPackage["description"];
  createdAt?: DesignPackage["createdAt"];
  updatedAt?: DesignPackage["updatedAt"];
  code?: DesignPackage["code"];
  displayCode?: DesignPackage["displayCode"];
  blueprintUrl?: Url | UrlOptions;
  status?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  effectiveStatus?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  interiorDesignPackageProductOfferings?: Array<ProductOffering | ProductOfferingOptions>;
  exteriorDesignPackageProductOfferings?: Array<ProductOffering | ProductOfferingOptions>;
  planPackages?: Array<PlanPackage | PlanPackageOptions>;
  designPackageSources?: Array<DesignPackageSource | DesignPackageSourceOptions>;
  copyInProgress?: DesignPackage["copyInProgress"];
  slots?: Array<DesignPackageSlot | DesignPackageSlotOptions>;
  assets?: Array<ReadyPlanAsset | ReadyPlanAssetOptions>;
  lotTypes?: DesignPackage["lotTypes"];
  location?: DesignPackageLocationDetailOptions | DesignPackageLocation;
  markets?: Array<Market | MarketOptions>;
  aggregateActive?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  aggregateDraft?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  aggregateLatest?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  aggregateVersions?: Array<ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions>;
  availableUpdates?: Array<DesignPackagePlanUpdate | DesignPackagePlanUpdateOptions>;
  version?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  itemLocations?: Array<Location | LocationOptions>;
  costCodes?: Array<CostCode | CostCodeOptions>;
  canEditLineItems?: PotentialOperation2 | PotentialOperation2Options;
  contingencyMarkupPercentage?: DesignPackage["contingencyMarkupPercentage"];
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  syncErrors?: DesignPackage["syncErrors"];
  readyPlanLocations?: Array<ReadyPlanLocation | ReadyPlanLocationOptions>;
  potentialPersonalizationOptions?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  potentialAddOnOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  documents?: Array<Document | DocumentOptions>;
  combinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
  availableTargetGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  requiredOptions?: Array<ReadyPlanRequiredOption | ReadyPlanRequiredOptionOptions>;
  projectConfigs?: Array<ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions>;
  owner?: InternalUser | InternalUserOptions | null;
  cabinetNotes?: DesignPackage["cabinetNotes"];
  cloneInProgress?: DesignPackage["cloneInProgress"];
}

export function newDesignPackage(options: DesignPackageOptions = {}, cache: Record<string, any> = {}): DesignPackage {
  const o = (options.__typename ? options : cache["DesignPackage"] = {}) as DesignPackage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackage";
  o.id = options.id ?? nextFactoryId("DesignPackage");
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.code = options.code ?? null;
  o.displayCode = options.displayCode ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.status = enumOrDetailOfReadyPlanStatus(options.status);
  o.effectiveStatus = enumOrDetailOfReadyPlanStatus(options.effectiveStatus);
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.optionGroups = (options.optionGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("optionGroups"))
  );
  o.interiorDesignPackageProductOfferings = (options.interiorDesignPackageProductOfferings ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("interiorDesignPackageProductOfferings"))
  );
  o.exteriorDesignPackageProductOfferings = (options.exteriorDesignPackageProductOfferings ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("exteriorDesignPackageProductOfferings"))
  );
  o.planPackages = (options.planPackages ?? []).map((i) =>
    maybeNew("PlanPackage", i, cache, options.hasOwnProperty("planPackages"))
  );
  o.designPackageSources = (options.designPackageSources ?? []).map((i) =>
    maybeNew("DesignPackageSource", i, cache, options.hasOwnProperty("designPackageSources"))
  );
  o.copyInProgress = options.copyInProgress ?? false;
  o.slots = (options.slots ?? []).map((i) => maybeNew("DesignPackageSlot", i, cache, options.hasOwnProperty("slots")));
  o.assets = (options.assets ?? []).map((i) => maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("assets")));
  o.lotTypes = options.lotTypes ?? [];
  o.location = enumOrDetailOfDesignPackageLocation(options.location);
  o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
  o.aggregateActive = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateActive, cache);
  o.aggregateDraft = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateDraft, cache);
  o.aggregateLatest = maybeNew(
    "ReadyPlanAggregateVersion",
    options.aggregateLatest,
    cache,
    options.hasOwnProperty("aggregateLatest"),
  );
  o.aggregateVersions = (options.aggregateVersions ?? []).map((i) =>
    maybeNew("ReadyPlanAggregateVersion", i, cache, options.hasOwnProperty("aggregateVersions"))
  );
  o.availableUpdates = (options.availableUpdates ?? []).map((i) =>
    maybeNew("DesignPackagePlanUpdate", i, cache, options.hasOwnProperty("availableUpdates"))
  );
  o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
  o.itemLocations = (options.itemLocations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("itemLocations"))
  );
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.canEditLineItems = maybeNew(
    "PotentialOperation2",
    options.canEditLineItems,
    cache,
    options.hasOwnProperty("canEditLineItems"),
  );
  o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.syncErrors = options.syncErrors ?? null;
  o.readyPlanLocations = (options.readyPlanLocations ?? []).map((i) =>
    maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("readyPlanLocations"))
  );
  o.potentialPersonalizationOptions = (options.potentialPersonalizationOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("potentialPersonalizationOptions"))
  );
  o.potentialAddOnOptions = (options.potentialAddOnOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("potentialAddOnOptions"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.combinations = (options.combinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("combinations"))
  );
  o.availableTargetGroups = (options.availableTargetGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("availableTargetGroups"))
  );
  o.requiredOptions = (options.requiredOptions ?? []).map((i) =>
    maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("requiredOptions"))
  );
  o.projectConfigs = (options.projectConfigs ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfig", i, cache, options.hasOwnProperty("projectConfigs"))
  );
  o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
  o.cabinetNotes = options.cabinetNotes ?? null;
  o.cloneInProgress = options.cloneInProgress ?? false;
  return o;
}

factories["DesignPackage"] = newDesignPackage;

export interface CreateDesignPackagePlaceholderTliResultOptions {
  __typename?: "CreateDesignPackagePlaceholderTliResult";
  placeholderTli?: TakeoffLineItem | TakeoffLineItemOptions;
  readyPlanAggregateVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  planPackageIncomingSlots?: Array<PlanPackageIncomingSlot | PlanPackageIncomingSlotOptions>;
}

export function newCreateDesignPackagePlaceholderTliResult(
  options: CreateDesignPackagePlaceholderTliResultOptions = {},
  cache: Record<string, any> = {},
): CreateDesignPackagePlaceholderTliResult {
  const o =
    (options.__typename
      ? options
      : cache["CreateDesignPackagePlaceholderTliResult"] = {}) as CreateDesignPackagePlaceholderTliResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateDesignPackagePlaceholderTliResult";
  o.placeholderTli = maybeNew(
    "TakeoffLineItem",
    options.placeholderTli,
    cache,
    options.hasOwnProperty("placeholderTli"),
  );
  o.readyPlanAggregateVersion = maybeNew(
    "ReadyPlanAggregateVersion",
    options.readyPlanAggregateVersion,
    cache,
    options.hasOwnProperty("readyPlanAggregateVersion"),
  );
  o.planPackageIncomingSlots = (options.planPackageIncomingSlots ?? []).map((i) =>
    maybeNew("PlanPackageIncomingSlot", i, cache, options.hasOwnProperty("planPackageIncomingSlots"))
  );
  return o;
}

factories["CreateDesignPackagePlaceholderTliResult"] = newCreateDesignPackagePlaceholderTliResult;

export interface SaveDesignPackageResultOptions {
  __typename?: "SaveDesignPackageResult";
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newSaveDesignPackageResult(
  options: SaveDesignPackageResultOptions = {},
  cache: Record<string, any> = {},
): SaveDesignPackageResult {
  const o = (options.__typename ? options : cache["SaveDesignPackageResult"] = {}) as SaveDesignPackageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDesignPackageResult";
  o.designPackage = maybeNew("DesignPackage", options.designPackage, cache, options.hasOwnProperty("designPackage"));
  return o;
}

factories["SaveDesignPackageResult"] = newSaveDesignPackageResult;

export interface SaveDesignPackageUpdatesResultOptions {
  __typename?: "SaveDesignPackageUpdatesResult";
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newSaveDesignPackageUpdatesResult(
  options: SaveDesignPackageUpdatesResultOptions = {},
  cache: Record<string, any> = {},
): SaveDesignPackageUpdatesResult {
  const o =
    (options.__typename ? options : cache["SaveDesignPackageUpdatesResult"] = {}) as SaveDesignPackageUpdatesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDesignPackageUpdatesResult";
  o.designPackage = maybeNew("DesignPackage", options.designPackage, cache, options.hasOwnProperty("designPackage"));
  return o;
}

factories["SaveDesignPackageUpdatesResult"] = newSaveDesignPackageUpdatesResult;

export interface DesignPackagesPageResultOptions {
  __typename?: "DesignPackagesPageResult";
  entities?: Array<DesignPackage | DesignPackageOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newDesignPackagesPageResult(
  options: DesignPackagesPageResultOptions = {},
  cache: Record<string, any> = {},
): DesignPackagesPageResult {
  const o = (options.__typename ? options : cache["DesignPackagesPageResult"] = {}) as DesignPackagesPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackagesPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("DesignPackage", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["DesignPackagesPageResult"] = newDesignPackagesPageResult;

export interface DesignPackageSlotOptions {
  __typename?: "DesignPackageSlot";
  id?: DesignPackageSlot["id"];
  slot?: ItemSlot | ItemSlotOptions;
  coverage?: DesignPackageSlot["coverage"];
  isFullyAssigned?: DesignPackageSlot["isFullyAssigned"];
  items?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  hasPendingPlanPackageIncomingSlots?: DesignPackageSlot["hasPendingPlanPackageIncomingSlots"];
  isRejectedIncomingSlot?: DesignPackageSlot["isRejectedIncomingSlot"];
  pendingDeletion?: DesignPackageSlot["pendingDeletion"];
}

export function newDesignPackageSlot(
  options: DesignPackageSlotOptions = {},
  cache: Record<string, any> = {},
): DesignPackageSlot {
  const o = (options.__typename ? options : cache["DesignPackageSlot"] = {}) as DesignPackageSlot;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackageSlot";
  o.id = options.id ?? nextFactoryId("DesignPackageSlot");
  o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
  o.coverage = options.coverage ?? 0;
  o.isFullyAssigned = options.isFullyAssigned ?? false;
  o.items = (options.items ?? []).map((i) => maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("items")));
  o.hasPendingPlanPackageIncomingSlots = options.hasPendingPlanPackageIncomingSlots ?? false;
  o.isRejectedIncomingSlot = options.isRejectedIncomingSlot ?? false;
  o.pendingDeletion = options.pendingDeletion ?? false;
  return o;
}

factories["DesignPackageSlot"] = newDesignPackageSlot;

export interface DesignPackageOptionCombinationOptions {
  __typename?: "DesignPackageOptionCombination";
  id?: DesignPackageOptionCombination["id"];
  combination?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  name?: DesignPackageOptionCombination["name"];
}

export function newDesignPackageOptionCombination(
  options: DesignPackageOptionCombinationOptions = {},
  cache: Record<string, any> = {},
): DesignPackageOptionCombination {
  const o =
    (options.__typename ? options : cache["DesignPackageOptionCombination"] = {}) as DesignPackageOptionCombination;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackageOptionCombination";
  o.id = options.id ?? nextFactoryId("DesignPackageOptionCombination");
  o.combination = (options.combination ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("combination"))
  );
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.name = options.name ?? "name";
  return o;
}

factories["DesignPackageOptionCombination"] = newDesignPackageOptionCombination;

export interface DesignPackageFinishSchedulePageResultOptions {
  __typename?: "DesignPackageFinishSchedulePageResult";
  entities?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newDesignPackageFinishSchedulePageResult(
  options: DesignPackageFinishSchedulePageResultOptions = {},
  cache: Record<string, any> = {},
): DesignPackageFinishSchedulePageResult {
  const o =
    (options.__typename
      ? options
      : cache["DesignPackageFinishSchedulePageResult"] = {}) as DesignPackageFinishSchedulePageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackageFinishSchedulePageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["DesignPackageFinishSchedulePageResult"] = newDesignPackageFinishSchedulePageResult;

export interface PlaceholderCombinationsResultOptions {
  __typename?: "PlaceholderCombinationsResult";
  takeoffLineItem?: TakeoffLineItem | TakeoffLineItemOptions;
  combinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
}

export function newPlaceholderCombinationsResult(
  options: PlaceholderCombinationsResultOptions = {},
  cache: Record<string, any> = {},
): PlaceholderCombinationsResult {
  const o =
    (options.__typename ? options : cache["PlaceholderCombinationsResult"] = {}) as PlaceholderCombinationsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlaceholderCombinationsResult";
  o.takeoffLineItem = maybeNew(
    "TakeoffLineItem",
    options.takeoffLineItem,
    cache,
    options.hasOwnProperty("takeoffLineItem"),
  );
  o.combinations = (options.combinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("combinations"))
  );
  return o;
}

factories["PlaceholderCombinationsResult"] = newPlaceholderCombinationsResult;

export interface SavePersonalizationOptionGroupResultOptions {
  __typename?: "SavePersonalizationOptionGroupResult";
  version?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  optionGroup?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions;
}

export function newSavePersonalizationOptionGroupResult(
  options: SavePersonalizationOptionGroupResultOptions = {},
  cache: Record<string, any> = {},
): SavePersonalizationOptionGroupResult {
  const o =
    (options.__typename
      ? options
      : cache["SavePersonalizationOptionGroupResult"] = {}) as SavePersonalizationOptionGroupResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePersonalizationOptionGroupResult";
  o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
  o.optionGroup = maybeNew("ReadyPlanOptionGroup", options.optionGroup, cache, options.hasOwnProperty("optionGroup"));
  return o;
}

factories["SavePersonalizationOptionGroupResult"] = newSavePersonalizationOptionGroupResult;

export interface CopyDesignPackageCardsResultOptions {
  __typename?: "CopyDesignPackageCardsResult";
  sourePlaceholderTli?: TakeoffLineItem | TakeoffLineItemOptions;
  targetPlaceholderTlis?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  addedTlis?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  version?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
}

export function newCopyDesignPackageCardsResult(
  options: CopyDesignPackageCardsResultOptions = {},
  cache: Record<string, any> = {},
): CopyDesignPackageCardsResult {
  const o = (options.__typename ? options : cache["CopyDesignPackageCardsResult"] = {}) as CopyDesignPackageCardsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CopyDesignPackageCardsResult";
  o.sourePlaceholderTli = maybeNew(
    "TakeoffLineItem",
    options.sourePlaceholderTli,
    cache,
    options.hasOwnProperty("sourePlaceholderTli"),
  );
  o.targetPlaceholderTlis = (options.targetPlaceholderTlis ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("targetPlaceholderTlis"))
  );
  o.addedTlis = (options.addedTlis ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("addedTlis"))
  );
  o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
  return o;
}

factories["CopyDesignPackageCardsResult"] = newCopyDesignPackageCardsResult;

export interface CopyDesignPackageSelectionsResultOptions {
  __typename?: "CopyDesignPackageSelectionsResult";
  updatedTakeoffLineItems?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  updatedReadyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  updatedReadyPlanRequiredOptions?: Array<ReadyPlanRequiredOption | ReadyPlanRequiredOptionOptions>;
}

export function newCopyDesignPackageSelectionsResult(
  options: CopyDesignPackageSelectionsResultOptions = {},
  cache: Record<string, any> = {},
): CopyDesignPackageSelectionsResult {
  const o =
    (options.__typename
      ? options
      : cache["CopyDesignPackageSelectionsResult"] = {}) as CopyDesignPackageSelectionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CopyDesignPackageSelectionsResult";
  o.updatedTakeoffLineItems = (options.updatedTakeoffLineItems ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("updatedTakeoffLineItems"))
  );
  o.updatedReadyPlanOptions = (options.updatedReadyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("updatedReadyPlanOptions"))
  );
  o.updatedReadyPlanRequiredOptions = (options.updatedReadyPlanRequiredOptions ?? []).map((i) =>
    maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("updatedReadyPlanRequiredOptions"))
  );
  return o;
}

factories["CopyDesignPackageSelectionsResult"] = newCopyDesignPackageSelectionsResult;

export interface DesignPackagePlanUpdateOptions {
  __typename?: "DesignPackagePlanUpdate";
  id?: DesignPackagePlanUpdate["id"];
  createdAt?: DesignPackagePlanUpdate["createdAt"];
  updatedAt?: DesignPackagePlanUpdate["updatedAt"];
  source?: DesignPackageSource | DesignPackageSourceOptions;
  designPackage?: DesignPackage | DesignPackageOptions;
  accepted?: DesignPackagePlanUpdate["accepted"];
  planVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  acceptedInVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
}

export function newDesignPackagePlanUpdate(
  options: DesignPackagePlanUpdateOptions = {},
  cache: Record<string, any> = {},
): DesignPackagePlanUpdate {
  const o = (options.__typename ? options : cache["DesignPackagePlanUpdate"] = {}) as DesignPackagePlanUpdate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackagePlanUpdate";
  o.id = options.id ?? nextFactoryId("DesignPackagePlanUpdate");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.source = maybeNew("DesignPackageSource", options.source, cache, options.hasOwnProperty("source"));
  o.designPackage = maybeNew("DesignPackage", options.designPackage, cache, options.hasOwnProperty("designPackage"));
  o.accepted = options.accepted ?? false;
  o.planVersion = maybeNew(
    "ReadyPlanAggregateVersion",
    options.planVersion,
    cache,
    options.hasOwnProperty("planVersion"),
  );
  o.acceptedInVersion = maybeNewOrNull("ReadyPlanAggregateVersion", options.acceptedInVersion, cache);
  return o;
}

factories["DesignPackagePlanUpdate"] = newDesignPackagePlanUpdate;

export interface DesignPackageSourceOptions {
  __typename?: "DesignPackageSource";
  id?: DesignPackageSource["id"];
  createdAt?: DesignPackageSource["createdAt"];
  updatedAt?: DesignPackageSource["updatedAt"];
  readyPlan?: DesignPackage | DesignPackageOptions;
  planPackage?: PlanPackage | PlanPackageOptions;
  copyInProgress?: DesignPackageSource["copyInProgress"];
  active?: DesignPackageSource["active"];
  versions?: Array<DesignPackageSourceVersion | DesignPackageSourceVersionOptions>;
  planUpdates?: Array<DesignPackagePlanUpdate | DesignPackagePlanUpdateOptions>;
  planPackageVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
}

export function newDesignPackageSource(
  options: DesignPackageSourceOptions = {},
  cache: Record<string, any> = {},
): DesignPackageSource {
  const o = (options.__typename ? options : cache["DesignPackageSource"] = {}) as DesignPackageSource;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackageSource";
  o.id = options.id ?? nextFactoryId("DesignPackageSource");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.readyPlan = maybeNew("DesignPackage", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.planPackage = maybeNew("PlanPackage", options.planPackage, cache, options.hasOwnProperty("planPackage"));
  o.copyInProgress = options.copyInProgress ?? false;
  o.active = options.active ?? false;
  o.versions = (options.versions ?? []).map((i) =>
    maybeNew("DesignPackageSourceVersion", i, cache, options.hasOwnProperty("versions"))
  );
  o.planUpdates = (options.planUpdates ?? []).map((i) =>
    maybeNew("DesignPackagePlanUpdate", i, cache, options.hasOwnProperty("planUpdates"))
  );
  o.planPackageVersion = maybeNewOrNull("ReadyPlanAggregateVersion", options.planPackageVersion, cache);
  return o;
}

factories["DesignPackageSource"] = newDesignPackageSource;

export interface SaveDesignPackageSourceResultOptions {
  __typename?: "SaveDesignPackageSourceResult";
  designPackageSource?: DesignPackageSource | DesignPackageSourceOptions;
}

export function newSaveDesignPackageSourceResult(
  options: SaveDesignPackageSourceResultOptions = {},
  cache: Record<string, any> = {},
): SaveDesignPackageSourceResult {
  const o =
    (options.__typename ? options : cache["SaveDesignPackageSourceResult"] = {}) as SaveDesignPackageSourceResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDesignPackageSourceResult";
  o.designPackageSource = maybeNew(
    "DesignPackageSource",
    options.designPackageSource,
    cache,
    options.hasOwnProperty("designPackageSource"),
  );
  return o;
}

factories["SaveDesignPackageSourceResult"] = newSaveDesignPackageSourceResult;

export interface DesignPackageSourceVersionOptions {
  __typename?: "DesignPackageSourceVersion";
  id?: DesignPackageSourceVersion["id"];
  active?: DesignPackageSourceVersion["active"];
  createdAt?: DesignPackageSourceVersion["createdAt"];
  updatedAt?: DesignPackageSourceVersion["updatedAt"];
  identity?: DesignPackageSource | DesignPackageSourceOptions;
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
}

export function newDesignPackageSourceVersion(
  options: DesignPackageSourceVersionOptions = {},
  cache: Record<string, any> = {},
): DesignPackageSourceVersion {
  const o = (options.__typename ? options : cache["DesignPackageSourceVersion"] = {}) as DesignPackageSourceVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackageSourceVersion";
  o.id = options.id ?? nextFactoryId("DesignPackageSourceVersion");
  o.active = options.active ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.identity = maybeNew("DesignPackageSource", options.identity, cache, options.hasOwnProperty("identity"));
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  return o;
}

factories["DesignPackageSourceVersion"] = newDesignPackageSourceVersion;

export interface DesignPackageVersionOptions {
  __typename?: "DesignPackageVersion";
  id?: DesignPackageVersion["id"];
  name?: DesignPackageVersion["name"];
  createdAt?: DesignPackageVersion["createdAt"];
  updatedAt?: DesignPackageVersion["updatedAt"];
  code?: DesignPackageVersion["code"];
  contingencyMarkupPercentage?: DesignPackageVersion["contingencyMarkupPercentage"];
  description?: DesignPackageVersion["description"];
  type?: ReadyPlanTypeDetailOptions | ReadyPlanType;
  lotTypes?: DesignPackageVersion["lotTypes"];
  identity?: DesignPackage | DesignPackageOptions;
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  markets?: Array<Market | MarketOptions>;
  owner?: InternalUser | InternalUserOptions | null;
}

export function newDesignPackageVersion(
  options: DesignPackageVersionOptions = {},
  cache: Record<string, any> = {},
): DesignPackageVersion {
  const o = (options.__typename ? options : cache["DesignPackageVersion"] = {}) as DesignPackageVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackageVersion";
  o.id = options.id ?? nextFactoryId("DesignPackageVersion");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.code = options.code ?? null;
  o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
  o.description = options.description ?? null;
  o.type = enumOrDetailOfReadyPlanType(options.type);
  o.lotTypes = options.lotTypes ?? [];
  o.identity = maybeNew("DesignPackage", options.identity, cache, options.hasOwnProperty("identity"));
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
  o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
  return o;
}

factories["DesignPackageVersion"] = newDesignPackageVersion;

export interface DevelopmentOptions {
  __typename?: "Development";
  id?: Development["id"];
  name?: Development["name"];
  blueprintUrl?: Url | UrlOptions;
  createdAt?: Development["createdAt"];
  updatedAt?: Development["updatedAt"];
  market?: Market | MarketOptions;
  cohorts?: Array<Cohort | CohortOptions> | null;
  schedules?: Array<Schedule | ScheduleOptions>;
  itemTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
  commitments?: Array<DevelopmentCommitment | DevelopmentCommitmentOptions>;
  documents?: Array<Document | DocumentOptions>;
  bidContracts?: Array<BidContract | BidContractOptions>;
  readyPlans?: Array<ReadyPlan | ReadyPlanOptions>;
  directorOfConstruction?: InternalUser | InternalUserOptions | null;
  teamMembers?: Array<DevelopmentTeamMember | DevelopmentTeamMemberOptions>;
  toDos?: Array<ToDo | ToDoOptions>;
  options?: Array<DevelopmentOption | DevelopmentOptionOptions>;
  scheduleTemplates?: Array<ScheduleTemplate | ScheduleTemplateOptions>;
  sequenceSheetFollowers?: Array<InternalUser | InternalUserOptions>;
  isSequenceSheetFollower?: Development["isSequenceSheetFollower"];
  isTeamMember?: Development["isTeamMember"];
  canStopFollowingSequenceSheet?: PotentialOperation2 | PotentialOperation2Options;
  canGenerateTemplates?: PotentialOperation2 | PotentialOperation2Options;
  itemMappings?: Array<DevelopmentItemMapping | DevelopmentItemMappingOptions>;
  costMappingProgress?: CostMappingProgress | CostMappingProgressOptions;
  internalBudgetEstimate?: BidContract | BidContractOptions;
  specOptions?: Array<GlobalOption | GlobalOptionOptions>;
  featureFlags?: Array<FeatureFlag | FeatureFlagOptions>;
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  costCodes?: Array<CostCode | CostCodeOptions>;
  drops?: Array<Drop | DropOptions>;
  costCodesWithDraws?: Array<CostCode | CostCodeOptions>;
  schedulingExclusionDates?: Array<SchedulingExclusionDate | SchedulingExclusionDateOptions>;
  salesTaxOverrideInBasisPoints?: Development["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Development["salesTaxInBasisPoints"];
}

export function newDevelopment(options: DevelopmentOptions = {}, cache: Record<string, any> = {}): Development {
  const o = (options.__typename ? options : cache["Development"] = {}) as Development;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Development";
  o.id = options.id ?? nextFactoryId("Development");
  o.name = options.name ?? "name";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.cohorts = (options.cohorts ?? []).map((i) => maybeNew("Cohort", i, cache, options.hasOwnProperty("cohorts")));
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.itemTemplates = (options.itemTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("itemTemplates"))
  );
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("DevelopmentCommitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.readyPlans = (options.readyPlans ?? []).map((i) =>
    maybeNew("ReadyPlan", i, cache, options.hasOwnProperty("readyPlans"))
  );
  o.directorOfConstruction = maybeNewOrNull("InternalUser", options.directorOfConstruction, cache);
  o.teamMembers = (options.teamMembers ?? []).map((i) =>
    maybeNew("DevelopmentTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
  );
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  o.options = (options.options ?? []).map((i) =>
    maybeNew("DevelopmentOption", i, cache, options.hasOwnProperty("options"))
  );
  o.scheduleTemplates = (options.scheduleTemplates ?? []).map((i) =>
    maybeNew("ScheduleTemplate", i, cache, options.hasOwnProperty("scheduleTemplates"))
  );
  o.sequenceSheetFollowers = (options.sequenceSheetFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("sequenceSheetFollowers"))
  );
  o.isSequenceSheetFollower = options.isSequenceSheetFollower ?? false;
  o.isTeamMember = options.isTeamMember ?? false;
  o.canStopFollowingSequenceSheet = maybeNew(
    "PotentialOperation2",
    options.canStopFollowingSequenceSheet,
    cache,
    options.hasOwnProperty("canStopFollowingSequenceSheet"),
  );
  o.canGenerateTemplates = maybeNew(
    "PotentialOperation2",
    options.canGenerateTemplates,
    cache,
    options.hasOwnProperty("canGenerateTemplates"),
  );
  o.itemMappings = (options.itemMappings ?? []).map((i) =>
    maybeNew("DevelopmentItemMapping", i, cache, options.hasOwnProperty("itemMappings"))
  );
  o.costMappingProgress = maybeNew(
    "CostMappingProgress",
    options.costMappingProgress,
    cache,
    options.hasOwnProperty("costMappingProgress"),
  );
  o.internalBudgetEstimate = maybeNew(
    "BidContract",
    options.internalBudgetEstimate,
    cache,
    options.hasOwnProperty("internalBudgetEstimate"),
  );
  o.specOptions = (options.specOptions ?? []).map((i) =>
    maybeNew("GlobalOption", i, cache, options.hasOwnProperty("specOptions"))
  );
  o.featureFlags = (options.featureFlags ?? []).map((i) =>
    maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
  );
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.drops = (options.drops ?? []).map((i) => maybeNew("Drop", i, cache, options.hasOwnProperty("drops")));
  o.costCodesWithDraws = (options.costCodesWithDraws ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodesWithDraws"))
  );
  o.schedulingExclusionDates = (options.schedulingExclusionDates ?? []).map((i) =>
    maybeNew("SchedulingExclusionDate", i, cache, options.hasOwnProperty("schedulingExclusionDates"))
  );
  o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
  o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
  return o;
}

factories["Development"] = newDevelopment;

export interface SaveDevelopmentsResultOptions {
  __typename?: "SaveDevelopmentsResult";
  developments?: Array<Development | DevelopmentOptions>;
}

export function newSaveDevelopmentsResult(
  options: SaveDevelopmentsResultOptions = {},
  cache: Record<string, any> = {},
): SaveDevelopmentsResult {
  const o = (options.__typename ? options : cache["SaveDevelopmentsResult"] = {}) as SaveDevelopmentsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDevelopmentsResult";
  o.developments = (options.developments ?? []).map((i) =>
    maybeNew("Development", i, cache, options.hasOwnProperty("developments"))
  );
  return o;
}

factories["SaveDevelopmentsResult"] = newSaveDevelopmentsResult;

export interface DevelopmentItemMappingOptions {
  __typename?: "DevelopmentItemMapping";
  item?: Item | ItemOptions;
  costType?: DevelopmentItemMapping["costType"];
  location?: Location | LocationOptions;
  stage?: DevelopmentItemMapping["stage"];
  scheduleTemplateItemMappings?: Array<ScheduleTemplateItemMapping | ScheduleTemplateItemMappingOptions>;
}

export function newDevelopmentItemMapping(
  options: DevelopmentItemMappingOptions = {},
  cache: Record<string, any> = {},
): DevelopmentItemMapping {
  const o = (options.__typename ? options : cache["DevelopmentItemMapping"] = {}) as DevelopmentItemMapping;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentItemMapping";
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.costType = options.costType ?? CostType.Labor;
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.stage = options.stage ?? Stage.PreConPlanning;
  o.scheduleTemplateItemMappings = (options.scheduleTemplateItemMappings ?? []).map((i) =>
    maybeNew("ScheduleTemplateItemMapping", i, cache, options.hasOwnProperty("scheduleTemplateItemMappings"))
  );
  return o;
}

factories["DevelopmentItemMapping"] = newDevelopmentItemMapping;

export interface CostMappingProgressOptions {
  __typename?: "CostMappingProgress";
  totalScheduleTemplateItemMappings?: CostMappingProgress["totalScheduleTemplateItemMappings"];
  totalMappingsForDevelopment?: CostMappingProgress["totalMappingsForDevelopment"];
  showCostMappingProgress?: CostMappingProgress["showCostMappingProgress"];
}

export function newCostMappingProgress(
  options: CostMappingProgressOptions = {},
  cache: Record<string, any> = {},
): CostMappingProgress {
  const o = (options.__typename ? options : cache["CostMappingProgress"] = {}) as CostMappingProgress;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostMappingProgress";
  o.totalScheduleTemplateItemMappings = options.totalScheduleTemplateItemMappings ?? 0;
  o.totalMappingsForDevelopment = options.totalMappingsForDevelopment ?? 0;
  o.showCostMappingProgress = options.showCostMappingProgress ?? false;
  return o;
}

factories["CostMappingProgress"] = newCostMappingProgress;

export interface DevelopmentLotSummaryChartsResultOptions {
  __typename?: "DevelopmentLotSummaryChartsResult";
  development?: Development | DevelopmentOptions;
  acquired?: Array<CohortLotSummaryChart | CohortLotSummaryChartOptions>;
  totalAcquired?: DevelopmentLotSummaryChartsResult["totalAcquired"];
  permitSubmitted?: Array<CohortLotSummaryChart | CohortLotSummaryChartOptions>;
  totalPermitSubmitted?: DevelopmentLotSummaryChartsResult["totalPermitSubmitted"];
  permitReceived?: Array<CohortLotSummaryChart | CohortLotSummaryChartOptions>;
  totalPermitReceived?: DevelopmentLotSummaryChartsResult["totalPermitReceived"];
  verticalMobilization?: Array<CohortLotSummaryChart | CohortLotSummaryChartOptions>;
  totalVerticalMobilization?: DevelopmentLotSummaryChartsResult["totalVerticalMobilization"];
  verticalComplete?: Array<CohortLotSummaryChart | CohortLotSummaryChartOptions>;
  totalVerticalComplete?: DevelopmentLotSummaryChartsResult["totalVerticalComplete"];
  delivered?: Array<CohortLotSummaryChart | CohortLotSummaryChartOptions>;
  totalDelivered?: DevelopmentLotSummaryChartsResult["totalDelivered"];
}

export function newDevelopmentLotSummaryChartsResult(
  options: DevelopmentLotSummaryChartsResultOptions = {},
  cache: Record<string, any> = {},
): DevelopmentLotSummaryChartsResult {
  const o =
    (options.__typename
      ? options
      : cache["DevelopmentLotSummaryChartsResult"] = {}) as DevelopmentLotSummaryChartsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentLotSummaryChartsResult";
  o.development = maybeNew("Development", options.development, cache, options.hasOwnProperty("development"));
  o.acquired = (options.acquired ?? []).map((i) =>
    maybeNew("CohortLotSummaryChart", i, cache, options.hasOwnProperty("acquired"))
  );
  o.totalAcquired = options.totalAcquired ?? 0;
  o.permitSubmitted = (options.permitSubmitted ?? []).map((i) =>
    maybeNew("CohortLotSummaryChart", i, cache, options.hasOwnProperty("permitSubmitted"))
  );
  o.totalPermitSubmitted = options.totalPermitSubmitted ?? 0;
  o.permitReceived = (options.permitReceived ?? []).map((i) =>
    maybeNew("CohortLotSummaryChart", i, cache, options.hasOwnProperty("permitReceived"))
  );
  o.totalPermitReceived = options.totalPermitReceived ?? 0;
  o.verticalMobilization = (options.verticalMobilization ?? []).map((i) =>
    maybeNew("CohortLotSummaryChart", i, cache, options.hasOwnProperty("verticalMobilization"))
  );
  o.totalVerticalMobilization = options.totalVerticalMobilization ?? 0;
  o.verticalComplete = (options.verticalComplete ?? []).map((i) =>
    maybeNew("CohortLotSummaryChart", i, cache, options.hasOwnProperty("verticalComplete"))
  );
  o.totalVerticalComplete = options.totalVerticalComplete ?? 0;
  o.delivered = (options.delivered ?? []).map((i) =>
    maybeNew("CohortLotSummaryChart", i, cache, options.hasOwnProperty("delivered"))
  );
  o.totalDelivered = options.totalDelivered ?? 0;
  return o;
}

factories["DevelopmentLotSummaryChartsResult"] = newDevelopmentLotSummaryChartsResult;

export interface CohortLotSummaryChartOptions {
  __typename?: "CohortLotSummaryChart";
  cohort?: Cohort | CohortOptions;
  total?: CohortLotSummaryChart["total"];
}

export function newCohortLotSummaryChart(
  options: CohortLotSummaryChartOptions = {},
  cache: Record<string, any> = {},
): CohortLotSummaryChart {
  const o = (options.__typename ? options : cache["CohortLotSummaryChart"] = {}) as CohortLotSummaryChart;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CohortLotSummaryChart";
  o.cohort = maybeNew("Cohort", options.cohort, cache, options.hasOwnProperty("cohort"));
  o.total = options.total ?? 0;
  return o;
}

factories["CohortLotSummaryChart"] = newCohortLotSummaryChart;

export interface DevelopmentCommitmentSummaryLineItemOptions {
  __typename?: "DevelopmentCommitmentSummaryLineItem";
  costInCents?: DevelopmentCommitmentSummaryLineItem["costInCents"];
  numberOfProjects?: DevelopmentCommitmentSummaryLineItem["numberOfProjects"];
  item?: Item | ItemOptions;
  quantity?: DevelopmentCommitmentSummaryLineItem["quantity"];
}

export function newDevelopmentCommitmentSummaryLineItem(
  options: DevelopmentCommitmentSummaryLineItemOptions = {},
  cache: Record<string, any> = {},
): DevelopmentCommitmentSummaryLineItem {
  const o =
    (options.__typename
      ? options
      : cache["DevelopmentCommitmentSummaryLineItem"] = {}) as DevelopmentCommitmentSummaryLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentCommitmentSummaryLineItem";
  o.costInCents = options.costInCents ?? 0;
  o.numberOfProjects = options.numberOfProjects ?? 0;
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.quantity = options.quantity ?? 0;
  return o;
}

factories["DevelopmentCommitmentSummaryLineItem"] = newDevelopmentCommitmentSummaryLineItem;

export interface DevelopmentCommitmentSummaryOptions {
  __typename?: "DevelopmentCommitmentSummary";
  lineItems?: Array<DevelopmentCommitmentSummaryLineItem | DevelopmentCommitmentSummaryLineItemOptions>;
}

export function newDevelopmentCommitmentSummary(
  options: DevelopmentCommitmentSummaryOptions = {},
  cache: Record<string, any> = {},
): DevelopmentCommitmentSummary {
  const o = (options.__typename ? options : cache["DevelopmentCommitmentSummary"] = {}) as DevelopmentCommitmentSummary;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentCommitmentSummary";
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("DevelopmentCommitmentSummaryLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  return o;
}

factories["DevelopmentCommitmentSummary"] = newDevelopmentCommitmentSummary;

export interface SaveDevelopmentCommitmentResultOptions {
  __typename?: "SaveDevelopmentCommitmentResult";
  developmentCommitment?: DevelopmentCommitment | DevelopmentCommitmentOptions;
}

export function newSaveDevelopmentCommitmentResult(
  options: SaveDevelopmentCommitmentResultOptions = {},
  cache: Record<string, any> = {},
): SaveDevelopmentCommitmentResult {
  const o =
    (options.__typename ? options : cache["SaveDevelopmentCommitmentResult"] = {}) as SaveDevelopmentCommitmentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDevelopmentCommitmentResult";
  o.developmentCommitment = maybeNew(
    "DevelopmentCommitment",
    options.developmentCommitment,
    cache,
    options.hasOwnProperty("developmentCommitment"),
  );
  return o;
}

factories["SaveDevelopmentCommitmentResult"] = newSaveDevelopmentCommitmentResult;

export interface DevelopmentCommitmentPotentialLineItemOptions {
  __typename?: "DevelopmentCommitmentPotentialLineItem";
  item?: Item | ItemOptions;
  costType?: DevelopmentCommitmentPotentialLineItem["costType"];
  location?: Location | LocationOptions;
  totalCostInCents?: DevelopmentCommitmentPotentialLineItem["totalCostInCents"];
  projects?: DevelopmentCommitmentPotentialLineItem["projects"];
}

export function newDevelopmentCommitmentPotentialLineItem(
  options: DevelopmentCommitmentPotentialLineItemOptions = {},
  cache: Record<string, any> = {},
): DevelopmentCommitmentPotentialLineItem {
  const o =
    (options.__typename
      ? options
      : cache["DevelopmentCommitmentPotentialLineItem"] = {}) as DevelopmentCommitmentPotentialLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentCommitmentPotentialLineItem";
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.costType = options.costType ?? CostType.Labor;
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.projects = options.projects ?? [];
  return o;
}

factories["DevelopmentCommitmentPotentialLineItem"] = newDevelopmentCommitmentPotentialLineItem;

export interface DevelopmentCommitmentCostCodeSummaryOptions {
  __typename?: "DevelopmentCommitmentCostCodeSummary";
  costCode?: CostCode | CostCodeOptions;
  numberOfProjects?: DevelopmentCommitmentCostCodeSummary["numberOfProjects"];
  quantity?: DevelopmentCommitmentCostCodeSummary["quantity"];
}

export function newDevelopmentCommitmentCostCodeSummary(
  options: DevelopmentCommitmentCostCodeSummaryOptions = {},
  cache: Record<string, any> = {},
): DevelopmentCommitmentCostCodeSummary {
  const o =
    (options.__typename
      ? options
      : cache["DevelopmentCommitmentCostCodeSummary"] = {}) as DevelopmentCommitmentCostCodeSummary;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentCommitmentCostCodeSummary";
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.numberOfProjects = options.numberOfProjects ?? 0;
  o.quantity = options.quantity ?? 0;
  return o;
}

factories["DevelopmentCommitmentCostCodeSummary"] = newDevelopmentCommitmentCostCodeSummary;

export interface DeleteDevelopmentCommitmentProjectsAndCommitmentsResultOptions {
  __typename?: "DeleteDevelopmentCommitmentProjectsAndCommitmentsResult";
  developmentCommitment?: DevelopmentCommitment | DevelopmentCommitmentOptions;
}

export function newDeleteDevelopmentCommitmentProjectsAndCommitmentsResult(
  options: DeleteDevelopmentCommitmentProjectsAndCommitmentsResultOptions = {},
  cache: Record<string, any> = {},
): DeleteDevelopmentCommitmentProjectsAndCommitmentsResult {
  const o =
    (options.__typename
      ? options
      : cache["DeleteDevelopmentCommitmentProjectsAndCommitmentsResult"] =
        {}) as DeleteDevelopmentCommitmentProjectsAndCommitmentsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteDevelopmentCommitmentProjectsAndCommitmentsResult";
  o.developmentCommitment = maybeNew(
    "DevelopmentCommitment",
    options.developmentCommitment,
    cache,
    options.hasOwnProperty("developmentCommitment"),
  );
  return o;
}

factories["DeleteDevelopmentCommitmentProjectsAndCommitmentsResult"] =
  newDeleteDevelopmentCommitmentProjectsAndCommitmentsResult;

export interface DevelopmentCommitmentsPageOptions {
  __typename?: "DevelopmentCommitmentsPage";
  entities?: Array<DevelopmentCommitment | DevelopmentCommitmentOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newDevelopmentCommitmentsPage(
  options: DevelopmentCommitmentsPageOptions = {},
  cache: Record<string, any> = {},
): DevelopmentCommitmentsPage {
  const o = (options.__typename ? options : cache["DevelopmentCommitmentsPage"] = {}) as DevelopmentCommitmentsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentCommitmentsPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("DevelopmentCommitment", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["DevelopmentCommitmentsPage"] = newDevelopmentCommitmentsPage;

export interface DevelopmentOptionOptions {
  __typename?: "DevelopmentOption";
  id?: DevelopmentOption["id"];
  shortName?: DevelopmentOption["shortName"];
  createdAt?: DevelopmentOption["createdAt"];
  updatedAt?: DevelopmentOption["updatedAt"];
  development?: Development | DevelopmentOptions;
  globalOption?: GlobalOption | GlobalOptionOptions;
}

export function newDevelopmentOption(
  options: DevelopmentOptionOptions = {},
  cache: Record<string, any> = {},
): DevelopmentOption {
  const o = (options.__typename ? options : cache["DevelopmentOption"] = {}) as DevelopmentOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentOption";
  o.id = options.id ?? nextFactoryId("DevelopmentOption");
  o.shortName = options.shortName ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.development = maybeNew("Development", options.development, cache, options.hasOwnProperty("development"));
  o.globalOption = maybeNew("GlobalOption", options.globalOption, cache, options.hasOwnProperty("globalOption"));
  return o;
}

factories["DevelopmentOption"] = newDevelopmentOption;

export interface SaveDevelopmentOptionsResultOptions {
  __typename?: "SaveDevelopmentOptionsResult";
  developmentOptions?: Array<DevelopmentOption | DevelopmentOptionOptions>;
}

export function newSaveDevelopmentOptionsResult(
  options: SaveDevelopmentOptionsResultOptions = {},
  cache: Record<string, any> = {},
): SaveDevelopmentOptionsResult {
  const o = (options.__typename ? options : cache["SaveDevelopmentOptionsResult"] = {}) as SaveDevelopmentOptionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDevelopmentOptionsResult";
  o.developmentOptions = (options.developmentOptions ?? []).map((i) =>
    maybeNew("DevelopmentOption", i, cache, options.hasOwnProperty("developmentOptions"))
  );
  return o;
}

factories["SaveDevelopmentOptionsResult"] = newSaveDevelopmentOptionsResult;

export interface DevelopmentTeamMemberOptions {
  __typename?: "DevelopmentTeamMember";
  id?: DevelopmentTeamMember["id"];
  createdAt?: DevelopmentTeamMember["createdAt"];
  updatedAt?: DevelopmentTeamMember["updatedAt"];
  projectRole?: ProjectRoleDetailOptions | ProjectRole;
  development?: Development | DevelopmentOptions;
  internalUser?: InternalUser | InternalUserOptions;
}

export function newDevelopmentTeamMember(
  options: DevelopmentTeamMemberOptions = {},
  cache: Record<string, any> = {},
): DevelopmentTeamMember {
  const o = (options.__typename ? options : cache["DevelopmentTeamMember"] = {}) as DevelopmentTeamMember;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentTeamMember";
  o.id = options.id ?? nextFactoryId("DevelopmentTeamMember");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.projectRole = enumOrDetailOfProjectRole(options.projectRole);
  o.development = maybeNew("Development", options.development, cache, options.hasOwnProperty("development"));
  o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
  return o;
}

factories["DevelopmentTeamMember"] = newDevelopmentTeamMember;

export interface DocumentsPageResultOptions {
  __typename?: "DocumentsPageResult";
  entities?: Array<Document | DocumentOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newDocumentsPageResult(
  options: DocumentsPageResultOptions = {},
  cache: Record<string, any> = {},
): DocumentsPageResult {
  const o = (options.__typename ? options : cache["DocumentsPageResult"] = {}) as DocumentsPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DocumentsPageResult";
  o.entities = (options.entities ?? []).map((i) => maybeNew("Document", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["DocumentsPageResult"] = newDocumentsPageResult;

export interface DeleteDocumentsResultOptions {
  __typename?: "DeleteDocumentsResult";
  parents?: Array<
    | DocumentParent
    | DevelopmentOptions
    | RequireTypename<PlanPackageOptions>
    | RequireTypename<StandaloneProjectOptions>
    | RequireTypename<RegionOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
  >;
  emptyResult?: DeleteDocumentsResult["emptyResult"];
  dummyString?: DeleteDocumentsResult["dummyString"];
}

export function newDeleteDocumentsResult(
  options: DeleteDocumentsResultOptions = {},
  cache: Record<string, any> = {},
): DeleteDocumentsResult {
  const o = (options.__typename ? options : cache["DeleteDocumentsResult"] = {}) as DeleteDocumentsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteDocumentsResult";
  o.parents = (options.parents ?? []).map((i) =>
    maybeNew(i?.__typename ?? "{Development", i, cache, options.hasOwnProperty("parents"))
  );
  o.emptyResult = options.emptyResult ?? null;
  o.dummyString = options.dummyString ?? null;
  return o;
}

factories["DeleteDocumentsResult"] = newDeleteDocumentsResult;

export interface CreateDocumentPendingUploadResultOptions {
  __typename?: "CreateDocumentPendingUploadResult";
  signedUrl?: CreateDocumentPendingUploadResult["signedUrl"];
  documentId?: CreateDocumentPendingUploadResult["documentId"];
}

export function newCreateDocumentPendingUploadResult(
  options: CreateDocumentPendingUploadResultOptions = {},
  cache: Record<string, any> = {},
): CreateDocumentPendingUploadResult {
  const o =
    (options.__typename
      ? options
      : cache["CreateDocumentPendingUploadResult"] = {}) as CreateDocumentPendingUploadResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateDocumentPendingUploadResult";
  o.signedUrl = options.signedUrl ?? "signedUrl";
  o.documentId = options.documentId ?? "documentId";
  return o;
}

factories["CreateDocumentPendingUploadResult"] = newCreateDocumentPendingUploadResult;

export interface MarkDocumentAsUploadedResultOptions {
  __typename?: "MarkDocumentAsUploadedResult";
  document?: Document | DocumentOptions;
}

export function newMarkDocumentAsUploadedResult(
  options: MarkDocumentAsUploadedResultOptions = {},
  cache: Record<string, any> = {},
): MarkDocumentAsUploadedResult {
  const o = (options.__typename ? options : cache["MarkDocumentAsUploadedResult"] = {}) as MarkDocumentAsUploadedResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MarkDocumentAsUploadedResult";
  o.document = maybeNew("Document", options.document, cache, options.hasOwnProperty("document"));
  return o;
}

factories["MarkDocumentAsUploadedResult"] = newMarkDocumentAsUploadedResult;

export interface ToggleDocumentAsFavoritedResultOptions {
  __typename?: "ToggleDocumentAsFavoritedResult";
  document?: Document | DocumentOptions;
}

export function newToggleDocumentAsFavoritedResult(
  options: ToggleDocumentAsFavoritedResultOptions = {},
  cache: Record<string, any> = {},
): ToggleDocumentAsFavoritedResult {
  const o =
    (options.__typename ? options : cache["ToggleDocumentAsFavoritedResult"] = {}) as ToggleDocumentAsFavoritedResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ToggleDocumentAsFavoritedResult";
  o.document = maybeNew("Document", options.document, cache, options.hasOwnProperty("document"));
  return o;
}

factories["ToggleDocumentAsFavoritedResult"] = newToggleDocumentAsFavoritedResult;

export interface SaveDocumentsResultOptions {
  __typename?: "SaveDocumentsResult";
  documents?: Array<Document | DocumentOptions>;
}

export function newSaveDocumentsResult(
  options: SaveDocumentsResultOptions = {},
  cache: Record<string, any> = {},
): SaveDocumentsResult {
  const o = (options.__typename ? options : cache["SaveDocumentsResult"] = {}) as SaveDocumentsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDocumentsResult";
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  return o;
}

factories["SaveDocumentsResult"] = newSaveDocumentsResult;

export interface DropOptions {
  __typename?: "Drop";
  id?: Drop["id"];
  name?: Drop["name"];
  code?: Drop["code"];
  createdAt?: Drop["createdAt"];
  updatedAt?: Drop["updatedAt"];
  costCode?: CostCode | CostCodeOptions;
  development?: Development | DevelopmentOptions | null;
  globalPlanTask?: GlobalPlanTask | GlobalPlanTaskOptions;
  locations?: Array<Location | LocationOptions>;
  order?: Drop["order"];
  commitments?: Array<Commitment | CommitmentOptions>;
  productOfferingIncomingUpdates?: Array<ProductOfferingIncomingUpdate | ProductOfferingIncomingUpdateOptions>;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
}

export function newDrop(options: DropOptions = {}, cache: Record<string, any> = {}): Drop {
  const o = (options.__typename ? options : cache["Drop"] = {}) as Drop;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Drop";
  o.id = options.id ?? nextFactoryId("Drop");
  o.name = options.name ?? "name";
  o.code = options.code ?? "code";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.globalPlanTask = maybeNew(
    "GlobalPlanTask",
    options.globalPlanTask,
    cache,
    options.hasOwnProperty("globalPlanTask"),
  );
  o.locations = (options.locations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("locations"))
  );
  o.order = options.order ?? 0;
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.productOfferingIncomingUpdates = (options.productOfferingIncomingUpdates ?? []).map((i) =>
    maybeNew("ProductOfferingIncomingUpdate", i, cache, options.hasOwnProperty("productOfferingIncomingUpdates"))
  );
  o.project = maybeNewOrNull("Project", options.project, cache);
  return o;
}

factories["Drop"] = newDrop;

export interface SaveDropResultOptions {
  __typename?: "SaveDropResult";
  drop?: Drop | DropOptions;
}

export function newSaveDropResult(
  options: SaveDropResultOptions = {},
  cache: Record<string, any> = {},
): SaveDropResult {
  const o = (options.__typename ? options : cache["SaveDropResult"] = {}) as SaveDropResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDropResult";
  o.drop = maybeNew("Drop", options.drop, cache, options.hasOwnProperty("drop"));
  return o;
}

factories["SaveDropResult"] = newSaveDropResult;

export interface ActivityPlanningStateDetailOptions {
  __typename?: "ActivityPlanningStateDetail";
  code?: ActivityPlanningStateDetail["code"];
  name?: ActivityPlanningStateDetail["name"];
}

export function newActivityPlanningStateDetail(
  options: ActivityPlanningStateDetailOptions = {},
  cache: Record<string, any> = {},
): ActivityPlanningStateDetail {
  const o = (options.__typename ? options : cache["ActivityPlanningStateDetail"] = {}) as ActivityPlanningStateDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ActivityPlanningStateDetail";
  o.code = options.code ?? ActivityPlanningState.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["ActivityPlanningStateDetail"] = newActivityPlanningStateDetail;

export interface ActivityResponsibilityDetailOptions {
  __typename?: "ActivityResponsibilityDetail";
  code?: ActivityResponsibilityDetail["code"];
  name?: ActivityResponsibilityDetail["name"];
}

export function newActivityResponsibilityDetail(
  options: ActivityResponsibilityDetailOptions = {},
  cache: Record<string, any> = {},
): ActivityResponsibilityDetail {
  const o = (options.__typename ? options : cache["ActivityResponsibilityDetail"] = {}) as ActivityResponsibilityDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ActivityResponsibilityDetail";
  o.code = options.code ?? ActivityResponsibility.Homebound;
  o.name = options.name ?? "Homebound";
  return o;
}

factories["ActivityResponsibilityDetail"] = newActivityResponsibilityDetail;

export interface ActivityTypeDetailOptions {
  __typename?: "ActivityTypeDetail";
  code?: ActivityTypeDetail["code"];
  name?: ActivityTypeDetail["name"];
}

export function newActivityTypeDetail(
  options: ActivityTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ActivityTypeDetail {
  const o = (options.__typename ? options : cache["ActivityTypeDetail"] = {}) as ActivityTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ActivityTypeDetail";
  o.code = options.code ?? ActivityType.PreconPlanning;
  o.name = options.name ?? "Precon planning";
  return o;
}

factories["ActivityTypeDetail"] = newActivityTypeDetail;

export interface AggregateVersionStatusDetailOptions {
  __typename?: "AggregateVersionStatusDetail";
  code?: AggregateVersionStatusDetail["code"];
  name?: AggregateVersionStatusDetail["name"];
}

export function newAggregateVersionStatusDetail(
  options: AggregateVersionStatusDetailOptions = {},
  cache: Record<string, any> = {},
): AggregateVersionStatusDetail {
  const o = (options.__typename ? options : cache["AggregateVersionStatusDetail"] = {}) as AggregateVersionStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AggregateVersionStatusDetail";
  o.code = options.code ?? AggregateVersionStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["AggregateVersionStatusDetail"] = newAggregateVersionStatusDetail;

export interface AiEntityProposalEntityTypeDetailOptions {
  __typename?: "AiEntityProposalEntityTypeDetail";
  code?: AiEntityProposalEntityTypeDetail["code"];
  name?: AiEntityProposalEntityTypeDetail["name"];
}

export function newAiEntityProposalEntityTypeDetail(
  options: AiEntityProposalEntityTypeDetailOptions = {},
  cache: Record<string, any> = {},
): AiEntityProposalEntityTypeDetail {
  const o =
    (options.__typename ? options : cache["AiEntityProposalEntityTypeDetail"] = {}) as AiEntityProposalEntityTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AiEntityProposalEntityTypeDetail";
  o.code = options.code ?? AiEntityProposalEntityType.MaterialVariant;
  o.name = options.name ?? "Material variant";
  return o;
}

factories["AiEntityProposalEntityTypeDetail"] = newAiEntityProposalEntityTypeDetail;

export interface AiEntityProposalTypeDetailOptions {
  __typename?: "AiEntityProposalTypeDetail";
  code?: AiEntityProposalTypeDetail["code"];
  name?: AiEntityProposalTypeDetail["name"];
}

export function newAiEntityProposalTypeDetail(
  options: AiEntityProposalTypeDetailOptions = {},
  cache: Record<string, any> = {},
): AiEntityProposalTypeDetail {
  const o = (options.__typename ? options : cache["AiEntityProposalTypeDetail"] = {}) as AiEntityProposalTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AiEntityProposalTypeDetail";
  o.code = options.code ?? AiEntityProposalType.Create;
  o.name = options.name ?? "Create";
  return o;
}

factories["AiEntityProposalTypeDetail"] = newAiEntityProposalTypeDetail;

export interface AiFieldProposalStatusDetailOptions {
  __typename?: "AiFieldProposalStatusDetail";
  code?: AiFieldProposalStatusDetail["code"];
  name?: AiFieldProposalStatusDetail["name"];
}

export function newAiFieldProposalStatusDetail(
  options: AiFieldProposalStatusDetailOptions = {},
  cache: Record<string, any> = {},
): AiFieldProposalStatusDetail {
  const o = (options.__typename ? options : cache["AiFieldProposalStatusDetail"] = {}) as AiFieldProposalStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AiFieldProposalStatusDetail";
  o.code = options.code ?? AiFieldProposalStatus.Pending;
  o.name = options.name ?? "Pending";
  return o;
}

factories["AiFieldProposalStatusDetail"] = newAiFieldProposalStatusDetail;

export interface AiProposalStatusDetailOptions {
  __typename?: "AiProposalStatusDetail";
  code?: AiProposalStatusDetail["code"];
  name?: AiProposalStatusDetail["name"];
}

export function newAiProposalStatusDetail(
  options: AiProposalStatusDetailOptions = {},
  cache: Record<string, any> = {},
): AiProposalStatusDetail {
  const o = (options.__typename ? options : cache["AiProposalStatusDetail"] = {}) as AiProposalStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AiProposalStatusDetail";
  o.code = options.code ?? AiProposalStatus.Pending;
  o.name = options.name ?? "Pending";
  return o;
}

factories["AiProposalStatusDetail"] = newAiProposalStatusDetail;

export interface AiProposalTypeDetailOptions {
  __typename?: "AiProposalTypeDetail";
  code?: AiProposalTypeDetail["code"];
  name?: AiProposalTypeDetail["name"];
}

export function newAiProposalTypeDetail(
  options: AiProposalTypeDetailOptions = {},
  cache: Record<string, any> = {},
): AiProposalTypeDetail {
  const o = (options.__typename ? options : cache["AiProposalTypeDetail"] = {}) as AiProposalTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AiProposalTypeDetail";
  o.code = options.code ?? AiProposalType.ConstructionDocumentImport;
  o.name = options.name ?? "Construction document import";
  return o;
}

factories["AiProposalTypeDetail"] = newAiProposalTypeDetail;

export interface AllocationStrategyDetailOptions {
  __typename?: "AllocationStrategyDetail";
  code?: AllocationStrategyDetail["code"];
  name?: AllocationStrategyDetail["name"];
}

export function newAllocationStrategyDetail(
  options: AllocationStrategyDetailOptions = {},
  cache: Record<string, any> = {},
): AllocationStrategyDetail {
  const o = (options.__typename ? options : cache["AllocationStrategyDetail"] = {}) as AllocationStrategyDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AllocationStrategyDetail";
  o.code = options.code ?? AllocationStrategy.SizeBased;
  o.name = options.name ?? "Size based";
  return o;
}

factories["AllocationStrategyDetail"] = newAllocationStrategyDetail;

export interface ApprovalStatusDetailOptions {
  __typename?: "ApprovalStatusDetail";
  code?: ApprovalStatusDetail["code"];
  name?: ApprovalStatusDetail["name"];
  sortOrder?: ApprovalStatusDetail["sortOrder"];
}

export function newApprovalStatusDetail(
  options: ApprovalStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ApprovalStatusDetail {
  const o = (options.__typename ? options : cache["ApprovalStatusDetail"] = {}) as ApprovalStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ApprovalStatusDetail";
  o.code = options.code ?? ApprovalStatus.ChangesNeeded;
  o.name = options.name ?? "Changes needed";
  o.sortOrder = options.sortOrder ?? 0;
  return o;
}

factories["ApprovalStatusDetail"] = newApprovalStatusDetail;

export interface ApproverStatusDetailOptions {
  __typename?: "ApproverStatusDetail";
  code?: ApproverStatusDetail["code"];
  name?: ApproverStatusDetail["name"];
  sortOrder?: ApproverStatusDetail["sortOrder"];
}

export function newApproverStatusDetail(
  options: ApproverStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ApproverStatusDetail {
  const o = (options.__typename ? options : cache["ApproverStatusDetail"] = {}) as ApproverStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ApproverStatusDetail";
  o.code = options.code ?? ApproverStatus.Pending;
  o.name = options.name ?? "Pending";
  o.sortOrder = options.sortOrder ?? 0;
  return o;
}

factories["ApproverStatusDetail"] = newApproverStatusDetail;

export interface BidContractRevisionStatusDetailOptions {
  __typename?: "BidContractRevisionStatusDetail";
  code?: BidContractRevisionStatusDetail["code"];
  name?: BidContractRevisionStatusDetail["name"];
}

export function newBidContractRevisionStatusDetail(
  options: BidContractRevisionStatusDetailOptions = {},
  cache: Record<string, any> = {},
): BidContractRevisionStatusDetail {
  const o =
    (options.__typename ? options : cache["BidContractRevisionStatusDetail"] = {}) as BidContractRevisionStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContractRevisionStatusDetail";
  o.code = options.code ?? BidContractRevisionStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["BidContractRevisionStatusDetail"] = newBidContractRevisionStatusDetail;

export interface BidContractTypeDetailOptions {
  __typename?: "BidContractTypeDetail";
  code?: BidContractTypeDetail["code"];
  name?: BidContractTypeDetail["name"];
}

export function newBidContractTypeDetail(
  options: BidContractTypeDetailOptions = {},
  cache: Record<string, any> = {},
): BidContractTypeDetail {
  const o = (options.__typename ? options : cache["BidContractTypeDetail"] = {}) as BidContractTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContractTypeDetail";
  o.code = options.code ?? BidContractType.UnitBased;
  o.name = options.name ?? "Unit based";
  return o;
}

factories["BidContractTypeDetail"] = newBidContractTypeDetail;

export interface BidPackageStatusDetailOptions {
  __typename?: "BidPackageStatusDetail";
  code?: BidPackageStatusDetail["code"];
  name?: BidPackageStatusDetail["name"];
}

export function newBidPackageStatusDetail(
  options: BidPackageStatusDetailOptions = {},
  cache: Record<string, any> = {},
): BidPackageStatusDetail {
  const o = (options.__typename ? options : cache["BidPackageStatusDetail"] = {}) as BidPackageStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageStatusDetail";
  o.code = options.code ?? BidPackageStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["BidPackageStatusDetail"] = newBidPackageStatusDetail;

export interface BidScopeSourceDetailOptions {
  __typename?: "BidScopeSourceDetail";
  code?: BidScopeSourceDetail["code"];
  name?: BidScopeSourceDetail["name"];
}

export function newBidScopeSourceDetail(
  options: BidScopeSourceDetailOptions = {},
  cache: Record<string, any> = {},
): BidScopeSourceDetail {
  const o = (options.__typename ? options : cache["BidScopeSourceDetail"] = {}) as BidScopeSourceDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidScopeSourceDetail";
  o.code = options.code ?? BidScopeSource.Community;
  o.name = options.name ?? "Community";
  return o;
}

factories["BidScopeSourceDetail"] = newBidScopeSourceDetail;

export interface BillGmailAttachmentResultDetailOptions {
  __typename?: "BillGmailAttachmentResultDetail";
  code?: BillGmailAttachmentResultDetail["code"];
  name?: BillGmailAttachmentResultDetail["name"];
}

export function newBillGmailAttachmentResultDetail(
  options: BillGmailAttachmentResultDetailOptions = {},
  cache: Record<string, any> = {},
): BillGmailAttachmentResultDetail {
  const o =
    (options.__typename ? options : cache["BillGmailAttachmentResultDetail"] = {}) as BillGmailAttachmentResultDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillGmailAttachmentResultDetail";
  o.code = options.code ?? BillGmailAttachmentResult.NotPdf;
  o.name = options.name ?? "Not pdf";
  return o;
}

factories["BillGmailAttachmentResultDetail"] = newBillGmailAttachmentResultDetail;

export interface BillGmailMessageResultDetailOptions {
  __typename?: "BillGmailMessageResultDetail";
  code?: BillGmailMessageResultDetail["code"];
  name?: BillGmailMessageResultDetail["name"];
}

export function newBillGmailMessageResultDetail(
  options: BillGmailMessageResultDetailOptions = {},
  cache: Record<string, any> = {},
): BillGmailMessageResultDetail {
  const o = (options.__typename ? options : cache["BillGmailMessageResultDetail"] = {}) as BillGmailMessageResultDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillGmailMessageResultDetail";
  o.code = options.code ?? BillGmailMessageResult.NotFound;
  o.name = options.name ?? "Not found";
  return o;
}

factories["BillGmailMessageResultDetail"] = newBillGmailMessageResultDetail;

export interface BillReviewReasonDetailOptions {
  __typename?: "BillReviewReasonDetail";
  code?: BillReviewReasonDetail["code"];
  name?: BillReviewReasonDetail["name"];
}

export function newBillReviewReasonDetail(
  options: BillReviewReasonDetailOptions = {},
  cache: Record<string, any> = {},
): BillReviewReasonDetail {
  const o = (options.__typename ? options : cache["BillReviewReasonDetail"] = {}) as BillReviewReasonDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillReviewReasonDetail";
  o.code = options.code ?? BillReviewReason.MissingPo;
  o.name = options.name ?? "Missing po";
  return o;
}

factories["BillReviewReasonDetail"] = newBillReviewReasonDetail;

export interface BillSourceDetailOptions {
  __typename?: "BillSourceDetail";
  code?: BillSourceDetail["code"];
  name?: BillSourceDetail["name"];
}

export function newBillSourceDetail(
  options: BillSourceDetailOptions = {},
  cache: Record<string, any> = {},
): BillSourceDetail {
  const o = (options.__typename ? options : cache["BillSourceDetail"] = {}) as BillSourceDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillSourceDetail";
  o.code = options.code ?? BillSource.Manual;
  o.name = options.name ?? "Manual";
  return o;
}

factories["BillSourceDetail"] = newBillSourceDetail;

export interface BillStatusDetailOptions {
  __typename?: "BillStatusDetail";
  code?: BillStatusDetail["code"];
  name?: BillStatusDetail["name"];
}

export function newBillStatusDetail(
  options: BillStatusDetailOptions = {},
  cache: Record<string, any> = {},
): BillStatusDetail {
  const o = (options.__typename ? options : cache["BillStatusDetail"] = {}) as BillStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillStatusDetail";
  o.code = options.code ?? BillStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["BillStatusDetail"] = newBillStatusDetail;

export interface BillTypeDetailOptions {
  __typename?: "BillTypeDetail";
  code?: BillTypeDetail["code"];
  name?: BillTypeDetail["name"];
}

export function newBillTypeDetail(
  options: BillTypeDetailOptions = {},
  cache: Record<string, any> = {},
): BillTypeDetail {
  const o = (options.__typename ? options : cache["BillTypeDetail"] = {}) as BillTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillTypeDetail";
  o.code = options.code ?? BillType.Standard;
  o.name = options.name ?? "Standard";
  return o;
}

factories["BillTypeDetail"] = newBillTypeDetail;

export interface BusinessFunctionTypeDetailOptions {
  __typename?: "BusinessFunctionTypeDetail";
  code?: BusinessFunctionTypeDetail["code"];
  name?: BusinessFunctionTypeDetail["name"];
}

export function newBusinessFunctionTypeDetail(
  options: BusinessFunctionTypeDetailOptions = {},
  cache: Record<string, any> = {},
): BusinessFunctionTypeDetail {
  const o = (options.__typename ? options : cache["BusinessFunctionTypeDetail"] = {}) as BusinessFunctionTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BusinessFunctionTypeDetail";
  o.code = options.code ?? BusinessFunctionType.Architecture;
  o.name = options.name ?? "Architecture";
  return o;
}

factories["BusinessFunctionTypeDetail"] = newBusinessFunctionTypeDetail;

export interface BuyoutStatusDetailOptions {
  __typename?: "BuyoutStatusDetail";
  code?: BuyoutStatusDetail["code"];
  name?: BuyoutStatusDetail["name"];
  shortName?: BuyoutStatusDetail["shortName"];
}

export function newBuyoutStatusDetail(
  options: BuyoutStatusDetailOptions = {},
  cache: Record<string, any> = {},
): BuyoutStatusDetail {
  const o = (options.__typename ? options : cache["BuyoutStatusDetail"] = {}) as BuyoutStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BuyoutStatusDetail";
  o.code = options.code ?? BuyoutStatus.NotBoughtOut;
  o.name = options.name ?? "Not bought out";
  o.shortName = options.shortName ?? "Not bought out";
  return o;
}

factories["BuyoutStatusDetail"] = newBuyoutStatusDetail;

export interface ChangeEventBudgetPhaseDetailOptions {
  __typename?: "ChangeEventBudgetPhaseDetail";
  code?: ChangeEventBudgetPhaseDetail["code"];
  name?: ChangeEventBudgetPhaseDetail["name"];
  sortOrder?: ChangeEventBudgetPhaseDetail["sortOrder"];
}

export function newChangeEventBudgetPhaseDetail(
  options: ChangeEventBudgetPhaseDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeEventBudgetPhaseDetail {
  const o = (options.__typename ? options : cache["ChangeEventBudgetPhaseDetail"] = {}) as ChangeEventBudgetPhaseDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventBudgetPhaseDetail";
  o.code = options.code ?? ChangeEventBudgetPhase.Prebid;
  o.name = options.name ?? "Prebid";
  o.sortOrder = options.sortOrder ?? 0;
  return o;
}

factories["ChangeEventBudgetPhaseDetail"] = newChangeEventBudgetPhaseDetail;

export interface ChangeEventLineItemTypeDetailOptions {
  __typename?: "ChangeEventLineItemTypeDetail";
  code?: ChangeEventLineItemTypeDetail["code"];
  name?: ChangeEventLineItemTypeDetail["name"];
}

export function newChangeEventLineItemTypeDetail(
  options: ChangeEventLineItemTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeEventLineItemTypeDetail {
  const o =
    (options.__typename ? options : cache["ChangeEventLineItemTypeDetail"] = {}) as ChangeEventLineItemTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventLineItemTypeDetail";
  o.code = options.code ?? ChangeEventLineItemType.Add;
  o.name = options.name ?? "Add";
  return o;
}

factories["ChangeEventLineItemTypeDetail"] = newChangeEventLineItemTypeDetail;

export interface ChangeEventStatusDetailOptions {
  __typename?: "ChangeEventStatusDetail";
  code?: ChangeEventStatusDetail["code"];
  name?: ChangeEventStatusDetail["name"];
}

export function newChangeEventStatusDetail(
  options: ChangeEventStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeEventStatusDetail {
  const o = (options.__typename ? options : cache["ChangeEventStatusDetail"] = {}) as ChangeEventStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventStatusDetail";
  o.code = options.code ?? ChangeEventStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["ChangeEventStatusDetail"] = newChangeEventStatusDetail;

export interface ChangeEventTypeDetailOptions {
  __typename?: "ChangeEventTypeDetail";
  code?: ChangeEventTypeDetail["code"];
  name?: ChangeEventTypeDetail["name"];
}

export function newChangeEventTypeDetail(
  options: ChangeEventTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeEventTypeDetail {
  const o = (options.__typename ? options : cache["ChangeEventTypeDetail"] = {}) as ChangeEventTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventTypeDetail";
  o.code = options.code ?? ChangeEventType.Internal;
  o.name = options.name ?? "Internal";
  return o;
}

factories["ChangeEventTypeDetail"] = newChangeEventTypeDetail;

export interface ChangeEventWorkflowDetailOptions {
  __typename?: "ChangeEventWorkflowDetail";
  code?: ChangeEventWorkflowDetail["code"];
  name?: ChangeEventWorkflowDetail["name"];
  description?: ChangeEventWorkflowDetail["description"];
}

export function newChangeEventWorkflowDetail(
  options: ChangeEventWorkflowDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeEventWorkflowDetail {
  const o = (options.__typename ? options : cache["ChangeEventWorkflowDetail"] = {}) as ChangeEventWorkflowDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventWorkflowDetail";
  o.code = options.code ?? ChangeEventWorkflow.ApplyFullConfiguration;
  o.name = options.name ?? "Apply full configuration";
  o.description = options.description ?? "Apply full configuration";
  return o;
}

factories["ChangeEventWorkflowDetail"] = newChangeEventWorkflowDetail;

export interface ChangeRequestAssetPlatformDetailOptions {
  __typename?: "ChangeRequestAssetPlatformDetail";
  code?: ChangeRequestAssetPlatformDetail["code"];
  name?: ChangeRequestAssetPlatformDetail["name"];
}

export function newChangeRequestAssetPlatformDetail(
  options: ChangeRequestAssetPlatformDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestAssetPlatformDetail {
  const o =
    (options.__typename ? options : cache["ChangeRequestAssetPlatformDetail"] = {}) as ChangeRequestAssetPlatformDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestAssetPlatformDetail";
  o.code = options.code ?? ChangeRequestAssetPlatform.Blueprint;
  o.name = options.name ?? "Blueprint";
  return o;
}

factories["ChangeRequestAssetPlatformDetail"] = newChangeRequestAssetPlatformDetail;

export interface ChangeRequestAssetScopeDetailOptions {
  __typename?: "ChangeRequestAssetScopeDetail";
  code?: ChangeRequestAssetScopeDetail["code"];
  name?: ChangeRequestAssetScopeDetail["name"];
}

export function newChangeRequestAssetScopeDetail(
  options: ChangeRequestAssetScopeDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestAssetScopeDetail {
  const o =
    (options.__typename ? options : cache["ChangeRequestAssetScopeDetail"] = {}) as ChangeRequestAssetScopeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestAssetScopeDetail";
  o.code = options.code ?? ChangeRequestAssetScope.Project;
  o.name = options.name ?? "Project";
  return o;
}

factories["ChangeRequestAssetScopeDetail"] = newChangeRequestAssetScopeDetail;

export interface ChangeRequestPriorityDetailOptions {
  __typename?: "ChangeRequestPriorityDetail";
  code?: ChangeRequestPriorityDetail["code"];
  name?: ChangeRequestPriorityDetail["name"];
}

export function newChangeRequestPriorityDetail(
  options: ChangeRequestPriorityDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestPriorityDetail {
  const o = (options.__typename ? options : cache["ChangeRequestPriorityDetail"] = {}) as ChangeRequestPriorityDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestPriorityDetail";
  o.code = options.code ?? ChangeRequestPriority.Low;
  o.name = options.name ?? "Low";
  return o;
}

factories["ChangeRequestPriorityDetail"] = newChangeRequestPriorityDetail;

export interface ChangeRequestSourceDetailOptions {
  __typename?: "ChangeRequestSourceDetail";
  code?: ChangeRequestSourceDetail["code"];
  name?: ChangeRequestSourceDetail["name"];
}

export function newChangeRequestSourceDetail(
  options: ChangeRequestSourceDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestSourceDetail {
  const o = (options.__typename ? options : cache["ChangeRequestSourceDetail"] = {}) as ChangeRequestSourceDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestSourceDetail";
  o.code = options.code ?? ChangeRequestSource.Na;
  o.name = options.name ?? "Na";
  return o;
}

factories["ChangeRequestSourceDetail"] = newChangeRequestSourceDetail;

export interface ChangeRequestStatusDetailOptions {
  __typename?: "ChangeRequestStatusDetail";
  code?: ChangeRequestStatusDetail["code"];
  name?: ChangeRequestStatusDetail["name"];
}

export function newChangeRequestStatusDetail(
  options: ChangeRequestStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestStatusDetail {
  const o = (options.__typename ? options : cache["ChangeRequestStatusDetail"] = {}) as ChangeRequestStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestStatusDetail";
  o.code = options.code ?? ChangeRequestStatus.NeedsReview;
  o.name = options.name ?? "Needs review";
  return o;
}

factories["ChangeRequestStatusDetail"] = newChangeRequestStatusDetail;

export interface ChangeRequestToDoTypeDetailOptions {
  __typename?: "ChangeRequestToDoTypeDetail";
  code?: ChangeRequestToDoTypeDetail["code"];
  name?: ChangeRequestToDoTypeDetail["name"];
}

export function newChangeRequestToDoTypeDetail(
  options: ChangeRequestToDoTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestToDoTypeDetail {
  const o = (options.__typename ? options : cache["ChangeRequestToDoTypeDetail"] = {}) as ChangeRequestToDoTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestToDoTypeDetail";
  o.code = options.code ?? ChangeRequestToDoType.InitialReview;
  o.name = options.name ?? "Initial review";
  return o;
}

factories["ChangeRequestToDoTypeDetail"] = newChangeRequestToDoTypeDetail;

export interface ChangeTypeDetailOptions {
  __typename?: "ChangeTypeDetail";
  code?: ChangeTypeDetail["code"];
  name?: ChangeTypeDetail["name"];
  sortOrder?: ChangeTypeDetail["sortOrder"];
}

export function newChangeTypeDetail(
  options: ChangeTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeTypeDetail {
  const o = (options.__typename ? options : cache["ChangeTypeDetail"] = {}) as ChangeTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeTypeDetail";
  o.code = options.code ?? ChangeType.Na;
  o.name = options.name ?? "Na";
  o.sortOrder = options.sortOrder ?? 0;
  return o;
}

factories["ChangeTypeDetail"] = newChangeTypeDetail;

export interface CheckoutConfigOptionGroupStepDetailOptions {
  __typename?: "CheckoutConfigOptionGroupStepDetail";
  code?: CheckoutConfigOptionGroupStepDetail["code"];
  name?: CheckoutConfigOptionGroupStepDetail["name"];
}

export function newCheckoutConfigOptionGroupStepDetail(
  options: CheckoutConfigOptionGroupStepDetailOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfigOptionGroupStepDetail {
  const o =
    (options.__typename
      ? options
      : cache["CheckoutConfigOptionGroupStepDetail"] = {}) as CheckoutConfigOptionGroupStepDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfigOptionGroupStepDetail";
  o.code = options.code ?? CheckoutConfigOptionGroupStep.ExteriorElevation;
  o.name = options.name ?? "Exterior elevation";
  return o;
}

factories["CheckoutConfigOptionGroupStepDetail"] = newCheckoutConfigOptionGroupStepDetail;

export interface CheckoutConfigStatusDetailOptions {
  __typename?: "CheckoutConfigStatusDetail";
  code?: CheckoutConfigStatusDetail["code"];
  name?: CheckoutConfigStatusDetail["name"];
}

export function newCheckoutConfigStatusDetail(
  options: CheckoutConfigStatusDetailOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfigStatusDetail {
  const o = (options.__typename ? options : cache["CheckoutConfigStatusDetail"] = {}) as CheckoutConfigStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfigStatusDetail";
  o.code = options.code ?? CheckoutConfigStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["CheckoutConfigStatusDetail"] = newCheckoutConfigStatusDetail;

export interface ClientPlatformDetailOptions {
  __typename?: "ClientPlatformDetail";
  code?: ClientPlatformDetail["code"];
  name?: ClientPlatformDetail["name"];
}

export function newClientPlatformDetail(
  options: ClientPlatformDetailOptions = {},
  cache: Record<string, any> = {},
): ClientPlatformDetail {
  const o = (options.__typename ? options : cache["ClientPlatformDetail"] = {}) as ClientPlatformDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ClientPlatformDetail";
  o.code = options.code ?? ClientPlatform.Web;
  o.name = options.name ?? "Web";
  return o;
}

factories["ClientPlatformDetail"] = newClientPlatformDetail;

export interface CommentStreamVisibilityDetailOptions {
  __typename?: "CommentStreamVisibilityDetail";
  code?: CommentStreamVisibilityDetail["code"];
  name?: CommentStreamVisibilityDetail["name"];
}

export function newCommentStreamVisibilityDetail(
  options: CommentStreamVisibilityDetailOptions = {},
  cache: Record<string, any> = {},
): CommentStreamVisibilityDetail {
  const o =
    (options.__typename ? options : cache["CommentStreamVisibilityDetail"] = {}) as CommentStreamVisibilityDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommentStreamVisibilityDetail";
  o.code = options.code ?? CommentStreamVisibility.Internal;
  o.name = options.name ?? "Internal";
  return o;
}

factories["CommentStreamVisibilityDetail"] = newCommentStreamVisibilityDetail;

export interface CommitmentStatusDetailOptions {
  __typename?: "CommitmentStatusDetail";
  code?: CommitmentStatusDetail["code"];
  name?: CommitmentStatusDetail["name"];
}

export function newCommitmentStatusDetail(
  options: CommitmentStatusDetailOptions = {},
  cache: Record<string, any> = {},
): CommitmentStatusDetail {
  const o = (options.__typename ? options : cache["CommitmentStatusDetail"] = {}) as CommitmentStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentStatusDetail";
  o.code = options.code ?? CommitmentStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["CommitmentStatusDetail"] = newCommitmentStatusDetail;

export interface CommitmentTypeDetailOptions {
  __typename?: "CommitmentTypeDetail";
  code?: CommitmentTypeDetail["code"];
  name?: CommitmentTypeDetail["name"];
}

export function newCommitmentTypeDetail(
  options: CommitmentTypeDetailOptions = {},
  cache: Record<string, any> = {},
): CommitmentTypeDetail {
  const o = (options.__typename ? options : cache["CommitmentTypeDetail"] = {}) as CommitmentTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentTypeDetail";
  o.code = options.code ?? CommitmentType.PurchaseOrder;
  o.name = options.name ?? "Purchase order";
  return o;
}

factories["CommitmentTypeDetail"] = newCommitmentTypeDetail;

export interface CommunicationChannelDetailOptions {
  __typename?: "CommunicationChannelDetail";
  code?: CommunicationChannelDetail["code"];
  name?: CommunicationChannelDetail["name"];
}

export function newCommunicationChannelDetail(
  options: CommunicationChannelDetailOptions = {},
  cache: Record<string, any> = {},
): CommunicationChannelDetail {
  const o = (options.__typename ? options : cache["CommunicationChannelDetail"] = {}) as CommunicationChannelDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommunicationChannelDetail";
  o.code = options.code ?? CommunicationChannel.Email;
  o.name = options.name ?? "Email";
  return o;
}

factories["CommunicationChannelDetail"] = newCommunicationChannelDetail;

export interface CommunityTypeDetailOptions {
  __typename?: "CommunityTypeDetail";
  code?: CommunityTypeDetail["code"];
  name?: CommunityTypeDetail["name"];
}

export function newCommunityTypeDetail(
  options: CommunityTypeDetailOptions = {},
  cache: Record<string, any> = {},
): CommunityTypeDetail {
  const o = (options.__typename ? options : cache["CommunityTypeDetail"] = {}) as CommunityTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommunityTypeDetail";
  o.code = options.code ?? CommunityType.Infill;
  o.name = options.name ?? "Infill";
  return o;
}

factories["CommunityTypeDetail"] = newCommunityTypeDetail;

export interface ConstructionTypeDetailOptions {
  __typename?: "ConstructionTypeDetail";
  code?: ConstructionTypeDetail["code"];
  name?: ConstructionTypeDetail["name"];
}

export function newConstructionTypeDetail(
  options: ConstructionTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ConstructionTypeDetail {
  const o = (options.__typename ? options : cache["ConstructionTypeDetail"] = {}) as ConstructionTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ConstructionTypeDetail";
  o.code = options.code ?? ConstructionType.TypeIii;
  o.name = options.name ?? "Type iii";
  return o;
}

factories["ConstructionTypeDetail"] = newConstructionTypeDetail;

export interface ContractTypeDetailOptions {
  __typename?: "ContractTypeDetail";
  code?: ContractTypeDetail["code"];
  name?: ContractTypeDetail["name"];
}

export function newContractTypeDetail(
  options: ContractTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ContractTypeDetail {
  const o = (options.__typename ? options : cache["ContractTypeDetail"] = {}) as ContractTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ContractTypeDetail";
  o.code = options.code ?? ContractType.Fixed;
  o.name = options.name ?? "Fixed";
  return o;
}

factories["ContractTypeDetail"] = newContractTypeDetail;

export interface CostClassificationTypeDetailOptions {
  __typename?: "CostClassificationTypeDetail";
  code?: CostClassificationTypeDetail["code"];
  name?: CostClassificationTypeDetail["name"];
}

export function newCostClassificationTypeDetail(
  options: CostClassificationTypeDetailOptions = {},
  cache: Record<string, any> = {},
): CostClassificationTypeDetail {
  const o = (options.__typename ? options : cache["CostClassificationTypeDetail"] = {}) as CostClassificationTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostClassificationTypeDetail";
  o.code = options.code ?? CostClassificationType.Soft;
  o.name = options.name ?? "Soft";
  return o;
}

factories["CostClassificationTypeDetail"] = newCostClassificationTypeDetail;

export interface CostCodeInvoiceCategoryDetailOptions {
  __typename?: "CostCodeInvoiceCategoryDetail";
  code?: CostCodeInvoiceCategoryDetail["code"];
  name?: CostCodeInvoiceCategoryDetail["name"];
  includeInInvoiceScheduleProration?: CostCodeInvoiceCategoryDetail["includeInInvoiceScheduleProration"];
  sortOrder?: CostCodeInvoiceCategoryDetail["sortOrder"];
}

export function newCostCodeInvoiceCategoryDetail(
  options: CostCodeInvoiceCategoryDetailOptions = {},
  cache: Record<string, any> = {},
): CostCodeInvoiceCategoryDetail {
  const o =
    (options.__typename ? options : cache["CostCodeInvoiceCategoryDetail"] = {}) as CostCodeInvoiceCategoryDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostCodeInvoiceCategoryDetail";
  o.code = options.code ?? CostCodeInvoiceCategory.PreCon;
  o.name = options.name ?? "Pre con";
  o.includeInInvoiceScheduleProration = options.includeInInvoiceScheduleProration ?? false;
  o.sortOrder = options.sortOrder ?? 0;
  return o;
}

factories["CostCodeInvoiceCategoryDetail"] = newCostCodeInvoiceCategoryDetail;

export interface CostConfidenceDetailOptions {
  __typename?: "CostConfidenceDetail";
  code?: CostConfidenceDetail["code"];
  name?: CostConfidenceDetail["name"];
}

export function newCostConfidenceDetail(
  options: CostConfidenceDetailOptions = {},
  cache: Record<string, any> = {},
): CostConfidenceDetail {
  const o = (options.__typename ? options : cache["CostConfidenceDetail"] = {}) as CostConfidenceDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostConfidenceDetail";
  o.code = options.code ?? CostConfidence.Low;
  o.name = options.name ?? "Low";
  return o;
}

factories["CostConfidenceDetail"] = newCostConfidenceDetail;

export interface CostSubClassificationTypeDetailOptions {
  __typename?: "CostSubClassificationTypeDetail";
  code?: CostSubClassificationTypeDetail["code"];
  name?: CostSubClassificationTypeDetail["name"];
}

export function newCostSubClassificationTypeDetail(
  options: CostSubClassificationTypeDetailOptions = {},
  cache: Record<string, any> = {},
): CostSubClassificationTypeDetail {
  const o =
    (options.__typename ? options : cache["CostSubClassificationTypeDetail"] = {}) as CostSubClassificationTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostSubClassificationTypeDetail";
  o.code = options.code ?? CostSubClassificationType.Indirect;
  o.name = options.name ?? "Indirect";
  return o;
}

factories["CostSubClassificationTypeDetail"] = newCostSubClassificationTypeDetail;

export interface CostTypeDetailOptions {
  __typename?: "CostTypeDetail";
  code?: CostTypeDetail["code"];
  name?: CostTypeDetail["name"];
  tradePartnerName?: CostTypeDetail["tradePartnerName"];
}

export function newCostTypeDetail(
  options: CostTypeDetailOptions = {},
  cache: Record<string, any> = {},
): CostTypeDetail {
  const o = (options.__typename ? options : cache["CostTypeDetail"] = {}) as CostTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostTypeDetail";
  o.code = options.code ?? CostType.Labor;
  o.name = options.name ?? "Labor";
  o.tradePartnerName = options.tradePartnerName ?? "Labor";
  return o;
}

factories["CostTypeDetail"] = newCostTypeDetail;

export interface DayOfWeekDetailOptions {
  __typename?: "DayOfWeekDetail";
  code?: DayOfWeekDetail["code"];
  name?: DayOfWeekDetail["name"];
  isBusinessDay?: DayOfWeekDetail["isBusinessDay"];
}

export function newDayOfWeekDetail(
  options: DayOfWeekDetailOptions = {},
  cache: Record<string, any> = {},
): DayOfWeekDetail {
  const o = (options.__typename ? options : cache["DayOfWeekDetail"] = {}) as DayOfWeekDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DayOfWeekDetail";
  o.code = options.code ?? DayOfWeek.Saturday;
  o.name = options.name ?? "Saturday";
  o.isBusinessDay = options.isBusinessDay ?? false;
  return o;
}

factories["DayOfWeekDetail"] = newDayOfWeekDetail;

export interface DesignPackageLocationDetailOptions {
  __typename?: "DesignPackageLocationDetail";
  code?: DesignPackageLocationDetail["code"];
  name?: DesignPackageLocationDetail["name"];
}

export function newDesignPackageLocationDetail(
  options: DesignPackageLocationDetailOptions = {},
  cache: Record<string, any> = {},
): DesignPackageLocationDetail {
  const o = (options.__typename ? options : cache["DesignPackageLocationDetail"] = {}) as DesignPackageLocationDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackageLocationDetail";
  o.code = options.code ?? DesignPackageLocation.Interior;
  o.name = options.name ?? "Interior";
  return o;
}

factories["DesignPackageLocationDetail"] = newDesignPackageLocationDetail;

export interface DevelopmentCommitmentTypeDetailOptions {
  __typename?: "DevelopmentCommitmentTypeDetail";
  code?: DevelopmentCommitmentTypeDetail["code"];
  name?: DevelopmentCommitmentTypeDetail["name"];
}

export function newDevelopmentCommitmentTypeDetail(
  options: DevelopmentCommitmentTypeDetailOptions = {},
  cache: Record<string, any> = {},
): DevelopmentCommitmentTypeDetail {
  const o =
    (options.__typename ? options : cache["DevelopmentCommitmentTypeDetail"] = {}) as DevelopmentCommitmentTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentCommitmentTypeDetail";
  o.code = options.code ?? DevelopmentCommitmentType.Materials;
  o.name = options.name ?? "Materials";
  return o;
}

factories["DevelopmentCommitmentTypeDetail"] = newDevelopmentCommitmentTypeDetail;

export interface DocumentAttachmentPlaceDetailOptions {
  __typename?: "DocumentAttachmentPlaceDetail";
  code?: DocumentAttachmentPlaceDetail["code"];
  name?: DocumentAttachmentPlaceDetail["name"];
}

export function newDocumentAttachmentPlaceDetail(
  options: DocumentAttachmentPlaceDetailOptions = {},
  cache: Record<string, any> = {},
): DocumentAttachmentPlaceDetail {
  const o =
    (options.__typename ? options : cache["DocumentAttachmentPlaceDetail"] = {}) as DocumentAttachmentPlaceDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DocumentAttachmentPlaceDetail";
  o.code = options.code ?? DocumentAttachmentPlace.PurchaseOrder;
  o.name = options.name ?? "Purchase order";
  return o;
}

factories["DocumentAttachmentPlaceDetail"] = newDocumentAttachmentPlaceDetail;

export interface DocumentCategoryDetailOptions {
  __typename?: "DocumentCategoryDetail";
  code?: DocumentCategoryDetail["code"];
  name?: DocumentCategoryDetail["name"];
}

export function newDocumentCategoryDetail(
  options: DocumentCategoryDetailOptions = {},
  cache: Record<string, any> = {},
): DocumentCategoryDetail {
  const o = (options.__typename ? options : cache["DocumentCategoryDetail"] = {}) as DocumentCategoryDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DocumentCategoryDetail";
  o.code = options.code ?? DocumentCategory.Contractual;
  o.name = options.name ?? "Contractual";
  return o;
}

factories["DocumentCategoryDetail"] = newDocumentCategoryDetail;

export interface DocumentTypeDetailOptions {
  __typename?: "DocumentTypeDetail";
  code?: DocumentTypeDetail["code"];
  name?: DocumentTypeDetail["name"];
  systemControlled?: DocumentTypeDetail["systemControlled"];
  defaultHomeownerVisible?: DocumentTypeDetail["defaultHomeownerVisible"];
  boolDefaultHomeownerVisible?: DocumentTypeDetail["boolDefaultHomeownerVisible"];
}

export function newDocumentTypeDetail(
  options: DocumentTypeDetailOptions = {},
  cache: Record<string, any> = {},
): DocumentTypeDetail {
  const o = (options.__typename ? options : cache["DocumentTypeDetail"] = {}) as DocumentTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DocumentTypeDetail";
  o.code = options.code ?? DocumentType.PreconAgreement;
  o.name = options.name ?? "Precon agreement";
  o.systemControlled = options.systemControlled ?? false;
  o.defaultHomeownerVisible = options.defaultHomeownerVisible ?? false;
  o.boolDefaultHomeownerVisible = options.boolDefaultHomeownerVisible ?? false;
  return o;
}

factories["DocumentTypeDetail"] = newDocumentTypeDetail;

export interface ErpAccrualTypeDetailOptions {
  __typename?: "ErpAccrualTypeDetail";
  code?: ErpAccrualTypeDetail["code"];
  name?: ErpAccrualTypeDetail["name"];
}

export function newErpAccrualTypeDetail(
  options: ErpAccrualTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ErpAccrualTypeDetail {
  const o = (options.__typename ? options : cache["ErpAccrualTypeDetail"] = {}) as ErpAccrualTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ErpAccrualTypeDetail";
  o.code = options.code ?? ErpAccrualType.TaskCompletion;
  o.name = options.name ?? "Task completion";
  return o;
}

factories["ErpAccrualTypeDetail"] = newErpAccrualTypeDetail;

export interface ErpRevenueLineItemSourceEventDetailOptions {
  __typename?: "ErpRevenueLineItemSourceEventDetail";
  code?: ErpRevenueLineItemSourceEventDetail["code"];
  name?: ErpRevenueLineItemSourceEventDetail["name"];
}

export function newErpRevenueLineItemSourceEventDetail(
  options: ErpRevenueLineItemSourceEventDetailOptions = {},
  cache: Record<string, any> = {},
): ErpRevenueLineItemSourceEventDetail {
  const o =
    (options.__typename
      ? options
      : cache["ErpRevenueLineItemSourceEventDetail"] = {}) as ErpRevenueLineItemSourceEventDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ErpRevenueLineItemSourceEventDetail";
  o.code = options.code ?? ErpRevenueLineItemSourceEvent.ContractPriceChange;
  o.name = options.name ?? "Contract price change";
  return o;
}

factories["ErpRevenueLineItemSourceEventDetail"] = newErpRevenueLineItemSourceEventDetail;

export interface ErpTransactionGroupEventDetailOptions {
  __typename?: "ErpTransactionGroupEventDetail";
  code?: ErpTransactionGroupEventDetail["code"];
  name?: ErpTransactionGroupEventDetail["name"];
}

export function newErpTransactionGroupEventDetail(
  options: ErpTransactionGroupEventDetailOptions = {},
  cache: Record<string, any> = {},
): ErpTransactionGroupEventDetail {
  const o =
    (options.__typename ? options : cache["ErpTransactionGroupEventDetail"] = {}) as ErpTransactionGroupEventDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ErpTransactionGroupEventDetail";
  o.code = options.code ?? ErpTransactionGroupEvent.TaskCompletion;
  o.name = options.name ?? "Task completion";
  return o;
}

factories["ErpTransactionGroupEventDetail"] = newErpTransactionGroupEventDetail;

export interface ErpTransactionGroupStatusDetailOptions {
  __typename?: "ErpTransactionGroupStatusDetail";
  code?: ErpTransactionGroupStatusDetail["code"];
  name?: ErpTransactionGroupStatusDetail["name"];
}

export function newErpTransactionGroupStatusDetail(
  options: ErpTransactionGroupStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ErpTransactionGroupStatusDetail {
  const o =
    (options.__typename ? options : cache["ErpTransactionGroupStatusDetail"] = {}) as ErpTransactionGroupStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ErpTransactionGroupStatusDetail";
  o.code = options.code ?? ErpTransactionGroupStatus.Pending;
  o.name = options.name ?? "Pending";
  return o;
}

factories["ErpTransactionGroupStatusDetail"] = newErpTransactionGroupStatusDetail;

export interface ErpTransactionStatusDetailOptions {
  __typename?: "ErpTransactionStatusDetail";
  code?: ErpTransactionStatusDetail["code"];
  name?: ErpTransactionStatusDetail["name"];
}

export function newErpTransactionStatusDetail(
  options: ErpTransactionStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ErpTransactionStatusDetail {
  const o = (options.__typename ? options : cache["ErpTransactionStatusDetail"] = {}) as ErpTransactionStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ErpTransactionStatusDetail";
  o.code = options.code ?? ErpTransactionStatus.Pending;
  o.name = options.name ?? "Pending";
  return o;
}

factories["ErpTransactionStatusDetail"] = newErpTransactionStatusDetail;

export interface EstimateStatusDetailOptions {
  __typename?: "EstimateStatusDetail";
  code?: EstimateStatusDetail["code"];
  name?: EstimateStatusDetail["name"];
}

export function newEstimateStatusDetail(
  options: EstimateStatusDetailOptions = {},
  cache: Record<string, any> = {},
): EstimateStatusDetail {
  const o = (options.__typename ? options : cache["EstimateStatusDetail"] = {}) as EstimateStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EstimateStatusDetail";
  o.code = options.code ?? EstimateStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["EstimateStatusDetail"] = newEstimateStatusDetail;

export interface EstimateTypeDetailOptions {
  __typename?: "EstimateTypeDetail";
  code?: EstimateTypeDetail["code"];
  name?: EstimateTypeDetail["name"];
}

export function newEstimateTypeDetail(
  options: EstimateTypeDetailOptions = {},
  cache: Record<string, any> = {},
): EstimateTypeDetail {
  const o = (options.__typename ? options : cache["EstimateTypeDetail"] = {}) as EstimateTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EstimateTypeDetail";
  o.code = options.code ?? EstimateType.Preliminary;
  o.name = options.name ?? "Preliminary";
  return o;
}

factories["EstimateTypeDetail"] = newEstimateTypeDetail;

export interface FeatureFlagStatusDetailOptions {
  __typename?: "FeatureFlagStatusDetail";
  code?: FeatureFlagStatusDetail["code"];
  name?: FeatureFlagStatusDetail["name"];
}

export function newFeatureFlagStatusDetail(
  options: FeatureFlagStatusDetailOptions = {},
  cache: Record<string, any> = {},
): FeatureFlagStatusDetail {
  const o = (options.__typename ? options : cache["FeatureFlagStatusDetail"] = {}) as FeatureFlagStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FeatureFlagStatusDetail";
  o.code = options.code ?? FeatureFlagStatus.Active;
  o.name = options.name ?? "Active";
  return o;
}

factories["FeatureFlagStatusDetail"] = newFeatureFlagStatusDetail;

export interface FeatureFlagTypeDetailOptions {
  __typename?: "FeatureFlagTypeDetail";
  code?: FeatureFlagTypeDetail["code"];
  name?: FeatureFlagTypeDetail["name"];
  description?: FeatureFlagTypeDetail["description"];
  presentational?: FeatureFlagTypeDetail["presentational"];
}

export function newFeatureFlagTypeDetail(
  options: FeatureFlagTypeDetailOptions = {},
  cache: Record<string, any> = {},
): FeatureFlagTypeDetail {
  const o = (options.__typename ? options : cache["FeatureFlagTypeDetail"] = {}) as FeatureFlagTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FeatureFlagTypeDetail";
  o.code = options.code ?? FeatureFlagType.TestFeature;
  o.name = options.name ?? "Test feature";
  o.description = options.description ?? "Test feature";
  o.presentational = options.presentational ?? false;
  return o;
}

factories["FeatureFlagTypeDetail"] = newFeatureFlagTypeDetail;

export interface FinishScheduleColumnTypeDetailOptions {
  __typename?: "FinishScheduleColumnTypeDetail";
  code?: FinishScheduleColumnTypeDetail["code"];
  name?: FinishScheduleColumnTypeDetail["name"];
}

export function newFinishScheduleColumnTypeDetail(
  options: FinishScheduleColumnTypeDetailOptions = {},
  cache: Record<string, any> = {},
): FinishScheduleColumnTypeDetail {
  const o =
    (options.__typename ? options : cache["FinishScheduleColumnTypeDetail"] = {}) as FinishScheduleColumnTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FinishScheduleColumnTypeDetail";
  o.code = options.code ?? FinishScheduleColumnType.Core;
  o.name = options.name ?? "Core";
  return o;
}

factories["FinishScheduleColumnTypeDetail"] = newFinishScheduleColumnTypeDetail;

export interface FinishScheduleCoreColumnDetailOptions {
  __typename?: "FinishScheduleCoreColumnDetail";
  code?: FinishScheduleCoreColumnDetail["code"];
  name?: FinishScheduleCoreColumnDetail["name"];
}

export function newFinishScheduleCoreColumnDetail(
  options: FinishScheduleCoreColumnDetailOptions = {},
  cache: Record<string, any> = {},
): FinishScheduleCoreColumnDetail {
  const o =
    (options.__typename ? options : cache["FinishScheduleCoreColumnDetail"] = {}) as FinishScheduleCoreColumnDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FinishScheduleCoreColumnDetail";
  o.code = options.code ?? FinishScheduleCoreColumn.Location;
  o.name = options.name ?? "Location";
  return o;
}

factories["FinishScheduleCoreColumnDetail"] = newFinishScheduleCoreColumnDetail;

export interface FloodPlainDetailOptions {
  __typename?: "FloodPlainDetail";
  code?: FloodPlainDetail["code"];
  name?: FloodPlainDetail["name"];
}

export function newFloodPlainDetail(
  options: FloodPlainDetailOptions = {},
  cache: Record<string, any> = {},
): FloodPlainDetail {
  const o = (options.__typename ? options : cache["FloodPlainDetail"] = {}) as FloodPlainDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FloodPlainDetail";
  o.code = options.code ?? FloodPlain.Fp_0;
  o.name = options.name ?? "Fp 0";
  return o;
}

factories["FloodPlainDetail"] = newFloodPlainDetail;

export interface FloodZoneDetailOptions {
  __typename?: "FloodZoneDetail";
  code?: FloodZoneDetail["code"];
  name?: FloodZoneDetail["name"];
}

export function newFloodZoneDetail(
  options: FloodZoneDetailOptions = {},
  cache: Record<string, any> = {},
): FloodZoneDetail {
  const o = (options.__typename ? options : cache["FloodZoneDetail"] = {}) as FloodZoneDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FloodZoneDetail";
  o.code = options.code ?? FloodZone.FzNone;
  o.name = options.name ?? "Fz none";
  return o;
}

factories["FloodZoneDetail"] = newFloodZoneDetail;

export interface FoundationTypeDetailOptions {
  __typename?: "FoundationTypeDetail";
  code?: FoundationTypeDetail["code"];
  name?: FoundationTypeDetail["name"];
}

export function newFoundationTypeDetail(
  options: FoundationTypeDetailOptions = {},
  cache: Record<string, any> = {},
): FoundationTypeDetail {
  const o = (options.__typename ? options : cache["FoundationTypeDetail"] = {}) as FoundationTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FoundationTypeDetail";
  o.code = options.code ?? FoundationType.Slab;
  o.name = options.name ?? "Slab";
  return o;
}

factories["FoundationTypeDetail"] = newFoundationTypeDetail;

export interface GlobalOptionStatusDetailOptions {
  __typename?: "GlobalOptionStatusDetail";
  code?: GlobalOptionStatusDetail["code"];
  name?: GlobalOptionStatusDetail["name"];
}

export function newGlobalOptionStatusDetail(
  options: GlobalOptionStatusDetailOptions = {},
  cache: Record<string, any> = {},
): GlobalOptionStatusDetail {
  const o = (options.__typename ? options : cache["GlobalOptionStatusDetail"] = {}) as GlobalOptionStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalOptionStatusDetail";
  o.code = options.code ?? GlobalOptionStatus.Active;
  o.name = options.name ?? "Active";
  return o;
}

factories["GlobalOptionStatusDetail"] = newGlobalOptionStatusDetail;

export interface GlobalOptionTypeStatusDetailOptions {
  __typename?: "GlobalOptionTypeStatusDetail";
  code?: GlobalOptionTypeStatusDetail["code"];
  name?: GlobalOptionTypeStatusDetail["name"];
}

export function newGlobalOptionTypeStatusDetail(
  options: GlobalOptionTypeStatusDetailOptions = {},
  cache: Record<string, any> = {},
): GlobalOptionTypeStatusDetail {
  const o = (options.__typename ? options : cache["GlobalOptionTypeStatusDetail"] = {}) as GlobalOptionTypeStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalOptionTypeStatusDetail";
  o.code = options.code ?? GlobalOptionTypeStatus.Active;
  o.name = options.name ?? "Active";
  return o;
}

factories["GlobalOptionTypeStatusDetail"] = newGlobalOptionTypeStatusDetail;

export interface GlobalPlanMilestoneTypeDetailOptions {
  __typename?: "GlobalPlanMilestoneTypeDetail";
  code?: GlobalPlanMilestoneTypeDetail["code"];
  name?: GlobalPlanMilestoneTypeDetail["name"];
}

export function newGlobalPlanMilestoneTypeDetail(
  options: GlobalPlanMilestoneTypeDetailOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanMilestoneTypeDetail {
  const o =
    (options.__typename ? options : cache["GlobalPlanMilestoneTypeDetail"] = {}) as GlobalPlanMilestoneTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanMilestoneTypeDetail";
  o.code = options.code ?? GlobalPlanMilestoneType.Construction;
  o.name = options.name ?? "Construction";
  return o;
}

factories["GlobalPlanMilestoneTypeDetail"] = newGlobalPlanMilestoneTypeDetail;

export interface InboxItemStatusDetailOptions {
  __typename?: "InboxItemStatusDetail";
  code?: InboxItemStatusDetail["code"];
  name?: InboxItemStatusDetail["name"];
}

export function newInboxItemStatusDetail(
  options: InboxItemStatusDetailOptions = {},
  cache: Record<string, any> = {},
): InboxItemStatusDetail {
  const o = (options.__typename ? options : cache["InboxItemStatusDetail"] = {}) as InboxItemStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InboxItemStatusDetail";
  o.code = options.code ?? InboxItemStatus.Read;
  o.name = options.name ?? "Read";
  return o;
}

factories["InboxItemStatusDetail"] = newInboxItemStatusDetail;

export interface InternalEstimateTypeDetailOptions {
  __typename?: "InternalEstimateTypeDetail";
  code?: InternalEstimateTypeDetail["code"];
  name?: InternalEstimateTypeDetail["name"];
}

export function newInternalEstimateTypeDetail(
  options: InternalEstimateTypeDetailOptions = {},
  cache: Record<string, any> = {},
): InternalEstimateTypeDetail {
  const o = (options.__typename ? options : cache["InternalEstimateTypeDetail"] = {}) as InternalEstimateTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InternalEstimateTypeDetail";
  o.code = options.code ?? InternalEstimateType.Temporary;
  o.name = options.name ?? "Temporary";
  return o;
}

factories["InternalEstimateTypeDetail"] = newInternalEstimateTypeDetail;

export interface InvoiceDocumentSourceDetailOptions {
  __typename?: "InvoiceDocumentSourceDetail";
  code?: InvoiceDocumentSourceDetail["code"];
  name?: InvoiceDocumentSourceDetail["name"];
}

export function newInvoiceDocumentSourceDetail(
  options: InvoiceDocumentSourceDetailOptions = {},
  cache: Record<string, any> = {},
): InvoiceDocumentSourceDetail {
  const o = (options.__typename ? options : cache["InvoiceDocumentSourceDetail"] = {}) as InvoiceDocumentSourceDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceDocumentSourceDetail";
  o.code = options.code ?? InvoiceDocumentSource.Quickbooks;
  o.name = options.name ?? "Quickbooks";
  return o;
}

factories["InvoiceDocumentSourceDetail"] = newInvoiceDocumentSourceDetail;

export interface InvoiceScheduleAmountTypeDetailOptions {
  __typename?: "InvoiceScheduleAmountTypeDetail";
  code?: InvoiceScheduleAmountTypeDetail["code"];
  name?: InvoiceScheduleAmountTypeDetail["name"];
}

export function newInvoiceScheduleAmountTypeDetail(
  options: InvoiceScheduleAmountTypeDetailOptions = {},
  cache: Record<string, any> = {},
): InvoiceScheduleAmountTypeDetail {
  const o =
    (options.__typename ? options : cache["InvoiceScheduleAmountTypeDetail"] = {}) as InvoiceScheduleAmountTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceScheduleAmountTypeDetail";
  o.code = options.code ?? InvoiceScheduleAmountType.Cost;
  o.name = options.name ?? "Cost";
  return o;
}

factories["InvoiceScheduleAmountTypeDetail"] = newInvoiceScheduleAmountTypeDetail;

export interface InvoiceScheduleItemFrequencyDetailOptions {
  __typename?: "InvoiceScheduleItemFrequencyDetail";
  code?: InvoiceScheduleItemFrequencyDetail["code"];
  name?: InvoiceScheduleItemFrequencyDetail["name"];
}

export function newInvoiceScheduleItemFrequencyDetail(
  options: InvoiceScheduleItemFrequencyDetailOptions = {},
  cache: Record<string, any> = {},
): InvoiceScheduleItemFrequencyDetail {
  const o =
    (options.__typename
      ? options
      : cache["InvoiceScheduleItemFrequencyDetail"] = {}) as InvoiceScheduleItemFrequencyDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceScheduleItemFrequencyDetail";
  o.code = options.code ?? InvoiceScheduleItemFrequency.Once;
  o.name = options.name ?? "Once";
  return o;
}

factories["InvoiceScheduleItemFrequencyDetail"] = newInvoiceScheduleItemFrequencyDetail;

export interface InvoiceScheduleTriggerTypeDetailOptions {
  __typename?: "InvoiceScheduleTriggerTypeDetail";
  code?: InvoiceScheduleTriggerTypeDetail["code"];
  name?: InvoiceScheduleTriggerTypeDetail["name"];
}

export function newInvoiceScheduleTriggerTypeDetail(
  options: InvoiceScheduleTriggerTypeDetailOptions = {},
  cache: Record<string, any> = {},
): InvoiceScheduleTriggerTypeDetail {
  const o =
    (options.__typename ? options : cache["InvoiceScheduleTriggerTypeDetail"] = {}) as InvoiceScheduleTriggerTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceScheduleTriggerTypeDetail";
  o.code = options.code ?? InvoiceScheduleTriggerType.Date;
  o.name = options.name ?? "Date";
  return o;
}

factories["InvoiceScheduleTriggerTypeDetail"] = newInvoiceScheduleTriggerTypeDetail;

export interface InvoiceSourceDetailOptions {
  __typename?: "InvoiceSourceDetail";
  code?: InvoiceSourceDetail["code"];
  name?: InvoiceSourceDetail["name"];
}

export function newInvoiceSourceDetail(
  options: InvoiceSourceDetailOptions = {},
  cache: Record<string, any> = {},
): InvoiceSourceDetail {
  const o = (options.__typename ? options : cache["InvoiceSourceDetail"] = {}) as InvoiceSourceDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceSourceDetail";
  o.code = options.code ?? InvoiceSource.Auto;
  o.name = options.name ?? "Auto";
  return o;
}

factories["InvoiceSourceDetail"] = newInvoiceSourceDetail;

export interface InvoiceStatusDetailOptions {
  __typename?: "InvoiceStatusDetail";
  code?: InvoiceStatusDetail["code"];
  name?: InvoiceStatusDetail["name"];
}

export function newInvoiceStatusDetail(
  options: InvoiceStatusDetailOptions = {},
  cache: Record<string, any> = {},
): InvoiceStatusDetail {
  const o = (options.__typename ? options : cache["InvoiceStatusDetail"] = {}) as InvoiceStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceStatusDetail";
  o.code = options.code ?? InvoiceStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["InvoiceStatusDetail"] = newInvoiceStatusDetail;

export interface InvoiceTypeDetailOptions {
  __typename?: "InvoiceTypeDetail";
  code?: InvoiceTypeDetail["code"];
  name?: InvoiceTypeDetail["name"];
}

export function newInvoiceTypeDetail(
  options: InvoiceTypeDetailOptions = {},
  cache: Record<string, any> = {},
): InvoiceTypeDetail {
  const o = (options.__typename ? options : cache["InvoiceTypeDetail"] = {}) as InvoiceTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceTypeDetail";
  o.code = options.code ?? InvoiceType.PercentageOfCompletion;
  o.name = options.name ?? "Percentage of completion";
  return o;
}

factories["InvoiceTypeDetail"] = newInvoiceTypeDetail;

export interface ItemStatusDetailOptions {
  __typename?: "ItemStatusDetail";
  code?: ItemStatusDetail["code"];
  name?: ItemStatusDetail["name"];
}

export function newItemStatusDetail(
  options: ItemStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ItemStatusDetail {
  const o = (options.__typename ? options : cache["ItemStatusDetail"] = {}) as ItemStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemStatusDetail";
  o.code = options.code ?? ItemStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["ItemStatusDetail"] = newItemStatusDetail;

export interface ItemTemplateItemCostStatusDetailOptions {
  __typename?: "ItemTemplateItemCostStatusDetail";
  code?: ItemTemplateItemCostStatusDetail["code"];
  name?: ItemTemplateItemCostStatusDetail["name"];
}

export function newItemTemplateItemCostStatusDetail(
  options: ItemTemplateItemCostStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateItemCostStatusDetail {
  const o =
    (options.__typename ? options : cache["ItemTemplateItemCostStatusDetail"] = {}) as ItemTemplateItemCostStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateItemCostStatusDetail";
  o.code = options.code ?? ItemTemplateItemCostStatus.InternalEstimate;
  o.name = options.name ?? "Internal estimate";
  return o;
}

factories["ItemTemplateItemCostStatusDetail"] = newItemTemplateItemCostStatusDetail;

export interface ItemTemplateStatusDetailOptions {
  __typename?: "ItemTemplateStatusDetail";
  code?: ItemTemplateStatusDetail["code"];
  name?: ItemTemplateStatusDetail["name"];
}

export function newItemTemplateStatusDetail(
  options: ItemTemplateStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateStatusDetail {
  const o = (options.__typename ? options : cache["ItemTemplateStatusDetail"] = {}) as ItemTemplateStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateStatusDetail";
  o.code = options.code ?? ItemTemplateStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["ItemTemplateStatusDetail"] = newItemTemplateStatusDetail;

export interface JobLogFlagDetailOptions {
  __typename?: "JobLogFlagDetail";
  code?: JobLogFlagDetail["code"];
  name?: JobLogFlagDetail["name"];
}

export function newJobLogFlagDetail(
  options: JobLogFlagDetailOptions = {},
  cache: Record<string, any> = {},
): JobLogFlagDetail {
  const o = (options.__typename ? options : cache["JobLogFlagDetail"] = {}) as JobLogFlagDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "JobLogFlagDetail";
  o.code = options.code ?? JobLogFlag.ChangeOrderDelay;
  o.name = options.name ?? "Change order delay";
  return o;
}

factories["JobLogFlagDetail"] = newJobLogFlagDetail;

export interface JobLogNoteTypeDetailOptions {
  __typename?: "JobLogNoteTypeDetail";
  code?: JobLogNoteTypeDetail["code"];
  name?: JobLogNoteTypeDetail["name"];
}

export function newJobLogNoteTypeDetail(
  options: JobLogNoteTypeDetailOptions = {},
  cache: Record<string, any> = {},
): JobLogNoteTypeDetail {
  const o = (options.__typename ? options : cache["JobLogNoteTypeDetail"] = {}) as JobLogNoteTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "JobLogNoteTypeDetail";
  o.code = options.code ?? JobLogNoteType.Delay;
  o.name = options.name ?? "Delay";
  return o;
}

factories["JobLogNoteTypeDetail"] = newJobLogNoteTypeDetail;

export interface LienWaiverConditionDetailOptions {
  __typename?: "LienWaiverConditionDetail";
  code?: LienWaiverConditionDetail["code"];
  name?: LienWaiverConditionDetail["name"];
}

export function newLienWaiverConditionDetail(
  options: LienWaiverConditionDetailOptions = {},
  cache: Record<string, any> = {},
): LienWaiverConditionDetail {
  const o = (options.__typename ? options : cache["LienWaiverConditionDetail"] = {}) as LienWaiverConditionDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LienWaiverConditionDetail";
  o.code = options.code ?? LienWaiverCondition.Unconditional;
  o.name = options.name ?? "Unconditional";
  return o;
}

factories["LienWaiverConditionDetail"] = newLienWaiverConditionDetail;

export interface LienWaiverStatusDetailOptions {
  __typename?: "LienWaiverStatusDetail";
  code?: LienWaiverStatusDetail["code"];
  name?: LienWaiverStatusDetail["name"];
}

export function newLienWaiverStatusDetail(
  options: LienWaiverStatusDetailOptions = {},
  cache: Record<string, any> = {},
): LienWaiverStatusDetail {
  const o = (options.__typename ? options : cache["LienWaiverStatusDetail"] = {}) as LienWaiverStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LienWaiverStatusDetail";
  o.code = options.code ?? LienWaiverStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["LienWaiverStatusDetail"] = newLienWaiverStatusDetail;

export interface LienWaiverTypeDetailOptions {
  __typename?: "LienWaiverTypeDetail";
  code?: LienWaiverTypeDetail["code"];
  name?: LienWaiverTypeDetail["name"];
}

export function newLienWaiverTypeDetail(
  options: LienWaiverTypeDetailOptions = {},
  cache: Record<string, any> = {},
): LienWaiverTypeDetail {
  const o = (options.__typename ? options : cache["LienWaiverTypeDetail"] = {}) as LienWaiverTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LienWaiverTypeDetail";
  o.code = options.code ?? LienWaiverType.Progress;
  o.name = options.name ?? "Progress";
  return o;
}

factories["LienWaiverTypeDetail"] = newLienWaiverTypeDetail;

export interface LocationTypeDetailOptions {
  __typename?: "LocationTypeDetail";
  code?: LocationTypeDetail["code"];
  name?: LocationTypeDetail["name"];
  sortOrder?: LocationTypeDetail["sortOrder"];
}

export function newLocationTypeDetail(
  options: LocationTypeDetailOptions = {},
  cache: Record<string, any> = {},
): LocationTypeDetail {
  const o = (options.__typename ? options : cache["LocationTypeDetail"] = {}) as LocationTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LocationTypeDetail";
  o.code = options.code ?? LocationType.Group;
  o.name = options.name ?? "Group";
  o.sortOrder = options.sortOrder ?? 0;
  return o;
}

factories["LocationTypeDetail"] = newLocationTypeDetail;

export interface LotSalesStatusDetailOptions {
  __typename?: "LotSalesStatusDetail";
  code?: LotSalesStatusDetail["code"];
  name?: LotSalesStatusDetail["name"];
}

export function newLotSalesStatusDetail(
  options: LotSalesStatusDetailOptions = {},
  cache: Record<string, any> = {},
): LotSalesStatusDetail {
  const o = (options.__typename ? options : cache["LotSalesStatusDetail"] = {}) as LotSalesStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotSalesStatusDetail";
  o.code = options.code ?? LotSalesStatus.NotAvailable;
  o.name = options.name ?? "Not available";
  return o;
}

factories["LotSalesStatusDetail"] = newLotSalesStatusDetail;

export interface LotTypeDetailOptions {
  __typename?: "LotTypeDetail";
  code?: LotTypeDetail["code"];
  name?: LotTypeDetail["name"];
  clientContract?: LotTypeDetail["clientContract"];
  clientNoun?: LotTypeDetail["clientNoun"];
  initialBudget?: LotTypeDetail["initialBudget"];
  shortClientNoun?: LotTypeDetail["shortClientNoun"];
  clientInvoice?: LotTypeDetail["clientInvoice"];
  description?: LotTypeDetail["description"];
}

export function newLotTypeDetail(options: LotTypeDetailOptions = {}, cache: Record<string, any> = {}): LotTypeDetail {
  const o = (options.__typename ? options : cache["LotTypeDetail"] = {}) as LotTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotTypeDetail";
  o.code = options.code ?? LotType.Boyl;
  o.name = options.name ?? "Boyl";
  o.clientContract = options.clientContract ?? "Boyl";
  o.clientNoun = options.clientNoun ?? "Boyl";
  o.initialBudget = options.initialBudget ?? "Boyl";
  o.shortClientNoun = options.shortClientNoun ?? "Boyl";
  o.clientInvoice = options.clientInvoice ?? "Boyl";
  o.description = options.description ?? "Boyl";
  return o;
}

factories["LotTypeDetail"] = newLotTypeDetail;

export interface MarkupApplicationMethodDetailOptions {
  __typename?: "MarkupApplicationMethodDetail";
  code?: MarkupApplicationMethodDetail["code"];
  name?: MarkupApplicationMethodDetail["name"];
}

export function newMarkupApplicationMethodDetail(
  options: MarkupApplicationMethodDetailOptions = {},
  cache: Record<string, any> = {},
): MarkupApplicationMethodDetail {
  const o =
    (options.__typename ? options : cache["MarkupApplicationMethodDetail"] = {}) as MarkupApplicationMethodDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MarkupApplicationMethodDetail";
  o.code = options.code ?? MarkupApplicationMethod.PerLineItem;
  o.name = options.name ?? "Per line item";
  return o;
}

factories["MarkupApplicationMethodDetail"] = newMarkupApplicationMethodDetail;

export interface MaterialAttributeDimensionTypeDetailOptions {
  __typename?: "MaterialAttributeDimensionTypeDetail";
  code?: MaterialAttributeDimensionTypeDetail["code"];
  name?: MaterialAttributeDimensionTypeDetail["name"];
}

export function newMaterialAttributeDimensionTypeDetail(
  options: MaterialAttributeDimensionTypeDetailOptions = {},
  cache: Record<string, any> = {},
): MaterialAttributeDimensionTypeDetail {
  const o =
    (options.__typename
      ? options
      : cache["MaterialAttributeDimensionTypeDetail"] = {}) as MaterialAttributeDimensionTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialAttributeDimensionTypeDetail";
  o.code = options.code ?? MaterialAttributeDimensionType.Number;
  o.name = options.name ?? "Number";
  return o;
}

factories["MaterialAttributeDimensionTypeDetail"] = newMaterialAttributeDimensionTypeDetail;

export interface MaterialAttributeValueTypeDetailOptions {
  __typename?: "MaterialAttributeValueTypeDetail";
  code?: MaterialAttributeValueTypeDetail["code"];
  name?: MaterialAttributeValueTypeDetail["name"];
}

export function newMaterialAttributeValueTypeDetail(
  options: MaterialAttributeValueTypeDetailOptions = {},
  cache: Record<string, any> = {},
): MaterialAttributeValueTypeDetail {
  const o =
    (options.__typename ? options : cache["MaterialAttributeValueTypeDetail"] = {}) as MaterialAttributeValueTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialAttributeValueTypeDetail";
  o.code = options.code ?? MaterialAttributeValueType.Exact;
  o.name = options.name ?? "Exact";
  return o;
}

factories["MaterialAttributeValueTypeDetail"] = newMaterialAttributeValueTypeDetail;

export interface MaterialTypeDetailOptions {
  __typename?: "MaterialTypeDetail";
  code?: MaterialTypeDetail["code"];
  name?: MaterialTypeDetail["name"];
}

export function newMaterialTypeDetail(
  options: MaterialTypeDetailOptions = {},
  cache: Record<string, any> = {},
): MaterialTypeDetail {
  const o = (options.__typename ? options : cache["MaterialTypeDetail"] = {}) as MaterialTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialTypeDetail";
  o.code = options.code ?? MaterialType.Placeholder;
  o.name = options.name ?? "Placeholder";
  return o;
}

factories["MaterialTypeDetail"] = newMaterialTypeDetail;

export interface MobileSyncUpdateTypeDetailOptions {
  __typename?: "MobileSyncUpdateTypeDetail";
  code?: MobileSyncUpdateTypeDetail["code"];
  name?: MobileSyncUpdateTypeDetail["name"];
}

export function newMobileSyncUpdateTypeDetail(
  options: MobileSyncUpdateTypeDetailOptions = {},
  cache: Record<string, any> = {},
): MobileSyncUpdateTypeDetail {
  const o = (options.__typename ? options : cache["MobileSyncUpdateTypeDetail"] = {}) as MobileSyncUpdateTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MobileSyncUpdateTypeDetail";
  o.code = options.code ?? MobileSyncUpdateType.Created;
  o.name = options.name ?? "Created";
  return o;
}

factories["MobileSyncUpdateTypeDetail"] = newMobileSyncUpdateTypeDetail;

export interface PandaDocRoleDetailOptions {
  __typename?: "PandaDocRoleDetail";
  code?: PandaDocRoleDetail["code"];
  name?: PandaDocRoleDetail["name"];
  shortName?: PandaDocRoleDetail["shortName"];
}

export function newPandaDocRoleDetail(
  options: PandaDocRoleDetailOptions = {},
  cache: Record<string, any> = {},
): PandaDocRoleDetail {
  const o = (options.__typename ? options : cache["PandaDocRoleDetail"] = {}) as PandaDocRoleDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PandaDocRoleDetail";
  o.code = options.code ?? PandaDocRole.User;
  o.name = options.name ?? "User";
  o.shortName = options.shortName ?? "User";
  return o;
}

factories["PandaDocRoleDetail"] = newPandaDocRoleDetail;

export interface PandaDocStatusDetailOptions {
  __typename?: "PandaDocStatusDetail";
  code?: PandaDocStatusDetail["code"];
  name?: PandaDocStatusDetail["name"];
  externalCode?: PandaDocStatusDetail["externalCode"];
  externalNumber?: PandaDocStatusDetail["externalNumber"];
}

export function newPandaDocStatusDetail(
  options: PandaDocStatusDetailOptions = {},
  cache: Record<string, any> = {},
): PandaDocStatusDetail {
  const o = (options.__typename ? options : cache["PandaDocStatusDetail"] = {}) as PandaDocStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PandaDocStatusDetail";
  o.code = options.code ?? PandaDocStatus.Pending;
  o.name = options.name ?? "Pending";
  o.externalCode = options.externalCode ?? "Pending";
  o.externalNumber = options.externalNumber ?? 0;
  return o;
}

factories["PandaDocStatusDetail"] = newPandaDocStatusDetail;

export interface PandaDocWorkspaceDetailOptions {
  __typename?: "PandaDocWorkspaceDetail";
  code?: PandaDocWorkspaceDetail["code"];
  name?: PandaDocWorkspaceDetail["name"];
}

export function newPandaDocWorkspaceDetail(
  options: PandaDocWorkspaceDetailOptions = {},
  cache: Record<string, any> = {},
): PandaDocWorkspaceDetail {
  const o = (options.__typename ? options : cache["PandaDocWorkspaceDetail"] = {}) as PandaDocWorkspaceDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PandaDocWorkspaceDetail";
  o.code = options.code ?? PandaDocWorkspace.Homebound;
  o.name = options.name ?? "Homebound";
  return o;
}

factories["PandaDocWorkspaceDetail"] = newPandaDocWorkspaceDetail;

export interface PaymentTermDueFromDetailOptions {
  __typename?: "PaymentTermDueFromDetail";
  code?: PaymentTermDueFromDetail["code"];
  name?: PaymentTermDueFromDetail["name"];
}

export function newPaymentTermDueFromDetail(
  options: PaymentTermDueFromDetailOptions = {},
  cache: Record<string, any> = {},
): PaymentTermDueFromDetail {
  const o = (options.__typename ? options : cache["PaymentTermDueFromDetail"] = {}) as PaymentTermDueFromDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PaymentTermDueFromDetail";
  o.code = options.code ?? PaymentTermDueFrom.FromInvoiceBillDate;
  o.name = options.name ?? "From invoice bill date";
  return o;
}

factories["PaymentTermDueFromDetail"] = newPaymentTermDueFromDetail;

export interface PermitDetailOptions {
  __typename?: "PermitDetail";
  code?: PermitDetail["code"];
  name?: PermitDetail["name"];
}

export function newPermitDetail(options: PermitDetailOptions = {}, cache: Record<string, any> = {}): PermitDetail {
  const o = (options.__typename ? options : cache["PermitDetail"] = {}) as PermitDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PermitDetail";
  o.code = options.code ?? Permit.Zoning;
  o.name = options.name ?? "Zoning";
  return o;
}

factories["PermitDetail"] = newPermitDetail;

export interface PlanPackageIncomingSlotStatusDetailOptions {
  __typename?: "PlanPackageIncomingSlotStatusDetail";
  code?: PlanPackageIncomingSlotStatusDetail["code"];
  name?: PlanPackageIncomingSlotStatusDetail["name"];
}

export function newPlanPackageIncomingSlotStatusDetail(
  options: PlanPackageIncomingSlotStatusDetailOptions = {},
  cache: Record<string, any> = {},
): PlanPackageIncomingSlotStatusDetail {
  const o =
    (options.__typename
      ? options
      : cache["PlanPackageIncomingSlotStatusDetail"] = {}) as PlanPackageIncomingSlotStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanPackageIncomingSlotStatusDetail";
  o.code = options.code ?? PlanPackageIncomingSlotStatus.Pending;
  o.name = options.name ?? "Pending";
  return o;
}

factories["PlanPackageIncomingSlotStatusDetail"] = newPlanPackageIncomingSlotStatusDetail;

export interface ProgramDataBasementConfigDetailOptions {
  __typename?: "ProgramDataBasementConfigDetail";
  code?: ProgramDataBasementConfigDetail["code"];
  name?: ProgramDataBasementConfigDetail["name"];
}

export function newProgramDataBasementConfigDetail(
  options: ProgramDataBasementConfigDetailOptions = {},
  cache: Record<string, any> = {},
): ProgramDataBasementConfigDetail {
  const o =
    (options.__typename ? options : cache["ProgramDataBasementConfigDetail"] = {}) as ProgramDataBasementConfigDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProgramDataBasementConfigDetail";
  o.code = options.code ?? ProgramDataBasementConfig.No;
  o.name = options.name ?? "No";
  return o;
}

factories["ProgramDataBasementConfigDetail"] = newProgramDataBasementConfigDetail;

export interface ProgramDataGarageConfigDetailOptions {
  __typename?: "ProgramDataGarageConfigDetail";
  code?: ProgramDataGarageConfigDetail["code"];
  name?: ProgramDataGarageConfigDetail["name"];
}

export function newProgramDataGarageConfigDetail(
  options: ProgramDataGarageConfigDetailOptions = {},
  cache: Record<string, any> = {},
): ProgramDataGarageConfigDetail {
  const o =
    (options.__typename ? options : cache["ProgramDataGarageConfigDetail"] = {}) as ProgramDataGarageConfigDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProgramDataGarageConfigDetail";
  o.code = options.code ?? ProgramDataGarageConfig.FrontLoad;
  o.name = options.name ?? "Front load";
  return o;
}

factories["ProgramDataGarageConfigDetail"] = newProgramDataGarageConfigDetail;

export interface ProgramDataMatchStateDetailOptions {
  __typename?: "ProgramDataMatchStateDetail";
  code?: ProgramDataMatchStateDetail["code"];
  name?: ProgramDataMatchStateDetail["name"];
}

export function newProgramDataMatchStateDetail(
  options: ProgramDataMatchStateDetailOptions = {},
  cache: Record<string, any> = {},
): ProgramDataMatchStateDetail {
  const o = (options.__typename ? options : cache["ProgramDataMatchStateDetail"] = {}) as ProgramDataMatchStateDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProgramDataMatchStateDetail";
  o.code = options.code ?? ProgramDataMatchState.Matches;
  o.name = options.name ?? "Matches";
  return o;
}

factories["ProgramDataMatchStateDetail"] = newProgramDataMatchStateDetail;

export interface ProgramDataPrimaryBedroomConfigDetailOptions {
  __typename?: "ProgramDataPrimaryBedroomConfigDetail";
  code?: ProgramDataPrimaryBedroomConfigDetail["code"];
  name?: ProgramDataPrimaryBedroomConfigDetail["name"];
}

export function newProgramDataPrimaryBedroomConfigDetail(
  options: ProgramDataPrimaryBedroomConfigDetailOptions = {},
  cache: Record<string, any> = {},
): ProgramDataPrimaryBedroomConfigDetail {
  const o =
    (options.__typename
      ? options
      : cache["ProgramDataPrimaryBedroomConfigDetail"] = {}) as ProgramDataPrimaryBedroomConfigDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProgramDataPrimaryBedroomConfigDetail";
  o.code = options.code ?? ProgramDataPrimaryBedroomConfig.Up;
  o.name = options.name ?? "Up";
  return o;
}

factories["ProgramDataPrimaryBedroomConfigDetail"] = newProgramDataPrimaryBedroomConfigDetail;

export interface ProgramDataWindowColorDetailOptions {
  __typename?: "ProgramDataWindowColorDetail";
  code?: ProgramDataWindowColorDetail["code"];
  name?: ProgramDataWindowColorDetail["name"];
}

export function newProgramDataWindowColorDetail(
  options: ProgramDataWindowColorDetailOptions = {},
  cache: Record<string, any> = {},
): ProgramDataWindowColorDetail {
  const o = (options.__typename ? options : cache["ProgramDataWindowColorDetail"] = {}) as ProgramDataWindowColorDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProgramDataWindowColorDetail";
  o.code = options.code ?? ProgramDataWindowColor.White;
  o.name = options.name ?? "White";
  return o;
}

factories["ProgramDataWindowColorDetail"] = newProgramDataWindowColorDetail;

export interface ProjectCollaboratorRoleDetailOptions {
  __typename?: "ProjectCollaboratorRoleDetail";
  code?: ProjectCollaboratorRoleDetail["code"];
  name?: ProjectCollaboratorRoleDetail["name"];
}

export function newProjectCollaboratorRoleDetail(
  options: ProjectCollaboratorRoleDetailOptions = {},
  cache: Record<string, any> = {},
): ProjectCollaboratorRoleDetail {
  const o =
    (options.__typename ? options : cache["ProjectCollaboratorRoleDetail"] = {}) as ProjectCollaboratorRoleDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectCollaboratorRoleDetail";
  o.code = options.code ?? ProjectCollaboratorRole.Homeowner;
  o.name = options.name ?? "Homeowner";
  return o;
}

factories["ProjectCollaboratorRoleDetail"] = newProjectCollaboratorRoleDetail;

export interface ProjectFeatureDetailOptions {
  __typename?: "ProjectFeatureDetail";
  code?: ProjectFeatureDetail["code"];
  name?: ProjectFeatureDetail["name"];
}

export function newProjectFeatureDetail(
  options: ProjectFeatureDetailOptions = {},
  cache: Record<string, any> = {},
): ProjectFeatureDetail {
  const o = (options.__typename ? options : cache["ProjectFeatureDetail"] = {}) as ProjectFeatureDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectFeatureDetail";
  o.code = options.code ?? ProjectFeature.SelectionsV1;
  o.name = options.name ?? "Selections v1";
  return o;
}

factories["ProjectFeatureDetail"] = newProjectFeatureDetail;

export interface ProjectReadyPlanConfigOrientationDetailOptions {
  __typename?: "ProjectReadyPlanConfigOrientationDetail";
  code?: ProjectReadyPlanConfigOrientationDetail["code"];
  name?: ProjectReadyPlanConfigOrientationDetail["name"];
}

export function newProjectReadyPlanConfigOrientationDetail(
  options: ProjectReadyPlanConfigOrientationDetailOptions = {},
  cache: Record<string, any> = {},
): ProjectReadyPlanConfigOrientationDetail {
  const o =
    (options.__typename
      ? options
      : cache["ProjectReadyPlanConfigOrientationDetail"] = {}) as ProjectReadyPlanConfigOrientationDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectReadyPlanConfigOrientationDetail";
  o.code = options.code ?? ProjectReadyPlanConfigOrientation.Left;
  o.name = options.name ?? "Left";
  return o;
}

factories["ProjectReadyPlanConfigOrientationDetail"] = newProjectReadyPlanConfigOrientationDetail;

export interface ProjectRoleDetailOptions {
  __typename?: "ProjectRoleDetail";
  code?: ProjectRoleDetail["code"];
  name?: ProjectRoleDetail["name"];
  sortOrder?: ProjectRoleDetail["sortOrder"];
  description?: ProjectRoleDetail["description"];
}

export function newProjectRoleDetail(
  options: ProjectRoleDetailOptions = {},
  cache: Record<string, any> = {},
): ProjectRoleDetail {
  const o = (options.__typename ? options : cache["ProjectRoleDetail"] = {}) as ProjectRoleDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectRoleDetail";
  o.code = options.code ?? ProjectRole.HeadOfConstruction;
  o.name = options.name ?? "Head of construction";
  o.sortOrder = options.sortOrder ?? 0;
  o.description = options.description ?? "Head of construction";
  return o;
}

factories["ProjectRoleDetail"] = newProjectRoleDetail;

export interface ProjectStageStatusDetailOptions {
  __typename?: "ProjectStageStatusDetail";
  code?: ProjectStageStatusDetail["code"];
  name?: ProjectStageStatusDetail["name"];
}

export function newProjectStageStatusDetail(
  options: ProjectStageStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ProjectStageStatusDetail {
  const o = (options.__typename ? options : cache["ProjectStageStatusDetail"] = {}) as ProjectStageStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectStageStatusDetail";
  o.code = options.code ?? ProjectStageStatus.Active;
  o.name = options.name ?? "Active";
  return o;
}

factories["ProjectStageStatusDetail"] = newProjectStageStatusDetail;

export interface ProjectStatusDetailOptions {
  __typename?: "ProjectStatusDetail";
  code?: ProjectStatusDetail["code"];
  name?: ProjectStatusDetail["name"];
}

export function newProjectStatusDetail(
  options: ProjectStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ProjectStatusDetail {
  const o = (options.__typename ? options : cache["ProjectStatusDetail"] = {}) as ProjectStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectStatusDetail";
  o.code = options.code ?? ProjectStatus.Active;
  o.name = options.name ?? "Active";
  return o;
}

factories["ProjectStatusDetail"] = newProjectStatusDetail;

export interface ProjectUpdateActionTypeDetailOptions {
  __typename?: "ProjectUpdateActionTypeDetail";
  code?: ProjectUpdateActionTypeDetail["code"];
  name?: ProjectUpdateActionTypeDetail["name"];
}

export function newProjectUpdateActionTypeDetail(
  options: ProjectUpdateActionTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ProjectUpdateActionTypeDetail {
  const o =
    (options.__typename ? options : cache["ProjectUpdateActionTypeDetail"] = {}) as ProjectUpdateActionTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectUpdateActionTypeDetail";
  o.code = options.code ?? ProjectUpdateActionType.ActivityComplete;
  o.name = options.name ?? "Activity complete";
  return o;
}

factories["ProjectUpdateActionTypeDetail"] = newProjectUpdateActionTypeDetail;

export interface PushNotificationEnvironmentDetailOptions {
  __typename?: "PushNotificationEnvironmentDetail";
  code?: PushNotificationEnvironmentDetail["code"];
  name?: PushNotificationEnvironmentDetail["name"];
}

export function newPushNotificationEnvironmentDetail(
  options: PushNotificationEnvironmentDetailOptions = {},
  cache: Record<string, any> = {},
): PushNotificationEnvironmentDetail {
  const o =
    (options.__typename
      ? options
      : cache["PushNotificationEnvironmentDetail"] = {}) as PushNotificationEnvironmentDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PushNotificationEnvironmentDetail";
  o.code = options.code ?? PushNotificationEnvironment.Sandbox;
  o.name = options.name ?? "Sandbox";
  return o;
}

factories["PushNotificationEnvironmentDetail"] = newPushNotificationEnvironmentDetail;

export interface PushNotificationPlatformDetailOptions {
  __typename?: "PushNotificationPlatformDetail";
  code?: PushNotificationPlatformDetail["code"];
  name?: PushNotificationPlatformDetail["name"];
}

export function newPushNotificationPlatformDetail(
  options: PushNotificationPlatformDetailOptions = {},
  cache: Record<string, any> = {},
): PushNotificationPlatformDetail {
  const o =
    (options.__typename ? options : cache["PushNotificationPlatformDetail"] = {}) as PushNotificationPlatformDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PushNotificationPlatformDetail";
  o.code = options.code ?? PushNotificationPlatform.Ios;
  o.name = options.name ?? "Ios";
  return o;
}

factories["PushNotificationPlatformDetail"] = newPushNotificationPlatformDetail;

export interface ReadyPlanAssetTypeDetailOptions {
  __typename?: "ReadyPlanAssetTypeDetail";
  code?: ReadyPlanAssetTypeDetail["code"];
  name?: ReadyPlanAssetTypeDetail["name"];
}

export function newReadyPlanAssetTypeDetail(
  options: ReadyPlanAssetTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanAssetTypeDetail {
  const o = (options.__typename ? options : cache["ReadyPlanAssetTypeDetail"] = {}) as ReadyPlanAssetTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanAssetTypeDetail";
  o.code = options.code ?? ReadyPlanAssetType.CoverPhoto;
  o.name = options.name ?? "Cover photo";
  return o;
}

factories["ReadyPlanAssetTypeDetail"] = newReadyPlanAssetTypeDetail;

export interface ReadyPlanOptionGroupPersonalizationTypeDetailOptions {
  __typename?: "ReadyPlanOptionGroupPersonalizationTypeDetail";
  code?: ReadyPlanOptionGroupPersonalizationTypeDetail["code"];
  name?: ReadyPlanOptionGroupPersonalizationTypeDetail["name"];
}

export function newReadyPlanOptionGroupPersonalizationTypeDetail(
  options: ReadyPlanOptionGroupPersonalizationTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOptionGroupPersonalizationTypeDetail {
  const o =
    (options.__typename
      ? options
      : cache["ReadyPlanOptionGroupPersonalizationTypeDetail"] = {}) as ReadyPlanOptionGroupPersonalizationTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOptionGroupPersonalizationTypeDetail";
  o.code = options.code ?? ReadyPlanOptionGroupPersonalizationType.SingleProduct;
  o.name = options.name ?? "Single product";
  return o;
}

factories["ReadyPlanOptionGroupPersonalizationTypeDetail"] = newReadyPlanOptionGroupPersonalizationTypeDetail;

export interface ReadyPlanStatusDetailOptions {
  __typename?: "ReadyPlanStatusDetail";
  code?: ReadyPlanStatusDetail["code"];
  name?: ReadyPlanStatusDetail["name"];
}

export function newReadyPlanStatusDetail(
  options: ReadyPlanStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanStatusDetail {
  const o = (options.__typename ? options : cache["ReadyPlanStatusDetail"] = {}) as ReadyPlanStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanStatusDetail";
  o.code = options.code ?? ReadyPlanStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["ReadyPlanStatusDetail"] = newReadyPlanStatusDetail;

export interface ReadyPlanTypeDetailOptions {
  __typename?: "ReadyPlanTypeDetail";
  code?: ReadyPlanTypeDetail["code"];
  name?: ReadyPlanTypeDetail["name"];
}

export function newReadyPlanTypeDetail(
  options: ReadyPlanTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanTypeDetail {
  const o = (options.__typename ? options : cache["ReadyPlanTypeDetail"] = {}) as ReadyPlanTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanTypeDetail";
  o.code = options.code ?? ReadyPlanType.Sfh;
  o.name = options.name ?? "Sfh";
  return o;
}

factories["ReadyPlanTypeDetail"] = newReadyPlanTypeDetail;

export interface ScheduleFlagReasonTypeDetailOptions {
  __typename?: "ScheduleFlagReasonTypeDetail";
  code?: ScheduleFlagReasonTypeDetail["code"];
  name?: ScheduleFlagReasonTypeDetail["name"];
}

export function newScheduleFlagReasonTypeDetail(
  options: ScheduleFlagReasonTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ScheduleFlagReasonTypeDetail {
  const o = (options.__typename ? options : cache["ScheduleFlagReasonTypeDetail"] = {}) as ScheduleFlagReasonTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleFlagReasonTypeDetail";
  o.code = options.code ?? ScheduleFlagReasonType.Client;
  o.name = options.name ?? "Client";
  return o;
}

factories["ScheduleFlagReasonTypeDetail"] = newScheduleFlagReasonTypeDetail;

export interface ScheduleStatusDetailOptions {
  __typename?: "ScheduleStatusDetail";
  code?: ScheduleStatusDetail["code"];
  name?: ScheduleStatusDetail["name"];
}

export function newScheduleStatusDetail(
  options: ScheduleStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ScheduleStatusDetail {
  const o = (options.__typename ? options : cache["ScheduleStatusDetail"] = {}) as ScheduleStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleStatusDetail";
  o.code = options.code ?? ScheduleStatus.Active;
  o.name = options.name ?? "Active";
  return o;
}

factories["ScheduleStatusDetail"] = newScheduleStatusDetail;

export interface ScheduleTemplateStatusDetailOptions {
  __typename?: "ScheduleTemplateStatusDetail";
  code?: ScheduleTemplateStatusDetail["code"];
  name?: ScheduleTemplateStatusDetail["name"];
}

export function newScheduleTemplateStatusDetail(
  options: ScheduleTemplateStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ScheduleTemplateStatusDetail {
  const o = (options.__typename ? options : cache["ScheduleTemplateStatusDetail"] = {}) as ScheduleTemplateStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleTemplateStatusDetail";
  o.code = options.code ?? ScheduleTemplateStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["ScheduleTemplateStatusDetail"] = newScheduleTemplateStatusDetail;

export interface ScopeChangeTypeDetailOptions {
  __typename?: "ScopeChangeTypeDetail";
  code?: ScopeChangeTypeDetail["code"];
  name?: ScopeChangeTypeDetail["name"];
}

export function newScopeChangeTypeDetail(
  options: ScopeChangeTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ScopeChangeTypeDetail {
  const o = (options.__typename ? options : cache["ScopeChangeTypeDetail"] = {}) as ScopeChangeTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScopeChangeTypeDetail";
  o.code = options.code ?? ScopeChangeType.None;
  o.name = options.name ?? "None";
  return o;
}

factories["ScopeChangeTypeDetail"] = newScopeChangeTypeDetail;

export interface ScopeModeDetailOptions {
  __typename?: "ScopeModeDetail";
  code?: ScopeModeDetail["code"];
  name?: ScopeModeDetail["name"];
}

export function newScopeModeDetail(
  options: ScopeModeDetailOptions = {},
  cache: Record<string, any> = {},
): ScopeModeDetail {
  const o = (options.__typename ? options : cache["ScopeModeDetail"] = {}) as ScopeModeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScopeModeDetail";
  o.code = options.code ?? ScopeMode.None;
  o.name = options.name ?? "None";
  return o;
}

factories["ScopeModeDetail"] = newScopeModeDetail;

export interface SelectionCutoffDetailOptions {
  __typename?: "SelectionCutoffDetail";
  code?: SelectionCutoffDetail["code"];
  name?: SelectionCutoffDetail["name"];
}

export function newSelectionCutoffDetail(
  options: SelectionCutoffDetailOptions = {},
  cache: Record<string, any> = {},
): SelectionCutoffDetail {
  const o = (options.__typename ? options : cache["SelectionCutoffDetail"] = {}) as SelectionCutoffDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SelectionCutoffDetail";
  o.code = options.code ?? SelectionCutoff.Cutoff_1;
  o.name = options.name ?? "Cutoff 1";
  return o;
}

factories["SelectionCutoffDetail"] = newSelectionCutoffDetail;

export interface StageDetailOptions {
  __typename?: "StageDetail";
  code?: StageDetail["code"];
  name?: StageDetail["name"];
  sortOrder?: StageDetail["sortOrder"];
  slug?: StageDetail["slug"];
  forDevelopment?: StageDetail["forDevelopment"];
  forProject?: StageDetail["forProject"];
  isDeprecated?: StageDetail["isDeprecated"];
}

export function newStageDetail(options: StageDetailOptions = {}, cache: Record<string, any> = {}): StageDetail {
  const o = (options.__typename ? options : cache["StageDetail"] = {}) as StageDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "StageDetail";
  o.code = options.code ?? Stage.PreConPlanning;
  o.name = options.name ?? "Pre con planning";
  o.sortOrder = options.sortOrder ?? 0;
  o.slug = options.slug ?? "Pre con planning";
  o.forDevelopment = options.forDevelopment ?? false;
  o.forProject = options.forProject ?? false;
  o.isDeprecated = options.isDeprecated ?? false;
  return o;
}

factories["StageDetail"] = newStageDetail;

export interface SuburbanAssetCategoryDetailOptions {
  __typename?: "SuburbanAssetCategoryDetail";
  code?: SuburbanAssetCategoryDetail["code"];
  name?: SuburbanAssetCategoryDetail["name"];
}

export function newSuburbanAssetCategoryDetail(
  options: SuburbanAssetCategoryDetailOptions = {},
  cache: Record<string, any> = {},
): SuburbanAssetCategoryDetail {
  const o = (options.__typename ? options : cache["SuburbanAssetCategoryDetail"] = {}) as SuburbanAssetCategoryDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SuburbanAssetCategoryDetail";
  o.code = options.code ?? SuburbanAssetCategory.Inventory;
  o.name = options.name ?? "Inventory";
  return o;
}

factories["SuburbanAssetCategoryDetail"] = newSuburbanAssetCategoryDetail;

export interface SystemChangeRequestAssetDetailOptions {
  __typename?: "SystemChangeRequestAssetDetail";
  code?: SystemChangeRequestAssetDetail["code"];
  name?: SystemChangeRequestAssetDetail["name"];
}

export function newSystemChangeRequestAssetDetail(
  options: SystemChangeRequestAssetDetailOptions = {},
  cache: Record<string, any> = {},
): SystemChangeRequestAssetDetail {
  const o =
    (options.__typename ? options : cache["SystemChangeRequestAssetDetail"] = {}) as SystemChangeRequestAssetDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SystemChangeRequestAssetDetail";
  o.code = options.code ?? SystemChangeRequestAsset.PandaDoc;
  o.name = options.name ?? "Panda doc";
  return o;
}

factories["SystemChangeRequestAssetDetail"] = newSystemChangeRequestAssetDetail;

export interface SystemPlanMilestoneDetailOptions {
  __typename?: "SystemPlanMilestoneDetail";
  code?: SystemPlanMilestoneDetail["code"];
  name?: SystemPlanMilestoneDetail["name"];
}

export function newSystemPlanMilestoneDetail(
  options: SystemPlanMilestoneDetailOptions = {},
  cache: Record<string, any> = {},
): SystemPlanMilestoneDetail {
  const o = (options.__typename ? options : cache["SystemPlanMilestoneDetail"] = {}) as SystemPlanMilestoneDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SystemPlanMilestoneDetail";
  o.code = options.code ?? SystemPlanMilestone.MobilizationStart;
  o.name = options.name ?? "Mobilization start";
  return o;
}

factories["SystemPlanMilestoneDetail"] = newSystemPlanMilestoneDetail;

export interface SystemTaskDetailOptions {
  __typename?: "SystemTaskDetail";
  code?: SystemTaskDetail["code"];
  name?: SystemTaskDetail["name"];
}

export function newSystemTaskDetail(
  options: SystemTaskDetailOptions = {},
  cache: Record<string, any> = {},
): SystemTaskDetail {
  const o = (options.__typename ? options : cache["SystemTaskDetail"] = {}) as SystemTaskDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SystemTaskDetail";
  o.code = options.code ?? SystemTask.ConstructionRts;
  o.name = options.name ?? "Construction rts";
  return o;
}

factories["SystemTaskDetail"] = newSystemTaskDetail;

export interface TakeoffLineItemActionDetailOptions {
  __typename?: "TakeoffLineItemActionDetail";
  code?: TakeoffLineItemActionDetail["code"];
  name?: TakeoffLineItemActionDetail["name"];
}

export function newTakeoffLineItemActionDetail(
  options: TakeoffLineItemActionDetailOptions = {},
  cache: Record<string, any> = {},
): TakeoffLineItemActionDetail {
  const o = (options.__typename ? options : cache["TakeoffLineItemActionDetail"] = {}) as TakeoffLineItemActionDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TakeoffLineItemActionDetail";
  o.code = options.code ?? TakeoffLineItemAction.Add;
  o.name = options.name ?? "Add";
  return o;
}

factories["TakeoffLineItemActionDetail"] = newTakeoffLineItemActionDetail;

export interface TakeoffLineItemDesignPackageTypeDetailOptions {
  __typename?: "TakeoffLineItemDesignPackageTypeDetail";
  code?: TakeoffLineItemDesignPackageTypeDetail["code"];
  name?: TakeoffLineItemDesignPackageTypeDetail["name"];
}

export function newTakeoffLineItemDesignPackageTypeDetail(
  options: TakeoffLineItemDesignPackageTypeDetailOptions = {},
  cache: Record<string, any> = {},
): TakeoffLineItemDesignPackageTypeDetail {
  const o =
    (options.__typename
      ? options
      : cache["TakeoffLineItemDesignPackageTypeDetail"] = {}) as TakeoffLineItemDesignPackageTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TakeoffLineItemDesignPackageTypeDetail";
  o.code = options.code ?? TakeoffLineItemDesignPackageType.RegularPlaceholder;
  o.name = options.name ?? "Regular placeholder";
  return o;
}

factories["TakeoffLineItemDesignPackageTypeDetail"] = newTakeoffLineItemDesignPackageTypeDetail;

export interface TakeoffLineItemTypeDetailOptions {
  __typename?: "TakeoffLineItemTypeDetail";
  code?: TakeoffLineItemTypeDetail["code"];
  name?: TakeoffLineItemTypeDetail["name"];
}

export function newTakeoffLineItemTypeDetail(
  options: TakeoffLineItemTypeDetailOptions = {},
  cache: Record<string, any> = {},
): TakeoffLineItemTypeDetail {
  const o = (options.__typename ? options : cache["TakeoffLineItemTypeDetail"] = {}) as TakeoffLineItemTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TakeoffLineItemTypeDetail";
  o.code = options.code ?? TakeoffLineItemType.Iti;
  o.name = options.name ?? "Iti";
  return o;
}

factories["TakeoffLineItemTypeDetail"] = newTakeoffLineItemTypeDetail;

export interface TaskDeadlineTypeDetailOptions {
  __typename?: "TaskDeadlineTypeDetail";
  code?: TaskDeadlineTypeDetail["code"];
  name?: TaskDeadlineTypeDetail["name"];
}

export function newTaskDeadlineTypeDetail(
  options: TaskDeadlineTypeDetailOptions = {},
  cache: Record<string, any> = {},
): TaskDeadlineTypeDetail {
  const o = (options.__typename ? options : cache["TaskDeadlineTypeDetail"] = {}) as TaskDeadlineTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TaskDeadlineTypeDetail";
  o.code = options.code ?? TaskDeadlineType.Cutoff;
  o.name = options.name ?? "Cutoff";
  return o;
}

factories["TaskDeadlineTypeDetail"] = newTaskDeadlineTypeDetail;

export interface TaskDependencyTypeDetailOptions {
  __typename?: "TaskDependencyTypeDetail";
  code?: TaskDependencyTypeDetail["code"];
  name?: TaskDependencyTypeDetail["name"];
  shorthand?: TaskDependencyTypeDetail["shorthand"];
}

export function newTaskDependencyTypeDetail(
  options: TaskDependencyTypeDetailOptions = {},
  cache: Record<string, any> = {},
): TaskDependencyTypeDetail {
  const o = (options.__typename ? options : cache["TaskDependencyTypeDetail"] = {}) as TaskDependencyTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TaskDependencyTypeDetail";
  o.code = options.code ?? TaskDependencyType.FinishStart;
  o.name = options.name ?? "Finish start";
  o.shorthand = options.shorthand ?? "Finish start";
  return o;
}

factories["TaskDependencyTypeDetail"] = newTaskDependencyTypeDetail;

export interface TaskStatusDetailOptions {
  __typename?: "TaskStatusDetail";
  code?: TaskStatusDetail["code"];
  name?: TaskStatusDetail["name"];
  sortOrder?: TaskStatusDetail["sortOrder"];
}

export function newTaskStatusDetail(
  options: TaskStatusDetailOptions = {},
  cache: Record<string, any> = {},
): TaskStatusDetail {
  const o = (options.__typename ? options : cache["TaskStatusDetail"] = {}) as TaskStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TaskStatusDetail";
  o.code = options.code ?? TaskStatus.NotStarted;
  o.name = options.name ?? "Not started";
  o.sortOrder = options.sortOrder ?? 0;
  return o;
}

factories["TaskStatusDetail"] = newTaskStatusDetail;

export interface TaskTypeDetailOptions {
  __typename?: "TaskTypeDetail";
  code?: TaskTypeDetail["code"];
  name?: TaskTypeDetail["name"];
}

export function newTaskTypeDetail(
  options: TaskTypeDetailOptions = {},
  cache: Record<string, any> = {},
): TaskTypeDetail {
  const o = (options.__typename ? options : cache["TaskTypeDetail"] = {}) as TaskTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TaskTypeDetail";
  o.code = options.code ?? TaskType.ScheduleTask;
  o.name = options.name ?? "Schedule task";
  return o;
}

factories["TaskTypeDetail"] = newTaskTypeDetail;

export interface TimeFrequencyDetailOptions {
  __typename?: "TimeFrequencyDetail";
  code?: TimeFrequencyDetail["code"];
  name?: TimeFrequencyDetail["name"];
}

export function newTimeFrequencyDetail(
  options: TimeFrequencyDetailOptions = {},
  cache: Record<string, any> = {},
): TimeFrequencyDetail {
  const o = (options.__typename ? options : cache["TimeFrequencyDetail"] = {}) as TimeFrequencyDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TimeFrequencyDetail";
  o.code = options.code ?? TimeFrequency.Days;
  o.name = options.name ?? "Days";
  return o;
}

factories["TimeFrequencyDetail"] = newTimeFrequencyDetail;

export interface TimeOfDayDetailOptions {
  __typename?: "TimeOfDayDetail";
  code?: TimeOfDayDetail["code"];
  name?: TimeOfDayDetail["name"];
}

export function newTimeOfDayDetail(
  options: TimeOfDayDetailOptions = {},
  cache: Record<string, any> = {},
): TimeOfDayDetail {
  const o = (options.__typename ? options : cache["TimeOfDayDetail"] = {}) as TimeOfDayDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TimeOfDayDetail";
  o.code = options.code ?? TimeOfDay.Morning;
  o.name = options.name ?? "Morning";
  return o;
}

factories["TimeOfDayDetail"] = newTimeOfDayDetail;

export interface ToDoStatusDetailOptions {
  __typename?: "ToDoStatusDetail";
  code?: ToDoStatusDetail["code"];
  name?: ToDoStatusDetail["name"];
  sortOrder?: ToDoStatusDetail["sortOrder"];
}

export function newToDoStatusDetail(
  options: ToDoStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ToDoStatusDetail {
  const o = (options.__typename ? options : cache["ToDoStatusDetail"] = {}) as ToDoStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ToDoStatusDetail";
  o.code = options.code ?? ToDoStatus.Backlog;
  o.name = options.name ?? "Backlog";
  o.sortOrder = options.sortOrder ?? 0;
  return o;
}

factories["ToDoStatusDetail"] = newToDoStatusDetail;

export interface ToDoTypeDetailOptions {
  __typename?: "ToDoTypeDetail";
  code?: ToDoTypeDetail["code"];
  name?: ToDoTypeDetail["name"];
}

export function newToDoTypeDetail(
  options: ToDoTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ToDoTypeDetail {
  const o = (options.__typename ? options : cache["ToDoTypeDetail"] = {}) as ToDoTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ToDoTypeDetail";
  o.code = options.code ?? ToDoType.Submittals;
  o.name = options.name ?? "Submittals";
  return o;
}

factories["ToDoTypeDetail"] = newToDoTypeDetail;

export interface TrackedJobStatusDetailOptions {
  __typename?: "TrackedJobStatusDetail";
  code?: TrackedJobStatusDetail["code"];
  name?: TrackedJobStatusDetail["name"];
}

export function newTrackedJobStatusDetail(
  options: TrackedJobStatusDetailOptions = {},
  cache: Record<string, any> = {},
): TrackedJobStatusDetail {
  const o = (options.__typename ? options : cache["TrackedJobStatusDetail"] = {}) as TrackedJobStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TrackedJobStatusDetail";
  o.code = options.code ?? TrackedJobStatus.Pending;
  o.name = options.name ?? "Pending";
  return o;
}

factories["TrackedJobStatusDetail"] = newTrackedJobStatusDetail;

export interface TradePartnerAvailabilityRequestStatusDetailOptions {
  __typename?: "TradePartnerAvailabilityRequestStatusDetail";
  code?: TradePartnerAvailabilityRequestStatusDetail["code"];
  name?: TradePartnerAvailabilityRequestStatusDetail["name"];
}

export function newTradePartnerAvailabilityRequestStatusDetail(
  options: TradePartnerAvailabilityRequestStatusDetailOptions = {},
  cache: Record<string, any> = {},
): TradePartnerAvailabilityRequestStatusDetail {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerAvailabilityRequestStatusDetail"] = {}) as TradePartnerAvailabilityRequestStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerAvailabilityRequestStatusDetail";
  o.code = options.code ?? TradePartnerAvailabilityRequestStatus.Waiting;
  o.name = options.name ?? "Waiting";
  return o;
}

factories["TradePartnerAvailabilityRequestStatusDetail"] = newTradePartnerAvailabilityRequestStatusDetail;

export interface TradePartnerMarketRoleDetailOptions {
  __typename?: "TradePartnerMarketRoleDetail";
  code?: TradePartnerMarketRoleDetail["code"];
  name?: TradePartnerMarketRoleDetail["name"];
  sortOrder?: TradePartnerMarketRoleDetail["sortOrder"];
  description?: TradePartnerMarketRoleDetail["description"];
}

export function newTradePartnerMarketRoleDetail(
  options: TradePartnerMarketRoleDetailOptions = {},
  cache: Record<string, any> = {},
): TradePartnerMarketRoleDetail {
  const o = (options.__typename ? options : cache["TradePartnerMarketRoleDetail"] = {}) as TradePartnerMarketRoleDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerMarketRoleDetail";
  o.code = options.code ?? TradePartnerMarketRole.BillApprover;
  o.name = options.name ?? "Bill approver";
  o.sortOrder = options.sortOrder ?? 0;
  o.description = options.description ?? "Bill approver";
  return o;
}

factories["TradePartnerMarketRoleDetail"] = newTradePartnerMarketRoleDetail;

export interface TradePartnerOnboardingStatusDetailOptions {
  __typename?: "TradePartnerOnboardingStatusDetail";
  code?: TradePartnerOnboardingStatusDetail["code"];
  name?: TradePartnerOnboardingStatusDetail["name"];
}

export function newTradePartnerOnboardingStatusDetail(
  options: TradePartnerOnboardingStatusDetailOptions = {},
  cache: Record<string, any> = {},
): TradePartnerOnboardingStatusDetail {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerOnboardingStatusDetail"] = {}) as TradePartnerOnboardingStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerOnboardingStatusDetail";
  o.code = options.code ?? TradePartnerOnboardingStatus.InProgress;
  o.name = options.name ?? "In progress";
  return o;
}

factories["TradePartnerOnboardingStatusDetail"] = newTradePartnerOnboardingStatusDetail;

export interface TradePartnerRequirementStatusDetailOptions {
  __typename?: "TradePartnerRequirementStatusDetail";
  code?: TradePartnerRequirementStatusDetail["code"];
  name?: TradePartnerRequirementStatusDetail["name"];
}

export function newTradePartnerRequirementStatusDetail(
  options: TradePartnerRequirementStatusDetailOptions = {},
  cache: Record<string, any> = {},
): TradePartnerRequirementStatusDetail {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerRequirementStatusDetail"] = {}) as TradePartnerRequirementStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerRequirementStatusDetail";
  o.code = options.code ?? TradePartnerRequirementStatus.Meets;
  o.name = options.name ?? "Meets";
  return o;
}

factories["TradePartnerRequirementStatusDetail"] = newTradePartnerRequirementStatusDetail;

export interface TradePartnerRequirementTypeDetailOptions {
  __typename?: "TradePartnerRequirementTypeDetail";
  code?: TradePartnerRequirementTypeDetail["code"];
  name?: TradePartnerRequirementTypeDetail["name"];
  hasExpirationDate?: TradePartnerRequirementTypeDetail["hasExpirationDate"];
  hasCoverageAmount?: TradePartnerRequirementTypeDetail["hasCoverageAmount"];
  hasLicenseNumber?: TradePartnerRequirementTypeDetail["hasLicenseNumber"];
  hasSignedDate?: TradePartnerRequirementTypeDetail["hasSignedDate"];
  isTsa?: TradePartnerRequirementTypeDetail["isTsa"];
}

export function newTradePartnerRequirementTypeDetail(
  options: TradePartnerRequirementTypeDetailOptions = {},
  cache: Record<string, any> = {},
): TradePartnerRequirementTypeDetail {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerRequirementTypeDetail"] = {}) as TradePartnerRequirementTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerRequirementTypeDetail";
  o.code = options.code ?? TradePartnerRequirementType.W9;
  o.name = options.name ?? "W9";
  o.hasExpirationDate = options.hasExpirationDate ?? false;
  o.hasCoverageAmount = options.hasCoverageAmount ?? false;
  o.hasLicenseNumber = options.hasLicenseNumber ?? false;
  o.hasSignedDate = options.hasSignedDate ?? false;
  o.isTsa = options.isTsa ?? false;
  return o;
}

factories["TradePartnerRequirementTypeDetail"] = newTradePartnerRequirementTypeDetail;

export interface TradePartnerTaskStatusDetailOptions {
  __typename?: "TradePartnerTaskStatusDetail";
  code?: TradePartnerTaskStatusDetail["code"];
  name?: TradePartnerTaskStatusDetail["name"];
}

export function newTradePartnerTaskStatusDetail(
  options: TradePartnerTaskStatusDetailOptions = {},
  cache: Record<string, any> = {},
): TradePartnerTaskStatusDetail {
  const o = (options.__typename ? options : cache["TradePartnerTaskStatusDetail"] = {}) as TradePartnerTaskStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerTaskStatusDetail";
  o.code = options.code ?? TradePartnerTaskStatus.NeedsConfirmation;
  o.name = options.name ?? "Needs confirmation";
  return o;
}

factories["TradePartnerTaskStatusDetail"] = newTradePartnerTaskStatusDetail;

export interface UserEventTypeDetailOptions {
  __typename?: "UserEventTypeDetail";
  code?: UserEventTypeDetail["code"];
  name?: UserEventTypeDetail["name"];
  allowedEntities?: UserEventTypeDetail["allowedEntities"];
}

export function newUserEventTypeDetail(
  options: UserEventTypeDetailOptions = {},
  cache: Record<string, any> = {},
): UserEventTypeDetail {
  const o = (options.__typename ? options : cache["UserEventTypeDetail"] = {}) as UserEventTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserEventTypeDetail";
  o.code = options.code ?? UserEventType.Created;
  o.name = options.name ?? "Created";
  o.allowedEntities = options.allowedEntities ?? "Created";
  return o;
}

factories["UserEventTypeDetail"] = newUserEventTypeDetail;

export interface UserTypeDetailOptions {
  __typename?: "UserTypeDetail";
  code?: UserTypeDetail["code"];
  name?: UserTypeDetail["name"];
}

export function newUserTypeDetail(
  options: UserTypeDetailOptions = {},
  cache: Record<string, any> = {},
): UserTypeDetail {
  const o = (options.__typename ? options : cache["UserTypeDetail"] = {}) as UserTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserTypeDetail";
  o.code = options.code ?? UserType.Anonymous;
  o.name = options.name ?? "Anonymous";
  return o;
}

factories["UserTypeDetail"] = newUserTypeDetail;

export interface VerificationMethodDetailOptions {
  __typename?: "VerificationMethodDetail";
  code?: VerificationMethodDetail["code"];
  name?: VerificationMethodDetail["name"];
}

export function newVerificationMethodDetail(
  options: VerificationMethodDetailOptions = {},
  cache: Record<string, any> = {},
): VerificationMethodDetail {
  const o = (options.__typename ? options : cache["VerificationMethodDetail"] = {}) as VerificationMethodDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "VerificationMethodDetail";
  o.code = options.code ?? VerificationMethod.VisualInput;
  o.name = options.name ?? "Visual input";
  return o;
}

factories["VerificationMethodDetail"] = newVerificationMethodDetail;

export interface WarrantyTicketItemStatusDetailOptions {
  __typename?: "WarrantyTicketItemStatusDetail";
  code?: WarrantyTicketItemStatusDetail["code"];
  name?: WarrantyTicketItemStatusDetail["name"];
  sortOrder?: WarrantyTicketItemStatusDetail["sortOrder"];
}

export function newWarrantyTicketItemStatusDetail(
  options: WarrantyTicketItemStatusDetailOptions = {},
  cache: Record<string, any> = {},
): WarrantyTicketItemStatusDetail {
  const o =
    (options.__typename ? options : cache["WarrantyTicketItemStatusDetail"] = {}) as WarrantyTicketItemStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WarrantyTicketItemStatusDetail";
  o.code = options.code ?? WarrantyTicketItemStatus.Submitted;
  o.name = options.name ?? "Submitted";
  o.sortOrder = options.sortOrder ?? 0;
  return o;
}

factories["WarrantyTicketItemStatusDetail"] = newWarrantyTicketItemStatusDetail;

export interface WarrantyTicketItemTypeDetailOptions {
  __typename?: "WarrantyTicketItemTypeDetail";
  code?: WarrantyTicketItemTypeDetail["code"];
  name?: WarrantyTicketItemTypeDetail["name"];
}

export function newWarrantyTicketItemTypeDetail(
  options: WarrantyTicketItemTypeDetailOptions = {},
  cache: Record<string, any> = {},
): WarrantyTicketItemTypeDetail {
  const o = (options.__typename ? options : cache["WarrantyTicketItemTypeDetail"] = {}) as WarrantyTicketItemTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WarrantyTicketItemTypeDetail";
  o.code = options.code ?? WarrantyTicketItemType.Mechanical;
  o.name = options.name ?? "Mechanical";
  return o;
}

factories["WarrantyTicketItemTypeDetail"] = newWarrantyTicketItemTypeDetail;

export interface WarrantyTicketStatusDetailOptions {
  __typename?: "WarrantyTicketStatusDetail";
  code?: WarrantyTicketStatusDetail["code"];
  name?: WarrantyTicketStatusDetail["name"];
}

export function newWarrantyTicketStatusDetail(
  options: WarrantyTicketStatusDetailOptions = {},
  cache: Record<string, any> = {},
): WarrantyTicketStatusDetail {
  const o = (options.__typename ? options : cache["WarrantyTicketStatusDetail"] = {}) as WarrantyTicketStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WarrantyTicketStatusDetail";
  o.code = options.code ?? WarrantyTicketStatus.NotStarted;
  o.name = options.name ?? "Not started";
  return o;
}

factories["WarrantyTicketStatusDetail"] = newWarrantyTicketStatusDetail;

export interface WarrantyTicketTypeDetailOptions {
  __typename?: "WarrantyTicketTypeDetail";
  code?: WarrantyTicketTypeDetail["code"];
  name?: WarrantyTicketTypeDetail["name"];
}

export function newWarrantyTicketTypeDetail(
  options: WarrantyTicketTypeDetailOptions = {},
  cache: Record<string, any> = {},
): WarrantyTicketTypeDetail {
  const o = (options.__typename ? options : cache["WarrantyTicketTypeDetail"] = {}) as WarrantyTicketTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WarrantyTicketTypeDetail";
  o.code = options.code ?? WarrantyTicketType.ItemsOfContinuance;
  o.name = options.name ?? "Items of continuance";
  return o;
}

factories["WarrantyTicketTypeDetail"] = newWarrantyTicketTypeDetail;

export interface WarrantyTrueUpTypeDetailOptions {
  __typename?: "WarrantyTrueUpTypeDetail";
  code?: WarrantyTrueUpTypeDetail["code"];
  name?: WarrantyTrueUpTypeDetail["name"];
  offsetInDays?: WarrantyTrueUpTypeDetail["offsetInDays"];
}

export function newWarrantyTrueUpTypeDetail(
  options: WarrantyTrueUpTypeDetailOptions = {},
  cache: Record<string, any> = {},
): WarrantyTrueUpTypeDetail {
  const o = (options.__typename ? options : cache["WarrantyTrueUpTypeDetail"] = {}) as WarrantyTrueUpTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WarrantyTrueUpTypeDetail";
  o.code = options.code ?? WarrantyTrueUpType.TimeOfSale;
  o.name = options.name ?? "Time of sale";
  o.offsetInDays = options.offsetInDays ?? 0;
  return o;
}

factories["WarrantyTrueUpTypeDetail"] = newWarrantyTrueUpTypeDetail;

export interface WeatherTypeDetailOptions {
  __typename?: "WeatherTypeDetail";
  code?: WeatherTypeDetail["code"];
  name?: WeatherTypeDetail["name"];
}

export function newWeatherTypeDetail(
  options: WeatherTypeDetailOptions = {},
  cache: Record<string, any> = {},
): WeatherTypeDetail {
  const o = (options.__typename ? options : cache["WeatherTypeDetail"] = {}) as WeatherTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WeatherTypeDetail";
  o.code = options.code ?? WeatherType.ClearDay;
  o.name = options.name ?? "Clear day";
  return o;
}

factories["WeatherTypeDetail"] = newWeatherTypeDetail;

export interface AllEnumDetailsOptions {
  __typename?: "AllEnumDetails";
  activityPlanningState?: Array<ActivityPlanningStateDetail | ActivityPlanningStateDetailOptions>;
  activityResponsibility?: Array<ActivityResponsibilityDetail | ActivityResponsibilityDetailOptions>;
  activityType?: Array<ActivityTypeDetail | ActivityTypeDetailOptions>;
  aggregateVersionStatus?: Array<AggregateVersionStatusDetail | AggregateVersionStatusDetailOptions>;
  aiEntityProposalEntityType?: Array<AiEntityProposalEntityTypeDetail | AiEntityProposalEntityTypeDetailOptions>;
  aiEntityProposalType?: Array<AiEntityProposalTypeDetail | AiEntityProposalTypeDetailOptions>;
  aiFieldProposalStatus?: Array<AiFieldProposalStatusDetail | AiFieldProposalStatusDetailOptions>;
  aiProposalStatus?: Array<AiProposalStatusDetail | AiProposalStatusDetailOptions>;
  aiProposalType?: Array<AiProposalTypeDetail | AiProposalTypeDetailOptions>;
  allocationStrategy?: Array<AllocationStrategyDetail | AllocationStrategyDetailOptions>;
  approvalStatus?: Array<ApprovalStatusDetail | ApprovalStatusDetailOptions>;
  approverStatus?: Array<ApproverStatusDetail | ApproverStatusDetailOptions>;
  bidContractRevisionStatus?: Array<BidContractRevisionStatusDetail | BidContractRevisionStatusDetailOptions>;
  bidContractType?: Array<BidContractTypeDetail | BidContractTypeDetailOptions>;
  bidPackageStatus?: Array<BidPackageStatusDetail | BidPackageStatusDetailOptions>;
  bidScopeSource?: Array<BidScopeSourceDetail | BidScopeSourceDetailOptions>;
  billGmailAttachmentResult?: Array<BillGmailAttachmentResultDetail | BillGmailAttachmentResultDetailOptions>;
  billGmailMessageResult?: Array<BillGmailMessageResultDetail | BillGmailMessageResultDetailOptions>;
  billReviewReason?: Array<BillReviewReasonDetail | BillReviewReasonDetailOptions>;
  billSource?: Array<BillSourceDetail | BillSourceDetailOptions>;
  billStatus?: Array<BillStatusDetail | BillStatusDetailOptions>;
  billType?: Array<BillTypeDetail | BillTypeDetailOptions>;
  businessFunctionType?: Array<BusinessFunctionTypeDetail | BusinessFunctionTypeDetailOptions>;
  buyoutStatus?: Array<BuyoutStatusDetail | BuyoutStatusDetailOptions>;
  changeEventBudgetPhase?: Array<ChangeEventBudgetPhaseDetail | ChangeEventBudgetPhaseDetailOptions>;
  changeEventLineItemType?: Array<ChangeEventLineItemTypeDetail | ChangeEventLineItemTypeDetailOptions>;
  changeEventStatus?: Array<ChangeEventStatusDetail | ChangeEventStatusDetailOptions>;
  changeEventType?: Array<ChangeEventTypeDetail | ChangeEventTypeDetailOptions>;
  changeEventWorkflow?: Array<ChangeEventWorkflowDetail | ChangeEventWorkflowDetailOptions>;
  changeRequestAssetPlatform?: Array<ChangeRequestAssetPlatformDetail | ChangeRequestAssetPlatformDetailOptions>;
  changeRequestAssetScope?: Array<ChangeRequestAssetScopeDetail | ChangeRequestAssetScopeDetailOptions>;
  changeRequestPriority?: Array<ChangeRequestPriorityDetail | ChangeRequestPriorityDetailOptions>;
  changeRequestSource?: Array<ChangeRequestSourceDetail | ChangeRequestSourceDetailOptions>;
  changeRequestStatus?: Array<ChangeRequestStatusDetail | ChangeRequestStatusDetailOptions>;
  changeRequestToDoType?: Array<ChangeRequestToDoTypeDetail | ChangeRequestToDoTypeDetailOptions>;
  changeType?: Array<ChangeTypeDetail | ChangeTypeDetailOptions>;
  checkoutConfigOptionGroupStep?: Array<
    CheckoutConfigOptionGroupStepDetail | CheckoutConfigOptionGroupStepDetailOptions
  >;
  checkoutConfigStatus?: Array<CheckoutConfigStatusDetail | CheckoutConfigStatusDetailOptions>;
  clientPlatform?: Array<ClientPlatformDetail | ClientPlatformDetailOptions>;
  commentStreamVisibility?: Array<CommentStreamVisibilityDetail | CommentStreamVisibilityDetailOptions>;
  commitmentStatus?: Array<CommitmentStatusDetail | CommitmentStatusDetailOptions>;
  commitmentType?: Array<CommitmentTypeDetail | CommitmentTypeDetailOptions>;
  communicationChannel?: Array<CommunicationChannelDetail | CommunicationChannelDetailOptions>;
  communityType?: Array<CommunityTypeDetail | CommunityTypeDetailOptions>;
  constructionType?: Array<ConstructionTypeDetail | ConstructionTypeDetailOptions>;
  contractType?: Array<ContractTypeDetail | ContractTypeDetailOptions>;
  costClassificationType?: Array<CostClassificationTypeDetail | CostClassificationTypeDetailOptions>;
  costCodeInvoiceCategory?: Array<CostCodeInvoiceCategoryDetail | CostCodeInvoiceCategoryDetailOptions>;
  costConfidence?: Array<CostConfidenceDetail | CostConfidenceDetailOptions>;
  costSubClassificationType?: Array<CostSubClassificationTypeDetail | CostSubClassificationTypeDetailOptions>;
  costType?: Array<CostTypeDetail | CostTypeDetailOptions>;
  dayOfWeek?: Array<DayOfWeekDetail | DayOfWeekDetailOptions>;
  designPackageLocation?: Array<DesignPackageLocationDetail | DesignPackageLocationDetailOptions>;
  developmentCommitmentType?: Array<DevelopmentCommitmentTypeDetail | DevelopmentCommitmentTypeDetailOptions>;
  documentAttachmentPlace?: Array<DocumentAttachmentPlaceDetail | DocumentAttachmentPlaceDetailOptions>;
  documentCategory?: Array<DocumentCategoryDetail | DocumentCategoryDetailOptions>;
  documentType?: Array<DocumentTypeDetail | DocumentTypeDetailOptions>;
  erpAccrualType?: Array<ErpAccrualTypeDetail | ErpAccrualTypeDetailOptions>;
  erpRevenueLineItemSourceEvent?: Array<
    ErpRevenueLineItemSourceEventDetail | ErpRevenueLineItemSourceEventDetailOptions
  >;
  erpTransactionGroupEvent?: Array<ErpTransactionGroupEventDetail | ErpTransactionGroupEventDetailOptions>;
  erpTransactionGroupStatus?: Array<ErpTransactionGroupStatusDetail | ErpTransactionGroupStatusDetailOptions>;
  erpTransactionStatus?: Array<ErpTransactionStatusDetail | ErpTransactionStatusDetailOptions>;
  estimateStatus?: Array<EstimateStatusDetail | EstimateStatusDetailOptions>;
  estimateType?: Array<EstimateTypeDetail | EstimateTypeDetailOptions>;
  featureFlagStatus?: Array<FeatureFlagStatusDetail | FeatureFlagStatusDetailOptions>;
  featureFlagType?: Array<FeatureFlagTypeDetail | FeatureFlagTypeDetailOptions>;
  finishScheduleColumnType?: Array<FinishScheduleColumnTypeDetail | FinishScheduleColumnTypeDetailOptions>;
  finishScheduleCoreColumn?: Array<FinishScheduleCoreColumnDetail | FinishScheduleCoreColumnDetailOptions>;
  floodPlain?: Array<FloodPlainDetail | FloodPlainDetailOptions>;
  floodZone?: Array<FloodZoneDetail | FloodZoneDetailOptions>;
  foundationType?: Array<FoundationTypeDetail | FoundationTypeDetailOptions>;
  globalOptionStatus?: Array<GlobalOptionStatusDetail | GlobalOptionStatusDetailOptions>;
  globalOptionTypeStatus?: Array<GlobalOptionTypeStatusDetail | GlobalOptionTypeStatusDetailOptions>;
  globalPlanMilestoneType?: Array<GlobalPlanMilestoneTypeDetail | GlobalPlanMilestoneTypeDetailOptions>;
  inboxItemStatus?: Array<InboxItemStatusDetail | InboxItemStatusDetailOptions>;
  internalEstimateType?: Array<InternalEstimateTypeDetail | InternalEstimateTypeDetailOptions>;
  invoiceDocumentSource?: Array<InvoiceDocumentSourceDetail | InvoiceDocumentSourceDetailOptions>;
  invoiceScheduleAmountType?: Array<InvoiceScheduleAmountTypeDetail | InvoiceScheduleAmountTypeDetailOptions>;
  invoiceScheduleItemFrequency?: Array<InvoiceScheduleItemFrequencyDetail | InvoiceScheduleItemFrequencyDetailOptions>;
  invoiceScheduleTriggerType?: Array<InvoiceScheduleTriggerTypeDetail | InvoiceScheduleTriggerTypeDetailOptions>;
  invoiceSource?: Array<InvoiceSourceDetail | InvoiceSourceDetailOptions>;
  invoiceStatus?: Array<InvoiceStatusDetail | InvoiceStatusDetailOptions>;
  invoiceType?: Array<InvoiceTypeDetail | InvoiceTypeDetailOptions>;
  itemStatus?: Array<ItemStatusDetail | ItemStatusDetailOptions>;
  itemTemplateItemCostStatus?: Array<ItemTemplateItemCostStatusDetail | ItemTemplateItemCostStatusDetailOptions>;
  itemTemplateStatus?: Array<ItemTemplateStatusDetail | ItemTemplateStatusDetailOptions>;
  jobLogFlag?: Array<JobLogFlagDetail | JobLogFlagDetailOptions>;
  jobLogNoteType?: Array<JobLogNoteTypeDetail | JobLogNoteTypeDetailOptions>;
  lienWaiverCondition?: Array<LienWaiverConditionDetail | LienWaiverConditionDetailOptions>;
  lienWaiverStatus?: Array<LienWaiverStatusDetail | LienWaiverStatusDetailOptions>;
  lienWaiverType?: Array<LienWaiverTypeDetail | LienWaiverTypeDetailOptions>;
  locationType?: Array<LocationTypeDetail | LocationTypeDetailOptions>;
  lotSalesStatus?: Array<LotSalesStatusDetail | LotSalesStatusDetailOptions>;
  lotType?: Array<LotTypeDetail | LotTypeDetailOptions>;
  markupApplicationMethod?: Array<MarkupApplicationMethodDetail | MarkupApplicationMethodDetailOptions>;
  materialAttributeDimensionType?: Array<
    MaterialAttributeDimensionTypeDetail | MaterialAttributeDimensionTypeDetailOptions
  >;
  materialAttributeValueType?: Array<MaterialAttributeValueTypeDetail | MaterialAttributeValueTypeDetailOptions>;
  materialType?: Array<MaterialTypeDetail | MaterialTypeDetailOptions>;
  mobileSyncUpdateType?: Array<MobileSyncUpdateTypeDetail | MobileSyncUpdateTypeDetailOptions>;
  pandaDocRole?: Array<PandaDocRoleDetail | PandaDocRoleDetailOptions>;
  pandaDocStatus?: Array<PandaDocStatusDetail | PandaDocStatusDetailOptions>;
  pandaDocWorkspace?: Array<PandaDocWorkspaceDetail | PandaDocWorkspaceDetailOptions>;
  paymentTermDueFrom?: Array<PaymentTermDueFromDetail | PaymentTermDueFromDetailOptions>;
  permit?: Array<PermitDetail | PermitDetailOptions>;
  planPackageIncomingSlotStatus?: Array<
    PlanPackageIncomingSlotStatusDetail | PlanPackageIncomingSlotStatusDetailOptions
  >;
  programDataBasementConfig?: Array<ProgramDataBasementConfigDetail | ProgramDataBasementConfigDetailOptions>;
  programDataGarageConfig?: Array<ProgramDataGarageConfigDetail | ProgramDataGarageConfigDetailOptions>;
  programDataMatchState?: Array<ProgramDataMatchStateDetail | ProgramDataMatchStateDetailOptions>;
  programDataPrimaryBedroomConfig?: Array<
    ProgramDataPrimaryBedroomConfigDetail | ProgramDataPrimaryBedroomConfigDetailOptions
  >;
  programDataWindowColor?: Array<ProgramDataWindowColorDetail | ProgramDataWindowColorDetailOptions>;
  projectCollaboratorRole?: Array<ProjectCollaboratorRoleDetail | ProjectCollaboratorRoleDetailOptions>;
  projectFeature?: Array<ProjectFeatureDetail | ProjectFeatureDetailOptions>;
  projectReadyPlanConfigOrientation?: Array<
    ProjectReadyPlanConfigOrientationDetail | ProjectReadyPlanConfigOrientationDetailOptions
  >;
  projectRole?: Array<ProjectRoleDetail | ProjectRoleDetailOptions>;
  projectStageStatus?: Array<ProjectStageStatusDetail | ProjectStageStatusDetailOptions>;
  projectStatus?: Array<ProjectStatusDetail | ProjectStatusDetailOptions>;
  projectUpdateActionType?: Array<ProjectUpdateActionTypeDetail | ProjectUpdateActionTypeDetailOptions>;
  pushNotificationEnvironment?: Array<PushNotificationEnvironmentDetail | PushNotificationEnvironmentDetailOptions>;
  pushNotificationPlatform?: Array<PushNotificationPlatformDetail | PushNotificationPlatformDetailOptions>;
  readyPlanAssetType?: Array<ReadyPlanAssetTypeDetail | ReadyPlanAssetTypeDetailOptions>;
  readyPlanOptionGroupPersonalizationType?: Array<
    ReadyPlanOptionGroupPersonalizationTypeDetail | ReadyPlanOptionGroupPersonalizationTypeDetailOptions
  >;
  readyPlanStatus?: Array<ReadyPlanStatusDetail | ReadyPlanStatusDetailOptions>;
  readyPlanType?: Array<ReadyPlanTypeDetail | ReadyPlanTypeDetailOptions>;
  scheduleFlagReasonType?: Array<ScheduleFlagReasonTypeDetail | ScheduleFlagReasonTypeDetailOptions>;
  scheduleStatus?: Array<ScheduleStatusDetail | ScheduleStatusDetailOptions>;
  scheduleTemplateStatus?: Array<ScheduleTemplateStatusDetail | ScheduleTemplateStatusDetailOptions>;
  scopeChangeType?: Array<ScopeChangeTypeDetail | ScopeChangeTypeDetailOptions>;
  scopeMode?: Array<ScopeModeDetail | ScopeModeDetailOptions>;
  selectionCutoff?: Array<SelectionCutoffDetail | SelectionCutoffDetailOptions>;
  stage?: Array<StageDetail | StageDetailOptions>;
  suburbanAssetCategory?: Array<SuburbanAssetCategoryDetail | SuburbanAssetCategoryDetailOptions>;
  systemChangeRequestAsset?: Array<SystemChangeRequestAssetDetail | SystemChangeRequestAssetDetailOptions>;
  systemPlanMilestone?: Array<SystemPlanMilestoneDetail | SystemPlanMilestoneDetailOptions>;
  systemTask?: Array<SystemTaskDetail | SystemTaskDetailOptions>;
  takeoffLineItemAction?: Array<TakeoffLineItemActionDetail | TakeoffLineItemActionDetailOptions>;
  takeoffLineItemDesignPackageType?: Array<
    TakeoffLineItemDesignPackageTypeDetail | TakeoffLineItemDesignPackageTypeDetailOptions
  >;
  takeoffLineItemType?: Array<TakeoffLineItemTypeDetail | TakeoffLineItemTypeDetailOptions>;
  taskDeadlineType?: Array<TaskDeadlineTypeDetail | TaskDeadlineTypeDetailOptions>;
  taskDependencyType?: Array<TaskDependencyTypeDetail | TaskDependencyTypeDetailOptions>;
  taskStatus?: Array<TaskStatusDetail | TaskStatusDetailOptions>;
  taskType?: Array<TaskTypeDetail | TaskTypeDetailOptions>;
  timeFrequency?: Array<TimeFrequencyDetail | TimeFrequencyDetailOptions>;
  timeOfDay?: Array<TimeOfDayDetail | TimeOfDayDetailOptions>;
  toDoStatus?: Array<ToDoStatusDetail | ToDoStatusDetailOptions>;
  toDoType?: Array<ToDoTypeDetail | ToDoTypeDetailOptions>;
  trackedJobStatus?: Array<TrackedJobStatusDetail | TrackedJobStatusDetailOptions>;
  tradePartnerAvailabilityRequestStatus?: Array<
    TradePartnerAvailabilityRequestStatusDetail | TradePartnerAvailabilityRequestStatusDetailOptions
  >;
  tradePartnerMarketRole?: Array<TradePartnerMarketRoleDetail | TradePartnerMarketRoleDetailOptions>;
  tradePartnerOnboardingStatus?: Array<TradePartnerOnboardingStatusDetail | TradePartnerOnboardingStatusDetailOptions>;
  tradePartnerRequirementStatus?: Array<
    TradePartnerRequirementStatusDetail | TradePartnerRequirementStatusDetailOptions
  >;
  tradePartnerRequirementType?: Array<TradePartnerRequirementTypeDetail | TradePartnerRequirementTypeDetailOptions>;
  tradePartnerTaskStatus?: Array<TradePartnerTaskStatusDetail | TradePartnerTaskStatusDetailOptions>;
  userEventType?: Array<UserEventTypeDetail | UserEventTypeDetailOptions>;
  userType?: Array<UserTypeDetail | UserTypeDetailOptions>;
  verificationMethod?: Array<VerificationMethodDetail | VerificationMethodDetailOptions>;
  warrantyTicketItemStatus?: Array<WarrantyTicketItemStatusDetail | WarrantyTicketItemStatusDetailOptions>;
  warrantyTicketItemType?: Array<WarrantyTicketItemTypeDetail | WarrantyTicketItemTypeDetailOptions>;
  warrantyTicketStatus?: Array<WarrantyTicketStatusDetail | WarrantyTicketStatusDetailOptions>;
  warrantyTicketType?: Array<WarrantyTicketTypeDetail | WarrantyTicketTypeDetailOptions>;
  warrantyTrueUpType?: Array<WarrantyTrueUpTypeDetail | WarrantyTrueUpTypeDetailOptions>;
  weatherType?: Array<WeatherTypeDetail | WeatherTypeDetailOptions>;
}

export function newAllEnumDetails(
  options: AllEnumDetailsOptions = {},
  cache: Record<string, any> = {},
): AllEnumDetails {
  const o = (options.__typename ? options : cache["AllEnumDetails"] = {}) as AllEnumDetails;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AllEnumDetails";
  o.activityPlanningState = (options.activityPlanningState ?? []).map((i) => enumOrDetailOfActivityPlanningState(i));
  o.activityResponsibility = (options.activityResponsibility ?? []).map((i) => enumOrDetailOfActivityResponsibility(i));
  o.activityType = (options.activityType ?? []).map((i) => enumOrDetailOfActivityType(i));
  o.aggregateVersionStatus = (options.aggregateVersionStatus ?? []).map((i) => enumOrDetailOfAggregateVersionStatus(i));
  o.aiEntityProposalEntityType = (options.aiEntityProposalEntityType ?? []).map((i) =>
    enumOrDetailOfAiEntityProposalEntityType(i)
  );
  o.aiEntityProposalType = (options.aiEntityProposalType ?? []).map((i) => enumOrDetailOfAiEntityProposalType(i));
  o.aiFieldProposalStatus = (options.aiFieldProposalStatus ?? []).map((i) => enumOrDetailOfAiFieldProposalStatus(i));
  o.aiProposalStatus = (options.aiProposalStatus ?? []).map((i) => enumOrDetailOfAiProposalStatus(i));
  o.aiProposalType = (options.aiProposalType ?? []).map((i) => enumOrDetailOfAiProposalType(i));
  o.allocationStrategy = (options.allocationStrategy ?? []).map((i) => enumOrDetailOfAllocationStrategy(i));
  o.approvalStatus = (options.approvalStatus ?? []).map((i) => enumOrDetailOfApprovalStatus(i));
  o.approverStatus = (options.approverStatus ?? []).map((i) => enumOrDetailOfApproverStatus(i));
  o.bidContractRevisionStatus = (options.bidContractRevisionStatus ?? []).map((i) =>
    enumOrDetailOfBidContractRevisionStatus(i)
  );
  o.bidContractType = (options.bidContractType ?? []).map((i) => enumOrDetailOfBidContractType(i));
  o.bidPackageStatus = (options.bidPackageStatus ?? []).map((i) => enumOrDetailOfBidPackageStatus(i));
  o.bidScopeSource = (options.bidScopeSource ?? []).map((i) => enumOrDetailOfBidScopeSource(i));
  o.billGmailAttachmentResult = (options.billGmailAttachmentResult ?? []).map((i) =>
    enumOrDetailOfBillGmailAttachmentResult(i)
  );
  o.billGmailMessageResult = (options.billGmailMessageResult ?? []).map((i) => enumOrDetailOfBillGmailMessageResult(i));
  o.billReviewReason = (options.billReviewReason ?? []).map((i) => enumOrDetailOfBillReviewReason(i));
  o.billSource = (options.billSource ?? []).map((i) => enumOrDetailOfBillSource(i));
  o.billStatus = (options.billStatus ?? []).map((i) => enumOrDetailOfBillStatus(i));
  o.billType = (options.billType ?? []).map((i) => enumOrDetailOfBillType(i));
  o.businessFunctionType = (options.businessFunctionType ?? []).map((i) => enumOrDetailOfBusinessFunctionType(i));
  o.buyoutStatus = (options.buyoutStatus ?? []).map((i) => enumOrDetailOfBuyoutStatus(i));
  o.changeEventBudgetPhase = (options.changeEventBudgetPhase ?? []).map((i) => enumOrDetailOfChangeEventBudgetPhase(i));
  o.changeEventLineItemType = (options.changeEventLineItemType ?? []).map((i) =>
    enumOrDetailOfChangeEventLineItemType(i)
  );
  o.changeEventStatus = (options.changeEventStatus ?? []).map((i) => enumOrDetailOfChangeEventStatus(i));
  o.changeEventType = (options.changeEventType ?? []).map((i) => enumOrDetailOfChangeEventType(i));
  o.changeEventWorkflow = (options.changeEventWorkflow ?? []).map((i) => enumOrDetailOfChangeEventWorkflow(i));
  o.changeRequestAssetPlatform = (options.changeRequestAssetPlatform ?? []).map((i) =>
    enumOrDetailOfChangeRequestAssetPlatform(i)
  );
  o.changeRequestAssetScope = (options.changeRequestAssetScope ?? []).map((i) =>
    enumOrDetailOfChangeRequestAssetScope(i)
  );
  o.changeRequestPriority = (options.changeRequestPriority ?? []).map((i) => enumOrDetailOfChangeRequestPriority(i));
  o.changeRequestSource = (options.changeRequestSource ?? []).map((i) => enumOrDetailOfChangeRequestSource(i));
  o.changeRequestStatus = (options.changeRequestStatus ?? []).map((i) => enumOrDetailOfChangeRequestStatus(i));
  o.changeRequestToDoType = (options.changeRequestToDoType ?? []).map((i) => enumOrDetailOfChangeRequestToDoType(i));
  o.changeType = (options.changeType ?? []).map((i) => enumOrDetailOfChangeType(i));
  o.checkoutConfigOptionGroupStep = (options.checkoutConfigOptionGroupStep ?? []).map((i) =>
    enumOrDetailOfCheckoutConfigOptionGroupStep(i)
  );
  o.checkoutConfigStatus = (options.checkoutConfigStatus ?? []).map((i) => enumOrDetailOfCheckoutConfigStatus(i));
  o.clientPlatform = (options.clientPlatform ?? []).map((i) => enumOrDetailOfClientPlatform(i));
  o.commentStreamVisibility = (options.commentStreamVisibility ?? []).map((i) =>
    enumOrDetailOfCommentStreamVisibility(i)
  );
  o.commitmentStatus = (options.commitmentStatus ?? []).map((i) => enumOrDetailOfCommitmentStatus(i));
  o.commitmentType = (options.commitmentType ?? []).map((i) => enumOrDetailOfCommitmentType(i));
  o.communicationChannel = (options.communicationChannel ?? []).map((i) => enumOrDetailOfCommunicationChannel(i));
  o.communityType = (options.communityType ?? []).map((i) => enumOrDetailOfCommunityType(i));
  o.constructionType = (options.constructionType ?? []).map((i) => enumOrDetailOfConstructionType(i));
  o.contractType = (options.contractType ?? []).map((i) => enumOrDetailOfContractType(i));
  o.costClassificationType = (options.costClassificationType ?? []).map((i) => enumOrDetailOfCostClassificationType(i));
  o.costCodeInvoiceCategory = (options.costCodeInvoiceCategory ?? []).map((i) =>
    enumOrDetailOfCostCodeInvoiceCategory(i)
  );
  o.costConfidence = (options.costConfidence ?? []).map((i) => enumOrDetailOfCostConfidence(i));
  o.costSubClassificationType = (options.costSubClassificationType ?? []).map((i) =>
    enumOrDetailOfCostSubClassificationType(i)
  );
  o.costType = (options.costType ?? []).map((i) => enumOrDetailOfCostType(i));
  o.dayOfWeek = (options.dayOfWeek ?? []).map((i) => enumOrDetailOfDayOfWeek(i));
  o.designPackageLocation = (options.designPackageLocation ?? []).map((i) => enumOrDetailOfDesignPackageLocation(i));
  o.developmentCommitmentType = (options.developmentCommitmentType ?? []).map((i) =>
    enumOrDetailOfDevelopmentCommitmentType(i)
  );
  o.documentAttachmentPlace = (options.documentAttachmentPlace ?? []).map((i) =>
    enumOrDetailOfDocumentAttachmentPlace(i)
  );
  o.documentCategory = (options.documentCategory ?? []).map((i) => enumOrDetailOfDocumentCategory(i));
  o.documentType = (options.documentType ?? []).map((i) => enumOrDetailOfDocumentType(i));
  o.erpAccrualType = (options.erpAccrualType ?? []).map((i) => enumOrDetailOfErpAccrualType(i));
  o.erpRevenueLineItemSourceEvent = (options.erpRevenueLineItemSourceEvent ?? []).map((i) =>
    enumOrDetailOfErpRevenueLineItemSourceEvent(i)
  );
  o.erpTransactionGroupEvent = (options.erpTransactionGroupEvent ?? []).map((i) =>
    enumOrDetailOfErpTransactionGroupEvent(i)
  );
  o.erpTransactionGroupStatus = (options.erpTransactionGroupStatus ?? []).map((i) =>
    enumOrDetailOfErpTransactionGroupStatus(i)
  );
  o.erpTransactionStatus = (options.erpTransactionStatus ?? []).map((i) => enumOrDetailOfErpTransactionStatus(i));
  o.estimateStatus = (options.estimateStatus ?? []).map((i) => enumOrDetailOfEstimateStatus(i));
  o.estimateType = (options.estimateType ?? []).map((i) => enumOrDetailOfEstimateType(i));
  o.featureFlagStatus = (options.featureFlagStatus ?? []).map((i) => enumOrDetailOfFeatureFlagStatus(i));
  o.featureFlagType = (options.featureFlagType ?? []).map((i) => enumOrDetailOfFeatureFlagType(i));
  o.finishScheduleColumnType = (options.finishScheduleColumnType ?? []).map((i) =>
    enumOrDetailOfFinishScheduleColumnType(i)
  );
  o.finishScheduleCoreColumn = (options.finishScheduleCoreColumn ?? []).map((i) =>
    enumOrDetailOfFinishScheduleCoreColumn(i)
  );
  o.floodPlain = (options.floodPlain ?? []).map((i) => enumOrDetailOfFloodPlain(i));
  o.floodZone = (options.floodZone ?? []).map((i) => enumOrDetailOfFloodZone(i));
  o.foundationType = (options.foundationType ?? []).map((i) => enumOrDetailOfFoundationType(i));
  o.globalOptionStatus = (options.globalOptionStatus ?? []).map((i) => enumOrDetailOfGlobalOptionStatus(i));
  o.globalOptionTypeStatus = (options.globalOptionTypeStatus ?? []).map((i) => enumOrDetailOfGlobalOptionTypeStatus(i));
  o.globalPlanMilestoneType = (options.globalPlanMilestoneType ?? []).map((i) =>
    enumOrDetailOfGlobalPlanMilestoneType(i)
  );
  o.inboxItemStatus = (options.inboxItemStatus ?? []).map((i) => enumOrDetailOfInboxItemStatus(i));
  o.internalEstimateType = (options.internalEstimateType ?? []).map((i) => enumOrDetailOfInternalEstimateType(i));
  o.invoiceDocumentSource = (options.invoiceDocumentSource ?? []).map((i) => enumOrDetailOfInvoiceDocumentSource(i));
  o.invoiceScheduleAmountType = (options.invoiceScheduleAmountType ?? []).map((i) =>
    enumOrDetailOfInvoiceScheduleAmountType(i)
  );
  o.invoiceScheduleItemFrequency = (options.invoiceScheduleItemFrequency ?? []).map((i) =>
    enumOrDetailOfInvoiceScheduleItemFrequency(i)
  );
  o.invoiceScheduleTriggerType = (options.invoiceScheduleTriggerType ?? []).map((i) =>
    enumOrDetailOfInvoiceScheduleTriggerType(i)
  );
  o.invoiceSource = (options.invoiceSource ?? []).map((i) => enumOrDetailOfInvoiceSource(i));
  o.invoiceStatus = (options.invoiceStatus ?? []).map((i) => enumOrDetailOfInvoiceStatus(i));
  o.invoiceType = (options.invoiceType ?? []).map((i) => enumOrDetailOfInvoiceType(i));
  o.itemStatus = (options.itemStatus ?? []).map((i) => enumOrDetailOfItemStatus(i));
  o.itemTemplateItemCostStatus = (options.itemTemplateItemCostStatus ?? []).map((i) =>
    enumOrDetailOfItemTemplateItemCostStatus(i)
  );
  o.itemTemplateStatus = (options.itemTemplateStatus ?? []).map((i) => enumOrDetailOfItemTemplateStatus(i));
  o.jobLogFlag = (options.jobLogFlag ?? []).map((i) => enumOrDetailOfJobLogFlag(i));
  o.jobLogNoteType = (options.jobLogNoteType ?? []).map((i) => enumOrDetailOfJobLogNoteType(i));
  o.lienWaiverCondition = (options.lienWaiverCondition ?? []).map((i) => enumOrDetailOfLienWaiverCondition(i));
  o.lienWaiverStatus = (options.lienWaiverStatus ?? []).map((i) => enumOrDetailOfLienWaiverStatus(i));
  o.lienWaiverType = (options.lienWaiverType ?? []).map((i) => enumOrDetailOfLienWaiverType(i));
  o.locationType = (options.locationType ?? []).map((i) => enumOrDetailOfLocationType(i));
  o.lotSalesStatus = (options.lotSalesStatus ?? []).map((i) => enumOrDetailOfLotSalesStatus(i));
  o.lotType = (options.lotType ?? []).map((i) => enumOrDetailOfLotType(i));
  o.markupApplicationMethod = (options.markupApplicationMethod ?? []).map((i) =>
    enumOrDetailOfMarkupApplicationMethod(i)
  );
  o.materialAttributeDimensionType = (options.materialAttributeDimensionType ?? []).map((i) =>
    enumOrDetailOfMaterialAttributeDimensionType(i)
  );
  o.materialAttributeValueType = (options.materialAttributeValueType ?? []).map((i) =>
    enumOrDetailOfMaterialAttributeValueType(i)
  );
  o.materialType = (options.materialType ?? []).map((i) => enumOrDetailOfMaterialType(i));
  o.mobileSyncUpdateType = (options.mobileSyncUpdateType ?? []).map((i) => enumOrDetailOfMobileSyncUpdateType(i));
  o.pandaDocRole = (options.pandaDocRole ?? []).map((i) => enumOrDetailOfPandaDocRole(i));
  o.pandaDocStatus = (options.pandaDocStatus ?? []).map((i) => enumOrDetailOfPandaDocStatus(i));
  o.pandaDocWorkspace = (options.pandaDocWorkspace ?? []).map((i) => enumOrDetailOfPandaDocWorkspace(i));
  o.paymentTermDueFrom = (options.paymentTermDueFrom ?? []).map((i) => enumOrDetailOfPaymentTermDueFrom(i));
  o.permit = (options.permit ?? []).map((i) => enumOrDetailOfPermit(i));
  o.planPackageIncomingSlotStatus = (options.planPackageIncomingSlotStatus ?? []).map((i) =>
    enumOrDetailOfPlanPackageIncomingSlotStatus(i)
  );
  o.programDataBasementConfig = (options.programDataBasementConfig ?? []).map((i) =>
    enumOrDetailOfProgramDataBasementConfig(i)
  );
  o.programDataGarageConfig = (options.programDataGarageConfig ?? []).map((i) =>
    enumOrDetailOfProgramDataGarageConfig(i)
  );
  o.programDataMatchState = (options.programDataMatchState ?? []).map((i) => enumOrDetailOfProgramDataMatchState(i));
  o.programDataPrimaryBedroomConfig = (options.programDataPrimaryBedroomConfig ?? []).map((i) =>
    enumOrDetailOfProgramDataPrimaryBedroomConfig(i)
  );
  o.programDataWindowColor = (options.programDataWindowColor ?? []).map((i) => enumOrDetailOfProgramDataWindowColor(i));
  o.projectCollaboratorRole = (options.projectCollaboratorRole ?? []).map((i) =>
    enumOrDetailOfProjectCollaboratorRole(i)
  );
  o.projectFeature = (options.projectFeature ?? []).map((i) => enumOrDetailOfProjectFeature(i));
  o.projectReadyPlanConfigOrientation = (options.projectReadyPlanConfigOrientation ?? []).map((i) =>
    enumOrDetailOfProjectReadyPlanConfigOrientation(i)
  );
  o.projectRole = (options.projectRole ?? []).map((i) => enumOrDetailOfProjectRole(i));
  o.projectStageStatus = (options.projectStageStatus ?? []).map((i) => enumOrDetailOfProjectStageStatus(i));
  o.projectStatus = (options.projectStatus ?? []).map((i) => enumOrDetailOfProjectStatus(i));
  o.projectUpdateActionType = (options.projectUpdateActionType ?? []).map((i) =>
    enumOrDetailOfProjectUpdateActionType(i)
  );
  o.pushNotificationEnvironment = (options.pushNotificationEnvironment ?? []).map((i) =>
    enumOrDetailOfPushNotificationEnvironment(i)
  );
  o.pushNotificationPlatform = (options.pushNotificationPlatform ?? []).map((i) =>
    enumOrDetailOfPushNotificationPlatform(i)
  );
  o.readyPlanAssetType = (options.readyPlanAssetType ?? []).map((i) => enumOrDetailOfReadyPlanAssetType(i));
  o.readyPlanOptionGroupPersonalizationType = (options.readyPlanOptionGroupPersonalizationType ?? []).map((i) =>
    enumOrDetailOfReadyPlanOptionGroupPersonalizationType(i)
  );
  o.readyPlanStatus = (options.readyPlanStatus ?? []).map((i) => enumOrDetailOfReadyPlanStatus(i));
  o.readyPlanType = (options.readyPlanType ?? []).map((i) => enumOrDetailOfReadyPlanType(i));
  o.scheduleFlagReasonType = (options.scheduleFlagReasonType ?? []).map((i) => enumOrDetailOfScheduleFlagReasonType(i));
  o.scheduleStatus = (options.scheduleStatus ?? []).map((i) => enumOrDetailOfScheduleStatus(i));
  o.scheduleTemplateStatus = (options.scheduleTemplateStatus ?? []).map((i) => enumOrDetailOfScheduleTemplateStatus(i));
  o.scopeChangeType = (options.scopeChangeType ?? []).map((i) => enumOrDetailOfScopeChangeType(i));
  o.scopeMode = (options.scopeMode ?? []).map((i) => enumOrDetailOfScopeMode(i));
  o.selectionCutoff = (options.selectionCutoff ?? []).map((i) => enumOrDetailOfSelectionCutoff(i));
  o.stage = (options.stage ?? []).map((i) => enumOrDetailOfStage(i));
  o.suburbanAssetCategory = (options.suburbanAssetCategory ?? []).map((i) => enumOrDetailOfSuburbanAssetCategory(i));
  o.systemChangeRequestAsset = (options.systemChangeRequestAsset ?? []).map((i) =>
    enumOrDetailOfSystemChangeRequestAsset(i)
  );
  o.systemPlanMilestone = (options.systemPlanMilestone ?? []).map((i) => enumOrDetailOfSystemPlanMilestone(i));
  o.systemTask = (options.systemTask ?? []).map((i) => enumOrDetailOfSystemTask(i));
  o.takeoffLineItemAction = (options.takeoffLineItemAction ?? []).map((i) => enumOrDetailOfTakeoffLineItemAction(i));
  o.takeoffLineItemDesignPackageType = (options.takeoffLineItemDesignPackageType ?? []).map((i) =>
    enumOrDetailOfTakeoffLineItemDesignPackageType(i)
  );
  o.takeoffLineItemType = (options.takeoffLineItemType ?? []).map((i) => enumOrDetailOfTakeoffLineItemType(i));
  o.taskDeadlineType = (options.taskDeadlineType ?? []).map((i) => enumOrDetailOfTaskDeadlineType(i));
  o.taskDependencyType = (options.taskDependencyType ?? []).map((i) => enumOrDetailOfTaskDependencyType(i));
  o.taskStatus = (options.taskStatus ?? []).map((i) => enumOrDetailOfTaskStatus(i));
  o.taskType = (options.taskType ?? []).map((i) => enumOrDetailOfTaskType(i));
  o.timeFrequency = (options.timeFrequency ?? []).map((i) => enumOrDetailOfTimeFrequency(i));
  o.timeOfDay = (options.timeOfDay ?? []).map((i) => enumOrDetailOfTimeOfDay(i));
  o.toDoStatus = (options.toDoStatus ?? []).map((i) => enumOrDetailOfToDoStatus(i));
  o.toDoType = (options.toDoType ?? []).map((i) => enumOrDetailOfToDoType(i));
  o.trackedJobStatus = (options.trackedJobStatus ?? []).map((i) => enumOrDetailOfTrackedJobStatus(i));
  o.tradePartnerAvailabilityRequestStatus = (options.tradePartnerAvailabilityRequestStatus ?? []).map((i) =>
    enumOrDetailOfTradePartnerAvailabilityRequestStatus(i)
  );
  o.tradePartnerMarketRole = (options.tradePartnerMarketRole ?? []).map((i) => enumOrDetailOfTradePartnerMarketRole(i));
  o.tradePartnerOnboardingStatus = (options.tradePartnerOnboardingStatus ?? []).map((i) =>
    enumOrDetailOfTradePartnerOnboardingStatus(i)
  );
  o.tradePartnerRequirementStatus = (options.tradePartnerRequirementStatus ?? []).map((i) =>
    enumOrDetailOfTradePartnerRequirementStatus(i)
  );
  o.tradePartnerRequirementType = (options.tradePartnerRequirementType ?? []).map((i) =>
    enumOrDetailOfTradePartnerRequirementType(i)
  );
  o.tradePartnerTaskStatus = (options.tradePartnerTaskStatus ?? []).map((i) => enumOrDetailOfTradePartnerTaskStatus(i));
  o.userEventType = (options.userEventType ?? []).map((i) => enumOrDetailOfUserEventType(i));
  o.userType = (options.userType ?? []).map((i) => enumOrDetailOfUserType(i));
  o.verificationMethod = (options.verificationMethod ?? []).map((i) => enumOrDetailOfVerificationMethod(i));
  o.warrantyTicketItemStatus = (options.warrantyTicketItemStatus ?? []).map((i) =>
    enumOrDetailOfWarrantyTicketItemStatus(i)
  );
  o.warrantyTicketItemType = (options.warrantyTicketItemType ?? []).map((i) => enumOrDetailOfWarrantyTicketItemType(i));
  o.warrantyTicketStatus = (options.warrantyTicketStatus ?? []).map((i) => enumOrDetailOfWarrantyTicketStatus(i));
  o.warrantyTicketType = (options.warrantyTicketType ?? []).map((i) => enumOrDetailOfWarrantyTicketType(i));
  o.warrantyTrueUpType = (options.warrantyTrueUpType ?? []).map((i) => enumOrDetailOfWarrantyTrueUpType(i));
  o.weatherType = (options.weatherType ?? []).map((i) => enumOrDetailOfWeatherType(i));
  return o;
}

factories["AllEnumDetails"] = newAllEnumDetails;

export interface IdentifyProjectAccrualAdjustmentsResultOptions {
  __typename?: "IdentifyProjectAccrualAdjustmentsResult";
  type?: IdentifyProjectAccrualAdjustmentsResult["type"];
  commitmentLineItem?: CommitmentLineItem | CommitmentLineItemOptions;
  commitmentLikeReference?: IdentifyProjectAccrualAdjustmentsResult["commitmentLikeReference"];
  adjustInCents?: IdentifyProjectAccrualAdjustmentsResult["adjustInCents"];
  intacctVendorId?: IdentifyProjectAccrualAdjustmentsResult["intacctVendorId"];
  intacctGLAccountNo?: IdentifyProjectAccrualAdjustmentsResult["intacctGLAccountNo"];
  intacctProjectId?: IdentifyProjectAccrualAdjustmentsResult["intacctProjectId"];
  intacctItemId?: IdentifyProjectAccrualAdjustmentsResult["intacctItemId"];
  intacctCustomerId?: IdentifyProjectAccrualAdjustmentsResult["intacctCustomerId"];
  intacctLocationId?: IdentifyProjectAccrualAdjustmentsResult["intacctLocationId"];
}

export function newIdentifyProjectAccrualAdjustmentsResult(
  options: IdentifyProjectAccrualAdjustmentsResultOptions = {},
  cache: Record<string, any> = {},
): IdentifyProjectAccrualAdjustmentsResult {
  const o =
    (options.__typename
      ? options
      : cache["IdentifyProjectAccrualAdjustmentsResult"] = {}) as IdentifyProjectAccrualAdjustmentsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "IdentifyProjectAccrualAdjustmentsResult";
  o.type = options.type ?? CostAccrualAdjustmentType.TaskWithOverbilled;
  o.commitmentLineItem = maybeNew(
    "CommitmentLineItem",
    options.commitmentLineItem,
    cache,
    options.hasOwnProperty("commitmentLineItem"),
  );
  o.commitmentLikeReference = options.commitmentLikeReference ?? "commitmentLikeReference";
  o.adjustInCents = options.adjustInCents ?? 0;
  o.intacctVendorId = options.intacctVendorId ?? "intacctVendorId";
  o.intacctGLAccountNo = options.intacctGLAccountNo ?? "intacctGLAccountNo";
  o.intacctProjectId = options.intacctProjectId ?? "intacctProjectId";
  o.intacctItemId = options.intacctItemId ?? "intacctItemId";
  o.intacctCustomerId = options.intacctCustomerId ?? "intacctCustomerId";
  o.intacctLocationId = options.intacctLocationId ?? "intacctLocationId";
  return o;
}

factories["IdentifyProjectAccrualAdjustmentsResult"] = newIdentifyProjectAccrualAdjustmentsResult;

export interface SaveEstimateResultOptions {
  __typename?: "SaveEstimateResult";
  estimate?: Estimate | EstimateOptions;
}

export function newSaveEstimateResult(
  options: SaveEstimateResultOptions = {},
  cache: Record<string, any> = {},
): SaveEstimateResult {
  const o = (options.__typename ? options : cache["SaveEstimateResult"] = {}) as SaveEstimateResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveEstimateResult";
  o.estimate = maybeNew("Estimate", options.estimate, cache, options.hasOwnProperty("estimate"));
  return o;
}

factories["SaveEstimateResult"] = newSaveEstimateResult;

export interface AnnotatedCostOptions {
  __typename?: "AnnotatedCost";
  item?: Item | ItemOptions;
  totalPriceInCents?: AnnotatedCost["totalPriceInCents"];
}

export function newAnnotatedCost(options: AnnotatedCostOptions = {}, cache: Record<string, any> = {}): AnnotatedCost {
  const o = (options.__typename ? options : cache["AnnotatedCost"] = {}) as AnnotatedCost;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AnnotatedCost";
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  return o;
}

factories["AnnotatedCost"] = newAnnotatedCost;

export interface EstimateLineItemOptions {
  __typename?: "EstimateLineItem";
  id?: EstimateLineItem["id"];
  quantity?: EstimateLineItem["quantity"];
  estimate?: Estimate | EstimateOptions;
  projectItem?: ProjectItem | ProjectItemOptions;
  projectItemHasDiverged?: EstimateLineItem["projectItemHasDiverged"];
  isPlaceholder?: EstimateLineItem["isPlaceholder"];
  unitCostInCents?: EstimateLineItem["unitCostInCents"];
  unitPriceInCents?: EstimateLineItem["unitPriceInCents"];
  totalCostInCents?: EstimateLineItem["totalCostInCents"];
  totalPriceInCents?: EstimateLineItem["totalPriceInCents"];
  changeEventLineItem?: ChangeEventLineItem | ChangeEventLineItemOptions | null;
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  displayName?: EstimateLineItem["displayName"];
}

export function newEstimateLineItem(
  options: EstimateLineItemOptions = {},
  cache: Record<string, any> = {},
): EstimateLineItem {
  const o = (options.__typename ? options : cache["EstimateLineItem"] = {}) as EstimateLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EstimateLineItem";
  o.id = options.id ?? nextFactoryId("EstimateLineItem");
  o.quantity = options.quantity ?? null;
  o.estimate = maybeNew("Estimate", options.estimate, cache, options.hasOwnProperty("estimate"));
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.projectItemHasDiverged = options.projectItemHasDiverged ?? false;
  o.isPlaceholder = options.isPlaceholder ?? false;
  o.unitCostInCents = options.unitCostInCents ?? 0;
  o.unitPriceInCents = options.unitPriceInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.changeEventLineItem = maybeNewOrNull("ChangeEventLineItem", options.changeEventLineItem, cache);
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.displayName = options.displayName ?? "displayName";
  return o;
}

factories["EstimateLineItem"] = newEstimateLineItem;

export interface ExpenseOptions {
  __typename?: "Expense";
  id?: Expense["id"];
  amountInCents?: Expense["amountInCents"];
  unallocatedAmountInCents?: Expense["unallocatedAmountInCents"];
  expenseDate?: Expense["expenseDate"];
  dueDate?: Expense["dueDate"];
  description?: Expense["description"];
  createdAt?: Expense["createdAt"];
  updatedAt?: Expense["updatedAt"];
  costCode?: CostCode | CostCodeOptions | null;
  intacctApBillId?: Expense["intacctApBillId"];
  intacctApBillLineId?: Expense["intacctApBillLineId"];
  intacctItemId?: Expense["intacctItemId"];
  intacctVendorName?: Expense["intacctVendorName"];
  intacctVendorBlueprintId?: Expense["intacctVendorBlueprintId"];
  amountPaidInCents?: Expense["amountPaidInCents"];
  stage?: StageDetailOptions | Stage;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  potentialProjectItems?: Array<ProjectItem | ProjectItemOptions>;
  intacctVendorId?: Expense["intacctVendorId"];
  document?: Document | DocumentOptions | null;
  allocations?: Array<ExpenseAllocation | ExpenseAllocationOptions>;
  changeEvents?: Array<ChangeEvent | ChangeEventOptions>;
  documents?: Array<Document | DocumentOptions>;
  tradeNumber?: Expense["tradeNumber"];
  allLineItemsAreExpenses?: Expense["allLineItemsAreExpenses"];
  canBeConvertedToBill?: PotentialOperation2 | PotentialOperation2Options;
  isBrex?: Expense["isBrex"];
}

export function newExpense(options: ExpenseOptions = {}, cache: Record<string, any> = {}): Expense {
  const o = (options.__typename ? options : cache["Expense"] = {}) as Expense;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Expense";
  o.id = options.id ?? nextFactoryId("Expense");
  o.amountInCents = options.amountInCents ?? 0;
  o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
  o.expenseDate = options.expenseDate ?? newDate();
  o.dueDate = options.dueDate ?? null;
  o.description = options.description ?? "description";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costCode = maybeNewOrNull("CostCode", options.costCode, cache);
  o.intacctApBillId = options.intacctApBillId ?? "intacctApBillId";
  o.intacctApBillLineId = options.intacctApBillLineId ?? "intacctApBillLineId";
  o.intacctItemId = options.intacctItemId ?? "intacctItemId";
  o.intacctVendorName = options.intacctVendorName ?? "intacctVendorName";
  o.intacctVendorBlueprintId = options.intacctVendorBlueprintId ?? null;
  o.amountPaidInCents = options.amountPaidInCents ?? 0;
  o.stage = enumOrDetailOfStage(options.stage);
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.potentialProjectItems = (options.potentialProjectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("potentialProjectItems"))
  );
  o.intacctVendorId = options.intacctVendorId ?? "intacctVendorId";
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.allocations = (options.allocations ?? []).map((i) =>
    maybeNew("ExpenseAllocation", i, cache, options.hasOwnProperty("allocations"))
  );
  o.changeEvents = (options.changeEvents ?? []).map((i) =>
    maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("changeEvents"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.tradeNumber = options.tradeNumber ?? null;
  o.allLineItemsAreExpenses = options.allLineItemsAreExpenses ?? false;
  o.canBeConvertedToBill = maybeNew(
    "PotentialOperation2",
    options.canBeConvertedToBill,
    cache,
    options.hasOwnProperty("canBeConvertedToBill"),
  );
  o.isBrex = options.isBrex ?? false;
  return o;
}

factories["Expense"] = newExpense;

export interface SaveExpensesResultOptions {
  __typename?: "SaveExpensesResult";
  expenses?: Array<Expense | ExpenseOptions>;
}

export function newSaveExpensesResult(
  options: SaveExpensesResultOptions = {},
  cache: Record<string, any> = {},
): SaveExpensesResult {
  const o = (options.__typename ? options : cache["SaveExpensesResult"] = {}) as SaveExpensesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveExpensesResult";
  o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
  return o;
}

factories["SaveExpensesResult"] = newSaveExpensesResult;

export interface ConvertExpenseToBillResultOptions {
  __typename?: "ConvertExpenseToBillResult";
  bill?: Bill | BillOptions;
}

export function newConvertExpenseToBillResult(
  options: ConvertExpenseToBillResultOptions = {},
  cache: Record<string, any> = {},
): ConvertExpenseToBillResult {
  const o = (options.__typename ? options : cache["ConvertExpenseToBillResult"] = {}) as ConvertExpenseToBillResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ConvertExpenseToBillResult";
  o.bill = maybeNew("Bill", options.bill, cache, options.hasOwnProperty("bill"));
  return o;
}

factories["ConvertExpenseToBillResult"] = newConvertExpenseToBillResult;

export interface ExpensesPageOptions {
  __typename?: "ExpensesPage";
  entities?: Array<Expense | ExpenseOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newExpensesPage(options: ExpensesPageOptions = {}, cache: Record<string, any> = {}): ExpensesPage {
  const o = (options.__typename ? options : cache["ExpensesPage"] = {}) as ExpensesPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ExpensesPage";
  o.entities = (options.entities ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ExpensesPage"] = newExpensesPage;

export interface ExpenseAllocationOptions {
  __typename?: "ExpenseAllocation";
  id?: ExpenseAllocation["id"];
  amountInCents?: ExpenseAllocation["amountInCents"];
  paidAmountInCents?: ExpenseAllocation["paidAmountInCents"];
  createdAt?: ExpenseAllocation["createdAt"];
  updatedAt?: ExpenseAllocation["updatedAt"];
  expense?: Expense | ExpenseOptions;
  projectItem?: ProjectItem | ProjectItemOptions;
  historicExpenseAmountInvoiced?: ExpenseAllocation["historicExpenseAmountInvoiced"];
  costLineItemAllocations?: Array<CostLineItemAllocation | CostLineItemAllocationOptions>;
  commitmentLineItem?: CommitmentLineItem | CommitmentLineItemOptions | null;
  invoiceAccruedLineItems?: Array<InvoiceAccruedLineItem | InvoiceAccruedLineItemOptions>;
  allocations?: Array<ExpenseAllocationAllocation | ExpenseAllocationAllocationOptions>;
}

export function newExpenseAllocation(
  options: ExpenseAllocationOptions = {},
  cache: Record<string, any> = {},
): ExpenseAllocation {
  const o = (options.__typename ? options : cache["ExpenseAllocation"] = {}) as ExpenseAllocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ExpenseAllocation";
  o.id = options.id ?? nextFactoryId("ExpenseAllocation");
  o.amountInCents = options.amountInCents ?? 0;
  o.paidAmountInCents = options.paidAmountInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.expense = maybeNew("Expense", options.expense, cache, options.hasOwnProperty("expense"));
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.historicExpenseAmountInvoiced = options.historicExpenseAmountInvoiced ?? null;
  o.costLineItemAllocations = (options.costLineItemAllocations ?? []).map((i) =>
    maybeNew("CostLineItemAllocation", i, cache, options.hasOwnProperty("costLineItemAllocations"))
  );
  o.commitmentLineItem = maybeNewOrNull("CommitmentLineItem", options.commitmentLineItem, cache);
  o.invoiceAccruedLineItems = (options.invoiceAccruedLineItems ?? []).map((i) =>
    maybeNew("InvoiceAccruedLineItem", i, cache, options.hasOwnProperty("invoiceAccruedLineItems"))
  );
  o.allocations = (options.allocations ?? []).map((i) =>
    maybeNew("ExpenseAllocationAllocation", i, cache, options.hasOwnProperty("allocations"))
  );
  return o;
}

factories["ExpenseAllocation"] = newExpenseAllocation;

export interface SaveExpenseAllocationsResultOptions {
  __typename?: "SaveExpenseAllocationsResult";
  expenseAllocations?: Array<ExpenseAllocation | ExpenseAllocationOptions>;
}

export function newSaveExpenseAllocationsResult(
  options: SaveExpenseAllocationsResultOptions = {},
  cache: Record<string, any> = {},
): SaveExpenseAllocationsResult {
  const o = (options.__typename ? options : cache["SaveExpenseAllocationsResult"] = {}) as SaveExpenseAllocationsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveExpenseAllocationsResult";
  o.expenseAllocations = (options.expenseAllocations ?? []).map((i) =>
    maybeNew("ExpenseAllocation", i, cache, options.hasOwnProperty("expenseAllocations"))
  );
  return o;
}

factories["SaveExpenseAllocationsResult"] = newSaveExpenseAllocationsResult;

export interface ExpenseAllocationAllocationOptions {
  __typename?: "ExpenseAllocationAllocation";
  id?: ExpenseAllocationAllocation["id"];
  costInCents?: ExpenseAllocationAllocation["costInCents"];
  createdAt?: ExpenseAllocationAllocation["createdAt"];
  updatedAt?: ExpenseAllocationAllocation["updatedAt"];
  expenseAllocation?: ExpenseAllocation | ExpenseAllocationOptions;
  projectItemAllocation?: ProjectItemAllocation | ProjectItemAllocationOptions;
}

export function newExpenseAllocationAllocation(
  options: ExpenseAllocationAllocationOptions = {},
  cache: Record<string, any> = {},
): ExpenseAllocationAllocation {
  const o = (options.__typename ? options : cache["ExpenseAllocationAllocation"] = {}) as ExpenseAllocationAllocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ExpenseAllocationAllocation";
  o.id = options.id ?? nextFactoryId("ExpenseAllocationAllocation");
  o.costInCents = options.costInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.expenseAllocation = maybeNew(
    "ExpenseAllocation",
    options.expenseAllocation,
    cache,
    options.hasOwnProperty("expenseAllocation"),
  );
  o.projectItemAllocation = maybeNew(
    "ProjectItemAllocation",
    options.projectItemAllocation,
    cache,
    options.hasOwnProperty("projectItemAllocation"),
  );
  return o;
}

factories["ExpenseAllocationAllocation"] = newExpenseAllocationAllocation;

export interface FeatureFlagOptions {
  __typename?: "FeatureFlag";
  id?: FeatureFlag["id"];
  type?: FeatureFlagTypeDetailOptions | FeatureFlagType;
  status?: FeatureFlagStatusDetailOptions | FeatureFlagStatus;
  targets?: Array<FeatureFlagTarget | FeatureFlagTargetOptions>;
  name?: FeatureFlag["name"];
  description?: FeatureFlag["description"];
  isPresentational?: FeatureFlag["isPresentational"];
  createdAt?: FeatureFlag["createdAt"];
  updatedAt?: FeatureFlag["updatedAt"];
  releaseVersion?: FeatureFlag["releaseVersion"];
}

export function newFeatureFlag(options: FeatureFlagOptions = {}, cache: Record<string, any> = {}): FeatureFlag {
  const o = (options.__typename ? options : cache["FeatureFlag"] = {}) as FeatureFlag;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FeatureFlag";
  o.id = options.id ?? nextFactoryId("FeatureFlag");
  o.type = enumOrDetailOfFeatureFlagType(options.type);
  o.status = enumOrDetailOfFeatureFlagStatus(options.status);
  o.targets = (options.targets ?? []).map((i) =>
    maybeNew("FeatureFlagTarget", i, cache, options.hasOwnProperty("targets"))
  );
  o.name = options.name ?? "name";
  o.description = options.description ?? "description";
  o.isPresentational = options.isPresentational ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.releaseVersion = options.releaseVersion ?? 0;
  return o;
}

factories["FeatureFlag"] = newFeatureFlag;

export interface SaveFeatureFlagResultOptions {
  __typename?: "SaveFeatureFlagResult";
  featureFlag?: FeatureFlag | FeatureFlagOptions;
}

export function newSaveFeatureFlagResult(
  options: SaveFeatureFlagResultOptions = {},
  cache: Record<string, any> = {},
): SaveFeatureFlagResult {
  const o = (options.__typename ? options : cache["SaveFeatureFlagResult"] = {}) as SaveFeatureFlagResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveFeatureFlagResult";
  o.featureFlag = maybeNew("FeatureFlag", options.featureFlag, cache, options.hasOwnProperty("featureFlag"));
  return o;
}

factories["SaveFeatureFlagResult"] = newSaveFeatureFlagResult;

export interface FeatureFlagTargetOptions {
  __typename?: "FeatureFlagTarget";
  id?: FeatureFlagTarget["id"];
  createdAt?: FeatureFlagTarget["createdAt"];
  updatedAt?: FeatureFlagTarget["updatedAt"];
  featureFlag?: FeatureFlag | FeatureFlagOptions;
  target?:
    | FeatureFlagTargetTarget
    | DevelopmentOptions
    | RequireTypename<StandaloneProjectOptions>
    | RequireTypename<RegionOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<UserOptions>
    | RequireTypename<UserGroupOptions>
    | null;
}

export function newFeatureFlagTarget(
  options: FeatureFlagTargetOptions = {},
  cache: Record<string, any> = {},
): FeatureFlagTarget {
  const o = (options.__typename ? options : cache["FeatureFlagTarget"] = {}) as FeatureFlagTarget;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FeatureFlagTarget";
  o.id = options.id ?? nextFactoryId("FeatureFlagTarget");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.featureFlag = maybeNew("FeatureFlag", options.featureFlag, cache, options.hasOwnProperty("featureFlag"));
  o.target = maybeNewOrNull(options.target?.__typename ?? "Development", options.target, cache);
  return o;
}

factories["FeatureFlagTarget"] = newFeatureFlagTarget;

export interface SaveFeatureFlagTargetResultOptions {
  __typename?: "SaveFeatureFlagTargetResult";
  featureFlagTarget?: FeatureFlagTarget | FeatureFlagTargetOptions;
}

export function newSaveFeatureFlagTargetResult(
  options: SaveFeatureFlagTargetResultOptions = {},
  cache: Record<string, any> = {},
): SaveFeatureFlagTargetResult {
  const o = (options.__typename ? options : cache["SaveFeatureFlagTargetResult"] = {}) as SaveFeatureFlagTargetResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveFeatureFlagTargetResult";
  o.featureFlagTarget = maybeNew(
    "FeatureFlagTarget",
    options.featureFlagTarget,
    cache,
    options.hasOwnProperty("featureFlagTarget"),
  );
  return o;
}

factories["SaveFeatureFlagTargetResult"] = newSaveFeatureFlagTargetResult;

export interface FeatureTypeOptions {
  __typename?: "FeatureType";
  id?: FeatureType["id"];
  name?: FeatureType["name"];
  allowedInBuilding?: FeatureType["allowedInBuilding"];
  allowedInLevel?: FeatureType["allowedInLevel"];
  createdAt?: FeatureType["createdAt"];
  updatedAt?: FeatureType["updatedAt"];
  parent?: FeatureType | FeatureTypeOptions | null;
  children?: Array<FeatureType | FeatureTypeOptions>;
  roomTypes?: Array<RoomType | RoomTypeOptions>;
}

export function newFeatureType(options: FeatureTypeOptions = {}, cache: Record<string, any> = {}): FeatureType {
  const o = (options.__typename ? options : cache["FeatureType"] = {}) as FeatureType;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FeatureType";
  o.id = options.id ?? nextFactoryId("FeatureType");
  o.name = options.name ?? "name";
  o.allowedInBuilding = options.allowedInBuilding ?? false;
  o.allowedInLevel = options.allowedInLevel ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.parent = maybeNewOrNull("FeatureType", options.parent, cache);
  o.children = (options.children ?? []).map((i) =>
    maybeNew("FeatureType", i, cache, options.hasOwnProperty("children"))
  );
  o.roomTypes = (options.roomTypes ?? []).map((i) =>
    maybeNew("RoomType", i, cache, options.hasOwnProperty("roomTypes"))
  );
  return o;
}

factories["FeatureType"] = newFeatureType;

export interface SaveFeatureTypeResultOptions {
  __typename?: "SaveFeatureTypeResult";
  featureType?: FeatureType | FeatureTypeOptions;
}

export function newSaveFeatureTypeResult(
  options: SaveFeatureTypeResultOptions = {},
  cache: Record<string, any> = {},
): SaveFeatureTypeResult {
  const o = (options.__typename ? options : cache["SaveFeatureTypeResult"] = {}) as SaveFeatureTypeResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveFeatureTypeResult";
  o.featureType = maybeNew("FeatureType", options.featureType, cache, options.hasOwnProperty("featureType"));
  return o;
}

factories["SaveFeatureTypeResult"] = newSaveFeatureTypeResult;

export interface FinishScheduleConfigOptions {
  __typename?: "FinishScheduleConfig";
  id?: FinishScheduleConfig["id"];
  sortOrder?: FinishScheduleConfig["sortOrder"];
  shown?: FinishScheduleConfig["shown"];
  useInVisualMode?: FinishScheduleConfig["useInVisualMode"];
  createdAt?: FinishScheduleConfig["createdAt"];
  updatedAt?: FinishScheduleConfig["updatedAt"];
  type?: FinishScheduleColumnTypeDetailOptions | FinishScheduleColumnType;
  costCode?: CostCode | CostCodeOptions;
  coreColumn?: FinishScheduleCoreColumnDetailOptions | FinishScheduleCoreColumn | null;
  sourceAttribute?: FinishScheduleConfig["sourceAttribute"];
  label?: FinishScheduleConfig["label"];
  designPackageLocation?: DesignPackageLocationDetailOptions | DesignPackageLocation;
}

export function newFinishScheduleConfig(
  options: FinishScheduleConfigOptions = {},
  cache: Record<string, any> = {},
): FinishScheduleConfig {
  const o = (options.__typename ? options : cache["FinishScheduleConfig"] = {}) as FinishScheduleConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FinishScheduleConfig";
  o.id = options.id ?? nextFactoryId("FinishScheduleConfig");
  o.sortOrder = options.sortOrder ?? 0;
  o.shown = options.shown ?? false;
  o.useInVisualMode = options.useInVisualMode ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.type = enumOrDetailOfFinishScheduleColumnType(options.type);
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.coreColumn = enumOrDetailOrNullOfFinishScheduleCoreColumn(options.coreColumn);
  o.sourceAttribute = options.sourceAttribute ?? null;
  o.label = options.label ?? null;
  o.designPackageLocation = enumOrDetailOfDesignPackageLocation(options.designPackageLocation);
  return o;
}

factories["FinishScheduleConfig"] = newFinishScheduleConfig;

export interface FollowSequenceSheetResultOptions {
  __typename?: "FollowSequenceSheetResult";
  developments?: Array<Development | DevelopmentOptions>;
  internalUsers?: Array<InternalUser | InternalUserOptions>;
}

export function newFollowSequenceSheetResult(
  options: FollowSequenceSheetResultOptions = {},
  cache: Record<string, any> = {},
): FollowSequenceSheetResult {
  const o = (options.__typename ? options : cache["FollowSequenceSheetResult"] = {}) as FollowSequenceSheetResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FollowSequenceSheetResult";
  o.developments = (options.developments ?? []).map((i) =>
    maybeNew("Development", i, cache, options.hasOwnProperty("developments"))
  );
  o.internalUsers = (options.internalUsers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("internalUsers"))
  );
  return o;
}

factories["FollowSequenceSheetResult"] = newFollowSequenceSheetResult;

export interface SaveFollowersResultOptions {
  __typename?: "SaveFollowersResult";
  emptyResult?: SaveFollowersResult["emptyResult"];
  commentable?:
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Commentable
    | CommentableOptions;
  followable?:
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Followable
    | FollowableOptions;
}

export function newSaveFollowersResult(
  options: SaveFollowersResultOptions = {},
  cache: Record<string, any> = {},
): SaveFollowersResult {
  const o = (options.__typename ? options : cache["SaveFollowersResult"] = {}) as SaveFollowersResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveFollowersResult";
  o.emptyResult = options.emptyResult ?? null;
  o.commentable = maybeNew("Commentable", options.commentable, cache, options.hasOwnProperty("commentable"));
  o.followable = maybeNew("Followable", options.followable, cache, options.hasOwnProperty("followable"));
  return o;
}

factories["SaveFollowersResult"] = newSaveFollowersResult;

export interface SaveGlobalOptionsResultOptions {
  __typename?: "SaveGlobalOptionsResult";
  globalOptions?: Array<GlobalOption | GlobalOptionOptions>;
}

export function newSaveGlobalOptionsResult(
  options: SaveGlobalOptionsResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalOptionsResult {
  const o = (options.__typename ? options : cache["SaveGlobalOptionsResult"] = {}) as SaveGlobalOptionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalOptionsResult";
  o.globalOptions = (options.globalOptions ?? []).map((i) =>
    maybeNew("GlobalOption", i, cache, options.hasOwnProperty("globalOptions"))
  );
  return o;
}

factories["SaveGlobalOptionsResult"] = newSaveGlobalOptionsResult;

export interface GlobalOptionGroupOptions {
  __typename?: "GlobalOptionGroup";
  id?: GlobalOptionGroup["id"];
  name?: GlobalOptionGroup["name"];
  createdAt?: GlobalOptionGroup["createdAt"];
  updatedAt?: GlobalOptionGroup["updatedAt"];
  globalOptions?: Array<GlobalOption | GlobalOptionOptions>;
  type?: GlobalOptionType | GlobalOptionTypeOptions;
  isSingleOptionGroup?: GlobalOptionGroup["isSingleOptionGroup"];
  isMultiOptionGroup?: GlobalOptionGroup["isMultiOptionGroup"];
  salesforceFieldName?: GlobalOptionGroup["salesforceFieldName"];
  forDesignPackage?: GlobalOptionGroup["forDesignPackage"];
  forDesignInterior?: GlobalOptionGroup["forDesignInterior"];
  forDesignUpgrade?: GlobalOptionGroup["forDesignUpgrade"];
  forExteriors?: GlobalOptionGroup["forExteriors"];
  forDesignExterior?: GlobalOptionGroup["forDesignExterior"];
  forDesignPackages?: GlobalOptionGroup["forDesignPackages"];
  defaultRequired?: GlobalOptionGroup["defaultRequired"];
  designPackageTagColor?: GlobalOptionGroup["designPackageTagColor"];
  version?: GlobalOptionGroup["version"];
  canEditType?: PotentialOperation2 | PotentialOperation2Options;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions | null;
}

export function newGlobalOptionGroup(
  options: GlobalOptionGroupOptions = {},
  cache: Record<string, any> = {},
): GlobalOptionGroup {
  const o = (options.__typename ? options : cache["GlobalOptionGroup"] = {}) as GlobalOptionGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalOptionGroup";
  o.id = options.id ?? nextFactoryId("GlobalOptionGroup");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.globalOptions = (options.globalOptions ?? []).map((i) =>
    maybeNew("GlobalOption", i, cache, options.hasOwnProperty("globalOptions"))
  );
  o.type = maybeNew("GlobalOptionType", options.type, cache, options.hasOwnProperty("type"));
  o.isSingleOptionGroup = options.isSingleOptionGroup ?? false;
  o.isMultiOptionGroup = options.isMultiOptionGroup ?? false;
  o.salesforceFieldName = options.salesforceFieldName ?? null;
  o.forDesignPackage = options.forDesignPackage ?? false;
  o.forDesignInterior = options.forDesignInterior ?? false;
  o.forDesignUpgrade = options.forDesignUpgrade ?? false;
  o.forExteriors = options.forExteriors ?? false;
  o.forDesignExterior = options.forDesignExterior ?? false;
  o.forDesignPackages = options.forDesignPackages ?? false;
  o.defaultRequired = options.defaultRequired ?? false;
  o.designPackageTagColor = options.designPackageTagColor ?? null;
  o.version = options.version ?? 0;
  o.canEditType = maybeNew("PotentialOperation2", options.canEditType, cache, options.hasOwnProperty("canEditType"));
  o.readyPlan = maybeNewOrNull("ReadyPlanLike", options.readyPlan, cache);
  return o;
}

factories["GlobalOptionGroup"] = newGlobalOptionGroup;

export interface SaveGlobalOptionGroupResultOptions {
  __typename?: "SaveGlobalOptionGroupResult";
  entity?: GlobalOptionGroup | GlobalOptionGroupOptions;
}

export function newSaveGlobalOptionGroupResult(
  options: SaveGlobalOptionGroupResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalOptionGroupResult {
  const o = (options.__typename ? options : cache["SaveGlobalOptionGroupResult"] = {}) as SaveGlobalOptionGroupResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalOptionGroupResult";
  o.entity = maybeNew("GlobalOptionGroup", options.entity, cache, options.hasOwnProperty("entity"));
  return o;
}

factories["SaveGlobalOptionGroupResult"] = newSaveGlobalOptionGroupResult;

export interface GlobalOptionTagOptions {
  __typename?: "GlobalOptionTag";
  id?: GlobalOptionTag["id"];
  name?: GlobalOptionTag["name"];
  globalOptions?: Array<GlobalOption | GlobalOptionOptions>;
  globalOptionTypes?: Array<GlobalOptionType | GlobalOptionTypeOptions>;
}

export function newGlobalOptionTag(
  options: GlobalOptionTagOptions = {},
  cache: Record<string, any> = {},
): GlobalOptionTag {
  const o = (options.__typename ? options : cache["GlobalOptionTag"] = {}) as GlobalOptionTag;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalOptionTag";
  o.id = options.id ?? nextFactoryId("GlobalOptionTag");
  o.name = options.name ?? "name";
  o.globalOptions = (options.globalOptions ?? []).map((i) =>
    maybeNew("GlobalOption", i, cache, options.hasOwnProperty("globalOptions"))
  );
  o.globalOptionTypes = (options.globalOptionTypes ?? []).map((i) =>
    maybeNew("GlobalOptionType", i, cache, options.hasOwnProperty("globalOptionTypes"))
  );
  return o;
}

factories["GlobalOptionTag"] = newGlobalOptionTag;

export interface SaveGlobalOptionTagsResultOptions {
  __typename?: "SaveGlobalOptionTagsResult";
  globalOptionTags?: Array<GlobalOptionTag | GlobalOptionTagOptions>;
}

export function newSaveGlobalOptionTagsResult(
  options: SaveGlobalOptionTagsResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalOptionTagsResult {
  const o = (options.__typename ? options : cache["SaveGlobalOptionTagsResult"] = {}) as SaveGlobalOptionTagsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalOptionTagsResult";
  o.globalOptionTags = (options.globalOptionTags ?? []).map((i) =>
    maybeNew("GlobalOptionTag", i, cache, options.hasOwnProperty("globalOptionTags"))
  );
  return o;
}

factories["SaveGlobalOptionTagsResult"] = newSaveGlobalOptionTagsResult;

export interface GlobalOptionTypeOptions {
  __typename?: "GlobalOptionType";
  id?: GlobalOptionType["id"];
  name?: GlobalOptionType["name"];
  description?: GlobalOptionType["description"];
  changesProgramData?: GlobalOptionType["changesProgramData"];
  changesSpecsAndSelections?: GlobalOptionType["changesSpecsAndSelections"];
  status?: GlobalOptionType["status"];
  statusDetail?: GlobalOptionTypeStatusDetailOptions | GlobalOptionTypeStatus;
  isElevation?: GlobalOptionType["isElevation"];
  isExteriorPalette?: GlobalOptionType["isExteriorPalette"];
  isSpecLevel?: GlobalOptionType["isSpecLevel"];
  isInteriorScheme?: GlobalOptionType["isInteriorScheme"];
  isExteriorScheme?: GlobalOptionType["isExteriorScheme"];
  isPlanPackage?: GlobalOptionType["isPlanPackage"];
  isInterior?: GlobalOptionType["isInterior"];
  isFloorPlan?: GlobalOptionType["isFloorPlan"];
  tags?: Array<GlobalOptionTag | GlobalOptionTagOptions>;
  globalOptionsCount?: GlobalOptionType["globalOptionsCount"];
  allowsLocations?: GlobalOptionType["allowsLocations"];
  order?: GlobalOptionType["order"];
  forDesignInterior?: GlobalOptionType["forDesignInterior"];
  forDesignExterior?: GlobalOptionType["forDesignExterior"];
  forDesignUpgrade?: GlobalOptionType["forDesignUpgrade"];
  forDesignPackage?: GlobalOptionType["forDesignPackage"];
  forExteriors?: GlobalOptionType["forExteriors"];
  forPlanBasedBids?: GlobalOptionType["forPlanBasedBids"];
  globalOptions?: Array<GlobalOption | GlobalOptionOptions>;
  isAddOnV2?: GlobalOptionType["isAddOnV2"];
  isStructuralV2?: GlobalOptionType["isStructuralV2"];
  isCatalogV2?: GlobalOptionType["isCatalogV2"];
  isProductOptionV2?: GlobalOptionType["isProductOptionV2"];
  isPackageOptionV2?: GlobalOptionType["isPackageOptionV2"];
  version?: GlobalOptionType["version"];
}

export function newGlobalOptionType(
  options: GlobalOptionTypeOptions = {},
  cache: Record<string, any> = {},
): GlobalOptionType {
  const o = (options.__typename ? options : cache["GlobalOptionType"] = {}) as GlobalOptionType;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalOptionType";
  o.id = options.id ?? nextFactoryId("GlobalOptionType");
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.changesProgramData = options.changesProgramData ?? null;
  o.changesSpecsAndSelections = options.changesSpecsAndSelections ?? null;
  o.status = options.status ?? GlobalOptionTypeStatus.Active;
  o.statusDetail = enumOrDetailOfGlobalOptionTypeStatus(options.statusDetail);
  o.isElevation = options.isElevation ?? false;
  o.isExteriorPalette = options.isExteriorPalette ?? false;
  o.isSpecLevel = options.isSpecLevel ?? false;
  o.isInteriorScheme = options.isInteriorScheme ?? false;
  o.isExteriorScheme = options.isExteriorScheme ?? false;
  o.isPlanPackage = options.isPlanPackage ?? false;
  o.isInterior = options.isInterior ?? false;
  o.isFloorPlan = options.isFloorPlan ?? false;
  o.tags = (options.tags ?? []).map((i) => maybeNew("GlobalOptionTag", i, cache, options.hasOwnProperty("tags")));
  o.globalOptionsCount = options.globalOptionsCount ?? 0;
  o.allowsLocations = options.allowsLocations ?? false;
  o.order = options.order ?? 0;
  o.forDesignInterior = options.forDesignInterior ?? false;
  o.forDesignExterior = options.forDesignExterior ?? false;
  o.forDesignUpgrade = options.forDesignUpgrade ?? false;
  o.forDesignPackage = options.forDesignPackage ?? false;
  o.forExteriors = options.forExteriors ?? false;
  o.forPlanBasedBids = options.forPlanBasedBids ?? false;
  o.globalOptions = (options.globalOptions ?? []).map((i) =>
    maybeNew("GlobalOption", i, cache, options.hasOwnProperty("globalOptions"))
  );
  o.isAddOnV2 = options.isAddOnV2 ?? null;
  o.isStructuralV2 = options.isStructuralV2 ?? null;
  o.isCatalogV2 = options.isCatalogV2 ?? null;
  o.isProductOptionV2 = options.isProductOptionV2 ?? false;
  o.isPackageOptionV2 = options.isPackageOptionV2 ?? false;
  o.version = options.version ?? 0;
  return o;
}

factories["GlobalOptionType"] = newGlobalOptionType;

export interface SaveGlobalOptionTypesResultOptions {
  __typename?: "SaveGlobalOptionTypesResult";
  globalOptionTypes?: Array<GlobalOptionType | GlobalOptionTypeOptions>;
}

export function newSaveGlobalOptionTypesResult(
  options: SaveGlobalOptionTypesResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalOptionTypesResult {
  const o = (options.__typename ? options : cache["SaveGlobalOptionTypesResult"] = {}) as SaveGlobalOptionTypesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalOptionTypesResult";
  o.globalOptionTypes = (options.globalOptionTypes ?? []).map((i) =>
    maybeNew("GlobalOptionType", i, cache, options.hasOwnProperty("globalOptionTypes"))
  );
  return o;
}

factories["SaveGlobalOptionTypesResult"] = newSaveGlobalOptionTypesResult;

export interface GlobalPhaseOptions {
  __typename?: "GlobalPhase";
  id?: GlobalPhase["id"];
  active?: GlobalPhase["active"];
  cmsId?: GlobalPhase["cmsId"];
  name?: GlobalPhase["name"];
  stage?: GlobalPhase["stage"];
  stageDetail?: StageDetailOptions | Stage;
  displayOrder?: GlobalPhase["displayOrder"];
  globalSubPhases?: Array<GlobalSubPhase | GlobalSubPhaseOptions>;
  globalTasks?: Array<GlobalTask | GlobalTaskOptions>;
}

export function newGlobalPhase(options: GlobalPhaseOptions = {}, cache: Record<string, any> = {}): GlobalPhase {
  const o = (options.__typename ? options : cache["GlobalPhase"] = {}) as GlobalPhase;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPhase";
  o.id = options.id ?? nextFactoryId("GlobalPhase");
  o.active = options.active ?? false;
  o.cmsId = options.cmsId ?? null;
  o.name = options.name ?? "name";
  o.stage = options.stage ?? Stage.PreConPlanning;
  o.stageDetail = enumOrDetailOfStage(options.stageDetail);
  o.displayOrder = options.displayOrder ?? null;
  o.globalSubPhases = (options.globalSubPhases ?? []).map((i) =>
    maybeNew("GlobalSubPhase", i, cache, options.hasOwnProperty("globalSubPhases"))
  );
  o.globalTasks = (options.globalTasks ?? []).map((i) =>
    maybeNew("GlobalTask", i, cache, options.hasOwnProperty("globalTasks"))
  );
  return o;
}

factories["GlobalPhase"] = newGlobalPhase;

export interface SaveGlobalPhasesResultOptions {
  __typename?: "SaveGlobalPhasesResult";
  globalPhases?: Array<GlobalPhase | GlobalPhaseOptions>;
}

export function newSaveGlobalPhasesResult(
  options: SaveGlobalPhasesResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPhasesResult {
  const o = (options.__typename ? options : cache["SaveGlobalPhasesResult"] = {}) as SaveGlobalPhasesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPhasesResult";
  o.globalPhases = (options.globalPhases ?? []).map((i) =>
    maybeNew("GlobalPhase", i, cache, options.hasOwnProperty("globalPhases"))
  );
  return o;
}

factories["SaveGlobalPhasesResult"] = newSaveGlobalPhasesResult;

export interface GlobalPlanAllowanceOptions {
  __typename?: "GlobalPlanAllowance";
  id?: GlobalPlanAllowance["id"];
  createdAt?: GlobalPlanAllowance["createdAt"];
  updatedAt?: GlobalPlanAllowance["updatedAt"];
  constraintItem?: GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions;
  task?: GlobalPlanTask | GlobalPlanTaskOptions;
}

export function newGlobalPlanAllowance(
  options: GlobalPlanAllowanceOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanAllowance {
  const o = (options.__typename ? options : cache["GlobalPlanAllowance"] = {}) as GlobalPlanAllowance;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanAllowance";
  o.id = options.id ?? nextFactoryId("GlobalPlanAllowance");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.constraintItem = maybeNew(
    "GlobalPlanConstraintItem",
    options.constraintItem,
    cache,
    options.hasOwnProperty("constraintItem"),
  );
  o.task = maybeNew("GlobalPlanTask", options.task, cache, options.hasOwnProperty("task"));
  return o;
}

factories["GlobalPlanAllowance"] = newGlobalPlanAllowance;

export interface GlobalPlanConstraintOptions {
  __typename?: "GlobalPlanConstraint";
  id?: GlobalPlanConstraint["id"];
  createdAt?: GlobalPlanConstraint["createdAt"];
  updatedAt?: GlobalPlanConstraint["updatedAt"];
  task?: GlobalPlanTask | GlobalPlanTaskOptions;
  constraintItem?: GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions;
}

export function newGlobalPlanConstraint(
  options: GlobalPlanConstraintOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanConstraint {
  const o = (options.__typename ? options : cache["GlobalPlanConstraint"] = {}) as GlobalPlanConstraint;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanConstraint";
  o.id = options.id ?? nextFactoryId("GlobalPlanConstraint");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.task = maybeNew("GlobalPlanTask", options.task, cache, options.hasOwnProperty("task"));
  o.constraintItem = maybeNew(
    "GlobalPlanConstraintItem",
    options.constraintItem,
    cache,
    options.hasOwnProperty("constraintItem"),
  );
  return o;
}

factories["GlobalPlanConstraint"] = newGlobalPlanConstraint;

export interface GlobalPlanConstraintItemOptions {
  __typename?: "GlobalPlanConstraintItem";
  id?: GlobalPlanConstraintItem["id"];
  name?: GlobalPlanConstraintItem["name"];
  createdAt?: GlobalPlanConstraintItem["createdAt"];
  updatedAt?: GlobalPlanConstraintItem["updatedAt"];
  allowances?: Array<GlobalPlanAllowance | GlobalPlanAllowanceOptions>;
  constraints?: Array<GlobalPlanConstraint | GlobalPlanConstraintOptions>;
  numberOfTimesUsed?: GlobalPlanConstraintItem["numberOfTimesUsed"];
  constrainedPlanTasks?: Array<PlanTask | PlanTaskOptions>;
  allowingPlanTasks?: Array<PlanTask | PlanTaskOptions>;
  lagInDays?: GlobalPlanConstraintItem["lagInDays"];
  deletedAt?: GlobalPlanConstraintItem["deletedAt"];
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
}

export function newGlobalPlanConstraintItem(
  options: GlobalPlanConstraintItemOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanConstraintItem {
  const o = (options.__typename ? options : cache["GlobalPlanConstraintItem"] = {}) as GlobalPlanConstraintItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanConstraintItem";
  o.id = options.id ?? nextFactoryId("GlobalPlanConstraintItem");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.allowances = (options.allowances ?? []).map((i) =>
    maybeNew("GlobalPlanAllowance", i, cache, options.hasOwnProperty("allowances"))
  );
  o.constraints = (options.constraints ?? []).map((i) =>
    maybeNew("GlobalPlanConstraint", i, cache, options.hasOwnProperty("constraints"))
  );
  o.numberOfTimesUsed = options.numberOfTimesUsed ?? 0;
  o.constrainedPlanTasks = (options.constrainedPlanTasks ?? []).map((i) =>
    maybeNew("PlanTask", i, cache, options.hasOwnProperty("constrainedPlanTasks"))
  );
  o.allowingPlanTasks = (options.allowingPlanTasks ?? []).map((i) =>
    maybeNew("PlanTask", i, cache, options.hasOwnProperty("allowingPlanTasks"))
  );
  o.lagInDays = options.lagInDays ?? 0;
  o.deletedAt = options.deletedAt ?? null;
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  return o;
}

factories["GlobalPlanConstraintItem"] = newGlobalPlanConstraintItem;

export interface SaveGlobalPlanConstraintItemResultOptions {
  __typename?: "SaveGlobalPlanConstraintItemResult";
  globalPlanConstraintItem?: GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions;
}

export function newSaveGlobalPlanConstraintItemResult(
  options: SaveGlobalPlanConstraintItemResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanConstraintItemResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveGlobalPlanConstraintItemResult"] = {}) as SaveGlobalPlanConstraintItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanConstraintItemResult";
  o.globalPlanConstraintItem = maybeNew(
    "GlobalPlanConstraintItem",
    options.globalPlanConstraintItem,
    cache,
    options.hasOwnProperty("globalPlanConstraintItem"),
  );
  return o;
}

factories["SaveGlobalPlanConstraintItemResult"] = newSaveGlobalPlanConstraintItemResult;

export interface SaveGlobalPlanConstraintItemsResultOptions {
  __typename?: "SaveGlobalPlanConstraintItemsResult";
  globalPlanConstraintItems?: Array<GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions>;
}

export function newSaveGlobalPlanConstraintItemsResult(
  options: SaveGlobalPlanConstraintItemsResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanConstraintItemsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveGlobalPlanConstraintItemsResult"] = {}) as SaveGlobalPlanConstraintItemsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanConstraintItemsResult";
  o.globalPlanConstraintItems = (options.globalPlanConstraintItems ?? []).map((i) =>
    maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("globalPlanConstraintItems"))
  );
  return o;
}

factories["SaveGlobalPlanConstraintItemsResult"] = newSaveGlobalPlanConstraintItemsResult;

export interface GlobalPlanMilestoneOptions {
  __typename?: "GlobalPlanMilestone";
  id?: GlobalPlanMilestone["id"];
  name?: GlobalPlanMilestone["name"];
  isDefault?: GlobalPlanMilestone["isDefault"];
  archived?: GlobalPlanMilestone["archived"];
  createdAt?: GlobalPlanMilestone["createdAt"];
  updatedAt?: GlobalPlanMilestone["updatedAt"];
  planMilestones?: Array<PlanMilestone | PlanMilestoneOptions>;
  groups?: Array<GlobalPlanMilestoneGroup | GlobalPlanMilestoneGroupOptions>;
  constraints?: Array<GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions>;
  systemPlanMilestone?: SystemPlanMilestoneDetailOptions | SystemPlanMilestone | null;
  isHomeownerVisible?: GlobalPlanMilestone["isHomeownerVisible"];
  isInvoiceMilestone?: GlobalPlanMilestone["isInvoiceMilestone"];
  homeownerName?: GlobalPlanMilestone["homeownerName"];
  homeownerDescription?: GlobalPlanMilestone["homeownerDescription"];
  homeownerIcon?: Asset | AssetOptions | null;
  description?: GlobalPlanMilestone["description"];
  type?: GlobalPlanMilestoneTypeDetailOptions | GlobalPlanMilestoneType;
}

export function newGlobalPlanMilestone(
  options: GlobalPlanMilestoneOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanMilestone {
  const o = (options.__typename ? options : cache["GlobalPlanMilestone"] = {}) as GlobalPlanMilestone;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanMilestone";
  o.id = options.id ?? nextFactoryId("GlobalPlanMilestone");
  o.name = options.name ?? "name";
  o.isDefault = options.isDefault ?? false;
  o.archived = options.archived ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.planMilestones = (options.planMilestones ?? []).map((i) =>
    maybeNew("PlanMilestone", i, cache, options.hasOwnProperty("planMilestones"))
  );
  o.groups = (options.groups ?? []).map((i) =>
    maybeNew("GlobalPlanMilestoneGroup", i, cache, options.hasOwnProperty("groups"))
  );
  o.constraints = (options.constraints ?? []).map((i) =>
    maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("constraints"))
  );
  o.systemPlanMilestone = enumOrDetailOrNullOfSystemPlanMilestone(options.systemPlanMilestone);
  o.isHomeownerVisible = options.isHomeownerVisible ?? false;
  o.isInvoiceMilestone = options.isInvoiceMilestone ?? false;
  o.homeownerName = options.homeownerName ?? null;
  o.homeownerDescription = options.homeownerDescription ?? null;
  o.homeownerIcon = maybeNewOrNull("Asset", options.homeownerIcon, cache);
  o.description = options.description ?? null;
  o.type = enumOrDetailOfGlobalPlanMilestoneType(options.type);
  return o;
}

factories["GlobalPlanMilestone"] = newGlobalPlanMilestone;

export interface SaveGlobalPlanMilestoneResultOptions {
  __typename?: "SaveGlobalPlanMilestoneResult";
  globalPlanMilestone?: GlobalPlanMilestone | GlobalPlanMilestoneOptions;
}

export function newSaveGlobalPlanMilestoneResult(
  options: SaveGlobalPlanMilestoneResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanMilestoneResult {
  const o =
    (options.__typename ? options : cache["SaveGlobalPlanMilestoneResult"] = {}) as SaveGlobalPlanMilestoneResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanMilestoneResult";
  o.globalPlanMilestone = maybeNew(
    "GlobalPlanMilestone",
    options.globalPlanMilestone,
    cache,
    options.hasOwnProperty("globalPlanMilestone"),
  );
  return o;
}

factories["SaveGlobalPlanMilestoneResult"] = newSaveGlobalPlanMilestoneResult;

export interface GlobalPlanMilestonesPageResultOptions {
  __typename?: "GlobalPlanMilestonesPageResult";
  entities?: Array<GlobalPlanMilestone | GlobalPlanMilestoneOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newGlobalPlanMilestonesPageResult(
  options: GlobalPlanMilestonesPageResultOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanMilestonesPageResult {
  const o =
    (options.__typename ? options : cache["GlobalPlanMilestonesPageResult"] = {}) as GlobalPlanMilestonesPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanMilestonesPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("GlobalPlanMilestone", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["GlobalPlanMilestonesPageResult"] = newGlobalPlanMilestonesPageResult;

export interface SaveGlobalPlanMilestonesResultOptions {
  __typename?: "SaveGlobalPlanMilestonesResult";
  globalPlanMilestones?: Array<GlobalPlanMilestone | GlobalPlanMilestoneOptions>;
}

export function newSaveGlobalPlanMilestonesResult(
  options: SaveGlobalPlanMilestonesResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanMilestonesResult {
  const o =
    (options.__typename ? options : cache["SaveGlobalPlanMilestonesResult"] = {}) as SaveGlobalPlanMilestonesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanMilestonesResult";
  o.globalPlanMilestones = (options.globalPlanMilestones ?? []).map((i) =>
    maybeNew("GlobalPlanMilestone", i, cache, options.hasOwnProperty("globalPlanMilestones"))
  );
  return o;
}

factories["SaveGlobalPlanMilestonesResult"] = newSaveGlobalPlanMilestonesResult;

export interface GlobalPlanMilestoneGroupOptions {
  __typename?: "GlobalPlanMilestoneGroup";
  id?: GlobalPlanMilestoneGroup["id"];
  name?: GlobalPlanMilestoneGroup["name"];
  createdAt?: GlobalPlanMilestoneGroup["createdAt"];
  updatedAt?: GlobalPlanMilestoneGroup["updatedAt"];
  businessFunctionType?: BusinessFunctionTypeDetailOptions | BusinessFunctionType;
  globalPlanMilestones?: Array<GlobalPlanMilestone | GlobalPlanMilestoneOptions>;
}

export function newGlobalPlanMilestoneGroup(
  options: GlobalPlanMilestoneGroupOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanMilestoneGroup {
  const o = (options.__typename ? options : cache["GlobalPlanMilestoneGroup"] = {}) as GlobalPlanMilestoneGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanMilestoneGroup";
  o.id = options.id ?? nextFactoryId("GlobalPlanMilestoneGroup");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.businessFunctionType = enumOrDetailOfBusinessFunctionType(options.businessFunctionType);
  o.globalPlanMilestones = (options.globalPlanMilestones ?? []).map((i) =>
    maybeNew("GlobalPlanMilestone", i, cache, options.hasOwnProperty("globalPlanMilestones"))
  );
  return o;
}

factories["GlobalPlanMilestoneGroup"] = newGlobalPlanMilestoneGroup;

export interface SaveGlobalPlanMilestoneGroupResultOptions {
  __typename?: "SaveGlobalPlanMilestoneGroupResult";
  globalPlanMilestoneGroup?: GlobalPlanMilestoneGroup | GlobalPlanMilestoneGroupOptions;
}

export function newSaveGlobalPlanMilestoneGroupResult(
  options: SaveGlobalPlanMilestoneGroupResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanMilestoneGroupResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveGlobalPlanMilestoneGroupResult"] = {}) as SaveGlobalPlanMilestoneGroupResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanMilestoneGroupResult";
  o.globalPlanMilestoneGroup = maybeNew(
    "GlobalPlanMilestoneGroup",
    options.globalPlanMilestoneGroup,
    cache,
    options.hasOwnProperty("globalPlanMilestoneGroup"),
  );
  return o;
}

factories["SaveGlobalPlanMilestoneGroupResult"] = newSaveGlobalPlanMilestoneGroupResult;

export interface GlobalPlanStageOptions {
  __typename?: "GlobalPlanStage";
  id?: GlobalPlanStage["id"];
  name?: GlobalPlanStage["name"];
  createdAt?: GlobalPlanStage["createdAt"];
  updatedAt?: GlobalPlanStage["updatedAt"];
  globalPlanTasks?: Array<GlobalPlanTask | GlobalPlanTaskOptions>;
  globalPlanTaskVariants?: Array<GlobalPlanTaskVariant | GlobalPlanTaskVariantOptions>;
  variants?: Array<GlobalPlanStageVariant | GlobalPlanStageVariantOptions>;
  orderForProject?: GlobalPlanStage["orderForProject"];
}

export function newGlobalPlanStage(
  options: GlobalPlanStageOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanStage {
  const o = (options.__typename ? options : cache["GlobalPlanStage"] = {}) as GlobalPlanStage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanStage";
  o.id = options.id ?? nextFactoryId("GlobalPlanStage");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.globalPlanTasks = (options.globalPlanTasks ?? []).map((i) =>
    maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("globalPlanTasks"))
  );
  o.globalPlanTaskVariants = (options.globalPlanTaskVariants ?? []).map((i) =>
    maybeNew("GlobalPlanTaskVariant", i, cache, options.hasOwnProperty("globalPlanTaskVariants"))
  );
  o.variants = (options.variants ?? []).map((i) =>
    maybeNew("GlobalPlanStageVariant", i, cache, options.hasOwnProperty("variants"))
  );
  o.orderForProject = options.orderForProject ?? null;
  return o;
}

factories["GlobalPlanStage"] = newGlobalPlanStage;

export interface SaveGlobalPlanStageResultOptions {
  __typename?: "SaveGlobalPlanStageResult";
  globalPlanStage?: GlobalPlanStage | GlobalPlanStageOptions;
}

export function newSaveGlobalPlanStageResult(
  options: SaveGlobalPlanStageResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanStageResult {
  const o = (options.__typename ? options : cache["SaveGlobalPlanStageResult"] = {}) as SaveGlobalPlanStageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanStageResult";
  o.globalPlanStage = maybeNew(
    "GlobalPlanStage",
    options.globalPlanStage,
    cache,
    options.hasOwnProperty("globalPlanStage"),
  );
  return o;
}

factories["SaveGlobalPlanStageResult"] = newSaveGlobalPlanStageResult;

export interface GlobalPlanStageVariantOptions {
  __typename?: "GlobalPlanStageVariant";
  id?: GlobalPlanStageVariant["id"];
  order?: GlobalPlanStageVariant["order"];
  createdAt?: GlobalPlanStageVariant["createdAt"];
  updatedAt?: GlobalPlanStageVariant["updatedAt"];
  globalPlanStage?: GlobalPlanStage | GlobalPlanStageOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
}

export function newGlobalPlanStageVariant(
  options: GlobalPlanStageVariantOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanStageVariant {
  const o = (options.__typename ? options : cache["GlobalPlanStageVariant"] = {}) as GlobalPlanStageVariant;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanStageVariant";
  o.id = options.id ?? nextFactoryId("GlobalPlanStageVariant");
  o.order = options.order ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.globalPlanStage = maybeNew(
    "GlobalPlanStage",
    options.globalPlanStage,
    cache,
    options.hasOwnProperty("globalPlanStage"),
  );
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  return o;
}

factories["GlobalPlanStageVariant"] = newGlobalPlanStageVariant;

export interface SaveGlobalPlanStageVariantsResultOptions {
  __typename?: "SaveGlobalPlanStageVariantsResult";
  globalPlanStageVariants?: Array<GlobalPlanStageVariant | GlobalPlanStageVariantOptions>;
}

export function newSaveGlobalPlanStageVariantsResult(
  options: SaveGlobalPlanStageVariantsResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanStageVariantsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveGlobalPlanStageVariantsResult"] = {}) as SaveGlobalPlanStageVariantsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanStageVariantsResult";
  o.globalPlanStageVariants = (options.globalPlanStageVariants ?? []).map((i) =>
    maybeNew("GlobalPlanStageVariant", i, cache, options.hasOwnProperty("globalPlanStageVariants"))
  );
  return o;
}

factories["SaveGlobalPlanStageVariantsResult"] = newSaveGlobalPlanStageVariantsResult;

export interface GlobalPlanTagOptions {
  __typename?: "GlobalPlanTag";
  id?: GlobalPlanTag["id"];
  name?: GlobalPlanTag["name"];
  createdAt?: GlobalPlanTag["createdAt"];
  updatedAt?: GlobalPlanTag["updatedAt"];
  tasks?: Array<GlobalPlanTask | GlobalPlanTaskOptions>;
  isHiddenFromSchedule?: GlobalPlanTag["isHiddenFromSchedule"];
}

export function newGlobalPlanTag(options: GlobalPlanTagOptions = {}, cache: Record<string, any> = {}): GlobalPlanTag {
  const o = (options.__typename ? options : cache["GlobalPlanTag"] = {}) as GlobalPlanTag;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanTag";
  o.id = options.id ?? nextFactoryId("GlobalPlanTag");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tasks = (options.tasks ?? []).map((i) => maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("tasks")));
  o.isHiddenFromSchedule = options.isHiddenFromSchedule ?? false;
  return o;
}

factories["GlobalPlanTag"] = newGlobalPlanTag;

export interface SaveGlobalPlanTagResultOptions {
  __typename?: "SaveGlobalPlanTagResult";
  globalPlanTag?: GlobalPlanTag | GlobalPlanTagOptions;
}

export function newSaveGlobalPlanTagResult(
  options: SaveGlobalPlanTagResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanTagResult {
  const o = (options.__typename ? options : cache["SaveGlobalPlanTagResult"] = {}) as SaveGlobalPlanTagResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanTagResult";
  o.globalPlanTag = maybeNew("GlobalPlanTag", options.globalPlanTag, cache, options.hasOwnProperty("globalPlanTag"));
  return o;
}

factories["SaveGlobalPlanTagResult"] = newSaveGlobalPlanTagResult;

export interface BulkSaveGlobalPlanTagsResultOptions {
  __typename?: "BulkSaveGlobalPlanTagsResult";
  globalPlanTags?: Array<GlobalPlanTag | GlobalPlanTagOptions>;
}

export function newBulkSaveGlobalPlanTagsResult(
  options: BulkSaveGlobalPlanTagsResultOptions = {},
  cache: Record<string, any> = {},
): BulkSaveGlobalPlanTagsResult {
  const o = (options.__typename ? options : cache["BulkSaveGlobalPlanTagsResult"] = {}) as BulkSaveGlobalPlanTagsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BulkSaveGlobalPlanTagsResult";
  o.globalPlanTags = (options.globalPlanTags ?? []).map((i) =>
    maybeNew("GlobalPlanTag", i, cache, options.hasOwnProperty("globalPlanTags"))
  );
  return o;
}

factories["BulkSaveGlobalPlanTagsResult"] = newBulkSaveGlobalPlanTagsResult;

export interface GlobalPlanTaskOptions {
  __typename?: "GlobalPlanTask";
  id?: GlobalPlanTask["id"];
  name?: GlobalPlanTask["name"];
  nameForEntity?: GlobalPlanTask["nameForEntity"];
  externalName?: GlobalPlanTask["externalName"];
  description?: GlobalPlanTask["description"];
  archived?: GlobalPlanTask["archived"];
  optimisticDurationInDays?: GlobalPlanTask["optimisticDurationInDays"];
  expectedDurationInDays?: GlobalPlanTask["expectedDurationInDays"];
  pessimisticDurationInDays?: GlobalPlanTask["pessimisticDurationInDays"];
  createdAt?: GlobalPlanTask["createdAt"];
  updatedAt?: GlobalPlanTask["updatedAt"];
  businessFunctionType?: BusinessFunctionTypeDetailOptions | BusinessFunctionType;
  projectRole?: ProjectRoleDetailOptions | ProjectRole | null;
  tradeCategory?: TradeCategory | TradeCategoryOptions | null;
  allowances?: Array<GlobalPlanAllowance | GlobalPlanAllowanceOptions>;
  constraints?: Array<GlobalPlanConstraint | GlobalPlanConstraintOptions>;
  tags?: Array<GlobalPlanTag | GlobalPlanTagOptions>;
  scopes?: Array<GlobalPlanTaskScope | GlobalPlanTaskScopeOptions>;
  applyToAllSchedules?: GlobalPlanTask["applyToAllSchedules"];
  budgetItem?: Item | ItemOptions;
  itemPlanTaskMappings?: Array<ItemPlanTaskMapping | ItemPlanTaskMappingOptions>;
  planTasks?: Array<PlanTask | PlanTaskOptions>;
  numberOfTimesUsed?: GlobalPlanTask["numberOfTimesUsed"];
  checklistItems?: Array<GlobalPlanTaskChecklistItem | GlobalPlanTaskChecklistItemOptions>;
  globalRequiredTaskDocuments?: Array<GlobalRequiredTaskDocument | GlobalRequiredTaskDocumentOptions>;
  canEditBudgetItem?: PotentialOperation2 | PotentialOperation2Options;
  bidContractRevisionDraws?: Array<BidContractRevisionDraw | BidContractRevisionDrawOptions>;
  stage?: GlobalPlanStage | GlobalPlanStageOptions | null;
  variants?: Array<GlobalPlanTaskVariant | GlobalPlanTaskVariantOptions>;
  drops?: Array<Drop | DropOptions>;
  parent?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  children?: Array<GlobalPlanTask | GlobalPlanTaskOptions>;
  systemTask?: SystemTaskDetailOptions | SystemTask | null;
  verificationMethod?: VerificationMethodDetailOptions | VerificationMethod | null;
  aiVerifiable?: GlobalPlanTask["aiVerifiable"];
}

export function newGlobalPlanTask(
  options: GlobalPlanTaskOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanTask {
  const o = (options.__typename ? options : cache["GlobalPlanTask"] = {}) as GlobalPlanTask;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanTask";
  o.id = options.id ?? nextFactoryId("GlobalPlanTask");
  o.name = options.name ?? "name";
  o.nameForEntity = options.nameForEntity ?? "nameForEntity";
  o.externalName = options.externalName ?? null;
  o.description = options.description ?? "description";
  o.archived = options.archived ?? false;
  o.optimisticDurationInDays = options.optimisticDurationInDays ?? 0;
  o.expectedDurationInDays = options.expectedDurationInDays ?? 0;
  o.pessimisticDurationInDays = options.pessimisticDurationInDays ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.businessFunctionType = enumOrDetailOfBusinessFunctionType(options.businessFunctionType);
  o.projectRole = enumOrDetailOrNullOfProjectRole(options.projectRole);
  o.tradeCategory = maybeNewOrNull("TradeCategory", options.tradeCategory, cache);
  o.allowances = (options.allowances ?? []).map((i) =>
    maybeNew("GlobalPlanAllowance", i, cache, options.hasOwnProperty("allowances"))
  );
  o.constraints = (options.constraints ?? []).map((i) =>
    maybeNew("GlobalPlanConstraint", i, cache, options.hasOwnProperty("constraints"))
  );
  o.tags = (options.tags ?? []).map((i) => maybeNew("GlobalPlanTag", i, cache, options.hasOwnProperty("tags")));
  o.scopes = (options.scopes ?? []).map((i) =>
    maybeNew("GlobalPlanTaskScope", i, cache, options.hasOwnProperty("scopes"))
  );
  o.applyToAllSchedules = options.applyToAllSchedules ?? false;
  o.budgetItem = maybeNew("Item", options.budgetItem, cache, options.hasOwnProperty("budgetItem"));
  o.itemPlanTaskMappings = (options.itemPlanTaskMappings ?? []).map((i) =>
    maybeNew("ItemPlanTaskMapping", i, cache, options.hasOwnProperty("itemPlanTaskMappings"))
  );
  o.planTasks = (options.planTasks ?? []).map((i) =>
    maybeNew("PlanTask", i, cache, options.hasOwnProperty("planTasks"))
  );
  o.numberOfTimesUsed = options.numberOfTimesUsed ?? 0;
  o.checklistItems = (options.checklistItems ?? []).map((i) =>
    maybeNew("GlobalPlanTaskChecklistItem", i, cache, options.hasOwnProperty("checklistItems"))
  );
  o.globalRequiredTaskDocuments = (options.globalRequiredTaskDocuments ?? []).map((i) =>
    maybeNew("GlobalRequiredTaskDocument", i, cache, options.hasOwnProperty("globalRequiredTaskDocuments"))
  );
  o.canEditBudgetItem = maybeNew(
    "PotentialOperation2",
    options.canEditBudgetItem,
    cache,
    options.hasOwnProperty("canEditBudgetItem"),
  );
  o.bidContractRevisionDraws = (options.bidContractRevisionDraws ?? []).map((i) =>
    maybeNew("BidContractRevisionDraw", i, cache, options.hasOwnProperty("bidContractRevisionDraws"))
  );
  o.stage = maybeNewOrNull("GlobalPlanStage", options.stage, cache);
  o.variants = (options.variants ?? []).map((i) =>
    maybeNew("GlobalPlanTaskVariant", i, cache, options.hasOwnProperty("variants"))
  );
  o.drops = (options.drops ?? []).map((i) => maybeNew("Drop", i, cache, options.hasOwnProperty("drops")));
  o.parent = maybeNewOrNull("GlobalPlanTask", options.parent, cache);
  o.children = (options.children ?? []).map((i) =>
    maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("children"))
  );
  o.systemTask = enumOrDetailOrNullOfSystemTask(options.systemTask);
  o.verificationMethod = enumOrDetailOrNullOfVerificationMethod(options.verificationMethod);
  o.aiVerifiable = options.aiVerifiable ?? false;
  return o;
}

factories["GlobalPlanTask"] = newGlobalPlanTask;

export interface SaveGlobalPlanTaskResultOptions {
  __typename?: "SaveGlobalPlanTaskResult";
  globalPlanTask?: GlobalPlanTask | GlobalPlanTaskOptions;
}

export function newSaveGlobalPlanTaskResult(
  options: SaveGlobalPlanTaskResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanTaskResult {
  const o = (options.__typename ? options : cache["SaveGlobalPlanTaskResult"] = {}) as SaveGlobalPlanTaskResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanTaskResult";
  o.globalPlanTask = maybeNew(
    "GlobalPlanTask",
    options.globalPlanTask,
    cache,
    options.hasOwnProperty("globalPlanTask"),
  );
  return o;
}

factories["SaveGlobalPlanTaskResult"] = newSaveGlobalPlanTaskResult;

export interface SaveGlobalPlanTasksResultOptions {
  __typename?: "SaveGlobalPlanTasksResult";
  globalPlanTasks?: Array<GlobalPlanTask | GlobalPlanTaskOptions>;
}

export function newSaveGlobalPlanTasksResult(
  options: SaveGlobalPlanTasksResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanTasksResult {
  const o = (options.__typename ? options : cache["SaveGlobalPlanTasksResult"] = {}) as SaveGlobalPlanTasksResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanTasksResult";
  o.globalPlanTasks = (options.globalPlanTasks ?? []).map((i) =>
    maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("globalPlanTasks"))
  );
  return o;
}

factories["SaveGlobalPlanTasksResult"] = newSaveGlobalPlanTasksResult;

export interface GlobalPlanTasksPageResultOptions {
  __typename?: "GlobalPlanTasksPageResult";
  entities?: Array<GlobalPlanTask | GlobalPlanTaskOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newGlobalPlanTasksPageResult(
  options: GlobalPlanTasksPageResultOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanTasksPageResult {
  const o = (options.__typename ? options : cache["GlobalPlanTasksPageResult"] = {}) as GlobalPlanTasksPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanTasksPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["GlobalPlanTasksPageResult"] = newGlobalPlanTasksPageResult;

export interface GlobalPlanTaskChecklistItemOptions {
  __typename?: "GlobalPlanTaskChecklistItem";
  id?: GlobalPlanTaskChecklistItem["id"];
  name?: GlobalPlanTaskChecklistItem["name"];
  deletedAt?: GlobalPlanTaskChecklistItem["deletedAt"];
  createdAt?: GlobalPlanTaskChecklistItem["createdAt"];
  updatedAt?: GlobalPlanTaskChecklistItem["updatedAt"];
  globalPlanTask?: GlobalPlanTask | GlobalPlanTaskOptions;
}

export function newGlobalPlanTaskChecklistItem(
  options: GlobalPlanTaskChecklistItemOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanTaskChecklistItem {
  const o = (options.__typename ? options : cache["GlobalPlanTaskChecklistItem"] = {}) as GlobalPlanTaskChecklistItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanTaskChecklistItem";
  o.id = options.id ?? nextFactoryId("GlobalPlanTaskChecklistItem");
  o.name = options.name ?? "name";
  o.deletedAt = options.deletedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.globalPlanTask = maybeNew(
    "GlobalPlanTask",
    options.globalPlanTask,
    cache,
    options.hasOwnProperty("globalPlanTask"),
  );
  return o;
}

factories["GlobalPlanTaskChecklistItem"] = newGlobalPlanTaskChecklistItem;

export interface GlobalPlanTaskScopeOptions {
  __typename?: "GlobalPlanTaskScope";
  id?: GlobalPlanTaskScope["id"];
  createdAt?: GlobalPlanTaskScope["createdAt"];
  updatedAt?: GlobalPlanTaskScope["updatedAt"];
  globalPlanTask?: GlobalPlanTask | GlobalPlanTaskOptions;
  target?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
}

export function newGlobalPlanTaskScope(
  options: GlobalPlanTaskScopeOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanTaskScope {
  const o = (options.__typename ? options : cache["GlobalPlanTaskScope"] = {}) as GlobalPlanTaskScope;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanTaskScope";
  o.id = options.id ?? nextFactoryId("GlobalPlanTaskScope");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.globalPlanTask = maybeNew(
    "GlobalPlanTask",
    options.globalPlanTask,
    cache,
    options.hasOwnProperty("globalPlanTask"),
  );
  o.target = maybeNew("Project", options.target, cache, options.hasOwnProperty("target"));
  return o;
}

factories["GlobalPlanTaskScope"] = newGlobalPlanTaskScope;

export interface GlobalPlanTaskVariantOptions {
  __typename?: "GlobalPlanTaskVariant";
  id?: GlobalPlanTaskVariant["id"];
  name?: GlobalPlanTaskVariant["name"];
  optimisticDurationInDays?: GlobalPlanTaskVariant["optimisticDurationInDays"];
  expectedDurationInDays?: GlobalPlanTaskVariant["expectedDurationInDays"];
  pessimisticDurationInDays?: GlobalPlanTaskVariant["pessimisticDurationInDays"];
  createdAt?: GlobalPlanTaskVariant["createdAt"];
  updatedAt?: GlobalPlanTaskVariant["updatedAt"];
  globalPlanTask?: GlobalPlanTask | GlobalPlanTaskOptions;
  allowances?: Array<GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions>;
  constraints?: Array<GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions>;
  stage?: GlobalPlanStage | GlobalPlanStageOptions | null;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
}

export function newGlobalPlanTaskVariant(
  options: GlobalPlanTaskVariantOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanTaskVariant {
  const o = (options.__typename ? options : cache["GlobalPlanTaskVariant"] = {}) as GlobalPlanTaskVariant;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanTaskVariant";
  o.id = options.id ?? nextFactoryId("GlobalPlanTaskVariant");
  o.name = options.name ?? null;
  o.optimisticDurationInDays = options.optimisticDurationInDays ?? null;
  o.expectedDurationInDays = options.expectedDurationInDays ?? null;
  o.pessimisticDurationInDays = options.pessimisticDurationInDays ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.globalPlanTask = maybeNew(
    "GlobalPlanTask",
    options.globalPlanTask,
    cache,
    options.hasOwnProperty("globalPlanTask"),
  );
  o.allowances = (options.allowances ?? []).map((i) =>
    maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("allowances"))
  );
  o.constraints = (options.constraints ?? []).map((i) =>
    maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("constraints"))
  );
  o.stage = maybeNewOrNull("GlobalPlanStage", options.stage, cache);
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  return o;
}

factories["GlobalPlanTaskVariant"] = newGlobalPlanTaskVariant;

export interface GlobalRequiredTaskDocumentOptions {
  __typename?: "GlobalRequiredTaskDocument";
  id?: GlobalRequiredTaskDocument["id"];
  name?: GlobalRequiredTaskDocument["name"];
  createdAt?: GlobalRequiredTaskDocument["createdAt"];
  updatedAt?: GlobalRequiredTaskDocument["updatedAt"];
  documentType?: DocumentTypeDetailOptions | DocumentType;
  watchers?: GlobalRequiredTaskDocument["watchers"];
  canEditDocumentType?: PotentialOperation2 | PotentialOperation2Options;
}

export function newGlobalRequiredTaskDocument(
  options: GlobalRequiredTaskDocumentOptions = {},
  cache: Record<string, any> = {},
): GlobalRequiredTaskDocument {
  const o = (options.__typename ? options : cache["GlobalRequiredTaskDocument"] = {}) as GlobalRequiredTaskDocument;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalRequiredTaskDocument";
  o.id = options.id ?? nextFactoryId("GlobalRequiredTaskDocument");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.documentType = enumOrDetailOfDocumentType(options.documentType);
  o.watchers = options.watchers ?? [];
  o.canEditDocumentType = maybeNew(
    "PotentialOperation2",
    options.canEditDocumentType,
    cache,
    options.hasOwnProperty("canEditDocumentType"),
  );
  return o;
}

factories["GlobalRequiredTaskDocument"] = newGlobalRequiredTaskDocument;

export interface SaveGlobalRequiredTaskDocumentResultOptions {
  __typename?: "SaveGlobalRequiredTaskDocumentResult";
  globalRequiredTaskDocument?: GlobalRequiredTaskDocument | GlobalRequiredTaskDocumentOptions;
}

export function newSaveGlobalRequiredTaskDocumentResult(
  options: SaveGlobalRequiredTaskDocumentResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalRequiredTaskDocumentResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveGlobalRequiredTaskDocumentResult"] = {}) as SaveGlobalRequiredTaskDocumentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalRequiredTaskDocumentResult";
  o.globalRequiredTaskDocument = maybeNew(
    "GlobalRequiredTaskDocument",
    options.globalRequiredTaskDocument,
    cache,
    options.hasOwnProperty("globalRequiredTaskDocument"),
  );
  return o;
}

factories["SaveGlobalRequiredTaskDocumentResult"] = newSaveGlobalRequiredTaskDocumentResult;

export interface GlobalSearchResultOptions {
  __typename?: "GlobalSearchResult";
  record?: GlobalSearchRecord | GlobalSearchRecordOptions;
}

export function newGlobalSearchResult(
  options: GlobalSearchResultOptions = {},
  cache: Record<string, any> = {},
): GlobalSearchResult {
  const o = (options.__typename ? options : cache["GlobalSearchResult"] = {}) as GlobalSearchResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalSearchResult";
  o.record = maybeNew("GlobalSearchRecord", options.record, cache, options.hasOwnProperty("record"));
  return o;
}

factories["GlobalSearchResult"] = newGlobalSearchResult;

export interface GlobalSearchRecordOptions {
  __typename?: "GlobalSearchRecord";
  id?: GlobalSearchRecord["id"];
  search?: GlobalSearchRecord["search"];
  parent?:
    | GlobalSearchRecordParent
    | BillOptions
    | RequireTypename<CommitmentOptions>
    | RequireTypename<CommitmentChangeOrderOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<DesignPackageOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<PlanPackageOptions>
    | RequireTypename<ProductOfferingOptions>
    | RequireTypename<RegionOptions>
    | RequireTypename<StandaloneProjectOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<TradePartnerOptions>;
}

export function newGlobalSearchRecord(
  options: GlobalSearchRecordOptions = {},
  cache: Record<string, any> = {},
): GlobalSearchRecord {
  const o = (options.__typename ? options : cache["GlobalSearchRecord"] = {}) as GlobalSearchRecord;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalSearchRecord";
  o.id = options.id ?? nextFactoryId("GlobalSearchRecord");
  o.search = options.search ?? null;
  o.parent = maybeNew(options.parent?.__typename ?? "Bill", options.parent, cache);
  return o;
}

factories["GlobalSearchRecord"] = newGlobalSearchRecord;

export interface GlobalSubPhaseOptions {
  __typename?: "GlobalSubPhase";
  id?: GlobalSubPhase["id"];
  name?: GlobalSubPhase["name"];
  globalPhase?: GlobalPhase | GlobalPhaseOptions;
  displayOrder?: GlobalSubPhase["displayOrder"];
  stage?: GlobalSubPhase["stage"];
  stageDetail?: StageDetailOptions | Stage;
  cmsId?: GlobalSubPhase["cmsId"];
}

export function newGlobalSubPhase(
  options: GlobalSubPhaseOptions = {},
  cache: Record<string, any> = {},
): GlobalSubPhase {
  const o = (options.__typename ? options : cache["GlobalSubPhase"] = {}) as GlobalSubPhase;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalSubPhase";
  o.id = options.id ?? nextFactoryId("GlobalSubPhase");
  o.name = options.name ?? "name";
  o.globalPhase = maybeNew("GlobalPhase", options.globalPhase, cache, options.hasOwnProperty("globalPhase"));
  o.displayOrder = options.displayOrder ?? null;
  o.stage = options.stage ?? Stage.PreConPlanning;
  o.stageDetail = enumOrDetailOfStage(options.stageDetail);
  o.cmsId = options.cmsId ?? null;
  return o;
}

factories["GlobalSubPhase"] = newGlobalSubPhase;

export interface SaveGlobalSubPhasesResultOptions {
  __typename?: "SaveGlobalSubPhasesResult";
  globalSubPhases?: Array<GlobalSubPhase | GlobalSubPhaseOptions>;
}

export function newSaveGlobalSubPhasesResult(
  options: SaveGlobalSubPhasesResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalSubPhasesResult {
  const o = (options.__typename ? options : cache["SaveGlobalSubPhasesResult"] = {}) as SaveGlobalSubPhasesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalSubPhasesResult";
  o.globalSubPhases = (options.globalSubPhases ?? []).map((i) =>
    maybeNew("GlobalSubPhase", i, cache, options.hasOwnProperty("globalSubPhases"))
  );
  return o;
}

factories["SaveGlobalSubPhasesResult"] = newSaveGlobalSubPhasesResult;

export interface ReplaceGlobalSubPhaseResultOptions {
  __typename?: "ReplaceGlobalSubPhaseResult";
  replaced?: GlobalSubPhase | GlobalSubPhaseOptions;
  with?: GlobalSubPhase | GlobalSubPhaseOptions;
  impactedCount?: ReplaceGlobalSubPhaseResult["impactedCount"];
  impacted?: Array<ScheduleSubPhase | ScheduleSubPhaseOptions>;
}

export function newReplaceGlobalSubPhaseResult(
  options: ReplaceGlobalSubPhaseResultOptions = {},
  cache: Record<string, any> = {},
): ReplaceGlobalSubPhaseResult {
  const o = (options.__typename ? options : cache["ReplaceGlobalSubPhaseResult"] = {}) as ReplaceGlobalSubPhaseResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReplaceGlobalSubPhaseResult";
  o.replaced = maybeNew("GlobalSubPhase", options.replaced, cache, options.hasOwnProperty("replaced"));
  o.with = maybeNew("GlobalSubPhase", options.with, cache, options.hasOwnProperty("with"));
  o.impactedCount = options.impactedCount ?? 0;
  o.impacted = (options.impacted ?? []).map((i) =>
    maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("impacted"))
  );
  return o;
}

factories["ReplaceGlobalSubPhaseResult"] = newReplaceGlobalSubPhaseResult;

export interface GlobalTaskOptions {
  __typename?: "GlobalTask";
  id?: GlobalTask["id"];
  name?: GlobalTask["name"];
  isMilestone?: GlobalTask["isMilestone"];
  createdAt?: GlobalTask["createdAt"];
  updatedAt?: GlobalTask["updatedAt"];
  globalPhase?: GlobalPhase | GlobalPhaseOptions;
  determinesStartDateForStage?: GlobalTask["determinesStartDateForStage"];
  beginsStage?: GlobalTask["beginsStage"];
  systemTask?: GlobalTask["systemTask"];
  sendEvent?: GlobalTask["sendEvent"];
  globalPlanMilestone?: GlobalPlanMilestone | GlobalPlanMilestoneOptions | null;
}

export function newGlobalTask(options: GlobalTaskOptions = {}, cache: Record<string, any> = {}): GlobalTask {
  const o = (options.__typename ? options : cache["GlobalTask"] = {}) as GlobalTask;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalTask";
  o.id = options.id ?? nextFactoryId("GlobalTask");
  o.name = options.name ?? "name";
  o.isMilestone = options.isMilestone ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.globalPhase = maybeNew("GlobalPhase", options.globalPhase, cache, options.hasOwnProperty("globalPhase"));
  o.determinesStartDateForStage = options.determinesStartDateForStage ?? null;
  o.beginsStage = options.beginsStage ?? null;
  o.systemTask = options.systemTask ?? null;
  o.sendEvent = options.sendEvent ?? false;
  o.globalPlanMilestone = maybeNewOrNull("GlobalPlanMilestone", options.globalPlanMilestone, cache);
  return o;
}

factories["GlobalTask"] = newGlobalTask;

export interface SaveGlobalTasksResultOptions {
  __typename?: "SaveGlobalTasksResult";
  globalTasks?: Array<GlobalTask | GlobalTaskOptions>;
}

export function newSaveGlobalTasksResult(
  options: SaveGlobalTasksResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalTasksResult {
  const o = (options.__typename ? options : cache["SaveGlobalTasksResult"] = {}) as SaveGlobalTasksResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalTasksResult";
  o.globalTasks = (options.globalTasks ?? []).map((i) =>
    maybeNew("GlobalTask", i, cache, options.hasOwnProperty("globalTasks"))
  );
  return o;
}

factories["SaveGlobalTasksResult"] = newSaveGlobalTasksResult;

export interface HistoryOptions {
  __typename?: "History";
  recordedAt?: History["recordedAt"];
  avatar?: History["avatar"];
  title?: History["title"];
  subtitle?: History["subtitle"];
  userName?: History["userName"];
}

export function newHistory(options: HistoryOptions = {}, cache: Record<string, any> = {}): History {
  const o = (options.__typename ? options : cache["History"] = {}) as History;
  (cache.all ??= new Set()).add(o);
  o.__typename = "History";
  o.recordedAt = options.recordedAt ?? newDateTime();
  o.avatar = options.avatar ?? "avatar";
  o.title = options.title ?? "title";
  o.subtitle = options.subtitle ?? null;
  o.userName = options.userName ?? null;
  return o;
}

factories["History"] = newHistory;

export interface HomeboundHolidayOptions {
  __typename?: "HomeboundHoliday";
  id?: HomeboundHoliday["id"];
  date?: HomeboundHoliday["date"];
  name?: HomeboundHoliday["name"];
  createdAt?: HomeboundHoliday["createdAt"];
  updatedAt?: HomeboundHoliday["updatedAt"];
}

export function newHomeboundHoliday(
  options: HomeboundHolidayOptions = {},
  cache: Record<string, any> = {},
): HomeboundHoliday {
  const o = (options.__typename ? options : cache["HomeboundHoliday"] = {}) as HomeboundHoliday;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeboundHoliday";
  o.id = options.id ?? nextFactoryId("HomeboundHoliday");
  o.date = options.date ?? newDate();
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  return o;
}

factories["HomeboundHoliday"] = newHomeboundHoliday;

export interface SaveHomeboundHolidayResultOptions {
  __typename?: "SaveHomeboundHolidayResult";
  homeboundHoliday?: HomeboundHoliday | HomeboundHolidayOptions;
}

export function newSaveHomeboundHolidayResult(
  options: SaveHomeboundHolidayResultOptions = {},
  cache: Record<string, any> = {},
): SaveHomeboundHolidayResult {
  const o = (options.__typename ? options : cache["SaveHomeboundHolidayResult"] = {}) as SaveHomeboundHolidayResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveHomeboundHolidayResult";
  o.homeboundHoliday = maybeNew(
    "HomeboundHoliday",
    options.homeboundHoliday,
    cache,
    options.hasOwnProperty("homeboundHoliday"),
  );
  return o;
}

factories["SaveHomeboundHolidayResult"] = newSaveHomeboundHolidayResult;

export interface HomeownerOptions {
  __typename?: "Homeowner";
  id?: Homeowner["id"];
  firstName?: Homeowner["firstName"];
  lastName?: Homeowner["lastName"];
  email?: Homeowner["email"];
  phone?: Homeowner["phone"];
  createdAt?: Homeowner["createdAt"];
  createdBy?: User | UserOptions | null;
  canViewCheckout?: Homeowner["canViewCheckout"];
  checkoutConfigs?: Array<CheckoutConfig | CheckoutConfigOptions>;
}

export function newHomeowner(options: HomeownerOptions = {}, cache: Record<string, any> = {}): Homeowner {
  const o = (options.__typename ? options : cache["Homeowner"] = {}) as Homeowner;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Homeowner";
  o.id = options.id ?? nextFactoryId("Homeowner");
  o.firstName = options.firstName ?? "firstName";
  o.lastName = options.lastName ?? "lastName";
  o.email = options.email ?? "email";
  o.phone = options.phone ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.createdBy = maybeNewOrNull("User", options.createdBy, cache);
  o.canViewCheckout = options.canViewCheckout ?? false;
  o.checkoutConfigs = (options.checkoutConfigs ?? []).map((i) =>
    maybeNew("CheckoutConfig", i, cache, options.hasOwnProperty("checkoutConfigs"))
  );
  return o;
}

factories["Homeowner"] = newHomeowner;

export interface HomeownersPageOptions {
  __typename?: "HomeownersPage";
  entities?: Array<Homeowner | HomeownerOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newHomeownersPage(
  options: HomeownersPageOptions = {},
  cache: Record<string, any> = {},
): HomeownersPage {
  const o = (options.__typename ? options : cache["HomeownersPage"] = {}) as HomeownersPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownersPage";
  o.entities = (options.entities ?? []).map((i) => maybeNew("Homeowner", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["HomeownersPage"] = newHomeownersPage;

export interface SaveHomeownerResultOptions {
  __typename?: "SaveHomeownerResult";
  homeowner?: Homeowner | HomeownerOptions;
}

export function newSaveHomeownerResult(
  options: SaveHomeownerResultOptions = {},
  cache: Record<string, any> = {},
): SaveHomeownerResult {
  const o = (options.__typename ? options : cache["SaveHomeownerResult"] = {}) as SaveHomeownerResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveHomeownerResult";
  o.homeowner = maybeNew("Homeowner", options.homeowner, cache, options.hasOwnProperty("homeowner"));
  return o;
}

factories["SaveHomeownerResult"] = newSaveHomeownerResult;

export interface HomeownerContractLineItemsByProjectItemOptions {
  __typename?: "HomeownerContractLineItemsByProjectItem";
  projectItem?: ProjectItem | ProjectItemOptions;
  lineItems?: Array<HomeownerContractLineItem | HomeownerContractLineItemOptions>;
}

export function newHomeownerContractLineItemsByProjectItem(
  options: HomeownerContractLineItemsByProjectItemOptions = {},
  cache: Record<string, any> = {},
): HomeownerContractLineItemsByProjectItem {
  const o =
    (options.__typename
      ? options
      : cache["HomeownerContractLineItemsByProjectItem"] = {}) as HomeownerContractLineItemsByProjectItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerContractLineItemsByProjectItem";
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("HomeownerContractLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  return o;
}

factories["HomeownerContractLineItemsByProjectItem"] = newHomeownerContractLineItemsByProjectItem;

export interface SaveHomeownerContractResultOptions {
  __typename?: "SaveHomeownerContractResult";
  homeownerContract?: HomeownerContract | HomeownerContractOptions;
}

export function newSaveHomeownerContractResult(
  options: SaveHomeownerContractResultOptions = {},
  cache: Record<string, any> = {},
): SaveHomeownerContractResult {
  const o = (options.__typename ? options : cache["SaveHomeownerContractResult"] = {}) as SaveHomeownerContractResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveHomeownerContractResult";
  o.homeownerContract = maybeNew(
    "HomeownerContract",
    options.homeownerContract,
    cache,
    options.hasOwnProperty("homeownerContract"),
  );
  return o;
}

factories["SaveHomeownerContractResult"] = newSaveHomeownerContractResult;

export interface SaveHomeownerContractChangeOrderResultOptions {
  __typename?: "SaveHomeownerContractChangeOrderResult";
  homeownerContractChangeOrder?: HomeownerContractChangeOrder | HomeownerContractChangeOrderOptions;
}

export function newSaveHomeownerContractChangeOrderResult(
  options: SaveHomeownerContractChangeOrderResultOptions = {},
  cache: Record<string, any> = {},
): SaveHomeownerContractChangeOrderResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveHomeownerContractChangeOrderResult"] = {}) as SaveHomeownerContractChangeOrderResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveHomeownerContractChangeOrderResult";
  o.homeownerContractChangeOrder = maybeNew(
    "HomeownerContractChangeOrder",
    options.homeownerContractChangeOrder,
    cache,
    options.hasOwnProperty("homeownerContractChangeOrder"),
  );
  return o;
}

factories["SaveHomeownerContractChangeOrderResult"] = newSaveHomeownerContractChangeOrderResult;

export interface ContractProjectFinancialsOptions {
  __typename?: "ContractProjectFinancials";
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  softCostBudgetInCents?: ContractProjectFinancials["softCostBudgetInCents"];
  directHardCostBudgetInCents?: ContractProjectFinancials["directHardCostBudgetInCents"];
  indirectHardCostBudgetInCents?: ContractProjectFinancials["indirectHardCostBudgetInCents"];
  totalMarkupInCents?: ContractProjectFinancials["totalMarkupInCents"];
}

export function newContractProjectFinancials(
  options: ContractProjectFinancialsOptions = {},
  cache: Record<string, any> = {},
): ContractProjectFinancials {
  const o = (options.__typename ? options : cache["ContractProjectFinancials"] = {}) as ContractProjectFinancials;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ContractProjectFinancials";
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.softCostBudgetInCents = options.softCostBudgetInCents ?? 0;
  o.directHardCostBudgetInCents = options.directHardCostBudgetInCents ?? 0;
  o.indirectHardCostBudgetInCents = options.indirectHardCostBudgetInCents ?? 0;
  o.totalMarkupInCents = options.totalMarkupInCents ?? 0;
  return o;
}

factories["ContractProjectFinancials"] = newContractProjectFinancials;

export interface HomeownerContractDrawOptions {
  __typename?: "HomeownerContractDraw";
  id?: HomeownerContractDraw["id"];
  parent?: HomeownerContract | HomeownerContractChangeOrder | HomeownerContractLike | HomeownerContractLikeOptions;
  task?: Task | TaskOptions;
  percent?: HomeownerContractDraw["percent"];
  amountInCents?: HomeownerContractDraw["amountInCents"];
  order?: HomeownerContractDraw["order"];
  isDrawn?: HomeownerContractDraw["isDrawn"];
  name?: HomeownerContractDraw["name"];
  description?: HomeownerContractDraw["description"];
  invoiceDrawLineItem?: InvoiceDrawLineItem | InvoiceDrawLineItemOptions | null;
}

export function newHomeownerContractDraw(
  options: HomeownerContractDrawOptions = {},
  cache: Record<string, any> = {},
): HomeownerContractDraw {
  const o = (options.__typename ? options : cache["HomeownerContractDraw"] = {}) as HomeownerContractDraw;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerContractDraw";
  o.id = options.id ?? nextFactoryId("HomeownerContractDraw");
  o.parent = maybeNew("HomeownerContractLike", options.parent, cache, options.hasOwnProperty("parent"));
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  o.percent = options.percent ?? 0;
  o.amountInCents = options.amountInCents ?? 0;
  o.order = options.order ?? 0;
  o.isDrawn = options.isDrawn ?? false;
  o.name = options.name ?? "name";
  o.description = options.description ?? "description";
  o.invoiceDrawLineItem = maybeNewOrNull("InvoiceDrawLineItem", options.invoiceDrawLineItem, cache);
  return o;
}

factories["HomeownerContractDraw"] = newHomeownerContractDraw;

export interface HomeownerContractLineItemAllocationOptions {
  __typename?: "HomeownerContractLineItemAllocation";
  id?: HomeownerContractLineItemAllocation["id"];
  costInCents?: HomeownerContractLineItemAllocation["costInCents"];
  priceInCents?: HomeownerContractLineItemAllocation["priceInCents"];
  createdAt?: HomeownerContractLineItemAllocation["createdAt"];
  updatedAt?: HomeownerContractLineItemAllocation["updatedAt"];
  homeownerContractLineItem?: HomeownerContractLineItem | HomeownerContractLineItemOptions;
  projectItemAllocation?: ProjectItemAllocation | ProjectItemAllocationOptions;
  changeEventLineItemAllocation?: ChangeEventLineItemAllocation | ChangeEventLineItemAllocationOptions | null;
}

export function newHomeownerContractLineItemAllocation(
  options: HomeownerContractLineItemAllocationOptions = {},
  cache: Record<string, any> = {},
): HomeownerContractLineItemAllocation {
  const o =
    (options.__typename
      ? options
      : cache["HomeownerContractLineItemAllocation"] = {}) as HomeownerContractLineItemAllocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerContractLineItemAllocation";
  o.id = options.id ?? nextFactoryId("HomeownerContractLineItemAllocation");
  o.costInCents = options.costInCents ?? 0;
  o.priceInCents = options.priceInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.homeownerContractLineItem = maybeNew(
    "HomeownerContractLineItem",
    options.homeownerContractLineItem,
    cache,
    options.hasOwnProperty("homeownerContractLineItem"),
  );
  o.projectItemAllocation = maybeNew(
    "ProjectItemAllocation",
    options.projectItemAllocation,
    cache,
    options.hasOwnProperty("projectItemAllocation"),
  );
  o.changeEventLineItemAllocation = maybeNewOrNull(
    "ChangeEventLineItemAllocation",
    options.changeEventLineItemAllocation,
    cache,
  );
  return o;
}

factories["HomeownerContractLineItemAllocation"] = newHomeownerContractLineItemAllocation;

export interface HomeownerNoteOptions {
  __typename?: "HomeownerNote";
  id?: HomeownerNote["id"];
  title?: HomeownerNote["title"];
  description?: HomeownerNote["description"];
  jobLogImages?: Array<JobLogImage | JobLogImageOptions>;
  scheduleTasks?: Array<ScheduleTask | ScheduleTaskOptions>;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  createdAt?: HomeownerNote["createdAt"];
  createdBy?: User | UserOptions;
  schedulePhases?: Array<SchedulePhase | SchedulePhaseOptions>;
}

export function newHomeownerNote(options: HomeownerNoteOptions = {}, cache: Record<string, any> = {}): HomeownerNote {
  const o = (options.__typename ? options : cache["HomeownerNote"] = {}) as HomeownerNote;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerNote";
  o.id = options.id ?? nextFactoryId("HomeownerNote");
  o.title = options.title ?? "title";
  o.description = options.description ?? "description";
  o.jobLogImages = (options.jobLogImages ?? []).map((i) =>
    maybeNew("JobLogImage", i, cache, options.hasOwnProperty("jobLogImages"))
  );
  o.scheduleTasks = (options.scheduleTasks ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("scheduleTasks"))
  );
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.schedulePhases = (options.schedulePhases ?? []).map((i) =>
    maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("schedulePhases"))
  );
  return o;
}

factories["HomeownerNote"] = newHomeownerNote;

export interface SaveHomeownerNoteResultOptions {
  __typename?: "SaveHomeownerNoteResult";
  homeownerNote?: HomeownerNote | HomeownerNoteOptions;
}

export function newSaveHomeownerNoteResult(
  options: SaveHomeownerNoteResultOptions = {},
  cache: Record<string, any> = {},
): SaveHomeownerNoteResult {
  const o = (options.__typename ? options : cache["SaveHomeownerNoteResult"] = {}) as SaveHomeownerNoteResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveHomeownerNoteResult";
  o.homeownerNote = maybeNew("HomeownerNote", options.homeownerNote, cache, options.hasOwnProperty("homeownerNote"));
  return o;
}

factories["SaveHomeownerNoteResult"] = newSaveHomeownerNoteResult;

export interface InsideMapsRoomRenderingOptions {
  __typename?: "InsideMapsRoomRendering";
  id?: InsideMapsRoomRendering["id"];
  createdAt?: InsideMapsRoomRendering["createdAt"];
  updatedAt?: InsideMapsRoomRendering["updatedAt"];
  asset?: Asset | AssetOptions | null;
  readyPlanLocation?: ReadyPlanLocation | ReadyPlanLocationOptions;
}

export function newInsideMapsRoomRendering(
  options: InsideMapsRoomRenderingOptions = {},
  cache: Record<string, any> = {},
): InsideMapsRoomRendering {
  const o = (options.__typename ? options : cache["InsideMapsRoomRendering"] = {}) as InsideMapsRoomRendering;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InsideMapsRoomRendering";
  o.id = options.id ?? nextFactoryId("InsideMapsRoomRendering");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.asset = maybeNewOrNull("Asset", options.asset, cache);
  o.readyPlanLocation = maybeNew(
    "ReadyPlanLocation",
    options.readyPlanLocation,
    cache,
    options.hasOwnProperty("readyPlanLocation"),
  );
  return o;
}

factories["InsideMapsRoomRendering"] = newInsideMapsRoomRendering;

export interface InternalUserOptions {
  __typename?: "InternalUser";
  id?: InternalUser["id"];
  name?: InternalUser["name"];
  email?: InternalUser["email"];
  avatar?: InternalUser["avatar"];
  projectRole?: InternalUser["projectRole"];
  projectRoleDetail?: ProjectRoleDetailOptions | ProjectRole | null;
  user?: User | UserOptions;
  approvals?: Array<Approval | ApprovalOptions>;
  approvers?: Array<Approver | ApproverOptions>;
  projectDashboardConfig?: DashboardConfig | DashboardConfigOptions | null;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
  impersonateInternalUser?: InternalUser | InternalUserOptions | null;
}

export function newInternalUser(options: InternalUserOptions = {}, cache: Record<string, any> = {}): InternalUser {
  const o = (options.__typename ? options : cache["InternalUser"] = {}) as InternalUser;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InternalUser";
  o.id = options.id ?? nextFactoryId("InternalUser");
  o.name = options.name ?? "name";
  o.email = options.email ?? "email";
  o.avatar = options.avatar ?? "avatar";
  o.projectRole = options.projectRole ?? null;
  o.projectRoleDetail = enumOrDetailOrNullOfProjectRole(options.projectRoleDetail);
  o.user = maybeNew("User", options.user, cache, options.hasOwnProperty("user"));
  o.approvals = (options.approvals ?? []).map((i) =>
    maybeNew("Approval", i, cache, options.hasOwnProperty("approvals"))
  );
  o.approvers = (options.approvers ?? []).map((i) =>
    maybeNew("Approver", i, cache, options.hasOwnProperty("approvers"))
  );
  o.projectDashboardConfig = maybeNewOrNull("DashboardConfig", options.projectDashboardConfig, cache);
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  o.impersonateInternalUser = maybeNewOrNull("InternalUser", options.impersonateInternalUser, cache);
  return o;
}

factories["InternalUser"] = newInternalUser;

export interface SaveInternalUserResultOptions {
  __typename?: "SaveInternalUserResult";
  internalUser?: InternalUser | InternalUserOptions;
}

export function newSaveInternalUserResult(
  options: SaveInternalUserResultOptions = {},
  cache: Record<string, any> = {},
): SaveInternalUserResult {
  const o = (options.__typename ? options : cache["SaveInternalUserResult"] = {}) as SaveInternalUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveInternalUserResult";
  o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
  return o;
}

factories["SaveInternalUserResult"] = newSaveInternalUserResult;

export interface DashboardConfigOptions {
  __typename?: "DashboardConfig";
  tileConfigs?: Array<DashboardTileConfig | DashboardTileConfigOptions> | null;
}

export function newDashboardConfig(
  options: DashboardConfigOptions = {},
  cache: Record<string, any> = {},
): DashboardConfig {
  const o = (options.__typename ? options : cache["DashboardConfig"] = {}) as DashboardConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DashboardConfig";
  o.tileConfigs = (options.tileConfigs ?? []).map((i) =>
    maybeNew("DashboardTileConfig", i, cache, options.hasOwnProperty("tileConfigs"))
  );
  return o;
}

factories["DashboardConfig"] = newDashboardConfig;

export interface DashboardTileConfigOptions {
  __typename?: "DashboardTileConfig";
  tile?: DashboardTileConfig["tile"];
  size?: DashboardTileConfig["size"];
}

export function newDashboardTileConfig(
  options: DashboardTileConfigOptions = {},
  cache: Record<string, any> = {},
): DashboardTileConfig {
  const o = (options.__typename ? options : cache["DashboardTileConfig"] = {}) as DashboardTileConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DashboardTileConfig";
  o.tile = options.tile ?? DashboardTile.ProjectSchedule;
  o.size = options.size ?? DashboardTileSize.Small;
  return o;
}

factories["DashboardTileConfig"] = newDashboardTileConfig;

export interface SaveInvoiceResultOptions {
  __typename?: "SaveInvoiceResult";
  invoice?: Invoice | InvoiceOptions;
}

export function newSaveInvoiceResult(
  options: SaveInvoiceResultOptions = {},
  cache: Record<string, any> = {},
): SaveInvoiceResult {
  const o = (options.__typename ? options : cache["SaveInvoiceResult"] = {}) as SaveInvoiceResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveInvoiceResult";
  o.invoice = maybeNew("Invoice", options.invoice, cache, options.hasOwnProperty("invoice"));
  return o;
}

factories["SaveInvoiceResult"] = newSaveInvoiceResult;

export interface SaveInvoicesResultOptions {
  __typename?: "SaveInvoicesResult";
  invoices?: Array<Invoice | InvoiceOptions>;
}

export function newSaveInvoicesResult(
  options: SaveInvoicesResultOptions = {},
  cache: Record<string, any> = {},
): SaveInvoicesResult {
  const o = (options.__typename ? options : cache["SaveInvoicesResult"] = {}) as SaveInvoicesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveInvoicesResult";
  o.invoices = (options.invoices ?? []).map((i) => maybeNew("Invoice", i, cache, options.hasOwnProperty("invoices")));
  return o;
}

factories["SaveInvoicesResult"] = newSaveInvoicesResult;

export interface InvoiceLineItemsByCostCodeOptions {
  __typename?: "InvoiceLineItemsByCostCode";
  costCode?: CostCode | CostCodeOptions;
  totalAmountInCents?: InvoiceLineItemsByCostCode["totalAmountInCents"];
  lineItems?: Array<InvoiceLineItem | InvoiceLineItemOptions>;
}

export function newInvoiceLineItemsByCostCode(
  options: InvoiceLineItemsByCostCodeOptions = {},
  cache: Record<string, any> = {},
): InvoiceLineItemsByCostCode {
  const o = (options.__typename ? options : cache["InvoiceLineItemsByCostCode"] = {}) as InvoiceLineItemsByCostCode;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceLineItemsByCostCode";
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.totalAmountInCents = options.totalAmountInCents ?? 0;
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("InvoiceLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  return o;
}

factories["InvoiceLineItemsByCostCode"] = newInvoiceLineItemsByCostCode;

export interface InvoiceLineItemOptions {
  __typename?: "InvoiceLineItem";
  id?: InvoiceLineItem["id"];
  amountInCents?: InvoiceLineItem["amountInCents"];
  marginInCents?: InvoiceLineItem["marginInCents"];
  homeownerContractLineItem?: HomeownerContractLineItem | HomeownerContractLineItemOptions;
  invoice?: Invoice | InvoiceOptions;
  costLineItemAllocations?: Array<CostLineItemAllocation | CostLineItemAllocationOptions>;
  downPaymentInvoice?: Invoice | InvoiceOptions | null;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
}

export function newInvoiceLineItem(
  options: InvoiceLineItemOptions = {},
  cache: Record<string, any> = {},
): InvoiceLineItem {
  const o = (options.__typename ? options : cache["InvoiceLineItem"] = {}) as InvoiceLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceLineItem";
  o.id = options.id ?? nextFactoryId("InvoiceLineItem");
  o.amountInCents = options.amountInCents ?? 0;
  o.marginInCents = options.marginInCents ?? null;
  o.homeownerContractLineItem = maybeNew(
    "HomeownerContractLineItem",
    options.homeownerContractLineItem,
    cache,
    options.hasOwnProperty("homeownerContractLineItem"),
  );
  o.invoice = maybeNew("Invoice", options.invoice, cache, options.hasOwnProperty("invoice"));
  o.costLineItemAllocations = (options.costLineItemAllocations ?? []).map((i) =>
    maybeNew("CostLineItemAllocation", i, cache, options.hasOwnProperty("costLineItemAllocations"))
  );
  o.downPaymentInvoice = maybeNewOrNull("Invoice", options.downPaymentInvoice, cache);
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  return o;
}

factories["InvoiceLineItem"] = newInvoiceLineItem;

export interface InvoiceDrawLineItemOptions {
  __typename?: "InvoiceDrawLineItem";
  id?: InvoiceDrawLineItem["id"];
  draw?: HomeownerContractDraw | HomeownerContractDrawOptions;
  invoice?: Invoice | InvoiceOptions;
}

export function newInvoiceDrawLineItem(
  options: InvoiceDrawLineItemOptions = {},
  cache: Record<string, any> = {},
): InvoiceDrawLineItem {
  const o = (options.__typename ? options : cache["InvoiceDrawLineItem"] = {}) as InvoiceDrawLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceDrawLineItem";
  o.id = options.id ?? nextFactoryId("InvoiceDrawLineItem");
  o.draw = maybeNew("HomeownerContractDraw", options.draw, cache, options.hasOwnProperty("draw"));
  o.invoice = maybeNew("Invoice", options.invoice, cache, options.hasOwnProperty("invoice"));
  return o;
}

factories["InvoiceDrawLineItem"] = newInvoiceDrawLineItem;

export interface InvoiceScheduledLineItemOptions {
  __typename?: "InvoiceScheduledLineItem";
  id?: InvoiceScheduledLineItem["id"];
  amountInCents?: InvoiceScheduledLineItem["amountInCents"];
  amountInBasisPoints?: InvoiceScheduledLineItem["amountInBasisPoints"];
  marginInCents?: InvoiceScheduledLineItem["marginInCents"];
  invoice?: Invoice | InvoiceOptions;
  invoiceScheduleItem?: InvoiceScheduleItem | InvoiceScheduleItemOptions;
  invoiceLineItems?: Array<InvoiceLineItem | InvoiceLineItemOptions>;
}

export function newInvoiceScheduledLineItem(
  options: InvoiceScheduledLineItemOptions = {},
  cache: Record<string, any> = {},
): InvoiceScheduledLineItem {
  const o = (options.__typename ? options : cache["InvoiceScheduledLineItem"] = {}) as InvoiceScheduledLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceScheduledLineItem";
  o.id = options.id ?? nextFactoryId("InvoiceScheduledLineItem");
  o.amountInCents = options.amountInCents ?? 0;
  o.amountInBasisPoints = options.amountInBasisPoints ?? 0;
  o.marginInCents = options.marginInCents ?? 0;
  o.invoice = maybeNew("Invoice", options.invoice, cache, options.hasOwnProperty("invoice"));
  o.invoiceScheduleItem = maybeNew(
    "InvoiceScheduleItem",
    options.invoiceScheduleItem,
    cache,
    options.hasOwnProperty("invoiceScheduleItem"),
  );
  o.invoiceLineItems = (options.invoiceLineItems ?? []).map((i) =>
    maybeNew("InvoiceLineItem", i, cache, options.hasOwnProperty("invoiceLineItems"))
  );
  return o;
}

factories["InvoiceScheduledLineItem"] = newInvoiceScheduledLineItem;

export interface InvoiceAccruedLineItemOptions {
  __typename?: "InvoiceAccruedLineItem";
  id?: InvoiceAccruedLineItem["id"];
  amountInCents?: InvoiceAccruedLineItem["amountInCents"];
  marginInCents?: InvoiceAccruedLineItem["marginInCents"];
  createdAt?: InvoiceAccruedLineItem["createdAt"];
  updatedAt?: InvoiceAccruedLineItem["updatedAt"];
  costClassificationType?: CostClassificationTypeDetailOptions | CostClassificationType;
  invoice?: Invoice | InvoiceOptions;
  invoiceCategory?: CostCodeInvoiceCategoryDetailOptions | CostCodeInvoiceCategory | null;
}

export function newInvoiceAccruedLineItem(
  options: InvoiceAccruedLineItemOptions = {},
  cache: Record<string, any> = {},
): InvoiceAccruedLineItem {
  const o = (options.__typename ? options : cache["InvoiceAccruedLineItem"] = {}) as InvoiceAccruedLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceAccruedLineItem";
  o.id = options.id ?? nextFactoryId("InvoiceAccruedLineItem");
  o.amountInCents = options.amountInCents ?? 0;
  o.marginInCents = options.marginInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costClassificationType = enumOrDetailOfCostClassificationType(options.costClassificationType);
  o.invoice = maybeNew("Invoice", options.invoice, cache, options.hasOwnProperty("invoice"));
  o.invoiceCategory = enumOrDetailOrNullOfCostCodeInvoiceCategory(options.invoiceCategory);
  return o;
}

factories["InvoiceAccruedLineItem"] = newInvoiceAccruedLineItem;

export interface InvoiceDisplayLineItemOptions {
  __typename?: "InvoiceDisplayLineItem";
  id?: InvoiceDisplayLineItem["id"];
  name?: InvoiceDisplayLineItem["name"];
  costClassificationType?: CostClassificationTypeDetailOptions | CostClassificationType | null;
  amountInCents?: InvoiceDisplayLineItem["amountInCents"];
  marginInCents?: InvoiceDisplayLineItem["marginInCents"];
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
}

export function newInvoiceDisplayLineItem(
  options: InvoiceDisplayLineItemOptions = {},
  cache: Record<string, any> = {},
): InvoiceDisplayLineItem {
  const o = (options.__typename ? options : cache["InvoiceDisplayLineItem"] = {}) as InvoiceDisplayLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceDisplayLineItem";
  o.id = options.id ?? nextFactoryId("InvoiceDisplayLineItem");
  o.name = options.name ?? "name";
  o.costClassificationType = enumOrDetailOrNullOfCostClassificationType(options.costClassificationType);
  o.amountInCents = options.amountInCents ?? 0;
  o.marginInCents = options.marginInCents ?? null;
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  return o;
}

factories["InvoiceDisplayLineItem"] = newInvoiceDisplayLineItem;

export interface InvoicesPageOptions {
  __typename?: "InvoicesPage";
  entities?: Array<Invoice | InvoiceOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newInvoicesPage(options: InvoicesPageOptions = {}, cache: Record<string, any> = {}): InvoicesPage {
  const o = (options.__typename ? options : cache["InvoicesPage"] = {}) as InvoicesPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoicesPage";
  o.entities = (options.entities ?? []).map((i) => maybeNew("Invoice", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["InvoicesPage"] = newInvoicesPage;

export interface InvoiceDocumentOptions {
  __typename?: "InvoiceDocument";
  id?: InvoiceDocument["id"];
  createdAt?: InvoiceDocument["createdAt"];
  updatedAt?: InvoiceDocument["updatedAt"];
  documentSource?: InvoiceDocumentSourceDetailOptions | InvoiceDocumentSource;
  document?: Document | DocumentOptions;
  invoice?: Invoice | InvoiceOptions;
}

export function newInvoiceDocument(
  options: InvoiceDocumentOptions = {},
  cache: Record<string, any> = {},
): InvoiceDocument {
  const o = (options.__typename ? options : cache["InvoiceDocument"] = {}) as InvoiceDocument;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceDocument";
  o.id = options.id ?? nextFactoryId("InvoiceDocument");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.documentSource = enumOrDetailOfInvoiceDocumentSource(options.documentSource);
  o.document = maybeNew("Document", options.document, cache, options.hasOwnProperty("document"));
  o.invoice = maybeNew("Invoice", options.invoice, cache, options.hasOwnProperty("invoice"));
  return o;
}

factories["InvoiceDocument"] = newInvoiceDocument;

export interface SaveInvoiceDocumentResultOptions {
  __typename?: "SaveInvoiceDocumentResult";
  invoiceDocument?: InvoiceDocument | InvoiceDocumentOptions;
}

export function newSaveInvoiceDocumentResult(
  options: SaveInvoiceDocumentResultOptions = {},
  cache: Record<string, any> = {},
): SaveInvoiceDocumentResult {
  const o = (options.__typename ? options : cache["SaveInvoiceDocumentResult"] = {}) as SaveInvoiceDocumentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveInvoiceDocumentResult";
  o.invoiceDocument = maybeNew(
    "InvoiceDocument",
    options.invoiceDocument,
    cache,
    options.hasOwnProperty("invoiceDocument"),
  );
  return o;
}

factories["SaveInvoiceDocumentResult"] = newSaveInvoiceDocumentResult;

export interface DeleteInvoiceScheduleResultOptions {
  __typename?: "DeleteInvoiceScheduleResult";
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
}

export function newDeleteInvoiceScheduleResult(
  options: DeleteInvoiceScheduleResultOptions = {},
  cache: Record<string, any> = {},
): DeleteInvoiceScheduleResult {
  const o = (options.__typename ? options : cache["DeleteInvoiceScheduleResult"] = {}) as DeleteInvoiceScheduleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteInvoiceScheduleResult";
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  return o;
}

factories["DeleteInvoiceScheduleResult"] = newDeleteInvoiceScheduleResult;

export interface InvoiceScheduleOptions {
  __typename?: "InvoiceSchedule";
  id?: InvoiceSchedule["id"];
  softCostDayOfMonth?: InvoiceSchedule["softCostDayOfMonth"];
  hardCostDayOfMonth?: InvoiceSchedule["hardCostDayOfMonth"];
  hardCostAmountType?: InvoiceScheduleAmountTypeDetailOptions | InvoiceScheduleAmountType;
  softCostAmountType?: InvoiceScheduleAmountTypeDetailOptions | InvoiceScheduleAmountType;
  hardCostTriggerType?: InvoiceScheduleTriggerTypeDetailOptions | InvoiceScheduleTriggerType;
  softCostTriggerType?: InvoiceScheduleTriggerTypeDetailOptions | InvoiceScheduleTriggerType;
  invoiceScheduleTemplate?: InvoiceScheduleTemplate | InvoiceScheduleTemplateOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  items?: Array<InvoiceScheduleItem | InvoiceScheduleItemOptions>;
  invoiceItemsIndependently?: InvoiceSchedule["invoiceItemsIndependently"];
}

export function newInvoiceSchedule(
  options: InvoiceScheduleOptions = {},
  cache: Record<string, any> = {},
): InvoiceSchedule {
  const o = (options.__typename ? options : cache["InvoiceSchedule"] = {}) as InvoiceSchedule;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceSchedule";
  o.id = options.id ?? nextFactoryId("InvoiceSchedule");
  o.softCostDayOfMonth = options.softCostDayOfMonth ?? null;
  o.hardCostDayOfMonth = options.hardCostDayOfMonth ?? null;
  o.hardCostAmountType = enumOrDetailOfInvoiceScheduleAmountType(options.hardCostAmountType);
  o.softCostAmountType = enumOrDetailOfInvoiceScheduleAmountType(options.softCostAmountType);
  o.hardCostTriggerType = enumOrDetailOfInvoiceScheduleTriggerType(options.hardCostTriggerType);
  o.softCostTriggerType = enumOrDetailOfInvoiceScheduleTriggerType(options.softCostTriggerType);
  o.invoiceScheduleTemplate = maybeNew(
    "InvoiceScheduleTemplate",
    options.invoiceScheduleTemplate,
    cache,
    options.hasOwnProperty("invoiceScheduleTemplate"),
  );
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.items = (options.items ?? []).map((i) =>
    maybeNew("InvoiceScheduleItem", i, cache, options.hasOwnProperty("items"))
  );
  o.invoiceItemsIndependently = options.invoiceItemsIndependently ?? false;
  return o;
}

factories["InvoiceSchedule"] = newInvoiceSchedule;

export interface InvoiceScheduleItemOptions {
  __typename?: "InvoiceScheduleItem";
  id?: InvoiceScheduleItem["id"];
  order?: InvoiceScheduleItem["order"];
  iteration?: InvoiceScheduleItem["iteration"];
  invoiceDate?: InvoiceScheduleItem["invoiceDate"];
  amountInBasisPoints?: InvoiceScheduleItem["amountInBasisPoints"];
  originalAmountInCents?: InvoiceScheduleItem["originalAmountInCents"];
  changeOrderAmountInCents?: InvoiceScheduleItem["changeOrderAmountInCents"];
  revisedAmountInCents?: InvoiceScheduleItem["revisedAmountInCents"];
  costClassificationType?: CostClassificationTypeDetailOptions | CostClassificationType;
  invoiceScheduleItemFrequency?: InvoiceScheduleItemFrequencyDetailOptions | InvoiceScheduleItemFrequency;
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions;
  parent?: InvoiceScheduleItemParent | PlanMilestoneOptions | RequireTypename<ScheduleTaskOptions> | null;
  globalParent?: InvoiceScheduleItemGlobalParent | GlobalPlanMilestoneOptions | RequireTypename<GlobalTaskOptions>;
  invoiceScheduledLineItems?: Array<InvoiceScheduledLineItem | InvoiceScheduledLineItemOptions>;
  changeOrders?: Array<HomeownerContractChangeOrder | HomeownerContractChangeOrderOptions>;
  invoiceDelayInDays?: InvoiceScheduleItem["invoiceDelayInDays"];
}

export function newInvoiceScheduleItem(
  options: InvoiceScheduleItemOptions = {},
  cache: Record<string, any> = {},
): InvoiceScheduleItem {
  const o = (options.__typename ? options : cache["InvoiceScheduleItem"] = {}) as InvoiceScheduleItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceScheduleItem";
  o.id = options.id ?? nextFactoryId("InvoiceScheduleItem");
  o.order = options.order ?? 0;
  o.iteration = options.iteration ?? 0;
  o.invoiceDate = options.invoiceDate ?? null;
  o.amountInBasisPoints = options.amountInBasisPoints ?? 0;
  o.originalAmountInCents = options.originalAmountInCents ?? 0;
  o.changeOrderAmountInCents = options.changeOrderAmountInCents ?? 0;
  o.revisedAmountInCents = options.revisedAmountInCents ?? 0;
  o.costClassificationType = enumOrDetailOfCostClassificationType(options.costClassificationType);
  o.invoiceScheduleItemFrequency = enumOrDetailOfInvoiceScheduleItemFrequency(options.invoiceScheduleItemFrequency);
  o.invoiceSchedule = maybeNew(
    "InvoiceSchedule",
    options.invoiceSchedule,
    cache,
    options.hasOwnProperty("invoiceSchedule"),
  );
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "PlanMilestone", options.parent, cache);
  o.globalParent = maybeNew(options.globalParent?.__typename ?? "GlobalPlanMilestone", options.globalParent, cache);
  o.invoiceScheduledLineItems = (options.invoiceScheduledLineItems ?? []).map((i) =>
    maybeNew("InvoiceScheduledLineItem", i, cache, options.hasOwnProperty("invoiceScheduledLineItems"))
  );
  o.changeOrders = (options.changeOrders ?? []).map((i) =>
    maybeNew("HomeownerContractChangeOrder", i, cache, options.hasOwnProperty("changeOrders"))
  );
  o.invoiceDelayInDays = options.invoiceDelayInDays ?? 0;
  return o;
}

factories["InvoiceScheduleItem"] = newInvoiceScheduleItem;

export interface InvoiceScheduleTemplateOptions {
  __typename?: "InvoiceScheduleTemplate";
  id?: InvoiceScheduleTemplate["id"];
  name?: InvoiceScheduleTemplate["name"];
  softCostDayOfMonth?: InvoiceScheduleTemplate["softCostDayOfMonth"];
  hardCostDayOfMonth?: InvoiceScheduleTemplate["hardCostDayOfMonth"];
  createdAt?: InvoiceScheduleTemplate["createdAt"];
  updatedAt?: InvoiceScheduleTemplate["updatedAt"];
  hardCostAmountType?: InvoiceScheduleAmountTypeDetailOptions | InvoiceScheduleAmountType;
  softCostAmountType?: InvoiceScheduleAmountTypeDetailOptions | InvoiceScheduleAmountType;
  hardCostTriggerType?: InvoiceScheduleTriggerTypeDetailOptions | InvoiceScheduleTriggerType;
  softCostTriggerType?: InvoiceScheduleTriggerTypeDetailOptions | InvoiceScheduleTriggerType;
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  customer?: Customer | CustomerOptions | null;
  items?: Array<InvoiceScheduleTemplateItem | InvoiceScheduleTemplateItemOptions>;
  invoiceSchedules?: Array<InvoiceSchedule | InvoiceScheduleOptions>;
  regions?: Array<Region | RegionOptions>;
  invoiceItemsIndependently?: InvoiceScheduleTemplate["invoiceItemsIndependently"];
}

export function newInvoiceScheduleTemplate(
  options: InvoiceScheduleTemplateOptions = {},
  cache: Record<string, any> = {},
): InvoiceScheduleTemplate {
  const o = (options.__typename ? options : cache["InvoiceScheduleTemplate"] = {}) as InvoiceScheduleTemplate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceScheduleTemplate";
  o.id = options.id ?? nextFactoryId("InvoiceScheduleTemplate");
  o.name = options.name ?? "name";
  o.softCostDayOfMonth = options.softCostDayOfMonth ?? null;
  o.hardCostDayOfMonth = options.hardCostDayOfMonth ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.hardCostAmountType = enumOrDetailOfInvoiceScheduleAmountType(options.hardCostAmountType);
  o.softCostAmountType = enumOrDetailOfInvoiceScheduleAmountType(options.softCostAmountType);
  o.hardCostTriggerType = enumOrDetailOfInvoiceScheduleTriggerType(options.hardCostTriggerType);
  o.softCostTriggerType = enumOrDetailOfInvoiceScheduleTriggerType(options.softCostTriggerType);
  o.lotType = enumOrDetailOfLotType(options.lotType);
  o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
  o.customer = maybeNewOrNull("Customer", options.customer, cache);
  o.items = (options.items ?? []).map((i) =>
    maybeNew("InvoiceScheduleTemplateItem", i, cache, options.hasOwnProperty("items"))
  );
  o.invoiceSchedules = (options.invoiceSchedules ?? []).map((i) =>
    maybeNew("InvoiceSchedule", i, cache, options.hasOwnProperty("invoiceSchedules"))
  );
  o.regions = (options.regions ?? []).map((i) => maybeNew("Region", i, cache, options.hasOwnProperty("regions")));
  o.invoiceItemsIndependently = options.invoiceItemsIndependently ?? false;
  return o;
}

factories["InvoiceScheduleTemplate"] = newInvoiceScheduleTemplate;

export interface SaveInvoiceScheduleTemplateResultOptions {
  __typename?: "SaveInvoiceScheduleTemplateResult";
  invoiceScheduleTemplate?: InvoiceScheduleTemplate | InvoiceScheduleTemplateOptions;
}

export function newSaveInvoiceScheduleTemplateResult(
  options: SaveInvoiceScheduleTemplateResultOptions = {},
  cache: Record<string, any> = {},
): SaveInvoiceScheduleTemplateResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveInvoiceScheduleTemplateResult"] = {}) as SaveInvoiceScheduleTemplateResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveInvoiceScheduleTemplateResult";
  o.invoiceScheduleTemplate = maybeNew(
    "InvoiceScheduleTemplate",
    options.invoiceScheduleTemplate,
    cache,
    options.hasOwnProperty("invoiceScheduleTemplate"),
  );
  return o;
}

factories["SaveInvoiceScheduleTemplateResult"] = newSaveInvoiceScheduleTemplateResult;

export interface InvoiceScheduleTemplateItemOptions {
  __typename?: "InvoiceScheduleTemplateItem";
  id?: InvoiceScheduleTemplateItem["id"];
  iterations?: InvoiceScheduleTemplateItem["iterations"];
  amountInBasisPoints?: InvoiceScheduleTemplateItem["amountInBasisPoints"];
  createdAt?: InvoiceScheduleTemplateItem["createdAt"];
  updatedAt?: InvoiceScheduleTemplateItem["updatedAt"];
  costClassificationType?: CostClassificationTypeDetailOptions | CostClassificationType;
  frequency?: InvoiceScheduleItemFrequencyDetailOptions | InvoiceScheduleItemFrequency;
  globalTask?: GlobalTask | GlobalTaskOptions | null;
  invoiceScheduleTemplate?: InvoiceScheduleTemplate | InvoiceScheduleTemplateOptions;
  globalPlanMilestone?: GlobalPlanMilestone | GlobalPlanMilestoneOptions;
  invoiceDelayInDays?: InvoiceScheduleTemplateItem["invoiceDelayInDays"];
}

export function newInvoiceScheduleTemplateItem(
  options: InvoiceScheduleTemplateItemOptions = {},
  cache: Record<string, any> = {},
): InvoiceScheduleTemplateItem {
  const o = (options.__typename ? options : cache["InvoiceScheduleTemplateItem"] = {}) as InvoiceScheduleTemplateItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceScheduleTemplateItem";
  o.id = options.id ?? nextFactoryId("InvoiceScheduleTemplateItem");
  o.iterations = options.iterations ?? 0;
  o.amountInBasisPoints = options.amountInBasisPoints ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costClassificationType = enumOrDetailOfCostClassificationType(options.costClassificationType);
  o.frequency = enumOrDetailOfInvoiceScheduleItemFrequency(options.frequency);
  o.globalTask = maybeNewOrNull("GlobalTask", options.globalTask, cache);
  o.invoiceScheduleTemplate = maybeNew(
    "InvoiceScheduleTemplate",
    options.invoiceScheduleTemplate,
    cache,
    options.hasOwnProperty("invoiceScheduleTemplate"),
  );
  o.globalPlanMilestone = maybeNew(
    "GlobalPlanMilestone",
    options.globalPlanMilestone,
    cache,
    options.hasOwnProperty("globalPlanMilestone"),
  );
  o.invoiceDelayInDays = options.invoiceDelayInDays ?? 0;
  return o;
}

factories["InvoiceScheduleTemplateItem"] = newInvoiceScheduleTemplateItem;

export interface ItemOptions {
  __typename?: "Item";
  id?: Item["id"];
  name?: Item["name"];
  displayName?: Item["displayName"];
  shortName?: Item["shortName"];
  costCode?: CostCode | CostCodeOptions;
  itemCode?: Item["itemCode"];
  fullCode?: Item["fullCode"];
  status?: ItemStatusDetailOptions | ItemStatus;
  internalNote?: Item["internalNote"];
  specifications?: Item["specifications"];
  tradePartnerNote?: Item["tradePartnerNote"];
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  tradeCategory?: TradeCategory | TradeCategoryOptions | null;
  bidItems?: Array<BidItem | BidItemOptions>;
  isContingency?: Item["isContingency"];
  materialAttributeDimensions?: Array<MaterialAttributeDimension | MaterialAttributeDimensionOptions>;
  materialListings?: Array<MaterialListing | MaterialListingOptions>;
  materialBrands?: Array<MaterialBrand | MaterialBrandOptions>;
  materialCodePrefix?: Item["materialCodePrefix"];
  placeholderMaterialListing?: MaterialListing | MaterialListingOptions | null;
  isAnnotated?: Item["isAnnotated"];
  planTaskMappings?: Array<ItemPlanTaskMapping | ItemPlanTaskMappingOptions>;
  version?: Item["version"];
  materialNameFormat?: Item["materialNameFormat"];
  designPackageLocation?: DesignPackageLocationDetailOptions | DesignPackageLocation;
  isMaterialModifier?: Item["isMaterialModifier"];
  isAssemblyRelated?: Item["isAssemblyRelated"];
  parentModifierItems?: Array<Item | ItemOptions>;
  childModifierItems?: Array<Item | ItemOptions>;
  canBecomeMaterialModifier?: PotentialOperation2 | PotentialOperation2Options;
  optionPricingConfig?: OptionPricingConfig | OptionPricingConfigOptions | null;
  materialLeadTimeConfig?: MaterialLeadTimeConfig | MaterialLeadTimeConfigOptions | null;
  minLeadTimeInDays?: Item["minLeadTimeInDays"];
  expectedLeadTimeInDays?: Item["expectedLeadTimeInDays"];
  maxLeadTimeInDays?: Item["maxLeadTimeInDays"];
  history?: Array<History | HistoryOptions>;
  isPlanBasedCost?: Item["isPlanBasedCost"];
  finishScheduleOrder?: Item["finishScheduleOrder"];
}

export function newItem(options: ItemOptions = {}, cache: Record<string, any> = {}): Item {
  const o = (options.__typename ? options : cache["Item"] = {}) as Item;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Item";
  o.id = options.id ?? nextFactoryId("Item");
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.shortName = options.shortName ?? "shortName";
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.itemCode = options.itemCode ?? 0;
  o.fullCode = options.fullCode ?? "fullCode";
  o.status = enumOrDetailOfItemStatus(options.status);
  o.internalNote = options.internalNote ?? null;
  o.specifications = options.specifications ?? null;
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.tradeCategory = maybeNewOrNull("TradeCategory", options.tradeCategory, cache);
  o.bidItems = (options.bidItems ?? []).map((i) => maybeNew("BidItem", i, cache, options.hasOwnProperty("bidItems")));
  o.isContingency = options.isContingency ?? null;
  o.materialAttributeDimensions = (options.materialAttributeDimensions ?? []).map((i) =>
    maybeNew("MaterialAttributeDimension", i, cache, options.hasOwnProperty("materialAttributeDimensions"))
  );
  o.materialListings = (options.materialListings ?? []).map((i) =>
    maybeNew("MaterialListing", i, cache, options.hasOwnProperty("materialListings"))
  );
  o.materialBrands = (options.materialBrands ?? []).map((i) =>
    maybeNew("MaterialBrand", i, cache, options.hasOwnProperty("materialBrands"))
  );
  o.materialCodePrefix = options.materialCodePrefix ?? null;
  o.placeholderMaterialListing = maybeNewOrNull("MaterialListing", options.placeholderMaterialListing, cache);
  o.isAnnotated = options.isAnnotated ?? false;
  o.planTaskMappings = (options.planTaskMappings ?? []).map((i) =>
    maybeNew("ItemPlanTaskMapping", i, cache, options.hasOwnProperty("planTaskMappings"))
  );
  o.version = options.version ?? 0;
  o.materialNameFormat = options.materialNameFormat ?? null;
  o.designPackageLocation = enumOrDetailOfDesignPackageLocation(options.designPackageLocation);
  o.isMaterialModifier = options.isMaterialModifier ?? false;
  o.isAssemblyRelated = options.isAssemblyRelated ?? false;
  o.parentModifierItems = (options.parentModifierItems ?? []).map((i) =>
    maybeNew("Item", i, cache, options.hasOwnProperty("parentModifierItems"))
  );
  o.childModifierItems = (options.childModifierItems ?? []).map((i) =>
    maybeNew("Item", i, cache, options.hasOwnProperty("childModifierItems"))
  );
  o.canBecomeMaterialModifier = maybeNew(
    "PotentialOperation2",
    options.canBecomeMaterialModifier,
    cache,
    options.hasOwnProperty("canBecomeMaterialModifier"),
  );
  o.optionPricingConfig = maybeNewOrNull("OptionPricingConfig", options.optionPricingConfig, cache);
  o.materialLeadTimeConfig = maybeNewOrNull("MaterialLeadTimeConfig", options.materialLeadTimeConfig, cache);
  o.minLeadTimeInDays = options.minLeadTimeInDays ?? 0;
  o.expectedLeadTimeInDays = options.expectedLeadTimeInDays ?? 0;
  o.maxLeadTimeInDays = options.maxLeadTimeInDays ?? 0;
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.isPlanBasedCost = options.isPlanBasedCost ?? false;
  o.finishScheduleOrder = options.finishScheduleOrder ?? 0;
  return o;
}

factories["Item"] = newItem;

export interface ItemPlanTaskMappingOptions {
  __typename?: "ItemPlanTaskMapping";
  id?: ItemPlanTaskMapping["id"];
  createdAt?: ItemPlanTaskMapping["createdAt"];
  updatedAt?: ItemPlanTaskMapping["updatedAt"];
  item?: Item | ItemOptions;
  location?: Location | LocationOptions | null;
  task?: GlobalPlanTask | GlobalPlanTaskOptions;
  estimatedLaborCostInCents?: ItemPlanTaskMapping["estimatedLaborCostInCents"];
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions | null;
}

export function newItemPlanTaskMapping(
  options: ItemPlanTaskMappingOptions = {},
  cache: Record<string, any> = {},
): ItemPlanTaskMapping {
  const o = (options.__typename ? options : cache["ItemPlanTaskMapping"] = {}) as ItemPlanTaskMapping;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemPlanTaskMapping";
  o.id = options.id ?? nextFactoryId("ItemPlanTaskMapping");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.location = maybeNewOrNull("Location", options.location, cache);
  o.task = maybeNew("GlobalPlanTask", options.task, cache, options.hasOwnProperty("task"));
  o.estimatedLaborCostInCents = options.estimatedLaborCostInCents ?? null;
  o.unitOfMeasure = maybeNewOrNull("UnitOfMeasure", options.unitOfMeasure, cache);
  return o;
}

factories["ItemPlanTaskMapping"] = newItemPlanTaskMapping;

export interface SaveItemPlanTaskMappingResultOptions {
  __typename?: "SaveItemPlanTaskMappingResult";
  itemPlanTaskMapping?: ItemPlanTaskMapping | ItemPlanTaskMappingOptions;
}

export function newSaveItemPlanTaskMappingResult(
  options: SaveItemPlanTaskMappingResultOptions = {},
  cache: Record<string, any> = {},
): SaveItemPlanTaskMappingResult {
  const o =
    (options.__typename ? options : cache["SaveItemPlanTaskMappingResult"] = {}) as SaveItemPlanTaskMappingResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveItemPlanTaskMappingResult";
  o.itemPlanTaskMapping = maybeNew(
    "ItemPlanTaskMapping",
    options.itemPlanTaskMapping,
    cache,
    options.hasOwnProperty("itemPlanTaskMapping"),
  );
  return o;
}

factories["SaveItemPlanTaskMappingResult"] = newSaveItemPlanTaskMappingResult;

export interface ItemPlanTaskMappingPageOptions {
  __typename?: "ItemPlanTaskMappingPage";
  entities?: Array<ItemPlanTaskMapping | ItemPlanTaskMappingOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newItemPlanTaskMappingPage(
  options: ItemPlanTaskMappingPageOptions = {},
  cache: Record<string, any> = {},
): ItemPlanTaskMappingPage {
  const o = (options.__typename ? options : cache["ItemPlanTaskMappingPage"] = {}) as ItemPlanTaskMappingPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemPlanTaskMappingPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("ItemPlanTaskMapping", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ItemPlanTaskMappingPage"] = newItemPlanTaskMappingPage;

export interface ItemSlotOptions {
  __typename?: "ItemSlot";
  id?: ItemSlot["id"];
  name?: ItemSlot["name"];
  createdAt?: ItemSlot["createdAt"];
  updatedAt?: ItemSlot["updatedAt"];
  costType?: ItemSlot["costType"];
  costTypeDetail?: CostTypeDetailOptions | CostType;
  item?: Item | ItemOptions;
  location?: Location | LocationOptions;
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
}

export function newItemSlot(options: ItemSlotOptions = {}, cache: Record<string, any> = {}): ItemSlot {
  const o = (options.__typename ? options : cache["ItemSlot"] = {}) as ItemSlot;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemSlot";
  o.id = options.id ?? nextFactoryId("ItemSlot");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costType = options.costType ?? CostType.Labor;
  o.costTypeDetail = enumOrDetailOfCostType(options.costTypeDetail);
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  return o;
}

factories["ItemSlot"] = newItemSlot;

export interface SaveItemSlotResultOptions {
  __typename?: "SaveItemSlotResult";
  itemSlot?: ItemSlot | ItemSlotOptions;
}

export function newSaveItemSlotResult(
  options: SaveItemSlotResultOptions = {},
  cache: Record<string, any> = {},
): SaveItemSlotResult {
  const o = (options.__typename ? options : cache["SaveItemSlotResult"] = {}) as SaveItemSlotResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveItemSlotResult";
  o.itemSlot = maybeNew("ItemSlot", options.itemSlot, cache, options.hasOwnProperty("itemSlot"));
  return o;
}

factories["SaveItemSlotResult"] = newSaveItemSlotResult;

export interface ItemTemplateOptions {
  __typename?: "ItemTemplate";
  id?: ItemTemplate["id"];
  name?: ItemTemplate["name"];
  createdAt?: ItemTemplate["createdAt"];
  updatedAt?: ItemTemplate["updatedAt"];
  items?: Array<ItemTemplateItem | ItemTemplateItemOptions>;
  status?: ItemTemplate["status"];
  statusDetail?: ItemTemplateStatusDetailOptions | ItemTemplateStatus;
  isPlanTemplate?: ItemTemplate["isPlanTemplate"];
  stage?: ItemTemplate["stage"];
  stageDetail?: StageDetailOptions | Stage;
  description?: ItemTemplate["description"];
  applyTemplatePlan?: Array<ItemTemplateItemPlan | ItemTemplateItemPlanOptions>;
  applyTemplatePlanChangeEvent?: Array<ItemTemplateItemPlan | ItemTemplateItemPlanOptions>;
  development?: Development | DevelopmentOptions | null;
  specOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  totalCostInCents?: ItemTemplate["totalCostInCents"];
  isReadyHomeTemplate?: ItemTemplate["isReadyHomeTemplate"];
  canCopyItemsToTemplate?: PotentialOperation2 | PotentialOperation2Options;
  canApplyTo?: PotentialOperation2 | PotentialOperation2Options;
  canUnlock?: PotentialOperation2 | PotentialOperation2Options;
  canActivate?: PotentialOperation2 | PotentialOperation2Options;
  canCreateNewVersion?: PotentialOperation2 | PotentialOperation2Options;
  canEditLineItems?: PotentialOperation2 | PotentialOperation2Options;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  readyPlan?: ReadyPlan | ReadyPlanOptions | null;
  displayName?: ItemTemplate["displayName"];
  hasCloneToTargets?: PotentialOperation2 | PotentialOperation2Options;
  cloneToTargets?: Array<ItemTemplate | ItemTemplateOptions>;
  activatedAt?: ItemTemplate["activatedAt"];
  archivedAt?: ItemTemplate["archivedAt"];
  collection?: ItemTemplateCollection | ItemTemplateCollectionOptions | null;
  itemVersions?: Array<ItemTemplateItemVersion | ItemTemplateItemVersionOptions>;
  major?: ItemTemplate["major"];
  minor?: ItemTemplate["minor"];
  scopeChangeType?: ItemTemplate["scopeChangeType"];
  scopeChangeTypeDetail?: ScopeChangeTypeDetailOptions | ScopeChangeType;
  scopeChangeReason?: ScopeChangeReason | ScopeChangeReasonOptions | null;
  basedOn?: ItemTemplate | ItemTemplateOptions | null;
  templatesBasedOn?: Array<ItemTemplate | ItemTemplateOptions>;
  isVersioned?: ItemTemplate["isVersioned"];
  isLocked?: ItemTemplate["isLocked"];
  appliedToCount?: ItemTemplate["appliedToCount"];
  isLatest?: ItemTemplate["isLatest"];
  isLatestActive?: ItemTemplate["isLatestActive"];
  scopeChangeReasonNote?: ItemTemplate["scopeChangeReasonNote"];
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  version?: ItemTemplate["version"];
  displayVersion?: ItemTemplate["displayVersion"];
  anomalies?: Array<ItemTemplateAnomaly | ItemTemplateAnomalyOptions>;
  contingencyMarkupPercentage?: ItemTemplate["contingencyMarkupPercentage"];
  hasContingencyLineItem?: ItemTemplate["hasContingencyLineItem"];
  sourceForApprovals?: Array<Approval | ApprovalOptions>;
  isUnderwritingTemplate?: ItemTemplate["isUnderwritingTemplate"];
  lastUsedAsUnderwritingTemplate?: ItemTemplate["lastUsedAsUnderwritingTemplate"];
  itemLocations?: Array<Location | LocationOptions>;
  tradeCategories?: Array<TradeCategory | TradeCategoryOptions>;
  costCodes?: Array<CostCode | CostCodeOptions>;
}

export function newItemTemplate(options: ItemTemplateOptions = {}, cache: Record<string, any> = {}): ItemTemplate {
  const o = (options.__typename ? options : cache["ItemTemplate"] = {}) as ItemTemplate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplate";
  o.id = options.id ?? nextFactoryId("ItemTemplate");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.items = (options.items ?? []).map((i) => maybeNew("ItemTemplateItem", i, cache, options.hasOwnProperty("items")));
  o.status = options.status ?? ItemTemplateStatus.Draft;
  o.statusDetail = enumOrDetailOfItemTemplateStatus(options.statusDetail);
  o.isPlanTemplate = options.isPlanTemplate ?? false;
  o.stage = options.stage ?? Stage.PreConPlanning;
  o.stageDetail = enumOrDetailOfStage(options.stageDetail);
  o.description = options.description ?? null;
  o.applyTemplatePlan = (options.applyTemplatePlan ?? []).map((i) =>
    maybeNew("ItemTemplateItemPlan", i, cache, options.hasOwnProperty("applyTemplatePlan"))
  );
  o.applyTemplatePlanChangeEvent = (options.applyTemplatePlanChangeEvent ?? []).map((i) =>
    maybeNew("ItemTemplateItemPlan", i, cache, options.hasOwnProperty("applyTemplatePlanChangeEvent"))
  );
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.specOptions = (options.specOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("specOptions"))
  );
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.isReadyHomeTemplate = options.isReadyHomeTemplate ?? false;
  o.canCopyItemsToTemplate = maybeNew(
    "PotentialOperation2",
    options.canCopyItemsToTemplate,
    cache,
    options.hasOwnProperty("canCopyItemsToTemplate"),
  );
  o.canApplyTo = maybeNew("PotentialOperation2", options.canApplyTo, cache, options.hasOwnProperty("canApplyTo"));
  o.canUnlock = maybeNew("PotentialOperation2", options.canUnlock, cache, options.hasOwnProperty("canUnlock"));
  o.canActivate = maybeNew("PotentialOperation2", options.canActivate, cache, options.hasOwnProperty("canActivate"));
  o.canCreateNewVersion = maybeNew(
    "PotentialOperation2",
    options.canCreateNewVersion,
    cache,
    options.hasOwnProperty("canCreateNewVersion"),
  );
  o.canEditLineItems = maybeNew(
    "PotentialOperation2",
    options.canEditLineItems,
    cache,
    options.hasOwnProperty("canEditLineItems"),
  );
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.readyPlan = maybeNewOrNull("ReadyPlan", options.readyPlan, cache);
  o.displayName = options.displayName ?? "displayName";
  o.hasCloneToTargets = maybeNew(
    "PotentialOperation2",
    options.hasCloneToTargets,
    cache,
    options.hasOwnProperty("hasCloneToTargets"),
  );
  o.cloneToTargets = (options.cloneToTargets ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("cloneToTargets"))
  );
  o.activatedAt = options.activatedAt ?? null;
  o.archivedAt = options.archivedAt ?? null;
  o.collection = maybeNewOrNull("ItemTemplateCollection", options.collection, cache);
  o.itemVersions = (options.itemVersions ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("itemVersions"))
  );
  o.major = options.major ?? 0;
  o.minor = options.minor ?? 0;
  o.scopeChangeType = options.scopeChangeType ?? ScopeChangeType.None;
  o.scopeChangeTypeDetail = enumOrDetailOfScopeChangeType(options.scopeChangeTypeDetail);
  o.scopeChangeReason = maybeNewOrNull("ScopeChangeReason", options.scopeChangeReason, cache);
  o.basedOn = maybeNewOrNull("ItemTemplate", options.basedOn, cache);
  o.templatesBasedOn = (options.templatesBasedOn ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("templatesBasedOn"))
  );
  o.isVersioned = options.isVersioned ?? false;
  o.isLocked = options.isLocked ?? false;
  o.appliedToCount = options.appliedToCount ?? 0;
  o.isLatest = options.isLatest ?? false;
  o.isLatestActive = options.isLatestActive ?? false;
  o.scopeChangeReasonNote = options.scopeChangeReasonNote ?? null;
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.version = options.version ?? "version";
  o.displayVersion = options.displayVersion ?? "displayVersion";
  o.anomalies = (options.anomalies ?? []).map((i) =>
    maybeNew("ItemTemplateAnomaly", i, cache, options.hasOwnProperty("anomalies"))
  );
  o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
  o.hasContingencyLineItem = options.hasContingencyLineItem ?? false;
  o.sourceForApprovals = (options.sourceForApprovals ?? []).map((i) =>
    maybeNew("Approval", i, cache, options.hasOwnProperty("sourceForApprovals"))
  );
  o.isUnderwritingTemplate = options.isUnderwritingTemplate ?? false;
  o.lastUsedAsUnderwritingTemplate = options.lastUsedAsUnderwritingTemplate ?? null;
  o.itemLocations = (options.itemLocations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("itemLocations"))
  );
  o.tradeCategories = (options.tradeCategories ?? []).map((i) =>
    maybeNew("TradeCategory", i, cache, options.hasOwnProperty("tradeCategories"))
  );
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  return o;
}

factories["ItemTemplate"] = newItemTemplate;

export interface ItemTemplateItemPlanOptions {
  __typename?: "ItemTemplateItemPlan";
  itemTemplateItem?: ItemTemplateItem | ItemTemplateItemOptions;
  projectItem?: ProjectItem | ProjectItemOptions | null;
}

export function newItemTemplateItemPlan(
  options: ItemTemplateItemPlanOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateItemPlan {
  const o = (options.__typename ? options : cache["ItemTemplateItemPlan"] = {}) as ItemTemplateItemPlan;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateItemPlan";
  o.itemTemplateItem = maybeNew(
    "ItemTemplateItem",
    options.itemTemplateItem,
    cache,
    options.hasOwnProperty("itemTemplateItem"),
  );
  o.projectItem = maybeNewOrNull("ProjectItem", options.projectItem, cache);
  return o;
}

factories["ItemTemplateItemPlan"] = newItemTemplateItemPlan;

export interface SaveItemTemplateResultOptions {
  __typename?: "SaveItemTemplateResult";
  itemTemplate?: ItemTemplate | ItemTemplateOptions;
}

export function newSaveItemTemplateResult(
  options: SaveItemTemplateResultOptions = {},
  cache: Record<string, any> = {},
): SaveItemTemplateResult {
  const o = (options.__typename ? options : cache["SaveItemTemplateResult"] = {}) as SaveItemTemplateResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveItemTemplateResult";
  o.itemTemplate = maybeNew("ItemTemplate", options.itemTemplate, cache, options.hasOwnProperty("itemTemplate"));
  return o;
}

factories["SaveItemTemplateResult"] = newSaveItemTemplateResult;

export interface SaveItemTemplatesResultOptions {
  __typename?: "SaveItemTemplatesResult";
  itemTemplates?: Array<Maybe<ItemTemplate | ItemTemplateOptions>> | null;
}

export function newSaveItemTemplatesResult(
  options: SaveItemTemplatesResultOptions = {},
  cache: Record<string, any> = {},
): SaveItemTemplatesResult {
  const o = (options.__typename ? options : cache["SaveItemTemplatesResult"] = {}) as SaveItemTemplatesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveItemTemplatesResult";
  o.itemTemplates = (options.itemTemplates ?? []).map((i) => maybeNewOrNull("ItemTemplate", i, cache));
  return o;
}

factories["SaveItemTemplatesResult"] = newSaveItemTemplatesResult;

export interface ApplyItemTemplateResultOptions {
  __typename?: "ApplyItemTemplateResult";
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
  projectStage?: ProjectStage | ProjectStageOptions;
  userErrors?: Array<UserError | UserErrorOptions> | null;
}

export function newApplyItemTemplateResult(
  options: ApplyItemTemplateResultOptions = {},
  cache: Record<string, any> = {},
): ApplyItemTemplateResult {
  const o = (options.__typename ? options : cache["ApplyItemTemplateResult"] = {}) as ApplyItemTemplateResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ApplyItemTemplateResult";
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["ApplyItemTemplateResult"] = newApplyItemTemplateResult;

export interface ApplyItemTemplateToChangeEventResultOptions {
  __typename?: "ApplyItemTemplateToChangeEventResult";
  lineItems?: Array<ChangeEventLineItem | ChangeEventLineItemOptions>;
  changeEvent?: ChangeEvent | ChangeEventOptions;
}

export function newApplyItemTemplateToChangeEventResult(
  options: ApplyItemTemplateToChangeEventResultOptions = {},
  cache: Record<string, any> = {},
): ApplyItemTemplateToChangeEventResult {
  const o =
    (options.__typename
      ? options
      : cache["ApplyItemTemplateToChangeEventResult"] = {}) as ApplyItemTemplateToChangeEventResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ApplyItemTemplateToChangeEventResult";
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("ChangeEventLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
  return o;
}

factories["ApplyItemTemplateToChangeEventResult"] = newApplyItemTemplateToChangeEventResult;

export interface CloneItemTemplateResultOptions {
  __typename?: "CloneItemTemplateResult";
  original?: ItemTemplate | ItemTemplateOptions;
  clone?: ItemTemplate | ItemTemplateOptions;
}

export function newCloneItemTemplateResult(
  options: CloneItemTemplateResultOptions = {},
  cache: Record<string, any> = {},
): CloneItemTemplateResult {
  const o = (options.__typename ? options : cache["CloneItemTemplateResult"] = {}) as CloneItemTemplateResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CloneItemTemplateResult";
  o.original = maybeNew("ItemTemplate", options.original, cache, options.hasOwnProperty("original"));
  o.clone = maybeNew("ItemTemplate", options.clone, cache, options.hasOwnProperty("clone"));
  return o;
}

factories["CloneItemTemplateResult"] = newCloneItemTemplateResult;

export interface CopyItemTemplateItemsResultOptions {
  __typename?: "CopyItemTemplateItemsResult";
  targetTemplate?: ItemTemplate | ItemTemplateOptions;
  sourceTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
  sourceItemVersions?: Array<ItemTemplateItemVersion | ItemTemplateItemVersionOptions>;
  copiedItems?: Array<ItemTemplateItem | ItemTemplateItemOptions>;
  copiedItemVersions?: Array<ItemTemplateItemVersion | ItemTemplateItemVersionOptions>;
}

export function newCopyItemTemplateItemsResult(
  options: CopyItemTemplateItemsResultOptions = {},
  cache: Record<string, any> = {},
): CopyItemTemplateItemsResult {
  const o = (options.__typename ? options : cache["CopyItemTemplateItemsResult"] = {}) as CopyItemTemplateItemsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CopyItemTemplateItemsResult";
  o.targetTemplate = maybeNew("ItemTemplate", options.targetTemplate, cache, options.hasOwnProperty("targetTemplate"));
  o.sourceTemplates = (options.sourceTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("sourceTemplates"))
  );
  o.sourceItemVersions = (options.sourceItemVersions ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("sourceItemVersions"))
  );
  o.copiedItems = (options.copiedItems ?? []).map((i) =>
    maybeNew("ItemTemplateItem", i, cache, options.hasOwnProperty("copiedItems"))
  );
  o.copiedItemVersions = (options.copiedItemVersions ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("copiedItemVersions"))
  );
  return o;
}

factories["CopyItemTemplateItemsResult"] = newCopyItemTemplateItemsResult;

export interface CreateNewItemTemplateVersionsResultOptions {
  __typename?: "CreateNewItemTemplateVersionsResult";
  newTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
}

export function newCreateNewItemTemplateVersionsResult(
  options: CreateNewItemTemplateVersionsResultOptions = {},
  cache: Record<string, any> = {},
): CreateNewItemTemplateVersionsResult {
  const o =
    (options.__typename
      ? options
      : cache["CreateNewItemTemplateVersionsResult"] = {}) as CreateNewItemTemplateVersionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateNewItemTemplateVersionsResult";
  o.newTemplates = (options.newTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("newTemplates"))
  );
  return o;
}

factories["CreateNewItemTemplateVersionsResult"] = newCreateNewItemTemplateVersionsResult;

export interface ActivateItemTemplateVersionsResultOptions {
  __typename?: "ActivateItemTemplateVersionsResult";
  activatedTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
}

export function newActivateItemTemplateVersionsResult(
  options: ActivateItemTemplateVersionsResultOptions = {},
  cache: Record<string, any> = {},
): ActivateItemTemplateVersionsResult {
  const o =
    (options.__typename
      ? options
      : cache["ActivateItemTemplateVersionsResult"] = {}) as ActivateItemTemplateVersionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ActivateItemTemplateVersionsResult";
  o.activatedTemplates = (options.activatedTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("activatedTemplates"))
  );
  return o;
}

factories["ActivateItemTemplateVersionsResult"] = newActivateItemTemplateVersionsResult;

export interface ItemTemplateAnomalyOptions {
  __typename?: "ItemTemplateAnomaly";
  id?: ItemTemplateAnomaly["id"];
  type?: ItemTemplateAnomaly["type"];
  parent?: ItemTemplateAnomalyParent | ItemTemplateOptions | RequireTypename<ItemTemplateItemVersionOptions>;
  description?: ItemTemplateAnomaly["description"];
}

export function newItemTemplateAnomaly(
  options: ItemTemplateAnomalyOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateAnomaly {
  const o = (options.__typename ? options : cache["ItemTemplateAnomaly"] = {}) as ItemTemplateAnomaly;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateAnomaly";
  o.id = options.id ?? nextFactoryId("ItemTemplateAnomaly");
  o.type = options.type ?? ItemTemplateAnomalyType.TemplateMissingScopeForOption;
  o.parent = maybeNew(options.parent?.__typename ?? "ItemTemplate", options.parent, cache);
  o.description = options.description ?? "description";
  return o;
}

factories["ItemTemplateAnomaly"] = newItemTemplateAnomaly;

export interface ItemTemplateCollectionOptions {
  __typename?: "ItemTemplateCollection";
  id?: ItemTemplateCollection["id"];
  createdAt?: ItemTemplateCollection["createdAt"];
  updatedAt?: ItemTemplateCollection["updatedAt"];
  templates?: Array<ItemTemplate | ItemTemplateOptions>;
  latest?: ItemTemplate | ItemTemplateOptions | null;
}

export function newItemTemplateCollection(
  options: ItemTemplateCollectionOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateCollection {
  const o = (options.__typename ? options : cache["ItemTemplateCollection"] = {}) as ItemTemplateCollection;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateCollection";
  o.id = options.id ?? nextFactoryId("ItemTemplateCollection");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.templates = (options.templates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("templates"))
  );
  o.latest = maybeNewOrNull("ItemTemplate", options.latest, cache);
  return o;
}

factories["ItemTemplateCollection"] = newItemTemplateCollection;

export interface ItemTemplateCostUpdateOptions {
  __typename?: "ItemTemplateCostUpdate";
  id?: ItemTemplateCostUpdate["id"];
  completed?: ItemTemplateCostUpdate["completed"];
  createdAt?: ItemTemplateCostUpdate["createdAt"];
  updatedAt?: ItemTemplateCostUpdate["updatedAt"];
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
  itemTemplate?: ItemTemplate | ItemTemplateOptions;
}

export function newItemTemplateCostUpdate(
  options: ItemTemplateCostUpdateOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateCostUpdate {
  const o = (options.__typename ? options : cache["ItemTemplateCostUpdate"] = {}) as ItemTemplateCostUpdate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateCostUpdate";
  o.id = options.id ?? nextFactoryId("ItemTemplateCostUpdate");
  o.completed = options.completed ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.bidContractRevision = maybeNew(
    "BidContractRevision",
    options.bidContractRevision,
    cache,
    options.hasOwnProperty("bidContractRevision"),
  );
  o.itemTemplate = maybeNew("ItemTemplate", options.itemTemplate, cache, options.hasOwnProperty("itemTemplate"));
  return o;
}

factories["ItemTemplateCostUpdate"] = newItemTemplateCostUpdate;

export interface ItemTemplateItemOptions {
  __typename?: "ItemTemplateItem";
  id?: ItemTemplateItem["id"];
  identityId?: ItemTemplateItem["identityId"];
  slot?: ItemSlot | ItemSlotOptions;
  item?: Item | ItemOptions;
  template?: ItemTemplate | ItemTemplateOptions;
  location?: Location | LocationOptions;
  quantity?: ItemTemplateItem["quantity"];
  createdAt?: ItemTemplateItem["createdAt"];
  updatedAt?: ItemTemplateItem["updatedAt"];
  costType?: ItemTemplateItem["costType"];
  costTypeDetail?: CostTypeDetailOptions | CostType;
  specifications?: ItemTemplateItem["specifications"];
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  tradePartnerNote?: ItemTemplateItem["tradePartnerNote"];
  internalNote?: ItemTemplateItem["internalNote"];
  name?: ItemTemplateItem["name"];
  displayName?: ItemTemplateItem["displayName"];
  parent?: ItemTemplate | ItemTemplateOptions;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions | null;
  first?: ItemTemplate | ItemTemplateOptions;
  totalCostInCents?: ItemTemplateItem["totalCostInCents"];
  unitCostInCents?: ItemTemplateItem["unitCostInCents"];
  canDeleteItem?: PotentialOperation2 | PotentialOperation2Options;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  preferredBidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  identityHash?: ItemTemplateItem["identityHash"];
  majorHash?: ItemTemplateItem["majorHash"];
  minorHash?: ItemTemplateItem["minorHash"];
  versions?: Array<ItemTemplateItemVersion | ItemTemplateItemVersionOptions>;
  basedOn?: ItemTemplateItem | ItemTemplateItemOptions | null;
  itemsBasedOn?: Array<ItemTemplateItem | ItemTemplateItemOptions>;
  original?: ItemTemplateItem | ItemTemplateItemOptions | null;
  bidItem?: BidItem | BidItemOptions | null;
  isDisabledMaterialVariant?: ItemTemplateItem["isDisabledMaterialVariant"];
  potentialBidItems?: Array<BidItem | BidItemOptions>;
  elevationIds?: ItemTemplateItem["elevationIds"];
  specOptionIds?: ItemTemplateItem["specOptionIds"];
  otherOptionIds?: ItemTemplateItem["otherOptionIds"];
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  blueprintUrl?: Url | UrlOptions;
  bidItemTemplateItem?: ItemTemplateItem | ItemTemplateItemOptions | null;
  task?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  costStatus?: ItemTemplateItemCostStatusDetailOptions | ItemTemplateItemCostStatus;
  materialVariant?: MaterialVariant | MaterialVariantOptions | null;
  development?: Development | DevelopmentOptions | null;
  costEstimate?: CostEstimate | CostEstimateOptions;
  customPlaceholderName?: ItemTemplateItem["customPlaceholderName"];
}

export function newItemTemplateItem(
  options: ItemTemplateItemOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateItem {
  const o = (options.__typename ? options : cache["ItemTemplateItem"] = {}) as ItemTemplateItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateItem";
  o.id = options.id ?? nextFactoryId("ItemTemplateItem");
  o.identityId = options.identityId ?? "identityId";
  o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.template = maybeNew("ItemTemplate", options.template, cache, options.hasOwnProperty("template"));
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.quantity = options.quantity ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costType = options.costType ?? CostType.Labor;
  o.costTypeDetail = enumOrDetailOfCostType(options.costTypeDetail);
  o.specifications = options.specifications ?? null;
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.internalNote = options.internalNote ?? null;
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.parent = maybeNew("ItemTemplate", options.parent, cache, options.hasOwnProperty("parent"));
  o.readyPlan = maybeNewOrNull("ReadyPlanLike", options.readyPlan, cache);
  o.first = maybeNew("ItemTemplate", options.first, cache, options.hasOwnProperty("first"));
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.unitCostInCents = options.unitCostInCents ?? 0;
  o.canDeleteItem = maybeNew(
    "PotentialOperation2",
    options.canDeleteItem,
    cache,
    options.hasOwnProperty("canDeleteItem"),
  );
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.preferredBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.preferredBidContractLineItem, cache);
  o.identityHash = options.identityHash ?? null;
  o.majorHash = options.majorHash ?? null;
  o.minorHash = options.minorHash ?? null;
  o.versions = (options.versions ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("versions"))
  );
  o.basedOn = maybeNewOrNull("ItemTemplateItem", options.basedOn, cache);
  o.itemsBasedOn = (options.itemsBasedOn ?? []).map((i) =>
    maybeNew("ItemTemplateItem", i, cache, options.hasOwnProperty("itemsBasedOn"))
  );
  o.original = maybeNewOrNull("ItemTemplateItem", options.original, cache);
  o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
  o.isDisabledMaterialVariant = options.isDisabledMaterialVariant ?? false;
  o.potentialBidItems = (options.potentialBidItems ?? []).map((i) =>
    maybeNew("BidItem", i, cache, options.hasOwnProperty("potentialBidItems"))
  );
  o.elevationIds = options.elevationIds ?? [];
  o.specOptionIds = options.specOptionIds ?? [];
  o.otherOptionIds = options.otherOptionIds ?? [];
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.bidItemTemplateItem = maybeNewOrNull("ItemTemplateItem", options.bidItemTemplateItem, cache);
  o.task = maybeNewOrNull("GlobalPlanTask", options.task, cache);
  o.costStatus = enumOrDetailOfItemTemplateItemCostStatus(options.costStatus);
  o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.costEstimate = maybeNew("CostEstimate", options.costEstimate, cache, options.hasOwnProperty("costEstimate"));
  o.customPlaceholderName = options.customPlaceholderName ?? null;
  return o;
}

factories["ItemTemplateItem"] = newItemTemplateItem;

export interface CostEstimateOptions {
  __typename?: "CostEstimate";
  costInCents?: CostEstimate["costInCents"];
}

export function newCostEstimate(options: CostEstimateOptions = {}, cache: Record<string, any> = {}): CostEstimate {
  const o = (options.__typename ? options : cache["CostEstimate"] = {}) as CostEstimate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostEstimate";
  o.costInCents = options.costInCents ?? 0;
  return o;
}

factories["CostEstimate"] = newCostEstimate;

export interface ItemTemplateItemVersionsPageOptions {
  __typename?: "ItemTemplateItemVersionsPage";
  items?: Array<ItemTemplateItemVersion | ItemTemplateItemVersionOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
  groupTotals?: Array<ItemTemplateItemVersionGroupTotal | ItemTemplateItemVersionGroupTotalOptions>;
}

export function newItemTemplateItemVersionsPage(
  options: ItemTemplateItemVersionsPageOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateItemVersionsPage {
  const o = (options.__typename ? options : cache["ItemTemplateItemVersionsPage"] = {}) as ItemTemplateItemVersionsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateItemVersionsPage";
  o.items = (options.items ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("items"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  o.groupTotals = (options.groupTotals ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersionGroupTotal", i, cache, options.hasOwnProperty("groupTotals"))
  );
  return o;
}

factories["ItemTemplateItemVersionsPage"] = newItemTemplateItemVersionsPage;

export interface ItemTemplateItemVersionGroupTotalOptions {
  __typename?: "ItemTemplateItemVersionGroupTotal";
  groupId?: ItemTemplateItemVersionGroupTotal["groupId"];
  totalCostInCents?: ItemTemplateItemVersionGroupTotal["totalCostInCents"];
  itivsInGroup?: ItemTemplateItemVersionGroupTotal["itivsInGroup"];
  itivIdsInGroup?: ItemTemplateItemVersionGroupTotal["itivIdsInGroup"];
  displayName?: ItemTemplateItemVersionGroupTotal["displayName"];
  materialsInGroup?: ItemTemplateItemVersionGroupTotal["materialsInGroup"];
  tasksInGroup?: ItemTemplateItemVersionGroupTotal["tasksInGroup"];
}

export function newItemTemplateItemVersionGroupTotal(
  options: ItemTemplateItemVersionGroupTotalOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateItemVersionGroupTotal {
  const o =
    (options.__typename
      ? options
      : cache["ItemTemplateItemVersionGroupTotal"] = {}) as ItemTemplateItemVersionGroupTotal;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateItemVersionGroupTotal";
  o.groupId = options.groupId ?? "groupId";
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.itivsInGroup = options.itivsInGroup ?? 0;
  o.itivIdsInGroup = options.itivIdsInGroup ?? [];
  o.displayName = options.displayName ?? "displayName";
  o.materialsInGroup = options.materialsInGroup ?? 0;
  o.tasksInGroup = options.tasksInGroup ?? 0;
  return o;
}

factories["ItemTemplateItemVersionGroupTotal"] = newItemTemplateItemVersionGroupTotal;

export interface ItiAnomalyOptions {
  __typename?: "ItiAnomaly";
  description?: ItiAnomaly["description"];
}

export function newItiAnomaly(options: ItiAnomalyOptions = {}, cache: Record<string, any> = {}): ItiAnomaly {
  const o = (options.__typename ? options : cache["ItiAnomaly"] = {}) as ItiAnomaly;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItiAnomaly";
  o.description = options.description ?? "description";
  return o;
}

factories["ItiAnomaly"] = newItiAnomaly;

export interface SaveItemTemplateItemVersionsResultOptions {
  __typename?: "SaveItemTemplateItemVersionsResult";
  itemTemplateItemVersions?: Array<ItemTemplateItemVersion | ItemTemplateItemVersionOptions>;
  removed?: Array<ItemTemplateItemVersion | ItemTemplateItemVersionOptions>;
  deleted?: SaveItemTemplateItemVersionsResult["deleted"];
  groupTotals?: Array<ItemTemplateItemVersionGroupTotal | ItemTemplateItemVersionGroupTotalOptions>;
}

export function newSaveItemTemplateItemVersionsResult(
  options: SaveItemTemplateItemVersionsResultOptions = {},
  cache: Record<string, any> = {},
): SaveItemTemplateItemVersionsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveItemTemplateItemVersionsResult"] = {}) as SaveItemTemplateItemVersionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveItemTemplateItemVersionsResult";
  o.itemTemplateItemVersions = (options.itemTemplateItemVersions ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("itemTemplateItemVersions"))
  );
  o.removed = (options.removed ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("removed"))
  );
  o.deleted = options.deleted ?? [];
  o.groupTotals = (options.groupTotals ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersionGroupTotal", i, cache, options.hasOwnProperty("groupTotals"))
  );
  return o;
}

factories["SaveItemTemplateItemVersionsResult"] = newSaveItemTemplateItemVersionsResult;

export interface DedupeReadyPlanItemTemplateItemVersionsResultOptions {
  __typename?: "DedupeReadyPlanItemTemplateItemVersionsResult";
  dedupedItemTemplateItemVersions?: Array<DedupedItemTemplateItemVersion | DedupedItemTemplateItemVersionOptions>;
  affectedTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
  affectedDevelopments?: Array<Development | DevelopmentOptions>;
  affectedReadyPlans?: Array<ReadyPlan | ReadyPlanOptions>;
}

export function newDedupeReadyPlanItemTemplateItemVersionsResult(
  options: DedupeReadyPlanItemTemplateItemVersionsResultOptions = {},
  cache: Record<string, any> = {},
): DedupeReadyPlanItemTemplateItemVersionsResult {
  const o =
    (options.__typename
      ? options
      : cache["DedupeReadyPlanItemTemplateItemVersionsResult"] = {}) as DedupeReadyPlanItemTemplateItemVersionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DedupeReadyPlanItemTemplateItemVersionsResult";
  o.dedupedItemTemplateItemVersions = (options.dedupedItemTemplateItemVersions ?? []).map((i) =>
    maybeNew("DedupedItemTemplateItemVersion", i, cache, options.hasOwnProperty("dedupedItemTemplateItemVersions"))
  );
  o.affectedTemplates = (options.affectedTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("affectedTemplates"))
  );
  o.affectedDevelopments = (options.affectedDevelopments ?? []).map((i) =>
    maybeNew("Development", i, cache, options.hasOwnProperty("affectedDevelopments"))
  );
  o.affectedReadyPlans = (options.affectedReadyPlans ?? []).map((i) =>
    maybeNew("ReadyPlan", i, cache, options.hasOwnProperty("affectedReadyPlans"))
  );
  return o;
}

factories["DedupeReadyPlanItemTemplateItemVersionsResult"] = newDedupeReadyPlanItemTemplateItemVersionsResult;

export interface DedupedItemTemplateItemVersionOptions {
  __typename?: "DedupedItemTemplateItemVersion";
  primary?: ItemTemplateItemVersion | ItemTemplateItemVersionOptions;
  removes?: Array<ItemTemplateItemVersion | ItemTemplateItemVersionOptions>;
}

export function newDedupedItemTemplateItemVersion(
  options: DedupedItemTemplateItemVersionOptions = {},
  cache: Record<string, any> = {},
): DedupedItemTemplateItemVersion {
  const o =
    (options.__typename ? options : cache["DedupedItemTemplateItemVersion"] = {}) as DedupedItemTemplateItemVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DedupedItemTemplateItemVersion";
  o.primary = maybeNew("ItemTemplateItemVersion", options.primary, cache, options.hasOwnProperty("primary"));
  o.removes = (options.removes ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("removes"))
  );
  return o;
}

factories["DedupedItemTemplateItemVersion"] = newDedupedItemTemplateItemVersion;

export interface AddJobResultOptions {
  __typename?: "AddJobResult";
  trackedJob?: TrackedJob | TrackedJobOptions | null;
  emptyResult?: AddJobResult["emptyResult"];
}

export function newAddJobResult(options: AddJobResultOptions = {}, cache: Record<string, any> = {}): AddJobResult {
  const o = (options.__typename ? options : cache["AddJobResult"] = {}) as AddJobResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AddJobResult";
  o.trackedJob = maybeNewOrNull("TrackedJob", options.trackedJob, cache);
  o.emptyResult = options.emptyResult ?? null;
  return o;
}

factories["AddJobResult"] = newAddJobResult;

export interface AddJobsResultOptions {
  __typename?: "AddJobsResult";
  trackedJobs?: Array<TrackedJob | TrackedJobOptions>;
  emptyResult?: AddJobsResult["emptyResult"];
}

export function newAddJobsResult(options: AddJobsResultOptions = {}, cache: Record<string, any> = {}): AddJobsResult {
  const o = (options.__typename ? options : cache["AddJobsResult"] = {}) as AddJobsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AddJobsResult";
  o.trackedJobs = (options.trackedJobs ?? []).map((i) =>
    maybeNew("TrackedJob", i, cache, options.hasOwnProperty("trackedJobs"))
  );
  o.emptyResult = options.emptyResult ?? null;
  return o;
}

factories["AddJobsResult"] = newAddJobsResult;

export interface JobLogOptions {
  __typename?: "JobLog";
  id?: JobLog["id"];
  logDate?: JobLog["logDate"];
  createdAt?: JobLog["createdAt"];
  updatedAt?: JobLog["updatedAt"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  notes?: Array<JobLogNote | JobLogNoteOptions>;
  images?: Array<JobLogImage | JobLogImageOptions>;
  minTemperature?: JobLog["minTemperature"];
  maxTemperature?: JobLog["maxTemperature"];
  humidity?: JobLog["humidity"];
  wind?: JobLog["wind"];
  weatherType?: JobLog["weatherType"];
  weatherTypeDetail?: WeatherTypeDetailOptions | WeatherType | null;
  weatherTypeChanged?: JobLog["weatherTypeChanged"];
}

export function newJobLog(options: JobLogOptions = {}, cache: Record<string, any> = {}): JobLog {
  const o = (options.__typename ? options : cache["JobLog"] = {}) as JobLog;
  (cache.all ??= new Set()).add(o);
  o.__typename = "JobLog";
  o.id = options.id ?? nextFactoryId("JobLog");
  o.logDate = options.logDate ?? newDate();
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.notes = (options.notes ?? []).map((i) => maybeNew("JobLogNote", i, cache, options.hasOwnProperty("notes")));
  o.images = (options.images ?? []).map((i) => maybeNew("JobLogImage", i, cache, options.hasOwnProperty("images")));
  o.minTemperature = options.minTemperature ?? null;
  o.maxTemperature = options.maxTemperature ?? null;
  o.humidity = options.humidity ?? null;
  o.wind = options.wind ?? null;
  o.weatherType = options.weatherType ?? null;
  o.weatherTypeDetail = enumOrDetailOrNullOfWeatherType(options.weatherTypeDetail);
  o.weatherTypeChanged = options.weatherTypeChanged ?? null;
  return o;
}

factories["JobLog"] = newJobLog;

export interface SaveJobLogResultOptions {
  __typename?: "SaveJobLogResult";
  jobLog?: JobLog | JobLogOptions;
}

export function newSaveJobLogResult(
  options: SaveJobLogResultOptions = {},
  cache: Record<string, any> = {},
): SaveJobLogResult {
  const o = (options.__typename ? options : cache["SaveJobLogResult"] = {}) as SaveJobLogResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveJobLogResult";
  o.jobLog = maybeNew("JobLog", options.jobLog, cache, options.hasOwnProperty("jobLog"));
  return o;
}

factories["SaveJobLogResult"] = newSaveJobLogResult;

export interface DuplicateJobLogsResultOptions {
  __typename?: "DuplicateJobLogsResult";
  jobLog?: JobLog | JobLogOptions;
  clonedJobLogs?: Array<JobLog | JobLogOptions>;
  copiedJobLogs?: Array<JobLog | JobLogOptions>;
}

export function newDuplicateJobLogsResult(
  options: DuplicateJobLogsResultOptions = {},
  cache: Record<string, any> = {},
): DuplicateJobLogsResult {
  const o = (options.__typename ? options : cache["DuplicateJobLogsResult"] = {}) as DuplicateJobLogsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DuplicateJobLogsResult";
  o.jobLog = maybeNew("JobLog", options.jobLog, cache, options.hasOwnProperty("jobLog"));
  o.clonedJobLogs = (options.clonedJobLogs ?? []).map((i) =>
    maybeNew("JobLog", i, cache, options.hasOwnProperty("clonedJobLogs"))
  );
  o.copiedJobLogs = (options.copiedJobLogs ?? []).map((i) =>
    maybeNew("JobLog", i, cache, options.hasOwnProperty("copiedJobLogs"))
  );
  return o;
}

factories["DuplicateJobLogsResult"] = newDuplicateJobLogsResult;

export interface JobLogsPageResultOptions {
  __typename?: "JobLogsPageResult";
  entities?: Array<JobLog | JobLogOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
  logDates?: JobLogsPageResult["logDates"];
}

export function newJobLogsPageResult(
  options: JobLogsPageResultOptions = {},
  cache: Record<string, any> = {},
): JobLogsPageResult {
  const o = (options.__typename ? options : cache["JobLogsPageResult"] = {}) as JobLogsPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "JobLogsPageResult";
  o.entities = (options.entities ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  o.logDates = options.logDates ?? [];
  return o;
}

factories["JobLogsPageResult"] = newJobLogsPageResult;

export interface JobLogImageOptions {
  __typename?: "JobLogImage";
  id?: JobLogImage["id"];
  createdAt?: JobLogImage["createdAt"];
  updatedAt?: JobLogImage["updatedAt"];
  asset?: Asset | AssetOptions;
  jobLog?: JobLog | JobLogOptions;
  parent?: JobLogImageParent | JobLogOptions | RequireTypename<JobLogNoteOptions> | null;
  sightlineJobId?: JobLogImage["sightlineJobId"];
  sightlineUrl?: JobLogImage["sightlineUrl"];
  sightlineFrameId?: JobLogImage["sightlineFrameId"];
}

export function newJobLogImage(options: JobLogImageOptions = {}, cache: Record<string, any> = {}): JobLogImage {
  const o = (options.__typename ? options : cache["JobLogImage"] = {}) as JobLogImage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "JobLogImage";
  o.id = options.id ?? nextFactoryId("JobLogImage");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  o.jobLog = maybeNew("JobLog", options.jobLog, cache, options.hasOwnProperty("jobLog"));
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "JobLog", options.parent, cache);
  o.sightlineJobId = options.sightlineJobId ?? null;
  o.sightlineUrl = options.sightlineUrl ?? null;
  o.sightlineFrameId = options.sightlineFrameId ?? null;
  return o;
}

factories["JobLogImage"] = newJobLogImage;

export interface SaveJobLogImageResultOptions {
  __typename?: "SaveJobLogImageResult";
  jobLogImage?: JobLogImage | JobLogImageOptions;
}

export function newSaveJobLogImageResult(
  options: SaveJobLogImageResultOptions = {},
  cache: Record<string, any> = {},
): SaveJobLogImageResult {
  const o = (options.__typename ? options : cache["SaveJobLogImageResult"] = {}) as SaveJobLogImageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveJobLogImageResult";
  o.jobLogImage = maybeNew("JobLogImage", options.jobLogImage, cache, options.hasOwnProperty("jobLogImage"));
  return o;
}

factories["SaveJobLogImageResult"] = newSaveJobLogImageResult;

export interface DeleteJobLogImageResultOptions {
  __typename?: "DeleteJobLogImageResult";
  jobLog?: JobLog | JobLogOptions;
  parent?: JobLogImageParent | JobLogOptions | RequireTypename<JobLogNoteOptions> | null;
}

export function newDeleteJobLogImageResult(
  options: DeleteJobLogImageResultOptions = {},
  cache: Record<string, any> = {},
): DeleteJobLogImageResult {
  const o = (options.__typename ? options : cache["DeleteJobLogImageResult"] = {}) as DeleteJobLogImageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteJobLogImageResult";
  o.jobLog = maybeNew("JobLog", options.jobLog, cache, options.hasOwnProperty("jobLog"));
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "JobLog", options.parent, cache);
  return o;
}

factories["DeleteJobLogImageResult"] = newDeleteJobLogImageResult;

export interface SaveJobLogNoteResultOptions {
  __typename?: "SaveJobLogNoteResult";
  jobLogNote?: JobLogNote | JobLogNoteOptions;
}

export function newSaveJobLogNoteResult(
  options: SaveJobLogNoteResultOptions = {},
  cache: Record<string, any> = {},
): SaveJobLogNoteResult {
  const o = (options.__typename ? options : cache["SaveJobLogNoteResult"] = {}) as SaveJobLogNoteResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveJobLogNoteResult";
  o.jobLogNote = maybeNew("JobLogNote", options.jobLogNote, cache, options.hasOwnProperty("jobLogNote"));
  return o;
}

factories["SaveJobLogNoteResult"] = newSaveJobLogNoteResult;

export interface DeleteJobLogNoteResultOptions {
  __typename?: "DeleteJobLogNoteResult";
  jobLog?: JobLog | JobLogOptions;
}

export function newDeleteJobLogNoteResult(
  options: DeleteJobLogNoteResultOptions = {},
  cache: Record<string, any> = {},
): DeleteJobLogNoteResult {
  const o = (options.__typename ? options : cache["DeleteJobLogNoteResult"] = {}) as DeleteJobLogNoteResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteJobLogNoteResult";
  o.jobLog = maybeNew("JobLog", options.jobLog, cache, options.hasOwnProperty("jobLog"));
  return o;
}

factories["DeleteJobLogNoteResult"] = newDeleteJobLogNoteResult;

export interface LienWaiverOptions {
  __typename?: "LienWaiver";
  id?: LienWaiver["id"];
  amountInCents?: LienWaiver["amountInCents"];
  createdAt?: LienWaiver["createdAt"];
  updatedAt?: LienWaiver["updatedAt"];
  condition?: LienWaiverConditionDetailOptions | LienWaiverCondition;
  type?: LienWaiverTypeDetailOptions | LienWaiverType;
  pandaDoc?: PandaDoc | PandaDocOptions | null;
  status?: LienWaiverStatusDetailOptions | LienWaiverStatus;
  document?: Document | DocumentOptions | null;
  parent?:
    | LienWaiverParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<BillOptions>
    | RequireTypename<InvoiceOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  throughDate?: LienWaiver["throughDate"];
  claimant?: LienWaiverClaimant | BuilderOptions | RequireTypename<TradePartnerOptions>;
  payer?: LienWaiverPayer | BuilderOptions | RequireTypename<ClientOptions>;
  payerName?: LienWaiver["payerName"];
  owner?: LienWaiverOwner | CustomerOptions | RequireTypename<ClientOptions>;
  signatory?: LienWaiverSignatory | InternalUserOptions | RequireTypename<TradePartnerContactOptions> | null;
  canCreatePandaDoc?: PotentialOperation2 | PotentialOperation2Options;
}

export function newLienWaiver(options: LienWaiverOptions = {}, cache: Record<string, any> = {}): LienWaiver {
  const o = (options.__typename ? options : cache["LienWaiver"] = {}) as LienWaiver;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LienWaiver";
  o.id = options.id ?? nextFactoryId("LienWaiver");
  o.amountInCents = options.amountInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.condition = enumOrDetailOfLienWaiverCondition(options.condition);
  o.type = enumOrDetailOfLienWaiverType(options.type);
  o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
  o.status = enumOrDetailOfLienWaiverStatus(options.status);
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.throughDate = options.throughDate ?? null;
  o.claimant = maybeNew(options.claimant?.__typename ?? "Builder", options.claimant, cache);
  o.payer = maybeNew(options.payer?.__typename ?? "Builder", options.payer, cache);
  o.payerName = options.payerName ?? "payerName";
  o.owner = maybeNew(options.owner?.__typename ?? "Customer", options.owner, cache);
  o.signatory = maybeNewOrNull(options.signatory?.__typename ?? "InternalUser", options.signatory, cache);
  o.canCreatePandaDoc = maybeNew(
    "PotentialOperation2",
    options.canCreatePandaDoc,
    cache,
    options.hasOwnProperty("canCreatePandaDoc"),
  );
  return o;
}

factories["LienWaiver"] = newLienWaiver;

export interface SaveLienWaiverResultOptions {
  __typename?: "SaveLienWaiverResult";
  lienWaiver?: LienWaiver | LienWaiverOptions;
}

export function newSaveLienWaiverResult(
  options: SaveLienWaiverResultOptions = {},
  cache: Record<string, any> = {},
): SaveLienWaiverResult {
  const o = (options.__typename ? options : cache["SaveLienWaiverResult"] = {}) as SaveLienWaiverResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLienWaiverResult";
  o.lienWaiver = maybeNew("LienWaiver", options.lienWaiver, cache, options.hasOwnProperty("lienWaiver"));
  return o;
}

factories["SaveLienWaiverResult"] = newSaveLienWaiverResult;

export interface LienWaiversPageOptions {
  __typename?: "LienWaiversPage";
  entities?: Array<LienWaiver | LienWaiverOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newLienWaiversPage(
  options: LienWaiversPageOptions = {},
  cache: Record<string, any> = {},
): LienWaiversPage {
  const o = (options.__typename ? options : cache["LienWaiversPage"] = {}) as LienWaiversPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LienWaiversPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("LienWaiver", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["LienWaiversPage"] = newLienWaiversPage;

export interface SaveLocationsResultOptions {
  __typename?: "SaveLocationsResult";
  locations?: Array<Location | LocationOptions>;
}

export function newSaveLocationsResult(
  options: SaveLocationsResultOptions = {},
  cache: Record<string, any> = {},
): SaveLocationsResult {
  const o = (options.__typename ? options : cache["SaveLocationsResult"] = {}) as SaveLocationsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLocationsResult";
  o.locations = (options.locations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("locations"))
  );
  return o;
}

factories["SaveLocationsResult"] = newSaveLocationsResult;

export interface LocationOptions {
  __typename?: "Location";
  id?: Location["id"];
  name?: Location["name"];
  image?: Asset | AssetOptions | null;
  isWholeHouse?: Location["isWholeHouse"];
  supportsRendering?: Location["supportsRendering"];
  code?: Location["code"];
  effectiveCode?: Location["effectiveCode"];
  version?: Location["version"];
  type?: LocationTypeDetailOptions | LocationType;
  parent?: Location | LocationOptions | null;
  parents?: Array<Location | LocationOptions>;
  path?: Location["path"];
  pathAsCode?: Location["pathAsCode"];
  pathArray?: Location["pathArray"];
  pathIds?: Location["pathIds"];
  group?: Location | LocationOptions | null;
  level?: Location | LocationOptions | null;
  room?: Location | LocationOptions | null;
  displayLocationPath?: Location["displayLocationPath"];
  locations?: Array<Location | LocationOptions>;
  feature?: Location | LocationOptions | null;
  effectiveLocation?: Location | LocationOptions;
  nonScopeLocation?: Location | LocationOptions;
  isNonStructural?: Location["isNonStructural"];
  materialVariant?: MaterialVariant | MaterialVariantOptions | null;
  isModifiedRoom?: Location["isModifiedRoom"];
  roomType?: RoomType | RoomTypeOptions | null;
  featureType?: FeatureType | FeatureTypeOptions | null;
}

export function newLocation(options: LocationOptions = {}, cache: Record<string, any> = {}): Location {
  const o = (options.__typename ? options : cache["Location"] = {}) as Location;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Location";
  o.id = options.id ?? nextFactoryId("Location");
  o.name = options.name ?? "name";
  o.image = maybeNewOrNull("Asset", options.image, cache);
  o.isWholeHouse = options.isWholeHouse ?? false;
  o.supportsRendering = options.supportsRendering ?? false;
  o.code = options.code ?? null;
  o.effectiveCode = options.effectiveCode ?? "effectiveCode";
  o.version = options.version ?? 0;
  o.type = enumOrDetailOfLocationType(options.type);
  o.parent = maybeNewOrNull("Location", options.parent, cache);
  o.parents = (options.parents ?? []).map((i) => maybeNew("Location", i, cache, options.hasOwnProperty("parents")));
  o.path = options.path ?? null;
  o.pathAsCode = options.pathAsCode ?? null;
  o.pathArray = options.pathArray ?? [];
  o.pathIds = options.pathIds ?? [];
  o.group = maybeNewOrNull("Location", options.group, cache);
  o.level = maybeNewOrNull("Location", options.level, cache);
  o.room = maybeNewOrNull("Location", options.room, cache);
  o.displayLocationPath = options.displayLocationPath ?? "displayLocationPath";
  o.locations = (options.locations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("locations"))
  );
  o.feature = maybeNewOrNull("Location", options.feature, cache);
  o.effectiveLocation = maybeNew(
    "Location",
    options.effectiveLocation,
    cache,
    options.hasOwnProperty("effectiveLocation"),
  );
  o.nonScopeLocation = maybeNew(
    "Location",
    options.nonScopeLocation,
    cache,
    options.hasOwnProperty("nonScopeLocation"),
  );
  o.isNonStructural = options.isNonStructural ?? null;
  o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
  o.isModifiedRoom = options.isModifiedRoom ?? false;
  o.roomType = maybeNewOrNull("RoomType", options.roomType, cache);
  o.featureType = maybeNewOrNull("FeatureType", options.featureType, cache);
  return o;
}

factories["Location"] = newLocation;

export interface SaveLotResultOptions {
  __typename?: "SaveLotResult";
  lot?: Lot | LotOptions;
}

export function newSaveLotResult(options: SaveLotResultOptions = {}, cache: Record<string, any> = {}): SaveLotResult {
  const o = (options.__typename ? options : cache["SaveLotResult"] = {}) as SaveLotResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotResult";
  o.lot = maybeNew("Lot", options.lot, cache, options.hasOwnProperty("lot"));
  return o;
}

factories["SaveLotResult"] = newSaveLotResult;

export interface LotRatingOptions {
  __typename?: "LotRating";
  id?: LotRating["id"];
  grade?: LotRating["grade"];
  description?: LotRating["description"];
  createdAt?: LotRating["createdAt"];
  updatedAt?: LotRating["updatedAt"];
  projects?: Array<StandaloneProject | StandaloneProjectOptions>;
}

export function newLotRating(options: LotRatingOptions = {}, cache: Record<string, any> = {}): LotRating {
  const o = (options.__typename ? options : cache["LotRating"] = {}) as LotRating;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotRating";
  o.id = options.id ?? nextFactoryId("LotRating");
  o.grade = options.grade ?? "grade";
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.projects = (options.projects ?? []).map((i) =>
    maybeNew("StandaloneProject", i, cache, options.hasOwnProperty("projects"))
  );
  return o;
}

factories["LotRating"] = newLotRating;

export interface SaveLotRatingResultOptions {
  __typename?: "SaveLotRatingResult";
  lotRating?: LotRating | LotRatingOptions;
}

export function newSaveLotRatingResult(
  options: SaveLotRatingResultOptions = {},
  cache: Record<string, any> = {},
): SaveLotRatingResult {
  const o = (options.__typename ? options : cache["SaveLotRatingResult"] = {}) as SaveLotRatingResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotRatingResult";
  o.lotRating = maybeNew("LotRating", options.lotRating, cache, options.hasOwnProperty("lotRating"));
  return o;
}

factories["SaveLotRatingResult"] = newSaveLotRatingResult;

export interface SaveMarketResultOptions {
  __typename?: "SaveMarketResult";
  market?: Market | MarketOptions;
}

export function newSaveMarketResult(
  options: SaveMarketResultOptions = {},
  cache: Record<string, any> = {},
): SaveMarketResult {
  const o = (options.__typename ? options : cache["SaveMarketResult"] = {}) as SaveMarketResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMarketResult";
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  return o;
}

factories["SaveMarketResult"] = newSaveMarketResult;

export interface MaterialAssemblyComponentOptions {
  __typename?: "MaterialAssemblyComponent";
  id?: MaterialAssemblyComponent["id"];
  createdAt?: MaterialAssemblyComponent["createdAt"];
  updatedAt?: MaterialAssemblyComponent["updatedAt"];
  assembly?: MaterialVariant | MaterialVariantOptions;
  component?: MaterialVariant | MaterialVariantOptions;
  name?: MaterialAssemblyComponent["name"];
  qualifier?: MaterialAssemblyComponent["qualifier"];
}

export function newMaterialAssemblyComponent(
  options: MaterialAssemblyComponentOptions = {},
  cache: Record<string, any> = {},
): MaterialAssemblyComponent {
  const o = (options.__typename ? options : cache["MaterialAssemblyComponent"] = {}) as MaterialAssemblyComponent;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialAssemblyComponent";
  o.id = options.id ?? nextFactoryId("MaterialAssemblyComponent");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.assembly = maybeNew("MaterialVariant", options.assembly, cache, options.hasOwnProperty("assembly"));
  o.component = maybeNew("MaterialVariant", options.component, cache, options.hasOwnProperty("component"));
  o.name = options.name ?? null;
  o.qualifier = options.qualifier ?? null;
  return o;
}

factories["MaterialAssemblyComponent"] = newMaterialAssemblyComponent;

export interface SaveMaterialAssemblyComponentResultOptions {
  __typename?: "SaveMaterialAssemblyComponentResult";
  materialAssemblyComponent?: MaterialAssemblyComponent | MaterialAssemblyComponentOptions;
}

export function newSaveMaterialAssemblyComponentResult(
  options: SaveMaterialAssemblyComponentResultOptions = {},
  cache: Record<string, any> = {},
): SaveMaterialAssemblyComponentResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveMaterialAssemblyComponentResult"] = {}) as SaveMaterialAssemblyComponentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMaterialAssemblyComponentResult";
  o.materialAssemblyComponent = maybeNew(
    "MaterialAssemblyComponent",
    options.materialAssemblyComponent,
    cache,
    options.hasOwnProperty("materialAssemblyComponent"),
  );
  return o;
}

factories["SaveMaterialAssemblyComponentResult"] = newSaveMaterialAssemblyComponentResult;

export interface MaterialAttributeDimensionOptions {
  __typename?: "MaterialAttributeDimension";
  id?: MaterialAttributeDimension["id"];
  name?: MaterialAttributeDimension["name"];
  createdAt?: MaterialAttributeDimension["createdAt"];
  updatedAt?: MaterialAttributeDimension["updatedAt"];
  item?: Item | ItemOptions;
  values?: Array<MaterialAttributeValue | MaterialAttributeValueOptions>;
  isAdminManaged?: MaterialAttributeDimension["isAdminManaged"];
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions | null;
  sortOrder?: MaterialAttributeDimension["sortOrder"];
  type?: MaterialAttributeDimensionTypeDetailOptions | MaterialAttributeDimensionType;
  useInTakeoff?: MaterialAttributeDimension["useInTakeoff"];
  useInVisualModePdf?: MaterialAttributeDimension["useInVisualModePdf"];
  showInFinishSchedule?: MaterialAttributeDimension["showInFinishSchedule"];
  showInCabinetsInfo?: MaterialAttributeDimension["showInCabinetsInfo"];
  copiedFromChildModifier?: MaterialAttributeDimension | MaterialAttributeDimensionOptions | null;
  isDeprecated?: MaterialAttributeDimension["isDeprecated"];
}

export function newMaterialAttributeDimension(
  options: MaterialAttributeDimensionOptions = {},
  cache: Record<string, any> = {},
): MaterialAttributeDimension {
  const o = (options.__typename ? options : cache["MaterialAttributeDimension"] = {}) as MaterialAttributeDimension;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialAttributeDimension";
  o.id = options.id ?? nextFactoryId("MaterialAttributeDimension");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.values = (options.values ?? []).map((i) =>
    maybeNew("MaterialAttributeValue", i, cache, options.hasOwnProperty("values"))
  );
  o.isAdminManaged = options.isAdminManaged ?? false;
  o.unitOfMeasure = maybeNewOrNull("UnitOfMeasure", options.unitOfMeasure, cache);
  o.sortOrder = options.sortOrder ?? 0;
  o.type = enumOrDetailOfMaterialAttributeDimensionType(options.type);
  o.useInTakeoff = options.useInTakeoff ?? false;
  o.useInVisualModePdf = options.useInVisualModePdf ?? false;
  o.showInFinishSchedule = options.showInFinishSchedule ?? false;
  o.showInCabinetsInfo = options.showInCabinetsInfo ?? false;
  o.copiedFromChildModifier = maybeNewOrNull("MaterialAttributeDimension", options.copiedFromChildModifier, cache);
  o.isDeprecated = options.isDeprecated ?? false;
  return o;
}

factories["MaterialAttributeDimension"] = newMaterialAttributeDimension;

export interface SaveMaterialAttributeDimensionResultOptions {
  __typename?: "SaveMaterialAttributeDimensionResult";
  materialAttributeDimension?: MaterialAttributeDimension | MaterialAttributeDimensionOptions;
}

export function newSaveMaterialAttributeDimensionResult(
  options: SaveMaterialAttributeDimensionResultOptions = {},
  cache: Record<string, any> = {},
): SaveMaterialAttributeDimensionResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveMaterialAttributeDimensionResult"] = {}) as SaveMaterialAttributeDimensionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMaterialAttributeDimensionResult";
  o.materialAttributeDimension = maybeNew(
    "MaterialAttributeDimension",
    options.materialAttributeDimension,
    cache,
    options.hasOwnProperty("materialAttributeDimension"),
  );
  return o;
}

factories["SaveMaterialAttributeDimensionResult"] = newSaveMaterialAttributeDimensionResult;

export interface SaveMaterialAttributeDimensionResultsOptions {
  __typename?: "SaveMaterialAttributeDimensionResults";
  materialAttributeDimensions?: Array<MaterialAttributeDimension | MaterialAttributeDimensionOptions>;
}

export function newSaveMaterialAttributeDimensionResults(
  options: SaveMaterialAttributeDimensionResultsOptions = {},
  cache: Record<string, any> = {},
): SaveMaterialAttributeDimensionResults {
  const o =
    (options.__typename
      ? options
      : cache["SaveMaterialAttributeDimensionResults"] = {}) as SaveMaterialAttributeDimensionResults;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMaterialAttributeDimensionResults";
  o.materialAttributeDimensions = (options.materialAttributeDimensions ?? []).map((i) =>
    maybeNew("MaterialAttributeDimension", i, cache, options.hasOwnProperty("materialAttributeDimensions"))
  );
  return o;
}

factories["SaveMaterialAttributeDimensionResults"] = newSaveMaterialAttributeDimensionResults;

export interface MaterialAttributeValueOptions {
  __typename?: "MaterialAttributeValue";
  id?: MaterialAttributeValue["id"];
  value?: MaterialAttributeValue["value"];
  textValue?: MaterialAttributeValue["textValue"];
  valueWithUom?: MaterialAttributeValue["valueWithUom"];
  createdAt?: MaterialAttributeValue["createdAt"];
  updatedAt?: MaterialAttributeValue["updatedAt"];
  dimension?: MaterialAttributeDimension | MaterialAttributeDimensionOptions;
  materialVariants?: Array<MaterialVariant | MaterialVariantOptions>;
  code?: MaterialAttributeValue["code"];
  type?: MaterialAttributeValueTypeDetailOptions | MaterialAttributeValueType;
  min?: MaterialAttributeValue["min"];
  max?: MaterialAttributeValue["max"];
}

export function newMaterialAttributeValue(
  options: MaterialAttributeValueOptions = {},
  cache: Record<string, any> = {},
): MaterialAttributeValue {
  const o = (options.__typename ? options : cache["MaterialAttributeValue"] = {}) as MaterialAttributeValue;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialAttributeValue";
  o.id = options.id ?? nextFactoryId("MaterialAttributeValue");
  o.value = options.value ?? "value";
  o.textValue = options.textValue ?? "textValue";
  o.valueWithUom = options.valueWithUom ?? "valueWithUom";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.dimension = maybeNew("MaterialAttributeDimension", options.dimension, cache, options.hasOwnProperty("dimension"));
  o.materialVariants = (options.materialVariants ?? []).map((i) =>
    maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("materialVariants"))
  );
  o.code = options.code ?? null;
  o.type = enumOrDetailOfMaterialAttributeValueType(options.type);
  o.min = options.min ?? null;
  o.max = options.max ?? null;
  return o;
}

factories["MaterialAttributeValue"] = newMaterialAttributeValue;

export interface SaveMaterialAttributeValueResultOptions {
  __typename?: "SaveMaterialAttributeValueResult";
  materialAttributeValue?: MaterialAttributeValue | MaterialAttributeValueOptions;
}

export function newSaveMaterialAttributeValueResult(
  options: SaveMaterialAttributeValueResultOptions = {},
  cache: Record<string, any> = {},
): SaveMaterialAttributeValueResult {
  const o =
    (options.__typename ? options : cache["SaveMaterialAttributeValueResult"] = {}) as SaveMaterialAttributeValueResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMaterialAttributeValueResult";
  o.materialAttributeValue = maybeNew(
    "MaterialAttributeValue",
    options.materialAttributeValue,
    cache,
    options.hasOwnProperty("materialAttributeValue"),
  );
  return o;
}

factories["SaveMaterialAttributeValueResult"] = newSaveMaterialAttributeValueResult;

export interface BackfillResponseOptions {
  __typename?: "BackfillResponse";
  processed?: BackfillResponse["processed"];
  skipped?: BackfillResponse["skipped"];
}

export function newBackfillResponse(
  options: BackfillResponseOptions = {},
  cache: Record<string, any> = {},
): BackfillResponse {
  const o = (options.__typename ? options : cache["BackfillResponse"] = {}) as BackfillResponse;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BackfillResponse";
  o.processed = options.processed ?? 0;
  o.skipped = options.skipped ?? 0;
  return o;
}

factories["BackfillResponse"] = newBackfillResponse;

export interface MaterialBrandOptions {
  __typename?: "MaterialBrand";
  id?: MaterialBrand["id"];
  name?: MaterialBrand["name"];
  abbreviation?: MaterialBrand["abbreviation"];
  shortName?: MaterialBrand["shortName"];
  createdAt?: MaterialBrand["createdAt"];
  updatedAt?: MaterialBrand["updatedAt"];
  materialListings?: Array<MaterialListing | MaterialListingOptions>;
}

export function newMaterialBrand(options: MaterialBrandOptions = {}, cache: Record<string, any> = {}): MaterialBrand {
  const o = (options.__typename ? options : cache["MaterialBrand"] = {}) as MaterialBrand;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialBrand";
  o.id = options.id ?? nextFactoryId("MaterialBrand");
  o.name = options.name ?? "name";
  o.abbreviation = options.abbreviation ?? null;
  o.shortName = options.shortName ?? "shortName";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.materialListings = (options.materialListings ?? []).map((i) =>
    maybeNew("MaterialListing", i, cache, options.hasOwnProperty("materialListings"))
  );
  return o;
}

factories["MaterialBrand"] = newMaterialBrand;

export interface SaveMaterialBrandResultOptions {
  __typename?: "SaveMaterialBrandResult";
  materialBrand?: MaterialBrand | MaterialBrandOptions;
}

export function newSaveMaterialBrandResult(
  options: SaveMaterialBrandResultOptions = {},
  cache: Record<string, any> = {},
): SaveMaterialBrandResult {
  const o = (options.__typename ? options : cache["SaveMaterialBrandResult"] = {}) as SaveMaterialBrandResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMaterialBrandResult";
  o.materialBrand = maybeNew("MaterialBrand", options.materialBrand, cache, options.hasOwnProperty("materialBrand"));
  return o;
}

factories["SaveMaterialBrandResult"] = newSaveMaterialBrandResult;

export interface MaterialLeadTimeConfigOptions {
  __typename?: "MaterialLeadTimeConfig";
  id?: MaterialLeadTimeConfig["id"];
  minLeadTimeInDays?: MaterialLeadTimeConfig["minLeadTimeInDays"];
  expectedLeadTimeInDays?: MaterialLeadTimeConfig["expectedLeadTimeInDays"];
  maxLeadTimeInDays?: MaterialLeadTimeConfig["maxLeadTimeInDays"];
  reasonNote?: MaterialLeadTimeConfig["reasonNote"];
  createdAt?: MaterialLeadTimeConfig["createdAt"];
  updatedAt?: MaterialLeadTimeConfig["updatedAt"];
  variants?: Array<MaterialLeadTimeConfigVariant | MaterialLeadTimeConfigVariantOptions>;
  parent?:
    | MaterialLeadTimeConfigParent
    | CostCodeOptions
    | RequireTypename<ItemOptions>
    | RequireTypename<MaterialListingOptions>
    | null;
}

export function newMaterialLeadTimeConfig(
  options: MaterialLeadTimeConfigOptions = {},
  cache: Record<string, any> = {},
): MaterialLeadTimeConfig {
  const o = (options.__typename ? options : cache["MaterialLeadTimeConfig"] = {}) as MaterialLeadTimeConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialLeadTimeConfig";
  o.id = options.id ?? nextFactoryId("MaterialLeadTimeConfig");
  o.minLeadTimeInDays = options.minLeadTimeInDays ?? 0;
  o.expectedLeadTimeInDays = options.expectedLeadTimeInDays ?? 0;
  o.maxLeadTimeInDays = options.maxLeadTimeInDays ?? 0;
  o.reasonNote = options.reasonNote ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.variants = (options.variants ?? []).map((i) =>
    maybeNew("MaterialLeadTimeConfigVariant", i, cache, options.hasOwnProperty("variants"))
  );
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "CostCode", options.parent, cache);
  return o;
}

factories["MaterialLeadTimeConfig"] = newMaterialLeadTimeConfig;

export interface SaveMaterialLeadTimeConfigResultOptions {
  __typename?: "SaveMaterialLeadTimeConfigResult";
  materialLeadTimeConfig?: MaterialLeadTimeConfig | MaterialLeadTimeConfigOptions;
}

export function newSaveMaterialLeadTimeConfigResult(
  options: SaveMaterialLeadTimeConfigResultOptions = {},
  cache: Record<string, any> = {},
): SaveMaterialLeadTimeConfigResult {
  const o =
    (options.__typename ? options : cache["SaveMaterialLeadTimeConfigResult"] = {}) as SaveMaterialLeadTimeConfigResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMaterialLeadTimeConfigResult";
  o.materialLeadTimeConfig = maybeNew(
    "MaterialLeadTimeConfig",
    options.materialLeadTimeConfig,
    cache,
    options.hasOwnProperty("materialLeadTimeConfig"),
  );
  return o;
}

factories["SaveMaterialLeadTimeConfigResult"] = newSaveMaterialLeadTimeConfigResult;

export interface MaterialLeadTimeConfigVariantOptions {
  __typename?: "MaterialLeadTimeConfigVariant";
  id?: MaterialLeadTimeConfigVariant["id"];
  minLeadTimeInDays?: MaterialLeadTimeConfigVariant["minLeadTimeInDays"];
  expectedLeadTimeInDays?: MaterialLeadTimeConfigVariant["expectedLeadTimeInDays"];
  maxLeadTimeInDays?: MaterialLeadTimeConfigVariant["maxLeadTimeInDays"];
  reasonNote?: MaterialLeadTimeConfigVariant["reasonNote"];
  createdAt?: MaterialLeadTimeConfigVariant["createdAt"];
  updatedAt?: MaterialLeadTimeConfigVariant["updatedAt"];
  market?: Market | MarketOptions | null;
  materialLeadTimeConfig?: MaterialLeadTimeConfig | MaterialLeadTimeConfigOptions;
}

export function newMaterialLeadTimeConfigVariant(
  options: MaterialLeadTimeConfigVariantOptions = {},
  cache: Record<string, any> = {},
): MaterialLeadTimeConfigVariant {
  const o =
    (options.__typename ? options : cache["MaterialLeadTimeConfigVariant"] = {}) as MaterialLeadTimeConfigVariant;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialLeadTimeConfigVariant";
  o.id = options.id ?? nextFactoryId("MaterialLeadTimeConfigVariant");
  o.minLeadTimeInDays = options.minLeadTimeInDays ?? null;
  o.expectedLeadTimeInDays = options.expectedLeadTimeInDays ?? null;
  o.maxLeadTimeInDays = options.maxLeadTimeInDays ?? null;
  o.reasonNote = options.reasonNote ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.market = maybeNewOrNull("Market", options.market, cache);
  o.materialLeadTimeConfig = maybeNew(
    "MaterialLeadTimeConfig",
    options.materialLeadTimeConfig,
    cache,
    options.hasOwnProperty("materialLeadTimeConfig"),
  );
  return o;
}

factories["MaterialLeadTimeConfigVariant"] = newMaterialLeadTimeConfigVariant;

export interface MaterialListingOptions {
  __typename?: "MaterialListing";
  id?: MaterialListing["id"];
  name?: MaterialListing["name"];
  createdAt?: MaterialListing["createdAt"];
  updatedAt?: MaterialListing["updatedAt"];
  item?: Item | ItemOptions;
  brand?: MaterialBrand | MaterialBrandOptions | null;
  materialVariants?: Array<MaterialVariant | MaterialVariantOptions>;
  type?: MaterialTypeDetailOptions | MaterialType;
  manufacturerUrl?: MaterialListing["manufacturerUrl"];
  description?: MaterialListing["description"];
  canEditItem?: PotentialOperation2 | PotentialOperation2Options;
  optionPricingConfig?: OptionPricingConfig | OptionPricingConfigOptions | null;
  preCutoffDesiredMarginInBasisPoints?: MaterialListing["preCutoffDesiredMarginInBasisPoints"];
  postCutoffDesiredMarginInBasisPoints?: MaterialListing["postCutoffDesiredMarginInBasisPoints"];
  selectionFeeInCents?: MaterialListing["selectionFeeInCents"];
  minimumPriceInCents?: MaterialListing["minimumPriceInCents"];
  materialLeadTimeConfig?: MaterialLeadTimeConfig | MaterialLeadTimeConfigOptions | null;
  minLeadTimeInDays?: MaterialListing["minLeadTimeInDays"];
  expectedLeadTimeInDays?: MaterialListing["expectedLeadTimeInDays"];
  maxLeadTimeInDays?: MaterialListing["maxLeadTimeInDays"];
  history?: Array<History | HistoryOptions>;
  designNote?: MaterialListing["designNote"];
}

export function newMaterialListing(
  options: MaterialListingOptions = {},
  cache: Record<string, any> = {},
): MaterialListing {
  const o = (options.__typename ? options : cache["MaterialListing"] = {}) as MaterialListing;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialListing";
  o.id = options.id ?? nextFactoryId("MaterialListing");
  o.name = options.name ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.brand = maybeNewOrNull("MaterialBrand", options.brand, cache);
  o.materialVariants = (options.materialVariants ?? []).map((i) =>
    maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("materialVariants"))
  );
  o.type = enumOrDetailOfMaterialType(options.type);
  o.manufacturerUrl = options.manufacturerUrl ?? null;
  o.description = options.description ?? null;
  o.canEditItem = maybeNew("PotentialOperation2", options.canEditItem, cache, options.hasOwnProperty("canEditItem"));
  o.optionPricingConfig = maybeNewOrNull("OptionPricingConfig", options.optionPricingConfig, cache);
  o.preCutoffDesiredMarginInBasisPoints = options.preCutoffDesiredMarginInBasisPoints ?? 0;
  o.postCutoffDesiredMarginInBasisPoints = options.postCutoffDesiredMarginInBasisPoints ?? null;
  o.selectionFeeInCents = options.selectionFeeInCents ?? null;
  o.minimumPriceInCents = options.minimumPriceInCents ?? 0;
  o.materialLeadTimeConfig = maybeNewOrNull("MaterialLeadTimeConfig", options.materialLeadTimeConfig, cache);
  o.minLeadTimeInDays = options.minLeadTimeInDays ?? 0;
  o.expectedLeadTimeInDays = options.expectedLeadTimeInDays ?? 0;
  o.maxLeadTimeInDays = options.maxLeadTimeInDays ?? 0;
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.designNote = options.designNote ?? null;
  return o;
}

factories["MaterialListing"] = newMaterialListing;

export interface MaterialListingsPageOptions {
  __typename?: "MaterialListingsPage";
  entities?: Array<MaterialListing | MaterialListingOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newMaterialListingsPage(
  options: MaterialListingsPageOptions = {},
  cache: Record<string, any> = {},
): MaterialListingsPage {
  const o = (options.__typename ? options : cache["MaterialListingsPage"] = {}) as MaterialListingsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialListingsPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("MaterialListing", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["MaterialListingsPage"] = newMaterialListingsPage;

export interface MigrateMaterialListingItemResultOptions {
  __typename?: "MigrateMaterialListingItemResult";
  listings?: Array<MaterialListing | MaterialListingOptions>;
}

export function newMigrateMaterialListingItemResult(
  options: MigrateMaterialListingItemResultOptions = {},
  cache: Record<string, any> = {},
): MigrateMaterialListingItemResult {
  const o =
    (options.__typename ? options : cache["MigrateMaterialListingItemResult"] = {}) as MigrateMaterialListingItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MigrateMaterialListingItemResult";
  o.listings = (options.listings ?? []).map((i) =>
    maybeNew("MaterialListing", i, cache, options.hasOwnProperty("listings"))
  );
  return o;
}

factories["MigrateMaterialListingItemResult"] = newMigrateMaterialListingItemResult;

export interface MergeMaterialListingsResultOptions {
  __typename?: "MergeMaterialListingsResult";
  target?: MaterialListing | MaterialListingOptions;
}

export function newMergeMaterialListingsResult(
  options: MergeMaterialListingsResultOptions = {},
  cache: Record<string, any> = {},
): MergeMaterialListingsResult {
  const o = (options.__typename ? options : cache["MergeMaterialListingsResult"] = {}) as MergeMaterialListingsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MergeMaterialListingsResult";
  o.target = maybeNew("MaterialListing", options.target, cache, options.hasOwnProperty("target"));
  return o;
}

factories["MergeMaterialListingsResult"] = newMergeMaterialListingsResult;

export interface UploadMaterialVariantsResultOptions {
  __typename?: "UploadMaterialVariantsResult";
  results?: Array<UploadMaterialVariantResult | UploadMaterialVariantResultOptions>;
}

export function newUploadMaterialVariantsResult(
  options: UploadMaterialVariantsResultOptions = {},
  cache: Record<string, any> = {},
): UploadMaterialVariantsResult {
  const o = (options.__typename ? options : cache["UploadMaterialVariantsResult"] = {}) as UploadMaterialVariantsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UploadMaterialVariantsResult";
  o.results = (options.results ?? []).map((i) =>
    maybeNew("UploadMaterialVariantResult", i, cache, options.hasOwnProperty("results"))
  );
  return o;
}

factories["UploadMaterialVariantsResult"] = newUploadMaterialVariantsResult;

export interface UploadMaterialVariantResultOptions {
  __typename?: "UploadMaterialVariantResult";
  data?: UploadMaterialVariantResult["data"];
  operation?: UploadMaterialVariantResult["operation"];
  newMaterialVariant?: MaterialVariant | MaterialVariantOptions | null;
  updatedMaterialVariant?: MaterialVariant | MaterialVariantOptions | null;
}

export function newUploadMaterialVariantResult(
  options: UploadMaterialVariantResultOptions = {},
  cache: Record<string, any> = {},
): UploadMaterialVariantResult {
  const o = (options.__typename ? options : cache["UploadMaterialVariantResult"] = {}) as UploadMaterialVariantResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UploadMaterialVariantResult";
  o.data = options.data ?? "" as any;
  o.operation = options.operation ?? "operation";
  o.newMaterialVariant = maybeNewOrNull("MaterialVariant", options.newMaterialVariant, cache);
  o.updatedMaterialVariant = maybeNewOrNull("MaterialVariant", options.updatedMaterialVariant, cache);
  return o;
}

factories["UploadMaterialVariantResult"] = newUploadMaterialVariantResult;

export interface MergeMaterialVariantsResultOptions {
  __typename?: "MergeMaterialVariantsResult";
  trackedJob?: TrackedJob | TrackedJobOptions;
}

export function newMergeMaterialVariantsResult(
  options: MergeMaterialVariantsResultOptions = {},
  cache: Record<string, any> = {},
): MergeMaterialVariantsResult {
  const o = (options.__typename ? options : cache["MergeMaterialVariantsResult"] = {}) as MergeMaterialVariantsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MergeMaterialVariantsResult";
  o.trackedJob = maybeNew("TrackedJob", options.trackedJob, cache, options.hasOwnProperty("trackedJob"));
  return o;
}

factories["MergeMaterialVariantsResult"] = newMergeMaterialVariantsResult;

export interface MaterialVariantOptions {
  __typename?: "MaterialVariant";
  id?: MaterialVariant["id"];
  code?: MaterialVariant["code"];
  displayName?: MaterialVariant["displayName"];
  modelNumber?: MaterialVariant["modelNumber"];
  createdAt?: MaterialVariant["createdAt"];
  updatedAt?: MaterialVariant["updatedAt"];
  deletedAt?: MaterialVariant["deletedAt"];
  listing?: MaterialListing | MaterialListingOptions;
  materialAttributeValues?: Array<MaterialAttributeValue | MaterialAttributeValueOptions>;
  bidItems?: Array<BidItem | BidItemOptions>;
  codeOverride?: MaterialVariant["codeOverride"];
  defaultBidItem?: BidItem | BidItemOptions;
  featuredImage?: MaterialVariantImage | MaterialVariantImageOptions | null;
  images?: Array<MaterialVariantImage | MaterialVariantImageOptions>;
  components?: Array<MaterialAssemblyComponent | MaterialAssemblyComponentOptions>;
  componentOf?: Array<MaterialAssemblyComponent | MaterialAssemblyComponentOptions>;
  lastUsedAt?: MaterialVariant["lastUsedAt"];
  effectiveMADs?: Array<MaterialAttributeDimension | MaterialAttributeDimensionOptions>;
  designFeedback?: MaterialVariant["designFeedback"];
  minCostInMills?: MaterialVariant["minCostInMills"];
  maxCostInMills?: MaterialVariant["maxCostInMills"];
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  tags?: Array<MaterialVariantTag | MaterialVariantTagOptions>;
  manufacturerUrl?: MaterialVariant["manufacturerUrl"];
  blueprintUrl?: Url | UrlOptions;
  sources?: Array<MaterialVariant | MaterialVariantOptions>;
  takeoffUsages?: Array<
    ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions
  >;
  matchesPlaceholder?: MaterialVariant["matchesPlaceholder"];
  hasAwardedCost?: MaterialVariant["hasAwardedCost"];
  merges?: Array<MaterialVariantMerge | MaterialVariantMergeOptions>;
}

export function newMaterialVariant(
  options: MaterialVariantOptions = {},
  cache: Record<string, any> = {},
): MaterialVariant {
  const o = (options.__typename ? options : cache["MaterialVariant"] = {}) as MaterialVariant;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialVariant";
  o.id = options.id ?? nextFactoryId("MaterialVariant");
  o.code = options.code ?? "code";
  o.displayName = options.displayName ?? "displayName";
  o.modelNumber = options.modelNumber ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.deletedAt = options.deletedAt ?? null;
  o.listing = maybeNew("MaterialListing", options.listing, cache, options.hasOwnProperty("listing"));
  o.materialAttributeValues = (options.materialAttributeValues ?? []).map((i) =>
    maybeNew("MaterialAttributeValue", i, cache, options.hasOwnProperty("materialAttributeValues"))
  );
  o.bidItems = (options.bidItems ?? []).map((i) => maybeNew("BidItem", i, cache, options.hasOwnProperty("bidItems")));
  o.codeOverride = options.codeOverride ?? null;
  o.defaultBidItem = maybeNew("BidItem", options.defaultBidItem, cache, options.hasOwnProperty("defaultBidItem"));
  o.featuredImage = maybeNewOrNull("MaterialVariantImage", options.featuredImage, cache);
  o.images = (options.images ?? []).map((i) =>
    maybeNew("MaterialVariantImage", i, cache, options.hasOwnProperty("images"))
  );
  o.components = (options.components ?? []).map((i) =>
    maybeNew("MaterialAssemblyComponent", i, cache, options.hasOwnProperty("components"))
  );
  o.componentOf = (options.componentOf ?? []).map((i) =>
    maybeNew("MaterialAssemblyComponent", i, cache, options.hasOwnProperty("componentOf"))
  );
  o.lastUsedAt = options.lastUsedAt ?? null;
  o.effectiveMADs = (options.effectiveMADs ?? []).map((i) =>
    maybeNew("MaterialAttributeDimension", i, cache, options.hasOwnProperty("effectiveMADs"))
  );
  o.designFeedback = options.designFeedback ?? null;
  o.minCostInMills = options.minCostInMills ?? null;
  o.maxCostInMills = options.maxCostInMills ?? null;
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.tags = (options.tags ?? []).map((i) => maybeNew("MaterialVariantTag", i, cache, options.hasOwnProperty("tags")));
  o.manufacturerUrl = options.manufacturerUrl ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.sources = (options.sources ?? []).map((i) =>
    maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("sources"))
  );
  o.takeoffUsages = (options.takeoffUsages ?? []).map((i) =>
    maybeNew("ReadyPlanLike", i, cache, options.hasOwnProperty("takeoffUsages"))
  );
  o.matchesPlaceholder = options.matchesPlaceholder ?? false;
  o.hasAwardedCost = options.hasAwardedCost ?? false;
  o.merges = (options.merges ?? []).map((i) =>
    maybeNew("MaterialVariantMerge", i, cache, options.hasOwnProperty("merges"))
  );
  return o;
}

factories["MaterialVariant"] = newMaterialVariant;

export interface SaveMaterialVariantResultOptions {
  __typename?: "SaveMaterialVariantResult";
  materialVariant?: MaterialVariant | MaterialVariantOptions;
}

export function newSaveMaterialVariantResult(
  options: SaveMaterialVariantResultOptions = {},
  cache: Record<string, any> = {},
): SaveMaterialVariantResult {
  const o = (options.__typename ? options : cache["SaveMaterialVariantResult"] = {}) as SaveMaterialVariantResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMaterialVariantResult";
  o.materialVariant = maybeNew(
    "MaterialVariant",
    options.materialVariant,
    cache,
    options.hasOwnProperty("materialVariant"),
  );
  return o;
}

factories["SaveMaterialVariantResult"] = newSaveMaterialVariantResult;

export interface MaterialVariantsPageOptions {
  __typename?: "MaterialVariantsPage";
  entities?: Array<MaterialVariant | MaterialVariantOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newMaterialVariantsPage(
  options: MaterialVariantsPageOptions = {},
  cache: Record<string, any> = {},
): MaterialVariantsPage {
  const o = (options.__typename ? options : cache["MaterialVariantsPage"] = {}) as MaterialVariantsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialVariantsPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["MaterialVariantsPage"] = newMaterialVariantsPage;

export interface MaterialVariantCostSourcesPageOptions {
  __typename?: "MaterialVariantCostSourcesPage";
  entities?: Array<MaterialCostSource | BidItemEstimateOptions | RequireTypename<BidContractLineItemOptions>>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newMaterialVariantCostSourcesPage(
  options: MaterialVariantCostSourcesPageOptions = {},
  cache: Record<string, any> = {},
): MaterialVariantCostSourcesPage {
  const o =
    (options.__typename ? options : cache["MaterialVariantCostSourcesPage"] = {}) as MaterialVariantCostSourcesPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialVariantCostSourcesPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew(i?.__typename ?? "{BidItemEstimate", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["MaterialVariantCostSourcesPage"] = newMaterialVariantCostSourcesPage;

export interface MaterialVariantImageOptions {
  __typename?: "MaterialVariantImage";
  id?: MaterialVariantImage["id"];
  sortOrder?: MaterialVariantImage["sortOrder"];
  createdAt?: MaterialVariantImage["createdAt"];
  updatedAt?: MaterialVariantImage["updatedAt"];
  variant?: MaterialVariant | MaterialVariantOptions;
  asset?: Asset | AssetOptions | null;
}

export function newMaterialVariantImage(
  options: MaterialVariantImageOptions = {},
  cache: Record<string, any> = {},
): MaterialVariantImage {
  const o = (options.__typename ? options : cache["MaterialVariantImage"] = {}) as MaterialVariantImage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialVariantImage";
  o.id = options.id ?? nextFactoryId("MaterialVariantImage");
  o.sortOrder = options.sortOrder ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.variant = maybeNew("MaterialVariant", options.variant, cache, options.hasOwnProperty("variant"));
  o.asset = maybeNewOrNull("Asset", options.asset, cache);
  return o;
}

factories["MaterialVariantImage"] = newMaterialVariantImage;

export interface MaterialVariantMergesPageOptions {
  __typename?: "MaterialVariantMergesPage";
  entities?: Array<MaterialVariantMerge | MaterialVariantMergeOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newMaterialVariantMergesPage(
  options: MaterialVariantMergesPageOptions = {},
  cache: Record<string, any> = {},
): MaterialVariantMergesPage {
  const o = (options.__typename ? options : cache["MaterialVariantMergesPage"] = {}) as MaterialVariantMergesPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialVariantMergesPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("MaterialVariantMerge", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["MaterialVariantMergesPage"] = newMaterialVariantMergesPage;

export interface MaterialVariantMergeOptions {
  __typename?: "MaterialVariantMerge";
  id?: MaterialVariantMerge["id"];
  mergedIntoId?: MaterialVariantMerge["mergedIntoId"];
  mergedFromId?: MaterialVariantMerge["mergedFromId"];
  mergedFromCode?: MaterialVariantMerge["mergedFromCode"];
  mergedFromDisplayName?: MaterialVariantMerge["mergedFromDisplayName"];
  mergedFromListingId?: MaterialVariantMerge["mergedFromListingId"];
  mergedFromListingName?: MaterialVariantMerge["mergedFromListingName"];
  createdAt?: MaterialVariantMerge["createdAt"];
  updatedAt?: MaterialVariantMerge["updatedAt"];
  source?: MaterialVariantMerge["source"];
  winner?: MaterialVariant | MaterialVariantOptions;
  mergedBy?: User | UserOptions | null;
}

export function newMaterialVariantMerge(
  options: MaterialVariantMergeOptions = {},
  cache: Record<string, any> = {},
): MaterialVariantMerge {
  const o = (options.__typename ? options : cache["MaterialVariantMerge"] = {}) as MaterialVariantMerge;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialVariantMerge";
  o.id = options.id ?? nextFactoryId("MaterialVariantMerge");
  o.mergedIntoId = options.mergedIntoId ?? "mergedIntoId";
  o.mergedFromId = options.mergedFromId ?? "mergedFromId";
  o.mergedFromCode = options.mergedFromCode ?? "mergedFromCode";
  o.mergedFromDisplayName = options.mergedFromDisplayName ?? "mergedFromDisplayName";
  o.mergedFromListingId = options.mergedFromListingId ?? "mergedFromListingId";
  o.mergedFromListingName = options.mergedFromListingName ?? "mergedFromListingName";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.source = options.source ?? "source";
  o.winner = maybeNew("MaterialVariant", options.winner, cache, options.hasOwnProperty("winner"));
  o.mergedBy = maybeNewOrNull("User", options.mergedBy, cache);
  return o;
}

factories["MaterialVariantMerge"] = newMaterialVariantMerge;

export interface MaterialVariantTagOptions {
  __typename?: "MaterialVariantTag";
  id?: MaterialVariantTag["id"];
  name?: MaterialVariantTag["name"];
  createdAt?: MaterialVariantTag["createdAt"];
  updatedAt?: MaterialVariantTag["updatedAt"];
  materialVariants?: Array<MaterialVariant | MaterialVariantOptions>;
}

export function newMaterialVariantTag(
  options: MaterialVariantTagOptions = {},
  cache: Record<string, any> = {},
): MaterialVariantTag {
  const o = (options.__typename ? options : cache["MaterialVariantTag"] = {}) as MaterialVariantTag;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialVariantTag";
  o.id = options.id ?? nextFactoryId("MaterialVariantTag");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.materialVariants = (options.materialVariants ?? []).map((i) =>
    maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("materialVariants"))
  );
  return o;
}

factories["MaterialVariantTag"] = newMaterialVariantTag;

export interface SaveMaterialVariantTagResultOptions {
  __typename?: "SaveMaterialVariantTagResult";
  materialVariantTag?: MaterialVariantTag | MaterialVariantTagOptions;
}

export function newSaveMaterialVariantTagResult(
  options: SaveMaterialVariantTagResultOptions = {},
  cache: Record<string, any> = {},
): SaveMaterialVariantTagResult {
  const o = (options.__typename ? options : cache["SaveMaterialVariantTagResult"] = {}) as SaveMaterialVariantTagResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMaterialVariantTagResult";
  o.materialVariantTag = maybeNew(
    "MaterialVariantTag",
    options.materialVariantTag,
    cache,
    options.hasOwnProperty("materialVariantTag"),
  );
  return o;
}

factories["SaveMaterialVariantTagResult"] = newSaveMaterialVariantTagResult;

export interface MermaidResultOptions {
  __typename?: "MermaidResult";
  url?: MermaidResult["url"];
  code?: MermaidResult["code"];
}

export function newMermaidResult(options: MermaidResultOptions = {}, cache: Record<string, any> = {}): MermaidResult {
  const o = (options.__typename ? options : cache["MermaidResult"] = {}) as MermaidResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MermaidResult";
  o.url = options.url ?? "url";
  o.code = options.code ?? "code";
  return o;
}

factories["MermaidResult"] = newMermaidResult;

export interface MobileSyncUpdatesPageResultOptions {
  __typename?: "MobileSyncUpdatesPageResult";
  entities?: Array<MobileSyncUpdate | MobileSyncUpdateOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newMobileSyncUpdatesPageResult(
  options: MobileSyncUpdatesPageResultOptions = {},
  cache: Record<string, any> = {},
): MobileSyncUpdatesPageResult {
  const o = (options.__typename ? options : cache["MobileSyncUpdatesPageResult"] = {}) as MobileSyncUpdatesPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MobileSyncUpdatesPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("MobileSyncUpdate", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["MobileSyncUpdatesPageResult"] = newMobileSyncUpdatesPageResult;

export interface MobileSyncUpdateOptions {
  __typename?: "MobileSyncUpdate";
  id?: MobileSyncUpdate["id"];
  type?: MobileSyncUpdate["type"];
  createdAt?: MobileSyncUpdate["createdAt"];
  updatedAt?: MobileSyncUpdate["updatedAt"];
  entityId?: MobileSyncUpdate["entityId"];
  entity?:
    | Asset
    | TradePartner
    | Bill
    | ScheduleTask
    | PlanTask
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Commitment
    | Document
    | JobLogNote
    | PunchlistItemTodo
    | Comment
    | ProjectStage
    | CommitmentDraw
    | FeatureFlag
    | JobLog
    | JobLogImage
    | Location
    | MobileSyncUpdate
    | ScheduleFlag
    | ScheduleFlagReason
    | ScheduleTaskChecklistItem
    | TaskWorkDay
    | TradePartnerContact
    | TradePartnerUser
    | Entity
    | EntityOptions
    | null;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
}

export function newMobileSyncUpdate(
  options: MobileSyncUpdateOptions = {},
  cache: Record<string, any> = {},
): MobileSyncUpdate {
  const o = (options.__typename ? options : cache["MobileSyncUpdate"] = {}) as MobileSyncUpdate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MobileSyncUpdate";
  o.id = options.id ?? nextFactoryId("MobileSyncUpdate");
  o.type = options.type ?? MobileSyncUpdateType.Created;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.entityId = options.entityId ?? "entityId";
  o.entity = maybeNewOrNull("Entity", options.entity, cache);
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  return o;
}

factories["MobileSyncUpdate"] = newMobileSyncUpdate;

export interface OptionPricingConfigOptions {
  __typename?: "OptionPricingConfig";
  id?: OptionPricingConfig["id"];
  selectionFeeInCents?: OptionPricingConfig["selectionFeeInCents"];
  createdAt?: OptionPricingConfig["createdAt"];
  updatedAt?: OptionPricingConfig["updatedAt"];
  variants?: Array<OptionPricingConfigVariant | OptionPricingConfigVariantOptions>;
  parent?:
    | OptionPricingConfigParent
    | CostCodeOptions
    | RequireTypename<GlobalOptionOptions>
    | RequireTypename<ItemOptions>
    | RequireTypename<MaterialListingOptions>
    | null;
  preCutoffDesiredMarginInBasisPoints?: OptionPricingConfig["preCutoffDesiredMarginInBasisPoints"];
  postCutoffDesiredMarginInBasisPoints?: OptionPricingConfig["postCutoffDesiredMarginInBasisPoints"];
  reasonNote?: OptionPricingConfig["reasonNote"];
  minimumPriceInCents?: OptionPricingConfig["minimumPriceInCents"];
}

export function newOptionPricingConfig(
  options: OptionPricingConfigOptions = {},
  cache: Record<string, any> = {},
): OptionPricingConfig {
  const o = (options.__typename ? options : cache["OptionPricingConfig"] = {}) as OptionPricingConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "OptionPricingConfig";
  o.id = options.id ?? nextFactoryId("OptionPricingConfig");
  o.selectionFeeInCents = options.selectionFeeInCents ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.variants = (options.variants ?? []).map((i) =>
    maybeNew("OptionPricingConfigVariant", i, cache, options.hasOwnProperty("variants"))
  );
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "CostCode", options.parent, cache);
  o.preCutoffDesiredMarginInBasisPoints = options.preCutoffDesiredMarginInBasisPoints ?? 0;
  o.postCutoffDesiredMarginInBasisPoints = options.postCutoffDesiredMarginInBasisPoints ?? null;
  o.reasonNote = options.reasonNote ?? null;
  o.minimumPriceInCents = options.minimumPriceInCents ?? 0;
  return o;
}

factories["OptionPricingConfig"] = newOptionPricingConfig;

export interface SaveOptionPricingConfigsResultOptions {
  __typename?: "SaveOptionPricingConfigsResult";
  optionPricingConfigs?: Array<OptionPricingConfig | OptionPricingConfigOptions>;
}

export function newSaveOptionPricingConfigsResult(
  options: SaveOptionPricingConfigsResultOptions = {},
  cache: Record<string, any> = {},
): SaveOptionPricingConfigsResult {
  const o =
    (options.__typename ? options : cache["SaveOptionPricingConfigsResult"] = {}) as SaveOptionPricingConfigsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveOptionPricingConfigsResult";
  o.optionPricingConfigs = (options.optionPricingConfigs ?? []).map((i) =>
    maybeNew("OptionPricingConfig", i, cache, options.hasOwnProperty("optionPricingConfigs"))
  );
  return o;
}

factories["SaveOptionPricingConfigsResult"] = newSaveOptionPricingConfigsResult;

export interface OptionPricingConfigVariantOptions {
  __typename?: "OptionPricingConfigVariant";
  id?: OptionPricingConfigVariant["id"];
  createdAt?: OptionPricingConfigVariant["createdAt"];
  updatedAt?: OptionPricingConfigVariant["updatedAt"];
  optionPricingConfig?: OptionPricingConfig | OptionPricingConfigOptions;
  preCutoffDesiredMarginInBasisPoints?: OptionPricingConfigVariant["preCutoffDesiredMarginInBasisPoints"];
  postCutoffDesiredMarginInBasisPoints?: OptionPricingConfigVariant["postCutoffDesiredMarginInBasisPoints"];
  selectionFeeInCents?: OptionPricingConfigVariant["selectionFeeInCents"];
  reasonNote?: OptionPricingConfigVariant["reasonNote"];
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  minimumPriceInCents?: OptionPricingConfigVariant["minimumPriceInCents"];
}

export function newOptionPricingConfigVariant(
  options: OptionPricingConfigVariantOptions = {},
  cache: Record<string, any> = {},
): OptionPricingConfigVariant {
  const o = (options.__typename ? options : cache["OptionPricingConfigVariant"] = {}) as OptionPricingConfigVariant;
  (cache.all ??= new Set()).add(o);
  o.__typename = "OptionPricingConfigVariant";
  o.id = options.id ?? nextFactoryId("OptionPricingConfigVariant");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.optionPricingConfig = maybeNew(
    "OptionPricingConfig",
    options.optionPricingConfig,
    cache,
    options.hasOwnProperty("optionPricingConfig"),
  );
  o.preCutoffDesiredMarginInBasisPoints = options.preCutoffDesiredMarginInBasisPoints ?? 0;
  o.postCutoffDesiredMarginInBasisPoints = options.postCutoffDesiredMarginInBasisPoints ?? null;
  o.selectionFeeInCents = options.selectionFeeInCents ?? null;
  o.reasonNote = options.reasonNote ?? null;
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  o.minimumPriceInCents = options.minimumPriceInCents ?? null;
  return o;
}

factories["OptionPricingConfigVariant"] = newOptionPricingConfigVariant;

export interface PageInfoOptions {
  __typename?: "PageInfo";
  hasNextPage?: PageInfo["hasNextPage"];
  totalCount?: PageInfo["totalCount"];
  nextPage?: Page | PageOptions | null;
}

export function newPageInfo(options: PageInfoOptions = {}, cache: Record<string, any> = {}): PageInfo {
  const o = (options.__typename ? options : cache["PageInfo"] = {}) as PageInfo;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PageInfo";
  o.hasNextPage = options.hasNextPage ?? false;
  o.totalCount = options.totalCount ?? 0;
  o.nextPage = maybeNewOrNull("Page", options.nextPage, cache);
  return o;
}

factories["PageInfo"] = newPageInfo;

export interface PageOptions {
  __typename?: "Page";
  limit?: Page["limit"];
  offset?: Page["offset"];
}

export function newPage(options: PageOptions = {}, cache: Record<string, any> = {}): Page {
  const o = (options.__typename ? options : cache["Page"] = {}) as Page;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Page";
  o.limit = options.limit ?? 0;
  o.offset = options.offset ?? 0;
  return o;
}

factories["Page"] = newPage;

export interface PandaDocSessionOptions {
  __typename?: "PandaDocSession";
  sessionId?: PandaDocSession["sessionId"];
}

export function newPandaDocSession(
  options: PandaDocSessionOptions = {},
  cache: Record<string, any> = {},
): PandaDocSession {
  const o = (options.__typename ? options : cache["PandaDocSession"] = {}) as PandaDocSession;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PandaDocSession";
  o.sessionId = options.sessionId ?? "sessionId";
  return o;
}

factories["PandaDocSession"] = newPandaDocSession;

export interface PandaDocOptions {
  __typename?: "PandaDoc";
  id?: PandaDoc["id"];
  name?: PandaDoc["name"];
  externalPandaDocId?: PandaDoc["externalPandaDocId"];
  externalPandaDocUrl?: PandaDoc["externalPandaDocUrl"];
  status?: PandaDoc["status"];
  statusDetail?: PandaDocStatusDetailOptions | PandaDocStatus;
  recipients?: Array<PandaDocRecipient | PandaDocRecipientOptions>;
  commitment?: Commitment | CommitmentOptions | null;
  developmentCommitment?: DevelopmentCommitment | DevelopmentCommitmentOptions | null;
  commitmentChangeOrder?: CommitmentChangeOrder | CommitmentChangeOrderOptions | null;
  tags?: PandaDoc["tags"];
  document?: Document | DocumentOptions | null;
  owner?:
    | PandaDocOwner
    | BidContractRevisionOptions
    | RequireTypename<ChangeEventOptions>
    | RequireTypename<CommitmentOptions>
    | RequireTypename<CommitmentChangeOrderOptions>
    | RequireTypename<DevelopmentCommitmentOptions>
    | RequireTypename<InvoiceOptions>
    | RequireTypename<LienWaiverOptions>
    | null;
  externalError?: PandaDoc["externalError"];
  canUpload?: PotentialOperation2 | PotentialOperation2Options | null;
  canCreatePandaDocSession?: PotentialOperation2 | PotentialOperation2Options | null;
}

export function newPandaDoc(options: PandaDocOptions = {}, cache: Record<string, any> = {}): PandaDoc {
  const o = (options.__typename ? options : cache["PandaDoc"] = {}) as PandaDoc;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PandaDoc";
  o.id = options.id ?? nextFactoryId("PandaDoc");
  o.name = options.name ?? "name";
  o.externalPandaDocId = options.externalPandaDocId ?? null;
  o.externalPandaDocUrl = options.externalPandaDocUrl ?? null;
  o.status = options.status ?? PandaDocStatus.Pending;
  o.statusDetail = enumOrDetailOfPandaDocStatus(options.statusDetail);
  o.recipients = (options.recipients ?? []).map((i) =>
    maybeNew("PandaDocRecipient", i, cache, options.hasOwnProperty("recipients"))
  );
  o.commitment = maybeNewOrNull("Commitment", options.commitment, cache);
  o.developmentCommitment = maybeNewOrNull("DevelopmentCommitment", options.developmentCommitment, cache);
  o.commitmentChangeOrder = maybeNewOrNull("CommitmentChangeOrder", options.commitmentChangeOrder, cache);
  o.tags = options.tags ?? [];
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.owner = maybeNewOrNull(options.owner?.__typename ?? "BidContractRevision", options.owner, cache);
  o.externalError = options.externalError ?? null;
  o.canUpload = maybeNewOrNull("PotentialOperation2", options.canUpload, cache);
  o.canCreatePandaDocSession = maybeNewOrNull("PotentialOperation2", options.canCreatePandaDocSession, cache);
  return o;
}

factories["PandaDoc"] = newPandaDoc;

export interface SavePandaDocResultOptions {
  __typename?: "SavePandaDocResult";
  pandaDoc?: PandaDoc | PandaDocOptions;
}

export function newSavePandaDocResult(
  options: SavePandaDocResultOptions = {},
  cache: Record<string, any> = {},
): SavePandaDocResult {
  const o = (options.__typename ? options : cache["SavePandaDocResult"] = {}) as SavePandaDocResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePandaDocResult";
  o.pandaDoc = maybeNew("PandaDoc", options.pandaDoc, cache, options.hasOwnProperty("pandaDoc"));
  return o;
}

factories["SavePandaDocResult"] = newSavePandaDocResult;

export interface DeletePandaDocResultOptions {
  __typename?: "DeletePandaDocResult";
  owner?:
    | PandaDocOwner
    | BidContractRevisionOptions
    | RequireTypename<ChangeEventOptions>
    | RequireTypename<CommitmentOptions>
    | RequireTypename<CommitmentChangeOrderOptions>
    | RequireTypename<DevelopmentCommitmentOptions>
    | RequireTypename<InvoiceOptions>
    | RequireTypename<LienWaiverOptions>;
}

export function newDeletePandaDocResult(
  options: DeletePandaDocResultOptions = {},
  cache: Record<string, any> = {},
): DeletePandaDocResult {
  const o = (options.__typename ? options : cache["DeletePandaDocResult"] = {}) as DeletePandaDocResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeletePandaDocResult";
  o.owner = maybeNew(options.owner?.__typename ?? "BidContractRevision", options.owner, cache);
  return o;
}

factories["DeletePandaDocResult"] = newDeletePandaDocResult;

export interface UploadPandaDocResultOptions {
  __typename?: "UploadPandaDocResult";
  pandaDoc?: PandaDoc | PandaDocOptions;
}

export function newUploadPandaDocResult(
  options: UploadPandaDocResultOptions = {},
  cache: Record<string, any> = {},
): UploadPandaDocResult {
  const o = (options.__typename ? options : cache["UploadPandaDocResult"] = {}) as UploadPandaDocResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UploadPandaDocResult";
  o.pandaDoc = maybeNew("PandaDoc", options.pandaDoc, cache, options.hasOwnProperty("pandaDoc"));
  return o;
}

factories["UploadPandaDocResult"] = newUploadPandaDocResult;

export interface PandaDocRecipientOptions {
  __typename?: "PandaDocRecipient";
  id?: PandaDocRecipient["id"];
  name?: PandaDocRecipient["name"];
  firstName?: PandaDocRecipient["firstName"];
  lastName?: PandaDocRecipient["lastName"];
  email?: PandaDocRecipient["email"];
  role?: PandaDocRecipient["role"];
  roleDetail?: PandaDocRoleDetailOptions | PandaDocRole;
  pandaDoc?: PandaDoc | PandaDocOptions;
  signingOrder?: PandaDocRecipient["signingOrder"];
  hasCompleted?: PandaDocRecipient["hasCompleted"];
}

export function newPandaDocRecipient(
  options: PandaDocRecipientOptions = {},
  cache: Record<string, any> = {},
): PandaDocRecipient {
  const o = (options.__typename ? options : cache["PandaDocRecipient"] = {}) as PandaDocRecipient;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PandaDocRecipient";
  o.id = options.id ?? nextFactoryId("PandaDocRecipient");
  o.name = options.name ?? "name";
  o.firstName = options.firstName ?? "firstName";
  o.lastName = options.lastName ?? "lastName";
  o.email = options.email ?? "email";
  o.role = options.role ?? PandaDocRole.User;
  o.roleDetail = enumOrDetailOfPandaDocRole(options.roleDetail);
  o.pandaDoc = maybeNew("PandaDoc", options.pandaDoc, cache, options.hasOwnProperty("pandaDoc"));
  o.signingOrder = options.signingOrder ?? null;
  o.hasCompleted = options.hasCompleted ?? false;
  return o;
}

factories["PandaDocRecipient"] = newPandaDocRecipient;

export interface PaymentTermOptions {
  __typename?: "PaymentTerm";
  id?: PaymentTerm["id"];
  name?: PaymentTerm["name"];
  description?: PaymentTerm["description"];
  active?: PaymentTerm["active"];
  intacctId?: PaymentTerm["intacctId"];
  createdAt?: PaymentTerm["createdAt"];
  updatedAt?: PaymentTerm["updatedAt"];
  alignWithPaymentCycle?: PaymentTerm["alignWithPaymentCycle"];
  dueDay?: PaymentTerm["dueDay"];
  dueFrom?: PaymentTermDueFromDetailOptions | PaymentTermDueFrom;
}

export function newPaymentTerm(options: PaymentTermOptions = {}, cache: Record<string, any> = {}): PaymentTerm {
  const o = (options.__typename ? options : cache["PaymentTerm"] = {}) as PaymentTerm;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PaymentTerm";
  o.id = options.id ?? nextFactoryId("PaymentTerm");
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.active = options.active ?? false;
  o.intacctId = options.intacctId ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.alignWithPaymentCycle = options.alignWithPaymentCycle ?? false;
  o.dueDay = options.dueDay ?? 0;
  o.dueFrom = enumOrDetailOfPaymentTermDueFrom(options.dueFrom);
  return o;
}

factories["PaymentTerm"] = newPaymentTerm;

export interface SavePaymentTermResultOptions {
  __typename?: "SavePaymentTermResult";
  paymentTerm?: PaymentTerm | PaymentTermOptions;
}

export function newSavePaymentTermResult(
  options: SavePaymentTermResultOptions = {},
  cache: Record<string, any> = {},
): SavePaymentTermResult {
  const o = (options.__typename ? options : cache["SavePaymentTermResult"] = {}) as SavePaymentTermResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePaymentTermResult";
  o.paymentTerm = maybeNew("PaymentTerm", options.paymentTerm, cache, options.hasOwnProperty("paymentTerm"));
  return o;
}

factories["SavePaymentTermResult"] = newSavePaymentTermResult;

export interface PermissionsOptions {
  __typename?: "Permissions";
  canEdit?: Permissions["canEdit"];
  canDelete?: Permissions["canDelete"];
}

export function newPermissions(options: PermissionsOptions = {}, cache: Record<string, any> = {}): Permissions {
  const o = (options.__typename ? options : cache["Permissions"] = {}) as Permissions;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Permissions";
  o.canEdit = options.canEdit ?? false;
  o.canDelete = options.canDelete ?? false;
  return o;
}

factories["Permissions"] = newPermissions;

export interface PlanBasedBidContractLineItemOptions {
  __typename?: "PlanBasedBidContractLineItem";
  id?: PlanBasedBidContractLineItem["id"];
  totalCostInCents?: PlanBasedBidContractLineItem["totalCostInCents"];
  createdAt?: PlanBasedBidContractLineItem["createdAt"];
  updatedAt?: PlanBasedBidContractLineItem["updatedAt"];
  revision?: BidContractRevision | BidContractRevisionOptions;
  costCode?: CostCode | CostCodeOptions;
  groupLine?: BidPlanChildGroupLine | BidPlanChildGroupLineOptions;
  forCoveringTakeoffs?: PlanBasedBidContractLineItem["forCoveringTakeoffs"];
  isNoCost?: PlanBasedBidContractLineItem["isNoCost"];
}

export function newPlanBasedBidContractLineItem(
  options: PlanBasedBidContractLineItemOptions = {},
  cache: Record<string, any> = {},
): PlanBasedBidContractLineItem {
  const o = (options.__typename ? options : cache["PlanBasedBidContractLineItem"] = {}) as PlanBasedBidContractLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanBasedBidContractLineItem";
  o.id = options.id ?? nextFactoryId("PlanBasedBidContractLineItem");
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.revision = maybeNew("BidContractRevision", options.revision, cache, options.hasOwnProperty("revision"));
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.groupLine = maybeNew("BidPlanChildGroupLine", options.groupLine, cache, options.hasOwnProperty("groupLine"));
  o.forCoveringTakeoffs = options.forCoveringTakeoffs ?? false;
  o.isNoCost = options.isNoCost ?? false;
  return o;
}

factories["PlanBasedBidContractLineItem"] = newPlanBasedBidContractLineItem;

export interface PlanMilestoneOptions {
  __typename?: "PlanMilestone";
  id?: PlanMilestone["id"];
  name?: PlanMilestone["name"];
  estStartDate?: PlanMilestone["estStartDate"];
  estEndDate?: PlanMilestone["estEndDate"];
  totalDays?: PlanMilestone["totalDays"];
  progress?: PlanMilestone["progress"];
  confidence?: PlanMilestone["confidence"];
  durationInDays?: PlanMilestone["durationInDays"];
  createdAt?: PlanMilestone["createdAt"];
  updatedAt?: PlanMilestone["updatedAt"];
  globalPlanMilestone?: GlobalPlanMilestone | GlobalPlanMilestoneOptions;
  planSchedule?: PlanSchedule | PlanScheduleOptions;
  allowingPlanTasks?: Array<PlanTask | PlanTaskOptions>;
  taskStatusRollup?: TaskStatusDetailOptions | TaskStatus;
  completedAt?: PlanMilestone["completedAt"];
}

export function newPlanMilestone(options: PlanMilestoneOptions = {}, cache: Record<string, any> = {}): PlanMilestone {
  const o = (options.__typename ? options : cache["PlanMilestone"] = {}) as PlanMilestone;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanMilestone";
  o.id = options.id ?? nextFactoryId("PlanMilestone");
  o.name = options.name ?? "name";
  o.estStartDate = options.estStartDate ?? null;
  o.estEndDate = options.estEndDate ?? null;
  o.totalDays = options.totalDays ?? 0;
  o.progress = options.progress ?? 0;
  o.confidence = options.confidence ?? 0;
  o.durationInDays = options.durationInDays ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.globalPlanMilestone = maybeNew(
    "GlobalPlanMilestone",
    options.globalPlanMilestone,
    cache,
    options.hasOwnProperty("globalPlanMilestone"),
  );
  o.planSchedule = maybeNew("PlanSchedule", options.planSchedule, cache, options.hasOwnProperty("planSchedule"));
  o.allowingPlanTasks = (options.allowingPlanTasks ?? []).map((i) =>
    maybeNew("PlanTask", i, cache, options.hasOwnProperty("allowingPlanTasks"))
  );
  o.taskStatusRollup = enumOrDetailOfTaskStatus(options.taskStatusRollup);
  o.completedAt = options.completedAt ?? null;
  return o;
}

factories["PlanMilestone"] = newPlanMilestone;

export interface PlanMilestonesResultOptions {
  __typename?: "PlanMilestonesResult";
  entities?: Array<PlanMilestone | PlanMilestoneOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newPlanMilestonesResult(
  options: PlanMilestonesResultOptions = {},
  cache: Record<string, any> = {},
): PlanMilestonesResult {
  const o = (options.__typename ? options : cache["PlanMilestonesResult"] = {}) as PlanMilestonesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanMilestonesResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("PlanMilestone", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["PlanMilestonesResult"] = newPlanMilestonesResult;

export interface PlanMilestoneSnapshotOptions {
  __typename?: "PlanMilestoneSnapshot";
  id?: PlanMilestoneSnapshot["id"];
  range?: PlanMilestoneSnapshot["range"];
  estStartDate?: PlanMilestoneSnapshot["estStartDate"];
  estEndDate?: PlanMilestoneSnapshot["estEndDate"];
  durationInDays?: PlanMilestoneSnapshot["durationInDays"];
  createdAt?: PlanMilestoneSnapshot["createdAt"];
  updatedAt?: PlanMilestoneSnapshot["updatedAt"];
  planMilestone?: PlanMilestone | PlanMilestoneOptions;
}

export function newPlanMilestoneSnapshot(
  options: PlanMilestoneSnapshotOptions = {},
  cache: Record<string, any> = {},
): PlanMilestoneSnapshot {
  const o = (options.__typename ? options : cache["PlanMilestoneSnapshot"] = {}) as PlanMilestoneSnapshot;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanMilestoneSnapshot";
  o.id = options.id ?? nextFactoryId("PlanMilestoneSnapshot");
  o.range = options.range ?? "range";
  o.estStartDate = options.estStartDate ?? null;
  o.estEndDate = options.estEndDate ?? null;
  o.durationInDays = options.durationInDays ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.planMilestone = maybeNew("PlanMilestone", options.planMilestone, cache, options.hasOwnProperty("planMilestone"));
  return o;
}

factories["PlanMilestoneSnapshot"] = newPlanMilestoneSnapshot;

export interface PlanMilestoneTargetOptions {
  __typename?: "PlanMilestoneTarget";
  id?: PlanMilestoneTarget["id"];
  targetDaysFromRts?: PlanMilestoneTarget["targetDaysFromRts"];
  createdAt?: PlanMilestoneTarget["createdAt"];
  updatedAt?: PlanMilestoneTarget["updatedAt"];
  globalPlanMilestone?: GlobalPlanMilestone | GlobalPlanMilestoneOptions;
  planSchedule?: PlanSchedule | PlanScheduleOptions;
  communityTarget?: PlanMilestoneTarget | PlanMilestoneTargetOptions | null;
  planMilestone?: PlanMilestone | PlanMilestoneOptions | null;
  targetDaysFromRtsSetByUser?: PlanMilestoneTarget["targetDaysFromRtsSetByUser"];
}

export function newPlanMilestoneTarget(
  options: PlanMilestoneTargetOptions = {},
  cache: Record<string, any> = {},
): PlanMilestoneTarget {
  const o = (options.__typename ? options : cache["PlanMilestoneTarget"] = {}) as PlanMilestoneTarget;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanMilestoneTarget";
  o.id = options.id ?? nextFactoryId("PlanMilestoneTarget");
  o.targetDaysFromRts = options.targetDaysFromRts ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.globalPlanMilestone = maybeNew(
    "GlobalPlanMilestone",
    options.globalPlanMilestone,
    cache,
    options.hasOwnProperty("globalPlanMilestone"),
  );
  o.planSchedule = maybeNew("PlanSchedule", options.planSchedule, cache, options.hasOwnProperty("planSchedule"));
  o.communityTarget = maybeNewOrNull("PlanMilestoneTarget", options.communityTarget, cache);
  o.planMilestone = maybeNewOrNull("PlanMilestone", options.planMilestone, cache);
  o.targetDaysFromRtsSetByUser = options.targetDaysFromRtsSetByUser ?? null;
  return o;
}

factories["PlanMilestoneTarget"] = newPlanMilestoneTarget;

export interface SavePlanPackageResultOptions {
  __typename?: "SavePlanPackageResult";
  planPackage?: PlanPackage | PlanPackageOptions;
}

export function newSavePlanPackageResult(
  options: SavePlanPackageResultOptions = {},
  cache: Record<string, any> = {},
): SavePlanPackageResult {
  const o = (options.__typename ? options : cache["SavePlanPackageResult"] = {}) as SavePlanPackageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePlanPackageResult";
  o.planPackage = maybeNew("PlanPackage", options.planPackage, cache, options.hasOwnProperty("planPackage"));
  return o;
}

factories["SavePlanPackageResult"] = newSavePlanPackageResult;

export interface PlanPackagesPageResultOptions {
  __typename?: "PlanPackagesPageResult";
  entities?: Array<PlanPackage | PlanPackageOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newPlanPackagesPageResult(
  options: PlanPackagesPageResultOptions = {},
  cache: Record<string, any> = {},
): PlanPackagesPageResult {
  const o = (options.__typename ? options : cache["PlanPackagesPageResult"] = {}) as PlanPackagesPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanPackagesPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("PlanPackage", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["PlanPackagesPageResult"] = newPlanPackagesPageResult;

export interface PlanPackageAiProposalOptions {
  __typename?: "PlanPackageAiProposal";
  id?: PlanPackageAiProposal["id"];
  createdAt?: PlanPackageAiProposal["createdAt"];
  updatedAt?: PlanPackageAiProposal["updatedAt"];
  entityProposals?: Array<AiEntityProposal | AiEntityProposalOptions>;
  status?: AiProposalStatusDetailOptions | AiProposalStatus;
  planPackage?: PlanPackage | PlanPackageOptions;
  asset?: Asset | AssetOptions;
}

export function newPlanPackageAiProposal(
  options: PlanPackageAiProposalOptions = {},
  cache: Record<string, any> = {},
): PlanPackageAiProposal {
  const o = (options.__typename ? options : cache["PlanPackageAiProposal"] = {}) as PlanPackageAiProposal;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanPackageAiProposal";
  o.id = options.id ?? nextFactoryId("PlanPackageAiProposal");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.entityProposals = (options.entityProposals ?? []).map((i) =>
    maybeNew("AiEntityProposal", i, cache, options.hasOwnProperty("entityProposals"))
  );
  o.status = enumOrDetailOfAiProposalStatus(options.status);
  o.planPackage = maybeNew("PlanPackage", options.planPackage, cache, options.hasOwnProperty("planPackage"));
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  return o;
}

factories["PlanPackageAiProposal"] = newPlanPackageAiProposal;

export interface PlanPackageIncomingSlotOptions {
  __typename?: "PlanPackageIncomingSlot";
  id?: PlanPackageIncomingSlot["id"];
  createdAt?: PlanPackageIncomingSlot["createdAt"];
  createdBy?: User | UserOptions;
  planPackage?: PlanPackage | PlanPackageOptions;
  designPackage?: DesignPackage | DesignPackageOptions;
  designPackagePlaceholder?: TakeoffLineItem | TakeoffLineItemOptions;
  status?: PlanPackageIncomingSlotStatusDetailOptions | PlanPackageIncomingSlotStatus;
  planPackageRpl?: ReadyPlanLocation | ReadyPlanLocationOptions;
}

export function newPlanPackageIncomingSlot(
  options: PlanPackageIncomingSlotOptions = {},
  cache: Record<string, any> = {},
): PlanPackageIncomingSlot {
  const o = (options.__typename ? options : cache["PlanPackageIncomingSlot"] = {}) as PlanPackageIncomingSlot;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanPackageIncomingSlot";
  o.id = options.id ?? nextFactoryId("PlanPackageIncomingSlot");
  o.createdAt = options.createdAt ?? newDateTime();
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.planPackage = maybeNew("PlanPackage", options.planPackage, cache, options.hasOwnProperty("planPackage"));
  o.designPackage = maybeNew("DesignPackage", options.designPackage, cache, options.hasOwnProperty("designPackage"));
  o.designPackagePlaceholder = maybeNew(
    "TakeoffLineItem",
    options.designPackagePlaceholder,
    cache,
    options.hasOwnProperty("designPackagePlaceholder"),
  );
  o.status = enumOrDetailOfPlanPackageIncomingSlotStatus(options.status);
  o.planPackageRpl = maybeNew(
    "ReadyPlanLocation",
    options.planPackageRpl,
    cache,
    options.hasOwnProperty("planPackageRpl"),
  );
  return o;
}

factories["PlanPackageIncomingSlot"] = newPlanPackageIncomingSlot;

export interface PlanPackageSlotDeletionRequestOptions {
  __typename?: "PlanPackageSlotDeletionRequest";
  id?: PlanPackageSlotDeletionRequest["id"];
}

export function newPlanPackageSlotDeletionRequest(
  options: PlanPackageSlotDeletionRequestOptions = {},
  cache: Record<string, any> = {},
): PlanPackageSlotDeletionRequest {
  const o =
    (options.__typename ? options : cache["PlanPackageSlotDeletionRequest"] = {}) as PlanPackageSlotDeletionRequest;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanPackageSlotDeletionRequest";
  o.id = options.id ?? nextFactoryId("PlanPackageSlotDeletionRequest");
  return o;
}

factories["PlanPackageSlotDeletionRequest"] = newPlanPackageSlotDeletionRequest;

export interface PlanPackageVersionOptions {
  __typename?: "PlanPackageVersion";
  id?: PlanPackageVersion["id"];
  name?: PlanPackageVersion["name"];
  createdAt?: PlanPackageVersion["createdAt"];
  updatedAt?: PlanPackageVersion["updatedAt"];
  code?: PlanPackageVersion["code"];
  contingencyMarkupPercentage?: PlanPackageVersion["contingencyMarkupPercentage"];
  description?: PlanPackageVersion["description"];
  type?: ReadyPlanTypeDetailOptions | ReadyPlanType;
  lotTypes?: PlanPackageVersion["lotTypes"];
  identity?: ReadyPlan | ReadyPlanOptions;
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  markets?: Array<Market | MarketOptions>;
  insideMapsProjectId?: PlanPackageVersion["insideMapsProjectId"];
  owner?: InternalUser | InternalUserOptions | null;
}

export function newPlanPackageVersion(
  options: PlanPackageVersionOptions = {},
  cache: Record<string, any> = {},
): PlanPackageVersion {
  const o = (options.__typename ? options : cache["PlanPackageVersion"] = {}) as PlanPackageVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanPackageVersion";
  o.id = options.id ?? nextFactoryId("PlanPackageVersion");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.code = options.code ?? null;
  o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
  o.description = options.description ?? null;
  o.type = enumOrDetailOfReadyPlanType(options.type);
  o.lotTypes = options.lotTypes ?? [];
  o.identity = maybeNew("ReadyPlan", options.identity, cache, options.hasOwnProperty("identity"));
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
  o.insideMapsProjectId = options.insideMapsProjectId ?? null;
  o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
  return o;
}

factories["PlanPackageVersion"] = newPlanPackageVersion;

export interface PlanScheduleOptions {
  __typename?: "PlanSchedule";
  id?: PlanSchedule["id"];
  createdAt?: PlanSchedule["createdAt"];
  updatedAt?: PlanSchedule["updatedAt"];
  tasks?: Array<PlanTask | PlanTaskOptions>;
  parent?:
    | PlanScheduleParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>;
  planMilestones?: Array<PlanMilestone | PlanMilestoneOptions>;
  recalculatedAt?: PlanSchedule["recalculatedAt"];
  recalculatedBy?: User | UserOptions | null;
  targetStartDate?: PlanSchedule["targetStartDate"];
  targetEndDate?: PlanSchedule["targetEndDate"];
  currentBaselineDate?: PlanSchedule["currentBaselineDate"];
  targetCycleTimeInDays?: PlanSchedule["targetCycleTimeInDays"];
  targetCycleTimeInCalendarDays?: PlanSchedule["targetCycleTimeInCalendarDays"];
  targetCycleTimeInWorkingDays?: PlanSchedule["targetCycleTimeInWorkingDays"];
  communityTargetCycleTimeInDays?: PlanSchedule["communityTargetCycleTimeInDays"];
  cycleTimeInWorkingDays?: PlanSchedule["cycleTimeInWorkingDays"];
  cycleTimeInCalendarDays?: PlanSchedule["cycleTimeInCalendarDays"];
  verticalCompleteDate?: PlanSchedule["verticalCompleteDate"];
  readyToStartDate?: PlanSchedule["readyToStartDate"];
  preconReadyToStartDate?: PlanSchedule["preconReadyToStartDate"];
  targetEndDateProbability?: PlanSchedule["targetEndDateProbability"];
  schedulingExclusionDates?: Array<SchedulingExclusionDate | SchedulingExclusionDateOptions>;
  canSendTradePartnerAvailabilityRequestEmail?: PotentialOperation2 | PotentialOperation2Options;
  targetConstructionRtsDate?: PlanSchedule["targetConstructionRtsDate"];
  targetPreconRtsDate?: PlanSchedule["targetPreconRtsDate"];
  planMilestoneTargets?: Array<PlanMilestoneTarget | PlanMilestoneTargetOptions>;
  childVerticalCompleteInDays?: PlanSchedule["childVerticalCompleteInDays"];
}

export function newPlanSchedule(options: PlanScheduleOptions = {}, cache: Record<string, any> = {}): PlanSchedule {
  const o = (options.__typename ? options : cache["PlanSchedule"] = {}) as PlanSchedule;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanSchedule";
  o.id = options.id ?? nextFactoryId("PlanSchedule");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tasks = (options.tasks ?? []).map((i) => maybeNew("PlanTask", i, cache, options.hasOwnProperty("tasks")));
  o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  o.planMilestones = (options.planMilestones ?? []).map((i) =>
    maybeNew("PlanMilestone", i, cache, options.hasOwnProperty("planMilestones"))
  );
  o.recalculatedAt = options.recalculatedAt ?? null;
  o.recalculatedBy = maybeNewOrNull("User", options.recalculatedBy, cache);
  o.targetStartDate = options.targetStartDate ?? newDate();
  o.targetEndDate = options.targetEndDate ?? newDate();
  o.currentBaselineDate = options.currentBaselineDate ?? newDate();
  o.targetCycleTimeInDays = options.targetCycleTimeInDays ?? 0;
  o.targetCycleTimeInCalendarDays = options.targetCycleTimeInCalendarDays ?? 0;
  o.targetCycleTimeInWorkingDays = options.targetCycleTimeInWorkingDays ?? 0;
  o.communityTargetCycleTimeInDays = options.communityTargetCycleTimeInDays ?? 0;
  o.cycleTimeInWorkingDays = options.cycleTimeInWorkingDays ?? null;
  o.cycleTimeInCalendarDays = options.cycleTimeInCalendarDays ?? null;
  o.verticalCompleteDate = options.verticalCompleteDate ?? null;
  o.readyToStartDate = options.readyToStartDate ?? null;
  o.preconReadyToStartDate = options.preconReadyToStartDate ?? null;
  o.targetEndDateProbability = options.targetEndDateProbability ?? null;
  o.schedulingExclusionDates = (options.schedulingExclusionDates ?? []).map((i) =>
    maybeNew("SchedulingExclusionDate", i, cache, options.hasOwnProperty("schedulingExclusionDates"))
  );
  o.canSendTradePartnerAvailabilityRequestEmail = maybeNew(
    "PotentialOperation2",
    options.canSendTradePartnerAvailabilityRequestEmail,
    cache,
    options.hasOwnProperty("canSendTradePartnerAvailabilityRequestEmail"),
  );
  o.targetConstructionRtsDate = options.targetConstructionRtsDate ?? null;
  o.targetPreconRtsDate = options.targetPreconRtsDate ?? null;
  o.planMilestoneTargets = (options.planMilestoneTargets ?? []).map((i) =>
    maybeNew("PlanMilestoneTarget", i, cache, options.hasOwnProperty("planMilestoneTargets"))
  );
  o.childVerticalCompleteInDays = options.childVerticalCompleteInDays ?? null;
  return o;
}

factories["PlanSchedule"] = newPlanSchedule;

export interface SavePlanScheduleResultOptions {
  __typename?: "SavePlanScheduleResult";
  planSchedule?: PlanSchedule | PlanScheduleOptions;
}

export function newSavePlanScheduleResult(
  options: SavePlanScheduleResultOptions = {},
  cache: Record<string, any> = {},
): SavePlanScheduleResult {
  const o = (options.__typename ? options : cache["SavePlanScheduleResult"] = {}) as SavePlanScheduleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePlanScheduleResult";
  o.planSchedule = maybeNew("PlanSchedule", options.planSchedule, cache, options.hasOwnProperty("planSchedule"));
  return o;
}

factories["SavePlanScheduleResult"] = newSavePlanScheduleResult;

export interface DraftScheduleResultOptions {
  __typename?: "DraftScheduleResult";
  planTasks?: Array<PlanTask | PlanTaskOptions>;
  newlyCompletedPlanTasks?: Array<PlanTask | PlanTaskOptions>;
  tradeConfirmPlanTasks?: Array<PlanTask | PlanTaskOptions>;
  planSchedule?: PlanSchedule | PlanScheduleOptions;
  bills?: Array<Bill | BillOptions> | null;
  planTaskDetail?: PlanTask | PlanTaskOptions | null;
}

export function newDraftScheduleResult(
  options: DraftScheduleResultOptions = {},
  cache: Record<string, any> = {},
): DraftScheduleResult {
  const o = (options.__typename ? options : cache["DraftScheduleResult"] = {}) as DraftScheduleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DraftScheduleResult";
  o.planTasks = (options.planTasks ?? []).map((i) =>
    maybeNew("PlanTask", i, cache, options.hasOwnProperty("planTasks"))
  );
  o.newlyCompletedPlanTasks = (options.newlyCompletedPlanTasks ?? []).map((i) =>
    maybeNew("PlanTask", i, cache, options.hasOwnProperty("newlyCompletedPlanTasks"))
  );
  o.tradeConfirmPlanTasks = (options.tradeConfirmPlanTasks ?? []).map((i) =>
    maybeNew("PlanTask", i, cache, options.hasOwnProperty("tradeConfirmPlanTasks"))
  );
  o.planSchedule = maybeNew("PlanSchedule", options.planSchedule, cache, options.hasOwnProperty("planSchedule"));
  o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
  o.planTaskDetail = maybeNewOrNull("PlanTask", options.planTaskDetail, cache);
  return o;
}

factories["DraftScheduleResult"] = newDraftScheduleResult;

export interface PlanScheduleSnapshotsResultOptions {
  __typename?: "PlanScheduleSnapshotsResult";
  taskSnapshots?: Array<TaskSnapshot | TaskSnapshotOptions>;
  planMilestoneSnapshots?: Array<PlanMilestoneSnapshot | PlanMilestoneSnapshotOptions>;
}

export function newPlanScheduleSnapshotsResult(
  options: PlanScheduleSnapshotsResultOptions = {},
  cache: Record<string, any> = {},
): PlanScheduleSnapshotsResult {
  const o = (options.__typename ? options : cache["PlanScheduleSnapshotsResult"] = {}) as PlanScheduleSnapshotsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanScheduleSnapshotsResult";
  o.taskSnapshots = (options.taskSnapshots ?? []).map((i) =>
    maybeNew("TaskSnapshot", i, cache, options.hasOwnProperty("taskSnapshots"))
  );
  o.planMilestoneSnapshots = (options.planMilestoneSnapshots ?? []).map((i) =>
    maybeNew("PlanMilestoneSnapshot", i, cache, options.hasOwnProperty("planMilestoneSnapshots"))
  );
  return o;
}

factories["PlanScheduleSnapshotsResult"] = newPlanScheduleSnapshotsResult;

export interface ForceScalePlanMilestoneTargetsResultOptions {
  __typename?: "ForceScalePlanMilestoneTargetsResult";
  planSchedules?: Array<PlanSchedule | PlanScheduleOptions>;
}

export function newForceScalePlanMilestoneTargetsResult(
  options: ForceScalePlanMilestoneTargetsResultOptions = {},
  cache: Record<string, any> = {},
): ForceScalePlanMilestoneTargetsResult {
  const o =
    (options.__typename
      ? options
      : cache["ForceScalePlanMilestoneTargetsResult"] = {}) as ForceScalePlanMilestoneTargetsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ForceScalePlanMilestoneTargetsResult";
  o.planSchedules = (options.planSchedules ?? []).map((i) =>
    maybeNew("PlanSchedule", i, cache, options.hasOwnProperty("planSchedules"))
  );
  return o;
}

factories["ForceScalePlanMilestoneTargetsResult"] = newForceScalePlanMilestoneTargetsResult;

export interface SavePlanTaskResultOptions {
  __typename?: "SavePlanTaskResult";
  planTask?: PlanTask | PlanTaskOptions;
}

export function newSavePlanTaskResult(
  options: SavePlanTaskResultOptions = {},
  cache: Record<string, any> = {},
): SavePlanTaskResult {
  const o = (options.__typename ? options : cache["SavePlanTaskResult"] = {}) as SavePlanTaskResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePlanTaskResult";
  o.planTask = maybeNew("PlanTask", options.planTask, cache, options.hasOwnProperty("planTask"));
  return o;
}

factories["SavePlanTaskResult"] = newSavePlanTaskResult;

export interface PlanTasksResultOptions {
  __typename?: "PlanTasksResult";
  entities?: Array<PlanTask | PlanTaskOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newPlanTasksResult(
  options: PlanTasksResultOptions = {},
  cache: Record<string, any> = {},
): PlanTasksResult {
  const o = (options.__typename ? options : cache["PlanTasksResult"] = {}) as PlanTasksResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanTasksResult";
  o.entities = (options.entities ?? []).map((i) => maybeNew("PlanTask", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["PlanTasksResult"] = newPlanTasksResult;

export interface SimulationProbabilityOptions {
  __typename?: "SimulationProbability";
  startDateBasisPoints?: SimulationProbability["startDateBasisPoints"];
  endDateBasisPoints?: SimulationProbability["endDateBasisPoints"];
  potentialStartDateBasisPoints?: Array<PotentialDateBasisPoints | PotentialDateBasisPointsOptions> | null;
  potentialEndDateBasisPoints?: Array<PotentialDateBasisPoints | PotentialDateBasisPointsOptions> | null;
}

export function newSimulationProbability(
  options: SimulationProbabilityOptions = {},
  cache: Record<string, any> = {},
): SimulationProbability {
  const o = (options.__typename ? options : cache["SimulationProbability"] = {}) as SimulationProbability;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SimulationProbability";
  o.startDateBasisPoints = options.startDateBasisPoints ?? null;
  o.endDateBasisPoints = options.endDateBasisPoints ?? null;
  o.potentialStartDateBasisPoints = (options.potentialStartDateBasisPoints ?? []).map((i) =>
    maybeNew("PotentialDateBasisPoints", i, cache, options.hasOwnProperty("potentialStartDateBasisPoints"))
  );
  o.potentialEndDateBasisPoints = (options.potentialEndDateBasisPoints ?? []).map((i) =>
    maybeNew("PotentialDateBasisPoints", i, cache, options.hasOwnProperty("potentialEndDateBasisPoints"))
  );
  return o;
}

factories["SimulationProbability"] = newSimulationProbability;

export interface PotentialDateBasisPointsOptions {
  __typename?: "PotentialDateBasisPoints";
  date?: PotentialDateBasisPoints["date"];
  basisPoints?: PotentialDateBasisPoints["basisPoints"];
}

export function newPotentialDateBasisPoints(
  options: PotentialDateBasisPointsOptions = {},
  cache: Record<string, any> = {},
): PotentialDateBasisPoints {
  const o = (options.__typename ? options : cache["PotentialDateBasisPoints"] = {}) as PotentialDateBasisPoints;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PotentialDateBasisPoints";
  o.date = options.date ?? newDate();
  o.basisPoints = options.basisPoints ?? 0;
  return o;
}

factories["PotentialDateBasisPoints"] = newPotentialDateBasisPoints;

export interface BulkSavePlanTasksResultOptions {
  __typename?: "BulkSavePlanTasksResult";
  planTasks?: Array<PlanTask | PlanTaskOptions>;
}

export function newBulkSavePlanTasksResult(
  options: BulkSavePlanTasksResultOptions = {},
  cache: Record<string, any> = {},
): BulkSavePlanTasksResult {
  const o = (options.__typename ? options : cache["BulkSavePlanTasksResult"] = {}) as BulkSavePlanTasksResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BulkSavePlanTasksResult";
  o.planTasks = (options.planTasks ?? []).map((i) =>
    maybeNew("PlanTask", i, cache, options.hasOwnProperty("planTasks"))
  );
  return o;
}

factories["BulkSavePlanTasksResult"] = newBulkSavePlanTasksResult;

export interface PlanTaskChecklistItemOptions {
  __typename?: "PlanTaskChecklistItem";
  id?: PlanTaskChecklistItem["id"];
  name?: PlanTaskChecklistItem["name"];
  completedAt?: PlanTaskChecklistItem["completedAt"];
  createdAt?: PlanTaskChecklistItem["createdAt"];
  updatedAt?: PlanTaskChecklistItem["updatedAt"];
  planTask?: PlanTask | PlanTaskOptions;
  completedBy?: User | UserOptions | null;
  globalItem?: GlobalPlanTaskChecklistItem | GlobalPlanTaskChecklistItemOptions;
}

export function newPlanTaskChecklistItem(
  options: PlanTaskChecklistItemOptions = {},
  cache: Record<string, any> = {},
): PlanTaskChecklistItem {
  const o = (options.__typename ? options : cache["PlanTaskChecklistItem"] = {}) as PlanTaskChecklistItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanTaskChecklistItem";
  o.id = options.id ?? nextFactoryId("PlanTaskChecklistItem");
  o.name = options.name ?? "name";
  o.completedAt = options.completedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.planTask = maybeNew("PlanTask", options.planTask, cache, options.hasOwnProperty("planTask"));
  o.completedBy = maybeNewOrNull("User", options.completedBy, cache);
  o.globalItem = maybeNew(
    "GlobalPlanTaskChecklistItem",
    options.globalItem,
    cache,
    options.hasOwnProperty("globalItem"),
  );
  return o;
}

factories["PlanTaskChecklistItem"] = newPlanTaskChecklistItem;

export interface SavePlanTaskChecklistItemResultOptions {
  __typename?: "SavePlanTaskChecklistItemResult";
  planTaskChecklistItem?: PlanTaskChecklistItem | PlanTaskChecklistItemOptions;
}

export function newSavePlanTaskChecklistItemResult(
  options: SavePlanTaskChecklistItemResultOptions = {},
  cache: Record<string, any> = {},
): SavePlanTaskChecklistItemResult {
  const o =
    (options.__typename ? options : cache["SavePlanTaskChecklistItemResult"] = {}) as SavePlanTaskChecklistItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePlanTaskChecklistItemResult";
  o.planTaskChecklistItem = maybeNew(
    "PlanTaskChecklistItem",
    options.planTaskChecklistItem,
    cache,
    options.hasOwnProperty("planTaskChecklistItem"),
  );
  return o;
}

factories["SavePlanTaskChecklistItemResult"] = newSavePlanTaskChecklistItemResult;

export interface PreconContractTypeOptions {
  __typename?: "PreconContractType";
  id?: PreconContractType["id"];
  name?: PreconContractType["name"];
  createdAt?: PreconContractType["createdAt"];
  updatedAt?: PreconContractType["updatedAt"];
  projects?: Array<StandaloneProject | StandaloneProjectOptions>;
  inviteHomeowners?: PreconContractType["inviteHomeowners"];
  needsWeeklyUpdate?: PreconContractType["needsWeeklyUpdate"];
}

export function newPreconContractType(
  options: PreconContractTypeOptions = {},
  cache: Record<string, any> = {},
): PreconContractType {
  const o = (options.__typename ? options : cache["PreconContractType"] = {}) as PreconContractType;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PreconContractType";
  o.id = options.id ?? nextFactoryId("PreconContractType");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.projects = (options.projects ?? []).map((i) =>
    maybeNew("StandaloneProject", i, cache, options.hasOwnProperty("projects"))
  );
  o.inviteHomeowners = options.inviteHomeowners ?? false;
  o.needsWeeklyUpdate = options.needsWeeklyUpdate ?? false;
  return o;
}

factories["PreconContractType"] = newPreconContractType;

export interface SavePreconContractTypeResultOptions {
  __typename?: "SavePreconContractTypeResult";
  preconContractType?: PreconContractType | PreconContractTypeOptions;
}

export function newSavePreconContractTypeResult(
  options: SavePreconContractTypeResultOptions = {},
  cache: Record<string, any> = {},
): SavePreconContractTypeResult {
  const o = (options.__typename ? options : cache["SavePreconContractTypeResult"] = {}) as SavePreconContractTypeResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePreconContractTypeResult";
  o.preconContractType = maybeNew(
    "PreconContractType",
    options.preconContractType,
    cache,
    options.hasOwnProperty("preconContractType"),
  );
  return o;
}

factories["SavePreconContractTypeResult"] = newSavePreconContractTypeResult;

export interface ProductOfferingOptions {
  __typename?: "ProductOffering";
  id?: ProductOffering["id"];
  name?: ProductOffering["name"];
  displayName?: ProductOffering["displayName"];
  description?: ProductOffering["description"];
  createdAt?: ProductOffering["createdAt"];
  updatedAt?: ProductOffering["updatedAt"];
  type?: ReadyPlanTypeDetailOptions | ReadyPlanType;
  code?: ProductOffering["code"];
  displayCode?: ProductOffering["displayCode"];
  blueprintUrl?: Url | UrlOptions;
  constructionDocumentCompletePercentage?: ProductOffering["constructionDocumentCompletePercentage"];
  status?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  effectiveStatus?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  development?: Development | DevelopmentOptions | null;
  underwritingTemplate?: ItemTemplate | ItemTemplateOptions | null;
  maxProgramData?: ProgramData | ProgramDataOptions;
  minProgramData?: ProgramData | ProgramDataOptions;
  programData?: ProgramData | ProgramDataOptions;
  itemTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  userEvents?: Array<UserEvent | UserEventOptions>;
  planPackage?: PlanPackage | PlanPackageOptions;
  planPackageVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  programDatas?: Array<ReadyPlanProgramData | ReadyPlanProgramDataOptions>;
  copyInProgress?: ProductOffering["copyInProgress"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  assets?: Array<ReadyPlanAsset | ReadyPlanAssetOptions>;
  lotTypes?: ProductOffering["lotTypes"];
  baseConfig?: ProductOfferingConfig | ProductOfferingConfigOptions | null;
  configs?: Array<ProductOfferingConfig | ProductOfferingConfigOptions>;
  projectConfigs?: Array<ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions>;
  bidOutPercentage?: ProductOffering["bidOutPercentage"];
  coverAsset?: Asset | AssetOptions | null;
  floorPlanAsset?: Asset | AssetOptions | null;
  floorPlanAssets?: Array<ReadyPlanAsset | ReadyPlanAssetOptions>;
  interiorDesignPackage?: DesignPackage | DesignPackageOptions;
  interiorDesignPackageVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  exteriorDesignPackage?: DesignPackage | DesignPackageOptions;
  exteriorDesignPackageVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  designPackageCombinations?: Array<DesignPackageCombination | DesignPackageCombinationOptions>;
  aggregateActive?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  aggregateDraft?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  aggregateLatest?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  aggregateCheckout?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  aggregateVersions?: Array<ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions>;
  version?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  availableUpdates?: Array<ProductOfferingIncomingUpdate | ProductOfferingIncomingUpdateOptions>;
  itemLocations?: Array<Location | LocationOptions>;
  costCodes?: Array<CostCode | CostCodeOptions>;
  canEditLineItems?: PotentialOperation2 | PotentialOperation2Options;
  contingencyMarkupPercentage?: ProductOffering["contingencyMarkupPercentage"];
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  canEditOptions?: PotentialOperation2 | PotentialOperation2Options;
  publishToUnderwriting?: ProductOffering["publishToUnderwriting"];
  tourUrl?: ProductOffering["tourUrl"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  checkoutConfigs?: Array<CheckoutConfig | CheckoutConfigOptions>;
  showInCheckout?: ProductOffering["showInCheckout"];
  documents?: Array<Document | DocumentOptions>;
  rendering?: Asset | AssetOptions | null;
  interiorRenderings?: Array<InteriorRoomRendering | InteriorRoomRenderingOptions>;
  renderings?: Array<RenderingAsset | RenderingAssetOptions>;
  requiredOptions?: Array<ReadyPlanRequiredOption | ReadyPlanRequiredOptionOptions>;
  owner?: InternalUser | InternalUserOptions | null;
  cloneInProgress?: ProductOffering["cloneInProgress"];
  insideMapsMissingLocations?: ProductOffering["insideMapsMissingLocations"];
  promoteInProgress?: ProductOffering["promoteInProgress"];
  buildableLots?: Array<Lot | LotOptions>;
  insideMapsPacket?: ProductOffering["insideMapsPacket"];
  architectureFeePriceInCents?: ProductOffering["architectureFeePriceInCents"];
  preconServicesPriceInCents?: ProductOffering["preconServicesPriceInCents"];
  trackedJobs?: Array<TrackedJob | TrackedJobOptions>;
  activeElevationCount?: ProductOffering["activeElevationCount"];
  checkoutBlockingErrors?: ProductOffering["checkoutBlockingErrors"];
}

export function newProductOffering(
  options: ProductOfferingOptions = {},
  cache: Record<string, any> = {},
): ProductOffering {
  const o = (options.__typename ? options : cache["ProductOffering"] = {}) as ProductOffering;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductOffering";
  o.id = options.id ?? nextFactoryId("ProductOffering");
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.type = enumOrDetailOfReadyPlanType(options.type);
  o.code = options.code ?? null;
  o.displayCode = options.displayCode ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.constructionDocumentCompletePercentage = options.constructionDocumentCompletePercentage ?? 0;
  o.status = enumOrDetailOfReadyPlanStatus(options.status);
  o.effectiveStatus = enumOrDetailOfReadyPlanStatus(options.effectiveStatus);
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.underwritingTemplate = maybeNewOrNull("ItemTemplate", options.underwritingTemplate, cache);
  o.maxProgramData = maybeNew("ProgramData", options.maxProgramData, cache, options.hasOwnProperty("maxProgramData"));
  o.minProgramData = maybeNew("ProgramData", options.minProgramData, cache, options.hasOwnProperty("minProgramData"));
  o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
  o.itemTemplates = (options.itemTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("itemTemplates"))
  );
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.optionGroups = (options.optionGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("optionGroups"))
  );
  o.userEvents = (options.userEvents ?? []).map((i) =>
    maybeNew("UserEvent", i, cache, options.hasOwnProperty("userEvents"))
  );
  o.planPackage = maybeNew("PlanPackage", options.planPackage, cache, options.hasOwnProperty("planPackage"));
  o.planPackageVersion = maybeNew(
    "ReadyPlanAggregateVersion",
    options.planPackageVersion,
    cache,
    options.hasOwnProperty("planPackageVersion"),
  );
  o.programDatas = (options.programDatas ?? []).map((i) =>
    maybeNew("ReadyPlanProgramData", i, cache, options.hasOwnProperty("programDatas"))
  );
  o.copyInProgress = options.copyInProgress ?? false;
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.assets = (options.assets ?? []).map((i) => maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("assets")));
  o.lotTypes = options.lotTypes ?? [];
  o.baseConfig = maybeNewOrNull("ProductOfferingConfig", options.baseConfig, cache);
  o.configs = (options.configs ?? []).map((i) =>
    maybeNew("ProductOfferingConfig", i, cache, options.hasOwnProperty("configs"))
  );
  o.projectConfigs = (options.projectConfigs ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfig", i, cache, options.hasOwnProperty("projectConfigs"))
  );
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.coverAsset = maybeNewOrNull("Asset", options.coverAsset, cache);
  o.floorPlanAsset = maybeNewOrNull("Asset", options.floorPlanAsset, cache);
  o.floorPlanAssets = (options.floorPlanAssets ?? []).map((i) =>
    maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("floorPlanAssets"))
  );
  o.interiorDesignPackage = maybeNew(
    "DesignPackage",
    options.interiorDesignPackage,
    cache,
    options.hasOwnProperty("interiorDesignPackage"),
  );
  o.interiorDesignPackageVersion = maybeNew(
    "ReadyPlanAggregateVersion",
    options.interiorDesignPackageVersion,
    cache,
    options.hasOwnProperty("interiorDesignPackageVersion"),
  );
  o.exteriorDesignPackage = maybeNew(
    "DesignPackage",
    options.exteriorDesignPackage,
    cache,
    options.hasOwnProperty("exteriorDesignPackage"),
  );
  o.exteriorDesignPackageVersion = maybeNew(
    "ReadyPlanAggregateVersion",
    options.exteriorDesignPackageVersion,
    cache,
    options.hasOwnProperty("exteriorDesignPackageVersion"),
  );
  o.designPackageCombinations = (options.designPackageCombinations ?? []).map((i) =>
    maybeNew("DesignPackageCombination", i, cache, options.hasOwnProperty("designPackageCombinations"))
  );
  o.aggregateActive = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateActive, cache);
  o.aggregateDraft = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateDraft, cache);
  o.aggregateLatest = maybeNew(
    "ReadyPlanAggregateVersion",
    options.aggregateLatest,
    cache,
    options.hasOwnProperty("aggregateLatest"),
  );
  o.aggregateCheckout = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateCheckout, cache);
  o.aggregateVersions = (options.aggregateVersions ?? []).map((i) =>
    maybeNew("ReadyPlanAggregateVersion", i, cache, options.hasOwnProperty("aggregateVersions"))
  );
  o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
  o.availableUpdates = (options.availableUpdates ?? []).map((i) =>
    maybeNew("ProductOfferingIncomingUpdate", i, cache, options.hasOwnProperty("availableUpdates"))
  );
  o.itemLocations = (options.itemLocations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("itemLocations"))
  );
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.canEditLineItems = maybeNew(
    "PotentialOperation2",
    options.canEditLineItems,
    cache,
    options.hasOwnProperty("canEditLineItems"),
  );
  o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.canEditOptions = maybeNew(
    "PotentialOperation2",
    options.canEditOptions,
    cache,
    options.hasOwnProperty("canEditOptions"),
  );
  o.publishToUnderwriting = options.publishToUnderwriting ?? false;
  o.tourUrl = options.tourUrl ?? null;
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.checkoutConfigs = (options.checkoutConfigs ?? []).map((i) =>
    maybeNew("CheckoutConfig", i, cache, options.hasOwnProperty("checkoutConfigs"))
  );
  o.showInCheckout = options.showInCheckout ?? false;
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.rendering = maybeNewOrNull("Asset", options.rendering, cache);
  o.interiorRenderings = (options.interiorRenderings ?? []).map((i) =>
    maybeNew("InteriorRoomRendering", i, cache, options.hasOwnProperty("interiorRenderings"))
  );
  o.renderings = (options.renderings ?? []).map((i) =>
    maybeNew("RenderingAsset", i, cache, options.hasOwnProperty("renderings"))
  );
  o.requiredOptions = (options.requiredOptions ?? []).map((i) =>
    maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("requiredOptions"))
  );
  o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
  o.cloneInProgress = options.cloneInProgress ?? false;
  o.insideMapsMissingLocations = options.insideMapsMissingLocations ?? [];
  o.promoteInProgress = options.promoteInProgress ?? false;
  o.buildableLots = (options.buildableLots ?? []).map((i) =>
    maybeNew("Lot", i, cache, options.hasOwnProperty("buildableLots"))
  );
  o.insideMapsPacket = options.insideMapsPacket ?? null;
  o.architectureFeePriceInCents = options.architectureFeePriceInCents ?? null;
  o.preconServicesPriceInCents = options.preconServicesPriceInCents ?? null;
  o.trackedJobs = (options.trackedJobs ?? []).map((i) =>
    maybeNew("TrackedJob", i, cache, options.hasOwnProperty("trackedJobs"))
  );
  o.activeElevationCount = options.activeElevationCount ?? 0;
  o.checkoutBlockingErrors = options.checkoutBlockingErrors ?? [];
  return o;
}

factories["ProductOffering"] = newProductOffering;

export interface ProductOfferingsPageResultOptions {
  __typename?: "ProductOfferingsPageResult";
  entities?: Array<ProductOffering | ProductOfferingOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newProductOfferingsPageResult(
  options: ProductOfferingsPageResultOptions = {},
  cache: Record<string, any> = {},
): ProductOfferingsPageResult {
  const o = (options.__typename ? options : cache["ProductOfferingsPageResult"] = {}) as ProductOfferingsPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductOfferingsPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ProductOfferingsPageResult"] = newProductOfferingsPageResult;

export interface SaveProductOfferingResultOptions {
  __typename?: "SaveProductOfferingResult";
  productOffering?: ProductOffering | ProductOfferingOptions;
}

export function newSaveProductOfferingResult(
  options: SaveProductOfferingResultOptions = {},
  cache: Record<string, any> = {},
): SaveProductOfferingResult {
  const o = (options.__typename ? options : cache["SaveProductOfferingResult"] = {}) as SaveProductOfferingResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProductOfferingResult";
  o.productOffering = maybeNew(
    "ProductOffering",
    options.productOffering,
    cache,
    options.hasOwnProperty("productOffering"),
  );
  return o;
}

factories["SaveProductOfferingResult"] = newSaveProductOfferingResult;

export interface DesignPackageCombinationOptions {
  __typename?: "DesignPackageCombination";
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  bidOutPercentage?: DesignPackageCombination["bidOutPercentage"];
}

export function newDesignPackageCombination(
  options: DesignPackageCombinationOptions = {},
  cache: Record<string, any> = {},
): DesignPackageCombination {
  const o = (options.__typename ? options : cache["DesignPackageCombination"] = {}) as DesignPackageCombination;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackageCombination";
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  return o;
}

factories["DesignPackageCombination"] = newDesignPackageCombination;

export interface ReadyPlanOptionCostAndPriceDeltaOptions {
  __typename?: "ReadyPlanOptionCostAndPriceDelta";
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions;
  totalCostInCents?: ReadyPlanOptionCostAndPriceDelta["totalCostInCents"];
  totalPriceInCents?: ReadyPlanOptionCostAndPriceDelta["totalPriceInCents"];
  preCutoffTotalPriceInCents?: ReadyPlanOptionCostAndPriceDelta["preCutoffTotalPriceInCents"];
  preCutoffDesiredMarginInBasisPoints?: ReadyPlanOptionCostAndPriceDelta["preCutoffDesiredMarginInBasisPoints"];
  postCutoffTotalPriceInCents?: ReadyPlanOptionCostAndPriceDelta["postCutoffTotalPriceInCents"];
  postCutoffDesiredMarginInBasisPoints?: ReadyPlanOptionCostAndPriceDelta["postCutoffDesiredMarginInBasisPoints"];
  selectionFeeInCents?: ReadyPlanOptionCostAndPriceDelta["selectionFeeInCents"];
  minimumPriceInCents?: ReadyPlanOptionCostAndPriceDelta["minimumPriceInCents"];
}

export function newReadyPlanOptionCostAndPriceDelta(
  options: ReadyPlanOptionCostAndPriceDeltaOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOptionCostAndPriceDelta {
  const o =
    (options.__typename ? options : cache["ReadyPlanOptionCostAndPriceDelta"] = {}) as ReadyPlanOptionCostAndPriceDelta;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOptionCostAndPriceDelta";
  o.readyPlanOption = maybeNew(
    "ReadyPlanOption",
    options.readyPlanOption,
    cache,
    options.hasOwnProperty("readyPlanOption"),
  );
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.preCutoffTotalPriceInCents = options.preCutoffTotalPriceInCents ?? 0;
  o.preCutoffDesiredMarginInBasisPoints = options.preCutoffDesiredMarginInBasisPoints ?? 0;
  o.postCutoffTotalPriceInCents = options.postCutoffTotalPriceInCents ?? null;
  o.postCutoffDesiredMarginInBasisPoints = options.postCutoffDesiredMarginInBasisPoints ?? null;
  o.selectionFeeInCents = options.selectionFeeInCents ?? 0;
  o.minimumPriceInCents = options.minimumPriceInCents ?? 0;
  return o;
}

factories["ReadyPlanOptionCostAndPriceDelta"] = newReadyPlanOptionCostAndPriceDelta;

export interface ComputeProductOfferingCostsAndPricesResponseOptions {
  __typename?: "ComputeProductOfferingCostsAndPricesResponse";
  productOffering?: ProductOffering | ProductOfferingOptions;
  baseCostInCents?: ComputeProductOfferingCostsAndPricesResponse["baseCostInCents"];
  basePriceInCents?: ComputeProductOfferingCostsAndPricesResponse["basePriceInCents"];
  totalCostInCents?: ComputeProductOfferingCostsAndPricesResponse["totalCostInCents"];
  preCutoffTotalPriceInCents?: ComputeProductOfferingCostsAndPricesResponse["preCutoffTotalPriceInCents"];
  postCutoffTotalPriceInCents?: ComputeProductOfferingCostsAndPricesResponse["postCutoffTotalPriceInCents"];
  selectedOptions?: Array<ReadyPlanOptionCostAndPriceDelta | ReadyPlanOptionCostAndPriceDeltaOptions>;
  unselectedOptions?: Array<ReadyPlanOptionCostAndPriceDelta | ReadyPlanOptionCostAndPriceDeltaOptions>;
  allOptions?: Array<ReadyPlanOptionCostAndPriceDelta | ReadyPlanOptionCostAndPriceDeltaOptions>;
}

export function newComputeProductOfferingCostsAndPricesResponse(
  options: ComputeProductOfferingCostsAndPricesResponseOptions = {},
  cache: Record<string, any> = {},
): ComputeProductOfferingCostsAndPricesResponse {
  const o =
    (options.__typename
      ? options
      : cache["ComputeProductOfferingCostsAndPricesResponse"] = {}) as ComputeProductOfferingCostsAndPricesResponse;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ComputeProductOfferingCostsAndPricesResponse";
  o.productOffering = maybeNew(
    "ProductOffering",
    options.productOffering,
    cache,
    options.hasOwnProperty("productOffering"),
  );
  o.baseCostInCents = options.baseCostInCents ?? 0;
  o.basePriceInCents = options.basePriceInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.preCutoffTotalPriceInCents = options.preCutoffTotalPriceInCents ?? 0;
  o.postCutoffTotalPriceInCents = options.postCutoffTotalPriceInCents ?? 0;
  o.selectedOptions = (options.selectedOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOptionCostAndPriceDelta", i, cache, options.hasOwnProperty("selectedOptions"))
  );
  o.unselectedOptions = (options.unselectedOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOptionCostAndPriceDelta", i, cache, options.hasOwnProperty("unselectedOptions"))
  );
  o.allOptions = (options.allOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOptionCostAndPriceDelta", i, cache, options.hasOwnProperty("allOptions"))
  );
  return o;
}

factories["ComputeProductOfferingCostsAndPricesResponse"] = newComputeProductOfferingCostsAndPricesResponse;

export interface CalculateScopeChangeResultOptions {
  __typename?: "CalculateScopeChangeResult";
  added?: Array<TakeoffLineItemVersion | TakeoffLineItemVersionOptions>;
  removed?: Array<TakeoffLineItemVersion | TakeoffLineItemVersionOptions>;
}

export function newCalculateScopeChangeResult(
  options: CalculateScopeChangeResultOptions = {},
  cache: Record<string, any> = {},
): CalculateScopeChangeResult {
  const o = (options.__typename ? options : cache["CalculateScopeChangeResult"] = {}) as CalculateScopeChangeResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CalculateScopeChangeResult";
  o.added = (options.added ?? []).map((i) =>
    maybeNew("TakeoffLineItemVersion", i, cache, options.hasOwnProperty("added"))
  );
  o.removed = (options.removed ?? []).map((i) =>
    maybeNew("TakeoffLineItemVersion", i, cache, options.hasOwnProperty("removed"))
  );
  return o;
}

factories["CalculateScopeChangeResult"] = newCalculateScopeChangeResult;

export interface InteriorRoomRenderingOptions {
  __typename?: "InteriorRoomRendering";
  roomName?: InteriorRoomRendering["roomName"];
  interiorScheme?: InteriorRoomRendering["interiorScheme"];
  asset?: Asset | AssetOptions | null;
}

export function newInteriorRoomRendering(
  options: InteriorRoomRenderingOptions = {},
  cache: Record<string, any> = {},
): InteriorRoomRendering {
  const o = (options.__typename ? options : cache["InteriorRoomRendering"] = {}) as InteriorRoomRendering;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InteriorRoomRendering";
  o.roomName = options.roomName ?? "roomName";
  o.interiorScheme = options.interiorScheme ?? "interiorScheme";
  o.asset = maybeNewOrNull("Asset", options.asset, cache);
  return o;
}

factories["InteriorRoomRendering"] = newInteriorRoomRendering;

export interface RenderingAssetOptions {
  __typename?: "RenderingAsset";
  type?: ReadyPlanAssetTypeDetailOptions | ReadyPlanAssetType;
  asset?: Asset | AssetOptions;
}

export function newRenderingAsset(
  options: RenderingAssetOptions = {},
  cache: Record<string, any> = {},
): RenderingAsset {
  const o = (options.__typename ? options : cache["RenderingAsset"] = {}) as RenderingAsset;
  (cache.all ??= new Set()).add(o);
  o.__typename = "RenderingAsset";
  o.type = enumOrDetailOfReadyPlanAssetType(options.type);
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  return o;
}

factories["RenderingAsset"] = newRenderingAsset;

export interface ProductOfferingConfigOptions {
  __typename?: "ProductOfferingConfig";
  id?: ProductOfferingConfig["id"];
  name?: ProductOfferingConfig["name"];
  createdAt?: ProductOfferingConfig["createdAt"];
  updatedAt?: ProductOfferingConfig["updatedAt"];
  createdBy?: User | UserOptions;
  productOffering?: ProductOffering | ProductOfferingOptions;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  baseConfigProductOffering?: ProductOffering | ProductOfferingOptions | null;
  archive?: ProductOfferingConfig["archive"];
  isBaseConfig?: ProductOfferingConfig["isBaseConfig"];
  programData?: ProgramData | ProgramDataOptions;
  totalCostInCents?: ProductOfferingConfig["totalCostInCents"];
  totalPriceInCents?: ProductOfferingConfig["totalPriceInCents"];
  hasCompleteCost?: ProductOfferingConfig["hasCompleteCost"];
  publishToUnderwriting?: ProductOfferingConfig["publishToUnderwriting"];
  salesPriceInCents?: ProductOfferingConfig["salesPriceInCents"];
  insideMapsTextureSwaps?: InsideMapsTextureSwaps | InsideMapsTextureSwapsOptions | null;
}

export function newProductOfferingConfig(
  options: ProductOfferingConfigOptions = {},
  cache: Record<string, any> = {},
): ProductOfferingConfig {
  const o = (options.__typename ? options : cache["ProductOfferingConfig"] = {}) as ProductOfferingConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductOfferingConfig";
  o.id = options.id ?? nextFactoryId("ProductOfferingConfig");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.productOffering = maybeNew(
    "ProductOffering",
    options.productOffering,
    cache,
    options.hasOwnProperty("productOffering"),
  );
  o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  o.baseConfigProductOffering = maybeNewOrNull("ProductOffering", options.baseConfigProductOffering, cache);
  o.archive = options.archive ?? false;
  o.isBaseConfig = options.isBaseConfig ?? false;
  o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.hasCompleteCost = options.hasCompleteCost ?? false;
  o.publishToUnderwriting = options.publishToUnderwriting ?? false;
  o.salesPriceInCents = options.salesPriceInCents ?? null;
  o.insideMapsTextureSwaps = maybeNewOrNull("InsideMapsTextureSwaps", options.insideMapsTextureSwaps, cache);
  return o;
}

factories["ProductOfferingConfig"] = newProductOfferingConfig;

export interface SaveProductOfferingConfigResultOptions {
  __typename?: "SaveProductOfferingConfigResult";
  productOfferingConfig?: ProductOfferingConfig | ProductOfferingConfigOptions;
}

export function newSaveProductOfferingConfigResult(
  options: SaveProductOfferingConfigResultOptions = {},
  cache: Record<string, any> = {},
): SaveProductOfferingConfigResult {
  const o =
    (options.__typename ? options : cache["SaveProductOfferingConfigResult"] = {}) as SaveProductOfferingConfigResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProductOfferingConfigResult";
  o.productOfferingConfig = maybeNew(
    "ProductOfferingConfig",
    options.productOfferingConfig,
    cache,
    options.hasOwnProperty("productOfferingConfig"),
  );
  return o;
}

factories["SaveProductOfferingConfigResult"] = newSaveProductOfferingConfigResult;

export interface ProductOfferingConfigsPageOptions {
  __typename?: "ProductOfferingConfigsPage";
  entities?: Array<ProductOfferingConfig | ProductOfferingConfigOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newProductOfferingConfigsPage(
  options: ProductOfferingConfigsPageOptions = {},
  cache: Record<string, any> = {},
): ProductOfferingConfigsPage {
  const o = (options.__typename ? options : cache["ProductOfferingConfigsPage"] = {}) as ProductOfferingConfigsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductOfferingConfigsPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("ProductOfferingConfig", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ProductOfferingConfigsPage"] = newProductOfferingConfigsPage;

export interface ComputeProductOfferingConfigCostsResultOptions {
  __typename?: "ComputeProductOfferingConfigCostsResult";
  configCosts?: Array<ConfigCostsResult | ConfigCostsResultOptions>;
}

export function newComputeProductOfferingConfigCostsResult(
  options: ComputeProductOfferingConfigCostsResultOptions = {},
  cache: Record<string, any> = {},
): ComputeProductOfferingConfigCostsResult {
  const o =
    (options.__typename
      ? options
      : cache["ComputeProductOfferingConfigCostsResult"] = {}) as ComputeProductOfferingConfigCostsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ComputeProductOfferingConfigCostsResult";
  o.configCosts = (options.configCosts ?? []).map((i) =>
    maybeNew("ConfigCostsResult", i, cache, options.hasOwnProperty("configCosts"))
  );
  return o;
}

factories["ComputeProductOfferingConfigCostsResult"] = newComputeProductOfferingConfigCostsResult;

export interface ConfigCostsResultOptions {
  __typename?: "ConfigCostsResult";
  productOfferingConfig?: ProductOfferingConfig | ProductOfferingConfigOptions;
  computedBaseCost?: ConfigCostsResult["computedBaseCost"];
  baseHouseCostInCents?: ConfigCostsResult["baseHouseCostInCents"];
  baseHouseHasCompleteCost?: ConfigCostsResult["baseHouseHasCompleteCost"];
  computedOptionCosts?: Array<ReadyPlanOptionConfigCosts | ReadyPlanOptionConfigCostsOptions>;
}

export function newConfigCostsResult(
  options: ConfigCostsResultOptions = {},
  cache: Record<string, any> = {},
): ConfigCostsResult {
  const o = (options.__typename ? options : cache["ConfigCostsResult"] = {}) as ConfigCostsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ConfigCostsResult";
  o.productOfferingConfig = maybeNew(
    "ProductOfferingConfig",
    options.productOfferingConfig,
    cache,
    options.hasOwnProperty("productOfferingConfig"),
  );
  o.computedBaseCost = options.computedBaseCost ?? 0;
  o.baseHouseCostInCents = options.baseHouseCostInCents ?? 0;
  o.baseHouseHasCompleteCost = options.baseHouseHasCompleteCost ?? false;
  o.computedOptionCosts = (options.computedOptionCosts ?? []).map((i) =>
    maybeNew("ReadyPlanOptionConfigCosts", i, cache, options.hasOwnProperty("computedOptionCosts"))
  );
  return o;
}

factories["ConfigCostsResult"] = newConfigCostsResult;

export interface ReadyPlanOptionConfigCostsOptions {
  __typename?: "ReadyPlanOptionConfigCosts";
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions;
  totalCostInCents?: ReadyPlanOptionConfigCosts["totalCostInCents"];
  hasCompleteCost?: ReadyPlanOptionConfigCosts["hasCompleteCost"];
}

export function newReadyPlanOptionConfigCosts(
  options: ReadyPlanOptionConfigCostsOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOptionConfigCosts {
  const o = (options.__typename ? options : cache["ReadyPlanOptionConfigCosts"] = {}) as ReadyPlanOptionConfigCosts;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOptionConfigCosts";
  o.readyPlanOption = maybeNew(
    "ReadyPlanOption",
    options.readyPlanOption,
    cache,
    options.hasOwnProperty("readyPlanOption"),
  );
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.hasCompleteCost = options.hasCompleteCost ?? false;
  return o;
}

factories["ReadyPlanOptionConfigCosts"] = newReadyPlanOptionConfigCosts;

export interface ProductOfferingIncomingUpdateOptions {
  __typename?: "ProductOfferingIncomingUpdate";
  id?: ProductOfferingIncomingUpdate["id"];
  accepted?: ProductOfferingIncomingUpdate["accepted"];
  createdAt?: ProductOfferingIncomingUpdate["createdAt"];
  updatedAt?: ProductOfferingIncomingUpdate["updatedAt"];
  offering?: ProductOffering | ProductOfferingOptions;
  forDesignPackageUpdate?: ProductOfferingIncomingUpdate["forDesignPackageUpdate"];
  forPlanPackageUpdate?: ProductOfferingIncomingUpdate["forPlanPackageUpdate"];
  source?: ProductOfferingIncomingUpdateSource | DropOptions | RequireTypename<ReadyPlanAggregateVersionOptions>;
}

export function newProductOfferingIncomingUpdate(
  options: ProductOfferingIncomingUpdateOptions = {},
  cache: Record<string, any> = {},
): ProductOfferingIncomingUpdate {
  const o =
    (options.__typename ? options : cache["ProductOfferingIncomingUpdate"] = {}) as ProductOfferingIncomingUpdate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductOfferingIncomingUpdate";
  o.id = options.id ?? nextFactoryId("ProductOfferingIncomingUpdate");
  o.accepted = options.accepted ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.offering = maybeNew("ProductOffering", options.offering, cache, options.hasOwnProperty("offering"));
  o.forDesignPackageUpdate = options.forDesignPackageUpdate ?? false;
  o.forPlanPackageUpdate = options.forPlanPackageUpdate ?? false;
  o.source = maybeNew(options.source?.__typename ?? "Drop", options.source, cache);
  return o;
}

factories["ProductOfferingIncomingUpdate"] = newProductOfferingIncomingUpdate;

export interface ProductOfferingVersionOptions {
  __typename?: "ProductOfferingVersion";
  id?: ProductOfferingVersion["id"];
  identity?: ReadyPlan | ReadyPlanOptions;
  name?: ProductOfferingVersion["name"];
  code?: ProductOfferingVersion["code"];
  type?: ProductOfferingVersion["type"];
  lotTypes?: ProductOfferingVersion["lotTypes"] | null;
  exteriorDesignPackageVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  interiorDesignPackageVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  planPackageVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  contingencyMarkupPercentage?: ProductOfferingVersion["contingencyMarkupPercentage"];
  description?: ProductOfferingVersion["description"];
  markets?: Array<Market | MarketOptions>;
  owner?: InternalUser | InternalUserOptions | null;
}

export function newProductOfferingVersion(
  options: ProductOfferingVersionOptions = {},
  cache: Record<string, any> = {},
): ProductOfferingVersion {
  const o = (options.__typename ? options : cache["ProductOfferingVersion"] = {}) as ProductOfferingVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductOfferingVersion";
  o.id = options.id ?? nextFactoryId("ProductOfferingVersion");
  o.identity = maybeNew("ReadyPlan", options.identity, cache, options.hasOwnProperty("identity"));
  o.name = options.name ?? "name";
  o.code = options.code ?? null;
  o.type = options.type ?? null;
  o.lotTypes = options.lotTypes ?? [];
  o.exteriorDesignPackageVersion = maybeNew(
    "ReadyPlanAggregateVersion",
    options.exteriorDesignPackageVersion,
    cache,
    options.hasOwnProperty("exteriorDesignPackageVersion"),
  );
  o.interiorDesignPackageVersion = maybeNew(
    "ReadyPlanAggregateVersion",
    options.interiorDesignPackageVersion,
    cache,
    options.hasOwnProperty("interiorDesignPackageVersion"),
  );
  o.planPackageVersion = maybeNew(
    "ReadyPlanAggregateVersion",
    options.planPackageVersion,
    cache,
    options.hasOwnProperty("planPackageVersion"),
  );
  o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
  o.description = options.description ?? null;
  o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
  o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
  return o;
}

factories["ProductOfferingVersion"] = newProductOfferingVersion;

export interface ProductTypeOptions {
  __typename?: "ProductType";
  id?: ProductType["id"];
  name?: ProductType["name"];
  createdAt?: ProductType["createdAt"];
  updatedAt?: ProductType["updatedAt"];
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
}

export function newProductType(options: ProductTypeOptions = {}, cache: Record<string, any> = {}): ProductType {
  const o = (options.__typename ? options : cache["ProductType"] = {}) as ProductType;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductType";
  o.id = options.id ?? nextFactoryId("ProductType");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  return o;
}

factories["ProductType"] = newProductType;

export interface SaveProductTypeResultOptions {
  __typename?: "SaveProductTypeResult";
  productType?: ProductType | ProductTypeOptions;
}

export function newSaveProductTypeResult(
  options: SaveProductTypeResultOptions = {},
  cache: Record<string, any> = {},
): SaveProductTypeResult {
  const o = (options.__typename ? options : cache["SaveProductTypeResult"] = {}) as SaveProductTypeResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProductTypeResult";
  o.productType = maybeNew("ProductType", options.productType, cache, options.hasOwnProperty("productType"));
  return o;
}

factories["SaveProductTypeResult"] = newSaveProductTypeResult;

export interface ProgramDataOptions {
  __typename?: "ProgramData";
  id?: ProgramData["id"];
  createdAt?: ProgramData["createdAt"];
  updatedAt?: ProgramData["updatedAt"];
  stories?: ProgramData["stories"];
  bedrooms?: ProgramData["bedrooms"];
  closetsInPrimarySuite?: ProgramData["closetsInPrimarySuite"];
  fullBaths?: ProgramData["fullBaths"];
  halfBaths?: ProgramData["halfBaths"];
  depthInInches?: ProgramData["depthInInches"];
  depthInFeet?: ProgramData["depthInFeet"];
  widthInInches?: ProgramData["widthInInches"];
  widthInFeet?: ProgramData["widthInFeet"];
  minLotWidthInInches?: ProgramData["minLotWidthInInches"];
  minLotWidthInFeet?: ProgramData["minLotWidthInFeet"];
  minLotDepthInInches?: ProgramData["minLotDepthInInches"];
  minLotDepthInFeet?: ProgramData["minLotDepthInFeet"];
  minLotSizeInSqft?: ProgramData["minLotSizeInSqft"];
  garageAttached?: ProgramData["garageAttached"];
  garageDetached?: ProgramData["garageDetached"];
  garagePort?: ProgramData["garagePort"];
  garageConfiguration?: ProgramDataGarageConfigDetailOptions | ProgramDataGarageConfig | null;
  basementConfig?: ProgramDataBasementConfigDetailOptions | ProgramDataBasementConfig | null;
  sellableBasementSqft?: ProgramData["sellableBasementSqft"];
  permittableSqft?: ProgramData["permittableSqft"];
  sellableSqft?: ProgramData["sellableSqft"];
  netBuildableSqft?: ProgramData["netBuildableSqft"];
  grossBuildableSqft?: ProgramData["grossBuildableSqft"];
  aboveGroundSqft?: ProgramData["aboveGroundSqft"];
  belowGroundSqft?: ProgramData["belowGroundSqft"];
  sellableAboveGroundSqft?: ProgramData["sellableAboveGroundSqft"];
  sellableBelowGroundSqft?: ProgramData["sellableBelowGroundSqft"];
  unfinishedBelowGroundSqft?: ProgramData["unfinishedBelowGroundSqft"];
  grossBelowGroundSqft?: ProgramData["grossBelowGroundSqft"];
  imperviousSqft?: ProgramData["imperviousSqft"];
  windowColor?: ProgramDataWindowColorDetailOptions | ProgramDataWindowColor | null;
  firstFloorBedrooms?: ProgramData["firstFloorBedrooms"];
  diningRoom?: ProgramData["diningRoom"];
  casualDining?: ProgramData["casualDining"];
  mediaRooms?: ProgramData["mediaRooms"];
  loftGameFlexRooms?: ProgramData["loftGameFlexRooms"];
  offices?: ProgramData["offices"];
  workspaces?: ProgramData["workspaces"];
  primaryBedroom?: ProgramDataPrimaryBedroomConfigDetailOptions | ProgramDataPrimaryBedroomConfig | null;
  multiUseBedrooms?: ProgramData["multiUseBedrooms"];
  primarySuiteDown?: ProgramData["primarySuiteDown"];
  buildingHeightInFeet?: ProgramData["buildingHeightInFeet"];
  readyPlanProgramData?: ReadyPlanProgramData | ReadyPlanProgramDataOptions | null;
}

export function newProgramData(options: ProgramDataOptions = {}, cache: Record<string, any> = {}): ProgramData {
  const o = (options.__typename ? options : cache["ProgramData"] = {}) as ProgramData;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProgramData";
  o.id = options.id ?? nextFactoryId("ProgramData");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.stories = options.stories ?? null;
  o.bedrooms = options.bedrooms ?? null;
  o.closetsInPrimarySuite = options.closetsInPrimarySuite ?? null;
  o.fullBaths = options.fullBaths ?? null;
  o.halfBaths = options.halfBaths ?? null;
  o.depthInInches = options.depthInInches ?? null;
  o.depthInFeet = options.depthInFeet ?? null;
  o.widthInInches = options.widthInInches ?? null;
  o.widthInFeet = options.widthInFeet ?? null;
  o.minLotWidthInInches = options.minLotWidthInInches ?? null;
  o.minLotWidthInFeet = options.minLotWidthInFeet ?? null;
  o.minLotDepthInInches = options.minLotDepthInInches ?? null;
  o.minLotDepthInFeet = options.minLotDepthInFeet ?? null;
  o.minLotSizeInSqft = options.minLotSizeInSqft ?? null;
  o.garageAttached = options.garageAttached ?? null;
  o.garageDetached = options.garageDetached ?? null;
  o.garagePort = options.garagePort ?? null;
  o.garageConfiguration = enumOrDetailOrNullOfProgramDataGarageConfig(options.garageConfiguration);
  o.basementConfig = enumOrDetailOrNullOfProgramDataBasementConfig(options.basementConfig);
  o.sellableBasementSqft = options.sellableBasementSqft ?? null;
  o.permittableSqft = options.permittableSqft ?? null;
  o.sellableSqft = options.sellableSqft ?? null;
  o.netBuildableSqft = options.netBuildableSqft ?? null;
  o.grossBuildableSqft = options.grossBuildableSqft ?? null;
  o.aboveGroundSqft = options.aboveGroundSqft ?? null;
  o.belowGroundSqft = options.belowGroundSqft ?? null;
  o.sellableAboveGroundSqft = options.sellableAboveGroundSqft ?? null;
  o.sellableBelowGroundSqft = options.sellableBelowGroundSqft ?? null;
  o.unfinishedBelowGroundSqft = options.unfinishedBelowGroundSqft ?? null;
  o.grossBelowGroundSqft = options.grossBelowGroundSqft ?? null;
  o.imperviousSqft = options.imperviousSqft ?? null;
  o.windowColor = enumOrDetailOrNullOfProgramDataWindowColor(options.windowColor);
  o.firstFloorBedrooms = options.firstFloorBedrooms ?? null;
  o.diningRoom = options.diningRoom ?? null;
  o.casualDining = options.casualDining ?? null;
  o.mediaRooms = options.mediaRooms ?? null;
  o.loftGameFlexRooms = options.loftGameFlexRooms ?? null;
  o.offices = options.offices ?? null;
  o.workspaces = options.workspaces ?? null;
  o.primaryBedroom = enumOrDetailOrNullOfProgramDataPrimaryBedroomConfig(options.primaryBedroom);
  o.multiUseBedrooms = options.multiUseBedrooms ?? null;
  o.primarySuiteDown = options.primarySuiteDown ?? null;
  o.buildingHeightInFeet = options.buildingHeightInFeet ?? null;
  o.readyPlanProgramData = maybeNewOrNull("ReadyPlanProgramData", options.readyPlanProgramData, cache);
  return o;
}

factories["ProgramData"] = newProgramData;

export interface NewProgramDataOptions {
  __typename?: "NewProgramData";
  createdAt?: NewProgramData["createdAt"];
  updatedAt?: NewProgramData["updatedAt"];
  stories?: NewProgramData["stories"];
  bedrooms?: NewProgramData["bedrooms"];
  closetsInPrimarySuite?: NewProgramData["closetsInPrimarySuite"];
  fullBaths?: NewProgramData["fullBaths"];
  halfBaths?: NewProgramData["halfBaths"];
  depthInInches?: NewProgramData["depthInInches"];
  depthInFeet?: NewProgramData["depthInFeet"];
  widthInInches?: NewProgramData["widthInInches"];
  widthInFeet?: NewProgramData["widthInFeet"];
  minLotWidthInInches?: NewProgramData["minLotWidthInInches"];
  minLotWidthInFeet?: NewProgramData["minLotWidthInFeet"];
  minLotDepthInInches?: NewProgramData["minLotDepthInInches"];
  minLotDepthInFeet?: NewProgramData["minLotDepthInFeet"];
  minLotSizeInSqft?: NewProgramData["minLotSizeInSqft"];
  garageAttached?: NewProgramData["garageAttached"];
  garageDetached?: NewProgramData["garageDetached"];
  garagePort?: NewProgramData["garagePort"];
  garageConfiguration?: ProgramDataGarageConfigDetailOptions | ProgramDataGarageConfig | null;
  basementConfig?: ProgramDataBasementConfigDetailOptions | ProgramDataBasementConfig | null;
  sellableBasementSqft?: NewProgramData["sellableBasementSqft"];
  permittableSqft?: NewProgramData["permittableSqft"];
  sellableSqft?: NewProgramData["sellableSqft"];
  netBuildableSqft?: NewProgramData["netBuildableSqft"];
  grossBuildableSqft?: NewProgramData["grossBuildableSqft"];
  aboveGroundSqft?: NewProgramData["aboveGroundSqft"];
  belowGroundSqft?: NewProgramData["belowGroundSqft"];
  sellableAboveGroundSqft?: NewProgramData["sellableAboveGroundSqft"];
  sellableBelowGroundSqft?: NewProgramData["sellableBelowGroundSqft"];
  unfinishedBelowGroundSqft?: NewProgramData["unfinishedBelowGroundSqft"];
  grossBelowGroundSqft?: NewProgramData["grossBelowGroundSqft"];
  imperviousSqft?: NewProgramData["imperviousSqft"];
  windowColor?: ProgramDataWindowColorDetailOptions | ProgramDataWindowColor | null;
  firstFloorBedrooms?: NewProgramData["firstFloorBedrooms"];
  diningRoom?: NewProgramData["diningRoom"];
  casualDining?: NewProgramData["casualDining"];
  mediaRooms?: NewProgramData["mediaRooms"];
  loftGameFlexRooms?: NewProgramData["loftGameFlexRooms"];
  offices?: NewProgramData["offices"];
  workspaces?: NewProgramData["workspaces"];
  primaryBedroom?: ProgramDataPrimaryBedroomConfigDetailOptions | ProgramDataPrimaryBedroomConfig | null;
  multiUseBedrooms?: NewProgramData["multiUseBedrooms"];
  primarySuiteDown?: NewProgramData["primarySuiteDown"];
  buildingHeightInFeet?: NewProgramData["buildingHeightInFeet"];
}

export function newNewProgramData(
  options: NewProgramDataOptions = {},
  cache: Record<string, any> = {},
): NewProgramData {
  const o = (options.__typename ? options : cache["NewProgramData"] = {}) as NewProgramData;
  (cache.all ??= new Set()).add(o);
  o.__typename = "NewProgramData";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.stories = options.stories ?? null;
  o.bedrooms = options.bedrooms ?? null;
  o.closetsInPrimarySuite = options.closetsInPrimarySuite ?? null;
  o.fullBaths = options.fullBaths ?? null;
  o.halfBaths = options.halfBaths ?? null;
  o.depthInInches = options.depthInInches ?? null;
  o.depthInFeet = options.depthInFeet ?? null;
  o.widthInInches = options.widthInInches ?? null;
  o.widthInFeet = options.widthInFeet ?? null;
  o.minLotWidthInInches = options.minLotWidthInInches ?? null;
  o.minLotWidthInFeet = options.minLotWidthInFeet ?? null;
  o.minLotDepthInInches = options.minLotDepthInInches ?? null;
  o.minLotDepthInFeet = options.minLotDepthInFeet ?? null;
  o.minLotSizeInSqft = options.minLotSizeInSqft ?? null;
  o.garageAttached = options.garageAttached ?? null;
  o.garageDetached = options.garageDetached ?? null;
  o.garagePort = options.garagePort ?? null;
  o.garageConfiguration = enumOrDetailOrNullOfProgramDataGarageConfig(options.garageConfiguration);
  o.basementConfig = enumOrDetailOrNullOfProgramDataBasementConfig(options.basementConfig);
  o.sellableBasementSqft = options.sellableBasementSqft ?? null;
  o.permittableSqft = options.permittableSqft ?? null;
  o.sellableSqft = options.sellableSqft ?? null;
  o.netBuildableSqft = options.netBuildableSqft ?? null;
  o.grossBuildableSqft = options.grossBuildableSqft ?? null;
  o.aboveGroundSqft = options.aboveGroundSqft ?? null;
  o.belowGroundSqft = options.belowGroundSqft ?? null;
  o.sellableAboveGroundSqft = options.sellableAboveGroundSqft ?? null;
  o.sellableBelowGroundSqft = options.sellableBelowGroundSqft ?? null;
  o.unfinishedBelowGroundSqft = options.unfinishedBelowGroundSqft ?? null;
  o.grossBelowGroundSqft = options.grossBelowGroundSqft ?? null;
  o.imperviousSqft = options.imperviousSqft ?? null;
  o.windowColor = enumOrDetailOrNullOfProgramDataWindowColor(options.windowColor);
  o.firstFloorBedrooms = options.firstFloorBedrooms ?? null;
  o.diningRoom = options.diningRoom ?? null;
  o.casualDining = options.casualDining ?? null;
  o.mediaRooms = options.mediaRooms ?? null;
  o.loftGameFlexRooms = options.loftGameFlexRooms ?? null;
  o.offices = options.offices ?? null;
  o.workspaces = options.workspaces ?? null;
  o.primaryBedroom = enumOrDetailOrNullOfProgramDataPrimaryBedroomConfig(options.primaryBedroom);
  o.multiUseBedrooms = options.multiUseBedrooms ?? null;
  o.primarySuiteDown = options.primarySuiteDown ?? null;
  o.buildingHeightInFeet = options.buildingHeightInFeet ?? null;
  return o;
}

factories["NewProgramData"] = newNewProgramData;

export interface ProjectJobLogInsightsOptions {
  __typename?: "ProjectJobLogInsights";
  delayFlagCount?: ProjectJobLogInsights["delayFlagCount"];
  popularFlagReason?: ScheduleFlagReason | ScheduleFlagReasonOptions | null;
  partnerWithMostDelays?: TradePartner | TradePartnerOptions | null;
  topJobLogCreator?: InternalUser | InternalUserOptions | null;
  notesToday?: ProjectJobLogInsights["notesToday"];
  weekJobLogs?: ProjectJobLogInsights["weekJobLogs"];
}

export function newProjectJobLogInsights(
  options: ProjectJobLogInsightsOptions = {},
  cache: Record<string, any> = {},
): ProjectJobLogInsights {
  const o = (options.__typename ? options : cache["ProjectJobLogInsights"] = {}) as ProjectJobLogInsights;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectJobLogInsights";
  o.delayFlagCount = options.delayFlagCount ?? 0;
  o.popularFlagReason = maybeNewOrNull("ScheduleFlagReason", options.popularFlagReason, cache);
  o.partnerWithMostDelays = maybeNewOrNull("TradePartner", options.partnerWithMostDelays, cache);
  o.topJobLogCreator = maybeNewOrNull("InternalUser", options.topJobLogCreator, cache);
  o.notesToday = options.notesToday ?? 0;
  o.weekJobLogs = options.weekJobLogs ?? 0;
  return o;
}

factories["ProjectJobLogInsights"] = newProjectJobLogInsights;

export interface ProjectDictionaryOptions {
  __typename?: "ProjectDictionary";
  clientContract?: ProjectDictionary["clientContract"];
  clientNoun?: ProjectDictionary["clientNoun"];
  initialBudget?: ProjectDictionary["initialBudget"];
  shortClientNoun?: ProjectDictionary["shortClientNoun"];
}

export function newProjectDictionary(
  options: ProjectDictionaryOptions = {},
  cache: Record<string, any> = {},
): ProjectDictionary {
  const o = (options.__typename ? options : cache["ProjectDictionary"] = {}) as ProjectDictionary;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectDictionary";
  o.clientContract = options.clientContract ?? "clientContract";
  o.clientNoun = options.clientNoun ?? "clientNoun";
  o.initialBudget = options.initialBudget ?? "initialBudget";
  o.shortClientNoun = options.shortClientNoun ?? "shortClientNoun";
  return o;
}

factories["ProjectDictionary"] = newProjectDictionary;

export interface SaveProjectResultOptions {
  __typename?: "SaveProjectResult";
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
}

export function newSaveProjectResult(
  options: SaveProjectResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectResult {
  const o = (options.__typename ? options : cache["SaveProjectResult"] = {}) as SaveProjectResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectResult";
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  return o;
}

factories["SaveProjectResult"] = newSaveProjectResult;

export interface ProgressSummaryOptions {
  __typename?: "ProgressSummary";
  inProgress?: ProgressSummary["inProgress"];
  notStarted?: ProgressSummary["notStarted"];
  completed?: ProgressSummary["completed"];
  total?: ProgressSummary["total"];
  status?: ProgressSummary["status"];
}

export function newProgressSummary(
  options: ProgressSummaryOptions = {},
  cache: Record<string, any> = {},
): ProgressSummary {
  const o = (options.__typename ? options : cache["ProgressSummary"] = {}) as ProgressSummary;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProgressSummary";
  o.inProgress = options.inProgress ?? 0;
  o.notStarted = options.notStarted ?? 0;
  o.completed = options.completed ?? 0;
  o.total = options.total ?? 0;
  o.status = options.status ?? ProgressSummaryStatus.InProgress;
  return o;
}

factories["ProgressSummary"] = newProgressSummary;

export interface ResyncPreconProjectItemCostResultOptions {
  __typename?: "ResyncPreconProjectItemCostResult";
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
}

export function newResyncPreconProjectItemCostResult(
  options: ResyncPreconProjectItemCostResultOptions = {},
  cache: Record<string, any> = {},
): ResyncPreconProjectItemCostResult {
  const o =
    (options.__typename
      ? options
      : cache["ResyncPreconProjectItemCostResult"] = {}) as ResyncPreconProjectItemCostResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ResyncPreconProjectItemCostResult";
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  return o;
}

factories["ResyncPreconProjectItemCostResult"] = newResyncPreconProjectItemCostResult;

export interface CloneProjectCostAllocationsResultOptions {
  __typename?: "CloneProjectCostAllocationsResult";
  source?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  targets?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
}

export function newCloneProjectCostAllocationsResult(
  options: CloneProjectCostAllocationsResultOptions = {},
  cache: Record<string, any> = {},
): CloneProjectCostAllocationsResult {
  const o =
    (options.__typename
      ? options
      : cache["CloneProjectCostAllocationsResult"] = {}) as CloneProjectCostAllocationsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CloneProjectCostAllocationsResult";
  o.source = maybeNew("Project", options.source, cache, options.hasOwnProperty("source"));
  o.targets = (options.targets ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("targets")));
  return o;
}

factories["CloneProjectCostAllocationsResult"] = newCloneProjectCostAllocationsResult;

export interface ProjectsPageResultOptions {
  __typename?: "ProjectsPageResult";
  entities?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newProjectsPageResult(
  options: ProjectsPageResultOptions = {},
  cache: Record<string, any> = {},
): ProjectsPageResult {
  const o = (options.__typename ? options : cache["ProjectsPageResult"] = {}) as ProjectsPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectsPageResult";
  o.entities = (options.entities ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ProjectsPageResult"] = newProjectsPageResult;

export interface EarnedValueCurveOptions {
  __typename?: "EarnedValueCurve";
  label?: EarnedValueCurve["label"];
  data?: Array<EarnedValueDataPoint | EarnedValueDataPointOptions>;
}

export function newEarnedValueCurve(
  options: EarnedValueCurveOptions = {},
  cache: Record<string, any> = {},
): EarnedValueCurve {
  const o = (options.__typename ? options : cache["EarnedValueCurve"] = {}) as EarnedValueCurve;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EarnedValueCurve";
  o.label = options.label ?? "label";
  o.data = (options.data ?? []).map((i) => maybeNew("EarnedValueDataPoint", i, cache, options.hasOwnProperty("data")));
  return o;
}

factories["EarnedValueCurve"] = newEarnedValueCurve;

export interface EarnedValueDataPointOptions {
  __typename?: "EarnedValueDataPoint";
  date?: EarnedValueDataPoint["date"];
  value?: EarnedValueDataPoint["value"];
}

export function newEarnedValueDataPoint(
  options: EarnedValueDataPointOptions = {},
  cache: Record<string, any> = {},
): EarnedValueDataPoint {
  const o = (options.__typename ? options : cache["EarnedValueDataPoint"] = {}) as EarnedValueDataPoint;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EarnedValueDataPoint";
  o.date = options.date ?? newDate();
  o.value = options.value ?? 0;
  return o;
}

factories["EarnedValueDataPoint"] = newEarnedValueDataPoint;

export interface ProjectsToUpdateByTemplatesResultOptions {
  __typename?: "ProjectsToUpdateByTemplatesResult";
  projectsToUpdate?: Array<ProjectToUpdate | ProjectToUpdateOptions>;
}

export function newProjectsToUpdateByTemplatesResult(
  options: ProjectsToUpdateByTemplatesResultOptions = {},
  cache: Record<string, any> = {},
): ProjectsToUpdateByTemplatesResult {
  const o =
    (options.__typename
      ? options
      : cache["ProjectsToUpdateByTemplatesResult"] = {}) as ProjectsToUpdateByTemplatesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectsToUpdateByTemplatesResult";
  o.projectsToUpdate = (options.projectsToUpdate ?? []).map((i) =>
    maybeNew("ProjectToUpdate", i, cache, options.hasOwnProperty("projectsToUpdate"))
  );
  return o;
}

factories["ProjectsToUpdateByTemplatesResult"] = newProjectsToUpdateByTemplatesResult;

export interface ProjectToUpdateOptions {
  __typename?: "ProjectToUpdate";
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  optionsToUpdate?: Array<OptionToUpdate | OptionToUpdateOptions>;
  currentTemplate?: ItemTemplate | ItemTemplateOptions | null;
  proposedTemplate?: ItemTemplate | ItemTemplateOptions;
}

export function newProjectToUpdate(
  options: ProjectToUpdateOptions = {},
  cache: Record<string, any> = {},
): ProjectToUpdate {
  const o = (options.__typename ? options : cache["ProjectToUpdate"] = {}) as ProjectToUpdate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectToUpdate";
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.optionsToUpdate = (options.optionsToUpdate ?? []).map((i) =>
    maybeNew("OptionToUpdate", i, cache, options.hasOwnProperty("optionsToUpdate"))
  );
  o.currentTemplate = maybeNewOrNull("ItemTemplate", options.currentTemplate, cache);
  o.proposedTemplate = maybeNew(
    "ItemTemplate",
    options.proposedTemplate,
    cache,
    options.hasOwnProperty("proposedTemplate"),
  );
  return o;
}

factories["ProjectToUpdate"] = newProjectToUpdate;

export interface OptionToUpdateOptions {
  __typename?: "OptionToUpdate";
  affectedPOs?: Array<Commitment | CommitmentOptions>;
  affectedPOsCount?: OptionToUpdate["affectedPOsCount"];
  optionOrReadyPlan?:
    | BidItem
    | BidPlanChildGroup
    | BidPlanChildGroupLine
    | BidPlanGroup
    | ChangeEventLineItem
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | ReadyPlan
    | PlanPackage
    | CommitmentChangeOrder
    | CostCode
    | CostDivision
    | DesignPackage
    | Item
    | ItemTemplate
    | ItemTemplateItem
    | ProductOffering
    | ReadyPlanAggregateVersion
    | ReadyPlanOption
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | TradeCategory
    | HasDisplayName
    | HasDisplayNameOptions;
}

export function newOptionToUpdate(
  options: OptionToUpdateOptions = {},
  cache: Record<string, any> = {},
): OptionToUpdate {
  const o = (options.__typename ? options : cache["OptionToUpdate"] = {}) as OptionToUpdate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "OptionToUpdate";
  o.affectedPOs = (options.affectedPOs ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("affectedPOs"))
  );
  o.affectedPOsCount = options.affectedPOsCount ?? 0;
  o.optionOrReadyPlan = maybeNew(
    "HasDisplayName",
    options.optionOrReadyPlan,
    cache,
    options.hasOwnProperty("optionOrReadyPlan"),
  );
  return o;
}

factories["OptionToUpdate"] = newOptionToUpdate;

export interface ProjectBudgetFinancialsOptions {
  __typename?: "ProjectBudgetFinancials";
  originalBudgetInCents?: ProjectBudgetFinancials["originalBudgetInCents"];
  currentBudgetInCents?: ProjectBudgetFinancials["currentBudgetInCents"];
  originalRevenueInCents?: ProjectBudgetFinancials["originalRevenueInCents"];
  currentRevenueInCents?: ProjectBudgetFinancials["currentRevenueInCents"];
}

export function newProjectBudgetFinancials(
  options: ProjectBudgetFinancialsOptions = {},
  cache: Record<string, any> = {},
): ProjectBudgetFinancials {
  const o = (options.__typename ? options : cache["ProjectBudgetFinancials"] = {}) as ProjectBudgetFinancials;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectBudgetFinancials";
  o.originalBudgetInCents = options.originalBudgetInCents ?? 0;
  o.currentBudgetInCents = options.currentBudgetInCents ?? 0;
  o.originalRevenueInCents = options.originalRevenueInCents ?? 0;
  o.currentRevenueInCents = options.currentRevenueInCents ?? 0;
  return o;
}

factories["ProjectBudgetFinancials"] = newProjectBudgetFinancials;

export interface ApplyInvoiceScheduleResultOptions {
  __typename?: "ApplyInvoiceScheduleResult";
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions | null;
}

export function newApplyInvoiceScheduleResult(
  options: ApplyInvoiceScheduleResultOptions = {},
  cache: Record<string, any> = {},
): ApplyInvoiceScheduleResult {
  const o = (options.__typename ? options : cache["ApplyInvoiceScheduleResult"] = {}) as ApplyInvoiceScheduleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ApplyInvoiceScheduleResult";
  o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
  return o;
}

factories["ApplyInvoiceScheduleResult"] = newApplyInvoiceScheduleResult;

export interface ExportProjectBillsResultOptions {
  __typename?: "ExportProjectBillsResult";
  googleDriveFolderId?: ExportProjectBillsResult["googleDriveFolderId"];
}

export function newExportProjectBillsResult(
  options: ExportProjectBillsResultOptions = {},
  cache: Record<string, any> = {},
): ExportProjectBillsResult {
  const o = (options.__typename ? options : cache["ExportProjectBillsResult"] = {}) as ExportProjectBillsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ExportProjectBillsResult";
  o.googleDriveFolderId = options.googleDriveFolderId ?? "googleDriveFolderId";
  return o;
}

factories["ExportProjectBillsResult"] = newExportProjectBillsResult;

export interface OptionWithCutoffDateOptions {
  __typename?: "OptionWithCutoffDate";
  option?: ReadyPlanOption | ReadyPlanOptionOptions;
  cutoffDate?: OptionWithCutoffDate["cutoffDate"];
}

export function newOptionWithCutoffDate(
  options: OptionWithCutoffDateOptions = {},
  cache: Record<string, any> = {},
): OptionWithCutoffDate {
  const o = (options.__typename ? options : cache["OptionWithCutoffDate"] = {}) as OptionWithCutoffDate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "OptionWithCutoffDate";
  o.option = maybeNew("ReadyPlanOption", options.option, cache, options.hasOwnProperty("option"));
  o.cutoffDate = options.cutoffDate ?? null;
  return o;
}

factories["OptionWithCutoffDate"] = newOptionWithCutoffDate;

export interface ProjectCompletedTaskBudgetReviewOptions {
  __typename?: "ProjectCompletedTaskBudgetReview";
  bucket?: ProjectCompletedTaskBudgetReview["bucket"];
  costInCents?: ProjectCompletedTaskBudgetReview["costInCents"];
}

export function newProjectCompletedTaskBudgetReview(
  options: ProjectCompletedTaskBudgetReviewOptions = {},
  cache: Record<string, any> = {},
): ProjectCompletedTaskBudgetReview {
  const o =
    (options.__typename ? options : cache["ProjectCompletedTaskBudgetReview"] = {}) as ProjectCompletedTaskBudgetReview;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectCompletedTaskBudgetReview";
  o.bucket = options.bucket ?? "bucket";
  o.costInCents = options.costInCents ?? 0;
  return o;
}

factories["ProjectCompletedTaskBudgetReview"] = newProjectCompletedTaskBudgetReview;

export interface ProjectDirectMarginGraphOptions {
  __typename?: "ProjectDirectMarginGraph";
  resolution?: ProjectDirectMarginGraph["resolution"];
  data?: Array<ProjectDirectMarginGraphData | ProjectDirectMarginGraphDataOptions>;
}

export function newProjectDirectMarginGraph(
  options: ProjectDirectMarginGraphOptions = {},
  cache: Record<string, any> = {},
): ProjectDirectMarginGraph {
  const o = (options.__typename ? options : cache["ProjectDirectMarginGraph"] = {}) as ProjectDirectMarginGraph;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectDirectMarginGraph";
  o.resolution = options.resolution ?? ProjectDirectMarginGraphResolution.Daily;
  o.data = (options.data ?? []).map((i) =>
    maybeNew("ProjectDirectMarginGraphData", i, cache, options.hasOwnProperty("data"))
  );
  return o;
}

factories["ProjectDirectMarginGraph"] = newProjectDirectMarginGraph;

export interface ProjectDirectMarginGraphDataOptions {
  __typename?: "ProjectDirectMarginGraphData";
  date?: ProjectDirectMarginGraphData["date"];
  directMarginInBasisPoints?: ProjectDirectMarginGraphData["directMarginInBasisPoints"];
}

export function newProjectDirectMarginGraphData(
  options: ProjectDirectMarginGraphDataOptions = {},
  cache: Record<string, any> = {},
): ProjectDirectMarginGraphData {
  const o = (options.__typename ? options : cache["ProjectDirectMarginGraphData"] = {}) as ProjectDirectMarginGraphData;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectDirectMarginGraphData";
  o.date = options.date ?? newDate();
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  return o;
}

factories["ProjectDirectMarginGraphData"] = newProjectDirectMarginGraphData;

export interface ProjectChangeEventGraphsResultOptions {
  __typename?: "ProjectChangeEventGraphsResult";
  graphs?: Array<ProjectChangeEventGraph | ProjectChangeEventGraphOptions>;
}

export function newProjectChangeEventGraphsResult(
  options: ProjectChangeEventGraphsResultOptions = {},
  cache: Record<string, any> = {},
): ProjectChangeEventGraphsResult {
  const o =
    (options.__typename ? options : cache["ProjectChangeEventGraphsResult"] = {}) as ProjectChangeEventGraphsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectChangeEventGraphsResult";
  o.graphs = (options.graphs ?? []).map((i) =>
    maybeNew("ProjectChangeEventGraph", i, cache, options.hasOwnProperty("graphs"))
  );
  return o;
}

factories["ProjectChangeEventGraphsResult"] = newProjectChangeEventGraphsResult;

export interface ProjectChangeEventGraphOptions {
  __typename?: "ProjectChangeEventGraph";
  type?: ProjectChangeEventGraph["type"];
  data?: Array<ProjectChangeEventGraphData | ProjectChangeEventGraphDataOptions>;
}

export function newProjectChangeEventGraph(
  options: ProjectChangeEventGraphOptions = {},
  cache: Record<string, any> = {},
): ProjectChangeEventGraph {
  const o = (options.__typename ? options : cache["ProjectChangeEventGraph"] = {}) as ProjectChangeEventGraph;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectChangeEventGraph";
  o.type = options.type ?? ProjectChangeEventGraphType.Reason;
  o.data = (options.data ?? []).map((i) =>
    maybeNew("ProjectChangeEventGraphData", i, cache, options.hasOwnProperty("data"))
  );
  return o;
}

factories["ProjectChangeEventGraph"] = newProjectChangeEventGraph;

export interface ProjectChangeEventGraphDataOptions {
  __typename?: "ProjectChangeEventGraphData";
  name?: ProjectChangeEventGraphData["name"];
  totalCostInCents?: ProjectChangeEventGraphData["totalCostInCents"];
  timesUsed?: ProjectChangeEventGraphData["timesUsed"];
}

export function newProjectChangeEventGraphData(
  options: ProjectChangeEventGraphDataOptions = {},
  cache: Record<string, any> = {},
): ProjectChangeEventGraphData {
  const o = (options.__typename ? options : cache["ProjectChangeEventGraphData"] = {}) as ProjectChangeEventGraphData;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectChangeEventGraphData";
  o.name = options.name ?? "name";
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.timesUsed = options.timesUsed ?? null;
  return o;
}

factories["ProjectChangeEventGraphData"] = newProjectChangeEventGraphData;

export interface CompanyInfoOptions {
  __typename?: "CompanyInfo";
  name?: CompanyInfo["name"];
  licenseNumber?: CompanyInfo["licenseNumber"];
  phoneNumber?: CompanyInfo["phoneNumber"];
  email?: CompanyInfo["email"];
  accountNumber?: CompanyInfo["accountNumber"];
  federalId?: CompanyInfo["federalId"];
}

export function newCompanyInfo(options: CompanyInfoOptions = {}, cache: Record<string, any> = {}): CompanyInfo {
  const o = (options.__typename ? options : cache["CompanyInfo"] = {}) as CompanyInfo;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CompanyInfo";
  o.name = options.name ?? "name";
  o.licenseNumber = options.licenseNumber ?? "licenseNumber";
  o.phoneNumber = options.phoneNumber ?? "phoneNumber";
  o.email = options.email ?? "email";
  o.accountNumber = options.accountNumber ?? "accountNumber";
  o.federalId = options.federalId ?? "federalId";
  return o;
}

factories["CompanyInfo"] = newCompanyInfo;

export interface RelevantProjectBidPackageOptions {
  __typename?: "RelevantProjectBidPackage";
  id?: RelevantProjectBidPackage["id"];
  bidPackage?: BidPackage | BidPackageOptions;
  totalCostInCents?: RelevantProjectBidPackage["totalCostInCents"];
  preferredBidContractRevision?: BidContractRevision | BidContractRevisionOptions;
  existingCommitments?: Array<Commitment | CommitmentChangeOrder | CommitmentLike | CommitmentLikeOptions>;
}

export function newRelevantProjectBidPackage(
  options: RelevantProjectBidPackageOptions = {},
  cache: Record<string, any> = {},
): RelevantProjectBidPackage {
  const o = (options.__typename ? options : cache["RelevantProjectBidPackage"] = {}) as RelevantProjectBidPackage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "RelevantProjectBidPackage";
  o.id = options.id ?? nextFactoryId("RelevantProjectBidPackage");
  o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.preferredBidContractRevision = maybeNew(
    "BidContractRevision",
    options.preferredBidContractRevision,
    cache,
    options.hasOwnProperty("preferredBidContractRevision"),
  );
  o.existingCommitments = (options.existingCommitments ?? []).map((i) =>
    maybeNew("CommitmentLike", i, cache, options.hasOwnProperty("existingCommitments"))
  );
  return o;
}

factories["RelevantProjectBidPackage"] = newRelevantProjectBidPackage;

export interface ProjectAllocationRuleOptions {
  __typename?: "ProjectAllocationRule";
  id?: ProjectAllocationRule["id"];
  isDefault?: ProjectAllocationRule["isDefault"];
  createdAt?: ProjectAllocationRule["createdAt"];
  updatedAt?: ProjectAllocationRule["updatedAt"];
  allocationStrategy?: AllocationStrategyDetailOptions | AllocationStrategy;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  costCodes?: Array<CostCode | CostCodeOptions>;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
}

export function newProjectAllocationRule(
  options: ProjectAllocationRuleOptions = {},
  cache: Record<string, any> = {},
): ProjectAllocationRule {
  const o = (options.__typename ? options : cache["ProjectAllocationRule"] = {}) as ProjectAllocationRule;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectAllocationRule";
  o.id = options.id ?? nextFactoryId("ProjectAllocationRule");
  o.isDefault = options.isDefault ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.allocationStrategy = enumOrDetailOfAllocationStrategy(options.allocationStrategy);
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  return o;
}

factories["ProjectAllocationRule"] = newProjectAllocationRule;

export interface SaveProjectAllocationRuleResultOptions {
  __typename?: "SaveProjectAllocationRuleResult";
  projectAllocationRule?: ProjectAllocationRule | ProjectAllocationRuleOptions;
}

export function newSaveProjectAllocationRuleResult(
  options: SaveProjectAllocationRuleResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectAllocationRuleResult {
  const o =
    (options.__typename ? options : cache["SaveProjectAllocationRuleResult"] = {}) as SaveProjectAllocationRuleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectAllocationRuleResult";
  o.projectAllocationRule = maybeNew(
    "ProjectAllocationRule",
    options.projectAllocationRule,
    cache,
    options.hasOwnProperty("projectAllocationRule"),
  );
  return o;
}

factories["SaveProjectAllocationRuleResult"] = newSaveProjectAllocationRuleResult;

export interface ProjectCollaboratorOptions {
  __typename?: "ProjectCollaborator";
  id?: ProjectCollaborator["id"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  collaborator?: Client | ClientOptions;
  role?: ProjectCollaborator["role"];
  roleDetail?: ProjectCollaboratorRoleDetailOptions | ProjectCollaboratorRole;
  inviteSent?: ProjectCollaborator["inviteSent"];
  inviteSentAt?: ProjectCollaborator["inviteSentAt"];
}

export function newProjectCollaborator(
  options: ProjectCollaboratorOptions = {},
  cache: Record<string, any> = {},
): ProjectCollaborator {
  const o = (options.__typename ? options : cache["ProjectCollaborator"] = {}) as ProjectCollaborator;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectCollaborator";
  o.id = options.id ?? nextFactoryId("ProjectCollaborator");
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.collaborator = maybeNew("Client", options.collaborator, cache, options.hasOwnProperty("collaborator"));
  o.role = options.role ?? ProjectCollaboratorRole.Homeowner;
  o.roleDetail = enumOrDetailOfProjectCollaboratorRole(options.roleDetail);
  o.inviteSent = options.inviteSent ?? null;
  o.inviteSentAt = options.inviteSentAt ?? null;
  return o;
}

factories["ProjectCollaborator"] = newProjectCollaborator;

export interface SendInviteEmailResultOptions {
  __typename?: "SendInviteEmailResult";
  projectCollaborator?: ProjectCollaborator | ProjectCollaboratorOptions;
}

export function newSendInviteEmailResult(
  options: SendInviteEmailResultOptions = {},
  cache: Record<string, any> = {},
): SendInviteEmailResult {
  const o = (options.__typename ? options : cache["SendInviteEmailResult"] = {}) as SendInviteEmailResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SendInviteEmailResult";
  o.projectCollaborator = maybeNew(
    "ProjectCollaborator",
    options.projectCollaborator,
    cache,
    options.hasOwnProperty("projectCollaborator"),
  );
  return o;
}

factories["SendInviteEmailResult"] = newSendInviteEmailResult;

export interface ProjectContactOptions {
  __typename?: "ProjectContact";
  id?: ProjectContact["id"];
  fullName?: ProjectContact["fullName"];
  phoneNumber?: ProjectContact["phoneNumber"];
  email?: ProjectContact["email"];
  createdAt?: ProjectContact["createdAt"];
  updatedAt?: ProjectContact["updatedAt"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
}

export function newProjectContact(
  options: ProjectContactOptions = {},
  cache: Record<string, any> = {},
): ProjectContact {
  const o = (options.__typename ? options : cache["ProjectContact"] = {}) as ProjectContact;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectContact";
  o.id = options.id ?? nextFactoryId("ProjectContact");
  o.fullName = options.fullName ?? "fullName";
  o.phoneNumber = options.phoneNumber ?? "phoneNumber";
  o.email = options.email ?? "email";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  return o;
}

factories["ProjectContact"] = newProjectContact;

export interface SaveProjectContactResultOptions {
  __typename?: "SaveProjectContactResult";
  projectContact?: ProjectContact | ProjectContactOptions;
}

export function newSaveProjectContactResult(
  options: SaveProjectContactResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectContactResult {
  const o = (options.__typename ? options : cache["SaveProjectContactResult"] = {}) as SaveProjectContactResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectContactResult";
  o.projectContact = maybeNew(
    "ProjectContact",
    options.projectContact,
    cache,
    options.hasOwnProperty("projectContact"),
  );
  return o;
}

factories["SaveProjectContactResult"] = newSaveProjectContactResult;

export interface ProjectCostCodesPageResultOptions {
  __typename?: "ProjectCostCodesPageResult";
  entities?: Array<ProjectCostCode | ProjectCostCodeOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newProjectCostCodesPageResult(
  options: ProjectCostCodesPageResultOptions = {},
  cache: Record<string, any> = {},
): ProjectCostCodesPageResult {
  const o = (options.__typename ? options : cache["ProjectCostCodesPageResult"] = {}) as ProjectCostCodesPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectCostCodesPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ProjectCostCodesPageResult"] = newProjectCostCodesPageResult;

export interface ProjectDocumentAssociationOptions {
  __typename?: "ProjectDocumentAssociation";
  id?: ProjectDocumentAssociation["id"];
  createdAt?: ProjectDocumentAssociation["createdAt"];
  updatedAt?: ProjectDocumentAssociation["updatedAt"];
  document?: Document | DocumentOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
}

export function newProjectDocumentAssociation(
  options: ProjectDocumentAssociationOptions = {},
  cache: Record<string, any> = {},
): ProjectDocumentAssociation {
  const o = (options.__typename ? options : cache["ProjectDocumentAssociation"] = {}) as ProjectDocumentAssociation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectDocumentAssociation";
  o.id = options.id ?? nextFactoryId("ProjectDocumentAssociation");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.document = maybeNew("Document", options.document, cache, options.hasOwnProperty("document"));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  return o;
}

factories["ProjectDocumentAssociation"] = newProjectDocumentAssociation;

export interface ProjectInvoiceSettingOptions {
  __typename?: "ProjectInvoiceSetting";
  id?: ProjectInvoiceSetting["id"];
  markupValuePercent?: ProjectInvoiceSetting["markupValuePercent"];
  insuranceCostInCents?: ProjectInvoiceSetting["insuranceCostInCents"];
  insuranceMarkupPercent?: ProjectInvoiceSetting["insuranceMarkupPercent"];
  requireWorkAuthorization?: ProjectInvoiceSetting["requireWorkAuthorization"];
  includesContractIncludesRetainage?: ProjectInvoiceSetting["includesContractIncludesRetainage"];
  retainageAmountPercent?: ProjectInvoiceSetting["retainageAmountPercent"];
  requireGFormat?: ProjectInvoiceSetting["requireGFormat"];
  requireTpCopiesBills?: ProjectInvoiceSetting["requireTpCopiesBills"];
  requireTpSummaryListBills?: ProjectInvoiceSetting["requireTpSummaryListBills"];
  requireTpConditionalLw?: ProjectInvoiceSetting["requireTpConditionalLw"];
  requireTpUnconditionalLw?: ProjectInvoiceSetting["requireTpUnconditionalLw"];
  requireHbConditionalLw?: ProjectInvoiceSetting["requireHbConditionalLw"];
  requireHbUnconditionalLw?: ProjectInvoiceSetting["requireHbUnconditionalLw"];
  createdAt?: ProjectInvoiceSetting["createdAt"];
  updatedAt?: ProjectInvoiceSetting["updatedAt"];
  markupApplicationMethod?: MarkupApplicationMethodDetailOptions | MarkupApplicationMethod | null;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
}

export function newProjectInvoiceSetting(
  options: ProjectInvoiceSettingOptions = {},
  cache: Record<string, any> = {},
): ProjectInvoiceSetting {
  const o = (options.__typename ? options : cache["ProjectInvoiceSetting"] = {}) as ProjectInvoiceSetting;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectInvoiceSetting";
  o.id = options.id ?? nextFactoryId("ProjectInvoiceSetting");
  o.markupValuePercent = options.markupValuePercent ?? null;
  o.insuranceCostInCents = options.insuranceCostInCents ?? null;
  o.insuranceMarkupPercent = options.insuranceMarkupPercent ?? null;
  o.requireWorkAuthorization = options.requireWorkAuthorization ?? null;
  o.includesContractIncludesRetainage = options.includesContractIncludesRetainage ?? null;
  o.retainageAmountPercent = options.retainageAmountPercent ?? null;
  o.requireGFormat = options.requireGFormat ?? null;
  o.requireTpCopiesBills = options.requireTpCopiesBills ?? null;
  o.requireTpSummaryListBills = options.requireTpSummaryListBills ?? null;
  o.requireTpConditionalLw = options.requireTpConditionalLw ?? null;
  o.requireTpUnconditionalLw = options.requireTpUnconditionalLw ?? null;
  o.requireHbConditionalLw = options.requireHbConditionalLw ?? null;
  o.requireHbUnconditionalLw = options.requireHbUnconditionalLw ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.markupApplicationMethod = enumOrDetailOrNullOfMarkupApplicationMethod(options.markupApplicationMethod);
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  return o;
}

factories["ProjectInvoiceSetting"] = newProjectInvoiceSetting;

export interface SaveProjectInvoiceSettingResultOptions {
  __typename?: "SaveProjectInvoiceSettingResult";
  projectInvoiceSetting?: ProjectInvoiceSetting | ProjectInvoiceSettingOptions;
}

export function newSaveProjectInvoiceSettingResult(
  options: SaveProjectInvoiceSettingResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectInvoiceSettingResult {
  const o =
    (options.__typename ? options : cache["SaveProjectInvoiceSettingResult"] = {}) as SaveProjectInvoiceSettingResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectInvoiceSettingResult";
  o.projectInvoiceSetting = maybeNew(
    "ProjectInvoiceSetting",
    options.projectInvoiceSetting,
    cache,
    options.hasOwnProperty("projectInvoiceSetting"),
  );
  return o;
}

factories["SaveProjectInvoiceSettingResult"] = newSaveProjectInvoiceSettingResult;

export interface PotentialBidContractLineItemOptions {
  __typename?: "PotentialBidContractLineItem";
  bidContractLineItem?: BidContractLineItem | BidContractLineItemOptions;
  bidContractLineItems?: Array<BidContractLineItem | BidContractLineItemOptions>;
  totalCostInCents?: PotentialBidContractLineItem["totalCostInCents"];
}

export function newPotentialBidContractLineItem(
  options: PotentialBidContractLineItemOptions = {},
  cache: Record<string, any> = {},
): PotentialBidContractLineItem {
  const o = (options.__typename ? options : cache["PotentialBidContractLineItem"] = {}) as PotentialBidContractLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PotentialBidContractLineItem";
  o.bidContractLineItem = maybeNew(
    "BidContractLineItem",
    options.bidContractLineItem,
    cache,
    options.hasOwnProperty("bidContractLineItem"),
  );
  o.bidContractLineItems = (options.bidContractLineItems ?? []).map((i) =>
    maybeNew("BidContractLineItem", i, cache, options.hasOwnProperty("bidContractLineItems"))
  );
  o.totalCostInCents = options.totalCostInCents ?? 0;
  return o;
}

factories["PotentialBidContractLineItem"] = newPotentialBidContractLineItem;

export interface ProjectItemScopeChangeOptions {
  __typename?: "ProjectItemScopeChange";
  quantity?: ProjectItemScopeChange["quantity"];
  costInCents?: ProjectItemScopeChange["costInCents"];
  priceInCents?: ProjectItemScopeChange["priceInCents"];
  tradePartnerNote?: ProjectItemScopeChange["tradePartnerNote"];
  specifications?: ProjectItemScopeChange["specifications"];
  shortName?: ProjectItemScopeChange["shortName"];
}

export function newProjectItemScopeChange(
  options: ProjectItemScopeChangeOptions = {},
  cache: Record<string, any> = {},
): ProjectItemScopeChange {
  const o = (options.__typename ? options : cache["ProjectItemScopeChange"] = {}) as ProjectItemScopeChange;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectItemScopeChange";
  o.quantity = options.quantity ?? null;
  o.costInCents = options.costInCents ?? 0;
  o.priceInCents = options.priceInCents ?? 0;
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.specifications = options.specifications ?? null;
  o.shortName = options.shortName ?? "shortName";
  return o;
}

factories["ProjectItemScopeChange"] = newProjectItemScopeChange;

export interface BudgetPhaseRollupOptions {
  __typename?: "BudgetPhaseRollup";
  original?: BudgetPhaseRollup["original"];
  prebid?: BudgetPhaseRollup["prebid"];
  prebidChange?: BudgetPhaseRollup["prebidChange"];
  awarded?: BudgetPhaseRollup["awarded"];
  awardedChange?: BudgetPhaseRollup["awardedChange"];
  revised?: BudgetPhaseRollup["revised"];
  revisedChange?: BudgetPhaseRollup["revisedChange"];
}

export function newBudgetPhaseRollup(
  options: BudgetPhaseRollupOptions = {},
  cache: Record<string, any> = {},
): BudgetPhaseRollup {
  const o = (options.__typename ? options : cache["BudgetPhaseRollup"] = {}) as BudgetPhaseRollup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BudgetPhaseRollup";
  o.original = options.original ?? 0;
  o.prebid = options.prebid ?? 0;
  o.prebidChange = options.prebidChange ?? 0;
  o.awarded = options.awarded ?? 0;
  o.awardedChange = options.awardedChange ?? 0;
  o.revised = options.revised ?? 0;
  o.revisedChange = options.revisedChange ?? 0;
  return o;
}

factories["BudgetPhaseRollup"] = newBudgetPhaseRollup;

export interface DuplicateProjectItemsResultOptions {
  __typename?: "DuplicateProjectItemsResult";
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
}

export function newDuplicateProjectItemsResult(
  options: DuplicateProjectItemsResultOptions = {},
  cache: Record<string, any> = {},
): DuplicateProjectItemsResult {
  const o = (options.__typename ? options : cache["DuplicateProjectItemsResult"] = {}) as DuplicateProjectItemsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DuplicateProjectItemsResult";
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  return o;
}

factories["DuplicateProjectItemsResult"] = newDuplicateProjectItemsResult;

export interface SaveProjectItemsResultOptions {
  __typename?: "SaveProjectItemsResult";
  projectItems?: Array<ProjectItem | ProjectItemOptions> | null;
  userErrors?: Array<UserError | UserErrorOptions> | null;
}

export function newSaveProjectItemsResult(
  options: SaveProjectItemsResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectItemsResult {
  const o = (options.__typename ? options : cache["SaveProjectItemsResult"] = {}) as SaveProjectItemsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectItemsResult";
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["SaveProjectItemsResult"] = newSaveProjectItemsResult;

export interface CostLineItemOptions {
  __typename?: "CostLineItem";
  id?: CostLineItem["id"];
  amountInCents?: CostLineItem["amountInCents"];
  historicAmountInvoiced?: CostLineItem["historicAmountInvoiced"];
  costDate?: CostLineItem["costDate"];
  isTradePartnerCredit?: CostLineItem["isTradePartnerCredit"];
  entity?: CostLineItemEntity | BillOptions | RequireTypename<ExpenseOptions>;
  tradePartnerNumber?: CostLineItem["tradePartnerNumber"];
}

export function newCostLineItem(options: CostLineItemOptions = {}, cache: Record<string, any> = {}): CostLineItem {
  const o = (options.__typename ? options : cache["CostLineItem"] = {}) as CostLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostLineItem";
  o.id = options.id ?? nextFactoryId("CostLineItem");
  o.amountInCents = options.amountInCents ?? 0;
  o.historicAmountInvoiced = options.historicAmountInvoiced ?? 0;
  o.costDate = options.costDate ?? newDate();
  o.isTradePartnerCredit = options.isTradePartnerCredit ?? false;
  o.entity = maybeNew(options.entity?.__typename ?? "Bill", options.entity, cache);
  o.tradePartnerNumber = options.tradePartnerNumber ?? "tradePartnerNumber";
  return o;
}

factories["CostLineItem"] = newCostLineItem;

export interface ProjectItemBudgetFinancialsOptions {
  __typename?: "ProjectItemBudgetFinancials";
  original?: ProjectItemBudgetFinancials["original"];
  awarded?: ProjectItemBudgetFinancials["awarded"];
  changeEvents?: ProjectItemBudgetFinancials["changeEvents"];
  nonChargeableChangeEvents?: ProjectItemBudgetFinancials["nonChargeableChangeEvents"];
  chargeableChangeEvents?: ProjectItemBudgetFinancials["chargeableChangeEvents"];
  proposedChangeEvents?: ProjectItemBudgetFinancials["proposedChangeEvents"];
  reallocations?: ProjectItemBudgetFinancials["reallocations"];
  revisedInternalBudget?: ProjectItemBudgetFinancials["revisedInternalBudget"];
  revisedExternalBudget?: ProjectItemBudgetFinancials["revisedExternalBudget"];
  committed?: ProjectItemBudgetFinancials["committed"];
  uncommitted?: ProjectItemBudgetFinancials["uncommitted"];
  tradeBilled?: ProjectItemBudgetFinancials["tradeBilled"];
  tradePaidToDate?: ProjectItemBudgetFinancials["tradePaidToDate"];
  unpaidCommitments?: ProjectItemBudgetFinancials["unpaidCommitments"];
  projected?: ProjectItemBudgetFinancials["projected"];
}

export function newProjectItemBudgetFinancials(
  options: ProjectItemBudgetFinancialsOptions = {},
  cache: Record<string, any> = {},
): ProjectItemBudgetFinancials {
  const o = (options.__typename ? options : cache["ProjectItemBudgetFinancials"] = {}) as ProjectItemBudgetFinancials;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectItemBudgetFinancials";
  o.original = options.original ?? 0;
  o.awarded = options.awarded ?? 0;
  o.changeEvents = options.changeEvents ?? 0;
  o.nonChargeableChangeEvents = options.nonChargeableChangeEvents ?? 0;
  o.chargeableChangeEvents = options.chargeableChangeEvents ?? 0;
  o.proposedChangeEvents = options.proposedChangeEvents ?? 0;
  o.reallocations = options.reallocations ?? 0;
  o.revisedInternalBudget = options.revisedInternalBudget ?? 0;
  o.revisedExternalBudget = options.revisedExternalBudget ?? 0;
  o.committed = options.committed ?? 0;
  o.uncommitted = options.uncommitted ?? 0;
  o.tradeBilled = options.tradeBilled ?? 0;
  o.tradePaidToDate = options.tradePaidToDate ?? 0;
  o.unpaidCommitments = options.unpaidCommitments ?? 0;
  o.projected = options.projected ?? 0;
  return o;
}

factories["ProjectItemBudgetFinancials"] = newProjectItemBudgetFinancials;

export interface ProjectItemsPageOptions {
  __typename?: "ProjectItemsPage";
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newProjectItemsPage(
  options: ProjectItemsPageOptions = {},
  cache: Record<string, any> = {},
): ProjectItemsPage {
  const o = (options.__typename ? options : cache["ProjectItemsPage"] = {}) as ProjectItemsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectItemsPage";
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ProjectItemsPage"] = newProjectItemsPage;

export interface ProjectItemAllocationOptions {
  __typename?: "ProjectItemAllocation";
  id?: ProjectItemAllocation["id"];
  createdAt?: ProjectItemAllocation["createdAt"];
  updatedAt?: ProjectItemAllocation["updatedAt"];
  childProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  parentProjectItem?: ProjectItem | ProjectItemOptions;
  commitmentLineItemAllocations?: Array<CommitmentLineItemAllocation | CommitmentLineItemAllocationOptions>;
  homeownerContractLineItemAllocations?: Array<
    HomeownerContractLineItemAllocation | HomeownerContractLineItemAllocationOptions
  >;
  changeEventLineItemAllocations?: Array<ChangeEventLineItemAllocation | ChangeEventLineItemAllocationOptions>;
  billLineItemAllocations?: Array<BillLineItemAllocation | BillLineItemAllocationOptions>;
  expenseAllocationAllocations?: Array<ExpenseAllocationAllocation | ExpenseAllocationAllocationOptions>;
  isActive?: ProjectItemAllocation["isActive"];
  revisedPriceInCents?: ProjectItemAllocation["revisedPriceInCents"];
  originalCostInCents?: ProjectItemAllocation["originalCostInCents"];
  startCostInCents?: ProjectItemAllocation["startCostInCents"];
  changeEventCostInCents?: ProjectItemAllocation["changeEventCostInCents"];
  revisedCostInCents?: ProjectItemAllocation["revisedCostInCents"];
  projectedCostInCents?: ProjectItemAllocation["projectedCostInCents"];
  committedCostInCents?: ProjectItemAllocation["committedCostInCents"];
  availableCostInCents?: ProjectItemAllocation["availableCostInCents"];
  billedCostInCents?: ProjectItemAllocation["billedCostInCents"];
  unbilledCostInCents?: ProjectItemAllocation["unbilledCostInCents"];
  revisedApprovedBudgetInCents?: ProjectItemAllocation["revisedApprovedBudgetInCents"];
}

export function newProjectItemAllocation(
  options: ProjectItemAllocationOptions = {},
  cache: Record<string, any> = {},
): ProjectItemAllocation {
  const o = (options.__typename ? options : cache["ProjectItemAllocation"] = {}) as ProjectItemAllocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectItemAllocation";
  o.id = options.id ?? nextFactoryId("ProjectItemAllocation");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.childProject = maybeNew("Project", options.childProject, cache, options.hasOwnProperty("childProject"));
  o.parentProjectItem = maybeNew(
    "ProjectItem",
    options.parentProjectItem,
    cache,
    options.hasOwnProperty("parentProjectItem"),
  );
  o.commitmentLineItemAllocations = (options.commitmentLineItemAllocations ?? []).map((i) =>
    maybeNew("CommitmentLineItemAllocation", i, cache, options.hasOwnProperty("commitmentLineItemAllocations"))
  );
  o.homeownerContractLineItemAllocations = (options.homeownerContractLineItemAllocations ?? []).map((i) =>
    maybeNew(
      "HomeownerContractLineItemAllocation",
      i,
      cache,
      options.hasOwnProperty("homeownerContractLineItemAllocations"),
    )
  );
  o.changeEventLineItemAllocations = (options.changeEventLineItemAllocations ?? []).map((i) =>
    maybeNew("ChangeEventLineItemAllocation", i, cache, options.hasOwnProperty("changeEventLineItemAllocations"))
  );
  o.billLineItemAllocations = (options.billLineItemAllocations ?? []).map((i) =>
    maybeNew("BillLineItemAllocation", i, cache, options.hasOwnProperty("billLineItemAllocations"))
  );
  o.expenseAllocationAllocations = (options.expenseAllocationAllocations ?? []).map((i) =>
    maybeNew("ExpenseAllocationAllocation", i, cache, options.hasOwnProperty("expenseAllocationAllocations"))
  );
  o.isActive = options.isActive ?? false;
  o.revisedPriceInCents = options.revisedPriceInCents ?? 0;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.revisedApprovedBudgetInCents = options.revisedApprovedBudgetInCents ?? 0;
  return o;
}

factories["ProjectItemAllocation"] = newProjectItemAllocation;

export interface ProjectLotDetailOptions {
  __typename?: "ProjectLotDetail";
  id?: ProjectLotDetail["id"];
  lotNumber?: ProjectLotDetail["lotNumber"];
  block?: ProjectLotDetail["block"];
  section?: ProjectLotDetail["section"];
  lotSquareFootage?: ProjectLotDetail["lotSquareFootage"];
  elevationCertificateDocumentRequired?: ProjectLotDetail["elevationCertificateDocumentRequired"];
  setBackFront?: ProjectLotDetail["setBackFront"];
  setBackRight?: ProjectLotDetail["setBackRight"];
  setBackLeft?: ProjectLotDetail["setBackLeft"];
  setBackRear?: ProjectLotDetail["setBackRear"];
  hoa?: ProjectLotDetail["hoa"];
  hoaSpecificModifications?: ProjectLotDetail["hoaSpecificModifications"];
  siteSpecificModifications?: ProjectLotDetail["siteSpecificModifications"];
  fireSprinklersRequired?: ProjectLotDetail["fireSprinklersRequired"];
  createdAt?: ProjectLotDetail["createdAt"];
  updatedAt?: ProjectLotDetail["updatedAt"];
  constructionType?: ConstructionTypeDetailOptions | ConstructionType | null;
  floodPlain?: FloodPlainDetailOptions | FloodPlain | null;
  foundationType?: FoundationTypeDetailOptions | FoundationType | null;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  userEvents?: Array<UserEvent | UserEventOptions>;
  floodZone?: FloodZoneDetailOptions | FloodZone | null;
  setBackFrontInFeet?: ProjectLotDetail["setBackFrontInFeet"];
  setBackLeftInFeet?: ProjectLotDetail["setBackLeftInFeet"];
  setBackRightInFeet?: ProjectLotDetail["setBackRightInFeet"];
  setBackRearInFeet?: ProjectLotDetail["setBackRearInFeet"];
}

export function newProjectLotDetail(
  options: ProjectLotDetailOptions = {},
  cache: Record<string, any> = {},
): ProjectLotDetail {
  const o = (options.__typename ? options : cache["ProjectLotDetail"] = {}) as ProjectLotDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectLotDetail";
  o.id = options.id ?? nextFactoryId("ProjectLotDetail");
  o.lotNumber = options.lotNumber ?? null;
  o.block = options.block ?? null;
  o.section = options.section ?? null;
  o.lotSquareFootage = options.lotSquareFootage ?? null;
  o.elevationCertificateDocumentRequired = options.elevationCertificateDocumentRequired ?? null;
  o.setBackFront = options.setBackFront ?? null;
  o.setBackRight = options.setBackRight ?? null;
  o.setBackLeft = options.setBackLeft ?? null;
  o.setBackRear = options.setBackRear ?? null;
  o.hoa = options.hoa ?? null;
  o.hoaSpecificModifications = options.hoaSpecificModifications ?? null;
  o.siteSpecificModifications = options.siteSpecificModifications ?? null;
  o.fireSprinklersRequired = options.fireSprinklersRequired ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.constructionType = enumOrDetailOrNullOfConstructionType(options.constructionType);
  o.floodPlain = enumOrDetailOrNullOfFloodPlain(options.floodPlain);
  o.foundationType = enumOrDetailOrNullOfFoundationType(options.foundationType);
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.userEvents = (options.userEvents ?? []).map((i) =>
    maybeNew("UserEvent", i, cache, options.hasOwnProperty("userEvents"))
  );
  o.floodZone = enumOrDetailOrNullOfFloodZone(options.floodZone);
  o.setBackFrontInFeet = options.setBackFrontInFeet ?? null;
  o.setBackLeftInFeet = options.setBackLeftInFeet ?? null;
  o.setBackRightInFeet = options.setBackRightInFeet ?? null;
  o.setBackRearInFeet = options.setBackRearInFeet ?? null;
  return o;
}

factories["ProjectLotDetail"] = newProjectLotDetail;

export interface SaveProjectLotDetailsResultOptions {
  __typename?: "SaveProjectLotDetailsResult";
  projectLotDetails?: Array<ProjectLotDetail | ProjectLotDetailOptions>;
}

export function newSaveProjectLotDetailsResult(
  options: SaveProjectLotDetailsResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectLotDetailsResult {
  const o = (options.__typename ? options : cache["SaveProjectLotDetailsResult"] = {}) as SaveProjectLotDetailsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectLotDetailsResult";
  o.projectLotDetails = (options.projectLotDetails ?? []).map((i) =>
    maybeNew("ProjectLotDetail", i, cache, options.hasOwnProperty("projectLotDetails"))
  );
  return o;
}

factories["SaveProjectLotDetailsResult"] = newSaveProjectLotDetailsResult;

export interface ProjectReadyPlanConfigOptions {
  __typename?: "ProjectReadyPlanConfig";
  id?: ProjectReadyPlanConfig["id"];
  name?: ProjectReadyPlanConfig["name"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions | null;
  productOffering?: ProductOffering | ProductOfferingOptions | null;
  blueprintUrl?: Url | UrlOptions;
  createdAt?: ProjectReadyPlanConfig["createdAt"];
  updatedAt?: ProjectReadyPlanConfig["updatedAt"];
  orientation?: ProjectReadyPlanConfig["orientation"];
  orientationDetail?: ProjectReadyPlanConfigOrientationDetailOptions | ProjectReadyPlanConfigOrientation;
  constructionStartDate?: ProjectReadyPlanConfig["constructionStartDate"];
  internalNote?: ProjectReadyPlanConfig["internalNote"];
  specOption?: ProjectReadyPlanConfigOption | ProjectReadyPlanConfigOptionOptions | null;
  elevationOption?: ProjectReadyPlanConfigOption | ProjectReadyPlanConfigOptionOptions | null;
  exteriorPaletteOption?: ProjectReadyPlanConfigOption | ProjectReadyPlanConfigOptionOptions | null;
  interiorOption?: ProjectReadyPlanConfigOption | ProjectReadyPlanConfigOptionOptions | null;
  options?: Array<ProjectReadyPlanConfigOption | ProjectReadyPlanConfigOptionOptions>;
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  supportedSpecOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  applied?: ProjectReadyPlanConfig["applied"];
  lastAppliedAt?: ProjectReadyPlanConfig["lastAppliedAt"];
  canApply?: PotentialOperation2 | PotentialOperation2Options;
  canRelease?: PotentialOperation2 | PotentialOperation2Options;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  programData?: ProgramData | ProgramDataOptions | null;
  deliveryDate?: ProjectReadyPlanConfig["deliveryDate"];
  configurationUpdatedAt?: ProjectReadyPlanConfig["configurationUpdatedAt"];
  programDataMatchState?: ProgramDataMatchStateDetailOptions | ProgramDataMatchState;
  computedProgramData?: ProgramData | ProgramDataOptions;
  autoPopulateWithComputedProgramData?: ProjectReadyPlanConfig["autoPopulateWithComputedProgramData"];
  insideMapsRoomRenderings?: Array<InsideMapsRoomRendering | InsideMapsRoomRenderingOptions>;
  includedPriceInCents?: ProjectReadyPlanConfig["includedPriceInCents"];
  insideMapsTextureSwaps?: InsideMapsTextureSwaps | InsideMapsTextureSwapsOptions | null;
  includedOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  exteriorRendering?: Asset | AssetOptions | null;
  aggregateVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  potentialOptionGroups?: Array<
    ProjectReadyPlanConfigPotentialOptionGroup | ProjectReadyPlanConfigPotentialOptionGroupOptions
  >;
}

export function newProjectReadyPlanConfig(
  options: ProjectReadyPlanConfigOptions = {},
  cache: Record<string, any> = {},
): ProjectReadyPlanConfig {
  const o = (options.__typename ? options : cache["ProjectReadyPlanConfig"] = {}) as ProjectReadyPlanConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectReadyPlanConfig";
  o.id = options.id ?? nextFactoryId("ProjectReadyPlanConfig");
  o.name = options.name ?? null;
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.readyPlan = maybeNewOrNull("ReadyPlanLike", options.readyPlan, cache);
  o.productOffering = maybeNewOrNull("ProductOffering", options.productOffering, cache);
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.orientation = options.orientation ?? ProjectReadyPlanConfigOrientation.Left;
  o.orientationDetail = enumOrDetailOfProjectReadyPlanConfigOrientation(options.orientationDetail);
  o.constructionStartDate = options.constructionStartDate ?? null;
  o.internalNote = options.internalNote ?? null;
  o.specOption = maybeNewOrNull("ProjectReadyPlanConfigOption", options.specOption, cache);
  o.elevationOption = maybeNewOrNull("ProjectReadyPlanConfigOption", options.elevationOption, cache);
  o.exteriorPaletteOption = maybeNewOrNull("ProjectReadyPlanConfigOption", options.exteriorPaletteOption, cache);
  o.interiorOption = maybeNewOrNull("ProjectReadyPlanConfigOption", options.interiorOption, cache);
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfigOption", i, cache, options.hasOwnProperty("options"))
  );
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  o.supportedSpecOptions = (options.supportedSpecOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("supportedSpecOptions"))
  );
  o.applied = options.applied ?? false;
  o.lastAppliedAt = options.lastAppliedAt ?? null;
  o.canApply = maybeNew("PotentialOperation2", options.canApply, cache, options.hasOwnProperty("canApply"));
  o.canRelease = maybeNew("PotentialOperation2", options.canRelease, cache, options.hasOwnProperty("canRelease"));
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.programData = maybeNewOrNull("ProgramData", options.programData, cache);
  o.deliveryDate = options.deliveryDate ?? null;
  o.configurationUpdatedAt = options.configurationUpdatedAt ?? newDateTime();
  o.programDataMatchState = enumOrDetailOfProgramDataMatchState(options.programDataMatchState);
  o.computedProgramData = maybeNew(
    "ProgramData",
    options.computedProgramData,
    cache,
    options.hasOwnProperty("computedProgramData"),
  );
  o.autoPopulateWithComputedProgramData = options.autoPopulateWithComputedProgramData ?? false;
  o.insideMapsRoomRenderings = (options.insideMapsRoomRenderings ?? []).map((i) =>
    maybeNew("InsideMapsRoomRendering", i, cache, options.hasOwnProperty("insideMapsRoomRenderings"))
  );
  o.includedPriceInCents = options.includedPriceInCents ?? null;
  o.insideMapsTextureSwaps = maybeNewOrNull("InsideMapsTextureSwaps", options.insideMapsTextureSwaps, cache);
  o.includedOptions = (options.includedOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("includedOptions"))
  );
  o.exteriorRendering = maybeNewOrNull("Asset", options.exteriorRendering, cache);
  o.aggregateVersion = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateVersion, cache);
  o.potentialOptionGroups = (options.potentialOptionGroups ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfigPotentialOptionGroup", i, cache, options.hasOwnProperty("potentialOptionGroups"))
  );
  return o;
}

factories["ProjectReadyPlanConfig"] = newProjectReadyPlanConfig;

export interface ProjectReadyPlanConfigPotentialOptionGroupOptions {
  __typename?: "ProjectReadyPlanConfigPotentialOptionGroup";
  id?: ProjectReadyPlanConfigPotentialOptionGroup["id"];
  group?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions;
  options?: Array<ProjectReadyPlanConfigPotentialOption | ProjectReadyPlanConfigPotentialOptionOptions>;
  isEnabled?: ProjectReadyPlanConfigPotentialOptionGroup["isEnabled"];
  canBeSelected?: PotentialOperation2 | PotentialOperation2Options;
}

export function newProjectReadyPlanConfigPotentialOptionGroup(
  options: ProjectReadyPlanConfigPotentialOptionGroupOptions = {},
  cache: Record<string, any> = {},
): ProjectReadyPlanConfigPotentialOptionGroup {
  const o =
    (options.__typename
      ? options
      : cache["ProjectReadyPlanConfigPotentialOptionGroup"] = {}) as ProjectReadyPlanConfigPotentialOptionGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectReadyPlanConfigPotentialOptionGroup";
  o.id = options.id ?? nextFactoryId("ProjectReadyPlanConfigPotentialOptionGroup");
  o.group = maybeNew("ReadyPlanOptionGroup", options.group, cache, options.hasOwnProperty("group"));
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfigPotentialOption", i, cache, options.hasOwnProperty("options"))
  );
  o.isEnabled = options.isEnabled ?? false;
  o.canBeSelected = maybeNew(
    "PotentialOperation2",
    options.canBeSelected,
    cache,
    options.hasOwnProperty("canBeSelected"),
  );
  return o;
}

factories["ProjectReadyPlanConfigPotentialOptionGroup"] = newProjectReadyPlanConfigPotentialOptionGroup;

export interface ProjectReadyPlanConfigPotentialOptionOptions {
  __typename?: "ProjectReadyPlanConfigPotentialOption";
  id?: ProjectReadyPlanConfigPotentialOption["id"];
  option?: ReadyPlanOption | ReadyPlanOptionOptions;
  isSelected?: ProjectReadyPlanConfigPotentialOption["isSelected"];
  isEnabled?: ProjectReadyPlanConfigPotentialOption["isEnabled"];
  canBeSelected?: PotentialOperation2 | PotentialOperation2Options;
  totalCostInCents?: ProjectReadyPlanConfigPotentialOption["totalCostInCents"];
  totalPriceInCents?: ProjectReadyPlanConfigPotentialOption["totalPriceInCents"];
}

export function newProjectReadyPlanConfigPotentialOption(
  options: ProjectReadyPlanConfigPotentialOptionOptions = {},
  cache: Record<string, any> = {},
): ProjectReadyPlanConfigPotentialOption {
  const o =
    (options.__typename
      ? options
      : cache["ProjectReadyPlanConfigPotentialOption"] = {}) as ProjectReadyPlanConfigPotentialOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectReadyPlanConfigPotentialOption";
  o.id = options.id ?? nextFactoryId("ProjectReadyPlanConfigPotentialOption");
  o.option = maybeNew("ReadyPlanOption", options.option, cache, options.hasOwnProperty("option"));
  o.isSelected = options.isSelected ?? false;
  o.isEnabled = options.isEnabled ?? false;
  o.canBeSelected = maybeNew(
    "PotentialOperation2",
    options.canBeSelected,
    cache,
    options.hasOwnProperty("canBeSelected"),
  );
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  return o;
}

factories["ProjectReadyPlanConfigPotentialOption"] = newProjectReadyPlanConfigPotentialOption;

export interface SaveProjectReadyPlanConfigsResultOptions {
  __typename?: "SaveProjectReadyPlanConfigsResult";
  projectReadyPlanConfigs?: Array<ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions>;
}

export function newSaveProjectReadyPlanConfigsResult(
  options: SaveProjectReadyPlanConfigsResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectReadyPlanConfigsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveProjectReadyPlanConfigsResult"] = {}) as SaveProjectReadyPlanConfigsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectReadyPlanConfigsResult";
  o.projectReadyPlanConfigs = (options.projectReadyPlanConfigs ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfig", i, cache, options.hasOwnProperty("projectReadyPlanConfigs"))
  );
  return o;
}

factories["SaveProjectReadyPlanConfigsResult"] = newSaveProjectReadyPlanConfigsResult;

export interface ApplyProjectReadyPlanConfigsResultOptions {
  __typename?: "ApplyProjectReadyPlanConfigsResult";
  projectReadyPlanConfigs?: Array<ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions>;
}

export function newApplyProjectReadyPlanConfigsResult(
  options: ApplyProjectReadyPlanConfigsResultOptions = {},
  cache: Record<string, any> = {},
): ApplyProjectReadyPlanConfigsResult {
  const o =
    (options.__typename
      ? options
      : cache["ApplyProjectReadyPlanConfigsResult"] = {}) as ApplyProjectReadyPlanConfigsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ApplyProjectReadyPlanConfigsResult";
  o.projectReadyPlanConfigs = (options.projectReadyPlanConfigs ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfig", i, cache, options.hasOwnProperty("projectReadyPlanConfigs"))
  );
  return o;
}

factories["ApplyProjectReadyPlanConfigsResult"] = newApplyProjectReadyPlanConfigsResult;

export interface SaveProjectReadyPlanConfigOptionsResultOptions {
  __typename?: "SaveProjectReadyPlanConfigOptionsResult";
  projectReadyPlanConfigOptions?: Array<ProjectReadyPlanConfigOption | ProjectReadyPlanConfigOptionOptions>;
}

export function newSaveProjectReadyPlanConfigOptionsResult(
  options: SaveProjectReadyPlanConfigOptionsResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectReadyPlanConfigOptionsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveProjectReadyPlanConfigOptionsResult"] = {}) as SaveProjectReadyPlanConfigOptionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectReadyPlanConfigOptionsResult";
  o.projectReadyPlanConfigOptions = (options.projectReadyPlanConfigOptions ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfigOption", i, cache, options.hasOwnProperty("projectReadyPlanConfigOptions"))
  );
  return o;
}

factories["SaveProjectReadyPlanConfigOptionsResult"] = newSaveProjectReadyPlanConfigOptionsResult;

export interface ProjectReadyPlanConfigOptionOptions {
  __typename?: "ProjectReadyPlanConfigOption";
  id?: ProjectReadyPlanConfigOption["id"];
  createdAt?: ProjectReadyPlanConfigOption["createdAt"];
  updatedAt?: ProjectReadyPlanConfigOption["updatedAt"];
  projectRpConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions;
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions;
  priceInCents?: ProjectReadyPlanConfigOption["priceInCents"];
}

export function newProjectReadyPlanConfigOption(
  options: ProjectReadyPlanConfigOptionOptions = {},
  cache: Record<string, any> = {},
): ProjectReadyPlanConfigOption {
  const o = (options.__typename ? options : cache["ProjectReadyPlanConfigOption"] = {}) as ProjectReadyPlanConfigOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectReadyPlanConfigOption";
  o.id = options.id ?? nextFactoryId("ProjectReadyPlanConfigOption");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.projectRpConfig = maybeNew(
    "ProjectReadyPlanConfig",
    options.projectRpConfig,
    cache,
    options.hasOwnProperty("projectRpConfig"),
  );
  o.readyPlanOption = maybeNew(
    "ReadyPlanOption",
    options.readyPlanOption,
    cache,
    options.hasOwnProperty("readyPlanOption"),
  );
  o.priceInCents = options.priceInCents ?? 0;
  return o;
}

factories["ProjectReadyPlanConfigOption"] = newProjectReadyPlanConfigOption;

export interface ProjectSalesforceOpportunityOptions {
  __typename?: "ProjectSalesforceOpportunity";
  id?: ProjectSalesforceOpportunity["id"];
  salesforceOpportunityId?: ProjectSalesforceOpportunity["salesforceOpportunityId"];
  salesforceOpportunityRecordType?: ProjectSalesforceOpportunity["salesforceOpportunityRecordType"];
  active?: ProjectSalesforceOpportunity["active"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  createdAt?: ProjectSalesforceOpportunity["createdAt"];
  updatedAt?: ProjectSalesforceOpportunity["updatedAt"];
}

export function newProjectSalesforceOpportunity(
  options: ProjectSalesforceOpportunityOptions = {},
  cache: Record<string, any> = {},
): ProjectSalesforceOpportunity {
  const o = (options.__typename ? options : cache["ProjectSalesforceOpportunity"] = {}) as ProjectSalesforceOpportunity;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectSalesforceOpportunity";
  o.id = options.id ?? nextFactoryId("ProjectSalesforceOpportunity");
  o.salesforceOpportunityId = options.salesforceOpportunityId ?? "salesforceOpportunityId";
  o.salesforceOpportunityRecordType = options.salesforceOpportunityRecordType ?? "salesforceOpportunityRecordType";
  o.active = options.active ?? false;
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  return o;
}

factories["ProjectSalesforceOpportunity"] = newProjectSalesforceOpportunity;

export interface ProjectSiteConditionOptions {
  __typename?: "ProjectSiteCondition";
  id?: ProjectSiteCondition["id"];
  expectedSlabPourDate?: ProjectSiteCondition["expectedSlabPourDate"];
  blueprintUrl?: Url | UrlOptions;
  drivewaySwing?: ProjectSiteCondition["drivewaySwing"];
  gasLocation?: ProjectSiteCondition["gasLocation"];
  electricLocation?: ProjectSiteCondition["electricLocation"];
  waterLocation?: ProjectSiteCondition["waterLocation"];
  curbGutterLinearFoot?: ProjectSiteCondition["curbGutterLinearFoot"];
  createdAt?: ProjectSiteCondition["createdAt"];
  updatedAt?: ProjectSiteCondition["updatedAt"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  additionalNotes?: ProjectSiteCondition["additionalNotes"];
  attachments?: Array<Attachment | AttachmentOptions>;
}

export function newProjectSiteCondition(
  options: ProjectSiteConditionOptions = {},
  cache: Record<string, any> = {},
): ProjectSiteCondition {
  const o = (options.__typename ? options : cache["ProjectSiteCondition"] = {}) as ProjectSiteCondition;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectSiteCondition";
  o.id = options.id ?? nextFactoryId("ProjectSiteCondition");
  o.expectedSlabPourDate = options.expectedSlabPourDate ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.drivewaySwing = options.drivewaySwing ?? null;
  o.gasLocation = options.gasLocation ?? null;
  o.electricLocation = options.electricLocation ?? null;
  o.waterLocation = options.waterLocation ?? null;
  o.curbGutterLinearFoot = options.curbGutterLinearFoot ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.additionalNotes = options.additionalNotes ?? null;
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  return o;
}

factories["ProjectSiteCondition"] = newProjectSiteCondition;

export interface SaveProjectSiteConditionResultOptions {
  __typename?: "SaveProjectSiteConditionResult";
  projectSiteCondition?: ProjectSiteCondition | ProjectSiteConditionOptions;
}

export function newSaveProjectSiteConditionResult(
  options: SaveProjectSiteConditionResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectSiteConditionResult {
  const o =
    (options.__typename ? options : cache["SaveProjectSiteConditionResult"] = {}) as SaveProjectSiteConditionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectSiteConditionResult";
  o.projectSiteCondition = maybeNew(
    "ProjectSiteCondition",
    options.projectSiteCondition,
    cache,
    options.hasOwnProperty("projectSiteCondition"),
  );
  return o;
}

factories["SaveProjectSiteConditionResult"] = newSaveProjectSiteConditionResult;

export interface ProjectSiteSpecificInfoOptions {
  __typename?: "ProjectSiteSpecificInfo";
  id?: ProjectSiteSpecificInfo["id"];
  perSiteBudgetInCents?: ProjectSiteSpecificInfo["perSiteBudgetInCents"];
  notes?: ProjectSiteSpecificInfo["notes"];
  createdAt?: ProjectSiteSpecificInfo["createdAt"];
  updatedAt?: ProjectSiteSpecificInfo["updatedAt"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  siteSpecificInfo?: SiteSpecificInfo | SiteSpecificInfoOptions;
}

export function newProjectSiteSpecificInfo(
  options: ProjectSiteSpecificInfoOptions = {},
  cache: Record<string, any> = {},
): ProjectSiteSpecificInfo {
  const o = (options.__typename ? options : cache["ProjectSiteSpecificInfo"] = {}) as ProjectSiteSpecificInfo;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectSiteSpecificInfo";
  o.id = options.id ?? nextFactoryId("ProjectSiteSpecificInfo");
  o.perSiteBudgetInCents = options.perSiteBudgetInCents ?? null;
  o.notes = options.notes ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.siteSpecificInfo = maybeNew(
    "SiteSpecificInfo",
    options.siteSpecificInfo,
    cache,
    options.hasOwnProperty("siteSpecificInfo"),
  );
  return o;
}

factories["ProjectSiteSpecificInfo"] = newProjectSiteSpecificInfo;

export interface SaveProjectSiteSpecificInfoResultOptions {
  __typename?: "SaveProjectSiteSpecificInfoResult";
  projectSiteSpecificInfo?: ProjectSiteSpecificInfo | ProjectSiteSpecificInfoOptions;
}

export function newSaveProjectSiteSpecificInfoResult(
  options: SaveProjectSiteSpecificInfoResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectSiteSpecificInfoResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveProjectSiteSpecificInfoResult"] = {}) as SaveProjectSiteSpecificInfoResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectSiteSpecificInfoResult";
  o.projectSiteSpecificInfo = maybeNew(
    "ProjectSiteSpecificInfo",
    options.projectSiteSpecificInfo,
    cache,
    options.hasOwnProperty("projectSiteSpecificInfo"),
  );
  return o;
}

factories["SaveProjectSiteSpecificInfoResult"] = newSaveProjectSiteSpecificInfoResult;

export interface ProjectSnapshotOptions {
  __typename?: "ProjectSnapshot";
  id?: ProjectSnapshot["id"];
  grossSalesPriceInCents?: ProjectSnapshot["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: ProjectSnapshot["closingCostsForDirectMarginInCents"];
  totalCostInCents?: ProjectSnapshot["totalCostInCents"];
  totalHardCostInCents?: ProjectSnapshot["totalHardCostInCents"];
  totalSoftCostInCents?: ProjectSnapshot["totalSoftCostInCents"];
  directMarginInBasisPoints?: ProjectSnapshot["directMarginInBasisPoints"];
  purchaseCostInCents?: ProjectSnapshot["purchaseCostInCents"];
  startDate?: ProjectSnapshot["startDate"];
  endDate?: ProjectSnapshot["endDate"];
}

export function newProjectSnapshot(
  options: ProjectSnapshotOptions = {},
  cache: Record<string, any> = {},
): ProjectSnapshot {
  const o = (options.__typename ? options : cache["ProjectSnapshot"] = {}) as ProjectSnapshot;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectSnapshot";
  o.id = options.id ?? nextFactoryId("ProjectSnapshot");
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
  o.totalCostInCents = options.totalCostInCents ?? null;
  o.totalHardCostInCents = options.totalHardCostInCents ?? null;
  o.totalSoftCostInCents = options.totalSoftCostInCents ?? null;
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  o.purchaseCostInCents = options.purchaseCostInCents ?? null;
  o.startDate = options.startDate ?? newDate();
  o.endDate = options.endDate ?? null;
  return o;
}

factories["ProjectSnapshot"] = newProjectSnapshot;

export interface StageProgressOptions {
  __typename?: "StageProgress";
  id?: StageProgress["id"];
  taskProgress?: ProgressSummary | ProgressSummaryOptions;
}

export function newStageProgress(options: StageProgressOptions = {}, cache: Record<string, any> = {}): StageProgress {
  const o = (options.__typename ? options : cache["StageProgress"] = {}) as StageProgress;
  (cache.all ??= new Set()).add(o);
  o.__typename = "StageProgress";
  o.id = options.id ?? nextFactoryId("StageProgress");
  o.taskProgress = maybeNew("ProgressSummary", options.taskProgress, cache, options.hasOwnProperty("taskProgress"));
  return o;
}

factories["StageProgress"] = newStageProgress;

export interface ProjectStageHomeownerFinancialsOptions {
  __typename?: "ProjectStageHomeownerFinancials";
  homeownerPriceInCents?: ProjectStageHomeownerFinancials["homeownerPriceInCents"];
  amountInvoicedInCents?: ProjectStageHomeownerFinancials["amountInvoicedInCents"];
  amountPaidInCents?: ProjectStageHomeownerFinancials["amountPaidInCents"];
  balanceInCents?: ProjectStageHomeownerFinancials["balanceInCents"];
  financialsLastUpdate?: ProjectStageHomeownerFinancials["financialsLastUpdate"];
}

export function newProjectStageHomeownerFinancials(
  options: ProjectStageHomeownerFinancialsOptions = {},
  cache: Record<string, any> = {},
): ProjectStageHomeownerFinancials {
  const o =
    (options.__typename ? options : cache["ProjectStageHomeownerFinancials"] = {}) as ProjectStageHomeownerFinancials;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectStageHomeownerFinancials";
  o.homeownerPriceInCents = options.homeownerPriceInCents ?? 0;
  o.amountInvoicedInCents = options.amountInvoicedInCents ?? 0;
  o.amountPaidInCents = options.amountPaidInCents ?? 0;
  o.balanceInCents = options.balanceInCents ?? 0;
  o.financialsLastUpdate = options.financialsLastUpdate ?? newDate();
  return o;
}

factories["ProjectStageHomeownerFinancials"] = newProjectStageHomeownerFinancials;

export interface ProjectStageHocFinancialsOptions {
  __typename?: "ProjectStageHocFinancials";
  originalContractValueInCents?: ProjectStageHocFinancials["originalContractValueInCents"];
  originalBudgetedCostInCents?: ProjectStageHocFinancials["originalBudgetedCostInCents"];
  originalGrossMarginBasisPoints?: ProjectStageHocFinancials["originalGrossMarginBasisPoints"];
  valueInCents?: ProjectStageHocFinancials["valueInCents"];
  costInCents?: ProjectStageHocFinancials["costInCents"];
  grossMarginBasisPoints?: ProjectStageHocFinancials["grossMarginBasisPoints"];
  paidFromHomeownerInCents?: ProjectStageHocFinancials["paidFromHomeownerInCents"];
  paidToTradesInCents?: ProjectStageHocFinancials["paidToTradesInCents"];
  paidNetInCents?: ProjectStageHocFinancials["paidNetInCents"];
  marginErosionBasisPoints?: ProjectStageHocFinancials["marginErosionBasisPoints"];
}

export function newProjectStageHocFinancials(
  options: ProjectStageHocFinancialsOptions = {},
  cache: Record<string, any> = {},
): ProjectStageHocFinancials {
  const o = (options.__typename ? options : cache["ProjectStageHocFinancials"] = {}) as ProjectStageHocFinancials;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectStageHocFinancials";
  o.originalContractValueInCents = options.originalContractValueInCents ?? 0;
  o.originalBudgetedCostInCents = options.originalBudgetedCostInCents ?? 0;
  o.originalGrossMarginBasisPoints = options.originalGrossMarginBasisPoints ?? 0;
  o.valueInCents = options.valueInCents ?? 0;
  o.costInCents = options.costInCents ?? 0;
  o.grossMarginBasisPoints = options.grossMarginBasisPoints ?? 0;
  o.paidFromHomeownerInCents = options.paidFromHomeownerInCents ?? 0;
  o.paidToTradesInCents = options.paidToTradesInCents ?? 0;
  o.paidNetInCents = options.paidNetInCents ?? 0;
  o.marginErosionBasisPoints = options.marginErosionBasisPoints ?? 0;
  return o;
}

factories["ProjectStageHocFinancials"] = newProjectStageHocFinancials;

export interface ProjectStageTemplateConfigOptions {
  __typename?: "ProjectStageTemplateConfig";
  id?: ProjectStageTemplateConfig["id"];
  itemTemplate?: ItemTemplate | ItemTemplateOptions;
  parent?: ItemTemplate | ReadyPlanAggregateVersion | BaseItemParentVersion | BaseItemParentVersionOptions;
  projectStage?: ProjectStage | ProjectStageOptions;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  createdAt?: ProjectStageTemplateConfig["createdAt"];
  updatedAt?: ProjectStageTemplateConfig["updatedAt"];
  name?: ProjectStageTemplateConfig["name"];
  totalCostInCents?: ProjectStageTemplateConfig["totalCostInCents"];
  onlyChangedInVersion?: ProjectStageTemplateConfig["onlyChangedInVersion"];
  changeEvent?: ChangeEvent | ChangeEventOptions | null;
}

export function newProjectStageTemplateConfig(
  options: ProjectStageTemplateConfigOptions = {},
  cache: Record<string, any> = {},
): ProjectStageTemplateConfig {
  const o = (options.__typename ? options : cache["ProjectStageTemplateConfig"] = {}) as ProjectStageTemplateConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectStageTemplateConfig";
  o.id = options.id ?? nextFactoryId("ProjectStageTemplateConfig");
  o.itemTemplate = maybeNew("ItemTemplate", options.itemTemplate, cache, options.hasOwnProperty("itemTemplate"));
  o.parent = maybeNew("BaseItemParentVersion", options.parent, cache, options.hasOwnProperty("parent"));
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.name = options.name ?? "name";
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.onlyChangedInVersion = options.onlyChangedInVersion ?? null;
  o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
  return o;
}

factories["ProjectStageTemplateConfig"] = newProjectStageTemplateConfig;

export interface ProjectStatusChangeOptions {
  __typename?: "ProjectStatusChange";
  id?: ProjectStatusChange["id"];
  internalNote?: ProjectStatusChange["internalNote"];
  createdAt?: ProjectStatusChange["createdAt"];
  updatedAt?: ProjectStatusChange["updatedAt"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  reason?: ProjectStatusChangeReason | ProjectStatusChangeReasonOptions | null;
  date?: ProjectStatusChange["date"];
}

export function newProjectStatusChange(
  options: ProjectStatusChangeOptions = {},
  cache: Record<string, any> = {},
): ProjectStatusChange {
  const o = (options.__typename ? options : cache["ProjectStatusChange"] = {}) as ProjectStatusChange;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectStatusChange";
  o.id = options.id ?? nextFactoryId("ProjectStatusChange");
  o.internalNote = options.internalNote ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.reason = maybeNewOrNull("ProjectStatusChangeReason", options.reason, cache);
  o.date = options.date ?? null;
  return o;
}

factories["ProjectStatusChange"] = newProjectStatusChange;

export interface ProjectStatusChangeReasonOptions {
  __typename?: "ProjectStatusChangeReason";
  id?: ProjectStatusChangeReason["id"];
  code?: ProjectStatusChangeReason["code"];
  name?: ProjectStatusChangeReason["name"];
  projectStatus?: ProjectStatusChangeReason["projectStatus"];
  projectStatusDetail?: ProjectStatusDetailOptions | ProjectStatus;
  projectStage?: ProjectStatusChangeReason["projectStage"];
  projectStageDetail?: StageDetailOptions | Stage;
}

export function newProjectStatusChangeReason(
  options: ProjectStatusChangeReasonOptions = {},
  cache: Record<string, any> = {},
): ProjectStatusChangeReason {
  const o = (options.__typename ? options : cache["ProjectStatusChangeReason"] = {}) as ProjectStatusChangeReason;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectStatusChangeReason";
  o.id = options.id ?? nextFactoryId("ProjectStatusChangeReason");
  o.code = options.code ?? "code";
  o.name = options.name ?? "name";
  o.projectStatus = options.projectStatus ?? ProjectStatus.Active;
  o.projectStatusDetail = enumOrDetailOfProjectStatus(options.projectStatusDetail);
  o.projectStage = options.projectStage ?? Stage.PreConPlanning;
  o.projectStageDetail = enumOrDetailOfStage(options.projectStageDetail);
  return o;
}

factories["ProjectStatusChangeReason"] = newProjectStatusChangeReason;

export interface SaveProjectStatusChangeReasonsResultOptions {
  __typename?: "SaveProjectStatusChangeReasonsResult";
  projectStatusChangeReasons?: Array<ProjectStatusChangeReason | ProjectStatusChangeReasonOptions>;
  userErrors?: Array<Maybe<UserError | UserErrorOptions>>;
}

export function newSaveProjectStatusChangeReasonsResult(
  options: SaveProjectStatusChangeReasonsResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectStatusChangeReasonsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveProjectStatusChangeReasonsResult"] = {}) as SaveProjectStatusChangeReasonsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectStatusChangeReasonsResult";
  o.projectStatusChangeReasons = (options.projectStatusChangeReasons ?? []).map((i) =>
    maybeNew("ProjectStatusChangeReason", i, cache, options.hasOwnProperty("projectStatusChangeReasons"))
  );
  o.userErrors = (options.userErrors ?? []).map((i) => maybeNewOrNull("UserError", i, cache));
  return o;
}

factories["SaveProjectStatusChangeReasonsResult"] = newSaveProjectStatusChangeReasonsResult;

export interface ProjectTeamMemberOptions {
  __typename?: "ProjectTeamMember";
  user?: InternalUser | InternalUserOptions | null;
  role?: ProjectRoleDetailOptions | ProjectRole;
}

export function newProjectTeamMember(
  options: ProjectTeamMemberOptions = {},
  cache: Record<string, any> = {},
): ProjectTeamMember {
  const o = (options.__typename ? options : cache["ProjectTeamMember"] = {}) as ProjectTeamMember;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectTeamMember";
  o.user = maybeNewOrNull("InternalUser", options.user, cache);
  o.role = enumOrDetailOfProjectRole(options.role);
  return o;
}

factories["ProjectTeamMember"] = newProjectTeamMember;

export interface UpdateProjectRoleResultOptions {
  __typename?: "UpdateProjectRoleResult";
  teamMember?: ProjectTeamMember | ProjectTeamMemberOptions;
  tasks?: Array<Task | TaskOptions>;
}

export function newUpdateProjectRoleResult(
  options: UpdateProjectRoleResultOptions = {},
  cache: Record<string, any> = {},
): UpdateProjectRoleResult {
  const o = (options.__typename ? options : cache["UpdateProjectRoleResult"] = {}) as UpdateProjectRoleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UpdateProjectRoleResult";
  o.teamMember = maybeNew("ProjectTeamMember", options.teamMember, cache, options.hasOwnProperty("teamMember"));
  o.tasks = (options.tasks ?? []).map((i) => maybeNew("Task", i, cache, options.hasOwnProperty("tasks")));
  return o;
}

factories["UpdateProjectRoleResult"] = newUpdateProjectRoleResult;

export interface BulkUpdateProjectRoleResultOptions {
  __typename?: "BulkUpdateProjectRoleResult";
  teamMember?: ProjectTeamMember | ProjectTeamMemberOptions;
  tasks?: Array<Task | TaskOptions>;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
}

export function newBulkUpdateProjectRoleResult(
  options: BulkUpdateProjectRoleResultOptions = {},
  cache: Record<string, any> = {},
): BulkUpdateProjectRoleResult {
  const o = (options.__typename ? options : cache["BulkUpdateProjectRoleResult"] = {}) as BulkUpdateProjectRoleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BulkUpdateProjectRoleResult";
  o.teamMember = maybeNew("ProjectTeamMember", options.teamMember, cache, options.hasOwnProperty("teamMember"));
  o.tasks = (options.tasks ?? []).map((i) => maybeNew("Task", i, cache, options.hasOwnProperty("tasks")));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  return o;
}

factories["BulkUpdateProjectRoleResult"] = newBulkUpdateProjectRoleResult;

export interface ProjectUpdateOptions {
  __typename?: "ProjectUpdate";
  id?: ProjectUpdate["id"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  createdAt?: ProjectUpdate["createdAt"];
  eventTime?: ProjectUpdate["eventTime"];
  actionType?: ProjectUpdate["actionType"];
  actionTypeDetail?: ProjectUpdateActionTypeDetailOptions | ProjectUpdateActionType;
  schedulePhase?: SchedulePhase | SchedulePhaseOptions | null;
  document?: Document | DocumentOptions | null;
  scheduleSubPhase?: ScheduleSubPhase | ScheduleSubPhaseOptions | null;
  homeownerNote?: HomeownerNote | HomeownerNoteOptions | null;
}

export function newProjectUpdate(options: ProjectUpdateOptions = {}, cache: Record<string, any> = {}): ProjectUpdate {
  const o = (options.__typename ? options : cache["ProjectUpdate"] = {}) as ProjectUpdate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectUpdate";
  o.id = options.id ?? nextFactoryId("ProjectUpdate");
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.eventTime = options.eventTime ?? newDateTime();
  o.actionType = options.actionType ?? ProjectUpdateActionType.ActivityComplete;
  o.actionTypeDetail = enumOrDetailOfProjectUpdateActionType(options.actionTypeDetail);
  o.schedulePhase = maybeNewOrNull("SchedulePhase", options.schedulePhase, cache);
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.scheduleSubPhase = maybeNewOrNull("ScheduleSubPhase", options.scheduleSubPhase, cache);
  o.homeownerNote = maybeNewOrNull("HomeownerNote", options.homeownerNote, cache);
  return o;
}

factories["ProjectUpdate"] = newProjectUpdate;

export interface SavePunchlistItemTodosResultOptions {
  __typename?: "SavePunchlistItemTodosResult";
  punchlistItemTodos?: Array<PunchlistItemTodo | PunchlistItemTodoOptions>;
}

export function newSavePunchlistItemTodosResult(
  options: SavePunchlistItemTodosResultOptions = {},
  cache: Record<string, any> = {},
): SavePunchlistItemTodosResult {
  const o = (options.__typename ? options : cache["SavePunchlistItemTodosResult"] = {}) as SavePunchlistItemTodosResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePunchlistItemTodosResult";
  o.punchlistItemTodos = (options.punchlistItemTodos ?? []).map((i) =>
    maybeNew("PunchlistItemTodo", i, cache, options.hasOwnProperty("punchlistItemTodos"))
  );
  return o;
}

factories["SavePunchlistItemTodosResult"] = newSavePunchlistItemTodosResult;

export interface SavePunchlistItemTodoResultOptions {
  __typename?: "SavePunchlistItemTodoResult";
  punchlistItemTodo?: PunchlistItemTodo | PunchlistItemTodoOptions;
}

export function newSavePunchlistItemTodoResult(
  options: SavePunchlistItemTodoResultOptions = {},
  cache: Record<string, any> = {},
): SavePunchlistItemTodoResult {
  const o = (options.__typename ? options : cache["SavePunchlistItemTodoResult"] = {}) as SavePunchlistItemTodoResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePunchlistItemTodoResult";
  o.punchlistItemTodo = maybeNew(
    "PunchlistItemTodo",
    options.punchlistItemTodo,
    cache,
    options.hasOwnProperty("punchlistItemTodo"),
  );
  return o;
}

factories["SavePunchlistItemTodoResult"] = newSavePunchlistItemTodoResult;

export interface SendTradePartnerPunchlistEmailResultsOptions {
  __typename?: "SendTradePartnerPunchlistEmailResults";
  results?:
    | Array<
      | SendTradePartnerPunchlistEmailResult
      | SendTradePartnerPunchlistEmailSuccessOptions
      | RequireTypename<SendTradePartnerPunchlistEmailFailureOptions>
    >
    | null;
}

export function newSendTradePartnerPunchlistEmailResults(
  options: SendTradePartnerPunchlistEmailResultsOptions = {},
  cache: Record<string, any> = {},
): SendTradePartnerPunchlistEmailResults {
  const o =
    (options.__typename
      ? options
      : cache["SendTradePartnerPunchlistEmailResults"] = {}) as SendTradePartnerPunchlistEmailResults;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SendTradePartnerPunchlistEmailResults";
  o.results = (options.results ?? []).map((i) =>
    maybeNew(i?.__typename ?? "{SendTradePartnerPunchlistEmailSuccess", i, cache, options.hasOwnProperty("results"))
  );
  return o;
}

factories["SendTradePartnerPunchlistEmailResults"] = newSendTradePartnerPunchlistEmailResults;

export interface SendTradePartnerPunchlistEmailSuccessOptions {
  __typename?: "SendTradePartnerPunchlistEmailSuccess";
  punchlistItemTodo?: PunchlistItemTodo | PunchlistItemTodoOptions;
  emails?: SendTradePartnerPunchlistEmailSuccess["emails"];
}

export function newSendTradePartnerPunchlistEmailSuccess(
  options: SendTradePartnerPunchlistEmailSuccessOptions = {},
  cache: Record<string, any> = {},
): SendTradePartnerPunchlistEmailSuccess {
  const o =
    (options.__typename
      ? options
      : cache["SendTradePartnerPunchlistEmailSuccess"] = {}) as SendTradePartnerPunchlistEmailSuccess;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SendTradePartnerPunchlistEmailSuccess";
  o.punchlistItemTodo = maybeNew(
    "PunchlistItemTodo",
    options.punchlistItemTodo,
    cache,
    options.hasOwnProperty("punchlistItemTodo"),
  );
  o.emails = options.emails ?? [];
  return o;
}

factories["SendTradePartnerPunchlistEmailSuccess"] = newSendTradePartnerPunchlistEmailSuccess;

export interface SendTradePartnerPunchlistEmailFailureOptions {
  __typename?: "SendTradePartnerPunchlistEmailFailure";
  punchlistItemTodoId?: SendTradePartnerPunchlistEmailFailure["punchlistItemTodoId"];
  error?: SendTradePartnerPunchlistEmailFailure["error"];
}

export function newSendTradePartnerPunchlistEmailFailure(
  options: SendTradePartnerPunchlistEmailFailureOptions = {},
  cache: Record<string, any> = {},
): SendTradePartnerPunchlistEmailFailure {
  const o =
    (options.__typename
      ? options
      : cache["SendTradePartnerPunchlistEmailFailure"] = {}) as SendTradePartnerPunchlistEmailFailure;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SendTradePartnerPunchlistEmailFailure";
  o.punchlistItemTodoId = options.punchlistItemTodoId ?? "punchlistItemTodoId";
  o.error = options.error ?? "error";
  return o;
}

factories["SendTradePartnerPunchlistEmailFailure"] = newSendTradePartnerPunchlistEmailFailure;

export interface SendPunchlistExportEmailResultsOptions {
  __typename?: "SendPunchlistExportEmailResults";
  results?:
    | Array<
      | SendPunchlistExportEmailResult
      | SendPunchlistExportEmailSuccessOptions
      | RequireTypename<SendPunchlistExportEmailFailureOptions>
    >
    | null;
}

export function newSendPunchlistExportEmailResults(
  options: SendPunchlistExportEmailResultsOptions = {},
  cache: Record<string, any> = {},
): SendPunchlistExportEmailResults {
  const o =
    (options.__typename ? options : cache["SendPunchlistExportEmailResults"] = {}) as SendPunchlistExportEmailResults;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SendPunchlistExportEmailResults";
  o.results = (options.results ?? []).map((i) =>
    maybeNew(i?.__typename ?? "{SendPunchlistExportEmailSuccess", i, cache, options.hasOwnProperty("results"))
  );
  return o;
}

factories["SendPunchlistExportEmailResults"] = newSendPunchlistExportEmailResults;

export interface SendPunchlistExportEmailSuccessOptions {
  __typename?: "SendPunchlistExportEmailSuccess";
  punchlistItemTodo?: PunchlistItemTodo | PunchlistItemTodoOptions;
}

export function newSendPunchlistExportEmailSuccess(
  options: SendPunchlistExportEmailSuccessOptions = {},
  cache: Record<string, any> = {},
): SendPunchlistExportEmailSuccess {
  const o =
    (options.__typename ? options : cache["SendPunchlistExportEmailSuccess"] = {}) as SendPunchlistExportEmailSuccess;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SendPunchlistExportEmailSuccess";
  o.punchlistItemTodo = maybeNew(
    "PunchlistItemTodo",
    options.punchlistItemTodo,
    cache,
    options.hasOwnProperty("punchlistItemTodo"),
  );
  return o;
}

factories["SendPunchlistExportEmailSuccess"] = newSendPunchlistExportEmailSuccess;

export interface SendPunchlistExportEmailFailureOptions {
  __typename?: "SendPunchlistExportEmailFailure";
  punchlistItemTodoId?: SendPunchlistExportEmailFailure["punchlistItemTodoId"];
  error?: SendPunchlistExportEmailFailure["error"];
}

export function newSendPunchlistExportEmailFailure(
  options: SendPunchlistExportEmailFailureOptions = {},
  cache: Record<string, any> = {},
): SendPunchlistExportEmailFailure {
  const o =
    (options.__typename ? options : cache["SendPunchlistExportEmailFailure"] = {}) as SendPunchlistExportEmailFailure;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SendPunchlistExportEmailFailure";
  o.punchlistItemTodoId = options.punchlistItemTodoId ?? "punchlistItemTodoId";
  o.error = options.error ?? "error";
  return o;
}

factories["SendPunchlistExportEmailFailure"] = newSendPunchlistExportEmailFailure;

export interface RegisterPushNotificationTokenResultOptions {
  __typename?: "RegisterPushNotificationTokenResult";
  pushNotificationToken?: PushNotificationToken | PushNotificationTokenOptions;
}

export function newRegisterPushNotificationTokenResult(
  options: RegisterPushNotificationTokenResultOptions = {},
  cache: Record<string, any> = {},
): RegisterPushNotificationTokenResult {
  const o =
    (options.__typename
      ? options
      : cache["RegisterPushNotificationTokenResult"] = {}) as RegisterPushNotificationTokenResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "RegisterPushNotificationTokenResult";
  o.pushNotificationToken = maybeNew(
    "PushNotificationToken",
    options.pushNotificationToken,
    cache,
    options.hasOwnProperty("pushNotificationToken"),
  );
  return o;
}

factories["RegisterPushNotificationTokenResult"] = newRegisterPushNotificationTokenResult;

export interface PushNotificationTokenOptions {
  __typename?: "PushNotificationToken";
  id?: PushNotificationToken["id"];
  token?: PushNotificationToken["token"];
  lastSeenAt?: PushNotificationToken["lastSeenAt"];
  createdAt?: PushNotificationToken["createdAt"];
  updatedAt?: PushNotificationToken["updatedAt"];
  platform?: PushNotificationPlatformDetailOptions | PushNotificationPlatform;
  user?: User | UserOptions;
  environment?: PushNotificationEnvironmentDetailOptions | PushNotificationEnvironment;
  snsEndpointArn?: PushNotificationToken["snsEndpointArn"];
}

export function newPushNotificationToken(
  options: PushNotificationTokenOptions = {},
  cache: Record<string, any> = {},
): PushNotificationToken {
  const o = (options.__typename ? options : cache["PushNotificationToken"] = {}) as PushNotificationToken;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PushNotificationToken";
  o.id = options.id ?? nextFactoryId("PushNotificationToken");
  o.token = options.token ?? "token";
  o.lastSeenAt = options.lastSeenAt ?? newDateTime();
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.platform = enumOrDetailOfPushNotificationPlatform(options.platform);
  o.user = maybeNew("User", options.user, cache, options.hasOwnProperty("user"));
  o.environment = enumOrDetailOfPushNotificationEnvironment(options.environment);
  o.snsEndpointArn = options.snsEndpointArn ?? null;
  return o;
}

factories["PushNotificationToken"] = newPushNotificationToken;

export interface TriggerQaDatabaseResetResultOptions {
  __typename?: "TriggerQaDatabaseResetResult";
  triggered?: TriggerQaDatabaseResetResult["triggered"];
  message?: TriggerQaDatabaseResetResult["message"];
}

export function newTriggerQaDatabaseResetResult(
  options: TriggerQaDatabaseResetResultOptions = {},
  cache: Record<string, any> = {},
): TriggerQaDatabaseResetResult {
  const o = (options.__typename ? options : cache["TriggerQaDatabaseResetResult"] = {}) as TriggerQaDatabaseResetResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TriggerQaDatabaseResetResult";
  o.triggered = options.triggered ?? false;
  o.message = options.message ?? "message";
  return o;
}

factories["TriggerQaDatabaseResetResult"] = newTriggerQaDatabaseResetResult;

export interface SaveReadyPlansResultOptions {
  __typename?: "SaveReadyPlansResult";
  readyPlans?: Array<ReadyPlan | ReadyPlanOptions>;
}

export function newSaveReadyPlansResult(
  options: SaveReadyPlansResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlansResult {
  const o = (options.__typename ? options : cache["SaveReadyPlansResult"] = {}) as SaveReadyPlansResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlansResult";
  o.readyPlans = (options.readyPlans ?? []).map((i) =>
    maybeNew("ReadyPlan", i, cache, options.hasOwnProperty("readyPlans"))
  );
  return o;
}

factories["SaveReadyPlansResult"] = newSaveReadyPlansResult;

export interface SaveReadyPlanResultOptions {
  __typename?: "SaveReadyPlanResult";
  readyPlan?: ReadyPlan | ReadyPlanOptions;
}

export function newSaveReadyPlanResult(
  options: SaveReadyPlanResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlanResult {
  const o = (options.__typename ? options : cache["SaveReadyPlanResult"] = {}) as SaveReadyPlanResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlanResult";
  o.readyPlan = maybeNew("ReadyPlan", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  return o;
}

factories["SaveReadyPlanResult"] = newSaveReadyPlanResult;

export interface ComputeReadyPlanCostResultOptions {
  __typename?: "ComputeReadyPlanCostResult";
  readyPlan?: ReadyPlan | ReadyPlanOptions;
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  includedOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  totalCostInCents?: ComputeReadyPlanCostResult["totalCostInCents"];
  softCostInCents?: ComputeReadyPlanCostResult["softCostInCents"];
  directHardCostInCents?: ComputeReadyPlanCostResult["directHardCostInCents"];
  indirectHardCostInCents?: ComputeReadyPlanCostResult["indirectHardCostInCents"];
  contingencyCostInCents?: ComputeReadyPlanCostResult["contingencyCostInCents"];
  contingencyComputed?: ComputeReadyPlanCostResult["contingencyComputed"];
  deltas?: Array<ReadyPlanOptionCostDelta | ReadyPlanOptionCostDeltaOptions>;
  protoProjectItems?: Array<ProtoProjectItem | ProtoProjectItemOptions>;
  configurationErrors?: ComputeReadyPlanCostResult["configurationErrors"];
}

export function newComputeReadyPlanCostResult(
  options: ComputeReadyPlanCostResultOptions = {},
  cache: Record<string, any> = {},
): ComputeReadyPlanCostResult {
  const o = (options.__typename ? options : cache["ComputeReadyPlanCostResult"] = {}) as ComputeReadyPlanCostResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ComputeReadyPlanCostResult";
  o.readyPlan = maybeNew("ReadyPlan", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  o.includedOptions = (options.includedOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("includedOptions"))
  );
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.softCostInCents = options.softCostInCents ?? 0;
  o.directHardCostInCents = options.directHardCostInCents ?? 0;
  o.indirectHardCostInCents = options.indirectHardCostInCents ?? 0;
  o.contingencyCostInCents = options.contingencyCostInCents ?? 0;
  o.contingencyComputed = options.contingencyComputed ?? false;
  o.deltas = (options.deltas ?? []).map((i) =>
    maybeNew("ReadyPlanOptionCostDelta", i, cache, options.hasOwnProperty("deltas"))
  );
  o.protoProjectItems = (options.protoProjectItems ?? []).map((i) =>
    maybeNew("ProtoProjectItem", i, cache, options.hasOwnProperty("protoProjectItems"))
  );
  o.configurationErrors = options.configurationErrors ?? [];
  return o;
}

factories["ComputeReadyPlanCostResult"] = newComputeReadyPlanCostResult;

export interface ReadyPlanOptionCostDeltaOptions {
  __typename?: "ReadyPlanOptionCostDelta";
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions;
  totalCostInCents?: ReadyPlanOptionCostDelta["totalCostInCents"];
  softCostInCents?: ReadyPlanOptionCostDelta["softCostInCents"];
  directHardCostInCents?: ReadyPlanOptionCostDelta["directHardCostInCents"];
  indirectHardCostInCents?: ReadyPlanOptionCostDelta["indirectHardCostInCents"];
  contingencyCostInCents?: ReadyPlanOptionCostDelta["contingencyCostInCents"];
  contingencyComputed?: ReadyPlanOptionCostDelta["contingencyComputed"];
}

export function newReadyPlanOptionCostDelta(
  options: ReadyPlanOptionCostDeltaOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOptionCostDelta {
  const o = (options.__typename ? options : cache["ReadyPlanOptionCostDelta"] = {}) as ReadyPlanOptionCostDelta;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOptionCostDelta";
  o.readyPlanOption = maybeNew(
    "ReadyPlanOption",
    options.readyPlanOption,
    cache,
    options.hasOwnProperty("readyPlanOption"),
  );
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.softCostInCents = options.softCostInCents ?? 0;
  o.directHardCostInCents = options.directHardCostInCents ?? 0;
  o.indirectHardCostInCents = options.indirectHardCostInCents ?? 0;
  o.contingencyCostInCents = options.contingencyCostInCents ?? 0;
  o.contingencyComputed = options.contingencyComputed ?? false;
  return o;
}

factories["ReadyPlanOptionCostDelta"] = newReadyPlanOptionCostDelta;

export interface ProtoProjectItemOptions {
  __typename?: "ProtoProjectItem";
  name?: ProtoProjectItem["name"];
  specifications?: ProtoProjectItem["specifications"];
  tradePartnerNote?: ProtoProjectItem["tradePartnerNote"];
  slot?: ItemSlot | ItemSlotOptions;
  item?: Item | ItemOptions;
  quantity?: ProtoProjectItem["quantity"];
  totalPriceInCents?: ProtoProjectItem["totalPriceInCents"];
  totalCostInCents?: ProtoProjectItem["totalCostInCents"];
  location?: Location | LocationOptions;
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  costType?: ProtoProjectItem["costType"];
  preferredPotentialBidContractLineItem?: PotentialBidContractLineItem | PotentialBidContractLineItemOptions | null;
  itemTemplateItem?:
    | ItemTemplateItemVersion
    | ItemTemplateItem
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | BaseItemLike
    | BaseItemLikeOptions
    | null;
  modifyingTemplateItems?: Array<
    | ItemTemplateItemVersion
    | ItemTemplateItem
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | BaseItemLike
    | BaseItemLikeOptions
  >;
  bidItem?: BidItem | BidItemOptions | null;
}

export function newProtoProjectItem(
  options: ProtoProjectItemOptions = {},
  cache: Record<string, any> = {},
): ProtoProjectItem {
  const o = (options.__typename ? options : cache["ProtoProjectItem"] = {}) as ProtoProjectItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProtoProjectItem";
  o.name = options.name ?? "name";
  o.specifications = options.specifications ?? null;
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.quantity = options.quantity ?? null;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.costType = options.costType ?? CostType.Labor;
  o.preferredPotentialBidContractLineItem = maybeNewOrNull(
    "PotentialBidContractLineItem",
    options.preferredPotentialBidContractLineItem,
    cache,
  );
  o.itemTemplateItem = maybeNewOrNull("BaseItemLike", options.itemTemplateItem, cache);
  o.modifyingTemplateItems = (options.modifyingTemplateItems ?? []).map((i) =>
    maybeNew("BaseItemLike", i, cache, options.hasOwnProperty("modifyingTemplateItems"))
  );
  o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
  return o;
}

factories["ProtoProjectItem"] = newProtoProjectItem;

export interface ScopeGlobalOptionGroupsToReadyPlansResultOptions {
  __typename?: "ScopeGlobalOptionGroupsToReadyPlansResult";
  globalOptionGroups?: Array<GlobalOptionGroup | GlobalOptionGroupOptions>;
}

export function newScopeGlobalOptionGroupsToReadyPlansResult(
  options: ScopeGlobalOptionGroupsToReadyPlansResultOptions = {},
  cache: Record<string, any> = {},
): ScopeGlobalOptionGroupsToReadyPlansResult {
  const o =
    (options.__typename
      ? options
      : cache["ScopeGlobalOptionGroupsToReadyPlansResult"] = {}) as ScopeGlobalOptionGroupsToReadyPlansResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScopeGlobalOptionGroupsToReadyPlansResult";
  o.globalOptionGroups = (options.globalOptionGroups ?? []).map((i) =>
    maybeNew("GlobalOptionGroup", i, cache, options.hasOwnProperty("globalOptionGroups"))
  );
  return o;
}

factories["ScopeGlobalOptionGroupsToReadyPlansResult"] = newScopeGlobalOptionGroupsToReadyPlansResult;

export interface GenerateReadyPlanVersionNotesResultOptions {
  __typename?: "GenerateReadyPlanVersionNotesResult";
  notes?: GenerateReadyPlanVersionNotesResult["notes"];
}

export function newGenerateReadyPlanVersionNotesResult(
  options: GenerateReadyPlanVersionNotesResultOptions = {},
  cache: Record<string, any> = {},
): GenerateReadyPlanVersionNotesResult {
  const o =
    (options.__typename
      ? options
      : cache["GenerateReadyPlanVersionNotesResult"] = {}) as GenerateReadyPlanVersionNotesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GenerateReadyPlanVersionNotesResult";
  o.notes = options.notes ?? "notes";
  return o;
}

factories["GenerateReadyPlanVersionNotesResult"] = newGenerateReadyPlanVersionNotesResult;

export interface ReadyPlanAggregateVersionOptions {
  __typename?: "ReadyPlanAggregateVersion";
  id?: ReadyPlanAggregateVersion["id"];
  version?: ReadyPlanAggregateVersion["version"];
  name?: ReadyPlanAggregateVersion["name"];
  displayName?: ReadyPlanAggregateVersion["displayName"];
  displayVersion?: ReadyPlanAggregateVersion["displayVersion"];
  createdAt?: ReadyPlanAggregateVersion["createdAt"];
  updatedAt?: ReadyPlanAggregateVersion["updatedAt"];
  status?: AggregateVersionStatusDetailOptions | AggregateVersionStatus;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  optionGroupVersions?: Array<ReadyPlanOptionGroupVersion | ReadyPlanOptionGroupVersionOptions>;
  optionVersions?: Array<ReadyPlanOptionVersion | ReadyPlanOptionVersionOptions>;
  finalReadyPlanOptionVersions?: Array<ReadyPlanOptionVersion | ReadyPlanOptionVersionOptions>;
  versions?: Array<ReadyPlanVersion | ReadyPlanVersionOptions>;
  removedTliVersions?: Array<TakeoffLineItemVersion | TakeoffLineItemVersionOptions>;
  tliVersions?: Array<TakeoffLineItemVersion | TakeoffLineItemVersionOptions>;
  versionNotes?: ReadyPlanAggregateVersion["versionNotes"];
  designPackagePlanUpdates?: Array<DesignPackagePlanUpdate | DesignPackagePlanUpdateOptions>;
  productOfferingIncomingUpdates?: Array<ProductOfferingIncomingUpdate | ProductOfferingIncomingUpdateOptions>;
  programDataVersions?: Array<ReadyPlanProgramDataVersion | ReadyPlanProgramDataVersionOptions>;
  removedProgramDataVersions?: Array<ReadyPlanProgramDataVersion | ReadyPlanProgramDataVersionOptions>;
  assetVersions?: Array<ReadyPlanAssetVersion | ReadyPlanAssetVersionOptions>;
  designPackageSourceVersions?: Array<DesignPackageSourceVersion | DesignPackageSourceVersionOptions>;
  tliVersionsCount?: ReadyPlanAggregateVersion["tliVersionsCount"];
  tlivChangeSummary?: Array<TlivChangeSummary | TlivChangeSummaryOptions>;
  productTlivChangeSummary?: Array<TlivChangeSummary | TlivChangeSummaryOptions>;
  rplVersions?: Array<ReadyPlanLocationVersion | ReadyPlanLocationVersionOptions>;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  canPublish?: PotentialOperation2 | PotentialOperation2Options;
  canPromote?: PotentialOperation2 | PotentialOperation2Options;
  acceptedDesignPackageUpdates?: Array<DesignPackagePlanUpdate | DesignPackagePlanUpdateOptions>;
  outgoingDesignPackageUpdates?: Array<DesignPackagePlanUpdate | DesignPackagePlanUpdateOptions>;
  incomingSlotsFulfilledByPublish?: Array<PlanPackageIncomingSlot | PlanPackageIncomingSlotOptions>;
  publishedAt?: ReadyPlanAggregateVersion["publishedAt"];
  finalReadyPlanRequiredOptionVersions?: Array<ReadyPlanRequiredOptionVersion | ReadyPlanRequiredOptionVersionOptions>;
  requiredOptionVersions?: Array<ReadyPlanRequiredOptionVersion | ReadyPlanRequiredOptionVersionOptions>;
  designNoteVersions?: Array<ReadyPlanDesignNoteVersion | ReadyPlanDesignNoteVersionOptions>;
  designPackageSources?: Array<DesignPackageSource | DesignPackageSourceOptions>;
  promotedAt?: ReadyPlanAggregateVersion["promotedAt"];
  promotedBy?: User | UserOptions | null;
  createdByPromotion?: ReadyPlanAggregateVersion["createdByPromotion"];
}

export function newReadyPlanAggregateVersion(
  options: ReadyPlanAggregateVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanAggregateVersion {
  const o = (options.__typename ? options : cache["ReadyPlanAggregateVersion"] = {}) as ReadyPlanAggregateVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanAggregateVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanAggregateVersion");
  o.version = options.version ?? null;
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.displayVersion = options.displayVersion ?? "displayVersion";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = enumOrDetailOfAggregateVersionStatus(options.status);
  o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.optionGroupVersions = (options.optionGroupVersions ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroupVersion", i, cache, options.hasOwnProperty("optionGroupVersions"))
  );
  o.optionVersions = (options.optionVersions ?? []).map((i) =>
    maybeNew("ReadyPlanOptionVersion", i, cache, options.hasOwnProperty("optionVersions"))
  );
  o.finalReadyPlanOptionVersions = (options.finalReadyPlanOptionVersions ?? []).map((i) =>
    maybeNew("ReadyPlanOptionVersion", i, cache, options.hasOwnProperty("finalReadyPlanOptionVersions"))
  );
  o.versions = (options.versions ?? []).map((i) =>
    maybeNew("ReadyPlanVersion", i, cache, options.hasOwnProperty("versions"))
  );
  o.removedTliVersions = (options.removedTliVersions ?? []).map((i) =>
    maybeNew("TakeoffLineItemVersion", i, cache, options.hasOwnProperty("removedTliVersions"))
  );
  o.tliVersions = (options.tliVersions ?? []).map((i) =>
    maybeNew("TakeoffLineItemVersion", i, cache, options.hasOwnProperty("tliVersions"))
  );
  o.versionNotes = options.versionNotes ?? null;
  o.designPackagePlanUpdates = (options.designPackagePlanUpdates ?? []).map((i) =>
    maybeNew("DesignPackagePlanUpdate", i, cache, options.hasOwnProperty("designPackagePlanUpdates"))
  );
  o.productOfferingIncomingUpdates = (options.productOfferingIncomingUpdates ?? []).map((i) =>
    maybeNew("ProductOfferingIncomingUpdate", i, cache, options.hasOwnProperty("productOfferingIncomingUpdates"))
  );
  o.programDataVersions = (options.programDataVersions ?? []).map((i) =>
    maybeNew("ReadyPlanProgramDataVersion", i, cache, options.hasOwnProperty("programDataVersions"))
  );
  o.removedProgramDataVersions = (options.removedProgramDataVersions ?? []).map((i) =>
    maybeNew("ReadyPlanProgramDataVersion", i, cache, options.hasOwnProperty("removedProgramDataVersions"))
  );
  o.assetVersions = (options.assetVersions ?? []).map((i) =>
    maybeNew("ReadyPlanAssetVersion", i, cache, options.hasOwnProperty("assetVersions"))
  );
  o.designPackageSourceVersions = (options.designPackageSourceVersions ?? []).map((i) =>
    maybeNew("DesignPackageSourceVersion", i, cache, options.hasOwnProperty("designPackageSourceVersions"))
  );
  o.tliVersionsCount = options.tliVersionsCount ?? 0;
  o.tlivChangeSummary = (options.tlivChangeSummary ?? []).map((i) =>
    maybeNew("TlivChangeSummary", i, cache, options.hasOwnProperty("tlivChangeSummary"))
  );
  o.productTlivChangeSummary = (options.productTlivChangeSummary ?? []).map((i) =>
    maybeNew("TlivChangeSummary", i, cache, options.hasOwnProperty("productTlivChangeSummary"))
  );
  o.rplVersions = (options.rplVersions ?? []).map((i) =>
    maybeNew("ReadyPlanLocationVersion", i, cache, options.hasOwnProperty("rplVersions"))
  );
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.canPublish = maybeNew("PotentialOperation2", options.canPublish, cache, options.hasOwnProperty("canPublish"));
  o.canPromote = maybeNew("PotentialOperation2", options.canPromote, cache, options.hasOwnProperty("canPromote"));
  o.acceptedDesignPackageUpdates = (options.acceptedDesignPackageUpdates ?? []).map((i) =>
    maybeNew("DesignPackagePlanUpdate", i, cache, options.hasOwnProperty("acceptedDesignPackageUpdates"))
  );
  o.outgoingDesignPackageUpdates = (options.outgoingDesignPackageUpdates ?? []).map((i) =>
    maybeNew("DesignPackagePlanUpdate", i, cache, options.hasOwnProperty("outgoingDesignPackageUpdates"))
  );
  o.incomingSlotsFulfilledByPublish = (options.incomingSlotsFulfilledByPublish ?? []).map((i) =>
    maybeNew("PlanPackageIncomingSlot", i, cache, options.hasOwnProperty("incomingSlotsFulfilledByPublish"))
  );
  o.publishedAt = options.publishedAt ?? null;
  o.finalReadyPlanRequiredOptionVersions = (options.finalReadyPlanRequiredOptionVersions ?? []).map((i) =>
    maybeNew("ReadyPlanRequiredOptionVersion", i, cache, options.hasOwnProperty("finalReadyPlanRequiredOptionVersions"))
  );
  o.requiredOptionVersions = (options.requiredOptionVersions ?? []).map((i) =>
    maybeNew("ReadyPlanRequiredOptionVersion", i, cache, options.hasOwnProperty("requiredOptionVersions"))
  );
  o.designNoteVersions = (options.designNoteVersions ?? []).map((i) =>
    maybeNew("ReadyPlanDesignNoteVersion", i, cache, options.hasOwnProperty("designNoteVersions"))
  );
  o.designPackageSources = (options.designPackageSources ?? []).map((i) =>
    maybeNew("DesignPackageSource", i, cache, options.hasOwnProperty("designPackageSources"))
  );
  o.promotedAt = options.promotedAt ?? null;
  o.promotedBy = maybeNewOrNull("User", options.promotedBy, cache);
  o.createdByPromotion = options.createdByPromotion ?? false;
  return o;
}

factories["ReadyPlanAggregateVersion"] = newReadyPlanAggregateVersion;

export interface TlivChangeSummaryOptions {
  __typename?: "TlivChangeSummary";
  changeType?: TlivChangeSummary["changeType"];
  total?: TlivChangeSummary["total"];
  byLocation?: Array<TlivLocationCount | TlivLocationCountOptions>;
}

export function newTlivChangeSummary(
  options: TlivChangeSummaryOptions = {},
  cache: Record<string, any> = {},
): TlivChangeSummary {
  const o = (options.__typename ? options : cache["TlivChangeSummary"] = {}) as TlivChangeSummary;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TlivChangeSummary";
  o.changeType = options.changeType ?? "changeType";
  o.total = options.total ?? 0;
  o.byLocation = (options.byLocation ?? []).map((i) =>
    maybeNew("TlivLocationCount", i, cache, options.hasOwnProperty("byLocation"))
  );
  return o;
}

factories["TlivChangeSummary"] = newTlivChangeSummary;

export interface TlivLocationCountOptions {
  __typename?: "TlivLocationCount";
  location?: Location | LocationOptions;
  count?: TlivLocationCount["count"];
}

export function newTlivLocationCount(
  options: TlivLocationCountOptions = {},
  cache: Record<string, any> = {},
): TlivLocationCount {
  const o = (options.__typename ? options : cache["TlivLocationCount"] = {}) as TlivLocationCount;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TlivLocationCount";
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.count = options.count ?? 0;
  return o;
}

factories["TlivLocationCount"] = newTlivLocationCount;

export interface SaveReadyPlanAggregateVersionResultOptions {
  __typename?: "SaveReadyPlanAggregateVersionResult";
  readyPlanAggregateVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
}

export function newSaveReadyPlanAggregateVersionResult(
  options: SaveReadyPlanAggregateVersionResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlanAggregateVersionResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveReadyPlanAggregateVersionResult"] = {}) as SaveReadyPlanAggregateVersionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlanAggregateVersionResult";
  o.readyPlanAggregateVersion = maybeNew(
    "ReadyPlanAggregateVersion",
    options.readyPlanAggregateVersion,
    cache,
    options.hasOwnProperty("readyPlanAggregateVersion"),
  );
  return o;
}

factories["SaveReadyPlanAggregateVersionResult"] = newSaveReadyPlanAggregateVersionResult;

export interface DeleteReadyPlanAggregateVersionResultOptions {
  __typename?: "DeleteReadyPlanAggregateVersionResult";
  latestReadyPlanAggregateVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
}

export function newDeleteReadyPlanAggregateVersionResult(
  options: DeleteReadyPlanAggregateVersionResultOptions = {},
  cache: Record<string, any> = {},
): DeleteReadyPlanAggregateVersionResult {
  const o =
    (options.__typename
      ? options
      : cache["DeleteReadyPlanAggregateVersionResult"] = {}) as DeleteReadyPlanAggregateVersionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteReadyPlanAggregateVersionResult";
  o.latestReadyPlanAggregateVersion = maybeNewOrNull(
    "ReadyPlanAggregateVersion",
    options.latestReadyPlanAggregateVersion,
    cache,
  );
  return o;
}

factories["DeleteReadyPlanAggregateVersionResult"] = newDeleteReadyPlanAggregateVersionResult;

export interface ReadyPlanAggregateVersionsPageResultOptions {
  __typename?: "ReadyPlanAggregateVersionsPageResult";
  entities?: Array<ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newReadyPlanAggregateVersionsPageResult(
  options: ReadyPlanAggregateVersionsPageResultOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanAggregateVersionsPageResult {
  const o =
    (options.__typename
      ? options
      : cache["ReadyPlanAggregateVersionsPageResult"] = {}) as ReadyPlanAggregateVersionsPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanAggregateVersionsPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("ReadyPlanAggregateVersion", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ReadyPlanAggregateVersionsPageResult"] = newReadyPlanAggregateVersionsPageResult;

export interface ReadyPlanAssetOptions {
  __typename?: "ReadyPlanAsset";
  id?: ReadyPlanAsset["id"];
  createdAt?: ReadyPlanAsset["createdAt"];
  updatedAt?: ReadyPlanAsset["updatedAt"];
  type?: ReadyPlanAssetTypeDetailOptions | ReadyPlanAssetType;
  asset?: Asset | AssetOptions;
  parent?:
    | ReadyPlanAssetParent
    | ReadyPlanOptions
    | RequireTypename<ReadyPlanLocationOptions>
    | RequireTypename<ReadyPlanOptionOptions>
    | RequireTypename<PlanPackageOptions>
    | RequireTypename<DesignPackageOptions>
    | RequireTypename<ProductOfferingOptions>
    | null;
  isCoverPhoto?: ReadyPlanAsset["isCoverPhoto"];
  versions?: Array<ReadyPlanAssetVersion | ReadyPlanAssetVersionOptions>;
  active?: ReadyPlanAsset["active"];
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
}

export function newReadyPlanAsset(
  options: ReadyPlanAssetOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanAsset {
  const o = (options.__typename ? options : cache["ReadyPlanAsset"] = {}) as ReadyPlanAsset;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanAsset";
  o.id = options.id ?? nextFactoryId("ReadyPlanAsset");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.type = enumOrDetailOfReadyPlanAssetType(options.type);
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "ReadyPlan", options.parent, cache);
  o.isCoverPhoto = options.isCoverPhoto ?? false;
  o.versions = (options.versions ?? []).map((i) =>
    maybeNew("ReadyPlanAssetVersion", i, cache, options.hasOwnProperty("versions"))
  );
  o.active = options.active ?? false;
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  return o;
}

factories["ReadyPlanAsset"] = newReadyPlanAsset;

export interface ReadyPlanAssetVersionOptions {
  __typename?: "ReadyPlanAssetVersion";
  id?: ReadyPlanAssetVersion["id"];
  active?: ReadyPlanAssetVersion["active"];
  createdAt?: ReadyPlanAssetVersion["createdAt"];
  updatedAt?: ReadyPlanAssetVersion["updatedAt"];
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  identity?: ReadyPlanAsset | ReadyPlanAssetOptions;
  asset?: Asset | AssetOptions;
}

export function newReadyPlanAssetVersion(
  options: ReadyPlanAssetVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanAssetVersion {
  const o = (options.__typename ? options : cache["ReadyPlanAssetVersion"] = {}) as ReadyPlanAssetVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanAssetVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanAssetVersion");
  o.active = options.active ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.identity = maybeNew("ReadyPlanAsset", options.identity, cache, options.hasOwnProperty("identity"));
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  return o;
}

factories["ReadyPlanAssetVersion"] = newReadyPlanAssetVersion;

export interface ReadyPlanDesignNoteOptions {
  __typename?: "ReadyPlanDesignNote";
  id?: ReadyPlanDesignNote["id"];
  active?: ReadyPlanDesignNote["active"];
  content?: ReadyPlanDesignNote["content"];
  createdAt?: ReadyPlanDesignNote["createdAt"];
  updatedAt?: ReadyPlanDesignNote["updatedAt"];
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  takeoffLineItem?: TakeoffLineItem | TakeoffLineItemOptions;
  targetGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  targetCombinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
}

export function newReadyPlanDesignNote(
  options: ReadyPlanDesignNoteOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanDesignNote {
  const o = (options.__typename ? options : cache["ReadyPlanDesignNote"] = {}) as ReadyPlanDesignNote;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanDesignNote";
  o.id = options.id ?? nextFactoryId("ReadyPlanDesignNote");
  o.active = options.active ?? false;
  o.content = options.content ?? "content";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.takeoffLineItem = maybeNew(
    "TakeoffLineItem",
    options.takeoffLineItem,
    cache,
    options.hasOwnProperty("takeoffLineItem"),
  );
  o.targetGroups = (options.targetGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("targetGroups"))
  );
  o.targetCombinations = (options.targetCombinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("targetCombinations"))
  );
  return o;
}

factories["ReadyPlanDesignNote"] = newReadyPlanDesignNote;

export interface SaveReadyPlanDesignNoteResultOptions {
  __typename?: "SaveReadyPlanDesignNoteResult";
  readyPlanDesignNote?: ReadyPlanDesignNote | ReadyPlanDesignNoteOptions;
}

export function newSaveReadyPlanDesignNoteResult(
  options: SaveReadyPlanDesignNoteResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlanDesignNoteResult {
  const o =
    (options.__typename ? options : cache["SaveReadyPlanDesignNoteResult"] = {}) as SaveReadyPlanDesignNoteResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlanDesignNoteResult";
  o.readyPlanDesignNote = maybeNew(
    "ReadyPlanDesignNote",
    options.readyPlanDesignNote,
    cache,
    options.hasOwnProperty("readyPlanDesignNote"),
  );
  return o;
}

factories["SaveReadyPlanDesignNoteResult"] = newSaveReadyPlanDesignNoteResult;

export interface ReadyPlanDesignNoteVersionOptions {
  __typename?: "ReadyPlanDesignNoteVersion";
  id?: ReadyPlanDesignNoteVersion["id"];
  active?: ReadyPlanDesignNoteVersion["active"];
  content?: ReadyPlanDesignNoteVersion["content"];
  createdAt?: ReadyPlanDesignNoteVersion["createdAt"];
  updatedAt?: ReadyPlanDesignNoteVersion["updatedAt"];
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  identity?: ReadyPlanDesignNote | ReadyPlanDesignNoteOptions;
  targetGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  targetCombinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
}

export function newReadyPlanDesignNoteVersion(
  options: ReadyPlanDesignNoteVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanDesignNoteVersion {
  const o = (options.__typename ? options : cache["ReadyPlanDesignNoteVersion"] = {}) as ReadyPlanDesignNoteVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanDesignNoteVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanDesignNoteVersion");
  o.active = options.active ?? false;
  o.content = options.content ?? "content";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.identity = maybeNew("ReadyPlanDesignNote", options.identity, cache, options.hasOwnProperty("identity"));
  o.targetGroups = (options.targetGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("targetGroups"))
  );
  o.targetCombinations = (options.targetCombinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("targetCombinations"))
  );
  return o;
}

factories["ReadyPlanDesignNoteVersion"] = newReadyPlanDesignNoteVersion;

export interface ReadyPlanDesignPackageOptions {
  __typename?: "ReadyPlanDesignPackage";
  id?: ReadyPlanDesignPackage["id"];
  active?: ReadyPlanDesignPackage["active"];
  name?: ReadyPlanDesignPackage["name"];
  createdAt?: ReadyPlanDesignPackage["createdAt"];
  updatedAt?: ReadyPlanDesignPackage["updatedAt"];
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionDefaultsIfChildren?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionVersionDefaultsIfChildren?: Array<ReadyPlanOptionVersion | ReadyPlanOptionVersionOptions>;
}

export function newReadyPlanDesignPackage(
  options: ReadyPlanDesignPackageOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanDesignPackage {
  const o = (options.__typename ? options : cache["ReadyPlanDesignPackage"] = {}) as ReadyPlanDesignPackage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanDesignPackage";
  o.id = options.id ?? nextFactoryId("ReadyPlanDesignPackage");
  o.active = options.active ?? false;
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.optionDefaultsIfChildren = (options.optionDefaultsIfChildren ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionDefaultsIfChildren"))
  );
  o.optionVersionDefaultsIfChildren = (options.optionVersionDefaultsIfChildren ?? []).map((i) =>
    maybeNew("ReadyPlanOptionVersion", i, cache, options.hasOwnProperty("optionVersionDefaultsIfChildren"))
  );
  return o;
}

factories["ReadyPlanDesignPackage"] = newReadyPlanDesignPackage;

export interface ReadyPlanDesignPackageVersionOptions {
  __typename?: "ReadyPlanDesignPackageVersion";
  id?: ReadyPlanDesignPackageVersion["id"];
  active?: ReadyPlanDesignPackageVersion["active"];
  createdAt?: ReadyPlanDesignPackageVersion["createdAt"];
  updatedAt?: ReadyPlanDesignPackageVersion["updatedAt"];
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  identity?: ReadyPlanDesignPackage | ReadyPlanDesignPackageOptions;
}

export function newReadyPlanDesignPackageVersion(
  options: ReadyPlanDesignPackageVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanDesignPackageVersion {
  const o =
    (options.__typename ? options : cache["ReadyPlanDesignPackageVersion"] = {}) as ReadyPlanDesignPackageVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanDesignPackageVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanDesignPackageVersion");
  o.active = options.active ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.identity = maybeNew("ReadyPlanDesignPackage", options.identity, cache, options.hasOwnProperty("identity"));
  return o;
}

factories["ReadyPlanDesignPackageVersion"] = newReadyPlanDesignPackageVersion;

export interface ReadyPlanDocumentVersionOptions {
  __typename?: "ReadyPlanDocumentVersion";
  id?: ReadyPlanDocumentVersion["id"];
  asset?: Asset | AssetOptions;
  identity?: Document | DocumentOptions;
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  active?: ReadyPlanDocumentVersion["active"];
  name?: ReadyPlanDocumentVersion["name"];
  uploaded?: ReadyPlanDocumentVersion["uploaded"];
  sizeInBytes?: ReadyPlanDocumentVersion["sizeInBytes"];
  documentType?: DocumentTypeDetailOptions | DocumentType;
  category?: DocumentCategoryDetailOptions | DocumentCategory;
}

export function newReadyPlanDocumentVersion(
  options: ReadyPlanDocumentVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanDocumentVersion {
  const o = (options.__typename ? options : cache["ReadyPlanDocumentVersion"] = {}) as ReadyPlanDocumentVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanDocumentVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanDocumentVersion");
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  o.identity = maybeNew("Document", options.identity, cache, options.hasOwnProperty("identity"));
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.active = options.active ?? false;
  o.name = options.name ?? "name";
  o.uploaded = options.uploaded ?? false;
  o.sizeInBytes = options.sizeInBytes ?? 0;
  o.documentType = enumOrDetailOfDocumentType(options.documentType);
  o.category = enumOrDetailOfDocumentCategory(options.category);
  return o;
}

factories["ReadyPlanDocumentVersion"] = newReadyPlanDocumentVersion;

export interface ReadyPlanLocationOptions {
  __typename?: "ReadyPlanLocation";
  id?: ReadyPlanLocation["id"];
  createdAt?: ReadyPlanLocation["createdAt"];
  updatedAt?: ReadyPlanLocation["updatedAt"];
  location?: Location | LocationOptions;
  readyPlan?: ReadyPlan | ReadyPlanOptions;
  roomNumber?: ReadyPlanLocation["roomNumber"];
  fullRoomNumber?: ReadyPlanLocation["fullRoomNumber"];
  level?: Location | LocationOptions | null;
  roomType?: RoomType | RoomTypeOptions | null;
  versions?: Array<ReadyPlanLocationVersion | ReadyPlanLocationVersionOptions>;
  active?: ReadyPlanLocation["active"];
  relatedTakeoffLineItemsCount?: ReadyPlanLocation["relatedTakeoffLineItemsCount"];
  readyPlanAssets?: Array<ReadyPlanAsset | ReadyPlanAssetOptions>;
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  designPackageLocations?: Array<ReadyPlanLocation | ReadyPlanLocationOptions>;
  planLocations?: Array<ReadyPlanLocation | ReadyPlanLocationOptions>;
  name?: ReadyPlanLocation["name"];
  isInsideMapsRoom?: ReadyPlanLocation["isInsideMapsRoom"];
  insideMapsRoomOrder?: ReadyPlanLocation["insideMapsRoomOrder"];
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  marketingName?: ReadyPlanLocation["marketingName"];
}

export function newReadyPlanLocation(
  options: ReadyPlanLocationOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanLocation {
  const o = (options.__typename ? options : cache["ReadyPlanLocation"] = {}) as ReadyPlanLocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanLocation";
  o.id = options.id ?? nextFactoryId("ReadyPlanLocation");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.readyPlan = maybeNew("ReadyPlan", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.roomNumber = options.roomNumber ?? null;
  o.fullRoomNumber = options.fullRoomNumber ?? null;
  o.level = maybeNewOrNull("Location", options.level, cache);
  o.roomType = maybeNewOrNull("RoomType", options.roomType, cache);
  o.versions = (options.versions ?? []).map((i) =>
    maybeNew("ReadyPlanLocationVersion", i, cache, options.hasOwnProperty("versions"))
  );
  o.active = options.active ?? false;
  o.relatedTakeoffLineItemsCount = options.relatedTakeoffLineItemsCount ?? 0;
  o.readyPlanAssets = (options.readyPlanAssets ?? []).map((i) =>
    maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("readyPlanAssets"))
  );
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  o.designPackageLocations = (options.designPackageLocations ?? []).map((i) =>
    maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("designPackageLocations"))
  );
  o.planLocations = (options.planLocations ?? []).map((i) =>
    maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("planLocations"))
  );
  o.name = options.name ?? "name";
  o.isInsideMapsRoom = options.isInsideMapsRoom ?? null;
  o.insideMapsRoomOrder = options.insideMapsRoomOrder ?? null;
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.marketingName = options.marketingName ?? "marketingName";
  return o;
}

factories["ReadyPlanLocation"] = newReadyPlanLocation;

export interface SaveReadyPlanLocationBulkResultOptions {
  __typename?: "SaveReadyPlanLocationBulkResult";
  readyPlanLocations?: Array<ReadyPlanLocation | ReadyPlanLocationOptions>;
  affectedTlis?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
}

export function newSaveReadyPlanLocationBulkResult(
  options: SaveReadyPlanLocationBulkResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlanLocationBulkResult {
  const o =
    (options.__typename ? options : cache["SaveReadyPlanLocationBulkResult"] = {}) as SaveReadyPlanLocationBulkResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlanLocationBulkResult";
  o.readyPlanLocations = (options.readyPlanLocations ?? []).map((i) =>
    maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("readyPlanLocations"))
  );
  o.affectedTlis = (options.affectedTlis ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("affectedTlis"))
  );
  return o;
}

factories["SaveReadyPlanLocationBulkResult"] = newSaveReadyPlanLocationBulkResult;

export interface SaveDesignPackageLocationPlanMappingsResultOptions {
  __typename?: "SaveDesignPackageLocationPlanMappingsResult";
  readyPlanLocations?: Array<ReadyPlanLocation | ReadyPlanLocationOptions>;
  affectedPlaceholders?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
}

export function newSaveDesignPackageLocationPlanMappingsResult(
  options: SaveDesignPackageLocationPlanMappingsResultOptions = {},
  cache: Record<string, any> = {},
): SaveDesignPackageLocationPlanMappingsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveDesignPackageLocationPlanMappingsResult"] = {}) as SaveDesignPackageLocationPlanMappingsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDesignPackageLocationPlanMappingsResult";
  o.readyPlanLocations = (options.readyPlanLocations ?? []).map((i) =>
    maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("readyPlanLocations"))
  );
  o.affectedPlaceholders = (options.affectedPlaceholders ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("affectedPlaceholders"))
  );
  return o;
}

factories["SaveDesignPackageLocationPlanMappingsResult"] = newSaveDesignPackageLocationPlanMappingsResult;

export interface CreateDesignPackageAlternateLocationResultOptions {
  __typename?: "CreateDesignPackageAlternateLocationResult";
  readyPlanLocation?: ReadyPlanLocation | ReadyPlanLocationOptions;
}

export function newCreateDesignPackageAlternateLocationResult(
  options: CreateDesignPackageAlternateLocationResultOptions = {},
  cache: Record<string, any> = {},
): CreateDesignPackageAlternateLocationResult {
  const o =
    (options.__typename
      ? options
      : cache["CreateDesignPackageAlternateLocationResult"] = {}) as CreateDesignPackageAlternateLocationResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateDesignPackageAlternateLocationResult";
  o.readyPlanLocation = maybeNew(
    "ReadyPlanLocation",
    options.readyPlanLocation,
    cache,
    options.hasOwnProperty("readyPlanLocation"),
  );
  return o;
}

factories["CreateDesignPackageAlternateLocationResult"] = newCreateDesignPackageAlternateLocationResult;

export interface ReadyPlanLocationVersionOptions {
  __typename?: "ReadyPlanLocationVersion";
  id?: ReadyPlanLocationVersion["id"];
  active?: ReadyPlanLocationVersion["active"];
  createdAt?: ReadyPlanLocationVersion["createdAt"];
  updatedAt?: ReadyPlanLocationVersion["updatedAt"];
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  identity?: ReadyPlanLocation | ReadyPlanLocationOptions;
  roomNumber?: ReadyPlanLocationVersion["roomNumber"];
  location?: Location | LocationOptions;
  changeType?: ReadyPlanLocationVersion["changeType"];
  previous?: ReadyPlanLocationVersion | ReadyPlanLocationVersionOptions | null;
  fullRoomNumber?: ReadyPlanLocationVersion["fullRoomNumber"];
  planLocations?: Array<ReadyPlanLocation | ReadyPlanLocationOptions>;
}

export function newReadyPlanLocationVersion(
  options: ReadyPlanLocationVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanLocationVersion {
  const o = (options.__typename ? options : cache["ReadyPlanLocationVersion"] = {}) as ReadyPlanLocationVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanLocationVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanLocationVersion");
  o.active = options.active ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.identity = maybeNew("ReadyPlanLocation", options.identity, cache, options.hasOwnProperty("identity"));
  o.roomNumber = options.roomNumber ?? null;
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.changeType = options.changeType ?? "changeType";
  o.previous = maybeNewOrNull("ReadyPlanLocationVersion", options.previous, cache);
  o.fullRoomNumber = options.fullRoomNumber ?? null;
  o.planLocations = (options.planLocations ?? []).map((i) =>
    maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("planLocations"))
  );
  return o;
}

factories["ReadyPlanLocationVersion"] = newReadyPlanLocationVersion;

export interface ReadyPlanOptionOptions {
  __typename?: "ReadyPlanOption";
  id?: ReadyPlanOption["id"];
  code?: ReadyPlanOption["code"];
  displayCode?: ReadyPlanOption["displayCode"];
  name?: ReadyPlanOption["name"];
  displayName?: ReadyPlanOption["displayName"];
  homeownerChoice?: ReadyPlanOption["homeownerChoice"];
  createdAt?: ReadyPlanOption["createdAt"];
  updatedAt?: ReadyPlanOption["updatedAt"];
  isChildOption?: ReadyPlanOption["isChildOption"];
  parentOption?: ReadyPlanOption | ReadyPlanOptionOptions | null;
  isParentOption?: ReadyPlanOption["isParentOption"];
  childOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  globalOption?: GlobalOption | GlobalOptionOptions;
  type?: GlobalOptionType | GlobalOptionTypeOptions;
  readyPlan?: ReadyPlan | ReadyPlanOptions;
  readyPlanLocation?: ReadyPlanLocation | ReadyPlanLocationOptions | null;
  location?: Location | LocationOptions | null;
  description?: ReadyPlanOption["description"];
  active?: ReadyPlanOption["active"];
  shortName?: ReadyPlanOption["shortName"];
  maybeShortName?: ReadyPlanOption["maybeShortName"];
  programData?: ProgramData | ProgramDataOptions;
  optionGroup?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions;
  userEvents?: Array<UserEvent | UserEventOptions>;
  blueprintUrl?: Url | UrlOptions;
  programDataModifiedBy?: Array<ReadyPlanOptionProgramDataModification | ReadyPlanOptionProgramDataModificationOptions>;
  modifiesProgramDataFor?: Array<
    ReadyPlanOptionProgramDataModification | ReadyPlanOptionProgramDataModificationOptions
  >;
  optionPrereqChildren?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionPrerequisites?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionConflictChildren?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionConflicts?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionDefaultChildren?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionDefaultsIf?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionRequiredIf?: Array<ReadyPlanRequiredOption | ReadyPlanRequiredOptionOptions>;
  personalizationTargetCombinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
  order?: ReadyPlanOption["order"];
  programDatas?: Array<ReadyPlanProgramData | ReadyPlanProgramDataOptions>;
  assets?: Array<ReadyPlanAsset | ReadyPlanAssetOptions>;
  bidOutPercentage?: ReadyPlanOption["bidOutPercentage"];
  latestVersion?: ReadyPlanOptionVersion | ReadyPlanOptionVersionOptions | null;
  draftVersion?: ReadyPlanOptionVersion | ReadyPlanOptionVersionOptions | null;
  publishToUnderwriting?: ReadyPlanOption["publishToUnderwriting"];
  optionImages?: Array<Asset | AssetOptions>;
  optionImage?: Asset | AssetOptions | null;
  materialVariant?: MaterialVariant | MaterialVariantOptions | null;
  materialVariants?: Array<MaterialVariant | MaterialVariantOptions>;
  preCutoffDesiredMarginInBasisPoints?: ReadyPlanOption["preCutoffDesiredMarginInBasisPoints"];
  postCutoffDesiredMarginInBasisPoints?: ReadyPlanOption["postCutoffDesiredMarginInBasisPoints"];
  selectionFeeInCents?: ReadyPlanOption["selectionFeeInCents"];
  minimumPriceInCents?: ReadyPlanOption["minimumPriceInCents"];
  showInCheckout?: ReadyPlanOption["showInCheckout"];
  missingInsideMapsRendering?: ReadyPlanOption["missingInsideMapsRendering"];
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  packageOptionMaterial?: MaterialVariant | MaterialVariantOptions | null;
  isNewFromUpstream?: ReadyPlanOption["isNewFromUpstream"];
  isUpstreamInactive?: ReadyPlanOption["isUpstreamInactive"];
  checkoutOrder?: ReadyPlanOption["checkoutOrder"];
}

export function newReadyPlanOption(
  options: ReadyPlanOptionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOption {
  const o = (options.__typename ? options : cache["ReadyPlanOption"] = {}) as ReadyPlanOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOption";
  o.id = options.id ?? nextFactoryId("ReadyPlanOption");
  o.code = options.code ?? "code";
  o.displayCode = options.displayCode ?? "displayCode";
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.homeownerChoice = options.homeownerChoice ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.isChildOption = options.isChildOption ?? false;
  o.parentOption = maybeNewOrNull("ReadyPlanOption", options.parentOption, cache);
  o.isParentOption = options.isParentOption ?? false;
  o.childOptions = (options.childOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("childOptions"))
  );
  o.globalOption = maybeNew("GlobalOption", options.globalOption, cache, options.hasOwnProperty("globalOption"));
  o.type = maybeNew("GlobalOptionType", options.type, cache, options.hasOwnProperty("type"));
  o.readyPlan = maybeNew("ReadyPlan", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.readyPlanLocation = maybeNewOrNull("ReadyPlanLocation", options.readyPlanLocation, cache);
  o.location = maybeNewOrNull("Location", options.location, cache);
  o.description = options.description ?? null;
  o.active = options.active ?? false;
  o.shortName = options.shortName ?? null;
  o.maybeShortName = options.maybeShortName ?? "maybeShortName";
  o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
  o.optionGroup = maybeNew("ReadyPlanOptionGroup", options.optionGroup, cache, options.hasOwnProperty("optionGroup"));
  o.userEvents = (options.userEvents ?? []).map((i) =>
    maybeNew("UserEvent", i, cache, options.hasOwnProperty("userEvents"))
  );
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.programDataModifiedBy = (options.programDataModifiedBy ?? []).map((i) =>
    maybeNew("ReadyPlanOptionProgramDataModification", i, cache, options.hasOwnProperty("programDataModifiedBy"))
  );
  o.modifiesProgramDataFor = (options.modifiesProgramDataFor ?? []).map((i) =>
    maybeNew("ReadyPlanOptionProgramDataModification", i, cache, options.hasOwnProperty("modifiesProgramDataFor"))
  );
  o.optionPrereqChildren = (options.optionPrereqChildren ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionPrereqChildren"))
  );
  o.optionPrerequisites = (options.optionPrerequisites ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionPrerequisites"))
  );
  o.optionConflictChildren = (options.optionConflictChildren ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionConflictChildren"))
  );
  o.optionConflicts = (options.optionConflicts ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionConflicts"))
  );
  o.optionDefaultChildren = (options.optionDefaultChildren ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionDefaultChildren"))
  );
  o.optionDefaultsIf = (options.optionDefaultsIf ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionDefaultsIf"))
  );
  o.optionRequiredIf = (options.optionRequiredIf ?? []).map((i) =>
    maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("optionRequiredIf"))
  );
  o.personalizationTargetCombinations = (options.personalizationTargetCombinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("personalizationTargetCombinations"))
  );
  o.order = options.order ?? 0;
  o.programDatas = (options.programDatas ?? []).map((i) =>
    maybeNew("ReadyPlanProgramData", i, cache, options.hasOwnProperty("programDatas"))
  );
  o.assets = (options.assets ?? []).map((i) => maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("assets")));
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.latestVersion = maybeNewOrNull("ReadyPlanOptionVersion", options.latestVersion, cache);
  o.draftVersion = maybeNewOrNull("ReadyPlanOptionVersion", options.draftVersion, cache);
  o.publishToUnderwriting = options.publishToUnderwriting ?? false;
  o.optionImages = (options.optionImages ?? []).map((i) =>
    maybeNew("Asset", i, cache, options.hasOwnProperty("optionImages"))
  );
  o.optionImage = maybeNewOrNull("Asset", options.optionImage, cache);
  o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
  o.materialVariants = (options.materialVariants ?? []).map((i) =>
    maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("materialVariants"))
  );
  o.preCutoffDesiredMarginInBasisPoints = options.preCutoffDesiredMarginInBasisPoints ?? 0;
  o.postCutoffDesiredMarginInBasisPoints = options.postCutoffDesiredMarginInBasisPoints ?? null;
  o.selectionFeeInCents = options.selectionFeeInCents ?? null;
  o.minimumPriceInCents = options.minimumPriceInCents ?? 0;
  o.showInCheckout = options.showInCheckout ?? false;
  o.missingInsideMapsRendering = options.missingInsideMapsRendering ?? false;
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.packageOptionMaterial = maybeNewOrNull("MaterialVariant", options.packageOptionMaterial, cache);
  o.isNewFromUpstream = options.isNewFromUpstream ?? false;
  o.isUpstreamInactive = options.isUpstreamInactive ?? false;
  o.checkoutOrder = options.checkoutOrder ?? null;
  return o;
}

factories["ReadyPlanOption"] = newReadyPlanOption;

export interface SaveReadyPlanOptionsResultOptions {
  __typename?: "SaveReadyPlanOptionsResult";
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
}

export function newSaveReadyPlanOptionsResult(
  options: SaveReadyPlanOptionsResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlanOptionsResult {
  const o = (options.__typename ? options : cache["SaveReadyPlanOptionsResult"] = {}) as SaveReadyPlanOptionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlanOptionsResult";
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  return o;
}

factories["SaveReadyPlanOptionsResult"] = newSaveReadyPlanOptionsResult;

export interface MergeReadyPlanOptionsResultOptions {
  __typename?: "MergeReadyPlanOptionsResult";
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions;
}

export function newMergeReadyPlanOptionsResult(
  options: MergeReadyPlanOptionsResultOptions = {},
  cache: Record<string, any> = {},
): MergeReadyPlanOptionsResult {
  const o = (options.__typename ? options : cache["MergeReadyPlanOptionsResult"] = {}) as MergeReadyPlanOptionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MergeReadyPlanOptionsResult";
  o.readyPlanOption = maybeNew(
    "ReadyPlanOption",
    options.readyPlanOption,
    cache,
    options.hasOwnProperty("readyPlanOption"),
  );
  return o;
}

factories["MergeReadyPlanOptionsResult"] = newMergeReadyPlanOptionsResult;

export interface ReadyPlanOptionGroupOptions {
  __typename?: "ReadyPlanOptionGroup";
  id?: ReadyPlanOptionGroup["id"];
  name?: ReadyPlanOptionGroup["name"];
  marketingDescription?: ReadyPlanOptionGroup["marketingDescription"];
  required?: ReadyPlanOptionGroup["required"];
  order?: ReadyPlanOptionGroup["order"];
  active?: ReadyPlanOptionGroup["active"];
  createdAt?: ReadyPlanOptionGroup["createdAt"];
  updatedAt?: ReadyPlanOptionGroup["updatedAt"];
  group?: GlobalOptionGroup | GlobalOptionGroupOptions;
  location?: Location | LocationOptions | null;
  readyPlan?: ReadyPlan | ReadyPlanOptions;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  isSingleOptionGroup?: ReadyPlanOptionGroup["isSingleOptionGroup"];
  isMultiOptionGroup?: ReadyPlanOptionGroup["isMultiOptionGroup"];
  forDesignUpgrade?: ReadyPlanOptionGroup["forDesignUpgrade"];
  forDesignPackage?: ReadyPlanOptionGroup["forDesignPackage"];
  forDesignInterior?: ReadyPlanOptionGroup["forDesignInterior"];
  forDesignExterior?: ReadyPlanOptionGroup["forDesignExterior"];
  forDesignPackages?: ReadyPlanOptionGroup["forDesignPackages"];
  isPlanPackage?: ReadyPlanOptionGroup["isPlanPackage"];
  personalizationType?:
    | ReadyPlanOptionGroupPersonalizationTypeDetailOptions
    | ReadyPlanOptionGroupPersonalizationType
    | null;
  groupByFeature?: ReadyPlanOptionGroup["groupByFeature"];
  personalizationPlaceholders?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  personalizationMaterialVariants?: Array<MaterialVariant | MaterialVariantOptions>;
  groupPrerequisites?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  groupPrereqChildren?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  levels?: ReadyPlanOptionGroup["levels"];
  personalizationTargetGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  readyPlanLocation?: ReadyPlanLocation | ReadyPlanLocationOptions | null;
  displayPackageOptionsAsSingleProduct?: ReadyPlanOptionGroup["displayPackageOptionsAsSingleProduct"];
  checkoutOrder?: ReadyPlanOptionGroup["checkoutOrder"];
  step?: CheckoutConfigOptionGroupStepDetailOptions | CheckoutConfigOptionGroupStep | null;
  substepNumber?: ReadyPlanOptionGroup["substepNumber"];
  hasDynamicProducts?: ReadyPlanOptionGroup["hasDynamicProducts"];
  overrideStep?: CheckoutConfigOptionGroupStepDetailOptions | CheckoutConfigOptionGroupStep | null;
  overrideSubstepNumber?: ReadyPlanOptionGroup["overrideSubstepNumber"];
  requiredWhen?: Array<ReadyPlanOptionGroupRequiredWhen | ReadyPlanOptionGroupRequiredWhenOptions> | null;
}

export function newReadyPlanOptionGroup(
  options: ReadyPlanOptionGroupOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOptionGroup {
  const o = (options.__typename ? options : cache["ReadyPlanOptionGroup"] = {}) as ReadyPlanOptionGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOptionGroup";
  o.id = options.id ?? nextFactoryId("ReadyPlanOptionGroup");
  o.name = options.name ?? "name";
  o.marketingDescription = options.marketingDescription ?? null;
  o.required = options.required ?? false;
  o.order = options.order ?? 0;
  o.active = options.active ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.group = maybeNew("GlobalOptionGroup", options.group, cache, options.hasOwnProperty("group"));
  o.location = maybeNewOrNull("Location", options.location, cache);
  o.readyPlan = maybeNew("ReadyPlan", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.isSingleOptionGroup = options.isSingleOptionGroup ?? false;
  o.isMultiOptionGroup = options.isMultiOptionGroup ?? false;
  o.forDesignUpgrade = options.forDesignUpgrade ?? false;
  o.forDesignPackage = options.forDesignPackage ?? false;
  o.forDesignInterior = options.forDesignInterior ?? false;
  o.forDesignExterior = options.forDesignExterior ?? false;
  o.forDesignPackages = options.forDesignPackages ?? false;
  o.isPlanPackage = options.isPlanPackage ?? false;
  o.personalizationType = enumOrDetailOrNullOfReadyPlanOptionGroupPersonalizationType(options.personalizationType);
  o.groupByFeature = options.groupByFeature ?? false;
  o.personalizationPlaceholders = (options.personalizationPlaceholders ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("personalizationPlaceholders"))
  );
  o.personalizationMaterialVariants = (options.personalizationMaterialVariants ?? []).map((i) =>
    maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("personalizationMaterialVariants"))
  );
  o.groupPrerequisites = (options.groupPrerequisites ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("groupPrerequisites"))
  );
  o.groupPrereqChildren = (options.groupPrereqChildren ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("groupPrereqChildren"))
  );
  o.levels = options.levels ?? null;
  o.personalizationTargetGroups = (options.personalizationTargetGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("personalizationTargetGroups"))
  );
  o.readyPlanLocation = maybeNewOrNull("ReadyPlanLocation", options.readyPlanLocation, cache);
  o.displayPackageOptionsAsSingleProduct = options.displayPackageOptionsAsSingleProduct ?? null;
  o.checkoutOrder = options.checkoutOrder ?? null;
  o.step = enumOrDetailOrNullOfCheckoutConfigOptionGroupStep(options.step);
  o.substepNumber = options.substepNumber ?? null;
  o.hasDynamicProducts = options.hasDynamicProducts ?? false;
  o.overrideStep = enumOrDetailOrNullOfCheckoutConfigOptionGroupStep(options.overrideStep);
  o.overrideSubstepNumber = options.overrideSubstepNumber ?? null;
  o.requiredWhen = (options.requiredWhen ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroupRequiredWhen", i, cache, options.hasOwnProperty("requiredWhen"))
  );
  return o;
}

factories["ReadyPlanOptionGroup"] = newReadyPlanOptionGroup;

export interface ReadyPlanOptionGroupRequiredWhenOptions {
  __typename?: "ReadyPlanOptionGroupRequiredWhen";
  all?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  none?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
}

export function newReadyPlanOptionGroupRequiredWhen(
  options: ReadyPlanOptionGroupRequiredWhenOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOptionGroupRequiredWhen {
  const o =
    (options.__typename ? options : cache["ReadyPlanOptionGroupRequiredWhen"] = {}) as ReadyPlanOptionGroupRequiredWhen;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOptionGroupRequiredWhen";
  o.all = (options.all ?? []).map((i) => maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("all")));
  o.none = (options.none ?? []).map((i) => maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("none")));
  return o;
}

factories["ReadyPlanOptionGroupRequiredWhen"] = newReadyPlanOptionGroupRequiredWhen;

export interface SaveReadyPlanOptionGroupResultOptions {
  __typename?: "SaveReadyPlanOptionGroupResult";
  optionGroup?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions;
}

export function newSaveReadyPlanOptionGroupResult(
  options: SaveReadyPlanOptionGroupResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlanOptionGroupResult {
  const o =
    (options.__typename ? options : cache["SaveReadyPlanOptionGroupResult"] = {}) as SaveReadyPlanOptionGroupResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlanOptionGroupResult";
  o.optionGroup = maybeNew("ReadyPlanOptionGroup", options.optionGroup, cache, options.hasOwnProperty("optionGroup"));
  return o;
}

factories["SaveReadyPlanOptionGroupResult"] = newSaveReadyPlanOptionGroupResult;

export interface SaveReadyPlanOptionGroupsResultOptions {
  __typename?: "SaveReadyPlanOptionGroupsResult";
  entities?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
}

export function newSaveReadyPlanOptionGroupsResult(
  options: SaveReadyPlanOptionGroupsResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlanOptionGroupsResult {
  const o =
    (options.__typename ? options : cache["SaveReadyPlanOptionGroupsResult"] = {}) as SaveReadyPlanOptionGroupsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlanOptionGroupsResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("entities"))
  );
  return o;
}

factories["SaveReadyPlanOptionGroupsResult"] = newSaveReadyPlanOptionGroupsResult;

export interface ReadyPlanOptionGroupVersionOptions {
  __typename?: "ReadyPlanOptionGroupVersion";
  id?: ReadyPlanOptionGroupVersion["id"];
  identity?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  required?: ReadyPlanOptionGroupVersion["required"];
  order?: ReadyPlanOptionGroupVersion["order"];
  active?: ReadyPlanOptionGroupVersion["active"];
  name?: ReadyPlanOptionGroupVersion["name"];
  marketingDescription?: ReadyPlanOptionGroupVersion["marketingDescription"];
  levels?: ReadyPlanOptionGroupVersion["levels"];
  personalizationTargetGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  location?: Location | LocationOptions | null;
  readyPlanLocation?: ReadyPlanLocation | ReadyPlanLocationOptions | null;
  displayPackageOptionsAsSingleProduct?: ReadyPlanOptionGroupVersion["displayPackageOptionsAsSingleProduct"];
  substepNumber?: ReadyPlanOptionGroupVersion["substepNumber"];
  step?: CheckoutConfigOptionGroupStepDetailOptions | CheckoutConfigOptionGroupStep | null;
  overrideStep?: CheckoutConfigOptionGroupStepDetailOptions | CheckoutConfigOptionGroupStep | null;
  overrideSubstepNumber?: ReadyPlanOptionGroupVersion["overrideSubstepNumber"];
}

export function newReadyPlanOptionGroupVersion(
  options: ReadyPlanOptionGroupVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOptionGroupVersion {
  const o = (options.__typename ? options : cache["ReadyPlanOptionGroupVersion"] = {}) as ReadyPlanOptionGroupVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOptionGroupVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanOptionGroupVersion");
  o.identity = maybeNew("ReadyPlanOptionGroup", options.identity, cache, options.hasOwnProperty("identity"));
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.required = options.required ?? false;
  o.order = options.order ?? 0;
  o.active = options.active ?? false;
  o.name = options.name ?? "name";
  o.marketingDescription = options.marketingDescription ?? null;
  o.levels = options.levels ?? null;
  o.personalizationTargetGroups = (options.personalizationTargetGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("personalizationTargetGroups"))
  );
  o.location = maybeNewOrNull("Location", options.location, cache);
  o.readyPlanLocation = maybeNewOrNull("ReadyPlanLocation", options.readyPlanLocation, cache);
  o.displayPackageOptionsAsSingleProduct = options.displayPackageOptionsAsSingleProduct ?? null;
  o.substepNumber = options.substepNumber ?? null;
  o.step = enumOrDetailOrNullOfCheckoutConfigOptionGroupStep(options.step);
  o.overrideStep = enumOrDetailOrNullOfCheckoutConfigOptionGroupStep(options.overrideStep);
  o.overrideSubstepNumber = options.overrideSubstepNumber ?? null;
  return o;
}

factories["ReadyPlanOptionGroupVersion"] = newReadyPlanOptionGroupVersion;

export interface ReadyPlanOptionProgramDataModificationOptions {
  __typename?: "ReadyPlanOptionProgramDataModification";
  id?: ReadyPlanOptionProgramDataModification["id"];
  createdAt?: ReadyPlanOptionProgramDataModification["createdAt"];
  updatedAt?: ReadyPlanOptionProgramDataModification["updatedAt"];
  programData?: ProgramData | ProgramDataOptions;
  modifiedOption?: ReadyPlanOption | ReadyPlanOptionOptions;
  matchesOption?: ReadyPlanOption | ReadyPlanOptionOptions;
  userEvents?: Array<UserEvent | UserEventOptions>;
  name?: ReadyPlanOptionProgramDataModification["name"];
}

export function newReadyPlanOptionProgramDataModification(
  options: ReadyPlanOptionProgramDataModificationOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOptionProgramDataModification {
  const o =
    (options.__typename
      ? options
      : cache["ReadyPlanOptionProgramDataModification"] = {}) as ReadyPlanOptionProgramDataModification;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOptionProgramDataModification";
  o.id = options.id ?? nextFactoryId("ReadyPlanOptionProgramDataModification");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
  o.modifiedOption = maybeNew(
    "ReadyPlanOption",
    options.modifiedOption,
    cache,
    options.hasOwnProperty("modifiedOption"),
  );
  o.matchesOption = maybeNew("ReadyPlanOption", options.matchesOption, cache, options.hasOwnProperty("matchesOption"));
  o.userEvents = (options.userEvents ?? []).map((i) =>
    maybeNew("UserEvent", i, cache, options.hasOwnProperty("userEvents"))
  );
  o.name = options.name ?? "name";
  return o;
}

factories["ReadyPlanOptionProgramDataModification"] = newReadyPlanOptionProgramDataModification;

export interface SaveReadyPlanOptionProgramDataModificationsResultOptions {
  __typename?: "SaveReadyPlanOptionProgramDataModificationsResult";
  entities?: Array<ReadyPlanOptionProgramDataModification | ReadyPlanOptionProgramDataModificationOptions>;
}

export function newSaveReadyPlanOptionProgramDataModificationsResult(
  options: SaveReadyPlanOptionProgramDataModificationsResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlanOptionProgramDataModificationsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveReadyPlanOptionProgramDataModificationsResult"] =
        {}) as SaveReadyPlanOptionProgramDataModificationsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlanOptionProgramDataModificationsResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("ReadyPlanOptionProgramDataModification", i, cache, options.hasOwnProperty("entities"))
  );
  return o;
}

factories["SaveReadyPlanOptionProgramDataModificationsResult"] = newSaveReadyPlanOptionProgramDataModificationsResult;

export interface DeleteReadyPlanOptionProgramDataModificationsResultOptions {
  __typename?: "DeleteReadyPlanOptionProgramDataModificationsResult";
  id?: DeleteReadyPlanOptionProgramDataModificationsResult["id"];
  modifiedOptionId?: DeleteReadyPlanOptionProgramDataModificationsResult["modifiedOptionId"];
}

export function newDeleteReadyPlanOptionProgramDataModificationsResult(
  options: DeleteReadyPlanOptionProgramDataModificationsResultOptions = {},
  cache: Record<string, any> = {},
): DeleteReadyPlanOptionProgramDataModificationsResult {
  const o =
    (options.__typename
      ? options
      : cache["DeleteReadyPlanOptionProgramDataModificationsResult"] =
        {}) as DeleteReadyPlanOptionProgramDataModificationsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteReadyPlanOptionProgramDataModificationsResult";
  o.id = options.id ?? nextFactoryId("DeleteReadyPlanOptionProgramDataModificationsResult");
  o.modifiedOptionId = options.modifiedOptionId ?? "modifiedOptionId";
  return o;
}

factories["DeleteReadyPlanOptionProgramDataModificationsResult"] =
  newDeleteReadyPlanOptionProgramDataModificationsResult;

export interface ReadyPlanOptionVersionOptions {
  __typename?: "ReadyPlanOptionVersion";
  id?: ReadyPlanOptionVersion["id"];
  identity?: ReadyPlanOption | ReadyPlanOptionOptions;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  active?: ReadyPlanOptionVersion["active"];
  createdAt?: ReadyPlanOptionVersion["createdAt"];
  updatedAt?: ReadyPlanOptionVersion["updatedAt"];
  customName?: ReadyPlanOptionVersion["customName"];
  displayCode?: ReadyPlanOptionVersion["displayCode"];
  isNewFromUpstream?: ReadyPlanOptionVersion["isNewFromUpstream"];
  isUpstreamInactive?: ReadyPlanOptionVersion["isUpstreamInactive"];
  isOfferingInactive?: ReadyPlanOptionVersion["isOfferingInactive"];
  optionConflicts?: Array<ReadyPlanOption | ReadyPlanOptionOptions> | null;
  optionPrerequisites?: Array<ReadyPlanOption | ReadyPlanOptionOptions> | null;
  optionDefaultsIf?: Array<ReadyPlanOption | ReadyPlanOptionOptions> | null;
  publishToUnderwriting?: ReadyPlanOptionVersion["publishToUnderwriting"];
  location?: Location | LocationOptions | null;
  showInCheckout?: ReadyPlanOptionVersion["showInCheckout"];
}

export function newReadyPlanOptionVersion(
  options: ReadyPlanOptionVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOptionVersion {
  const o = (options.__typename ? options : cache["ReadyPlanOptionVersion"] = {}) as ReadyPlanOptionVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOptionVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanOptionVersion");
  o.identity = maybeNew("ReadyPlanOption", options.identity, cache, options.hasOwnProperty("identity"));
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.active = options.active ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.customName = options.customName ?? null;
  o.displayCode = options.displayCode ?? null;
  o.isNewFromUpstream = options.isNewFromUpstream ?? false;
  o.isUpstreamInactive = options.isUpstreamInactive ?? false;
  o.isOfferingInactive = options.isOfferingInactive ?? null;
  o.optionConflicts = (options.optionConflicts ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionConflicts"))
  );
  o.optionPrerequisites = (options.optionPrerequisites ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionPrerequisites"))
  );
  o.optionDefaultsIf = (options.optionDefaultsIf ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionDefaultsIf"))
  );
  o.publishToUnderwriting = options.publishToUnderwriting ?? false;
  o.location = maybeNewOrNull("Location", options.location, cache);
  o.showInCheckout = options.showInCheckout ?? false;
  return o;
}

factories["ReadyPlanOptionVersion"] = newReadyPlanOptionVersion;

export interface ReadyPlanProgramDataOptions {
  __typename?: "ReadyPlanProgramData";
  id?: ReadyPlanProgramData["id"];
  createdAt?: ReadyPlanProgramData["createdAt"];
  updatedAt?: ReadyPlanProgramData["updatedAt"];
  readyPlan?: ReadyPlan | ReadyPlanOptions;
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  programData?: ProgramData | ProgramDataOptions;
  versions?: Array<ReadyPlanProgramDataVersion | ReadyPlanProgramDataVersionOptions>;
  active?: ReadyPlanProgramData["active"];
}

export function newReadyPlanProgramData(
  options: ReadyPlanProgramDataOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanProgramData {
  const o = (options.__typename ? options : cache["ReadyPlanProgramData"] = {}) as ReadyPlanProgramData;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanProgramData";
  o.id = options.id ?? nextFactoryId("ReadyPlanProgramData");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.readyPlan = maybeNew("ReadyPlan", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
  o.versions = (options.versions ?? []).map((i) =>
    maybeNew("ReadyPlanProgramDataVersion", i, cache, options.hasOwnProperty("versions"))
  );
  o.active = options.active ?? false;
  return o;
}

factories["ReadyPlanProgramData"] = newReadyPlanProgramData;

export interface ReadyPlanProgramDataVersionOptions {
  __typename?: "ReadyPlanProgramDataVersion";
  id?: ReadyPlanProgramDataVersion["id"];
  active?: ReadyPlanProgramDataVersion["active"];
  createdAt?: ReadyPlanProgramDataVersion["createdAt"];
  updatedAt?: ReadyPlanProgramDataVersion["updatedAt"];
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  identity?: ReadyPlanProgramData | ReadyPlanProgramDataOptions;
  programData?: ProgramData | ProgramDataOptions;
}

export function newReadyPlanProgramDataVersion(
  options: ReadyPlanProgramDataVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanProgramDataVersion {
  const o = (options.__typename ? options : cache["ReadyPlanProgramDataVersion"] = {}) as ReadyPlanProgramDataVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanProgramDataVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanProgramDataVersion");
  o.active = options.active ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.identity = maybeNew("ReadyPlanProgramData", options.identity, cache, options.hasOwnProperty("identity"));
  o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
  return o;
}

factories["ReadyPlanProgramDataVersion"] = newReadyPlanProgramDataVersion;

export interface ReadyPlanRequiredOptionOptions {
  __typename?: "ReadyPlanRequiredOption";
  id?: ReadyPlanRequiredOption["id"];
  createdAt?: ReadyPlanRequiredOption["createdAt"];
  updatedAt?: ReadyPlanRequiredOption["updatedAt"];
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  planAddOns?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  targetGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  targetCombinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
  active?: ReadyPlanRequiredOption["active"];
  usePersonalizationGroups?: ReadyPlanRequiredOption["usePersonalizationGroups"];
}

export function newReadyPlanRequiredOption(
  options: ReadyPlanRequiredOptionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanRequiredOption {
  const o = (options.__typename ? options : cache["ReadyPlanRequiredOption"] = {}) as ReadyPlanRequiredOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanRequiredOption";
  o.id = options.id ?? nextFactoryId("ReadyPlanRequiredOption");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.planAddOns = (options.planAddOns ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("planAddOns"))
  );
  o.targetGroups = (options.targetGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("targetGroups"))
  );
  o.targetCombinations = (options.targetCombinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("targetCombinations"))
  );
  o.active = options.active ?? false;
  o.usePersonalizationGroups = options.usePersonalizationGroups ?? false;
  return o;
}

factories["ReadyPlanRequiredOption"] = newReadyPlanRequiredOption;

export interface SaveReadyPlanRequiredOptionsResultOptions {
  __typename?: "SaveReadyPlanRequiredOptionsResult";
  readyPlanRequiredOptions?: Array<ReadyPlanRequiredOption | ReadyPlanRequiredOptionOptions>;
}

export function newSaveReadyPlanRequiredOptionsResult(
  options: SaveReadyPlanRequiredOptionsResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlanRequiredOptionsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveReadyPlanRequiredOptionsResult"] = {}) as SaveReadyPlanRequiredOptionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlanRequiredOptionsResult";
  o.readyPlanRequiredOptions = (options.readyPlanRequiredOptions ?? []).map((i) =>
    maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("readyPlanRequiredOptions"))
  );
  return o;
}

factories["SaveReadyPlanRequiredOptionsResult"] = newSaveReadyPlanRequiredOptionsResult;

export interface ReadyPlanRequiredOptionVersionOptions {
  __typename?: "ReadyPlanRequiredOptionVersion";
  id?: ReadyPlanRequiredOptionVersion["id"];
  active?: ReadyPlanRequiredOptionVersion["active"];
  createdAt?: ReadyPlanRequiredOptionVersion["createdAt"];
  updatedAt?: ReadyPlanRequiredOptionVersion["updatedAt"];
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  identity?: ReadyPlanRequiredOption | ReadyPlanRequiredOptionOptions;
  targetGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  targetCombinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
}

export function newReadyPlanRequiredOptionVersion(
  options: ReadyPlanRequiredOptionVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanRequiredOptionVersion {
  const o =
    (options.__typename ? options : cache["ReadyPlanRequiredOptionVersion"] = {}) as ReadyPlanRequiredOptionVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanRequiredOptionVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanRequiredOptionVersion");
  o.active = options.active ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.identity = maybeNew("ReadyPlanRequiredOption", options.identity, cache, options.hasOwnProperty("identity"));
  o.targetGroups = (options.targetGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("targetGroups"))
  );
  o.targetCombinations = (options.targetCombinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("targetCombinations"))
  );
  return o;
}

factories["ReadyPlanRequiredOptionVersion"] = newReadyPlanRequiredOptionVersion;

export interface ReadyPlanVersionOptions {
  __typename?: "ReadyPlanVersion";
  id?: ReadyPlanVersion["id"];
  identity?: ReadyPlan | ReadyPlanOptions;
  name?: ReadyPlanVersion["name"];
  code?: ReadyPlanVersion["code"];
  type?: ReadyPlanTypeDetailOptions | ReadyPlanType;
  lotTypes?: ReadyPlanVersion["lotTypes"];
  contingencyMarkupPercentage?: ReadyPlanVersion["contingencyMarkupPercentage"];
  description?: ReadyPlanVersion["description"];
  markets?: Array<Market | MarketOptions>;
  owner?: InternalUser | InternalUserOptions | null;
}

export function newReadyPlanVersion(
  options: ReadyPlanVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanVersion {
  const o = (options.__typename ? options : cache["ReadyPlanVersion"] = {}) as ReadyPlanVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanVersion");
  o.identity = maybeNew("ReadyPlan", options.identity, cache, options.hasOwnProperty("identity"));
  o.name = options.name ?? "name";
  o.code = options.code ?? null;
  o.type = enumOrDetailOfReadyPlanType(options.type);
  o.lotTypes = options.lotTypes ?? [];
  o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
  o.description = options.description ?? null;
  o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
  o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
  return o;
}

factories["ReadyPlanVersion"] = newReadyPlanVersion;

export interface SaveReferencesResultOptions {
  __typename?: "SaveReferencesResult";
  references?: Array<Reference | ReferenceOptions>;
}

export function newSaveReferencesResult(
  options: SaveReferencesResultOptions = {},
  cache: Record<string, any> = {},
): SaveReferencesResult {
  const o = (options.__typename ? options : cache["SaveReferencesResult"] = {}) as SaveReferencesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReferencesResult";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Reference", i, cache, options.hasOwnProperty("references"))
  );
  return o;
}

factories["SaveReferencesResult"] = newSaveReferencesResult;

export interface ReferenceOptions {
  __typename?: "Reference";
  source?:
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions;
  target?:
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions;
}

export function newReference(options: ReferenceOptions = {}, cache: Record<string, any> = {}): Reference {
  const o = (options.__typename ? options : cache["Reference"] = {}) as Reference;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Reference";
  o.source = maybeNew("Referencable", options.source, cache, options.hasOwnProperty("source"));
  o.target = maybeNew("Referencable", options.target, cache, options.hasOwnProperty("target"));
  return o;
}

factories["Reference"] = newReference;

export interface SaveRegionResultOptions {
  __typename?: "SaveRegionResult";
  region?: Region | RegionOptions;
}

export function newSaveRegionResult(
  options: SaveRegionResultOptions = {},
  cache: Record<string, any> = {},
): SaveRegionResult {
  const o = (options.__typename ? options : cache["SaveRegionResult"] = {}) as SaveRegionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveRegionResult";
  o.region = maybeNew("Region", options.region, cache, options.hasOwnProperty("region"));
  return o;
}

factories["SaveRegionResult"] = newSaveRegionResult;

export interface RequiredTaskDocumentOptions {
  __typename?: "RequiredTaskDocument";
  id?: RequiredTaskDocument["id"];
  name?: RequiredTaskDocument["name"];
  createdAt?: RequiredTaskDocument["createdAt"];
  updatedAt?: RequiredTaskDocument["updatedAt"];
  watchers?: RequiredTaskDocument["watchers"];
  documentType?: DocumentTypeDetailOptions | DocumentType;
  sampleAsset?: Asset | AssetOptions | null;
  task?: Task | TaskOptions;
  document?: Document | DocumentOptions | null;
  globalRequiredTaskDocument?: GlobalRequiredTaskDocument | GlobalRequiredTaskDocumentOptions | null;
}

export function newRequiredTaskDocument(
  options: RequiredTaskDocumentOptions = {},
  cache: Record<string, any> = {},
): RequiredTaskDocument {
  const o = (options.__typename ? options : cache["RequiredTaskDocument"] = {}) as RequiredTaskDocument;
  (cache.all ??= new Set()).add(o);
  o.__typename = "RequiredTaskDocument";
  o.id = options.id ?? nextFactoryId("RequiredTaskDocument");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.watchers = options.watchers ?? [];
  o.documentType = enumOrDetailOfDocumentType(options.documentType);
  o.sampleAsset = maybeNewOrNull("Asset", options.sampleAsset, cache);
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.globalRequiredTaskDocument = maybeNewOrNull(
    "GlobalRequiredTaskDocument",
    options.globalRequiredTaskDocument,
    cache,
  );
  return o;
}

factories["RequiredTaskDocument"] = newRequiredTaskDocument;

export interface SaveRequiredTaskDocumentResultOptions {
  __typename?: "SaveRequiredTaskDocumentResult";
  requiredTaskDocument?: RequiredTaskDocument | RequiredTaskDocumentOptions;
}

export function newSaveRequiredTaskDocumentResult(
  options: SaveRequiredTaskDocumentResultOptions = {},
  cache: Record<string, any> = {},
): SaveRequiredTaskDocumentResult {
  const o =
    (options.__typename ? options : cache["SaveRequiredTaskDocumentResult"] = {}) as SaveRequiredTaskDocumentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveRequiredTaskDocumentResult";
  o.requiredTaskDocument = maybeNew(
    "RequiredTaskDocument",
    options.requiredTaskDocument,
    cache,
    options.hasOwnProperty("requiredTaskDocument"),
  );
  return o;
}

factories["SaveRequiredTaskDocumentResult"] = newSaveRequiredTaskDocumentResult;

export interface DeleteRequiredTaskDocumentResultOptions {
  __typename?: "DeleteRequiredTaskDocumentResult";
  task?: Task | TaskOptions;
}

export function newDeleteRequiredTaskDocumentResult(
  options: DeleteRequiredTaskDocumentResultOptions = {},
  cache: Record<string, any> = {},
): DeleteRequiredTaskDocumentResult {
  const o =
    (options.__typename ? options : cache["DeleteRequiredTaskDocumentResult"] = {}) as DeleteRequiredTaskDocumentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteRequiredTaskDocumentResult";
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  return o;
}

factories["DeleteRequiredTaskDocumentResult"] = newDeleteRequiredTaskDocumentResult;

export interface RoomTypeOptions {
  __typename?: "RoomType";
  id?: RoomType["id"];
  name?: RoomType["name"];
  createdAt?: RoomType["createdAt"];
  updatedAt?: RoomType["updatedAt"];
  locations?: Array<Location | LocationOptions>;
  canDesignPackageRemap?: RoomType["canDesignPackageRemap"];
}

export function newRoomType(options: RoomTypeOptions = {}, cache: Record<string, any> = {}): RoomType {
  const o = (options.__typename ? options : cache["RoomType"] = {}) as RoomType;
  (cache.all ??= new Set()).add(o);
  o.__typename = "RoomType";
  o.id = options.id ?? nextFactoryId("RoomType");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.locations = (options.locations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("locations"))
  );
  o.canDesignPackageRemap = options.canDesignPackageRemap ?? null;
  return o;
}

factories["RoomType"] = newRoomType;

export interface SaveRoomTypeResultOptions {
  __typename?: "SaveRoomTypeResult";
  roomType?: RoomType | RoomTypeOptions;
}

export function newSaveRoomTypeResult(
  options: SaveRoomTypeResultOptions = {},
  cache: Record<string, any> = {},
): SaveRoomTypeResult {
  const o = (options.__typename ? options : cache["SaveRoomTypeResult"] = {}) as SaveRoomTypeResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveRoomTypeResult";
  o.roomType = maybeNew("RoomType", options.roomType, cache, options.hasOwnProperty("roomType"));
  return o;
}

factories["SaveRoomTypeResult"] = newSaveRoomTypeResult;

export interface TestMutationResultOptions {
  __typename?: "TestMutationResult";
  datetime?: TestMutationResult["datetime"];
  date?: TestMutationResult["date"];
}

export function newTestMutationResult(
  options: TestMutationResultOptions = {},
  cache: Record<string, any> = {},
): TestMutationResult {
  const o = (options.__typename ? options : cache["TestMutationResult"] = {}) as TestMutationResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TestMutationResult";
  o.datetime = options.datetime ?? newDateTime();
  o.date = options.date ?? newDate();
  return o;
}

factories["TestMutationResult"] = newTestMutationResult;

export interface UserErrorOptions {
  __typename?: "UserError";
  message?: UserError["message"];
}

export function newUserError(options: UserErrorOptions = {}, cache: Record<string, any> = {}): UserError {
  const o = (options.__typename ? options : cache["UserError"] = {}) as UserError;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserError";
  o.message = options.message ?? "message";
  return o;
}

factories["UserError"] = newUserError;

export interface EmptyResultOptions {
  __typename?: "EmptyResult";
  emptyResult?: EmptyResult["emptyResult"];
  dummyString?: EmptyResult["dummyString"];
}

export function newEmptyResult(options: EmptyResultOptions = {}, cache: Record<string, any> = {}): EmptyResult {
  const o = (options.__typename ? options : cache["EmptyResult"] = {}) as EmptyResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EmptyResult";
  o.emptyResult = options.emptyResult ?? null;
  o.dummyString = options.dummyString ?? null;
  return o;
}

factories["EmptyResult"] = newEmptyResult;

export interface UrlOptions {
  __typename?: "Url";
  path?: Url["path"];
  url?: Url["url"];
}

export function newUrl(options: UrlOptions = {}, cache: Record<string, any> = {}): Url {
  const o = (options.__typename ? options : cache["Url"] = {}) as Url;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Url";
  o.path = options.path ?? "path";
  o.url = options.url ?? "url";
  return o;
}

factories["Url"] = newUrl;

export interface PotentialOperationOptions {
  __typename?: "PotentialOperation";
  shown?: PotentialOperation["shown"];
  hiddenReasons?: PotentialOperation["hiddenReasons"];
  enabled?: PotentialOperation["enabled"];
  disabledReasons?: PotentialOperation["disabledReasons"];
}

export function newPotentialOperation(
  options: PotentialOperationOptions = {},
  cache: Record<string, any> = {},
): PotentialOperation {
  const o = (options.__typename ? options : cache["PotentialOperation"] = {}) as PotentialOperation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PotentialOperation";
  o.shown = options.shown ?? false;
  o.hiddenReasons = options.hiddenReasons ?? [];
  o.enabled = options.enabled ?? false;
  o.disabledReasons = options.disabledReasons ?? [];
  return o;
}

factories["PotentialOperation"] = newPotentialOperation;

export interface PotentialOperation2Options {
  __typename?: "PotentialOperation2";
  allowed?: PotentialOperation2["allowed"];
  disabledReasons?: Array<Reason | ReasonOptions>;
}

export function newPotentialOperation2(
  options: PotentialOperation2Options = {},
  cache: Record<string, any> = {},
): PotentialOperation2 {
  const o = (options.__typename ? options : cache["PotentialOperation2"] = {}) as PotentialOperation2;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PotentialOperation2";
  o.allowed = options.allowed ?? false;
  o.disabledReasons = (options.disabledReasons ?? []).map((i) =>
    maybeNew("Reason", i, cache, options.hasOwnProperty("disabledReasons"))
  );
  return o;
}

factories["PotentialOperation2"] = newPotentialOperation2;

export interface ReasonOptions {
  __typename?: "Reason";
  message?: Reason["message"];
  entity?:
    | Approval
    | BidContract
    | BidContractRevision
    | BidItem
    | BidPackageRequest
    | Bill
    | BusinessFunction
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | ScheduleTask
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | CommitmentChangeOrder
    | DesignPackage
    | Development
    | ItemTemplateItem
    | MaterialVariant
    | ProductOffering
    | ProjectReadyPlanConfig
    | ProjectSiteCondition
    | ReadyPlanOption
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | HasBlueprintUrl
    | HasBlueprintUrlOptions
    | null;
}

export function newReason(options: ReasonOptions = {}, cache: Record<string, any> = {}): Reason {
  const o = (options.__typename ? options : cache["Reason"] = {}) as Reason;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Reason";
  o.message = options.message ?? "message";
  o.entity = maybeNewOrNull("HasBlueprintUrl", options.entity, cache);
  return o;
}

factories["Reason"] = newReason;

export interface ScheduleOptions {
  __typename?: "Schedule";
  id?: Schedule["id"];
  name?: Schedule["name"];
  interval?: CalendarInterval | CalendarIntervalOptions | null;
  baselineInterval?: CalendarInterval | CalendarIntervalOptions | null;
  createdAt?: Schedule["createdAt"];
  updatedAt?: Schedule["updatedAt"];
  status?: Schedule["status"];
  statusDetail?: ScheduleStatusDetailOptions | ScheduleStatus;
  stage?: Schedule["stage"];
  stageDetail?: StageDetailOptions | Stage;
  parent?:
    | ScheduleParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<ScheduleTemplateOptions>;
  scheduleSetting?: ScheduleSetting | ScheduleSettingOptions | null;
  canPublishSchedule?: PotentialOperation2 | PotentialOperation2Options;
  canCompleteSchedule?: PotentialOperation2 | PotentialOperation2Options;
  duration?: Schedule["duration"];
  baselineDuration?: Schedule["baselineDuration"];
  phases?: Array<SchedulePhase | SchedulePhaseOptions>;
  isLocked?: Schedule["isLocked"];
  flagCount?: Schedule["flagCount"];
  templateSchedule?: Schedule | ScheduleOptions | null;
  enableReviewReminders?: Schedule["enableReviewReminders"];
  reviewReminderDays?: Schedule["reviewReminderDays"];
  market?: Market | MarketOptions | null;
}

export function newSchedule(options: ScheduleOptions = {}, cache: Record<string, any> = {}): Schedule {
  const o = (options.__typename ? options : cache["Schedule"] = {}) as Schedule;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Schedule";
  o.id = options.id ?? nextFactoryId("Schedule");
  o.name = options.name ?? "name";
  o.interval = maybeNewOrNull("CalendarInterval", options.interval, cache);
  o.baselineInterval = maybeNewOrNull("CalendarInterval", options.baselineInterval, cache);
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = options.status ?? ScheduleStatus.Active;
  o.statusDetail = enumOrDetailOfScheduleStatus(options.statusDetail);
  o.stage = options.stage ?? Stage.PreConPlanning;
  o.stageDetail = enumOrDetailOfStage(options.stageDetail);
  o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  o.scheduleSetting = maybeNewOrNull("ScheduleSetting", options.scheduleSetting, cache);
  o.canPublishSchedule = maybeNew(
    "PotentialOperation2",
    options.canPublishSchedule,
    cache,
    options.hasOwnProperty("canPublishSchedule"),
  );
  o.canCompleteSchedule = maybeNew(
    "PotentialOperation2",
    options.canCompleteSchedule,
    cache,
    options.hasOwnProperty("canCompleteSchedule"),
  );
  o.duration = options.duration ?? null;
  o.baselineDuration = options.baselineDuration ?? null;
  o.phases = (options.phases ?? []).map((i) => maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("phases")));
  o.isLocked = options.isLocked ?? false;
  o.flagCount = options.flagCount ?? 0;
  o.templateSchedule = maybeNewOrNull("Schedule", options.templateSchedule, cache);
  o.enableReviewReminders = options.enableReviewReminders ?? false;
  o.reviewReminderDays = options.reviewReminderDays ?? [];
  o.market = maybeNewOrNull("Market", options.market, cache);
  return o;
}

factories["Schedule"] = newSchedule;

export interface SchedulesResultOptions {
  __typename?: "SchedulesResult";
  schedules?: Array<Schedule | ScheduleOptions>;
}

export function newSchedulesResult(
  options: SchedulesResultOptions = {},
  cache: Record<string, any> = {},
): SchedulesResult {
  const o = (options.__typename ? options : cache["SchedulesResult"] = {}) as SchedulesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SchedulesResult";
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  return o;
}

factories["SchedulesResult"] = newSchedulesResult;

export interface SaveScheduleResultOptions {
  __typename?: "SaveScheduleResult";
  schedule?: Schedule | ScheduleOptions;
}

export function newSaveScheduleResult(
  options: SaveScheduleResultOptions = {},
  cache: Record<string, any> = {},
): SaveScheduleResult {
  const o = (options.__typename ? options : cache["SaveScheduleResult"] = {}) as SaveScheduleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScheduleResult";
  o.schedule = maybeNew("Schedule", options.schedule, cache, options.hasOwnProperty("schedule"));
  return o;
}

factories["SaveScheduleResult"] = newSaveScheduleResult;

export interface ResetScheduleBaselinesResultOptions {
  __typename?: "ResetScheduleBaselinesResult";
  projectIds?: ResetScheduleBaselinesResult["projectIds"];
}

export function newResetScheduleBaselinesResult(
  options: ResetScheduleBaselinesResultOptions = {},
  cache: Record<string, any> = {},
): ResetScheduleBaselinesResult {
  const o = (options.__typename ? options : cache["ResetScheduleBaselinesResult"] = {}) as ResetScheduleBaselinesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ResetScheduleBaselinesResult";
  o.projectIds = options.projectIds ?? [];
  return o;
}

factories["ResetScheduleBaselinesResult"] = newResetScheduleBaselinesResult;

export interface ScheduleFlagOptions {
  __typename?: "ScheduleFlag";
  id?: ScheduleFlag["id"];
  durationInDays?: ScheduleFlag["durationInDays"];
  description?: ScheduleFlag["description"];
  createdAt?: ScheduleFlag["createdAt"];
  updatedAt?: ScheduleFlag["updatedAt"];
  reason?: ScheduleFlagReason | ScheduleFlagReasonOptions | null;
  scheduleTask?: ScheduleTask | ScheduleTaskOptions | null;
  task?: Task | TaskOptions;
  attachments?: Array<Attachment | AttachmentOptions>;
}

export function newScheduleFlag(options: ScheduleFlagOptions = {}, cache: Record<string, any> = {}): ScheduleFlag {
  const o = (options.__typename ? options : cache["ScheduleFlag"] = {}) as ScheduleFlag;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleFlag";
  o.id = options.id ?? nextFactoryId("ScheduleFlag");
  o.durationInDays = options.durationInDays ?? null;
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.reason = maybeNewOrNull("ScheduleFlagReason", options.reason, cache);
  o.scheduleTask = maybeNewOrNull("ScheduleTask", options.scheduleTask, cache);
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  return o;
}

factories["ScheduleFlag"] = newScheduleFlag;

export interface SaveScheduleFlagResultOptions {
  __typename?: "SaveScheduleFlagResult";
  scheduleFlag?: ScheduleFlag | ScheduleFlagOptions;
}

export function newSaveScheduleFlagResult(
  options: SaveScheduleFlagResultOptions = {},
  cache: Record<string, any> = {},
): SaveScheduleFlagResult {
  const o = (options.__typename ? options : cache["SaveScheduleFlagResult"] = {}) as SaveScheduleFlagResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScheduleFlagResult";
  o.scheduleFlag = maybeNew("ScheduleFlag", options.scheduleFlag, cache, options.hasOwnProperty("scheduleFlag"));
  return o;
}

factories["SaveScheduleFlagResult"] = newSaveScheduleFlagResult;

export interface DeleteScheduleFlagResultOptions {
  __typename?: "DeleteScheduleFlagResult";
  scheduleTask?: ScheduleTask | ScheduleTaskOptions | null;
  task?: Task | TaskOptions;
}

export function newDeleteScheduleFlagResult(
  options: DeleteScheduleFlagResultOptions = {},
  cache: Record<string, any> = {},
): DeleteScheduleFlagResult {
  const o = (options.__typename ? options : cache["DeleteScheduleFlagResult"] = {}) as DeleteScheduleFlagResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteScheduleFlagResult";
  o.scheduleTask = maybeNewOrNull("ScheduleTask", options.scheduleTask, cache);
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  return o;
}

factories["DeleteScheduleFlagResult"] = newDeleteScheduleFlagResult;

export interface ScheduleFlagImpactOptions {
  __typename?: "ScheduleFlagImpact";
  id?: ScheduleFlagImpact["id"];
  oldStartDate?: ScheduleFlagImpact["oldStartDate"];
  newStartDate?: ScheduleFlagImpact["newStartDate"];
  oldEndDate?: ScheduleFlagImpact["oldEndDate"];
  newEndDate?: ScheduleFlagImpact["newEndDate"];
  oldDurationInDays?: ScheduleFlagImpact["oldDurationInDays"];
  newDurationInDays?: ScheduleFlagImpact["newDurationInDays"];
  oldSlackInDays?: ScheduleFlagImpact["oldSlackInDays"];
  newSlackInDays?: ScheduleFlagImpact["newSlackInDays"];
  createdAt?: ScheduleFlagImpact["createdAt"];
  updatedAt?: ScheduleFlagImpact["updatedAt"];
  scheduleFlag?: ScheduleFlag | ScheduleFlagOptions;
  impacted?: ScheduleFlagImpactImpacted | PlanMilestoneOptions | RequireTypename<TaskOptions> | null;
}

export function newScheduleFlagImpact(
  options: ScheduleFlagImpactOptions = {},
  cache: Record<string, any> = {},
): ScheduleFlagImpact {
  const o = (options.__typename ? options : cache["ScheduleFlagImpact"] = {}) as ScheduleFlagImpact;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleFlagImpact";
  o.id = options.id ?? nextFactoryId("ScheduleFlagImpact");
  o.oldStartDate = options.oldStartDate ?? null;
  o.newStartDate = options.newStartDate ?? newDate();
  o.oldEndDate = options.oldEndDate ?? null;
  o.newEndDate = options.newEndDate ?? newDate();
  o.oldDurationInDays = options.oldDurationInDays ?? null;
  o.newDurationInDays = options.newDurationInDays ?? 0;
  o.oldSlackInDays = options.oldSlackInDays ?? null;
  o.newSlackInDays = options.newSlackInDays ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.scheduleFlag = maybeNew("ScheduleFlag", options.scheduleFlag, cache, options.hasOwnProperty("scheduleFlag"));
  o.impacted = maybeNewOrNull(options.impacted?.__typename ?? "PlanMilestone", options.impacted, cache);
  return o;
}

factories["ScheduleFlagImpact"] = newScheduleFlagImpact;

export interface ScheduleFlagReasonOptions {
  __typename?: "ScheduleFlagReason";
  id?: ScheduleFlagReason["id"];
  createdAt?: ScheduleFlagReason["createdAt"];
  updatedAt?: ScheduleFlagReason["updatedAt"];
  scheduleFlagReasonType?: ScheduleFlagReasonTypeDetailOptions | ScheduleFlagReasonType;
  stages?: ScheduleFlagReason["stages"];
  scheduleFlags?: Array<ScheduleFlag | ScheduleFlagOptions>;
  title?: ScheduleFlagReason["title"];
  attachmentIsRequired?: ScheduleFlagReason["attachmentIsRequired"];
  descriptionIsRequired?: ScheduleFlagReason["descriptionIsRequired"];
}

export function newScheduleFlagReason(
  options: ScheduleFlagReasonOptions = {},
  cache: Record<string, any> = {},
): ScheduleFlagReason {
  const o = (options.__typename ? options : cache["ScheduleFlagReason"] = {}) as ScheduleFlagReason;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleFlagReason";
  o.id = options.id ?? nextFactoryId("ScheduleFlagReason");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.scheduleFlagReasonType = enumOrDetailOfScheduleFlagReasonType(options.scheduleFlagReasonType);
  o.stages = options.stages ?? [];
  o.scheduleFlags = (options.scheduleFlags ?? []).map((i) =>
    maybeNew("ScheduleFlag", i, cache, options.hasOwnProperty("scheduleFlags"))
  );
  o.title = options.title ?? "title";
  o.attachmentIsRequired = options.attachmentIsRequired ?? false;
  o.descriptionIsRequired = options.descriptionIsRequired ?? false;
  return o;
}

factories["ScheduleFlagReason"] = newScheduleFlagReason;

export interface SaveScheduleFlagReasonsResultOptions {
  __typename?: "SaveScheduleFlagReasonsResult";
  scheduleFlagReasons?: Array<ScheduleFlagReason | ScheduleFlagReasonOptions>;
}

export function newSaveScheduleFlagReasonsResult(
  options: SaveScheduleFlagReasonsResultOptions = {},
  cache: Record<string, any> = {},
): SaveScheduleFlagReasonsResult {
  const o =
    (options.__typename ? options : cache["SaveScheduleFlagReasonsResult"] = {}) as SaveScheduleFlagReasonsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScheduleFlagReasonsResult";
  o.scheduleFlagReasons = (options.scheduleFlagReasons ?? []).map((i) =>
    maybeNew("ScheduleFlagReason", i, cache, options.hasOwnProperty("scheduleFlagReasons"))
  );
  return o;
}

factories["SaveScheduleFlagReasonsResult"] = newSaveScheduleFlagReasonsResult;

export interface SchedulePhaseProgressOptions {
  __typename?: "SchedulePhaseProgress";
  scheduleSubPhaseProgress?: ProgressSummary | ProgressSummaryOptions;
  taskProgress?: ProgressSummary | ProgressSummaryOptions;
}

export function newSchedulePhaseProgress(
  options: SchedulePhaseProgressOptions = {},
  cache: Record<string, any> = {},
): SchedulePhaseProgress {
  const o = (options.__typename ? options : cache["SchedulePhaseProgress"] = {}) as SchedulePhaseProgress;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SchedulePhaseProgress";
  o.scheduleSubPhaseProgress = maybeNew(
    "ProgressSummary",
    options.scheduleSubPhaseProgress,
    cache,
    options.hasOwnProperty("scheduleSubPhaseProgress"),
  );
  o.taskProgress = maybeNew("ProgressSummary", options.taskProgress, cache, options.hasOwnProperty("taskProgress"));
  return o;
}

factories["SchedulePhaseProgress"] = newSchedulePhaseProgress;

export interface SaveSchedulePhasesResultOptions {
  __typename?: "SaveSchedulePhasesResult";
  schedulePhases?: Array<SchedulePhase | SchedulePhaseOptions>;
}

export function newSaveSchedulePhasesResult(
  options: SaveSchedulePhasesResultOptions = {},
  cache: Record<string, any> = {},
): SaveSchedulePhasesResult {
  const o = (options.__typename ? options : cache["SaveSchedulePhasesResult"] = {}) as SaveSchedulePhasesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveSchedulePhasesResult";
  o.schedulePhases = (options.schedulePhases ?? []).map((i) =>
    maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("schedulePhases"))
  );
  return o;
}

factories["SaveSchedulePhasesResult"] = newSaveSchedulePhasesResult;

export interface DeleteSchedulePhasesResultOptions {
  __typename?: "DeleteSchedulePhasesResult";
  impactedScheduleTasks?: Array<ScheduleTask | ScheduleTaskOptions>;
  impactedScheduleSubPhases?: Array<ScheduleSubPhase | ScheduleSubPhaseOptions>;
  impactedSchedulePhases?: Array<SchedulePhase | SchedulePhaseOptions>;
  impactedSchedules?: Array<Schedule | ScheduleOptions>;
  impacted?: Array<SchedulePhase | ScheduleSubPhase | ScheduleTask | Schedule | ScheduleEntity | ScheduleEntityOptions>;
}

export function newDeleteSchedulePhasesResult(
  options: DeleteSchedulePhasesResultOptions = {},
  cache: Record<string, any> = {},
): DeleteSchedulePhasesResult {
  const o = (options.__typename ? options : cache["DeleteSchedulePhasesResult"] = {}) as DeleteSchedulePhasesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteSchedulePhasesResult";
  o.impactedScheduleTasks = (options.impactedScheduleTasks ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("impactedScheduleTasks"))
  );
  o.impactedScheduleSubPhases = (options.impactedScheduleSubPhases ?? []).map((i) =>
    maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("impactedScheduleSubPhases"))
  );
  o.impactedSchedulePhases = (options.impactedSchedulePhases ?? []).map((i) =>
    maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("impactedSchedulePhases"))
  );
  o.impactedSchedules = (options.impactedSchedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("impactedSchedules"))
  );
  o.impacted = (options.impacted ?? []).map((i) =>
    maybeNew("ScheduleEntity", i, cache, options.hasOwnProperty("impacted"))
  );
  return o;
}

factories["DeleteSchedulePhasesResult"] = newDeleteSchedulePhasesResult;

export interface ScheduleSettingOptions {
  __typename?: "ScheduleSetting";
  id?: ScheduleSetting["id"];
  workingDays?: ScheduleSetting["workingDays"];
  createdAt?: ScheduleSetting["createdAt"];
  updatedAt?: ScheduleSetting["updatedAt"];
  schedule?: Schedule | ScheduleOptions;
  exceptions?: ScheduleSetting["exceptions"];
}

export function newScheduleSetting(
  options: ScheduleSettingOptions = {},
  cache: Record<string, any> = {},
): ScheduleSetting {
  const o = (options.__typename ? options : cache["ScheduleSetting"] = {}) as ScheduleSetting;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleSetting";
  o.id = options.id ?? nextFactoryId("ScheduleSetting");
  o.workingDays = options.workingDays ?? [];
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.schedule = maybeNew("Schedule", options.schedule, cache, options.hasOwnProperty("schedule"));
  o.exceptions = options.exceptions ?? null;
  return o;
}

factories["ScheduleSetting"] = newScheduleSetting;

export interface SaveScheduleSettingsResultOptions {
  __typename?: "SaveScheduleSettingsResult";
  scheduleSettings?: Array<ScheduleSetting | ScheduleSettingOptions>;
}

export function newSaveScheduleSettingsResult(
  options: SaveScheduleSettingsResultOptions = {},
  cache: Record<string, any> = {},
): SaveScheduleSettingsResult {
  const o = (options.__typename ? options : cache["SaveScheduleSettingsResult"] = {}) as SaveScheduleSettingsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScheduleSettingsResult";
  o.scheduleSettings = (options.scheduleSettings ?? []).map((i) =>
    maybeNew("ScheduleSetting", i, cache, options.hasOwnProperty("scheduleSettings"))
  );
  return o;
}

factories["SaveScheduleSettingsResult"] = newSaveScheduleSettingsResult;

export interface ScheduleSubPhaseProgressOptions {
  __typename?: "ScheduleSubPhaseProgress";
  taskProgress?: ProgressSummary | ProgressSummaryOptions;
}

export function newScheduleSubPhaseProgress(
  options: ScheduleSubPhaseProgressOptions = {},
  cache: Record<string, any> = {},
): ScheduleSubPhaseProgress {
  const o = (options.__typename ? options : cache["ScheduleSubPhaseProgress"] = {}) as ScheduleSubPhaseProgress;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleSubPhaseProgress";
  o.taskProgress = maybeNew("ProgressSummary", options.taskProgress, cache, options.hasOwnProperty("taskProgress"));
  return o;
}

factories["ScheduleSubPhaseProgress"] = newScheduleSubPhaseProgress;

export interface SaveScheduleSubPhasesResultOptions {
  __typename?: "SaveScheduleSubPhasesResult";
  scheduleSubPhases?: Array<ScheduleSubPhase | ScheduleSubPhaseOptions>;
}

export function newSaveScheduleSubPhasesResult(
  options: SaveScheduleSubPhasesResultOptions = {},
  cache: Record<string, any> = {},
): SaveScheduleSubPhasesResult {
  const o = (options.__typename ? options : cache["SaveScheduleSubPhasesResult"] = {}) as SaveScheduleSubPhasesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScheduleSubPhasesResult";
  o.scheduleSubPhases = (options.scheduleSubPhases ?? []).map((i) =>
    maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("scheduleSubPhases"))
  );
  return o;
}

factories["SaveScheduleSubPhasesResult"] = newSaveScheduleSubPhasesResult;

export interface DeleteScheduleSubPhasesResultOptions {
  __typename?: "DeleteScheduleSubPhasesResult";
  impactedScheduleTasks?: Array<ScheduleTask | ScheduleTaskOptions>;
  impactedScheduleSubPhases?: Array<ScheduleSubPhase | ScheduleSubPhaseOptions>;
  impactedSchedulePhases?: Array<SchedulePhase | SchedulePhaseOptions>;
  impactedSchedules?: Array<Schedule | ScheduleOptions>;
  impacted?: Array<SchedulePhase | ScheduleSubPhase | ScheduleTask | Schedule | ScheduleEntity | ScheduleEntityOptions>;
}

export function newDeleteScheduleSubPhasesResult(
  options: DeleteScheduleSubPhasesResultOptions = {},
  cache: Record<string, any> = {},
): DeleteScheduleSubPhasesResult {
  const o =
    (options.__typename ? options : cache["DeleteScheduleSubPhasesResult"] = {}) as DeleteScheduleSubPhasesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteScheduleSubPhasesResult";
  o.impactedScheduleTasks = (options.impactedScheduleTasks ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("impactedScheduleTasks"))
  );
  o.impactedScheduleSubPhases = (options.impactedScheduleSubPhases ?? []).map((i) =>
    maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("impactedScheduleSubPhases"))
  );
  o.impactedSchedulePhases = (options.impactedSchedulePhases ?? []).map((i) =>
    maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("impactedSchedulePhases"))
  );
  o.impactedSchedules = (options.impactedSchedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("impactedSchedules"))
  );
  o.impacted = (options.impacted ?? []).map((i) =>
    maybeNew("ScheduleEntity", i, cache, options.hasOwnProperty("impacted"))
  );
  return o;
}

factories["DeleteScheduleSubPhasesResult"] = newDeleteScheduleSubPhasesResult;

export interface MoveScheduleSubPhasesResultOptions {
  __typename?: "MoveScheduleSubPhasesResult";
  impactedScheduleTasks?: Array<ScheduleTask | ScheduleTaskOptions>;
  impactedScheduleSubPhases?: Array<ScheduleSubPhase | ScheduleSubPhaseOptions>;
  impactedSchedulePhases?: Array<SchedulePhase | SchedulePhaseOptions>;
  impactedSchedules?: Array<Schedule | ScheduleOptions>;
  impacted?: Array<SchedulePhase | ScheduleSubPhase | ScheduleTask | Schedule | ScheduleEntity | ScheduleEntityOptions>;
}

export function newMoveScheduleSubPhasesResult(
  options: MoveScheduleSubPhasesResultOptions = {},
  cache: Record<string, any> = {},
): MoveScheduleSubPhasesResult {
  const o = (options.__typename ? options : cache["MoveScheduleSubPhasesResult"] = {}) as MoveScheduleSubPhasesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MoveScheduleSubPhasesResult";
  o.impactedScheduleTasks = (options.impactedScheduleTasks ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("impactedScheduleTasks"))
  );
  o.impactedScheduleSubPhases = (options.impactedScheduleSubPhases ?? []).map((i) =>
    maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("impactedScheduleSubPhases"))
  );
  o.impactedSchedulePhases = (options.impactedSchedulePhases ?? []).map((i) =>
    maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("impactedSchedulePhases"))
  );
  o.impactedSchedules = (options.impactedSchedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("impactedSchedules"))
  );
  o.impacted = (options.impacted ?? []).map((i) =>
    maybeNew("ScheduleEntity", i, cache, options.hasOwnProperty("impacted"))
  );
  return o;
}

factories["MoveScheduleSubPhasesResult"] = newMoveScheduleSubPhasesResult;

export interface SaveScheduleTasksResultOptions {
  __typename?: "SaveScheduleTasksResult";
  scheduleTasks?: Array<ScheduleTask | ScheduleTaskOptions>;
  impactedScheduleTasks?: Array<ScheduleTask | ScheduleTaskOptions>;
  impactedScheduleSubPhases?: Array<ScheduleSubPhase | ScheduleSubPhaseOptions>;
  impactedSchedulePhases?: Array<SchedulePhase | SchedulePhaseOptions>;
  impactedSchedules?: Array<Schedule | ScheduleOptions>;
  impacted?: Array<SchedulePhase | ScheduleSubPhase | ScheduleTask | Schedule | ScheduleEntity | ScheduleEntityOptions>;
  resultingDelays?: Array<ResultingDelay | ResultingDelayOptions>;
  generatedInvoices?: Array<Invoice | InvoiceOptions>;
  generatedDepositBills?: Array<Bill | BillOptions>;
}

export function newSaveScheduleTasksResult(
  options: SaveScheduleTasksResultOptions = {},
  cache: Record<string, any> = {},
): SaveScheduleTasksResult {
  const o = (options.__typename ? options : cache["SaveScheduleTasksResult"] = {}) as SaveScheduleTasksResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScheduleTasksResult";
  o.scheduleTasks = (options.scheduleTasks ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("scheduleTasks"))
  );
  o.impactedScheduleTasks = (options.impactedScheduleTasks ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("impactedScheduleTasks"))
  );
  o.impactedScheduleSubPhases = (options.impactedScheduleSubPhases ?? []).map((i) =>
    maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("impactedScheduleSubPhases"))
  );
  o.impactedSchedulePhases = (options.impactedSchedulePhases ?? []).map((i) =>
    maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("impactedSchedulePhases"))
  );
  o.impactedSchedules = (options.impactedSchedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("impactedSchedules"))
  );
  o.impacted = (options.impacted ?? []).map((i) =>
    maybeNew("ScheduleEntity", i, cache, options.hasOwnProperty("impacted"))
  );
  o.resultingDelays = (options.resultingDelays ?? []).map((i) =>
    maybeNew("ResultingDelay", i, cache, options.hasOwnProperty("resultingDelays"))
  );
  o.generatedInvoices = (options.generatedInvoices ?? []).map((i) =>
    maybeNew("Invoice", i, cache, options.hasOwnProperty("generatedInvoices"))
  );
  o.generatedDepositBills = (options.generatedDepositBills ?? []).map((i) =>
    maybeNew("Bill", i, cache, options.hasOwnProperty("generatedDepositBills"))
  );
  return o;
}

factories["SaveScheduleTasksResult"] = newSaveScheduleTasksResult;

export interface ResultingDelayOptions {
  __typename?: "ResultingDelay";
  scheduleTask?: ScheduleTask | ScheduleTaskOptions;
  durationInDays?: ResultingDelay["durationInDays"];
  oldTaskStart?: ResultingDelay["oldTaskStart"];
  oldTaskEnd?: ResultingDelay["oldTaskEnd"];
}

export function newResultingDelay(
  options: ResultingDelayOptions = {},
  cache: Record<string, any> = {},
): ResultingDelay {
  const o = (options.__typename ? options : cache["ResultingDelay"] = {}) as ResultingDelay;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ResultingDelay";
  o.scheduleTask = maybeNew("ScheduleTask", options.scheduleTask, cache, options.hasOwnProperty("scheduleTask"));
  o.durationInDays = options.durationInDays ?? 0;
  o.oldTaskStart = options.oldTaskStart ?? newDate();
  o.oldTaskEnd = options.oldTaskEnd ?? newDate();
  return o;
}

factories["ResultingDelay"] = newResultingDelay;

export interface ScheduleTaskChecklistItemOptions {
  __typename?: "ScheduleTaskChecklistItem";
  id?: ScheduleTaskChecklistItem["id"];
  description?: ScheduleTaskChecklistItem["description"];
  completedAt?: ScheduleTaskChecklistItem["completedAt"];
  createdAt?: ScheduleTaskChecklistItem["createdAt"];
  updatedAt?: ScheduleTaskChecklistItem["updatedAt"];
  completedBy?: InternalUser | InternalUserOptions | null;
  isCompleted?: ScheduleTaskChecklistItem["isCompleted"];
  task?: ScheduleTask | ScheduleTaskOptions;
  templateChecklistItem?: ScheduleTaskChecklistItem | ScheduleTaskChecklistItemOptions | null;
  scheduleTaskChecklistItems?: Array<ScheduleTaskChecklistItem | ScheduleTaskChecklistItemOptions>;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
}

export function newScheduleTaskChecklistItem(
  options: ScheduleTaskChecklistItemOptions = {},
  cache: Record<string, any> = {},
): ScheduleTaskChecklistItem {
  const o = (options.__typename ? options : cache["ScheduleTaskChecklistItem"] = {}) as ScheduleTaskChecklistItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleTaskChecklistItem";
  o.id = options.id ?? nextFactoryId("ScheduleTaskChecklistItem");
  o.description = options.description ?? "description";
  o.completedAt = options.completedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.completedBy = maybeNewOrNull("InternalUser", options.completedBy, cache);
  o.isCompleted = options.isCompleted ?? false;
  o.task = maybeNew("ScheduleTask", options.task, cache, options.hasOwnProperty("task"));
  o.templateChecklistItem = maybeNewOrNull("ScheduleTaskChecklistItem", options.templateChecklistItem, cache);
  o.scheduleTaskChecklistItems = (options.scheduleTaskChecklistItems ?? []).map((i) =>
    maybeNew("ScheduleTaskChecklistItem", i, cache, options.hasOwnProperty("scheduleTaskChecklistItems"))
  );
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  return o;
}

factories["ScheduleTaskChecklistItem"] = newScheduleTaskChecklistItem;

export interface SaveScheduleTaskChecklistItemResultOptions {
  __typename?: "SaveScheduleTaskChecklistItemResult";
  scheduleTaskChecklistItem?: ScheduleTaskChecklistItem | ScheduleTaskChecklistItemOptions;
}

export function newSaveScheduleTaskChecklistItemResult(
  options: SaveScheduleTaskChecklistItemResultOptions = {},
  cache: Record<string, any> = {},
): SaveScheduleTaskChecklistItemResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveScheduleTaskChecklistItemResult"] = {}) as SaveScheduleTaskChecklistItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScheduleTaskChecklistItemResult";
  o.scheduleTaskChecklistItem = maybeNew(
    "ScheduleTaskChecklistItem",
    options.scheduleTaskChecklistItem,
    cache,
    options.hasOwnProperty("scheduleTaskChecklistItem"),
  );
  return o;
}

factories["SaveScheduleTaskChecklistItemResult"] = newSaveScheduleTaskChecklistItemResult;

export interface ScheduleTaskDependencyOptions {
  __typename?: "ScheduleTaskDependency";
  type?: ScheduleTaskDependency["type"];
  lagInDays?: ScheduleTaskDependency["lagInDays"];
  predecessor?: ScheduleTask | ScheduleTaskOptions;
  successor?: ScheduleTask | ScheduleTaskOptions;
  id?: ScheduleTaskDependency["id"];
}

export function newScheduleTaskDependency(
  options: ScheduleTaskDependencyOptions = {},
  cache: Record<string, any> = {},
): ScheduleTaskDependency {
  const o = (options.__typename ? options : cache["ScheduleTaskDependency"] = {}) as ScheduleTaskDependency;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleTaskDependency";
  o.type = options.type ?? TaskDependencyType.FinishStart;
  o.lagInDays = options.lagInDays ?? 0;
  o.predecessor = maybeNew("ScheduleTask", options.predecessor, cache, options.hasOwnProperty("predecessor"));
  o.successor = maybeNew("ScheduleTask", options.successor, cache, options.hasOwnProperty("successor"));
  o.id = options.id ?? nextFactoryId("ScheduleTaskDependency");
  return o;
}

factories["ScheduleTaskDependency"] = newScheduleTaskDependency;

export interface ScheduleTemplateOptions {
  __typename?: "ScheduleTemplate";
  id?: ScheduleTemplate["id"];
  name?: ScheduleTemplate["name"];
  createdAt?: ScheduleTemplate["createdAt"];
  updatedAt?: ScheduleTemplate["updatedAt"];
  status?: ScheduleTemplate["status"];
  statusDetail?: ScheduleTemplateStatusDetailOptions | ScheduleTemplateStatus;
  stage?: ScheduleTemplate["stage"];
  stageDetail?: StageDetailOptions | Stage;
  market?: Market | MarketOptions | null;
  schedules?: Array<Schedule | ScheduleOptions>;
  developments?: Array<Development | DevelopmentOptions>;
  itemMappings?: Array<ScheduleTemplateItemMapping | ScheduleTemplateItemMappingOptions>;
}

export function newScheduleTemplate(
  options: ScheduleTemplateOptions = {},
  cache: Record<string, any> = {},
): ScheduleTemplate {
  const o = (options.__typename ? options : cache["ScheduleTemplate"] = {}) as ScheduleTemplate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleTemplate";
  o.id = options.id ?? nextFactoryId("ScheduleTemplate");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = options.status ?? ScheduleTemplateStatus.Draft;
  o.statusDetail = enumOrDetailOfScheduleTemplateStatus(options.statusDetail);
  o.stage = options.stage ?? Stage.PreConPlanning;
  o.stageDetail = enumOrDetailOfStage(options.stageDetail);
  o.market = maybeNewOrNull("Market", options.market, cache);
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.developments = (options.developments ?? []).map((i) =>
    maybeNew("Development", i, cache, options.hasOwnProperty("developments"))
  );
  o.itemMappings = (options.itemMappings ?? []).map((i) =>
    maybeNew("ScheduleTemplateItemMapping", i, cache, options.hasOwnProperty("itemMappings"))
  );
  return o;
}

factories["ScheduleTemplate"] = newScheduleTemplate;

export interface SaveScheduleTemplatesResultOptions {
  __typename?: "SaveScheduleTemplatesResult";
  scheduleTemplates?: Array<ScheduleTemplate | ScheduleTemplateOptions>;
  userErrors?: Array<UserError | UserErrorOptions> | null;
}

export function newSaveScheduleTemplatesResult(
  options: SaveScheduleTemplatesResultOptions = {},
  cache: Record<string, any> = {},
): SaveScheduleTemplatesResult {
  const o = (options.__typename ? options : cache["SaveScheduleTemplatesResult"] = {}) as SaveScheduleTemplatesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScheduleTemplatesResult";
  o.scheduleTemplates = (options.scheduleTemplates ?? []).map((i) =>
    maybeNew("ScheduleTemplate", i, cache, options.hasOwnProperty("scheduleTemplates"))
  );
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["SaveScheduleTemplatesResult"] = newSaveScheduleTemplatesResult;

export interface DuplicateScheduleTemplateResultOptions {
  __typename?: "DuplicateScheduleTemplateResult";
  scheduleTemplate?: ScheduleTemplate | ScheduleTemplateOptions | null;
  userErrors?: Array<UserError | UserErrorOptions> | null;
}

export function newDuplicateScheduleTemplateResult(
  options: DuplicateScheduleTemplateResultOptions = {},
  cache: Record<string, any> = {},
): DuplicateScheduleTemplateResult {
  const o =
    (options.__typename ? options : cache["DuplicateScheduleTemplateResult"] = {}) as DuplicateScheduleTemplateResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DuplicateScheduleTemplateResult";
  o.scheduleTemplate = maybeNewOrNull("ScheduleTemplate", options.scheduleTemplate, cache);
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["DuplicateScheduleTemplateResult"] = newDuplicateScheduleTemplateResult;

export interface ApplyScheduleTemplatesResultOptions {
  __typename?: "ApplyScheduleTemplatesResult";
  scheduleParents?: Array<
    | ScheduleParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<ScheduleTemplateOptions>
  >;
  schedules?: Array<Schedule | ScheduleOptions>;
}

export function newApplyScheduleTemplatesResult(
  options: ApplyScheduleTemplatesResultOptions = {},
  cache: Record<string, any> = {},
): ApplyScheduleTemplatesResult {
  const o = (options.__typename ? options : cache["ApplyScheduleTemplatesResult"] = {}) as ApplyScheduleTemplatesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ApplyScheduleTemplatesResult";
  o.scheduleParents = (options.scheduleParents ?? []).map((i) =>
    maybeNew(i?.__typename ?? "{StandaloneProject", i, cache, options.hasOwnProperty("scheduleParents"))
  );
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  return o;
}

factories["ApplyScheduleTemplatesResult"] = newApplyScheduleTemplatesResult;

export interface ScheduleTemplateItemMappingOptions {
  __typename?: "ScheduleTemplateItemMapping";
  id?: ScheduleTemplateItemMapping["id"];
  createdAt?: ScheduleTemplateItemMapping["createdAt"];
  updatedAt?: ScheduleTemplateItemMapping["updatedAt"];
  costType?: CostTypeDetailOptions | CostType;
  item?: Item | ItemOptions;
  location?: Location | LocationOptions;
  scheduleTemplate?: ScheduleTemplate | ScheduleTemplateOptions;
  task?: Task | TaskOptions;
}

export function newScheduleTemplateItemMapping(
  options: ScheduleTemplateItemMappingOptions = {},
  cache: Record<string, any> = {},
): ScheduleTemplateItemMapping {
  const o = (options.__typename ? options : cache["ScheduleTemplateItemMapping"] = {}) as ScheduleTemplateItemMapping;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleTemplateItemMapping";
  o.id = options.id ?? nextFactoryId("ScheduleTemplateItemMapping");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costType = enumOrDetailOfCostType(options.costType);
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.scheduleTemplate = maybeNew(
    "ScheduleTemplate",
    options.scheduleTemplate,
    cache,
    options.hasOwnProperty("scheduleTemplate"),
  );
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  return o;
}

factories["ScheduleTemplateItemMapping"] = newScheduleTemplateItemMapping;

export interface SaveScheduleTemplateItemMappingsResultOptions {
  __typename?: "SaveScheduleTemplateItemMappingsResult";
  scheduleTemplateItemMappings?: Array<ScheduleTemplateItemMapping | ScheduleTemplateItemMappingOptions>;
}

export function newSaveScheduleTemplateItemMappingsResult(
  options: SaveScheduleTemplateItemMappingsResultOptions = {},
  cache: Record<string, any> = {},
): SaveScheduleTemplateItemMappingsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveScheduleTemplateItemMappingsResult"] = {}) as SaveScheduleTemplateItemMappingsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScheduleTemplateItemMappingsResult";
  o.scheduleTemplateItemMappings = (options.scheduleTemplateItemMappings ?? []).map((i) =>
    maybeNew("ScheduleTemplateItemMapping", i, cache, options.hasOwnProperty("scheduleTemplateItemMappings"))
  );
  return o;
}

factories["SaveScheduleTemplateItemMappingsResult"] = newSaveScheduleTemplateItemMappingsResult;

export interface SchedulingExclusionDateOptions {
  __typename?: "SchedulingExclusionDate";
  id?: SchedulingExclusionDate["id"];
  date?: SchedulingExclusionDate["date"];
  name?: SchedulingExclusionDate["name"];
  createdAt?: SchedulingExclusionDate["createdAt"];
  updatedAt?: SchedulingExclusionDate["updatedAt"];
  parent?:
    | SchedulingExclusionDateParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>;
}

export function newSchedulingExclusionDate(
  options: SchedulingExclusionDateOptions = {},
  cache: Record<string, any> = {},
): SchedulingExclusionDate {
  const o = (options.__typename ? options : cache["SchedulingExclusionDate"] = {}) as SchedulingExclusionDate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SchedulingExclusionDate";
  o.id = options.id ?? nextFactoryId("SchedulingExclusionDate");
  o.date = options.date ?? newDate();
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  return o;
}

factories["SchedulingExclusionDate"] = newSchedulingExclusionDate;

export interface ScopeChangeReasonOptions {
  __typename?: "ScopeChangeReason";
  id?: ScopeChangeReason["id"];
  name?: ScopeChangeReason["name"];
  createdAt?: ScopeChangeReason["createdAt"];
  updatedAt?: ScopeChangeReason["updatedAt"];
}

export function newScopeChangeReason(
  options: ScopeChangeReasonOptions = {},
  cache: Record<string, any> = {},
): ScopeChangeReason {
  const o = (options.__typename ? options : cache["ScopeChangeReason"] = {}) as ScopeChangeReason;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScopeChangeReason";
  o.id = options.id ?? nextFactoryId("ScopeChangeReason");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  return o;
}

factories["ScopeChangeReason"] = newScopeChangeReason;

export interface SaveScopeChangeReasonResultOptions {
  __typename?: "SaveScopeChangeReasonResult";
  scopeChangeReason?: ScopeChangeReason | ScopeChangeReasonOptions;
}

export function newSaveScopeChangeReasonResult(
  options: SaveScopeChangeReasonResultOptions = {},
  cache: Record<string, any> = {},
): SaveScopeChangeReasonResult {
  const o = (options.__typename ? options : cache["SaveScopeChangeReasonResult"] = {}) as SaveScopeChangeReasonResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScopeChangeReasonResult";
  o.scopeChangeReason = maybeNew(
    "ScopeChangeReason",
    options.scopeChangeReason,
    cache,
    options.hasOwnProperty("scopeChangeReason"),
  );
  return o;
}

factories["SaveScopeChangeReasonResult"] = newSaveScopeChangeReasonResult;

export interface SiteSpecificInfoOptions {
  __typename?: "SiteSpecificInfo";
  id?: SiteSpecificInfo["id"];
  description?: SiteSpecificInfo["description"];
  createdAt?: SiteSpecificInfo["createdAt"];
  updatedAt?: SiteSpecificInfo["updatedAt"];
}

export function newSiteSpecificInfo(
  options: SiteSpecificInfoOptions = {},
  cache: Record<string, any> = {},
): SiteSpecificInfo {
  const o = (options.__typename ? options : cache["SiteSpecificInfo"] = {}) as SiteSpecificInfo;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SiteSpecificInfo";
  o.id = options.id ?? nextFactoryId("SiteSpecificInfo");
  o.description = options.description ?? "description";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  return o;
}

factories["SiteSpecificInfo"] = newSiteSpecificInfo;

export interface SaveSiteSpecificInfoResultOptions {
  __typename?: "SaveSiteSpecificInfoResult";
  siteSpecificInfo?: SiteSpecificInfo | SiteSpecificInfoOptions;
}

export function newSaveSiteSpecificInfoResult(
  options: SaveSiteSpecificInfoResultOptions = {},
  cache: Record<string, any> = {},
): SaveSiteSpecificInfoResult {
  const o = (options.__typename ? options : cache["SaveSiteSpecificInfoResult"] = {}) as SaveSiteSpecificInfoResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveSiteSpecificInfoResult";
  o.siteSpecificInfo = maybeNew(
    "SiteSpecificInfo",
    options.siteSpecificInfo,
    cache,
    options.hasOwnProperty("siteSpecificInfo"),
  );
  return o;
}

factories["SaveSiteSpecificInfoResult"] = newSaveSiteSpecificInfoResult;

export interface SaveStructureResultOptions {
  __typename?: "SaveStructureResult";
  structure?: Structure | StructureOptions;
}

export function newSaveStructureResult(
  options: SaveStructureResultOptions = {},
  cache: Record<string, any> = {},
): SaveStructureResult {
  const o = (options.__typename ? options : cache["SaveStructureResult"] = {}) as SaveStructureResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveStructureResult";
  o.structure = maybeNew("Structure", options.structure, cache, options.hasOwnProperty("structure"));
  return o;
}

factories["SaveStructureResult"] = newSaveStructureResult;

export interface StructuresPageResultOptions {
  __typename?: "StructuresPageResult";
  entities?: Array<Structure | StructureOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newStructuresPageResult(
  options: StructuresPageResultOptions = {},
  cache: Record<string, any> = {},
): StructuresPageResult {
  const o = (options.__typename ? options : cache["StructuresPageResult"] = {}) as StructuresPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "StructuresPageResult";
  o.entities = (options.entities ?? []).map((i) => maybeNew("Structure", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["StructuresPageResult"] = newStructuresPageResult;

export interface SaveSubdivisionResultOptions {
  __typename?: "SaveSubdivisionResult";
  subdivision?: Subdivision | SubdivisionOptions;
}

export function newSaveSubdivisionResult(
  options: SaveSubdivisionResultOptions = {},
  cache: Record<string, any> = {},
): SaveSubdivisionResult {
  const o = (options.__typename ? options : cache["SaveSubdivisionResult"] = {}) as SaveSubdivisionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveSubdivisionResult";
  o.subdivision = maybeNew("Subdivision", options.subdivision, cache, options.hasOwnProperty("subdivision"));
  return o;
}

factories["SaveSubdivisionResult"] = newSaveSubdivisionResult;

export interface SubmarketOptions {
  __typename?: "Submarket";
  id?: Submarket["id"];
  name?: Submarket["name"];
  createdAt?: Submarket["createdAt"];
  updatedAt?: Submarket["updatedAt"];
  market?: Market | MarketOptions;
}

export function newSubmarket(options: SubmarketOptions = {}, cache: Record<string, any> = {}): Submarket {
  const o = (options.__typename ? options : cache["Submarket"] = {}) as Submarket;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Submarket";
  o.id = options.id ?? nextFactoryId("Submarket");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  return o;
}

factories["Submarket"] = newSubmarket;

export interface SaveSubmarketResultOptions {
  __typename?: "SaveSubmarketResult";
  submarket?: Submarket | SubmarketOptions;
}

export function newSaveSubmarketResult(
  options: SaveSubmarketResultOptions = {},
  cache: Record<string, any> = {},
): SaveSubmarketResult {
  const o = (options.__typename ? options : cache["SaveSubmarketResult"] = {}) as SaveSubmarketResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveSubmarketResult";
  o.submarket = maybeNew("Submarket", options.submarket, cache, options.hasOwnProperty("submarket"));
  return o;
}

factories["SaveSubmarketResult"] = newSaveSubmarketResult;

export interface CopyTakeoffLineItemsResultOptions {
  __typename?: "CopyTakeoffLineItemsResult";
  targetReadyPlan?: ReadyPlan | ReadyPlanOptions;
  sourceReadyPlans?: Array<ReadyPlan | ReadyPlanOptions>;
  sourceItems?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  copiedItems?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
}

export function newCopyTakeoffLineItemsResult(
  options: CopyTakeoffLineItemsResultOptions = {},
  cache: Record<string, any> = {},
): CopyTakeoffLineItemsResult {
  const o = (options.__typename ? options : cache["CopyTakeoffLineItemsResult"] = {}) as CopyTakeoffLineItemsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CopyTakeoffLineItemsResult";
  o.targetReadyPlan = maybeNew("ReadyPlan", options.targetReadyPlan, cache, options.hasOwnProperty("targetReadyPlan"));
  o.sourceReadyPlans = (options.sourceReadyPlans ?? []).map((i) =>
    maybeNew("ReadyPlan", i, cache, options.hasOwnProperty("sourceReadyPlans"))
  );
  o.sourceItems = (options.sourceItems ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("sourceItems"))
  );
  o.copiedItems = (options.copiedItems ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("copiedItems"))
  );
  return o;
}

factories["CopyTakeoffLineItemsResult"] = newCopyTakeoffLineItemsResult;

export interface TakeoffLineItemsPageOptions {
  __typename?: "TakeoffLineItemsPage";
  items?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
  groupTotals?: Array<TakeoffLineItemGroupTotal | TakeoffLineItemGroupTotalOptions>;
}

export function newTakeoffLineItemsPage(
  options: TakeoffLineItemsPageOptions = {},
  cache: Record<string, any> = {},
): TakeoffLineItemsPage {
  const o = (options.__typename ? options : cache["TakeoffLineItemsPage"] = {}) as TakeoffLineItemsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TakeoffLineItemsPage";
  o.items = (options.items ?? []).map((i) => maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("items")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  o.groupTotals = (options.groupTotals ?? []).map((i) =>
    maybeNew("TakeoffLineItemGroupTotal", i, cache, options.hasOwnProperty("groupTotals"))
  );
  return o;
}

factories["TakeoffLineItemsPage"] = newTakeoffLineItemsPage;

export interface TakeoffLineItemGroupTotalOptions {
  __typename?: "TakeoffLineItemGroupTotal";
  groupId?: TakeoffLineItemGroupTotal["groupId"];
  totalCostInCents?: TakeoffLineItemGroupTotal["totalCostInCents"];
  tlisInGroup?: TakeoffLineItemGroupTotal["tlisInGroup"];
  tliIdsInGroup?: TakeoffLineItemGroupTotal["tliIdsInGroup"];
  activeTliIdsInGroup?: TakeoffLineItemGroupTotal["activeTliIdsInGroup"];
  displayName?: TakeoffLineItemGroupTotal["displayName"];
  materialsInGroup?: TakeoffLineItemGroupTotal["materialsInGroup"];
  tasksInGroup?: TakeoffLineItemGroupTotal["tasksInGroup"];
}

export function newTakeoffLineItemGroupTotal(
  options: TakeoffLineItemGroupTotalOptions = {},
  cache: Record<string, any> = {},
): TakeoffLineItemGroupTotal {
  const o = (options.__typename ? options : cache["TakeoffLineItemGroupTotal"] = {}) as TakeoffLineItemGroupTotal;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TakeoffLineItemGroupTotal";
  o.groupId = options.groupId ?? "groupId";
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.tlisInGroup = options.tlisInGroup ?? 0;
  o.tliIdsInGroup = options.tliIdsInGroup ?? [];
  o.activeTliIdsInGroup = options.activeTliIdsInGroup ?? [];
  o.displayName = options.displayName ?? "displayName";
  o.materialsInGroup = options.materialsInGroup ?? 0;
  o.tasksInGroup = options.tasksInGroup ?? 0;
  return o;
}

factories["TakeoffLineItemGroupTotal"] = newTakeoffLineItemGroupTotal;

export interface TakeoffLineItemOptions {
  __typename?: "TakeoffLineItem";
  id?: TakeoffLineItem["id"];
  identityId?: TakeoffLineItem["identityId"];
  active?: TakeoffLineItem["active"];
  name?: TakeoffLineItem["name"];
  displayName?: TakeoffLineItem["displayName"];
  parent?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  customPlaceholderName?: TakeoffLineItem["customPlaceholderName"];
  quantity?: TakeoffLineItem["quantity"];
  totalCostInCents?: TakeoffLineItem["totalCostInCents"];
  unitCostInCents?: TakeoffLineItem["unitCostInCents"];
  isDisabledMaterialVariant?: TakeoffLineItem["isDisabledMaterialVariant"];
  tradePartnerNote?: TakeoffLineItem["tradePartnerNote"];
  internalNote?: TakeoffLineItem["internalNote"];
  specifications?: TakeoffLineItem["specifications"];
  createdAt?: TakeoffLineItem["createdAt"];
  updatedAt?: TakeoffLineItem["updatedAt"];
  costType?: TakeoffLineItem["costType"];
  costTypeDetail?: CostTypeDetailOptions | CostType;
  costStatus?: ItemTemplateItemCostStatusDetailOptions | ItemTemplateItemCostStatus;
  placeholder?: TakeoffLineItem | TakeoffLineItemOptions | null;
  preferredBidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  bidItem?: BidItem | BidItemOptions | null;
  bidItemTemplateItem?: TakeoffLineItem | TakeoffLineItemOptions | null;
  development?: Development | DevelopmentOptions | null;
  drop?: Drop | DropOptions | null;
  item?: Item | ItemOptions;
  slot?: ItemSlot | ItemSlotOptions;
  location?: Location | LocationOptions;
  materialVariant?: MaterialVariant | MaterialVariantOptions | null;
  task?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  products?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  rootAssemblyItem?: TakeoffLineItem | TakeoffLineItemOptions | null;
  assemblyRootItem?: TakeoffLineItem | TakeoffLineItemOptions | null;
  childItems?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  canEditLocation?: PotentialOperation2 | PotentialOperation2Options;
  canEditOptions?: PotentialOperation2 | PotentialOperation2Options;
  canEditQuantity?: PotentialOperation2 | PotentialOperation2Options;
  canEditMaterial?: PotentialOperation2 | PotentialOperation2Options;
  canDuplicate?: PotentialOperation2 | PotentialOperation2Options;
  canDeleteFromDesignPackage?: PotentialOperation2 | PotentialOperation2Options;
  canHaveActiveProductCards?: PotentialOperation2 | PotentialOperation2Options;
  dpSignature?: TakeoffLineItem["dpSignature"];
  blueprintUrl?: Url | UrlOptions;
  elevationIds?: TakeoffLineItem["elevationIds"];
  specOptionIds?: TakeoffLineItem["specOptionIds"];
  otherOptionIds?: TakeoffLineItem["otherOptionIds"];
  costEstimate?: CostEstimate | CostEstimateOptions;
  isPlaceholderMaterial?: TakeoffLineItem["isPlaceholderMaterial"];
  isProductMaterial?: TakeoffLineItem["isProductMaterial"];
  changeType?: TakeoffLineItem["changeType"];
  previous?: TakeoffLineItemVersion | TakeoffLineItemVersionOptions | null;
  planLines?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  personalizationOptionGroup?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions | null;
  personalizationPlaceholderControlledSlots?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  personalizationShadowPlaceholder?: TakeoffLineItem | TakeoffLineItemOptions | null;
  personalizationIdpShadowPlaceholder?: TakeoffLineItem | TakeoffLineItemOptions | null;
  personalizationRpoShadowPlaceholder?: TakeoffLineItem | TakeoffLineItemOptions | null;
  designPackageType?: TakeoffLineItemDesignPackageTypeDetailOptions | TakeoffLineItemDesignPackageType | null;
  targetGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  targetCombinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
  missingCombinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
  designNotes?: Array<ReadyPlanDesignNote | ReadyPlanDesignNoteOptions>;
  packageDesignNotes?: TakeoffLineItem["packageDesignNotes"];
  targetPlan?: PlanPackage | PlanPackageOptions | null;
  personalizationSlotOrder?: TakeoffLineItem["personalizationSlotOrder"];
  isTaxExempt?: TakeoffLineItem["isTaxExempt"];
  taxableCostInCents?: TakeoffLineItem["taxableCostInCents"];
  taxInCents?: TakeoffLineItem["taxInCents"];
  planPackageIncomingSlots?: Array<PlanPackageIncomingSlot | PlanPackageIncomingSlotOptions>;
  managingBidPackage?: BidPackage | BidPackageOptions | null;
  action?: TakeoffLineItemActionDetailOptions | TakeoffLineItemAction;
  missingPlanPackages?: Array<PlanPackage | PlanPackageOptions>;
}

export function newTakeoffLineItem(
  options: TakeoffLineItemOptions = {},
  cache: Record<string, any> = {},
): TakeoffLineItem {
  const o = (options.__typename ? options : cache["TakeoffLineItem"] = {}) as TakeoffLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TakeoffLineItem";
  o.id = options.id ?? nextFactoryId("TakeoffLineItem");
  o.identityId = options.identityId ?? "identityId";
  o.active = options.active ?? false;
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.parent = maybeNew("ReadyPlanLike", options.parent, cache, options.hasOwnProperty("parent"));
  o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.customPlaceholderName = options.customPlaceholderName ?? null;
  o.quantity = options.quantity ?? null;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.unitCostInCents = options.unitCostInCents ?? 0;
  o.isDisabledMaterialVariant = options.isDisabledMaterialVariant ?? false;
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.internalNote = options.internalNote ?? null;
  o.specifications = options.specifications ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costType = options.costType ?? CostType.Labor;
  o.costTypeDetail = enumOrDetailOfCostType(options.costTypeDetail);
  o.costStatus = enumOrDetailOfItemTemplateItemCostStatus(options.costStatus);
  o.placeholder = maybeNewOrNull("TakeoffLineItem", options.placeholder, cache);
  o.preferredBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.preferredBidContractLineItem, cache);
  o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
  o.bidItemTemplateItem = maybeNewOrNull("TakeoffLineItem", options.bidItemTemplateItem, cache);
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.drop = maybeNewOrNull("Drop", options.drop, cache);
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
  o.task = maybeNewOrNull("GlobalPlanTask", options.task, cache);
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.products = (options.products ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("products"))
  );
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.rootAssemblyItem = maybeNewOrNull("TakeoffLineItem", options.rootAssemblyItem, cache);
  o.assemblyRootItem = maybeNewOrNull("TakeoffLineItem", options.assemblyRootItem, cache);
  o.childItems = (options.childItems ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("childItems"))
  );
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.canEditLocation = maybeNew(
    "PotentialOperation2",
    options.canEditLocation,
    cache,
    options.hasOwnProperty("canEditLocation"),
  );
  o.canEditOptions = maybeNew(
    "PotentialOperation2",
    options.canEditOptions,
    cache,
    options.hasOwnProperty("canEditOptions"),
  );
  o.canEditQuantity = maybeNew(
    "PotentialOperation2",
    options.canEditQuantity,
    cache,
    options.hasOwnProperty("canEditQuantity"),
  );
  o.canEditMaterial = maybeNew(
    "PotentialOperation2",
    options.canEditMaterial,
    cache,
    options.hasOwnProperty("canEditMaterial"),
  );
  o.canDuplicate = maybeNew("PotentialOperation2", options.canDuplicate, cache, options.hasOwnProperty("canDuplicate"));
  o.canDeleteFromDesignPackage = maybeNew(
    "PotentialOperation2",
    options.canDeleteFromDesignPackage,
    cache,
    options.hasOwnProperty("canDeleteFromDesignPackage"),
  );
  o.canHaveActiveProductCards = maybeNew(
    "PotentialOperation2",
    options.canHaveActiveProductCards,
    cache,
    options.hasOwnProperty("canHaveActiveProductCards"),
  );
  o.dpSignature = options.dpSignature ?? "dpSignature";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.elevationIds = options.elevationIds ?? [];
  o.specOptionIds = options.specOptionIds ?? [];
  o.otherOptionIds = options.otherOptionIds ?? [];
  o.costEstimate = maybeNew("CostEstimate", options.costEstimate, cache, options.hasOwnProperty("costEstimate"));
  o.isPlaceholderMaterial = options.isPlaceholderMaterial ?? false;
  o.isProductMaterial = options.isProductMaterial ?? false;
  o.changeType = options.changeType ?? "changeType";
  o.previous = maybeNewOrNull("TakeoffLineItemVersion", options.previous, cache);
  o.planLines = (options.planLines ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("planLines"))
  );
  o.personalizationOptionGroup = maybeNewOrNull("ReadyPlanOptionGroup", options.personalizationOptionGroup, cache);
  o.personalizationPlaceholderControlledSlots = (options.personalizationPlaceholderControlledSlots ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("personalizationPlaceholderControlledSlots"))
  );
  o.personalizationShadowPlaceholder = maybeNewOrNull(
    "TakeoffLineItem",
    options.personalizationShadowPlaceholder,
    cache,
  );
  o.personalizationIdpShadowPlaceholder = maybeNewOrNull(
    "TakeoffLineItem",
    options.personalizationIdpShadowPlaceholder,
    cache,
  );
  o.personalizationRpoShadowPlaceholder = maybeNewOrNull(
    "TakeoffLineItem",
    options.personalizationRpoShadowPlaceholder,
    cache,
  );
  o.designPackageType = enumOrDetailOrNullOfTakeoffLineItemDesignPackageType(options.designPackageType);
  o.targetGroups = (options.targetGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("targetGroups"))
  );
  o.targetCombinations = (options.targetCombinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("targetCombinations"))
  );
  o.missingCombinations = (options.missingCombinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("missingCombinations"))
  );
  o.designNotes = (options.designNotes ?? []).map((i) =>
    maybeNew("ReadyPlanDesignNote", i, cache, options.hasOwnProperty("designNotes"))
  );
  o.packageDesignNotes = options.packageDesignNotes ?? null;
  o.targetPlan = maybeNewOrNull("PlanPackage", options.targetPlan, cache);
  o.personalizationSlotOrder = options.personalizationSlotOrder ?? null;
  o.isTaxExempt = options.isTaxExempt ?? false;
  o.taxableCostInCents = options.taxableCostInCents ?? 0;
  o.taxInCents = options.taxInCents ?? 0;
  o.planPackageIncomingSlots = (options.planPackageIncomingSlots ?? []).map((i) =>
    maybeNew("PlanPackageIncomingSlot", i, cache, options.hasOwnProperty("planPackageIncomingSlots"))
  );
  o.managingBidPackage = maybeNewOrNull("BidPackage", options.managingBidPackage, cache);
  o.action = enumOrDetailOfTakeoffLineItemAction(options.action);
  o.missingPlanPackages = (options.missingPlanPackages ?? []).map((i) =>
    maybeNew("PlanPackage", i, cache, options.hasOwnProperty("missingPlanPackages"))
  );
  return o;
}

factories["TakeoffLineItem"] = newTakeoffLineItem;

export interface SaveTakeoffLineItemResultOptions {
  __typename?: "SaveTakeoffLineItemResult";
  version?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  takeoffLineItems?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  autoAddedLaborLines?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  removed?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  deleted?: SaveTakeoffLineItemResult["deleted"];
  groupTotals?: Array<TakeoffLineItemGroupTotal | TakeoffLineItemGroupTotalOptions>;
}

export function newSaveTakeoffLineItemResult(
  options: SaveTakeoffLineItemResultOptions = {},
  cache: Record<string, any> = {},
): SaveTakeoffLineItemResult {
  const o = (options.__typename ? options : cache["SaveTakeoffLineItemResult"] = {}) as SaveTakeoffLineItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTakeoffLineItemResult";
  o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
  o.takeoffLineItems = (options.takeoffLineItems ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("takeoffLineItems"))
  );
  o.autoAddedLaborLines = (options.autoAddedLaborLines ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("autoAddedLaborLines"))
  );
  o.removed = (options.removed ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("removed"))
  );
  o.deleted = options.deleted ?? [];
  o.groupTotals = (options.groupTotals ?? []).map((i) =>
    maybeNew("TakeoffLineItemGroupTotal", i, cache, options.hasOwnProperty("groupTotals"))
  );
  return o;
}

factories["SaveTakeoffLineItemResult"] = newSaveTakeoffLineItemResult;

export interface TakeoffLineItemVersionOptions {
  __typename?: "TakeoffLineItemVersion";
  id?: TakeoffLineItemVersion["id"];
  identityId?: TakeoffLineItemVersion["identityId"];
  quantity?: TakeoffLineItemVersion["quantity"];
  createdAt?: TakeoffLineItemVersion["createdAt"];
  updatedAt?: TakeoffLineItemVersion["updatedAt"];
  specifications?: TakeoffLineItemVersion["specifications"];
  totalCostInCents?: TakeoffLineItemVersion["totalCostInCents"];
  unitCostInCents?: TakeoffLineItemVersion["unitCostInCents"];
  tradePartnerNote?: TakeoffLineItemVersion["tradePartnerNote"];
  internalNote?: TakeoffLineItemVersion["internalNote"];
  name?: TakeoffLineItemVersion["name"];
  displayName?: TakeoffLineItemVersion["displayName"];
  parent?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  isDisabledMaterialVariant?: TakeoffLineItemVersion["isDisabledMaterialVariant"];
  placeholder?: TakeoffLineItem | TakeoffLineItemOptions | null;
  customPlaceholderName?: TakeoffLineItemVersion["customPlaceholderName"];
  costType?: TakeoffLineItemVersion["costType"];
  costTypeDetail?: CostTypeDetailOptions | CostType;
  type?: TakeoffLineItemTypeDetailOptions | TakeoffLineItemType;
  preferredBidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  bidItem?: BidItem | BidItemOptions | null;
  bidItemTemplateItem?: TakeoffLineItemVersion | TakeoffLineItemVersionOptions | null;
  item?: Item | ItemOptions;
  slot?: ItemSlot | ItemSlotOptions;
  location?: Location | LocationOptions;
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  dpSignature?: TakeoffLineItemVersion["dpSignature"];
  canDeleteFromDesignPackage?: PotentialOperation2 | PotentialOperation2Options;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  costStatus?: ItemTemplateItemCostStatusDetailOptions | ItemTemplateItemCostStatus | null;
  development?: Development | DevelopmentOptions | null;
  drop?: Drop | DropOptions | null;
  task?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  materialVariant?: MaterialVariant | MaterialVariantOptions | null;
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  identity?: TakeoffLineItem | TakeoffLineItemOptions;
  active?: TakeoffLineItemVersion["active"];
  blueprintUrl?: Url | UrlOptions;
  elevationIds?: TakeoffLineItemVersion["elevationIds"];
  specOptionIds?: TakeoffLineItemVersion["specOptionIds"];
  otherOptionIds?: TakeoffLineItemVersion["otherOptionIds"];
  costEstimate?: CostEstimate | CostEstimateOptions;
  changeType?: TakeoffLineItemVersion["changeType"];
  planLines?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  targetGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  targetCombinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
  missingCombinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
  packageDesignNotes?: TakeoffLineItemVersion["packageDesignNotes"];
  isTaxExempt?: TakeoffLineItemVersion["isTaxExempt"];
  taxableCostInCents?: TakeoffLineItemVersion["taxableCostInCents"];
  taxInCents?: TakeoffLineItemVersion["taxInCents"];
  action?: TakeoffLineItemActionDetailOptions | TakeoffLineItemAction;
}

export function newTakeoffLineItemVersion(
  options: TakeoffLineItemVersionOptions = {},
  cache: Record<string, any> = {},
): TakeoffLineItemVersion {
  const o = (options.__typename ? options : cache["TakeoffLineItemVersion"] = {}) as TakeoffLineItemVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TakeoffLineItemVersion";
  o.id = options.id ?? nextFactoryId("TakeoffLineItemVersion");
  o.identityId = options.identityId ?? "identityId";
  o.quantity = options.quantity ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.specifications = options.specifications ?? null;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.unitCostInCents = options.unitCostInCents ?? 0;
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.internalNote = options.internalNote ?? null;
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.parent = maybeNew("ReadyPlanLike", options.parent, cache, options.hasOwnProperty("parent"));
  o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.isDisabledMaterialVariant = options.isDisabledMaterialVariant ?? false;
  o.placeholder = maybeNewOrNull("TakeoffLineItem", options.placeholder, cache);
  o.customPlaceholderName = options.customPlaceholderName ?? null;
  o.costType = options.costType ?? CostType.Labor;
  o.costTypeDetail = enumOrDetailOfCostType(options.costTypeDetail);
  o.type = enumOrDetailOfTakeoffLineItemType(options.type);
  o.preferredBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.preferredBidContractLineItem, cache);
  o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
  o.bidItemTemplateItem = maybeNewOrNull("TakeoffLineItemVersion", options.bidItemTemplateItem, cache);
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.dpSignature = options.dpSignature ?? "dpSignature";
  o.canDeleteFromDesignPackage = maybeNew(
    "PotentialOperation2",
    options.canDeleteFromDesignPackage,
    cache,
    options.hasOwnProperty("canDeleteFromDesignPackage"),
  );
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.costStatus = enumOrDetailOrNullOfItemTemplateItemCostStatus(options.costStatus);
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.drop = maybeNewOrNull("Drop", options.drop, cache);
  o.task = maybeNewOrNull("GlobalPlanTask", options.task, cache);
  o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.identity = maybeNew("TakeoffLineItem", options.identity, cache, options.hasOwnProperty("identity"));
  o.active = options.active ?? false;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.elevationIds = options.elevationIds ?? [];
  o.specOptionIds = options.specOptionIds ?? [];
  o.otherOptionIds = options.otherOptionIds ?? [];
  o.costEstimate = maybeNew("CostEstimate", options.costEstimate, cache, options.hasOwnProperty("costEstimate"));
  o.changeType = options.changeType ?? "changeType";
  o.planLines = (options.planLines ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("planLines"))
  );
  o.targetGroups = (options.targetGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("targetGroups"))
  );
  o.targetCombinations = (options.targetCombinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("targetCombinations"))
  );
  o.missingCombinations = (options.missingCombinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("missingCombinations"))
  );
  o.packageDesignNotes = options.packageDesignNotes ?? null;
  o.isTaxExempt = options.isTaxExempt ?? false;
  o.taxableCostInCents = options.taxableCostInCents ?? 0;
  o.taxInCents = options.taxInCents ?? 0;
  o.action = enumOrDetailOfTakeoffLineItemAction(options.action);
  return o;
}

factories["TakeoffLineItemVersion"] = newTakeoffLineItemVersion;

export interface TaskPageOptions {
  __typename?: "TaskPage";
  tasks?: Array<Task | TaskOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newTaskPage(options: TaskPageOptions = {}, cache: Record<string, any> = {}): TaskPage {
  const o = (options.__typename ? options : cache["TaskPage"] = {}) as TaskPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TaskPage";
  o.tasks = (options.tasks ?? []).map((i) => maybeNew("Task", i, cache, options.hasOwnProperty("tasks")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["TaskPage"] = newTaskPage;

export interface TaskDependencyOptions {
  __typename?: "TaskDependency";
  type?: TaskDependency["type"];
  typeDetail?: TaskDependencyTypeDetailOptions | TaskDependencyType;
  lagInDays?: TaskDependency["lagInDays"];
  predecessor?: Task | TaskOptions;
  successor?: Task | TaskOptions;
}

export function newTaskDependency(
  options: TaskDependencyOptions = {},
  cache: Record<string, any> = {},
): TaskDependency {
  const o = (options.__typename ? options : cache["TaskDependency"] = {}) as TaskDependency;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TaskDependency";
  o.type = options.type ?? TaskDependencyType.FinishStart;
  o.typeDetail = enumOrDetailOfTaskDependencyType(options.typeDetail);
  o.lagInDays = options.lagInDays ?? 0;
  o.predecessor = maybeNew("Task", options.predecessor, cache, options.hasOwnProperty("predecessor"));
  o.successor = maybeNew("Task", options.successor, cache, options.hasOwnProperty("successor"));
  return o;
}

factories["TaskDependency"] = newTaskDependency;

export interface TaskSnapshotOptions {
  __typename?: "TaskSnapshot";
  id?: TaskSnapshot["id"];
  range?: TaskSnapshot["range"];
  startDate?: TaskSnapshot["startDate"];
  endDate?: TaskSnapshot["endDate"];
  durationInDays?: TaskSnapshot["durationInDays"];
  createdAt?: TaskSnapshot["createdAt"];
  updatedAt?: TaskSnapshot["updatedAt"];
  task?: Task | TaskOptions;
}

export function newTaskSnapshot(options: TaskSnapshotOptions = {}, cache: Record<string, any> = {}): TaskSnapshot {
  const o = (options.__typename ? options : cache["TaskSnapshot"] = {}) as TaskSnapshot;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TaskSnapshot";
  o.id = options.id ?? nextFactoryId("TaskSnapshot");
  o.range = options.range ?? "range";
  o.startDate = options.startDate ?? newDate();
  o.endDate = options.endDate ?? newDate();
  o.durationInDays = options.durationInDays ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  return o;
}

factories["TaskSnapshot"] = newTaskSnapshot;

export interface TaskWorkDayOptions {
  __typename?: "TaskWorkDay";
  id?: TaskWorkDay["id"];
  workDay?: TaskWorkDay["workDay"];
  createdAt?: TaskWorkDay["createdAt"];
  updatedAt?: TaskWorkDay["updatedAt"];
  task?: Task | TaskOptions;
}

export function newTaskWorkDay(options: TaskWorkDayOptions = {}, cache: Record<string, any> = {}): TaskWorkDay {
  const o = (options.__typename ? options : cache["TaskWorkDay"] = {}) as TaskWorkDay;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TaskWorkDay";
  o.id = options.id ?? nextFactoryId("TaskWorkDay");
  o.workDay = options.workDay ?? newDate();
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  return o;
}

factories["TaskWorkDay"] = newTaskWorkDay;

export interface SaveTaskWorkDayResultOptions {
  __typename?: "SaveTaskWorkDayResult";
  taskWorkDay?: TaskWorkDay | TaskWorkDayOptions;
}

export function newSaveTaskWorkDayResult(
  options: SaveTaskWorkDayResultOptions = {},
  cache: Record<string, any> = {},
): SaveTaskWorkDayResult {
  const o = (options.__typename ? options : cache["SaveTaskWorkDayResult"] = {}) as SaveTaskWorkDayResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTaskWorkDayResult";
  o.taskWorkDay = maybeNew("TaskWorkDay", options.taskWorkDay, cache, options.hasOwnProperty("taskWorkDay"));
  return o;
}

factories["SaveTaskWorkDayResult"] = newSaveTaskWorkDayResult;

export interface SaveToDosResultOptions {
  __typename?: "SaveToDosResult";
  toDos?: Array<ToDo | ToDoOptions>;
}

export function newSaveToDosResult(
  options: SaveToDosResultOptions = {},
  cache: Record<string, any> = {},
): SaveToDosResult {
  const o = (options.__typename ? options : cache["SaveToDosResult"] = {}) as SaveToDosResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveToDosResult";
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  return o;
}

factories["SaveToDosResult"] = newSaveToDosResult;

export interface ToDoChecklistProgressOptions {
  __typename?: "ToDoChecklistProgress";
  total?: ToDoChecklistProgress["total"];
  completed?: ToDoChecklistProgress["completed"];
}

export function newToDoChecklistProgress(
  options: ToDoChecklistProgressOptions = {},
  cache: Record<string, any> = {},
): ToDoChecklistProgress {
  const o = (options.__typename ? options : cache["ToDoChecklistProgress"] = {}) as ToDoChecklistProgress;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ToDoChecklistProgress";
  o.total = options.total ?? 0;
  o.completed = options.completed ?? 0;
  return o;
}

factories["ToDoChecklistProgress"] = newToDoChecklistProgress;

export interface ToDoChecklistItemOptions {
  __typename?: "ToDoChecklistItem";
  id?: ToDoChecklistItem["id"];
  description?: ToDoChecklistItem["description"];
  createdAt?: ToDoChecklistItem["createdAt"];
  updatedAt?: ToDoChecklistItem["updatedAt"];
  toDo?: ToDo | ToDoOptions;
  isComplete?: ToDoChecklistItem["isComplete"];
}

export function newToDoChecklistItem(
  options: ToDoChecklistItemOptions = {},
  cache: Record<string, any> = {},
): ToDoChecklistItem {
  const o = (options.__typename ? options : cache["ToDoChecklistItem"] = {}) as ToDoChecklistItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ToDoChecklistItem";
  o.id = options.id ?? nextFactoryId("ToDoChecklistItem");
  o.description = options.description ?? "description";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.toDo = maybeNew("ToDo", options.toDo, cache, options.hasOwnProperty("toDo"));
  o.isComplete = options.isComplete ?? false;
  return o;
}

factories["ToDoChecklistItem"] = newToDoChecklistItem;

export interface SaveToDoChecklistItemResultOptions {
  __typename?: "SaveToDoChecklistItemResult";
  toDoChecklistItem?: ToDoChecklistItem | ToDoChecklistItemOptions;
}

export function newSaveToDoChecklistItemResult(
  options: SaveToDoChecklistItemResultOptions = {},
  cache: Record<string, any> = {},
): SaveToDoChecklistItemResult {
  const o = (options.__typename ? options : cache["SaveToDoChecklistItemResult"] = {}) as SaveToDoChecklistItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveToDoChecklistItemResult";
  o.toDoChecklistItem = maybeNew(
    "ToDoChecklistItem",
    options.toDoChecklistItem,
    cache,
    options.hasOwnProperty("toDoChecklistItem"),
  );
  return o;
}

factories["SaveToDoChecklistItemResult"] = newSaveToDoChecklistItemResult;

export interface TrackedJobOptions {
  __typename?: "TrackedJob";
  id?: TrackedJob["id"];
  pollIntervalInMs?: TrackedJob["pollIntervalInMs"];
  progressCurrent?: TrackedJob["progressCurrent"];
  progressTotal?: TrackedJob["progressTotal"];
  progressMessage?: TrackedJob["progressMessage"];
  startedAt?: TrackedJob["startedAt"];
  completedAt?: TrackedJob["completedAt"];
  createdAt?: TrackedJob["createdAt"];
  updatedAt?: TrackedJob["updatedAt"];
  status?: TrackedJobStatusDetailOptions | TrackedJobStatus;
  user?: User | UserOptions;
  result?: TrackedJobResult | AssetOptions | RequireTypename<BillOcrOptions> | null;
  parent?: TrackedJobParent | ProductOfferingOptions | null;
}

export function newTrackedJob(options: TrackedJobOptions = {}, cache: Record<string, any> = {}): TrackedJob {
  const o = (options.__typename ? options : cache["TrackedJob"] = {}) as TrackedJob;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TrackedJob";
  o.id = options.id ?? nextFactoryId("TrackedJob");
  o.pollIntervalInMs = options.pollIntervalInMs ?? 0;
  o.progressCurrent = options.progressCurrent ?? null;
  o.progressTotal = options.progressTotal ?? null;
  o.progressMessage = options.progressMessage ?? null;
  o.startedAt = options.startedAt ?? null;
  o.completedAt = options.completedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = enumOrDetailOfTrackedJobStatus(options.status);
  o.user = maybeNew("User", options.user, cache, options.hasOwnProperty("user"));
  o.result = maybeNewOrNull(options.result?.__typename ?? "Asset", options.result, cache);
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "ProductOffering", options.parent, cache);
  return o;
}

factories["TrackedJob"] = newTrackedJob;

export interface TradeCategoryOptions {
  __typename?: "TradeCategory";
  id?: TradeCategory["id"];
  number?: TradeCategory["number"];
  name?: TradeCategory["name"];
  displayName?: TradeCategory["displayName"];
  createdAt?: TradeCategory["createdAt"];
  updatedAt?: TradeCategory["updatedAt"];
  items?: Array<Item | ItemOptions>;
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  developmentCommitments?: Array<DevelopmentCommitment | DevelopmentCommitmentOptions>;
  leadTimes?: Array<TradeCategoryLeadTime | TradeCategoryLeadTimeOptions>;
}

export function newTradeCategory(options: TradeCategoryOptions = {}, cache: Record<string, any> = {}): TradeCategory {
  const o = (options.__typename ? options : cache["TradeCategory"] = {}) as TradeCategory;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradeCategory";
  o.id = options.id ?? nextFactoryId("TradeCategory");
  o.number = options.number ?? "number";
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.items = (options.items ?? []).map((i) => maybeNew("Item", i, cache, options.hasOwnProperty("items")));
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.developmentCommitments = (options.developmentCommitments ?? []).map((i) =>
    maybeNew("DevelopmentCommitment", i, cache, options.hasOwnProperty("developmentCommitments"))
  );
  o.leadTimes = (options.leadTimes ?? []).map((i) =>
    maybeNew("TradeCategoryLeadTime", i, cache, options.hasOwnProperty("leadTimes"))
  );
  return o;
}

factories["TradeCategory"] = newTradeCategory;

export interface SaveTradeCategoryResultOptions {
  __typename?: "SaveTradeCategoryResult";
  tradeCategory?: TradeCategory | TradeCategoryOptions;
}

export function newSaveTradeCategoryResult(
  options: SaveTradeCategoryResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradeCategoryResult {
  const o = (options.__typename ? options : cache["SaveTradeCategoryResult"] = {}) as SaveTradeCategoryResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradeCategoryResult";
  o.tradeCategory = maybeNew("TradeCategory", options.tradeCategory, cache, options.hasOwnProperty("tradeCategory"));
  return o;
}

factories["SaveTradeCategoryResult"] = newSaveTradeCategoryResult;

export interface TradeCategoryLeadTimeDefaultOptions {
  __typename?: "TradeCategoryLeadTimeDefault";
  leadTimeInDays?: TradeCategoryLeadTimeDefault["leadTimeInDays"];
  market?: Market | MarketOptions;
  tradeCategory?: TradeCategory | TradeCategoryOptions;
  leadTimeFrequency?: TimeFrequencyDetailOptions | TimeFrequency;
}

export function newTradeCategoryLeadTimeDefault(
  options: TradeCategoryLeadTimeDefaultOptions = {},
  cache: Record<string, any> = {},
): TradeCategoryLeadTimeDefault {
  const o = (options.__typename ? options : cache["TradeCategoryLeadTimeDefault"] = {}) as TradeCategoryLeadTimeDefault;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradeCategoryLeadTimeDefault";
  o.leadTimeInDays = options.leadTimeInDays ?? 0;
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.tradeCategory = maybeNew("TradeCategory", options.tradeCategory, cache, options.hasOwnProperty("tradeCategory"));
  o.leadTimeFrequency = enumOrDetailOfTimeFrequency(options.leadTimeFrequency);
  return o;
}

factories["TradeCategoryLeadTimeDefault"] = newTradeCategoryLeadTimeDefault;

export interface TradeCategoryLeadTimeOptions {
  __typename?: "TradeCategoryLeadTime";
  id?: TradeCategoryLeadTime["id"];
  leadTimeInDays?: TradeCategoryLeadTime["leadTimeInDays"];
  createdAt?: TradeCategoryLeadTime["createdAt"];
  updatedAt?: TradeCategoryLeadTime["updatedAt"];
  leadTimeFrequency?: TimeFrequencyDetailOptions | TimeFrequency;
  market?: Market | MarketOptions;
  tradeCategory?: TradeCategory | TradeCategoryOptions;
}

export function newTradeCategoryLeadTime(
  options: TradeCategoryLeadTimeOptions = {},
  cache: Record<string, any> = {},
): TradeCategoryLeadTime {
  const o = (options.__typename ? options : cache["TradeCategoryLeadTime"] = {}) as TradeCategoryLeadTime;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradeCategoryLeadTime";
  o.id = options.id ?? nextFactoryId("TradeCategoryLeadTime");
  o.leadTimeInDays = options.leadTimeInDays ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.leadTimeFrequency = enumOrDetailOfTimeFrequency(options.leadTimeFrequency);
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.tradeCategory = maybeNew("TradeCategory", options.tradeCategory, cache, options.hasOwnProperty("tradeCategory"));
  return o;
}

factories["TradeCategoryLeadTime"] = newTradeCategoryLeadTime;

export interface SaveTradeCategoryLeadTimesResultOptions {
  __typename?: "SaveTradeCategoryLeadTimesResult";
  tradeCategoryLeadTimes?: Array<TradeCategoryLeadTime | TradeCategoryLeadTimeOptions>;
}

export function newSaveTradeCategoryLeadTimesResult(
  options: SaveTradeCategoryLeadTimesResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradeCategoryLeadTimesResult {
  const o =
    (options.__typename ? options : cache["SaveTradeCategoryLeadTimesResult"] = {}) as SaveTradeCategoryLeadTimesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradeCategoryLeadTimesResult";
  o.tradeCategoryLeadTimes = (options.tradeCategoryLeadTimes ?? []).map((i) =>
    maybeNew("TradeCategoryLeadTime", i, cache, options.hasOwnProperty("tradeCategoryLeadTimes"))
  );
  return o;
}

factories["SaveTradeCategoryLeadTimesResult"] = newSaveTradeCategoryLeadTimesResult;

export interface SaveTradePartnerResultOptions {
  __typename?: "SaveTradePartnerResult";
  tradePartner?: TradePartner | TradePartnerOptions;
}

export function newSaveTradePartnerResult(
  options: SaveTradePartnerResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradePartnerResult {
  const o = (options.__typename ? options : cache["SaveTradePartnerResult"] = {}) as SaveTradePartnerResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradePartnerResult";
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  return o;
}

factories["SaveTradePartnerResult"] = newSaveTradePartnerResult;

export interface SaveTradePartnersResultOptions {
  __typename?: "SaveTradePartnersResult";
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
}

export function newSaveTradePartnersResult(
  options: SaveTradePartnersResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradePartnersResult {
  const o = (options.__typename ? options : cache["SaveTradePartnersResult"] = {}) as SaveTradePartnersResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradePartnersResult";
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  return o;
}

factories["SaveTradePartnersResult"] = newSaveTradePartnersResult;

export interface TradePartnersPageOptions {
  __typename?: "TradePartnersPage";
  entities?: Array<TradePartner | TradePartnerOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newTradePartnersPage(
  options: TradePartnersPageOptions = {},
  cache: Record<string, any> = {},
): TradePartnersPage {
  const o = (options.__typename ? options : cache["TradePartnersPage"] = {}) as TradePartnersPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnersPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["TradePartnersPage"] = newTradePartnersPage;

export interface TradePartnerAgreementOptions {
  __typename?: "TradePartnerAgreement";
  id?: TradePartnerAgreement["id"];
  isNationalAgreement?: TradePartnerAgreement["isNationalAgreement"];
  internalNote?: TradePartnerAgreement["internalNote"];
  createdAt?: TradePartnerAgreement["createdAt"];
  updatedAt?: TradePartnerAgreement["updatedAt"];
  costDivision?: CostDivision | CostDivisionOptions;
  tradePartner?: TradePartner | TradePartnerOptions;
}

export function newTradePartnerAgreement(
  options: TradePartnerAgreementOptions = {},
  cache: Record<string, any> = {},
): TradePartnerAgreement {
  const o = (options.__typename ? options : cache["TradePartnerAgreement"] = {}) as TradePartnerAgreement;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerAgreement";
  o.id = options.id ?? nextFactoryId("TradePartnerAgreement");
  o.isNationalAgreement = options.isNationalAgreement ?? false;
  o.internalNote = options.internalNote ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costDivision = maybeNew("CostDivision", options.costDivision, cache, options.hasOwnProperty("costDivision"));
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  return o;
}

factories["TradePartnerAgreement"] = newTradePartnerAgreement;

export interface SaveTradePartnerAgreementResultOptions {
  __typename?: "SaveTradePartnerAgreementResult";
  tradePartnerAgreement?: TradePartnerAgreement | TradePartnerAgreementOptions;
}

export function newSaveTradePartnerAgreementResult(
  options: SaveTradePartnerAgreementResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradePartnerAgreementResult {
  const o =
    (options.__typename ? options : cache["SaveTradePartnerAgreementResult"] = {}) as SaveTradePartnerAgreementResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradePartnerAgreementResult";
  o.tradePartnerAgreement = maybeNew(
    "TradePartnerAgreement",
    options.tradePartnerAgreement,
    cache,
    options.hasOwnProperty("tradePartnerAgreement"),
  );
  return o;
}

factories["SaveTradePartnerAgreementResult"] = newSaveTradePartnerAgreementResult;

export interface DeleteTradePartnerAgreementResultOptions {
  __typename?: "DeleteTradePartnerAgreementResult";
  tradePartner?: TradePartner | TradePartnerOptions;
}

export function newDeleteTradePartnerAgreementResult(
  options: DeleteTradePartnerAgreementResultOptions = {},
  cache: Record<string, any> = {},
): DeleteTradePartnerAgreementResult {
  const o =
    (options.__typename
      ? options
      : cache["DeleteTradePartnerAgreementResult"] = {}) as DeleteTradePartnerAgreementResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteTradePartnerAgreementResult";
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  return o;
}

factories["DeleteTradePartnerAgreementResult"] = newDeleteTradePartnerAgreementResult;

export interface SaveTradePartnerAvailabilityRequestResultOptions {
  __typename?: "SaveTradePartnerAvailabilityRequestResult";
  tradePartnerAvailabilityRequest?: TradePartnerAvailabilityRequest | TradePartnerAvailabilityRequestOptions;
}

export function newSaveTradePartnerAvailabilityRequestResult(
  options: SaveTradePartnerAvailabilityRequestResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradePartnerAvailabilityRequestResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveTradePartnerAvailabilityRequestResult"] = {}) as SaveTradePartnerAvailabilityRequestResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradePartnerAvailabilityRequestResult";
  o.tradePartnerAvailabilityRequest = maybeNew(
    "TradePartnerAvailabilityRequest",
    options.tradePartnerAvailabilityRequest,
    cache,
    options.hasOwnProperty("tradePartnerAvailabilityRequest"),
  );
  return o;
}

factories["SaveTradePartnerAvailabilityRequestResult"] = newSaveTradePartnerAvailabilityRequestResult;

export interface SaveTradePartnerAvailabilityRequestsResultOptions {
  __typename?: "SaveTradePartnerAvailabilityRequestsResult";
  tradePartnerAvailabilityRequests?: Array<TradePartnerAvailabilityRequest | TradePartnerAvailabilityRequestOptions>;
}

export function newSaveTradePartnerAvailabilityRequestsResult(
  options: SaveTradePartnerAvailabilityRequestsResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradePartnerAvailabilityRequestsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveTradePartnerAvailabilityRequestsResult"] = {}) as SaveTradePartnerAvailabilityRequestsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradePartnerAvailabilityRequestsResult";
  o.tradePartnerAvailabilityRequests = (options.tradePartnerAvailabilityRequests ?? []).map((i) =>
    maybeNew("TradePartnerAvailabilityRequest", i, cache, options.hasOwnProperty("tradePartnerAvailabilityRequests"))
  );
  return o;
}

factories["SaveTradePartnerAvailabilityRequestsResult"] = newSaveTradePartnerAvailabilityRequestsResult;

export interface TradePartnerAvailabilityRequestEmailOptions {
  __typename?: "TradePartnerAvailabilityRequestEmail";
  id?: TradePartnerAvailabilityRequestEmail["id"];
  subject?: TradePartnerAvailabilityRequestEmail["subject"];
  message?: TradePartnerAvailabilityRequestEmail["message"];
  createdAt?: TradePartnerAvailabilityRequestEmail["createdAt"];
  updatedAt?: TradePartnerAvailabilityRequestEmail["updatedAt"];
  tradePartnerAvailabilityRequest?: TradePartnerAvailabilityRequest | TradePartnerAvailabilityRequestOptions;
  attachments?: Array<Attachment | AttachmentOptions>;
}

export function newTradePartnerAvailabilityRequestEmail(
  options: TradePartnerAvailabilityRequestEmailOptions = {},
  cache: Record<string, any> = {},
): TradePartnerAvailabilityRequestEmail {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerAvailabilityRequestEmail"] = {}) as TradePartnerAvailabilityRequestEmail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerAvailabilityRequestEmail";
  o.id = options.id ?? nextFactoryId("TradePartnerAvailabilityRequestEmail");
  o.subject = options.subject ?? "subject";
  o.message = options.message ?? "message";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tradePartnerAvailabilityRequest = maybeNew(
    "TradePartnerAvailabilityRequest",
    options.tradePartnerAvailabilityRequest,
    cache,
    options.hasOwnProperty("tradePartnerAvailabilityRequest"),
  );
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  return o;
}

factories["TradePartnerAvailabilityRequestEmail"] = newTradePartnerAvailabilityRequestEmail;

export interface TradePartnerAvailabilityRequestTextMessageOptions {
  __typename?: "TradePartnerAvailabilityRequestTextMessage";
  id?: TradePartnerAvailabilityRequestTextMessage["id"];
  body?: TradePartnerAvailabilityRequestTextMessage["body"];
  createdAt?: TradePartnerAvailabilityRequestTextMessage["createdAt"];
  updatedAt?: TradePartnerAvailabilityRequestTextMessage["updatedAt"];
  tradePartnerAvailabilityRequest?: TradePartnerAvailabilityRequest | TradePartnerAvailabilityRequestOptions;
}

export function newTradePartnerAvailabilityRequestTextMessage(
  options: TradePartnerAvailabilityRequestTextMessageOptions = {},
  cache: Record<string, any> = {},
): TradePartnerAvailabilityRequestTextMessage {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerAvailabilityRequestTextMessage"] = {}) as TradePartnerAvailabilityRequestTextMessage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerAvailabilityRequestTextMessage";
  o.id = options.id ?? nextFactoryId("TradePartnerAvailabilityRequestTextMessage");
  o.body = options.body ?? "body";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tradePartnerAvailabilityRequest = maybeNew(
    "TradePartnerAvailabilityRequest",
    options.tradePartnerAvailabilityRequest,
    cache,
    options.hasOwnProperty("tradePartnerAvailabilityRequest"),
  );
  return o;
}

factories["TradePartnerAvailabilityRequestTextMessage"] = newTradePartnerAvailabilityRequestTextMessage;

export interface TradePartnerContactOptions {
  __typename?: "TradePartnerContact";
  id?: TradePartnerContact["id"];
  isPrimary?: TradePartnerContact["isPrimary"];
  isBillingSignatory?: TradePartnerContact["isBillingSignatory"];
  name?: TradePartnerContact["name"];
  email?: TradePartnerContact["email"];
  officePhone?: TradePartnerContact["officePhone"];
  mobilePhone?: TradePartnerContact["mobilePhone"];
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  canDeactivate?: PotentialOperation2 | PotentialOperation2Options;
  createdAt?: TradePartnerContact["createdAt"];
  updatedAt?: TradePartnerContact["updatedAt"];
  tradePartner?: TradePartner | TradePartnerOptions;
  title?: TradePartnerContact["title"];
  maybeBillingSignatory?: TradePartnerContact["maybeBillingSignatory"];
  address?: Address | AddressOptions | null;
  markets?: Array<Market | MarketOptions>;
  tradePartnerMailingLists?: Array<TradePartnerMailingList | TradePartnerMailingListOptions>;
  mailingLists?: Array<TradePartnerMailingList | TradePartnerMailingListOptions>;
  tradePartnerUser?: TradePartnerUser | TradePartnerUserOptions | null;
  tradePartnerMarketContacts?: Array<TradePartnerMarketContact | TradePartnerMarketContactOptions>;
  canLoginToPortal?: TradePartnerContact["canLoginToPortal"];
  isActive?: TradePartnerContact["isActive"];
}

export function newTradePartnerContact(
  options: TradePartnerContactOptions = {},
  cache: Record<string, any> = {},
): TradePartnerContact {
  const o = (options.__typename ? options : cache["TradePartnerContact"] = {}) as TradePartnerContact;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerContact";
  o.id = options.id ?? nextFactoryId("TradePartnerContact");
  o.isPrimary = options.isPrimary ?? false;
  o.isBillingSignatory = options.isBillingSignatory ?? false;
  o.name = options.name ?? "name";
  o.email = options.email ?? null;
  o.officePhone = options.officePhone ?? null;
  o.mobilePhone = options.mobilePhone ?? null;
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.canDeactivate = maybeNew(
    "PotentialOperation2",
    options.canDeactivate,
    cache,
    options.hasOwnProperty("canDeactivate"),
  );
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.title = options.title ?? null;
  o.maybeBillingSignatory = options.maybeBillingSignatory ?? false;
  o.address = maybeNewOrNull("Address", options.address, cache);
  o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
  o.tradePartnerMailingLists = (options.tradePartnerMailingLists ?? []).map((i) =>
    maybeNew("TradePartnerMailingList", i, cache, options.hasOwnProperty("tradePartnerMailingLists"))
  );
  o.mailingLists = (options.mailingLists ?? []).map((i) =>
    maybeNew("TradePartnerMailingList", i, cache, options.hasOwnProperty("mailingLists"))
  );
  o.tradePartnerUser = maybeNewOrNull("TradePartnerUser", options.tradePartnerUser, cache);
  o.tradePartnerMarketContacts = (options.tradePartnerMarketContacts ?? []).map((i) =>
    maybeNew("TradePartnerMarketContact", i, cache, options.hasOwnProperty("tradePartnerMarketContacts"))
  );
  o.canLoginToPortal = options.canLoginToPortal ?? false;
  o.isActive = options.isActive ?? false;
  return o;
}

factories["TradePartnerContact"] = newTradePartnerContact;

export interface SaveTradePartnerContactResultOptions {
  __typename?: "SaveTradePartnerContactResult";
  tradePartnerContact?: TradePartnerContact | TradePartnerContactOptions;
}

export function newSaveTradePartnerContactResult(
  options: SaveTradePartnerContactResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradePartnerContactResult {
  const o =
    (options.__typename ? options : cache["SaveTradePartnerContactResult"] = {}) as SaveTradePartnerContactResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradePartnerContactResult";
  o.tradePartnerContact = maybeNew(
    "TradePartnerContact",
    options.tradePartnerContact,
    cache,
    options.hasOwnProperty("tradePartnerContact"),
  );
  return o;
}

factories["SaveTradePartnerContactResult"] = newSaveTradePartnerContactResult;

export interface DeleteTradePartnerContactResultOptions {
  __typename?: "DeleteTradePartnerContactResult";
  tradePartner?: TradePartner | TradePartnerOptions;
  tradePartnerContact?: TradePartnerContact | TradePartnerContactOptions | null;
}

export function newDeleteTradePartnerContactResult(
  options: DeleteTradePartnerContactResultOptions = {},
  cache: Record<string, any> = {},
): DeleteTradePartnerContactResult {
  const o =
    (options.__typename ? options : cache["DeleteTradePartnerContactResult"] = {}) as DeleteTradePartnerContactResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteTradePartnerContactResult";
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.tradePartnerContact = maybeNewOrNull("TradePartnerContact", options.tradePartnerContact, cache);
  return o;
}

factories["DeleteTradePartnerContactResult"] = newDeleteTradePartnerContactResult;

export interface MarketContactWithRolesOptions {
  __typename?: "MarketContactWithRoles";
  contact?: TradePartnerContact | TradePartnerContactOptions;
  roles?: MarketContactWithRoles["roles"];
}

export function newMarketContactWithRoles(
  options: MarketContactWithRolesOptions = {},
  cache: Record<string, any> = {},
): MarketContactWithRoles {
  const o = (options.__typename ? options : cache["MarketContactWithRoles"] = {}) as MarketContactWithRoles;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MarketContactWithRoles";
  o.contact = maybeNew("TradePartnerContact", options.contact, cache, options.hasOwnProperty("contact"));
  o.roles = options.roles ?? [];
  return o;
}

factories["MarketContactWithRoles"] = newMarketContactWithRoles;

export interface TradePartnerMailingListOptions {
  __typename?: "TradePartnerMailingList";
  id?: TradePartnerMailingList["id"];
  name?: TradePartnerMailingList["name"];
  createdAt?: TradePartnerMailingList["createdAt"];
  updatedAt?: TradePartnerMailingList["updatedAt"];
  tradePartnerContacts?: Array<TradePartnerContact | TradePartnerContactOptions>;
}

export function newTradePartnerMailingList(
  options: TradePartnerMailingListOptions = {},
  cache: Record<string, any> = {},
): TradePartnerMailingList {
  const o = (options.__typename ? options : cache["TradePartnerMailingList"] = {}) as TradePartnerMailingList;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerMailingList";
  o.id = options.id ?? nextFactoryId("TradePartnerMailingList");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tradePartnerContacts = (options.tradePartnerContacts ?? []).map((i) =>
    maybeNew("TradePartnerContact", i, cache, options.hasOwnProperty("tradePartnerContacts"))
  );
  return o;
}

factories["TradePartnerMailingList"] = newTradePartnerMailingList;

export interface TradePartnerMarketContactOptions {
  __typename?: "TradePartnerMarketContact";
  id?: TradePartnerMarketContact["id"];
  createdAt?: TradePartnerMarketContact["createdAt"];
  updatedAt?: TradePartnerMarketContact["updatedAt"];
  role?: TradePartnerMarketRoleDetailOptions | TradePartnerMarketRole;
  market?: Market | MarketOptions;
  tradePartner?: TradePartner | TradePartnerOptions;
  contact?: TradePartnerContact | TradePartnerContactOptions;
}

export function newTradePartnerMarketContact(
  options: TradePartnerMarketContactOptions = {},
  cache: Record<string, any> = {},
): TradePartnerMarketContact {
  const o = (options.__typename ? options : cache["TradePartnerMarketContact"] = {}) as TradePartnerMarketContact;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerMarketContact";
  o.id = options.id ?? nextFactoryId("TradePartnerMarketContact");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.role = enumOrDetailOfTradePartnerMarketRole(options.role);
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.contact = maybeNew("TradePartnerContact", options.contact, cache, options.hasOwnProperty("contact"));
  return o;
}

factories["TradePartnerMarketContact"] = newTradePartnerMarketContact;

export interface SaveTradePartnerMarketContactResultOptions {
  __typename?: "SaveTradePartnerMarketContactResult";
  tradePartnerMarketContact?: TradePartnerMarketContact | TradePartnerMarketContactOptions;
}

export function newSaveTradePartnerMarketContactResult(
  options: SaveTradePartnerMarketContactResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradePartnerMarketContactResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveTradePartnerMarketContactResult"] = {}) as SaveTradePartnerMarketContactResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradePartnerMarketContactResult";
  o.tradePartnerMarketContact = maybeNew(
    "TradePartnerMarketContact",
    options.tradePartnerMarketContact,
    cache,
    options.hasOwnProperty("tradePartnerMarketContact"),
  );
  return o;
}

factories["SaveTradePartnerMarketContactResult"] = newSaveTradePartnerMarketContactResult;

export interface DeleteTradePartnerMarketContactResultOptions {
  __typename?: "DeleteTradePartnerMarketContactResult";
  tradePartner?: TradePartner | TradePartnerOptions;
}

export function newDeleteTradePartnerMarketContactResult(
  options: DeleteTradePartnerMarketContactResultOptions = {},
  cache: Record<string, any> = {},
): DeleteTradePartnerMarketContactResult {
  const o =
    (options.__typename
      ? options
      : cache["DeleteTradePartnerMarketContactResult"] = {}) as DeleteTradePartnerMarketContactResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteTradePartnerMarketContactResult";
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  return o;
}

factories["DeleteTradePartnerMarketContactResult"] = newDeleteTradePartnerMarketContactResult;

export interface TradePartnerRequirementOptions {
  __typename?: "TradePartnerRequirement";
  id?: TradePartnerRequirement["id"];
  signedDate?: TradePartnerRequirement["signedDate"];
  expirationDate?: TradePartnerRequirement["expirationDate"];
  licenseNumber?: TradePartnerRequirement["licenseNumber"];
  coverageAmountInCents?: TradePartnerRequirement["coverageAmountInCents"];
  createdAt?: TradePartnerRequirement["createdAt"];
  updatedAt?: TradePartnerRequirement["updatedAt"];
  type?: TradePartnerRequirementTypeDetailOptions | TradePartnerRequirementType;
  tradePartner?: TradePartner | TradePartnerOptions;
  status?: TradePartnerRequirementStatusDetailOptions | TradePartnerRequirementStatus;
  internalNote?: TradePartnerRequirement["internalNote"];
  attachments?: Array<Attachment | AttachmentOptions>;
}

export function newTradePartnerRequirement(
  options: TradePartnerRequirementOptions = {},
  cache: Record<string, any> = {},
): TradePartnerRequirement {
  const o = (options.__typename ? options : cache["TradePartnerRequirement"] = {}) as TradePartnerRequirement;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerRequirement";
  o.id = options.id ?? nextFactoryId("TradePartnerRequirement");
  o.signedDate = options.signedDate ?? null;
  o.expirationDate = options.expirationDate ?? null;
  o.licenseNumber = options.licenseNumber ?? null;
  o.coverageAmountInCents = options.coverageAmountInCents ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.type = enumOrDetailOfTradePartnerRequirementType(options.type);
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.status = enumOrDetailOfTradePartnerRequirementStatus(options.status);
  o.internalNote = options.internalNote ?? null;
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  return o;
}

factories["TradePartnerRequirement"] = newTradePartnerRequirement;

export interface SaveTradePartnerRequirementResultOptions {
  __typename?: "SaveTradePartnerRequirementResult";
  tradePartnerRequirement?: TradePartnerRequirement | TradePartnerRequirementOptions;
}

export function newSaveTradePartnerRequirementResult(
  options: SaveTradePartnerRequirementResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradePartnerRequirementResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveTradePartnerRequirementResult"] = {}) as SaveTradePartnerRequirementResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradePartnerRequirementResult";
  o.tradePartnerRequirement = maybeNew(
    "TradePartnerRequirement",
    options.tradePartnerRequirement,
    cache,
    options.hasOwnProperty("tradePartnerRequirement"),
  );
  return o;
}

factories["SaveTradePartnerRequirementResult"] = newSaveTradePartnerRequirementResult;

export interface TradePartnerReviewOptions {
  __typename?: "TradePartnerReview";
  id?: TradePartnerReview["id"];
  recommended?: TradePartnerReview["recommended"];
  score?: TradePartnerReview["score"];
  createdAt?: TradePartnerReview["createdAt"];
  internalUser?: InternalUser | InternalUserOptions;
  tradePartner?: TradePartner | TradePartnerOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  internalNote?: TradePartnerReview["internalNote"];
}

export function newTradePartnerReview(
  options: TradePartnerReviewOptions = {},
  cache: Record<string, any> = {},
): TradePartnerReview {
  const o = (options.__typename ? options : cache["TradePartnerReview"] = {}) as TradePartnerReview;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerReview";
  o.id = options.id ?? nextFactoryId("TradePartnerReview");
  o.recommended = options.recommended ?? null;
  o.score = options.score ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.internalNote = options.internalNote ?? null;
  return o;
}

factories["TradePartnerReview"] = newTradePartnerReview;

export interface SaveTradePartnerReviewResultOptions {
  __typename?: "SaveTradePartnerReviewResult";
  tradePartnerReview?: TradePartnerReview | TradePartnerReviewOptions;
}

export function newSaveTradePartnerReviewResult(
  options: SaveTradePartnerReviewResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradePartnerReviewResult {
  const o = (options.__typename ? options : cache["SaveTradePartnerReviewResult"] = {}) as SaveTradePartnerReviewResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradePartnerReviewResult";
  o.tradePartnerReview = maybeNew(
    "TradePartnerReview",
    options.tradePartnerReview,
    cache,
    options.hasOwnProperty("tradePartnerReview"),
  );
  return o;
}

factories["SaveTradePartnerReviewResult"] = newSaveTradePartnerReviewResult;

export interface TradePartnerUserOptions {
  __typename?: "TradePartnerUser";
  id?: TradePartnerUser["id"];
  user?: User | UserOptions;
  tradePartner?: TradePartner | TradePartnerOptions;
  name?: TradePartnerUser["name"];
  createdAt?: TradePartnerUser["createdAt"];
  updatedAt?: TradePartnerUser["updatedAt"];
  commentStreams?: Array<CommentStream | CommentStreamOptions>;
  tradePartnerContact?: TradePartnerContact | TradePartnerContactOptions | null;
  approvers?: Array<Approver | ApproverOptions>;
  lastActive?: TradePartnerUser["lastActive"];
  lastActiveAt?: TradePartnerUser["lastActiveAt"];
}

export function newTradePartnerUser(
  options: TradePartnerUserOptions = {},
  cache: Record<string, any> = {},
): TradePartnerUser {
  const o = (options.__typename ? options : cache["TradePartnerUser"] = {}) as TradePartnerUser;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerUser";
  o.id = options.id ?? nextFactoryId("TradePartnerUser");
  o.user = maybeNew("User", options.user, cache, options.hasOwnProperty("user"));
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.commentStreams = (options.commentStreams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("commentStreams"))
  );
  o.tradePartnerContact = maybeNewOrNull("TradePartnerContact", options.tradePartnerContact, cache);
  o.approvers = (options.approvers ?? []).map((i) =>
    maybeNew("Approver", i, cache, options.hasOwnProperty("approvers"))
  );
  o.lastActive = options.lastActive ?? null;
  o.lastActiveAt = options.lastActiveAt ?? null;
  return o;
}

factories["TradePartnerUser"] = newTradePartnerUser;

export interface SaveUnitResultOptions {
  __typename?: "SaveUnitResult";
  unit?: Unit | UnitOptions;
}

export function newSaveUnitResult(
  options: SaveUnitResultOptions = {},
  cache: Record<string, any> = {},
): SaveUnitResult {
  const o = (options.__typename ? options : cache["SaveUnitResult"] = {}) as SaveUnitResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveUnitResult";
  o.unit = maybeNew("Unit", options.unit, cache, options.hasOwnProperty("unit"));
  return o;
}

factories["SaveUnitResult"] = newSaveUnitResult;

export interface SaveUnitsOfMeasureResultOptions {
  __typename?: "SaveUnitsOfMeasureResult";
  unitsOfMeasure?: Array<UnitOfMeasure | UnitOfMeasureOptions>;
}

export function newSaveUnitsOfMeasureResult(
  options: SaveUnitsOfMeasureResultOptions = {},
  cache: Record<string, any> = {},
): SaveUnitsOfMeasureResult {
  const o = (options.__typename ? options : cache["SaveUnitsOfMeasureResult"] = {}) as SaveUnitsOfMeasureResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveUnitsOfMeasureResult";
  o.unitsOfMeasure = (options.unitsOfMeasure ?? []).map((i) =>
    maybeNew("UnitOfMeasure", i, cache, options.hasOwnProperty("unitsOfMeasure"))
  );
  return o;
}

factories["SaveUnitsOfMeasureResult"] = newSaveUnitsOfMeasureResult;

export interface UnitOfMeasureOptions {
  __typename?: "UnitOfMeasure";
  id?: UnitOfMeasure["id"];
  name?: UnitOfMeasure["name"];
  useQuantity?: UnitOfMeasure["useQuantity"];
  sageName?: UnitOfMeasure["sageName"];
  abbreviation?: UnitOfMeasure["abbreviation"];
  shortName?: UnitOfMeasure["shortName"];
  shouldMultiplySelectionFee?: UnitOfMeasure["shouldMultiplySelectionFee"];
}

export function newUnitOfMeasure(options: UnitOfMeasureOptions = {}, cache: Record<string, any> = {}): UnitOfMeasure {
  const o = (options.__typename ? options : cache["UnitOfMeasure"] = {}) as UnitOfMeasure;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UnitOfMeasure";
  o.id = options.id ?? nextFactoryId("UnitOfMeasure");
  o.name = options.name ?? "name";
  o.useQuantity = options.useQuantity ?? false;
  o.sageName = options.sageName ?? null;
  o.abbreviation = options.abbreviation ?? "abbreviation";
  o.shortName = options.shortName ?? "shortName";
  o.shouldMultiplySelectionFee = options.shouldMultiplySelectionFee ?? false;
  return o;
}

factories["UnitOfMeasure"] = newUnitOfMeasure;

export interface UserOptions {
  __typename?: "User";
  id?: User["id"];
  userId?: User["userId"];
  userType?: User["userType"];
  name?: User["name"];
  email?: User["email"];
  avatarUrl?: User["avatarUrl"];
  avatar?: User["avatar"];
  internalUser?: InternalUser | InternalUserOptions | null;
  type?: User["type"];
  typeDetail?: UserTypeDetailOptions | UserType;
  isActive?: User["isActive"];
  tradePartnerUser?: TradePartnerUser | TradePartnerUserOptions | null;
  tradePartnerUsers?: Array<TradePartnerUser | TradePartnerUserOptions>;
  zendeskJwt?: User["zendeskJwt"];
  userCommunicationPreference?: UserCommunicationPreference | UserCommunicationPreferenceOptions | null;
  isBeingImpersonated?: User["isBeingImpersonated"];
  hasCheckoutAccess?: User["hasCheckoutAccess"];
  pushNotificationTokens?: Array<PushNotificationToken | PushNotificationTokenOptions>;
}

export function newUser(options: UserOptions = {}, cache: Record<string, any> = {}): User {
  const o = (options.__typename ? options : cache["User"] = {}) as User;
  (cache.all ??= new Set()).add(o);
  o.__typename = "User";
  o.id = options.id ?? nextFactoryId("User");
  o.userId = options.userId ?? "userId";
  o.userType = options.userType ?? UserType.Anonymous;
  o.name = options.name ?? "name";
  o.email = options.email ?? "email";
  o.avatarUrl = options.avatarUrl ?? "avatarUrl";
  o.avatar = options.avatar ?? "avatar";
  o.internalUser = maybeNewOrNull("InternalUser", options.internalUser, cache);
  o.type = options.type ?? UserType.Anonymous;
  o.typeDetail = enumOrDetailOfUserType(options.typeDetail);
  o.isActive = options.isActive ?? false;
  o.tradePartnerUser = maybeNewOrNull("TradePartnerUser", options.tradePartnerUser, cache);
  o.tradePartnerUsers = (options.tradePartnerUsers ?? []).map((i) =>
    maybeNew("TradePartnerUser", i, cache, options.hasOwnProperty("tradePartnerUsers"))
  );
  o.zendeskJwt = options.zendeskJwt ?? "zendeskJwt";
  o.userCommunicationPreference = maybeNewOrNull(
    "UserCommunicationPreference",
    options.userCommunicationPreference,
    cache,
  );
  o.isBeingImpersonated = options.isBeingImpersonated ?? false;
  o.hasCheckoutAccess = options.hasCheckoutAccess ?? false;
  o.pushNotificationTokens = (options.pushNotificationTokens ?? []).map((i) =>
    maybeNew("PushNotificationToken", i, cache, options.hasOwnProperty("pushNotificationTokens"))
  );
  return o;
}

factories["User"] = newUser;

export interface SaveUserResultOptions {
  __typename?: "SaveUserResult";
  userErrors?: Array<UserError | UserErrorOptions>;
}

export function newSaveUserResult(
  options: SaveUserResultOptions = {},
  cache: Record<string, any> = {},
): SaveUserResult {
  const o = (options.__typename ? options : cache["SaveUserResult"] = {}) as SaveUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveUserResult";
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["SaveUserResult"] = newSaveUserResult;

export interface DeactivateUserResultOptions {
  __typename?: "DeactivateUserResult";
  userErrors?: Array<UserError | UserErrorOptions>;
}

export function newDeactivateUserResult(
  options: DeactivateUserResultOptions = {},
  cache: Record<string, any> = {},
): DeactivateUserResult {
  const o = (options.__typename ? options : cache["DeactivateUserResult"] = {}) as DeactivateUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeactivateUserResult";
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["DeactivateUserResult"] = newDeactivateUserResult;

export interface ActivateUserResultOptions {
  __typename?: "ActivateUserResult";
  userErrors?: Array<UserError | UserErrorOptions>;
}

export function newActivateUserResult(
  options: ActivateUserResultOptions = {},
  cache: Record<string, any> = {},
): ActivateUserResult {
  const o = (options.__typename ? options : cache["ActivateUserResult"] = {}) as ActivateUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ActivateUserResult";
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["ActivateUserResult"] = newActivateUserResult;

export interface DeactivateUsersResultOptions {
  __typename?: "DeactivateUsersResult";
  users?: Array<User | UserOptions>;
}

export function newDeactivateUsersResult(
  options: DeactivateUsersResultOptions = {},
  cache: Record<string, any> = {},
): DeactivateUsersResult {
  const o = (options.__typename ? options : cache["DeactivateUsersResult"] = {}) as DeactivateUsersResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeactivateUsersResult";
  o.users = (options.users ?? []).map((i) => maybeNew("User", i, cache, options.hasOwnProperty("users")));
  return o;
}

factories["DeactivateUsersResult"] = newDeactivateUsersResult;

export interface ActivateUsersResultOptions {
  __typename?: "ActivateUsersResult";
  users?: Array<User | UserOptions>;
}

export function newActivateUsersResult(
  options: ActivateUsersResultOptions = {},
  cache: Record<string, any> = {},
): ActivateUsersResult {
  const o = (options.__typename ? options : cache["ActivateUsersResult"] = {}) as ActivateUsersResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ActivateUsersResult";
  o.users = (options.users ?? []).map((i) => maybeNew("User", i, cache, options.hasOwnProperty("users")));
  return o;
}

factories["ActivateUsersResult"] = newActivateUsersResult;

export interface UserCommunicationPreferenceOptions {
  __typename?: "UserCommunicationPreference";
  id?: UserCommunicationPreference["id"];
  user?: User | UserOptions;
  createdAt?: UserCommunicationPreference["createdAt"];
  updatedAt?: UserCommunicationPreference["updatedAt"];
  tpAvailabilityRequestPreference?: UserCommunicationPreference["tpAvailabilityRequestPreference"] | null;
  commentPreference?: UserCommunicationPreference["commentPreference"] | null;
}

export function newUserCommunicationPreference(
  options: UserCommunicationPreferenceOptions = {},
  cache: Record<string, any> = {},
): UserCommunicationPreference {
  const o = (options.__typename ? options : cache["UserCommunicationPreference"] = {}) as UserCommunicationPreference;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserCommunicationPreference";
  o.id = options.id ?? nextFactoryId("UserCommunicationPreference");
  o.user = maybeNew("User", options.user, cache, options.hasOwnProperty("user"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tpAvailabilityRequestPreference = options.tpAvailabilityRequestPreference ?? [];
  o.commentPreference = options.commentPreference ?? [];
  return o;
}

factories["UserCommunicationPreference"] = newUserCommunicationPreference;

export interface SaveUserCommunicationPreferenceResultOptions {
  __typename?: "SaveUserCommunicationPreferenceResult";
  userCommunicationPreference?: UserCommunicationPreference | UserCommunicationPreferenceOptions;
}

export function newSaveUserCommunicationPreferenceResult(
  options: SaveUserCommunicationPreferenceResultOptions = {},
  cache: Record<string, any> = {},
): SaveUserCommunicationPreferenceResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveUserCommunicationPreferenceResult"] = {}) as SaveUserCommunicationPreferenceResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveUserCommunicationPreferenceResult";
  o.userCommunicationPreference = maybeNew(
    "UserCommunicationPreference",
    options.userCommunicationPreference,
    cache,
    options.hasOwnProperty("userCommunicationPreference"),
  );
  return o;
}

factories["SaveUserCommunicationPreferenceResult"] = newSaveUserCommunicationPreferenceResult;

export interface UserEventOptions {
  __typename?: "UserEvent";
  id?: UserEvent["id"];
  parent?:
    | UserEventParent
    | ApprovalOptions
    | RequireTypename<BillOptions>
    | RequireTypename<ChangeEventOptions>
    | RequireTypename<CommitmentOptions>
    | RequireTypename<CommitmentChangeOrderOptions>
    | RequireTypename<DocumentOptions>
    | RequireTypename<EstimateOptions>
    | RequireTypename<HomeownerContractChangeOrderOptions>
    | RequireTypename<InvoiceOptions>
    | RequireTypename<ItemTemplateOptions>
    | RequireTypename<JobLogOptions>
    | RequireTypename<JobLogImageOptions>
    | RequireTypename<JobLogNoteOptions>
    | RequireTypename<StandaloneProjectOptions>
    | RequireTypename<RegionOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<ProjectItemOptions>
    | RequireTypename<ProjectLotDetailOptions>
    | RequireTypename<ProjectReadyPlanConfigOptions>
    | RequireTypename<ReadyPlanOptions>
    | RequireTypename<PlanPackageOptions>
    | RequireTypename<DesignPackageOptions>
    | RequireTypename<ProductOfferingOptions>
    | RequireTypename<ReadyPlanOptionOptions>
    | RequireTypename<ToDoOptions>
    | RequireTypename<ChangeRequestToDoOptions>
    | RequireTypename<PunchlistItemTodoOptions>
    | RequireTypename<TaskOptions>
    | RequireTypename<ScheduleTaskOptions>
    | RequireTypename<PlanTaskOptions>
    | RequireTypename<WarrantyTicketOptions>;
  parentTypeName?: UserEvent["parentTypeName"];
  createdAt?: UserEvent["createdAt"];
  createdBy?: User | UserOptions;
  createdFor?: User | UserOptions | null;
  type?: UserEvent["type"];
  typeDetail?: UserEventTypeDetailOptions | UserEventType;
  development?: Development | DevelopmentOptions | null;
  cohort?: Cohort | CohortOptions | null;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  notifiedAt?: UserEvent["notifiedAt"];
  comment?: Comment | CommentOptions | null;
  payload?: UserEvent["payload"];
  attachment?: Attachment | AttachmentOptions | null;
}

export function newUserEvent(options: UserEventOptions = {}, cache: Record<string, any> = {}): UserEvent {
  const o = (options.__typename ? options : cache["UserEvent"] = {}) as UserEvent;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserEvent";
  o.id = options.id ?? nextFactoryId("UserEvent");
  o.parent = maybeNew(options.parent?.__typename ?? "Approval", options.parent, cache);
  o.parentTypeName = options.parentTypeName ?? "parentTypeName";
  o.createdAt = options.createdAt ?? newDateTime();
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.createdFor = maybeNewOrNull("User", options.createdFor, cache);
  o.type = options.type ?? UserEventType.Created;
  o.typeDetail = enumOrDetailOfUserEventType(options.typeDetail);
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.notifiedAt = options.notifiedAt ?? null;
  o.comment = maybeNewOrNull("Comment", options.comment, cache);
  o.payload = options.payload ?? null;
  o.attachment = maybeNewOrNull("Attachment", options.attachment, cache);
  return o;
}

factories["UserEvent"] = newUserEvent;

export interface UserEventParentTypeOptions {
  __typename?: "UserEventParentType";
  id?: UserEventParentType["id"];
  name?: UserEventParentType["name"];
}

export function newUserEventParentType(
  options: UserEventParentTypeOptions = {},
  cache: Record<string, any> = {},
): UserEventParentType {
  const o = (options.__typename ? options : cache["UserEventParentType"] = {}) as UserEventParentType;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserEventParentType";
  o.id = options.id ?? nextFactoryId("UserEventParentType");
  o.name = options.name ?? "name";
  return o;
}

factories["UserEventParentType"] = newUserEventParentType;

export interface UserGroupOptions {
  __typename?: "UserGroup";
  id?: UserGroup["id"];
  name?: UserGroup["name"];
  createdAt?: UserGroup["createdAt"];
  updatedAt?: UserGroup["updatedAt"];
  featureFlagTargets?: Array<FeatureFlagTarget | FeatureFlagTargetOptions>;
  users?: Array<User | UserOptions>;
}

export function newUserGroup(options: UserGroupOptions = {}, cache: Record<string, any> = {}): UserGroup {
  const o = (options.__typename ? options : cache["UserGroup"] = {}) as UserGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserGroup";
  o.id = options.id ?? nextFactoryId("UserGroup");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.featureFlagTargets = (options.featureFlagTargets ?? []).map((i) =>
    maybeNew("FeatureFlagTarget", i, cache, options.hasOwnProperty("featureFlagTargets"))
  );
  o.users = (options.users ?? []).map((i) => maybeNew("User", i, cache, options.hasOwnProperty("users")));
  return o;
}

factories["UserGroup"] = newUserGroup;

export interface SaveUserGroupResultOptions {
  __typename?: "SaveUserGroupResult";
  userGroup?: UserGroup | UserGroupOptions;
}

export function newSaveUserGroupResult(
  options: SaveUserGroupResultOptions = {},
  cache: Record<string, any> = {},
): SaveUserGroupResult {
  const o = (options.__typename ? options : cache["SaveUserGroupResult"] = {}) as SaveUserGroupResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveUserGroupResult";
  o.userGroup = maybeNew("UserGroup", options.userGroup, cache, options.hasOwnProperty("userGroup"));
  return o;
}

factories["SaveUserGroupResult"] = newSaveUserGroupResult;

export interface SaveWarrantyTicketResultOptions {
  __typename?: "SaveWarrantyTicketResult";
  warrantyTicket?: WarrantyTicket | WarrantyTicketOptions;
}

export function newSaveWarrantyTicketResult(
  options: SaveWarrantyTicketResultOptions = {},
  cache: Record<string, any> = {},
): SaveWarrantyTicketResult {
  const o = (options.__typename ? options : cache["SaveWarrantyTicketResult"] = {}) as SaveWarrantyTicketResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveWarrantyTicketResult";
  o.warrantyTicket = maybeNew(
    "WarrantyTicket",
    options.warrantyTicket,
    cache,
    options.hasOwnProperty("warrantyTicket"),
  );
  return o;
}

factories["SaveWarrantyTicketResult"] = newSaveWarrantyTicketResult;

export interface WarrantyTicketsPageOptions {
  __typename?: "WarrantyTicketsPage";
  entities?: Array<WarrantyTicket | WarrantyTicketOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newWarrantyTicketsPage(
  options: WarrantyTicketsPageOptions = {},
  cache: Record<string, any> = {},
): WarrantyTicketsPage {
  const o = (options.__typename ? options : cache["WarrantyTicketsPage"] = {}) as WarrantyTicketsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WarrantyTicketsPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["WarrantyTicketsPage"] = newWarrantyTicketsPage;

export interface WarrantyTicketAvailabilityOptions {
  __typename?: "WarrantyTicketAvailability";
  id?: WarrantyTicketAvailability["id"];
  createdAt?: WarrantyTicketAvailability["createdAt"];
  updatedAt?: WarrantyTicketAvailability["updatedAt"];
  dayOfWeek?: DayOfWeekDetailOptions | DayOfWeek;
  timeOfDay?: TimeOfDayDetailOptions | TimeOfDay;
  warrantyTicket?: WarrantyTicket | WarrantyTicketOptions;
}

export function newWarrantyTicketAvailability(
  options: WarrantyTicketAvailabilityOptions = {},
  cache: Record<string, any> = {},
): WarrantyTicketAvailability {
  const o = (options.__typename ? options : cache["WarrantyTicketAvailability"] = {}) as WarrantyTicketAvailability;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WarrantyTicketAvailability";
  o.id = options.id ?? nextFactoryId("WarrantyTicketAvailability");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.dayOfWeek = enumOrDetailOfDayOfWeek(options.dayOfWeek);
  o.timeOfDay = enumOrDetailOfTimeOfDay(options.timeOfDay);
  o.warrantyTicket = maybeNew(
    "WarrantyTicket",
    options.warrantyTicket,
    cache,
    options.hasOwnProperty("warrantyTicket"),
  );
  return o;
}

factories["WarrantyTicketAvailability"] = newWarrantyTicketAvailability;

export interface WarrantyTicketItemOptions {
  __typename?: "WarrantyTicketItem";
  id?: WarrantyTicketItem["id"];
  product?: WarrantyTicketItem["product"];
  description?: WarrantyTicketItem["description"];
  createdAt?: WarrantyTicketItem["createdAt"];
  updatedAt?: WarrantyTicketItem["updatedAt"];
  status?: WarrantyTicketItemStatusDetailOptions | WarrantyTicketItemStatus;
  warrantyTicket?: WarrantyTicket | WarrantyTicketOptions;
  attachments?: Array<Attachment | AttachmentOptions>;
  type?: WarrantyTicketItemTypeDetailOptions | WarrantyTicketItemType;
  homeownerVisible?: WarrantyTicketItem["homeownerVisible"];
  statusUpdatedAt?: WarrantyTicketItem["statusUpdatedAt"];
}

export function newWarrantyTicketItem(
  options: WarrantyTicketItemOptions = {},
  cache: Record<string, any> = {},
): WarrantyTicketItem {
  const o = (options.__typename ? options : cache["WarrantyTicketItem"] = {}) as WarrantyTicketItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WarrantyTicketItem";
  o.id = options.id ?? nextFactoryId("WarrantyTicketItem");
  o.product = options.product ?? null;
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = enumOrDetailOfWarrantyTicketItemStatus(options.status);
  o.warrantyTicket = maybeNew(
    "WarrantyTicket",
    options.warrantyTicket,
    cache,
    options.hasOwnProperty("warrantyTicket"),
  );
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  o.type = enumOrDetailOfWarrantyTicketItemType(options.type);
  o.homeownerVisible = options.homeownerVisible ?? false;
  o.statusUpdatedAt = options.statusUpdatedAt ?? newDateTime();
  return o;
}

factories["WarrantyTicketItem"] = newWarrantyTicketItem;

export interface SaveWarrantyTicketItemResultOptions {
  __typename?: "SaveWarrantyTicketItemResult";
  warrantyTicketItem?: WarrantyTicketItem | WarrantyTicketItemOptions;
}

export function newSaveWarrantyTicketItemResult(
  options: SaveWarrantyTicketItemResultOptions = {},
  cache: Record<string, any> = {},
): SaveWarrantyTicketItemResult {
  const o = (options.__typename ? options : cache["SaveWarrantyTicketItemResult"] = {}) as SaveWarrantyTicketItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveWarrantyTicketItemResult";
  o.warrantyTicketItem = maybeNew(
    "WarrantyTicketItem",
    options.warrantyTicketItem,
    cache,
    options.hasOwnProperty("warrantyTicketItem"),
  );
  return o;
}

factories["SaveWarrantyTicketItemResult"] = newSaveWarrantyTicketItemResult;

export interface SaveWarrantyTicketItemsResultOptions {
  __typename?: "SaveWarrantyTicketItemsResult";
  warrantyTicketItems?: Array<WarrantyTicketItem | WarrantyTicketItemOptions>;
}

export function newSaveWarrantyTicketItemsResult(
  options: SaveWarrantyTicketItemsResultOptions = {},
  cache: Record<string, any> = {},
): SaveWarrantyTicketItemsResult {
  const o =
    (options.__typename ? options : cache["SaveWarrantyTicketItemsResult"] = {}) as SaveWarrantyTicketItemsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveWarrantyTicketItemsResult";
  o.warrantyTicketItems = (options.warrantyTicketItems ?? []).map((i) =>
    maybeNew("WarrantyTicketItem", i, cache, options.hasOwnProperty("warrantyTicketItems"))
  );
  return o;
}

factories["SaveWarrantyTicketItemsResult"] = newSaveWarrantyTicketItemsResult;

export interface WorkAuthorizationOptions {
  __typename?: "WorkAuthorization";
  id?: WorkAuthorization["id"];
  name?: WorkAuthorization["name"];
  createdAt?: WorkAuthorization["createdAt"];
  updatedAt?: WorkAuthorization["updatedAt"];
  projectStage?: ProjectStage | ProjectStageOptions;
  documents?: Array<Document | DocumentOptions>;
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
}

export function newWorkAuthorization(
  options: WorkAuthorizationOptions = {},
  cache: Record<string, any> = {},
): WorkAuthorization {
  const o = (options.__typename ? options : cache["WorkAuthorization"] = {}) as WorkAuthorization;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WorkAuthorization";
  o.id = options.id ?? nextFactoryId("WorkAuthorization");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  return o;
}

factories["WorkAuthorization"] = newWorkAuthorization;

export interface SaveWorkAuthorizationResultOptions {
  __typename?: "SaveWorkAuthorizationResult";
  workAuthorization?: WorkAuthorization | WorkAuthorizationOptions;
}

export function newSaveWorkAuthorizationResult(
  options: SaveWorkAuthorizationResultOptions = {},
  cache: Record<string, any> = {},
): SaveWorkAuthorizationResult {
  const o = (options.__typename ? options : cache["SaveWorkAuthorizationResult"] = {}) as SaveWorkAuthorizationResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveWorkAuthorizationResult";
  o.workAuthorization = maybeNew(
    "WorkAuthorization",
    options.workAuthorization,
    cache,
    options.hasOwnProperty("workAuthorization"),
  );
  return o;
}

factories["SaveWorkAuthorizationResult"] = newSaveWorkAuthorizationResult;

export type HasBlueprintUrlOptions =
  | ApprovalOptions
  | RequireTypename<BidContractOptions>
  | RequireTypename<BidContractRevisionOptions>
  | RequireTypename<BidItemOptions>
  | RequireTypename<BidPackageRequestOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<BusinessFunctionOptions>
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<ChangeRequestOptions>
  | RequireTypename<ChangeRequestToDoOptions>
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<ScheduleTaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<ToDoOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<TradePartnerAvailabilityRequestOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<WarrantyTicketOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<HomeownerContractChangeOrderOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<GlobalOptionOptions>
  | RequireTypename<ProjectCostCodeOptions>
  | RequireTypename<CommitmentChangeOrderOptions>
  | RequireTypename<DesignPackageOptions>
  | RequireTypename<DevelopmentOptions>
  | RequireTypename<ItemTemplateItemOptions>
  | RequireTypename<MaterialVariantOptions>
  | RequireTypename<ProductOfferingOptions>
  | RequireTypename<ProjectReadyPlanConfigOptions>
  | RequireTypename<ProjectSiteConditionOptions>
  | RequireTypename<ReadyPlanOptionOptions>
  | RequireTypename<TakeoffLineItemOptions>
  | RequireTypename<TakeoffLineItemVersionOptions>;

export type HasBlueprintUrlType =
  | Approval
  | BidContract
  | BidContractRevision
  | BidItem
  | BidPackageRequest
  | Bill
  | BusinessFunction
  | ChangeEvent
  | ChangeRequest
  | ChangeRequestToDo
  | SchedulePhase
  | ScheduleSubPhase
  | Task
  | ScheduleTask
  | PlanTask
  | ToDo
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | DevelopmentCommitment
  | Commitment
  | Document
  | ItemTemplateItemVersion
  | JobLogNote
  | TradePartnerAvailabilityRequest
  | PunchlistItemTodo
  | WarrantyTicket
  | HomeownerContract
  | HomeownerContractChangeOrder
  | ReadyPlan
  | PlanPackage
  | GlobalOption
  | ProjectCostCode
  | CommitmentChangeOrder
  | DesignPackage
  | Development
  | ItemTemplateItem
  | MaterialVariant
  | ProductOffering
  | ProjectReadyPlanConfig
  | ProjectSiteCondition
  | ReadyPlanOption
  | TakeoffLineItem
  | TakeoffLineItemVersion;

export type HasBlueprintUrlTypeName =
  | "Approval"
  | "BidContract"
  | "BidContractRevision"
  | "BidItem"
  | "BidPackageRequest"
  | "Bill"
  | "BusinessFunction"
  | "ChangeEvent"
  | "ChangeRequest"
  | "ChangeRequestToDo"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "ScheduleTask"
  | "PlanTask"
  | "ToDo"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "DevelopmentCommitment"
  | "Commitment"
  | "Document"
  | "ItemTemplateItemVersion"
  | "JobLogNote"
  | "TradePartnerAvailabilityRequest"
  | "PunchlistItemTodo"
  | "WarrantyTicket"
  | "HomeownerContract"
  | "HomeownerContractChangeOrder"
  | "ReadyPlan"
  | "PlanPackage"
  | "GlobalOption"
  | "ProjectCostCode"
  | "CommitmentChangeOrder"
  | "DesignPackage"
  | "Development"
  | "ItemTemplateItem"
  | "MaterialVariant"
  | "ProductOffering"
  | "ProjectReadyPlanConfig"
  | "ProjectSiteCondition"
  | "ReadyPlanOption"
  | "TakeoffLineItem"
  | "TakeoffLineItemVersion";

export function newHasBlueprintUrl(): Approval;
export function newHasBlueprintUrl(options: ApprovalOptions, cache?: Record<string, any>): Approval;
export function newHasBlueprintUrl(
  options: RequireTypename<BidContractOptions>,
  cache?: Record<string, any>,
): BidContract;
export function newHasBlueprintUrl(
  options: RequireTypename<BidContractRevisionOptions>,
  cache?: Record<string, any>,
): BidContractRevision;
export function newHasBlueprintUrl(options: RequireTypename<BidItemOptions>, cache?: Record<string, any>): BidItem;
export function newHasBlueprintUrl(
  options: RequireTypename<BidPackageRequestOptions>,
  cache?: Record<string, any>,
): BidPackageRequest;
export function newHasBlueprintUrl(options: RequireTypename<BillOptions>, cache?: Record<string, any>): Bill;
export function newHasBlueprintUrl(
  options: RequireTypename<BusinessFunctionOptions>,
  cache?: Record<string, any>,
): BusinessFunction;
export function newHasBlueprintUrl(
  options: RequireTypename<ChangeEventOptions>,
  cache?: Record<string, any>,
): ChangeEvent;
export function newHasBlueprintUrl(
  options: RequireTypename<ChangeRequestOptions>,
  cache?: Record<string, any>,
): ChangeRequest;
export function newHasBlueprintUrl(
  options: RequireTypename<ChangeRequestToDoOptions>,
  cache?: Record<string, any>,
): ChangeRequestToDo;
export function newHasBlueprintUrl(
  options: RequireTypename<SchedulePhaseOptions>,
  cache?: Record<string, any>,
): SchedulePhase;
export function newHasBlueprintUrl(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  cache?: Record<string, any>,
): ScheduleSubPhase;
export function newHasBlueprintUrl(options: RequireTypename<TaskOptions>, cache?: Record<string, any>): Task;
export function newHasBlueprintUrl(
  options: RequireTypename<ScheduleTaskOptions>,
  cache?: Record<string, any>,
): ScheduleTask;
export function newHasBlueprintUrl(options: RequireTypename<PlanTaskOptions>, cache?: Record<string, any>): PlanTask;
export function newHasBlueprintUrl(options: RequireTypename<ToDoOptions>, cache?: Record<string, any>): ToDo;
export function newHasBlueprintUrl(options: RequireTypename<InvoiceOptions>, cache?: Record<string, any>): Invoice;
export function newHasBlueprintUrl(
  options: RequireTypename<StandaloneProjectOptions>,
  cache?: Record<string, any>,
): StandaloneProject;
export function newHasBlueprintUrl(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newHasBlueprintUrl(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newHasBlueprintUrl(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newHasBlueprintUrl(
  options: RequireTypename<SubdivisionOptions>,
  cache?: Record<string, any>,
): Subdivision;
export function newHasBlueprintUrl(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newHasBlueprintUrl(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newHasBlueprintUrl(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newHasBlueprintUrl(
  options: RequireTypename<ProjectItemOptions>,
  cache?: Record<string, any>,
): ProjectItem;
export function newHasBlueprintUrl(options: RequireTypename<EstimateOptions>, cache?: Record<string, any>): Estimate;
export function newHasBlueprintUrl(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  cache?: Record<string, any>,
): DevelopmentCommitment;
export function newHasBlueprintUrl(
  options: RequireTypename<CommitmentOptions>,
  cache?: Record<string, any>,
): Commitment;
export function newHasBlueprintUrl(options: RequireTypename<DocumentOptions>, cache?: Record<string, any>): Document;
export function newHasBlueprintUrl(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  cache?: Record<string, any>,
): ItemTemplateItemVersion;
export function newHasBlueprintUrl(
  options: RequireTypename<JobLogNoteOptions>,
  cache?: Record<string, any>,
): JobLogNote;
export function newHasBlueprintUrl(
  options: RequireTypename<TradePartnerAvailabilityRequestOptions>,
  cache?: Record<string, any>,
): TradePartnerAvailabilityRequest;
export function newHasBlueprintUrl(
  options: RequireTypename<PunchlistItemTodoOptions>,
  cache?: Record<string, any>,
): PunchlistItemTodo;
export function newHasBlueprintUrl(
  options: RequireTypename<WarrantyTicketOptions>,
  cache?: Record<string, any>,
): WarrantyTicket;
export function newHasBlueprintUrl(
  options: RequireTypename<HomeownerContractOptions>,
  cache?: Record<string, any>,
): HomeownerContract;
export function newHasBlueprintUrl(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  cache?: Record<string, any>,
): HomeownerContractChangeOrder;
export function newHasBlueprintUrl(options: RequireTypename<ReadyPlanOptions>, cache?: Record<string, any>): ReadyPlan;
export function newHasBlueprintUrl(
  options: RequireTypename<PlanPackageOptions>,
  cache?: Record<string, any>,
): PlanPackage;
export function newHasBlueprintUrl(
  options: RequireTypename<GlobalOptionOptions>,
  cache?: Record<string, any>,
): GlobalOption;
export function newHasBlueprintUrl(
  options: RequireTypename<ProjectCostCodeOptions>,
  cache?: Record<string, any>,
): ProjectCostCode;
export function newHasBlueprintUrl(
  options: RequireTypename<CommitmentChangeOrderOptions>,
  cache?: Record<string, any>,
): CommitmentChangeOrder;
export function newHasBlueprintUrl(
  options: RequireTypename<DesignPackageOptions>,
  cache?: Record<string, any>,
): DesignPackage;
export function newHasBlueprintUrl(
  options: RequireTypename<DevelopmentOptions>,
  cache?: Record<string, any>,
): Development;
export function newHasBlueprintUrl(
  options: RequireTypename<ItemTemplateItemOptions>,
  cache?: Record<string, any>,
): ItemTemplateItem;
export function newHasBlueprintUrl(
  options: RequireTypename<MaterialVariantOptions>,
  cache?: Record<string, any>,
): MaterialVariant;
export function newHasBlueprintUrl(
  options: RequireTypename<ProductOfferingOptions>,
  cache?: Record<string, any>,
): ProductOffering;
export function newHasBlueprintUrl(
  options: RequireTypename<ProjectReadyPlanConfigOptions>,
  cache?: Record<string, any>,
): ProjectReadyPlanConfig;
export function newHasBlueprintUrl(
  options: RequireTypename<ProjectSiteConditionOptions>,
  cache?: Record<string, any>,
): ProjectSiteCondition;
export function newHasBlueprintUrl(
  options: RequireTypename<ReadyPlanOptionOptions>,
  cache?: Record<string, any>,
): ReadyPlanOption;
export function newHasBlueprintUrl(
  options: RequireTypename<TakeoffLineItemOptions>,
  cache?: Record<string, any>,
): TakeoffLineItem;
export function newHasBlueprintUrl(
  options: RequireTypename<TakeoffLineItemVersionOptions>,
  cache?: Record<string, any>,
): TakeoffLineItemVersion;
export function newHasBlueprintUrl(
  options: HasBlueprintUrlOptions = {},
  cache: Record<string, any> = {},
): HasBlueprintUrlType {
  const { __typename = "Approval" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasBlueprintUrl"] = newHasBlueprintUrl;

export type NamedOptions =
  | ApprovalOptions
  | RequireTypename<BidContractOptions>
  | RequireTypename<BidContractLineItemOptions>
  | RequireTypename<BidItemOptions>
  | RequireTypename<BidPackageOptions>
  | RequireTypename<BidPackageRequestOptions>
  | RequireTypename<TradePartnerOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<BusinessFunctionOptions>
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<ChangeEventLineItemOptions>
  | RequireTypename<ChangeEventReasonOptions>
  | RequireTypename<ChangeEventTemplateConfigOptions>
  | RequireTypename<ChangeRequestOptions>
  | RequireTypename<ChangeRequestAssetOptions>
  | RequireTypename<ChangeRequestToDoOptions>
  | RequireTypename<ClientOptions>
  | RequireTypename<CohortOptions>
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<ScheduleTaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<ToDoOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<TradePartnerAvailabilityRequestOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<WarrantyTicketOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<HomeownerContractChangeOrderOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<GlobalOptionOptions>
  | RequireTypename<ProjectCostCodeOptions>
  | RequireTypename<CommitmentChangeOrderOptions>
  | RequireTypename<CostCodeOptions>
  | RequireTypename<CostDivisionOptions>
  | RequireTypename<CustomerOptions>
  | RequireTypename<CustomerOwnerEntityOptions>
  | RequireTypename<DesignPackageOptions>
  | RequireTypename<DevelopmentOptions>
  | RequireTypename<GlobalOptionTagOptions>
  | RequireTypename<GlobalOptionTypeOptions>
  | RequireTypename<GlobalPlanConstraintItemOptions>
  | RequireTypename<GlobalPlanMilestoneOptions>
  | RequireTypename<GlobalPlanTaskOptions>
  | RequireTypename<GlobalTaskOptions>
  | RequireTypename<HomeownerContractDrawOptions>
  | RequireTypename<InternalUserOptions>
  | RequireTypename<InvoiceScheduleTemplateOptions>
  | RequireTypename<ItemOptions>
  | RequireTypename<ItemSlotOptions>
  | RequireTypename<ItemTemplateOptions>
  | RequireTypename<ItemTemplateItemOptions>
  | RequireTypename<LocationOptions>
  | RequireTypename<MaterialVariantTagOptions>
  | RequireTypename<PandaDocOptions>
  | RequireTypename<PandaDocRecipientOptions>
  | RequireTypename<PlanMilestoneOptions>
  | RequireTypename<ProductOfferingOptions>
  | RequireTypename<ProjectStageTemplateConfigOptions>
  | RequireTypename<ProjectStatusChangeReasonOptions>
  | RequireTypename<ReadyPlanAggregateVersionOptions>
  | RequireTypename<ReadyPlanLocationOptions>
  | RequireTypename<ReadyPlanOptionOptions>
  | RequireTypename<ReadyPlanOptionProgramDataModificationOptions>
  | RequireTypename<ScheduleOptions>
  | RequireTypename<ScheduleTemplateOptions>
  | RequireTypename<SubmarketOptions>
  | RequireTypename<TakeoffLineItemOptions>
  | RequireTypename<TakeoffLineItemVersionOptions>
  | RequireTypename<TradeCategoryOptions>
  | RequireTypename<TradePartnerContactOptions>
  | RequireTypename<TradePartnerMailingListOptions>
  | RequireTypename<TradePartnerUserOptions>
  | RequireTypename<UnitOfMeasureOptions>
  | RequireTypename<UserOptions>;

export type NamedType =
  | Approval
  | BidContract
  | BidContractLineItem
  | BidItem
  | BidPackage
  | BidPackageRequest
  | TradePartner
  | Bill
  | BusinessFunction
  | ChangeEvent
  | ChangeEventLineItem
  | ChangeEventReason
  | ChangeEventTemplateConfig
  | ChangeRequest
  | ChangeRequestAsset
  | ChangeRequestToDo
  | Client
  | Cohort
  | SchedulePhase
  | ScheduleSubPhase
  | Task
  | ScheduleTask
  | PlanTask
  | ToDo
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | DevelopmentCommitment
  | Commitment
  | Document
  | ItemTemplateItemVersion
  | JobLogNote
  | TradePartnerAvailabilityRequest
  | PunchlistItemTodo
  | WarrantyTicket
  | HomeownerContract
  | HomeownerContractChangeOrder
  | ReadyPlan
  | PlanPackage
  | GlobalOption
  | ProjectCostCode
  | CommitmentChangeOrder
  | CostCode
  | CostDivision
  | Customer
  | CustomerOwnerEntity
  | DesignPackage
  | Development
  | GlobalOptionTag
  | GlobalOptionType
  | GlobalPlanConstraintItem
  | GlobalPlanMilestone
  | GlobalPlanTask
  | GlobalTask
  | HomeownerContractDraw
  | InternalUser
  | InvoiceScheduleTemplate
  | Item
  | ItemSlot
  | ItemTemplate
  | ItemTemplateItem
  | Location
  | MaterialVariantTag
  | PandaDoc
  | PandaDocRecipient
  | PlanMilestone
  | ProductOffering
  | ProjectStageTemplateConfig
  | ProjectStatusChangeReason
  | ReadyPlanAggregateVersion
  | ReadyPlanLocation
  | ReadyPlanOption
  | ReadyPlanOptionProgramDataModification
  | Schedule
  | ScheduleTemplate
  | Submarket
  | TakeoffLineItem
  | TakeoffLineItemVersion
  | TradeCategory
  | TradePartnerContact
  | TradePartnerMailingList
  | TradePartnerUser
  | UnitOfMeasure
  | User;

export type NamedTypeName =
  | "Approval"
  | "BidContract"
  | "BidContractLineItem"
  | "BidItem"
  | "BidPackage"
  | "BidPackageRequest"
  | "TradePartner"
  | "Bill"
  | "BusinessFunction"
  | "ChangeEvent"
  | "ChangeEventLineItem"
  | "ChangeEventReason"
  | "ChangeEventTemplateConfig"
  | "ChangeRequest"
  | "ChangeRequestAsset"
  | "ChangeRequestToDo"
  | "Client"
  | "Cohort"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "ScheduleTask"
  | "PlanTask"
  | "ToDo"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "DevelopmentCommitment"
  | "Commitment"
  | "Document"
  | "ItemTemplateItemVersion"
  | "JobLogNote"
  | "TradePartnerAvailabilityRequest"
  | "PunchlistItemTodo"
  | "WarrantyTicket"
  | "HomeownerContract"
  | "HomeownerContractChangeOrder"
  | "ReadyPlan"
  | "PlanPackage"
  | "GlobalOption"
  | "ProjectCostCode"
  | "CommitmentChangeOrder"
  | "CostCode"
  | "CostDivision"
  | "Customer"
  | "CustomerOwnerEntity"
  | "DesignPackage"
  | "Development"
  | "GlobalOptionTag"
  | "GlobalOptionType"
  | "GlobalPlanConstraintItem"
  | "GlobalPlanMilestone"
  | "GlobalPlanTask"
  | "GlobalTask"
  | "HomeownerContractDraw"
  | "InternalUser"
  | "InvoiceScheduleTemplate"
  | "Item"
  | "ItemSlot"
  | "ItemTemplate"
  | "ItemTemplateItem"
  | "Location"
  | "MaterialVariantTag"
  | "PandaDoc"
  | "PandaDocRecipient"
  | "PlanMilestone"
  | "ProductOffering"
  | "ProjectStageTemplateConfig"
  | "ProjectStatusChangeReason"
  | "ReadyPlanAggregateVersion"
  | "ReadyPlanLocation"
  | "ReadyPlanOption"
  | "ReadyPlanOptionProgramDataModification"
  | "Schedule"
  | "ScheduleTemplate"
  | "Submarket"
  | "TakeoffLineItem"
  | "TakeoffLineItemVersion"
  | "TradeCategory"
  | "TradePartnerContact"
  | "TradePartnerMailingList"
  | "TradePartnerUser"
  | "UnitOfMeasure"
  | "User";

export function newNamed(): Approval;
export function newNamed(options: ApprovalOptions, cache?: Record<string, any>): Approval;
export function newNamed(options: RequireTypename<BidContractOptions>, cache?: Record<string, any>): BidContract;
export function newNamed(
  options: RequireTypename<BidContractLineItemOptions>,
  cache?: Record<string, any>,
): BidContractLineItem;
export function newNamed(options: RequireTypename<BidItemOptions>, cache?: Record<string, any>): BidItem;
export function newNamed(options: RequireTypename<BidPackageOptions>, cache?: Record<string, any>): BidPackage;
export function newNamed(
  options: RequireTypename<BidPackageRequestOptions>,
  cache?: Record<string, any>,
): BidPackageRequest;
export function newNamed(options: RequireTypename<TradePartnerOptions>, cache?: Record<string, any>): TradePartner;
export function newNamed(options: RequireTypename<BillOptions>, cache?: Record<string, any>): Bill;
export function newNamed(
  options: RequireTypename<BusinessFunctionOptions>,
  cache?: Record<string, any>,
): BusinessFunction;
export function newNamed(options: RequireTypename<ChangeEventOptions>, cache?: Record<string, any>): ChangeEvent;
export function newNamed(
  options: RequireTypename<ChangeEventLineItemOptions>,
  cache?: Record<string, any>,
): ChangeEventLineItem;
export function newNamed(
  options: RequireTypename<ChangeEventReasonOptions>,
  cache?: Record<string, any>,
): ChangeEventReason;
export function newNamed(
  options: RequireTypename<ChangeEventTemplateConfigOptions>,
  cache?: Record<string, any>,
): ChangeEventTemplateConfig;
export function newNamed(options: RequireTypename<ChangeRequestOptions>, cache?: Record<string, any>): ChangeRequest;
export function newNamed(
  options: RequireTypename<ChangeRequestAssetOptions>,
  cache?: Record<string, any>,
): ChangeRequestAsset;
export function newNamed(
  options: RequireTypename<ChangeRequestToDoOptions>,
  cache?: Record<string, any>,
): ChangeRequestToDo;
export function newNamed(options: RequireTypename<ClientOptions>, cache?: Record<string, any>): Client;
export function newNamed(options: RequireTypename<CohortOptions>, cache?: Record<string, any>): Cohort;
export function newNamed(options: RequireTypename<SchedulePhaseOptions>, cache?: Record<string, any>): SchedulePhase;
export function newNamed(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  cache?: Record<string, any>,
): ScheduleSubPhase;
export function newNamed(options: RequireTypename<TaskOptions>, cache?: Record<string, any>): Task;
export function newNamed(options: RequireTypename<ScheduleTaskOptions>, cache?: Record<string, any>): ScheduleTask;
export function newNamed(options: RequireTypename<PlanTaskOptions>, cache?: Record<string, any>): PlanTask;
export function newNamed(options: RequireTypename<ToDoOptions>, cache?: Record<string, any>): ToDo;
export function newNamed(options: RequireTypename<InvoiceOptions>, cache?: Record<string, any>): Invoice;
export function newNamed(
  options: RequireTypename<StandaloneProjectOptions>,
  cache?: Record<string, any>,
): StandaloneProject;
export function newNamed(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newNamed(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newNamed(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newNamed(options: RequireTypename<SubdivisionOptions>, cache?: Record<string, any>): Subdivision;
export function newNamed(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newNamed(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newNamed(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newNamed(options: RequireTypename<ProjectItemOptions>, cache?: Record<string, any>): ProjectItem;
export function newNamed(options: RequireTypename<EstimateOptions>, cache?: Record<string, any>): Estimate;
export function newNamed(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  cache?: Record<string, any>,
): DevelopmentCommitment;
export function newNamed(options: RequireTypename<CommitmentOptions>, cache?: Record<string, any>): Commitment;
export function newNamed(options: RequireTypename<DocumentOptions>, cache?: Record<string, any>): Document;
export function newNamed(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  cache?: Record<string, any>,
): ItemTemplateItemVersion;
export function newNamed(options: RequireTypename<JobLogNoteOptions>, cache?: Record<string, any>): JobLogNote;
export function newNamed(
  options: RequireTypename<TradePartnerAvailabilityRequestOptions>,
  cache?: Record<string, any>,
): TradePartnerAvailabilityRequest;
export function newNamed(
  options: RequireTypename<PunchlistItemTodoOptions>,
  cache?: Record<string, any>,
): PunchlistItemTodo;
export function newNamed(options: RequireTypename<WarrantyTicketOptions>, cache?: Record<string, any>): WarrantyTicket;
export function newNamed(
  options: RequireTypename<HomeownerContractOptions>,
  cache?: Record<string, any>,
): HomeownerContract;
export function newNamed(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  cache?: Record<string, any>,
): HomeownerContractChangeOrder;
export function newNamed(options: RequireTypename<ReadyPlanOptions>, cache?: Record<string, any>): ReadyPlan;
export function newNamed(options: RequireTypename<PlanPackageOptions>, cache?: Record<string, any>): PlanPackage;
export function newNamed(options: RequireTypename<GlobalOptionOptions>, cache?: Record<string, any>): GlobalOption;
export function newNamed(
  options: RequireTypename<ProjectCostCodeOptions>,
  cache?: Record<string, any>,
): ProjectCostCode;
export function newNamed(
  options: RequireTypename<CommitmentChangeOrderOptions>,
  cache?: Record<string, any>,
): CommitmentChangeOrder;
export function newNamed(options: RequireTypename<CostCodeOptions>, cache?: Record<string, any>): CostCode;
export function newNamed(options: RequireTypename<CostDivisionOptions>, cache?: Record<string, any>): CostDivision;
export function newNamed(options: RequireTypename<CustomerOptions>, cache?: Record<string, any>): Customer;
export function newNamed(
  options: RequireTypename<CustomerOwnerEntityOptions>,
  cache?: Record<string, any>,
): CustomerOwnerEntity;
export function newNamed(options: RequireTypename<DesignPackageOptions>, cache?: Record<string, any>): DesignPackage;
export function newNamed(options: RequireTypename<DevelopmentOptions>, cache?: Record<string, any>): Development;
export function newNamed(
  options: RequireTypename<GlobalOptionTagOptions>,
  cache?: Record<string, any>,
): GlobalOptionTag;
export function newNamed(
  options: RequireTypename<GlobalOptionTypeOptions>,
  cache?: Record<string, any>,
): GlobalOptionType;
export function newNamed(
  options: RequireTypename<GlobalPlanConstraintItemOptions>,
  cache?: Record<string, any>,
): GlobalPlanConstraintItem;
export function newNamed(
  options: RequireTypename<GlobalPlanMilestoneOptions>,
  cache?: Record<string, any>,
): GlobalPlanMilestone;
export function newNamed(options: RequireTypename<GlobalPlanTaskOptions>, cache?: Record<string, any>): GlobalPlanTask;
export function newNamed(options: RequireTypename<GlobalTaskOptions>, cache?: Record<string, any>): GlobalTask;
export function newNamed(
  options: RequireTypename<HomeownerContractDrawOptions>,
  cache?: Record<string, any>,
): HomeownerContractDraw;
export function newNamed(options: RequireTypename<InternalUserOptions>, cache?: Record<string, any>): InternalUser;
export function newNamed(
  options: RequireTypename<InvoiceScheduleTemplateOptions>,
  cache?: Record<string, any>,
): InvoiceScheduleTemplate;
export function newNamed(options: RequireTypename<ItemOptions>, cache?: Record<string, any>): Item;
export function newNamed(options: RequireTypename<ItemSlotOptions>, cache?: Record<string, any>): ItemSlot;
export function newNamed(options: RequireTypename<ItemTemplateOptions>, cache?: Record<string, any>): ItemTemplate;
export function newNamed(
  options: RequireTypename<ItemTemplateItemOptions>,
  cache?: Record<string, any>,
): ItemTemplateItem;
export function newNamed(options: RequireTypename<LocationOptions>, cache?: Record<string, any>): Location;
export function newNamed(
  options: RequireTypename<MaterialVariantTagOptions>,
  cache?: Record<string, any>,
): MaterialVariantTag;
export function newNamed(options: RequireTypename<PandaDocOptions>, cache?: Record<string, any>): PandaDoc;
export function newNamed(
  options: RequireTypename<PandaDocRecipientOptions>,
  cache?: Record<string, any>,
): PandaDocRecipient;
export function newNamed(options: RequireTypename<PlanMilestoneOptions>, cache?: Record<string, any>): PlanMilestone;
export function newNamed(
  options: RequireTypename<ProductOfferingOptions>,
  cache?: Record<string, any>,
): ProductOffering;
export function newNamed(
  options: RequireTypename<ProjectStageTemplateConfigOptions>,
  cache?: Record<string, any>,
): ProjectStageTemplateConfig;
export function newNamed(
  options: RequireTypename<ProjectStatusChangeReasonOptions>,
  cache?: Record<string, any>,
): ProjectStatusChangeReason;
export function newNamed(
  options: RequireTypename<ReadyPlanAggregateVersionOptions>,
  cache?: Record<string, any>,
): ReadyPlanAggregateVersion;
export function newNamed(
  options: RequireTypename<ReadyPlanLocationOptions>,
  cache?: Record<string, any>,
): ReadyPlanLocation;
export function newNamed(
  options: RequireTypename<ReadyPlanOptionOptions>,
  cache?: Record<string, any>,
): ReadyPlanOption;
export function newNamed(
  options: RequireTypename<ReadyPlanOptionProgramDataModificationOptions>,
  cache?: Record<string, any>,
): ReadyPlanOptionProgramDataModification;
export function newNamed(options: RequireTypename<ScheduleOptions>, cache?: Record<string, any>): Schedule;
export function newNamed(
  options: RequireTypename<ScheduleTemplateOptions>,
  cache?: Record<string, any>,
): ScheduleTemplate;
export function newNamed(options: RequireTypename<SubmarketOptions>, cache?: Record<string, any>): Submarket;
export function newNamed(
  options: RequireTypename<TakeoffLineItemOptions>,
  cache?: Record<string, any>,
): TakeoffLineItem;
export function newNamed(
  options: RequireTypename<TakeoffLineItemVersionOptions>,
  cache?: Record<string, any>,
): TakeoffLineItemVersion;
export function newNamed(options: RequireTypename<TradeCategoryOptions>, cache?: Record<string, any>): TradeCategory;
export function newNamed(
  options: RequireTypename<TradePartnerContactOptions>,
  cache?: Record<string, any>,
): TradePartnerContact;
export function newNamed(
  options: RequireTypename<TradePartnerMailingListOptions>,
  cache?: Record<string, any>,
): TradePartnerMailingList;
export function newNamed(
  options: RequireTypename<TradePartnerUserOptions>,
  cache?: Record<string, any>,
): TradePartnerUser;
export function newNamed(options: RequireTypename<UnitOfMeasureOptions>, cache?: Record<string, any>): UnitOfMeasure;
export function newNamed(options: RequireTypename<UserOptions>, cache?: Record<string, any>): User;
export function newNamed(options: NamedOptions = {}, cache: Record<string, any> = {}): NamedType {
  const { __typename = "Approval" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["Named"] = newNamed;

export type CanCollaborateOptions =
  | ApprovalOptions
  | RequireTypename<BidContractOptions>
  | RequireTypename<BidItemOptions>
  | RequireTypename<BidPackageRequestOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<ChangeRequestOptions>
  | RequireTypename<ChangeRequestToDoOptions>
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<ScheduleTaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<ToDoOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<TradePartnerAvailabilityRequestOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<WarrantyTicketOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<HomeownerContractChangeOrderOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<GlobalOptionOptions>
  | RequireTypename<ProjectCostCodeOptions>;

export type CanCollaborateType =
  | Approval
  | BidContract
  | BidItem
  | BidPackageRequest
  | Bill
  | ChangeEvent
  | ChangeRequest
  | ChangeRequestToDo
  | SchedulePhase
  | ScheduleSubPhase
  | Task
  | ScheduleTask
  | PlanTask
  | ToDo
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | DevelopmentCommitment
  | Commitment
  | Document
  | ItemTemplateItemVersion
  | JobLogNote
  | TradePartnerAvailabilityRequest
  | PunchlistItemTodo
  | WarrantyTicket
  | HomeownerContract
  | HomeownerContractChangeOrder
  | ReadyPlan
  | PlanPackage
  | GlobalOption
  | ProjectCostCode;

export type CanCollaborateTypeName =
  | "Approval"
  | "BidContract"
  | "BidItem"
  | "BidPackageRequest"
  | "Bill"
  | "ChangeEvent"
  | "ChangeRequest"
  | "ChangeRequestToDo"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "ScheduleTask"
  | "PlanTask"
  | "ToDo"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "DevelopmentCommitment"
  | "Commitment"
  | "Document"
  | "ItemTemplateItemVersion"
  | "JobLogNote"
  | "TradePartnerAvailabilityRequest"
  | "PunchlistItemTodo"
  | "WarrantyTicket"
  | "HomeownerContract"
  | "HomeownerContractChangeOrder"
  | "ReadyPlan"
  | "PlanPackage"
  | "GlobalOption"
  | "ProjectCostCode";

export function newCanCollaborate(): Approval;
export function newCanCollaborate(options: ApprovalOptions, cache?: Record<string, any>): Approval;
export function newCanCollaborate(
  options: RequireTypename<BidContractOptions>,
  cache?: Record<string, any>,
): BidContract;
export function newCanCollaborate(options: RequireTypename<BidItemOptions>, cache?: Record<string, any>): BidItem;
export function newCanCollaborate(
  options: RequireTypename<BidPackageRequestOptions>,
  cache?: Record<string, any>,
): BidPackageRequest;
export function newCanCollaborate(options: RequireTypename<BillOptions>, cache?: Record<string, any>): Bill;
export function newCanCollaborate(
  options: RequireTypename<ChangeEventOptions>,
  cache?: Record<string, any>,
): ChangeEvent;
export function newCanCollaborate(
  options: RequireTypename<ChangeRequestOptions>,
  cache?: Record<string, any>,
): ChangeRequest;
export function newCanCollaborate(
  options: RequireTypename<ChangeRequestToDoOptions>,
  cache?: Record<string, any>,
): ChangeRequestToDo;
export function newCanCollaborate(
  options: RequireTypename<SchedulePhaseOptions>,
  cache?: Record<string, any>,
): SchedulePhase;
export function newCanCollaborate(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  cache?: Record<string, any>,
): ScheduleSubPhase;
export function newCanCollaborate(options: RequireTypename<TaskOptions>, cache?: Record<string, any>): Task;
export function newCanCollaborate(
  options: RequireTypename<ScheduleTaskOptions>,
  cache?: Record<string, any>,
): ScheduleTask;
export function newCanCollaborate(options: RequireTypename<PlanTaskOptions>, cache?: Record<string, any>): PlanTask;
export function newCanCollaborate(options: RequireTypename<ToDoOptions>, cache?: Record<string, any>): ToDo;
export function newCanCollaborate(options: RequireTypename<InvoiceOptions>, cache?: Record<string, any>): Invoice;
export function newCanCollaborate(
  options: RequireTypename<StandaloneProjectOptions>,
  cache?: Record<string, any>,
): StandaloneProject;
export function newCanCollaborate(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newCanCollaborate(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newCanCollaborate(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newCanCollaborate(
  options: RequireTypename<SubdivisionOptions>,
  cache?: Record<string, any>,
): Subdivision;
export function newCanCollaborate(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newCanCollaborate(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newCanCollaborate(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newCanCollaborate(
  options: RequireTypename<ProjectItemOptions>,
  cache?: Record<string, any>,
): ProjectItem;
export function newCanCollaborate(options: RequireTypename<EstimateOptions>, cache?: Record<string, any>): Estimate;
export function newCanCollaborate(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  cache?: Record<string, any>,
): DevelopmentCommitment;
export function newCanCollaborate(options: RequireTypename<CommitmentOptions>, cache?: Record<string, any>): Commitment;
export function newCanCollaborate(options: RequireTypename<DocumentOptions>, cache?: Record<string, any>): Document;
export function newCanCollaborate(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  cache?: Record<string, any>,
): ItemTemplateItemVersion;
export function newCanCollaborate(options: RequireTypename<JobLogNoteOptions>, cache?: Record<string, any>): JobLogNote;
export function newCanCollaborate(
  options: RequireTypename<TradePartnerAvailabilityRequestOptions>,
  cache?: Record<string, any>,
): TradePartnerAvailabilityRequest;
export function newCanCollaborate(
  options: RequireTypename<PunchlistItemTodoOptions>,
  cache?: Record<string, any>,
): PunchlistItemTodo;
export function newCanCollaborate(
  options: RequireTypename<WarrantyTicketOptions>,
  cache?: Record<string, any>,
): WarrantyTicket;
export function newCanCollaborate(
  options: RequireTypename<HomeownerContractOptions>,
  cache?: Record<string, any>,
): HomeownerContract;
export function newCanCollaborate(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  cache?: Record<string, any>,
): HomeownerContractChangeOrder;
export function newCanCollaborate(options: RequireTypename<ReadyPlanOptions>, cache?: Record<string, any>): ReadyPlan;
export function newCanCollaborate(
  options: RequireTypename<PlanPackageOptions>,
  cache?: Record<string, any>,
): PlanPackage;
export function newCanCollaborate(
  options: RequireTypename<GlobalOptionOptions>,
  cache?: Record<string, any>,
): GlobalOption;
export function newCanCollaborate(
  options: RequireTypename<ProjectCostCodeOptions>,
  cache?: Record<string, any>,
): ProjectCostCode;
export function newCanCollaborate(
  options: CanCollaborateOptions = {},
  cache: Record<string, any> = {},
): CanCollaborateType {
  const { __typename = "Approval" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["CanCollaborate"] = newCanCollaborate;

export type CommentableOptions =
  | ApprovalOptions
  | RequireTypename<BidContractOptions>
  | RequireTypename<BidItemOptions>
  | RequireTypename<BidPackageRequestOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<ChangeRequestOptions>
  | RequireTypename<ChangeRequestToDoOptions>
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<ScheduleTaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<ToDoOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<TradePartnerAvailabilityRequestOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<WarrantyTicketOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<HomeownerContractChangeOrderOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<GlobalOptionOptions>
  | RequireTypename<ProjectCostCodeOptions>;

export type CommentableType =
  | Approval
  | BidContract
  | BidItem
  | BidPackageRequest
  | Bill
  | ChangeEvent
  | ChangeRequest
  | ChangeRequestToDo
  | SchedulePhase
  | ScheduleSubPhase
  | Task
  | ScheduleTask
  | PlanTask
  | ToDo
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | DevelopmentCommitment
  | Commitment
  | Document
  | ItemTemplateItemVersion
  | JobLogNote
  | TradePartnerAvailabilityRequest
  | PunchlistItemTodo
  | WarrantyTicket
  | HomeownerContract
  | HomeownerContractChangeOrder
  | ReadyPlan
  | PlanPackage
  | GlobalOption
  | ProjectCostCode;

export type CommentableTypeName =
  | "Approval"
  | "BidContract"
  | "BidItem"
  | "BidPackageRequest"
  | "Bill"
  | "ChangeEvent"
  | "ChangeRequest"
  | "ChangeRequestToDo"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "ScheduleTask"
  | "PlanTask"
  | "ToDo"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "DevelopmentCommitment"
  | "Commitment"
  | "Document"
  | "ItemTemplateItemVersion"
  | "JobLogNote"
  | "TradePartnerAvailabilityRequest"
  | "PunchlistItemTodo"
  | "WarrantyTicket"
  | "HomeownerContract"
  | "HomeownerContractChangeOrder"
  | "ReadyPlan"
  | "PlanPackage"
  | "GlobalOption"
  | "ProjectCostCode";

export function newCommentable(): Approval;
export function newCommentable(options: ApprovalOptions, cache?: Record<string, any>): Approval;
export function newCommentable(options: RequireTypename<BidContractOptions>, cache?: Record<string, any>): BidContract;
export function newCommentable(options: RequireTypename<BidItemOptions>, cache?: Record<string, any>): BidItem;
export function newCommentable(
  options: RequireTypename<BidPackageRequestOptions>,
  cache?: Record<string, any>,
): BidPackageRequest;
export function newCommentable(options: RequireTypename<BillOptions>, cache?: Record<string, any>): Bill;
export function newCommentable(options: RequireTypename<ChangeEventOptions>, cache?: Record<string, any>): ChangeEvent;
export function newCommentable(
  options: RequireTypename<ChangeRequestOptions>,
  cache?: Record<string, any>,
): ChangeRequest;
export function newCommentable(
  options: RequireTypename<ChangeRequestToDoOptions>,
  cache?: Record<string, any>,
): ChangeRequestToDo;
export function newCommentable(
  options: RequireTypename<SchedulePhaseOptions>,
  cache?: Record<string, any>,
): SchedulePhase;
export function newCommentable(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  cache?: Record<string, any>,
): ScheduleSubPhase;
export function newCommentable(options: RequireTypename<TaskOptions>, cache?: Record<string, any>): Task;
export function newCommentable(
  options: RequireTypename<ScheduleTaskOptions>,
  cache?: Record<string, any>,
): ScheduleTask;
export function newCommentable(options: RequireTypename<PlanTaskOptions>, cache?: Record<string, any>): PlanTask;
export function newCommentable(options: RequireTypename<ToDoOptions>, cache?: Record<string, any>): ToDo;
export function newCommentable(options: RequireTypename<InvoiceOptions>, cache?: Record<string, any>): Invoice;
export function newCommentable(
  options: RequireTypename<StandaloneProjectOptions>,
  cache?: Record<string, any>,
): StandaloneProject;
export function newCommentable(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newCommentable(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newCommentable(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newCommentable(options: RequireTypename<SubdivisionOptions>, cache?: Record<string, any>): Subdivision;
export function newCommentable(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newCommentable(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newCommentable(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newCommentable(options: RequireTypename<ProjectItemOptions>, cache?: Record<string, any>): ProjectItem;
export function newCommentable(options: RequireTypename<EstimateOptions>, cache?: Record<string, any>): Estimate;
export function newCommentable(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  cache?: Record<string, any>,
): DevelopmentCommitment;
export function newCommentable(options: RequireTypename<CommitmentOptions>, cache?: Record<string, any>): Commitment;
export function newCommentable(options: RequireTypename<DocumentOptions>, cache?: Record<string, any>): Document;
export function newCommentable(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  cache?: Record<string, any>,
): ItemTemplateItemVersion;
export function newCommentable(options: RequireTypename<JobLogNoteOptions>, cache?: Record<string, any>): JobLogNote;
export function newCommentable(
  options: RequireTypename<TradePartnerAvailabilityRequestOptions>,
  cache?: Record<string, any>,
): TradePartnerAvailabilityRequest;
export function newCommentable(
  options: RequireTypename<PunchlistItemTodoOptions>,
  cache?: Record<string, any>,
): PunchlistItemTodo;
export function newCommentable(
  options: RequireTypename<WarrantyTicketOptions>,
  cache?: Record<string, any>,
): WarrantyTicket;
export function newCommentable(
  options: RequireTypename<HomeownerContractOptions>,
  cache?: Record<string, any>,
): HomeownerContract;
export function newCommentable(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  cache?: Record<string, any>,
): HomeownerContractChangeOrder;
export function newCommentable(options: RequireTypename<ReadyPlanOptions>, cache?: Record<string, any>): ReadyPlan;
export function newCommentable(options: RequireTypename<PlanPackageOptions>, cache?: Record<string, any>): PlanPackage;
export function newCommentable(
  options: RequireTypename<GlobalOptionOptions>,
  cache?: Record<string, any>,
): GlobalOption;
export function newCommentable(
  options: RequireTypename<ProjectCostCodeOptions>,
  cache?: Record<string, any>,
): ProjectCostCode;
export function newCommentable(options: CommentableOptions = {}, cache: Record<string, any> = {}): CommentableType {
  const { __typename = "Approval" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["Commentable"] = newCommentable;

export type ReferencableOptions =
  | ApprovalOptions
  | RequireTypename<BidContractOptions>
  | RequireTypename<BidItemOptions>
  | RequireTypename<BidPackageRequestOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<ChangeRequestOptions>
  | RequireTypename<ChangeRequestToDoOptions>
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<ScheduleTaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<ToDoOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<TradePartnerAvailabilityRequestOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<WarrantyTicketOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<HomeownerContractChangeOrderOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<GlobalOptionOptions>
  | RequireTypename<ProjectCostCodeOptions>;

export type ReferencableType =
  | Approval
  | BidContract
  | BidItem
  | BidPackageRequest
  | Bill
  | ChangeEvent
  | ChangeRequest
  | ChangeRequestToDo
  | SchedulePhase
  | ScheduleSubPhase
  | Task
  | ScheduleTask
  | PlanTask
  | ToDo
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | DevelopmentCommitment
  | Commitment
  | Document
  | ItemTemplateItemVersion
  | JobLogNote
  | TradePartnerAvailabilityRequest
  | PunchlistItemTodo
  | WarrantyTicket
  | HomeownerContract
  | HomeownerContractChangeOrder
  | ReadyPlan
  | PlanPackage
  | GlobalOption
  | ProjectCostCode;

export type ReferencableTypeName =
  | "Approval"
  | "BidContract"
  | "BidItem"
  | "BidPackageRequest"
  | "Bill"
  | "ChangeEvent"
  | "ChangeRequest"
  | "ChangeRequestToDo"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "ScheduleTask"
  | "PlanTask"
  | "ToDo"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "DevelopmentCommitment"
  | "Commitment"
  | "Document"
  | "ItemTemplateItemVersion"
  | "JobLogNote"
  | "TradePartnerAvailabilityRequest"
  | "PunchlistItemTodo"
  | "WarrantyTicket"
  | "HomeownerContract"
  | "HomeownerContractChangeOrder"
  | "ReadyPlan"
  | "PlanPackage"
  | "GlobalOption"
  | "ProjectCostCode";

export function newReferencable(): Approval;
export function newReferencable(options: ApprovalOptions, cache?: Record<string, any>): Approval;
export function newReferencable(options: RequireTypename<BidContractOptions>, cache?: Record<string, any>): BidContract;
export function newReferencable(options: RequireTypename<BidItemOptions>, cache?: Record<string, any>): BidItem;
export function newReferencable(
  options: RequireTypename<BidPackageRequestOptions>,
  cache?: Record<string, any>,
): BidPackageRequest;
export function newReferencable(options: RequireTypename<BillOptions>, cache?: Record<string, any>): Bill;
export function newReferencable(options: RequireTypename<ChangeEventOptions>, cache?: Record<string, any>): ChangeEvent;
export function newReferencable(
  options: RequireTypename<ChangeRequestOptions>,
  cache?: Record<string, any>,
): ChangeRequest;
export function newReferencable(
  options: RequireTypename<ChangeRequestToDoOptions>,
  cache?: Record<string, any>,
): ChangeRequestToDo;
export function newReferencable(
  options: RequireTypename<SchedulePhaseOptions>,
  cache?: Record<string, any>,
): SchedulePhase;
export function newReferencable(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  cache?: Record<string, any>,
): ScheduleSubPhase;
export function newReferencable(options: RequireTypename<TaskOptions>, cache?: Record<string, any>): Task;
export function newReferencable(
  options: RequireTypename<ScheduleTaskOptions>,
  cache?: Record<string, any>,
): ScheduleTask;
export function newReferencable(options: RequireTypename<PlanTaskOptions>, cache?: Record<string, any>): PlanTask;
export function newReferencable(options: RequireTypename<ToDoOptions>, cache?: Record<string, any>): ToDo;
export function newReferencable(options: RequireTypename<InvoiceOptions>, cache?: Record<string, any>): Invoice;
export function newReferencable(
  options: RequireTypename<StandaloneProjectOptions>,
  cache?: Record<string, any>,
): StandaloneProject;
export function newReferencable(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newReferencable(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newReferencable(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newReferencable(options: RequireTypename<SubdivisionOptions>, cache?: Record<string, any>): Subdivision;
export function newReferencable(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newReferencable(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newReferencable(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newReferencable(options: RequireTypename<ProjectItemOptions>, cache?: Record<string, any>): ProjectItem;
export function newReferencable(options: RequireTypename<EstimateOptions>, cache?: Record<string, any>): Estimate;
export function newReferencable(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  cache?: Record<string, any>,
): DevelopmentCommitment;
export function newReferencable(options: RequireTypename<CommitmentOptions>, cache?: Record<string, any>): Commitment;
export function newReferencable(options: RequireTypename<DocumentOptions>, cache?: Record<string, any>): Document;
export function newReferencable(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  cache?: Record<string, any>,
): ItemTemplateItemVersion;
export function newReferencable(options: RequireTypename<JobLogNoteOptions>, cache?: Record<string, any>): JobLogNote;
export function newReferencable(
  options: RequireTypename<TradePartnerAvailabilityRequestOptions>,
  cache?: Record<string, any>,
): TradePartnerAvailabilityRequest;
export function newReferencable(
  options: RequireTypename<PunchlistItemTodoOptions>,
  cache?: Record<string, any>,
): PunchlistItemTodo;
export function newReferencable(
  options: RequireTypename<WarrantyTicketOptions>,
  cache?: Record<string, any>,
): WarrantyTicket;
export function newReferencable(
  options: RequireTypename<HomeownerContractOptions>,
  cache?: Record<string, any>,
): HomeownerContract;
export function newReferencable(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  cache?: Record<string, any>,
): HomeownerContractChangeOrder;
export function newReferencable(options: RequireTypename<ReadyPlanOptions>, cache?: Record<string, any>): ReadyPlan;
export function newReferencable(options: RequireTypename<PlanPackageOptions>, cache?: Record<string, any>): PlanPackage;
export function newReferencable(
  options: RequireTypename<GlobalOptionOptions>,
  cache?: Record<string, any>,
): GlobalOption;
export function newReferencable(
  options: RequireTypename<ProjectCostCodeOptions>,
  cache?: Record<string, any>,
): ProjectCostCode;
export function newReferencable(options: ReferencableOptions = {}, cache: Record<string, any> = {}): ReferencableType {
  const { __typename = "Approval" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["Referencable"] = newReferencable;

export type FollowableOptions =
  | ApprovalOptions
  | RequireTypename<BidContractOptions>
  | RequireTypename<BidItemOptions>
  | RequireTypename<BidPackageRequestOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<ChangeRequestOptions>
  | RequireTypename<ChangeRequestToDoOptions>
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<ScheduleTaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<ToDoOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<TradePartnerAvailabilityRequestOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<WarrantyTicketOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<HomeownerContractChangeOrderOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<GlobalOptionOptions>
  | RequireTypename<ProjectCostCodeOptions>;

export type FollowableType =
  | Approval
  | BidContract
  | BidItem
  | BidPackageRequest
  | Bill
  | ChangeEvent
  | ChangeRequest
  | ChangeRequestToDo
  | SchedulePhase
  | ScheduleSubPhase
  | Task
  | ScheduleTask
  | PlanTask
  | ToDo
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | DevelopmentCommitment
  | Commitment
  | Document
  | ItemTemplateItemVersion
  | JobLogNote
  | TradePartnerAvailabilityRequest
  | PunchlistItemTodo
  | WarrantyTicket
  | HomeownerContract
  | HomeownerContractChangeOrder
  | ReadyPlan
  | PlanPackage
  | GlobalOption
  | ProjectCostCode;

export type FollowableTypeName =
  | "Approval"
  | "BidContract"
  | "BidItem"
  | "BidPackageRequest"
  | "Bill"
  | "ChangeEvent"
  | "ChangeRequest"
  | "ChangeRequestToDo"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "ScheduleTask"
  | "PlanTask"
  | "ToDo"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "DevelopmentCommitment"
  | "Commitment"
  | "Document"
  | "ItemTemplateItemVersion"
  | "JobLogNote"
  | "TradePartnerAvailabilityRequest"
  | "PunchlistItemTodo"
  | "WarrantyTicket"
  | "HomeownerContract"
  | "HomeownerContractChangeOrder"
  | "ReadyPlan"
  | "PlanPackage"
  | "GlobalOption"
  | "ProjectCostCode";

export function newFollowable(): Approval;
export function newFollowable(options: ApprovalOptions, cache?: Record<string, any>): Approval;
export function newFollowable(options: RequireTypename<BidContractOptions>, cache?: Record<string, any>): BidContract;
export function newFollowable(options: RequireTypename<BidItemOptions>, cache?: Record<string, any>): BidItem;
export function newFollowable(
  options: RequireTypename<BidPackageRequestOptions>,
  cache?: Record<string, any>,
): BidPackageRequest;
export function newFollowable(options: RequireTypename<BillOptions>, cache?: Record<string, any>): Bill;
export function newFollowable(options: RequireTypename<ChangeEventOptions>, cache?: Record<string, any>): ChangeEvent;
export function newFollowable(
  options: RequireTypename<ChangeRequestOptions>,
  cache?: Record<string, any>,
): ChangeRequest;
export function newFollowable(
  options: RequireTypename<ChangeRequestToDoOptions>,
  cache?: Record<string, any>,
): ChangeRequestToDo;
export function newFollowable(
  options: RequireTypename<SchedulePhaseOptions>,
  cache?: Record<string, any>,
): SchedulePhase;
export function newFollowable(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  cache?: Record<string, any>,
): ScheduleSubPhase;
export function newFollowable(options: RequireTypename<TaskOptions>, cache?: Record<string, any>): Task;
export function newFollowable(options: RequireTypename<ScheduleTaskOptions>, cache?: Record<string, any>): ScheduleTask;
export function newFollowable(options: RequireTypename<PlanTaskOptions>, cache?: Record<string, any>): PlanTask;
export function newFollowable(options: RequireTypename<ToDoOptions>, cache?: Record<string, any>): ToDo;
export function newFollowable(options: RequireTypename<InvoiceOptions>, cache?: Record<string, any>): Invoice;
export function newFollowable(
  options: RequireTypename<StandaloneProjectOptions>,
  cache?: Record<string, any>,
): StandaloneProject;
export function newFollowable(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newFollowable(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newFollowable(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newFollowable(options: RequireTypename<SubdivisionOptions>, cache?: Record<string, any>): Subdivision;
export function newFollowable(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newFollowable(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newFollowable(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newFollowable(options: RequireTypename<ProjectItemOptions>, cache?: Record<string, any>): ProjectItem;
export function newFollowable(options: RequireTypename<EstimateOptions>, cache?: Record<string, any>): Estimate;
export function newFollowable(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  cache?: Record<string, any>,
): DevelopmentCommitment;
export function newFollowable(options: RequireTypename<CommitmentOptions>, cache?: Record<string, any>): Commitment;
export function newFollowable(options: RequireTypename<DocumentOptions>, cache?: Record<string, any>): Document;
export function newFollowable(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  cache?: Record<string, any>,
): ItemTemplateItemVersion;
export function newFollowable(options: RequireTypename<JobLogNoteOptions>, cache?: Record<string, any>): JobLogNote;
export function newFollowable(
  options: RequireTypename<TradePartnerAvailabilityRequestOptions>,
  cache?: Record<string, any>,
): TradePartnerAvailabilityRequest;
export function newFollowable(
  options: RequireTypename<PunchlistItemTodoOptions>,
  cache?: Record<string, any>,
): PunchlistItemTodo;
export function newFollowable(
  options: RequireTypename<WarrantyTicketOptions>,
  cache?: Record<string, any>,
): WarrantyTicket;
export function newFollowable(
  options: RequireTypename<HomeownerContractOptions>,
  cache?: Record<string, any>,
): HomeownerContract;
export function newFollowable(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  cache?: Record<string, any>,
): HomeownerContractChangeOrder;
export function newFollowable(options: RequireTypename<ReadyPlanOptions>, cache?: Record<string, any>): ReadyPlan;
export function newFollowable(options: RequireTypename<PlanPackageOptions>, cache?: Record<string, any>): PlanPackage;
export function newFollowable(options: RequireTypename<GlobalOptionOptions>, cache?: Record<string, any>): GlobalOption;
export function newFollowable(
  options: RequireTypename<ProjectCostCodeOptions>,
  cache?: Record<string, any>,
): ProjectCostCode;
export function newFollowable(options: FollowableOptions = {}, cache: Record<string, any> = {}): FollowableType {
  const { __typename = "Approval" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["Followable"] = newFollowable;

export type EntityOptions =
  | AssetOptions
  | RequireTypename<TradePartnerOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<ScheduleTaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<CommentOptions>
  | RequireTypename<ProjectStageOptions>
  | RequireTypename<CommitmentDrawOptions>
  | RequireTypename<FeatureFlagOptions>
  | RequireTypename<JobLogOptions>
  | RequireTypename<JobLogImageOptions>
  | RequireTypename<LocationOptions>
  | RequireTypename<MobileSyncUpdateOptions>
  | RequireTypename<ScheduleFlagOptions>
  | RequireTypename<ScheduleFlagReasonOptions>
  | RequireTypename<ScheduleTaskChecklistItemOptions>
  | RequireTypename<TaskWorkDayOptions>
  | RequireTypename<TradePartnerContactOptions>
  | RequireTypename<TradePartnerUserOptions>;

export type EntityType =
  | Asset
  | TradePartner
  | Bill
  | ScheduleTask
  | PlanTask
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | Commitment
  | Document
  | JobLogNote
  | PunchlistItemTodo
  | Comment
  | ProjectStage
  | CommitmentDraw
  | FeatureFlag
  | JobLog
  | JobLogImage
  | Location
  | MobileSyncUpdate
  | ScheduleFlag
  | ScheduleFlagReason
  | ScheduleTaskChecklistItem
  | TaskWorkDay
  | TradePartnerContact
  | TradePartnerUser;

export type EntityTypeName =
  | "Asset"
  | "TradePartner"
  | "Bill"
  | "ScheduleTask"
  | "PlanTask"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "Commitment"
  | "Document"
  | "JobLogNote"
  | "PunchlistItemTodo"
  | "Comment"
  | "ProjectStage"
  | "CommitmentDraw"
  | "FeatureFlag"
  | "JobLog"
  | "JobLogImage"
  | "Location"
  | "MobileSyncUpdate"
  | "ScheduleFlag"
  | "ScheduleFlagReason"
  | "ScheduleTaskChecklistItem"
  | "TaskWorkDay"
  | "TradePartnerContact"
  | "TradePartnerUser";

export function newEntity(): Asset;
export function newEntity(options: AssetOptions, cache?: Record<string, any>): Asset;
export function newEntity(options: RequireTypename<TradePartnerOptions>, cache?: Record<string, any>): TradePartner;
export function newEntity(options: RequireTypename<BillOptions>, cache?: Record<string, any>): Bill;
export function newEntity(options: RequireTypename<ScheduleTaskOptions>, cache?: Record<string, any>): ScheduleTask;
export function newEntity(options: RequireTypename<PlanTaskOptions>, cache?: Record<string, any>): PlanTask;
export function newEntity(
  options: RequireTypename<StandaloneProjectOptions>,
  cache?: Record<string, any>,
): StandaloneProject;
export function newEntity(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newEntity(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newEntity(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newEntity(options: RequireTypename<SubdivisionOptions>, cache?: Record<string, any>): Subdivision;
export function newEntity(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newEntity(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newEntity(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newEntity(options: RequireTypename<CommitmentOptions>, cache?: Record<string, any>): Commitment;
export function newEntity(options: RequireTypename<DocumentOptions>, cache?: Record<string, any>): Document;
export function newEntity(options: RequireTypename<JobLogNoteOptions>, cache?: Record<string, any>): JobLogNote;
export function newEntity(
  options: RequireTypename<PunchlistItemTodoOptions>,
  cache?: Record<string, any>,
): PunchlistItemTodo;
export function newEntity(options: RequireTypename<CommentOptions>, cache?: Record<string, any>): Comment;
export function newEntity(options: RequireTypename<ProjectStageOptions>, cache?: Record<string, any>): ProjectStage;
export function newEntity(options: RequireTypename<CommitmentDrawOptions>, cache?: Record<string, any>): CommitmentDraw;
export function newEntity(options: RequireTypename<FeatureFlagOptions>, cache?: Record<string, any>): FeatureFlag;
export function newEntity(options: RequireTypename<JobLogOptions>, cache?: Record<string, any>): JobLog;
export function newEntity(options: RequireTypename<JobLogImageOptions>, cache?: Record<string, any>): JobLogImage;
export function newEntity(options: RequireTypename<LocationOptions>, cache?: Record<string, any>): Location;
export function newEntity(
  options: RequireTypename<MobileSyncUpdateOptions>,
  cache?: Record<string, any>,
): MobileSyncUpdate;
export function newEntity(options: RequireTypename<ScheduleFlagOptions>, cache?: Record<string, any>): ScheduleFlag;
export function newEntity(
  options: RequireTypename<ScheduleFlagReasonOptions>,
  cache?: Record<string, any>,
): ScheduleFlagReason;
export function newEntity(
  options: RequireTypename<ScheduleTaskChecklistItemOptions>,
  cache?: Record<string, any>,
): ScheduleTaskChecklistItem;
export function newEntity(options: RequireTypename<TaskWorkDayOptions>, cache?: Record<string, any>): TaskWorkDay;
export function newEntity(
  options: RequireTypename<TradePartnerContactOptions>,
  cache?: Record<string, any>,
): TradePartnerContact;
export function newEntity(
  options: RequireTypename<TradePartnerUserOptions>,
  cache?: Record<string, any>,
): TradePartnerUser;
export function newEntity(options: EntityOptions = {}, cache: Record<string, any> = {}): EntityType {
  const { __typename = "Asset" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["Entity"] = newEntity;

export type HasPandaDocOptions =
  | BidContractRevisionOptions
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<CommitmentChangeOrderOptions>;

export type HasPandaDocType = BidContractRevision | DevelopmentCommitment | Commitment | CommitmentChangeOrder;

export type HasPandaDocTypeName =
  | "BidContractRevision"
  | "DevelopmentCommitment"
  | "Commitment"
  | "CommitmentChangeOrder";

export function newHasPandaDoc(): BidContractRevision;
export function newHasPandaDoc(options: BidContractRevisionOptions, cache?: Record<string, any>): BidContractRevision;
export function newHasPandaDoc(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  cache?: Record<string, any>,
): DevelopmentCommitment;
export function newHasPandaDoc(options: RequireTypename<CommitmentOptions>, cache?: Record<string, any>): Commitment;
export function newHasPandaDoc(
  options: RequireTypename<CommitmentChangeOrderOptions>,
  cache?: Record<string, any>,
): CommitmentChangeOrder;
export function newHasPandaDoc(options: HasPandaDocOptions = {}, cache: Record<string, any> = {}): HasPandaDocType {
  const { __typename = "BidContractRevision" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasPandaDoc"] = newHasPandaDoc;

export type HasDisplayNameOptions =
  | BidItemOptions
  | RequireTypename<BidPlanChildGroupOptions>
  | RequireTypename<BidPlanChildGroupLineOptions>
  | RequireTypename<BidPlanGroupOptions>
  | RequireTypename<ChangeEventLineItemOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<CommitmentChangeOrderOptions>
  | RequireTypename<CostCodeOptions>
  | RequireTypename<CostDivisionOptions>
  | RequireTypename<DesignPackageOptions>
  | RequireTypename<ItemOptions>
  | RequireTypename<ItemTemplateOptions>
  | RequireTypename<ItemTemplateItemOptions>
  | RequireTypename<ProductOfferingOptions>
  | RequireTypename<ReadyPlanAggregateVersionOptions>
  | RequireTypename<ReadyPlanOptionOptions>
  | RequireTypename<TakeoffLineItemOptions>
  | RequireTypename<TakeoffLineItemVersionOptions>
  | RequireTypename<TradeCategoryOptions>;

export type HasDisplayNameType =
  | BidItem
  | BidPlanChildGroup
  | BidPlanChildGroupLine
  | BidPlanGroup
  | ChangeEventLineItem
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Commitment
  | Document
  | ItemTemplateItemVersion
  | ReadyPlan
  | PlanPackage
  | CommitmentChangeOrder
  | CostCode
  | CostDivision
  | DesignPackage
  | Item
  | ItemTemplate
  | ItemTemplateItem
  | ProductOffering
  | ReadyPlanAggregateVersion
  | ReadyPlanOption
  | TakeoffLineItem
  | TakeoffLineItemVersion
  | TradeCategory;

export type HasDisplayNameTypeName =
  | "BidItem"
  | "BidPlanChildGroup"
  | "BidPlanChildGroupLine"
  | "BidPlanGroup"
  | "ChangeEventLineItem"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Commitment"
  | "Document"
  | "ItemTemplateItemVersion"
  | "ReadyPlan"
  | "PlanPackage"
  | "CommitmentChangeOrder"
  | "CostCode"
  | "CostDivision"
  | "DesignPackage"
  | "Item"
  | "ItemTemplate"
  | "ItemTemplateItem"
  | "ProductOffering"
  | "ReadyPlanAggregateVersion"
  | "ReadyPlanOption"
  | "TakeoffLineItem"
  | "TakeoffLineItemVersion"
  | "TradeCategory";

export function newHasDisplayName(): BidItem;
export function newHasDisplayName(options: BidItemOptions, cache?: Record<string, any>): BidItem;
export function newHasDisplayName(
  options: RequireTypename<BidPlanChildGroupOptions>,
  cache?: Record<string, any>,
): BidPlanChildGroup;
export function newHasDisplayName(
  options: RequireTypename<BidPlanChildGroupLineOptions>,
  cache?: Record<string, any>,
): BidPlanChildGroupLine;
export function newHasDisplayName(
  options: RequireTypename<BidPlanGroupOptions>,
  cache?: Record<string, any>,
): BidPlanGroup;
export function newHasDisplayName(
  options: RequireTypename<ChangeEventLineItemOptions>,
  cache?: Record<string, any>,
): ChangeEventLineItem;
export function newHasDisplayName(
  options: RequireTypename<StandaloneProjectOptions>,
  cache?: Record<string, any>,
): StandaloneProject;
export function newHasDisplayName(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newHasDisplayName(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newHasDisplayName(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newHasDisplayName(
  options: RequireTypename<SubdivisionOptions>,
  cache?: Record<string, any>,
): Subdivision;
export function newHasDisplayName(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newHasDisplayName(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newHasDisplayName(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newHasDisplayName(
  options: RequireTypename<ProjectItemOptions>,
  cache?: Record<string, any>,
): ProjectItem;
export function newHasDisplayName(options: RequireTypename<CommitmentOptions>, cache?: Record<string, any>): Commitment;
export function newHasDisplayName(options: RequireTypename<DocumentOptions>, cache?: Record<string, any>): Document;
export function newHasDisplayName(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  cache?: Record<string, any>,
): ItemTemplateItemVersion;
export function newHasDisplayName(options: RequireTypename<ReadyPlanOptions>, cache?: Record<string, any>): ReadyPlan;
export function newHasDisplayName(
  options: RequireTypename<PlanPackageOptions>,
  cache?: Record<string, any>,
): PlanPackage;
export function newHasDisplayName(
  options: RequireTypename<CommitmentChangeOrderOptions>,
  cache?: Record<string, any>,
): CommitmentChangeOrder;
export function newHasDisplayName(options: RequireTypename<CostCodeOptions>, cache?: Record<string, any>): CostCode;
export function newHasDisplayName(
  options: RequireTypename<CostDivisionOptions>,
  cache?: Record<string, any>,
): CostDivision;
export function newHasDisplayName(
  options: RequireTypename<DesignPackageOptions>,
  cache?: Record<string, any>,
): DesignPackage;
export function newHasDisplayName(options: RequireTypename<ItemOptions>, cache?: Record<string, any>): Item;
export function newHasDisplayName(
  options: RequireTypename<ItemTemplateOptions>,
  cache?: Record<string, any>,
): ItemTemplate;
export function newHasDisplayName(
  options: RequireTypename<ItemTemplateItemOptions>,
  cache?: Record<string, any>,
): ItemTemplateItem;
export function newHasDisplayName(
  options: RequireTypename<ProductOfferingOptions>,
  cache?: Record<string, any>,
): ProductOffering;
export function newHasDisplayName(
  options: RequireTypename<ReadyPlanAggregateVersionOptions>,
  cache?: Record<string, any>,
): ReadyPlanAggregateVersion;
export function newHasDisplayName(
  options: RequireTypename<ReadyPlanOptionOptions>,
  cache?: Record<string, any>,
): ReadyPlanOption;
export function newHasDisplayName(
  options: RequireTypename<TakeoffLineItemOptions>,
  cache?: Record<string, any>,
): TakeoffLineItem;
export function newHasDisplayName(
  options: RequireTypename<TakeoffLineItemVersionOptions>,
  cache?: Record<string, any>,
): TakeoffLineItemVersion;
export function newHasDisplayName(
  options: RequireTypename<TradeCategoryOptions>,
  cache?: Record<string, any>,
): TradeCategory;
export function newHasDisplayName(
  options: HasDisplayNameOptions = {},
  cache: Record<string, any> = {},
): HasDisplayNameType {
  const { __typename = "BidItem" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasDisplayName"] = newHasDisplayName;

export type MaybeHasProjectOptions =
  | BillOptions
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<ProjectStageOptions>
  | RequireTypename<ProjectCollaboratorOptions>
  | RequireTypename<ProjectUpdateOptions>;

export type MaybeHasProjectType =
  | Bill
  | ChangeEvent
  | Task
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | HomeownerContract
  | ProjectStage
  | ProjectCollaborator
  | ProjectUpdate;

export type MaybeHasProjectTypeName =
  | "Bill"
  | "ChangeEvent"
  | "Task"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "HomeownerContract"
  | "ProjectStage"
  | "ProjectCollaborator"
  | "ProjectUpdate";

export function newMaybeHasProject(): Bill;
export function newMaybeHasProject(options: BillOptions, cache?: Record<string, any>): Bill;
export function newMaybeHasProject(
  options: RequireTypename<ChangeEventOptions>,
  cache?: Record<string, any>,
): ChangeEvent;
export function newMaybeHasProject(options: RequireTypename<TaskOptions>, cache?: Record<string, any>): Task;
export function newMaybeHasProject(options: RequireTypename<InvoiceOptions>, cache?: Record<string, any>): Invoice;
export function newMaybeHasProject(
  options: RequireTypename<StandaloneProjectOptions>,
  cache?: Record<string, any>,
): StandaloneProject;
export function newMaybeHasProject(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newMaybeHasProject(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newMaybeHasProject(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newMaybeHasProject(
  options: RequireTypename<SubdivisionOptions>,
  cache?: Record<string, any>,
): Subdivision;
export function newMaybeHasProject(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newMaybeHasProject(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newMaybeHasProject(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newMaybeHasProject(
  options: RequireTypename<ProjectItemOptions>,
  cache?: Record<string, any>,
): ProjectItem;
export function newMaybeHasProject(options: RequireTypename<EstimateOptions>, cache?: Record<string, any>): Estimate;
export function newMaybeHasProject(
  options: RequireTypename<HomeownerContractOptions>,
  cache?: Record<string, any>,
): HomeownerContract;
export function newMaybeHasProject(
  options: RequireTypename<ProjectStageOptions>,
  cache?: Record<string, any>,
): ProjectStage;
export function newMaybeHasProject(
  options: RequireTypename<ProjectCollaboratorOptions>,
  cache?: Record<string, any>,
): ProjectCollaborator;
export function newMaybeHasProject(
  options: RequireTypename<ProjectUpdateOptions>,
  cache?: Record<string, any>,
): ProjectUpdate;
export function newMaybeHasProject(
  options: MaybeHasProjectOptions = {},
  cache: Record<string, any> = {},
): MaybeHasProjectType {
  const { __typename = "Bill" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["MaybeHasProject"] = newMaybeHasProject;

export type ProjectStageTemplateConfigLikeOptions =
  | ChangeEventTemplateConfigOptions
  | RequireTypename<ProjectStageTemplateConfigOptions>;

export type ProjectStageTemplateConfigLikeType = ChangeEventTemplateConfig | ProjectStageTemplateConfig;

export type ProjectStageTemplateConfigLikeTypeName = "ChangeEventTemplateConfig" | "ProjectStageTemplateConfig";

export function newProjectStageTemplateConfigLike(): ChangeEventTemplateConfig;
export function newProjectStageTemplateConfigLike(
  options: ChangeEventTemplateConfigOptions,
  cache?: Record<string, any>,
): ChangeEventTemplateConfig;
export function newProjectStageTemplateConfigLike(
  options: RequireTypename<ProjectStageTemplateConfigOptions>,
  cache?: Record<string, any>,
): ProjectStageTemplateConfig;
export function newProjectStageTemplateConfigLike(
  options: ProjectStageTemplateConfigLikeOptions = {},
  cache: Record<string, any> = {},
): ProjectStageTemplateConfigLikeType {
  const { __typename = "ChangeEventTemplateConfig" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["ProjectStageTemplateConfigLike"] = newProjectStageTemplateConfigLike;

export type HasCheckoutUrlOptions = CheckoutConfigOptions;

export type HasCheckoutUrlType = CheckoutConfig;

export type HasCheckoutUrlTypeName = "CheckoutConfig";

export function newHasCheckoutUrl(): CheckoutConfig;
export function newHasCheckoutUrl(options: CheckoutConfigOptions, cache?: Record<string, any>): CheckoutConfig;
export function newHasCheckoutUrl(
  options: HasCheckoutUrlOptions = {},
  cache: Record<string, any> = {},
): HasCheckoutUrlType {
  const { __typename = "CheckoutConfig" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasCheckoutUrl"] = newHasCheckoutUrl;

export type ReadyPlanConfigLikeOptions =
  | CheckoutConfigOptions
  | RequireTypename<ProductOfferingConfigOptions>
  | RequireTypename<ProjectReadyPlanConfigOptions>;

export type ReadyPlanConfigLikeType = CheckoutConfig | ProductOfferingConfig | ProjectReadyPlanConfig;

export type ReadyPlanConfigLikeTypeName = "CheckoutConfig" | "ProductOfferingConfig" | "ProjectReadyPlanConfig";

export function newReadyPlanConfigLike(): CheckoutConfig;
export function newReadyPlanConfigLike(options: CheckoutConfigOptions, cache?: Record<string, any>): CheckoutConfig;
export function newReadyPlanConfigLike(
  options: RequireTypename<ProductOfferingConfigOptions>,
  cache?: Record<string, any>,
): ProductOfferingConfig;
export function newReadyPlanConfigLike(
  options: RequireTypename<ProjectReadyPlanConfigOptions>,
  cache?: Record<string, any>,
): ProjectReadyPlanConfig;
export function newReadyPlanConfigLike(
  options: ReadyPlanConfigLikeOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanConfigLikeType {
  const { __typename = "CheckoutConfig" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["ReadyPlanConfigLike"] = newReadyPlanConfigLike;

export type PotentialOptionGroupLikeOptions =
  | CheckoutConfigOptionGroupOptions
  | RequireTypename<ProjectReadyPlanConfigPotentialOptionGroupOptions>;

export type PotentialOptionGroupLikeType = CheckoutConfigOptionGroup | ProjectReadyPlanConfigPotentialOptionGroup;

export type PotentialOptionGroupLikeTypeName =
  | "CheckoutConfigOptionGroup"
  | "ProjectReadyPlanConfigPotentialOptionGroup";

export function newPotentialOptionGroupLike(): CheckoutConfigOptionGroup;
export function newPotentialOptionGroupLike(
  options: CheckoutConfigOptionGroupOptions,
  cache?: Record<string, any>,
): CheckoutConfigOptionGroup;
export function newPotentialOptionGroupLike(
  options: RequireTypename<ProjectReadyPlanConfigPotentialOptionGroupOptions>,
  cache?: Record<string, any>,
): ProjectReadyPlanConfigPotentialOptionGroup;
export function newPotentialOptionGroupLike(
  options: PotentialOptionGroupLikeOptions = {},
  cache: Record<string, any> = {},
): PotentialOptionGroupLikeType {
  const { __typename = "CheckoutConfigOptionGroup" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["PotentialOptionGroupLike"] = newPotentialOptionGroupLike;

export type PotentialOptionLikeOptions =
  | CheckoutConfigPotentialOptionOptions
  | RequireTypename<ProjectReadyPlanConfigPotentialOptionOptions>;

export type PotentialOptionLikeType = CheckoutConfigPotentialOption | ProjectReadyPlanConfigPotentialOption;

export type PotentialOptionLikeTypeName = "CheckoutConfigPotentialOption" | "ProjectReadyPlanConfigPotentialOption";

export function newPotentialOptionLike(): CheckoutConfigPotentialOption;
export function newPotentialOptionLike(
  options: CheckoutConfigPotentialOptionOptions,
  cache?: Record<string, any>,
): CheckoutConfigPotentialOption;
export function newPotentialOptionLike(
  options: RequireTypename<ProjectReadyPlanConfigPotentialOptionOptions>,
  cache?: Record<string, any>,
): ProjectReadyPlanConfigPotentialOption;
export function newPotentialOptionLike(
  options: PotentialOptionLikeOptions = {},
  cache: Record<string, any> = {},
): PotentialOptionLikeType {
  const { __typename = "CheckoutConfigPotentialOption" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["PotentialOptionLike"] = newPotentialOptionLike;

export type ScheduleEntityOptions =
  | SchedulePhaseOptions
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<ScheduleTaskOptions>
  | RequireTypename<ScheduleOptions>;

export type ScheduleEntityType = SchedulePhase | ScheduleSubPhase | ScheduleTask | Schedule;

export type ScheduleEntityTypeName = "SchedulePhase" | "ScheduleSubPhase" | "ScheduleTask" | "Schedule";

export function newScheduleEntity(): SchedulePhase;
export function newScheduleEntity(options: SchedulePhaseOptions, cache?: Record<string, any>): SchedulePhase;
export function newScheduleEntity(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  cache?: Record<string, any>,
): ScheduleSubPhase;
export function newScheduleEntity(
  options: RequireTypename<ScheduleTaskOptions>,
  cache?: Record<string, any>,
): ScheduleTask;
export function newScheduleEntity(options: RequireTypename<ScheduleOptions>, cache?: Record<string, any>): Schedule;
export function newScheduleEntity(
  options: ScheduleEntityOptions = {},
  cache: Record<string, any> = {},
): ScheduleEntityType {
  const { __typename = "SchedulePhase" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["ScheduleEntity"] = newScheduleEntity;

export type MaybeHasIntervalOptions =
  | SchedulePhaseOptions
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<ScheduleTaskOptions>
  | RequireTypename<ProjectStageOptions>
  | RequireTypename<ScheduleOptions>;

export type MaybeHasIntervalType = SchedulePhase | ScheduleSubPhase | Task | ScheduleTask | ProjectStage | Schedule;

export type MaybeHasIntervalTypeName =
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "ScheduleTask"
  | "ProjectStage"
  | "Schedule";

export function newMaybeHasInterval(): SchedulePhase;
export function newMaybeHasInterval(options: SchedulePhaseOptions, cache?: Record<string, any>): SchedulePhase;
export function newMaybeHasInterval(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  cache?: Record<string, any>,
): ScheduleSubPhase;
export function newMaybeHasInterval(options: RequireTypename<TaskOptions>, cache?: Record<string, any>): Task;
export function newMaybeHasInterval(
  options: RequireTypename<ScheduleTaskOptions>,
  cache?: Record<string, any>,
): ScheduleTask;
export function newMaybeHasInterval(
  options: RequireTypename<ProjectStageOptions>,
  cache?: Record<string, any>,
): ProjectStage;
export function newMaybeHasInterval(options: RequireTypename<ScheduleOptions>, cache?: Record<string, any>): Schedule;
export function newMaybeHasInterval(
  options: MaybeHasIntervalOptions = {},
  cache: Record<string, any> = {},
): MaybeHasIntervalType {
  const { __typename = "SchedulePhase" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["MaybeHasInterval"] = newMaybeHasInterval;

export type MaybeHasBaselineIntervalOptions =
  | SchedulePhaseOptions
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<ScheduleTaskOptions>
  | RequireTypename<ScheduleOptions>;

export type MaybeHasBaselineIntervalType = SchedulePhase | ScheduleSubPhase | ScheduleTask | Schedule;

export type MaybeHasBaselineIntervalTypeName = "SchedulePhase" | "ScheduleSubPhase" | "ScheduleTask" | "Schedule";

export function newMaybeHasBaselineInterval(): SchedulePhase;
export function newMaybeHasBaselineInterval(options: SchedulePhaseOptions, cache?: Record<string, any>): SchedulePhase;
export function newMaybeHasBaselineInterval(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  cache?: Record<string, any>,
): ScheduleSubPhase;
export function newMaybeHasBaselineInterval(
  options: RequireTypename<ScheduleTaskOptions>,
  cache?: Record<string, any>,
): ScheduleTask;
export function newMaybeHasBaselineInterval(
  options: RequireTypename<ScheduleOptions>,
  cache?: Record<string, any>,
): Schedule;
export function newMaybeHasBaselineInterval(
  options: MaybeHasBaselineIntervalOptions = {},
  cache: Record<string, any> = {},
): MaybeHasBaselineIntervalType {
  const { __typename = "SchedulePhase" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["MaybeHasBaselineInterval"] = newMaybeHasBaselineInterval;

export type ProjectOptions =
  | StandaloneProjectOptions
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>;

export type ProjectType = StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit;

export type ProjectTypeName =
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit";

export function newProject(): StandaloneProject;
export function newProject(options: StandaloneProjectOptions, cache?: Record<string, any>): StandaloneProject;
export function newProject(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newProject(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newProject(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newProject(options: RequireTypename<SubdivisionOptions>, cache?: Record<string, any>): Subdivision;
export function newProject(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newProject(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newProject(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newProject(options: ProjectOptions = {}, cache: Record<string, any> = {}): ProjectType {
  const { __typename = "StandaloneProject" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["Project"] = newProject;

export type HasSchedulesOptions =
  | StandaloneProjectOptions
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<DevelopmentOptions>
  | RequireTypename<ScheduleTemplateOptions>;

export type HasSchedulesType =
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | Development
  | ScheduleTemplate;

export type HasSchedulesTypeName =
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "Development"
  | "ScheduleTemplate";

export function newHasSchedules(): StandaloneProject;
export function newHasSchedules(options: StandaloneProjectOptions, cache?: Record<string, any>): StandaloneProject;
export function newHasSchedules(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newHasSchedules(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newHasSchedules(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newHasSchedules(options: RequireTypename<SubdivisionOptions>, cache?: Record<string, any>): Subdivision;
export function newHasSchedules(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newHasSchedules(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newHasSchedules(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newHasSchedules(options: RequireTypename<DevelopmentOptions>, cache?: Record<string, any>): Development;
export function newHasSchedules(
  options: RequireTypename<ScheduleTemplateOptions>,
  cache?: Record<string, any>,
): ScheduleTemplate;
export function newHasSchedules(options: HasSchedulesOptions = {}, cache: Record<string, any> = {}): HasSchedulesType {
  const { __typename = "StandaloneProject" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasSchedules"] = newHasSchedules;

export type HasHopUrlOptions =
  | StandaloneProjectOptions
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>;

export type HasHopUrlType = StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit;

export type HasHopUrlTypeName =
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit";

export function newHasHopUrl(): StandaloneProject;
export function newHasHopUrl(options: StandaloneProjectOptions, cache?: Record<string, any>): StandaloneProject;
export function newHasHopUrl(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newHasHopUrl(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newHasHopUrl(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newHasHopUrl(options: RequireTypename<SubdivisionOptions>, cache?: Record<string, any>): Subdivision;
export function newHasHopUrl(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newHasHopUrl(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newHasHopUrl(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newHasHopUrl(options: HasHopUrlOptions = {}, cache: Record<string, any> = {}): HasHopUrlType {
  const { __typename = "StandaloneProject" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasHopUrl"] = newHasHopUrl;

export type MaybeHasPropcoUrlOptions = StandaloneProjectOptions | RequireTypename<StructureOptions>;

export type MaybeHasPropcoUrlType = StandaloneProject | Structure;

export type MaybeHasPropcoUrlTypeName = "StandaloneProject" | "Structure";

export function newMaybeHasPropcoUrl(): StandaloneProject;
export function newMaybeHasPropcoUrl(options: StandaloneProjectOptions, cache?: Record<string, any>): StandaloneProject;
export function newMaybeHasPropcoUrl(
  options: RequireTypename<StructureOptions>,
  cache?: Record<string, any>,
): Structure;
export function newMaybeHasPropcoUrl(
  options: MaybeHasPropcoUrlOptions = {},
  cache: Record<string, any> = {},
): MaybeHasPropcoUrlType {
  const { __typename = "StandaloneProject" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["MaybeHasPropcoUrl"] = newMaybeHasPropcoUrl;

export type ProjectItemLikeOptions = ProjectItemOptions | RequireTypename<ProtoProjectItemOptions>;

export type ProjectItemLikeType = ProjectItem | ProtoProjectItem;

export type ProjectItemLikeTypeName = "ProjectItem" | "ProtoProjectItem";

export function newProjectItemLike(): ProjectItem;
export function newProjectItemLike(options: ProjectItemOptions, cache?: Record<string, any>): ProjectItem;
export function newProjectItemLike(
  options: RequireTypename<ProtoProjectItemOptions>,
  cache?: Record<string, any>,
): ProtoProjectItem;
export function newProjectItemLike(
  options: ProjectItemLikeOptions = {},
  cache: Record<string, any> = {},
): ProjectItemLikeType {
  const { __typename = "ProjectItem" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["ProjectItemLike"] = newProjectItemLike;

export type CommitmentLikeOptions = CommitmentOptions | RequireTypename<CommitmentChangeOrderOptions>;

export type CommitmentLikeType = Commitment | CommitmentChangeOrder;

export type CommitmentLikeTypeName = "Commitment" | "CommitmentChangeOrder";

export function newCommitmentLike(): Commitment;
export function newCommitmentLike(options: CommitmentOptions, cache?: Record<string, any>): Commitment;
export function newCommitmentLike(
  options: RequireTypename<CommitmentChangeOrderOptions>,
  cache?: Record<string, any>,
): CommitmentChangeOrder;
export function newCommitmentLike(
  options: CommitmentLikeOptions = {},
  cache: Record<string, any> = {},
): CommitmentLikeType {
  const { __typename = "Commitment" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["CommitmentLike"] = newCommitmentLike;

export type BaseItemLikeOptions =
  | ItemTemplateItemVersionOptions
  | RequireTypename<ItemTemplateItemOptions>
  | RequireTypename<TakeoffLineItemOptions>
  | RequireTypename<TakeoffLineItemVersionOptions>;

export type BaseItemLikeType = ItemTemplateItemVersion | ItemTemplateItem | TakeoffLineItem | TakeoffLineItemVersion;

export type BaseItemLikeTypeName =
  | "ItemTemplateItemVersion"
  | "ItemTemplateItem"
  | "TakeoffLineItem"
  | "TakeoffLineItemVersion";

export function newBaseItemLike(): ItemTemplateItemVersion;
export function newBaseItemLike(
  options: ItemTemplateItemVersionOptions,
  cache?: Record<string, any>,
): ItemTemplateItemVersion;
export function newBaseItemLike(
  options: RequireTypename<ItemTemplateItemOptions>,
  cache?: Record<string, any>,
): ItemTemplateItem;
export function newBaseItemLike(
  options: RequireTypename<TakeoffLineItemOptions>,
  cache?: Record<string, any>,
): TakeoffLineItem;
export function newBaseItemLike(
  options: RequireTypename<TakeoffLineItemVersionOptions>,
  cache?: Record<string, any>,
): TakeoffLineItemVersion;
export function newBaseItemLike(options: BaseItemLikeOptions = {}, cache: Record<string, any> = {}): BaseItemLikeType {
  const { __typename = "ItemTemplateItemVersion" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["BaseItemLike"] = newBaseItemLike;

export type HomeownerContractLikeOptions =
  | HomeownerContractOptions
  | RequireTypename<HomeownerContractChangeOrderOptions>;

export type HomeownerContractLikeType = HomeownerContract | HomeownerContractChangeOrder;

export type HomeownerContractLikeTypeName = "HomeownerContract" | "HomeownerContractChangeOrder";

export function newHomeownerContractLike(): HomeownerContract;
export function newHomeownerContractLike(
  options: HomeownerContractOptions,
  cache?: Record<string, any>,
): HomeownerContract;
export function newHomeownerContractLike(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  cache?: Record<string, any>,
): HomeownerContractChangeOrder;
export function newHomeownerContractLike(
  options: HomeownerContractLikeOptions = {},
  cache: Record<string, any> = {},
): HomeownerContractLikeType {
  const { __typename = "HomeownerContract" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HomeownerContractLike"] = newHomeownerContractLike;

export type ReadyPlanLikeOptions =
  | ReadyPlanOptions
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<DesignPackageOptions>
  | RequireTypename<ProductOfferingOptions>;

export type ReadyPlanLikeType = ReadyPlan | PlanPackage | DesignPackage | ProductOffering;

export type ReadyPlanLikeTypeName = "ReadyPlan" | "PlanPackage" | "DesignPackage" | "ProductOffering";

export function newReadyPlanLike(): ReadyPlan;
export function newReadyPlanLike(options: ReadyPlanOptions, cache?: Record<string, any>): ReadyPlan;
export function newReadyPlanLike(
  options: RequireTypename<PlanPackageOptions>,
  cache?: Record<string, any>,
): PlanPackage;
export function newReadyPlanLike(
  options: RequireTypename<DesignPackageOptions>,
  cache?: Record<string, any>,
): DesignPackage;
export function newReadyPlanLike(
  options: RequireTypename<ProductOfferingOptions>,
  cache?: Record<string, any>,
): ProductOffering;
export function newReadyPlanLike(
  options: ReadyPlanLikeOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanLikeType {
  const { __typename = "ReadyPlan" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["ReadyPlanLike"] = newReadyPlanLike;

export type BaseItemParentOptions =
  | ReadyPlanOptions
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<DesignPackageOptions>
  | RequireTypename<ItemTemplateOptions>
  | RequireTypename<ProductOfferingOptions>;

export type BaseItemParentType = ReadyPlan | PlanPackage | DesignPackage | ItemTemplate | ProductOffering;

export type BaseItemParentTypeName = "ReadyPlan" | "PlanPackage" | "DesignPackage" | "ItemTemplate" | "ProductOffering";

export function newBaseItemParent(): ReadyPlan;
export function newBaseItemParent(options: ReadyPlanOptions, cache?: Record<string, any>): ReadyPlan;
export function newBaseItemParent(
  options: RequireTypename<PlanPackageOptions>,
  cache?: Record<string, any>,
): PlanPackage;
export function newBaseItemParent(
  options: RequireTypename<DesignPackageOptions>,
  cache?: Record<string, any>,
): DesignPackage;
export function newBaseItemParent(
  options: RequireTypename<ItemTemplateOptions>,
  cache?: Record<string, any>,
): ItemTemplate;
export function newBaseItemParent(
  options: RequireTypename<ProductOfferingOptions>,
  cache?: Record<string, any>,
): ProductOffering;
export function newBaseItemParent(
  options: BaseItemParentOptions = {},
  cache: Record<string, any> = {},
): BaseItemParentType {
  const { __typename = "ReadyPlan" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["BaseItemParent"] = newBaseItemParent;

export type HasMaterialLeadTimeConfigDataOptions =
  | CostCodeOptions
  | RequireTypename<ItemOptions>
  | RequireTypename<MaterialListingOptions>;

export type HasMaterialLeadTimeConfigDataType = CostCode | Item | MaterialListing;

export type HasMaterialLeadTimeConfigDataTypeName = "CostCode" | "Item" | "MaterialListing";

export function newHasMaterialLeadTimeConfigData(): CostCode;
export function newHasMaterialLeadTimeConfigData(options: CostCodeOptions, cache?: Record<string, any>): CostCode;
export function newHasMaterialLeadTimeConfigData(
  options: RequireTypename<ItemOptions>,
  cache?: Record<string, any>,
): Item;
export function newHasMaterialLeadTimeConfigData(
  options: RequireTypename<MaterialListingOptions>,
  cache?: Record<string, any>,
): MaterialListing;
export function newHasMaterialLeadTimeConfigData(
  options: HasMaterialLeadTimeConfigDataOptions = {},
  cache: Record<string, any> = {},
): HasMaterialLeadTimeConfigDataType {
  const { __typename = "CostCode" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasMaterialLeadTimeConfigData"] = newHasMaterialLeadTimeConfigData;

export type MaybeHasMarketOptions = DevelopmentOptions | RequireTypename<ScheduleTemplateOptions>;

export type MaybeHasMarketType = Development | ScheduleTemplate;

export type MaybeHasMarketTypeName = "Development" | "ScheduleTemplate";

export function newMaybeHasMarket(): Development;
export function newMaybeHasMarket(options: DevelopmentOptions, cache?: Record<string, any>): Development;
export function newMaybeHasMarket(
  options: RequireTypename<ScheduleTemplateOptions>,
  cache?: Record<string, any>,
): ScheduleTemplate;
export function newMaybeHasMarket(
  options: MaybeHasMarketOptions = {},
  cache: Record<string, any> = {},
): MaybeHasMarketType {
  const { __typename = "Development" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["MaybeHasMarket"] = newMaybeHasMarket;

export type HasGlobalConstraintItemOptions = GlobalPlanAllowanceOptions | RequireTypename<GlobalPlanConstraintOptions>;

export type HasGlobalConstraintItemType = GlobalPlanAllowance | GlobalPlanConstraint;

export type HasGlobalConstraintItemTypeName = "GlobalPlanAllowance" | "GlobalPlanConstraint";

export function newHasGlobalConstraintItem(): GlobalPlanAllowance;
export function newHasGlobalConstraintItem(
  options: GlobalPlanAllowanceOptions,
  cache?: Record<string, any>,
): GlobalPlanAllowance;
export function newHasGlobalConstraintItem(
  options: RequireTypename<GlobalPlanConstraintOptions>,
  cache?: Record<string, any>,
): GlobalPlanConstraint;
export function newHasGlobalConstraintItem(
  options: HasGlobalConstraintItemOptions = {},
  cache: Record<string, any> = {},
): HasGlobalConstraintItemType {
  const { __typename = "GlobalPlanAllowance" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasGlobalConstraintItem"] = newHasGlobalConstraintItem;

export type HasDisplayVersionOptions = ItemTemplateOptions | RequireTypename<ReadyPlanAggregateVersionOptions>;

export type HasDisplayVersionType = ItemTemplate | ReadyPlanAggregateVersion;

export type HasDisplayVersionTypeName = "ItemTemplate" | "ReadyPlanAggregateVersion";

export function newHasDisplayVersion(): ItemTemplate;
export function newHasDisplayVersion(options: ItemTemplateOptions, cache?: Record<string, any>): ItemTemplate;
export function newHasDisplayVersion(
  options: RequireTypename<ReadyPlanAggregateVersionOptions>,
  cache?: Record<string, any>,
): ReadyPlanAggregateVersion;
export function newHasDisplayVersion(
  options: HasDisplayVersionOptions = {},
  cache: Record<string, any> = {},
): HasDisplayVersionType {
  const { __typename = "ItemTemplate" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasDisplayVersion"] = newHasDisplayVersion;

export type BaseItemParentVersionOptions = ItemTemplateOptions | RequireTypename<ReadyPlanAggregateVersionOptions>;

export type BaseItemParentVersionType = ItemTemplate | ReadyPlanAggregateVersion;

export type BaseItemParentVersionTypeName = "ItemTemplate" | "ReadyPlanAggregateVersion";

export function newBaseItemParentVersion(): ItemTemplate;
export function newBaseItemParentVersion(options: ItemTemplateOptions, cache?: Record<string, any>): ItemTemplate;
export function newBaseItemParentVersion(
  options: RequireTypename<ReadyPlanAggregateVersionOptions>,
  cache?: Record<string, any>,
): ReadyPlanAggregateVersion;
export function newBaseItemParentVersion(
  options: BaseItemParentVersionOptions = {},
  cache: Record<string, any> = {},
): BaseItemParentVersionType {
  const { __typename = "ItemTemplate" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["BaseItemParentVersion"] = newBaseItemParentVersion;

export type HasOptionPricingDataOptions = MaterialListingOptions | RequireTypename<ReadyPlanOptionOptions>;

export type HasOptionPricingDataType = MaterialListing | ReadyPlanOption;

export type HasOptionPricingDataTypeName = "MaterialListing" | "ReadyPlanOption";

export function newHasOptionPricingData(): MaterialListing;
export function newHasOptionPricingData(options: MaterialListingOptions, cache?: Record<string, any>): MaterialListing;
export function newHasOptionPricingData(
  options: RequireTypename<ReadyPlanOptionOptions>,
  cache?: Record<string, any>,
): ReadyPlanOption;
export function newHasOptionPricingData(
  options: HasOptionPricingDataOptions = {},
  cache: Record<string, any> = {},
): HasOptionPricingDataType {
  const { __typename = "MaterialListing" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasOptionPricingData"] = newHasOptionPricingData;

export type ProgramDataLikeOptions = ProgramDataOptions | RequireTypename<NewProgramDataOptions>;

export type ProgramDataLikeType = ProgramData | NewProgramData;

export type ProgramDataLikeTypeName = "ProgramData" | "NewProgramData";

export function newProgramDataLike(): ProgramData;
export function newProgramDataLike(options: ProgramDataOptions, cache?: Record<string, any>): ProgramData;
export function newProgramDataLike(
  options: RequireTypename<NewProgramDataOptions>,
  cache?: Record<string, any>,
): NewProgramData;
export function newProgramDataLike(
  options: ProgramDataLikeOptions = {},
  cache: Record<string, any> = {},
): ProgramDataLikeType {
  const { __typename = "ProgramData" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["ProgramDataLike"] = newProgramDataLike;

export type HasUserErrorsOptions = SaveProjectItemsResultOptions;

export type HasUserErrorsType = SaveProjectItemsResult;

export type HasUserErrorsTypeName = "SaveProjectItemsResult";

export function newHasUserErrors(): SaveProjectItemsResult;
export function newHasUserErrors(
  options: SaveProjectItemsResultOptions,
  cache?: Record<string, any>,
): SaveProjectItemsResult;
export function newHasUserErrors(
  options: HasUserErrorsOptions = {},
  cache: Record<string, any> = {},
): HasUserErrorsType {
  const { __typename = "SaveProjectItemsResult" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasUserErrors"] = newHasUserErrors;

export type ReadyPlanCostDataOptions =
  | ComputeReadyPlanCostResultOptions
  | RequireTypename<ReadyPlanOptionCostDeltaOptions>;

export type ReadyPlanCostDataType = ComputeReadyPlanCostResult | ReadyPlanOptionCostDelta;

export type ReadyPlanCostDataTypeName = "ComputeReadyPlanCostResult" | "ReadyPlanOptionCostDelta";

export function newReadyPlanCostData(): ComputeReadyPlanCostResult;
export function newReadyPlanCostData(
  options: ComputeReadyPlanCostResultOptions,
  cache?: Record<string, any>,
): ComputeReadyPlanCostResult;
export function newReadyPlanCostData(
  options: RequireTypename<ReadyPlanOptionCostDeltaOptions>,
  cache?: Record<string, any>,
): ReadyPlanOptionCostDelta;
export function newReadyPlanCostData(
  options: ReadyPlanCostDataOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanCostDataType {
  const { __typename = "ComputeReadyPlanCostResult" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["ReadyPlanCostData"] = newReadyPlanCostData;

export type HasScheduleImpactOptions =
  | DeleteSchedulePhasesResultOptions
  | RequireTypename<DeleteScheduleSubPhasesResultOptions>
  | RequireTypename<MoveScheduleSubPhasesResultOptions>
  | RequireTypename<SaveScheduleTasksResultOptions>;

export type HasScheduleImpactType =
  | DeleteSchedulePhasesResult
  | DeleteScheduleSubPhasesResult
  | MoveScheduleSubPhasesResult
  | SaveScheduleTasksResult;

export type HasScheduleImpactTypeName =
  | "DeleteSchedulePhasesResult"
  | "DeleteScheduleSubPhasesResult"
  | "MoveScheduleSubPhasesResult"
  | "SaveScheduleTasksResult";

export function newHasScheduleImpact(): DeleteSchedulePhasesResult;
export function newHasScheduleImpact(
  options: DeleteSchedulePhasesResultOptions,
  cache?: Record<string, any>,
): DeleteSchedulePhasesResult;
export function newHasScheduleImpact(
  options: RequireTypename<DeleteScheduleSubPhasesResultOptions>,
  cache?: Record<string, any>,
): DeleteScheduleSubPhasesResult;
export function newHasScheduleImpact(
  options: RequireTypename<MoveScheduleSubPhasesResultOptions>,
  cache?: Record<string, any>,
): MoveScheduleSubPhasesResult;
export function newHasScheduleImpact(
  options: RequireTypename<SaveScheduleTasksResultOptions>,
  cache?: Record<string, any>,
): SaveScheduleTasksResult;
export function newHasScheduleImpact(
  options: HasScheduleImpactOptions = {},
  cache: Record<string, any> = {},
): HasScheduleImpactType {
  const { __typename = "DeleteSchedulePhasesResult" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasScheduleImpact"] = newHasScheduleImpact;

export type TradeCategoryLeadTimeLikeOptions =
  | TradeCategoryLeadTimeDefaultOptions
  | RequireTypename<TradeCategoryLeadTimeOptions>;

export type TradeCategoryLeadTimeLikeType = TradeCategoryLeadTimeDefault | TradeCategoryLeadTime;

export type TradeCategoryLeadTimeLikeTypeName = "TradeCategoryLeadTimeDefault" | "TradeCategoryLeadTime";

export function newTradeCategoryLeadTimeLike(): TradeCategoryLeadTimeDefault;
export function newTradeCategoryLeadTimeLike(
  options: TradeCategoryLeadTimeDefaultOptions,
  cache?: Record<string, any>,
): TradeCategoryLeadTimeDefault;
export function newTradeCategoryLeadTimeLike(
  options: RequireTypename<TradeCategoryLeadTimeOptions>,
  cache?: Record<string, any>,
): TradeCategoryLeadTime;
export function newTradeCategoryLeadTimeLike(
  options: TradeCategoryLeadTimeLikeOptions = {},
  cache: Record<string, any> = {},
): TradeCategoryLeadTimeLikeType {
  const { __typename = "TradeCategoryLeadTimeDefault" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["TradeCategoryLeadTimeLike"] = newTradeCategoryLeadTimeLike;

const enumDetailNameOfAiEntityProposalType = { CREATE: "Create", UPDATE: "Update", DELETE: "Delete" };

function enumOrDetailOfAiEntityProposalType(
  enumOrDetail: AiEntityProposalTypeDetailOptions | AiEntityProposalType | undefined,
): AiEntityProposalTypeDetail {
  if (enumOrDetail === undefined) {
    return newAiEntityProposalTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "AiEntityProposalTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfAiEntityProposalType[enumOrDetail.code!],
      ...enumOrDetail,
    } as AiEntityProposalTypeDetail;
  } else {
    return newAiEntityProposalTypeDetail({
      code: enumOrDetail as AiEntityProposalType,
      name: enumDetailNameOfAiEntityProposalType[enumOrDetail as AiEntityProposalType],
    });
  }
}

function enumOrDetailOrNullOfAiEntityProposalType(
  enumOrDetail: AiEntityProposalTypeDetailOptions | AiEntityProposalType | undefined | null,
): AiEntityProposalTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfAiEntityProposalType(enumOrDetail);
}

const enumDetailNameOfAiEntityProposalEntityType = {
  MATERIAL_VARIANT: "Material variant",
  READY_PLAN_LOCATION: "Ready plan location",
  READY_PLAN_OPTION: "Ready plan option",
  READY_PLAN_PROGRAM_DATA: "Ready plan program data",
};

function enumOrDetailOfAiEntityProposalEntityType(
  enumOrDetail: AiEntityProposalEntityTypeDetailOptions | AiEntityProposalEntityType | undefined,
): AiEntityProposalEntityTypeDetail {
  if (enumOrDetail === undefined) {
    return newAiEntityProposalEntityTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "AiEntityProposalEntityTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfAiEntityProposalEntityType[enumOrDetail.code!],
      ...enumOrDetail,
    } as AiEntityProposalEntityTypeDetail;
  } else {
    return newAiEntityProposalEntityTypeDetail({
      code: enumOrDetail as AiEntityProposalEntityType,
      name: enumDetailNameOfAiEntityProposalEntityType[enumOrDetail as AiEntityProposalEntityType],
    });
  }
}

function enumOrDetailOrNullOfAiEntityProposalEntityType(
  enumOrDetail: AiEntityProposalEntityTypeDetailOptions | AiEntityProposalEntityType | undefined | null,
): AiEntityProposalEntityTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfAiEntityProposalEntityType(enumOrDetail);
}

const enumDetailNameOfAiFieldProposalStatus = { PENDING: "Pending", ACCEPTED: "Accepted", REJECTED: "Rejected" };

function enumOrDetailOfAiFieldProposalStatus(
  enumOrDetail: AiFieldProposalStatusDetailOptions | AiFieldProposalStatus | undefined,
): AiFieldProposalStatusDetail {
  if (enumOrDetail === undefined) {
    return newAiFieldProposalStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "AiFieldProposalStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfAiFieldProposalStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as AiFieldProposalStatusDetail;
  } else {
    return newAiFieldProposalStatusDetail({
      code: enumOrDetail as AiFieldProposalStatus,
      name: enumDetailNameOfAiFieldProposalStatus[enumOrDetail as AiFieldProposalStatus],
    });
  }
}

function enumOrDetailOrNullOfAiFieldProposalStatus(
  enumOrDetail: AiFieldProposalStatusDetailOptions | AiFieldProposalStatus | undefined | null,
): AiFieldProposalStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfAiFieldProposalStatus(enumOrDetail);
}

const enumDetailNameOfAiProposalType = {
  CONSTRUCTION_DOCUMENT_IMPORT: "Construction document import",
  MATERIAL_IMPORT: "Material import",
};

function enumOrDetailOfAiProposalType(
  enumOrDetail: AiProposalTypeDetailOptions | AiProposalType | undefined,
): AiProposalTypeDetail {
  if (enumOrDetail === undefined) {
    return newAiProposalTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "AiProposalTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfAiProposalType[enumOrDetail.code!],
      ...enumOrDetail,
    } as AiProposalTypeDetail;
  } else {
    return newAiProposalTypeDetail({
      code: enumOrDetail as AiProposalType,
      name: enumDetailNameOfAiProposalType[enumOrDetail as AiProposalType],
    });
  }
}

function enumOrDetailOrNullOfAiProposalType(
  enumOrDetail: AiProposalTypeDetailOptions | AiProposalType | undefined | null,
): AiProposalTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfAiProposalType(enumOrDetail);
}

const enumDetailNameOfAiProposalStatus = { PENDING: "Pending", COMPLETE: "Complete" };

function enumOrDetailOfAiProposalStatus(
  enumOrDetail: AiProposalStatusDetailOptions | AiProposalStatus | undefined,
): AiProposalStatusDetail {
  if (enumOrDetail === undefined) {
    return newAiProposalStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "AiProposalStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfAiProposalStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as AiProposalStatusDetail;
  } else {
    return newAiProposalStatusDetail({
      code: enumOrDetail as AiProposalStatus,
      name: enumDetailNameOfAiProposalStatus[enumOrDetail as AiProposalStatus],
    });
  }
}

function enumOrDetailOrNullOfAiProposalStatus(
  enumOrDetail: AiProposalStatusDetailOptions | AiProposalStatus | undefined | null,
): AiProposalStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfAiProposalStatus(enumOrDetail);
}

const enumDetailNameOfApprovalStatus = {
  CHANGES_NEEDED: "Changes needed",
  REQUESTED: "Requested",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

function enumOrDetailOfApprovalStatus(
  enumOrDetail: ApprovalStatusDetailOptions | ApprovalStatus | undefined,
): ApprovalStatusDetail {
  if (enumOrDetail === undefined) {
    return newApprovalStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ApprovalStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfApprovalStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ApprovalStatusDetail;
  } else {
    return newApprovalStatusDetail({
      code: enumOrDetail as ApprovalStatus,
      name: enumDetailNameOfApprovalStatus[enumOrDetail as ApprovalStatus],
    });
  }
}

function enumOrDetailOrNullOfApprovalStatus(
  enumOrDetail: ApprovalStatusDetailOptions | ApprovalStatus | undefined | null,
): ApprovalStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfApprovalStatus(enumOrDetail);
}

const enumDetailNameOfApproverStatus = {
  PENDING: "Pending",
  ACTION_REQUIRED: "Action required",
  CHANGES_REQUESTED: "Changes requested",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

function enumOrDetailOfApproverStatus(
  enumOrDetail: ApproverStatusDetailOptions | ApproverStatus | undefined,
): ApproverStatusDetail {
  if (enumOrDetail === undefined) {
    return newApproverStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ApproverStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfApproverStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ApproverStatusDetail;
  } else {
    return newApproverStatusDetail({
      code: enumOrDetail as ApproverStatus,
      name: enumDetailNameOfApproverStatus[enumOrDetail as ApproverStatus],
    });
  }
}

function enumOrDetailOrNullOfApproverStatus(
  enumOrDetail: ApproverStatusDetailOptions | ApproverStatus | undefined | null,
): ApproverStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfApproverStatus(enumOrDetail);
}

const enumDetailNameOfBidContractType = {
  UNIT_BASED: "Unit based",
  ITEM_TEMPLATE_BASED: "Item template based",
  GROUPED_BY_PLAN_AND_OPTION: "Grouped by plan and option",
  USER_CREATED_GROUP_BASED: "User created group based",
  LEGACY_UNIT_AND_TEMPLATE_BASED: "Legacy unit and template based",
};

function enumOrDetailOfBidContractType(
  enumOrDetail: BidContractTypeDetailOptions | BidContractType | undefined,
): BidContractTypeDetail {
  if (enumOrDetail === undefined) {
    return newBidContractTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BidContractTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBidContractType[enumOrDetail.code!],
      ...enumOrDetail,
    } as BidContractTypeDetail;
  } else {
    return newBidContractTypeDetail({
      code: enumOrDetail as BidContractType,
      name: enumDetailNameOfBidContractType[enumOrDetail as BidContractType],
    });
  }
}

function enumOrDetailOrNullOfBidContractType(
  enumOrDetail: BidContractTypeDetailOptions | BidContractType | undefined | null,
): BidContractTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBidContractType(enumOrDetail);
}

const enumDetailNameOfBidScopeSource = {
  COMMUNITY: "Community",
  SUBDIVISION: "Subdivision",
  LOT: "Lot",
  PRODUCT_OFFERING: "Product offering",
};

function enumOrDetailOfBidScopeSource(
  enumOrDetail: BidScopeSourceDetailOptions | BidScopeSource | undefined,
): BidScopeSourceDetail {
  if (enumOrDetail === undefined) {
    return newBidScopeSourceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BidScopeSourceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBidScopeSource[enumOrDetail.code!],
      ...enumOrDetail,
    } as BidScopeSourceDetail;
  } else {
    return newBidScopeSourceDetail({
      code: enumOrDetail as BidScopeSource,
      name: enumDetailNameOfBidScopeSource[enumOrDetail as BidScopeSource],
    });
  }
}

function enumOrDetailOrNullOfBidScopeSource(
  enumOrDetail: BidScopeSourceDetailOptions | BidScopeSource | undefined | null,
): BidScopeSourceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBidScopeSource(enumOrDetail);
}

const enumDetailNameOfInternalEstimateType = { TEMPORARY: "Temporary", LOT_DETERMINED: "Lot determined" };

function enumOrDetailOfInternalEstimateType(
  enumOrDetail: InternalEstimateTypeDetailOptions | InternalEstimateType | undefined,
): InternalEstimateTypeDetail {
  if (enumOrDetail === undefined) {
    return newInternalEstimateTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InternalEstimateTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInternalEstimateType[enumOrDetail.code!],
      ...enumOrDetail,
    } as InternalEstimateTypeDetail;
  } else {
    return newInternalEstimateTypeDetail({
      code: enumOrDetail as InternalEstimateType,
      name: enumDetailNameOfInternalEstimateType[enumOrDetail as InternalEstimateType],
    });
  }
}

function enumOrDetailOrNullOfInternalEstimateType(
  enumOrDetail: InternalEstimateTypeDetailOptions | InternalEstimateType | undefined | null,
): InternalEstimateTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInternalEstimateType(enumOrDetail);
}

const enumDetailNameOfBidContractRevisionStatus = {
  DRAFT: "Draft",
  UPLOADED: "Uploaded",
  SENT: "Sent",
  SIGNED: "Signed",
  PARTIALLY_SIGNED: "Partially signed",
  ARCHIVED: "Archived",
};

function enumOrDetailOfBidContractRevisionStatus(
  enumOrDetail: BidContractRevisionStatusDetailOptions | BidContractRevisionStatus | undefined,
): BidContractRevisionStatusDetail {
  if (enumOrDetail === undefined) {
    return newBidContractRevisionStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BidContractRevisionStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBidContractRevisionStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as BidContractRevisionStatusDetail;
  } else {
    return newBidContractRevisionStatusDetail({
      code: enumOrDetail as BidContractRevisionStatus,
      name: enumDetailNameOfBidContractRevisionStatus[enumOrDetail as BidContractRevisionStatus],
    });
  }
}

function enumOrDetailOrNullOfBidContractRevisionStatus(
  enumOrDetail: BidContractRevisionStatusDetailOptions | BidContractRevisionStatus | undefined | null,
): BidContractRevisionStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBidContractRevisionStatus(enumOrDetail);
}

const enumDetailNameOfCostType = {
  LABOR: "Labor",
  MATERIALS: "Materials",
  SUBCONTRACTOR: "Subcontractor",
  EQUIPMENT: "Equipment",
  OTHER: "Other",
};

function enumOrDetailOfCostType(enumOrDetail: CostTypeDetailOptions | CostType | undefined): CostTypeDetail {
  if (enumOrDetail === undefined) {
    return newCostTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CostTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCostType[enumOrDetail.code!],
      ...enumOrDetail,
    } as CostTypeDetail;
  } else {
    return newCostTypeDetail({
      code: enumOrDetail as CostType,
      name: enumDetailNameOfCostType[enumOrDetail as CostType],
    });
  }
}

function enumOrDetailOrNullOfCostType(
  enumOrDetail: CostTypeDetailOptions | CostType | undefined | null,
): CostTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCostType(enumOrDetail);
}

const enumDetailNameOfBidPackageStatus = { DRAFT: "Draft", OPEN: "Open", RECEIVED: "Received", AWARDED: "Awarded" };

function enumOrDetailOfBidPackageStatus(
  enumOrDetail: BidPackageStatusDetailOptions | BidPackageStatus | undefined,
): BidPackageStatusDetail {
  if (enumOrDetail === undefined) {
    return newBidPackageStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BidPackageStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBidPackageStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as BidPackageStatusDetail;
  } else {
    return newBidPackageStatusDetail({
      code: enumOrDetail as BidPackageStatus,
      name: enumDetailNameOfBidPackageStatus[enumOrDetail as BidPackageStatus],
    });
  }
}

function enumOrDetailOrNullOfBidPackageStatus(
  enumOrDetail: BidPackageStatusDetailOptions | BidPackageStatus | undefined | null,
): BidPackageStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBidPackageStatus(enumOrDetail);
}

const enumDetailNameOfTradePartnerOnboardingStatus = {
  IN_PROGRESS: "In progress",
  COMPLETE: "Complete",
  DO_NOT_USE: "Do not use",
  INACTIVE: "Inactive",
};

function enumOrDetailOfTradePartnerOnboardingStatus(
  enumOrDetail: TradePartnerOnboardingStatusDetailOptions | TradePartnerOnboardingStatus | undefined,
): TradePartnerOnboardingStatusDetail {
  if (enumOrDetail === undefined) {
    return newTradePartnerOnboardingStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TradePartnerOnboardingStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTradePartnerOnboardingStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as TradePartnerOnboardingStatusDetail;
  } else {
    return newTradePartnerOnboardingStatusDetail({
      code: enumOrDetail as TradePartnerOnboardingStatus,
      name: enumDetailNameOfTradePartnerOnboardingStatus[enumOrDetail as TradePartnerOnboardingStatus],
    });
  }
}

function enumOrDetailOrNullOfTradePartnerOnboardingStatus(
  enumOrDetail: TradePartnerOnboardingStatusDetailOptions | TradePartnerOnboardingStatus | undefined | null,
): TradePartnerOnboardingStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTradePartnerOnboardingStatus(enumOrDetail);
}

const enumDetailNameOfBillType = {
  STANDARD: "Standard",
  DEPOSIT: "Deposit",
  OVERHEAD: "Overhead",
  REPAIR_AND_MAINTENANCE: "Repair and maintenance",
  WARRANTY: "Warranty",
};

function enumOrDetailOfBillType(enumOrDetail: BillTypeDetailOptions | BillType | undefined): BillTypeDetail {
  if (enumOrDetail === undefined) {
    return newBillTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BillTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBillType[enumOrDetail.code!],
      ...enumOrDetail,
    } as BillTypeDetail;
  } else {
    return newBillTypeDetail({
      code: enumOrDetail as BillType,
      name: enumDetailNameOfBillType[enumOrDetail as BillType],
    });
  }
}

function enumOrDetailOrNullOfBillType(
  enumOrDetail: BillTypeDetailOptions | BillType | undefined | null,
): BillTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBillType(enumOrDetail);
}

const enumDetailNameOfBillStatus = {
  DRAFT: "Draft",
  CHANGES_REQUESTED: "Changes requested",
  RELEASE_SCHEDULED: "Release scheduled",
  PENDING_APPROVAL: "Pending approval",
  READY_TO_PAY: "Ready to pay",
  REJECTED: "Rejected",
  PAID: "Paid",
  REVERSED: "Reversed",
  CANCELLED: "Cancelled",
  PENDING_CONDITIONAL_LIEN_WAIVER: "Pending conditional lien waiver",
  PENDING_UNCONDITIONAL_LIEN_WAIVER: "Pending unconditional lien waiver",
  UNRELEASED: "Unreleased",
  PARTIALLY_PAID: "Partially paid",
};

function enumOrDetailOfBillStatus(enumOrDetail: BillStatusDetailOptions | BillStatus | undefined): BillStatusDetail {
  if (enumOrDetail === undefined) {
    return newBillStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BillStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBillStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as BillStatusDetail;
  } else {
    return newBillStatusDetail({
      code: enumOrDetail as BillStatus,
      name: enumDetailNameOfBillStatus[enumOrDetail as BillStatus],
    });
  }
}

function enumOrDetailOrNullOfBillStatus(
  enumOrDetail: BillStatusDetailOptions | BillStatus | undefined | null,
): BillStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBillStatus(enumOrDetail);
}

const enumDetailNameOfBillReviewReason = {
  MISSING_PO: "Missing po",
  UNSIGNED_PO: "Unsigned po",
  NEED_VPO: "Need vpo",
  INSUFFICIENT_BUDGET: "Insufficient budget",
  AUTO_PARSED: "Auto parsed",
  NEED_CLARIFICATION: "Need clarification",
};

function enumOrDetailOfBillReviewReason(
  enumOrDetail: BillReviewReasonDetailOptions | BillReviewReason | undefined,
): BillReviewReasonDetail {
  if (enumOrDetail === undefined) {
    return newBillReviewReasonDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BillReviewReasonDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBillReviewReason[enumOrDetail.code!],
      ...enumOrDetail,
    } as BillReviewReasonDetail;
  } else {
    return newBillReviewReasonDetail({
      code: enumOrDetail as BillReviewReason,
      name: enumDetailNameOfBillReviewReason[enumOrDetail as BillReviewReason],
    });
  }
}

function enumOrDetailOrNullOfBillReviewReason(
  enumOrDetail: BillReviewReasonDetailOptions | BillReviewReason | undefined | null,
): BillReviewReasonDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBillReviewReason(enumOrDetail);
}

const enumDetailNameOfBillSource = { MANUAL: "Manual", CLICK_TO_PAY: "Click to pay", AUTO_PARSED: "Auto parsed" };

function enumOrDetailOfBillSource(enumOrDetail: BillSourceDetailOptions | BillSource | undefined): BillSourceDetail {
  if (enumOrDetail === undefined) {
    return newBillSourceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BillSourceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBillSource[enumOrDetail.code!],
      ...enumOrDetail,
    } as BillSourceDetail;
  } else {
    return newBillSourceDetail({
      code: enumOrDetail as BillSource,
      name: enumDetailNameOfBillSource[enumOrDetail as BillSource],
    });
  }
}

function enumOrDetailOrNullOfBillSource(
  enumOrDetail: BillSourceDetailOptions | BillSource | undefined | null,
): BillSourceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBillSource(enumOrDetail);
}

const enumDetailNameOfBillGmailMessageResult = {
  NOT_FOUND: "Not found",
  NO_ATTACHMENTS: "No attachments",
  NO_PDFS: "No pdfs",
  PARSED: "Parsed",
  PARSING: "Parsing",
};

function enumOrDetailOfBillGmailMessageResult(
  enumOrDetail: BillGmailMessageResultDetailOptions | BillGmailMessageResult | undefined,
): BillGmailMessageResultDetail {
  if (enumOrDetail === undefined) {
    return newBillGmailMessageResultDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BillGmailMessageResultDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBillGmailMessageResult[enumOrDetail.code!],
      ...enumOrDetail,
    } as BillGmailMessageResultDetail;
  } else {
    return newBillGmailMessageResultDetail({
      code: enumOrDetail as BillGmailMessageResult,
      name: enumDetailNameOfBillGmailMessageResult[enumOrDetail as BillGmailMessageResult],
    });
  }
}

function enumOrDetailOrNullOfBillGmailMessageResult(
  enumOrDetail: BillGmailMessageResultDetailOptions | BillGmailMessageResult | undefined | null,
): BillGmailMessageResultDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBillGmailMessageResult(enumOrDetail);
}

const enumDetailNameOfProjectRole = {
  HEAD_OF_CONSTRUCTION: "Head of construction",
  ACCOUNT_EXECUTIVE: "Account executive",
  CON_OPS_PROJECT_MANAGER: "Con ops project manager",
  DESIGNER: "Designer",
  LEGAL: "Legal",
  AREA_MANAGER: "Area manager",
  ACCOUNTING: "Accounting",
  PURCHASING_ONE: "Purchasing one",
  CONSTRUCTION_COORDINATOR: "Construction coordinator",
  CX: "Cx",
  DESIGN_LEAD: "Design lead",
  HOMEBOUND_AUTHORIZED_SIGNATORY: "Homebound authorized signatory",
  A_AND_D_PROGRAM_MANAGER: "A and d program manager",
  WARRANTY_MANAGER: "Warranty manager",
  SUPERINTENDENT: "Superintendent",
  PRE_CON_PROJECT_MANAGER: "Pre con project manager",
  PRE_CON_LEAD: "Pre con lead",
  PURCHASING_TWO: "Purchasing two",
  HEAD_OF_ACCOUNTS_PAYABLE: "Head of accounts payable",
  AP_ACCOUNTANT: "Ap accountant",
  ARCHITECT_ASSOCIATE: "Architect associate",
  MARKET_LEAD: "Market lead",
  ARCHITECTURE_LEAD: "Architecture lead",
  OPTIONS_MANAGER: "Options manager",
  A_AND_D_OPERATIONS: "A and d operations",
  GRAPHIC_DESIGNER: "Graphic designer",
  PURCHASING_MANAGER: "Purchasing manager",
  SALES_LEAD: "Sales lead",
  RISK_MANAGER: "Risk manager",
  HEAD_OF_PURCHASING: "Head of purchasing",
  TRANSACTION_COORDINATOR: "Transaction coordinator",
  CON_OPS_PROJECT_MANAGER_TWO: "Con ops project manager two",
  SUPERINTENDENT_TWO: "Superintendent two",
  GENERAL_MANAGER: "General manager",
  UNDERWRITING_LEAD: "Underwriting lead",
  A_AND_D_STRATEGY: "A and d strategy",
  NATIONAL_NETWORK_MANAGER: "National network manager",
  PRODUCT_OPS: "Product ops",
  LW_INVOICE_SIGNATORY: "Lw invoice signatory",
  LAND_ACQUISITION_LEAD: "Land acquisition lead",
};

function enumOrDetailOfProjectRole(
  enumOrDetail: ProjectRoleDetailOptions | ProjectRole | undefined,
): ProjectRoleDetail {
  if (enumOrDetail === undefined) {
    return newProjectRoleDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectRoleDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectRole[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectRoleDetail;
  } else {
    return newProjectRoleDetail({
      code: enumOrDetail as ProjectRole,
      name: enumDetailNameOfProjectRole[enumOrDetail as ProjectRole],
    });
  }
}

function enumOrDetailOrNullOfProjectRole(
  enumOrDetail: ProjectRoleDetailOptions | ProjectRole | undefined | null,
): ProjectRoleDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectRole(enumOrDetail);
}

const enumDetailNameOfBusinessFunctionType = {
  ARCHITECTURE: "Architecture",
  CONSTRUCTION: "Construction",
  DESIGN: "Design",
  MARKETING: "Marketing",
  PURCHASING: "Purchasing",
  ACCOUNTING: "Accounting",
  SALES: "Sales",
  WARRANTY: "Warranty",
  CUSTOMER_EXPERIENCE: "Customer experience",
  UNDERWRITING: "Underwriting",
  PRECON: "Precon",
  MARKET_LAUNCH: "Market launch",
  LAND_ACQUISITION: "Land acquisition",
  LEGAL: "Legal",
};

function enumOrDetailOfBusinessFunctionType(
  enumOrDetail: BusinessFunctionTypeDetailOptions | BusinessFunctionType | undefined,
): BusinessFunctionTypeDetail {
  if (enumOrDetail === undefined) {
    return newBusinessFunctionTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BusinessFunctionTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBusinessFunctionType[enumOrDetail.code!],
      ...enumOrDetail,
    } as BusinessFunctionTypeDetail;
  } else {
    return newBusinessFunctionTypeDetail({
      code: enumOrDetail as BusinessFunctionType,
      name: enumDetailNameOfBusinessFunctionType[enumOrDetail as BusinessFunctionType],
    });
  }
}

function enumOrDetailOrNullOfBusinessFunctionType(
  enumOrDetail: BusinessFunctionTypeDetailOptions | BusinessFunctionType | undefined | null,
): BusinessFunctionTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBusinessFunctionType(enumOrDetail);
}

const enumDetailNameOfChangeType = {
  NA: "Na",
  PROGRAM_CHANGE: "Program change",
  ARCHITECHTURAL_DESIGN: "Architechtural design",
  STRUCTURAL_DESIGN: "Structural design",
  MEP_DESIGN: "Mep design",
  ADD_REMOVE_MODIFY_PRODUCTS: "Add remove modify products",
  MODIFY_OPTIONS_PROGRAM: "Modify options program",
  NEW_DESIGN_PACKAGE: "New design package",
  UPDATE_EXISTING_DESIGN_PACKAGE: "Update existing design package",
  NEW_EXTERIOR_STYLE: "New exterior style",
  IMPLEMENTATION_ERROR: "Implementation error",
  PRODUCT_REFRESH: "Product refresh",
};

function enumOrDetailOfChangeType(enumOrDetail: ChangeTypeDetailOptions | ChangeType | undefined): ChangeTypeDetail {
  if (enumOrDetail === undefined) {
    return newChangeTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeTypeDetail;
  } else {
    return newChangeTypeDetail({
      code: enumOrDetail as ChangeType,
      name: enumDetailNameOfChangeType[enumOrDetail as ChangeType],
    });
  }
}

function enumOrDetailOrNullOfChangeType(
  enumOrDetail: ChangeTypeDetailOptions | ChangeType | undefined | null,
): ChangeTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeType(enumOrDetail);
}

const enumDetailNameOfChangeEventStatus = {
  DRAFT: "Draft",
  ACCEPTED: "Accepted",
  REJECTED: "Rejected",
  PROPOSED: "Proposed",
  REQUESTED: "Requested",
  VOID: "Void",
  PENDING_SIGNATURE: "Pending signature",
};

function enumOrDetailOfChangeEventStatus(
  enumOrDetail: ChangeEventStatusDetailOptions | ChangeEventStatus | undefined,
): ChangeEventStatusDetail {
  if (enumOrDetail === undefined) {
    return newChangeEventStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeEventStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeEventStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeEventStatusDetail;
  } else {
    return newChangeEventStatusDetail({
      code: enumOrDetail as ChangeEventStatus,
      name: enumDetailNameOfChangeEventStatus[enumOrDetail as ChangeEventStatus],
    });
  }
}

function enumOrDetailOrNullOfChangeEventStatus(
  enumOrDetail: ChangeEventStatusDetailOptions | ChangeEventStatus | undefined | null,
): ChangeEventStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeEventStatus(enumOrDetail);
}

const enumDetailNameOfChangeEventBudgetPhase = { PREBID: "Prebid", AWARDED: "Awarded", REVISED: "Revised" };

function enumOrDetailOfChangeEventBudgetPhase(
  enumOrDetail: ChangeEventBudgetPhaseDetailOptions | ChangeEventBudgetPhase | undefined,
): ChangeEventBudgetPhaseDetail {
  if (enumOrDetail === undefined) {
    return newChangeEventBudgetPhaseDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeEventBudgetPhaseDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeEventBudgetPhase[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeEventBudgetPhaseDetail;
  } else {
    return newChangeEventBudgetPhaseDetail({
      code: enumOrDetail as ChangeEventBudgetPhase,
      name: enumDetailNameOfChangeEventBudgetPhase[enumOrDetail as ChangeEventBudgetPhase],
    });
  }
}

function enumOrDetailOrNullOfChangeEventBudgetPhase(
  enumOrDetail: ChangeEventBudgetPhaseDetailOptions | ChangeEventBudgetPhase | undefined | null,
): ChangeEventBudgetPhaseDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeEventBudgetPhase(enumOrDetail);
}

const enumDetailNameOfChangeEventType = {
  INTERNAL: "Internal",
  EXTERNAL: "External",
  BUDGET_REALLOCATION: "Budget reallocation",
};

function enumOrDetailOfChangeEventType(
  enumOrDetail: ChangeEventTypeDetailOptions | ChangeEventType | undefined,
): ChangeEventTypeDetail {
  if (enumOrDetail === undefined) {
    return newChangeEventTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeEventTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeEventType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeEventTypeDetail;
  } else {
    return newChangeEventTypeDetail({
      code: enumOrDetail as ChangeEventType,
      name: enumDetailNameOfChangeEventType[enumOrDetail as ChangeEventType],
    });
  }
}

function enumOrDetailOrNullOfChangeEventType(
  enumOrDetail: ChangeEventTypeDetailOptions | ChangeEventType | undefined | null,
): ChangeEventTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeEventType(enumOrDetail);
}

const enumDetailNameOfProjectReadyPlanConfigOrientation = { LEFT: "Left", RIGHT: "Right" };

function enumOrDetailOfProjectReadyPlanConfigOrientation(
  enumOrDetail: ProjectReadyPlanConfigOrientationDetailOptions | ProjectReadyPlanConfigOrientation | undefined,
): ProjectReadyPlanConfigOrientationDetail {
  if (enumOrDetail === undefined) {
    return newProjectReadyPlanConfigOrientationDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectReadyPlanConfigOrientationDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectReadyPlanConfigOrientation[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectReadyPlanConfigOrientationDetail;
  } else {
    return newProjectReadyPlanConfigOrientationDetail({
      code: enumOrDetail as ProjectReadyPlanConfigOrientation,
      name: enumDetailNameOfProjectReadyPlanConfigOrientation[enumOrDetail as ProjectReadyPlanConfigOrientation],
    });
  }
}

function enumOrDetailOrNullOfProjectReadyPlanConfigOrientation(
  enumOrDetail: ProjectReadyPlanConfigOrientationDetailOptions | ProjectReadyPlanConfigOrientation | undefined | null,
): ProjectReadyPlanConfigOrientationDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectReadyPlanConfigOrientation(enumOrDetail);
}

const enumDetailNameOfChangeEventWorkflow = {
  APPLY_FULL_CONFIGURATION: "Apply full configuration",
  APPLY_PARTIAL_CONFIGURATION: "Apply partial configuration",
  ADD_ON_BOOK_OPTION: "Add on book option",
  CONFIGURATION_TRUE_UP: "Configuration true up",
  SWAP_PRODUCT: "Swap product",
  FULL_LINE_CUSTOM_OPTION: "Full line custom option",
};

function enumOrDetailOfChangeEventWorkflow(
  enumOrDetail: ChangeEventWorkflowDetailOptions | ChangeEventWorkflow | undefined,
): ChangeEventWorkflowDetail {
  if (enumOrDetail === undefined) {
    return newChangeEventWorkflowDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeEventWorkflowDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeEventWorkflow[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeEventWorkflowDetail;
  } else {
    return newChangeEventWorkflowDetail({
      code: enumOrDetail as ChangeEventWorkflow,
      name: enumDetailNameOfChangeEventWorkflow[enumOrDetail as ChangeEventWorkflow],
    });
  }
}

function enumOrDetailOrNullOfChangeEventWorkflow(
  enumOrDetail: ChangeEventWorkflowDetailOptions | ChangeEventWorkflow | undefined | null,
): ChangeEventWorkflowDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeEventWorkflow(enumOrDetail);
}

const enumDetailNameOfCostConfidence = { LOW: "Low", HIGH: "High", HARD_BID: "Hard bid" };

function enumOrDetailOfCostConfidence(
  enumOrDetail: CostConfidenceDetailOptions | CostConfidence | undefined,
): CostConfidenceDetail {
  if (enumOrDetail === undefined) {
    return newCostConfidenceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CostConfidenceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCostConfidence[enumOrDetail.code!],
      ...enumOrDetail,
    } as CostConfidenceDetail;
  } else {
    return newCostConfidenceDetail({
      code: enumOrDetail as CostConfidence,
      name: enumDetailNameOfCostConfidence[enumOrDetail as CostConfidence],
    });
  }
}

function enumOrDetailOrNullOfCostConfidence(
  enumOrDetail: CostConfidenceDetailOptions | CostConfidence | undefined | null,
): CostConfidenceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCostConfidence(enumOrDetail);
}

const enumDetailNameOfChangeEventLineItemType = { ADD: "Add", MODIFY: "Modify", CUTOFF: "Cutoff", REMOVE: "Remove" };

function enumOrDetailOfChangeEventLineItemType(
  enumOrDetail: ChangeEventLineItemTypeDetailOptions | ChangeEventLineItemType | undefined,
): ChangeEventLineItemTypeDetail {
  if (enumOrDetail === undefined) {
    return newChangeEventLineItemTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeEventLineItemTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeEventLineItemType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeEventLineItemTypeDetail;
  } else {
    return newChangeEventLineItemTypeDetail({
      code: enumOrDetail as ChangeEventLineItemType,
      name: enumDetailNameOfChangeEventLineItemType[enumOrDetail as ChangeEventLineItemType],
    });
  }
}

function enumOrDetailOrNullOfChangeEventLineItemType(
  enumOrDetail: ChangeEventLineItemTypeDetailOptions | ChangeEventLineItemType | undefined | null,
): ChangeEventLineItemTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeEventLineItemType(enumOrDetail);
}

const enumDetailNameOfChangeRequestPriority = {
  LOW: "Low",
  MEDIUM: "Medium",
  HIGH: "High",
  URGENT: "Urgent",
  EXPEDITED: "Expedited",
};

function enumOrDetailOfChangeRequestPriority(
  enumOrDetail: ChangeRequestPriorityDetailOptions | ChangeRequestPriority | undefined,
): ChangeRequestPriorityDetail {
  if (enumOrDetail === undefined) {
    return newChangeRequestPriorityDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeRequestPriorityDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeRequestPriority[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeRequestPriorityDetail;
  } else {
    return newChangeRequestPriorityDetail({
      code: enumOrDetail as ChangeRequestPriority,
      name: enumDetailNameOfChangeRequestPriority[enumOrDetail as ChangeRequestPriority],
    });
  }
}

function enumOrDetailOrNullOfChangeRequestPriority(
  enumOrDetail: ChangeRequestPriorityDetailOptions | ChangeRequestPriority | undefined | null,
): ChangeRequestPriorityDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeRequestPriority(enumOrDetail);
}

const enumDetailNameOfChangeRequestSource = {
  NA: "Na",
  VALUE_ENGINEERING: "Value engineering",
  UP_SPECING: "Up specing",
  CUSTOMER_REQUEST_PERSONALIZATION: "Customer request personalization",
  FIELD_DIRECTIVE: "Field directive",
  FRAME_WALK_ADJUSTMENTS: "Frame walk adjustments",
  PROVIDER_UPDATE: "Provider update",
  INTERNAL_SALES_FEEDBACK: "Internal sales feedback",
  BOYL_CUSTOMER_REQUEST_PERSONALIZATION: "Boyl customer request personalization",
  PRODUCT_REFRESH: "Product refresh",
  INTERNAL_DESIGN_FEEDBACK: "Internal design feedback",
  FEE_BUILD_PROJECT_CHANGE: "Fee build project change",
};

function enumOrDetailOfChangeRequestSource(
  enumOrDetail: ChangeRequestSourceDetailOptions | ChangeRequestSource | undefined,
): ChangeRequestSourceDetail {
  if (enumOrDetail === undefined) {
    return newChangeRequestSourceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeRequestSourceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeRequestSource[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeRequestSourceDetail;
  } else {
    return newChangeRequestSourceDetail({
      code: enumOrDetail as ChangeRequestSource,
      name: enumDetailNameOfChangeRequestSource[enumOrDetail as ChangeRequestSource],
    });
  }
}

function enumOrDetailOrNullOfChangeRequestSource(
  enumOrDetail: ChangeRequestSourceDetailOptions | ChangeRequestSource | undefined | null,
): ChangeRequestSourceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeRequestSource(enumOrDetail);
}

const enumDetailNameOfChangeRequestStatus = {
  NEEDS_REVIEW: "Needs review",
  READY_FOR_REVIEW: "Ready for review",
  READY_FOR_APPROVAL: "Ready for approval",
  APPROVED: "Approved",
  DENIED: "Denied",
  COMPLETED: "Completed",
  REVERSED: "Reversed",
  BLOCKED: "Blocked",
};

function enumOrDetailOfChangeRequestStatus(
  enumOrDetail: ChangeRequestStatusDetailOptions | ChangeRequestStatus | undefined,
): ChangeRequestStatusDetail {
  if (enumOrDetail === undefined) {
    return newChangeRequestStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeRequestStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeRequestStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeRequestStatusDetail;
  } else {
    return newChangeRequestStatusDetail({
      code: enumOrDetail as ChangeRequestStatus,
      name: enumDetailNameOfChangeRequestStatus[enumOrDetail as ChangeRequestStatus],
    });
  }
}

function enumOrDetailOrNullOfChangeRequestStatus(
  enumOrDetail: ChangeRequestStatusDetailOptions | ChangeRequestStatus | undefined | null,
): ChangeRequestStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeRequestStatus(enumOrDetail);
}

const enumDetailNameOfChangeRequestAssetPlatform = {
  BLUEPRINT: "Blueprint",
  SALESFORCE: "Salesforce",
  UNDERWRITING_APP: "Underwriting app",
  MLS: "Mls",
  ZILLOW: "Zillow",
  GDRIVE: "Gdrive",
  FIGMA: "Figma",
  PHYSICAL_COLATERAL: "Physical colateral",
  GOOGLE_SLIDES: "Google slides",
  GOOGLE_SHEET: "Google sheet",
  CHECKOUT: "Checkout",
  AIRTABLE: "Airtable",
  HOMEBOUND_COM: "Homebound com",
  LYONELANE_COM: "Lyonelane com",
  AIR: "Air",
};

function enumOrDetailOfChangeRequestAssetPlatform(
  enumOrDetail: ChangeRequestAssetPlatformDetailOptions | ChangeRequestAssetPlatform | undefined,
): ChangeRequestAssetPlatformDetail {
  if (enumOrDetail === undefined) {
    return newChangeRequestAssetPlatformDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeRequestAssetPlatformDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeRequestAssetPlatform[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeRequestAssetPlatformDetail;
  } else {
    return newChangeRequestAssetPlatformDetail({
      code: enumOrDetail as ChangeRequestAssetPlatform,
      name: enumDetailNameOfChangeRequestAssetPlatform[enumOrDetail as ChangeRequestAssetPlatform],
    });
  }
}

function enumOrDetailOrNullOfChangeRequestAssetPlatform(
  enumOrDetail: ChangeRequestAssetPlatformDetailOptions | ChangeRequestAssetPlatform | undefined | null,
): ChangeRequestAssetPlatformDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeRequestAssetPlatform(enumOrDetail);
}

const enumDetailNameOfSystemChangeRequestAsset = {
  PANDA_DOC: "Panda doc",
  UPDATE_CLIENT_AND_CONTRACT: "Update client and contract",
  CHANGE_EVENT: "Change event",
};

function enumOrDetailOfSystemChangeRequestAsset(
  enumOrDetail: SystemChangeRequestAssetDetailOptions | SystemChangeRequestAsset | undefined,
): SystemChangeRequestAssetDetail {
  if (enumOrDetail === undefined) {
    return newSystemChangeRequestAssetDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "SystemChangeRequestAssetDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfSystemChangeRequestAsset[enumOrDetail.code!],
      ...enumOrDetail,
    } as SystemChangeRequestAssetDetail;
  } else {
    return newSystemChangeRequestAssetDetail({
      code: enumOrDetail as SystemChangeRequestAsset,
      name: enumDetailNameOfSystemChangeRequestAsset[enumOrDetail as SystemChangeRequestAsset],
    });
  }
}

function enumOrDetailOrNullOfSystemChangeRequestAsset(
  enumOrDetail: SystemChangeRequestAssetDetailOptions | SystemChangeRequestAsset | undefined | null,
): SystemChangeRequestAssetDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfSystemChangeRequestAsset(enumOrDetail);
}

const enumDetailNameOfToDoStatus = {
  BACKLOG: "Backlog",
  UP_NEXT: "Up next",
  IN_PROGRESS: "In progress",
  COMPLETE: "Complete",
};

function enumOrDetailOfToDoStatus(enumOrDetail: ToDoStatusDetailOptions | ToDoStatus | undefined): ToDoStatusDetail {
  if (enumOrDetail === undefined) {
    return newToDoStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ToDoStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfToDoStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ToDoStatusDetail;
  } else {
    return newToDoStatusDetail({
      code: enumOrDetail as ToDoStatus,
      name: enumDetailNameOfToDoStatus[enumOrDetail as ToDoStatus],
    });
  }
}

function enumOrDetailOrNullOfToDoStatus(
  enumOrDetail: ToDoStatusDetailOptions | ToDoStatus | undefined | null,
): ToDoStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfToDoStatus(enumOrDetail);
}

const enumDetailNameOfToDoType = {
  SUBMITTALS: "Submittals",
  JOB_LIST: "Job list",
  SK_ASI: "Sk asi",
  RFI_QUESTIONS: "Rfi questions",
  MEETING_NOTES: "Meeting notes",
  PURCHASING: "Purchasing",
  DESIGN: "Design",
  REVIEWS: "Reviews",
  FINANCE: "Finance",
  GENERAL: "General",
  PRODUCT_OPS: "Product ops",
  PUNCH_LIST: "Punch list",
  WARRANTY: "Warranty",
  INSPECTION: "Inspection",
  DELIVERY: "Delivery",
  PRODUCT_FEEDBACK: "Product feedback",
  SCHEDULE_REVIEW: "Schedule review",
};

function enumOrDetailOfToDoType(enumOrDetail: ToDoTypeDetailOptions | ToDoType | undefined): ToDoTypeDetail {
  if (enumOrDetail === undefined) {
    return newToDoTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ToDoTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfToDoType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ToDoTypeDetail;
  } else {
    return newToDoTypeDetail({
      code: enumOrDetail as ToDoType,
      name: enumDetailNameOfToDoType[enumOrDetail as ToDoType],
    });
  }
}

function enumOrDetailOrNullOfToDoType(
  enumOrDetail: ToDoTypeDetailOptions | ToDoType | undefined | null,
): ToDoTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfToDoType(enumOrDetail);
}

const enumDetailNameOfChangeRequestToDoType = {
  INITIAL_REVIEW: "Initial review",
  IMPACT_ESTIMATE: "Impact estimate",
  IMPLEMENTATION: "Implementation",
  IMPLEMENTATION_REVIEW: "Implementation review",
};

function enumOrDetailOfChangeRequestToDoType(
  enumOrDetail: ChangeRequestToDoTypeDetailOptions | ChangeRequestToDoType | undefined,
): ChangeRequestToDoTypeDetail {
  if (enumOrDetail === undefined) {
    return newChangeRequestToDoTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeRequestToDoTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeRequestToDoType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeRequestToDoTypeDetail;
  } else {
    return newChangeRequestToDoTypeDetail({
      code: enumOrDetail as ChangeRequestToDoType,
      name: enumDetailNameOfChangeRequestToDoType[enumOrDetail as ChangeRequestToDoType],
    });
  }
}

function enumOrDetailOrNullOfChangeRequestToDoType(
  enumOrDetail: ChangeRequestToDoTypeDetailOptions | ChangeRequestToDoType | undefined | null,
): ChangeRequestToDoTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeRequestToDoType(enumOrDetail);
}

const enumDetailNameOfScopeMode = {
  NONE: "None",
  RELEASE_TO_TRADES: "Release to trades",
  FULL: "Full",
  BUDGET_SAFE: "Budget safe",
};

function enumOrDetailOfScopeMode(enumOrDetail: ScopeModeDetailOptions | ScopeMode | undefined): ScopeModeDetail {
  if (enumOrDetail === undefined) {
    return newScopeModeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ScopeModeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfScopeMode[enumOrDetail.code!],
      ...enumOrDetail,
    } as ScopeModeDetail;
  } else {
    return newScopeModeDetail({
      code: enumOrDetail as ScopeMode,
      name: enumDetailNameOfScopeMode[enumOrDetail as ScopeMode],
    });
  }
}

function enumOrDetailOrNullOfScopeMode(
  enumOrDetail: ScopeModeDetailOptions | ScopeMode | undefined | null,
): ScopeModeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfScopeMode(enumOrDetail);
}

const enumDetailNameOfTaskStatus = {
  NOT_STARTED: "Not started",
  IN_PROGRESS: "In progress",
  COMPLETE: "Complete",
  ON_HOLD: "On hold",
  DELAYED: "Delayed",
};

function enumOrDetailOfTaskStatus(enumOrDetail: TaskStatusDetailOptions | TaskStatus | undefined): TaskStatusDetail {
  if (enumOrDetail === undefined) {
    return newTaskStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TaskStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTaskStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as TaskStatusDetail;
  } else {
    return newTaskStatusDetail({
      code: enumOrDetail as TaskStatus,
      name: enumDetailNameOfTaskStatus[enumOrDetail as TaskStatus],
    });
  }
}

function enumOrDetailOrNullOfTaskStatus(
  enumOrDetail: TaskStatusDetailOptions | TaskStatus | undefined | null,
): TaskStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTaskStatus(enumOrDetail);
}

const enumDetailNameOfTaskDeadlineType = { CUTOFF: "Cutoff", KEY_MILESTONE: "Key milestone" };

function enumOrDetailOfTaskDeadlineType(
  enumOrDetail: TaskDeadlineTypeDetailOptions | TaskDeadlineType | undefined,
): TaskDeadlineTypeDetail {
  if (enumOrDetail === undefined) {
    return newTaskDeadlineTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TaskDeadlineTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTaskDeadlineType[enumOrDetail.code!],
      ...enumOrDetail,
    } as TaskDeadlineTypeDetail;
  } else {
    return newTaskDeadlineTypeDetail({
      code: enumOrDetail as TaskDeadlineType,
      name: enumDetailNameOfTaskDeadlineType[enumOrDetail as TaskDeadlineType],
    });
  }
}

function enumOrDetailOrNullOfTaskDeadlineType(
  enumOrDetail: TaskDeadlineTypeDetailOptions | TaskDeadlineType | undefined | null,
): TaskDeadlineTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTaskDeadlineType(enumOrDetail);
}

const enumDetailNameOfTradePartnerTaskStatus = {
  NEEDS_CONFIRMATION: "Needs confirmation",
  CONFIRMED: "Confirmed",
  UNAVAILABLE: "Unavailable",
  COMPLETED_JOB: "Completed job",
  NEEDS_RECONFIRMATION: "Needs reconfirmation",
  NOT_SENT: "Not sent",
};

function enumOrDetailOfTradePartnerTaskStatus(
  enumOrDetail: TradePartnerTaskStatusDetailOptions | TradePartnerTaskStatus | undefined,
): TradePartnerTaskStatusDetail {
  if (enumOrDetail === undefined) {
    return newTradePartnerTaskStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TradePartnerTaskStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTradePartnerTaskStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as TradePartnerTaskStatusDetail;
  } else {
    return newTradePartnerTaskStatusDetail({
      code: enumOrDetail as TradePartnerTaskStatus,
      name: enumDetailNameOfTradePartnerTaskStatus[enumOrDetail as TradePartnerTaskStatus],
    });
  }
}

function enumOrDetailOrNullOfTradePartnerTaskStatus(
  enumOrDetail: TradePartnerTaskStatusDetailOptions | TradePartnerTaskStatus | undefined | null,
): TradePartnerTaskStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTradePartnerTaskStatus(enumOrDetail);
}

const enumDetailNameOfTaskType = { SCHEDULE_TASK: "Schedule task", PLAN_TASK: "Plan task" };

function enumOrDetailOfTaskType(enumOrDetail: TaskTypeDetailOptions | TaskType | undefined): TaskTypeDetail {
  if (enumOrDetail === undefined) {
    return newTaskTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TaskTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTaskType[enumOrDetail.code!],
      ...enumOrDetail,
    } as TaskTypeDetail;
  } else {
    return newTaskTypeDetail({
      code: enumOrDetail as TaskType,
      name: enumDetailNameOfTaskType[enumOrDetail as TaskType],
    });
  }
}

function enumOrDetailOrNullOfTaskType(
  enumOrDetail: TaskTypeDetailOptions | TaskType | undefined | null,
): TaskTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTaskType(enumOrDetail);
}

const enumDetailNameOfInvoiceStatus = {
  DRAFT: "Draft",
  REQUESTED: "Requested",
  CHANGES_REQUESTED: "Changes requested",
  APPROVED: "Approved",
  PAID: "Paid",
  REJECTED: "Rejected",
  VOID: "Void",
};

function enumOrDetailOfInvoiceStatus(
  enumOrDetail: InvoiceStatusDetailOptions | InvoiceStatus | undefined,
): InvoiceStatusDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceStatusDetail;
  } else {
    return newInvoiceStatusDetail({
      code: enumOrDetail as InvoiceStatus,
      name: enumDetailNameOfInvoiceStatus[enumOrDetail as InvoiceStatus],
    });
  }
}

function enumOrDetailOrNullOfInvoiceStatus(
  enumOrDetail: InvoiceStatusDetailOptions | InvoiceStatus | undefined | null,
): InvoiceStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceStatus(enumOrDetail);
}

const enumDetailNameOfInvoiceType = {
  PERCENTAGE_OF_COMPLETION: "Percentage of completion",
  DOWN_PAYMENT: "Down payment",
  STANDARD: "Standard",
  WARRANTY_TRUE_UP: "Warranty true up",
};

function enumOrDetailOfInvoiceType(
  enumOrDetail: InvoiceTypeDetailOptions | InvoiceType | undefined,
): InvoiceTypeDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceType[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceTypeDetail;
  } else {
    return newInvoiceTypeDetail({
      code: enumOrDetail as InvoiceType,
      name: enumDetailNameOfInvoiceType[enumOrDetail as InvoiceType],
    });
  }
}

function enumOrDetailOrNullOfInvoiceType(
  enumOrDetail: InvoiceTypeDetailOptions | InvoiceType | undefined | null,
): InvoiceTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceType(enumOrDetail);
}

const enumDetailNameOfInvoiceSource = { AUTO: "Auto", MANUAL: "Manual" };

function enumOrDetailOfInvoiceSource(
  enumOrDetail: InvoiceSourceDetailOptions | InvoiceSource | undefined,
): InvoiceSourceDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceSourceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceSourceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceSource[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceSourceDetail;
  } else {
    return newInvoiceSourceDetail({
      code: enumOrDetail as InvoiceSource,
      name: enumDetailNameOfInvoiceSource[enumOrDetail as InvoiceSource],
    });
  }
}

function enumOrDetailOrNullOfInvoiceSource(
  enumOrDetail: InvoiceSourceDetailOptions | InvoiceSource | undefined | null,
): InvoiceSourceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceSource(enumOrDetail);
}

const enumDetailNameOfStage = {
  PRE_CON_PLANNING: "Pre con planning",
  PRE_CON_EXECUTION: "Pre con execution",
  CONSTRUCTION: "Construction",
  DEVELOPMENT: "Development",
};

function enumOrDetailOfStage(enumOrDetail: StageDetailOptions | Stage | undefined): StageDetail {
  if (enumOrDetail === undefined) {
    return newStageDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "StageDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfStage[enumOrDetail.code!],
      ...enumOrDetail,
    } as StageDetail;
  } else {
    return newStageDetail({ code: enumOrDetail as Stage, name: enumDetailNameOfStage[enumOrDetail as Stage] });
  }
}

function enumOrDetailOrNullOfStage(enumOrDetail: StageDetailOptions | Stage | undefined | null): StageDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfStage(enumOrDetail);
}

const enumDetailNameOfProjectStatus = {
  ACTIVE: "Active",
  COMPLETED: "Completed",
  DISQUALIFIED: "Disqualified",
  HOLD: "Hold",
  UNDER_WARRANTY: "Under warranty",
};

function enumOrDetailOfProjectStatus(
  enumOrDetail: ProjectStatusDetailOptions | ProjectStatus | undefined,
): ProjectStatusDetail {
  if (enumOrDetail === undefined) {
    return newProjectStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectStatusDetail;
  } else {
    return newProjectStatusDetail({
      code: enumOrDetail as ProjectStatus,
      name: enumDetailNameOfProjectStatus[enumOrDetail as ProjectStatus],
    });
  }
}

function enumOrDetailOrNullOfProjectStatus(
  enumOrDetail: ProjectStatusDetailOptions | ProjectStatus | undefined | null,
): ProjectStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectStatus(enumOrDetail);
}

const enumDetailNameOfLotType = { BOYL: "Boyl", BOOL: "Bool", HBL: "Hbl", BTR: "Btr", FEE: "Fee" };

function enumOrDetailOfLotType(enumOrDetail: LotTypeDetailOptions | LotType | undefined): LotTypeDetail {
  if (enumOrDetail === undefined) {
    return newLotTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LotTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLotType[enumOrDetail.code!],
      ...enumOrDetail,
    } as LotTypeDetail;
  } else {
    return newLotTypeDetail({ code: enumOrDetail as LotType, name: enumDetailNameOfLotType[enumOrDetail as LotType] });
  }
}

function enumOrDetailOrNullOfLotType(
  enumOrDetail: LotTypeDetailOptions | LotType | undefined | null,
): LotTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLotType(enumOrDetail);
}

const enumDetailNameOfCommunityType = { INFILL: "Infill", SUBURBAN: "Suburban" };

function enumOrDetailOfCommunityType(
  enumOrDetail: CommunityTypeDetailOptions | CommunityType | undefined,
): CommunityTypeDetail {
  if (enumOrDetail === undefined) {
    return newCommunityTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CommunityTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCommunityType[enumOrDetail.code!],
      ...enumOrDetail,
    } as CommunityTypeDetail;
  } else {
    return newCommunityTypeDetail({
      code: enumOrDetail as CommunityType,
      name: enumDetailNameOfCommunityType[enumOrDetail as CommunityType],
    });
  }
}

function enumOrDetailOrNullOfCommunityType(
  enumOrDetail: CommunityTypeDetailOptions | CommunityType | undefined | null,
): CommunityTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCommunityType(enumOrDetail);
}

const enumDetailNameOfReadyPlanType = { SFH: "Sfh", ADU: "Adu", MFU: "Mfu" };

function enumOrDetailOfReadyPlanType(
  enumOrDetail: ReadyPlanTypeDetailOptions | ReadyPlanType | undefined,
): ReadyPlanTypeDetail {
  if (enumOrDetail === undefined) {
    return newReadyPlanTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ReadyPlanTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfReadyPlanType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ReadyPlanTypeDetail;
  } else {
    return newReadyPlanTypeDetail({
      code: enumOrDetail as ReadyPlanType,
      name: enumDetailNameOfReadyPlanType[enumOrDetail as ReadyPlanType],
    });
  }
}

function enumOrDetailOrNullOfReadyPlanType(
  enumOrDetail: ReadyPlanTypeDetailOptions | ReadyPlanType | undefined | null,
): ReadyPlanTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfReadyPlanType(enumOrDetail);
}

const enumDetailNameOfSuburbanAssetCategory = {
  INVENTORY: "Inventory",
  MODEL_HOME: "Model home",
  BUILD_TO_ORDER: "Build to order",
};

function enumOrDetailOfSuburbanAssetCategory(
  enumOrDetail: SuburbanAssetCategoryDetailOptions | SuburbanAssetCategory | undefined,
): SuburbanAssetCategoryDetail {
  if (enumOrDetail === undefined) {
    return newSuburbanAssetCategoryDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "SuburbanAssetCategoryDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfSuburbanAssetCategory[enumOrDetail.code!],
      ...enumOrDetail,
    } as SuburbanAssetCategoryDetail;
  } else {
    return newSuburbanAssetCategoryDetail({
      code: enumOrDetail as SuburbanAssetCategory,
      name: enumDetailNameOfSuburbanAssetCategory[enumOrDetail as SuburbanAssetCategory],
    });
  }
}

function enumOrDetailOrNullOfSuburbanAssetCategory(
  enumOrDetail: SuburbanAssetCategoryDetailOptions | SuburbanAssetCategory | undefined | null,
): SuburbanAssetCategoryDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfSuburbanAssetCategory(enumOrDetail);
}

const enumDetailNameOfLotSalesStatus = {
  NOT_AVAILABLE: "Not available",
  AVAILABLE: "Available",
  MODEL_HOME: "Model home",
  RESERVED: "Reserved",
  SOLD: "Sold",
};

function enumOrDetailOfLotSalesStatus(
  enumOrDetail: LotSalesStatusDetailOptions | LotSalesStatus | undefined,
): LotSalesStatusDetail {
  if (enumOrDetail === undefined) {
    return newLotSalesStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LotSalesStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLotSalesStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as LotSalesStatusDetail;
  } else {
    return newLotSalesStatusDetail({
      code: enumOrDetail as LotSalesStatus,
      name: enumDetailNameOfLotSalesStatus[enumOrDetail as LotSalesStatus],
    });
  }
}

function enumOrDetailOrNullOfLotSalesStatus(
  enumOrDetail: LotSalesStatusDetailOptions | LotSalesStatus | undefined | null,
): LotSalesStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLotSalesStatus(enumOrDetail);
}

const enumDetailNameOfBuyoutStatus = {
  NOT_BOUGHT_OUT: "Not bought out",
  BOUGHT_OUT: "Bought out",
  PARTIALLY_BOUGHT_OUT: "Partially bought out",
};

function enumOrDetailOfBuyoutStatus(
  enumOrDetail: BuyoutStatusDetailOptions | BuyoutStatus | undefined,
): BuyoutStatusDetail {
  if (enumOrDetail === undefined) {
    return newBuyoutStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BuyoutStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBuyoutStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as BuyoutStatusDetail;
  } else {
    return newBuyoutStatusDetail({
      code: enumOrDetail as BuyoutStatus,
      name: enumDetailNameOfBuyoutStatus[enumOrDetail as BuyoutStatus],
    });
  }
}

function enumOrDetailOrNullOfBuyoutStatus(
  enumOrDetail: BuyoutStatusDetailOptions | BuyoutStatus | undefined | null,
): BuyoutStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBuyoutStatus(enumOrDetail);
}

const enumDetailNameOfEstimateStatus = { DRAFT: "Draft", ACCEPTED: "Accepted", REJECTED: "Rejected" };

function enumOrDetailOfEstimateStatus(
  enumOrDetail: EstimateStatusDetailOptions | EstimateStatus | undefined,
): EstimateStatusDetail {
  if (enumOrDetail === undefined) {
    return newEstimateStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "EstimateStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfEstimateStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as EstimateStatusDetail;
  } else {
    return newEstimateStatusDetail({
      code: enumOrDetail as EstimateStatus,
      name: enumDetailNameOfEstimateStatus[enumOrDetail as EstimateStatus],
    });
  }
}

function enumOrDetailOrNullOfEstimateStatus(
  enumOrDetail: EstimateStatusDetailOptions | EstimateStatus | undefined | null,
): EstimateStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfEstimateStatus(enumOrDetail);
}

const enumDetailNameOfEstimateType = { PRELIMINARY: "Preliminary", FINAL: "Final" };

function enumOrDetailOfEstimateType(
  enumOrDetail: EstimateTypeDetailOptions | EstimateType | undefined,
): EstimateTypeDetail {
  if (enumOrDetail === undefined) {
    return newEstimateTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "EstimateTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfEstimateType[enumOrDetail.code!],
      ...enumOrDetail,
    } as EstimateTypeDetail;
  } else {
    return newEstimateTypeDetail({
      code: enumOrDetail as EstimateType,
      name: enumDetailNameOfEstimateType[enumOrDetail as EstimateType],
    });
  }
}

function enumOrDetailOrNullOfEstimateType(
  enumOrDetail: EstimateTypeDetailOptions | EstimateType | undefined | null,
): EstimateTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfEstimateType(enumOrDetail);
}

const enumDetailNameOfCommitmentStatus = {
  DRAFT: "Draft",
  UPLOADED: "Uploaded",
  SENT: "Sent",
  SIGNED: "Signed",
  VOIDED: "Voided",
  PARTIALLY_SIGNED: "Partially signed",
};

function enumOrDetailOfCommitmentStatus(
  enumOrDetail: CommitmentStatusDetailOptions | CommitmentStatus | undefined,
): CommitmentStatusDetail {
  if (enumOrDetail === undefined) {
    return newCommitmentStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CommitmentStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCommitmentStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as CommitmentStatusDetail;
  } else {
    return newCommitmentStatusDetail({
      code: enumOrDetail as CommitmentStatus,
      name: enumDetailNameOfCommitmentStatus[enumOrDetail as CommitmentStatus],
    });
  }
}

function enumOrDetailOrNullOfCommitmentStatus(
  enumOrDetail: CommitmentStatusDetailOptions | CommitmentStatus | undefined | null,
): CommitmentStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCommitmentStatus(enumOrDetail);
}

const enumDetailNameOfDevelopmentCommitmentType = {
  MATERIALS: "Materials",
  LABOR: "Labor",
  LABOR_AND_MATERIALS: "Labor and materials",
};

function enumOrDetailOfDevelopmentCommitmentType(
  enumOrDetail: DevelopmentCommitmentTypeDetailOptions | DevelopmentCommitmentType | undefined,
): DevelopmentCommitmentTypeDetail {
  if (enumOrDetail === undefined) {
    return newDevelopmentCommitmentTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DevelopmentCommitmentTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDevelopmentCommitmentType[enumOrDetail.code!],
      ...enumOrDetail,
    } as DevelopmentCommitmentTypeDetail;
  } else {
    return newDevelopmentCommitmentTypeDetail({
      code: enumOrDetail as DevelopmentCommitmentType,
      name: enumDetailNameOfDevelopmentCommitmentType[enumOrDetail as DevelopmentCommitmentType],
    });
  }
}

function enumOrDetailOrNullOfDevelopmentCommitmentType(
  enumOrDetail: DevelopmentCommitmentTypeDetailOptions | DevelopmentCommitmentType | undefined | null,
): DevelopmentCommitmentTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDevelopmentCommitmentType(enumOrDetail);
}

const enumDetailNameOfCommitmentType = { PURCHASE_ORDER: "Purchase order", SUBCONTRACT: "Subcontract" };

function enumOrDetailOfCommitmentType(
  enumOrDetail: CommitmentTypeDetailOptions | CommitmentType | undefined,
): CommitmentTypeDetail {
  if (enumOrDetail === undefined) {
    return newCommitmentTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CommitmentTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCommitmentType[enumOrDetail.code!],
      ...enumOrDetail,
    } as CommitmentTypeDetail;
  } else {
    return newCommitmentTypeDetail({
      code: enumOrDetail as CommitmentType,
      name: enumDetailNameOfCommitmentType[enumOrDetail as CommitmentType],
    });
  }
}

function enumOrDetailOrNullOfCommitmentType(
  enumOrDetail: CommitmentTypeDetailOptions | CommitmentType | undefined | null,
): CommitmentTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCommitmentType(enumOrDetail);
}

const enumDetailNameOfDocumentType = {
  PRECON_AGREEMENT: "Precon agreement",
  CONSTRUCTION_AGREEMENT: "Construction agreement",
  PURCHASE_ORDER: "Purchase order",
  SUBCONTRACT: "Subcontract",
  PRECON_AGREEMENT_CHANGE_ORDER: "Precon agreement change order",
  CONSTRUCTION_AGREEMENT_CHANGE_ORDER: "Construction agreement change order",
  PURCHASE_ORDER_CHANGE_ORDER: "Purchase order change order",
  SUBCONTRACT_CHANGE_ORDER: "Subcontract change order",
  BILL: "Bill",
  INVOICE: "Invoice",
  MEETING_NOTE: "Meeting note",
  INSURANCE: "Insurance",
  SALES: "Sales",
  ARCHITECTURE_AND_ENGINEERING: "Architecture and engineering",
  SITE_REPORT: "Site report",
  CORRESPONDENCE: "Correspondence",
  GENERAL: "General",
  PERMITTING: "Permitting",
  APPROVED_PLAN: "Approved plan",
  PHOTO: "Photo",
  DESIGN_STUDIO: "Design studio",
  DEVELOPMENT_COMMITMENT: "Development commitment",
  BID_CONTRACT: "Bid contract",
  EXPENSE: "Expense",
  WORK_AUTHORIZATION: "Work authorization",
  PRICE_AGREEMENT_CHANGE_ORDER: "Price agreement change order",
  PRICE_AGREEMENT_BID_CONTRACT_REVISION: "Price agreement bid contract revision",
  PRICE_AGREEMENT_DEVELOPMENT_COMMITMENT: "Price agreement development commitment",
  PRICE_AGREEMENT_COMMITMENT: "Price agreement commitment",
  PLAN: "Plan",
  DRAWING: "Drawing",
  FINISH_SCHEDULE: "Finish schedule",
  BOUNDARY_SURVEYS: "Boundary surveys",
  TOPO_SURVEYS: "Topo surveys",
  GEOTECH_REPORT_SOILS_REPORT: "Geotech report soils report",
  ELEVATION_CERTIFICATE: "Elevation certificate",
  MISCELLANEOUS_GENERAL: "Miscellaneous general",
  LEGAL: "Legal",
  CERTIFICATE_OF_OCCUPANCY: "Certificate of occupancy",
  FLOOD_INSURANCE_POLICY: "Flood insurance policy",
  PRE_BUILD_APPRAISAL: "Pre build appraisal",
  PURCHASE_AGREEMENT: "Purchase agreement",
  PURCHASE_AGREEMENT_AMENDMENT_LOT_ACQ: "Purchase agreement amendment lot acq",
  SETTLEMENT_STATEMENT_PRELIMINARY: "Settlement statement preliminary",
  SETTLEMENT_STATEMENT_FINAL: "Settlement statement final",
  DEED: "Deed",
  RECORDED_DEED: "Recorded deed",
  TITLE_INSURANCE_POLICY: "Title insurance policy",
  PROPERTY_SURVEY: "Property survey",
  EARNEST_MONEY_RECEIPT_LOT_ACQ: "Earnest money receipt lot acq",
  BUILDING_PERMIT: "Building permit",
  DEMO_PERMIT: "Demo permit",
  RETAINING_WALL_PERMIT: "Retaining wall permit",
  WATER_PERMIT: "Water permit",
  GRADING_PERMIT: "Grading permit",
  POOL_PERMIT: "Pool permit",
  VPO: "Vpo",
  PURCHASE_AGREEMENT_FINAL: "Purchase agreement final",
  PURCHASE_AGREEMENT_COUNTER_OFFER: "Purchase agreement counter offer",
  PURCHASE_AGREEMENT_AMENDMENT_SALES: "Purchase agreement amendment sales",
  PURCHASE_AGREEMENT_ADDENDUM: "Purchase agreement addendum",
  EARNEST_MONEY_RECEIPT_SALES: "Earnest money receipt sales",
  DISCLOSURES: "Disclosures",
  MISCELLANEOUS_SALES: "Miscellaneous sales",
  APPRAISAL_PRECON: "Appraisal precon",
  APPRAISAL_POST_COO: "Appraisal post coo",
  INSURANCE_HAZARD: "Insurance hazard",
  INSURANCE_BUILDERS_RISK: "Insurance builders risk",
  HOMEOWNER_ORIENTATION: "Homeowner orientation",
  LIEN_WAIVER: "Lien waiver",
  CHANGE_EVENT: "Change event",
  THIRD_PARTY_INSPECTION: "Third party inspection",
  CITY_INSPECTION: "City inspection",
  WARRANTY: "Warranty",
  RENDERING: "Rendering",
};

function enumOrDetailOfDocumentType(
  enumOrDetail: DocumentTypeDetailOptions | DocumentType | undefined,
): DocumentTypeDetail {
  if (enumOrDetail === undefined) {
    return newDocumentTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DocumentTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDocumentType[enumOrDetail.code!],
      ...enumOrDetail,
    } as DocumentTypeDetail;
  } else {
    return newDocumentTypeDetail({
      code: enumOrDetail as DocumentType,
      name: enumDetailNameOfDocumentType[enumOrDetail as DocumentType],
    });
  }
}

function enumOrDetailOrNullOfDocumentType(
  enumOrDetail: DocumentTypeDetailOptions | DocumentType | undefined | null,
): DocumentTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDocumentType(enumOrDetail);
}

const enumDetailNameOfDocumentCategory = {
  CONTRACTUAL: "Contractual",
  PERMITS: "Permits",
  DESIGN: "Design",
  PROCUREMENT: "Procurement",
  ACCOUNTING: "Accounting",
  SALES_MARKETING: "Sales marketing",
  WARRANTY: "Warranty",
  ENGINEERING: "Engineering",
  GENERAL: "General",
  LOT_ACQUISITION: "Lot acquisition",
  VALUATION: "Valuation",
  INSURANCE: "Insurance",
  ASSET_MANAGEMENT: "Asset management",
};

function enumOrDetailOfDocumentCategory(
  enumOrDetail: DocumentCategoryDetailOptions | DocumentCategory | undefined,
): DocumentCategoryDetail {
  if (enumOrDetail === undefined) {
    return newDocumentCategoryDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DocumentCategoryDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDocumentCategory[enumOrDetail.code!],
      ...enumOrDetail,
    } as DocumentCategoryDetail;
  } else {
    return newDocumentCategoryDetail({
      code: enumOrDetail as DocumentCategory,
      name: enumDetailNameOfDocumentCategory[enumOrDetail as DocumentCategory],
    });
  }
}

function enumOrDetailOrNullOfDocumentCategory(
  enumOrDetail: DocumentCategoryDetailOptions | DocumentCategory | undefined | null,
): DocumentCategoryDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDocumentCategory(enumOrDetail);
}

const enumDetailNameOfScopeChangeType = {
  NONE: "None",
  ADD: "Add",
  REPLACE: "Replace",
  MINOR: "Minor",
  MAJOR: "Major",
  REMOVED: "Removed",
  SYSTEM: "System",
};

function enumOrDetailOfScopeChangeType(
  enumOrDetail: ScopeChangeTypeDetailOptions | ScopeChangeType | undefined,
): ScopeChangeTypeDetail {
  if (enumOrDetail === undefined) {
    return newScopeChangeTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ScopeChangeTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfScopeChangeType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ScopeChangeTypeDetail;
  } else {
    return newScopeChangeTypeDetail({
      code: enumOrDetail as ScopeChangeType,
      name: enumDetailNameOfScopeChangeType[enumOrDetail as ScopeChangeType],
    });
  }
}

function enumOrDetailOrNullOfScopeChangeType(
  enumOrDetail: ScopeChangeTypeDetailOptions | ScopeChangeType | undefined | null,
): ScopeChangeTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfScopeChangeType(enumOrDetail);
}

const enumDetailNameOfJobLogNoteType = {
  DELAY: "Delay",
  DELIVERY: "Delivery",
  INCIDENT: "Incident",
  INJURY: "Injury",
  INSPECTION: "Inspection",
  ISSUE: "Issue",
  HOLIDAY: "Holiday",
  REQUEST_FOR_INFORMATION: "Request for information",
  TRADE_PARTNER_WORK: "Trade partner work",
  UPCOMING_ACTIVITY: "Upcoming activity",
  VISITOR: "Visitor",
  WARRANTY: "Warranty",
  WEATHER: "Weather",
  OTHER: "Other",
  CLIENT_COMMUNICATION: "Client communication",
  INTERNAL: "Internal",
  PRE_CON: "Pre con",
  AI_SUMMARY: "Ai summary",
};

function enumOrDetailOfJobLogNoteType(
  enumOrDetail: JobLogNoteTypeDetailOptions | JobLogNoteType | undefined,
): JobLogNoteTypeDetail {
  if (enumOrDetail === undefined) {
    return newJobLogNoteTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "JobLogNoteTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfJobLogNoteType[enumOrDetail.code!],
      ...enumOrDetail,
    } as JobLogNoteTypeDetail;
  } else {
    return newJobLogNoteTypeDetail({
      code: enumOrDetail as JobLogNoteType,
      name: enumDetailNameOfJobLogNoteType[enumOrDetail as JobLogNoteType],
    });
  }
}

function enumOrDetailOrNullOfJobLogNoteType(
  enumOrDetail: JobLogNoteTypeDetailOptions | JobLogNoteType | undefined | null,
): JobLogNoteTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfJobLogNoteType(enumOrDetail);
}

const enumDetailNameOfClientPlatform = { WEB: "Web", MOBILE: "Mobile" };

function enumOrDetailOfClientPlatform(
  enumOrDetail: ClientPlatformDetailOptions | ClientPlatform | undefined,
): ClientPlatformDetail {
  if (enumOrDetail === undefined) {
    return newClientPlatformDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ClientPlatformDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfClientPlatform[enumOrDetail.code!],
      ...enumOrDetail,
    } as ClientPlatformDetail;
  } else {
    return newClientPlatformDetail({
      code: enumOrDetail as ClientPlatform,
      name: enumDetailNameOfClientPlatform[enumOrDetail as ClientPlatform],
    });
  }
}

function enumOrDetailOrNullOfClientPlatform(
  enumOrDetail: ClientPlatformDetailOptions | ClientPlatform | undefined | null,
): ClientPlatformDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfClientPlatform(enumOrDetail);
}

const enumDetailNameOfTradePartnerAvailabilityRequestStatus = {
  WAITING: "Waiting",
  RESCHEDULE_NEEDED: "Reschedule needed",
  CONFIRMED: "Confirmed",
  CANCELED: "Canceled",
};

function enumOrDetailOfTradePartnerAvailabilityRequestStatus(
  enumOrDetail: TradePartnerAvailabilityRequestStatusDetailOptions | TradePartnerAvailabilityRequestStatus | undefined,
): TradePartnerAvailabilityRequestStatusDetail {
  if (enumOrDetail === undefined) {
    return newTradePartnerAvailabilityRequestStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TradePartnerAvailabilityRequestStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTradePartnerAvailabilityRequestStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as TradePartnerAvailabilityRequestStatusDetail;
  } else {
    return newTradePartnerAvailabilityRequestStatusDetail({
      code: enumOrDetail as TradePartnerAvailabilityRequestStatus,
      name:
        enumDetailNameOfTradePartnerAvailabilityRequestStatus[enumOrDetail as TradePartnerAvailabilityRequestStatus],
    });
  }
}

function enumOrDetailOrNullOfTradePartnerAvailabilityRequestStatus(
  enumOrDetail:
    | TradePartnerAvailabilityRequestStatusDetailOptions
    | TradePartnerAvailabilityRequestStatus
    | undefined
    | null,
): TradePartnerAvailabilityRequestStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTradePartnerAvailabilityRequestStatus(enumOrDetail);
}

const enumDetailNameOfWarrantyTicketType = {
  ITEMS_OF_CONTINUANCE: "Items of continuance",
  THIRTY_DAY: "Thirty day",
  ONE_YEAR: "One year",
  TWO_YEAR: "Two year",
  TEN_YEAR: "Ten year",
};

function enumOrDetailOfWarrantyTicketType(
  enumOrDetail: WarrantyTicketTypeDetailOptions | WarrantyTicketType | undefined,
): WarrantyTicketTypeDetail {
  if (enumOrDetail === undefined) {
    return newWarrantyTicketTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "WarrantyTicketTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfWarrantyTicketType[enumOrDetail.code!],
      ...enumOrDetail,
    } as WarrantyTicketTypeDetail;
  } else {
    return newWarrantyTicketTypeDetail({
      code: enumOrDetail as WarrantyTicketType,
      name: enumDetailNameOfWarrantyTicketType[enumOrDetail as WarrantyTicketType],
    });
  }
}

function enumOrDetailOrNullOfWarrantyTicketType(
  enumOrDetail: WarrantyTicketTypeDetailOptions | WarrantyTicketType | undefined | null,
): WarrantyTicketTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfWarrantyTicketType(enumOrDetail);
}

const enumDetailNameOfWarrantyTicketStatus = {
  NOT_STARTED: "Not started",
  IN_PROGRESS: "In progress",
  CLOSED: "Closed",
};

function enumOrDetailOfWarrantyTicketStatus(
  enumOrDetail: WarrantyTicketStatusDetailOptions | WarrantyTicketStatus | undefined,
): WarrantyTicketStatusDetail {
  if (enumOrDetail === undefined) {
    return newWarrantyTicketStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "WarrantyTicketStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfWarrantyTicketStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as WarrantyTicketStatusDetail;
  } else {
    return newWarrantyTicketStatusDetail({
      code: enumOrDetail as WarrantyTicketStatus,
      name: enumDetailNameOfWarrantyTicketStatus[enumOrDetail as WarrantyTicketStatus],
    });
  }
}

function enumOrDetailOrNullOfWarrantyTicketStatus(
  enumOrDetail: WarrantyTicketStatusDetailOptions | WarrantyTicketStatus | undefined | null,
): WarrantyTicketStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfWarrantyTicketStatus(enumOrDetail);
}

const enumDetailNameOfContractType = {
  FIXED: "Fixed",
  COST_PLUS: "Cost plus",
  BUDGET_REALLOCATION: "Budget reallocation",
};

function enumOrDetailOfContractType(
  enumOrDetail: ContractTypeDetailOptions | ContractType | undefined,
): ContractTypeDetail {
  if (enumOrDetail === undefined) {
    return newContractTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ContractTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfContractType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ContractTypeDetail;
  } else {
    return newContractTypeDetail({
      code: enumOrDetail as ContractType,
      name: enumDetailNameOfContractType[enumOrDetail as ContractType],
    });
  }
}

function enumOrDetailOrNullOfContractType(
  enumOrDetail: ContractTypeDetailOptions | ContractType | undefined | null,
): ContractTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfContractType(enumOrDetail);
}

const enumDetailNameOfReadyPlanStatus = { DRAFT: "Draft", ARCHIVED: "Archived", ACTIVE: "Active" };

function enumOrDetailOfReadyPlanStatus(
  enumOrDetail: ReadyPlanStatusDetailOptions | ReadyPlanStatus | undefined,
): ReadyPlanStatusDetail {
  if (enumOrDetail === undefined) {
    return newReadyPlanStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ReadyPlanStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfReadyPlanStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ReadyPlanStatusDetail;
  } else {
    return newReadyPlanStatusDetail({
      code: enumOrDetail as ReadyPlanStatus,
      name: enumDetailNameOfReadyPlanStatus[enumOrDetail as ReadyPlanStatus],
    });
  }
}

function enumOrDetailOrNullOfReadyPlanStatus(
  enumOrDetail: ReadyPlanStatusDetailOptions | ReadyPlanStatus | undefined | null,
): ReadyPlanStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfReadyPlanStatus(enumOrDetail);
}

const enumDetailNameOfGlobalOptionStatus = {
  ACTIVE: "Active",
  ARCHIVED: "Archived",
  PENDING_APPROVAL: "Pending approval",
};

function enumOrDetailOfGlobalOptionStatus(
  enumOrDetail: GlobalOptionStatusDetailOptions | GlobalOptionStatus | undefined,
): GlobalOptionStatusDetail {
  if (enumOrDetail === undefined) {
    return newGlobalOptionStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "GlobalOptionStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfGlobalOptionStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as GlobalOptionStatusDetail;
  } else {
    return newGlobalOptionStatusDetail({
      code: enumOrDetail as GlobalOptionStatus,
      name: enumDetailNameOfGlobalOptionStatus[enumOrDetail as GlobalOptionStatus],
    });
  }
}

function enumOrDetailOrNullOfGlobalOptionStatus(
  enumOrDetail: GlobalOptionStatusDetailOptions | GlobalOptionStatus | undefined | null,
): GlobalOptionStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfGlobalOptionStatus(enumOrDetail);
}

const enumDetailNameOfCommentStreamVisibility = { INTERNAL: "Internal", HOMEOWNER: "Homeowner", TRADES: "Trades" };

function enumOrDetailOfCommentStreamVisibility(
  enumOrDetail: CommentStreamVisibilityDetailOptions | CommentStreamVisibility | undefined,
): CommentStreamVisibilityDetail {
  if (enumOrDetail === undefined) {
    return newCommentStreamVisibilityDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CommentStreamVisibilityDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCommentStreamVisibility[enumOrDetail.code!],
      ...enumOrDetail,
    } as CommentStreamVisibilityDetail;
  } else {
    return newCommentStreamVisibilityDetail({
      code: enumOrDetail as CommentStreamVisibility,
      name: enumDetailNameOfCommentStreamVisibility[enumOrDetail as CommentStreamVisibility],
    });
  }
}

function enumOrDetailOrNullOfCommentStreamVisibility(
  enumOrDetail: CommentStreamVisibilityDetailOptions | CommentStreamVisibility | undefined | null,
): CommentStreamVisibilityDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCommentStreamVisibility(enumOrDetail);
}

const enumDetailNameOfProjectStageStatus = { ACTIVE: "Active", COMPLETED: "Completed", DRAFT: "Draft" };

function enumOrDetailOfProjectStageStatus(
  enumOrDetail: ProjectStageStatusDetailOptions | ProjectStageStatus | undefined,
): ProjectStageStatusDetail {
  if (enumOrDetail === undefined) {
    return newProjectStageStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectStageStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectStageStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectStageStatusDetail;
  } else {
    return newProjectStageStatusDetail({
      code: enumOrDetail as ProjectStageStatus,
      name: enumDetailNameOfProjectStageStatus[enumOrDetail as ProjectStageStatus],
    });
  }
}

function enumOrDetailOrNullOfProjectStageStatus(
  enumOrDetail: ProjectStageStatusDetailOptions | ProjectStageStatus | undefined | null,
): ProjectStageStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectStageStatus(enumOrDetail);
}

const enumDetailNameOfCostClassificationType = { SOFT: "Soft", HARD: "Hard" };

function enumOrDetailOfCostClassificationType(
  enumOrDetail: CostClassificationTypeDetailOptions | CostClassificationType | undefined,
): CostClassificationTypeDetail {
  if (enumOrDetail === undefined) {
    return newCostClassificationTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CostClassificationTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCostClassificationType[enumOrDetail.code!],
      ...enumOrDetail,
    } as CostClassificationTypeDetail;
  } else {
    return newCostClassificationTypeDetail({
      code: enumOrDetail as CostClassificationType,
      name: enumDetailNameOfCostClassificationType[enumOrDetail as CostClassificationType],
    });
  }
}

function enumOrDetailOrNullOfCostClassificationType(
  enumOrDetail: CostClassificationTypeDetailOptions | CostClassificationType | undefined | null,
): CostClassificationTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCostClassificationType(enumOrDetail);
}

const enumDetailNameOfCostSubClassificationType = { INDIRECT: "Indirect", DIRECT: "Direct" };

function enumOrDetailOfCostSubClassificationType(
  enumOrDetail: CostSubClassificationTypeDetailOptions | CostSubClassificationType | undefined,
): CostSubClassificationTypeDetail {
  if (enumOrDetail === undefined) {
    return newCostSubClassificationTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CostSubClassificationTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCostSubClassificationType[enumOrDetail.code!],
      ...enumOrDetail,
    } as CostSubClassificationTypeDetail;
  } else {
    return newCostSubClassificationTypeDetail({
      code: enumOrDetail as CostSubClassificationType,
      name: enumDetailNameOfCostSubClassificationType[enumOrDetail as CostSubClassificationType],
    });
  }
}

function enumOrDetailOrNullOfCostSubClassificationType(
  enumOrDetail: CostSubClassificationTypeDetailOptions | CostSubClassificationType | undefined | null,
): CostSubClassificationTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCostSubClassificationType(enumOrDetail);
}

const enumDetailNameOfCostCodeInvoiceCategory = {
  PRE_CON: "Pre con",
  FOUNDATION: "Foundation",
  FRAMING: "Framing",
  HARDSCAPE: "Hardscape",
  INSULATION_DRYWALL: "Insulation drywall",
  INTERIOR_FINISHES: "Interior finishes",
  ROOFING: "Roofing",
  ROUGH_IN: "Rough in",
  SIDING: "Siding",
  SUBSTANTIAL_COMPLETION: "Substantial completion",
  ARCHITECTURE_PLAN: "Architecture plan",
  ARCHITECTURE_FEE: "Architecture fee",
  EXTERIOR: "Exterior",
  MECHANICAL_SYSTEMS: "Mechanical systems",
  GENERAL_CONDITIONS: "General conditions",
  CONTINGENCY: "Contingency",
  HOLD_BACK: "Hold back",
  DEPOSIT: "Deposit",
};

function enumOrDetailOfCostCodeInvoiceCategory(
  enumOrDetail: CostCodeInvoiceCategoryDetailOptions | CostCodeInvoiceCategory | undefined,
): CostCodeInvoiceCategoryDetail {
  if (enumOrDetail === undefined) {
    return newCostCodeInvoiceCategoryDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CostCodeInvoiceCategoryDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCostCodeInvoiceCategory[enumOrDetail.code!],
      ...enumOrDetail,
    } as CostCodeInvoiceCategoryDetail;
  } else {
    return newCostCodeInvoiceCategoryDetail({
      code: enumOrDetail as CostCodeInvoiceCategory,
      name: enumDetailNameOfCostCodeInvoiceCategory[enumOrDetail as CostCodeInvoiceCategory],
    });
  }
}

function enumOrDetailOrNullOfCostCodeInvoiceCategory(
  enumOrDetail: CostCodeInvoiceCategoryDetailOptions | CostCodeInvoiceCategory | undefined | null,
): CostCodeInvoiceCategoryDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCostCodeInvoiceCategory(enumOrDetail);
}

const enumDetailNameOfSelectionCutoff = {
  CUTOFF_1: "Cutoff 1",
  CUTOFF_2A: "Cutoff 2 a",
  CUTOFF_2B: "Cutoff 2 b",
  CUTOFF_3: "Cutoff 3",
};

function enumOrDetailOfSelectionCutoff(
  enumOrDetail: SelectionCutoffDetailOptions | SelectionCutoff | undefined,
): SelectionCutoffDetail {
  if (enumOrDetail === undefined) {
    return newSelectionCutoffDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "SelectionCutoffDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfSelectionCutoff[enumOrDetail.code!],
      ...enumOrDetail,
    } as SelectionCutoffDetail;
  } else {
    return newSelectionCutoffDetail({
      code: enumOrDetail as SelectionCutoff,
      name: enumDetailNameOfSelectionCutoff[enumOrDetail as SelectionCutoff],
    });
  }
}

function enumOrDetailOrNullOfSelectionCutoff(
  enumOrDetail: SelectionCutoffDetailOptions | SelectionCutoff | undefined | null,
): SelectionCutoffDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfSelectionCutoff(enumOrDetail);
}

const enumDetailNameOfDesignPackageLocation = { INTERIOR: "Interior", EXTERIOR: "Exterior" };

function enumOrDetailOfDesignPackageLocation(
  enumOrDetail: DesignPackageLocationDetailOptions | DesignPackageLocation | undefined,
): DesignPackageLocationDetail {
  if (enumOrDetail === undefined) {
    return newDesignPackageLocationDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DesignPackageLocationDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDesignPackageLocation[enumOrDetail.code!],
      ...enumOrDetail,
    } as DesignPackageLocationDetail;
  } else {
    return newDesignPackageLocationDetail({
      code: enumOrDetail as DesignPackageLocation,
      name: enumDetailNameOfDesignPackageLocation[enumOrDetail as DesignPackageLocation],
    });
  }
}

function enumOrDetailOrNullOfDesignPackageLocation(
  enumOrDetail: DesignPackageLocationDetailOptions | DesignPackageLocation | undefined | null,
): DesignPackageLocationDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDesignPackageLocation(enumOrDetail);
}

const enumDetailNameOfActivityPlanningState = {
  DRAFT: "Draft",
  READY_FOR_REVIEW: "Ready for review",
  IN_REVIEW: "In review",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

function enumOrDetailOfActivityPlanningState(
  enumOrDetail: ActivityPlanningStateDetailOptions | ActivityPlanningState | undefined,
): ActivityPlanningStateDetail {
  if (enumOrDetail === undefined) {
    return newActivityPlanningStateDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ActivityPlanningStateDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfActivityPlanningState[enumOrDetail.code!],
      ...enumOrDetail,
    } as ActivityPlanningStateDetail;
  } else {
    return newActivityPlanningStateDetail({
      code: enumOrDetail as ActivityPlanningState,
      name: enumDetailNameOfActivityPlanningState[enumOrDetail as ActivityPlanningState],
    });
  }
}

function enumOrDetailOrNullOfActivityPlanningState(
  enumOrDetail: ActivityPlanningStateDetailOptions | ActivityPlanningState | undefined | null,
): ActivityPlanningStateDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfActivityPlanningState(enumOrDetail);
}

const enumDetailNameOfActivityResponsibility = {
  HOMEBOUND: "Homebound",
  OWNERS_CONSULTANT: "Owners consultant",
  NOT_APPLICABLE: "Not applicable",
};

function enumOrDetailOfActivityResponsibility(
  enumOrDetail: ActivityResponsibilityDetailOptions | ActivityResponsibility | undefined,
): ActivityResponsibilityDetail {
  if (enumOrDetail === undefined) {
    return newActivityResponsibilityDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ActivityResponsibilityDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfActivityResponsibility[enumOrDetail.code!],
      ...enumOrDetail,
    } as ActivityResponsibilityDetail;
  } else {
    return newActivityResponsibilityDetail({
      code: enumOrDetail as ActivityResponsibility,
      name: enumDetailNameOfActivityResponsibility[enumOrDetail as ActivityResponsibility],
    });
  }
}

function enumOrDetailOrNullOfActivityResponsibility(
  enumOrDetail: ActivityResponsibilityDetailOptions | ActivityResponsibility | undefined | null,
): ActivityResponsibilityDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfActivityResponsibility(enumOrDetail);
}

const enumDetailNameOfActivityType = {
  PRECON_PLANNING: "Precon planning",
  PRECON_CONSTRUCTION_DOC: "Precon construction doc",
};

function enumOrDetailOfActivityType(
  enumOrDetail: ActivityTypeDetailOptions | ActivityType | undefined,
): ActivityTypeDetail {
  if (enumOrDetail === undefined) {
    return newActivityTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ActivityTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfActivityType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ActivityTypeDetail;
  } else {
    return newActivityTypeDetail({
      code: enumOrDetail as ActivityType,
      name: enumDetailNameOfActivityType[enumOrDetail as ActivityType],
    });
  }
}

function enumOrDetailOrNullOfActivityType(
  enumOrDetail: ActivityTypeDetailOptions | ActivityType | undefined | null,
): ActivityTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfActivityType(enumOrDetail);
}

const enumDetailNameOfAggregateVersionStatus = { DRAFT: "Draft", ACTIVE: "Active", ARCHIVED: "Archived" };

function enumOrDetailOfAggregateVersionStatus(
  enumOrDetail: AggregateVersionStatusDetailOptions | AggregateVersionStatus | undefined,
): AggregateVersionStatusDetail {
  if (enumOrDetail === undefined) {
    return newAggregateVersionStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "AggregateVersionStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfAggregateVersionStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as AggregateVersionStatusDetail;
  } else {
    return newAggregateVersionStatusDetail({
      code: enumOrDetail as AggregateVersionStatus,
      name: enumDetailNameOfAggregateVersionStatus[enumOrDetail as AggregateVersionStatus],
    });
  }
}

function enumOrDetailOrNullOfAggregateVersionStatus(
  enumOrDetail: AggregateVersionStatusDetailOptions | AggregateVersionStatus | undefined | null,
): AggregateVersionStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfAggregateVersionStatus(enumOrDetail);
}

const enumDetailNameOfAllocationStrategy = {
  SIZE_BASED: "Size based",
  EQUAL_SHARE: "Equal share",
  MARKET_VALUE: "Market value",
};

function enumOrDetailOfAllocationStrategy(
  enumOrDetail: AllocationStrategyDetailOptions | AllocationStrategy | undefined,
): AllocationStrategyDetail {
  if (enumOrDetail === undefined) {
    return newAllocationStrategyDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "AllocationStrategyDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfAllocationStrategy[enumOrDetail.code!],
      ...enumOrDetail,
    } as AllocationStrategyDetail;
  } else {
    return newAllocationStrategyDetail({
      code: enumOrDetail as AllocationStrategy,
      name: enumDetailNameOfAllocationStrategy[enumOrDetail as AllocationStrategy],
    });
  }
}

function enumOrDetailOrNullOfAllocationStrategy(
  enumOrDetail: AllocationStrategyDetailOptions | AllocationStrategy | undefined | null,
): AllocationStrategyDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfAllocationStrategy(enumOrDetail);
}

const enumDetailNameOfBillGmailAttachmentResult = {
  NOT_PDF: "Not pdf",
  MISSING_PO: "Missing po",
  MISSING_TRADE: "Missing trade",
  MISSING_PROJECT: "Missing project",
  MISSING_INVOICE_NUMBER: "Missing invoice number",
  DUPLICATE: "Duplicate",
  CLICK_TO_PAY: "Click to pay",
  BILL_CREATED: "Bill created",
  MISSING_CONSTRUCTION_STAGE: "Missing construction stage",
  PROCESSING_ERROR: "Processing error",
  NOT_AN_INVOICE: "Not an invoice",
};

function enumOrDetailOfBillGmailAttachmentResult(
  enumOrDetail: BillGmailAttachmentResultDetailOptions | BillGmailAttachmentResult | undefined,
): BillGmailAttachmentResultDetail {
  if (enumOrDetail === undefined) {
    return newBillGmailAttachmentResultDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BillGmailAttachmentResultDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBillGmailAttachmentResult[enumOrDetail.code!],
      ...enumOrDetail,
    } as BillGmailAttachmentResultDetail;
  } else {
    return newBillGmailAttachmentResultDetail({
      code: enumOrDetail as BillGmailAttachmentResult,
      name: enumDetailNameOfBillGmailAttachmentResult[enumOrDetail as BillGmailAttachmentResult],
    });
  }
}

function enumOrDetailOrNullOfBillGmailAttachmentResult(
  enumOrDetail: BillGmailAttachmentResultDetailOptions | BillGmailAttachmentResult | undefined | null,
): BillGmailAttachmentResultDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBillGmailAttachmentResult(enumOrDetail);
}

const enumDetailNameOfChangeRequestAssetScope = { PROJECT: "Project", DEVELOPMENT: "Development" };

function enumOrDetailOfChangeRequestAssetScope(
  enumOrDetail: ChangeRequestAssetScopeDetailOptions | ChangeRequestAssetScope | undefined,
): ChangeRequestAssetScopeDetail {
  if (enumOrDetail === undefined) {
    return newChangeRequestAssetScopeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeRequestAssetScopeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeRequestAssetScope[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeRequestAssetScopeDetail;
  } else {
    return newChangeRequestAssetScopeDetail({
      code: enumOrDetail as ChangeRequestAssetScope,
      name: enumDetailNameOfChangeRequestAssetScope[enumOrDetail as ChangeRequestAssetScope],
    });
  }
}

function enumOrDetailOrNullOfChangeRequestAssetScope(
  enumOrDetail: ChangeRequestAssetScopeDetailOptions | ChangeRequestAssetScope | undefined | null,
): ChangeRequestAssetScopeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeRequestAssetScope(enumOrDetail);
}

const enumDetailNameOfCheckoutConfigOptionGroupStep = {
  EXTERIOR_ELEVATION: "Exterior elevation",
  EXTERIOR_DESIGN_PACKAGE: "Exterior design package",
  OPTIONS_STRUCTURAL: "Options structural",
  OPTIONS_ADDON: "Options addon",
  INTERIOR_DESIGN_PACKAGE: "Interior design package",
  INTERIOR_PERSONALIZATION: "Interior personalization",
  ADU: "Adu",
};

function enumOrDetailOfCheckoutConfigOptionGroupStep(
  enumOrDetail: CheckoutConfigOptionGroupStepDetailOptions | CheckoutConfigOptionGroupStep | undefined,
): CheckoutConfigOptionGroupStepDetail {
  if (enumOrDetail === undefined) {
    return newCheckoutConfigOptionGroupStepDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CheckoutConfigOptionGroupStepDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCheckoutConfigOptionGroupStep[enumOrDetail.code!],
      ...enumOrDetail,
    } as CheckoutConfigOptionGroupStepDetail;
  } else {
    return newCheckoutConfigOptionGroupStepDetail({
      code: enumOrDetail as CheckoutConfigOptionGroupStep,
      name: enumDetailNameOfCheckoutConfigOptionGroupStep[enumOrDetail as CheckoutConfigOptionGroupStep],
    });
  }
}

function enumOrDetailOrNullOfCheckoutConfigOptionGroupStep(
  enumOrDetail: CheckoutConfigOptionGroupStepDetailOptions | CheckoutConfigOptionGroupStep | undefined | null,
): CheckoutConfigOptionGroupStepDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCheckoutConfigOptionGroupStep(enumOrDetail);
}

const enumDetailNameOfCheckoutConfigStatus = { DRAFT: "Draft", RESERVED: "Reserved", EXPIRED: "Expired" };

function enumOrDetailOfCheckoutConfigStatus(
  enumOrDetail: CheckoutConfigStatusDetailOptions | CheckoutConfigStatus | undefined,
): CheckoutConfigStatusDetail {
  if (enumOrDetail === undefined) {
    return newCheckoutConfigStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CheckoutConfigStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCheckoutConfigStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as CheckoutConfigStatusDetail;
  } else {
    return newCheckoutConfigStatusDetail({
      code: enumOrDetail as CheckoutConfigStatus,
      name: enumDetailNameOfCheckoutConfigStatus[enumOrDetail as CheckoutConfigStatus],
    });
  }
}

function enumOrDetailOrNullOfCheckoutConfigStatus(
  enumOrDetail: CheckoutConfigStatusDetailOptions | CheckoutConfigStatus | undefined | null,
): CheckoutConfigStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCheckoutConfigStatus(enumOrDetail);
}

const enumDetailNameOfCommunicationChannel = { EMAIL: "Email", TEXT: "Text" };

function enumOrDetailOfCommunicationChannel(
  enumOrDetail: CommunicationChannelDetailOptions | CommunicationChannel | undefined,
): CommunicationChannelDetail {
  if (enumOrDetail === undefined) {
    return newCommunicationChannelDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CommunicationChannelDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCommunicationChannel[enumOrDetail.code!],
      ...enumOrDetail,
    } as CommunicationChannelDetail;
  } else {
    return newCommunicationChannelDetail({
      code: enumOrDetail as CommunicationChannel,
      name: enumDetailNameOfCommunicationChannel[enumOrDetail as CommunicationChannel],
    });
  }
}

function enumOrDetailOrNullOfCommunicationChannel(
  enumOrDetail: CommunicationChannelDetailOptions | CommunicationChannel | undefined | null,
): CommunicationChannelDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCommunicationChannel(enumOrDetail);
}

const enumDetailNameOfConstructionType = { TYPE_III: "Type iii", TYPE_IV: "Type iv", TYPE_V: "Type v" };

function enumOrDetailOfConstructionType(
  enumOrDetail: ConstructionTypeDetailOptions | ConstructionType | undefined,
): ConstructionTypeDetail {
  if (enumOrDetail === undefined) {
    return newConstructionTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ConstructionTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfConstructionType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ConstructionTypeDetail;
  } else {
    return newConstructionTypeDetail({
      code: enumOrDetail as ConstructionType,
      name: enumDetailNameOfConstructionType[enumOrDetail as ConstructionType],
    });
  }
}

function enumOrDetailOrNullOfConstructionType(
  enumOrDetail: ConstructionTypeDetailOptions | ConstructionType | undefined | null,
): ConstructionTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfConstructionType(enumOrDetail);
}

const enumDetailNameOfDayOfWeek = {
  SATURDAY: "Saturday",
  SUNDAY: "Sunday",
  MONDAY: "Monday",
  TUESDAY: "Tuesday",
  WEDNESDAY: "Wednesday",
  THURSDAY: "Thursday",
  FRIDAY: "Friday",
};

function enumOrDetailOfDayOfWeek(enumOrDetail: DayOfWeekDetailOptions | DayOfWeek | undefined): DayOfWeekDetail {
  if (enumOrDetail === undefined) {
    return newDayOfWeekDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DayOfWeekDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDayOfWeek[enumOrDetail.code!],
      ...enumOrDetail,
    } as DayOfWeekDetail;
  } else {
    return newDayOfWeekDetail({
      code: enumOrDetail as DayOfWeek,
      name: enumDetailNameOfDayOfWeek[enumOrDetail as DayOfWeek],
    });
  }
}

function enumOrDetailOrNullOfDayOfWeek(
  enumOrDetail: DayOfWeekDetailOptions | DayOfWeek | undefined | null,
): DayOfWeekDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDayOfWeek(enumOrDetail);
}

const enumDetailNameOfDocumentAttachmentPlace = { PURCHASE_ORDER: "Purchase order", BID_CONTRACT: "Bid contract" };

function enumOrDetailOfDocumentAttachmentPlace(
  enumOrDetail: DocumentAttachmentPlaceDetailOptions | DocumentAttachmentPlace | undefined,
): DocumentAttachmentPlaceDetail {
  if (enumOrDetail === undefined) {
    return newDocumentAttachmentPlaceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DocumentAttachmentPlaceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDocumentAttachmentPlace[enumOrDetail.code!],
      ...enumOrDetail,
    } as DocumentAttachmentPlaceDetail;
  } else {
    return newDocumentAttachmentPlaceDetail({
      code: enumOrDetail as DocumentAttachmentPlace,
      name: enumDetailNameOfDocumentAttachmentPlace[enumOrDetail as DocumentAttachmentPlace],
    });
  }
}

function enumOrDetailOrNullOfDocumentAttachmentPlace(
  enumOrDetail: DocumentAttachmentPlaceDetailOptions | DocumentAttachmentPlace | undefined | null,
): DocumentAttachmentPlaceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDocumentAttachmentPlace(enumOrDetail);
}

const enumDetailNameOfErpAccrualType = {
  TASK_COMPLETION: "Task completion",
  TASK_ALLOCATION_CHANGE: "Task allocation change",
  TASK_REVERSAL: "Task reversal",
  PURCHASE_ORDER_SIGNED: "Purchase order signed",
  PURCHASE_ORDER_VOID: "Purchase order void",
  CHANGE_ORDER_VOID: "Change order void",
  CHANGE_ORDER_SIGNED: "Change order signed",
  DEPOSIT_BILL_PAYMENT: "Deposit bill payment",
  DEPOSIT_BILL_PAYMENT_VOID: "Deposit bill payment void",
  AP_BILL_APPROVAL: "Ap bill approval",
  AP_BILL_REVERSAL: "Ap bill reversal",
  OVERHEAD_BILL_APPROVAL: "Overhead bill approval",
  OVERHEAD_BILL_REVERSAL: "Overhead bill reversal",
  EOM_ACCRUAL: "Eom accrual",
  BILL_LINE_ITEM_ALLOCATION: "Bill line item allocation",
  BILL_LINE_ITEM_ALLOCATION_REVERSAL: "Bill line item allocation reversal",
  EOM_ACCRUAL_REVERSAL: "Eom accrual reversal",
  EXPENSE_COST_ALLOCATION: "Expense cost allocation",
  EXPENSE_COST_ALLOCATION_REVERSAL: "Expense cost allocation reversal",
};

function enumOrDetailOfErpAccrualType(
  enumOrDetail: ErpAccrualTypeDetailOptions | ErpAccrualType | undefined,
): ErpAccrualTypeDetail {
  if (enumOrDetail === undefined) {
    return newErpAccrualTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ErpAccrualTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfErpAccrualType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ErpAccrualTypeDetail;
  } else {
    return newErpAccrualTypeDetail({
      code: enumOrDetail as ErpAccrualType,
      name: enumDetailNameOfErpAccrualType[enumOrDetail as ErpAccrualType],
    });
  }
}

function enumOrDetailOrNullOfErpAccrualType(
  enumOrDetail: ErpAccrualTypeDetailOptions | ErpAccrualType | undefined | null,
): ErpAccrualTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfErpAccrualType(enumOrDetail);
}

const enumDetailNameOfErpRevenueLineItemSourceEvent = {
  CONTRACT_PRICE_CHANGE: "Contract price change",
  CONTRACT_PRICE_CHANGE_VOID: "Contract price change void",
  DIRECT_EXPENSE: "Direct expense",
  DIRECT_EXPENSE_VOID: "Direct expense void",
  COST_ACCRUAL: "Cost accrual",
  INITIAL_BALANCE: "Initial balance",
  OVERHEAD_BILL_APPROVAL: "Overhead bill approval",
  OVERHEAD_BILL_REVERSAL: "Overhead bill reversal",
  BUDGET_CHANGE: "Budget change",
  BUDGET_CHANGE_VOID: "Budget change void",
};

function enumOrDetailOfErpRevenueLineItemSourceEvent(
  enumOrDetail: ErpRevenueLineItemSourceEventDetailOptions | ErpRevenueLineItemSourceEvent | undefined,
): ErpRevenueLineItemSourceEventDetail {
  if (enumOrDetail === undefined) {
    return newErpRevenueLineItemSourceEventDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ErpRevenueLineItemSourceEventDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfErpRevenueLineItemSourceEvent[enumOrDetail.code!],
      ...enumOrDetail,
    } as ErpRevenueLineItemSourceEventDetail;
  } else {
    return newErpRevenueLineItemSourceEventDetail({
      code: enumOrDetail as ErpRevenueLineItemSourceEvent,
      name: enumDetailNameOfErpRevenueLineItemSourceEvent[enumOrDetail as ErpRevenueLineItemSourceEvent],
    });
  }
}

function enumOrDetailOrNullOfErpRevenueLineItemSourceEvent(
  enumOrDetail: ErpRevenueLineItemSourceEventDetailOptions | ErpRevenueLineItemSourceEvent | undefined | null,
): ErpRevenueLineItemSourceEventDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfErpRevenueLineItemSourceEvent(enumOrDetail);
}

const enumDetailNameOfErpTransactionGroupEvent = {
  TASK_COMPLETION: "Task completion",
  DEPOSIT_BILL: "Deposit bill",
  AP_BILL_APPROVAL: "Ap bill approval",
  EOM_ACCRUAL: "Eom accrual",
  REVENUE_RECOGNITION: "Revenue recognition",
  REVENUE_EOM_ACCRUAL: "Revenue eom accrual",
  COST_ALLOCATION: "Cost allocation",
};

function enumOrDetailOfErpTransactionGroupEvent(
  enumOrDetail: ErpTransactionGroupEventDetailOptions | ErpTransactionGroupEvent | undefined,
): ErpTransactionGroupEventDetail {
  if (enumOrDetail === undefined) {
    return newErpTransactionGroupEventDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ErpTransactionGroupEventDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfErpTransactionGroupEvent[enumOrDetail.code!],
      ...enumOrDetail,
    } as ErpTransactionGroupEventDetail;
  } else {
    return newErpTransactionGroupEventDetail({
      code: enumOrDetail as ErpTransactionGroupEvent,
      name: enumDetailNameOfErpTransactionGroupEvent[enumOrDetail as ErpTransactionGroupEvent],
    });
  }
}

function enumOrDetailOrNullOfErpTransactionGroupEvent(
  enumOrDetail: ErpTransactionGroupEventDetailOptions | ErpTransactionGroupEvent | undefined | null,
): ErpTransactionGroupEventDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfErpTransactionGroupEvent(enumOrDetail);
}

const enumDetailNameOfErpTransactionGroupStatus = { PENDING: "Pending", SUCCESS: "Success", DRAFT: "Draft" };

function enumOrDetailOfErpTransactionGroupStatus(
  enumOrDetail: ErpTransactionGroupStatusDetailOptions | ErpTransactionGroupStatus | undefined,
): ErpTransactionGroupStatusDetail {
  if (enumOrDetail === undefined) {
    return newErpTransactionGroupStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ErpTransactionGroupStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfErpTransactionGroupStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ErpTransactionGroupStatusDetail;
  } else {
    return newErpTransactionGroupStatusDetail({
      code: enumOrDetail as ErpTransactionGroupStatus,
      name: enumDetailNameOfErpTransactionGroupStatus[enumOrDetail as ErpTransactionGroupStatus],
    });
  }
}

function enumOrDetailOrNullOfErpTransactionGroupStatus(
  enumOrDetail: ErpTransactionGroupStatusDetailOptions | ErpTransactionGroupStatus | undefined | null,
): ErpTransactionGroupStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfErpTransactionGroupStatus(enumOrDetail);
}

const enumDetailNameOfErpTransactionStatus = { PENDING: "Pending", MISMATCHING: "Mismatching", SYNCED: "Synced" };

function enumOrDetailOfErpTransactionStatus(
  enumOrDetail: ErpTransactionStatusDetailOptions | ErpTransactionStatus | undefined,
): ErpTransactionStatusDetail {
  if (enumOrDetail === undefined) {
    return newErpTransactionStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ErpTransactionStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfErpTransactionStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ErpTransactionStatusDetail;
  } else {
    return newErpTransactionStatusDetail({
      code: enumOrDetail as ErpTransactionStatus,
      name: enumDetailNameOfErpTransactionStatus[enumOrDetail as ErpTransactionStatus],
    });
  }
}

function enumOrDetailOrNullOfErpTransactionStatus(
  enumOrDetail: ErpTransactionStatusDetailOptions | ErpTransactionStatus | undefined | null,
): ErpTransactionStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfErpTransactionStatus(enumOrDetail);
}

const enumDetailNameOfFeatureFlagStatus = { ACTIVE: "Active", RELEASED: "Released", ARCHIVED: "Archived" };

function enumOrDetailOfFeatureFlagStatus(
  enumOrDetail: FeatureFlagStatusDetailOptions | FeatureFlagStatus | undefined,
): FeatureFlagStatusDetail {
  if (enumOrDetail === undefined) {
    return newFeatureFlagStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FeatureFlagStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFeatureFlagStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as FeatureFlagStatusDetail;
  } else {
    return newFeatureFlagStatusDetail({
      code: enumOrDetail as FeatureFlagStatus,
      name: enumDetailNameOfFeatureFlagStatus[enumOrDetail as FeatureFlagStatus],
    });
  }
}

function enumOrDetailOrNullOfFeatureFlagStatus(
  enumOrDetail: FeatureFlagStatusDetailOptions | FeatureFlagStatus | undefined | null,
): FeatureFlagStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFeatureFlagStatus(enumOrDetail);
}

const enumDetailNameOfFeatureFlagType = {
  TEST_FEATURE: "Test feature",
  TRADE_PARTNER_COMMUNICATIONS_SMS: "Trade partner communications sms",
  CHANGE_REQUEST_MVP: "Change request mvp",
  DIGITAL_BUILDING_EXPERIMENTS: "Digital building experiments",
  TRADE_PORTAL_ACCESS: "Trade portal access",
  MATERIAL_CATALOG: "Material catalog",
  DYNAMIC_SCHEDULES: "Dynamic schedules",
  COST_ACCRUALS: "Cost accruals",
  PRODUCT_CONFIG: "Product config",
  MOBILE_PUNCHLIST_POLLING: "Mobile punchlist polling",
  DYNAMIC_SCHEDULES_TRADE_COMMS: "Dynamic schedules trade comms",
  REVENUE_RECOGNITION: "Revenue recognition",
  MOBILE_PROJECT_GEOFENCE: "Mobile project geofence",
  OPTIONS_CATALOG_V2: "Options catalog v2",
  DESIGN_PACKAGE_PERSONALIZATION: "Design package personalization",
  PRODUCTION_WARNING_BANNER: "Production warning banner",
  MOBILE_LEADERBOARD: "Mobile leaderboard",
  MOBILE_SCHEDULE_SIM_DRAFT_MODE: "Mobile schedule sim draft mode",
  MOBILE_AI_CHATBOT_V2: "Mobile ai chatbot v2",
  VIDEO_SIGHTLINE_ANALYSIS: "Video sightline analysis",
  MOBILE_INCREMENTAL_SYNC: "Mobile incremental sync",
  DESIGNER_MODIFIED_SLOTS: "Designer modified slots",
  PREFER_LEGACY_PROJECTS: "Prefer legacy projects",
  BID_PACKAGES_V2: "Bid packages v2",
  BLUEPRINT_ADMIN: "Blueprint admin",
  MOBILE_NAVIGATION_V2: "Mobile navigation v2",
  COST_CODES_ADMIN: "Cost codes admin",
  ITEM_CODES_ADMIN: "Item codes admin",
  FEATURE_TYPES_ADMIN: "Feature types admin",
  TASK_CATALOG_ADMIN: "Task catalog admin",
  SCHEDULE_MILESTONE_TARGETS: "Schedule milestone targets",
  TAKEOFF_REMOVALS: "Takeoff removals",
  MOBILE_UPLOAD_OBSERVABILITY: "Mobile upload observability",
  GUIDED_CHANGE_EVENT: "Guided change event",
  MOBILE_SMART_ACTION_INBOX: "Mobile smart action inbox",
  FINISH_SCHEDULES_V2: "Finish schedules v2",
  PLAN_PACKAGES_V2: "Plan packages v2",
  MOBILE_SCHEDULES_V2: "Mobile schedules v2",
};

function enumOrDetailOfFeatureFlagType(
  enumOrDetail: FeatureFlagTypeDetailOptions | FeatureFlagType | undefined,
): FeatureFlagTypeDetail {
  if (enumOrDetail === undefined) {
    return newFeatureFlagTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FeatureFlagTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFeatureFlagType[enumOrDetail.code!],
      ...enumOrDetail,
    } as FeatureFlagTypeDetail;
  } else {
    return newFeatureFlagTypeDetail({
      code: enumOrDetail as FeatureFlagType,
      name: enumDetailNameOfFeatureFlagType[enumOrDetail as FeatureFlagType],
    });
  }
}

function enumOrDetailOrNullOfFeatureFlagType(
  enumOrDetail: FeatureFlagTypeDetailOptions | FeatureFlagType | undefined | null,
): FeatureFlagTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFeatureFlagType(enumOrDetail);
}

const enumDetailNameOfFinishScheduleColumnType = { CORE: "Core", ATTRIBUTE: "Attribute" };

function enumOrDetailOfFinishScheduleColumnType(
  enumOrDetail: FinishScheduleColumnTypeDetailOptions | FinishScheduleColumnType | undefined,
): FinishScheduleColumnTypeDetail {
  if (enumOrDetail === undefined) {
    return newFinishScheduleColumnTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FinishScheduleColumnTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFinishScheduleColumnType[enumOrDetail.code!],
      ...enumOrDetail,
    } as FinishScheduleColumnTypeDetail;
  } else {
    return newFinishScheduleColumnTypeDetail({
      code: enumOrDetail as FinishScheduleColumnType,
      name: enumDetailNameOfFinishScheduleColumnType[enumOrDetail as FinishScheduleColumnType],
    });
  }
}

function enumOrDetailOrNullOfFinishScheduleColumnType(
  enumOrDetail: FinishScheduleColumnTypeDetailOptions | FinishScheduleColumnType | undefined | null,
): FinishScheduleColumnTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFinishScheduleColumnType(enumOrDetail);
}

const enumDetailNameOfFinishScheduleCoreColumn = {
  LOCATION: "Location",
  IMAGE: "Image",
  ITEM: "Item",
  BRAND: "Brand",
  PRODUCT: "Product",
  TRADE: "Trade",
  NOTES: "Notes",
  LINK: "Link",
  DIMENSIONS: "Dimensions",
};

function enumOrDetailOfFinishScheduleCoreColumn(
  enumOrDetail: FinishScheduleCoreColumnDetailOptions | FinishScheduleCoreColumn | undefined,
): FinishScheduleCoreColumnDetail {
  if (enumOrDetail === undefined) {
    return newFinishScheduleCoreColumnDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FinishScheduleCoreColumnDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFinishScheduleCoreColumn[enumOrDetail.code!],
      ...enumOrDetail,
    } as FinishScheduleCoreColumnDetail;
  } else {
    return newFinishScheduleCoreColumnDetail({
      code: enumOrDetail as FinishScheduleCoreColumn,
      name: enumDetailNameOfFinishScheduleCoreColumn[enumOrDetail as FinishScheduleCoreColumn],
    });
  }
}

function enumOrDetailOrNullOfFinishScheduleCoreColumn(
  enumOrDetail: FinishScheduleCoreColumnDetailOptions | FinishScheduleCoreColumn | undefined | null,
): FinishScheduleCoreColumnDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFinishScheduleCoreColumn(enumOrDetail);
}

const enumDetailNameOfFloodPlain = { FP_0: "Fp 0", FP_100: "Fp 100", FP_500: "Fp 500" };

function enumOrDetailOfFloodPlain(enumOrDetail: FloodPlainDetailOptions | FloodPlain | undefined): FloodPlainDetail {
  if (enumOrDetail === undefined) {
    return newFloodPlainDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FloodPlainDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFloodPlain[enumOrDetail.code!],
      ...enumOrDetail,
    } as FloodPlainDetail;
  } else {
    return newFloodPlainDetail({
      code: enumOrDetail as FloodPlain,
      name: enumDetailNameOfFloodPlain[enumOrDetail as FloodPlain],
    });
  }
}

function enumOrDetailOrNullOfFloodPlain(
  enumOrDetail: FloodPlainDetailOptions | FloodPlain | undefined | null,
): FloodPlainDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFloodPlain(enumOrDetail);
}

const enumDetailNameOfFloodZone = { FZ_NONE: "Fz none", FZ_AE: "Fz ae", FZ_COASTAL_A: "Fz coastal a", FZ_VE: "Fz ve" };

function enumOrDetailOfFloodZone(enumOrDetail: FloodZoneDetailOptions | FloodZone | undefined): FloodZoneDetail {
  if (enumOrDetail === undefined) {
    return newFloodZoneDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FloodZoneDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFloodZone[enumOrDetail.code!],
      ...enumOrDetail,
    } as FloodZoneDetail;
  } else {
    return newFloodZoneDetail({
      code: enumOrDetail as FloodZone,
      name: enumDetailNameOfFloodZone[enumOrDetail as FloodZone],
    });
  }
}

function enumOrDetailOrNullOfFloodZone(
  enumOrDetail: FloodZoneDetailOptions | FloodZone | undefined | null,
): FloodZoneDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFloodZone(enumOrDetail);
}

const enumDetailNameOfFoundationType = { SLAB: "Slab", ELEVATED: "Elevated", PIERS: "Piers" };

function enumOrDetailOfFoundationType(
  enumOrDetail: FoundationTypeDetailOptions | FoundationType | undefined,
): FoundationTypeDetail {
  if (enumOrDetail === undefined) {
    return newFoundationTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FoundationTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFoundationType[enumOrDetail.code!],
      ...enumOrDetail,
    } as FoundationTypeDetail;
  } else {
    return newFoundationTypeDetail({
      code: enumOrDetail as FoundationType,
      name: enumDetailNameOfFoundationType[enumOrDetail as FoundationType],
    });
  }
}

function enumOrDetailOrNullOfFoundationType(
  enumOrDetail: FoundationTypeDetailOptions | FoundationType | undefined | null,
): FoundationTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFoundationType(enumOrDetail);
}

const enumDetailNameOfGlobalOptionTypeStatus = { ACTIVE: "Active", ARCHIVED: "Archived" };

function enumOrDetailOfGlobalOptionTypeStatus(
  enumOrDetail: GlobalOptionTypeStatusDetailOptions | GlobalOptionTypeStatus | undefined,
): GlobalOptionTypeStatusDetail {
  if (enumOrDetail === undefined) {
    return newGlobalOptionTypeStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "GlobalOptionTypeStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfGlobalOptionTypeStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as GlobalOptionTypeStatusDetail;
  } else {
    return newGlobalOptionTypeStatusDetail({
      code: enumOrDetail as GlobalOptionTypeStatus,
      name: enumDetailNameOfGlobalOptionTypeStatus[enumOrDetail as GlobalOptionTypeStatus],
    });
  }
}

function enumOrDetailOrNullOfGlobalOptionTypeStatus(
  enumOrDetail: GlobalOptionTypeStatusDetailOptions | GlobalOptionTypeStatus | undefined | null,
): GlobalOptionTypeStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfGlobalOptionTypeStatus(enumOrDetail);
}

const enumDetailNameOfGlobalPlanMilestoneType = {
  CONSTRUCTION: "Construction",
  PRECONSTRUCTION: "Preconstruction",
  COMMUNITY: "Community",
  SALES: "Sales",
};

function enumOrDetailOfGlobalPlanMilestoneType(
  enumOrDetail: GlobalPlanMilestoneTypeDetailOptions | GlobalPlanMilestoneType | undefined,
): GlobalPlanMilestoneTypeDetail {
  if (enumOrDetail === undefined) {
    return newGlobalPlanMilestoneTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "GlobalPlanMilestoneTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfGlobalPlanMilestoneType[enumOrDetail.code!],
      ...enumOrDetail,
    } as GlobalPlanMilestoneTypeDetail;
  } else {
    return newGlobalPlanMilestoneTypeDetail({
      code: enumOrDetail as GlobalPlanMilestoneType,
      name: enumDetailNameOfGlobalPlanMilestoneType[enumOrDetail as GlobalPlanMilestoneType],
    });
  }
}

function enumOrDetailOrNullOfGlobalPlanMilestoneType(
  enumOrDetail: GlobalPlanMilestoneTypeDetailOptions | GlobalPlanMilestoneType | undefined | null,
): GlobalPlanMilestoneTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfGlobalPlanMilestoneType(enumOrDetail);
}

const enumDetailNameOfInboxItemStatus = { READ: "Read", UNREAD: "Unread", ARCHIVED: "Archived" };

function enumOrDetailOfInboxItemStatus(
  enumOrDetail: InboxItemStatusDetailOptions | InboxItemStatus | undefined,
): InboxItemStatusDetail {
  if (enumOrDetail === undefined) {
    return newInboxItemStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InboxItemStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInboxItemStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as InboxItemStatusDetail;
  } else {
    return newInboxItemStatusDetail({
      code: enumOrDetail as InboxItemStatus,
      name: enumDetailNameOfInboxItemStatus[enumOrDetail as InboxItemStatus],
    });
  }
}

function enumOrDetailOrNullOfInboxItemStatus(
  enumOrDetail: InboxItemStatusDetailOptions | InboxItemStatus | undefined | null,
): InboxItemStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInboxItemStatus(enumOrDetail);
}

const enumDetailNameOfInvoiceDocumentSource = { QUICKBOOKS: "Quickbooks", INTACCT: "Intacct", BLUEPRINT: "Blueprint" };

function enumOrDetailOfInvoiceDocumentSource(
  enumOrDetail: InvoiceDocumentSourceDetailOptions | InvoiceDocumentSource | undefined,
): InvoiceDocumentSourceDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceDocumentSourceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceDocumentSourceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceDocumentSource[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceDocumentSourceDetail;
  } else {
    return newInvoiceDocumentSourceDetail({
      code: enumOrDetail as InvoiceDocumentSource,
      name: enumDetailNameOfInvoiceDocumentSource[enumOrDetail as InvoiceDocumentSource],
    });
  }
}

function enumOrDetailOrNullOfInvoiceDocumentSource(
  enumOrDetail: InvoiceDocumentSourceDetailOptions | InvoiceDocumentSource | undefined | null,
): InvoiceDocumentSourceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceDocumentSource(enumOrDetail);
}

const enumDetailNameOfInvoiceScheduleAmountType = {
  COST: "Cost",
  MARGIN: "Margin",
  COST_AND_MARGIN: "Cost and margin",
};

function enumOrDetailOfInvoiceScheduleAmountType(
  enumOrDetail: InvoiceScheduleAmountTypeDetailOptions | InvoiceScheduleAmountType | undefined,
): InvoiceScheduleAmountTypeDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceScheduleAmountTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceScheduleAmountTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceScheduleAmountType[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceScheduleAmountTypeDetail;
  } else {
    return newInvoiceScheduleAmountTypeDetail({
      code: enumOrDetail as InvoiceScheduleAmountType,
      name: enumDetailNameOfInvoiceScheduleAmountType[enumOrDetail as InvoiceScheduleAmountType],
    });
  }
}

function enumOrDetailOrNullOfInvoiceScheduleAmountType(
  enumOrDetail: InvoiceScheduleAmountTypeDetailOptions | InvoiceScheduleAmountType | undefined | null,
): InvoiceScheduleAmountTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceScheduleAmountType(enumOrDetail);
}

const enumDetailNameOfInvoiceScheduleItemFrequency = { ONCE: "Once", MONTHLY: "Monthly", DYNAMIC: "Dynamic" };

function enumOrDetailOfInvoiceScheduleItemFrequency(
  enumOrDetail: InvoiceScheduleItemFrequencyDetailOptions | InvoiceScheduleItemFrequency | undefined,
): InvoiceScheduleItemFrequencyDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceScheduleItemFrequencyDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceScheduleItemFrequencyDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceScheduleItemFrequency[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceScheduleItemFrequencyDetail;
  } else {
    return newInvoiceScheduleItemFrequencyDetail({
      code: enumOrDetail as InvoiceScheduleItemFrequency,
      name: enumDetailNameOfInvoiceScheduleItemFrequency[enumOrDetail as InvoiceScheduleItemFrequency],
    });
  }
}

function enumOrDetailOrNullOfInvoiceScheduleItemFrequency(
  enumOrDetail: InvoiceScheduleItemFrequencyDetailOptions | InvoiceScheduleItemFrequency | undefined | null,
): InvoiceScheduleItemFrequencyDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceScheduleItemFrequency(enumOrDetail);
}

const enumDetailNameOfInvoiceScheduleTriggerType = {
  DATE: "Date",
  TASK: "Task",
  COST: "Cost",
  NONE: "None",
  END_OF_MONTH: "End of month",
  PERCENTAGE_OF_COMPLETION: "Percentage of completion",
};

function enumOrDetailOfInvoiceScheduleTriggerType(
  enumOrDetail: InvoiceScheduleTriggerTypeDetailOptions | InvoiceScheduleTriggerType | undefined,
): InvoiceScheduleTriggerTypeDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceScheduleTriggerTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceScheduleTriggerTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceScheduleTriggerType[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceScheduleTriggerTypeDetail;
  } else {
    return newInvoiceScheduleTriggerTypeDetail({
      code: enumOrDetail as InvoiceScheduleTriggerType,
      name: enumDetailNameOfInvoiceScheduleTriggerType[enumOrDetail as InvoiceScheduleTriggerType],
    });
  }
}

function enumOrDetailOrNullOfInvoiceScheduleTriggerType(
  enumOrDetail: InvoiceScheduleTriggerTypeDetailOptions | InvoiceScheduleTriggerType | undefined | null,
): InvoiceScheduleTriggerTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceScheduleTriggerType(enumOrDetail);
}

const enumDetailNameOfItemStatus = { DRAFT: "Draft", ACTIVE: "Active", ARCHIVED: "Archived" };

function enumOrDetailOfItemStatus(enumOrDetail: ItemStatusDetailOptions | ItemStatus | undefined): ItemStatusDetail {
  if (enumOrDetail === undefined) {
    return newItemStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ItemStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfItemStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ItemStatusDetail;
  } else {
    return newItemStatusDetail({
      code: enumOrDetail as ItemStatus,
      name: enumDetailNameOfItemStatus[enumOrDetail as ItemStatus],
    });
  }
}

function enumOrDetailOrNullOfItemStatus(
  enumOrDetail: ItemStatusDetailOptions | ItemStatus | undefined | null,
): ItemStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfItemStatus(enumOrDetail);
}

const enumDetailNameOfItemTemplateItemCostStatus = {
  INTERNAL_ESTIMATE: "Internal estimate",
  CONTRACTED: "Contracted",
  NO_COST_SOURCE: "No cost source",
};

function enumOrDetailOfItemTemplateItemCostStatus(
  enumOrDetail: ItemTemplateItemCostStatusDetailOptions | ItemTemplateItemCostStatus | undefined,
): ItemTemplateItemCostStatusDetail {
  if (enumOrDetail === undefined) {
    return newItemTemplateItemCostStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ItemTemplateItemCostStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfItemTemplateItemCostStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ItemTemplateItemCostStatusDetail;
  } else {
    return newItemTemplateItemCostStatusDetail({
      code: enumOrDetail as ItemTemplateItemCostStatus,
      name: enumDetailNameOfItemTemplateItemCostStatus[enumOrDetail as ItemTemplateItemCostStatus],
    });
  }
}

function enumOrDetailOrNullOfItemTemplateItemCostStatus(
  enumOrDetail: ItemTemplateItemCostStatusDetailOptions | ItemTemplateItemCostStatus | undefined | null,
): ItemTemplateItemCostStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfItemTemplateItemCostStatus(enumOrDetail);
}

const enumDetailNameOfItemTemplateStatus = {
  DRAFT: "Draft",
  ACTIVE: "Active",
  ARCHIVED: "Archived",
  SYSTEM_DRAFT: "System draft",
};

function enumOrDetailOfItemTemplateStatus(
  enumOrDetail: ItemTemplateStatusDetailOptions | ItemTemplateStatus | undefined,
): ItemTemplateStatusDetail {
  if (enumOrDetail === undefined) {
    return newItemTemplateStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ItemTemplateStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfItemTemplateStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ItemTemplateStatusDetail;
  } else {
    return newItemTemplateStatusDetail({
      code: enumOrDetail as ItemTemplateStatus,
      name: enumDetailNameOfItemTemplateStatus[enumOrDetail as ItemTemplateStatus],
    });
  }
}

function enumOrDetailOrNullOfItemTemplateStatus(
  enumOrDetail: ItemTemplateStatusDetailOptions | ItemTemplateStatus | undefined | null,
): ItemTemplateStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfItemTemplateStatus(enumOrDetail);
}

const enumDetailNameOfJobLogFlag = {
  CHANGE_ORDER_DELAY: "Change order delay",
  CLIENT_DELAY: "Client delay",
  CONSULTANT_DELAY: "Consultant delay",
  DESIGN_DELAY: "Design delay",
  GROUND_WET: "Ground wet",
  HEALTH_DELAY: "Health delay",
  MATERIALS_DELAY: "Materials delay",
  QUALITY_CONTROL_DELAY: "Quality control delay",
  TRADE_PARTNER_DELAY: "Trade partner delay",
  WEATHER_DELAY: "Weather delay",
  DELIVERY_DELAY: "Delivery delay",
  INSPECTION_DELAY: "Inspection delay",
  INTERNAL_DELAY: "Internal delay",
};

function enumOrDetailOfJobLogFlag(enumOrDetail: JobLogFlagDetailOptions | JobLogFlag | undefined): JobLogFlagDetail {
  if (enumOrDetail === undefined) {
    return newJobLogFlagDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "JobLogFlagDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfJobLogFlag[enumOrDetail.code!],
      ...enumOrDetail,
    } as JobLogFlagDetail;
  } else {
    return newJobLogFlagDetail({
      code: enumOrDetail as JobLogFlag,
      name: enumDetailNameOfJobLogFlag[enumOrDetail as JobLogFlag],
    });
  }
}

function enumOrDetailOrNullOfJobLogFlag(
  enumOrDetail: JobLogFlagDetailOptions | JobLogFlag | undefined | null,
): JobLogFlagDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfJobLogFlag(enumOrDetail);
}

const enumDetailNameOfLienWaiverCondition = { UNCONDITIONAL: "Unconditional", CONDITIONAL: "Conditional" };

function enumOrDetailOfLienWaiverCondition(
  enumOrDetail: LienWaiverConditionDetailOptions | LienWaiverCondition | undefined,
): LienWaiverConditionDetail {
  if (enumOrDetail === undefined) {
    return newLienWaiverConditionDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LienWaiverConditionDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLienWaiverCondition[enumOrDetail.code!],
      ...enumOrDetail,
    } as LienWaiverConditionDetail;
  } else {
    return newLienWaiverConditionDetail({
      code: enumOrDetail as LienWaiverCondition,
      name: enumDetailNameOfLienWaiverCondition[enumOrDetail as LienWaiverCondition],
    });
  }
}

function enumOrDetailOrNullOfLienWaiverCondition(
  enumOrDetail: LienWaiverConditionDetailOptions | LienWaiverCondition | undefined | null,
): LienWaiverConditionDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLienWaiverCondition(enumOrDetail);
}

const enumDetailNameOfLienWaiverStatus = {
  DRAFT: "Draft",
  UPLOADED: "Uploaded",
  SENT: "Sent",
  PARTIALLY_SIGNED: "Partially signed",
  SIGNED: "Signed",
  PENDING: "Pending",
};

function enumOrDetailOfLienWaiverStatus(
  enumOrDetail: LienWaiverStatusDetailOptions | LienWaiverStatus | undefined,
): LienWaiverStatusDetail {
  if (enumOrDetail === undefined) {
    return newLienWaiverStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LienWaiverStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLienWaiverStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as LienWaiverStatusDetail;
  } else {
    return newLienWaiverStatusDetail({
      code: enumOrDetail as LienWaiverStatus,
      name: enumDetailNameOfLienWaiverStatus[enumOrDetail as LienWaiverStatus],
    });
  }
}

function enumOrDetailOrNullOfLienWaiverStatus(
  enumOrDetail: LienWaiverStatusDetailOptions | LienWaiverStatus | undefined | null,
): LienWaiverStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLienWaiverStatus(enumOrDetail);
}

const enumDetailNameOfLienWaiverType = { PROGRESS: "Progress", FINAL: "Final" };

function enumOrDetailOfLienWaiverType(
  enumOrDetail: LienWaiverTypeDetailOptions | LienWaiverType | undefined,
): LienWaiverTypeDetail {
  if (enumOrDetail === undefined) {
    return newLienWaiverTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LienWaiverTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLienWaiverType[enumOrDetail.code!],
      ...enumOrDetail,
    } as LienWaiverTypeDetail;
  } else {
    return newLienWaiverTypeDetail({
      code: enumOrDetail as LienWaiverType,
      name: enumDetailNameOfLienWaiverType[enumOrDetail as LienWaiverType],
    });
  }
}

function enumOrDetailOrNullOfLienWaiverType(
  enumOrDetail: LienWaiverTypeDetailOptions | LienWaiverType | undefined | null,
): LienWaiverTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLienWaiverType(enumOrDetail);
}

const enumDetailNameOfLocationType = {
  GROUP: "Group",
  LEVEL: "Level",
  ROOM: "Room",
  FEATURE: "Feature",
  SCOPE: "Scope",
};

function enumOrDetailOfLocationType(
  enumOrDetail: LocationTypeDetailOptions | LocationType | undefined,
): LocationTypeDetail {
  if (enumOrDetail === undefined) {
    return newLocationTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LocationTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLocationType[enumOrDetail.code!],
      ...enumOrDetail,
    } as LocationTypeDetail;
  } else {
    return newLocationTypeDetail({
      code: enumOrDetail as LocationType,
      name: enumDetailNameOfLocationType[enumOrDetail as LocationType],
    });
  }
}

function enumOrDetailOrNullOfLocationType(
  enumOrDetail: LocationTypeDetailOptions | LocationType | undefined | null,
): LocationTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLocationType(enumOrDetail);
}

const enumDetailNameOfMarkupApplicationMethod = { PER_LINE_ITEM: "Per line item", PER_TOTAL_COST: "Per total cost" };

function enumOrDetailOfMarkupApplicationMethod(
  enumOrDetail: MarkupApplicationMethodDetailOptions | MarkupApplicationMethod | undefined,
): MarkupApplicationMethodDetail {
  if (enumOrDetail === undefined) {
    return newMarkupApplicationMethodDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "MarkupApplicationMethodDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfMarkupApplicationMethod[enumOrDetail.code!],
      ...enumOrDetail,
    } as MarkupApplicationMethodDetail;
  } else {
    return newMarkupApplicationMethodDetail({
      code: enumOrDetail as MarkupApplicationMethod,
      name: enumDetailNameOfMarkupApplicationMethod[enumOrDetail as MarkupApplicationMethod],
    });
  }
}

function enumOrDetailOrNullOfMarkupApplicationMethod(
  enumOrDetail: MarkupApplicationMethodDetailOptions | MarkupApplicationMethod | undefined | null,
): MarkupApplicationMethodDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfMarkupApplicationMethod(enumOrDetail);
}

const enumDetailNameOfMaterialAttributeDimensionType = { NUMBER: "Number", SELECT: "Select", BOOLEAN: "Boolean" };

function enumOrDetailOfMaterialAttributeDimensionType(
  enumOrDetail: MaterialAttributeDimensionTypeDetailOptions | MaterialAttributeDimensionType | undefined,
): MaterialAttributeDimensionTypeDetail {
  if (enumOrDetail === undefined) {
    return newMaterialAttributeDimensionTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "MaterialAttributeDimensionTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfMaterialAttributeDimensionType[enumOrDetail.code!],
      ...enumOrDetail,
    } as MaterialAttributeDimensionTypeDetail;
  } else {
    return newMaterialAttributeDimensionTypeDetail({
      code: enumOrDetail as MaterialAttributeDimensionType,
      name: enumDetailNameOfMaterialAttributeDimensionType[enumOrDetail as MaterialAttributeDimensionType],
    });
  }
}

function enumOrDetailOrNullOfMaterialAttributeDimensionType(
  enumOrDetail: MaterialAttributeDimensionTypeDetailOptions | MaterialAttributeDimensionType | undefined | null,
): MaterialAttributeDimensionTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfMaterialAttributeDimensionType(enumOrDetail);
}

const enumDetailNameOfMaterialAttributeValueType = {
  EXACT: "Exact",
  GREATER_THAN: "Greater than",
  LESS_THAN: "Less than",
  BETWEEN: "Between",
};

function enumOrDetailOfMaterialAttributeValueType(
  enumOrDetail: MaterialAttributeValueTypeDetailOptions | MaterialAttributeValueType | undefined,
): MaterialAttributeValueTypeDetail {
  if (enumOrDetail === undefined) {
    return newMaterialAttributeValueTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "MaterialAttributeValueTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfMaterialAttributeValueType[enumOrDetail.code!],
      ...enumOrDetail,
    } as MaterialAttributeValueTypeDetail;
  } else {
    return newMaterialAttributeValueTypeDetail({
      code: enumOrDetail as MaterialAttributeValueType,
      name: enumDetailNameOfMaterialAttributeValueType[enumOrDetail as MaterialAttributeValueType],
    });
  }
}

function enumOrDetailOrNullOfMaterialAttributeValueType(
  enumOrDetail: MaterialAttributeValueTypeDetailOptions | MaterialAttributeValueType | undefined | null,
): MaterialAttributeValueTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfMaterialAttributeValueType(enumOrDetail);
}

const enumDetailNameOfMaterialType = { PLACEHOLDER: "Placeholder", PRODUCT: "Product", CONSTRUCTION: "Construction" };

function enumOrDetailOfMaterialType(
  enumOrDetail: MaterialTypeDetailOptions | MaterialType | undefined,
): MaterialTypeDetail {
  if (enumOrDetail === undefined) {
    return newMaterialTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "MaterialTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfMaterialType[enumOrDetail.code!],
      ...enumOrDetail,
    } as MaterialTypeDetail;
  } else {
    return newMaterialTypeDetail({
      code: enumOrDetail as MaterialType,
      name: enumDetailNameOfMaterialType[enumOrDetail as MaterialType],
    });
  }
}

function enumOrDetailOrNullOfMaterialType(
  enumOrDetail: MaterialTypeDetailOptions | MaterialType | undefined | null,
): MaterialTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfMaterialType(enumOrDetail);
}

const enumDetailNameOfMobileSyncUpdateType = { CREATED: "Created", UPDATED: "Updated", DELETED: "Deleted" };

function enumOrDetailOfMobileSyncUpdateType(
  enumOrDetail: MobileSyncUpdateTypeDetailOptions | MobileSyncUpdateType | undefined,
): MobileSyncUpdateTypeDetail {
  if (enumOrDetail === undefined) {
    return newMobileSyncUpdateTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "MobileSyncUpdateTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfMobileSyncUpdateType[enumOrDetail.code!],
      ...enumOrDetail,
    } as MobileSyncUpdateTypeDetail;
  } else {
    return newMobileSyncUpdateTypeDetail({
      code: enumOrDetail as MobileSyncUpdateType,
      name: enumDetailNameOfMobileSyncUpdateType[enumOrDetail as MobileSyncUpdateType],
    });
  }
}

function enumOrDetailOrNullOfMobileSyncUpdateType(
  enumOrDetail: MobileSyncUpdateTypeDetailOptions | MobileSyncUpdateType | undefined | null,
): MobileSyncUpdateTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfMobileSyncUpdateType(enumOrDetail);
}

const enumDetailNameOfPandaDocRole = {
  USER: "User",
  TRADE_PARTNER: "Trade partner",
  HEAD_OF_CONSTRUCTION: "Head of construction",
  PROJECT_MANAGER: "Project manager",
  HOMEBOUND_AUTHORIZED_SIGNATORY: "Homebound authorized signatory",
  AREA_MANAGER: "Area manager",
  LEAD_ESTIMATOR: "Lead estimator",
  HOMEOWNER: "Homeowner",
  SIGNATORY: "Signatory",
};

function enumOrDetailOfPandaDocRole(
  enumOrDetail: PandaDocRoleDetailOptions | PandaDocRole | undefined,
): PandaDocRoleDetail {
  if (enumOrDetail === undefined) {
    return newPandaDocRoleDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PandaDocRoleDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPandaDocRole[enumOrDetail.code!],
      ...enumOrDetail,
    } as PandaDocRoleDetail;
  } else {
    return newPandaDocRoleDetail({
      code: enumOrDetail as PandaDocRole,
      name: enumDetailNameOfPandaDocRole[enumOrDetail as PandaDocRole],
    });
  }
}

function enumOrDetailOrNullOfPandaDocRole(
  enumOrDetail: PandaDocRoleDetailOptions | PandaDocRole | undefined | null,
): PandaDocRoleDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPandaDocRole(enumOrDetail);
}

const enumDetailNameOfPandaDocStatus = {
  PENDING: "Pending",
  UPLOADED: "Uploaded",
  SENT: "Sent",
  VIEWED: "Viewed",
  WAITING_APPROVAL: "Waiting approval",
  REJECTED: "Rejected",
  APPROVED: "Approved",
  WAITING_PAY: "Waiting pay",
  PAID: "Paid",
  COMPLETED: "Completed",
  VOIDED: "Voided",
  DECLINED: "Declined",
  AWAITING_DELETE: "Awaiting delete",
  UPLOAD_FAILED: "Upload failed",
  PARTIALLY_SIGNED: "Partially signed",
  DRAFT: "Draft",
};

function enumOrDetailOfPandaDocStatus(
  enumOrDetail: PandaDocStatusDetailOptions | PandaDocStatus | undefined,
): PandaDocStatusDetail {
  if (enumOrDetail === undefined) {
    return newPandaDocStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PandaDocStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPandaDocStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as PandaDocStatusDetail;
  } else {
    return newPandaDocStatusDetail({
      code: enumOrDetail as PandaDocStatus,
      name: enumDetailNameOfPandaDocStatus[enumOrDetail as PandaDocStatus],
    });
  }
}

function enumOrDetailOrNullOfPandaDocStatus(
  enumOrDetail: PandaDocStatusDetailOptions | PandaDocStatus | undefined | null,
): PandaDocStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPandaDocStatus(enumOrDetail);
}

const enumDetailNameOfPandaDocWorkspace = {
  HOMEBOUND: "Homebound",
  HOMEBOUND_FINANCE: "Homebound finance",
  HOMEBOUND_CALIFORNIA: "Homebound california",
};

function enumOrDetailOfPandaDocWorkspace(
  enumOrDetail: PandaDocWorkspaceDetailOptions | PandaDocWorkspace | undefined,
): PandaDocWorkspaceDetail {
  if (enumOrDetail === undefined) {
    return newPandaDocWorkspaceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PandaDocWorkspaceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPandaDocWorkspace[enumOrDetail.code!],
      ...enumOrDetail,
    } as PandaDocWorkspaceDetail;
  } else {
    return newPandaDocWorkspaceDetail({
      code: enumOrDetail as PandaDocWorkspace,
      name: enumDetailNameOfPandaDocWorkspace[enumOrDetail as PandaDocWorkspace],
    });
  }
}

function enumOrDetailOrNullOfPandaDocWorkspace(
  enumOrDetail: PandaDocWorkspaceDetailOptions | PandaDocWorkspace | undefined | null,
): PandaDocWorkspaceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPandaDocWorkspace(enumOrDetail);
}

const enumDetailNameOfPaymentTermDueFrom = {
  FROM_INVOICE_BILL_DATE: "From invoice bill date",
  OF_THE_MONTH_OF_INVOICE_BILL_DATE: "Of the month of invoice bill date",
  OF_NEXT_MONTH_FROM_INVOICE_BILL_DATE: "Of next month from invoice bill date",
  OF_2ND_MONTH_FROM_INVOICE_BILL_DATE: "Of 2 nd month from invoice bill date",
  OF_3RD_MONTH_FROM_INVOICE_BILL_DATE: "Of 3 rd month from invoice bill date",
  OF_4TH_MONTH_FROM_INVOICE_BILL_DATE: "Of 4 th month from invoice bill date",
  OF_5TH_MONTH_FROM_INVOICE_BILL_DATE: "Of 5 th month from invoice bill date",
  OF_6TH_MONTH_FROM_INVOICE_BILL_DATE: "Of 6 th month from invoice bill date",
};

function enumOrDetailOfPaymentTermDueFrom(
  enumOrDetail: PaymentTermDueFromDetailOptions | PaymentTermDueFrom | undefined,
): PaymentTermDueFromDetail {
  if (enumOrDetail === undefined) {
    return newPaymentTermDueFromDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PaymentTermDueFromDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPaymentTermDueFrom[enumOrDetail.code!],
      ...enumOrDetail,
    } as PaymentTermDueFromDetail;
  } else {
    return newPaymentTermDueFromDetail({
      code: enumOrDetail as PaymentTermDueFrom,
      name: enumDetailNameOfPaymentTermDueFrom[enumOrDetail as PaymentTermDueFrom],
    });
  }
}

function enumOrDetailOrNullOfPaymentTermDueFrom(
  enumOrDetail: PaymentTermDueFromDetailOptions | PaymentTermDueFrom | undefined | null,
): PaymentTermDueFromDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPaymentTermDueFrom(enumOrDetail);
}

const enumDetailNameOfPermit = {
  ZONING: "Zoning",
  STRUCTURAL: "Structural",
  ELECTRICAL: "Electrical",
  PLUMBING: "Plumbing",
  HVAC: "Hvac",
};

function enumOrDetailOfPermit(enumOrDetail: PermitDetailOptions | Permit | undefined): PermitDetail {
  if (enumOrDetail === undefined) {
    return newPermitDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PermitDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPermit[enumOrDetail.code!],
      ...enumOrDetail,
    } as PermitDetail;
  } else {
    return newPermitDetail({ code: enumOrDetail as Permit, name: enumDetailNameOfPermit[enumOrDetail as Permit] });
  }
}

function enumOrDetailOrNullOfPermit(
  enumOrDetail: PermitDetailOptions | Permit | undefined | null,
): PermitDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPermit(enumOrDetail);
}

const enumDetailNameOfPlanPackageIncomingSlotStatus = {
  PENDING: "Pending",
  REJECTED: "Rejected",
  FULFILLED: "Fulfilled",
};

function enumOrDetailOfPlanPackageIncomingSlotStatus(
  enumOrDetail: PlanPackageIncomingSlotStatusDetailOptions | PlanPackageIncomingSlotStatus | undefined,
): PlanPackageIncomingSlotStatusDetail {
  if (enumOrDetail === undefined) {
    return newPlanPackageIncomingSlotStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PlanPackageIncomingSlotStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPlanPackageIncomingSlotStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as PlanPackageIncomingSlotStatusDetail;
  } else {
    return newPlanPackageIncomingSlotStatusDetail({
      code: enumOrDetail as PlanPackageIncomingSlotStatus,
      name: enumDetailNameOfPlanPackageIncomingSlotStatus[enumOrDetail as PlanPackageIncomingSlotStatus],
    });
  }
}

function enumOrDetailOrNullOfPlanPackageIncomingSlotStatus(
  enumOrDetail: PlanPackageIncomingSlotStatusDetailOptions | PlanPackageIncomingSlotStatus | undefined | null,
): PlanPackageIncomingSlotStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPlanPackageIncomingSlotStatus(enumOrDetail);
}

const enumDetailNameOfProgramDataBasementConfig = {
  NO: "No",
  PARTIAL_UNFINISHED: "Partial unfinished",
  FULL_FINISHED: "Full finished",
  FULL_UNFINISHED: "Full unfinished",
  WALKOUT_UNFINISHED: "Walkout unfinished",
  WALKOUT_FINISHED: "Walkout finished",
  GARDEN_LEVEL_UNFINISHED: "Garden level unfinished",
  GARDEN_LEVEL_FINISHED: "Garden level finished",
};

function enumOrDetailOfProgramDataBasementConfig(
  enumOrDetail: ProgramDataBasementConfigDetailOptions | ProgramDataBasementConfig | undefined,
): ProgramDataBasementConfigDetail {
  if (enumOrDetail === undefined) {
    return newProgramDataBasementConfigDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProgramDataBasementConfigDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProgramDataBasementConfig[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProgramDataBasementConfigDetail;
  } else {
    return newProgramDataBasementConfigDetail({
      code: enumOrDetail as ProgramDataBasementConfig,
      name: enumDetailNameOfProgramDataBasementConfig[enumOrDetail as ProgramDataBasementConfig],
    });
  }
}

function enumOrDetailOrNullOfProgramDataBasementConfig(
  enumOrDetail: ProgramDataBasementConfigDetailOptions | ProgramDataBasementConfig | undefined | null,
): ProgramDataBasementConfigDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProgramDataBasementConfig(enumOrDetail);
}

const enumDetailNameOfProgramDataGarageConfig = {
  FRONT_LOAD: "Front load",
  ALLEY_LOAD: "Alley load",
  SIDE_LOAD: "Side load",
  SPLIT_LOAD: "Split load",
};

function enumOrDetailOfProgramDataGarageConfig(
  enumOrDetail: ProgramDataGarageConfigDetailOptions | ProgramDataGarageConfig | undefined,
): ProgramDataGarageConfigDetail {
  if (enumOrDetail === undefined) {
    return newProgramDataGarageConfigDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProgramDataGarageConfigDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProgramDataGarageConfig[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProgramDataGarageConfigDetail;
  } else {
    return newProgramDataGarageConfigDetail({
      code: enumOrDetail as ProgramDataGarageConfig,
      name: enumDetailNameOfProgramDataGarageConfig[enumOrDetail as ProgramDataGarageConfig],
    });
  }
}

function enumOrDetailOrNullOfProgramDataGarageConfig(
  enumOrDetail: ProgramDataGarageConfigDetailOptions | ProgramDataGarageConfig | undefined | null,
): ProgramDataGarageConfigDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProgramDataGarageConfig(enumOrDetail);
}

const enumDetailNameOfProgramDataMatchState = {
  MATCHES: "Matches",
  DEVIATION_PENDING_REVIEW: "Deviation pending review",
  DEVIATION_ACKNOWLEDGED: "Deviation acknowledged",
};

function enumOrDetailOfProgramDataMatchState(
  enumOrDetail: ProgramDataMatchStateDetailOptions | ProgramDataMatchState | undefined,
): ProgramDataMatchStateDetail {
  if (enumOrDetail === undefined) {
    return newProgramDataMatchStateDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProgramDataMatchStateDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProgramDataMatchState[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProgramDataMatchStateDetail;
  } else {
    return newProgramDataMatchStateDetail({
      code: enumOrDetail as ProgramDataMatchState,
      name: enumDetailNameOfProgramDataMatchState[enumOrDetail as ProgramDataMatchState],
    });
  }
}

function enumOrDetailOrNullOfProgramDataMatchState(
  enumOrDetail: ProgramDataMatchStateDetailOptions | ProgramDataMatchState | undefined | null,
): ProgramDataMatchStateDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProgramDataMatchState(enumOrDetail);
}

const enumDetailNameOfProgramDataPrimaryBedroomConfig = { UP: "Up", DOWN: "Down" };

function enumOrDetailOfProgramDataPrimaryBedroomConfig(
  enumOrDetail: ProgramDataPrimaryBedroomConfigDetailOptions | ProgramDataPrimaryBedroomConfig | undefined,
): ProgramDataPrimaryBedroomConfigDetail {
  if (enumOrDetail === undefined) {
    return newProgramDataPrimaryBedroomConfigDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProgramDataPrimaryBedroomConfigDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProgramDataPrimaryBedroomConfig[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProgramDataPrimaryBedroomConfigDetail;
  } else {
    return newProgramDataPrimaryBedroomConfigDetail({
      code: enumOrDetail as ProgramDataPrimaryBedroomConfig,
      name: enumDetailNameOfProgramDataPrimaryBedroomConfig[enumOrDetail as ProgramDataPrimaryBedroomConfig],
    });
  }
}

function enumOrDetailOrNullOfProgramDataPrimaryBedroomConfig(
  enumOrDetail: ProgramDataPrimaryBedroomConfigDetailOptions | ProgramDataPrimaryBedroomConfig | undefined | null,
): ProgramDataPrimaryBedroomConfigDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProgramDataPrimaryBedroomConfig(enumOrDetail);
}

const enumDetailNameOfProgramDataWindowColor = { WHITE: "White", BLACK: "Black" };

function enumOrDetailOfProgramDataWindowColor(
  enumOrDetail: ProgramDataWindowColorDetailOptions | ProgramDataWindowColor | undefined,
): ProgramDataWindowColorDetail {
  if (enumOrDetail === undefined) {
    return newProgramDataWindowColorDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProgramDataWindowColorDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProgramDataWindowColor[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProgramDataWindowColorDetail;
  } else {
    return newProgramDataWindowColorDetail({
      code: enumOrDetail as ProgramDataWindowColor,
      name: enumDetailNameOfProgramDataWindowColor[enumOrDetail as ProgramDataWindowColor],
    });
  }
}

function enumOrDetailOrNullOfProgramDataWindowColor(
  enumOrDetail: ProgramDataWindowColorDetailOptions | ProgramDataWindowColor | undefined | null,
): ProgramDataWindowColorDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProgramDataWindowColor(enumOrDetail);
}

const enumDetailNameOfProjectCollaboratorRole = {
  HOMEOWNER: "Homeowner",
  FAMILY: "Family",
  DESIGNER: "Designer",
  LEGAL: "Legal",
  OTHER: "Other",
};

function enumOrDetailOfProjectCollaboratorRole(
  enumOrDetail: ProjectCollaboratorRoleDetailOptions | ProjectCollaboratorRole | undefined,
): ProjectCollaboratorRoleDetail {
  if (enumOrDetail === undefined) {
    return newProjectCollaboratorRoleDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectCollaboratorRoleDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectCollaboratorRole[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectCollaboratorRoleDetail;
  } else {
    return newProjectCollaboratorRoleDetail({
      code: enumOrDetail as ProjectCollaboratorRole,
      name: enumDetailNameOfProjectCollaboratorRole[enumOrDetail as ProjectCollaboratorRole],
    });
  }
}

function enumOrDetailOrNullOfProjectCollaboratorRole(
  enumOrDetail: ProjectCollaboratorRoleDetailOptions | ProjectCollaboratorRole | undefined | null,
): ProjectCollaboratorRoleDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectCollaboratorRole(enumOrDetail);
}

const enumDetailNameOfProjectFeature = {
  SELECTIONS_V1: "Selections v1",
  HOP_HIDE_FINANCIALS: "Hop hide financials",
  HOP_VIZ_WALKTHROUGH: "Hop viz walkthrough",
  BP_PROJECT_SETTINGS: "Bp project settings",
  HIDE_ALL_HOP_PRICING: "Hide all hop pricing",
  HOP_PRICING_MSRP_NO_HB: "Hop pricing msrp no hb",
  HOP_PRICING_HB_NO_MSRP: "Hop pricing hb no msrp",
  HOP_SELECTIONS_INCLUDED_UPGRADE_PRICING: "Hop selections included upgrade pricing",
  SCHEDULES_V2: "Schedules v2",
  SCHEDULES_V2_GANTT: "Schedules v2 gantt",
  SCHEDULES_CALENDAR: "Schedules calendar",
  HOP_HIDE_PRECON_FINANCIALS: "Hop hide precon financials",
  DELAY_FLAGS: "Delay flags",
  HOMEOWNER_NOTES: "Homeowner notes",
  HOMEOWNER_JOURNEY_V2: "Homeowner journey v2",
  PRODUCT_CONFIG_PLAN: "Product config plan",
  CHANGE_EVENT_SIGNATURES: "Change event signatures",
};

function enumOrDetailOfProjectFeature(
  enumOrDetail: ProjectFeatureDetailOptions | ProjectFeature | undefined,
): ProjectFeatureDetail {
  if (enumOrDetail === undefined) {
    return newProjectFeatureDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectFeatureDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectFeature[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectFeatureDetail;
  } else {
    return newProjectFeatureDetail({
      code: enumOrDetail as ProjectFeature,
      name: enumDetailNameOfProjectFeature[enumOrDetail as ProjectFeature],
    });
  }
}

function enumOrDetailOrNullOfProjectFeature(
  enumOrDetail: ProjectFeatureDetailOptions | ProjectFeature | undefined | null,
): ProjectFeatureDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectFeature(enumOrDetail);
}

const enumDetailNameOfProjectUpdateActionType = {
  ACTIVITY_COMPLETE: "Activity complete",
  UNIT_COMPLETE: "Unit complete",
  DOCUMENT_AVAILABLE: "Document available",
  NEW_HOMEOWNER_NOTE: "New homeowner note",
};

function enumOrDetailOfProjectUpdateActionType(
  enumOrDetail: ProjectUpdateActionTypeDetailOptions | ProjectUpdateActionType | undefined,
): ProjectUpdateActionTypeDetail {
  if (enumOrDetail === undefined) {
    return newProjectUpdateActionTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectUpdateActionTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectUpdateActionType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectUpdateActionTypeDetail;
  } else {
    return newProjectUpdateActionTypeDetail({
      code: enumOrDetail as ProjectUpdateActionType,
      name: enumDetailNameOfProjectUpdateActionType[enumOrDetail as ProjectUpdateActionType],
    });
  }
}

function enumOrDetailOrNullOfProjectUpdateActionType(
  enumOrDetail: ProjectUpdateActionTypeDetailOptions | ProjectUpdateActionType | undefined | null,
): ProjectUpdateActionTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectUpdateActionType(enumOrDetail);
}

const enumDetailNameOfPushNotificationEnvironment = { SANDBOX: "Sandbox", PRODUCTION: "Production" };

function enumOrDetailOfPushNotificationEnvironment(
  enumOrDetail: PushNotificationEnvironmentDetailOptions | PushNotificationEnvironment | undefined,
): PushNotificationEnvironmentDetail {
  if (enumOrDetail === undefined) {
    return newPushNotificationEnvironmentDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PushNotificationEnvironmentDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPushNotificationEnvironment[enumOrDetail.code!],
      ...enumOrDetail,
    } as PushNotificationEnvironmentDetail;
  } else {
    return newPushNotificationEnvironmentDetail({
      code: enumOrDetail as PushNotificationEnvironment,
      name: enumDetailNameOfPushNotificationEnvironment[enumOrDetail as PushNotificationEnvironment],
    });
  }
}

function enumOrDetailOrNullOfPushNotificationEnvironment(
  enumOrDetail: PushNotificationEnvironmentDetailOptions | PushNotificationEnvironment | undefined | null,
): PushNotificationEnvironmentDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPushNotificationEnvironment(enumOrDetail);
}

const enumDetailNameOfPushNotificationPlatform = { IOS: "Ios", ANDROID: "Android", WEB: "Web" };

function enumOrDetailOfPushNotificationPlatform(
  enumOrDetail: PushNotificationPlatformDetailOptions | PushNotificationPlatform | undefined,
): PushNotificationPlatformDetail {
  if (enumOrDetail === undefined) {
    return newPushNotificationPlatformDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PushNotificationPlatformDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPushNotificationPlatform[enumOrDetail.code!],
      ...enumOrDetail,
    } as PushNotificationPlatformDetail;
  } else {
    return newPushNotificationPlatformDetail({
      code: enumOrDetail as PushNotificationPlatform,
      name: enumDetailNameOfPushNotificationPlatform[enumOrDetail as PushNotificationPlatform],
    });
  }
}

function enumOrDetailOrNullOfPushNotificationPlatform(
  enumOrDetail: PushNotificationPlatformDetailOptions | PushNotificationPlatform | undefined | null,
): PushNotificationPlatformDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPushNotificationPlatform(enumOrDetail);
}

const enumDetailNameOfReadyPlanAssetType = {
  COVER_PHOTO: "Cover photo",
  PREVIEW: "Preview",
  FLOOR_PLAN: "Floor plan",
  MOOD_BOARD: "Mood board",
  GROUND_BASEMENT_FLOOR_PLAN: "Ground basement floor plan",
  FIRST_FLOOR_PLAN: "First floor plan",
  SECOND_FLOOR_PLAN: "Second floor plan",
  ADU_FIRST_FLOOR_PLAN: "Adu first floor plan",
  ADU_SECOND_FLOOR_PLAN: "Adu second floor plan",
  ADU_EXTERIOR: "Adu exterior",
  ADU_KITCHEN: "Adu kitchen",
  ADU_LIVING: "Adu living",
  ADU_BATHROOM: "Adu bathroom",
  ADU_BEDROOM: "Adu bedroom",
};

function enumOrDetailOfReadyPlanAssetType(
  enumOrDetail: ReadyPlanAssetTypeDetailOptions | ReadyPlanAssetType | undefined,
): ReadyPlanAssetTypeDetail {
  if (enumOrDetail === undefined) {
    return newReadyPlanAssetTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ReadyPlanAssetTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfReadyPlanAssetType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ReadyPlanAssetTypeDetail;
  } else {
    return newReadyPlanAssetTypeDetail({
      code: enumOrDetail as ReadyPlanAssetType,
      name: enumDetailNameOfReadyPlanAssetType[enumOrDetail as ReadyPlanAssetType],
    });
  }
}

function enumOrDetailOrNullOfReadyPlanAssetType(
  enumOrDetail: ReadyPlanAssetTypeDetailOptions | ReadyPlanAssetType | undefined | null,
): ReadyPlanAssetTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfReadyPlanAssetType(enumOrDetail);
}

const enumDetailNameOfReadyPlanOptionGroupPersonalizationType = {
  SINGLE_PRODUCT: "Single product",
  LINKED_PRODUCT: "Linked product",
  PACKAGE: "Package",
};

function enumOrDetailOfReadyPlanOptionGroupPersonalizationType(
  enumOrDetail:
    | ReadyPlanOptionGroupPersonalizationTypeDetailOptions
    | ReadyPlanOptionGroupPersonalizationType
    | undefined,
): ReadyPlanOptionGroupPersonalizationTypeDetail {
  if (enumOrDetail === undefined) {
    return newReadyPlanOptionGroupPersonalizationTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ReadyPlanOptionGroupPersonalizationTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfReadyPlanOptionGroupPersonalizationType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ReadyPlanOptionGroupPersonalizationTypeDetail;
  } else {
    return newReadyPlanOptionGroupPersonalizationTypeDetail({
      code: enumOrDetail as ReadyPlanOptionGroupPersonalizationType,
      name:
        enumDetailNameOfReadyPlanOptionGroupPersonalizationType[
          enumOrDetail as ReadyPlanOptionGroupPersonalizationType
        ],
    });
  }
}

function enumOrDetailOrNullOfReadyPlanOptionGroupPersonalizationType(
  enumOrDetail:
    | ReadyPlanOptionGroupPersonalizationTypeDetailOptions
    | ReadyPlanOptionGroupPersonalizationType
    | undefined
    | null,
): ReadyPlanOptionGroupPersonalizationTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfReadyPlanOptionGroupPersonalizationType(enumOrDetail);
}

const enumDetailNameOfScheduleFlagReasonType = {
  CLIENT: "Client",
  INTERNAL: "Internal",
  EXTERNAL: "External",
  PERMITTING: "Permitting",
  FIELD: "Field",
  INSPECTION: "Inspection",
  MATERIAL_SUPPLY: "Material supply",
  OTHER: "Other",
  TRADE_PARTNER: "Trade partner",
  WEATHER: "Weather",
};

function enumOrDetailOfScheduleFlagReasonType(
  enumOrDetail: ScheduleFlagReasonTypeDetailOptions | ScheduleFlagReasonType | undefined,
): ScheduleFlagReasonTypeDetail {
  if (enumOrDetail === undefined) {
    return newScheduleFlagReasonTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ScheduleFlagReasonTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfScheduleFlagReasonType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ScheduleFlagReasonTypeDetail;
  } else {
    return newScheduleFlagReasonTypeDetail({
      code: enumOrDetail as ScheduleFlagReasonType,
      name: enumDetailNameOfScheduleFlagReasonType[enumOrDetail as ScheduleFlagReasonType],
    });
  }
}

function enumOrDetailOrNullOfScheduleFlagReasonType(
  enumOrDetail: ScheduleFlagReasonTypeDetailOptions | ScheduleFlagReasonType | undefined | null,
): ScheduleFlagReasonTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfScheduleFlagReasonType(enumOrDetail);
}

const enumDetailNameOfScheduleStatus = { ACTIVE: "Active", COMPLETED: "Completed", DRAFT: "Draft" };

function enumOrDetailOfScheduleStatus(
  enumOrDetail: ScheduleStatusDetailOptions | ScheduleStatus | undefined,
): ScheduleStatusDetail {
  if (enumOrDetail === undefined) {
    return newScheduleStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ScheduleStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfScheduleStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ScheduleStatusDetail;
  } else {
    return newScheduleStatusDetail({
      code: enumOrDetail as ScheduleStatus,
      name: enumDetailNameOfScheduleStatus[enumOrDetail as ScheduleStatus],
    });
  }
}

function enumOrDetailOrNullOfScheduleStatus(
  enumOrDetail: ScheduleStatusDetailOptions | ScheduleStatus | undefined | null,
): ScheduleStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfScheduleStatus(enumOrDetail);
}

const enumDetailNameOfScheduleTemplateStatus = { DRAFT: "Draft", PUBLISHED: "Published", ARCHIVED: "Archived" };

function enumOrDetailOfScheduleTemplateStatus(
  enumOrDetail: ScheduleTemplateStatusDetailOptions | ScheduleTemplateStatus | undefined,
): ScheduleTemplateStatusDetail {
  if (enumOrDetail === undefined) {
    return newScheduleTemplateStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ScheduleTemplateStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfScheduleTemplateStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ScheduleTemplateStatusDetail;
  } else {
    return newScheduleTemplateStatusDetail({
      code: enumOrDetail as ScheduleTemplateStatus,
      name: enumDetailNameOfScheduleTemplateStatus[enumOrDetail as ScheduleTemplateStatus],
    });
  }
}

function enumOrDetailOrNullOfScheduleTemplateStatus(
  enumOrDetail: ScheduleTemplateStatusDetailOptions | ScheduleTemplateStatus | undefined | null,
): ScheduleTemplateStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfScheduleTemplateStatus(enumOrDetail);
}

const enumDetailNameOfSystemPlanMilestone = {
  MOBILIZATION_START: "Mobilization start",
  VERTICAL_COMPLETE: "Vertical complete",
  PRE_MOBILIZATION_COMPLETE: "Pre mobilization complete",
  CUSTOMER_CONTRACT_SIGNED: "Customer contract signed",
  BUILDING_PERMIT_ISSUED: "Building permit issued",
  FINAL_PUNCH_OUT: "Final punch out",
  MOBILIZATION_COMPLETE: "Mobilization complete",
  DELIVERY_COMPLETE: "Delivery complete",
  BUILDING_PERMIT_SUBMITTED: "Building permit submitted",
  FRAMING_COMPLETE: "Framing complete",
  DRYWALL_COMPLETE: "Drywall complete",
  SALES_READY: "Sales ready",
  BUYER_WALKTHROUGH: "Buyer walkthrough",
  PRECON_READY_TO_START: "Precon ready to start",
};

function enumOrDetailOfSystemPlanMilestone(
  enumOrDetail: SystemPlanMilestoneDetailOptions | SystemPlanMilestone | undefined,
): SystemPlanMilestoneDetail {
  if (enumOrDetail === undefined) {
    return newSystemPlanMilestoneDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "SystemPlanMilestoneDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfSystemPlanMilestone[enumOrDetail.code!],
      ...enumOrDetail,
    } as SystemPlanMilestoneDetail;
  } else {
    return newSystemPlanMilestoneDetail({
      code: enumOrDetail as SystemPlanMilestone,
      name: enumDetailNameOfSystemPlanMilestone[enumOrDetail as SystemPlanMilestone],
    });
  }
}

function enumOrDetailOrNullOfSystemPlanMilestone(
  enumOrDetail: SystemPlanMilestoneDetailOptions | SystemPlanMilestone | undefined | null,
): SystemPlanMilestoneDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfSystemPlanMilestone(enumOrDetail);
}

const enumDetailNameOfSystemTask = {
  CONSTRUCTION_RTS: "Construction rts",
  FRAMING_COMPLETE: "Framing complete",
  DRYWALL_COMPLETE: "Drywall complete",
  DELIVERY_COMPLETE: "Delivery complete",
  VERTICAL_COMPLETE: "Vertical complete",
  ACQUIRED: "Acquired",
  PERMIT_SUBMITTED: "Permit submitted",
  PERMIT_RECEIVED: "Permit received",
  MLS_DATE: "Mls date",
  SALES_READY: "Sales ready",
  BUYER_WALKTHROUGH: "Buyer walkthrough",
  PUNCH_LIST: "Punch list",
  BUILDING_FINAL_INSPECTION: "Building final inspection",
};

function enumOrDetailOfSystemTask(enumOrDetail: SystemTaskDetailOptions | SystemTask | undefined): SystemTaskDetail {
  if (enumOrDetail === undefined) {
    return newSystemTaskDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "SystemTaskDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfSystemTask[enumOrDetail.code!],
      ...enumOrDetail,
    } as SystemTaskDetail;
  } else {
    return newSystemTaskDetail({
      code: enumOrDetail as SystemTask,
      name: enumDetailNameOfSystemTask[enumOrDetail as SystemTask],
    });
  }
}

function enumOrDetailOrNullOfSystemTask(
  enumOrDetail: SystemTaskDetailOptions | SystemTask | undefined | null,
): SystemTaskDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfSystemTask(enumOrDetail);
}

const enumDetailNameOfTakeoffLineItemAction = { ADD: "Add", REMOVE: "Remove" };

function enumOrDetailOfTakeoffLineItemAction(
  enumOrDetail: TakeoffLineItemActionDetailOptions | TakeoffLineItemAction | undefined,
): TakeoffLineItemActionDetail {
  if (enumOrDetail === undefined) {
    return newTakeoffLineItemActionDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TakeoffLineItemActionDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTakeoffLineItemAction[enumOrDetail.code!],
      ...enumOrDetail,
    } as TakeoffLineItemActionDetail;
  } else {
    return newTakeoffLineItemActionDetail({
      code: enumOrDetail as TakeoffLineItemAction,
      name: enumDetailNameOfTakeoffLineItemAction[enumOrDetail as TakeoffLineItemAction],
    });
  }
}

function enumOrDetailOrNullOfTakeoffLineItemAction(
  enumOrDetail: TakeoffLineItemActionDetailOptions | TakeoffLineItemAction | undefined | null,
): TakeoffLineItemActionDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTakeoffLineItemAction(enumOrDetail);
}

const enumDetailNameOfTakeoffLineItemDesignPackageType = {
  REGULAR_PLACEHOLDER: "Regular placeholder",
  REGULAR_PRODUCT_CARD: "Regular product card",
  IDP_SHADOW_PLACEHOLDER: "Idp shadow placeholder",
  IDP_SHADOW_PRODUCT_CARD: "Idp shadow product card",
  RPO_SHADOW_PLACEHOLDER: "Rpo shadow placeholder",
  RPO_SHADOW_PRODUCT_CARD: "Rpo shadow product card",
};

function enumOrDetailOfTakeoffLineItemDesignPackageType(
  enumOrDetail: TakeoffLineItemDesignPackageTypeDetailOptions | TakeoffLineItemDesignPackageType | undefined,
): TakeoffLineItemDesignPackageTypeDetail {
  if (enumOrDetail === undefined) {
    return newTakeoffLineItemDesignPackageTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TakeoffLineItemDesignPackageTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTakeoffLineItemDesignPackageType[enumOrDetail.code!],
      ...enumOrDetail,
    } as TakeoffLineItemDesignPackageTypeDetail;
  } else {
    return newTakeoffLineItemDesignPackageTypeDetail({
      code: enumOrDetail as TakeoffLineItemDesignPackageType,
      name: enumDetailNameOfTakeoffLineItemDesignPackageType[enumOrDetail as TakeoffLineItemDesignPackageType],
    });
  }
}

function enumOrDetailOrNullOfTakeoffLineItemDesignPackageType(
  enumOrDetail: TakeoffLineItemDesignPackageTypeDetailOptions | TakeoffLineItemDesignPackageType | undefined | null,
): TakeoffLineItemDesignPackageTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTakeoffLineItemDesignPackageType(enumOrDetail);
}

const enumDetailNameOfTakeoffLineItemType = { ITI: "Iti", TLIV: "Tliv" };

function enumOrDetailOfTakeoffLineItemType(
  enumOrDetail: TakeoffLineItemTypeDetailOptions | TakeoffLineItemType | undefined,
): TakeoffLineItemTypeDetail {
  if (enumOrDetail === undefined) {
    return newTakeoffLineItemTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TakeoffLineItemTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTakeoffLineItemType[enumOrDetail.code!],
      ...enumOrDetail,
    } as TakeoffLineItemTypeDetail;
  } else {
    return newTakeoffLineItemTypeDetail({
      code: enumOrDetail as TakeoffLineItemType,
      name: enumDetailNameOfTakeoffLineItemType[enumOrDetail as TakeoffLineItemType],
    });
  }
}

function enumOrDetailOrNullOfTakeoffLineItemType(
  enumOrDetail: TakeoffLineItemTypeDetailOptions | TakeoffLineItemType | undefined | null,
): TakeoffLineItemTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTakeoffLineItemType(enumOrDetail);
}

const enumDetailNameOfTaskDependencyType = {
  FINISH_START: "Finish start",
  START_START: "Start start",
  START_FINISH: "Start finish",
  FINISH_FINISH: "Finish finish",
};

function enumOrDetailOfTaskDependencyType(
  enumOrDetail: TaskDependencyTypeDetailOptions | TaskDependencyType | undefined,
): TaskDependencyTypeDetail {
  if (enumOrDetail === undefined) {
    return newTaskDependencyTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TaskDependencyTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTaskDependencyType[enumOrDetail.code!],
      ...enumOrDetail,
    } as TaskDependencyTypeDetail;
  } else {
    return newTaskDependencyTypeDetail({
      code: enumOrDetail as TaskDependencyType,
      name: enumDetailNameOfTaskDependencyType[enumOrDetail as TaskDependencyType],
    });
  }
}

function enumOrDetailOrNullOfTaskDependencyType(
  enumOrDetail: TaskDependencyTypeDetailOptions | TaskDependencyType | undefined | null,
): TaskDependencyTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTaskDependencyType(enumOrDetail);
}

const enumDetailNameOfTimeFrequency = { DAYS: "Days", WEEKS: "Weeks", MONTHS: "Months" };

function enumOrDetailOfTimeFrequency(
  enumOrDetail: TimeFrequencyDetailOptions | TimeFrequency | undefined,
): TimeFrequencyDetail {
  if (enumOrDetail === undefined) {
    return newTimeFrequencyDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TimeFrequencyDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTimeFrequency[enumOrDetail.code!],
      ...enumOrDetail,
    } as TimeFrequencyDetail;
  } else {
    return newTimeFrequencyDetail({
      code: enumOrDetail as TimeFrequency,
      name: enumDetailNameOfTimeFrequency[enumOrDetail as TimeFrequency],
    });
  }
}

function enumOrDetailOrNullOfTimeFrequency(
  enumOrDetail: TimeFrequencyDetailOptions | TimeFrequency | undefined | null,
): TimeFrequencyDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTimeFrequency(enumOrDetail);
}

const enumDetailNameOfTimeOfDay = { MORNING: "Morning", AFTERNOON: "Afternoon", EVENING: "Evening" };

function enumOrDetailOfTimeOfDay(enumOrDetail: TimeOfDayDetailOptions | TimeOfDay | undefined): TimeOfDayDetail {
  if (enumOrDetail === undefined) {
    return newTimeOfDayDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TimeOfDayDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTimeOfDay[enumOrDetail.code!],
      ...enumOrDetail,
    } as TimeOfDayDetail;
  } else {
    return newTimeOfDayDetail({
      code: enumOrDetail as TimeOfDay,
      name: enumDetailNameOfTimeOfDay[enumOrDetail as TimeOfDay],
    });
  }
}

function enumOrDetailOrNullOfTimeOfDay(
  enumOrDetail: TimeOfDayDetailOptions | TimeOfDay | undefined | null,
): TimeOfDayDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTimeOfDay(enumOrDetail);
}

const enumDetailNameOfTrackedJobStatus = {
  PENDING: "Pending",
  RUNNING: "Running",
  COMPLETED: "Completed",
  FAILED: "Failed",
};

function enumOrDetailOfTrackedJobStatus(
  enumOrDetail: TrackedJobStatusDetailOptions | TrackedJobStatus | undefined,
): TrackedJobStatusDetail {
  if (enumOrDetail === undefined) {
    return newTrackedJobStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TrackedJobStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTrackedJobStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as TrackedJobStatusDetail;
  } else {
    return newTrackedJobStatusDetail({
      code: enumOrDetail as TrackedJobStatus,
      name: enumDetailNameOfTrackedJobStatus[enumOrDetail as TrackedJobStatus],
    });
  }
}

function enumOrDetailOrNullOfTrackedJobStatus(
  enumOrDetail: TrackedJobStatusDetailOptions | TrackedJobStatus | undefined | null,
): TrackedJobStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTrackedJobStatus(enumOrDetail);
}

const enumDetailNameOfTradePartnerMarketRole = {
  BILL_APPROVER: "Bill approver",
  CONTRACT_SIGNATORY: "Contract signatory",
  PO_SIGNATORY: "Po signatory",
  PO_RECIPIENT_1: "Po recipient 1",
  PO_RECIPIENT_2: "Po recipient 2",
  ESTIMATING: "Estimating",
  SCHEDULING: "Scheduling",
  LW_SIGNATORY: "Lw signatory",
  SCHEDULING_RECIPIENT_2: "Scheduling recipient 2",
};

function enumOrDetailOfTradePartnerMarketRole(
  enumOrDetail: TradePartnerMarketRoleDetailOptions | TradePartnerMarketRole | undefined,
): TradePartnerMarketRoleDetail {
  if (enumOrDetail === undefined) {
    return newTradePartnerMarketRoleDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TradePartnerMarketRoleDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTradePartnerMarketRole[enumOrDetail.code!],
      ...enumOrDetail,
    } as TradePartnerMarketRoleDetail;
  } else {
    return newTradePartnerMarketRoleDetail({
      code: enumOrDetail as TradePartnerMarketRole,
      name: enumDetailNameOfTradePartnerMarketRole[enumOrDetail as TradePartnerMarketRole],
    });
  }
}

function enumOrDetailOrNullOfTradePartnerMarketRole(
  enumOrDetail: TradePartnerMarketRoleDetailOptions | TradePartnerMarketRole | undefined | null,
): TradePartnerMarketRoleDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTradePartnerMarketRole(enumOrDetail);
}

const enumDetailNameOfTradePartnerRequirementStatus = {
  MEETS: "Meets",
  DOES_NOT_MEET: "Does not meet",
  NA: "Na",
  WAIVER: "Waiver",
};

function enumOrDetailOfTradePartnerRequirementStatus(
  enumOrDetail: TradePartnerRequirementStatusDetailOptions | TradePartnerRequirementStatus | undefined,
): TradePartnerRequirementStatusDetail {
  if (enumOrDetail === undefined) {
    return newTradePartnerRequirementStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TradePartnerRequirementStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTradePartnerRequirementStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as TradePartnerRequirementStatusDetail;
  } else {
    return newTradePartnerRequirementStatusDetail({
      code: enumOrDetail as TradePartnerRequirementStatus,
      name: enumDetailNameOfTradePartnerRequirementStatus[enumOrDetail as TradePartnerRequirementStatus],
    });
  }
}

function enumOrDetailOrNullOfTradePartnerRequirementStatus(
  enumOrDetail: TradePartnerRequirementStatusDetailOptions | TradePartnerRequirementStatus | undefined | null,
): TradePartnerRequirementStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTradePartnerRequirementStatus(enumOrDetail);
}

const enumDetailNameOfTradePartnerRequirementType = {
  W9: "W9",
  WORKERS_COMP: "Workers comp",
  MSA: "Msa",
  GENERAL_LIABILITY: "General liability",
  PROFESSIONAL_LIABILITY: "Professional liability",
  INDUSTRY_LICENSE: "Industry license",
  AUTOMOBILE_LIABILITY: "Automobile liability",
  UMBRELLA_LIABILITY: "Umbrella liability",
  TRADE_SPECIFIC_AGREEMENT: "Trade specific agreement",
  APPLIANCES: "Appliances",
  CABINETS_AND_CABINET_HARDWARE: "Cabinets and cabinet hardware",
  CMU_WALLS: "Cmu walls",
  CONCRETE: "Concrete",
  COUNTERTOPS: "Countertops",
  DRYWALL: "Drywall",
  ELECTRICAL: "Electrical",
  EXTERIOR_SHEATING_FINISH_WINDOWS_EXT_DOORS_WATERPROOFING: "Exterior sheating finish windows ext doors waterproofing",
  FENCES_AND_GATES: "Fences and gates",
  FIREPLACE_INSTALL: "Fireplace install",
  FIRE_SUPRESSION: "Fire supression",
  FLOORING_AND_WALL_SURFACES: "Flooring and wall surfaces",
  FRAMING: "Framing",
  GARAGE_DOORS: "Garage doors",
  GENERAL_CONDITIONS: "General conditions",
  GUTTERS: "Gutters",
  HVAC: "Hvac",
  INSULATION: "Insulation",
  INTERIOR_MILLWORK_DOORS_HARDWARE: "Interior millwork doors hardware",
  LOW_VOLTAGE: "Low voltage",
  MASONRY_WALL_CLADDING: "Masonry wall cladding",
  MIRROR_AND_SHOWER_ECLOSURES: "Mirror and shower eclosures",
  PAINT: "Paint",
  PLANTING_AND_IRRIGATION: "Planting and irrigation",
  PLUMBING: "Plumbing",
  PROGRESSINVE_CLEANUP: "Progressinve cleanup",
  ROOFING: "Roofing",
  SITEWORK: "Sitework",
  SOLAR_PANELS: "Solar panels",
  STAIR_RAILINGS: "Stair railings",
  STUCCO_AND_THIN_VENNER: "Stucco and thin venner",
  SWPP_AND_EROSION_CONTROL: "Swpp and erosion control",
  TERMITE: "Termite",
  WASTE_REMOVAL: "Waste removal",
};

function enumOrDetailOfTradePartnerRequirementType(
  enumOrDetail: TradePartnerRequirementTypeDetailOptions | TradePartnerRequirementType | undefined,
): TradePartnerRequirementTypeDetail {
  if (enumOrDetail === undefined) {
    return newTradePartnerRequirementTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TradePartnerRequirementTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTradePartnerRequirementType[enumOrDetail.code!],
      ...enumOrDetail,
    } as TradePartnerRequirementTypeDetail;
  } else {
    return newTradePartnerRequirementTypeDetail({
      code: enumOrDetail as TradePartnerRequirementType,
      name: enumDetailNameOfTradePartnerRequirementType[enumOrDetail as TradePartnerRequirementType],
    });
  }
}

function enumOrDetailOrNullOfTradePartnerRequirementType(
  enumOrDetail: TradePartnerRequirementTypeDetailOptions | TradePartnerRequirementType | undefined | null,
): TradePartnerRequirementTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTradePartnerRequirementType(enumOrDetail);
}

const enumDetailNameOfUserEventType = {
  CREATED: "Created",
  UPDATED: "Updated",
  ASSIGNED: "Assigned",
  SCHEDULE_CHANGE: "Schedule change",
  COMPLETED: "Completed",
  TAGGED: "Tagged",
  FINALIZED: "Finalized",
  APPROVED: "Approved",
  COMMENTED: "Commented",
  ATTACHED: "Attached",
  PROJECT_COHORT_CHANGE: "Project cohort change",
  LOT_RELEASE: "Lot release",
  PRPC_APPLIED: "Prpc applied",
  PRPC_RESET: "Prpc reset",
  FLAGGED: "Flagged",
  REQUESTED_CHANGES: "Requested changes",
  REJECTED: "Rejected",
  ITEM_ADDED: "Item added",
  ITEM_REMOVED: "Item removed",
  PUBLISHED: "Published",
};

function enumOrDetailOfUserEventType(
  enumOrDetail: UserEventTypeDetailOptions | UserEventType | undefined,
): UserEventTypeDetail {
  if (enumOrDetail === undefined) {
    return newUserEventTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "UserEventTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfUserEventType[enumOrDetail.code!],
      ...enumOrDetail,
    } as UserEventTypeDetail;
  } else {
    return newUserEventTypeDetail({
      code: enumOrDetail as UserEventType,
      name: enumDetailNameOfUserEventType[enumOrDetail as UserEventType],
    });
  }
}

function enumOrDetailOrNullOfUserEventType(
  enumOrDetail: UserEventTypeDetailOptions | UserEventType | undefined | null,
): UserEventTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfUserEventType(enumOrDetail);
}

const enumDetailNameOfUserType = {
  ANONYMOUS: "Anonymous",
  SYSTEM: "System",
  INTERNAL: "Internal",
  HOMEOWNER: "Homeowner",
  TRADE_PARTNER: "Trade partner",
};

function enumOrDetailOfUserType(enumOrDetail: UserTypeDetailOptions | UserType | undefined): UserTypeDetail {
  if (enumOrDetail === undefined) {
    return newUserTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "UserTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfUserType[enumOrDetail.code!],
      ...enumOrDetail,
    } as UserTypeDetail;
  } else {
    return newUserTypeDetail({
      code: enumOrDetail as UserType,
      name: enumDetailNameOfUserType[enumOrDetail as UserType],
    });
  }
}

function enumOrDetailOrNullOfUserType(
  enumOrDetail: UserTypeDetailOptions | UserType | undefined | null,
): UserTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfUserType(enumOrDetail);
}

const enumDetailNameOfVerificationMethod = {
  VISUAL_INPUT: "Visual input",
  CLOSE_UP_VISUAL_INPUT: "Close up visual input",
  DOCUMENT_UPLOAD: "Document upload",
  IN_PERSON_INSPECTION: "In person inspection",
};

function enumOrDetailOfVerificationMethod(
  enumOrDetail: VerificationMethodDetailOptions | VerificationMethod | undefined,
): VerificationMethodDetail {
  if (enumOrDetail === undefined) {
    return newVerificationMethodDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "VerificationMethodDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfVerificationMethod[enumOrDetail.code!],
      ...enumOrDetail,
    } as VerificationMethodDetail;
  } else {
    return newVerificationMethodDetail({
      code: enumOrDetail as VerificationMethod,
      name: enumDetailNameOfVerificationMethod[enumOrDetail as VerificationMethod],
    });
  }
}

function enumOrDetailOrNullOfVerificationMethod(
  enumOrDetail: VerificationMethodDetailOptions | VerificationMethod | undefined | null,
): VerificationMethodDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfVerificationMethod(enumOrDetail);
}

const enumDetailNameOfWarrantyTicketItemStatus = {
  SUBMITTED: "Submitted",
  REJECTED: "Rejected",
  ACCEPTED: "Accepted",
  ON_HOLD: "On hold",
  SCHEDULED: "Scheduled",
  COMPLETED: "Completed",
  MATERIALS_ORDERED: "Materials ordered",
  IN_PROGRESS: "In progress",
  TRADE_CONTACTED: "Trade contacted",
  PENDING_INFO_FROM_HOMEOWNER: "Pending info from homeowner",
};

function enumOrDetailOfWarrantyTicketItemStatus(
  enumOrDetail: WarrantyTicketItemStatusDetailOptions | WarrantyTicketItemStatus | undefined,
): WarrantyTicketItemStatusDetail {
  if (enumOrDetail === undefined) {
    return newWarrantyTicketItemStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "WarrantyTicketItemStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfWarrantyTicketItemStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as WarrantyTicketItemStatusDetail;
  } else {
    return newWarrantyTicketItemStatusDetail({
      code: enumOrDetail as WarrantyTicketItemStatus,
      name: enumDetailNameOfWarrantyTicketItemStatus[enumOrDetail as WarrantyTicketItemStatus],
    });
  }
}

function enumOrDetailOrNullOfWarrantyTicketItemStatus(
  enumOrDetail: WarrantyTicketItemStatusDetailOptions | WarrantyTicketItemStatus | undefined | null,
): WarrantyTicketItemStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfWarrantyTicketItemStatus(enumOrDetail);
}

const enumDetailNameOfWarrantyTicketItemType = {
  MECHANICAL: "Mechanical",
  ELECTRICAL: "Electrical",
  PLUMBING: "Plumbing",
  MISC_INTERIOR: "Misc interior",
  MISC_EXTERIOR: "Misc exterior",
};

function enumOrDetailOfWarrantyTicketItemType(
  enumOrDetail: WarrantyTicketItemTypeDetailOptions | WarrantyTicketItemType | undefined,
): WarrantyTicketItemTypeDetail {
  if (enumOrDetail === undefined) {
    return newWarrantyTicketItemTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "WarrantyTicketItemTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfWarrantyTicketItemType[enumOrDetail.code!],
      ...enumOrDetail,
    } as WarrantyTicketItemTypeDetail;
  } else {
    return newWarrantyTicketItemTypeDetail({
      code: enumOrDetail as WarrantyTicketItemType,
      name: enumDetailNameOfWarrantyTicketItemType[enumOrDetail as WarrantyTicketItemType],
    });
  }
}

function enumOrDetailOrNullOfWarrantyTicketItemType(
  enumOrDetail: WarrantyTicketItemTypeDetailOptions | WarrantyTicketItemType | undefined | null,
): WarrantyTicketItemTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfWarrantyTicketItemType(enumOrDetail);
}

const enumDetailNameOfWarrantyTrueUpType = {
  TIME_OF_SALE: "Time of sale",
  SALE_PLUS_30: "Sale plus 30",
  SALE_PLUS_60: "Sale plus 60",
  FINAL: "Final",
};

function enumOrDetailOfWarrantyTrueUpType(
  enumOrDetail: WarrantyTrueUpTypeDetailOptions | WarrantyTrueUpType | undefined,
): WarrantyTrueUpTypeDetail {
  if (enumOrDetail === undefined) {
    return newWarrantyTrueUpTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "WarrantyTrueUpTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfWarrantyTrueUpType[enumOrDetail.code!],
      ...enumOrDetail,
    } as WarrantyTrueUpTypeDetail;
  } else {
    return newWarrantyTrueUpTypeDetail({
      code: enumOrDetail as WarrantyTrueUpType,
      name: enumDetailNameOfWarrantyTrueUpType[enumOrDetail as WarrantyTrueUpType],
    });
  }
}

function enumOrDetailOrNullOfWarrantyTrueUpType(
  enumOrDetail: WarrantyTrueUpTypeDetailOptions | WarrantyTrueUpType | undefined | null,
): WarrantyTrueUpTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfWarrantyTrueUpType(enumOrDetail);
}

const enumDetailNameOfWeatherType = {
  CLEAR_DAY: "Clear day",
  PARTLY_CLOUDY_DAY: "Partly cloudy day",
  CLOUDY: "Cloudy",
  WIND: "Wind",
  FOG: "Fog",
  SHOWERS_DAY: "Showers day",
  RAIN: "Rain",
  THUNDER_SHOWERS_DAY: "Thunder showers day",
  THUNDER_DAY: "Thunder day",
  SNOW_SHOWERS_DAY: "Snow showers day",
  SNOW: "Snow",
  SLEET: "Sleet",
  HAIL: "Hail",
  HAZE: "Haze",
  ICE: "Ice",
  SMOKE: "Smoke",
  DUST: "Dust",
};

function enumOrDetailOfWeatherType(
  enumOrDetail: WeatherTypeDetailOptions | WeatherType | undefined,
): WeatherTypeDetail {
  if (enumOrDetail === undefined) {
    return newWeatherTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "WeatherTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfWeatherType[enumOrDetail.code!],
      ...enumOrDetail,
    } as WeatherTypeDetail;
  } else {
    return newWeatherTypeDetail({
      code: enumOrDetail as WeatherType,
      name: enumDetailNameOfWeatherType[enumOrDetail as WeatherType],
    });
  }
}

function enumOrDetailOrNullOfWeatherType(
  enumOrDetail: WeatherTypeDetailOptions | WeatherType | undefined | null,
): WeatherTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfWeatherType(enumOrDetail);
}

const taggedIds: Record<string, string> = {
  "Community": "p",
  "Development": "dev",
  "GlobalOptionType": "gotype",
  "Invoice": "inv",
  "Lot": "p",
  "Subdivision": "p",
  "StandaloneProject": "p",
  "Structure": "p",
  "Product": "pr",
  "Unit": "p",
};
let nextFactoryIds: Record<string, number> = {};

export function resetFactoryIds() {
  nextFactoryIds = {};
}

function nextFactoryId(objectName: string): string {
  const nextId = nextFactoryIds[objectName] || 1;
  nextFactoryIds[objectName] = nextId + 1;
  const tag = taggedIds[objectName] ?? objectName.replace(/[a-z]/g, "").toLowerCase();
  return tag + ":" + nextId;
}

function maybeNew(
  type: string,
  value: { __typename?: string } | object | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): any {
  if (value === undefined) {
    return isSet ? undefined : cache[type] || factories[type]({}, cache);
  } else if ("__typename" in value && value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return factories[type](value, cache);
  }
}

function maybeNewOrNull(
  type: string,
  value: { __typename?: string } | object | undefined | null,
  cache: Record<string, any>,
): any {
  if (!value) {
    return null;
  } else if ("__typename" in value && value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return factories[type](value, cache);
  }
}

export const possibleTypes = {
  AiEntityProposalEntity: ["MaterialVariant", "ReadyPlanLocation", "ReadyPlanOption", "ReadyPlanProgramData"],
  HasBlueprintUrl: [
    "Approval",
    "BidContract",
    "BidContractRevision",
    "BidItem",
    "BidPackageRequest",
    "Bill",
    "BusinessFunction",
    "ChangeEvent",
    "ChangeRequest",
    "ChangeRequestToDo",
    "SchedulePhase",
    "ScheduleSubPhase",
    "Task",
    "ScheduleTask",
    "PlanTask",
    "ToDo",
    "Invoice",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectItem",
    "Estimate",
    "DevelopmentCommitment",
    "Commitment",
    "Document",
    "ItemTemplateItemVersion",
    "JobLogNote",
    "TradePartnerAvailabilityRequest",
    "PunchlistItemTodo",
    "WarrantyTicket",
    "HomeownerContract",
    "HomeownerContractChangeOrder",
    "ReadyPlan",
    "PlanPackage",
    "GlobalOption",
    "ProjectCostCode",
    "CommitmentChangeOrder",
    "DesignPackage",
    "Development",
    "ItemTemplateItem",
    "MaterialVariant",
    "ProductOffering",
    "ProjectReadyPlanConfig",
    "ProjectSiteCondition",
    "ReadyPlanOption",
    "TakeoffLineItem",
    "TakeoffLineItemVersion",
  ],
  Named: [
    "Approval",
    "BidContract",
    "BidContractLineItem",
    "BidItem",
    "BidPackage",
    "BidPackageRequest",
    "TradePartner",
    "Bill",
    "BusinessFunction",
    "ChangeEvent",
    "ChangeEventLineItem",
    "ChangeEventReason",
    "ChangeEventTemplateConfig",
    "ChangeRequest",
    "ChangeRequestAsset",
    "ChangeRequestToDo",
    "Client",
    "Cohort",
    "SchedulePhase",
    "ScheduleSubPhase",
    "Task",
    "ScheduleTask",
    "PlanTask",
    "ToDo",
    "Invoice",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectItem",
    "Estimate",
    "DevelopmentCommitment",
    "Commitment",
    "Document",
    "ItemTemplateItemVersion",
    "JobLogNote",
    "TradePartnerAvailabilityRequest",
    "PunchlistItemTodo",
    "WarrantyTicket",
    "HomeownerContract",
    "HomeownerContractChangeOrder",
    "ReadyPlan",
    "PlanPackage",
    "GlobalOption",
    "ProjectCostCode",
    "CommitmentChangeOrder",
    "CostCode",
    "CostDivision",
    "Customer",
    "CustomerOwnerEntity",
    "DesignPackage",
    "Development",
    "GlobalOptionTag",
    "GlobalOptionType",
    "GlobalPlanConstraintItem",
    "GlobalPlanMilestone",
    "GlobalPlanTask",
    "GlobalTask",
    "HomeownerContractDraw",
    "InternalUser",
    "InvoiceScheduleTemplate",
    "Item",
    "ItemSlot",
    "ItemTemplate",
    "ItemTemplateItem",
    "Location",
    "MaterialVariantTag",
    "PandaDoc",
    "PandaDocRecipient",
    "PlanMilestone",
    "ProductOffering",
    "ProjectStageTemplateConfig",
    "ProjectStatusChangeReason",
    "ReadyPlanAggregateVersion",
    "ReadyPlanLocation",
    "ReadyPlanOption",
    "ReadyPlanOptionProgramDataModification",
    "Schedule",
    "ScheduleTemplate",
    "Submarket",
    "TakeoffLineItem",
    "TakeoffLineItemVersion",
    "TradeCategory",
    "TradePartnerContact",
    "TradePartnerMailingList",
    "TradePartnerUser",
    "UnitOfMeasure",
    "User",
  ],
  CanCollaborate: [
    "Approval",
    "BidContract",
    "BidItem",
    "BidPackageRequest",
    "Bill",
    "ChangeEvent",
    "ChangeRequest",
    "ChangeRequestToDo",
    "SchedulePhase",
    "ScheduleSubPhase",
    "Task",
    "ScheduleTask",
    "PlanTask",
    "ToDo",
    "Invoice",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectItem",
    "Estimate",
    "DevelopmentCommitment",
    "Commitment",
    "Document",
    "ItemTemplateItemVersion",
    "JobLogNote",
    "TradePartnerAvailabilityRequest",
    "PunchlistItemTodo",
    "WarrantyTicket",
    "HomeownerContract",
    "HomeownerContractChangeOrder",
    "ReadyPlan",
    "PlanPackage",
    "GlobalOption",
    "ProjectCostCode",
  ],
  Commentable: [
    "Approval",
    "BidContract",
    "BidItem",
    "BidPackageRequest",
    "Bill",
    "ChangeEvent",
    "ChangeRequest",
    "ChangeRequestToDo",
    "SchedulePhase",
    "ScheduleSubPhase",
    "Task",
    "ScheduleTask",
    "PlanTask",
    "ToDo",
    "Invoice",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectItem",
    "Estimate",
    "DevelopmentCommitment",
    "Commitment",
    "Document",
    "ItemTemplateItemVersion",
    "JobLogNote",
    "TradePartnerAvailabilityRequest",
    "PunchlistItemTodo",
    "WarrantyTicket",
    "HomeownerContract",
    "HomeownerContractChangeOrder",
    "ReadyPlan",
    "PlanPackage",
    "GlobalOption",
    "ProjectCostCode",
  ],
  Referencable: [
    "Approval",
    "BidContract",
    "BidItem",
    "BidPackageRequest",
    "Bill",
    "ChangeEvent",
    "ChangeRequest",
    "ChangeRequestToDo",
    "SchedulePhase",
    "ScheduleSubPhase",
    "Task",
    "ScheduleTask",
    "PlanTask",
    "ToDo",
    "Invoice",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectItem",
    "Estimate",
    "DevelopmentCommitment",
    "Commitment",
    "Document",
    "ItemTemplateItemVersion",
    "JobLogNote",
    "TradePartnerAvailabilityRequest",
    "PunchlistItemTodo",
    "WarrantyTicket",
    "HomeownerContract",
    "HomeownerContractChangeOrder",
    "ReadyPlan",
    "PlanPackage",
    "GlobalOption",
    "ProjectCostCode",
  ],
  Followable: [
    "Approval",
    "BidContract",
    "BidItem",
    "BidPackageRequest",
    "Bill",
    "ChangeEvent",
    "ChangeRequest",
    "ChangeRequestToDo",
    "SchedulePhase",
    "ScheduleSubPhase",
    "Task",
    "ScheduleTask",
    "PlanTask",
    "ToDo",
    "Invoice",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectItem",
    "Estimate",
    "DevelopmentCommitment",
    "Commitment",
    "Document",
    "ItemTemplateItemVersion",
    "JobLogNote",
    "TradePartnerAvailabilityRequest",
    "PunchlistItemTodo",
    "WarrantyTicket",
    "HomeownerContract",
    "HomeownerContractChangeOrder",
    "ReadyPlan",
    "PlanPackage",
    "GlobalOption",
    "ProjectCostCode",
  ],
  ApprovalSource: ["BidContractRevision", "ItemTemplate", "ReadyPlanAggregateVersion"],
  ApprovalSubject: ["Bill", "ChangeEvent", "ChangeRequest", "Invoice"],
  ApproverSource: ["DevelopmentTeamMember", "ProjectCollaborator", "ProjectTeamMember", "TradePartnerMarketContact"],
  ApproverSubjectData: ["ChangeRequestApproverSubjectData"],
  ApproverUser: ["Client", "InternalUser", "TradePartnerUser"],
  Entity: [
    "Asset",
    "TradePartner",
    "Bill",
    "ScheduleTask",
    "PlanTask",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "Commitment",
    "Document",
    "JobLogNote",
    "PunchlistItemTodo",
    "Comment",
    "ProjectStage",
    "CommitmentDraw",
    "FeatureFlag",
    "JobLog",
    "JobLogImage",
    "Location",
    "MobileSyncUpdate",
    "ScheduleFlag",
    "ScheduleFlagReason",
    "ScheduleTaskChecklistItem",
    "TaskWorkDay",
    "TradePartnerContact",
    "TradePartnerUser",
  ],
  AttachmentParent: [
    "ChangeRequest",
    "Comment",
    "GlobalOption",
    "ProjectSiteCondition",
    "ScheduleFlag",
    "ToDo",
    "TradePartnerAvailabilityRequestEmail",
    "TradePartnerRequirement",
    "WarrantyTicket",
    "WarrantyTicketItem",
  ],
  HasPandaDoc: ["BidContractRevision", "DevelopmentCommitment", "Commitment", "CommitmentChangeOrder"],
  HasDisplayName: [
    "BidItem",
    "BidPlanChildGroup",
    "BidPlanChildGroupLine",
    "BidPlanGroup",
    "ChangeEventLineItem",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectItem",
    "Commitment",
    "Document",
    "ItemTemplateItemVersion",
    "ReadyPlan",
    "PlanPackage",
    "CommitmentChangeOrder",
    "CostCode",
    "CostDivision",
    "DesignPackage",
    "Item",
    "ItemTemplate",
    "ItemTemplateItem",
    "ProductOffering",
    "ReadyPlanAggregateVersion",
    "ReadyPlanOption",
    "TakeoffLineItem",
    "TakeoffLineItemVersion",
    "TradeCategory",
  ],
  MaybeHasProject: [
    "Bill",
    "ChangeEvent",
    "Task",
    "Invoice",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectItem",
    "Estimate",
    "HomeownerContract",
    "ProjectStage",
    "ProjectCollaborator",
    "ProjectUpdate",
  ],
  ErpAccountBillLineItemErpSource: ["CommitmentDraw", "CommitmentLineItem", "ProjectItem", "CostCode", "Commitment"],
  ChangeEventCreatedBy: ["Bill", "Expense"],
  ProjectStageTemplateConfigLike: ["ChangeEventTemplateConfig", "ProjectStageTemplateConfig"],
  ChangeRequestScopeTarget: [
    "StandaloneProject",
    "Region",
    "Development",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
  ],
  HasCheckoutUrl: ["CheckoutConfig"],
  ReadyPlanConfigLike: ["CheckoutConfig", "ProductOfferingConfig", "ProjectReadyPlanConfig"],
  PotentialOptionGroupLike: ["CheckoutConfigOptionGroup", "ProjectReadyPlanConfigPotentialOptionGroup"],
  PotentialOptionLike: ["CheckoutConfigPotentialOption", "ProjectReadyPlanConfigPotentialOption"],
  ScheduleEntity: ["SchedulePhase", "ScheduleSubPhase", "ScheduleTask", "Schedule"],
  MaybeHasInterval: ["SchedulePhase", "ScheduleSubPhase", "Task", "ScheduleTask", "ProjectStage", "Schedule"],
  MaybeHasBaselineInterval: ["SchedulePhase", "ScheduleSubPhase", "ScheduleTask", "Schedule"],
  Project: ["StandaloneProject", "Region", "Market", "Community", "Subdivision", "Lot", "Structure", "Unit"],
  HasSchedules: [
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "Development",
    "ScheduleTemplate",
  ],
  HasHopUrl: ["StandaloneProject", "Region", "Market", "Community", "Subdivision", "Lot", "Structure", "Unit"],
  MaybeHasPropcoUrl: ["StandaloneProject", "Structure"],
  ProjectItemLike: ["ProjectItem", "ProtoProjectItem"],
  CommitmentLike: ["Commitment", "CommitmentChangeOrder"],
  BaseItemLike: ["ItemTemplateItemVersion", "ItemTemplateItem", "TakeoffLineItem", "TakeoffLineItemVersion"],
  HomeownerContractLike: ["HomeownerContract", "HomeownerContractChangeOrder"],
  ReadyPlanLike: ["ReadyPlan", "PlanPackage", "DesignPackage", "ProductOffering"],
  BaseItemParent: ["ReadyPlan", "PlanPackage", "DesignPackage", "ItemTemplate", "ProductOffering"],
  CollaborationParent: [
    "ScheduleSubPhase",
    "Approval",
    "BidContract",
    "BidItem",
    "BidPackageRequest",
    "Bill",
    "ChangeEvent",
    "ChangeRequest",
    "ChangeRequestToDo",
    "Commitment",
    "DevelopmentCommitment",
    "Document",
    "Estimate",
    "GlobalOption",
    "HomeownerContract",
    "HomeownerContractChangeOrder",
    "Invoice",
    "ItemTemplateItemVersion",
    "JobLogNote",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectCostCode",
    "ProjectItem",
    "PunchlistItemTodo",
    "ReadyPlan",
    "Task",
    "ToDo",
    "TradePartnerAvailabilityRequest",
    "SchedulePhase",
    "WarrantyTicket",
  ],
  HasMaterialLeadTimeConfigData: ["CostCode", "Item", "MaterialListing"],
  MaybeHasMarket: ["Development", "ScheduleTemplate"],
  DocumentParent: [
    "Development",
    "PlanPackage",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
  ],
  DocumentOwner: [
    "HomeownerContract",
    "HomeownerContractChangeOrder",
    "Commitment",
    "CommitmentChangeOrder",
    "DevelopmentCommitment",
    "InvoiceDocument",
    "Development",
    "PlanPackage",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "BidContractRevision",
    "LienWaiver",
    "ChangeEvent",
  ],
  ErpAccrualLineItemSourceLine: [
    "BillLineItemAllocation",
    "CommitmentDraw",
    "CommitmentLineItem",
    "ExpenseAllocationAllocation",
    "ProjectItem",
    "CostCode",
  ],
  FeatureFlagTargetTarget: [
    "Development",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "User",
    "UserGroup",
  ],
  HasGlobalConstraintItem: ["GlobalPlanAllowance", "GlobalPlanConstraint"],
  GlobalPlanTaskScopeTarget: ["Community", "Market", "Region", "Subdivision"],
  GlobalSearchRecordParent: [
    "Bill",
    "Commitment",
    "CommitmentChangeOrder",
    "Community",
    "DesignPackage",
    "Lot",
    "Market",
    "PlanPackage",
    "ProductOffering",
    "Region",
    "StandaloneProject",
    "Structure",
    "Subdivision",
    "TradePartner",
  ],
  InvoiceParent: ["PlanMilestone", "Task", "ScheduleTask", "PlanTask"],
  InvoiceScheduleItemParent: ["PlanMilestone", "ScheduleTask"],
  InvoiceScheduleItemGlobalParent: ["GlobalPlanMilestone", "GlobalTask"],
  HasDisplayVersion: ["ItemTemplate", "ReadyPlanAggregateVersion"],
  BaseItemParentVersion: ["ItemTemplate", "ReadyPlanAggregateVersion"],
  ItemTemplateAnomalyParent: ["ItemTemplate", "ItemTemplateItemVersion"],
  JobLogImageParent: ["JobLog", "JobLogNote"],
  LienWaiverParent: [
    "StandaloneProject",
    "Region",
    "Bill",
    "Invoice",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
  ],
  LienWaiverClaimant: ["Builder", "TradePartner"],
  LienWaiverPayer: ["Builder", "Client"],
  LienWaiverSignatory: ["InternalUser", "TradePartnerContact"],
  LienWaiverOwner: ["Customer", "Client"],
  MaterialLeadTimeConfigParent: ["CostCode", "Item", "MaterialListing"],
  HasOptionPricingData: ["MaterialListing", "ReadyPlanOption"],
  MaterialCostSource: ["BidItemEstimate", "BidContractLineItem"],
  OptionPricingConfigParent: ["CostCode", "GlobalOption", "Item", "MaterialListing"],
  PandaDocOwner: [
    "BidContractRevision",
    "ChangeEvent",
    "Commitment",
    "CommitmentChangeOrder",
    "DevelopmentCommitment",
    "Invoice",
    "LienWaiver",
  ],
  PlanScheduleParent: ["StandaloneProject", "Region", "Market", "Community", "Subdivision", "Lot", "Structure", "Unit"],
  ProductOfferingIncomingUpdateSource: ["Drop", "ReadyPlanAggregateVersion"],
  ProgramDataLike: ["ProgramData", "NewProgramData"],
  HasUserErrors: ["SaveProjectItemsResult"],
  CostLineItemEntity: ["Bill", "Expense"],
  SendTradePartnerPunchlistEmailResult: [
    "SendTradePartnerPunchlistEmailSuccess",
    "SendTradePartnerPunchlistEmailFailure",
  ],
  SendPunchlistExportEmailResult: ["SendPunchlistExportEmailSuccess", "SendPunchlistExportEmailFailure"],
  ReadyPlanCostData: ["ComputeReadyPlanCostResult", "ReadyPlanOptionCostDelta"],
  ReadyPlanAssetParent: [
    "ReadyPlan",
    "ReadyPlanLocation",
    "ReadyPlanOption",
    "PlanPackage",
    "DesignPackage",
    "ProductOffering",
  ],
  ScheduleParent: [
    "StandaloneProject",
    "Region",
    "Development",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ScheduleTemplate",
  ],
  ScheduleFlagImpactImpacted: ["PlanMilestone", "Task"],
  HasScheduleImpact: [
    "DeleteSchedulePhasesResult",
    "DeleteScheduleSubPhasesResult",
    "MoveScheduleSubPhasesResult",
    "SaveScheduleTasksResult",
  ],
  SchedulingExclusionDateParent: [
    "StandaloneProject",
    "Region",
    "Development",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
  ],
  ScheduleLike: ["Schedule", "PlanSchedule"],
  ToDoParent: [
    "StandaloneProject",
    "Region",
    "Cohort",
    "Development",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
  ],
  TrackedJobResult: ["Asset", "BillOcr"],
  TrackedJobParent: ["ProductOffering"],
  TradeCategoryLeadTimeLike: ["TradeCategoryLeadTimeDefault", "TradeCategoryLeadTime"],
  UserEventParent: [
    "Approval",
    "Bill",
    "ChangeEvent",
    "Commitment",
    "CommitmentChangeOrder",
    "Document",
    "Estimate",
    "HomeownerContractChangeOrder",
    "Invoice",
    "ItemTemplate",
    "JobLog",
    "JobLogImage",
    "JobLogNote",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectItem",
    "ProjectLotDetail",
    "ProjectReadyPlanConfig",
    "ReadyPlan",
    "PlanPackage",
    "DesignPackage",
    "ProductOffering",
    "ReadyPlanOption",
    "ToDo",
    "ChangeRequestToDo",
    "PunchlistItemTodo",
    "Task",
    "ScheduleTask",
    "PlanTask",
    "WarrantyTicket",
  ],
};

export const enumTypePolicies = {
  ActivityPlanningStateDetail: { keyFields: ["code"] },

  ActivityResponsibilityDetail: { keyFields: ["code"] },

  ActivityTypeDetail: { keyFields: ["code"] },

  AggregateVersionStatusDetail: { keyFields: ["code"] },

  AiEntityProposalEntityTypeDetail: { keyFields: ["code"] },

  AiEntityProposalTypeDetail: { keyFields: ["code"] },

  AiFieldProposalStatusDetail: { keyFields: ["code"] },

  AiProposalStatusDetail: { keyFields: ["code"] },

  AiProposalTypeDetail: { keyFields: ["code"] },

  AllocationStrategyDetail: { keyFields: ["code"] },

  ApprovalStatusDetail: { keyFields: ["code"] },

  ApproverStatusDetail: { keyFields: ["code"] },

  BidContractRevisionStatusDetail: { keyFields: ["code"] },

  BidContractTypeDetail: { keyFields: ["code"] },

  BidPackageStatusDetail: { keyFields: ["code"] },

  BidScopeSourceDetail: { keyFields: ["code"] },

  BillGmailAttachmentResultDetail: { keyFields: ["code"] },

  BillGmailMessageResultDetail: { keyFields: ["code"] },

  BillReviewReasonDetail: { keyFields: ["code"] },

  BillSourceDetail: { keyFields: ["code"] },

  BillStatusDetail: { keyFields: ["code"] },

  BillTypeDetail: { keyFields: ["code"] },

  BusinessFunctionTypeDetail: { keyFields: ["code"] },

  BuyoutStatusDetail: { keyFields: ["code"] },

  ChangeEventBudgetPhaseDetail: { keyFields: ["code"] },

  ChangeEventLineItemTypeDetail: { keyFields: ["code"] },

  ChangeEventStatusDetail: { keyFields: ["code"] },

  ChangeEventTypeDetail: { keyFields: ["code"] },

  ChangeEventWorkflowDetail: { keyFields: ["code"] },

  ChangeRequestAssetPlatformDetail: { keyFields: ["code"] },

  ChangeRequestAssetScopeDetail: { keyFields: ["code"] },

  ChangeRequestPriorityDetail: { keyFields: ["code"] },

  ChangeRequestSourceDetail: { keyFields: ["code"] },

  ChangeRequestStatusDetail: { keyFields: ["code"] },

  ChangeRequestToDoTypeDetail: { keyFields: ["code"] },

  ChangeTypeDetail: { keyFields: ["code"] },

  CheckoutConfigOptionGroupStepDetail: { keyFields: ["code"] },

  CheckoutConfigStatusDetail: { keyFields: ["code"] },

  ClientPlatformDetail: { keyFields: ["code"] },

  CommentStreamVisibilityDetail: { keyFields: ["code"] },

  CommitmentStatusDetail: { keyFields: ["code"] },

  CommitmentTypeDetail: { keyFields: ["code"] },

  CommunicationChannelDetail: { keyFields: ["code"] },

  CommunityTypeDetail: { keyFields: ["code"] },

  ConstructionTypeDetail: { keyFields: ["code"] },

  ContractTypeDetail: { keyFields: ["code"] },

  CostClassificationTypeDetail: { keyFields: ["code"] },

  CostCodeInvoiceCategoryDetail: { keyFields: ["code"] },

  CostConfidenceDetail: { keyFields: ["code"] },

  CostSubClassificationTypeDetail: { keyFields: ["code"] },

  CostTypeDetail: { keyFields: ["code"] },

  DayOfWeekDetail: { keyFields: ["code"] },

  DesignPackageLocationDetail: { keyFields: ["code"] },

  DevelopmentCommitmentTypeDetail: { keyFields: ["code"] },

  DocumentAttachmentPlaceDetail: { keyFields: ["code"] },

  DocumentCategoryDetail: { keyFields: ["code"] },

  DocumentTypeDetail: { keyFields: ["code"] },

  ErpAccrualTypeDetail: { keyFields: ["code"] },

  ErpRevenueLineItemSourceEventDetail: { keyFields: ["code"] },

  ErpTransactionGroupEventDetail: { keyFields: ["code"] },

  ErpTransactionGroupStatusDetail: { keyFields: ["code"] },

  ErpTransactionStatusDetail: { keyFields: ["code"] },

  EstimateStatusDetail: { keyFields: ["code"] },

  EstimateTypeDetail: { keyFields: ["code"] },

  FeatureFlagStatusDetail: { keyFields: ["code"] },

  FeatureFlagTypeDetail: { keyFields: ["code"] },

  FinishScheduleColumnTypeDetail: { keyFields: ["code"] },

  FinishScheduleCoreColumnDetail: { keyFields: ["code"] },

  FloodPlainDetail: { keyFields: ["code"] },

  FloodZoneDetail: { keyFields: ["code"] },

  FoundationTypeDetail: { keyFields: ["code"] },

  GlobalOptionStatusDetail: { keyFields: ["code"] },

  GlobalOptionTypeStatusDetail: { keyFields: ["code"] },

  GlobalPlanMilestoneTypeDetail: { keyFields: ["code"] },

  InboxItemStatusDetail: { keyFields: ["code"] },

  InternalEstimateTypeDetail: { keyFields: ["code"] },

  InvoiceDocumentSourceDetail: { keyFields: ["code"] },

  InvoiceScheduleAmountTypeDetail: { keyFields: ["code"] },

  InvoiceScheduleItemFrequencyDetail: { keyFields: ["code"] },

  InvoiceScheduleTriggerTypeDetail: { keyFields: ["code"] },

  InvoiceSourceDetail: { keyFields: ["code"] },

  InvoiceStatusDetail: { keyFields: ["code"] },

  InvoiceTypeDetail: { keyFields: ["code"] },

  ItemStatusDetail: { keyFields: ["code"] },

  ItemTemplateItemCostStatusDetail: { keyFields: ["code"] },

  ItemTemplateStatusDetail: { keyFields: ["code"] },

  JobLogFlagDetail: { keyFields: ["code"] },

  JobLogNoteTypeDetail: { keyFields: ["code"] },

  LienWaiverConditionDetail: { keyFields: ["code"] },

  LienWaiverStatusDetail: { keyFields: ["code"] },

  LienWaiverTypeDetail: { keyFields: ["code"] },

  LocationTypeDetail: { keyFields: ["code"] },

  LotSalesStatusDetail: { keyFields: ["code"] },

  LotTypeDetail: { keyFields: ["code"] },

  MarkupApplicationMethodDetail: { keyFields: ["code"] },

  MaterialAttributeDimensionTypeDetail: { keyFields: ["code"] },

  MaterialAttributeValueTypeDetail: { keyFields: ["code"] },

  MaterialTypeDetail: { keyFields: ["code"] },

  MobileSyncUpdateTypeDetail: { keyFields: ["code"] },

  PandaDocRoleDetail: { keyFields: ["code"] },

  PandaDocStatusDetail: { keyFields: ["code"] },

  PandaDocWorkspaceDetail: { keyFields: ["code"] },

  PaymentTermDueFromDetail: { keyFields: ["code"] },

  PermitDetail: { keyFields: ["code"] },

  PlanPackageIncomingSlotStatusDetail: { keyFields: ["code"] },

  ProgramDataBasementConfigDetail: { keyFields: ["code"] },

  ProgramDataGarageConfigDetail: { keyFields: ["code"] },

  ProgramDataMatchStateDetail: { keyFields: ["code"] },

  ProgramDataPrimaryBedroomConfigDetail: { keyFields: ["code"] },

  ProgramDataWindowColorDetail: { keyFields: ["code"] },

  ProjectCollaboratorRoleDetail: { keyFields: ["code"] },

  ProjectFeatureDetail: { keyFields: ["code"] },

  ProjectReadyPlanConfigOrientationDetail: { keyFields: ["code"] },

  ProjectRoleDetail: { keyFields: ["code"] },

  ProjectStageStatusDetail: { keyFields: ["code"] },

  ProjectStatusDetail: { keyFields: ["code"] },

  ProjectUpdateActionTypeDetail: { keyFields: ["code"] },

  PushNotificationEnvironmentDetail: { keyFields: ["code"] },

  PushNotificationPlatformDetail: { keyFields: ["code"] },

  ReadyPlanAssetTypeDetail: { keyFields: ["code"] },

  ReadyPlanOptionGroupPersonalizationTypeDetail: { keyFields: ["code"] },

  ReadyPlanStatusDetail: { keyFields: ["code"] },

  ReadyPlanTypeDetail: { keyFields: ["code"] },

  ScheduleFlagReasonTypeDetail: { keyFields: ["code"] },

  ScheduleStatusDetail: { keyFields: ["code"] },

  ScheduleTemplateStatusDetail: { keyFields: ["code"] },

  ScopeChangeTypeDetail: { keyFields: ["code"] },

  ScopeModeDetail: { keyFields: ["code"] },

  SelectionCutoffDetail: { keyFields: ["code"] },

  StageDetail: { keyFields: ["code"] },

  SuburbanAssetCategoryDetail: { keyFields: ["code"] },

  SystemChangeRequestAssetDetail: { keyFields: ["code"] },

  SystemPlanMilestoneDetail: { keyFields: ["code"] },

  SystemTaskDetail: { keyFields: ["code"] },

  TakeoffLineItemActionDetail: { keyFields: ["code"] },

  TakeoffLineItemDesignPackageTypeDetail: { keyFields: ["code"] },

  TakeoffLineItemTypeDetail: { keyFields: ["code"] },

  TaskDeadlineTypeDetail: { keyFields: ["code"] },

  TaskDependencyTypeDetail: { keyFields: ["code"] },

  TaskStatusDetail: { keyFields: ["code"] },

  TaskTypeDetail: { keyFields: ["code"] },

  TimeFrequencyDetail: { keyFields: ["code"] },

  TimeOfDayDetail: { keyFields: ["code"] },

  ToDoStatusDetail: { keyFields: ["code"] },

  ToDoTypeDetail: { keyFields: ["code"] },

  TrackedJobStatusDetail: { keyFields: ["code"] },

  TradePartnerAvailabilityRequestStatusDetail: { keyFields: ["code"] },

  TradePartnerMarketRoleDetail: { keyFields: ["code"] },

  TradePartnerOnboardingStatusDetail: { keyFields: ["code"] },

  TradePartnerRequirementStatusDetail: { keyFields: ["code"] },

  TradePartnerRequirementTypeDetail: { keyFields: ["code"] },

  TradePartnerTaskStatusDetail: { keyFields: ["code"] },

  UserEventTypeDetail: { keyFields: ["code"] },

  UserTypeDetail: { keyFields: ["code"] },

  VerificationMethodDetail: { keyFields: ["code"] },

  WarrantyTicketItemStatusDetail: { keyFields: ["code"] },

  WarrantyTicketItemTypeDetail: { keyFields: ["code"] },

  WarrantyTicketStatusDetail: { keyFields: ["code"] },

  WarrantyTicketTypeDetail: { keyFields: ["code"] },

  WarrantyTrueUpTypeDetail: { keyFields: ["code"] },

  WeatherTypeDetail: { keyFields: ["code"] },
};

interface UserFeatureFlagsDataOptions {
  userFeatureFlags?: (FeatureFlag | FeatureFlagOptions)[];
}

export function newUserFeatureFlagsData(data: UserFeatureFlagsDataOptions): UserFeatureFlagsQuery {
  return {
    __typename: "Query" as const,
    userFeatureFlags: data["userFeatureFlags"]?.map((d) => newFeatureFlag(d)) || [],
  } as any;
}

export function newUserFeatureFlagsResponse(
  data: UserFeatureFlagsDataOptions | Error,
): MockedResponse<UserFeatureFlagsQueryVariables, UserFeatureFlagsQuery> {
  return {
    request: { query: UserFeatureFlagsDocument },
    result: { data: data instanceof Error ? undefined : newUserFeatureFlagsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateAssetUploadUrlDataOptions {
  createAssetUploadUrl?: CreateAssetUploadUrlResult | CreateAssetUploadUrlResultOptions;
}

export function newCreateAssetUploadUrlData(data: CreateAssetUploadUrlDataOptions): CreateAssetUploadUrlMutation {
  return {
    __typename: "Mutation" as const,
    createAssetUploadUrl: maybeNew("CreateAssetUploadUrlResult", data["createAssetUploadUrl"] || undefined, {}),
  } as any;
}

export function newCreateAssetUploadUrlResponse(
  variables: CreateAssetUploadUrlMutationVariables,
  data: CreateAssetUploadUrlDataOptions | Error,
): MockedResponse<CreateAssetUploadUrlMutationVariables, CreateAssetUploadUrlMutation> {
  return {
    request: { query: CreateAssetUploadUrlDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateAssetUploadUrlData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CurrentUserDataOptions {
  currentUser?: User | UserOptions | null;
}

export function newCurrentUserData(data: CurrentUserDataOptions): CurrentUserQuery {
  return {
    __typename: "Query" as const,
    currentUser: maybeNewOrNull("User", data["currentUser"] || undefined, {}),
  } as any;
}

export function newCurrentUserResponse(
  data: CurrentUserDataOptions | Error,
): MockedResponse<CurrentUserQueryVariables, CurrentUserQuery> {
  return {
    request: { query: CurrentUserDocument },
    result: { data: data instanceof Error ? undefined : newCurrentUserData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApproveTradePartnerAvailabilityRequestDataOptions {
  approveTradePartnerAvailabilityRequest?: EmptyResult | EmptyResultOptions;
}

export function newApproveTradePartnerAvailabilityRequestData(
  data: ApproveTradePartnerAvailabilityRequestDataOptions,
): ApproveTradePartnerAvailabilityRequestMutation {
  return {
    __typename: "Mutation" as const,
    approveTradePartnerAvailabilityRequest: maybeNew(
      "EmptyResult",
      data["approveTradePartnerAvailabilityRequest"] || undefined,
      {},
    ),
  } as any;
}

export function newApproveTradePartnerAvailabilityRequestResponse(
  variables: ApproveTradePartnerAvailabilityRequestMutationVariables,
  data: ApproveTradePartnerAvailabilityRequestDataOptions | Error,
): MockedResponse<
  ApproveTradePartnerAvailabilityRequestMutationVariables,
  ApproveTradePartnerAvailabilityRequestMutation
> {
  return {
    request: { query: ApproveTradePartnerAvailabilityRequestDocument, variables },
    result: { data: data instanceof Error ? undefined : newApproveTradePartnerAvailabilityRequestData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoicePageDataOptions {
  bill?: Bill | BillOptions;
}

export function newInvoicePageData(data: InvoicePageDataOptions): InvoicePageQuery {
  return { __typename: "Query" as const, bill: maybeNew("Bill", data["bill"] || undefined, {}) } as any;
}

export function newInvoicePageResponse(
  variables: InvoicePageQueryVariables,
  data: InvoicePageDataOptions | Error,
): MockedResponse<InvoicePageQueryVariables, InvoicePageQuery> {
  return {
    request: { query: InvoicePageDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoicePageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PollLienWaiverDataOptions {
  lienWaivers?: (LienWaiver | LienWaiverOptions)[];
}

export function newPollLienWaiverData(data: PollLienWaiverDataOptions): PollLienWaiverQuery {
  return { __typename: "Query" as const, lienWaivers: data["lienWaivers"]?.map((d) => newLienWaiver(d)) || [] } as any;
}

export function newPollLienWaiverResponse(
  variables: PollLienWaiverQueryVariables,
  data: PollLienWaiverDataOptions | Error,
): MockedResponse<PollLienWaiverQueryVariables, PollLienWaiverQuery> {
  return {
    request: { query: PollLienWaiverDocument, variables },
    result: { data: data instanceof Error ? undefined : newPollLienWaiverData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveInvoiceDataOptions {
  saveBill?: SaveBillResult | SaveBillResultOptions;
}

export function newSaveInvoiceData(data: SaveInvoiceDataOptions): SaveInvoiceMutation {
  return {
    __typename: "Mutation" as const,
    saveBill: maybeNew("SaveBillResult", data["saveBill"] || undefined, {}),
  } as any;
}

export function newSaveInvoiceResponse(
  variables: SaveInvoiceMutationVariables,
  data: SaveInvoiceDataOptions | Error,
): MockedResponse<SaveInvoiceMutationVariables, SaveInvoiceMutation> {
  return {
    request: { query: SaveInvoiceDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveInvoiceData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoicePage_SaveApproverDataOptions {
  saveApprover?: SaveApproverResult | SaveApproverResultOptions;
}

export function newInvoicePage_SaveApproverData(
  data: InvoicePage_SaveApproverDataOptions,
): InvoicePage_SaveApproverMutation {
  return {
    __typename: "Mutation" as const,
    saveApprover: maybeNew("SaveApproverResult", data["saveApprover"] || undefined, {}),
  } as any;
}

export function newInvoicePage_SaveApproverResponse(
  variables: InvoicePage_SaveApproverMutationVariables,
  data: InvoicePage_SaveApproverDataOptions | Error,
): MockedResponse<InvoicePage_SaveApproverMutationVariables, InvoicePage_SaveApproverMutation> {
  return {
    request: { query: InvoicePage_SaveApproverDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoicePage_SaveApproverData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoicesPageDataOptions {
  bills?: (Bill | BillOptions)[];
}

export function newInvoicesPageData(data: InvoicesPageDataOptions): InvoicesPageQuery {
  return { __typename: "Query" as const, bills: data["bills"]?.map((d) => newBill(d)) || [] } as any;
}

export function newInvoicesPageResponse(
  variables: InvoicesPageQueryVariables,
  data: InvoicesPageDataOptions | Error,
): MockedResponse<InvoicesPageQueryVariables, InvoicesPageQuery> {
  return {
    request: { query: InvoicesPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoicesPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PurchaseOrderPageDataOptions {
  commitment?: Commitment | CommitmentOptions;
  commitmentChangeOrder?: CommitmentChangeOrder | CommitmentChangeOrderOptions;
}

export function newPurchaseOrderPageData(data: PurchaseOrderPageDataOptions): PurchaseOrderPageQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
    commitmentChangeOrder: maybeNew("CommitmentChangeOrder", data["commitmentChangeOrder"] || undefined, {}),
  } as any;
}

export function newPurchaseOrderPageResponse(
  variables: PurchaseOrderPageQueryVariables,
  data: PurchaseOrderPageDataOptions | Error,
): MockedResponse<PurchaseOrderPageQueryVariables, PurchaseOrderPageQuery> {
  return {
    request: { query: PurchaseOrderPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newPurchaseOrderPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreatePandaDocSessionDataOptions {
  createPandaDocSession?: PandaDocSession | PandaDocSessionOptions;
}

export function newCreatePandaDocSessionData(data: CreatePandaDocSessionDataOptions): CreatePandaDocSessionMutation {
  return {
    __typename: "Mutation" as const,
    createPandaDocSession: maybeNew("PandaDocSession", data["createPandaDocSession"] || undefined, {}),
  } as any;
}

export function newCreatePandaDocSessionResponse(
  variables: CreatePandaDocSessionMutationVariables,
  data: CreatePandaDocSessionDataOptions | Error,
): MockedResponse<CreatePandaDocSessionMutationVariables, CreatePandaDocSessionMutation> {
  return {
    request: { query: CreatePandaDocSessionDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreatePandaDocSessionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCommitmentDataOptions {
  saveCommitment?: SaveCommitmentResult | SaveCommitmentResultOptions;
}

export function newSaveCommitmentData(data: SaveCommitmentDataOptions): SaveCommitmentMutation {
  return {
    __typename: "Mutation" as const,
    saveCommitment: maybeNew("SaveCommitmentResult", data["saveCommitment"] || undefined, {}),
  } as any;
}

export function newSaveCommitmentResponse(
  variables: SaveCommitmentMutationVariables,
  data: SaveCommitmentDataOptions | Error,
): MockedResponse<SaveCommitmentMutationVariables, SaveCommitmentMutation> {
  return {
    request: { query: SaveCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCommitmentChangeOrderDataOptions {
  saveCommitmentChangeOrder?: SaveCommitmentChangeOrderResult | SaveCommitmentChangeOrderResultOptions;
}

export function newSaveCommitmentChangeOrderData(
  data: SaveCommitmentChangeOrderDataOptions,
): SaveCommitmentChangeOrderMutation {
  return {
    __typename: "Mutation" as const,
    saveCommitmentChangeOrder: maybeNew(
      "SaveCommitmentChangeOrderResult",
      data["saveCommitmentChangeOrder"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveCommitmentChangeOrderResponse(
  variables: SaveCommitmentChangeOrderMutationVariables,
  data: SaveCommitmentChangeOrderDataOptions | Error,
): MockedResponse<SaveCommitmentChangeOrderMutationVariables, SaveCommitmentChangeOrderMutation> {
  return {
    request: { query: SaveCommitmentChangeOrderDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCommitmentChangeOrderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PurchaseOrdersPageDataOptions {
  commitmentsPage?: CommitmentsPage | CommitmentsPageOptions;
  currentUser?: User | UserOptions | null;
  projects?: (Project | ProjectOptions)[];
}

export function newPurchaseOrdersPageData(data: PurchaseOrdersPageDataOptions): PurchaseOrdersPageQuery {
  return {
    __typename: "Query" as const,
    commitmentsPage: maybeNew("CommitmentsPage", data["commitmentsPage"] || undefined, {}),
    currentUser: maybeNewOrNull("User", data["currentUser"] || undefined, {}),
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newPurchaseOrdersPageResponse(
  variables: PurchaseOrdersPageQueryVariables,
  data: PurchaseOrdersPageDataOptions | Error,
): MockedResponse<PurchaseOrdersPageQueryVariables, PurchaseOrdersPageQuery> {
  return {
    request: { query: PurchaseOrdersPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newPurchaseOrdersPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UpdateTradePartnerAvailabilityRequestStatusDataOptions {
  updateTradePartnerAvailabilityRequestStatus?: EmptyResult | EmptyResultOptions;
}

export function newUpdateTradePartnerAvailabilityRequestStatusData(
  data: UpdateTradePartnerAvailabilityRequestStatusDataOptions,
): UpdateTradePartnerAvailabilityRequestStatusMutation {
  return {
    __typename: "Mutation" as const,
    updateTradePartnerAvailabilityRequestStatus: maybeNew(
      "EmptyResult",
      data["updateTradePartnerAvailabilityRequestStatus"] || undefined,
      {},
    ),
  } as any;
}

export function newUpdateTradePartnerAvailabilityRequestStatusResponse(
  variables: UpdateTradePartnerAvailabilityRequestStatusMutationVariables,
  data: UpdateTradePartnerAvailabilityRequestStatusDataOptions | Error,
): MockedResponse<
  UpdateTradePartnerAvailabilityRequestStatusMutationVariables,
  UpdateTradePartnerAvailabilityRequestStatusMutation
> {
  return {
    request: { query: UpdateTradePartnerAvailabilityRequestStatusDocument, variables },
    result: { data: data instanceof Error ? undefined : newUpdateTradePartnerAvailabilityRequestStatusData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerAvailabilityRequestDataOptions {
  saveTradePartnerAvailabilityRequest?:
    | SaveTradePartnerAvailabilityRequestResult
    | SaveTradePartnerAvailabilityRequestResultOptions;
}

export function newSaveTradePartnerAvailabilityRequestData(
  data: SaveTradePartnerAvailabilityRequestDataOptions,
): SaveTradePartnerAvailabilityRequestMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartnerAvailabilityRequest: maybeNew(
      "SaveTradePartnerAvailabilityRequestResult",
      data["saveTradePartnerAvailabilityRequest"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveTradePartnerAvailabilityRequestResponse(
  variables: SaveTradePartnerAvailabilityRequestMutationVariables,
  data: SaveTradePartnerAvailabilityRequestDataOptions | Error,
): MockedResponse<SaveTradePartnerAvailabilityRequestMutationVariables, SaveTradePartnerAvailabilityRequestMutation> {
  return {
    request: { query: SaveTradePartnerAvailabilityRequestDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerAvailabilityRequestData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SchedulesPageDataOptions {
  tasks?: (Task | TaskOptions)[];
}

export function newSchedulesPageData(data: SchedulesPageDataOptions): SchedulesPageQuery {
  return { __typename: "Query" as const, tasks: data["tasks"]?.map((d) => newTask(d)) || [] } as any;
}

export function newSchedulesPageResponse(
  variables: SchedulesPageQueryVariables,
  data: SchedulesPageDataOptions | Error,
): MockedResponse<SchedulesPageQueryVariables, SchedulesPageQuery> {
  return {
    request: { query: SchedulesPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newSchedulesPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerContactsRolesPanelMetadataDataOptions {
  tradePartnerMarketRoles?: (TradePartnerMarketRoleDetail | TradePartnerMarketRoleDetailOptions)[];
}

export function newTradePartnerContactsRolesPanelMetadataData(
  data: TradePartnerContactsRolesPanelMetadataDataOptions,
): TradePartnerContactsRolesPanelMetadataQuery {
  return {
    __typename: "Query" as const,
    tradePartnerMarketRoles: data["tradePartnerMarketRoles"]?.map((d) => newTradePartnerMarketRoleDetail(d)) || [],
  } as any;
}

export function newTradePartnerContactsRolesPanelMetadataResponse(
  data: TradePartnerContactsRolesPanelMetadataDataOptions | Error,
): MockedResponse<TradePartnerContactsRolesPanelMetadataQueryVariables, TradePartnerContactsRolesPanelMetadataQuery> {
  return {
    request: { query: TradePartnerContactsRolesPanelMetadataDocument },
    result: { data: data instanceof Error ? undefined : newTradePartnerContactsRolesPanelMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerContactsDataOptions {
  tradePartner?: TradePartner | TradePartnerOptions;
  markets?: (Market | MarketOptions)[];
}

export function newTradePartnerContactsData(data: TradePartnerContactsDataOptions): TradePartnerContactsQuery {
  return {
    __typename: "Query" as const,
    tradePartner: maybeNew("TradePartner", data["tradePartner"] || undefined, {}),
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
  } as any;
}

export function newTradePartnerContactsResponse(
  variables: TradePartnerContactsQueryVariables,
  data: TradePartnerContactsDataOptions | Error,
): MockedResponse<TradePartnerContactsQueryVariables, TradePartnerContactsQuery> {
  return {
    request: { query: TradePartnerContactsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerContactsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerContactDataOptions {
  saveTradePartnerContact?: SaveTradePartnerContactResult | SaveTradePartnerContactResultOptions;
}

export function newSaveTradePartnerContactData(
  data: SaveTradePartnerContactDataOptions,
): SaveTradePartnerContactMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartnerContact: maybeNew(
      "SaveTradePartnerContactResult",
      data["saveTradePartnerContact"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveTradePartnerContactResponse(
  variables: SaveTradePartnerContactMutationVariables,
  data: SaveTradePartnerContactDataOptions | Error,
): MockedResponse<SaveTradePartnerContactMutationVariables, SaveTradePartnerContactMutation> {
  return {
    request: { query: SaveTradePartnerContactDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerContactData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerMarketContactDataOptions {
  saveTradePartnerMarketContact?: SaveTradePartnerMarketContactResult | SaveTradePartnerMarketContactResultOptions;
}

export function newSaveTradePartnerMarketContactData(
  data: SaveTradePartnerMarketContactDataOptions,
): SaveTradePartnerMarketContactMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartnerMarketContact: maybeNew(
      "SaveTradePartnerMarketContactResult",
      data["saveTradePartnerMarketContact"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveTradePartnerMarketContactResponse(
  variables: SaveTradePartnerMarketContactMutationVariables,
  data: SaveTradePartnerMarketContactDataOptions | Error,
): MockedResponse<SaveTradePartnerMarketContactMutationVariables, SaveTradePartnerMarketContactMutation> {
  return {
    request: { query: SaveTradePartnerMarketContactDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerMarketContactData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveUserCommunicationPreferenceDataOptions {
  saveUserCommunicationPreference?:
    | SaveUserCommunicationPreferenceResult
    | SaveUserCommunicationPreferenceResultOptions;
}

export function newSaveUserCommunicationPreferenceData(
  data: SaveUserCommunicationPreferenceDataOptions,
): SaveUserCommunicationPreferenceMutation {
  return {
    __typename: "Mutation" as const,
    saveUserCommunicationPreference: maybeNew(
      "SaveUserCommunicationPreferenceResult",
      data["saveUserCommunicationPreference"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveUserCommunicationPreferenceResponse(
  variables: SaveUserCommunicationPreferenceMutationVariables,
  data: SaveUserCommunicationPreferenceDataOptions | Error,
): MockedResponse<SaveUserCommunicationPreferenceMutationVariables, SaveUserCommunicationPreferenceMutation> {
  return {
    request: { query: SaveUserCommunicationPreferenceDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveUserCommunicationPreferenceData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteTradePartnerContactDataOptions {
  deleteTradePartnerContact?: DeleteTradePartnerContactResult | DeleteTradePartnerContactResultOptions;
}

export function newDeleteTradePartnerContactData(
  data: DeleteTradePartnerContactDataOptions,
): DeleteTradePartnerContactMutation {
  return {
    __typename: "Mutation" as const,
    deleteTradePartnerContact: maybeNew(
      "DeleteTradePartnerContactResult",
      data["deleteTradePartnerContact"] || undefined,
      {},
    ),
  } as any;
}

export function newDeleteTradePartnerContactResponse(
  variables: DeleteTradePartnerContactMutationVariables,
  data: DeleteTradePartnerContactDataOptions | Error,
): MockedResponse<DeleteTradePartnerContactMutationVariables, DeleteTradePartnerContactMutation> {
  return {
    request: { query: DeleteTradePartnerContactDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteTradePartnerContactData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ImpersonateTradeUserModalDataOptions {
  tradePartners?: (TradePartner | TradePartnerOptions)[];
}

export function newImpersonateTradeUserModalData(
  data: ImpersonateTradeUserModalDataOptions,
): ImpersonateTradeUserModalQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
  } as any;
}

export function newImpersonateTradeUserModalResponse(
  data: ImpersonateTradeUserModalDataOptions | Error,
): MockedResponse<ImpersonateTradeUserModalQueryVariables, ImpersonateTradeUserModalQuery> {
  return {
    request: { query: ImpersonateTradeUserModalDocument },
    result: { data: data instanceof Error ? undefined : newImpersonateTradeUserModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ImpersonateTradeUserModal_SaveInternalUserDataOptions {
  saveInternalUser?: SaveInternalUserResult | SaveInternalUserResultOptions;
}

export function newImpersonateTradeUserModal_SaveInternalUserData(
  data: ImpersonateTradeUserModal_SaveInternalUserDataOptions,
): ImpersonateTradeUserModal_SaveInternalUserMutation {
  return {
    __typename: "Mutation" as const,
    saveInternalUser: maybeNew("SaveInternalUserResult", data["saveInternalUser"] || undefined, {}),
  } as any;
}

export function newImpersonateTradeUserModal_SaveInternalUserResponse(
  variables: ImpersonateTradeUserModal_SaveInternalUserMutationVariables,
  data: ImpersonateTradeUserModal_SaveInternalUserDataOptions | Error,
): MockedResponse<
  ImpersonateTradeUserModal_SaveInternalUserMutationVariables,
  ImpersonateTradeUserModal_SaveInternalUserMutation
> {
  return {
    request: { query: ImpersonateTradeUserModal_SaveInternalUserDocument, variables },
    result: { data: data instanceof Error ? undefined : newImpersonateTradeUserModal_SaveInternalUserData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceRequestChangesDataOptions {
  bill?: Bill | BillOptions;
}

export function newInvoiceRequestChangesData(data: InvoiceRequestChangesDataOptions): InvoiceRequestChangesQuery {
  return { __typename: "Query" as const, bill: maybeNew("Bill", data["bill"] || undefined, {}) } as any;
}

export function newInvoiceRequestChangesResponse(
  variables: InvoiceRequestChangesQueryVariables,
  data: InvoiceRequestChangesDataOptions | Error,
): MockedResponse<InvoiceRequestChangesQueryVariables, InvoiceRequestChangesQuery> {
  return {
    request: { query: InvoiceRequestChangesDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceRequestChangesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceRequestChangesPane_SaveApproverDataOptions {
  saveApprover?: SaveApproverResult | SaveApproverResultOptions;
}

export function newInvoiceRequestChangesPane_SaveApproverData(
  data: InvoiceRequestChangesPane_SaveApproverDataOptions,
): InvoiceRequestChangesPane_SaveApproverMutation {
  return {
    __typename: "Mutation" as const,
    saveApprover: maybeNew("SaveApproverResult", data["saveApprover"] || undefined, {}),
  } as any;
}

export function newInvoiceRequestChangesPane_SaveApproverResponse(
  variables: InvoiceRequestChangesPane_SaveApproverMutationVariables,
  data: InvoiceRequestChangesPane_SaveApproverDataOptions | Error,
): MockedResponse<
  InvoiceRequestChangesPane_SaveApproverMutationVariables,
  InvoiceRequestChangesPane_SaveApproverMutation
> {
  return {
    request: { query: InvoiceRequestChangesPane_SaveApproverDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceRequestChangesPane_SaveApproverData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceRequestChangesPane_SaveCommentDataOptions {
  saveComment?: SaveCommentResult | SaveCommentResultOptions;
}

export function newInvoiceRequestChangesPane_SaveCommentData(
  data: InvoiceRequestChangesPane_SaveCommentDataOptions,
): InvoiceRequestChangesPane_SaveCommentMutation {
  return {
    __typename: "Mutation" as const,
    saveComment: maybeNew("SaveCommentResult", data["saveComment"] || undefined, {}),
  } as any;
}

export function newInvoiceRequestChangesPane_SaveCommentResponse(
  variables: InvoiceRequestChangesPane_SaveCommentMutationVariables,
  data: InvoiceRequestChangesPane_SaveCommentDataOptions | Error,
): MockedResponse<
  InvoiceRequestChangesPane_SaveCommentMutationVariables,
  InvoiceRequestChangesPane_SaveCommentMutation
> {
  return {
    request: { query: InvoiceRequestChangesPane_SaveCommentDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceRequestChangesPane_SaveCommentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanBasedLineItemsTabDataOptions {
  commitment?: Commitment | CommitmentOptions;
}

export function newPlanBasedLineItemsTabData(data: PlanBasedLineItemsTabDataOptions): PlanBasedLineItemsTabQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
  } as any;
}

export function newPlanBasedLineItemsTabResponse(
  variables: PlanBasedLineItemsTabQueryVariables,
  data: PlanBasedLineItemsTabDataOptions | Error,
): MockedResponse<PlanBasedLineItemsTabQueryVariables, PlanBasedLineItemsTabQuery> {
  return {
    request: { query: PlanBasedLineItemsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanBasedLineItemsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PurchaseOrderDetailPane_DetailsTabDataOptions {
  commitment?: Commitment | CommitmentOptions;
  commitmentChangeOrder?: CommitmentChangeOrder | CommitmentChangeOrderOptions;
}

export function newPurchaseOrderDetailPane_DetailsTabData(
  data: PurchaseOrderDetailPane_DetailsTabDataOptions,
): PurchaseOrderDetailPane_DetailsTabQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
    commitmentChangeOrder: maybeNew("CommitmentChangeOrder", data["commitmentChangeOrder"] || undefined, {}),
  } as any;
}

export function newPurchaseOrderDetailPane_DetailsTabResponse(
  variables: PurchaseOrderDetailPane_DetailsTabQueryVariables,
  data: PurchaseOrderDetailPane_DetailsTabDataOptions | Error,
): MockedResponse<PurchaseOrderDetailPane_DetailsTabQueryVariables, PurchaseOrderDetailPane_DetailsTabQuery> {
  return {
    request: { query: PurchaseOrderDetailPane_DetailsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newPurchaseOrderDetailPane_DetailsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PurchaseOrderDetailPane_InvoicesTabDataOptions {
  commitment?: Commitment | CommitmentOptions;
  commitmentChangeOrder?: CommitmentChangeOrder | CommitmentChangeOrderOptions;
}

export function newPurchaseOrderDetailPane_InvoicesTabData(
  data: PurchaseOrderDetailPane_InvoicesTabDataOptions,
): PurchaseOrderDetailPane_InvoicesTabQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
    commitmentChangeOrder: maybeNew("CommitmentChangeOrder", data["commitmentChangeOrder"] || undefined, {}),
  } as any;
}

export function newPurchaseOrderDetailPane_InvoicesTabResponse(
  variables: PurchaseOrderDetailPane_InvoicesTabQueryVariables,
  data: PurchaseOrderDetailPane_InvoicesTabDataOptions | Error,
): MockedResponse<PurchaseOrderDetailPane_InvoicesTabQueryVariables, PurchaseOrderDetailPane_InvoicesTabQuery> {
  return {
    request: { query: PurchaseOrderDetailPane_InvoicesTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newPurchaseOrderDetailPane_InvoicesTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PurchaseOrderDetailPane_SpecsTabDataOptions {
  commitment?: Commitment | CommitmentOptions;
  commitmentChangeOrder?: CommitmentChangeOrder | CommitmentChangeOrderOptions;
}

export function newPurchaseOrderDetailPane_SpecsTabData(
  data: PurchaseOrderDetailPane_SpecsTabDataOptions,
): PurchaseOrderDetailPane_SpecsTabQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
    commitmentChangeOrder: maybeNew("CommitmentChangeOrder", data["commitmentChangeOrder"] || undefined, {}),
  } as any;
}

export function newPurchaseOrderDetailPane_SpecsTabResponse(
  variables: PurchaseOrderDetailPane_SpecsTabQueryVariables,
  data: PurchaseOrderDetailPane_SpecsTabDataOptions | Error,
): MockedResponse<PurchaseOrderDetailPane_SpecsTabQueryVariables, PurchaseOrderDetailPane_SpecsTabQuery> {
  return {
    request: { query: PurchaseOrderDetailPane_SpecsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newPurchaseOrderDetailPane_SpecsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}

  export type MockedResponse<V, Q> = {
    request: {
      query: any;
      variables?: V;
    };
    result: {
      data?: Q;
    };
    error?: Error;
    // Note this only works if using Homebound's better-apollo-mocked-provider
    requestedCount?: number;
  };

import { dateTimeTypePolicy, dateTypePolicy } from "src/utils/dates";

export const scalarTypePolicies = {
  AiEntityProposal: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  AiFieldProposal: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  AiProposal: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Approval: {
    fields: {
      requestedAt: dateTimeTypePolicy,
      dueOn: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
    },
  },
  Approver: {
    fields: { statusUpdatedAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  CreateAssetMultipartUploadUrlResult: { fields: { expiresAt: dateTimeTypePolicy } },
  Asset: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Attachment: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidContract: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, archivedAt: dateTimeTypePolicy },
  },
  BidContractLineItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidContractRevision: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      startDate: dateTypePolicy,
      endDate: dateTypePolicy,
      signedOn: dateTypePolicy,
    },
  },
  BidContractRevisionDraw: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidContractTradeLineItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidItemEstimate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidPackage: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      archivedAt: dateTimeTypePolicy,
      lastAwardedAt: dateTimeTypePolicy,
    },
  },
  BidPackageBidder: { fields: { archivedAt: dateTimeTypePolicy } },
  BidPackageAward: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidPackageGroup: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidPackageIncomingUpdate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidPackageLineItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidPackageRequest: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      sentDate: dateTypePolicy,
      archivedAt: dateTimeTypePolicy,
    },
  },
  BidPackageVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidPlanChildGroup: {
    fields: { deletedAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  BidPlanChildGroupLine: {
    fields: { deletedAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  BidPlanGroup: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, deletedAt: dateTimeTypePolicy },
  },
  BidPlanGroupDimension: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TradePartner: {
    fields: {
      meetsRequirementsExpiresAt: dateTypePolicy,
      meetsRequirementsExpiresOn: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      billDueDateFor: dateTypePolicy,
    },
  },
  Bill: {
    fields: {
      billDate: dateTypePolicy,
      dueDate: dateTypePolicy,
      paidDate: dateTypePolicy,
      postedDate: dateTypePolicy,
      approvedAt: dateTimeTypePolicy,
      sentDate: dateTypePolicy,
      updatedAt: dateTimeTypePolicy,
      syncedToIntacctAt: dateTimeTypePolicy,
    },
  },
  BillGmailAttachment: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BillGmailMessage: {
    fields: { receivedAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  BillLineItemAllocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BillOcr: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      billDate: dateTypePolicy,
      dueDate: dateTypePolicy,
    },
  },
  BusinessFunction: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  CalendarInterval: { fields: { startDate: dateTypePolicy, endDate: dateTypePolicy } },
  CalendarInterval2: { fields: { startDate: dateTypePolicy, endDate: dateTypePolicy } },
  ChangeEvent: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, acceptedAt: dateTimeTypePolicy },
  },
  ChangeEventLineItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ChangeEventLineItemAllocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ChangeEventMaterialVariantSwap: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ChangeEventOriginalOption: { fields: { createdAt: dateTimeTypePolicy } },
  ChangeEventProposedOption: { fields: { createdAt: dateTimeTypePolicy } },
  ChangeEventReason: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ChangeEventTemplateConfig: { fields: { createdAt: dateTimeTypePolicy } },
  ChangeRequest: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ChangeRequestAsset: {
    fields: { deletedAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  ChangeRequestGroup: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ChangeRequestScope: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, deletedAt: dateTimeTypePolicy },
  },
  ChangeRequestToDo: {
    fields: {
      deletedAt: dateTimeTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      dueDate: dateTypePolicy,
    },
  },
  CheckoutConfig: {
    fields: {
      reservedAt: dateTimeTypePolicy,
      expiresAt: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      archivedAt: dateTimeTypePolicy,
    },
  },
  CheckoutConfigOptionGroup: { fields: { cutoffDate: dateTypePolicy } },
  CheckoutConfigOption: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, reservedCutoffDate: dateTypePolicy },
  },
  Client: { fields: { lastActiveAt: dateTimeTypePolicy, lastActive: dateTimeTypePolicy } },
  Cohort: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Task: { fields: { completedAt: dateTypePolicy, startDate: dateTypePolicy } },
  ScheduleTask: { fields: { completedAt: dateTypePolicy, startDate: dateTypePolicy } },
  PlanTask: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      startDate: dateTypePolicy,
      endDate: dateTypePolicy,
      completedAt: dateTimeTypePolicy,
      earliestStartDate: dateTypePolicy,
    },
  },
  ToDo: {
    fields: {
      deletedAt: dateTimeTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      dueDate: dateTypePolicy,
    },
  },
  Invoice: {
    fields: {
      invoiceDate: dateTypePolicy,
      dueDate: dateTypePolicy,
      lineItemCutoffDate: dateTypePolicy,
      lineItemStartDate: dateTypePolicy,
      paidDate: dateTypePolicy,
      updatedAt: dateTimeTypePolicy,
      createdAt: dateTimeTypePolicy,
    },
  },
  StandaloneProject: {
    fields: {
      startDate: dateTypePolicy,
      warrantyStartDate: dateTypePolicy,
      verticalCompleteDate: dateTypePolicy,
      targetEndDate: dateTypePolicy,
      homeownerDeliveryDate: dateTypePolicy,
      readyToStartDate: dateTypePolicy,
      warrantyEndDate: dateTypePolicy,
    },
  },
  Region: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      startDate: dateTypePolicy,
      warrantyStartDate: dateTypePolicy,
      verticalCompleteDate: dateTypePolicy,
      targetEndDate: dateTypePolicy,
      homeownerDeliveryDate: dateTypePolicy,
      readyToStartDate: dateTypePolicy,
      warrantyEndDate: dateTypePolicy,
    },
  },
  Market: {
    fields: {
      startDate: dateTypePolicy,
      warrantyStartDate: dateTypePolicy,
      verticalCompleteDate: dateTypePolicy,
      targetEndDate: dateTypePolicy,
      homeownerDeliveryDate: dateTypePolicy,
      readyToStartDate: dateTypePolicy,
      warrantyEndDate: dateTypePolicy,
    },
  },
  Community: {
    fields: {
      startDate: dateTypePolicy,
      warrantyStartDate: dateTypePolicy,
      verticalCompleteDate: dateTypePolicy,
      targetEndDate: dateTypePolicy,
      homeownerDeliveryDate: dateTypePolicy,
      readyToStartDate: dateTypePolicy,
      warrantyEndDate: dateTypePolicy,
    },
  },
  Subdivision: {
    fields: {
      startDate: dateTypePolicy,
      warrantyStartDate: dateTypePolicy,
      verticalCompleteDate: dateTypePolicy,
      targetEndDate: dateTypePolicy,
      homeownerDeliveryDate: dateTypePolicy,
      readyToStartDate: dateTypePolicy,
      warrantyEndDate: dateTypePolicy,
    },
  },
  Lot: {
    fields: {
      startDate: dateTypePolicy,
      warrantyStartDate: dateTypePolicy,
      verticalCompleteDate: dateTypePolicy,
      targetEndDate: dateTypePolicy,
      homeownerDeliveryDate: dateTypePolicy,
      readyToStartDate: dateTypePolicy,
      warrantyEndDate: dateTypePolicy,
    },
  },
  Structure: {
    fields: {
      startDate: dateTypePolicy,
      warrantyStartDate: dateTypePolicy,
      verticalCompleteDate: dateTypePolicy,
      targetEndDate: dateTypePolicy,
      homeownerDeliveryDate: dateTypePolicy,
      readyToStartDate: dateTypePolicy,
      warrantyEndDate: dateTypePolicy,
    },
  },
  Unit: {
    fields: {
      startDate: dateTypePolicy,
      warrantyStartDate: dateTypePolicy,
      verticalCompleteDate: dateTypePolicy,
      targetEndDate: dateTypePolicy,
      homeownerDeliveryDate: dateTypePolicy,
      readyToStartDate: dateTypePolicy,
      warrantyEndDate: dateTypePolicy,
    },
  },
  Estimate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  DevelopmentCommitment: {
    fields: {
      executionDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      releasedDate: dateTypePolicy,
      releasedAt: dateTypePolicy,
    },
  },
  Commitment: {
    fields: {
      executionDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      sentDate: dateTypePolicy,
    },
  },
  Document: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, issuanceDate: dateTypePolicy } },
  ItemTemplateItemVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  JobLogNote: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TradePartnerAvailabilityRequest: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      tradePartnerConfirmationDate: dateTypePolicy,
    },
  },
  PunchlistItemTodo: {
    fields: {
      deletedAt: dateTimeTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      dueDate: dateTypePolicy,
    },
  },
  WarrantyTicket: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  HomeownerContract: { fields: { executionDate: dateTypePolicy } },
  HomeownerContractChangeOrder: { fields: { executionDate: dateTypePolicy } },
  ReadyPlan: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  PlanPackage: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalOption: {
    fields: {
      activeDate: dateTypePolicy,
      archivedDate: dateTypePolicy,
      lastUsedAt: dateTimeTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
    },
  },
  Comment: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  CommentTag: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectStage: { fields: { clientPresentationDate: dateTypePolicy } },
  CommitmentChangeOrder: {
    fields: {
      executionDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      sentDate: dateTypePolicy,
    },
  },
  CommitmentDraw: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  CommitmentLineItemAllocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  CostLineItemAllocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Customer: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  CustomerItemConfig: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  CustomerOwnerEntity: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  DesignPackage: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  DesignPackagePlanUpdate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  DesignPackageSource: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  DesignPackageSourceVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  DesignPackageVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Development: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  DevelopmentOption: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  DevelopmentTeamMember: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Drop: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Expense: {
    fields: {
      expenseDate: dateTypePolicy,
      dueDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
    },
  },
  ExpenseAllocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ExpenseAllocationAllocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  FeatureFlag: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  FeatureFlagTarget: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  FeatureType: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  FinishScheduleConfig: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalOptionGroup: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanAllowance: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanConstraint: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanConstraintItem: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, deletedAt: dateTimeTypePolicy },
  },
  GlobalPlanMilestone: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanMilestoneGroup: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanStage: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanStageVariant: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanTag: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanTask: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanTaskChecklistItem: {
    fields: { deletedAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  GlobalPlanTaskScope: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanTaskVariant: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalRequiredTaskDocument: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalTask: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  History: { fields: { recordedAt: dateTimeTypePolicy } },
  HomeboundHoliday: { fields: { date: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Homeowner: { fields: { createdAt: dateTimeTypePolicy } },
  HomeownerContractLineItemAllocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  HomeownerNote: { fields: { createdAt: dateTimeTypePolicy } },
  InsideMapsRoomRendering: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  InvoiceAccruedLineItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  InvoiceDocument: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  InvoiceScheduleItem: { fields: { invoiceDate: dateTypePolicy } },
  InvoiceScheduleTemplate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  InvoiceScheduleTemplateItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ItemPlanTaskMapping: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ItemSlot: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ItemTemplate: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      activatedAt: dateTimeTypePolicy,
      archivedAt: dateTimeTypePolicy,
      lastUsedAsUnderwritingTemplate: dateTypePolicy,
    },
  },
  ItemTemplateCollection: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ItemTemplateCostUpdate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ItemTemplateItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  JobLog: { fields: { logDate: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  JobLogImage: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  LienWaiver: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, throughDate: dateTypePolicy } },
  LotRating: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialAssemblyComponent: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialAttributeDimension: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialAttributeValue: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialBrand: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialLeadTimeConfig: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialLeadTimeConfigVariant: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialListing: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialVariant: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      deletedAt: dateTimeTypePolicy,
      lastUsedAt: dateTimeTypePolicy,
    },
  },
  MaterialVariantImage: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialVariantMerge: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialVariantTag: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MobileSyncUpdate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  OptionPricingConfig: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  OptionPricingConfigVariant: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  PaymentTerm: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  PlanBasedBidContractLineItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  PlanMilestone: {
    fields: {
      estStartDate: dateTypePolicy,
      estEndDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      completedAt: dateTimeTypePolicy,
    },
  },
  PlanMilestoneSnapshot: {
    fields: {
      estStartDate: dateTypePolicy,
      estEndDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
    },
  },
  PlanMilestoneTarget: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  PlanPackageAiProposal: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  PlanPackageIncomingSlot: { fields: { createdAt: dateTimeTypePolicy } },
  PlanPackageVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  PlanSchedule: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      recalculatedAt: dateTimeTypePolicy,
      targetStartDate: dateTypePolicy,
      targetEndDate: dateTypePolicy,
      currentBaselineDate: dateTypePolicy,
      verticalCompleteDate: dateTypePolicy,
      readyToStartDate: dateTypePolicy,
      preconReadyToStartDate: dateTypePolicy,
      targetConstructionRtsDate: dateTypePolicy,
      targetPreconRtsDate: dateTypePolicy,
    },
  },
  PotentialDateBasisPoints: { fields: { date: dateTypePolicy } },
  PlanTaskChecklistItem: {
    fields: { completedAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  PreconContractType: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProductOffering: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProductOfferingConfig: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProductOfferingIncomingUpdate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProductType: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProgramData: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  NewProgramData: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  EarnedValueDataPoint: { fields: { date: dateTypePolicy } },
  OptionWithCutoffDate: { fields: { cutoffDate: dateTypePolicy } },
  ProjectDirectMarginGraphData: { fields: { date: dateTypePolicy } },
  ProjectAllocationRule: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectCollaborator: { fields: { inviteSent: dateTimeTypePolicy, inviteSentAt: dateTimeTypePolicy } },
  ProjectContact: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectDocumentAssociation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectInvoiceSetting: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  CostLineItem: { fields: { costDate: dateTypePolicy } },
  ProjectItemAllocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectLotDetail: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectReadyPlanConfig: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      constructionStartDate: dateTypePolicy,
      lastAppliedAt: dateTimeTypePolicy,
      deliveryDate: dateTypePolicy,
      configurationUpdatedAt: dateTimeTypePolicy,
    },
  },
  ProjectReadyPlanConfigOption: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectSalesforceOpportunity: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectSiteCondition: {
    fields: { expectedSlabPourDate: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  ProjectSiteSpecificInfo: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectSnapshot: { fields: { startDate: dateTypePolicy, endDate: dateTypePolicy } },
  ProjectStageHomeownerFinancials: { fields: { financialsLastUpdate: dateTypePolicy } },
  ProjectStageTemplateConfig: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectStatusChange: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, date: dateTypePolicy },
  },
  ProjectUpdate: { fields: { createdAt: dateTimeTypePolicy, eventTime: dateTimeTypePolicy } },
  PushNotificationToken: {
    fields: { lastSeenAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  ReadyPlanAggregateVersion: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      publishedAt: dateTimeTypePolicy,
      promotedAt: dateTimeTypePolicy,
    },
  },
  ReadyPlanAsset: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanAssetVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanDesignNote: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanDesignNoteVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanDesignPackage: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanDesignPackageVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanLocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanLocationVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanOption: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanOptionGroup: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanOptionProgramDataModification: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanOptionVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanProgramData: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanProgramDataVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanRequiredOption: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanRequiredOptionVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  RequiredTaskDocument: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  RoomType: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TestMutationResult: { fields: { datetime: dateTimeTypePolicy, date: dateTypePolicy } },
  Schedule: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ScheduleFlag: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ScheduleFlagImpact: {
    fields: {
      oldStartDate: dateTypePolicy,
      newStartDate: dateTypePolicy,
      oldEndDate: dateTypePolicy,
      newEndDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
    },
  },
  ScheduleFlagReason: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ScheduleSetting: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ResultingDelay: { fields: { oldTaskStart: dateTypePolicy, oldTaskEnd: dateTypePolicy } },
  ScheduleTaskChecklistItem: {
    fields: { completedAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  ScheduleTemplate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ScheduleTemplateItemMapping: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  SchedulingExclusionDate: {
    fields: { date: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  ScopeChangeReason: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  SiteSpecificInfo: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Submarket: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TakeoffLineItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TakeoffLineItemVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TaskSnapshot: {
    fields: {
      startDate: dateTypePolicy,
      endDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
    },
  },
  TaskWorkDay: { fields: { workDay: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ToDoChecklistItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TrackedJob: {
    fields: {
      startedAt: dateTimeTypePolicy,
      completedAt: dateTimeTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
    },
  },
  TradeCategory: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TradeCategoryLeadTime: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TradePartnerAgreement: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TradePartnerAvailabilityRequestEmail: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TradePartnerAvailabilityRequestTextMessage: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  TradePartnerContact: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TradePartnerMailingList: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TradePartnerMarketContact: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TradePartnerRequirement: {
    fields: {
      signedDate: dateTypePolicy,
      expirationDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
    },
  },
  TradePartnerReview: { fields: { createdAt: dateTimeTypePolicy } },
  TradePartnerUser: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      lastActive: dateTimeTypePolicy,
      lastActiveAt: dateTimeTypePolicy,
    },
  },
  UserCommunicationPreference: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  UserEvent: { fields: { createdAt: dateTimeTypePolicy, notifiedAt: dateTimeTypePolicy } },
  UserGroup: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  WarrantyTicketAvailability: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  WarrantyTicketItem: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, statusUpdatedAt: dateTimeTypePolicy },
  },
  WorkAuthorization: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
};
